import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  bigint: { input: any; output: any; }
  bpchar: { input: any; output: any; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  infraestruturas_tipos_scalar: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  smallint: { input: any; output: any; }
  time: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
};

export type AgeVsLeaksFrequencyResponse = {
  __typename?: 'AgeVsLeaksFrequencyResponse';
  age: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interv_count: Scalars['Int']['output'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type DailyFlowChartItem = {
  __typename?: 'DailyFlowChartItem';
  id: Scalars['ID']['output'];
  place: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type DailyFlowChartResponse = {
  __typename?: 'DailyFlowChartResponse';
  id: Scalars['ID']['output'];
  items: Array<DailyFlowChartItem>;
};

export type DailyFlowIndicator = {
  __typename?: 'DailyFlowIndicator';
  date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type DailyFlowIndicators = {
  __typename?: 'DailyFlowIndicators';
  avg: DailyFlowIndicator;
  id: Scalars['ID']['output'];
  max: DailyFlowIndicator;
  min: DailyFlowIndicator;
  total: DailyFlowIndicator;
};

export type DailyFlowReading = {
  __typename?: 'DailyFlowReading';
  date: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  id_fonte_origem: Scalars['Int']['output'];
  id_fonte_origem_partial: Array<Scalars['Int']['output']>;
  id_infraestrutura: Scalars['Int']['output'];
  parcial_totalizer?: Maybe<Scalars['Float']['output']>;
  place: Scalars['String']['output'];
  readingId?: Maybe<Scalars['Int']['output']>;
  totalizer?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type DailyFlowReadings = {
  __typename?: 'DailyFlowReadings';
  id: Scalars['String']['output'];
  readings: Array<Maybe<DailyFlowReading>>;
  totalCount: Scalars['Int']['output'];
};

export enum DailyFlowReadingsSortField {
  Date = 'date',
  Place = 'place'
}

export type DailyFlowReadingsSortInput = {
  direction: SortDirection;
  field: DailyFlowReadingsSortField;
};

export type DashboardsLicencaIntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DashboardsLicencaOrderByInput = {
  descricao?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  ordem?: InputMaybe<OrderByEnum>;
  url?: InputMaybe<OrderByEnum>;
};

export type DashboardsLicencaStringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DashboardsLicencaWhereInput = {
  _and?: InputMaybe<Array<DashboardsLicencaWhereInput>>;
  _not?: InputMaybe<DashboardsLicencaWhereInput>;
  _or?: InputMaybe<Array<DashboardsLicencaWhereInput>>;
  descricao?: InputMaybe<DashboardsLicencaStringComparisonExp>;
  id?: InputMaybe<DashboardsLicencaIntComparisonExp>;
  url?: InputMaybe<DashboardsLicencaStringComparisonExp>;
};

export type DashboardsNaviaIds = {
  __typename?: 'DashboardsNaviaIds';
  descricao: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image_path_dark?: Maybe<Scalars['String']['output']>;
  image_path_light?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  menuTransacoes: Array<Navia_Dashboards_Menu_R_Transacoes>;
  /** An aggregate relationship */
  menuTransacoes_aggregate: Navia_Dashboards_Menu_R_Transacoes_Aggregate;
  ordem: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};


export type DashboardsNaviaIdsMenuTransacoesArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};


export type DashboardsNaviaIdsMenuTransacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};

export type FailureRecurrenceRateResponse = {
  __typename?: 'FailureRecurrenceRateResponse';
  failure_recurrence_rate: Scalars['Float']['output'];
  pipes_count: Scalars['Int']['output'];
  pipes_with_more_than_1: Scalars['Int']['output'];
};

export type Indicator = {
  __typename?: 'Indicator';
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type InfrastructureTotalizerTreeResponse = {
  __typename?: 'InfrastructureTotalizerTreeResponse';
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  descricao: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  id_pai?: Maybe<Scalars['Int']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Int']['output']>;
  node: Scalars['JSON']['output'];
};

export type InfrastructureVariableTreeResponse = {
  __typename?: 'InfrastructureVariableTreeResponse';
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  descricao: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  id_pai?: Maybe<Scalars['Int']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Int']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Int']['output']>;
  node: Scalars['JSON']['output'];
  nome_completo?: Maybe<Scalars['String']['output']>;
  nome_instalacao?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Languages = {
  __typename?: 'Languages';
  available_languages: Array<Scalars['String']['output']>;
  default_language: Scalars['String']['output'];
};

export type LeakRecurrenceVsRehabilitationResponse = {
  __typename?: 'LeakRecurrenceVsRehabilitationResponse';
  failure_recurrence_rate: Scalars['Float']['output'];
  leak_interv_count: Scalars['Int']['output'];
  pipes_count: Scalars['Int']['output'];
  pipes_with_more_than_1: Scalars['Int']['output'];
  rehabilitation_interv_count: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type LeaksPerDistanceResponse = {
  __typename?: 'LeaksPerDistanceResponse';
  interv_count: Scalars['Int']['output'];
  leaks_per_distance?: Maybe<Scalars['Float']['output']>;
  length_sum?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type MenuIds = {
  __typename?: 'MenuIds';
  UtilizadoresMenu?: Maybe<Utilizadores_Menu>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type MunicipalityExistsResponse = {
  __typename?: 'MunicipalityExistsResponse';
  exists: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type MunicipalityTotalizer = {
  __typename?: 'MunicipalityTotalizer';
  expression: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  parameterId: Scalars['Int']['output'];
  place?: Maybe<Scalars['String']['output']>;
  reading: Scalars['String']['output'];
  sourceOriginPropertyId: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
  totalizer?: Maybe<Scalars['String']['output']>;
};

export type MunicipalityTotalizers = {
  __typename?: 'MunicipalityTotalizers';
  id: Scalars['ID']['output'];
  totalCount: Scalars['Int']['output'];
  totalizers: Array<Maybe<MunicipalityTotalizer>>;
};

export type NetworkIntegrityResponse = {
  __typename?: 'NetworkIntegrityResponse';
  interv_count: Scalars['Int']['output'];
  network_integrity: Scalars['Float']['output'];
  pipes_count: Scalars['Int']['output'];
};

export enum OrderByEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type PipeAgeAverageResponse = {
  __typename?: 'PipeAgeAverageResponse';
  avg: Scalars['Float']['output'];
};

export type PipeReadingsByMaterialResponse = {
  __typename?: 'PipeReadingsByMaterialResponse';
  data_hora: Scalars['Date']['output'];
  dominio?: Maybe<Scalars['String']['output']>;
  dominio_valor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  id_fonte_origem: Scalars['Int']['output'];
  valor_texto?: Maybe<Scalars['String']['output']>;
};

export type PipeRehabilitationRateResponse = {
  __typename?: 'PipeRehabilitationRateResponse';
  avg_length_10y?: Maybe<Scalars['Float']['output']>;
  pipe_rehabilitation_rate?: Maybe<Scalars['Float']['output']>;
  rehab_5y_length_sum?: Maybe<Scalars['Float']['output']>;
};

export type RequestsActAndDangerList = {
  __typename?: 'RequestsActAndDangerList';
  id_frequency_time_limit_response: Scalars['Int']['output'];
  id_frequency_time_notification_response: Scalars['ID']['output'];
  request_address?: Maybe<Scalars['String']['output']>;
  request_infrastructure?: Maybe<Scalars['String']['output']>;
  request_number: Scalars['String']['output'];
  symptom: Scalars['String']['output'];
  time_limit_response_seconds: Scalars['Int']['output'];
  time_notification_seconds: Scalars['Int']['output'];
  time_over_in_seconds: Scalars['Int']['output'];
  time_passed_in_seconds: Scalars['Int']['output'];
  time_remaining_in_seconds: Scalars['Int']['output'];
  total_results: Scalars['Int']['output'];
};

export type SaveDailyFlowExpressionResponse = {
  __typename?: 'SaveDailyFlowExpressionResponse';
  id: Scalars['Int']['output'];
  savedExpression?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type Top5PipesWithMostLeaksResponse = {
  __typename?: 'Top5PipesWithMostLeaksResponse';
  descricao?: Maybe<Scalars['String']['output']>;
  i_codigo_externo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interv_count: Scalars['Int']['output'];
  sig_atributo_id?: Maybe<Scalars['String']['output']>;
  t_codigo_externo?: Maybe<Scalars['String']['output']>;
};

export type TopFiveAverageDurationBySymptom = {
  __typename?: 'TopFiveAverageDurationBySymptom';
  average_time_in_seconds: Scalars['Float']['output'];
  id_frequency_time_limit_response: Scalars['ID']['output'];
  id_symptom: Scalars['ID']['output'];
  symptom: Scalars['String']['output'];
  time_limit_response: Scalars['Float']['output'];
  time_limit_seconds: Scalars['Int']['output'];
};

export type TopFiveNonComplianceBySymptom = {
  __typename?: 'TopFiveNonComplianceBySymptom';
  id_symptom: Scalars['ID']['output'];
  symptom: Scalars['String']['output'];
  total_requests?: Maybe<Scalars['Int']['output']>;
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type ZmcLeaksCountResponse = {
  __typename?: 'ZMCLeaksCountResponse';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interv_count: Scalars['Int']['output'];
  sig_atributo_id?: Maybe<Scalars['String']['output']>;
};

/** age_vs_leaks_frequencyNative Query Arguments */
export type Age_Vs_Leaks_Frequency_Arguments = {
  endDate: Scalars['timestamptz']['input'];
  startDate: Scalars['timestamptz']['input'];
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

export type Age_Vs_Leaks_Frequency_Model = {
  __typename?: 'age_vs_leaks_frequency_model';
  age: Scalars['Int']['output'];
  id: Scalars['bigint']['output'];
  interv_count: Scalars['bigint']['output'];
};

/** Boolean expression to filter rows from the logical model for "age_vs_leaks_frequency_model". All fields are combined with a logical 'AND'. */
export type Age_Vs_Leaks_Frequency_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Age_Vs_Leaks_Frequency_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Age_Vs_Leaks_Frequency_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Age_Vs_Leaks_Frequency_Model_Bool_Exp_Bool_Exp>>;
  age?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  interv_count?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Age_Vs_Leaks_Frequency_Model_Enum_Name {
  /** column name */
  Age = 'age',
  /** column name */
  Id = 'id',
  /** column name */
  IntervCount = 'interv_count'
}

/** Ordering options when selecting data from "age_vs_leaks_frequency_model". */
export type Age_Vs_Leaks_Frequency_Model_Order_By = {
  age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interv_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "base.bulk_tipos" */
export type Base_Bulk_Tipos = {
  __typename?: 'base_bulk_tipos';
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "base.bulk_tipos" */
export type Base_Bulk_Tipos_Aggregate = {
  __typename?: 'base_bulk_tipos_aggregate';
  aggregate?: Maybe<Base_Bulk_Tipos_Aggregate_Fields>;
  nodes: Array<Base_Bulk_Tipos>;
};

/** aggregate fields of "base.bulk_tipos" */
export type Base_Bulk_Tipos_Aggregate_Fields = {
  __typename?: 'base_bulk_tipos_aggregate_fields';
  avg?: Maybe<Base_Bulk_Tipos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Base_Bulk_Tipos_Max_Fields>;
  min?: Maybe<Base_Bulk_Tipos_Min_Fields>;
  stddev?: Maybe<Base_Bulk_Tipos_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Bulk_Tipos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Bulk_Tipos_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Bulk_Tipos_Sum_Fields>;
  var_pop?: Maybe<Base_Bulk_Tipos_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Bulk_Tipos_Var_Samp_Fields>;
  variance?: Maybe<Base_Bulk_Tipos_Variance_Fields>;
};


/** aggregate fields of "base.bulk_tipos" */
export type Base_Bulk_Tipos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Bulk_Tipos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Base_Bulk_Tipos_Avg_Fields = {
  __typename?: 'base_bulk_tipos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "base.bulk_tipos". All fields are combined with a logical 'AND'. */
export type Base_Bulk_Tipos_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Bulk_Tipos_Bool_Exp>>;
  _not?: InputMaybe<Base_Bulk_Tipos_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Bulk_Tipos_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "base.bulk_tipos" */
export enum Base_Bulk_Tipos_Constraint {
  /** unique or primary key constraint on columns "id" */
  NosTipoPkey = 'nos_tipo_pkey'
}

/** input type for incrementing numeric columns in table "base.bulk_tipos" */
export type Base_Bulk_Tipos_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "base.bulk_tipos" */
export type Base_Bulk_Tipos_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Base_Bulk_Tipos_Max_Fields = {
  __typename?: 'base_bulk_tipos_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Base_Bulk_Tipos_Min_Fields = {
  __typename?: 'base_bulk_tipos_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "base.bulk_tipos" */
export type Base_Bulk_Tipos_Mutation_Response = {
  __typename?: 'base_bulk_tipos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Bulk_Tipos>;
};

/** input type for inserting object relation for remote table "base.bulk_tipos" */
export type Base_Bulk_Tipos_Obj_Rel_Insert_Input = {
  data: Base_Bulk_Tipos_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_Bulk_Tipos_On_Conflict>;
};

/** on_conflict condition type for table "base.bulk_tipos" */
export type Base_Bulk_Tipos_On_Conflict = {
  constraint: Base_Bulk_Tipos_Constraint;
  update_columns?: Array<Base_Bulk_Tipos_Update_Column>;
  where?: InputMaybe<Base_Bulk_Tipos_Bool_Exp>;
};

/** Ordering options when selecting data from "base.bulk_tipos". */
export type Base_Bulk_Tipos_Order_By = {
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base.bulk_tipos */
export type Base_Bulk_Tipos_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "base.bulk_tipos" */
export enum Base_Bulk_Tipos_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "base.bulk_tipos" */
export type Base_Bulk_Tipos_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Base_Bulk_Tipos_Stddev_Fields = {
  __typename?: 'base_bulk_tipos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Base_Bulk_Tipos_Stddev_Pop_Fields = {
  __typename?: 'base_bulk_tipos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Base_Bulk_Tipos_Stddev_Samp_Fields = {
  __typename?: 'base_bulk_tipos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "base_bulk_tipos" */
export type Base_Bulk_Tipos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Bulk_Tipos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Bulk_Tipos_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Base_Bulk_Tipos_Sum_Fields = {
  __typename?: 'base_bulk_tipos_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "base.bulk_tipos" */
export enum Base_Bulk_Tipos_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Base_Bulk_Tipos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Bulk_Tipos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Bulk_Tipos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Bulk_Tipos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Bulk_Tipos_Var_Pop_Fields = {
  __typename?: 'base_bulk_tipos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Base_Bulk_Tipos_Var_Samp_Fields = {
  __typename?: 'base_bulk_tipos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Base_Bulk_Tipos_Variance_Fields = {
  __typename?: 'base_bulk_tipos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "base.centros" */
export type Base_Centros = {
  __typename?: 'base_centros';
  apagado: Scalars['Boolean']['output'];
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  equipaVirtualCentros: Array<Utilizadores_Equipas_Virtuais_R_Centros>;
  /** An aggregate relationship */
  equipaVirtualCentros_aggregate: Utilizadores_Equipas_Virtuais_R_Centros_Aggregate;
  id: Scalars['bigint']['output'];
  morada?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  requisicoes: Array<Servicos_Requisicoes>;
  /** An aggregate relationship */
  requisicoes_aggregate: Servicos_Requisicoes_Aggregate;
};


/** columns and relationships of "base.centros" */
export type Base_CentrosEquipaVirtualCentrosArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>;
};


/** columns and relationships of "base.centros" */
export type Base_CentrosEquipaVirtualCentros_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>;
};


/** columns and relationships of "base.centros" */
export type Base_CentrosRequisicoesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
};


/** columns and relationships of "base.centros" */
export type Base_CentrosRequisicoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
};

/** aggregated selection of "base.centros" */
export type Base_Centros_Aggregate = {
  __typename?: 'base_centros_aggregate';
  aggregate?: Maybe<Base_Centros_Aggregate_Fields>;
  nodes: Array<Base_Centros>;
};

/** aggregate fields of "base.centros" */
export type Base_Centros_Aggregate_Fields = {
  __typename?: 'base_centros_aggregate_fields';
  avg?: Maybe<Base_Centros_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Base_Centros_Max_Fields>;
  min?: Maybe<Base_Centros_Min_Fields>;
  stddev?: Maybe<Base_Centros_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Centros_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Centros_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Centros_Sum_Fields>;
  var_pop?: Maybe<Base_Centros_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Centros_Var_Samp_Fields>;
  variance?: Maybe<Base_Centros_Variance_Fields>;
};


/** aggregate fields of "base.centros" */
export type Base_Centros_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Centros_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Base_Centros_Avg_Fields = {
  __typename?: 'base_centros_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "base.centros". All fields are combined with a logical 'AND'. */
export type Base_Centros_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Centros_Bool_Exp>>;
  _not?: InputMaybe<Base_Centros_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Centros_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  codigo?: InputMaybe<String_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  equipaVirtualCentros?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>;
  equipaVirtualCentros_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  morada?: InputMaybe<String_Comparison_Exp>;
  requisicoes?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
  requisicoes_aggregate?: InputMaybe<Servicos_Requisicoes_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "base.centros" */
export enum Base_Centros_Constraint {
  /** unique or primary key constraint on columns "id" */
  CentrosPkey = 'centros_pkey'
}

/** input type for incrementing numeric columns in table "base.centros" */
export type Base_Centros_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "base.centros" */
export type Base_Centros_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  equipaVirtualCentros?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  morada?: InputMaybe<Scalars['String']['input']>;
  requisicoes?: InputMaybe<Servicos_Requisicoes_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Base_Centros_Max_Fields = {
  __typename?: 'base_centros_max_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  morada?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Base_Centros_Min_Fields = {
  __typename?: 'base_centros_min_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  morada?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "base.centros" */
export type Base_Centros_Mutation_Response = {
  __typename?: 'base_centros_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Centros>;
};

/** input type for inserting object relation for remote table "base.centros" */
export type Base_Centros_Obj_Rel_Insert_Input = {
  data: Base_Centros_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_Centros_On_Conflict>;
};

/** on_conflict condition type for table "base.centros" */
export type Base_Centros_On_Conflict = {
  constraint: Base_Centros_Constraint;
  update_columns?: Array<Base_Centros_Update_Column>;
  where?: InputMaybe<Base_Centros_Bool_Exp>;
};

/** Ordering options when selecting data from "base.centros". */
export type Base_Centros_Order_By = {
  apagado?: InputMaybe<Order_By>;
  codigo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  equipaVirtualCentros_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  morada?: InputMaybe<Order_By>;
  requisicoes_aggregate?: InputMaybe<Servicos_Requisicoes_Aggregate_Order_By>;
};

/** primary key columns input for table: base.centros */
export type Base_Centros_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "base.centros" */
export enum Base_Centros_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  Morada = 'morada'
}

/** input type for updating data in table "base.centros" */
export type Base_Centros_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  morada?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Base_Centros_Stddev_Fields = {
  __typename?: 'base_centros_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Base_Centros_Stddev_Pop_Fields = {
  __typename?: 'base_centros_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Base_Centros_Stddev_Samp_Fields = {
  __typename?: 'base_centros_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "base_centros" */
export type Base_Centros_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Centros_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Centros_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  morada?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Base_Centros_Sum_Fields = {
  __typename?: 'base_centros_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "base.centros" */
export enum Base_Centros_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  Morada = 'morada'
}

export type Base_Centros_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Centros_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Centros_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Centros_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Centros_Var_Pop_Fields = {
  __typename?: 'base_centros_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Base_Centros_Var_Samp_Fields = {
  __typename?: 'base_centros_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Base_Centros_Variance_Fields = {
  __typename?: 'base_centros_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Base_Get_Infraestruturas_Tipos_Active_Childs_Args = {
  infraestrutura_tipo?: InputMaybe<Scalars['infraestruturas_tipos_scalar']['input']>;
};

/** columns and relationships of "base.infraestruturas" */
export type Base_Infraestruturas = {
  __typename?: 'base_infraestruturas';
  /** A computed field that returns infraestrutura active childs */
  activeChilds?: Maybe<Array<Base_Infraestruturas>>;
  apagado: Scalars['Boolean']['output'];
  arvore_bulk: Scalars['Boolean']['output'];
  atualiza_nome_completo?: Maybe<Scalars['Boolean']['output']>;
  atualiza_ordem_global?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  bulk?: Maybe<Base_Bulk_Tipos>;
  codigo_apa?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_ponto_amostragem?: Maybe<Scalars['String']['output']>;
  codigo_sap?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_modificacao: Scalars['timestamp']['output'];
  desactivado: Scalars['Boolean']['output'];
  descricao: Scalars['String']['output'];
  descricao_curta?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  equipaVirtualInfraestruturas: Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas>;
  /** An aggregate relationship */
  equipaVirtualInfraestruturas_aggregate: Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate;
  /** An array relationship */
  fontesOrigemEstatistica: Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica>;
  /** An aggregate relationship */
  fontesOrigemEstatistica_aggregate: Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate;
  /** An array relationship */
  fontesOrigemPropriedades: Array<Variaveis_Fontes_Origem_Propriedades>;
  /** An aggregate relationship */
  fontesOrigemPropriedades_aggregate: Variaveis_Fontes_Origem_Propriedades_Aggregate;
  gestao_ativos?: Maybe<Scalars['Boolean']['output']>;
  has_childs?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  id_centro_custo?: Maybe<Scalars['bigint']['output']>;
  id_instalacao?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura: Scalars['bigint']['output'];
  /** An array relationship */
  infraestruturaCoordenadas: Array<Base_Infraestruturas_Coordenadas>;
  /** An aggregate relationship */
  infraestruturaCoordenadas_aggregate: Base_Infraestruturas_Coordenadas_Aggregate;
  /** An object relationship */
  infraestruturaToponimia?: Maybe<Base_Infraestruturas_R_Toponimias>;
  /** An object relationship */
  instalacao?: Maybe<Base_Infraestruturas>;
  /** An array relationship */
  leituras: Array<Variaveis_Leituras>;
  /** An aggregate relationship */
  leituras_aggregate: Variaveis_Leituras_Aggregate;
  nome_completo?: Maybe<Scalars['String']['output']>;
  nome_instalacao?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  ordem_global?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  parentInfra?: Maybe<Base_Infraestruturas>;
  referencias?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  requisicoesLocaisInfraestruturas: Array<Servicos_Requisicoes_Locais_Infra_Estruturas>;
  /** An aggregate relationship */
  requisicoesLocaisInfraestruturas_aggregate: Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate;
  /** An object relationship */
  tipo: Base_Infraestruturas_Tipos;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasActiveChildsArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasEquipaVirtualInfraestruturasArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasEquipaVirtualInfraestruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasFontesOrigemEstatisticaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasFontesOrigemEstatistica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasFontesOrigemPropriedadesArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasFontesOrigemPropriedades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasInfraestruturaCoordenadasArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasInfraestruturaCoordenadas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasLeiturasArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasLeituras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasRequisicoesLocaisInfraestruturasArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas" */
export type Base_InfraestruturasRequisicoesLocaisInfraestruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
};

/** aggregated selection of "base.infraestruturas" */
export type Base_Infraestruturas_Aggregate = {
  __typename?: 'base_infraestruturas_aggregate';
  aggregate?: Maybe<Base_Infraestruturas_Aggregate_Fields>;
  nodes: Array<Base_Infraestruturas>;
};

export type Base_Infraestruturas_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Base_Infraestruturas_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Base_Infraestruturas_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Base_Infraestruturas_Aggregate_Bool_Exp_Count>;
};

export type Base_Infraestruturas_Aggregate_Bool_Exp_Bool_And = {
  arguments: Base_Infraestruturas_Select_Column_Base_Infraestruturas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Base_Infraestruturas_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Base_Infraestruturas_Select_Column_Base_Infraestruturas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Base_Infraestruturas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Base_Infraestruturas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "base.infraestruturas" */
export type Base_Infraestruturas_Aggregate_Fields = {
  __typename?: 'base_infraestruturas_aggregate_fields';
  avg?: Maybe<Base_Infraestruturas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Base_Infraestruturas_Max_Fields>;
  min?: Maybe<Base_Infraestruturas_Min_Fields>;
  stddev?: Maybe<Base_Infraestruturas_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Infraestruturas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Infraestruturas_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Infraestruturas_Sum_Fields>;
  var_pop?: Maybe<Base_Infraestruturas_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Infraestruturas_Var_Samp_Fields>;
  variance?: Maybe<Base_Infraestruturas_Variance_Fields>;
};


/** aggregate fields of "base.infraestruturas" */
export type Base_Infraestruturas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Infraestruturas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "base.infraestruturas" */
export type Base_Infraestruturas_Aggregate_Order_By = {
  avg?: InputMaybe<Base_Infraestruturas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_Infraestruturas_Max_Order_By>;
  min?: InputMaybe<Base_Infraestruturas_Min_Order_By>;
  stddev?: InputMaybe<Base_Infraestruturas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_Infraestruturas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_Infraestruturas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_Infraestruturas_Sum_Order_By>;
  var_pop?: InputMaybe<Base_Infraestruturas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_Infraestruturas_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_Infraestruturas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base.infraestruturas" */
export type Base_Infraestruturas_Arr_Rel_Insert_Input = {
  data: Array<Base_Infraestruturas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_Infraestruturas_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_Infraestruturas_Avg_Fields = {
  __typename?: 'base_infraestruturas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_instalacao?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  ordem_global?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "base.infraestruturas" */
export type Base_Infraestruturas_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_instalacao?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  ordem_global?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base.infraestruturas". All fields are combined with a logical 'AND'. */
export type Base_Infraestruturas_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Infraestruturas_Bool_Exp>>;
  _not?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Infraestruturas_Bool_Exp>>;
  activeChilds?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  arvore_bulk?: InputMaybe<Boolean_Comparison_Exp>;
  atualiza_nome_completo?: InputMaybe<Boolean_Comparison_Exp>;
  atualiza_ordem_global?: InputMaybe<Boolean_Comparison_Exp>;
  bulk?: InputMaybe<Base_Bulk_Tipos_Bool_Exp>;
  codigo_apa?: InputMaybe<String_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  codigo_manutencao?: InputMaybe<String_Comparison_Exp>;
  codigo_ponto_amostragem?: InputMaybe<String_Comparison_Exp>;
  codigo_sap?: InputMaybe<String_Comparison_Exp>;
  codigo_sig?: InputMaybe<String_Comparison_Exp>;
  data_hora_registo_bd?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_ultima_modificacao?: InputMaybe<Timestamp_Comparison_Exp>;
  desactivado?: InputMaybe<Boolean_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  descricao_curta?: InputMaybe<String_Comparison_Exp>;
  equipaVirtualInfraestruturas?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>;
  equipaVirtualInfraestruturas_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate_Bool_Exp>;
  fontesOrigemEstatistica?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
  fontesOrigemEstatistica_aggregate?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate_Bool_Exp>;
  fontesOrigemPropriedades?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
  fontesOrigemPropriedades_aggregate?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp>;
  gestao_ativos?: InputMaybe<Boolean_Comparison_Exp>;
  has_childs?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_centro_custo?: InputMaybe<Bigint_Comparison_Exp>;
  id_instalacao?: InputMaybe<Bigint_Comparison_Exp>;
  id_pai?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_bulk?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  infraestruturaCoordenadas?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
  infraestruturaCoordenadas_aggregate?: InputMaybe<Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp>;
  infraestruturaToponimia?: InputMaybe<Base_Infraestruturas_R_Toponimias_Bool_Exp>;
  instalacao?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  leituras?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
  leituras_aggregate?: InputMaybe<Variaveis_Leituras_Aggregate_Bool_Exp>;
  nome_completo?: InputMaybe<String_Comparison_Exp>;
  nome_instalacao?: InputMaybe<String_Comparison_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
  ordem_global?: InputMaybe<Int_Comparison_Exp>;
  parentInfra?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  referencias?: InputMaybe<String_Comparison_Exp>;
  requisicoesLocaisInfraestruturas?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
  requisicoesLocaisInfraestruturas_aggregate?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate_Bool_Exp>;
  tipo?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};

/** unique or primary key constraints on table "base.infraestruturas" */
export enum Base_Infraestruturas_Constraint {
  /** unique or primary key constraint on columns "id" */
  ArvoreCompletaPkey = 'arvore_completa_pkey',
  /** unique or primary key constraint on columns "id_tipo_infraestrutura", "codigo_externo" */
  IndUniqueInfraestruturasTipoCodigoExterno = 'ind_unique_infraestruturas_tipo_codigo_externo'
}

/** columns and relationships of "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas = {
  __typename?: 'base_infraestruturas_coordenadas';
  id: Scalars['bigint']['output'];
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  infraestrutura?: Maybe<Base_Infraestruturas>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['numeric']['output']>;
  principal?: Maybe<Scalars['Boolean']['output']>;
  proximidade?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Aggregate = {
  __typename?: 'base_infraestruturas_coordenadas_aggregate';
  aggregate?: Maybe<Base_Infraestruturas_Coordenadas_Aggregate_Fields>;
  nodes: Array<Base_Infraestruturas_Coordenadas>;
};

export type Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp_Count>;
};

export type Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp_Bool_And = {
  arguments: Base_Infraestruturas_Coordenadas_Select_Column_Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Base_Infraestruturas_Coordenadas_Select_Column_Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Aggregate_Fields = {
  __typename?: 'base_infraestruturas_coordenadas_aggregate_fields';
  avg?: Maybe<Base_Infraestruturas_Coordenadas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Base_Infraestruturas_Coordenadas_Max_Fields>;
  min?: Maybe<Base_Infraestruturas_Coordenadas_Min_Fields>;
  stddev?: Maybe<Base_Infraestruturas_Coordenadas_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Infraestruturas_Coordenadas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Infraestruturas_Coordenadas_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Infraestruturas_Coordenadas_Sum_Fields>;
  var_pop?: Maybe<Base_Infraestruturas_Coordenadas_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Infraestruturas_Coordenadas_Var_Samp_Fields>;
  variance?: Maybe<Base_Infraestruturas_Coordenadas_Variance_Fields>;
};


/** aggregate fields of "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Aggregate_Order_By = {
  avg?: InputMaybe<Base_Infraestruturas_Coordenadas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_Infraestruturas_Coordenadas_Max_Order_By>;
  min?: InputMaybe<Base_Infraestruturas_Coordenadas_Min_Order_By>;
  stddev?: InputMaybe<Base_Infraestruturas_Coordenadas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_Infraestruturas_Coordenadas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_Infraestruturas_Coordenadas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_Infraestruturas_Coordenadas_Sum_Order_By>;
  var_pop?: InputMaybe<Base_Infraestruturas_Coordenadas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_Infraestruturas_Coordenadas_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_Infraestruturas_Coordenadas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Arr_Rel_Insert_Input = {
  data: Array<Base_Infraestruturas_Coordenadas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_Infraestruturas_Coordenadas_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_Infraestruturas_Coordenadas_Avg_Fields = {
  __typename?: 'base_infraestruturas_coordenadas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  proximidade?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  proximidade?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base.infraestruturas_coordenadas". All fields are combined with a logical 'AND'. */
export type Base_Infraestruturas_Coordenadas_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Bool_Exp>>;
  _not?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
  ordem?: InputMaybe<Numeric_Comparison_Exp>;
  principal?: InputMaybe<Boolean_Comparison_Exp>;
  proximidade?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "base.infraestruturas_coordenadas" */
export enum Base_Infraestruturas_Coordenadas_Constraint {
  /** unique or primary key constraint on columns "id" */
  InfraEstruturasCoordenadasPkey = 'infra_estruturas_coordenadas_pkey'
}

/** input type for incrementing numeric columns in table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['numeric']['input']>;
  proximidade?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['numeric']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
  proximidade?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Base_Infraestruturas_Coordenadas_Max_Fields = {
  __typename?: 'base_infraestruturas_coordenadas_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['numeric']['output']>;
  proximidade?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  proximidade?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_Infraestruturas_Coordenadas_Min_Fields = {
  __typename?: 'base_infraestruturas_coordenadas_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['numeric']['output']>;
  proximidade?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  proximidade?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Mutation_Response = {
  __typename?: 'base_infraestruturas_coordenadas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Infraestruturas_Coordenadas>;
};

/** on_conflict condition type for table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_On_Conflict = {
  constraint: Base_Infraestruturas_Coordenadas_Constraint;
  update_columns?: Array<Base_Infraestruturas_Coordenadas_Update_Column>;
  where?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
};

/** Ordering options when selecting data from "base.infraestruturas_coordenadas". */
export type Base_Infraestruturas_Coordenadas_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  principal?: InputMaybe<Order_By>;
  proximidade?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base.infraestruturas_coordenadas */
export type Base_Infraestruturas_Coordenadas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "base.infraestruturas_coordenadas" */
export enum Base_Infraestruturas_Coordenadas_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  Principal = 'principal',
  /** column name */
  Proximidade = 'proximidade'
}

/** select "base_infraestruturas_coordenadas_aggregate_bool_exp_bool_and_arguments_columns" columns of table "base.infraestruturas_coordenadas" */
export enum Base_Infraestruturas_Coordenadas_Select_Column_Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Principal = 'principal'
}

/** select "base_infraestruturas_coordenadas_aggregate_bool_exp_bool_or_arguments_columns" columns of table "base.infraestruturas_coordenadas" */
export enum Base_Infraestruturas_Coordenadas_Select_Column_Base_Infraestruturas_Coordenadas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Principal = 'principal'
}

/** input type for updating data in table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['numeric']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
  proximidade?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Base_Infraestruturas_Coordenadas_Stddev_Fields = {
  __typename?: 'base_infraestruturas_coordenadas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  proximidade?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  proximidade?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_Infraestruturas_Coordenadas_Stddev_Pop_Fields = {
  __typename?: 'base_infraestruturas_coordenadas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  proximidade?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  proximidade?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_Infraestruturas_Coordenadas_Stddev_Samp_Fields = {
  __typename?: 'base_infraestruturas_coordenadas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  proximidade?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  proximidade?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Infraestruturas_Coordenadas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Infraestruturas_Coordenadas_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['numeric']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
  proximidade?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Base_Infraestruturas_Coordenadas_Sum_Fields = {
  __typename?: 'base_infraestruturas_coordenadas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['numeric']['output']>;
  proximidade?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  proximidade?: InputMaybe<Order_By>;
};

/** update columns of table "base.infraestruturas_coordenadas" */
export enum Base_Infraestruturas_Coordenadas_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  Principal = 'principal',
  /** column name */
  Proximidade = 'proximidade'
}

export type Base_Infraestruturas_Coordenadas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Infraestruturas_Coordenadas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Infraestruturas_Coordenadas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Infraestruturas_Coordenadas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Infraestruturas_Coordenadas_Var_Pop_Fields = {
  __typename?: 'base_infraestruturas_coordenadas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  proximidade?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  proximidade?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_Infraestruturas_Coordenadas_Var_Samp_Fields = {
  __typename?: 'base_infraestruturas_coordenadas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  proximidade?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  proximidade?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_Infraestruturas_Coordenadas_Variance_Fields = {
  __typename?: 'base_infraestruturas_coordenadas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  proximidade?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "base.infraestruturas_coordenadas" */
export type Base_Infraestruturas_Coordenadas_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  proximidade?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "base.infraestruturas" */
export type Base_Infraestruturas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro_custo?: InputMaybe<Scalars['bigint']['input']>;
  id_instalacao?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_bulk?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  ordem_global?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "base.infraestruturas" */
export type Base_Infraestruturas_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  arvore_bulk?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_ordem_global?: InputMaybe<Scalars['Boolean']['input']>;
  bulk?: InputMaybe<Base_Bulk_Tipos_Obj_Rel_Insert_Input>;
  codigo_apa?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  codigo_manutencao?: InputMaybe<Scalars['String']['input']>;
  codigo_ponto_amostragem?: InputMaybe<Scalars['String']['input']>;
  codigo_sap?: InputMaybe<Scalars['String']['input']>;
  codigo_sig?: InputMaybe<Scalars['String']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  desactivado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  equipaVirtualInfraestruturas?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Arr_Rel_Insert_Input>;
  fontesOrigemEstatistica?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Arr_Rel_Insert_Input>;
  fontesOrigemPropriedades?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Arr_Rel_Insert_Input>;
  gestao_ativos?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro_custo?: InputMaybe<Scalars['bigint']['input']>;
  id_instalacao?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_bulk?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  infraestruturaCoordenadas?: InputMaybe<Base_Infraestruturas_Coordenadas_Arr_Rel_Insert_Input>;
  infraestruturaToponimia?: InputMaybe<Base_Infraestruturas_R_Toponimias_Obj_Rel_Insert_Input>;
  instalacao?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
  leituras?: InputMaybe<Variaveis_Leituras_Arr_Rel_Insert_Input>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  nome_instalacao?: InputMaybe<Scalars['String']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  ordem_global?: InputMaybe<Scalars['Int']['input']>;
  parentInfra?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
  referencias?: InputMaybe<Scalars['String']['input']>;
  requisicoesLocaisInfraestruturas?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Arr_Rel_Insert_Input>;
  tipo?: InputMaybe<Base_Infraestruturas_Tipos_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Base_Infraestruturas_Max_Fields = {
  __typename?: 'base_infraestruturas_max_fields';
  codigo_apa?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_ponto_amostragem?: Maybe<Scalars['String']['output']>;
  codigo_sap?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro_custo?: Maybe<Scalars['bigint']['output']>;
  id_instalacao?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  nome_instalacao?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  ordem_global?: Maybe<Scalars['Int']['output']>;
  referencias?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "base.infraestruturas" */
export type Base_Infraestruturas_Max_Order_By = {
  codigo_apa?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  codigo_manutencao?: InputMaybe<Order_By>;
  codigo_ponto_amostragem?: InputMaybe<Order_By>;
  codigo_sap?: InputMaybe<Order_By>;
  codigo_sig?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_instalacao?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
  nome_instalacao?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  ordem_global?: InputMaybe<Order_By>;
  referencias?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_Infraestruturas_Min_Fields = {
  __typename?: 'base_infraestruturas_min_fields';
  codigo_apa?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_ponto_amostragem?: Maybe<Scalars['String']['output']>;
  codigo_sap?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro_custo?: Maybe<Scalars['bigint']['output']>;
  id_instalacao?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  nome_instalacao?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  ordem_global?: Maybe<Scalars['Int']['output']>;
  referencias?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "base.infraestruturas" */
export type Base_Infraestruturas_Min_Order_By = {
  codigo_apa?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  codigo_manutencao?: InputMaybe<Order_By>;
  codigo_ponto_amostragem?: InputMaybe<Order_By>;
  codigo_sap?: InputMaybe<Order_By>;
  codigo_sig?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_instalacao?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
  nome_instalacao?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  ordem_global?: InputMaybe<Order_By>;
  referencias?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base.infraestruturas" */
export type Base_Infraestruturas_Mutation_Response = {
  __typename?: 'base_infraestruturas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Infraestruturas>;
};

/** input type for inserting object relation for remote table "base.infraestruturas" */
export type Base_Infraestruturas_Obj_Rel_Insert_Input = {
  data: Base_Infraestruturas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_Infraestruturas_On_Conflict>;
};

/** on_conflict condition type for table "base.infraestruturas" */
export type Base_Infraestruturas_On_Conflict = {
  constraint: Base_Infraestruturas_Constraint;
  update_columns?: Array<Base_Infraestruturas_Update_Column>;
  where?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
};

/** Ordering options when selecting data from "base.infraestruturas". */
export type Base_Infraestruturas_Order_By = {
  activeChilds_aggregate?: InputMaybe<Base_Infraestruturas_Aggregate_Order_By>;
  apagado?: InputMaybe<Order_By>;
  arvore_bulk?: InputMaybe<Order_By>;
  atualiza_nome_completo?: InputMaybe<Order_By>;
  atualiza_ordem_global?: InputMaybe<Order_By>;
  bulk?: InputMaybe<Base_Bulk_Tipos_Order_By>;
  codigo_apa?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  codigo_manutencao?: InputMaybe<Order_By>;
  codigo_ponto_amostragem?: InputMaybe<Order_By>;
  codigo_sap?: InputMaybe<Order_By>;
  codigo_sig?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  desactivado?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  equipaVirtualInfraestruturas_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate_Order_By>;
  fontesOrigemEstatistica_aggregate?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate_Order_By>;
  fontesOrigemPropriedades_aggregate?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Aggregate_Order_By>;
  gestao_ativos?: InputMaybe<Order_By>;
  has_childs?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_instalacao?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  infraestruturaCoordenadas_aggregate?: InputMaybe<Base_Infraestruturas_Coordenadas_Aggregate_Order_By>;
  infraestruturaToponimia?: InputMaybe<Base_Infraestruturas_R_Toponimias_Order_By>;
  instalacao?: InputMaybe<Base_Infraestruturas_Order_By>;
  leituras_aggregate?: InputMaybe<Variaveis_Leituras_Aggregate_Order_By>;
  nome_completo?: InputMaybe<Order_By>;
  nome_instalacao?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  ordem_global?: InputMaybe<Order_By>;
  parentInfra?: InputMaybe<Base_Infraestruturas_Order_By>;
  referencias?: InputMaybe<Order_By>;
  requisicoesLocaisInfraestruturas_aggregate?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate_Order_By>;
  tipo?: InputMaybe<Base_Infraestruturas_Tipos_Order_By>;
};

/** primary key columns input for table: base.infraestruturas */
export type Base_Infraestruturas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "base.infraestruturas_r_toponimias" */
export type Base_Infraestruturas_R_Toponimias = {
  __typename?: 'base_infraestruturas_r_toponimias';
  id: Scalars['bigint']['output'];
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  infraestrutura?: Maybe<Base_Infraestruturas>;
  principal?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  toponimia?: Maybe<Base_Toponimias>;
};

/** aggregated selection of "base.infraestruturas_r_toponimias" */
export type Base_Infraestruturas_R_Toponimias_Aggregate = {
  __typename?: 'base_infraestruturas_r_toponimias_aggregate';
  aggregate?: Maybe<Base_Infraestruturas_R_Toponimias_Aggregate_Fields>;
  nodes: Array<Base_Infraestruturas_R_Toponimias>;
};

/** aggregate fields of "base.infraestruturas_r_toponimias" */
export type Base_Infraestruturas_R_Toponimias_Aggregate_Fields = {
  __typename?: 'base_infraestruturas_r_toponimias_aggregate_fields';
  avg?: Maybe<Base_Infraestruturas_R_Toponimias_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Base_Infraestruturas_R_Toponimias_Max_Fields>;
  min?: Maybe<Base_Infraestruturas_R_Toponimias_Min_Fields>;
  stddev?: Maybe<Base_Infraestruturas_R_Toponimias_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Infraestruturas_R_Toponimias_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Infraestruturas_R_Toponimias_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Infraestruturas_R_Toponimias_Sum_Fields>;
  var_pop?: Maybe<Base_Infraestruturas_R_Toponimias_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Infraestruturas_R_Toponimias_Var_Samp_Fields>;
  variance?: Maybe<Base_Infraestruturas_R_Toponimias_Variance_Fields>;
};


/** aggregate fields of "base.infraestruturas_r_toponimias" */
export type Base_Infraestruturas_R_Toponimias_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Infraestruturas_R_Toponimias_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Base_Infraestruturas_R_Toponimias_Avg_Fields = {
  __typename?: 'base_infraestruturas_r_toponimias_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "base.infraestruturas_r_toponimias". All fields are combined with a logical 'AND'. */
export type Base_Infraestruturas_R_Toponimias_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Infraestruturas_R_Toponimias_Bool_Exp>>;
  _not?: InputMaybe<Base_Infraestruturas_R_Toponimias_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Infraestruturas_R_Toponimias_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_toponimia?: InputMaybe<Bigint_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  principal?: InputMaybe<Boolean_Comparison_Exp>;
  toponimia?: InputMaybe<Base_Toponimias_Bool_Exp>;
};

/** unique or primary key constraints on table "base.infraestruturas_r_toponimias" */
export enum Base_Infraestruturas_R_Toponimias_Constraint {
  /** unique or primary key constraint on columns "id" */
  InfraEstruturasRArvorePkey = 'infra_estruturas_r_arvore_pkey'
}

/** input type for incrementing numeric columns in table "base.infraestruturas_r_toponimias" */
export type Base_Infraestruturas_R_Toponimias_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "base.infraestruturas_r_toponimias" */
export type Base_Infraestruturas_R_Toponimias_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
  toponimia?: InputMaybe<Base_Toponimias_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Base_Infraestruturas_R_Toponimias_Max_Fields = {
  __typename?: 'base_infraestruturas_r_toponimias_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Base_Infraestruturas_R_Toponimias_Min_Fields = {
  __typename?: 'base_infraestruturas_r_toponimias_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "base.infraestruturas_r_toponimias" */
export type Base_Infraestruturas_R_Toponimias_Mutation_Response = {
  __typename?: 'base_infraestruturas_r_toponimias_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Infraestruturas_R_Toponimias>;
};

/** input type for inserting object relation for remote table "base.infraestruturas_r_toponimias" */
export type Base_Infraestruturas_R_Toponimias_Obj_Rel_Insert_Input = {
  data: Base_Infraestruturas_R_Toponimias_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_Infraestruturas_R_Toponimias_On_Conflict>;
};

/** on_conflict condition type for table "base.infraestruturas_r_toponimias" */
export type Base_Infraestruturas_R_Toponimias_On_Conflict = {
  constraint: Base_Infraestruturas_R_Toponimias_Constraint;
  update_columns?: Array<Base_Infraestruturas_R_Toponimias_Update_Column>;
  where?: InputMaybe<Base_Infraestruturas_R_Toponimias_Bool_Exp>;
};

/** Ordering options when selecting data from "base.infraestruturas_r_toponimias". */
export type Base_Infraestruturas_R_Toponimias_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
  principal?: InputMaybe<Order_By>;
  toponimia?: InputMaybe<Base_Toponimias_Order_By>;
};

/** primary key columns input for table: base.infraestruturas_r_toponimias */
export type Base_Infraestruturas_R_Toponimias_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "base.infraestruturas_r_toponimias" */
export enum Base_Infraestruturas_R_Toponimias_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  Principal = 'principal'
}

/** input type for updating data in table "base.infraestruturas_r_toponimias" */
export type Base_Infraestruturas_R_Toponimias_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Base_Infraestruturas_R_Toponimias_Stddev_Fields = {
  __typename?: 'base_infraestruturas_r_toponimias_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Base_Infraestruturas_R_Toponimias_Stddev_Pop_Fields = {
  __typename?: 'base_infraestruturas_r_toponimias_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Base_Infraestruturas_R_Toponimias_Stddev_Samp_Fields = {
  __typename?: 'base_infraestruturas_r_toponimias_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "base_infraestruturas_r_toponimias" */
export type Base_Infraestruturas_R_Toponimias_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Infraestruturas_R_Toponimias_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Infraestruturas_R_Toponimias_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Base_Infraestruturas_R_Toponimias_Sum_Fields = {
  __typename?: 'base_infraestruturas_r_toponimias_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "base.infraestruturas_r_toponimias" */
export enum Base_Infraestruturas_R_Toponimias_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  Principal = 'principal'
}

export type Base_Infraestruturas_R_Toponimias_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Infraestruturas_R_Toponimias_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Infraestruturas_R_Toponimias_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Infraestruturas_R_Toponimias_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Infraestruturas_R_Toponimias_Var_Pop_Fields = {
  __typename?: 'base_infraestruturas_r_toponimias_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Base_Infraestruturas_R_Toponimias_Var_Samp_Fields = {
  __typename?: 'base_infraestruturas_r_toponimias_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Base_Infraestruturas_R_Toponimias_Variance_Fields = {
  __typename?: 'base_infraestruturas_r_toponimias_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "base.infraestruturas" */
export enum Base_Infraestruturas_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  ArvoreBulk = 'arvore_bulk',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  AtualizaOrdemGlobal = 'atualiza_ordem_global',
  /** column name */
  CodigoApa = 'codigo_apa',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  CodigoManutencao = 'codigo_manutencao',
  /** column name */
  CodigoPontoAmostragem = 'codigo_ponto_amostragem',
  /** column name */
  CodigoSap = 'codigo_sap',
  /** column name */
  CodigoSig = 'codigo_sig',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaModificacao = 'data_hora_ultima_modificacao',
  /** column name */
  Desactivado = 'desactivado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  GestaoAtivos = 'gestao_ativos',
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  Id = 'id',
  /** column name */
  IdCentroCusto = 'id_centro_custo',
  /** column name */
  IdInstalacao = 'id_instalacao',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdTipoBulk = 'id_tipo_bulk',
  /** column name */
  IdTipoInfraestrutura = 'id_tipo_infraestrutura',
  /** column name */
  NomeCompleto = 'nome_completo',
  /** column name */
  NomeInstalacao = 'nome_instalacao',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  OrdemGlobal = 'ordem_global',
  /** column name */
  Referencias = 'referencias'
}

/** select "base_infraestruturas_aggregate_bool_exp_bool_and_arguments_columns" columns of table "base.infraestruturas" */
export enum Base_Infraestruturas_Select_Column_Base_Infraestruturas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  ArvoreBulk = 'arvore_bulk',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  AtualizaOrdemGlobal = 'atualiza_ordem_global',
  /** column name */
  Desactivado = 'desactivado',
  /** column name */
  GestaoAtivos = 'gestao_ativos',
  /** column name */
  HasChilds = 'has_childs'
}

/** select "base_infraestruturas_aggregate_bool_exp_bool_or_arguments_columns" columns of table "base.infraestruturas" */
export enum Base_Infraestruturas_Select_Column_Base_Infraestruturas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  ArvoreBulk = 'arvore_bulk',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  AtualizaOrdemGlobal = 'atualiza_ordem_global',
  /** column name */
  Desactivado = 'desactivado',
  /** column name */
  GestaoAtivos = 'gestao_ativos',
  /** column name */
  HasChilds = 'has_childs'
}

/** input type for updating data in table "base.infraestruturas" */
export type Base_Infraestruturas_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  arvore_bulk?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_ordem_global?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_apa?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  codigo_manutencao?: InputMaybe<Scalars['String']['input']>;
  codigo_ponto_amostragem?: InputMaybe<Scalars['String']['input']>;
  codigo_sap?: InputMaybe<Scalars['String']['input']>;
  codigo_sig?: InputMaybe<Scalars['String']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  desactivado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  gestao_ativos?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro_custo?: InputMaybe<Scalars['bigint']['input']>;
  id_instalacao?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_bulk?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  nome_instalacao?: InputMaybe<Scalars['String']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  ordem_global?: InputMaybe<Scalars['Int']['input']>;
  referencias?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Base_Infraestruturas_Stddev_Fields = {
  __typename?: 'base_infraestruturas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_instalacao?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  ordem_global?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "base.infraestruturas" */
export type Base_Infraestruturas_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_instalacao?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  ordem_global?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_Infraestruturas_Stddev_Pop_Fields = {
  __typename?: 'base_infraestruturas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_instalacao?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  ordem_global?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "base.infraestruturas" */
export type Base_Infraestruturas_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_instalacao?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  ordem_global?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_Infraestruturas_Stddev_Samp_Fields = {
  __typename?: 'base_infraestruturas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_instalacao?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  ordem_global?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "base.infraestruturas" */
export type Base_Infraestruturas_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_instalacao?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  ordem_global?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_infraestruturas" */
export type Base_Infraestruturas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Infraestruturas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Infraestruturas_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  arvore_bulk?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_ordem_global?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_apa?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  codigo_manutencao?: InputMaybe<Scalars['String']['input']>;
  codigo_ponto_amostragem?: InputMaybe<Scalars['String']['input']>;
  codigo_sap?: InputMaybe<Scalars['String']['input']>;
  codigo_sig?: InputMaybe<Scalars['String']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  desactivado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  gestao_ativos?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro_custo?: InputMaybe<Scalars['bigint']['input']>;
  id_instalacao?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_bulk?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  nome_instalacao?: InputMaybe<Scalars['String']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  ordem_global?: InputMaybe<Scalars['Int']['input']>;
  referencias?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Base_Infraestruturas_Sum_Fields = {
  __typename?: 'base_infraestruturas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro_custo?: Maybe<Scalars['bigint']['output']>;
  id_instalacao?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  ordem_global?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "base.infraestruturas" */
export type Base_Infraestruturas_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_instalacao?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  ordem_global?: InputMaybe<Order_By>;
};

/** columns and relationships of "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos = {
  __typename?: 'base_infraestruturas_tipos';
  /** A computed field that returns infraestrutura tipo active childs */
  activeChilds?: Maybe<Array<Base_Infraestruturas_Tipos>>;
  apagado: Scalars['Boolean']['output'];
  atualiza_nome_completo?: Maybe<Scalars['Boolean']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  cor?: Maybe<Scalars['String']['output']>;
  descricao: Scalars['String']['output'];
  descricao_curta?: Maybe<Scalars['String']['output']>;
  georeferenciar_filhos?: Maybe<Scalars['Boolean']['output']>;
  has_childs?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_sig_service?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  infraestruturas: Array<Base_Infraestruturas>;
  /** An aggregate relationship */
  infraestruturas_aggregate: Base_Infraestruturas_Aggregate;
  layer_name?: Maybe<Scalars['String']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  sig_actualiza_descricao?: Maybe<Scalars['Boolean']['output']>;
  sig_actualiza_infraestruturas?: Maybe<Scalars['Boolean']['output']>;
  sig_atributo_codigo_manutencao?: Maybe<Scalars['String']['output']>;
  sig_atributo_codigo_ponto_amostragem?: Maybe<Scalars['String']['output']>;
  sig_atributo_codigo_sap?: Maybe<Scalars['String']['output']>;
  sig_atributo_codigo_sig?: Maybe<Scalars['String']['output']>;
  sig_atributo_descricao?: Maybe<Scalars['String']['output']>;
  sig_atributo_freguesia?: Maybe<Scalars['String']['output']>;
  sig_atributo_id?: Maybe<Scalars['String']['output']>;
  sig_atributo_numero_policia?: Maybe<Scalars['String']['output']>;
  sig_atributo_rua?: Maybe<Scalars['String']['output']>;
  sig_atributo_subzmc?: Maybe<Scalars['String']['output']>;
  sig_atributo_zmc?: Maybe<Scalars['String']['output']>;
  sig_data_ultimo_sync?: Maybe<Scalars['timestamp']['output']>;
};


/** columns and relationships of "base.infraestruturas_tipos" */
export type Base_Infraestruturas_TiposActiveChildsArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Tipos_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas_tipos" */
export type Base_Infraestruturas_TiposInfraestruturasArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
};


/** columns and relationships of "base.infraestruturas_tipos" */
export type Base_Infraestruturas_TiposInfraestruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
};

export type Base_Infraestruturas_Tipos_Aggregate = {
  __typename?: 'base_infraestruturas_tipos_aggregate';
  aggregate?: Maybe<Base_Infraestruturas_Tipos_Aggregate_Fields>;
  nodes: Array<Base_Infraestruturas_Tipos>;
};

/** aggregate fields of "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Aggregate_Fields = {
  __typename?: 'base_infraestruturas_tipos_aggregate_fields';
  avg?: Maybe<Base_Infraestruturas_Tipos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Base_Infraestruturas_Tipos_Max_Fields>;
  min?: Maybe<Base_Infraestruturas_Tipos_Min_Fields>;
  stddev?: Maybe<Base_Infraestruturas_Tipos_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Infraestruturas_Tipos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Infraestruturas_Tipos_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Infraestruturas_Tipos_Sum_Fields>;
  var_pop?: Maybe<Base_Infraestruturas_Tipos_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Infraestruturas_Tipos_Var_Samp_Fields>;
  variance?: Maybe<Base_Infraestruturas_Tipos_Variance_Fields>;
};


/** aggregate fields of "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Infraestruturas_Tipos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Aggregate_Order_By = {
  avg?: InputMaybe<Base_Infraestruturas_Tipos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_Infraestruturas_Tipos_Max_Order_By>;
  min?: InputMaybe<Base_Infraestruturas_Tipos_Min_Order_By>;
  stddev?: InputMaybe<Base_Infraestruturas_Tipos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_Infraestruturas_Tipos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_Infraestruturas_Tipos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_Infraestruturas_Tipos_Sum_Order_By>;
  var_pop?: InputMaybe<Base_Infraestruturas_Tipos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_Infraestruturas_Tipos_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_Infraestruturas_Tipos_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Base_Infraestruturas_Tipos_Avg_Fields = {
  __typename?: 'base_infraestruturas_tipos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base.infraestruturas_tipos". All fields are combined with a logical 'AND'. */
export type Base_Infraestruturas_Tipos_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Infraestruturas_Tipos_Bool_Exp>>;
  _not?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Infraestruturas_Tipos_Bool_Exp>>;
  activeChilds?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  atualiza_nome_completo?: InputMaybe<Boolean_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  cor?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  descricao_curta?: InputMaybe<String_Comparison_Exp>;
  georeferenciar_filhos?: InputMaybe<Boolean_Comparison_Exp>;
  has_childs?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_no_tipo?: InputMaybe<Bigint_Comparison_Exp>;
  id_pai?: InputMaybe<Bigint_Comparison_Exp>;
  id_sig_service?: InputMaybe<Bigint_Comparison_Exp>;
  id_zona_bacia?: InputMaybe<Bigint_Comparison_Exp>;
  infraestruturas?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  infraestruturas_aggregate?: InputMaybe<Base_Infraestruturas_Aggregate_Bool_Exp>;
  layer_name?: InputMaybe<String_Comparison_Exp>;
  nome_completo?: InputMaybe<String_Comparison_Exp>;
  readonly?: InputMaybe<Boolean_Comparison_Exp>;
  sig_actualiza_descricao?: InputMaybe<Boolean_Comparison_Exp>;
  sig_actualiza_infraestruturas?: InputMaybe<Boolean_Comparison_Exp>;
  sig_atributo_codigo_manutencao?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_codigo_ponto_amostragem?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_codigo_sap?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_codigo_sig?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_descricao?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_freguesia?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_id?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_numero_policia?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_rua?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_subzmc?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_zmc?: InputMaybe<String_Comparison_Exp>;
  sig_data_ultimo_sync?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "base.infraestruturas_tipos" */
export enum Base_Infraestruturas_Tipos_Constraint {
  /** unique or primary key constraint on columns "id" */
  TiposPkey = 'tipos_pkey',
  /** unique or primary key constraint on columns "codigo_externo" */
  UniqueBaseInfraestruturasTiposCodigoExterno = 'unique_base_infraestruturas_tipos_codigo_externo',
  /** unique or primary key constraint on columns "id" */
  UniqueFkIdTipoInfraestrutura = 'unique_fk_id_tipo_infraestrutura'
}

/** input type for incrementing numeric columns in table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_sig_service?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  georeferenciar_filhos?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_sig_service?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
  infraestruturas?: InputMaybe<Base_Infraestruturas_Arr_Rel_Insert_Input>;
  layer_name?: InputMaybe<Scalars['String']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  sig_actualiza_descricao?: InputMaybe<Scalars['Boolean']['input']>;
  sig_actualiza_infraestruturas?: InputMaybe<Scalars['Boolean']['input']>;
  sig_atributo_codigo_manutencao?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_codigo_ponto_amostragem?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_codigo_sap?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_codigo_sig?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_descricao?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_freguesia?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_id?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_numero_policia?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_rua?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_subzmc?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_zmc?: InputMaybe<Scalars['String']['input']>;
  sig_data_ultimo_sync?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Base_Infraestruturas_Tipos_Max_Fields = {
  __typename?: 'base_infraestruturas_tipos_max_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_sig_service?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
  layer_name?: Maybe<Scalars['String']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  sig_atributo_codigo_manutencao?: Maybe<Scalars['String']['output']>;
  sig_atributo_codigo_ponto_amostragem?: Maybe<Scalars['String']['output']>;
  sig_atributo_codigo_sap?: Maybe<Scalars['String']['output']>;
  sig_atributo_codigo_sig?: Maybe<Scalars['String']['output']>;
  sig_atributo_descricao?: Maybe<Scalars['String']['output']>;
  sig_atributo_freguesia?: Maybe<Scalars['String']['output']>;
  sig_atributo_id?: Maybe<Scalars['String']['output']>;
  sig_atributo_numero_policia?: Maybe<Scalars['String']['output']>;
  sig_atributo_rua?: Maybe<Scalars['String']['output']>;
  sig_atributo_subzmc?: Maybe<Scalars['String']['output']>;
  sig_atributo_zmc?: Maybe<Scalars['String']['output']>;
  sig_data_ultimo_sync?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Max_Order_By = {
  codigo_externo?: InputMaybe<Order_By>;
  cor?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
  layer_name?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
  sig_atributo_codigo_manutencao?: InputMaybe<Order_By>;
  sig_atributo_codigo_ponto_amostragem?: InputMaybe<Order_By>;
  sig_atributo_codigo_sap?: InputMaybe<Order_By>;
  sig_atributo_codigo_sig?: InputMaybe<Order_By>;
  sig_atributo_descricao?: InputMaybe<Order_By>;
  sig_atributo_freguesia?: InputMaybe<Order_By>;
  sig_atributo_id?: InputMaybe<Order_By>;
  sig_atributo_numero_policia?: InputMaybe<Order_By>;
  sig_atributo_rua?: InputMaybe<Order_By>;
  sig_atributo_subzmc?: InputMaybe<Order_By>;
  sig_atributo_zmc?: InputMaybe<Order_By>;
  sig_data_ultimo_sync?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_Infraestruturas_Tipos_Min_Fields = {
  __typename?: 'base_infraestruturas_tipos_min_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_sig_service?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
  layer_name?: Maybe<Scalars['String']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  sig_atributo_codigo_manutencao?: Maybe<Scalars['String']['output']>;
  sig_atributo_codigo_ponto_amostragem?: Maybe<Scalars['String']['output']>;
  sig_atributo_codigo_sap?: Maybe<Scalars['String']['output']>;
  sig_atributo_codigo_sig?: Maybe<Scalars['String']['output']>;
  sig_atributo_descricao?: Maybe<Scalars['String']['output']>;
  sig_atributo_freguesia?: Maybe<Scalars['String']['output']>;
  sig_atributo_id?: Maybe<Scalars['String']['output']>;
  sig_atributo_numero_policia?: Maybe<Scalars['String']['output']>;
  sig_atributo_rua?: Maybe<Scalars['String']['output']>;
  sig_atributo_subzmc?: Maybe<Scalars['String']['output']>;
  sig_atributo_zmc?: Maybe<Scalars['String']['output']>;
  sig_data_ultimo_sync?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Min_Order_By = {
  codigo_externo?: InputMaybe<Order_By>;
  cor?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
  layer_name?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
  sig_atributo_codigo_manutencao?: InputMaybe<Order_By>;
  sig_atributo_codigo_ponto_amostragem?: InputMaybe<Order_By>;
  sig_atributo_codigo_sap?: InputMaybe<Order_By>;
  sig_atributo_codigo_sig?: InputMaybe<Order_By>;
  sig_atributo_descricao?: InputMaybe<Order_By>;
  sig_atributo_freguesia?: InputMaybe<Order_By>;
  sig_atributo_id?: InputMaybe<Order_By>;
  sig_atributo_numero_policia?: InputMaybe<Order_By>;
  sig_atributo_rua?: InputMaybe<Order_By>;
  sig_atributo_subzmc?: InputMaybe<Order_By>;
  sig_atributo_zmc?: InputMaybe<Order_By>;
  sig_data_ultimo_sync?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Mutation_Response = {
  __typename?: 'base_infraestruturas_tipos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Infraestruturas_Tipos>;
};

/** input type for inserting object relation for remote table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Obj_Rel_Insert_Input = {
  data: Base_Infraestruturas_Tipos_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_Infraestruturas_Tipos_On_Conflict>;
};

/** on_conflict condition type for table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_On_Conflict = {
  constraint: Base_Infraestruturas_Tipos_Constraint;
  update_columns?: Array<Base_Infraestruturas_Tipos_Update_Column>;
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};

/** Ordering options when selecting data from "base.infraestruturas_tipos". */
export type Base_Infraestruturas_Tipos_Order_By = {
  activeChilds_aggregate?: InputMaybe<Base_Infraestruturas_Tipos_Aggregate_Order_By>;
  apagado?: InputMaybe<Order_By>;
  atualiza_nome_completo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  cor?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  georeferenciar_filhos?: InputMaybe<Order_By>;
  has_childs?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
  infraestruturas_aggregate?: InputMaybe<Base_Infraestruturas_Aggregate_Order_By>;
  layer_name?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
  readonly?: InputMaybe<Order_By>;
  sig_actualiza_descricao?: InputMaybe<Order_By>;
  sig_actualiza_infraestruturas?: InputMaybe<Order_By>;
  sig_atributo_codigo_manutencao?: InputMaybe<Order_By>;
  sig_atributo_codigo_ponto_amostragem?: InputMaybe<Order_By>;
  sig_atributo_codigo_sap?: InputMaybe<Order_By>;
  sig_atributo_codigo_sig?: InputMaybe<Order_By>;
  sig_atributo_descricao?: InputMaybe<Order_By>;
  sig_atributo_freguesia?: InputMaybe<Order_By>;
  sig_atributo_id?: InputMaybe<Order_By>;
  sig_atributo_numero_policia?: InputMaybe<Order_By>;
  sig_atributo_rua?: InputMaybe<Order_By>;
  sig_atributo_subzmc?: InputMaybe<Order_By>;
  sig_atributo_zmc?: InputMaybe<Order_By>;
  sig_data_ultimo_sync?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base.infraestruturas_tipos */
export type Base_Infraestruturas_Tipos_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "base.infraestruturas_tipos" */
export enum Base_Infraestruturas_Tipos_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Cor = 'cor',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  GeoreferenciarFilhos = 'georeferenciar_filhos',
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  Id = 'id',
  /** column name */
  IdNoTipo = 'id_no_tipo',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdSigService = 'id_sig_service',
  /** column name */
  IdZonaBacia = 'id_zona_bacia',
  /** column name */
  LayerName = 'layer_name',
  /** column name */
  NomeCompleto = 'nome_completo',
  /** column name */
  Readonly = 'readonly',
  /** column name */
  SigActualizaDescricao = 'sig_actualiza_descricao',
  /** column name */
  SigActualizaInfraestruturas = 'sig_actualiza_infraestruturas',
  /** column name */
  SigAtributoCodigoManutencao = 'sig_atributo_codigo_manutencao',
  /** column name */
  SigAtributoCodigoPontoAmostragem = 'sig_atributo_codigo_ponto_amostragem',
  /** column name */
  SigAtributoCodigoSap = 'sig_atributo_codigo_sap',
  /** column name */
  SigAtributoCodigoSig = 'sig_atributo_codigo_sig',
  /** column name */
  SigAtributoDescricao = 'sig_atributo_descricao',
  /** column name */
  SigAtributoFreguesia = 'sig_atributo_freguesia',
  /** column name */
  SigAtributoId = 'sig_atributo_id',
  /** column name */
  SigAtributoNumeroPolicia = 'sig_atributo_numero_policia',
  /** column name */
  SigAtributoRua = 'sig_atributo_rua',
  /** column name */
  SigAtributoSubzmc = 'sig_atributo_subzmc',
  /** column name */
  SigAtributoZmc = 'sig_atributo_zmc',
  /** column name */
  SigDataUltimoSync = 'sig_data_ultimo_sync'
}

/** input type for updating data in table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  georeferenciar_filhos?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_sig_service?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
  layer_name?: InputMaybe<Scalars['String']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  sig_actualiza_descricao?: InputMaybe<Scalars['Boolean']['input']>;
  sig_actualiza_infraestruturas?: InputMaybe<Scalars['Boolean']['input']>;
  sig_atributo_codigo_manutencao?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_codigo_ponto_amostragem?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_codigo_sap?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_codigo_sig?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_descricao?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_freguesia?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_id?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_numero_policia?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_rua?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_subzmc?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_zmc?: InputMaybe<Scalars['String']['input']>;
  sig_data_ultimo_sync?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Base_Infraestruturas_Tipos_Stddev_Fields = {
  __typename?: 'base_infraestruturas_tipos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_Infraestruturas_Tipos_Stddev_Pop_Fields = {
  __typename?: 'base_infraestruturas_tipos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_Infraestruturas_Tipos_Stddev_Samp_Fields = {
  __typename?: 'base_infraestruturas_tipos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Infraestruturas_Tipos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Infraestruturas_Tipos_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  georeferenciar_filhos?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_sig_service?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
  layer_name?: InputMaybe<Scalars['String']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  sig_actualiza_descricao?: InputMaybe<Scalars['Boolean']['input']>;
  sig_actualiza_infraestruturas?: InputMaybe<Scalars['Boolean']['input']>;
  sig_atributo_codigo_manutencao?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_codigo_ponto_amostragem?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_codigo_sap?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_codigo_sig?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_descricao?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_freguesia?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_id?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_numero_policia?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_rua?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_subzmc?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_zmc?: InputMaybe<Scalars['String']['input']>;
  sig_data_ultimo_sync?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Base_Infraestruturas_Tipos_Sum_Fields = {
  __typename?: 'base_infraestruturas_tipos_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_sig_service?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** update columns of table "base.infraestruturas_tipos" */
export enum Base_Infraestruturas_Tipos_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Cor = 'cor',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  GeoreferenciarFilhos = 'georeferenciar_filhos',
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  Id = 'id',
  /** column name */
  IdNoTipo = 'id_no_tipo',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdSigService = 'id_sig_service',
  /** column name */
  IdZonaBacia = 'id_zona_bacia',
  /** column name */
  LayerName = 'layer_name',
  /** column name */
  NomeCompleto = 'nome_completo',
  /** column name */
  Readonly = 'readonly',
  /** column name */
  SigActualizaDescricao = 'sig_actualiza_descricao',
  /** column name */
  SigActualizaInfraestruturas = 'sig_actualiza_infraestruturas',
  /** column name */
  SigAtributoCodigoManutencao = 'sig_atributo_codigo_manutencao',
  /** column name */
  SigAtributoCodigoPontoAmostragem = 'sig_atributo_codigo_ponto_amostragem',
  /** column name */
  SigAtributoCodigoSap = 'sig_atributo_codigo_sap',
  /** column name */
  SigAtributoCodigoSig = 'sig_atributo_codigo_sig',
  /** column name */
  SigAtributoDescricao = 'sig_atributo_descricao',
  /** column name */
  SigAtributoFreguesia = 'sig_atributo_freguesia',
  /** column name */
  SigAtributoId = 'sig_atributo_id',
  /** column name */
  SigAtributoNumeroPolicia = 'sig_atributo_numero_policia',
  /** column name */
  SigAtributoRua = 'sig_atributo_rua',
  /** column name */
  SigAtributoSubzmc = 'sig_atributo_subzmc',
  /** column name */
  SigAtributoZmc = 'sig_atributo_zmc',
  /** column name */
  SigDataUltimoSync = 'sig_data_ultimo_sync'
}

export type Base_Infraestruturas_Tipos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Infraestruturas_Tipos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Infraestruturas_Tipos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Infraestruturas_Tipos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Infraestruturas_Tipos_Var_Pop_Fields = {
  __typename?: 'base_infraestruturas_tipos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_Infraestruturas_Tipos_Var_Samp_Fields = {
  __typename?: 'base_infraestruturas_tipos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_Infraestruturas_Tipos_Variance_Fields = {
  __typename?: 'base_infraestruturas_tipos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "base.infraestruturas_tipos" */
export type Base_Infraestruturas_Tipos_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** update columns of table "base.infraestruturas" */
export enum Base_Infraestruturas_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  ArvoreBulk = 'arvore_bulk',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  AtualizaOrdemGlobal = 'atualiza_ordem_global',
  /** column name */
  CodigoApa = 'codigo_apa',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  CodigoManutencao = 'codigo_manutencao',
  /** column name */
  CodigoPontoAmostragem = 'codigo_ponto_amostragem',
  /** column name */
  CodigoSap = 'codigo_sap',
  /** column name */
  CodigoSig = 'codigo_sig',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaModificacao = 'data_hora_ultima_modificacao',
  /** column name */
  Desactivado = 'desactivado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  GestaoAtivos = 'gestao_ativos',
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  Id = 'id',
  /** column name */
  IdCentroCusto = 'id_centro_custo',
  /** column name */
  IdInstalacao = 'id_instalacao',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdTipoBulk = 'id_tipo_bulk',
  /** column name */
  IdTipoInfraestrutura = 'id_tipo_infraestrutura',
  /** column name */
  NomeCompleto = 'nome_completo',
  /** column name */
  NomeInstalacao = 'nome_instalacao',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  OrdemGlobal = 'ordem_global',
  /** column name */
  Referencias = 'referencias'
}

export type Base_Infraestruturas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Infraestruturas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Infraestruturas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Infraestruturas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Infraestruturas_Var_Pop_Fields = {
  __typename?: 'base_infraestruturas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_instalacao?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  ordem_global?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "base.infraestruturas" */
export type Base_Infraestruturas_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_instalacao?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  ordem_global?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_Infraestruturas_Var_Samp_Fields = {
  __typename?: 'base_infraestruturas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_instalacao?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  ordem_global?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "base.infraestruturas" */
export type Base_Infraestruturas_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_instalacao?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  ordem_global?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_Infraestruturas_Variance_Fields = {
  __typename?: 'base_infraestruturas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_instalacao?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  ordem_global?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "base.infraestruturas" */
export type Base_Infraestruturas_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_instalacao?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  ordem_global?: InputMaybe<Order_By>;
};

/** columns and relationships of "base.parametrizacoes" */
export type Base_Parametrizacoes = {
  __typename?: 'base_parametrizacoes';
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  valor?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "base.parametrizacoes" */
export type Base_Parametrizacoes_Aggregate = {
  __typename?: 'base_parametrizacoes_aggregate';
  aggregate?: Maybe<Base_Parametrizacoes_Aggregate_Fields>;
  nodes: Array<Base_Parametrizacoes>;
};

/** aggregate fields of "base.parametrizacoes" */
export type Base_Parametrizacoes_Aggregate_Fields = {
  __typename?: 'base_parametrizacoes_aggregate_fields';
  avg?: Maybe<Base_Parametrizacoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Base_Parametrizacoes_Max_Fields>;
  min?: Maybe<Base_Parametrizacoes_Min_Fields>;
  stddev?: Maybe<Base_Parametrizacoes_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Parametrizacoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Parametrizacoes_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Parametrizacoes_Sum_Fields>;
  var_pop?: Maybe<Base_Parametrizacoes_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Parametrizacoes_Var_Samp_Fields>;
  variance?: Maybe<Base_Parametrizacoes_Variance_Fields>;
};


/** aggregate fields of "base.parametrizacoes" */
export type Base_Parametrizacoes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Parametrizacoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Base_Parametrizacoes_Avg_Fields = {
  __typename?: 'base_parametrizacoes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "base.parametrizacoes". All fields are combined with a logical 'AND'. */
export type Base_Parametrizacoes_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Parametrizacoes_Bool_Exp>>;
  _not?: InputMaybe<Base_Parametrizacoes_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Parametrizacoes_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  valor?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "base.parametrizacoes" */
export type Base_Parametrizacoes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "base.parametrizacoes" */
export type Base_Parametrizacoes_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  valor?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Base_Parametrizacoes_Max_Fields = {
  __typename?: 'base_parametrizacoes_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  valor?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Base_Parametrizacoes_Min_Fields = {
  __typename?: 'base_parametrizacoes_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  valor?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "base.parametrizacoes" */
export type Base_Parametrizacoes_Mutation_Response = {
  __typename?: 'base_parametrizacoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Parametrizacoes>;
};

/** Ordering options when selecting data from "base.parametrizacoes". */
export type Base_Parametrizacoes_Order_By = {
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** select columns of table "base.parametrizacoes" */
export enum Base_Parametrizacoes_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  Valor = 'valor'
}

/** input type for updating data in table "base.parametrizacoes" */
export type Base_Parametrizacoes_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  valor?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Base_Parametrizacoes_Stddev_Fields = {
  __typename?: 'base_parametrizacoes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Base_Parametrizacoes_Stddev_Pop_Fields = {
  __typename?: 'base_parametrizacoes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Base_Parametrizacoes_Stddev_Samp_Fields = {
  __typename?: 'base_parametrizacoes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "base_parametrizacoes" */
export type Base_Parametrizacoes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Parametrizacoes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Parametrizacoes_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  valor?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Base_Parametrizacoes_Sum_Fields = {
  __typename?: 'base_parametrizacoes_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

export type Base_Parametrizacoes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Parametrizacoes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Parametrizacoes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Parametrizacoes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Parametrizacoes_Var_Pop_Fields = {
  __typename?: 'base_parametrizacoes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Base_Parametrizacoes_Var_Samp_Fields = {
  __typename?: 'base_parametrizacoes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Base_Parametrizacoes_Variance_Fields = {
  __typename?: 'base_parametrizacoes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "base.toponimias" */
export type Base_Toponimias = {
  __typename?: 'base_toponimias';
  activo?: Maybe<Scalars['Boolean']['output']>;
  apagado: Scalars['Boolean']['output'];
  atualiza_nome_completo?: Maybe<Scalars['Boolean']['output']>;
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  codigo_postal_3?: Maybe<Scalars['numeric']['output']>;
  codigo_postal_4?: Maybe<Scalars['numeric']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  equipaVirtualToponimia: Array<Utilizadores_Equipas_Virtuais_R_Toponimias>;
  /** An aggregate relationship */
  equipaVirtualToponimia_aggregate: Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate;
  filhos_ruas: Scalars['Boolean']['output'];
  has_childs: Scalars['Boolean']['output'];
  id: Scalars['bigint']['output'];
  id_no_permissao: Scalars['bigint']['output'];
  id_no_tipo: Scalars['bigint']['output'];
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_regiao?: Maybe<Scalars['bigint']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  nome_medio?: Maybe<Scalars['String']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  toponimiaCoordenadas: Array<Base_Toponimias_Coordenadas>;
  /** An aggregate relationship */
  toponimiaCoordenadas_aggregate: Base_Toponimias_Coordenadas_Aggregate;
  /** An object relationship */
  toponimiaPermissao: Base_Toponimias;
};


/** columns and relationships of "base.toponimias" */
export type Base_ToponimiasEquipaVirtualToponimiaArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>;
};


/** columns and relationships of "base.toponimias" */
export type Base_ToponimiasEquipaVirtualToponimia_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>;
};


/** columns and relationships of "base.toponimias" */
export type Base_ToponimiasToponimiaCoordenadasArgs = {
  distinct_on?: InputMaybe<Array<Base_Toponimias_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Toponimias_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
};


/** columns and relationships of "base.toponimias" */
export type Base_ToponimiasToponimiaCoordenadas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Toponimias_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Toponimias_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
};

/** aggregated selection of "base.toponimias" */
export type Base_Toponimias_Aggregate = {
  __typename?: 'base_toponimias_aggregate';
  aggregate?: Maybe<Base_Toponimias_Aggregate_Fields>;
  nodes: Array<Base_Toponimias>;
};

/** aggregate fields of "base.toponimias" */
export type Base_Toponimias_Aggregate_Fields = {
  __typename?: 'base_toponimias_aggregate_fields';
  avg?: Maybe<Base_Toponimias_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Base_Toponimias_Max_Fields>;
  min?: Maybe<Base_Toponimias_Min_Fields>;
  stddev?: Maybe<Base_Toponimias_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Toponimias_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Toponimias_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Toponimias_Sum_Fields>;
  var_pop?: Maybe<Base_Toponimias_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Toponimias_Var_Samp_Fields>;
  variance?: Maybe<Base_Toponimias_Variance_Fields>;
};


/** aggregate fields of "base.toponimias" */
export type Base_Toponimias_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Toponimias_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Base_Toponimias_Avg_Fields = {
  __typename?: 'base_toponimias_avg_fields';
  codigo_postal_3?: Maybe<Scalars['Float']['output']>;
  codigo_postal_4?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_no_permissao?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_regiao?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "base.toponimias". All fields are combined with a logical 'AND'. */
export type Base_Toponimias_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Toponimias_Bool_Exp>>;
  _not?: InputMaybe<Base_Toponimias_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Toponimias_Bool_Exp>>;
  activo?: InputMaybe<Boolean_Comparison_Exp>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  atualiza_nome_completo?: InputMaybe<Boolean_Comparison_Exp>;
  codigo?: InputMaybe<String_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  codigo_postal_3?: InputMaybe<Numeric_Comparison_Exp>;
  codigo_postal_4?: InputMaybe<Numeric_Comparison_Exp>;
  codigo_sig?: InputMaybe<String_Comparison_Exp>;
  data_hora_registo_bd?: InputMaybe<Timestamp_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  descricao_curta?: InputMaybe<String_Comparison_Exp>;
  equipaVirtualToponimia?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>;
  equipaVirtualToponimia_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate_Bool_Exp>;
  filhos_ruas?: InputMaybe<Boolean_Comparison_Exp>;
  has_childs?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_no_permissao?: InputMaybe<Bigint_Comparison_Exp>;
  id_no_tipo?: InputMaybe<Bigint_Comparison_Exp>;
  id_pai?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_regiao?: InputMaybe<Bigint_Comparison_Exp>;
  nome_completo?: InputMaybe<String_Comparison_Exp>;
  nome_medio?: InputMaybe<String_Comparison_Exp>;
  obs?: InputMaybe<String_Comparison_Exp>;
  toponimiaCoordenadas?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
  toponimiaCoordenadas_aggregate?: InputMaybe<Base_Toponimias_Coordenadas_Aggregate_Bool_Exp>;
  toponimiaPermissao?: InputMaybe<Base_Toponimias_Bool_Exp>;
};

/** unique or primary key constraints on table "base.toponimias" */
export enum Base_Toponimias_Constraint {
  /** unique or primary key constraint on columns "id" */
  SupArvorePkey = 'sup_arvore_pkey'
}

/** columns and relationships of "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas = {
  __typename?: 'base_toponimias_coordenadas';
  id: Scalars['bigint']['output'];
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['numeric']['output']>;
  principal?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  toponimia?: Maybe<Base_Toponimias>;
};

/** aggregated selection of "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Aggregate = {
  __typename?: 'base_toponimias_coordenadas_aggregate';
  aggregate?: Maybe<Base_Toponimias_Coordenadas_Aggregate_Fields>;
  nodes: Array<Base_Toponimias_Coordenadas>;
};

export type Base_Toponimias_Coordenadas_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Base_Toponimias_Coordenadas_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Base_Toponimias_Coordenadas_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Base_Toponimias_Coordenadas_Aggregate_Bool_Exp_Count>;
};

export type Base_Toponimias_Coordenadas_Aggregate_Bool_Exp_Bool_And = {
  arguments: Base_Toponimias_Coordenadas_Select_Column_Base_Toponimias_Coordenadas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Base_Toponimias_Coordenadas_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Base_Toponimias_Coordenadas_Select_Column_Base_Toponimias_Coordenadas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Base_Toponimias_Coordenadas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Base_Toponimias_Coordenadas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Aggregate_Fields = {
  __typename?: 'base_toponimias_coordenadas_aggregate_fields';
  avg?: Maybe<Base_Toponimias_Coordenadas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Base_Toponimias_Coordenadas_Max_Fields>;
  min?: Maybe<Base_Toponimias_Coordenadas_Min_Fields>;
  stddev?: Maybe<Base_Toponimias_Coordenadas_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Toponimias_Coordenadas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Toponimias_Coordenadas_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Toponimias_Coordenadas_Sum_Fields>;
  var_pop?: Maybe<Base_Toponimias_Coordenadas_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Toponimias_Coordenadas_Var_Samp_Fields>;
  variance?: Maybe<Base_Toponimias_Coordenadas_Variance_Fields>;
};


/** aggregate fields of "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Toponimias_Coordenadas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Aggregate_Order_By = {
  avg?: InputMaybe<Base_Toponimias_Coordenadas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_Toponimias_Coordenadas_Max_Order_By>;
  min?: InputMaybe<Base_Toponimias_Coordenadas_Min_Order_By>;
  stddev?: InputMaybe<Base_Toponimias_Coordenadas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_Toponimias_Coordenadas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_Toponimias_Coordenadas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_Toponimias_Coordenadas_Sum_Order_By>;
  var_pop?: InputMaybe<Base_Toponimias_Coordenadas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_Toponimias_Coordenadas_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_Toponimias_Coordenadas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Arr_Rel_Insert_Input = {
  data: Array<Base_Toponimias_Coordenadas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_Toponimias_Coordenadas_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_Toponimias_Coordenadas_Avg_Fields = {
  __typename?: 'base_toponimias_coordenadas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base.toponimias_coordenadas". All fields are combined with a logical 'AND'. */
export type Base_Toponimias_Coordenadas_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Toponimias_Coordenadas_Bool_Exp>>;
  _not?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Toponimias_Coordenadas_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_toponimia?: InputMaybe<Bigint_Comparison_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
  ordem?: InputMaybe<Numeric_Comparison_Exp>;
  principal?: InputMaybe<Boolean_Comparison_Exp>;
  toponimia?: InputMaybe<Base_Toponimias_Bool_Exp>;
};

/** unique or primary key constraints on table "base.toponimias_coordenadas" */
export enum Base_Toponimias_Coordenadas_Constraint {
  /** unique or primary key constraint on columns "id" */
  ToponimiasCoordenadasPkey = 'toponimias_coordenadas_pkey'
}

/** input type for incrementing numeric columns in table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['numeric']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
  toponimia?: InputMaybe<Base_Toponimias_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Base_Toponimias_Coordenadas_Max_Fields = {
  __typename?: 'base_toponimias_coordenadas_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_Toponimias_Coordenadas_Min_Fields = {
  __typename?: 'base_toponimias_coordenadas_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Mutation_Response = {
  __typename?: 'base_toponimias_coordenadas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Toponimias_Coordenadas>;
};

/** on_conflict condition type for table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_On_Conflict = {
  constraint: Base_Toponimias_Coordenadas_Constraint;
  update_columns?: Array<Base_Toponimias_Coordenadas_Update_Column>;
  where?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
};

/** Ordering options when selecting data from "base.toponimias_coordenadas". */
export type Base_Toponimias_Coordenadas_Order_By = {
  id?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  principal?: InputMaybe<Order_By>;
  toponimia?: InputMaybe<Base_Toponimias_Order_By>;
};

/** primary key columns input for table: base.toponimias_coordenadas */
export type Base_Toponimias_Coordenadas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "base.toponimias_coordenadas" */
export enum Base_Toponimias_Coordenadas_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  Principal = 'principal'
}

/** select "base_toponimias_coordenadas_aggregate_bool_exp_bool_and_arguments_columns" columns of table "base.toponimias_coordenadas" */
export enum Base_Toponimias_Coordenadas_Select_Column_Base_Toponimias_Coordenadas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Principal = 'principal'
}

/** select "base_toponimias_coordenadas_aggregate_bool_exp_bool_or_arguments_columns" columns of table "base.toponimias_coordenadas" */
export enum Base_Toponimias_Coordenadas_Select_Column_Base_Toponimias_Coordenadas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Principal = 'principal'
}

/** input type for updating data in table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['numeric']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Base_Toponimias_Coordenadas_Stddev_Fields = {
  __typename?: 'base_toponimias_coordenadas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_Toponimias_Coordenadas_Stddev_Pop_Fields = {
  __typename?: 'base_toponimias_coordenadas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_Toponimias_Coordenadas_Stddev_Samp_Fields = {
  __typename?: 'base_toponimias_coordenadas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Toponimias_Coordenadas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Toponimias_Coordenadas_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['numeric']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Base_Toponimias_Coordenadas_Sum_Fields = {
  __typename?: 'base_toponimias_coordenadas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** update columns of table "base.toponimias_coordenadas" */
export enum Base_Toponimias_Coordenadas_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  Principal = 'principal'
}

export type Base_Toponimias_Coordenadas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Toponimias_Coordenadas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Toponimias_Coordenadas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Toponimias_Coordenadas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Toponimias_Coordenadas_Var_Pop_Fields = {
  __typename?: 'base_toponimias_coordenadas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_Toponimias_Coordenadas_Var_Samp_Fields = {
  __typename?: 'base_toponimias_coordenadas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_Toponimias_Coordenadas_Variance_Fields = {
  __typename?: 'base_toponimias_coordenadas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "base.toponimias_coordenadas" */
export type Base_Toponimias_Coordenadas_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "base.toponimias" */
export type Base_Toponimias_Inc_Input = {
  codigo_postal_3?: InputMaybe<Scalars['numeric']['input']>;
  codigo_postal_4?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_no_permissao?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_regiao?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "base.toponimias" */
export type Base_Toponimias_Insert_Input = {
  activo?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  codigo_postal_3?: InputMaybe<Scalars['numeric']['input']>;
  codigo_postal_4?: InputMaybe<Scalars['numeric']['input']>;
  codigo_sig?: InputMaybe<Scalars['String']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  equipaVirtualToponimia?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Arr_Rel_Insert_Input>;
  filhos_ruas?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_no_permissao?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_regiao?: InputMaybe<Scalars['bigint']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  nome_medio?: InputMaybe<Scalars['String']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  toponimiaCoordenadas?: InputMaybe<Base_Toponimias_Coordenadas_Arr_Rel_Insert_Input>;
  toponimiaPermissao?: InputMaybe<Base_Toponimias_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Base_Toponimias_Max_Fields = {
  __typename?: 'base_toponimias_max_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  codigo_postal_3?: Maybe<Scalars['numeric']['output']>;
  codigo_postal_4?: Maybe<Scalars['numeric']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_no_permissao?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_regiao?: Maybe<Scalars['bigint']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  nome_medio?: Maybe<Scalars['String']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Base_Toponimias_Min_Fields = {
  __typename?: 'base_toponimias_min_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  codigo_postal_3?: Maybe<Scalars['numeric']['output']>;
  codigo_postal_4?: Maybe<Scalars['numeric']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_no_permissao?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_regiao?: Maybe<Scalars['bigint']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  nome_medio?: Maybe<Scalars['String']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "base.toponimias" */
export type Base_Toponimias_Mutation_Response = {
  __typename?: 'base_toponimias_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Toponimias>;
};

/** input type for inserting object relation for remote table "base.toponimias" */
export type Base_Toponimias_Obj_Rel_Insert_Input = {
  data: Base_Toponimias_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_Toponimias_On_Conflict>;
};

/** on_conflict condition type for table "base.toponimias" */
export type Base_Toponimias_On_Conflict = {
  constraint: Base_Toponimias_Constraint;
  update_columns?: Array<Base_Toponimias_Update_Column>;
  where?: InputMaybe<Base_Toponimias_Bool_Exp>;
};

/** Ordering options when selecting data from "base.toponimias". */
export type Base_Toponimias_Order_By = {
  activo?: InputMaybe<Order_By>;
  apagado?: InputMaybe<Order_By>;
  atualiza_nome_completo?: InputMaybe<Order_By>;
  codigo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  codigo_postal_3?: InputMaybe<Order_By>;
  codigo_postal_4?: InputMaybe<Order_By>;
  codigo_sig?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  equipaVirtualToponimia_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate_Order_By>;
  filhos_ruas?: InputMaybe<Order_By>;
  has_childs?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_no_permissao?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_regiao?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
  nome_medio?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  toponimiaCoordenadas_aggregate?: InputMaybe<Base_Toponimias_Coordenadas_Aggregate_Order_By>;
  toponimiaPermissao?: InputMaybe<Base_Toponimias_Order_By>;
};

/** primary key columns input for table: base.toponimias */
export type Base_Toponimias_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "base.toponimias" */
export enum Base_Toponimias_Select_Column {
  /** column name */
  Activo = 'activo',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  CodigoPostal_3 = 'codigo_postal_3',
  /** column name */
  CodigoPostal_4 = 'codigo_postal_4',
  /** column name */
  CodigoSig = 'codigo_sig',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  FilhosRuas = 'filhos_ruas',
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  Id = 'id',
  /** column name */
  IdNoPermissao = 'id_no_permissao',
  /** column name */
  IdNoTipo = 'id_no_tipo',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdTipoRegiao = 'id_tipo_regiao',
  /** column name */
  NomeCompleto = 'nome_completo',
  /** column name */
  NomeMedio = 'nome_medio',
  /** column name */
  Obs = 'obs'
}

/** input type for updating data in table "base.toponimias" */
export type Base_Toponimias_Set_Input = {
  activo?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  codigo_postal_3?: InputMaybe<Scalars['numeric']['input']>;
  codigo_postal_4?: InputMaybe<Scalars['numeric']['input']>;
  codigo_sig?: InputMaybe<Scalars['String']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  filhos_ruas?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_no_permissao?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_regiao?: InputMaybe<Scalars['bigint']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  nome_medio?: InputMaybe<Scalars['String']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Base_Toponimias_Stddev_Fields = {
  __typename?: 'base_toponimias_stddev_fields';
  codigo_postal_3?: Maybe<Scalars['Float']['output']>;
  codigo_postal_4?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_no_permissao?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_regiao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Base_Toponimias_Stddev_Pop_Fields = {
  __typename?: 'base_toponimias_stddev_pop_fields';
  codigo_postal_3?: Maybe<Scalars['Float']['output']>;
  codigo_postal_4?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_no_permissao?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_regiao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Base_Toponimias_Stddev_Samp_Fields = {
  __typename?: 'base_toponimias_stddev_samp_fields';
  codigo_postal_3?: Maybe<Scalars['Float']['output']>;
  codigo_postal_4?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_no_permissao?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_regiao?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "base_toponimias" */
export type Base_Toponimias_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Toponimias_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Toponimias_Stream_Cursor_Value_Input = {
  activo?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  codigo_postal_3?: InputMaybe<Scalars['numeric']['input']>;
  codigo_postal_4?: InputMaybe<Scalars['numeric']['input']>;
  codigo_sig?: InputMaybe<Scalars['String']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  filhos_ruas?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_no_permissao?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_regiao?: InputMaybe<Scalars['bigint']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  nome_medio?: InputMaybe<Scalars['String']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Base_Toponimias_Sum_Fields = {
  __typename?: 'base_toponimias_sum_fields';
  codigo_postal_3?: Maybe<Scalars['numeric']['output']>;
  codigo_postal_4?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_no_permissao?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_regiao?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "base.toponimias" */
export enum Base_Toponimias_Update_Column {
  /** column name */
  Activo = 'activo',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  CodigoPostal_3 = 'codigo_postal_3',
  /** column name */
  CodigoPostal_4 = 'codigo_postal_4',
  /** column name */
  CodigoSig = 'codigo_sig',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  FilhosRuas = 'filhos_ruas',
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  Id = 'id',
  /** column name */
  IdNoPermissao = 'id_no_permissao',
  /** column name */
  IdNoTipo = 'id_no_tipo',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdTipoRegiao = 'id_tipo_regiao',
  /** column name */
  NomeCompleto = 'nome_completo',
  /** column name */
  NomeMedio = 'nome_medio',
  /** column name */
  Obs = 'obs'
}

export type Base_Toponimias_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Toponimias_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Toponimias_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Toponimias_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Toponimias_Var_Pop_Fields = {
  __typename?: 'base_toponimias_var_pop_fields';
  codigo_postal_3?: Maybe<Scalars['Float']['output']>;
  codigo_postal_4?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_no_permissao?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_regiao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Base_Toponimias_Var_Samp_Fields = {
  __typename?: 'base_toponimias_var_samp_fields';
  codigo_postal_3?: Maybe<Scalars['Float']['output']>;
  codigo_postal_4?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_no_permissao?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_regiao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Base_Toponimias_Variance_Fields = {
  __typename?: 'base_toponimias_variance_fields';
  codigo_postal_3?: Maybe<Scalars['Float']['output']>;
  codigo_postal_4?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_no_permissao?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_regiao?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "base.zmc" */
export type Base_Zmc = {
  __typename?: 'base_zmc';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  atualiza_nome_completo?: Maybe<Scalars['Boolean']['output']>;
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  has_childs?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  id_centro: Scalars['bigint']['output'];
  id_no_tipo: Scalars['bigint']['output'];
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
  nivel?: Maybe<Scalars['Int']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "base.zmc" */
export type Base_Zmc_Aggregate = {
  __typename?: 'base_zmc_aggregate';
  aggregate?: Maybe<Base_Zmc_Aggregate_Fields>;
  nodes: Array<Base_Zmc>;
};

/** aggregate fields of "base.zmc" */
export type Base_Zmc_Aggregate_Fields = {
  __typename?: 'base_zmc_aggregate_fields';
  avg?: Maybe<Base_Zmc_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Base_Zmc_Max_Fields>;
  min?: Maybe<Base_Zmc_Min_Fields>;
  stddev?: Maybe<Base_Zmc_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Zmc_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Zmc_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Zmc_Sum_Fields>;
  var_pop?: Maybe<Base_Zmc_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Zmc_Var_Samp_Fields>;
  variance?: Maybe<Base_Zmc_Variance_Fields>;
};


/** aggregate fields of "base.zmc" */
export type Base_Zmc_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Zmc_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Base_Zmc_Avg_Fields = {
  __typename?: 'base_zmc_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
  nivel?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "base.zmc". All fields are combined with a logical 'AND'. */
export type Base_Zmc_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Zmc_Bool_Exp>>;
  _not?: InputMaybe<Base_Zmc_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Zmc_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  atualiza_nome_completo?: InputMaybe<Boolean_Comparison_Exp>;
  codigo?: InputMaybe<String_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  data_hora_registo_bd?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_ultima_modificacao?: InputMaybe<Timestamp_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  has_childs?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_centro?: InputMaybe<Bigint_Comparison_Exp>;
  id_no_tipo?: InputMaybe<Bigint_Comparison_Exp>;
  id_pai?: InputMaybe<Bigint_Comparison_Exp>;
  id_zona_bacia?: InputMaybe<Bigint_Comparison_Exp>;
  nivel?: InputMaybe<Int_Comparison_Exp>;
  nome_completo?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "base.zmc" */
export enum Base_Zmc_Constraint {
  /** unique or primary key constraint on columns "id" */
  ZmcPkey = 'zmc_pkey'
}

/** input type for incrementing numeric columns in table "base.zmc" */
export type Base_Zmc_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
  nivel?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "base.zmc" */
export type Base_Zmc_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
  nivel?: InputMaybe<Scalars['Int']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Base_Zmc_Max_Fields = {
  __typename?: 'base_zmc_max_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
  nivel?: Maybe<Scalars['Int']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Base_Zmc_Min_Fields = {
  __typename?: 'base_zmc_min_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
  nivel?: Maybe<Scalars['Int']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "base.zmc" */
export type Base_Zmc_Mutation_Response = {
  __typename?: 'base_zmc_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Zmc>;
};

/** columns and relationships of "base.zmc_nos_tipo" */
export type Base_Zmc_Nos_Tipo = {
  __typename?: 'base_zmc_nos_tipo';
  codigo_externo_nr_digitos?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  id_sig_service?: Maybe<Scalars['bigint']['output']>;
  sig_atributo_descricao?: Maybe<Scalars['String']['output']>;
  sig_atributo_id?: Maybe<Scalars['String']['output']>;
  sig_atributo_id_pai?: Maybe<Scalars['String']['output']>;
  sig_data_ultimo_sincronismo?: Maybe<Scalars['timestamp']['output']>;
  sig_layer?: Maybe<Scalars['String']['output']>;
  sig_sincronismo_ativo: Scalars['Boolean']['output'];
};

/** aggregated selection of "base.zmc_nos_tipo" */
export type Base_Zmc_Nos_Tipo_Aggregate = {
  __typename?: 'base_zmc_nos_tipo_aggregate';
  aggregate?: Maybe<Base_Zmc_Nos_Tipo_Aggregate_Fields>;
  nodes: Array<Base_Zmc_Nos_Tipo>;
};

/** aggregate fields of "base.zmc_nos_tipo" */
export type Base_Zmc_Nos_Tipo_Aggregate_Fields = {
  __typename?: 'base_zmc_nos_tipo_aggregate_fields';
  avg?: Maybe<Base_Zmc_Nos_Tipo_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Base_Zmc_Nos_Tipo_Max_Fields>;
  min?: Maybe<Base_Zmc_Nos_Tipo_Min_Fields>;
  stddev?: Maybe<Base_Zmc_Nos_Tipo_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Zmc_Nos_Tipo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Zmc_Nos_Tipo_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Zmc_Nos_Tipo_Sum_Fields>;
  var_pop?: Maybe<Base_Zmc_Nos_Tipo_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Zmc_Nos_Tipo_Var_Samp_Fields>;
  variance?: Maybe<Base_Zmc_Nos_Tipo_Variance_Fields>;
};


/** aggregate fields of "base.zmc_nos_tipo" */
export type Base_Zmc_Nos_Tipo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Zmc_Nos_Tipo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Base_Zmc_Nos_Tipo_Avg_Fields = {
  __typename?: 'base_zmc_nos_tipo_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "base.zmc_nos_tipo". All fields are combined with a logical 'AND'. */
export type Base_Zmc_Nos_Tipo_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Zmc_Nos_Tipo_Bool_Exp>>;
  _not?: InputMaybe<Base_Zmc_Nos_Tipo_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Zmc_Nos_Tipo_Bool_Exp>>;
  codigo_externo_nr_digitos?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_sig_service?: InputMaybe<Bigint_Comparison_Exp>;
  sig_atributo_descricao?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_id?: InputMaybe<String_Comparison_Exp>;
  sig_atributo_id_pai?: InputMaybe<String_Comparison_Exp>;
  sig_data_ultimo_sincronismo?: InputMaybe<Timestamp_Comparison_Exp>;
  sig_layer?: InputMaybe<String_Comparison_Exp>;
  sig_sincronismo_ativo?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "base.zmc_nos_tipo" */
export enum Base_Zmc_Nos_Tipo_Constraint {
  /** unique or primary key constraint on columns "id" */
  ZmcNosTipoPkey = 'zmc_nos_tipo_pkey'
}

/** input type for incrementing numeric columns in table "base.zmc_nos_tipo" */
export type Base_Zmc_Nos_Tipo_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_sig_service?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "base.zmc_nos_tipo" */
export type Base_Zmc_Nos_Tipo_Insert_Input = {
  codigo_externo_nr_digitos?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_sig_service?: InputMaybe<Scalars['bigint']['input']>;
  sig_atributo_descricao?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_id?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_id_pai?: InputMaybe<Scalars['String']['input']>;
  sig_data_ultimo_sincronismo?: InputMaybe<Scalars['timestamp']['input']>;
  sig_layer?: InputMaybe<Scalars['String']['input']>;
  sig_sincronismo_ativo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Base_Zmc_Nos_Tipo_Max_Fields = {
  __typename?: 'base_zmc_nos_tipo_max_fields';
  codigo_externo_nr_digitos?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_sig_service?: Maybe<Scalars['bigint']['output']>;
  sig_atributo_descricao?: Maybe<Scalars['String']['output']>;
  sig_atributo_id?: Maybe<Scalars['String']['output']>;
  sig_atributo_id_pai?: Maybe<Scalars['String']['output']>;
  sig_data_ultimo_sincronismo?: Maybe<Scalars['timestamp']['output']>;
  sig_layer?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Base_Zmc_Nos_Tipo_Min_Fields = {
  __typename?: 'base_zmc_nos_tipo_min_fields';
  codigo_externo_nr_digitos?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_sig_service?: Maybe<Scalars['bigint']['output']>;
  sig_atributo_descricao?: Maybe<Scalars['String']['output']>;
  sig_atributo_id?: Maybe<Scalars['String']['output']>;
  sig_atributo_id_pai?: Maybe<Scalars['String']['output']>;
  sig_data_ultimo_sincronismo?: Maybe<Scalars['timestamp']['output']>;
  sig_layer?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "base.zmc_nos_tipo" */
export type Base_Zmc_Nos_Tipo_Mutation_Response = {
  __typename?: 'base_zmc_nos_tipo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Zmc_Nos_Tipo>;
};

/** on_conflict condition type for table "base.zmc_nos_tipo" */
export type Base_Zmc_Nos_Tipo_On_Conflict = {
  constraint: Base_Zmc_Nos_Tipo_Constraint;
  update_columns?: Array<Base_Zmc_Nos_Tipo_Update_Column>;
  where?: InputMaybe<Base_Zmc_Nos_Tipo_Bool_Exp>;
};

/** Ordering options when selecting data from "base.zmc_nos_tipo". */
export type Base_Zmc_Nos_Tipo_Order_By = {
  codigo_externo_nr_digitos?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_sig_service?: InputMaybe<Order_By>;
  sig_atributo_descricao?: InputMaybe<Order_By>;
  sig_atributo_id?: InputMaybe<Order_By>;
  sig_atributo_id_pai?: InputMaybe<Order_By>;
  sig_data_ultimo_sincronismo?: InputMaybe<Order_By>;
  sig_layer?: InputMaybe<Order_By>;
  sig_sincronismo_ativo?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base.zmc_nos_tipo */
export type Base_Zmc_Nos_Tipo_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "base.zmc_nos_tipo" */
export enum Base_Zmc_Nos_Tipo_Select_Column {
  /** column name */
  CodigoExternoNrDigitos = 'codigo_externo_nr_digitos',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdSigService = 'id_sig_service',
  /** column name */
  SigAtributoDescricao = 'sig_atributo_descricao',
  /** column name */
  SigAtributoId = 'sig_atributo_id',
  /** column name */
  SigAtributoIdPai = 'sig_atributo_id_pai',
  /** column name */
  SigDataUltimoSincronismo = 'sig_data_ultimo_sincronismo',
  /** column name */
  SigLayer = 'sig_layer',
  /** column name */
  SigSincronismoAtivo = 'sig_sincronismo_ativo'
}

/** input type for updating data in table "base.zmc_nos_tipo" */
export type Base_Zmc_Nos_Tipo_Set_Input = {
  codigo_externo_nr_digitos?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_sig_service?: InputMaybe<Scalars['bigint']['input']>;
  sig_atributo_descricao?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_id?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_id_pai?: InputMaybe<Scalars['String']['input']>;
  sig_data_ultimo_sincronismo?: InputMaybe<Scalars['timestamp']['input']>;
  sig_layer?: InputMaybe<Scalars['String']['input']>;
  sig_sincronismo_ativo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Base_Zmc_Nos_Tipo_Stddev_Fields = {
  __typename?: 'base_zmc_nos_tipo_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Base_Zmc_Nos_Tipo_Stddev_Pop_Fields = {
  __typename?: 'base_zmc_nos_tipo_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Base_Zmc_Nos_Tipo_Stddev_Samp_Fields = {
  __typename?: 'base_zmc_nos_tipo_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "base_zmc_nos_tipo" */
export type Base_Zmc_Nos_Tipo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Zmc_Nos_Tipo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Zmc_Nos_Tipo_Stream_Cursor_Value_Input = {
  codigo_externo_nr_digitos?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_sig_service?: InputMaybe<Scalars['bigint']['input']>;
  sig_atributo_descricao?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_id?: InputMaybe<Scalars['String']['input']>;
  sig_atributo_id_pai?: InputMaybe<Scalars['String']['input']>;
  sig_data_ultimo_sincronismo?: InputMaybe<Scalars['timestamp']['input']>;
  sig_layer?: InputMaybe<Scalars['String']['input']>;
  sig_sincronismo_ativo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Base_Zmc_Nos_Tipo_Sum_Fields = {
  __typename?: 'base_zmc_nos_tipo_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_sig_service?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "base.zmc_nos_tipo" */
export enum Base_Zmc_Nos_Tipo_Update_Column {
  /** column name */
  CodigoExternoNrDigitos = 'codigo_externo_nr_digitos',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdSigService = 'id_sig_service',
  /** column name */
  SigAtributoDescricao = 'sig_atributo_descricao',
  /** column name */
  SigAtributoId = 'sig_atributo_id',
  /** column name */
  SigAtributoIdPai = 'sig_atributo_id_pai',
  /** column name */
  SigDataUltimoSincronismo = 'sig_data_ultimo_sincronismo',
  /** column name */
  SigLayer = 'sig_layer',
  /** column name */
  SigSincronismoAtivo = 'sig_sincronismo_ativo'
}

export type Base_Zmc_Nos_Tipo_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Zmc_Nos_Tipo_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Zmc_Nos_Tipo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Zmc_Nos_Tipo_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Zmc_Nos_Tipo_Var_Pop_Fields = {
  __typename?: 'base_zmc_nos_tipo_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Base_Zmc_Nos_Tipo_Var_Samp_Fields = {
  __typename?: 'base_zmc_nos_tipo_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Base_Zmc_Nos_Tipo_Variance_Fields = {
  __typename?: 'base_zmc_nos_tipo_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_sig_service?: Maybe<Scalars['Float']['output']>;
};

/** on_conflict condition type for table "base.zmc" */
export type Base_Zmc_On_Conflict = {
  constraint: Base_Zmc_Constraint;
  update_columns?: Array<Base_Zmc_Update_Column>;
  where?: InputMaybe<Base_Zmc_Bool_Exp>;
};

/** Ordering options when selecting data from "base.zmc". */
export type Base_Zmc_Order_By = {
  apagado?: InputMaybe<Order_By>;
  atualiza_nome_completo?: InputMaybe<Order_By>;
  codigo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  has_childs?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
  nivel?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base.zmc */
export type Base_Zmc_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "base.zmc" */
export enum Base_Zmc_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaModificacao = 'data_hora_ultima_modificacao',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  Id = 'id',
  /** column name */
  IdCentro = 'id_centro',
  /** column name */
  IdNoTipo = 'id_no_tipo',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdZonaBacia = 'id_zona_bacia',
  /** column name */
  Nivel = 'nivel',
  /** column name */
  NomeCompleto = 'nome_completo'
}

/** input type for updating data in table "base.zmc" */
export type Base_Zmc_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
  nivel?: InputMaybe<Scalars['Int']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Base_Zmc_Stddev_Fields = {
  __typename?: 'base_zmc_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
  nivel?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Base_Zmc_Stddev_Pop_Fields = {
  __typename?: 'base_zmc_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
  nivel?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Base_Zmc_Stddev_Samp_Fields = {
  __typename?: 'base_zmc_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
  nivel?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "base_zmc" */
export type Base_Zmc_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Zmc_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Zmc_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
  nivel?: InputMaybe<Scalars['Int']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Base_Zmc_Sum_Fields = {
  __typename?: 'base_zmc_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
  nivel?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "base.zmc" */
export enum Base_Zmc_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaModificacao = 'data_hora_ultima_modificacao',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  Id = 'id',
  /** column name */
  IdCentro = 'id_centro',
  /** column name */
  IdNoTipo = 'id_no_tipo',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdZonaBacia = 'id_zona_bacia',
  /** column name */
  Nivel = 'nivel',
  /** column name */
  NomeCompleto = 'nome_completo'
}

export type Base_Zmc_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Zmc_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Zmc_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Zmc_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Zmc_Var_Pop_Fields = {
  __typename?: 'base_zmc_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
  nivel?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Base_Zmc_Var_Samp_Fields = {
  __typename?: 'base_zmc_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
  nivel?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Base_Zmc_Variance_Fields = {
  __typename?: 'base_zmc_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
  nivel?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _eq?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _gt?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _gte?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['bigint']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _lte?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _neq?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['bigint']['input']>>>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']['input']>;
  _gt?: InputMaybe<Scalars['bpchar']['input']>;
  _gte?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']['input']>;
  _in?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']['input']>;
  _lt?: InputMaybe<Scalars['bpchar']['input']>;
  _lte?: InputMaybe<Scalars['bpchar']['input']>;
  _neq?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']['input']>;
};

/** columns and relationships of "consultas.requisicoes" */
export type Consultas_Requisicoes = {
  __typename?: 'consultas_requisicoes';
  codigo_unico?: Maybe<Scalars['String']['output']>;
  data_fim?: Maybe<Scalars['timestamp']['output']>;
  data_inicio?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  flag_follow?: Maybe<Scalars['Boolean']['output']>;
  flag_qs?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  id_com_intervencao?: Maybe<Scalars['String']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_motivo_cancelada?: Maybe<Scalars['bigint']['output']>;
  id_motivo_sem_intervencao?: Maybe<Scalars['String']['output']>;
  ids_causas?: Maybe<Scalars['String']['output']>;
  ids_centro?: Maybe<Scalars['String']['output']>;
  ids_estado?: Maybe<Scalars['String']['output']>;
  ids_infraestruturas?: Maybe<Scalars['String']['output']>;
  ids_ocultas?: Maybe<Scalars['String']['output']>;
  ids_operadores?: Maybe<Scalars['String']['output']>;
  ids_sintomas?: Maybe<Scalars['String']['output']>;
  ids_sub_areas?: Maybe<Scalars['String']['output']>;
  ids_sub_contratados?: Maybe<Scalars['String']['output']>;
  ids_tipo_infraestrutura?: Maybe<Scalars['String']['output']>;
  ids_toponimias?: Maybe<Scalars['String']['output']>;
  ids_trabalhos?: Maybe<Scalars['String']['output']>;
  ids_variaveis?: Maybe<Scalars['String']['output']>;
  ids_veiculos?: Maybe<Scalars['String']['output']>;
  periodo?: Maybe<Scalars['String']['output']>;
  responsavel_ids_equipas?: Maybe<Scalars['String']['output']>;
  responsavel_ids_sub_contratados?: Maybe<Scalars['String']['output']>;
  responsavel_ids_utilizadores?: Maybe<Scalars['String']['output']>;
  responsavel_ids_veiculos?: Maybe<Scalars['String']['output']>;
  vars_texto?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "consultas.requisicoes" */
export type Consultas_Requisicoes_Aggregate = {
  __typename?: 'consultas_requisicoes_aggregate';
  aggregate?: Maybe<Consultas_Requisicoes_Aggregate_Fields>;
  nodes: Array<Consultas_Requisicoes>;
};

/** aggregate fields of "consultas.requisicoes" */
export type Consultas_Requisicoes_Aggregate_Fields = {
  __typename?: 'consultas_requisicoes_aggregate_fields';
  avg?: Maybe<Consultas_Requisicoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Consultas_Requisicoes_Max_Fields>;
  min?: Maybe<Consultas_Requisicoes_Min_Fields>;
  stddev?: Maybe<Consultas_Requisicoes_Stddev_Fields>;
  stddev_pop?: Maybe<Consultas_Requisicoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consultas_Requisicoes_Stddev_Samp_Fields>;
  sum?: Maybe<Consultas_Requisicoes_Sum_Fields>;
  var_pop?: Maybe<Consultas_Requisicoes_Var_Pop_Fields>;
  var_samp?: Maybe<Consultas_Requisicoes_Var_Samp_Fields>;
  variance?: Maybe<Consultas_Requisicoes_Variance_Fields>;
};


/** aggregate fields of "consultas.requisicoes" */
export type Consultas_Requisicoes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consultas_Requisicoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Consultas_Requisicoes_Avg_Fields = {
  __typename?: 'consultas_requisicoes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_motivo_cancelada?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "consultas.requisicoes". All fields are combined with a logical 'AND'. */
export type Consultas_Requisicoes_Bool_Exp = {
  _and?: InputMaybe<Array<Consultas_Requisicoes_Bool_Exp>>;
  _not?: InputMaybe<Consultas_Requisicoes_Bool_Exp>;
  _or?: InputMaybe<Array<Consultas_Requisicoes_Bool_Exp>>;
  codigo_unico?: InputMaybe<String_Comparison_Exp>;
  data_fim?: InputMaybe<Timestamp_Comparison_Exp>;
  data_inicio?: InputMaybe<Timestamp_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  flag_follow?: InputMaybe<Boolean_Comparison_Exp>;
  flag_qs?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_com_intervencao?: InputMaybe<String_Comparison_Exp>;
  id_estado_validacao?: InputMaybe<Bigint_Comparison_Exp>;
  id_motivo_cancelada?: InputMaybe<Bigint_Comparison_Exp>;
  id_motivo_sem_intervencao?: InputMaybe<String_Comparison_Exp>;
  ids_causas?: InputMaybe<String_Comparison_Exp>;
  ids_centro?: InputMaybe<String_Comparison_Exp>;
  ids_estado?: InputMaybe<String_Comparison_Exp>;
  ids_infraestruturas?: InputMaybe<String_Comparison_Exp>;
  ids_ocultas?: InputMaybe<String_Comparison_Exp>;
  ids_operadores?: InputMaybe<String_Comparison_Exp>;
  ids_sintomas?: InputMaybe<String_Comparison_Exp>;
  ids_sub_areas?: InputMaybe<String_Comparison_Exp>;
  ids_sub_contratados?: InputMaybe<String_Comparison_Exp>;
  ids_tipo_infraestrutura?: InputMaybe<String_Comparison_Exp>;
  ids_toponimias?: InputMaybe<String_Comparison_Exp>;
  ids_trabalhos?: InputMaybe<String_Comparison_Exp>;
  ids_variaveis?: InputMaybe<String_Comparison_Exp>;
  ids_veiculos?: InputMaybe<String_Comparison_Exp>;
  periodo?: InputMaybe<String_Comparison_Exp>;
  responsavel_ids_equipas?: InputMaybe<String_Comparison_Exp>;
  responsavel_ids_sub_contratados?: InputMaybe<String_Comparison_Exp>;
  responsavel_ids_utilizadores?: InputMaybe<String_Comparison_Exp>;
  responsavel_ids_veiculos?: InputMaybe<String_Comparison_Exp>;
  vars_texto?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "consultas.requisicoes" */
export enum Consultas_Requisicoes_Constraint {
  /** unique or primary key constraint on columns "id" */
  RequisicoesPkey = 'requisicoes_pkey'
}

/** input type for incrementing numeric columns in table "consultas.requisicoes" */
export type Consultas_Requisicoes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo_cancelada?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "consultas.requisicoes" */
export type Consultas_Requisicoes_Insert_Input = {
  codigo_unico?: InputMaybe<Scalars['String']['input']>;
  data_fim?: InputMaybe<Scalars['timestamp']['input']>;
  data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  flag_follow?: InputMaybe<Scalars['Boolean']['input']>;
  flag_qs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_com_intervencao?: InputMaybe<Scalars['String']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo_cancelada?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo_sem_intervencao?: InputMaybe<Scalars['String']['input']>;
  ids_causas?: InputMaybe<Scalars['String']['input']>;
  ids_centro?: InputMaybe<Scalars['String']['input']>;
  ids_estado?: InputMaybe<Scalars['String']['input']>;
  ids_infraestruturas?: InputMaybe<Scalars['String']['input']>;
  ids_ocultas?: InputMaybe<Scalars['String']['input']>;
  ids_operadores?: InputMaybe<Scalars['String']['input']>;
  ids_sintomas?: InputMaybe<Scalars['String']['input']>;
  ids_sub_areas?: InputMaybe<Scalars['String']['input']>;
  ids_sub_contratados?: InputMaybe<Scalars['String']['input']>;
  ids_tipo_infraestrutura?: InputMaybe<Scalars['String']['input']>;
  ids_toponimias?: InputMaybe<Scalars['String']['input']>;
  ids_trabalhos?: InputMaybe<Scalars['String']['input']>;
  ids_variaveis?: InputMaybe<Scalars['String']['input']>;
  ids_veiculos?: InputMaybe<Scalars['String']['input']>;
  periodo?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_equipas?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_sub_contratados?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_utilizadores?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_veiculos?: InputMaybe<Scalars['String']['input']>;
  vars_texto?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Consultas_Requisicoes_Max_Fields = {
  __typename?: 'consultas_requisicoes_max_fields';
  codigo_unico?: Maybe<Scalars['String']['output']>;
  data_fim?: Maybe<Scalars['timestamp']['output']>;
  data_inicio?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_com_intervencao?: Maybe<Scalars['String']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_motivo_cancelada?: Maybe<Scalars['bigint']['output']>;
  id_motivo_sem_intervencao?: Maybe<Scalars['String']['output']>;
  ids_causas?: Maybe<Scalars['String']['output']>;
  ids_centro?: Maybe<Scalars['String']['output']>;
  ids_estado?: Maybe<Scalars['String']['output']>;
  ids_infraestruturas?: Maybe<Scalars['String']['output']>;
  ids_ocultas?: Maybe<Scalars['String']['output']>;
  ids_operadores?: Maybe<Scalars['String']['output']>;
  ids_sintomas?: Maybe<Scalars['String']['output']>;
  ids_sub_areas?: Maybe<Scalars['String']['output']>;
  ids_sub_contratados?: Maybe<Scalars['String']['output']>;
  ids_tipo_infraestrutura?: Maybe<Scalars['String']['output']>;
  ids_toponimias?: Maybe<Scalars['String']['output']>;
  ids_trabalhos?: Maybe<Scalars['String']['output']>;
  ids_variaveis?: Maybe<Scalars['String']['output']>;
  ids_veiculos?: Maybe<Scalars['String']['output']>;
  periodo?: Maybe<Scalars['String']['output']>;
  responsavel_ids_equipas?: Maybe<Scalars['String']['output']>;
  responsavel_ids_sub_contratados?: Maybe<Scalars['String']['output']>;
  responsavel_ids_utilizadores?: Maybe<Scalars['String']['output']>;
  responsavel_ids_veiculos?: Maybe<Scalars['String']['output']>;
  vars_texto?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Consultas_Requisicoes_Min_Fields = {
  __typename?: 'consultas_requisicoes_min_fields';
  codigo_unico?: Maybe<Scalars['String']['output']>;
  data_fim?: Maybe<Scalars['timestamp']['output']>;
  data_inicio?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_com_intervencao?: Maybe<Scalars['String']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_motivo_cancelada?: Maybe<Scalars['bigint']['output']>;
  id_motivo_sem_intervencao?: Maybe<Scalars['String']['output']>;
  ids_causas?: Maybe<Scalars['String']['output']>;
  ids_centro?: Maybe<Scalars['String']['output']>;
  ids_estado?: Maybe<Scalars['String']['output']>;
  ids_infraestruturas?: Maybe<Scalars['String']['output']>;
  ids_ocultas?: Maybe<Scalars['String']['output']>;
  ids_operadores?: Maybe<Scalars['String']['output']>;
  ids_sintomas?: Maybe<Scalars['String']['output']>;
  ids_sub_areas?: Maybe<Scalars['String']['output']>;
  ids_sub_contratados?: Maybe<Scalars['String']['output']>;
  ids_tipo_infraestrutura?: Maybe<Scalars['String']['output']>;
  ids_toponimias?: Maybe<Scalars['String']['output']>;
  ids_trabalhos?: Maybe<Scalars['String']['output']>;
  ids_variaveis?: Maybe<Scalars['String']['output']>;
  ids_veiculos?: Maybe<Scalars['String']['output']>;
  periodo?: Maybe<Scalars['String']['output']>;
  responsavel_ids_equipas?: Maybe<Scalars['String']['output']>;
  responsavel_ids_sub_contratados?: Maybe<Scalars['String']['output']>;
  responsavel_ids_utilizadores?: Maybe<Scalars['String']['output']>;
  responsavel_ids_veiculos?: Maybe<Scalars['String']['output']>;
  vars_texto?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "consultas.requisicoes" */
export type Consultas_Requisicoes_Mutation_Response = {
  __typename?: 'consultas_requisicoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Consultas_Requisicoes>;
};

/** on_conflict condition type for table "consultas.requisicoes" */
export type Consultas_Requisicoes_On_Conflict = {
  constraint: Consultas_Requisicoes_Constraint;
  update_columns?: Array<Consultas_Requisicoes_Update_Column>;
  where?: InputMaybe<Consultas_Requisicoes_Bool_Exp>;
};

/** Ordering options when selecting data from "consultas.requisicoes". */
export type Consultas_Requisicoes_Order_By = {
  codigo_unico?: InputMaybe<Order_By>;
  data_fim?: InputMaybe<Order_By>;
  data_inicio?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  flag_follow?: InputMaybe<Order_By>;
  flag_qs?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_com_intervencao?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_motivo_cancelada?: InputMaybe<Order_By>;
  id_motivo_sem_intervencao?: InputMaybe<Order_By>;
  ids_causas?: InputMaybe<Order_By>;
  ids_centro?: InputMaybe<Order_By>;
  ids_estado?: InputMaybe<Order_By>;
  ids_infraestruturas?: InputMaybe<Order_By>;
  ids_ocultas?: InputMaybe<Order_By>;
  ids_operadores?: InputMaybe<Order_By>;
  ids_sintomas?: InputMaybe<Order_By>;
  ids_sub_areas?: InputMaybe<Order_By>;
  ids_sub_contratados?: InputMaybe<Order_By>;
  ids_tipo_infraestrutura?: InputMaybe<Order_By>;
  ids_toponimias?: InputMaybe<Order_By>;
  ids_trabalhos?: InputMaybe<Order_By>;
  ids_variaveis?: InputMaybe<Order_By>;
  ids_veiculos?: InputMaybe<Order_By>;
  periodo?: InputMaybe<Order_By>;
  responsavel_ids_equipas?: InputMaybe<Order_By>;
  responsavel_ids_sub_contratados?: InputMaybe<Order_By>;
  responsavel_ids_utilizadores?: InputMaybe<Order_By>;
  responsavel_ids_veiculos?: InputMaybe<Order_By>;
  vars_texto?: InputMaybe<Order_By>;
};

/** primary key columns input for table: consultas.requisicoes */
export type Consultas_Requisicoes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "consultas.requisicoes" */
export enum Consultas_Requisicoes_Select_Column {
  /** column name */
  CodigoUnico = 'codigo_unico',
  /** column name */
  DataFim = 'data_fim',
  /** column name */
  DataInicio = 'data_inicio',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  FlagFollow = 'flag_follow',
  /** column name */
  FlagQs = 'flag_qs',
  /** column name */
  Id = 'id',
  /** column name */
  IdComIntervencao = 'id_com_intervencao',
  /** column name */
  IdEstadoValidacao = 'id_estado_validacao',
  /** column name */
  IdMotivoCancelada = 'id_motivo_cancelada',
  /** column name */
  IdMotivoSemIntervencao = 'id_motivo_sem_intervencao',
  /** column name */
  IdsCausas = 'ids_causas',
  /** column name */
  IdsCentro = 'ids_centro',
  /** column name */
  IdsEstado = 'ids_estado',
  /** column name */
  IdsInfraestruturas = 'ids_infraestruturas',
  /** column name */
  IdsOcultas = 'ids_ocultas',
  /** column name */
  IdsOperadores = 'ids_operadores',
  /** column name */
  IdsSintomas = 'ids_sintomas',
  /** column name */
  IdsSubAreas = 'ids_sub_areas',
  /** column name */
  IdsSubContratados = 'ids_sub_contratados',
  /** column name */
  IdsTipoInfraestrutura = 'ids_tipo_infraestrutura',
  /** column name */
  IdsToponimias = 'ids_toponimias',
  /** column name */
  IdsTrabalhos = 'ids_trabalhos',
  /** column name */
  IdsVariaveis = 'ids_variaveis',
  /** column name */
  IdsVeiculos = 'ids_veiculos',
  /** column name */
  Periodo = 'periodo',
  /** column name */
  ResponsavelIdsEquipas = 'responsavel_ids_equipas',
  /** column name */
  ResponsavelIdsSubContratados = 'responsavel_ids_sub_contratados',
  /** column name */
  ResponsavelIdsUtilizadores = 'responsavel_ids_utilizadores',
  /** column name */
  ResponsavelIdsVeiculos = 'responsavel_ids_veiculos',
  /** column name */
  VarsTexto = 'vars_texto'
}

/** input type for updating data in table "consultas.requisicoes" */
export type Consultas_Requisicoes_Set_Input = {
  codigo_unico?: InputMaybe<Scalars['String']['input']>;
  data_fim?: InputMaybe<Scalars['timestamp']['input']>;
  data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  flag_follow?: InputMaybe<Scalars['Boolean']['input']>;
  flag_qs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_com_intervencao?: InputMaybe<Scalars['String']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo_cancelada?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo_sem_intervencao?: InputMaybe<Scalars['String']['input']>;
  ids_causas?: InputMaybe<Scalars['String']['input']>;
  ids_centro?: InputMaybe<Scalars['String']['input']>;
  ids_estado?: InputMaybe<Scalars['String']['input']>;
  ids_infraestruturas?: InputMaybe<Scalars['String']['input']>;
  ids_ocultas?: InputMaybe<Scalars['String']['input']>;
  ids_operadores?: InputMaybe<Scalars['String']['input']>;
  ids_sintomas?: InputMaybe<Scalars['String']['input']>;
  ids_sub_areas?: InputMaybe<Scalars['String']['input']>;
  ids_sub_contratados?: InputMaybe<Scalars['String']['input']>;
  ids_tipo_infraestrutura?: InputMaybe<Scalars['String']['input']>;
  ids_toponimias?: InputMaybe<Scalars['String']['input']>;
  ids_trabalhos?: InputMaybe<Scalars['String']['input']>;
  ids_variaveis?: InputMaybe<Scalars['String']['input']>;
  ids_veiculos?: InputMaybe<Scalars['String']['input']>;
  periodo?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_equipas?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_sub_contratados?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_utilizadores?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_veiculos?: InputMaybe<Scalars['String']['input']>;
  vars_texto?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Consultas_Requisicoes_Stddev_Fields = {
  __typename?: 'consultas_requisicoes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_motivo_cancelada?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Consultas_Requisicoes_Stddev_Pop_Fields = {
  __typename?: 'consultas_requisicoes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_motivo_cancelada?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Consultas_Requisicoes_Stddev_Samp_Fields = {
  __typename?: 'consultas_requisicoes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_motivo_cancelada?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "consultas_requisicoes" */
export type Consultas_Requisicoes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consultas_Requisicoes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consultas_Requisicoes_Stream_Cursor_Value_Input = {
  codigo_unico?: InputMaybe<Scalars['String']['input']>;
  data_fim?: InputMaybe<Scalars['timestamp']['input']>;
  data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  flag_follow?: InputMaybe<Scalars['Boolean']['input']>;
  flag_qs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_com_intervencao?: InputMaybe<Scalars['String']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo_cancelada?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo_sem_intervencao?: InputMaybe<Scalars['String']['input']>;
  ids_causas?: InputMaybe<Scalars['String']['input']>;
  ids_centro?: InputMaybe<Scalars['String']['input']>;
  ids_estado?: InputMaybe<Scalars['String']['input']>;
  ids_infraestruturas?: InputMaybe<Scalars['String']['input']>;
  ids_ocultas?: InputMaybe<Scalars['String']['input']>;
  ids_operadores?: InputMaybe<Scalars['String']['input']>;
  ids_sintomas?: InputMaybe<Scalars['String']['input']>;
  ids_sub_areas?: InputMaybe<Scalars['String']['input']>;
  ids_sub_contratados?: InputMaybe<Scalars['String']['input']>;
  ids_tipo_infraestrutura?: InputMaybe<Scalars['String']['input']>;
  ids_toponimias?: InputMaybe<Scalars['String']['input']>;
  ids_trabalhos?: InputMaybe<Scalars['String']['input']>;
  ids_variaveis?: InputMaybe<Scalars['String']['input']>;
  ids_veiculos?: InputMaybe<Scalars['String']['input']>;
  periodo?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_equipas?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_sub_contratados?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_utilizadores?: InputMaybe<Scalars['String']['input']>;
  responsavel_ids_veiculos?: InputMaybe<Scalars['String']['input']>;
  vars_texto?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Consultas_Requisicoes_Sum_Fields = {
  __typename?: 'consultas_requisicoes_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_motivo_cancelada?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "consultas.requisicoes" */
export enum Consultas_Requisicoes_Update_Column {
  /** column name */
  CodigoUnico = 'codigo_unico',
  /** column name */
  DataFim = 'data_fim',
  /** column name */
  DataInicio = 'data_inicio',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  FlagFollow = 'flag_follow',
  /** column name */
  FlagQs = 'flag_qs',
  /** column name */
  Id = 'id',
  /** column name */
  IdComIntervencao = 'id_com_intervencao',
  /** column name */
  IdEstadoValidacao = 'id_estado_validacao',
  /** column name */
  IdMotivoCancelada = 'id_motivo_cancelada',
  /** column name */
  IdMotivoSemIntervencao = 'id_motivo_sem_intervencao',
  /** column name */
  IdsCausas = 'ids_causas',
  /** column name */
  IdsCentro = 'ids_centro',
  /** column name */
  IdsEstado = 'ids_estado',
  /** column name */
  IdsInfraestruturas = 'ids_infraestruturas',
  /** column name */
  IdsOcultas = 'ids_ocultas',
  /** column name */
  IdsOperadores = 'ids_operadores',
  /** column name */
  IdsSintomas = 'ids_sintomas',
  /** column name */
  IdsSubAreas = 'ids_sub_areas',
  /** column name */
  IdsSubContratados = 'ids_sub_contratados',
  /** column name */
  IdsTipoInfraestrutura = 'ids_tipo_infraestrutura',
  /** column name */
  IdsToponimias = 'ids_toponimias',
  /** column name */
  IdsTrabalhos = 'ids_trabalhos',
  /** column name */
  IdsVariaveis = 'ids_variaveis',
  /** column name */
  IdsVeiculos = 'ids_veiculos',
  /** column name */
  Periodo = 'periodo',
  /** column name */
  ResponsavelIdsEquipas = 'responsavel_ids_equipas',
  /** column name */
  ResponsavelIdsSubContratados = 'responsavel_ids_sub_contratados',
  /** column name */
  ResponsavelIdsUtilizadores = 'responsavel_ids_utilizadores',
  /** column name */
  ResponsavelIdsVeiculos = 'responsavel_ids_veiculos',
  /** column name */
  VarsTexto = 'vars_texto'
}

export type Consultas_Requisicoes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Consultas_Requisicoes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Consultas_Requisicoes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Consultas_Requisicoes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Consultas_Requisicoes_Var_Pop_Fields = {
  __typename?: 'consultas_requisicoes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_motivo_cancelada?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Consultas_Requisicoes_Var_Samp_Fields = {
  __typename?: 'consultas_requisicoes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_motivo_cancelada?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Consultas_Requisicoes_Variance_Fields = {
  __typename?: 'consultas_requisicoes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_motivo_cancelada?: Maybe<Scalars['Float']['output']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** failure_recurrence_rateNative Query Arguments */
export type Failure_Recurrence_Rate_Arguments = {
  endDate: Scalars['timestamptz']['input'];
  startDate: Scalars['timestamptz']['input'];
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

export type Failure_Recurrence_Rate_Model = {
  __typename?: 'failure_recurrence_rate_model';
  failure_recurrence_rate: Scalars['float8']['output'];
  pipes_count: Scalars['bigint']['output'];
  pipes_with_more_than_1: Scalars['bigint']['output'];
};

/** Boolean expression to filter rows from the logical model for "failure_recurrence_rate_model". All fields are combined with a logical 'AND'. */
export type Failure_Recurrence_Rate_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Failure_Recurrence_Rate_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Failure_Recurrence_Rate_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Failure_Recurrence_Rate_Model_Bool_Exp_Bool_Exp>>;
  failure_recurrence_rate?: InputMaybe<Float8_Comparison_Exp>;
  pipes_count?: InputMaybe<Bigint_Comparison_Exp>;
  pipes_with_more_than_1?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Failure_Recurrence_Rate_Model_Enum_Name {
  /** column name */
  FailureRecurrenceRate = 'failure_recurrence_rate',
  /** column name */
  PipesCount = 'pipes_count',
  /** column name */
  PipesWithMoreThan_1 = 'pipes_with_more_than_1'
}

/** Ordering options when selecting data from "failure_recurrence_rate_model". */
export type Failure_Recurrence_Rate_Model_Order_By = {
  failure_recurrence_rate?: InputMaybe<Order_By>;
  pipes_count?: InputMaybe<Order_By>;
  pipes_with_more_than_1?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** infrastructure_totalizers_treeNative Query Arguments */
export type Infrastructure_Totalizers_Tree_Arguments = {
  description: Scalars['String']['input'];
  totalizer: Scalars['String']['input'];
  transactionId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};

/** infrastructure_variables_treeNative Query Arguments */
export type Infrastructure_Variables_Tree_Arguments = {
  infrastructureSearchText?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['bigint']['input'];
  typeIds: Scalars['String']['input'];
  userId: Scalars['bigint']['input'];
  variableSearchText?: InputMaybe<Scalars['String']['input']>;
};

export type Infrastructures_Totalizers_Tree_Model = {
  __typename?: 'infrastructures_totalizers_tree_model';
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  node: Scalars['jsonb']['output'];
  ordem?: Maybe<Scalars['Int']['output']>;
};


export type Infrastructures_Totalizers_Tree_ModelNodeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "infrastructures_totalizers_tree_model". All fields are combined with a logical 'AND'. */
export type Infrastructures_Totalizers_Tree_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Infrastructures_Totalizers_Tree_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Infrastructures_Totalizers_Tree_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Infrastructures_Totalizers_Tree_Model_Bool_Exp_Bool_Exp>>;
  codigo_manutencao?: InputMaybe<String_Comparison_Exp>;
  codigo_sig?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_pai?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_bulk?: InputMaybe<Bigint_Comparison_Exp>;
  node?: InputMaybe<Jsonb_Comparison_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
};

export enum Infrastructures_Totalizers_Tree_Model_Enum_Name {
  /** column name */
  CodigoManutencao = 'codigo_manutencao',
  /** column name */
  CodigoSig = 'codigo_sig',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdTipoBulk = 'id_tipo_bulk',
  /** column name */
  Node = 'node',
  /** column name */
  Ordem = 'ordem'
}

/** Ordering options when selecting data from "infrastructures_totalizers_tree_model". */
export type Infrastructures_Totalizers_Tree_Model_Order_By = {
  codigo_manutencao?: InputMaybe<Order_By>;
  codigo_sig?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  node?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

export type Infrastructures_Variables_Tree_Model = {
  __typename?: 'infrastructures_variables_tree_model';
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  node: Scalars['jsonb']['output'];
  nome_completo?: Maybe<Scalars['String']['output']>;
  nome_instalacao?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};


export type Infrastructures_Variables_Tree_ModelNodeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "infrastructures_variables_tree_model". All fields are combined with a logical 'AND'. */
export type Infrastructures_Variables_Tree_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Infrastructures_Variables_Tree_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Infrastructures_Variables_Tree_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Infrastructures_Variables_Tree_Model_Bool_Exp_Bool_Exp>>;
  codigo_manutencao?: InputMaybe<String_Comparison_Exp>;
  codigo_sig?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_pai?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_bulk?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  node?: InputMaybe<Jsonb_Comparison_Exp>;
  nome_completo?: InputMaybe<String_Comparison_Exp>;
  nome_instalacao?: InputMaybe<String_Comparison_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
};

export enum Infrastructures_Variables_Tree_Model_Enum_Name {
  /** column name */
  CodigoManutencao = 'codigo_manutencao',
  /** column name */
  CodigoSig = 'codigo_sig',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdTipoBulk = 'id_tipo_bulk',
  /** column name */
  IdTipoInfraestrutura = 'id_tipo_infraestrutura',
  /** column name */
  Node = 'node',
  /** column name */
  NomeCompleto = 'nome_completo',
  /** column name */
  NomeInstalacao = 'nome_instalacao',
  /** column name */
  Ordem = 'ordem'
}

/** Ordering options when selecting data from "infrastructures_variables_tree_model". */
export type Infrastructures_Variables_Tree_Model_Order_By = {
  codigo_manutencao?: InputMaybe<Order_By>;
  codigo_sig?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  node?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
  nome_instalacao?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** columns and relationships of "integracoes.ad_parametrizacao" */
export type Integracoes_Ad_Parametrizacao = {
  __typename?: 'integracoes_ad_parametrizacao';
  data_hora_ultima_modificacao: Scalars['timestamp']['output'];
  id_protocolo?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "integracoes.ad_parametrizacao" */
export type Integracoes_Ad_Parametrizacao_Aggregate = {
  __typename?: 'integracoes_ad_parametrizacao_aggregate';
  aggregate?: Maybe<Integracoes_Ad_Parametrizacao_Aggregate_Fields>;
  nodes: Array<Integracoes_Ad_Parametrizacao>;
};

/** aggregate fields of "integracoes.ad_parametrizacao" */
export type Integracoes_Ad_Parametrizacao_Aggregate_Fields = {
  __typename?: 'integracoes_ad_parametrizacao_aggregate_fields';
  avg?: Maybe<Integracoes_Ad_Parametrizacao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Integracoes_Ad_Parametrizacao_Max_Fields>;
  min?: Maybe<Integracoes_Ad_Parametrizacao_Min_Fields>;
  stddev?: Maybe<Integracoes_Ad_Parametrizacao_Stddev_Fields>;
  stddev_pop?: Maybe<Integracoes_Ad_Parametrizacao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Integracoes_Ad_Parametrizacao_Stddev_Samp_Fields>;
  sum?: Maybe<Integracoes_Ad_Parametrizacao_Sum_Fields>;
  var_pop?: Maybe<Integracoes_Ad_Parametrizacao_Var_Pop_Fields>;
  var_samp?: Maybe<Integracoes_Ad_Parametrizacao_Var_Samp_Fields>;
  variance?: Maybe<Integracoes_Ad_Parametrizacao_Variance_Fields>;
};


/** aggregate fields of "integracoes.ad_parametrizacao" */
export type Integracoes_Ad_Parametrizacao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Integracoes_Ad_Parametrizacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Integracoes_Ad_Parametrizacao_Avg_Fields = {
  __typename?: 'integracoes_ad_parametrizacao_avg_fields';
  id_protocolo?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "integracoes.ad_parametrizacao". All fields are combined with a logical 'AND'. */
export type Integracoes_Ad_Parametrizacao_Bool_Exp = {
  _and?: InputMaybe<Array<Integracoes_Ad_Parametrizacao_Bool_Exp>>;
  _not?: InputMaybe<Integracoes_Ad_Parametrizacao_Bool_Exp>;
  _or?: InputMaybe<Array<Integracoes_Ad_Parametrizacao_Bool_Exp>>;
  data_hora_ultima_modificacao?: InputMaybe<Timestamp_Comparison_Exp>;
  id_protocolo?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "integracoes.ad_parametrizacao" */
export type Integracoes_Ad_Parametrizacao_Inc_Input = {
  id_protocolo?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "integracoes.ad_parametrizacao" */
export type Integracoes_Ad_Parametrizacao_Insert_Input = {
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  id_protocolo?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Integracoes_Ad_Parametrizacao_Max_Fields = {
  __typename?: 'integracoes_ad_parametrizacao_max_fields';
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  id_protocolo?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Integracoes_Ad_Parametrizacao_Min_Fields = {
  __typename?: 'integracoes_ad_parametrizacao_min_fields';
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  id_protocolo?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "integracoes.ad_parametrizacao" */
export type Integracoes_Ad_Parametrizacao_Mutation_Response = {
  __typename?: 'integracoes_ad_parametrizacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Integracoes_Ad_Parametrizacao>;
};

/** Ordering options when selecting data from "integracoes.ad_parametrizacao". */
export type Integracoes_Ad_Parametrizacao_Order_By = {
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  id_protocolo?: InputMaybe<Order_By>;
};

/** select columns of table "integracoes.ad_parametrizacao" */
export enum Integracoes_Ad_Parametrizacao_Select_Column {
  /** column name */
  DataHoraUltimaModificacao = 'data_hora_ultima_modificacao',
  /** column name */
  IdProtocolo = 'id_protocolo'
}

/** input type for updating data in table "integracoes.ad_parametrizacao" */
export type Integracoes_Ad_Parametrizacao_Set_Input = {
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  id_protocolo?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Integracoes_Ad_Parametrizacao_Stddev_Fields = {
  __typename?: 'integracoes_ad_parametrizacao_stddev_fields';
  id_protocolo?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Integracoes_Ad_Parametrizacao_Stddev_Pop_Fields = {
  __typename?: 'integracoes_ad_parametrizacao_stddev_pop_fields';
  id_protocolo?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Integracoes_Ad_Parametrizacao_Stddev_Samp_Fields = {
  __typename?: 'integracoes_ad_parametrizacao_stddev_samp_fields';
  id_protocolo?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "integracoes_ad_parametrizacao" */
export type Integracoes_Ad_Parametrizacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Integracoes_Ad_Parametrizacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Integracoes_Ad_Parametrizacao_Stream_Cursor_Value_Input = {
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  id_protocolo?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Integracoes_Ad_Parametrizacao_Sum_Fields = {
  __typename?: 'integracoes_ad_parametrizacao_sum_fields';
  id_protocolo?: Maybe<Scalars['Int']['output']>;
};

export type Integracoes_Ad_Parametrizacao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Integracoes_Ad_Parametrizacao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Integracoes_Ad_Parametrizacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Integracoes_Ad_Parametrizacao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Integracoes_Ad_Parametrizacao_Var_Pop_Fields = {
  __typename?: 'integracoes_ad_parametrizacao_var_pop_fields';
  id_protocolo?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Integracoes_Ad_Parametrizacao_Var_Samp_Fields = {
  __typename?: 'integracoes_ad_parametrizacao_var_samp_fields';
  id_protocolo?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Integracoes_Ad_Parametrizacao_Variance_Fields = {
  __typename?: 'integracoes_ad_parametrizacao_variance_fields';
  id_protocolo?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "integracoes.ad_saml_parametrizacao" */
export type Integracoes_Ad_Saml_Parametrizacao = {
  __typename?: 'integracoes_ad_saml_parametrizacao';
  aplicacao_id?: Maybe<Scalars['String']['output']>;
  diretorio_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  id_secret?: Maybe<Scalars['String']['output']>;
  url_encaminhamento?: Maybe<Scalars['String']['output']>;
  value_secret?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "integracoes.ad_saml_parametrizacao" */
export type Integracoes_Ad_Saml_Parametrizacao_Aggregate = {
  __typename?: 'integracoes_ad_saml_parametrizacao_aggregate';
  aggregate?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Aggregate_Fields>;
  nodes: Array<Integracoes_Ad_Saml_Parametrizacao>;
};

/** aggregate fields of "integracoes.ad_saml_parametrizacao" */
export type Integracoes_Ad_Saml_Parametrizacao_Aggregate_Fields = {
  __typename?: 'integracoes_ad_saml_parametrizacao_aggregate_fields';
  avg?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Max_Fields>;
  min?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Min_Fields>;
  stddev?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Stddev_Fields>;
  stddev_pop?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Stddev_Samp_Fields>;
  sum?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Sum_Fields>;
  var_pop?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Var_Pop_Fields>;
  var_samp?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Var_Samp_Fields>;
  variance?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Variance_Fields>;
};


/** aggregate fields of "integracoes.ad_saml_parametrizacao" */
export type Integracoes_Ad_Saml_Parametrizacao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Integracoes_Ad_Saml_Parametrizacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Integracoes_Ad_Saml_Parametrizacao_Avg_Fields = {
  __typename?: 'integracoes_ad_saml_parametrizacao_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "integracoes.ad_saml_parametrizacao". All fields are combined with a logical 'AND'. */
export type Integracoes_Ad_Saml_Parametrizacao_Bool_Exp = {
  _and?: InputMaybe<Array<Integracoes_Ad_Saml_Parametrizacao_Bool_Exp>>;
  _not?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Bool_Exp>;
  _or?: InputMaybe<Array<Integracoes_Ad_Saml_Parametrizacao_Bool_Exp>>;
  aplicacao_id?: InputMaybe<String_Comparison_Exp>;
  diretorio_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_secret?: InputMaybe<String_Comparison_Exp>;
  url_encaminhamento?: InputMaybe<String_Comparison_Exp>;
  value_secret?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "integracoes.ad_saml_parametrizacao" */
export enum Integracoes_Ad_Saml_Parametrizacao_Constraint {
  /** unique or primary key constraint on columns "id" */
  AdSamlParametrizacaoPkey = 'ad_saml_parametrizacao_pkey'
}

/** input type for incrementing numeric columns in table "integracoes.ad_saml_parametrizacao" */
export type Integracoes_Ad_Saml_Parametrizacao_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "integracoes.ad_saml_parametrizacao" */
export type Integracoes_Ad_Saml_Parametrizacao_Insert_Input = {
  aplicacao_id?: InputMaybe<Scalars['String']['input']>;
  diretorio_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_secret?: InputMaybe<Scalars['String']['input']>;
  url_encaminhamento?: InputMaybe<Scalars['String']['input']>;
  value_secret?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Integracoes_Ad_Saml_Parametrizacao_Max_Fields = {
  __typename?: 'integracoes_ad_saml_parametrizacao_max_fields';
  aplicacao_id?: Maybe<Scalars['String']['output']>;
  diretorio_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_secret?: Maybe<Scalars['String']['output']>;
  url_encaminhamento?: Maybe<Scalars['String']['output']>;
  value_secret?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Integracoes_Ad_Saml_Parametrizacao_Min_Fields = {
  __typename?: 'integracoes_ad_saml_parametrizacao_min_fields';
  aplicacao_id?: Maybe<Scalars['String']['output']>;
  diretorio_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_secret?: Maybe<Scalars['String']['output']>;
  url_encaminhamento?: Maybe<Scalars['String']['output']>;
  value_secret?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "integracoes.ad_saml_parametrizacao" */
export type Integracoes_Ad_Saml_Parametrizacao_Mutation_Response = {
  __typename?: 'integracoes_ad_saml_parametrizacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Integracoes_Ad_Saml_Parametrizacao>;
};

/** on_conflict condition type for table "integracoes.ad_saml_parametrizacao" */
export type Integracoes_Ad_Saml_Parametrizacao_On_Conflict = {
  constraint: Integracoes_Ad_Saml_Parametrizacao_Constraint;
  update_columns?: Array<Integracoes_Ad_Saml_Parametrizacao_Update_Column>;
  where?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Bool_Exp>;
};

/** Ordering options when selecting data from "integracoes.ad_saml_parametrizacao". */
export type Integracoes_Ad_Saml_Parametrizacao_Order_By = {
  aplicacao_id?: InputMaybe<Order_By>;
  diretorio_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_secret?: InputMaybe<Order_By>;
  url_encaminhamento?: InputMaybe<Order_By>;
  value_secret?: InputMaybe<Order_By>;
};

/** primary key columns input for table: integracoes.ad_saml_parametrizacao */
export type Integracoes_Ad_Saml_Parametrizacao_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "integracoes.ad_saml_parametrizacao" */
export enum Integracoes_Ad_Saml_Parametrizacao_Select_Column {
  /** column name */
  AplicacaoId = 'aplicacao_id',
  /** column name */
  DiretorioId = 'diretorio_id',
  /** column name */
  Id = 'id',
  /** column name */
  IdSecret = 'id_secret',
  /** column name */
  UrlEncaminhamento = 'url_encaminhamento',
  /** column name */
  ValueSecret = 'value_secret'
}

/** input type for updating data in table "integracoes.ad_saml_parametrizacao" */
export type Integracoes_Ad_Saml_Parametrizacao_Set_Input = {
  aplicacao_id?: InputMaybe<Scalars['String']['input']>;
  diretorio_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_secret?: InputMaybe<Scalars['String']['input']>;
  url_encaminhamento?: InputMaybe<Scalars['String']['input']>;
  value_secret?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Integracoes_Ad_Saml_Parametrizacao_Stddev_Fields = {
  __typename?: 'integracoes_ad_saml_parametrizacao_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Integracoes_Ad_Saml_Parametrizacao_Stddev_Pop_Fields = {
  __typename?: 'integracoes_ad_saml_parametrizacao_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Integracoes_Ad_Saml_Parametrizacao_Stddev_Samp_Fields = {
  __typename?: 'integracoes_ad_saml_parametrizacao_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "integracoes_ad_saml_parametrizacao" */
export type Integracoes_Ad_Saml_Parametrizacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Integracoes_Ad_Saml_Parametrizacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Integracoes_Ad_Saml_Parametrizacao_Stream_Cursor_Value_Input = {
  aplicacao_id?: InputMaybe<Scalars['String']['input']>;
  diretorio_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_secret?: InputMaybe<Scalars['String']['input']>;
  url_encaminhamento?: InputMaybe<Scalars['String']['input']>;
  value_secret?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Integracoes_Ad_Saml_Parametrizacao_Sum_Fields = {
  __typename?: 'integracoes_ad_saml_parametrizacao_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "integracoes.ad_saml_parametrizacao" */
export enum Integracoes_Ad_Saml_Parametrizacao_Update_Column {
  /** column name */
  AplicacaoId = 'aplicacao_id',
  /** column name */
  DiretorioId = 'diretorio_id',
  /** column name */
  Id = 'id',
  /** column name */
  IdSecret = 'id_secret',
  /** column name */
  UrlEncaminhamento = 'url_encaminhamento',
  /** column name */
  ValueSecret = 'value_secret'
}

export type Integracoes_Ad_Saml_Parametrizacao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Integracoes_Ad_Saml_Parametrizacao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Integracoes_Ad_Saml_Parametrizacao_Var_Pop_Fields = {
  __typename?: 'integracoes_ad_saml_parametrizacao_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Integracoes_Ad_Saml_Parametrizacao_Var_Samp_Fields = {
  __typename?: 'integracoes_ad_saml_parametrizacao_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Integracoes_Ad_Saml_Parametrizacao_Variance_Fields = {
  __typename?: 'integracoes_ad_saml_parametrizacao_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "integracoes.sig_maps_ortos" */
export type Integracoes_Sig_Maps_Ortos = {
  __typename?: 'integracoes_sig_maps_ortos';
  id: Scalars['smallint']['output'];
  json?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "integracoes.sig_maps_ortos" */
export type Integracoes_Sig_Maps_Ortos_Aggregate = {
  __typename?: 'integracoes_sig_maps_ortos_aggregate';
  aggregate?: Maybe<Integracoes_Sig_Maps_Ortos_Aggregate_Fields>;
  nodes: Array<Integracoes_Sig_Maps_Ortos>;
};

/** aggregate fields of "integracoes.sig_maps_ortos" */
export type Integracoes_Sig_Maps_Ortos_Aggregate_Fields = {
  __typename?: 'integracoes_sig_maps_ortos_aggregate_fields';
  avg?: Maybe<Integracoes_Sig_Maps_Ortos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Integracoes_Sig_Maps_Ortos_Max_Fields>;
  min?: Maybe<Integracoes_Sig_Maps_Ortos_Min_Fields>;
  stddev?: Maybe<Integracoes_Sig_Maps_Ortos_Stddev_Fields>;
  stddev_pop?: Maybe<Integracoes_Sig_Maps_Ortos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Integracoes_Sig_Maps_Ortos_Stddev_Samp_Fields>;
  sum?: Maybe<Integracoes_Sig_Maps_Ortos_Sum_Fields>;
  var_pop?: Maybe<Integracoes_Sig_Maps_Ortos_Var_Pop_Fields>;
  var_samp?: Maybe<Integracoes_Sig_Maps_Ortos_Var_Samp_Fields>;
  variance?: Maybe<Integracoes_Sig_Maps_Ortos_Variance_Fields>;
};


/** aggregate fields of "integracoes.sig_maps_ortos" */
export type Integracoes_Sig_Maps_Ortos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Integracoes_Sig_Maps_Ortos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Integracoes_Sig_Maps_Ortos_Avg_Fields = {
  __typename?: 'integracoes_sig_maps_ortos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "integracoes.sig_maps_ortos". All fields are combined with a logical 'AND'. */
export type Integracoes_Sig_Maps_Ortos_Bool_Exp = {
  _and?: InputMaybe<Array<Integracoes_Sig_Maps_Ortos_Bool_Exp>>;
  _not?: InputMaybe<Integracoes_Sig_Maps_Ortos_Bool_Exp>;
  _or?: InputMaybe<Array<Integracoes_Sig_Maps_Ortos_Bool_Exp>>;
  id?: InputMaybe<Smallint_Comparison_Exp>;
  json?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "integracoes.sig_maps_ortos" */
export enum Integracoes_Sig_Maps_Ortos_Constraint {
  /** unique or primary key constraint on columns "id" */
  SigMapsOrtosPkey = 'sig_maps_ortos_pkey'
}

/** input type for incrementing numeric columns in table "integracoes.sig_maps_ortos" */
export type Integracoes_Sig_Maps_Ortos_Inc_Input = {
  id?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "integracoes.sig_maps_ortos" */
export type Integracoes_Sig_Maps_Ortos_Insert_Input = {
  id?: InputMaybe<Scalars['smallint']['input']>;
  json?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Integracoes_Sig_Maps_Ortos_Max_Fields = {
  __typename?: 'integracoes_sig_maps_ortos_max_fields';
  id?: Maybe<Scalars['smallint']['output']>;
  json?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Integracoes_Sig_Maps_Ortos_Min_Fields = {
  __typename?: 'integracoes_sig_maps_ortos_min_fields';
  id?: Maybe<Scalars['smallint']['output']>;
  json?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "integracoes.sig_maps_ortos" */
export type Integracoes_Sig_Maps_Ortos_Mutation_Response = {
  __typename?: 'integracoes_sig_maps_ortos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Integracoes_Sig_Maps_Ortos>;
};

/** on_conflict condition type for table "integracoes.sig_maps_ortos" */
export type Integracoes_Sig_Maps_Ortos_On_Conflict = {
  constraint: Integracoes_Sig_Maps_Ortos_Constraint;
  update_columns?: Array<Integracoes_Sig_Maps_Ortos_Update_Column>;
  where?: InputMaybe<Integracoes_Sig_Maps_Ortos_Bool_Exp>;
};

/** Ordering options when selecting data from "integracoes.sig_maps_ortos". */
export type Integracoes_Sig_Maps_Ortos_Order_By = {
  id?: InputMaybe<Order_By>;
  json?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: integracoes.sig_maps_ortos */
export type Integracoes_Sig_Maps_Ortos_Pk_Columns_Input = {
  id: Scalars['smallint']['input'];
};

/** select columns of table "integracoes.sig_maps_ortos" */
export enum Integracoes_Sig_Maps_Ortos_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Json = 'json',
  /** column name */
  Name = 'name',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "integracoes.sig_maps_ortos" */
export type Integracoes_Sig_Maps_Ortos_Set_Input = {
  id?: InputMaybe<Scalars['smallint']['input']>;
  json?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Integracoes_Sig_Maps_Ortos_Stddev_Fields = {
  __typename?: 'integracoes_sig_maps_ortos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Integracoes_Sig_Maps_Ortos_Stddev_Pop_Fields = {
  __typename?: 'integracoes_sig_maps_ortos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Integracoes_Sig_Maps_Ortos_Stddev_Samp_Fields = {
  __typename?: 'integracoes_sig_maps_ortos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "integracoes_sig_maps_ortos" */
export type Integracoes_Sig_Maps_Ortos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Integracoes_Sig_Maps_Ortos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Integracoes_Sig_Maps_Ortos_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['smallint']['input']>;
  json?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Integracoes_Sig_Maps_Ortos_Sum_Fields = {
  __typename?: 'integracoes_sig_maps_ortos_sum_fields';
  id?: Maybe<Scalars['smallint']['output']>;
};

/** update columns of table "integracoes.sig_maps_ortos" */
export enum Integracoes_Sig_Maps_Ortos_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Json = 'json',
  /** column name */
  Name = 'name',
  /** column name */
  Url = 'url'
}

export type Integracoes_Sig_Maps_Ortos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Integracoes_Sig_Maps_Ortos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Integracoes_Sig_Maps_Ortos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Integracoes_Sig_Maps_Ortos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Integracoes_Sig_Maps_Ortos_Var_Pop_Fields = {
  __typename?: 'integracoes_sig_maps_ortos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Integracoes_Sig_Maps_Ortos_Var_Samp_Fields = {
  __typename?: 'integracoes_sig_maps_ortos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Integracoes_Sig_Maps_Ortos_Variance_Fields = {
  __typename?: 'integracoes_sig_maps_ortos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "integracoes.sig_parametrizacao" */
export type Integracoes_Sig_Parametrizacao = {
  __typename?: 'integracoes_sig_parametrizacao';
  enable_proxy?: Maybe<Scalars['Boolean']['output']>;
  esri_version?: Maybe<Scalars['String']['output']>;
  estado_comunicacao_intervencoes?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  map_server?: Maybe<Scalars['String']['output']>;
  map_type?: Maybe<Scalars['String']['output']>;
  nao_esri_version?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  projection_begin?: Maybe<Scalars['String']['output']>;
  projection_end?: Maybe<Scalars['String']['output']>;
  proxy_add_url?: Maybe<Scalars['String']['output']>;
  setup_layer?: Maybe<Scalars['String']['output']>;
  sig_paginacao?: Maybe<Scalars['Boolean']['output']>;
  token_password?: Maybe<Scalars['String']['output']>;
  token_referer?: Maybe<Scalars['String']['output']>;
  token_request?: Maybe<Scalars['String']['output']>;
  token_url?: Maybe<Scalars['String']['output']>;
  token_username?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url_intervencoes?: Maybe<Scalars['String']['output']>;
  url_services?: Maybe<Scalars['String']['output']>;
  zoom_default?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "integracoes.sig_parametrizacao" */
export type Integracoes_Sig_Parametrizacao_Aggregate = {
  __typename?: 'integracoes_sig_parametrizacao_aggregate';
  aggregate?: Maybe<Integracoes_Sig_Parametrizacao_Aggregate_Fields>;
  nodes: Array<Integracoes_Sig_Parametrizacao>;
};

/** aggregate fields of "integracoes.sig_parametrizacao" */
export type Integracoes_Sig_Parametrizacao_Aggregate_Fields = {
  __typename?: 'integracoes_sig_parametrizacao_aggregate_fields';
  avg?: Maybe<Integracoes_Sig_Parametrizacao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Integracoes_Sig_Parametrizacao_Max_Fields>;
  min?: Maybe<Integracoes_Sig_Parametrizacao_Min_Fields>;
  stddev?: Maybe<Integracoes_Sig_Parametrizacao_Stddev_Fields>;
  stddev_pop?: Maybe<Integracoes_Sig_Parametrizacao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Integracoes_Sig_Parametrizacao_Stddev_Samp_Fields>;
  sum?: Maybe<Integracoes_Sig_Parametrizacao_Sum_Fields>;
  var_pop?: Maybe<Integracoes_Sig_Parametrizacao_Var_Pop_Fields>;
  var_samp?: Maybe<Integracoes_Sig_Parametrizacao_Var_Samp_Fields>;
  variance?: Maybe<Integracoes_Sig_Parametrizacao_Variance_Fields>;
};


/** aggregate fields of "integracoes.sig_parametrizacao" */
export type Integracoes_Sig_Parametrizacao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Integracoes_Sig_Parametrizacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Integracoes_Sig_Parametrizacao_Avg_Fields = {
  __typename?: 'integracoes_sig_parametrizacao_avg_fields';
  zoom_default?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "integracoes.sig_parametrizacao". All fields are combined with a logical 'AND'. */
export type Integracoes_Sig_Parametrizacao_Bool_Exp = {
  _and?: InputMaybe<Array<Integracoes_Sig_Parametrizacao_Bool_Exp>>;
  _not?: InputMaybe<Integracoes_Sig_Parametrizacao_Bool_Exp>;
  _or?: InputMaybe<Array<Integracoes_Sig_Parametrizacao_Bool_Exp>>;
  enable_proxy?: InputMaybe<Boolean_Comparison_Exp>;
  esri_version?: InputMaybe<String_Comparison_Exp>;
  estado_comunicacao_intervencoes?: InputMaybe<String_Comparison_Exp>;
  latitude?: InputMaybe<String_Comparison_Exp>;
  login?: InputMaybe<String_Comparison_Exp>;
  longitude?: InputMaybe<String_Comparison_Exp>;
  map_server?: InputMaybe<String_Comparison_Exp>;
  map_type?: InputMaybe<String_Comparison_Exp>;
  nao_esri_version?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  projection_begin?: InputMaybe<String_Comparison_Exp>;
  projection_end?: InputMaybe<String_Comparison_Exp>;
  proxy_add_url?: InputMaybe<String_Comparison_Exp>;
  setup_layer?: InputMaybe<String_Comparison_Exp>;
  sig_paginacao?: InputMaybe<Boolean_Comparison_Exp>;
  token_password?: InputMaybe<String_Comparison_Exp>;
  token_referer?: InputMaybe<String_Comparison_Exp>;
  token_request?: InputMaybe<String_Comparison_Exp>;
  token_url?: InputMaybe<String_Comparison_Exp>;
  token_username?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  url_intervencoes?: InputMaybe<String_Comparison_Exp>;
  url_services?: InputMaybe<String_Comparison_Exp>;
  zoom_default?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "integracoes.sig_parametrizacao" */
export type Integracoes_Sig_Parametrizacao_Inc_Input = {
  zoom_default?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "integracoes.sig_parametrizacao" */
export type Integracoes_Sig_Parametrizacao_Insert_Input = {
  enable_proxy?: InputMaybe<Scalars['Boolean']['input']>;
  esri_version?: InputMaybe<Scalars['String']['input']>;
  estado_comunicacao_intervencoes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  map_server?: InputMaybe<Scalars['String']['input']>;
  map_type?: InputMaybe<Scalars['String']['input']>;
  nao_esri_version?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  projection_begin?: InputMaybe<Scalars['String']['input']>;
  projection_end?: InputMaybe<Scalars['String']['input']>;
  proxy_add_url?: InputMaybe<Scalars['String']['input']>;
  setup_layer?: InputMaybe<Scalars['String']['input']>;
  sig_paginacao?: InputMaybe<Scalars['Boolean']['input']>;
  token_password?: InputMaybe<Scalars['String']['input']>;
  token_referer?: InputMaybe<Scalars['String']['input']>;
  token_request?: InputMaybe<Scalars['String']['input']>;
  token_url?: InputMaybe<Scalars['String']['input']>;
  token_username?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url_intervencoes?: InputMaybe<Scalars['String']['input']>;
  url_services?: InputMaybe<Scalars['String']['input']>;
  zoom_default?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Integracoes_Sig_Parametrizacao_Max_Fields = {
  __typename?: 'integracoes_sig_parametrizacao_max_fields';
  esri_version?: Maybe<Scalars['String']['output']>;
  estado_comunicacao_intervencoes?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  map_server?: Maybe<Scalars['String']['output']>;
  map_type?: Maybe<Scalars['String']['output']>;
  nao_esri_version?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  projection_begin?: Maybe<Scalars['String']['output']>;
  projection_end?: Maybe<Scalars['String']['output']>;
  proxy_add_url?: Maybe<Scalars['String']['output']>;
  setup_layer?: Maybe<Scalars['String']['output']>;
  token_password?: Maybe<Scalars['String']['output']>;
  token_referer?: Maybe<Scalars['String']['output']>;
  token_request?: Maybe<Scalars['String']['output']>;
  token_url?: Maybe<Scalars['String']['output']>;
  token_username?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url_intervencoes?: Maybe<Scalars['String']['output']>;
  url_services?: Maybe<Scalars['String']['output']>;
  zoom_default?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Integracoes_Sig_Parametrizacao_Min_Fields = {
  __typename?: 'integracoes_sig_parametrizacao_min_fields';
  esri_version?: Maybe<Scalars['String']['output']>;
  estado_comunicacao_intervencoes?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  map_server?: Maybe<Scalars['String']['output']>;
  map_type?: Maybe<Scalars['String']['output']>;
  nao_esri_version?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  projection_begin?: Maybe<Scalars['String']['output']>;
  projection_end?: Maybe<Scalars['String']['output']>;
  proxy_add_url?: Maybe<Scalars['String']['output']>;
  setup_layer?: Maybe<Scalars['String']['output']>;
  token_password?: Maybe<Scalars['String']['output']>;
  token_referer?: Maybe<Scalars['String']['output']>;
  token_request?: Maybe<Scalars['String']['output']>;
  token_url?: Maybe<Scalars['String']['output']>;
  token_username?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url_intervencoes?: Maybe<Scalars['String']['output']>;
  url_services?: Maybe<Scalars['String']['output']>;
  zoom_default?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "integracoes.sig_parametrizacao" */
export type Integracoes_Sig_Parametrizacao_Mutation_Response = {
  __typename?: 'integracoes_sig_parametrizacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Integracoes_Sig_Parametrizacao>;
};

/** Ordering options when selecting data from "integracoes.sig_parametrizacao". */
export type Integracoes_Sig_Parametrizacao_Order_By = {
  enable_proxy?: InputMaybe<Order_By>;
  esri_version?: InputMaybe<Order_By>;
  estado_comunicacao_intervencoes?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  login?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  map_server?: InputMaybe<Order_By>;
  map_type?: InputMaybe<Order_By>;
  nao_esri_version?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  projection_begin?: InputMaybe<Order_By>;
  projection_end?: InputMaybe<Order_By>;
  proxy_add_url?: InputMaybe<Order_By>;
  setup_layer?: InputMaybe<Order_By>;
  sig_paginacao?: InputMaybe<Order_By>;
  token_password?: InputMaybe<Order_By>;
  token_referer?: InputMaybe<Order_By>;
  token_request?: InputMaybe<Order_By>;
  token_url?: InputMaybe<Order_By>;
  token_username?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  url_intervencoes?: InputMaybe<Order_By>;
  url_services?: InputMaybe<Order_By>;
  zoom_default?: InputMaybe<Order_By>;
};

/** select columns of table "integracoes.sig_parametrizacao" */
export enum Integracoes_Sig_Parametrizacao_Select_Column {
  /** column name */
  EnableProxy = 'enable_proxy',
  /** column name */
  EsriVersion = 'esri_version',
  /** column name */
  EstadoComunicacaoIntervencoes = 'estado_comunicacao_intervencoes',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Login = 'login',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  MapServer = 'map_server',
  /** column name */
  MapType = 'map_type',
  /** column name */
  NaoEsriVersion = 'nao_esri_version',
  /** column name */
  Password = 'password',
  /** column name */
  ProjectionBegin = 'projection_begin',
  /** column name */
  ProjectionEnd = 'projection_end',
  /** column name */
  ProxyAddUrl = 'proxy_add_url',
  /** column name */
  SetupLayer = 'setup_layer',
  /** column name */
  SigPaginacao = 'sig_paginacao',
  /** column name */
  TokenPassword = 'token_password',
  /** column name */
  TokenReferer = 'token_referer',
  /** column name */
  TokenRequest = 'token_request',
  /** column name */
  TokenUrl = 'token_url',
  /** column name */
  TokenUsername = 'token_username',
  /** column name */
  Type = 'type',
  /** column name */
  UrlIntervencoes = 'url_intervencoes',
  /** column name */
  UrlServices = 'url_services',
  /** column name */
  ZoomDefault = 'zoom_default'
}

/** input type for updating data in table "integracoes.sig_parametrizacao" */
export type Integracoes_Sig_Parametrizacao_Set_Input = {
  enable_proxy?: InputMaybe<Scalars['Boolean']['input']>;
  esri_version?: InputMaybe<Scalars['String']['input']>;
  estado_comunicacao_intervencoes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  map_server?: InputMaybe<Scalars['String']['input']>;
  map_type?: InputMaybe<Scalars['String']['input']>;
  nao_esri_version?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  projection_begin?: InputMaybe<Scalars['String']['input']>;
  projection_end?: InputMaybe<Scalars['String']['input']>;
  proxy_add_url?: InputMaybe<Scalars['String']['input']>;
  setup_layer?: InputMaybe<Scalars['String']['input']>;
  sig_paginacao?: InputMaybe<Scalars['Boolean']['input']>;
  token_password?: InputMaybe<Scalars['String']['input']>;
  token_referer?: InputMaybe<Scalars['String']['input']>;
  token_request?: InputMaybe<Scalars['String']['input']>;
  token_url?: InputMaybe<Scalars['String']['input']>;
  token_username?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url_intervencoes?: InputMaybe<Scalars['String']['input']>;
  url_services?: InputMaybe<Scalars['String']['input']>;
  zoom_default?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Integracoes_Sig_Parametrizacao_Stddev_Fields = {
  __typename?: 'integracoes_sig_parametrizacao_stddev_fields';
  zoom_default?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Integracoes_Sig_Parametrizacao_Stddev_Pop_Fields = {
  __typename?: 'integracoes_sig_parametrizacao_stddev_pop_fields';
  zoom_default?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Integracoes_Sig_Parametrizacao_Stddev_Samp_Fields = {
  __typename?: 'integracoes_sig_parametrizacao_stddev_samp_fields';
  zoom_default?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "integracoes_sig_parametrizacao" */
export type Integracoes_Sig_Parametrizacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Integracoes_Sig_Parametrizacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Integracoes_Sig_Parametrizacao_Stream_Cursor_Value_Input = {
  enable_proxy?: InputMaybe<Scalars['Boolean']['input']>;
  esri_version?: InputMaybe<Scalars['String']['input']>;
  estado_comunicacao_intervencoes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  map_server?: InputMaybe<Scalars['String']['input']>;
  map_type?: InputMaybe<Scalars['String']['input']>;
  nao_esri_version?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  projection_begin?: InputMaybe<Scalars['String']['input']>;
  projection_end?: InputMaybe<Scalars['String']['input']>;
  proxy_add_url?: InputMaybe<Scalars['String']['input']>;
  setup_layer?: InputMaybe<Scalars['String']['input']>;
  sig_paginacao?: InputMaybe<Scalars['Boolean']['input']>;
  token_password?: InputMaybe<Scalars['String']['input']>;
  token_referer?: InputMaybe<Scalars['String']['input']>;
  token_request?: InputMaybe<Scalars['String']['input']>;
  token_url?: InputMaybe<Scalars['String']['input']>;
  token_username?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url_intervencoes?: InputMaybe<Scalars['String']['input']>;
  url_services?: InputMaybe<Scalars['String']['input']>;
  zoom_default?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Integracoes_Sig_Parametrizacao_Sum_Fields = {
  __typename?: 'integracoes_sig_parametrizacao_sum_fields';
  zoom_default?: Maybe<Scalars['Int']['output']>;
};

export type Integracoes_Sig_Parametrizacao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Integracoes_Sig_Parametrizacao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Integracoes_Sig_Parametrizacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Integracoes_Sig_Parametrizacao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Integracoes_Sig_Parametrizacao_Var_Pop_Fields = {
  __typename?: 'integracoes_sig_parametrizacao_var_pop_fields';
  zoom_default?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Integracoes_Sig_Parametrizacao_Var_Samp_Fields = {
  __typename?: 'integracoes_sig_parametrizacao_var_samp_fields';
  zoom_default?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Integracoes_Sig_Parametrizacao_Variance_Fields = {
  __typename?: 'integracoes_sig_parametrizacao_variance_fields';
  zoom_default?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "integracoes.sig_proxy" */
export type Integracoes_Sig_Proxy = {
  __typename?: 'integracoes_sig_proxy';
  apagado: Scalars['Boolean']['output'];
  ativo: Scalars['Boolean']['output'];
  id: Scalars['bigint']['output'];
  login?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** aggregated selection of "integracoes.sig_proxy" */
export type Integracoes_Sig_Proxy_Aggregate = {
  __typename?: 'integracoes_sig_proxy_aggregate';
  aggregate?: Maybe<Integracoes_Sig_Proxy_Aggregate_Fields>;
  nodes: Array<Integracoes_Sig_Proxy>;
};

/** aggregate fields of "integracoes.sig_proxy" */
export type Integracoes_Sig_Proxy_Aggregate_Fields = {
  __typename?: 'integracoes_sig_proxy_aggregate_fields';
  avg?: Maybe<Integracoes_Sig_Proxy_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Integracoes_Sig_Proxy_Max_Fields>;
  min?: Maybe<Integracoes_Sig_Proxy_Min_Fields>;
  stddev?: Maybe<Integracoes_Sig_Proxy_Stddev_Fields>;
  stddev_pop?: Maybe<Integracoes_Sig_Proxy_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Integracoes_Sig_Proxy_Stddev_Samp_Fields>;
  sum?: Maybe<Integracoes_Sig_Proxy_Sum_Fields>;
  var_pop?: Maybe<Integracoes_Sig_Proxy_Var_Pop_Fields>;
  var_samp?: Maybe<Integracoes_Sig_Proxy_Var_Samp_Fields>;
  variance?: Maybe<Integracoes_Sig_Proxy_Variance_Fields>;
};


/** aggregate fields of "integracoes.sig_proxy" */
export type Integracoes_Sig_Proxy_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Integracoes_Sig_Proxy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Integracoes_Sig_Proxy_Avg_Fields = {
  __typename?: 'integracoes_sig_proxy_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "integracoes.sig_proxy". All fields are combined with a logical 'AND'. */
export type Integracoes_Sig_Proxy_Bool_Exp = {
  _and?: InputMaybe<Array<Integracoes_Sig_Proxy_Bool_Exp>>;
  _not?: InputMaybe<Integracoes_Sig_Proxy_Bool_Exp>;
  _or?: InputMaybe<Array<Integracoes_Sig_Proxy_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  ativo?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  login?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "integracoes.sig_proxy" */
export enum Integracoes_Sig_Proxy_Constraint {
  /** unique or primary key constraint on columns "id" */
  SigProxyPkey = 'sig_proxy_pkey'
}

/** input type for incrementing numeric columns in table "integracoes.sig_proxy" */
export type Integracoes_Sig_Proxy_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "integracoes.sig_proxy" */
export type Integracoes_Sig_Proxy_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Integracoes_Sig_Proxy_Max_Fields = {
  __typename?: 'integracoes_sig_proxy_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Integracoes_Sig_Proxy_Min_Fields = {
  __typename?: 'integracoes_sig_proxy_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "integracoes.sig_proxy" */
export type Integracoes_Sig_Proxy_Mutation_Response = {
  __typename?: 'integracoes_sig_proxy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Integracoes_Sig_Proxy>;
};

/** on_conflict condition type for table "integracoes.sig_proxy" */
export type Integracoes_Sig_Proxy_On_Conflict = {
  constraint: Integracoes_Sig_Proxy_Constraint;
  update_columns?: Array<Integracoes_Sig_Proxy_Update_Column>;
  where?: InputMaybe<Integracoes_Sig_Proxy_Bool_Exp>;
};

/** Ordering options when selecting data from "integracoes.sig_proxy". */
export type Integracoes_Sig_Proxy_Order_By = {
  apagado?: InputMaybe<Order_By>;
  ativo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  login?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: integracoes.sig_proxy */
export type Integracoes_Sig_Proxy_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "integracoes.sig_proxy" */
export enum Integracoes_Sig_Proxy_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Ativo = 'ativo',
  /** column name */
  Id = 'id',
  /** column name */
  Login = 'login',
  /** column name */
  Password = 'password',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "integracoes.sig_proxy" */
export type Integracoes_Sig_Proxy_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Integracoes_Sig_Proxy_Stddev_Fields = {
  __typename?: 'integracoes_sig_proxy_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Integracoes_Sig_Proxy_Stddev_Pop_Fields = {
  __typename?: 'integracoes_sig_proxy_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Integracoes_Sig_Proxy_Stddev_Samp_Fields = {
  __typename?: 'integracoes_sig_proxy_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "integracoes_sig_proxy" */
export type Integracoes_Sig_Proxy_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Integracoes_Sig_Proxy_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Integracoes_Sig_Proxy_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Integracoes_Sig_Proxy_Sum_Fields = {
  __typename?: 'integracoes_sig_proxy_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "integracoes.sig_proxy" */
export enum Integracoes_Sig_Proxy_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Ativo = 'ativo',
  /** column name */
  Id = 'id',
  /** column name */
  Login = 'login',
  /** column name */
  Password = 'password',
  /** column name */
  Url = 'url'
}

export type Integracoes_Sig_Proxy_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Integracoes_Sig_Proxy_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Integracoes_Sig_Proxy_Set_Input>;
  /** filter the rows which have to be updated */
  where: Integracoes_Sig_Proxy_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Integracoes_Sig_Proxy_Var_Pop_Fields = {
  __typename?: 'integracoes_sig_proxy_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Integracoes_Sig_Proxy_Var_Samp_Fields = {
  __typename?: 'integracoes_sig_proxy_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Integracoes_Sig_Proxy_Variance_Fields = {
  __typename?: 'integracoes_sig_proxy_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "integracoes.sig_request_get_attributes" */
export type Integracoes_Sig_Request_Get_Attributes = {
  __typename?: 'integracoes_sig_request_get_attributes';
  outputformat?: Maybe<Scalars['String']['output']>;
  request: Scalars['String']['output'];
  service: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** aggregated selection of "integracoes.sig_request_get_attributes" */
export type Integracoes_Sig_Request_Get_Attributes_Aggregate = {
  __typename?: 'integracoes_sig_request_get_attributes_aggregate';
  aggregate?: Maybe<Integracoes_Sig_Request_Get_Attributes_Aggregate_Fields>;
  nodes: Array<Integracoes_Sig_Request_Get_Attributes>;
};

/** aggregate fields of "integracoes.sig_request_get_attributes" */
export type Integracoes_Sig_Request_Get_Attributes_Aggregate_Fields = {
  __typename?: 'integracoes_sig_request_get_attributes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Integracoes_Sig_Request_Get_Attributes_Max_Fields>;
  min?: Maybe<Integracoes_Sig_Request_Get_Attributes_Min_Fields>;
};


/** aggregate fields of "integracoes.sig_request_get_attributes" */
export type Integracoes_Sig_Request_Get_Attributes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Integracoes_Sig_Request_Get_Attributes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "integracoes.sig_request_get_attributes". All fields are combined with a logical 'AND'. */
export type Integracoes_Sig_Request_Get_Attributes_Bool_Exp = {
  _and?: InputMaybe<Array<Integracoes_Sig_Request_Get_Attributes_Bool_Exp>>;
  _not?: InputMaybe<Integracoes_Sig_Request_Get_Attributes_Bool_Exp>;
  _or?: InputMaybe<Array<Integracoes_Sig_Request_Get_Attributes_Bool_Exp>>;
  outputformat?: InputMaybe<String_Comparison_Exp>;
  request?: InputMaybe<String_Comparison_Exp>;
  service?: InputMaybe<String_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "integracoes.sig_request_get_attributes" */
export type Integracoes_Sig_Request_Get_Attributes_Insert_Input = {
  outputformat?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Integracoes_Sig_Request_Get_Attributes_Max_Fields = {
  __typename?: 'integracoes_sig_request_get_attributes_max_fields';
  outputformat?: Maybe<Scalars['String']['output']>;
  request?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Integracoes_Sig_Request_Get_Attributes_Min_Fields = {
  __typename?: 'integracoes_sig_request_get_attributes_min_fields';
  outputformat?: Maybe<Scalars['String']['output']>;
  request?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "integracoes.sig_request_get_attributes" */
export type Integracoes_Sig_Request_Get_Attributes_Mutation_Response = {
  __typename?: 'integracoes_sig_request_get_attributes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Integracoes_Sig_Request_Get_Attributes>;
};

/** Ordering options when selecting data from "integracoes.sig_request_get_attributes". */
export type Integracoes_Sig_Request_Get_Attributes_Order_By = {
  outputformat?: InputMaybe<Order_By>;
  request?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** select columns of table "integracoes.sig_request_get_attributes" */
export enum Integracoes_Sig_Request_Get_Attributes_Select_Column {
  /** column name */
  Outputformat = 'outputformat',
  /** column name */
  Request = 'request',
  /** column name */
  Service = 'service',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "integracoes.sig_request_get_attributes" */
export type Integracoes_Sig_Request_Get_Attributes_Set_Input = {
  outputformat?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "integracoes_sig_request_get_attributes" */
export type Integracoes_Sig_Request_Get_Attributes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Integracoes_Sig_Request_Get_Attributes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Integracoes_Sig_Request_Get_Attributes_Stream_Cursor_Value_Input = {
  outputformat?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type Integracoes_Sig_Request_Get_Attributes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Integracoes_Sig_Request_Get_Attributes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Integracoes_Sig_Request_Get_Attributes_Bool_Exp;
};

/** columns and relationships of "integracoes.sig_request_get_capabilities" */
export type Integracoes_Sig_Request_Get_Capabilities = {
  __typename?: 'integracoes_sig_request_get_capabilities';
  request: Scalars['String']['output'];
  service: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** aggregated selection of "integracoes.sig_request_get_capabilities" */
export type Integracoes_Sig_Request_Get_Capabilities_Aggregate = {
  __typename?: 'integracoes_sig_request_get_capabilities_aggregate';
  aggregate?: Maybe<Integracoes_Sig_Request_Get_Capabilities_Aggregate_Fields>;
  nodes: Array<Integracoes_Sig_Request_Get_Capabilities>;
};

/** aggregate fields of "integracoes.sig_request_get_capabilities" */
export type Integracoes_Sig_Request_Get_Capabilities_Aggregate_Fields = {
  __typename?: 'integracoes_sig_request_get_capabilities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Integracoes_Sig_Request_Get_Capabilities_Max_Fields>;
  min?: Maybe<Integracoes_Sig_Request_Get_Capabilities_Min_Fields>;
};


/** aggregate fields of "integracoes.sig_request_get_capabilities" */
export type Integracoes_Sig_Request_Get_Capabilities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Integracoes_Sig_Request_Get_Capabilities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "integracoes.sig_request_get_capabilities". All fields are combined with a logical 'AND'. */
export type Integracoes_Sig_Request_Get_Capabilities_Bool_Exp = {
  _and?: InputMaybe<Array<Integracoes_Sig_Request_Get_Capabilities_Bool_Exp>>;
  _not?: InputMaybe<Integracoes_Sig_Request_Get_Capabilities_Bool_Exp>;
  _or?: InputMaybe<Array<Integracoes_Sig_Request_Get_Capabilities_Bool_Exp>>;
  request?: InputMaybe<String_Comparison_Exp>;
  service?: InputMaybe<String_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "integracoes.sig_request_get_capabilities" */
export type Integracoes_Sig_Request_Get_Capabilities_Insert_Input = {
  request?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Integracoes_Sig_Request_Get_Capabilities_Max_Fields = {
  __typename?: 'integracoes_sig_request_get_capabilities_max_fields';
  request?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Integracoes_Sig_Request_Get_Capabilities_Min_Fields = {
  __typename?: 'integracoes_sig_request_get_capabilities_min_fields';
  request?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "integracoes.sig_request_get_capabilities" */
export type Integracoes_Sig_Request_Get_Capabilities_Mutation_Response = {
  __typename?: 'integracoes_sig_request_get_capabilities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Integracoes_Sig_Request_Get_Capabilities>;
};

/** Ordering options when selecting data from "integracoes.sig_request_get_capabilities". */
export type Integracoes_Sig_Request_Get_Capabilities_Order_By = {
  request?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** select columns of table "integracoes.sig_request_get_capabilities" */
export enum Integracoes_Sig_Request_Get_Capabilities_Select_Column {
  /** column name */
  Request = 'request',
  /** column name */
  Service = 'service',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "integracoes.sig_request_get_capabilities" */
export type Integracoes_Sig_Request_Get_Capabilities_Set_Input = {
  request?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "integracoes_sig_request_get_capabilities" */
export type Integracoes_Sig_Request_Get_Capabilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Integracoes_Sig_Request_Get_Capabilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Integracoes_Sig_Request_Get_Capabilities_Stream_Cursor_Value_Input = {
  request?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type Integracoes_Sig_Request_Get_Capabilities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Integracoes_Sig_Request_Get_Capabilities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Integracoes_Sig_Request_Get_Capabilities_Bool_Exp;
};

/** columns and relationships of "integracoes.sig_request_get_features" */
export type Integracoes_Sig_Request_Get_Features = {
  __typename?: 'integracoes_sig_request_get_features';
  outputformat?: Maybe<Scalars['String']['output']>;
  request: Scalars['String']['output'];
  service: Scalars['String']['output'];
  srsname?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

/** aggregated selection of "integracoes.sig_request_get_features" */
export type Integracoes_Sig_Request_Get_Features_Aggregate = {
  __typename?: 'integracoes_sig_request_get_features_aggregate';
  aggregate?: Maybe<Integracoes_Sig_Request_Get_Features_Aggregate_Fields>;
  nodes: Array<Integracoes_Sig_Request_Get_Features>;
};

/** aggregate fields of "integracoes.sig_request_get_features" */
export type Integracoes_Sig_Request_Get_Features_Aggregate_Fields = {
  __typename?: 'integracoes_sig_request_get_features_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Integracoes_Sig_Request_Get_Features_Max_Fields>;
  min?: Maybe<Integracoes_Sig_Request_Get_Features_Min_Fields>;
};


/** aggregate fields of "integracoes.sig_request_get_features" */
export type Integracoes_Sig_Request_Get_Features_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Integracoes_Sig_Request_Get_Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "integracoes.sig_request_get_features". All fields are combined with a logical 'AND'. */
export type Integracoes_Sig_Request_Get_Features_Bool_Exp = {
  _and?: InputMaybe<Array<Integracoes_Sig_Request_Get_Features_Bool_Exp>>;
  _not?: InputMaybe<Integracoes_Sig_Request_Get_Features_Bool_Exp>;
  _or?: InputMaybe<Array<Integracoes_Sig_Request_Get_Features_Bool_Exp>>;
  outputformat?: InputMaybe<String_Comparison_Exp>;
  request?: InputMaybe<String_Comparison_Exp>;
  service?: InputMaybe<String_Comparison_Exp>;
  srsname?: InputMaybe<String_Comparison_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "integracoes.sig_request_get_features" */
export type Integracoes_Sig_Request_Get_Features_Insert_Input = {
  outputformat?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  srsname?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Integracoes_Sig_Request_Get_Features_Max_Fields = {
  __typename?: 'integracoes_sig_request_get_features_max_fields';
  outputformat?: Maybe<Scalars['String']['output']>;
  request?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  srsname?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Integracoes_Sig_Request_Get_Features_Min_Fields = {
  __typename?: 'integracoes_sig_request_get_features_min_fields';
  outputformat?: Maybe<Scalars['String']['output']>;
  request?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  srsname?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "integracoes.sig_request_get_features" */
export type Integracoes_Sig_Request_Get_Features_Mutation_Response = {
  __typename?: 'integracoes_sig_request_get_features_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Integracoes_Sig_Request_Get_Features>;
};

/** Ordering options when selecting data from "integracoes.sig_request_get_features". */
export type Integracoes_Sig_Request_Get_Features_Order_By = {
  outputformat?: InputMaybe<Order_By>;
  request?: InputMaybe<Order_By>;
  service?: InputMaybe<Order_By>;
  srsname?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** select columns of table "integracoes.sig_request_get_features" */
export enum Integracoes_Sig_Request_Get_Features_Select_Column {
  /** column name */
  Outputformat = 'outputformat',
  /** column name */
  Request = 'request',
  /** column name */
  Service = 'service',
  /** column name */
  Srsname = 'srsname',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "integracoes.sig_request_get_features" */
export type Integracoes_Sig_Request_Get_Features_Set_Input = {
  outputformat?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  srsname?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "integracoes_sig_request_get_features" */
export type Integracoes_Sig_Request_Get_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Integracoes_Sig_Request_Get_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Integracoes_Sig_Request_Get_Features_Stream_Cursor_Value_Input = {
  outputformat?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  srsname?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type Integracoes_Sig_Request_Get_Features_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Integracoes_Sig_Request_Get_Features_Set_Input>;
  /** filter the rows which have to be updated */
  where: Integracoes_Sig_Request_Get_Features_Bool_Exp;
};

/** columns and relationships of "integracoes.sig_services" */
export type Integracoes_Sig_Services = {
  __typename?: 'integracoes_sig_services';
  apagado: Scalars['Boolean']['output'];
  id: Scalars['bigint']['output'];
  id_type_data?: Maybe<Scalars['Int']['output']>;
  id_type_service?: Maybe<Scalars['bigint']['output']>;
  itemid?: Maybe<Scalars['bigint']['output']>;
  opacity?: Maybe<Scalars['bigint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  visibility_default: Scalars['Boolean']['output'];
};

/** aggregated selection of "integracoes.sig_services" */
export type Integracoes_Sig_Services_Aggregate = {
  __typename?: 'integracoes_sig_services_aggregate';
  aggregate?: Maybe<Integracoes_Sig_Services_Aggregate_Fields>;
  nodes: Array<Integracoes_Sig_Services>;
};

/** aggregate fields of "integracoes.sig_services" */
export type Integracoes_Sig_Services_Aggregate_Fields = {
  __typename?: 'integracoes_sig_services_aggregate_fields';
  avg?: Maybe<Integracoes_Sig_Services_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Integracoes_Sig_Services_Max_Fields>;
  min?: Maybe<Integracoes_Sig_Services_Min_Fields>;
  stddev?: Maybe<Integracoes_Sig_Services_Stddev_Fields>;
  stddev_pop?: Maybe<Integracoes_Sig_Services_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Integracoes_Sig_Services_Stddev_Samp_Fields>;
  sum?: Maybe<Integracoes_Sig_Services_Sum_Fields>;
  var_pop?: Maybe<Integracoes_Sig_Services_Var_Pop_Fields>;
  var_samp?: Maybe<Integracoes_Sig_Services_Var_Samp_Fields>;
  variance?: Maybe<Integracoes_Sig_Services_Variance_Fields>;
};


/** aggregate fields of "integracoes.sig_services" */
export type Integracoes_Sig_Services_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Integracoes_Sig_Services_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Integracoes_Sig_Services_Avg_Fields = {
  __typename?: 'integracoes_sig_services_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_type_data?: Maybe<Scalars['Float']['output']>;
  id_type_service?: Maybe<Scalars['Float']['output']>;
  itemid?: Maybe<Scalars['Float']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "integracoes.sig_services". All fields are combined with a logical 'AND'. */
export type Integracoes_Sig_Services_Bool_Exp = {
  _and?: InputMaybe<Array<Integracoes_Sig_Services_Bool_Exp>>;
  _not?: InputMaybe<Integracoes_Sig_Services_Bool_Exp>;
  _or?: InputMaybe<Array<Integracoes_Sig_Services_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_type_data?: InputMaybe<Int_Comparison_Exp>;
  id_type_service?: InputMaybe<Bigint_Comparison_Exp>;
  itemid?: InputMaybe<Bigint_Comparison_Exp>;
  opacity?: InputMaybe<Bigint_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  visibility_default?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "integracoes.sig_services" */
export enum Integracoes_Sig_Services_Constraint {
  /** unique or primary key constraint on columns "id" */
  EsriServicesPkey = 'esri_services_pkey'
}

/** input type for incrementing numeric columns in table "integracoes.sig_services" */
export type Integracoes_Sig_Services_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_type_data?: InputMaybe<Scalars['Int']['input']>;
  id_type_service?: InputMaybe<Scalars['bigint']['input']>;
  itemid?: InputMaybe<Scalars['bigint']['input']>;
  opacity?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "integracoes.sig_services" */
export type Integracoes_Sig_Services_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_type_data?: InputMaybe<Scalars['Int']['input']>;
  id_type_service?: InputMaybe<Scalars['bigint']['input']>;
  itemid?: InputMaybe<Scalars['bigint']['input']>;
  opacity?: InputMaybe<Scalars['bigint']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  visibility_default?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Integracoes_Sig_Services_Max_Fields = {
  __typename?: 'integracoes_sig_services_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_type_data?: Maybe<Scalars['Int']['output']>;
  id_type_service?: Maybe<Scalars['bigint']['output']>;
  itemid?: Maybe<Scalars['bigint']['output']>;
  opacity?: Maybe<Scalars['bigint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Integracoes_Sig_Services_Min_Fields = {
  __typename?: 'integracoes_sig_services_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_type_data?: Maybe<Scalars['Int']['output']>;
  id_type_service?: Maybe<Scalars['bigint']['output']>;
  itemid?: Maybe<Scalars['bigint']['output']>;
  opacity?: Maybe<Scalars['bigint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "integracoes.sig_services" */
export type Integracoes_Sig_Services_Mutation_Response = {
  __typename?: 'integracoes_sig_services_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Integracoes_Sig_Services>;
};

/** on_conflict condition type for table "integracoes.sig_services" */
export type Integracoes_Sig_Services_On_Conflict = {
  constraint: Integracoes_Sig_Services_Constraint;
  update_columns?: Array<Integracoes_Sig_Services_Update_Column>;
  where?: InputMaybe<Integracoes_Sig_Services_Bool_Exp>;
};

/** Ordering options when selecting data from "integracoes.sig_services". */
export type Integracoes_Sig_Services_Order_By = {
  apagado?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_type_data?: InputMaybe<Order_By>;
  id_type_service?: InputMaybe<Order_By>;
  itemid?: InputMaybe<Order_By>;
  opacity?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  visibility_default?: InputMaybe<Order_By>;
};

/** primary key columns input for table: integracoes.sig_services */
export type Integracoes_Sig_Services_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "integracoes.sig_services" */
export enum Integracoes_Sig_Services_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Id = 'id',
  /** column name */
  IdTypeData = 'id_type_data',
  /** column name */
  IdTypeService = 'id_type_service',
  /** column name */
  Itemid = 'itemid',
  /** column name */
  Opacity = 'opacity',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url',
  /** column name */
  VisibilityDefault = 'visibility_default'
}

/** input type for updating data in table "integracoes.sig_services" */
export type Integracoes_Sig_Services_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_type_data?: InputMaybe<Scalars['Int']['input']>;
  id_type_service?: InputMaybe<Scalars['bigint']['input']>;
  itemid?: InputMaybe<Scalars['bigint']['input']>;
  opacity?: InputMaybe<Scalars['bigint']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  visibility_default?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Integracoes_Sig_Services_Stddev_Fields = {
  __typename?: 'integracoes_sig_services_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_type_data?: Maybe<Scalars['Float']['output']>;
  id_type_service?: Maybe<Scalars['Float']['output']>;
  itemid?: Maybe<Scalars['Float']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Integracoes_Sig_Services_Stddev_Pop_Fields = {
  __typename?: 'integracoes_sig_services_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_type_data?: Maybe<Scalars['Float']['output']>;
  id_type_service?: Maybe<Scalars['Float']['output']>;
  itemid?: Maybe<Scalars['Float']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Integracoes_Sig_Services_Stddev_Samp_Fields = {
  __typename?: 'integracoes_sig_services_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_type_data?: Maybe<Scalars['Float']['output']>;
  id_type_service?: Maybe<Scalars['Float']['output']>;
  itemid?: Maybe<Scalars['Float']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "integracoes_sig_services" */
export type Integracoes_Sig_Services_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Integracoes_Sig_Services_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Integracoes_Sig_Services_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_type_data?: InputMaybe<Scalars['Int']['input']>;
  id_type_service?: InputMaybe<Scalars['bigint']['input']>;
  itemid?: InputMaybe<Scalars['bigint']['input']>;
  opacity?: InputMaybe<Scalars['bigint']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  visibility_default?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Integracoes_Sig_Services_Sum_Fields = {
  __typename?: 'integracoes_sig_services_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_type_data?: Maybe<Scalars['Int']['output']>;
  id_type_service?: Maybe<Scalars['bigint']['output']>;
  itemid?: Maybe<Scalars['bigint']['output']>;
  opacity?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "integracoes.sig_services" */
export enum Integracoes_Sig_Services_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Id = 'id',
  /** column name */
  IdTypeData = 'id_type_data',
  /** column name */
  IdTypeService = 'id_type_service',
  /** column name */
  Itemid = 'itemid',
  /** column name */
  Opacity = 'opacity',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url',
  /** column name */
  VisibilityDefault = 'visibility_default'
}

export type Integracoes_Sig_Services_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Integracoes_Sig_Services_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Integracoes_Sig_Services_Set_Input>;
  /** filter the rows which have to be updated */
  where: Integracoes_Sig_Services_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Integracoes_Sig_Services_Var_Pop_Fields = {
  __typename?: 'integracoes_sig_services_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_type_data?: Maybe<Scalars['Float']['output']>;
  id_type_service?: Maybe<Scalars['Float']['output']>;
  itemid?: Maybe<Scalars['Float']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Integracoes_Sig_Services_Var_Samp_Fields = {
  __typename?: 'integracoes_sig_services_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_type_data?: Maybe<Scalars['Float']['output']>;
  id_type_service?: Maybe<Scalars['Float']['output']>;
  itemid?: Maybe<Scalars['Float']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Integracoes_Sig_Services_Variance_Fields = {
  __typename?: 'integracoes_sig_services_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_type_data?: Maybe<Scalars['Float']['output']>;
  id_type_service?: Maybe<Scalars['Float']['output']>;
  itemid?: Maybe<Scalars['Float']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** leak_recurrence_vs_rehabilitationNative Query Arguments */
export type Leak_Recurrence_Vs_Rehabilitation_Arguments = {
  endDate: Scalars['timestamptz']['input'];
  startDate: Scalars['timestamptz']['input'];
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

export type Leak_Recurrence_Vs_Rehabilitation_Model = {
  __typename?: 'leak_recurrence_vs_rehabilitation_model';
  failure_recurrence_rate: Scalars['float8']['output'];
  leak_interv_count: Scalars['Int']['output'];
  pipes_count: Scalars['Int']['output'];
  pipes_with_more_than_1: Scalars['Int']['output'];
  rehabilitation_interv_count: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the logical model for "leak_recurrence_vs_rehabilitation_model". All fields are combined with a logical 'AND'. */
export type Leak_Recurrence_Vs_Rehabilitation_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Leak_Recurrence_Vs_Rehabilitation_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Leak_Recurrence_Vs_Rehabilitation_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Leak_Recurrence_Vs_Rehabilitation_Model_Bool_Exp_Bool_Exp>>;
  failure_recurrence_rate?: InputMaybe<Float8_Comparison_Exp>;
  leak_interv_count?: InputMaybe<Int_Comparison_Exp>;
  pipes_count?: InputMaybe<Int_Comparison_Exp>;
  pipes_with_more_than_1?: InputMaybe<Int_Comparison_Exp>;
  rehabilitation_interv_count?: InputMaybe<Int_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

export enum Leak_Recurrence_Vs_Rehabilitation_Model_Enum_Name {
  /** column name */
  FailureRecurrenceRate = 'failure_recurrence_rate',
  /** column name */
  LeakIntervCount = 'leak_interv_count',
  /** column name */
  PipesCount = 'pipes_count',
  /** column name */
  PipesWithMoreThan_1 = 'pipes_with_more_than_1',
  /** column name */
  RehabilitationIntervCount = 'rehabilitation_interv_count',
  /** column name */
  Year = 'year'
}

/** Ordering options when selecting data from "leak_recurrence_vs_rehabilitation_model". */
export type Leak_Recurrence_Vs_Rehabilitation_Model_Order_By = {
  failure_recurrence_rate?: InputMaybe<Order_By>;
  leak_interv_count?: InputMaybe<Order_By>;
  pipes_count?: InputMaybe<Order_By>;
  pipes_with_more_than_1?: InputMaybe<Order_By>;
  rehabilitation_interv_count?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** leaks_per_distanceNative Query Arguments */
export type Leaks_Per_Distance_Arguments = {
  endDate: Scalars['timestamptz']['input'];
  startDate: Scalars['timestamptz']['input'];
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

export type Leaks_Per_Distance_Model = {
  __typename?: 'leaks_per_distance_model';
  interv_count: Scalars['numeric']['output'];
  leaks_per_distance: Scalars['numeric']['output'];
  length_sum: Scalars['numeric']['output'];
  multiplier: Scalars['numeric']['output'];
  unit: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the logical model for "leaks_per_distance_model". All fields are combined with a logical 'AND'. */
export type Leaks_Per_Distance_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Leaks_Per_Distance_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Leaks_Per_Distance_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Leaks_Per_Distance_Model_Bool_Exp_Bool_Exp>>;
  interv_count?: InputMaybe<Numeric_Comparison_Exp>;
  leaks_per_distance?: InputMaybe<Numeric_Comparison_Exp>;
  length_sum?: InputMaybe<Numeric_Comparison_Exp>;
  multiplier?: InputMaybe<Numeric_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
};

export enum Leaks_Per_Distance_Model_Enum_Name {
  /** column name */
  IntervCount = 'interv_count',
  /** column name */
  LeaksPerDistance = 'leaks_per_distance',
  /** column name */
  LengthSum = 'length_sum',
  /** column name */
  Multiplier = 'multiplier',
  /** column name */
  Unit = 'unit'
}

/** Ordering options when selecting data from "leaks_per_distance_model". */
export type Leaks_Per_Distance_Model_Order_By = {
  interv_count?: InputMaybe<Order_By>;
  leaks_per_distance?: InputMaybe<Order_By>;
  length_sum?: InputMaybe<Order_By>;
  multiplier?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
};

/** columns and relationships of "mensagens.anexos" */
export type Mensagens_Anexos = {
  __typename?: 'mensagens_anexos';
  descricao?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  id_file?: Maybe<Scalars['bigint']['output']>;
  id_mensagem?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "mensagens.anexos" */
export type Mensagens_Anexos_Aggregate = {
  __typename?: 'mensagens_anexos_aggregate';
  aggregate?: Maybe<Mensagens_Anexos_Aggregate_Fields>;
  nodes: Array<Mensagens_Anexos>;
};

/** aggregate fields of "mensagens.anexos" */
export type Mensagens_Anexos_Aggregate_Fields = {
  __typename?: 'mensagens_anexos_aggregate_fields';
  avg?: Maybe<Mensagens_Anexos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mensagens_Anexos_Max_Fields>;
  min?: Maybe<Mensagens_Anexos_Min_Fields>;
  stddev?: Maybe<Mensagens_Anexos_Stddev_Fields>;
  stddev_pop?: Maybe<Mensagens_Anexos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mensagens_Anexos_Stddev_Samp_Fields>;
  sum?: Maybe<Mensagens_Anexos_Sum_Fields>;
  var_pop?: Maybe<Mensagens_Anexos_Var_Pop_Fields>;
  var_samp?: Maybe<Mensagens_Anexos_Var_Samp_Fields>;
  variance?: Maybe<Mensagens_Anexos_Variance_Fields>;
};


/** aggregate fields of "mensagens.anexos" */
export type Mensagens_Anexos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mensagens_Anexos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mensagens_Anexos_Avg_Fields = {
  __typename?: 'mensagens_anexos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_file?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mensagens.anexos". All fields are combined with a logical 'AND'. */
export type Mensagens_Anexos_Bool_Exp = {
  _and?: InputMaybe<Array<Mensagens_Anexos_Bool_Exp>>;
  _not?: InputMaybe<Mensagens_Anexos_Bool_Exp>;
  _or?: InputMaybe<Array<Mensagens_Anexos_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  file_path?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_file?: InputMaybe<Bigint_Comparison_Exp>;
  id_mensagem?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "mensagens.anexos" */
export enum Mensagens_Anexos_Constraint {
  /** unique or primary key constraint on columns "id" */
  AnexosPkey = 'anexos_pkey'
}

/** input type for incrementing numeric columns in table "mensagens.anexos" */
export type Mensagens_Anexos_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_file?: InputMaybe<Scalars['bigint']['input']>;
  id_mensagem?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "mensagens.anexos" */
export type Mensagens_Anexos_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_file?: InputMaybe<Scalars['bigint']['input']>;
  id_mensagem?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Mensagens_Anexos_Max_Fields = {
  __typename?: 'mensagens_anexos_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_file?: Maybe<Scalars['bigint']['output']>;
  id_mensagem?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Mensagens_Anexos_Min_Fields = {
  __typename?: 'mensagens_anexos_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_file?: Maybe<Scalars['bigint']['output']>;
  id_mensagem?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "mensagens.anexos" */
export type Mensagens_Anexos_Mutation_Response = {
  __typename?: 'mensagens_anexos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mensagens_Anexos>;
};

/** on_conflict condition type for table "mensagens.anexos" */
export type Mensagens_Anexos_On_Conflict = {
  constraint: Mensagens_Anexos_Constraint;
  update_columns?: Array<Mensagens_Anexos_Update_Column>;
  where?: InputMaybe<Mensagens_Anexos_Bool_Exp>;
};

/** Ordering options when selecting data from "mensagens.anexos". */
export type Mensagens_Anexos_Order_By = {
  descricao?: InputMaybe<Order_By>;
  file_path?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_file?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mensagens.anexos */
export type Mensagens_Anexos_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "mensagens.anexos" */
export enum Mensagens_Anexos_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  FilePath = 'file_path',
  /** column name */
  Id = 'id',
  /** column name */
  IdFile = 'id_file',
  /** column name */
  IdMensagem = 'id_mensagem'
}

/** input type for updating data in table "mensagens.anexos" */
export type Mensagens_Anexos_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_file?: InputMaybe<Scalars['bigint']['input']>;
  id_mensagem?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Mensagens_Anexos_Stddev_Fields = {
  __typename?: 'mensagens_anexos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_file?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mensagens_Anexos_Stddev_Pop_Fields = {
  __typename?: 'mensagens_anexos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_file?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mensagens_Anexos_Stddev_Samp_Fields = {
  __typename?: 'mensagens_anexos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_file?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mensagens_anexos" */
export type Mensagens_Anexos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mensagens_Anexos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mensagens_Anexos_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  file_path?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_file?: InputMaybe<Scalars['bigint']['input']>;
  id_mensagem?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Mensagens_Anexos_Sum_Fields = {
  __typename?: 'mensagens_anexos_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_file?: Maybe<Scalars['bigint']['output']>;
  id_mensagem?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "mensagens.anexos" */
export enum Mensagens_Anexos_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  FilePath = 'file_path',
  /** column name */
  Id = 'id',
  /** column name */
  IdFile = 'id_file',
  /** column name */
  IdMensagem = 'id_mensagem'
}

export type Mensagens_Anexos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mensagens_Anexos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mensagens_Anexos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mensagens_Anexos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mensagens_Anexos_Var_Pop_Fields = {
  __typename?: 'mensagens_anexos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_file?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mensagens_Anexos_Var_Samp_Fields = {
  __typename?: 'mensagens_anexos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_file?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mensagens_Anexos_Variance_Fields = {
  __typename?: 'mensagens_anexos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_file?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mensagens.mensagens" */
export type Mensagens_Mensagens = {
  __typename?: 'mensagens_mensagens';
  apagada_sent?: Maybe<Scalars['Boolean']['output']>;
  assunto?: Maybe<Scalars['String']['output']>;
  corpo?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['timestamp']['output']>;
  /** Campo auxiliar com o nome dos destinatarios */
  destinatario?: Maybe<Scalars['String']['output']>;
  enviada_mail?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  id_ocorrencia_naviacity?: Maybe<Scalars['bigint']['output']>;
  id_remetente?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  posts: Array<Mensagens_Post>;
  /** An aggregate relationship */
  posts_aggregate: Mensagens_Post_Aggregate;
  /** An object relationship */
  remetente?: Maybe<Utilizadores_Utilizadores>;
};


/** columns and relationships of "mensagens.mensagens" */
export type Mensagens_MensagensPostsArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Post_Order_By>>;
  where?: InputMaybe<Mensagens_Post_Bool_Exp>;
};


/** columns and relationships of "mensagens.mensagens" */
export type Mensagens_MensagensPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Post_Order_By>>;
  where?: InputMaybe<Mensagens_Post_Bool_Exp>;
};

/** aggregated selection of "mensagens.mensagens" */
export type Mensagens_Mensagens_Aggregate = {
  __typename?: 'mensagens_mensagens_aggregate';
  aggregate?: Maybe<Mensagens_Mensagens_Aggregate_Fields>;
  nodes: Array<Mensagens_Mensagens>;
};

/** aggregate fields of "mensagens.mensagens" */
export type Mensagens_Mensagens_Aggregate_Fields = {
  __typename?: 'mensagens_mensagens_aggregate_fields';
  avg?: Maybe<Mensagens_Mensagens_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mensagens_Mensagens_Max_Fields>;
  min?: Maybe<Mensagens_Mensagens_Min_Fields>;
  stddev?: Maybe<Mensagens_Mensagens_Stddev_Fields>;
  stddev_pop?: Maybe<Mensagens_Mensagens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mensagens_Mensagens_Stddev_Samp_Fields>;
  sum?: Maybe<Mensagens_Mensagens_Sum_Fields>;
  var_pop?: Maybe<Mensagens_Mensagens_Var_Pop_Fields>;
  var_samp?: Maybe<Mensagens_Mensagens_Var_Samp_Fields>;
  variance?: Maybe<Mensagens_Mensagens_Variance_Fields>;
};


/** aggregate fields of "mensagens.mensagens" */
export type Mensagens_Mensagens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mensagens_Mensagens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mensagens_Mensagens_Avg_Fields = {
  __typename?: 'mensagens_mensagens_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_remetente?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mensagens.mensagens". All fields are combined with a logical 'AND'. */
export type Mensagens_Mensagens_Bool_Exp = {
  _and?: InputMaybe<Array<Mensagens_Mensagens_Bool_Exp>>;
  _not?: InputMaybe<Mensagens_Mensagens_Bool_Exp>;
  _or?: InputMaybe<Array<Mensagens_Mensagens_Bool_Exp>>;
  apagada_sent?: InputMaybe<Boolean_Comparison_Exp>;
  assunto?: InputMaybe<String_Comparison_Exp>;
  corpo?: InputMaybe<String_Comparison_Exp>;
  data?: InputMaybe<Timestamp_Comparison_Exp>;
  destinatario?: InputMaybe<String_Comparison_Exp>;
  enviada_mail?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_ocorrencia_naviacity?: InputMaybe<Bigint_Comparison_Exp>;
  id_remetente?: InputMaybe<Bigint_Comparison_Exp>;
  posts?: InputMaybe<Mensagens_Post_Bool_Exp>;
  posts_aggregate?: InputMaybe<Mensagens_Post_Aggregate_Bool_Exp>;
  remetente?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
};

/** unique or primary key constraints on table "mensagens.mensagens" */
export enum Mensagens_Mensagens_Constraint {
  /** unique or primary key constraint on columns "id" */
  MensagensPkey = 'mensagens_pkey'
}

/** input type for incrementing numeric columns in table "mensagens.mensagens" */
export type Mensagens_Mensagens_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia_naviacity?: InputMaybe<Scalars['bigint']['input']>;
  id_remetente?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "mensagens.mensagens" */
export type Mensagens_Mensagens_Insert_Input = {
  apagada_sent?: InputMaybe<Scalars['Boolean']['input']>;
  assunto?: InputMaybe<Scalars['String']['input']>;
  corpo?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['timestamp']['input']>;
  /** Campo auxiliar com o nome dos destinatarios */
  destinatario?: InputMaybe<Scalars['String']['input']>;
  enviada_mail?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia_naviacity?: InputMaybe<Scalars['bigint']['input']>;
  id_remetente?: InputMaybe<Scalars['bigint']['input']>;
  posts?: InputMaybe<Mensagens_Post_Arr_Rel_Insert_Input>;
  remetente?: InputMaybe<Utilizadores_Utilizadores_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Mensagens_Mensagens_Max_Fields = {
  __typename?: 'mensagens_mensagens_max_fields';
  assunto?: Maybe<Scalars['String']['output']>;
  corpo?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['timestamp']['output']>;
  /** Campo auxiliar com o nome dos destinatarios */
  destinatario?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['bigint']['output']>;
  id_remetente?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Mensagens_Mensagens_Min_Fields = {
  __typename?: 'mensagens_mensagens_min_fields';
  assunto?: Maybe<Scalars['String']['output']>;
  corpo?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['timestamp']['output']>;
  /** Campo auxiliar com o nome dos destinatarios */
  destinatario?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['bigint']['output']>;
  id_remetente?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "mensagens.mensagens" */
export type Mensagens_Mensagens_Mutation_Response = {
  __typename?: 'mensagens_mensagens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mensagens_Mensagens>;
};

/** input type for inserting object relation for remote table "mensagens.mensagens" */
export type Mensagens_Mensagens_Obj_Rel_Insert_Input = {
  data: Mensagens_Mensagens_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mensagens_Mensagens_On_Conflict>;
};

/** on_conflict condition type for table "mensagens.mensagens" */
export type Mensagens_Mensagens_On_Conflict = {
  constraint: Mensagens_Mensagens_Constraint;
  update_columns?: Array<Mensagens_Mensagens_Update_Column>;
  where?: InputMaybe<Mensagens_Mensagens_Bool_Exp>;
};

/** Ordering options when selecting data from "mensagens.mensagens". */
export type Mensagens_Mensagens_Order_By = {
  apagada_sent?: InputMaybe<Order_By>;
  assunto?: InputMaybe<Order_By>;
  corpo?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  destinatario?: InputMaybe<Order_By>;
  enviada_mail?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ocorrencia_naviacity?: InputMaybe<Order_By>;
  id_remetente?: InputMaybe<Order_By>;
  posts_aggregate?: InputMaybe<Mensagens_Post_Aggregate_Order_By>;
  remetente?: InputMaybe<Utilizadores_Utilizadores_Order_By>;
};

/** primary key columns input for table: mensagens.mensagens */
export type Mensagens_Mensagens_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "mensagens.mensagens" */
export enum Mensagens_Mensagens_Select_Column {
  /** column name */
  ApagadaSent = 'apagada_sent',
  /** column name */
  Assunto = 'assunto',
  /** column name */
  Corpo = 'corpo',
  /** column name */
  Data = 'data',
  /** column name */
  Destinatario = 'destinatario',
  /** column name */
  EnviadaMail = 'enviada_mail',
  /** column name */
  Id = 'id',
  /** column name */
  IdOcorrenciaNaviacity = 'id_ocorrencia_naviacity',
  /** column name */
  IdRemetente = 'id_remetente'
}

/** input type for updating data in table "mensagens.mensagens" */
export type Mensagens_Mensagens_Set_Input = {
  apagada_sent?: InputMaybe<Scalars['Boolean']['input']>;
  assunto?: InputMaybe<Scalars['String']['input']>;
  corpo?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['timestamp']['input']>;
  /** Campo auxiliar com o nome dos destinatarios */
  destinatario?: InputMaybe<Scalars['String']['input']>;
  enviada_mail?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia_naviacity?: InputMaybe<Scalars['bigint']['input']>;
  id_remetente?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Mensagens_Mensagens_Stddev_Fields = {
  __typename?: 'mensagens_mensagens_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_remetente?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mensagens_Mensagens_Stddev_Pop_Fields = {
  __typename?: 'mensagens_mensagens_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_remetente?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mensagens_Mensagens_Stddev_Samp_Fields = {
  __typename?: 'mensagens_mensagens_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_remetente?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mensagens_mensagens" */
export type Mensagens_Mensagens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mensagens_Mensagens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mensagens_Mensagens_Stream_Cursor_Value_Input = {
  apagada_sent?: InputMaybe<Scalars['Boolean']['input']>;
  assunto?: InputMaybe<Scalars['String']['input']>;
  corpo?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['timestamp']['input']>;
  /** Campo auxiliar com o nome dos destinatarios */
  destinatario?: InputMaybe<Scalars['String']['input']>;
  enviada_mail?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia_naviacity?: InputMaybe<Scalars['bigint']['input']>;
  id_remetente?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Mensagens_Mensagens_Sum_Fields = {
  __typename?: 'mensagens_mensagens_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['bigint']['output']>;
  id_remetente?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "mensagens.mensagens" */
export enum Mensagens_Mensagens_Update_Column {
  /** column name */
  ApagadaSent = 'apagada_sent',
  /** column name */
  Assunto = 'assunto',
  /** column name */
  Corpo = 'corpo',
  /** column name */
  Data = 'data',
  /** column name */
  Destinatario = 'destinatario',
  /** column name */
  EnviadaMail = 'enviada_mail',
  /** column name */
  Id = 'id',
  /** column name */
  IdOcorrenciaNaviacity = 'id_ocorrencia_naviacity',
  /** column name */
  IdRemetente = 'id_remetente'
}

export type Mensagens_Mensagens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mensagens_Mensagens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mensagens_Mensagens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mensagens_Mensagens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mensagens_Mensagens_Var_Pop_Fields = {
  __typename?: 'mensagens_mensagens_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_remetente?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mensagens_Mensagens_Var_Samp_Fields = {
  __typename?: 'mensagens_mensagens_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_remetente?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mensagens_Mensagens_Variance_Fields = {
  __typename?: 'mensagens_mensagens_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_remetente?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mensagens.post" */
export type Mensagens_Post = {
  __typename?: 'mensagens_post';
  apagada?: Maybe<Scalars['Boolean']['output']>;
  apagada_trash?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  destinatario?: Maybe<Utilizadores_Utilizadores>;
  id: Scalars['bigint']['output'];
  id_destinatario?: Maybe<Scalars['bigint']['output']>;
  id_mensagem?: Maybe<Scalars['bigint']['output']>;
  lida?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  mensagem?: Maybe<Mensagens_Mensagens>;
  nova?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "mensagens.post" */
export type Mensagens_Post_Aggregate = {
  __typename?: 'mensagens_post_aggregate';
  aggregate?: Maybe<Mensagens_Post_Aggregate_Fields>;
  nodes: Array<Mensagens_Post>;
};

export type Mensagens_Post_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Mensagens_Post_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Mensagens_Post_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Mensagens_Post_Aggregate_Bool_Exp_Count>;
};

export type Mensagens_Post_Aggregate_Bool_Exp_Bool_And = {
  arguments: Mensagens_Post_Select_Column_Mensagens_Post_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mensagens_Post_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mensagens_Post_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Mensagens_Post_Select_Column_Mensagens_Post_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mensagens_Post_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mensagens_Post_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mensagens_Post_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mensagens_Post_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mensagens.post" */
export type Mensagens_Post_Aggregate_Fields = {
  __typename?: 'mensagens_post_aggregate_fields';
  avg?: Maybe<Mensagens_Post_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mensagens_Post_Max_Fields>;
  min?: Maybe<Mensagens_Post_Min_Fields>;
  stddev?: Maybe<Mensagens_Post_Stddev_Fields>;
  stddev_pop?: Maybe<Mensagens_Post_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mensagens_Post_Stddev_Samp_Fields>;
  sum?: Maybe<Mensagens_Post_Sum_Fields>;
  var_pop?: Maybe<Mensagens_Post_Var_Pop_Fields>;
  var_samp?: Maybe<Mensagens_Post_Var_Samp_Fields>;
  variance?: Maybe<Mensagens_Post_Variance_Fields>;
};


/** aggregate fields of "mensagens.post" */
export type Mensagens_Post_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mensagens_Post_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mensagens.post" */
export type Mensagens_Post_Aggregate_Order_By = {
  avg?: InputMaybe<Mensagens_Post_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mensagens_Post_Max_Order_By>;
  min?: InputMaybe<Mensagens_Post_Min_Order_By>;
  stddev?: InputMaybe<Mensagens_Post_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mensagens_Post_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mensagens_Post_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mensagens_Post_Sum_Order_By>;
  var_pop?: InputMaybe<Mensagens_Post_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mensagens_Post_Var_Samp_Order_By>;
  variance?: InputMaybe<Mensagens_Post_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mensagens.post" */
export type Mensagens_Post_Arr_Rel_Insert_Input = {
  data: Array<Mensagens_Post_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mensagens_Post_On_Conflict>;
};

/** aggregate avg on columns */
export type Mensagens_Post_Avg_Fields = {
  __typename?: 'mensagens_post_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_destinatario?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mensagens.post" */
export type Mensagens_Post_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_destinatario?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mensagens.post". All fields are combined with a logical 'AND'. */
export type Mensagens_Post_Bool_Exp = {
  _and?: InputMaybe<Array<Mensagens_Post_Bool_Exp>>;
  _not?: InputMaybe<Mensagens_Post_Bool_Exp>;
  _or?: InputMaybe<Array<Mensagens_Post_Bool_Exp>>;
  apagada?: InputMaybe<Boolean_Comparison_Exp>;
  apagada_trash?: InputMaybe<Boolean_Comparison_Exp>;
  destinatario?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_destinatario?: InputMaybe<Bigint_Comparison_Exp>;
  id_mensagem?: InputMaybe<Bigint_Comparison_Exp>;
  lida?: InputMaybe<Boolean_Comparison_Exp>;
  mensagem?: InputMaybe<Mensagens_Mensagens_Bool_Exp>;
  nova?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "mensagens.post" */
export enum Mensagens_Post_Constraint {
  /** unique or primary key constraint on columns "id" */
  PostPkey = 'post_pkey'
}

/** input type for incrementing numeric columns in table "mensagens.post" */
export type Mensagens_Post_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_destinatario?: InputMaybe<Scalars['bigint']['input']>;
  id_mensagem?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "mensagens.post" */
export type Mensagens_Post_Insert_Input = {
  apagada?: InputMaybe<Scalars['Boolean']['input']>;
  apagada_trash?: InputMaybe<Scalars['Boolean']['input']>;
  destinatario?: InputMaybe<Utilizadores_Utilizadores_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_destinatario?: InputMaybe<Scalars['bigint']['input']>;
  id_mensagem?: InputMaybe<Scalars['bigint']['input']>;
  lida?: InputMaybe<Scalars['Boolean']['input']>;
  mensagem?: InputMaybe<Mensagens_Mensagens_Obj_Rel_Insert_Input>;
  nova?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Mensagens_Post_Max_Fields = {
  __typename?: 'mensagens_post_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_destinatario?: Maybe<Scalars['bigint']['output']>;
  id_mensagem?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "mensagens.post" */
export type Mensagens_Post_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_destinatario?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mensagens_Post_Min_Fields = {
  __typename?: 'mensagens_post_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_destinatario?: Maybe<Scalars['bigint']['output']>;
  id_mensagem?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "mensagens.post" */
export type Mensagens_Post_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_destinatario?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mensagens.post" */
export type Mensagens_Post_Mutation_Response = {
  __typename?: 'mensagens_post_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mensagens_Post>;
};

/** on_conflict condition type for table "mensagens.post" */
export type Mensagens_Post_On_Conflict = {
  constraint: Mensagens_Post_Constraint;
  update_columns?: Array<Mensagens_Post_Update_Column>;
  where?: InputMaybe<Mensagens_Post_Bool_Exp>;
};

/** Ordering options when selecting data from "mensagens.post". */
export type Mensagens_Post_Order_By = {
  apagada?: InputMaybe<Order_By>;
  apagada_trash?: InputMaybe<Order_By>;
  destinatario?: InputMaybe<Utilizadores_Utilizadores_Order_By>;
  id?: InputMaybe<Order_By>;
  id_destinatario?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
  lida?: InputMaybe<Order_By>;
  mensagem?: InputMaybe<Mensagens_Mensagens_Order_By>;
  nova?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mensagens.post */
export type Mensagens_Post_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "mensagens.post" */
export enum Mensagens_Post_Select_Column {
  /** column name */
  Apagada = 'apagada',
  /** column name */
  ApagadaTrash = 'apagada_trash',
  /** column name */
  Id = 'id',
  /** column name */
  IdDestinatario = 'id_destinatario',
  /** column name */
  IdMensagem = 'id_mensagem',
  /** column name */
  Lida = 'lida',
  /** column name */
  Nova = 'nova'
}

/** select "mensagens_post_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mensagens.post" */
export enum Mensagens_Post_Select_Column_Mensagens_Post_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagada = 'apagada',
  /** column name */
  ApagadaTrash = 'apagada_trash',
  /** column name */
  Lida = 'lida',
  /** column name */
  Nova = 'nova'
}

/** select "mensagens_post_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mensagens.post" */
export enum Mensagens_Post_Select_Column_Mensagens_Post_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagada = 'apagada',
  /** column name */
  ApagadaTrash = 'apagada_trash',
  /** column name */
  Lida = 'lida',
  /** column name */
  Nova = 'nova'
}

/** input type for updating data in table "mensagens.post" */
export type Mensagens_Post_Set_Input = {
  apagada?: InputMaybe<Scalars['Boolean']['input']>;
  apagada_trash?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_destinatario?: InputMaybe<Scalars['bigint']['input']>;
  id_mensagem?: InputMaybe<Scalars['bigint']['input']>;
  lida?: InputMaybe<Scalars['Boolean']['input']>;
  nova?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Mensagens_Post_Stddev_Fields = {
  __typename?: 'mensagens_post_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_destinatario?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mensagens.post" */
export type Mensagens_Post_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_destinatario?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mensagens_Post_Stddev_Pop_Fields = {
  __typename?: 'mensagens_post_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_destinatario?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mensagens.post" */
export type Mensagens_Post_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_destinatario?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mensagens_Post_Stddev_Samp_Fields = {
  __typename?: 'mensagens_post_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_destinatario?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mensagens.post" */
export type Mensagens_Post_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_destinatario?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mensagens_post" */
export type Mensagens_Post_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mensagens_Post_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mensagens_Post_Stream_Cursor_Value_Input = {
  apagada?: InputMaybe<Scalars['Boolean']['input']>;
  apagada_trash?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_destinatario?: InputMaybe<Scalars['bigint']['input']>;
  id_mensagem?: InputMaybe<Scalars['bigint']['input']>;
  lida?: InputMaybe<Scalars['Boolean']['input']>;
  nova?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Mensagens_Post_Sum_Fields = {
  __typename?: 'mensagens_post_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_destinatario?: Maybe<Scalars['bigint']['output']>;
  id_mensagem?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "mensagens.post" */
export type Mensagens_Post_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_destinatario?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
};

/** update columns of table "mensagens.post" */
export enum Mensagens_Post_Update_Column {
  /** column name */
  Apagada = 'apagada',
  /** column name */
  ApagadaTrash = 'apagada_trash',
  /** column name */
  Id = 'id',
  /** column name */
  IdDestinatario = 'id_destinatario',
  /** column name */
  IdMensagem = 'id_mensagem',
  /** column name */
  Lida = 'lida',
  /** column name */
  Nova = 'nova'
}

export type Mensagens_Post_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mensagens_Post_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mensagens_Post_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mensagens_Post_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mensagens_Post_Var_Pop_Fields = {
  __typename?: 'mensagens_post_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_destinatario?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mensagens.post" */
export type Mensagens_Post_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_destinatario?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mensagens_Post_Var_Samp_Fields = {
  __typename?: 'mensagens_post_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_destinatario?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mensagens.post" */
export type Mensagens_Post_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_destinatario?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mensagens_Post_Variance_Fields = {
  __typename?: 'mensagens_post_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_destinatario?: Maybe<Scalars['Float']['output']>;
  id_mensagem?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mensagens.post" */
export type Mensagens_Post_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_destinatario?: InputMaybe<Order_By>;
  id_mensagem?: InputMaybe<Order_By>;
};

/** columns and relationships of "mobile.coordenadas" */
export type Mobile_Coordenadas = {
  __typename?: 'mobile_coordenadas';
  data_hora: Scalars['timestamp']['output'];
  distancia_validacao?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  id_arvore?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_horario?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_origem: Scalars['Int']['output'];
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id_veiculo?: Maybe<Scalars['bigint']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['numeric']['output'];
  longitude: Scalars['numeric']['output'];
  obs?: Maybe<Scalars['String']['output']>;
  precisao?: Maybe<Scalars['numeric']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  utilizador?: Maybe<Utilizadores_Utilizadores>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "mobile.coordenadas" */
export type Mobile_Coordenadas_Aggregate = {
  __typename?: 'mobile_coordenadas_aggregate';
  aggregate?: Maybe<Mobile_Coordenadas_Aggregate_Fields>;
  nodes: Array<Mobile_Coordenadas>;
};

export type Mobile_Coordenadas_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mobile_Coordenadas_Aggregate_Bool_Exp_Count>;
};

export type Mobile_Coordenadas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mobile_Coordenadas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mobile.coordenadas" */
export type Mobile_Coordenadas_Aggregate_Fields = {
  __typename?: 'mobile_coordenadas_aggregate_fields';
  avg?: Maybe<Mobile_Coordenadas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mobile_Coordenadas_Max_Fields>;
  min?: Maybe<Mobile_Coordenadas_Min_Fields>;
  stddev?: Maybe<Mobile_Coordenadas_Stddev_Fields>;
  stddev_pop?: Maybe<Mobile_Coordenadas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mobile_Coordenadas_Stddev_Samp_Fields>;
  sum?: Maybe<Mobile_Coordenadas_Sum_Fields>;
  var_pop?: Maybe<Mobile_Coordenadas_Var_Pop_Fields>;
  var_samp?: Maybe<Mobile_Coordenadas_Var_Samp_Fields>;
  variance?: Maybe<Mobile_Coordenadas_Variance_Fields>;
};


/** aggregate fields of "mobile.coordenadas" */
export type Mobile_Coordenadas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mobile_Coordenadas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mobile.coordenadas" */
export type Mobile_Coordenadas_Aggregate_Order_By = {
  avg?: InputMaybe<Mobile_Coordenadas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mobile_Coordenadas_Max_Order_By>;
  min?: InputMaybe<Mobile_Coordenadas_Min_Order_By>;
  stddev?: InputMaybe<Mobile_Coordenadas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mobile_Coordenadas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mobile_Coordenadas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mobile_Coordenadas_Sum_Order_By>;
  var_pop?: InputMaybe<Mobile_Coordenadas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mobile_Coordenadas_Var_Samp_Order_By>;
  variance?: InputMaybe<Mobile_Coordenadas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mobile.coordenadas" */
export type Mobile_Coordenadas_Arr_Rel_Insert_Input = {
  data: Array<Mobile_Coordenadas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mobile_Coordenadas_On_Conflict>;
};

/** aggregate avg on columns */
export type Mobile_Coordenadas_Avg_Fields = {
  __typename?: 'mobile_coordenadas_avg_fields';
  distancia_validacao?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_arvore?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_horario?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  precisao?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mobile.coordenadas" */
export type Mobile_Coordenadas_Avg_Order_By = {
  distancia_validacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_arvore?: InputMaybe<Order_By>;
  id_equipa_virtual_horario?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  precisao?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mobile.coordenadas". All fields are combined with a logical 'AND'. */
export type Mobile_Coordenadas_Bool_Exp = {
  _and?: InputMaybe<Array<Mobile_Coordenadas_Bool_Exp>>;
  _not?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
  _or?: InputMaybe<Array<Mobile_Coordenadas_Bool_Exp>>;
  data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  distancia_validacao?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_arvore?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual_horario?: InputMaybe<Bigint_Comparison_Exp>;
  id_intervencao?: InputMaybe<Bigint_Comparison_Exp>;
  id_origem?: InputMaybe<Int_Comparison_Exp>;
  id_requisicao?: InputMaybe<Bigint_Comparison_Exp>;
  id_tarefa?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  id_veiculo?: InputMaybe<Bigint_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
  obs?: InputMaybe<String_Comparison_Exp>;
  precisao?: InputMaybe<Numeric_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  utilizador?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mobile.coordenadas" */
export enum Mobile_Coordenadas_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoordenadasPkey = 'coordenadas_pkey'
}

/** input type for incrementing numeric columns in table "mobile.coordenadas" */
export type Mobile_Coordenadas_Inc_Input = {
  distancia_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_arvore?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_horario?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_origem?: InputMaybe<Scalars['Int']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  precisao?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "mobile.coordenadas" */
export type Mobile_Coordenadas_Insert_Input = {
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  distancia_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_arvore?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_horario?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_origem?: InputMaybe<Scalars['Int']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo?: InputMaybe<Scalars['bigint']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  precisao?: InputMaybe<Scalars['numeric']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  utilizador?: InputMaybe<Utilizadores_Utilizadores_Obj_Rel_Insert_Input>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mobile_Coordenadas_Max_Fields = {
  __typename?: 'mobile_coordenadas_max_fields';
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  distancia_validacao?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_arvore?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_horario?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_origem?: Maybe<Scalars['Int']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id_veiculo?: Maybe<Scalars['bigint']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  precisao?: Maybe<Scalars['numeric']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "mobile.coordenadas" */
export type Mobile_Coordenadas_Max_Order_By = {
  data_hora?: InputMaybe<Order_By>;
  distancia_validacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_arvore?: InputMaybe<Order_By>;
  id_equipa_virtual_horario?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  precisao?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mobile_Coordenadas_Min_Fields = {
  __typename?: 'mobile_coordenadas_min_fields';
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  distancia_validacao?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_arvore?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_horario?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_origem?: Maybe<Scalars['Int']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id_veiculo?: Maybe<Scalars['bigint']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  precisao?: Maybe<Scalars['numeric']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "mobile.coordenadas" */
export type Mobile_Coordenadas_Min_Order_By = {
  data_hora?: InputMaybe<Order_By>;
  distancia_validacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_arvore?: InputMaybe<Order_By>;
  id_equipa_virtual_horario?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  precisao?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mobile.coordenadas" */
export type Mobile_Coordenadas_Mutation_Response = {
  __typename?: 'mobile_coordenadas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mobile_Coordenadas>;
};

/** input type for inserting object relation for remote table "mobile.coordenadas" */
export type Mobile_Coordenadas_Obj_Rel_Insert_Input = {
  data: Mobile_Coordenadas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mobile_Coordenadas_On_Conflict>;
};

/** on_conflict condition type for table "mobile.coordenadas" */
export type Mobile_Coordenadas_On_Conflict = {
  constraint: Mobile_Coordenadas_Constraint;
  update_columns?: Array<Mobile_Coordenadas_Update_Column>;
  where?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
};

/** Ordering options when selecting data from "mobile.coordenadas". */
export type Mobile_Coordenadas_Order_By = {
  data_hora?: InputMaybe<Order_By>;
  distancia_validacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_arvore?: InputMaybe<Order_By>;
  id_equipa_virtual_horario?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  precisao?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  utilizador?: InputMaybe<Utilizadores_Utilizadores_Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mobile.coordenadas */
export type Mobile_Coordenadas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "mobile.coordenadas" */
export enum Mobile_Coordenadas_Select_Column {
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  DistanciaValidacao = 'distancia_validacao',
  /** column name */
  Id = 'id',
  /** column name */
  IdArvore = 'id_arvore',
  /** column name */
  IdEquipaVirtualHorario = 'id_equipa_virtual_horario',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdOrigem = 'id_origem',
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  IdTarefa = 'id_tarefa',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  IdVeiculo = 'id_veiculo',
  /** column name */
  Key = 'key',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Obs = 'obs',
  /** column name */
  Precisao = 'precisao',
  /** column name */
  Provider = 'provider',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "mobile.coordenadas" */
export type Mobile_Coordenadas_Set_Input = {
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  distancia_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_arvore?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_horario?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_origem?: InputMaybe<Scalars['Int']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo?: InputMaybe<Scalars['bigint']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  precisao?: InputMaybe<Scalars['numeric']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Mobile_Coordenadas_Stddev_Fields = {
  __typename?: 'mobile_coordenadas_stddev_fields';
  distancia_validacao?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_arvore?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_horario?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  precisao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mobile.coordenadas" */
export type Mobile_Coordenadas_Stddev_Order_By = {
  distancia_validacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_arvore?: InputMaybe<Order_By>;
  id_equipa_virtual_horario?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  precisao?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mobile_Coordenadas_Stddev_Pop_Fields = {
  __typename?: 'mobile_coordenadas_stddev_pop_fields';
  distancia_validacao?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_arvore?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_horario?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  precisao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mobile.coordenadas" */
export type Mobile_Coordenadas_Stddev_Pop_Order_By = {
  distancia_validacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_arvore?: InputMaybe<Order_By>;
  id_equipa_virtual_horario?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  precisao?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mobile_Coordenadas_Stddev_Samp_Fields = {
  __typename?: 'mobile_coordenadas_stddev_samp_fields';
  distancia_validacao?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_arvore?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_horario?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  precisao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mobile.coordenadas" */
export type Mobile_Coordenadas_Stddev_Samp_Order_By = {
  distancia_validacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_arvore?: InputMaybe<Order_By>;
  id_equipa_virtual_horario?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  precisao?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mobile_coordenadas" */
export type Mobile_Coordenadas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mobile_Coordenadas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mobile_Coordenadas_Stream_Cursor_Value_Input = {
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  distancia_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_arvore?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_horario?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_origem?: InputMaybe<Scalars['Int']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo?: InputMaybe<Scalars['bigint']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  precisao?: InputMaybe<Scalars['numeric']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Mobile_Coordenadas_Sum_Fields = {
  __typename?: 'mobile_coordenadas_sum_fields';
  distancia_validacao?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_arvore?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_horario?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_origem?: Maybe<Scalars['Int']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id_veiculo?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  precisao?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "mobile.coordenadas" */
export type Mobile_Coordenadas_Sum_Order_By = {
  distancia_validacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_arvore?: InputMaybe<Order_By>;
  id_equipa_virtual_horario?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  precisao?: InputMaybe<Order_By>;
};

/** update columns of table "mobile.coordenadas" */
export enum Mobile_Coordenadas_Update_Column {
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  DistanciaValidacao = 'distancia_validacao',
  /** column name */
  Id = 'id',
  /** column name */
  IdArvore = 'id_arvore',
  /** column name */
  IdEquipaVirtualHorario = 'id_equipa_virtual_horario',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdOrigem = 'id_origem',
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  IdTarefa = 'id_tarefa',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  IdVeiculo = 'id_veiculo',
  /** column name */
  Key = 'key',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Obs = 'obs',
  /** column name */
  Precisao = 'precisao',
  /** column name */
  Provider = 'provider',
  /** column name */
  Uuid = 'uuid'
}

export type Mobile_Coordenadas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mobile_Coordenadas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mobile_Coordenadas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mobile_Coordenadas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mobile_Coordenadas_Var_Pop_Fields = {
  __typename?: 'mobile_coordenadas_var_pop_fields';
  distancia_validacao?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_arvore?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_horario?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  precisao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mobile.coordenadas" */
export type Mobile_Coordenadas_Var_Pop_Order_By = {
  distancia_validacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_arvore?: InputMaybe<Order_By>;
  id_equipa_virtual_horario?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  precisao?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mobile_Coordenadas_Var_Samp_Fields = {
  __typename?: 'mobile_coordenadas_var_samp_fields';
  distancia_validacao?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_arvore?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_horario?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  precisao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mobile.coordenadas" */
export type Mobile_Coordenadas_Var_Samp_Order_By = {
  distancia_validacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_arvore?: InputMaybe<Order_By>;
  id_equipa_virtual_horario?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  precisao?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mobile_Coordenadas_Variance_Fields = {
  __typename?: 'mobile_coordenadas_variance_fields';
  distancia_validacao?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_arvore?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_horario?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  precisao?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mobile.coordenadas" */
export type Mobile_Coordenadas_Variance_Order_By = {
  distancia_validacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_arvore?: InputMaybe<Order_By>;
  id_equipa_virtual_horario?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  precisao?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "base.bulk_tipos" */
  delete_base_bulk_tipos?: Maybe<Base_Bulk_Tipos_Mutation_Response>;
  /** delete single row from the table: "base.bulk_tipos" */
  delete_base_bulk_tipos_by_pk?: Maybe<Base_Bulk_Tipos>;
  /** delete data from the table: "base.centros" */
  delete_base_centros?: Maybe<Base_Centros_Mutation_Response>;
  /** delete single row from the table: "base.centros" */
  delete_base_centros_by_pk?: Maybe<Base_Centros>;
  /** delete data from the table: "base.infraestruturas" */
  delete_base_infraestruturas?: Maybe<Base_Infraestruturas_Mutation_Response>;
  /** delete single row from the table: "base.infraestruturas" */
  delete_base_infraestruturas_by_pk?: Maybe<Base_Infraestruturas>;
  /** delete data from the table: "base.infraestruturas_coordenadas" */
  delete_base_infraestruturas_coordenadas?: Maybe<Base_Infraestruturas_Coordenadas_Mutation_Response>;
  /** delete single row from the table: "base.infraestruturas_coordenadas" */
  delete_base_infraestruturas_coordenadas_by_pk?: Maybe<Base_Infraestruturas_Coordenadas>;
  /** delete data from the table: "base.infraestruturas_r_toponimias" */
  delete_base_infraestruturas_r_toponimias?: Maybe<Base_Infraestruturas_R_Toponimias_Mutation_Response>;
  /** delete single row from the table: "base.infraestruturas_r_toponimias" */
  delete_base_infraestruturas_r_toponimias_by_pk?: Maybe<Base_Infraestruturas_R_Toponimias>;
  /** delete data from the table: "base.infraestruturas_tipos" */
  delete_base_infraestruturas_tipos?: Maybe<Base_Infraestruturas_Tipos_Mutation_Response>;
  /** delete single row from the table: "base.infraestruturas_tipos" */
  delete_base_infraestruturas_tipos_by_pk?: Maybe<Base_Infraestruturas_Tipos>;
  /** delete data from the table: "base.parametrizacoes" */
  delete_base_parametrizacoes?: Maybe<Base_Parametrizacoes_Mutation_Response>;
  /** delete data from the table: "base.toponimias" */
  delete_base_toponimias?: Maybe<Base_Toponimias_Mutation_Response>;
  /** delete single row from the table: "base.toponimias" */
  delete_base_toponimias_by_pk?: Maybe<Base_Toponimias>;
  /** delete data from the table: "base.toponimias_coordenadas" */
  delete_base_toponimias_coordenadas?: Maybe<Base_Toponimias_Coordenadas_Mutation_Response>;
  /** delete single row from the table: "base.toponimias_coordenadas" */
  delete_base_toponimias_coordenadas_by_pk?: Maybe<Base_Toponimias_Coordenadas>;
  /** delete data from the table: "base.zmc" */
  delete_base_zmc?: Maybe<Base_Zmc_Mutation_Response>;
  /** delete single row from the table: "base.zmc" */
  delete_base_zmc_by_pk?: Maybe<Base_Zmc>;
  /** delete data from the table: "base.zmc_nos_tipo" */
  delete_base_zmc_nos_tipo?: Maybe<Base_Zmc_Nos_Tipo_Mutation_Response>;
  /** delete single row from the table: "base.zmc_nos_tipo" */
  delete_base_zmc_nos_tipo_by_pk?: Maybe<Base_Zmc_Nos_Tipo>;
  /** delete data from the table: "consultas.requisicoes" */
  delete_consultas_requisicoes?: Maybe<Consultas_Requisicoes_Mutation_Response>;
  /** delete single row from the table: "consultas.requisicoes" */
  delete_consultas_requisicoes_by_pk?: Maybe<Consultas_Requisicoes>;
  /** delete data from the table: "integracoes.ad_parametrizacao" */
  delete_integracoes_ad_parametrizacao?: Maybe<Integracoes_Ad_Parametrizacao_Mutation_Response>;
  /** delete data from the table: "integracoes.ad_saml_parametrizacao" */
  delete_integracoes_ad_saml_parametrizacao?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Mutation_Response>;
  /** delete single row from the table: "integracoes.ad_saml_parametrizacao" */
  delete_integracoes_ad_saml_parametrizacao_by_pk?: Maybe<Integracoes_Ad_Saml_Parametrizacao>;
  /** delete data from the table: "integracoes.sig_maps_ortos" */
  delete_integracoes_sig_maps_ortos?: Maybe<Integracoes_Sig_Maps_Ortos_Mutation_Response>;
  /** delete single row from the table: "integracoes.sig_maps_ortos" */
  delete_integracoes_sig_maps_ortos_by_pk?: Maybe<Integracoes_Sig_Maps_Ortos>;
  /** delete data from the table: "integracoes.sig_parametrizacao" */
  delete_integracoes_sig_parametrizacao?: Maybe<Integracoes_Sig_Parametrizacao_Mutation_Response>;
  /** delete data from the table: "integracoes.sig_proxy" */
  delete_integracoes_sig_proxy?: Maybe<Integracoes_Sig_Proxy_Mutation_Response>;
  /** delete single row from the table: "integracoes.sig_proxy" */
  delete_integracoes_sig_proxy_by_pk?: Maybe<Integracoes_Sig_Proxy>;
  /** delete data from the table: "integracoes.sig_request_get_attributes" */
  delete_integracoes_sig_request_get_attributes?: Maybe<Integracoes_Sig_Request_Get_Attributes_Mutation_Response>;
  /** delete data from the table: "integracoes.sig_request_get_capabilities" */
  delete_integracoes_sig_request_get_capabilities?: Maybe<Integracoes_Sig_Request_Get_Capabilities_Mutation_Response>;
  /** delete data from the table: "integracoes.sig_request_get_features" */
  delete_integracoes_sig_request_get_features?: Maybe<Integracoes_Sig_Request_Get_Features_Mutation_Response>;
  /** delete data from the table: "integracoes.sig_services" */
  delete_integracoes_sig_services?: Maybe<Integracoes_Sig_Services_Mutation_Response>;
  /** delete single row from the table: "integracoes.sig_services" */
  delete_integracoes_sig_services_by_pk?: Maybe<Integracoes_Sig_Services>;
  /** delete data from the table: "mensagens.anexos" */
  delete_mensagens_anexos?: Maybe<Mensagens_Anexos_Mutation_Response>;
  /** delete single row from the table: "mensagens.anexos" */
  delete_mensagens_anexos_by_pk?: Maybe<Mensagens_Anexos>;
  /** delete data from the table: "mensagens.mensagens" */
  delete_mensagens_mensagens?: Maybe<Mensagens_Mensagens_Mutation_Response>;
  /** delete single row from the table: "mensagens.mensagens" */
  delete_mensagens_mensagens_by_pk?: Maybe<Mensagens_Mensagens>;
  /** delete data from the table: "mensagens.post" */
  delete_mensagens_post?: Maybe<Mensagens_Post_Mutation_Response>;
  /** delete single row from the table: "mensagens.post" */
  delete_mensagens_post_by_pk?: Maybe<Mensagens_Post>;
  /** delete data from the table: "mobile.coordenadas" */
  delete_mobile_coordenadas?: Maybe<Mobile_Coordenadas_Mutation_Response>;
  /** delete single row from the table: "mobile.coordenadas" */
  delete_mobile_coordenadas_by_pk?: Maybe<Mobile_Coordenadas>;
  /** delete data from the table: "navia.cores" */
  delete_navia_cores?: Maybe<Navia_Cores_Mutation_Response>;
  /** delete single row from the table: "navia.cores" */
  delete_navia_cores_by_pk?: Maybe<Navia_Cores>;
  /** delete data from the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  delete_navia_dashboards_diagnostico_roturas_infraestruturas_variaveis?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  delete_navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis>;
  /** delete data from the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  delete_navia_dashboards_diagnostico_roturas_mapa_niveis?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  delete_navia_dashboards_diagnostico_roturas_mapa_niveis_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis>;
  /** delete data from the table: "navia_dashboards.diagnostico_roturas_sintomas" */
  delete_navia_dashboards_diagnostico_roturas_sintomas?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.diagnostico_roturas_sintomas" */
  delete_navia_dashboards_diagnostico_roturas_sintomas_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas>;
  /** delete data from the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  delete_navia_dashboards_diagnostico_roturas_sintomas_tipos?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  delete_navia_dashboards_diagnostico_roturas_sintomas_tipos_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos>;
  /** delete data from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  delete_navia_dashboards_diagnostico_roturas_tipos_infraestrutura?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  delete_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura>;
  /** delete data from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  delete_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  delete_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc>;
  /** delete data from the table: "navia_dashboards.menu" */
  delete_navia_dashboards_menu?: Maybe<Navia_Dashboards_Menu_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.menu" */
  delete_navia_dashboards_menu_by_pk?: Maybe<Navia_Dashboards_Menu>;
  /** delete data from the table: "navia_dashboards.menu_r_transacoes" */
  delete_navia_dashboards_menu_r_transacoes?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.menu_r_transacoes" */
  delete_navia_dashboards_menu_r_transacoes_by_pk?: Maybe<Navia_Dashboards_Menu_R_Transacoes>;
  /** delete data from the table: "navia_dashboards.modo_tv_tokens" */
  delete_navia_dashboards_modo_tv_tokens?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.modo_tv_tokens" */
  delete_navia_dashboards_modo_tv_tokens_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens>;
  /** delete data from the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  delete_navia_dashboards_modo_tv_tokens_revogacao_manual?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  delete_navia_dashboards_modo_tv_tokens_revogacao_manual_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual>;
  /** delete data from the table: "navia_dashboards.modo_tv_tokens_validados" */
  delete_navia_dashboards_modo_tv_tokens_validados?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.modo_tv_tokens_validados" */
  delete_navia_dashboards_modo_tv_tokens_validados_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados>;
  /** delete data from the table: "navia_dashboards.monitorizacao_roturas_causas" */
  delete_navia_dashboards_monitorizacao_roturas_causas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.monitorizacao_roturas_causas" */
  delete_navia_dashboards_monitorizacao_roturas_causas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas>;
  /** delete data from the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  delete_navia_dashboards_monitorizacao_roturas_causas_r_causas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  delete_navia_dashboards_monitorizacao_roturas_causas_r_causas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas>;
  /** delete data from the table: "navia_dashboards.monitorizacao_roturas_indicadores" */
  delete_navia_dashboards_monitorizacao_roturas_indicadores?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.monitorizacao_roturas_indicadores" */
  delete_navia_dashboards_monitorizacao_roturas_indicadores_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores>;
  /** delete data from the table: "navia_dashboards.monitorizacao_roturas_sintomas" */
  delete_navia_dashboards_monitorizacao_roturas_sintomas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.monitorizacao_roturas_sintomas" */
  delete_navia_dashboards_monitorizacao_roturas_sintomas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas>;
  /** delete data from the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  delete_navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  delete_navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas>;
  /** delete data from the table: "navia_dashboards.monitorizacao_roturas_variaveis" */
  delete_navia_dashboards_monitorizacao_roturas_variaveis?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.monitorizacao_roturas_variaveis" */
  delete_navia_dashboards_monitorizacao_roturas_variaveis_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis>;
  /** delete data from the table: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  delete_navia_dashboards_performance_infraestrutura_parametrizacao?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  delete_navia_dashboards_performance_infraestrutura_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao>;
  /** delete data from the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  delete_navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  delete_navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao>;
  /** delete data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  delete_navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  delete_navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa>;
  /** delete data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  delete_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  delete_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas>;
  /** delete data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  delete_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  delete_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores>;
  /** delete data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  delete_navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  delete_navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura>;
  /** delete data from the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  delete_navia_dashboards_requisicoes_indicadores_parametrizacao?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  delete_navia_dashboards_requisicoes_indicadores_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao>;
  /** delete data from the table: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  delete_navia_dashboards_requisicoes_mapa_parametrizacao?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  delete_navia_dashboards_requisicoes_mapa_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao>;
  /** delete data from the table: "navia_dashboards.visao_360_parametrizacao" */
  delete_navia_dashboards_visao_360_parametrizacao?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.visao_360_parametrizacao" */
  delete_navia_dashboards_visao_360_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao>;
  /** delete data from the table: "navia_dashboards.visao_360_selectores" */
  delete_navia_dashboards_visao_360_selectores?: Maybe<Navia_Dashboards_Visao_360_Selectores_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.visao_360_selectores" */
  delete_navia_dashboards_visao_360_selectores_by_pk?: Maybe<Navia_Dashboards_Visao_360_Selectores>;
  /** delete data from the table: "navia_dashboards.volumes_diarios_caudais" */
  delete_navia_dashboards_volumes_diarios_caudais?: Maybe<Navia_Dashboards_Volumes_Diarios_Caudais_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.volumes_diarios_caudais" */
  delete_navia_dashboards_volumes_diarios_caudais_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Caudais>;
  /** delete data from the table: "navia_dashboards.volumes_diarios_dados" */
  delete_navia_dashboards_volumes_diarios_dados?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.volumes_diarios_dados" */
  delete_navia_dashboards_volumes_diarios_dados_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados>;
  /** delete data from the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  delete_navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  delete_navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios>;
  /** delete data from the table: "navia_dashboards.volumes_diarios_leituras" */
  delete_navia_dashboards_volumes_diarios_leituras?: Maybe<Navia_Dashboards_Volumes_Diarios_Leituras_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.volumes_diarios_leituras" */
  delete_navia_dashboards_volumes_diarios_leituras_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Leituras>;
  /** delete data from the table: "navia_dashboards.volumes_diarios_locais" */
  delete_navia_dashboards_volumes_diarios_locais?: Maybe<Navia_Dashboards_Volumes_Diarios_Locais_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.volumes_diarios_locais" */
  delete_navia_dashboards_volumes_diarios_locais_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Locais>;
  /** delete data from the table: "navia_dashboards.volumes_diarios_municipios" */
  delete_navia_dashboards_volumes_diarios_municipios?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.volumes_diarios_municipios" */
  delete_navia_dashboards_volumes_diarios_municipios_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios>;
  /** delete data from the table: "navia_dashboards.volumes_diarios_registos" */
  delete_navia_dashboards_volumes_diarios_registos?: Maybe<Navia_Dashboards_Volumes_Diarios_Registos_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.volumes_diarios_registos" */
  delete_navia_dashboards_volumes_diarios_registos_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Registos>;
  /** delete data from the table: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  delete_navia_dashboards_volumes_diarios_totalizador_leituras?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  delete_navia_dashboards_volumes_diarios_totalizador_leituras_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras>;
  /** delete data from the table: "navia_dashboards.volumes_diarios_totalizadores" */
  delete_navia_dashboards_volumes_diarios_totalizadores?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Mutation_Response>;
  /** delete single row from the table: "navia_dashboards.volumes_diarios_totalizadores" */
  delete_navia_dashboards_volumes_diarios_totalizadores_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores>;
  /** delete data from the table: "navia.integracoes" */
  delete_navia_integracoes?: Maybe<Navia_Integracoes_Mutation_Response>;
  /** delete single row from the table: "navia.integracoes" */
  delete_navia_integracoes_by_pk?: Maybe<Navia_Integracoes>;
  /** delete data from the table: "navia.log" */
  delete_navia_log?: Maybe<Navia_Log_Mutation_Response>;
  /** delete single row from the table: "navia.log" */
  delete_navia_log_by_pk?: Maybe<Navia_Log>;
  /** delete data from the table: "notificacoes.itens" */
  delete_notificacoes_itens?: Maybe<Notificacoes_Itens_Mutation_Response>;
  /** delete single row from the table: "notificacoes.itens" */
  delete_notificacoes_itens_by_pk?: Maybe<Notificacoes_Itens>;
  /** delete data from the table: "notificacoes.notificacoes" */
  delete_notificacoes_notificacoes?: Maybe<Notificacoes_Notificacoes_Mutation_Response>;
  /** delete single row from the table: "notificacoes.notificacoes" */
  delete_notificacoes_notificacoes_by_pk?: Maybe<Notificacoes_Notificacoes>;
  /** delete data from the table: "notificacoes.notificacoes_r_utilizadores" */
  delete_notificacoes_notificacoes_r_utilizadores?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Mutation_Response>;
  /** delete single row from the table: "notificacoes.notificacoes_r_utilizadores" */
  delete_notificacoes_notificacoes_r_utilizadores_by_pk?: Maybe<Notificacoes_Notificacoes_R_Utilizadores>;
  /** delete data from the table: "notificacoes.tipos" */
  delete_notificacoes_tipos?: Maybe<Notificacoes_Tipos_Mutation_Response>;
  /** delete single row from the table: "notificacoes.tipos" */
  delete_notificacoes_tipos_by_pk?: Maybe<Notificacoes_Tipos>;
  /** delete data from the table: "permissoes.transacoes" */
  delete_permissoes_transacoes?: Maybe<Permissoes_Transacoes_Mutation_Response>;
  /** delete single row from the table: "permissoes.transacoes" */
  delete_permissoes_transacoes_by_pk?: Maybe<Permissoes_Transacoes>;
  /** delete data from the table: "permissoes.transacoes_r_menus" */
  delete_permissoes_transacoes_r_menus?: Maybe<Permissoes_Transacoes_R_Menus_Mutation_Response>;
  /** delete single row from the table: "permissoes.transacoes_r_menus" */
  delete_permissoes_transacoes_r_menus_by_pk?: Maybe<Permissoes_Transacoes_R_Menus>;
  /** delete data from the table: "rqs.parametrizacao" */
  delete_rqs_parametrizacao?: Maybe<Rqs_Parametrizacao_Mutation_Response>;
  /** delete data from the table: "rqs.requisicoes_periodos" */
  delete_rqs_requisicoes_periodos?: Maybe<Rqs_Requisicoes_Periodos_Mutation_Response>;
  /** delete single row from the table: "rqs.requisicoes_periodos" */
  delete_rqs_requisicoes_periodos_by_pk?: Maybe<Rqs_Requisicoes_Periodos>;
  /** delete data from the table: "rqs.requisicoes_tempos_wrap" */
  delete_rqs_requisicoes_tempos_wrap?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Mutation_Response>;
  /** delete single row from the table: "rqs.requisicoes_tempos_wrap" */
  delete_rqs_requisicoes_tempos_wrap_by_pk?: Maybe<Rqs_Requisicoes_Tempos_Wrap>;
  /** delete data from the table: "rqs.sintomas" */
  delete_rqs_sintomas?: Maybe<Rqs_Sintomas_Mutation_Response>;
  /** delete single row from the table: "rqs.sintomas" */
  delete_rqs_sintomas_by_pk?: Maybe<Rqs_Sintomas>;
  /** delete data from the table: "rqs.sintomas_parametrizacao_tempos" */
  delete_rqs_sintomas_parametrizacao_tempos?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Mutation_Response>;
  /** delete single row from the table: "rqs.sintomas_parametrizacao_tempos" */
  delete_rqs_sintomas_parametrizacao_tempos_by_pk?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos>;
  /** delete data from the table: "servicos.fases" */
  delete_servicos_fases?: Maybe<Servicos_Fases_Mutation_Response>;
  /** delete single row from the table: "servicos.fases" */
  delete_servicos_fases_by_pk?: Maybe<Servicos_Fases>;
  /** delete data from the table: "servicos.intervencoes" */
  delete_servicos_intervencoes?: Maybe<Servicos_Intervencoes_Mutation_Response>;
  /** delete data from the table: "servicos.intervencoes_atribuicao_utilizadores" */
  delete_servicos_intervencoes_atribuicao_utilizadores?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Mutation_Response>;
  /** delete single row from the table: "servicos.intervencoes_atribuicao_utilizadores" */
  delete_servicos_intervencoes_atribuicao_utilizadores_by_pk?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores>;
  /** delete single row from the table: "servicos.intervencoes" */
  delete_servicos_intervencoes_by_pk?: Maybe<Servicos_Intervencoes>;
  /** delete data from the table: "servicos.intervencoes_estados" */
  delete_servicos_intervencoes_estados?: Maybe<Servicos_Intervencoes_Estados_Mutation_Response>;
  /** delete single row from the table: "servicos.intervencoes_estados" */
  delete_servicos_intervencoes_estados_by_pk?: Maybe<Servicos_Intervencoes_Estados>;
  /** delete data from the table: "servicos.intervencoes_r_causas_trabalhos" */
  delete_servicos_intervencoes_r_causas_trabalhos?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Mutation_Response>;
  /** delete single row from the table: "servicos.intervencoes_r_causas_trabalhos" */
  delete_servicos_intervencoes_r_causas_trabalhos_by_pk?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos>;
  /** delete data from the table: "servicos.rastreabilidade" */
  delete_servicos_rastreabilidade?: Maybe<Servicos_Rastreabilidade_Mutation_Response>;
  /** delete single row from the table: "servicos.rastreabilidade" */
  delete_servicos_rastreabilidade_by_pk?: Maybe<Servicos_Rastreabilidade>;
  /** delete data from the table: "servicos.requisicoes" */
  delete_servicos_requisicoes?: Maybe<Servicos_Requisicoes_Mutation_Response>;
  /** delete single row from the table: "servicos.requisicoes" */
  delete_servicos_requisicoes_by_pk?: Maybe<Servicos_Requisicoes>;
  /** delete data from the table: "servicos.requisicoes_estados" */
  delete_servicos_requisicoes_estados?: Maybe<Servicos_Requisicoes_Estados_Mutation_Response>;
  /** delete single row from the table: "servicos.requisicoes_estados" */
  delete_servicos_requisicoes_estados_by_pk?: Maybe<Servicos_Requisicoes_Estados>;
  /** delete data from the table: "servicos.requisicoes_locais_infra_estruturas" */
  delete_servicos_requisicoes_locais_infra_estruturas?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Mutation_Response>;
  /** delete single row from the table: "servicos.requisicoes_locais_infra_estruturas" */
  delete_servicos_requisicoes_locais_infra_estruturas_by_pk?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas>;
  /** delete data from the table: "servicos.requisicoes_r_intervencoes" */
  delete_servicos_requisicoes_r_intervencoes?: Maybe<Servicos_Requisicoes_R_Intervencoes_Mutation_Response>;
  /** delete single row from the table: "servicos.requisicoes_r_intervencoes" */
  delete_servicos_requisicoes_r_intervencoes_by_pk?: Maybe<Servicos_Requisicoes_R_Intervencoes>;
  /** delete data from the table: "sintomas.arvore" */
  delete_sintomas_arvore?: Maybe<Sintomas_Arvore_Mutation_Response>;
  /** delete single row from the table: "sintomas.arvore" */
  delete_sintomas_arvore_by_pk?: Maybe<Sintomas_Arvore>;
  /** delete data from the table: "sintomas.causas_trabalhos" */
  delete_sintomas_causas_trabalhos?: Maybe<Sintomas_Causas_Trabalhos_Mutation_Response>;
  /** delete single row from the table: "sintomas.causas_trabalhos" */
  delete_sintomas_causas_trabalhos_by_pk?: Maybe<Sintomas_Causas_Trabalhos>;
  /** delete data from the table: "sintomas.sintomas_relacao" */
  delete_sintomas_sintomas_relacao?: Maybe<Sintomas_Sintomas_Relacao_Mutation_Response>;
  /** delete single row from the table: "sintomas.sintomas_relacao" */
  delete_sintomas_sintomas_relacao_by_pk?: Maybe<Sintomas_Sintomas_Relacao>;
  /** delete data from the table: "sintomas.sintomas_relacao_ordem" */
  delete_sintomas_sintomas_relacao_ordem?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Mutation_Response>;
  /** delete single row from the table: "sintomas.sintomas_relacao_ordem" */
  delete_sintomas_sintomas_relacao_ordem_by_pk?: Maybe<Sintomas_Sintomas_Relacao_Ordem>;
  /** delete data from the table: "tarefas.estados" */
  delete_tarefas_estados?: Maybe<Tarefas_Estados_Mutation_Response>;
  /** delete single row from the table: "tarefas.estados" */
  delete_tarefas_estados_by_pk?: Maybe<Tarefas_Estados>;
  /** delete data from the table: "tarefas.intervalos" */
  delete_tarefas_intervalos?: Maybe<Tarefas_Intervalos_Mutation_Response>;
  /** delete single row from the table: "tarefas.intervalos" */
  delete_tarefas_intervalos_by_pk?: Maybe<Tarefas_Intervalos>;
  /** delete data from the table: "tarefas.planos_padrao" */
  delete_tarefas_planos_padrao?: Maybe<Tarefas_Planos_Padrao_Mutation_Response>;
  /** delete single row from the table: "tarefas.planos_padrao" */
  delete_tarefas_planos_padrao_by_pk?: Maybe<Tarefas_Planos_Padrao>;
  /** delete data from the table: "tarefas.tarefas" */
  delete_tarefas_tarefas?: Maybe<Tarefas_Tarefas_Mutation_Response>;
  /** delete single row from the table: "tarefas.tarefas" */
  delete_tarefas_tarefas_by_pk?: Maybe<Tarefas_Tarefas>;
  /** delete data from the table: "tarefas.tarefas_r_equipas_virtuais" */
  delete_tarefas_tarefas_r_equipas_virtuais?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Mutation_Response>;
  /** delete single row from the table: "tarefas.tarefas_r_equipas_virtuais" */
  delete_tarefas_tarefas_r_equipas_virtuais_by_pk?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais>;
  /** delete data from the table: "tarefas.tarefas_r_infraestruturas" */
  delete_tarefas_tarefas_r_infraestruturas?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Mutation_Response>;
  /** delete single row from the table: "tarefas.tarefas_r_infraestruturas" */
  delete_tarefas_tarefas_r_infraestruturas_by_pk?: Maybe<Tarefas_Tarefas_R_Infraestruturas>;
  /** delete data from the table: "utilizadores.categorias" */
  delete_utilizadores_categorias?: Maybe<Utilizadores_Categorias_Mutation_Response>;
  /** delete single row from the table: "utilizadores.categorias" */
  delete_utilizadores_categorias_by_pk?: Maybe<Utilizadores_Categorias>;
  /** delete data from the table: "utilizadores.equipas_virtuais" */
  delete_utilizadores_equipas_virtuais?: Maybe<Utilizadores_Equipas_Virtuais_Mutation_Response>;
  /** delete single row from the table: "utilizadores.equipas_virtuais" */
  delete_utilizadores_equipas_virtuais_by_pk?: Maybe<Utilizadores_Equipas_Virtuais>;
  /** delete data from the table: "utilizadores.equipas_virtuais_r_centros" */
  delete_utilizadores_equipas_virtuais_r_centros?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Mutation_Response>;
  /** delete single row from the table: "utilizadores.equipas_virtuais_r_centros" */
  delete_utilizadores_equipas_virtuais_r_centros_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros>;
  /** delete data from the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  delete_utilizadores_equipas_virtuais_r_equipas_virtuais?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Mutation_Response>;
  /** delete single row from the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  delete_utilizadores_equipas_virtuais_r_equipas_virtuais_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais>;
  /** delete data from the table: "utilizadores.equipas_virtuais_r_infraestruturas" */
  delete_utilizadores_equipas_virtuais_r_infraestruturas?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Mutation_Response>;
  /** delete single row from the table: "utilizadores.equipas_virtuais_r_infraestruturas" */
  delete_utilizadores_equipas_virtuais_r_infraestruturas_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas>;
  /** delete data from the table: "utilizadores.equipas_virtuais_r_sintoma" */
  delete_utilizadores_equipas_virtuais_r_sintoma?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Mutation_Response>;
  /** delete single row from the table: "utilizadores.equipas_virtuais_r_sintoma" */
  delete_utilizadores_equipas_virtuais_r_sintoma_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma>;
  /** delete data from the table: "utilizadores.equipas_virtuais_r_toponimias" */
  delete_utilizadores_equipas_virtuais_r_toponimias?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Mutation_Response>;
  /** delete single row from the table: "utilizadores.equipas_virtuais_r_toponimias" */
  delete_utilizadores_equipas_virtuais_r_toponimias_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias>;
  /** delete data from the table: "utilizadores.equipas_virtuais_r_transacoes" */
  delete_utilizadores_equipas_virtuais_r_transacoes?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Mutation_Response>;
  /** delete single row from the table: "utilizadores.equipas_virtuais_r_transacoes" */
  delete_utilizadores_equipas_virtuais_r_transacoes_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** delete data from the table: "utilizadores.equipas_virtuais_r_utilizadores" */
  delete_utilizadores_equipas_virtuais_r_utilizadores?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Mutation_Response>;
  /** delete single row from the table: "utilizadores.equipas_virtuais_r_utilizadores" */
  delete_utilizadores_equipas_virtuais_r_utilizadores_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  /** delete data from the table: "utilizadores.exportacoes" */
  delete_utilizadores_exportacoes?: Maybe<Utilizadores_Exportacoes_Mutation_Response>;
  /** delete single row from the table: "utilizadores.exportacoes" */
  delete_utilizadores_exportacoes_by_pk?: Maybe<Utilizadores_Exportacoes>;
  /** delete data from the table: "utilizadores.mapa_posicao_cores" */
  delete_utilizadores_mapa_posicao_cores?: Maybe<Utilizadores_Mapa_Posicao_Cores_Mutation_Response>;
  /** delete single row from the table: "utilizadores.mapa_posicao_cores" */
  delete_utilizadores_mapa_posicao_cores_by_pk?: Maybe<Utilizadores_Mapa_Posicao_Cores>;
  /** delete data from the table: "utilizadores.menu" */
  delete_utilizadores_menu?: Maybe<Utilizadores_Menu_Mutation_Response>;
  /** delete single row from the table: "utilizadores.menu" */
  delete_utilizadores_menu_by_pk?: Maybe<Utilizadores_Menu>;
  /** delete data from the table: "utilizadores.temas" */
  delete_utilizadores_temas?: Maybe<Utilizadores_Temas_Mutation_Response>;
  /** delete single row from the table: "utilizadores.temas" */
  delete_utilizadores_temas_by_pk?: Maybe<Utilizadores_Temas>;
  /** delete data from the table: "utilizadores.utilizadores" */
  delete_utilizadores_utilizadores?: Maybe<Utilizadores_Utilizadores_Mutation_Response>;
  /** delete single row from the table: "utilizadores.utilizadores" */
  delete_utilizadores_utilizadores_by_pk?: Maybe<Utilizadores_Utilizadores>;
  /** delete data from the table: "variaveis.agregacao" */
  delete_variaveis_agregacao?: Maybe<Variaveis_Agregacao_Mutation_Response>;
  /** delete single row from the table: "variaveis.agregacao" */
  delete_variaveis_agregacao_by_pk?: Maybe<Variaveis_Agregacao>;
  /** delete data from the table: "variaveis.base" */
  delete_variaveis_base?: Maybe<Variaveis_Base_Mutation_Response>;
  /** delete single row from the table: "variaveis.base" */
  delete_variaveis_base_by_pk?: Maybe<Variaveis_Base>;
  /** delete data from the table: "variaveis.base_calc_variaveis" */
  delete_variaveis_base_calc_variaveis?: Maybe<Variaveis_Base_Calc_Variaveis_Mutation_Response>;
  /** delete single row from the table: "variaveis.base_calc_variaveis" */
  delete_variaveis_base_calc_variaveis_by_pk?: Maybe<Variaveis_Base_Calc_Variaveis>;
  /** delete data from the table: "variaveis.base_categorias" */
  delete_variaveis_base_categorias?: Maybe<Variaveis_Base_Categorias_Mutation_Response>;
  /** delete single row from the table: "variaveis.base_categorias" */
  delete_variaveis_base_categorias_by_pk?: Maybe<Variaveis_Base_Categorias>;
  /** delete data from the table: "variaveis.base_propriedades" */
  delete_variaveis_base_propriedades?: Maybe<Variaveis_Base_Propriedades_Mutation_Response>;
  /** delete single row from the table: "variaveis.base_propriedades" */
  delete_variaveis_base_propriedades_by_pk?: Maybe<Variaveis_Base_Propriedades>;
  /** delete data from the table: "variaveis.calc_variaveis" */
  delete_variaveis_calc_variaveis?: Maybe<Variaveis_Calc_Variaveis_Mutation_Response>;
  /** delete single row from the table: "variaveis.calc_variaveis" */
  delete_variaveis_calc_variaveis_by_pk?: Maybe<Variaveis_Calc_Variaveis>;
  /** delete data from the table: "variaveis.dominios" */
  delete_variaveis_dominios?: Maybe<Variaveis_Dominios_Mutation_Response>;
  /** delete single row from the table: "variaveis.dominios" */
  delete_variaveis_dominios_by_pk?: Maybe<Variaveis_Dominios>;
  /** delete data from the table: "variaveis.dominios_r_dominios_valores" */
  delete_variaveis_dominios_r_dominios_valores?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Mutation_Response>;
  /** delete single row from the table: "variaveis.dominios_r_dominios_valores" */
  delete_variaveis_dominios_r_dominios_valores_by_pk?: Maybe<Variaveis_Dominios_R_Dominios_Valores>;
  /** delete data from the table: "variaveis.dominios_valores" */
  delete_variaveis_dominios_valores?: Maybe<Variaveis_Dominios_Valores_Mutation_Response>;
  /** delete single row from the table: "variaveis.dominios_valores" */
  delete_variaveis_dominios_valores_by_pk?: Maybe<Variaveis_Dominios_Valores>;
  /** delete data from the table: "variaveis.escalas_precisao" */
  delete_variaveis_escalas_precisao?: Maybe<Variaveis_Escalas_Precisao_Mutation_Response>;
  /** delete single row from the table: "variaveis.escalas_precisao" */
  delete_variaveis_escalas_precisao_by_pk?: Maybe<Variaveis_Escalas_Precisao>;
  /** delete data from the table: "variaveis.fontes_origem" */
  delete_variaveis_fontes_origem?: Maybe<Variaveis_Fontes_Origem_Mutation_Response>;
  /** delete single row from the table: "variaveis.fontes_origem" */
  delete_variaveis_fontes_origem_by_pk?: Maybe<Variaveis_Fontes_Origem>;
  /** delete data from the table: "variaveis.fontes_origem_propriedades" */
  delete_variaveis_fontes_origem_propriedades?: Maybe<Variaveis_Fontes_Origem_Propriedades_Mutation_Response>;
  /** delete single row from the table: "variaveis.fontes_origem_propriedades" */
  delete_variaveis_fontes_origem_propriedades_by_pk?: Maybe<Variaveis_Fontes_Origem_Propriedades>;
  /** delete data from the table: "variaveis.fontes_origem_tipos" */
  delete_variaveis_fontes_origem_tipos?: Maybe<Variaveis_Fontes_Origem_Tipos_Mutation_Response>;
  /** delete single row from the table: "variaveis.fontes_origem_tipos" */
  delete_variaveis_fontes_origem_tipos_by_pk?: Maybe<Variaveis_Fontes_Origem_Tipos>;
  /** delete data from the table: "variaveis.leituras" */
  delete_variaveis_leituras?: Maybe<Variaveis_Leituras_Mutation_Response>;
  /** delete single row from the table: "variaveis.leituras" */
  delete_variaveis_leituras_by_pk?: Maybe<Variaveis_Leituras>;
  /** delete data from the table: "variaveis.parametros" */
  delete_variaveis_parametros?: Maybe<Variaveis_Parametros_Mutation_Response>;
  /** delete single row from the table: "variaveis.parametros" */
  delete_variaveis_parametros_by_pk?: Maybe<Variaveis_Parametros>;
  /** delete data from the table: "variaveis.parametros_r_unidades_medida" */
  delete_variaveis_parametros_r_unidades_medida?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Mutation_Response>;
  /** delete single row from the table: "variaveis.parametros_r_unidades_medida" */
  delete_variaveis_parametros_r_unidades_medida_by_pk?: Maybe<Variaveis_Parametros_R_Unidades_Medida>;
  /** delete data from the table: "variaveis.tipos" */
  delete_variaveis_tipos?: Maybe<Variaveis_Tipos_Mutation_Response>;
  /** delete single row from the table: "variaveis.tipos" */
  delete_variaveis_tipos_by_pk?: Maybe<Variaveis_Tipos>;
  /** delete data from the table: "variaveis.totalizadores_tipos_registo" */
  delete_variaveis_totalizadores_tipos_registo?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Mutation_Response>;
  /** delete single row from the table: "variaveis.totalizadores_tipos_registo" */
  delete_variaveis_totalizadores_tipos_registo_by_pk?: Maybe<Variaveis_Totalizadores_Tipos_Registo>;
  /** delete data from the table: "variaveis.unidades_medida" */
  delete_variaveis_unidades_medida?: Maybe<Variaveis_Unidades_Medida_Mutation_Response>;
  /** delete single row from the table: "variaveis.unidades_medida" */
  delete_variaveis_unidades_medida_by_pk?: Maybe<Variaveis_Unidades_Medida>;
  /** delete data from the table: "variaveis.valores_mensais" */
  delete_variaveis_valores_mensais?: Maybe<Variaveis_Valores_Mensais_Mutation_Response>;
  /** delete single row from the table: "variaveis.valores_mensais" */
  delete_variaveis_valores_mensais_by_pk?: Maybe<Variaveis_Valores_Mensais>;
  /** insert data into the table: "base.bulk_tipos" */
  insert_base_bulk_tipos?: Maybe<Base_Bulk_Tipos_Mutation_Response>;
  /** insert a single row into the table: "base.bulk_tipos" */
  insert_base_bulk_tipos_one?: Maybe<Base_Bulk_Tipos>;
  /** insert data into the table: "base.centros" */
  insert_base_centros?: Maybe<Base_Centros_Mutation_Response>;
  /** insert a single row into the table: "base.centros" */
  insert_base_centros_one?: Maybe<Base_Centros>;
  /** insert data into the table: "base.infraestruturas" */
  insert_base_infraestruturas?: Maybe<Base_Infraestruturas_Mutation_Response>;
  /** insert data into the table: "base.infraestruturas_coordenadas" */
  insert_base_infraestruturas_coordenadas?: Maybe<Base_Infraestruturas_Coordenadas_Mutation_Response>;
  /** insert a single row into the table: "base.infraestruturas_coordenadas" */
  insert_base_infraestruturas_coordenadas_one?: Maybe<Base_Infraestruturas_Coordenadas>;
  /** insert a single row into the table: "base.infraestruturas" */
  insert_base_infraestruturas_one?: Maybe<Base_Infraestruturas>;
  /** insert data into the table: "base.infraestruturas_r_toponimias" */
  insert_base_infraestruturas_r_toponimias?: Maybe<Base_Infraestruturas_R_Toponimias_Mutation_Response>;
  /** insert a single row into the table: "base.infraestruturas_r_toponimias" */
  insert_base_infraestruturas_r_toponimias_one?: Maybe<Base_Infraestruturas_R_Toponimias>;
  /** insert data into the table: "base.infraestruturas_tipos" */
  insert_base_infraestruturas_tipos?: Maybe<Base_Infraestruturas_Tipos_Mutation_Response>;
  /** insert a single row into the table: "base.infraestruturas_tipos" */
  insert_base_infraestruturas_tipos_one?: Maybe<Base_Infraestruturas_Tipos>;
  /** insert data into the table: "base.parametrizacoes" */
  insert_base_parametrizacoes?: Maybe<Base_Parametrizacoes_Mutation_Response>;
  /** insert a single row into the table: "base.parametrizacoes" */
  insert_base_parametrizacoes_one?: Maybe<Base_Parametrizacoes>;
  /** insert data into the table: "base.toponimias" */
  insert_base_toponimias?: Maybe<Base_Toponimias_Mutation_Response>;
  /** insert data into the table: "base.toponimias_coordenadas" */
  insert_base_toponimias_coordenadas?: Maybe<Base_Toponimias_Coordenadas_Mutation_Response>;
  /** insert a single row into the table: "base.toponimias_coordenadas" */
  insert_base_toponimias_coordenadas_one?: Maybe<Base_Toponimias_Coordenadas>;
  /** insert a single row into the table: "base.toponimias" */
  insert_base_toponimias_one?: Maybe<Base_Toponimias>;
  /** insert data into the table: "base.zmc" */
  insert_base_zmc?: Maybe<Base_Zmc_Mutation_Response>;
  /** insert data into the table: "base.zmc_nos_tipo" */
  insert_base_zmc_nos_tipo?: Maybe<Base_Zmc_Nos_Tipo_Mutation_Response>;
  /** insert a single row into the table: "base.zmc_nos_tipo" */
  insert_base_zmc_nos_tipo_one?: Maybe<Base_Zmc_Nos_Tipo>;
  /** insert a single row into the table: "base.zmc" */
  insert_base_zmc_one?: Maybe<Base_Zmc>;
  /** insert data into the table: "consultas.requisicoes" */
  insert_consultas_requisicoes?: Maybe<Consultas_Requisicoes_Mutation_Response>;
  /** insert a single row into the table: "consultas.requisicoes" */
  insert_consultas_requisicoes_one?: Maybe<Consultas_Requisicoes>;
  /** insert data into the table: "integracoes.ad_parametrizacao" */
  insert_integracoes_ad_parametrizacao?: Maybe<Integracoes_Ad_Parametrizacao_Mutation_Response>;
  /** insert a single row into the table: "integracoes.ad_parametrizacao" */
  insert_integracoes_ad_parametrizacao_one?: Maybe<Integracoes_Ad_Parametrizacao>;
  /** insert data into the table: "integracoes.ad_saml_parametrizacao" */
  insert_integracoes_ad_saml_parametrizacao?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Mutation_Response>;
  /** insert a single row into the table: "integracoes.ad_saml_parametrizacao" */
  insert_integracoes_ad_saml_parametrizacao_one?: Maybe<Integracoes_Ad_Saml_Parametrizacao>;
  /** insert data into the table: "integracoes.sig_maps_ortos" */
  insert_integracoes_sig_maps_ortos?: Maybe<Integracoes_Sig_Maps_Ortos_Mutation_Response>;
  /** insert a single row into the table: "integracoes.sig_maps_ortos" */
  insert_integracoes_sig_maps_ortos_one?: Maybe<Integracoes_Sig_Maps_Ortos>;
  /** insert data into the table: "integracoes.sig_parametrizacao" */
  insert_integracoes_sig_parametrizacao?: Maybe<Integracoes_Sig_Parametrizacao_Mutation_Response>;
  /** insert a single row into the table: "integracoes.sig_parametrizacao" */
  insert_integracoes_sig_parametrizacao_one?: Maybe<Integracoes_Sig_Parametrizacao>;
  /** insert data into the table: "integracoes.sig_proxy" */
  insert_integracoes_sig_proxy?: Maybe<Integracoes_Sig_Proxy_Mutation_Response>;
  /** insert a single row into the table: "integracoes.sig_proxy" */
  insert_integracoes_sig_proxy_one?: Maybe<Integracoes_Sig_Proxy>;
  /** insert data into the table: "integracoes.sig_request_get_attributes" */
  insert_integracoes_sig_request_get_attributes?: Maybe<Integracoes_Sig_Request_Get_Attributes_Mutation_Response>;
  /** insert a single row into the table: "integracoes.sig_request_get_attributes" */
  insert_integracoes_sig_request_get_attributes_one?: Maybe<Integracoes_Sig_Request_Get_Attributes>;
  /** insert data into the table: "integracoes.sig_request_get_capabilities" */
  insert_integracoes_sig_request_get_capabilities?: Maybe<Integracoes_Sig_Request_Get_Capabilities_Mutation_Response>;
  /** insert a single row into the table: "integracoes.sig_request_get_capabilities" */
  insert_integracoes_sig_request_get_capabilities_one?: Maybe<Integracoes_Sig_Request_Get_Capabilities>;
  /** insert data into the table: "integracoes.sig_request_get_features" */
  insert_integracoes_sig_request_get_features?: Maybe<Integracoes_Sig_Request_Get_Features_Mutation_Response>;
  /** insert a single row into the table: "integracoes.sig_request_get_features" */
  insert_integracoes_sig_request_get_features_one?: Maybe<Integracoes_Sig_Request_Get_Features>;
  /** insert data into the table: "integracoes.sig_services" */
  insert_integracoes_sig_services?: Maybe<Integracoes_Sig_Services_Mutation_Response>;
  /** insert a single row into the table: "integracoes.sig_services" */
  insert_integracoes_sig_services_one?: Maybe<Integracoes_Sig_Services>;
  /** insert data into the table: "mensagens.anexos" */
  insert_mensagens_anexos?: Maybe<Mensagens_Anexos_Mutation_Response>;
  /** insert a single row into the table: "mensagens.anexos" */
  insert_mensagens_anexos_one?: Maybe<Mensagens_Anexos>;
  /** insert data into the table: "mensagens.mensagens" */
  insert_mensagens_mensagens?: Maybe<Mensagens_Mensagens_Mutation_Response>;
  /** insert a single row into the table: "mensagens.mensagens" */
  insert_mensagens_mensagens_one?: Maybe<Mensagens_Mensagens>;
  /** insert data into the table: "mensagens.post" */
  insert_mensagens_post?: Maybe<Mensagens_Post_Mutation_Response>;
  /** insert a single row into the table: "mensagens.post" */
  insert_mensagens_post_one?: Maybe<Mensagens_Post>;
  /** insert data into the table: "mobile.coordenadas" */
  insert_mobile_coordenadas?: Maybe<Mobile_Coordenadas_Mutation_Response>;
  /** insert a single row into the table: "mobile.coordenadas" */
  insert_mobile_coordenadas_one?: Maybe<Mobile_Coordenadas>;
  /** insert data into the table: "navia.cores" */
  insert_navia_cores?: Maybe<Navia_Cores_Mutation_Response>;
  /** insert a single row into the table: "navia.cores" */
  insert_navia_cores_one?: Maybe<Navia_Cores>;
  /** insert data into the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  insert_navia_dashboards_diagnostico_roturas_infraestruturas_variaveis?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  insert_navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_one?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis>;
  /** insert data into the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  insert_navia_dashboards_diagnostico_roturas_mapa_niveis?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  insert_navia_dashboards_diagnostico_roturas_mapa_niveis_one?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis>;
  /** insert data into the table: "navia_dashboards.diagnostico_roturas_sintomas" */
  insert_navia_dashboards_diagnostico_roturas_sintomas?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.diagnostico_roturas_sintomas" */
  insert_navia_dashboards_diagnostico_roturas_sintomas_one?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas>;
  /** insert data into the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  insert_navia_dashboards_diagnostico_roturas_sintomas_tipos?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  insert_navia_dashboards_diagnostico_roturas_sintomas_tipos_one?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos>;
  /** insert data into the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  insert_navia_dashboards_diagnostico_roturas_tipos_infraestrutura?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  insert_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_one?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura>;
  /** insert data into the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  insert_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  insert_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_one?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc>;
  /** insert data into the table: "navia_dashboards.menu" */
  insert_navia_dashboards_menu?: Maybe<Navia_Dashboards_Menu_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.menu" */
  insert_navia_dashboards_menu_one?: Maybe<Navia_Dashboards_Menu>;
  /** insert data into the table: "navia_dashboards.menu_r_transacoes" */
  insert_navia_dashboards_menu_r_transacoes?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.menu_r_transacoes" */
  insert_navia_dashboards_menu_r_transacoes_one?: Maybe<Navia_Dashboards_Menu_R_Transacoes>;
  /** insert data into the table: "navia_dashboards.modo_tv_tokens" */
  insert_navia_dashboards_modo_tv_tokens?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.modo_tv_tokens" */
  insert_navia_dashboards_modo_tv_tokens_one?: Maybe<Navia_Dashboards_Modo_Tv_Tokens>;
  /** insert data into the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  insert_navia_dashboards_modo_tv_tokens_revogacao_manual?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  insert_navia_dashboards_modo_tv_tokens_revogacao_manual_one?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual>;
  /** insert data into the table: "navia_dashboards.modo_tv_tokens_validados" */
  insert_navia_dashboards_modo_tv_tokens_validados?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.modo_tv_tokens_validados" */
  insert_navia_dashboards_modo_tv_tokens_validados_one?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados>;
  /** insert data into the table: "navia_dashboards.monitorizacao_roturas_causas" */
  insert_navia_dashboards_monitorizacao_roturas_causas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.monitorizacao_roturas_causas" */
  insert_navia_dashboards_monitorizacao_roturas_causas_one?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas>;
  /** insert data into the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  insert_navia_dashboards_monitorizacao_roturas_causas_r_causas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  insert_navia_dashboards_monitorizacao_roturas_causas_r_causas_one?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas>;
  /** insert data into the table: "navia_dashboards.monitorizacao_roturas_indicadores" */
  insert_navia_dashboards_monitorizacao_roturas_indicadores?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.monitorizacao_roturas_indicadores" */
  insert_navia_dashboards_monitorizacao_roturas_indicadores_one?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores>;
  /** insert data into the table: "navia_dashboards.monitorizacao_roturas_sintomas" */
  insert_navia_dashboards_monitorizacao_roturas_sintomas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.monitorizacao_roturas_sintomas" */
  insert_navia_dashboards_monitorizacao_roturas_sintomas_one?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas>;
  /** insert data into the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  insert_navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  insert_navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_one?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas>;
  /** insert data into the table: "navia_dashboards.monitorizacao_roturas_variaveis" */
  insert_navia_dashboards_monitorizacao_roturas_variaveis?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.monitorizacao_roturas_variaveis" */
  insert_navia_dashboards_monitorizacao_roturas_variaveis_one?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis>;
  /** insert data into the table: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  insert_navia_dashboards_performance_infraestrutura_parametrizacao?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  insert_navia_dashboards_performance_infraestrutura_parametrizacao_one?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao>;
  /** insert data into the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  insert_navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  insert_navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_one?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao>;
  /** insert data into the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  insert_navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  insert_navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_one?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa>;
  /** insert data into the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  insert_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  insert_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_one?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas>;
  /** insert data into the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  insert_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  insert_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_one?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores>;
  /** insert data into the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  insert_navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  insert_navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_one?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura>;
  /** insert data into the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  insert_navia_dashboards_requisicoes_indicadores_parametrizacao?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  insert_navia_dashboards_requisicoes_indicadores_parametrizacao_one?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao>;
  /** insert data into the table: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  insert_navia_dashboards_requisicoes_mapa_parametrizacao?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  insert_navia_dashboards_requisicoes_mapa_parametrizacao_one?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao>;
  /** insert data into the table: "navia_dashboards.visao_360_parametrizacao" */
  insert_navia_dashboards_visao_360_parametrizacao?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.visao_360_parametrizacao" */
  insert_navia_dashboards_visao_360_parametrizacao_one?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao>;
  /** insert data into the table: "navia_dashboards.visao_360_selectores" */
  insert_navia_dashboards_visao_360_selectores?: Maybe<Navia_Dashboards_Visao_360_Selectores_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.visao_360_selectores" */
  insert_navia_dashboards_visao_360_selectores_one?: Maybe<Navia_Dashboards_Visao_360_Selectores>;
  /** insert data into the table: "navia_dashboards.volumes_diarios_caudais" */
  insert_navia_dashboards_volumes_diarios_caudais?: Maybe<Navia_Dashboards_Volumes_Diarios_Caudais_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.volumes_diarios_caudais" */
  insert_navia_dashboards_volumes_diarios_caudais_one?: Maybe<Navia_Dashboards_Volumes_Diarios_Caudais>;
  /** insert data into the table: "navia_dashboards.volumes_diarios_dados" */
  insert_navia_dashboards_volumes_diarios_dados?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.volumes_diarios_dados" */
  insert_navia_dashboards_volumes_diarios_dados_one?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados>;
  /** insert data into the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  insert_navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  insert_navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_one?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios>;
  /** insert data into the table: "navia_dashboards.volumes_diarios_leituras" */
  insert_navia_dashboards_volumes_diarios_leituras?: Maybe<Navia_Dashboards_Volumes_Diarios_Leituras_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.volumes_diarios_leituras" */
  insert_navia_dashboards_volumes_diarios_leituras_one?: Maybe<Navia_Dashboards_Volumes_Diarios_Leituras>;
  /** insert data into the table: "navia_dashboards.volumes_diarios_locais" */
  insert_navia_dashboards_volumes_diarios_locais?: Maybe<Navia_Dashboards_Volumes_Diarios_Locais_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.volumes_diarios_locais" */
  insert_navia_dashboards_volumes_diarios_locais_one?: Maybe<Navia_Dashboards_Volumes_Diarios_Locais>;
  /** insert data into the table: "navia_dashboards.volumes_diarios_municipios" */
  insert_navia_dashboards_volumes_diarios_municipios?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.volumes_diarios_municipios" */
  insert_navia_dashboards_volumes_diarios_municipios_one?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios>;
  /** insert data into the table: "navia_dashboards.volumes_diarios_registos" */
  insert_navia_dashboards_volumes_diarios_registos?: Maybe<Navia_Dashboards_Volumes_Diarios_Registos_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.volumes_diarios_registos" */
  insert_navia_dashboards_volumes_diarios_registos_one?: Maybe<Navia_Dashboards_Volumes_Diarios_Registos>;
  /** insert data into the table: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  insert_navia_dashboards_volumes_diarios_totalizador_leituras?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  insert_navia_dashboards_volumes_diarios_totalizador_leituras_one?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras>;
  /** insert data into the table: "navia_dashboards.volumes_diarios_totalizadores" */
  insert_navia_dashboards_volumes_diarios_totalizadores?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Mutation_Response>;
  /** insert a single row into the table: "navia_dashboards.volumes_diarios_totalizadores" */
  insert_navia_dashboards_volumes_diarios_totalizadores_one?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores>;
  /** insert data into the table: "navia.integracoes" */
  insert_navia_integracoes?: Maybe<Navia_Integracoes_Mutation_Response>;
  /** insert a single row into the table: "navia.integracoes" */
  insert_navia_integracoes_one?: Maybe<Navia_Integracoes>;
  /** insert data into the table: "navia.log" */
  insert_navia_log?: Maybe<Navia_Log_Mutation_Response>;
  /** insert a single row into the table: "navia.log" */
  insert_navia_log_one?: Maybe<Navia_Log>;
  /** insert data into the table: "notificacoes.itens" */
  insert_notificacoes_itens?: Maybe<Notificacoes_Itens_Mutation_Response>;
  /** insert a single row into the table: "notificacoes.itens" */
  insert_notificacoes_itens_one?: Maybe<Notificacoes_Itens>;
  /** insert data into the table: "notificacoes.notificacoes" */
  insert_notificacoes_notificacoes?: Maybe<Notificacoes_Notificacoes_Mutation_Response>;
  /** insert a single row into the table: "notificacoes.notificacoes" */
  insert_notificacoes_notificacoes_one?: Maybe<Notificacoes_Notificacoes>;
  /** insert data into the table: "notificacoes.notificacoes_r_utilizadores" */
  insert_notificacoes_notificacoes_r_utilizadores?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Mutation_Response>;
  /** insert a single row into the table: "notificacoes.notificacoes_r_utilizadores" */
  insert_notificacoes_notificacoes_r_utilizadores_one?: Maybe<Notificacoes_Notificacoes_R_Utilizadores>;
  /** insert data into the table: "notificacoes.tipos" */
  insert_notificacoes_tipos?: Maybe<Notificacoes_Tipos_Mutation_Response>;
  /** insert a single row into the table: "notificacoes.tipos" */
  insert_notificacoes_tipos_one?: Maybe<Notificacoes_Tipos>;
  /** insert data into the table: "permissoes.transacoes" */
  insert_permissoes_transacoes?: Maybe<Permissoes_Transacoes_Mutation_Response>;
  /** insert a single row into the table: "permissoes.transacoes" */
  insert_permissoes_transacoes_one?: Maybe<Permissoes_Transacoes>;
  /** insert data into the table: "permissoes.transacoes_r_menus" */
  insert_permissoes_transacoes_r_menus?: Maybe<Permissoes_Transacoes_R_Menus_Mutation_Response>;
  /** insert a single row into the table: "permissoes.transacoes_r_menus" */
  insert_permissoes_transacoes_r_menus_one?: Maybe<Permissoes_Transacoes_R_Menus>;
  /** insert data into the table: "rqs.parametrizacao" */
  insert_rqs_parametrizacao?: Maybe<Rqs_Parametrizacao_Mutation_Response>;
  /** insert a single row into the table: "rqs.parametrizacao" */
  insert_rqs_parametrizacao_one?: Maybe<Rqs_Parametrizacao>;
  /** insert data into the table: "rqs.requisicoes_periodos" */
  insert_rqs_requisicoes_periodos?: Maybe<Rqs_Requisicoes_Periodos_Mutation_Response>;
  /** insert a single row into the table: "rqs.requisicoes_periodos" */
  insert_rqs_requisicoes_periodos_one?: Maybe<Rqs_Requisicoes_Periodos>;
  /** insert data into the table: "rqs.requisicoes_tempos_wrap" */
  insert_rqs_requisicoes_tempos_wrap?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Mutation_Response>;
  /** insert a single row into the table: "rqs.requisicoes_tempos_wrap" */
  insert_rqs_requisicoes_tempos_wrap_one?: Maybe<Rqs_Requisicoes_Tempos_Wrap>;
  /** insert data into the table: "rqs.sintomas" */
  insert_rqs_sintomas?: Maybe<Rqs_Sintomas_Mutation_Response>;
  /** insert a single row into the table: "rqs.sintomas" */
  insert_rqs_sintomas_one?: Maybe<Rqs_Sintomas>;
  /** insert data into the table: "rqs.sintomas_parametrizacao_tempos" */
  insert_rqs_sintomas_parametrizacao_tempos?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Mutation_Response>;
  /** insert a single row into the table: "rqs.sintomas_parametrizacao_tempos" */
  insert_rqs_sintomas_parametrizacao_tempos_one?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos>;
  /** insert data into the table: "servicos.fases" */
  insert_servicos_fases?: Maybe<Servicos_Fases_Mutation_Response>;
  /** insert a single row into the table: "servicos.fases" */
  insert_servicos_fases_one?: Maybe<Servicos_Fases>;
  /** insert data into the table: "servicos.intervencoes" */
  insert_servicos_intervencoes?: Maybe<Servicos_Intervencoes_Mutation_Response>;
  /** insert data into the table: "servicos.intervencoes_atribuicao_utilizadores" */
  insert_servicos_intervencoes_atribuicao_utilizadores?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Mutation_Response>;
  /** insert a single row into the table: "servicos.intervencoes_atribuicao_utilizadores" */
  insert_servicos_intervencoes_atribuicao_utilizadores_one?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores>;
  /** insert data into the table: "servicos.intervencoes_estados" */
  insert_servicos_intervencoes_estados?: Maybe<Servicos_Intervencoes_Estados_Mutation_Response>;
  /** insert a single row into the table: "servicos.intervencoes_estados" */
  insert_servicos_intervencoes_estados_one?: Maybe<Servicos_Intervencoes_Estados>;
  /** insert a single row into the table: "servicos.intervencoes" */
  insert_servicos_intervencoes_one?: Maybe<Servicos_Intervencoes>;
  /** insert data into the table: "servicos.intervencoes_r_causas_trabalhos" */
  insert_servicos_intervencoes_r_causas_trabalhos?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Mutation_Response>;
  /** insert a single row into the table: "servicos.intervencoes_r_causas_trabalhos" */
  insert_servicos_intervencoes_r_causas_trabalhos_one?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos>;
  /** insert data into the table: "servicos.rastreabilidade" */
  insert_servicos_rastreabilidade?: Maybe<Servicos_Rastreabilidade_Mutation_Response>;
  /** insert a single row into the table: "servicos.rastreabilidade" */
  insert_servicos_rastreabilidade_one?: Maybe<Servicos_Rastreabilidade>;
  /** insert data into the table: "servicos.requisicoes" */
  insert_servicos_requisicoes?: Maybe<Servicos_Requisicoes_Mutation_Response>;
  /** insert data into the table: "servicos.requisicoes_estados" */
  insert_servicos_requisicoes_estados?: Maybe<Servicos_Requisicoes_Estados_Mutation_Response>;
  /** insert a single row into the table: "servicos.requisicoes_estados" */
  insert_servicos_requisicoes_estados_one?: Maybe<Servicos_Requisicoes_Estados>;
  /** insert data into the table: "servicos.requisicoes_locais_infra_estruturas" */
  insert_servicos_requisicoes_locais_infra_estruturas?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Mutation_Response>;
  /** insert a single row into the table: "servicos.requisicoes_locais_infra_estruturas" */
  insert_servicos_requisicoes_locais_infra_estruturas_one?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas>;
  /** insert a single row into the table: "servicos.requisicoes" */
  insert_servicos_requisicoes_one?: Maybe<Servicos_Requisicoes>;
  /** insert data into the table: "servicos.requisicoes_r_intervencoes" */
  insert_servicos_requisicoes_r_intervencoes?: Maybe<Servicos_Requisicoes_R_Intervencoes_Mutation_Response>;
  /** insert a single row into the table: "servicos.requisicoes_r_intervencoes" */
  insert_servicos_requisicoes_r_intervencoes_one?: Maybe<Servicos_Requisicoes_R_Intervencoes>;
  /** insert data into the table: "sintomas.arvore" */
  insert_sintomas_arvore?: Maybe<Sintomas_Arvore_Mutation_Response>;
  /** insert a single row into the table: "sintomas.arvore" */
  insert_sintomas_arvore_one?: Maybe<Sintomas_Arvore>;
  /** insert data into the table: "sintomas.causas_trabalhos" */
  insert_sintomas_causas_trabalhos?: Maybe<Sintomas_Causas_Trabalhos_Mutation_Response>;
  /** insert a single row into the table: "sintomas.causas_trabalhos" */
  insert_sintomas_causas_trabalhos_one?: Maybe<Sintomas_Causas_Trabalhos>;
  /** insert data into the table: "sintomas.sintomas_relacao" */
  insert_sintomas_sintomas_relacao?: Maybe<Sintomas_Sintomas_Relacao_Mutation_Response>;
  /** insert a single row into the table: "sintomas.sintomas_relacao" */
  insert_sintomas_sintomas_relacao_one?: Maybe<Sintomas_Sintomas_Relacao>;
  /** insert data into the table: "sintomas.sintomas_relacao_ordem" */
  insert_sintomas_sintomas_relacao_ordem?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Mutation_Response>;
  /** insert a single row into the table: "sintomas.sintomas_relacao_ordem" */
  insert_sintomas_sintomas_relacao_ordem_one?: Maybe<Sintomas_Sintomas_Relacao_Ordem>;
  /** insert data into the table: "tarefas.estados" */
  insert_tarefas_estados?: Maybe<Tarefas_Estados_Mutation_Response>;
  /** insert a single row into the table: "tarefas.estados" */
  insert_tarefas_estados_one?: Maybe<Tarefas_Estados>;
  /** insert data into the table: "tarefas.intervalos" */
  insert_tarefas_intervalos?: Maybe<Tarefas_Intervalos_Mutation_Response>;
  /** insert a single row into the table: "tarefas.intervalos" */
  insert_tarefas_intervalos_one?: Maybe<Tarefas_Intervalos>;
  /** insert data into the table: "tarefas.planos_padrao" */
  insert_tarefas_planos_padrao?: Maybe<Tarefas_Planos_Padrao_Mutation_Response>;
  /** insert a single row into the table: "tarefas.planos_padrao" */
  insert_tarefas_planos_padrao_one?: Maybe<Tarefas_Planos_Padrao>;
  /** insert data into the table: "tarefas.tarefas" */
  insert_tarefas_tarefas?: Maybe<Tarefas_Tarefas_Mutation_Response>;
  /** insert a single row into the table: "tarefas.tarefas" */
  insert_tarefas_tarefas_one?: Maybe<Tarefas_Tarefas>;
  /** insert data into the table: "tarefas.tarefas_r_equipas_virtuais" */
  insert_tarefas_tarefas_r_equipas_virtuais?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Mutation_Response>;
  /** insert a single row into the table: "tarefas.tarefas_r_equipas_virtuais" */
  insert_tarefas_tarefas_r_equipas_virtuais_one?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais>;
  /** insert data into the table: "tarefas.tarefas_r_infraestruturas" */
  insert_tarefas_tarefas_r_infraestruturas?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Mutation_Response>;
  /** insert a single row into the table: "tarefas.tarefas_r_infraestruturas" */
  insert_tarefas_tarefas_r_infraestruturas_one?: Maybe<Tarefas_Tarefas_R_Infraestruturas>;
  /** insert data into the table: "utilizadores.categorias" */
  insert_utilizadores_categorias?: Maybe<Utilizadores_Categorias_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.categorias" */
  insert_utilizadores_categorias_one?: Maybe<Utilizadores_Categorias>;
  /** insert data into the table: "utilizadores.equipas_virtuais" */
  insert_utilizadores_equipas_virtuais?: Maybe<Utilizadores_Equipas_Virtuais_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.equipas_virtuais" */
  insert_utilizadores_equipas_virtuais_one?: Maybe<Utilizadores_Equipas_Virtuais>;
  /** insert data into the table: "utilizadores.equipas_virtuais_r_centros" */
  insert_utilizadores_equipas_virtuais_r_centros?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.equipas_virtuais_r_centros" */
  insert_utilizadores_equipas_virtuais_r_centros_one?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros>;
  /** insert data into the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  insert_utilizadores_equipas_virtuais_r_equipas_virtuais?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  insert_utilizadores_equipas_virtuais_r_equipas_virtuais_one?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais>;
  /** insert data into the table: "utilizadores.equipas_virtuais_r_infraestruturas" */
  insert_utilizadores_equipas_virtuais_r_infraestruturas?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.equipas_virtuais_r_infraestruturas" */
  insert_utilizadores_equipas_virtuais_r_infraestruturas_one?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas>;
  /** insert data into the table: "utilizadores.equipas_virtuais_r_sintoma" */
  insert_utilizadores_equipas_virtuais_r_sintoma?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.equipas_virtuais_r_sintoma" */
  insert_utilizadores_equipas_virtuais_r_sintoma_one?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma>;
  /** insert data into the table: "utilizadores.equipas_virtuais_r_toponimias" */
  insert_utilizadores_equipas_virtuais_r_toponimias?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.equipas_virtuais_r_toponimias" */
  insert_utilizadores_equipas_virtuais_r_toponimias_one?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias>;
  /** insert data into the table: "utilizadores.equipas_virtuais_r_transacoes" */
  insert_utilizadores_equipas_virtuais_r_transacoes?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.equipas_virtuais_r_transacoes" */
  insert_utilizadores_equipas_virtuais_r_transacoes_one?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** insert data into the table: "utilizadores.equipas_virtuais_r_utilizadores" */
  insert_utilizadores_equipas_virtuais_r_utilizadores?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.equipas_virtuais_r_utilizadores" */
  insert_utilizadores_equipas_virtuais_r_utilizadores_one?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  /** insert data into the table: "utilizadores.exportacoes" */
  insert_utilizadores_exportacoes?: Maybe<Utilizadores_Exportacoes_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.exportacoes" */
  insert_utilizadores_exportacoes_one?: Maybe<Utilizadores_Exportacoes>;
  /** insert data into the table: "utilizadores.mapa_posicao_cores" */
  insert_utilizadores_mapa_posicao_cores?: Maybe<Utilizadores_Mapa_Posicao_Cores_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.mapa_posicao_cores" */
  insert_utilizadores_mapa_posicao_cores_one?: Maybe<Utilizadores_Mapa_Posicao_Cores>;
  /** insert data into the table: "utilizadores.menu" */
  insert_utilizadores_menu?: Maybe<Utilizadores_Menu_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.menu" */
  insert_utilizadores_menu_one?: Maybe<Utilizadores_Menu>;
  /** insert data into the table: "utilizadores.temas" */
  insert_utilizadores_temas?: Maybe<Utilizadores_Temas_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.temas" */
  insert_utilizadores_temas_one?: Maybe<Utilizadores_Temas>;
  /** insert data into the table: "utilizadores.utilizadores" */
  insert_utilizadores_utilizadores?: Maybe<Utilizadores_Utilizadores_Mutation_Response>;
  /** insert a single row into the table: "utilizadores.utilizadores" */
  insert_utilizadores_utilizadores_one?: Maybe<Utilizadores_Utilizadores>;
  /** insert data into the table: "variaveis.agregacao" */
  insert_variaveis_agregacao?: Maybe<Variaveis_Agregacao_Mutation_Response>;
  /** insert a single row into the table: "variaveis.agregacao" */
  insert_variaveis_agregacao_one?: Maybe<Variaveis_Agregacao>;
  /** insert data into the table: "variaveis.base" */
  insert_variaveis_base?: Maybe<Variaveis_Base_Mutation_Response>;
  /** insert data into the table: "variaveis.base_calc_variaveis" */
  insert_variaveis_base_calc_variaveis?: Maybe<Variaveis_Base_Calc_Variaveis_Mutation_Response>;
  /** insert a single row into the table: "variaveis.base_calc_variaveis" */
  insert_variaveis_base_calc_variaveis_one?: Maybe<Variaveis_Base_Calc_Variaveis>;
  /** insert data into the table: "variaveis.base_categorias" */
  insert_variaveis_base_categorias?: Maybe<Variaveis_Base_Categorias_Mutation_Response>;
  /** insert a single row into the table: "variaveis.base_categorias" */
  insert_variaveis_base_categorias_one?: Maybe<Variaveis_Base_Categorias>;
  /** insert a single row into the table: "variaveis.base" */
  insert_variaveis_base_one?: Maybe<Variaveis_Base>;
  /** insert data into the table: "variaveis.base_propriedades" */
  insert_variaveis_base_propriedades?: Maybe<Variaveis_Base_Propriedades_Mutation_Response>;
  /** insert a single row into the table: "variaveis.base_propriedades" */
  insert_variaveis_base_propriedades_one?: Maybe<Variaveis_Base_Propriedades>;
  /** insert data into the table: "variaveis.calc_variaveis" */
  insert_variaveis_calc_variaveis?: Maybe<Variaveis_Calc_Variaveis_Mutation_Response>;
  /** insert a single row into the table: "variaveis.calc_variaveis" */
  insert_variaveis_calc_variaveis_one?: Maybe<Variaveis_Calc_Variaveis>;
  /** insert data into the table: "variaveis.dominios" */
  insert_variaveis_dominios?: Maybe<Variaveis_Dominios_Mutation_Response>;
  /** insert a single row into the table: "variaveis.dominios" */
  insert_variaveis_dominios_one?: Maybe<Variaveis_Dominios>;
  /** insert data into the table: "variaveis.dominios_r_dominios_valores" */
  insert_variaveis_dominios_r_dominios_valores?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Mutation_Response>;
  /** insert a single row into the table: "variaveis.dominios_r_dominios_valores" */
  insert_variaveis_dominios_r_dominios_valores_one?: Maybe<Variaveis_Dominios_R_Dominios_Valores>;
  /** insert data into the table: "variaveis.dominios_valores" */
  insert_variaveis_dominios_valores?: Maybe<Variaveis_Dominios_Valores_Mutation_Response>;
  /** insert a single row into the table: "variaveis.dominios_valores" */
  insert_variaveis_dominios_valores_one?: Maybe<Variaveis_Dominios_Valores>;
  /** insert data into the table: "variaveis.escalas_precisao" */
  insert_variaveis_escalas_precisao?: Maybe<Variaveis_Escalas_Precisao_Mutation_Response>;
  /** insert a single row into the table: "variaveis.escalas_precisao" */
  insert_variaveis_escalas_precisao_one?: Maybe<Variaveis_Escalas_Precisao>;
  /** insert data into the table: "variaveis.fontes_origem" */
  insert_variaveis_fontes_origem?: Maybe<Variaveis_Fontes_Origem_Mutation_Response>;
  /** insert a single row into the table: "variaveis.fontes_origem" */
  insert_variaveis_fontes_origem_one?: Maybe<Variaveis_Fontes_Origem>;
  /** insert data into the table: "variaveis.fontes_origem_propriedades" */
  insert_variaveis_fontes_origem_propriedades?: Maybe<Variaveis_Fontes_Origem_Propriedades_Mutation_Response>;
  /** insert a single row into the table: "variaveis.fontes_origem_propriedades" */
  insert_variaveis_fontes_origem_propriedades_one?: Maybe<Variaveis_Fontes_Origem_Propriedades>;
  /** insert data into the table: "variaveis.fontes_origem_tipos" */
  insert_variaveis_fontes_origem_tipos?: Maybe<Variaveis_Fontes_Origem_Tipos_Mutation_Response>;
  /** insert a single row into the table: "variaveis.fontes_origem_tipos" */
  insert_variaveis_fontes_origem_tipos_one?: Maybe<Variaveis_Fontes_Origem_Tipos>;
  /** insert data into the table: "variaveis.leituras" */
  insert_variaveis_leituras?: Maybe<Variaveis_Leituras_Mutation_Response>;
  /** insert a single row into the table: "variaveis.leituras" */
  insert_variaveis_leituras_one?: Maybe<Variaveis_Leituras>;
  /** insert data into the table: "variaveis.parametros" */
  insert_variaveis_parametros?: Maybe<Variaveis_Parametros_Mutation_Response>;
  /** insert a single row into the table: "variaveis.parametros" */
  insert_variaveis_parametros_one?: Maybe<Variaveis_Parametros>;
  /** insert data into the table: "variaveis.parametros_r_unidades_medida" */
  insert_variaveis_parametros_r_unidades_medida?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Mutation_Response>;
  /** insert a single row into the table: "variaveis.parametros_r_unidades_medida" */
  insert_variaveis_parametros_r_unidades_medida_one?: Maybe<Variaveis_Parametros_R_Unidades_Medida>;
  /** insert data into the table: "variaveis.tipos" */
  insert_variaveis_tipos?: Maybe<Variaveis_Tipos_Mutation_Response>;
  /** insert a single row into the table: "variaveis.tipos" */
  insert_variaveis_tipos_one?: Maybe<Variaveis_Tipos>;
  /** insert data into the table: "variaveis.totalizadores_tipos_registo" */
  insert_variaveis_totalizadores_tipos_registo?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Mutation_Response>;
  /** insert a single row into the table: "variaveis.totalizadores_tipos_registo" */
  insert_variaveis_totalizadores_tipos_registo_one?: Maybe<Variaveis_Totalizadores_Tipos_Registo>;
  /** insert data into the table: "variaveis.unidades_medida" */
  insert_variaveis_unidades_medida?: Maybe<Variaveis_Unidades_Medida_Mutation_Response>;
  /** insert a single row into the table: "variaveis.unidades_medida" */
  insert_variaveis_unidades_medida_one?: Maybe<Variaveis_Unidades_Medida>;
  /** insert data into the table: "variaveis.valores_mensais" */
  insert_variaveis_valores_mensais?: Maybe<Variaveis_Valores_Mensais_Mutation_Response>;
  /** insert a single row into the table: "variaveis.valores_mensais" */
  insert_variaveis_valores_mensais_one?: Maybe<Variaveis_Valores_Mensais>;
  saveDailyFlowExpression?: Maybe<SaveDailyFlowExpressionResponse>;
  /** update data of the table: "base.bulk_tipos" */
  update_base_bulk_tipos?: Maybe<Base_Bulk_Tipos_Mutation_Response>;
  /** update single row of the table: "base.bulk_tipos" */
  update_base_bulk_tipos_by_pk?: Maybe<Base_Bulk_Tipos>;
  /** update multiples rows of table: "base.bulk_tipos" */
  update_base_bulk_tipos_many?: Maybe<Array<Maybe<Base_Bulk_Tipos_Mutation_Response>>>;
  /** update data of the table: "base.centros" */
  update_base_centros?: Maybe<Base_Centros_Mutation_Response>;
  /** update single row of the table: "base.centros" */
  update_base_centros_by_pk?: Maybe<Base_Centros>;
  /** update multiples rows of table: "base.centros" */
  update_base_centros_many?: Maybe<Array<Maybe<Base_Centros_Mutation_Response>>>;
  /** update data of the table: "base.infraestruturas" */
  update_base_infraestruturas?: Maybe<Base_Infraestruturas_Mutation_Response>;
  /** update single row of the table: "base.infraestruturas" */
  update_base_infraestruturas_by_pk?: Maybe<Base_Infraestruturas>;
  /** update data of the table: "base.infraestruturas_coordenadas" */
  update_base_infraestruturas_coordenadas?: Maybe<Base_Infraestruturas_Coordenadas_Mutation_Response>;
  /** update single row of the table: "base.infraestruturas_coordenadas" */
  update_base_infraestruturas_coordenadas_by_pk?: Maybe<Base_Infraestruturas_Coordenadas>;
  /** update multiples rows of table: "base.infraestruturas_coordenadas" */
  update_base_infraestruturas_coordenadas_many?: Maybe<Array<Maybe<Base_Infraestruturas_Coordenadas_Mutation_Response>>>;
  /** update multiples rows of table: "base.infraestruturas" */
  update_base_infraestruturas_many?: Maybe<Array<Maybe<Base_Infraestruturas_Mutation_Response>>>;
  /** update data of the table: "base.infraestruturas_r_toponimias" */
  update_base_infraestruturas_r_toponimias?: Maybe<Base_Infraestruturas_R_Toponimias_Mutation_Response>;
  /** update single row of the table: "base.infraestruturas_r_toponimias" */
  update_base_infraestruturas_r_toponimias_by_pk?: Maybe<Base_Infraestruturas_R_Toponimias>;
  /** update multiples rows of table: "base.infraestruturas_r_toponimias" */
  update_base_infraestruturas_r_toponimias_many?: Maybe<Array<Maybe<Base_Infraestruturas_R_Toponimias_Mutation_Response>>>;
  /** update data of the table: "base.infraestruturas_tipos" */
  update_base_infraestruturas_tipos?: Maybe<Base_Infraestruturas_Tipos_Mutation_Response>;
  /** update single row of the table: "base.infraestruturas_tipos" */
  update_base_infraestruturas_tipos_by_pk?: Maybe<Base_Infraestruturas_Tipos>;
  /** update multiples rows of table: "base.infraestruturas_tipos" */
  update_base_infraestruturas_tipos_many?: Maybe<Array<Maybe<Base_Infraestruturas_Tipos_Mutation_Response>>>;
  /** update data of the table: "base.parametrizacoes" */
  update_base_parametrizacoes?: Maybe<Base_Parametrizacoes_Mutation_Response>;
  /** update multiples rows of table: "base.parametrizacoes" */
  update_base_parametrizacoes_many?: Maybe<Array<Maybe<Base_Parametrizacoes_Mutation_Response>>>;
  /** update data of the table: "base.toponimias" */
  update_base_toponimias?: Maybe<Base_Toponimias_Mutation_Response>;
  /** update single row of the table: "base.toponimias" */
  update_base_toponimias_by_pk?: Maybe<Base_Toponimias>;
  /** update data of the table: "base.toponimias_coordenadas" */
  update_base_toponimias_coordenadas?: Maybe<Base_Toponimias_Coordenadas_Mutation_Response>;
  /** update single row of the table: "base.toponimias_coordenadas" */
  update_base_toponimias_coordenadas_by_pk?: Maybe<Base_Toponimias_Coordenadas>;
  /** update multiples rows of table: "base.toponimias_coordenadas" */
  update_base_toponimias_coordenadas_many?: Maybe<Array<Maybe<Base_Toponimias_Coordenadas_Mutation_Response>>>;
  /** update multiples rows of table: "base.toponimias" */
  update_base_toponimias_many?: Maybe<Array<Maybe<Base_Toponimias_Mutation_Response>>>;
  /** update data of the table: "base.zmc" */
  update_base_zmc?: Maybe<Base_Zmc_Mutation_Response>;
  /** update single row of the table: "base.zmc" */
  update_base_zmc_by_pk?: Maybe<Base_Zmc>;
  /** update multiples rows of table: "base.zmc" */
  update_base_zmc_many?: Maybe<Array<Maybe<Base_Zmc_Mutation_Response>>>;
  /** update data of the table: "base.zmc_nos_tipo" */
  update_base_zmc_nos_tipo?: Maybe<Base_Zmc_Nos_Tipo_Mutation_Response>;
  /** update single row of the table: "base.zmc_nos_tipo" */
  update_base_zmc_nos_tipo_by_pk?: Maybe<Base_Zmc_Nos_Tipo>;
  /** update multiples rows of table: "base.zmc_nos_tipo" */
  update_base_zmc_nos_tipo_many?: Maybe<Array<Maybe<Base_Zmc_Nos_Tipo_Mutation_Response>>>;
  /** update data of the table: "consultas.requisicoes" */
  update_consultas_requisicoes?: Maybe<Consultas_Requisicoes_Mutation_Response>;
  /** update single row of the table: "consultas.requisicoes" */
  update_consultas_requisicoes_by_pk?: Maybe<Consultas_Requisicoes>;
  /** update multiples rows of table: "consultas.requisicoes" */
  update_consultas_requisicoes_many?: Maybe<Array<Maybe<Consultas_Requisicoes_Mutation_Response>>>;
  /** update data of the table: "integracoes.ad_parametrizacao" */
  update_integracoes_ad_parametrizacao?: Maybe<Integracoes_Ad_Parametrizacao_Mutation_Response>;
  /** update multiples rows of table: "integracoes.ad_parametrizacao" */
  update_integracoes_ad_parametrizacao_many?: Maybe<Array<Maybe<Integracoes_Ad_Parametrizacao_Mutation_Response>>>;
  /** update data of the table: "integracoes.ad_saml_parametrizacao" */
  update_integracoes_ad_saml_parametrizacao?: Maybe<Integracoes_Ad_Saml_Parametrizacao_Mutation_Response>;
  /** update single row of the table: "integracoes.ad_saml_parametrizacao" */
  update_integracoes_ad_saml_parametrizacao_by_pk?: Maybe<Integracoes_Ad_Saml_Parametrizacao>;
  /** update multiples rows of table: "integracoes.ad_saml_parametrizacao" */
  update_integracoes_ad_saml_parametrizacao_many?: Maybe<Array<Maybe<Integracoes_Ad_Saml_Parametrizacao_Mutation_Response>>>;
  /** update data of the table: "integracoes.sig_maps_ortos" */
  update_integracoes_sig_maps_ortos?: Maybe<Integracoes_Sig_Maps_Ortos_Mutation_Response>;
  /** update single row of the table: "integracoes.sig_maps_ortos" */
  update_integracoes_sig_maps_ortos_by_pk?: Maybe<Integracoes_Sig_Maps_Ortos>;
  /** update multiples rows of table: "integracoes.sig_maps_ortos" */
  update_integracoes_sig_maps_ortos_many?: Maybe<Array<Maybe<Integracoes_Sig_Maps_Ortos_Mutation_Response>>>;
  /** update data of the table: "integracoes.sig_parametrizacao" */
  update_integracoes_sig_parametrizacao?: Maybe<Integracoes_Sig_Parametrizacao_Mutation_Response>;
  /** update multiples rows of table: "integracoes.sig_parametrizacao" */
  update_integracoes_sig_parametrizacao_many?: Maybe<Array<Maybe<Integracoes_Sig_Parametrizacao_Mutation_Response>>>;
  /** update data of the table: "integracoes.sig_proxy" */
  update_integracoes_sig_proxy?: Maybe<Integracoes_Sig_Proxy_Mutation_Response>;
  /** update single row of the table: "integracoes.sig_proxy" */
  update_integracoes_sig_proxy_by_pk?: Maybe<Integracoes_Sig_Proxy>;
  /** update multiples rows of table: "integracoes.sig_proxy" */
  update_integracoes_sig_proxy_many?: Maybe<Array<Maybe<Integracoes_Sig_Proxy_Mutation_Response>>>;
  /** update data of the table: "integracoes.sig_request_get_attributes" */
  update_integracoes_sig_request_get_attributes?: Maybe<Integracoes_Sig_Request_Get_Attributes_Mutation_Response>;
  /** update multiples rows of table: "integracoes.sig_request_get_attributes" */
  update_integracoes_sig_request_get_attributes_many?: Maybe<Array<Maybe<Integracoes_Sig_Request_Get_Attributes_Mutation_Response>>>;
  /** update data of the table: "integracoes.sig_request_get_capabilities" */
  update_integracoes_sig_request_get_capabilities?: Maybe<Integracoes_Sig_Request_Get_Capabilities_Mutation_Response>;
  /** update multiples rows of table: "integracoes.sig_request_get_capabilities" */
  update_integracoes_sig_request_get_capabilities_many?: Maybe<Array<Maybe<Integracoes_Sig_Request_Get_Capabilities_Mutation_Response>>>;
  /** update data of the table: "integracoes.sig_request_get_features" */
  update_integracoes_sig_request_get_features?: Maybe<Integracoes_Sig_Request_Get_Features_Mutation_Response>;
  /** update multiples rows of table: "integracoes.sig_request_get_features" */
  update_integracoes_sig_request_get_features_many?: Maybe<Array<Maybe<Integracoes_Sig_Request_Get_Features_Mutation_Response>>>;
  /** update data of the table: "integracoes.sig_services" */
  update_integracoes_sig_services?: Maybe<Integracoes_Sig_Services_Mutation_Response>;
  /** update single row of the table: "integracoes.sig_services" */
  update_integracoes_sig_services_by_pk?: Maybe<Integracoes_Sig_Services>;
  /** update multiples rows of table: "integracoes.sig_services" */
  update_integracoes_sig_services_many?: Maybe<Array<Maybe<Integracoes_Sig_Services_Mutation_Response>>>;
  /** update data of the table: "mensagens.anexos" */
  update_mensagens_anexos?: Maybe<Mensagens_Anexos_Mutation_Response>;
  /** update single row of the table: "mensagens.anexos" */
  update_mensagens_anexos_by_pk?: Maybe<Mensagens_Anexos>;
  /** update multiples rows of table: "mensagens.anexos" */
  update_mensagens_anexos_many?: Maybe<Array<Maybe<Mensagens_Anexos_Mutation_Response>>>;
  /** update data of the table: "mensagens.mensagens" */
  update_mensagens_mensagens?: Maybe<Mensagens_Mensagens_Mutation_Response>;
  /** update single row of the table: "mensagens.mensagens" */
  update_mensagens_mensagens_by_pk?: Maybe<Mensagens_Mensagens>;
  /** update multiples rows of table: "mensagens.mensagens" */
  update_mensagens_mensagens_many?: Maybe<Array<Maybe<Mensagens_Mensagens_Mutation_Response>>>;
  /** update data of the table: "mensagens.post" */
  update_mensagens_post?: Maybe<Mensagens_Post_Mutation_Response>;
  /** update single row of the table: "mensagens.post" */
  update_mensagens_post_by_pk?: Maybe<Mensagens_Post>;
  /** update multiples rows of table: "mensagens.post" */
  update_mensagens_post_many?: Maybe<Array<Maybe<Mensagens_Post_Mutation_Response>>>;
  /** update data of the table: "mobile.coordenadas" */
  update_mobile_coordenadas?: Maybe<Mobile_Coordenadas_Mutation_Response>;
  /** update single row of the table: "mobile.coordenadas" */
  update_mobile_coordenadas_by_pk?: Maybe<Mobile_Coordenadas>;
  /** update multiples rows of table: "mobile.coordenadas" */
  update_mobile_coordenadas_many?: Maybe<Array<Maybe<Mobile_Coordenadas_Mutation_Response>>>;
  /** update data of the table: "navia.cores" */
  update_navia_cores?: Maybe<Navia_Cores_Mutation_Response>;
  /** update single row of the table: "navia.cores" */
  update_navia_cores_by_pk?: Maybe<Navia_Cores>;
  /** update multiples rows of table: "navia.cores" */
  update_navia_cores_many?: Maybe<Array<Maybe<Navia_Cores_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  update_navia_dashboards_diagnostico_roturas_infraestruturas_variaveis?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  update_navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis>;
  /** update multiples rows of table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  update_navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_many?: Maybe<Array<Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  update_navia_dashboards_diagnostico_roturas_mapa_niveis?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  update_navia_dashboards_diagnostico_roturas_mapa_niveis_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis>;
  /** update multiples rows of table: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  update_navia_dashboards_diagnostico_roturas_mapa_niveis_many?: Maybe<Array<Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.diagnostico_roturas_sintomas" */
  update_navia_dashboards_diagnostico_roturas_sintomas?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.diagnostico_roturas_sintomas" */
  update_navia_dashboards_diagnostico_roturas_sintomas_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas>;
  /** update multiples rows of table: "navia_dashboards.diagnostico_roturas_sintomas" */
  update_navia_dashboards_diagnostico_roturas_sintomas_many?: Maybe<Array<Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  update_navia_dashboards_diagnostico_roturas_sintomas_tipos?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  update_navia_dashboards_diagnostico_roturas_sintomas_tipos_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos>;
  /** update multiples rows of table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  update_navia_dashboards_diagnostico_roturas_sintomas_tipos_many?: Maybe<Array<Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  update_navia_dashboards_diagnostico_roturas_tipos_infraestrutura?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  update_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura>;
  /** update multiples rows of table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  update_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_many?: Maybe<Array<Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  update_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  update_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc>;
  /** update multiples rows of table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  update_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_many?: Maybe<Array<Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.menu" */
  update_navia_dashboards_menu?: Maybe<Navia_Dashboards_Menu_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.menu" */
  update_navia_dashboards_menu_by_pk?: Maybe<Navia_Dashboards_Menu>;
  /** update multiples rows of table: "navia_dashboards.menu" */
  update_navia_dashboards_menu_many?: Maybe<Array<Maybe<Navia_Dashboards_Menu_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.menu_r_transacoes" */
  update_navia_dashboards_menu_r_transacoes?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.menu_r_transacoes" */
  update_navia_dashboards_menu_r_transacoes_by_pk?: Maybe<Navia_Dashboards_Menu_R_Transacoes>;
  /** update multiples rows of table: "navia_dashboards.menu_r_transacoes" */
  update_navia_dashboards_menu_r_transacoes_many?: Maybe<Array<Maybe<Navia_Dashboards_Menu_R_Transacoes_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.modo_tv_tokens" */
  update_navia_dashboards_modo_tv_tokens?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.modo_tv_tokens" */
  update_navia_dashboards_modo_tv_tokens_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens>;
  /** update multiples rows of table: "navia_dashboards.modo_tv_tokens" */
  update_navia_dashboards_modo_tv_tokens_many?: Maybe<Array<Maybe<Navia_Dashboards_Modo_Tv_Tokens_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  update_navia_dashboards_modo_tv_tokens_revogacao_manual?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  update_navia_dashboards_modo_tv_tokens_revogacao_manual_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual>;
  /** update multiples rows of table: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  update_navia_dashboards_modo_tv_tokens_revogacao_manual_many?: Maybe<Array<Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.modo_tv_tokens_validados" */
  update_navia_dashboards_modo_tv_tokens_validados?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.modo_tv_tokens_validados" */
  update_navia_dashboards_modo_tv_tokens_validados_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados>;
  /** update multiples rows of table: "navia_dashboards.modo_tv_tokens_validados" */
  update_navia_dashboards_modo_tv_tokens_validados_many?: Maybe<Array<Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.monitorizacao_roturas_causas" */
  update_navia_dashboards_monitorizacao_roturas_causas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.monitorizacao_roturas_causas" */
  update_navia_dashboards_monitorizacao_roturas_causas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas>;
  /** update multiples rows of table: "navia_dashboards.monitorizacao_roturas_causas" */
  update_navia_dashboards_monitorizacao_roturas_causas_many?: Maybe<Array<Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  update_navia_dashboards_monitorizacao_roturas_causas_r_causas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  update_navia_dashboards_monitorizacao_roturas_causas_r_causas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas>;
  /** update multiples rows of table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  update_navia_dashboards_monitorizacao_roturas_causas_r_causas_many?: Maybe<Array<Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.monitorizacao_roturas_indicadores" */
  update_navia_dashboards_monitorizacao_roturas_indicadores?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.monitorizacao_roturas_indicadores" */
  update_navia_dashboards_monitorizacao_roturas_indicadores_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores>;
  /** update multiples rows of table: "navia_dashboards.monitorizacao_roturas_indicadores" */
  update_navia_dashboards_monitorizacao_roturas_indicadores_many?: Maybe<Array<Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.monitorizacao_roturas_sintomas" */
  update_navia_dashboards_monitorizacao_roturas_sintomas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.monitorizacao_roturas_sintomas" */
  update_navia_dashboards_monitorizacao_roturas_sintomas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas>;
  /** update multiples rows of table: "navia_dashboards.monitorizacao_roturas_sintomas" */
  update_navia_dashboards_monitorizacao_roturas_sintomas_many?: Maybe<Array<Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  update_navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  update_navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas>;
  /** update multiples rows of table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  update_navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_many?: Maybe<Array<Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.monitorizacao_roturas_variaveis" */
  update_navia_dashboards_monitorizacao_roturas_variaveis?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.monitorizacao_roturas_variaveis" */
  update_navia_dashboards_monitorizacao_roturas_variaveis_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis>;
  /** update multiples rows of table: "navia_dashboards.monitorizacao_roturas_variaveis" */
  update_navia_dashboards_monitorizacao_roturas_variaveis_many?: Maybe<Array<Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  update_navia_dashboards_performance_infraestrutura_parametrizacao?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  update_navia_dashboards_performance_infraestrutura_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao>;
  /** update multiples rows of table: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  update_navia_dashboards_performance_infraestrutura_parametrizacao_many?: Maybe<Array<Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  update_navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  update_navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao>;
  /** update multiples rows of table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  update_navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_many?: Maybe<Array<Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa>;
  /** update multiples rows of table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_many?: Maybe<Array<Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas>;
  /** update multiples rows of table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_many?: Maybe<Array<Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores>;
  /** update multiples rows of table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_many?: Maybe<Array<Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura>;
  /** update multiples rows of table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  update_navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_many?: Maybe<Array<Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  update_navia_dashboards_requisicoes_indicadores_parametrizacao?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  update_navia_dashboards_requisicoes_indicadores_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao>;
  /** update multiples rows of table: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  update_navia_dashboards_requisicoes_indicadores_parametrizacao_many?: Maybe<Array<Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  update_navia_dashboards_requisicoes_mapa_parametrizacao?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  update_navia_dashboards_requisicoes_mapa_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao>;
  /** update multiples rows of table: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  update_navia_dashboards_requisicoes_mapa_parametrizacao_many?: Maybe<Array<Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.visao_360_parametrizacao" */
  update_navia_dashboards_visao_360_parametrizacao?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.visao_360_parametrizacao" */
  update_navia_dashboards_visao_360_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao>;
  /** update multiples rows of table: "navia_dashboards.visao_360_parametrizacao" */
  update_navia_dashboards_visao_360_parametrizacao_many?: Maybe<Array<Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.visao_360_selectores" */
  update_navia_dashboards_visao_360_selectores?: Maybe<Navia_Dashboards_Visao_360_Selectores_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.visao_360_selectores" */
  update_navia_dashboards_visao_360_selectores_by_pk?: Maybe<Navia_Dashboards_Visao_360_Selectores>;
  /** update multiples rows of table: "navia_dashboards.visao_360_selectores" */
  update_navia_dashboards_visao_360_selectores_many?: Maybe<Array<Maybe<Navia_Dashboards_Visao_360_Selectores_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.volumes_diarios_caudais" */
  update_navia_dashboards_volumes_diarios_caudais?: Maybe<Navia_Dashboards_Volumes_Diarios_Caudais_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.volumes_diarios_caudais" */
  update_navia_dashboards_volumes_diarios_caudais_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Caudais>;
  /** update multiples rows of table: "navia_dashboards.volumes_diarios_caudais" */
  update_navia_dashboards_volumes_diarios_caudais_many?: Maybe<Array<Maybe<Navia_Dashboards_Volumes_Diarios_Caudais_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.volumes_diarios_dados" */
  update_navia_dashboards_volumes_diarios_dados?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.volumes_diarios_dados" */
  update_navia_dashboards_volumes_diarios_dados_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados>;
  /** update multiples rows of table: "navia_dashboards.volumes_diarios_dados" */
  update_navia_dashboards_volumes_diarios_dados_many?: Maybe<Array<Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  update_navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  update_navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios>;
  /** update multiples rows of table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  update_navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_many?: Maybe<Array<Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.volumes_diarios_leituras" */
  update_navia_dashboards_volumes_diarios_leituras?: Maybe<Navia_Dashboards_Volumes_Diarios_Leituras_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.volumes_diarios_leituras" */
  update_navia_dashboards_volumes_diarios_leituras_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Leituras>;
  /** update multiples rows of table: "navia_dashboards.volumes_diarios_leituras" */
  update_navia_dashboards_volumes_diarios_leituras_many?: Maybe<Array<Maybe<Navia_Dashboards_Volumes_Diarios_Leituras_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.volumes_diarios_locais" */
  update_navia_dashboards_volumes_diarios_locais?: Maybe<Navia_Dashboards_Volumes_Diarios_Locais_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.volumes_diarios_locais" */
  update_navia_dashboards_volumes_diarios_locais_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Locais>;
  /** update multiples rows of table: "navia_dashboards.volumes_diarios_locais" */
  update_navia_dashboards_volumes_diarios_locais_many?: Maybe<Array<Maybe<Navia_Dashboards_Volumes_Diarios_Locais_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.volumes_diarios_municipios" */
  update_navia_dashboards_volumes_diarios_municipios?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.volumes_diarios_municipios" */
  update_navia_dashboards_volumes_diarios_municipios_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios>;
  /** update multiples rows of table: "navia_dashboards.volumes_diarios_municipios" */
  update_navia_dashboards_volumes_diarios_municipios_many?: Maybe<Array<Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.volumes_diarios_registos" */
  update_navia_dashboards_volumes_diarios_registos?: Maybe<Navia_Dashboards_Volumes_Diarios_Registos_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.volumes_diarios_registos" */
  update_navia_dashboards_volumes_diarios_registos_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Registos>;
  /** update multiples rows of table: "navia_dashboards.volumes_diarios_registos" */
  update_navia_dashboards_volumes_diarios_registos_many?: Maybe<Array<Maybe<Navia_Dashboards_Volumes_Diarios_Registos_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  update_navia_dashboards_volumes_diarios_totalizador_leituras?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  update_navia_dashboards_volumes_diarios_totalizador_leituras_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras>;
  /** update multiples rows of table: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  update_navia_dashboards_volumes_diarios_totalizador_leituras_many?: Maybe<Array<Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Mutation_Response>>>;
  /** update data of the table: "navia_dashboards.volumes_diarios_totalizadores" */
  update_navia_dashboards_volumes_diarios_totalizadores?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Mutation_Response>;
  /** update single row of the table: "navia_dashboards.volumes_diarios_totalizadores" */
  update_navia_dashboards_volumes_diarios_totalizadores_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores>;
  /** update multiples rows of table: "navia_dashboards.volumes_diarios_totalizadores" */
  update_navia_dashboards_volumes_diarios_totalizadores_many?: Maybe<Array<Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Mutation_Response>>>;
  /** update data of the table: "navia.integracoes" */
  update_navia_integracoes?: Maybe<Navia_Integracoes_Mutation_Response>;
  /** update single row of the table: "navia.integracoes" */
  update_navia_integracoes_by_pk?: Maybe<Navia_Integracoes>;
  /** update multiples rows of table: "navia.integracoes" */
  update_navia_integracoes_many?: Maybe<Array<Maybe<Navia_Integracoes_Mutation_Response>>>;
  /** update data of the table: "navia.log" */
  update_navia_log?: Maybe<Navia_Log_Mutation_Response>;
  /** update single row of the table: "navia.log" */
  update_navia_log_by_pk?: Maybe<Navia_Log>;
  /** update multiples rows of table: "navia.log" */
  update_navia_log_many?: Maybe<Array<Maybe<Navia_Log_Mutation_Response>>>;
  /** update data of the table: "notificacoes.itens" */
  update_notificacoes_itens?: Maybe<Notificacoes_Itens_Mutation_Response>;
  /** update single row of the table: "notificacoes.itens" */
  update_notificacoes_itens_by_pk?: Maybe<Notificacoes_Itens>;
  /** update multiples rows of table: "notificacoes.itens" */
  update_notificacoes_itens_many?: Maybe<Array<Maybe<Notificacoes_Itens_Mutation_Response>>>;
  /** update data of the table: "notificacoes.notificacoes" */
  update_notificacoes_notificacoes?: Maybe<Notificacoes_Notificacoes_Mutation_Response>;
  /** update single row of the table: "notificacoes.notificacoes" */
  update_notificacoes_notificacoes_by_pk?: Maybe<Notificacoes_Notificacoes>;
  /** update multiples rows of table: "notificacoes.notificacoes" */
  update_notificacoes_notificacoes_many?: Maybe<Array<Maybe<Notificacoes_Notificacoes_Mutation_Response>>>;
  /** update data of the table: "notificacoes.notificacoes_r_utilizadores" */
  update_notificacoes_notificacoes_r_utilizadores?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Mutation_Response>;
  /** update single row of the table: "notificacoes.notificacoes_r_utilizadores" */
  update_notificacoes_notificacoes_r_utilizadores_by_pk?: Maybe<Notificacoes_Notificacoes_R_Utilizadores>;
  /** update multiples rows of table: "notificacoes.notificacoes_r_utilizadores" */
  update_notificacoes_notificacoes_r_utilizadores_many?: Maybe<Array<Maybe<Notificacoes_Notificacoes_R_Utilizadores_Mutation_Response>>>;
  /** update data of the table: "notificacoes.tipos" */
  update_notificacoes_tipos?: Maybe<Notificacoes_Tipos_Mutation_Response>;
  /** update single row of the table: "notificacoes.tipos" */
  update_notificacoes_tipos_by_pk?: Maybe<Notificacoes_Tipos>;
  /** update multiples rows of table: "notificacoes.tipos" */
  update_notificacoes_tipos_many?: Maybe<Array<Maybe<Notificacoes_Tipos_Mutation_Response>>>;
  /** update data of the table: "permissoes.transacoes" */
  update_permissoes_transacoes?: Maybe<Permissoes_Transacoes_Mutation_Response>;
  /** update single row of the table: "permissoes.transacoes" */
  update_permissoes_transacoes_by_pk?: Maybe<Permissoes_Transacoes>;
  /** update multiples rows of table: "permissoes.transacoes" */
  update_permissoes_transacoes_many?: Maybe<Array<Maybe<Permissoes_Transacoes_Mutation_Response>>>;
  /** update data of the table: "permissoes.transacoes_r_menus" */
  update_permissoes_transacoes_r_menus?: Maybe<Permissoes_Transacoes_R_Menus_Mutation_Response>;
  /** update single row of the table: "permissoes.transacoes_r_menus" */
  update_permissoes_transacoes_r_menus_by_pk?: Maybe<Permissoes_Transacoes_R_Menus>;
  /** update multiples rows of table: "permissoes.transacoes_r_menus" */
  update_permissoes_transacoes_r_menus_many?: Maybe<Array<Maybe<Permissoes_Transacoes_R_Menus_Mutation_Response>>>;
  /** update data of the table: "rqs.parametrizacao" */
  update_rqs_parametrizacao?: Maybe<Rqs_Parametrizacao_Mutation_Response>;
  /** update multiples rows of table: "rqs.parametrizacao" */
  update_rqs_parametrizacao_many?: Maybe<Array<Maybe<Rqs_Parametrizacao_Mutation_Response>>>;
  /** update data of the table: "rqs.requisicoes_periodos" */
  update_rqs_requisicoes_periodos?: Maybe<Rqs_Requisicoes_Periodos_Mutation_Response>;
  /** update single row of the table: "rqs.requisicoes_periodos" */
  update_rqs_requisicoes_periodos_by_pk?: Maybe<Rqs_Requisicoes_Periodos>;
  /** update multiples rows of table: "rqs.requisicoes_periodos" */
  update_rqs_requisicoes_periodos_many?: Maybe<Array<Maybe<Rqs_Requisicoes_Periodos_Mutation_Response>>>;
  /** update data of the table: "rqs.requisicoes_tempos_wrap" */
  update_rqs_requisicoes_tempos_wrap?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Mutation_Response>;
  /** update single row of the table: "rqs.requisicoes_tempos_wrap" */
  update_rqs_requisicoes_tempos_wrap_by_pk?: Maybe<Rqs_Requisicoes_Tempos_Wrap>;
  /** update multiples rows of table: "rqs.requisicoes_tempos_wrap" */
  update_rqs_requisicoes_tempos_wrap_many?: Maybe<Array<Maybe<Rqs_Requisicoes_Tempos_Wrap_Mutation_Response>>>;
  /** update data of the table: "rqs.sintomas" */
  update_rqs_sintomas?: Maybe<Rqs_Sintomas_Mutation_Response>;
  /** update single row of the table: "rqs.sintomas" */
  update_rqs_sintomas_by_pk?: Maybe<Rqs_Sintomas>;
  /** update multiples rows of table: "rqs.sintomas" */
  update_rqs_sintomas_many?: Maybe<Array<Maybe<Rqs_Sintomas_Mutation_Response>>>;
  /** update data of the table: "rqs.sintomas_parametrizacao_tempos" */
  update_rqs_sintomas_parametrizacao_tempos?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Mutation_Response>;
  /** update single row of the table: "rqs.sintomas_parametrizacao_tempos" */
  update_rqs_sintomas_parametrizacao_tempos_by_pk?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos>;
  /** update multiples rows of table: "rqs.sintomas_parametrizacao_tempos" */
  update_rqs_sintomas_parametrizacao_tempos_many?: Maybe<Array<Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Mutation_Response>>>;
  /** update data of the table: "servicos.fases" */
  update_servicos_fases?: Maybe<Servicos_Fases_Mutation_Response>;
  /** update single row of the table: "servicos.fases" */
  update_servicos_fases_by_pk?: Maybe<Servicos_Fases>;
  /** update multiples rows of table: "servicos.fases" */
  update_servicos_fases_many?: Maybe<Array<Maybe<Servicos_Fases_Mutation_Response>>>;
  /** update data of the table: "servicos.intervencoes" */
  update_servicos_intervencoes?: Maybe<Servicos_Intervencoes_Mutation_Response>;
  /** update data of the table: "servicos.intervencoes_atribuicao_utilizadores" */
  update_servicos_intervencoes_atribuicao_utilizadores?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Mutation_Response>;
  /** update single row of the table: "servicos.intervencoes_atribuicao_utilizadores" */
  update_servicos_intervencoes_atribuicao_utilizadores_by_pk?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores>;
  /** update multiples rows of table: "servicos.intervencoes_atribuicao_utilizadores" */
  update_servicos_intervencoes_atribuicao_utilizadores_many?: Maybe<Array<Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Mutation_Response>>>;
  /** update single row of the table: "servicos.intervencoes" */
  update_servicos_intervencoes_by_pk?: Maybe<Servicos_Intervencoes>;
  /** update data of the table: "servicos.intervencoes_estados" */
  update_servicos_intervencoes_estados?: Maybe<Servicos_Intervencoes_Estados_Mutation_Response>;
  /** update single row of the table: "servicos.intervencoes_estados" */
  update_servicos_intervencoes_estados_by_pk?: Maybe<Servicos_Intervencoes_Estados>;
  /** update multiples rows of table: "servicos.intervencoes_estados" */
  update_servicos_intervencoes_estados_many?: Maybe<Array<Maybe<Servicos_Intervencoes_Estados_Mutation_Response>>>;
  /** update multiples rows of table: "servicos.intervencoes" */
  update_servicos_intervencoes_many?: Maybe<Array<Maybe<Servicos_Intervencoes_Mutation_Response>>>;
  /** update data of the table: "servicos.intervencoes_r_causas_trabalhos" */
  update_servicos_intervencoes_r_causas_trabalhos?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Mutation_Response>;
  /** update single row of the table: "servicos.intervencoes_r_causas_trabalhos" */
  update_servicos_intervencoes_r_causas_trabalhos_by_pk?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos>;
  /** update multiples rows of table: "servicos.intervencoes_r_causas_trabalhos" */
  update_servicos_intervencoes_r_causas_trabalhos_many?: Maybe<Array<Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Mutation_Response>>>;
  /** update data of the table: "servicos.rastreabilidade" */
  update_servicos_rastreabilidade?: Maybe<Servicos_Rastreabilidade_Mutation_Response>;
  /** update single row of the table: "servicos.rastreabilidade" */
  update_servicos_rastreabilidade_by_pk?: Maybe<Servicos_Rastreabilidade>;
  /** update multiples rows of table: "servicos.rastreabilidade" */
  update_servicos_rastreabilidade_many?: Maybe<Array<Maybe<Servicos_Rastreabilidade_Mutation_Response>>>;
  /** update data of the table: "servicos.requisicoes" */
  update_servicos_requisicoes?: Maybe<Servicos_Requisicoes_Mutation_Response>;
  /** update single row of the table: "servicos.requisicoes" */
  update_servicos_requisicoes_by_pk?: Maybe<Servicos_Requisicoes>;
  /** update data of the table: "servicos.requisicoes_estados" */
  update_servicos_requisicoes_estados?: Maybe<Servicos_Requisicoes_Estados_Mutation_Response>;
  /** update single row of the table: "servicos.requisicoes_estados" */
  update_servicos_requisicoes_estados_by_pk?: Maybe<Servicos_Requisicoes_Estados>;
  /** update multiples rows of table: "servicos.requisicoes_estados" */
  update_servicos_requisicoes_estados_many?: Maybe<Array<Maybe<Servicos_Requisicoes_Estados_Mutation_Response>>>;
  /** update data of the table: "servicos.requisicoes_locais_infra_estruturas" */
  update_servicos_requisicoes_locais_infra_estruturas?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Mutation_Response>;
  /** update single row of the table: "servicos.requisicoes_locais_infra_estruturas" */
  update_servicos_requisicoes_locais_infra_estruturas_by_pk?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas>;
  /** update multiples rows of table: "servicos.requisicoes_locais_infra_estruturas" */
  update_servicos_requisicoes_locais_infra_estruturas_many?: Maybe<Array<Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Mutation_Response>>>;
  /** update multiples rows of table: "servicos.requisicoes" */
  update_servicos_requisicoes_many?: Maybe<Array<Maybe<Servicos_Requisicoes_Mutation_Response>>>;
  /** update data of the table: "servicos.requisicoes_r_intervencoes" */
  update_servicos_requisicoes_r_intervencoes?: Maybe<Servicos_Requisicoes_R_Intervencoes_Mutation_Response>;
  /** update single row of the table: "servicos.requisicoes_r_intervencoes" */
  update_servicos_requisicoes_r_intervencoes_by_pk?: Maybe<Servicos_Requisicoes_R_Intervencoes>;
  /** update multiples rows of table: "servicos.requisicoes_r_intervencoes" */
  update_servicos_requisicoes_r_intervencoes_many?: Maybe<Array<Maybe<Servicos_Requisicoes_R_Intervencoes_Mutation_Response>>>;
  /** update data of the table: "sintomas.arvore" */
  update_sintomas_arvore?: Maybe<Sintomas_Arvore_Mutation_Response>;
  /** update single row of the table: "sintomas.arvore" */
  update_sintomas_arvore_by_pk?: Maybe<Sintomas_Arvore>;
  /** update multiples rows of table: "sintomas.arvore" */
  update_sintomas_arvore_many?: Maybe<Array<Maybe<Sintomas_Arvore_Mutation_Response>>>;
  /** update data of the table: "sintomas.causas_trabalhos" */
  update_sintomas_causas_trabalhos?: Maybe<Sintomas_Causas_Trabalhos_Mutation_Response>;
  /** update single row of the table: "sintomas.causas_trabalhos" */
  update_sintomas_causas_trabalhos_by_pk?: Maybe<Sintomas_Causas_Trabalhos>;
  /** update multiples rows of table: "sintomas.causas_trabalhos" */
  update_sintomas_causas_trabalhos_many?: Maybe<Array<Maybe<Sintomas_Causas_Trabalhos_Mutation_Response>>>;
  /** update data of the table: "sintomas.sintomas_relacao" */
  update_sintomas_sintomas_relacao?: Maybe<Sintomas_Sintomas_Relacao_Mutation_Response>;
  /** update single row of the table: "sintomas.sintomas_relacao" */
  update_sintomas_sintomas_relacao_by_pk?: Maybe<Sintomas_Sintomas_Relacao>;
  /** update multiples rows of table: "sintomas.sintomas_relacao" */
  update_sintomas_sintomas_relacao_many?: Maybe<Array<Maybe<Sintomas_Sintomas_Relacao_Mutation_Response>>>;
  /** update data of the table: "sintomas.sintomas_relacao_ordem" */
  update_sintomas_sintomas_relacao_ordem?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Mutation_Response>;
  /** update single row of the table: "sintomas.sintomas_relacao_ordem" */
  update_sintomas_sintomas_relacao_ordem_by_pk?: Maybe<Sintomas_Sintomas_Relacao_Ordem>;
  /** update multiples rows of table: "sintomas.sintomas_relacao_ordem" */
  update_sintomas_sintomas_relacao_ordem_many?: Maybe<Array<Maybe<Sintomas_Sintomas_Relacao_Ordem_Mutation_Response>>>;
  /** update data of the table: "tarefas.estados" */
  update_tarefas_estados?: Maybe<Tarefas_Estados_Mutation_Response>;
  /** update single row of the table: "tarefas.estados" */
  update_tarefas_estados_by_pk?: Maybe<Tarefas_Estados>;
  /** update multiples rows of table: "tarefas.estados" */
  update_tarefas_estados_many?: Maybe<Array<Maybe<Tarefas_Estados_Mutation_Response>>>;
  /** update data of the table: "tarefas.intervalos" */
  update_tarefas_intervalos?: Maybe<Tarefas_Intervalos_Mutation_Response>;
  /** update single row of the table: "tarefas.intervalos" */
  update_tarefas_intervalos_by_pk?: Maybe<Tarefas_Intervalos>;
  /** update multiples rows of table: "tarefas.intervalos" */
  update_tarefas_intervalos_many?: Maybe<Array<Maybe<Tarefas_Intervalos_Mutation_Response>>>;
  /** update data of the table: "tarefas.planos_padrao" */
  update_tarefas_planos_padrao?: Maybe<Tarefas_Planos_Padrao_Mutation_Response>;
  /** update single row of the table: "tarefas.planos_padrao" */
  update_tarefas_planos_padrao_by_pk?: Maybe<Tarefas_Planos_Padrao>;
  /** update multiples rows of table: "tarefas.planos_padrao" */
  update_tarefas_planos_padrao_many?: Maybe<Array<Maybe<Tarefas_Planos_Padrao_Mutation_Response>>>;
  /** update data of the table: "tarefas.tarefas" */
  update_tarefas_tarefas?: Maybe<Tarefas_Tarefas_Mutation_Response>;
  /** update single row of the table: "tarefas.tarefas" */
  update_tarefas_tarefas_by_pk?: Maybe<Tarefas_Tarefas>;
  /** update multiples rows of table: "tarefas.tarefas" */
  update_tarefas_tarefas_many?: Maybe<Array<Maybe<Tarefas_Tarefas_Mutation_Response>>>;
  /** update data of the table: "tarefas.tarefas_r_equipas_virtuais" */
  update_tarefas_tarefas_r_equipas_virtuais?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Mutation_Response>;
  /** update single row of the table: "tarefas.tarefas_r_equipas_virtuais" */
  update_tarefas_tarefas_r_equipas_virtuais_by_pk?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais>;
  /** update multiples rows of table: "tarefas.tarefas_r_equipas_virtuais" */
  update_tarefas_tarefas_r_equipas_virtuais_many?: Maybe<Array<Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Mutation_Response>>>;
  /** update data of the table: "tarefas.tarefas_r_infraestruturas" */
  update_tarefas_tarefas_r_infraestruturas?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Mutation_Response>;
  /** update single row of the table: "tarefas.tarefas_r_infraestruturas" */
  update_tarefas_tarefas_r_infraestruturas_by_pk?: Maybe<Tarefas_Tarefas_R_Infraestruturas>;
  /** update multiples rows of table: "tarefas.tarefas_r_infraestruturas" */
  update_tarefas_tarefas_r_infraestruturas_many?: Maybe<Array<Maybe<Tarefas_Tarefas_R_Infraestruturas_Mutation_Response>>>;
  /** update data of the table: "utilizadores.categorias" */
  update_utilizadores_categorias?: Maybe<Utilizadores_Categorias_Mutation_Response>;
  /** update single row of the table: "utilizadores.categorias" */
  update_utilizadores_categorias_by_pk?: Maybe<Utilizadores_Categorias>;
  /** update multiples rows of table: "utilizadores.categorias" */
  update_utilizadores_categorias_many?: Maybe<Array<Maybe<Utilizadores_Categorias_Mutation_Response>>>;
  /** update data of the table: "utilizadores.equipas_virtuais" */
  update_utilizadores_equipas_virtuais?: Maybe<Utilizadores_Equipas_Virtuais_Mutation_Response>;
  /** update single row of the table: "utilizadores.equipas_virtuais" */
  update_utilizadores_equipas_virtuais_by_pk?: Maybe<Utilizadores_Equipas_Virtuais>;
  /** update multiples rows of table: "utilizadores.equipas_virtuais" */
  update_utilizadores_equipas_virtuais_many?: Maybe<Array<Maybe<Utilizadores_Equipas_Virtuais_Mutation_Response>>>;
  /** update data of the table: "utilizadores.equipas_virtuais_r_centros" */
  update_utilizadores_equipas_virtuais_r_centros?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Mutation_Response>;
  /** update single row of the table: "utilizadores.equipas_virtuais_r_centros" */
  update_utilizadores_equipas_virtuais_r_centros_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros>;
  /** update multiples rows of table: "utilizadores.equipas_virtuais_r_centros" */
  update_utilizadores_equipas_virtuais_r_centros_many?: Maybe<Array<Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Mutation_Response>>>;
  /** update data of the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  update_utilizadores_equipas_virtuais_r_equipas_virtuais?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Mutation_Response>;
  /** update single row of the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  update_utilizadores_equipas_virtuais_r_equipas_virtuais_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais>;
  /** update multiples rows of table: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  update_utilizadores_equipas_virtuais_r_equipas_virtuais_many?: Maybe<Array<Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Mutation_Response>>>;
  /** update data of the table: "utilizadores.equipas_virtuais_r_infraestruturas" */
  update_utilizadores_equipas_virtuais_r_infraestruturas?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Mutation_Response>;
  /** update single row of the table: "utilizadores.equipas_virtuais_r_infraestruturas" */
  update_utilizadores_equipas_virtuais_r_infraestruturas_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas>;
  /** update multiples rows of table: "utilizadores.equipas_virtuais_r_infraestruturas" */
  update_utilizadores_equipas_virtuais_r_infraestruturas_many?: Maybe<Array<Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Mutation_Response>>>;
  /** update data of the table: "utilizadores.equipas_virtuais_r_sintoma" */
  update_utilizadores_equipas_virtuais_r_sintoma?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Mutation_Response>;
  /** update single row of the table: "utilizadores.equipas_virtuais_r_sintoma" */
  update_utilizadores_equipas_virtuais_r_sintoma_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma>;
  /** update multiples rows of table: "utilizadores.equipas_virtuais_r_sintoma" */
  update_utilizadores_equipas_virtuais_r_sintoma_many?: Maybe<Array<Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Mutation_Response>>>;
  /** update data of the table: "utilizadores.equipas_virtuais_r_toponimias" */
  update_utilizadores_equipas_virtuais_r_toponimias?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Mutation_Response>;
  /** update single row of the table: "utilizadores.equipas_virtuais_r_toponimias" */
  update_utilizadores_equipas_virtuais_r_toponimias_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias>;
  /** update multiples rows of table: "utilizadores.equipas_virtuais_r_toponimias" */
  update_utilizadores_equipas_virtuais_r_toponimias_many?: Maybe<Array<Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Mutation_Response>>>;
  /** update data of the table: "utilizadores.equipas_virtuais_r_transacoes" */
  update_utilizadores_equipas_virtuais_r_transacoes?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Mutation_Response>;
  /** update single row of the table: "utilizadores.equipas_virtuais_r_transacoes" */
  update_utilizadores_equipas_virtuais_r_transacoes_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** update multiples rows of table: "utilizadores.equipas_virtuais_r_transacoes" */
  update_utilizadores_equipas_virtuais_r_transacoes_many?: Maybe<Array<Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Mutation_Response>>>;
  /** update data of the table: "utilizadores.equipas_virtuais_r_utilizadores" */
  update_utilizadores_equipas_virtuais_r_utilizadores?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Mutation_Response>;
  /** update single row of the table: "utilizadores.equipas_virtuais_r_utilizadores" */
  update_utilizadores_equipas_virtuais_r_utilizadores_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  /** update multiples rows of table: "utilizadores.equipas_virtuais_r_utilizadores" */
  update_utilizadores_equipas_virtuais_r_utilizadores_many?: Maybe<Array<Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Mutation_Response>>>;
  /** update data of the table: "utilizadores.exportacoes" */
  update_utilizadores_exportacoes?: Maybe<Utilizadores_Exportacoes_Mutation_Response>;
  /** update single row of the table: "utilizadores.exportacoes" */
  update_utilizadores_exportacoes_by_pk?: Maybe<Utilizadores_Exportacoes>;
  /** update multiples rows of table: "utilizadores.exportacoes" */
  update_utilizadores_exportacoes_many?: Maybe<Array<Maybe<Utilizadores_Exportacoes_Mutation_Response>>>;
  /** update data of the table: "utilizadores.mapa_posicao_cores" */
  update_utilizadores_mapa_posicao_cores?: Maybe<Utilizadores_Mapa_Posicao_Cores_Mutation_Response>;
  /** update single row of the table: "utilizadores.mapa_posicao_cores" */
  update_utilizadores_mapa_posicao_cores_by_pk?: Maybe<Utilizadores_Mapa_Posicao_Cores>;
  /** update multiples rows of table: "utilizadores.mapa_posicao_cores" */
  update_utilizadores_mapa_posicao_cores_many?: Maybe<Array<Maybe<Utilizadores_Mapa_Posicao_Cores_Mutation_Response>>>;
  /** update data of the table: "utilizadores.menu" */
  update_utilizadores_menu?: Maybe<Utilizadores_Menu_Mutation_Response>;
  /** update single row of the table: "utilizadores.menu" */
  update_utilizadores_menu_by_pk?: Maybe<Utilizadores_Menu>;
  /** update multiples rows of table: "utilizadores.menu" */
  update_utilizadores_menu_many?: Maybe<Array<Maybe<Utilizadores_Menu_Mutation_Response>>>;
  /** update data of the table: "utilizadores.temas" */
  update_utilizadores_temas?: Maybe<Utilizadores_Temas_Mutation_Response>;
  /** update single row of the table: "utilizadores.temas" */
  update_utilizadores_temas_by_pk?: Maybe<Utilizadores_Temas>;
  /** update multiples rows of table: "utilizadores.temas" */
  update_utilizadores_temas_many?: Maybe<Array<Maybe<Utilizadores_Temas_Mutation_Response>>>;
  /** update data of the table: "utilizadores.utilizadores" */
  update_utilizadores_utilizadores?: Maybe<Utilizadores_Utilizadores_Mutation_Response>;
  /** update single row of the table: "utilizadores.utilizadores" */
  update_utilizadores_utilizadores_by_pk?: Maybe<Utilizadores_Utilizadores>;
  /** update multiples rows of table: "utilizadores.utilizadores" */
  update_utilizadores_utilizadores_many?: Maybe<Array<Maybe<Utilizadores_Utilizadores_Mutation_Response>>>;
  /** update data of the table: "variaveis.agregacao" */
  update_variaveis_agregacao?: Maybe<Variaveis_Agregacao_Mutation_Response>;
  /** update single row of the table: "variaveis.agregacao" */
  update_variaveis_agregacao_by_pk?: Maybe<Variaveis_Agregacao>;
  /** update multiples rows of table: "variaveis.agregacao" */
  update_variaveis_agregacao_many?: Maybe<Array<Maybe<Variaveis_Agregacao_Mutation_Response>>>;
  /** update data of the table: "variaveis.base" */
  update_variaveis_base?: Maybe<Variaveis_Base_Mutation_Response>;
  /** update single row of the table: "variaveis.base" */
  update_variaveis_base_by_pk?: Maybe<Variaveis_Base>;
  /** update data of the table: "variaveis.base_calc_variaveis" */
  update_variaveis_base_calc_variaveis?: Maybe<Variaveis_Base_Calc_Variaveis_Mutation_Response>;
  /** update single row of the table: "variaveis.base_calc_variaveis" */
  update_variaveis_base_calc_variaveis_by_pk?: Maybe<Variaveis_Base_Calc_Variaveis>;
  /** update multiples rows of table: "variaveis.base_calc_variaveis" */
  update_variaveis_base_calc_variaveis_many?: Maybe<Array<Maybe<Variaveis_Base_Calc_Variaveis_Mutation_Response>>>;
  /** update data of the table: "variaveis.base_categorias" */
  update_variaveis_base_categorias?: Maybe<Variaveis_Base_Categorias_Mutation_Response>;
  /** update single row of the table: "variaveis.base_categorias" */
  update_variaveis_base_categorias_by_pk?: Maybe<Variaveis_Base_Categorias>;
  /** update multiples rows of table: "variaveis.base_categorias" */
  update_variaveis_base_categorias_many?: Maybe<Array<Maybe<Variaveis_Base_Categorias_Mutation_Response>>>;
  /** update multiples rows of table: "variaveis.base" */
  update_variaveis_base_many?: Maybe<Array<Maybe<Variaveis_Base_Mutation_Response>>>;
  /** update data of the table: "variaveis.base_propriedades" */
  update_variaveis_base_propriedades?: Maybe<Variaveis_Base_Propriedades_Mutation_Response>;
  /** update single row of the table: "variaveis.base_propriedades" */
  update_variaveis_base_propriedades_by_pk?: Maybe<Variaveis_Base_Propriedades>;
  /** update multiples rows of table: "variaveis.base_propriedades" */
  update_variaveis_base_propriedades_many?: Maybe<Array<Maybe<Variaveis_Base_Propriedades_Mutation_Response>>>;
  /** update data of the table: "variaveis.calc_variaveis" */
  update_variaveis_calc_variaveis?: Maybe<Variaveis_Calc_Variaveis_Mutation_Response>;
  /** update single row of the table: "variaveis.calc_variaveis" */
  update_variaveis_calc_variaveis_by_pk?: Maybe<Variaveis_Calc_Variaveis>;
  /** update multiples rows of table: "variaveis.calc_variaveis" */
  update_variaveis_calc_variaveis_many?: Maybe<Array<Maybe<Variaveis_Calc_Variaveis_Mutation_Response>>>;
  /** update data of the table: "variaveis.dominios" */
  update_variaveis_dominios?: Maybe<Variaveis_Dominios_Mutation_Response>;
  /** update single row of the table: "variaveis.dominios" */
  update_variaveis_dominios_by_pk?: Maybe<Variaveis_Dominios>;
  /** update multiples rows of table: "variaveis.dominios" */
  update_variaveis_dominios_many?: Maybe<Array<Maybe<Variaveis_Dominios_Mutation_Response>>>;
  /** update data of the table: "variaveis.dominios_r_dominios_valores" */
  update_variaveis_dominios_r_dominios_valores?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Mutation_Response>;
  /** update single row of the table: "variaveis.dominios_r_dominios_valores" */
  update_variaveis_dominios_r_dominios_valores_by_pk?: Maybe<Variaveis_Dominios_R_Dominios_Valores>;
  /** update multiples rows of table: "variaveis.dominios_r_dominios_valores" */
  update_variaveis_dominios_r_dominios_valores_many?: Maybe<Array<Maybe<Variaveis_Dominios_R_Dominios_Valores_Mutation_Response>>>;
  /** update data of the table: "variaveis.dominios_valores" */
  update_variaveis_dominios_valores?: Maybe<Variaveis_Dominios_Valores_Mutation_Response>;
  /** update single row of the table: "variaveis.dominios_valores" */
  update_variaveis_dominios_valores_by_pk?: Maybe<Variaveis_Dominios_Valores>;
  /** update multiples rows of table: "variaveis.dominios_valores" */
  update_variaveis_dominios_valores_many?: Maybe<Array<Maybe<Variaveis_Dominios_Valores_Mutation_Response>>>;
  /** update data of the table: "variaveis.escalas_precisao" */
  update_variaveis_escalas_precisao?: Maybe<Variaveis_Escalas_Precisao_Mutation_Response>;
  /** update single row of the table: "variaveis.escalas_precisao" */
  update_variaveis_escalas_precisao_by_pk?: Maybe<Variaveis_Escalas_Precisao>;
  /** update multiples rows of table: "variaveis.escalas_precisao" */
  update_variaveis_escalas_precisao_many?: Maybe<Array<Maybe<Variaveis_Escalas_Precisao_Mutation_Response>>>;
  /** update data of the table: "variaveis.fontes_origem" */
  update_variaveis_fontes_origem?: Maybe<Variaveis_Fontes_Origem_Mutation_Response>;
  /** update single row of the table: "variaveis.fontes_origem" */
  update_variaveis_fontes_origem_by_pk?: Maybe<Variaveis_Fontes_Origem>;
  /** update multiples rows of table: "variaveis.fontes_origem" */
  update_variaveis_fontes_origem_many?: Maybe<Array<Maybe<Variaveis_Fontes_Origem_Mutation_Response>>>;
  /** update data of the table: "variaveis.fontes_origem_propriedades" */
  update_variaveis_fontes_origem_propriedades?: Maybe<Variaveis_Fontes_Origem_Propriedades_Mutation_Response>;
  /** update single row of the table: "variaveis.fontes_origem_propriedades" */
  update_variaveis_fontes_origem_propriedades_by_pk?: Maybe<Variaveis_Fontes_Origem_Propriedades>;
  /** update multiples rows of table: "variaveis.fontes_origem_propriedades" */
  update_variaveis_fontes_origem_propriedades_many?: Maybe<Array<Maybe<Variaveis_Fontes_Origem_Propriedades_Mutation_Response>>>;
  /** update data of the table: "variaveis.fontes_origem_tipos" */
  update_variaveis_fontes_origem_tipos?: Maybe<Variaveis_Fontes_Origem_Tipos_Mutation_Response>;
  /** update single row of the table: "variaveis.fontes_origem_tipos" */
  update_variaveis_fontes_origem_tipos_by_pk?: Maybe<Variaveis_Fontes_Origem_Tipos>;
  /** update multiples rows of table: "variaveis.fontes_origem_tipos" */
  update_variaveis_fontes_origem_tipos_many?: Maybe<Array<Maybe<Variaveis_Fontes_Origem_Tipos_Mutation_Response>>>;
  /** update data of the table: "variaveis.leituras" */
  update_variaveis_leituras?: Maybe<Variaveis_Leituras_Mutation_Response>;
  /** update single row of the table: "variaveis.leituras" */
  update_variaveis_leituras_by_pk?: Maybe<Variaveis_Leituras>;
  /** update multiples rows of table: "variaveis.leituras" */
  update_variaveis_leituras_many?: Maybe<Array<Maybe<Variaveis_Leituras_Mutation_Response>>>;
  /** update data of the table: "variaveis.parametros" */
  update_variaveis_parametros?: Maybe<Variaveis_Parametros_Mutation_Response>;
  /** update single row of the table: "variaveis.parametros" */
  update_variaveis_parametros_by_pk?: Maybe<Variaveis_Parametros>;
  /** update multiples rows of table: "variaveis.parametros" */
  update_variaveis_parametros_many?: Maybe<Array<Maybe<Variaveis_Parametros_Mutation_Response>>>;
  /** update data of the table: "variaveis.parametros_r_unidades_medida" */
  update_variaveis_parametros_r_unidades_medida?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Mutation_Response>;
  /** update single row of the table: "variaveis.parametros_r_unidades_medida" */
  update_variaveis_parametros_r_unidades_medida_by_pk?: Maybe<Variaveis_Parametros_R_Unidades_Medida>;
  /** update multiples rows of table: "variaveis.parametros_r_unidades_medida" */
  update_variaveis_parametros_r_unidades_medida_many?: Maybe<Array<Maybe<Variaveis_Parametros_R_Unidades_Medida_Mutation_Response>>>;
  /** update data of the table: "variaveis.tipos" */
  update_variaveis_tipos?: Maybe<Variaveis_Tipos_Mutation_Response>;
  /** update single row of the table: "variaveis.tipos" */
  update_variaveis_tipos_by_pk?: Maybe<Variaveis_Tipos>;
  /** update multiples rows of table: "variaveis.tipos" */
  update_variaveis_tipos_many?: Maybe<Array<Maybe<Variaveis_Tipos_Mutation_Response>>>;
  /** update data of the table: "variaveis.totalizadores_tipos_registo" */
  update_variaveis_totalizadores_tipos_registo?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Mutation_Response>;
  /** update single row of the table: "variaveis.totalizadores_tipos_registo" */
  update_variaveis_totalizadores_tipos_registo_by_pk?: Maybe<Variaveis_Totalizadores_Tipos_Registo>;
  /** update multiples rows of table: "variaveis.totalizadores_tipos_registo" */
  update_variaveis_totalizadores_tipos_registo_many?: Maybe<Array<Maybe<Variaveis_Totalizadores_Tipos_Registo_Mutation_Response>>>;
  /** update data of the table: "variaveis.unidades_medida" */
  update_variaveis_unidades_medida?: Maybe<Variaveis_Unidades_Medida_Mutation_Response>;
  /** update single row of the table: "variaveis.unidades_medida" */
  update_variaveis_unidades_medida_by_pk?: Maybe<Variaveis_Unidades_Medida>;
  /** update multiples rows of table: "variaveis.unidades_medida" */
  update_variaveis_unidades_medida_many?: Maybe<Array<Maybe<Variaveis_Unidades_Medida_Mutation_Response>>>;
  /** update data of the table: "variaveis.valores_mensais" */
  update_variaveis_valores_mensais?: Maybe<Variaveis_Valores_Mensais_Mutation_Response>;
  /** update single row of the table: "variaveis.valores_mensais" */
  update_variaveis_valores_mensais_by_pk?: Maybe<Variaveis_Valores_Mensais>;
  /** update multiples rows of table: "variaveis.valores_mensais" */
  update_variaveis_valores_mensais_many?: Maybe<Array<Maybe<Variaveis_Valores_Mensais_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_Base_Bulk_TiposArgs = {
  where: Base_Bulk_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_Bulk_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Base_CentrosArgs = {
  where: Base_Centros_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_Centros_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Base_InfraestruturasArgs = {
  where: Base_Infraestruturas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_Infraestruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Base_Infraestruturas_CoordenadasArgs = {
  where: Base_Infraestruturas_Coordenadas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_Infraestruturas_Coordenadas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Base_Infraestruturas_R_ToponimiasArgs = {
  where: Base_Infraestruturas_R_Toponimias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_Infraestruturas_R_Toponimias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Base_Infraestruturas_TiposArgs = {
  where: Base_Infraestruturas_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_Infraestruturas_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Base_ParametrizacoesArgs = {
  where: Base_Parametrizacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_ToponimiasArgs = {
  where: Base_Toponimias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_Toponimias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Base_Toponimias_CoordenadasArgs = {
  where: Base_Toponimias_Coordenadas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_Toponimias_Coordenadas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Base_ZmcArgs = {
  where: Base_Zmc_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_Zmc_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Base_Zmc_Nos_TipoArgs = {
  where: Base_Zmc_Nos_Tipo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_Zmc_Nos_Tipo_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Consultas_RequisicoesArgs = {
  where: Consultas_Requisicoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consultas_Requisicoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Ad_ParametrizacaoArgs = {
  where: Integracoes_Ad_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Ad_Saml_ParametrizacaoArgs = {
  where: Integracoes_Ad_Saml_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Ad_Saml_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Sig_Maps_OrtosArgs = {
  where: Integracoes_Sig_Maps_Ortos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Sig_Maps_Ortos_By_PkArgs = {
  id: Scalars['smallint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Sig_ParametrizacaoArgs = {
  where: Integracoes_Sig_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Sig_ProxyArgs = {
  where: Integracoes_Sig_Proxy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Sig_Proxy_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Sig_Request_Get_AttributesArgs = {
  where: Integracoes_Sig_Request_Get_Attributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Sig_Request_Get_CapabilitiesArgs = {
  where: Integracoes_Sig_Request_Get_Capabilities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Sig_Request_Get_FeaturesArgs = {
  where: Integracoes_Sig_Request_Get_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Sig_ServicesArgs = {
  where: Integracoes_Sig_Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Integracoes_Sig_Services_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mensagens_AnexosArgs = {
  where: Mensagens_Anexos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mensagens_Anexos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mensagens_MensagensArgs = {
  where: Mensagens_Mensagens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mensagens_Mensagens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mensagens_PostArgs = {
  where: Mensagens_Post_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mensagens_Post_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mobile_CoordenadasArgs = {
  where: Mobile_Coordenadas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mobile_Coordenadas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_CoresArgs = {
  where: Navia_Cores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Cores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_VariaveisArgs = {
  where: Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_Mapa_NiveisArgs = {
  where: Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_SintomasArgs = {
  where: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_Sintomas_TiposArgs = {
  where: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_Tipos_InfraestruturaArgs = {
  where: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_By_PkArgs = {
  tipo_infraestrutura_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_ZmcArgs = {
  where: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_By_PkArgs = {
  tipo_infraestrutura_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_MenuArgs = {
  where: Navia_Dashboards_Menu_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Menu_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Menu_R_TransacoesArgs = {
  where: Navia_Dashboards_Menu_R_Transacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Menu_R_Transacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Modo_Tv_TokensArgs = {
  where: Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Modo_Tv_Tokens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Modo_Tv_Tokens_Revogacao_ManualArgs = {
  where: Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_By_PkArgs = {
  id_token: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Modo_Tv_Tokens_ValidadosArgs = {
  where: Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Modo_Tv_Tokens_Validados_By_PkArgs = {
  id_token: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_CausasArgs = {
  where: Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_Causas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_Causas_R_CausasArgs = {
  where: Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_IndicadoresArgs = {
  where: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_Indicadores_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_SintomasArgs = {
  where: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_SintomasArgs = {
  where: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_VariaveisArgs = {
  where: Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Monitorizacao_Roturas_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Performance_Infraestrutura_ParametrizacaoArgs = {
  where: Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_ParametrizacaoArgs = {
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_TarefaArgs = {
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_By_PkArgs = {
  plano_padrao_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_SintomasArgs = {
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_ValoresArgs = {
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_InfraestruturaArgs = {
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_By_PkArgs = {
  tipo_infraestrutura_id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Requisicoes_Indicadores_ParametrizacaoArgs = {
  where: Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Requisicoes_Mapa_ParametrizacaoArgs = {
  where: Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Visao_360_ParametrizacaoArgs = {
  where: Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Visao_360_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Visao_360_SelectoresArgs = {
  where: Navia_Dashboards_Visao_360_Selectores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Visao_360_Selectores_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_CaudaisArgs = {
  where: Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_Caudais_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_DadosArgs = {
  where: Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_Dados_By_PkArgs = {
  id_municipio: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_MunicipiosArgs = {
  where: Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_LeiturasArgs = {
  where: Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_Leituras_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_LocaisArgs = {
  where: Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_Locais_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_MunicipiosArgs = {
  where: Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_Municipios_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_RegistosArgs = {
  where: Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_Registos_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_Totalizador_LeiturasArgs = {
  where: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_TotalizadoresArgs = {
  where: Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Dashboards_Volumes_Diarios_Totalizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_IntegracoesArgs = {
  where: Navia_Integracoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Integracoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Navia_LogArgs = {
  where: Navia_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Navia_Log_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Notificacoes_ItensArgs = {
  where: Notificacoes_Itens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notificacoes_Itens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Notificacoes_NotificacoesArgs = {
  where: Notificacoes_Notificacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notificacoes_Notificacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Notificacoes_Notificacoes_R_UtilizadoresArgs = {
  where: Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notificacoes_Notificacoes_R_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Notificacoes_TiposArgs = {
  where: Notificacoes_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notificacoes_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Permissoes_TransacoesArgs = {
  where: Permissoes_Transacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Permissoes_Transacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Permissoes_Transacoes_R_MenusArgs = {
  where: Permissoes_Transacoes_R_Menus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Permissoes_Transacoes_R_Menus_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rqs_ParametrizacaoArgs = {
  where: Rqs_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rqs_Requisicoes_PeriodosArgs = {
  where: Rqs_Requisicoes_Periodos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rqs_Requisicoes_Periodos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rqs_Requisicoes_Tempos_WrapArgs = {
  where: Rqs_Requisicoes_Tempos_Wrap_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rqs_Requisicoes_Tempos_Wrap_By_PkArgs = {
  id_requisicao: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rqs_SintomasArgs = {
  where: Rqs_Sintomas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rqs_Sintomas_By_PkArgs = {
  id_sintoma: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Rqs_Sintomas_Parametrizacao_TemposArgs = {
  where: Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rqs_Sintomas_Parametrizacao_Tempos_By_PkArgs = {
  id_sintoma: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Servicos_FasesArgs = {
  where: Servicos_Fases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Fases_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Servicos_IntervencoesArgs = {
  where: Servicos_Intervencoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Intervencoes_Atribuicao_UtilizadoresArgs = {
  where: Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Intervencoes_Atribuicao_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Intervencoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Intervencoes_EstadosArgs = {
  where: Servicos_Intervencoes_Estados_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Intervencoes_Estados_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Intervencoes_R_Causas_TrabalhosArgs = {
  where: Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Intervencoes_R_Causas_Trabalhos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Servicos_RastreabilidadeArgs = {
  where: Servicos_Rastreabilidade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Rastreabilidade_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Servicos_RequisicoesArgs = {
  where: Servicos_Requisicoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Requisicoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Requisicoes_EstadosArgs = {
  where: Servicos_Requisicoes_Estados_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Requisicoes_Estados_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Requisicoes_Locais_Infra_EstruturasArgs = {
  where: Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Requisicoes_Locais_Infra_Estruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Requisicoes_R_IntervencoesArgs = {
  where: Servicos_Requisicoes_R_Intervencoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Servicos_Requisicoes_R_Intervencoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sintomas_ArvoreArgs = {
  where: Sintomas_Arvore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sintomas_Arvore_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sintomas_Causas_TrabalhosArgs = {
  where: Sintomas_Causas_Trabalhos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sintomas_Causas_Trabalhos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sintomas_Sintomas_RelacaoArgs = {
  where: Sintomas_Sintomas_Relacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sintomas_Sintomas_Relacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sintomas_Sintomas_Relacao_OrdemArgs = {
  where: Sintomas_Sintomas_Relacao_Ordem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sintomas_Sintomas_Relacao_Ordem_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_EstadosArgs = {
  where: Tarefas_Estados_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_Estados_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_IntervalosArgs = {
  where: Tarefas_Intervalos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_Intervalos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_Planos_PadraoArgs = {
  where: Tarefas_Planos_Padrao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_Planos_Padrao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_TarefasArgs = {
  where: Tarefas_Tarefas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_Tarefas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_Tarefas_R_Equipas_VirtuaisArgs = {
  where: Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_Tarefas_R_Equipas_Virtuais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_Tarefas_R_InfraestruturasArgs = {
  where: Tarefas_Tarefas_R_Infraestruturas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tarefas_Tarefas_R_Infraestruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_CategoriasArgs = {
  where: Utilizadores_Categorias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Categorias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_VirtuaisArgs = {
  where: Utilizadores_Equipas_Virtuais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_CentrosArgs = {
  where: Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_Centros_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_Equipas_VirtuaisArgs = {
  where: Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_InfraestruturasArgs = {
  where: Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_Infraestruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_SintomaArgs = {
  where: Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_Sintoma_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_ToponimiasArgs = {
  where: Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_Toponimias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_TransacoesArgs = {
  where: Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_Transacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_UtilizadoresArgs = {
  where: Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Equipas_Virtuais_R_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_ExportacoesArgs = {
  where: Utilizadores_Exportacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Exportacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Mapa_Posicao_CoresArgs = {
  where: Utilizadores_Mapa_Posicao_Cores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Mapa_Posicao_Cores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_MenuArgs = {
  where: Utilizadores_Menu_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Menu_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_TemasArgs = {
  where: Utilizadores_Temas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Temas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_UtilizadoresArgs = {
  where: Utilizadores_Utilizadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Utilizadores_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_AgregacaoArgs = {
  where: Variaveis_Agregacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Agregacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_BaseArgs = {
  where: Variaveis_Base_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Base_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Base_Calc_VariaveisArgs = {
  where: Variaveis_Base_Calc_Variaveis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Base_Calc_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Base_CategoriasArgs = {
  where: Variaveis_Base_Categorias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Base_Categorias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Base_PropriedadesArgs = {
  where: Variaveis_Base_Propriedades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Base_Propriedades_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Calc_VariaveisArgs = {
  where: Variaveis_Calc_Variaveis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Calc_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_DominiosArgs = {
  where: Variaveis_Dominios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Dominios_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Dominios_R_Dominios_ValoresArgs = {
  where: Variaveis_Dominios_R_Dominios_Valores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Dominios_R_Dominios_Valores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Dominios_ValoresArgs = {
  where: Variaveis_Dominios_Valores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Dominios_Valores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Escalas_PrecisaoArgs = {
  where: Variaveis_Escalas_Precisao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Escalas_Precisao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Fontes_OrigemArgs = {
  where: Variaveis_Fontes_Origem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Fontes_Origem_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Fontes_Origem_PropriedadesArgs = {
  where: Variaveis_Fontes_Origem_Propriedades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Fontes_Origem_Propriedades_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Fontes_Origem_TiposArgs = {
  where: Variaveis_Fontes_Origem_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Fontes_Origem_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_LeiturasArgs = {
  where: Variaveis_Leituras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Leituras_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_ParametrosArgs = {
  where: Variaveis_Parametros_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Parametros_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Parametros_R_Unidades_MedidaArgs = {
  where: Variaveis_Parametros_R_Unidades_Medida_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Parametros_R_Unidades_Medida_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_TiposArgs = {
  where: Variaveis_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Totalizadores_Tipos_RegistoArgs = {
  where: Variaveis_Totalizadores_Tipos_Registo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Totalizadores_Tipos_Registo_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Unidades_MedidaArgs = {
  where: Variaveis_Unidades_Medida_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Unidades_Medida_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Valores_MensaisArgs = {
  where: Variaveis_Valores_Mensais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Variaveis_Valores_Mensais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Base_Bulk_TiposArgs = {
  objects: Array<Base_Bulk_Tipos_Insert_Input>;
  on_conflict?: InputMaybe<Base_Bulk_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Bulk_Tipos_OneArgs = {
  object: Base_Bulk_Tipos_Insert_Input;
  on_conflict?: InputMaybe<Base_Bulk_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_CentrosArgs = {
  objects: Array<Base_Centros_Insert_Input>;
  on_conflict?: InputMaybe<Base_Centros_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Centros_OneArgs = {
  object: Base_Centros_Insert_Input;
  on_conflict?: InputMaybe<Base_Centros_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_InfraestruturasArgs = {
  objects: Array<Base_Infraestruturas_Insert_Input>;
  on_conflict?: InputMaybe<Base_Infraestruturas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Infraestruturas_CoordenadasArgs = {
  objects: Array<Base_Infraestruturas_Coordenadas_Insert_Input>;
  on_conflict?: InputMaybe<Base_Infraestruturas_Coordenadas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Infraestruturas_Coordenadas_OneArgs = {
  object: Base_Infraestruturas_Coordenadas_Insert_Input;
  on_conflict?: InputMaybe<Base_Infraestruturas_Coordenadas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Infraestruturas_OneArgs = {
  object: Base_Infraestruturas_Insert_Input;
  on_conflict?: InputMaybe<Base_Infraestruturas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Infraestruturas_R_ToponimiasArgs = {
  objects: Array<Base_Infraestruturas_R_Toponimias_Insert_Input>;
  on_conflict?: InputMaybe<Base_Infraestruturas_R_Toponimias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Infraestruturas_R_Toponimias_OneArgs = {
  object: Base_Infraestruturas_R_Toponimias_Insert_Input;
  on_conflict?: InputMaybe<Base_Infraestruturas_R_Toponimias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Infraestruturas_TiposArgs = {
  objects: Array<Base_Infraestruturas_Tipos_Insert_Input>;
  on_conflict?: InputMaybe<Base_Infraestruturas_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Infraestruturas_Tipos_OneArgs = {
  object: Base_Infraestruturas_Tipos_Insert_Input;
  on_conflict?: InputMaybe<Base_Infraestruturas_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_ParametrizacoesArgs = {
  objects: Array<Base_Parametrizacoes_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Parametrizacoes_OneArgs = {
  object: Base_Parametrizacoes_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Base_ToponimiasArgs = {
  objects: Array<Base_Toponimias_Insert_Input>;
  on_conflict?: InputMaybe<Base_Toponimias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Toponimias_CoordenadasArgs = {
  objects: Array<Base_Toponimias_Coordenadas_Insert_Input>;
  on_conflict?: InputMaybe<Base_Toponimias_Coordenadas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Toponimias_Coordenadas_OneArgs = {
  object: Base_Toponimias_Coordenadas_Insert_Input;
  on_conflict?: InputMaybe<Base_Toponimias_Coordenadas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Toponimias_OneArgs = {
  object: Base_Toponimias_Insert_Input;
  on_conflict?: InputMaybe<Base_Toponimias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_ZmcArgs = {
  objects: Array<Base_Zmc_Insert_Input>;
  on_conflict?: InputMaybe<Base_Zmc_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Zmc_Nos_TipoArgs = {
  objects: Array<Base_Zmc_Nos_Tipo_Insert_Input>;
  on_conflict?: InputMaybe<Base_Zmc_Nos_Tipo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Zmc_Nos_Tipo_OneArgs = {
  object: Base_Zmc_Nos_Tipo_Insert_Input;
  on_conflict?: InputMaybe<Base_Zmc_Nos_Tipo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Zmc_OneArgs = {
  object: Base_Zmc_Insert_Input;
  on_conflict?: InputMaybe<Base_Zmc_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consultas_RequisicoesArgs = {
  objects: Array<Consultas_Requisicoes_Insert_Input>;
  on_conflict?: InputMaybe<Consultas_Requisicoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consultas_Requisicoes_OneArgs = {
  object: Consultas_Requisicoes_Insert_Input;
  on_conflict?: InputMaybe<Consultas_Requisicoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Ad_ParametrizacaoArgs = {
  objects: Array<Integracoes_Ad_Parametrizacao_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Ad_Parametrizacao_OneArgs = {
  object: Integracoes_Ad_Parametrizacao_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Ad_Saml_ParametrizacaoArgs = {
  objects: Array<Integracoes_Ad_Saml_Parametrizacao_Insert_Input>;
  on_conflict?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Ad_Saml_Parametrizacao_OneArgs = {
  object: Integracoes_Ad_Saml_Parametrizacao_Insert_Input;
  on_conflict?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_Maps_OrtosArgs = {
  objects: Array<Integracoes_Sig_Maps_Ortos_Insert_Input>;
  on_conflict?: InputMaybe<Integracoes_Sig_Maps_Ortos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_Maps_Ortos_OneArgs = {
  object: Integracoes_Sig_Maps_Ortos_Insert_Input;
  on_conflict?: InputMaybe<Integracoes_Sig_Maps_Ortos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_ParametrizacaoArgs = {
  objects: Array<Integracoes_Sig_Parametrizacao_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_Parametrizacao_OneArgs = {
  object: Integracoes_Sig_Parametrizacao_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_ProxyArgs = {
  objects: Array<Integracoes_Sig_Proxy_Insert_Input>;
  on_conflict?: InputMaybe<Integracoes_Sig_Proxy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_Proxy_OneArgs = {
  object: Integracoes_Sig_Proxy_Insert_Input;
  on_conflict?: InputMaybe<Integracoes_Sig_Proxy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_Request_Get_AttributesArgs = {
  objects: Array<Integracoes_Sig_Request_Get_Attributes_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_Request_Get_Attributes_OneArgs = {
  object: Integracoes_Sig_Request_Get_Attributes_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_Request_Get_CapabilitiesArgs = {
  objects: Array<Integracoes_Sig_Request_Get_Capabilities_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_Request_Get_Capabilities_OneArgs = {
  object: Integracoes_Sig_Request_Get_Capabilities_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_Request_Get_FeaturesArgs = {
  objects: Array<Integracoes_Sig_Request_Get_Features_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_Request_Get_Features_OneArgs = {
  object: Integracoes_Sig_Request_Get_Features_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_ServicesArgs = {
  objects: Array<Integracoes_Sig_Services_Insert_Input>;
  on_conflict?: InputMaybe<Integracoes_Sig_Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Integracoes_Sig_Services_OneArgs = {
  object: Integracoes_Sig_Services_Insert_Input;
  on_conflict?: InputMaybe<Integracoes_Sig_Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mensagens_AnexosArgs = {
  objects: Array<Mensagens_Anexos_Insert_Input>;
  on_conflict?: InputMaybe<Mensagens_Anexos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mensagens_Anexos_OneArgs = {
  object: Mensagens_Anexos_Insert_Input;
  on_conflict?: InputMaybe<Mensagens_Anexos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mensagens_MensagensArgs = {
  objects: Array<Mensagens_Mensagens_Insert_Input>;
  on_conflict?: InputMaybe<Mensagens_Mensagens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mensagens_Mensagens_OneArgs = {
  object: Mensagens_Mensagens_Insert_Input;
  on_conflict?: InputMaybe<Mensagens_Mensagens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mensagens_PostArgs = {
  objects: Array<Mensagens_Post_Insert_Input>;
  on_conflict?: InputMaybe<Mensagens_Post_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mensagens_Post_OneArgs = {
  object: Mensagens_Post_Insert_Input;
  on_conflict?: InputMaybe<Mensagens_Post_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mobile_CoordenadasArgs = {
  objects: Array<Mobile_Coordenadas_Insert_Input>;
  on_conflict?: InputMaybe<Mobile_Coordenadas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mobile_Coordenadas_OneArgs = {
  object: Mobile_Coordenadas_Insert_Input;
  on_conflict?: InputMaybe<Mobile_Coordenadas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_CoresArgs = {
  objects: Array<Navia_Cores_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Cores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Cores_OneArgs = {
  object: Navia_Cores_Insert_Input;
  on_conflict?: InputMaybe<Navia_Cores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_VariaveisArgs = {
  objects: Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_OneArgs = {
  object: Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_Mapa_NiveisArgs = {
  objects: Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_OneArgs = {
  object: Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_SintomasArgs = {
  objects: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_Sintomas_OneArgs = {
  object: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_Sintomas_TiposArgs = {
  objects: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_OneArgs = {
  object: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_Tipos_InfraestruturaArgs = {
  objects: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_OneArgs = {
  object: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_ZmcArgs = {
  objects: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_OneArgs = {
  object: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_MenuArgs = {
  objects: Array<Navia_Dashboards_Menu_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Menu_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Menu_OneArgs = {
  object: Navia_Dashboards_Menu_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Menu_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Menu_R_TransacoesArgs = {
  objects: Array<Navia_Dashboards_Menu_R_Transacoes_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Menu_R_Transacoes_OneArgs = {
  object: Navia_Dashboards_Menu_R_Transacoes_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Modo_Tv_TokensArgs = {
  objects: Array<Navia_Dashboards_Modo_Tv_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Modo_Tv_Tokens_OneArgs = {
  object: Navia_Dashboards_Modo_Tv_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Modo_Tv_Tokens_Revogacao_ManualArgs = {
  objects: Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_OneArgs = {
  object: Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Modo_Tv_Tokens_ValidadosArgs = {
  objects: Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Modo_Tv_Tokens_Validados_OneArgs = {
  object: Navia_Dashboards_Modo_Tv_Tokens_Validados_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_CausasArgs = {
  objects: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_Causas_OneArgs = {
  object: Navia_Dashboards_Monitorizacao_Roturas_Causas_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_Causas_R_CausasArgs = {
  objects: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_OneArgs = {
  object: Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_IndicadoresArgs = {
  objects: Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_Indicadores_OneArgs = {
  object: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_SintomasArgs = {
  objects: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_Sintomas_OneArgs = {
  object: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_SintomasArgs = {
  objects: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_OneArgs = {
  object: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_VariaveisArgs = {
  objects: Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Monitorizacao_Roturas_Variaveis_OneArgs = {
  object: Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Performance_Infraestrutura_ParametrizacaoArgs = {
  objects: Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_OneArgs = {
  object: Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_ParametrizacaoArgs = {
  objects: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_OneArgs = {
  object: Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_TarefaArgs = {
  objects: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_OneArgs = {
  object: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_SintomasArgs = {
  objects: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_OneArgs = {
  object: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_ValoresArgs = {
  objects: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_OneArgs = {
  object: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_InfraestruturaArgs = {
  objects: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_OneArgs = {
  object: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Requisicoes_Indicadores_ParametrizacaoArgs = {
  objects: Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_OneArgs = {
  object: Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Requisicoes_Mapa_ParametrizacaoArgs = {
  objects: Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_OneArgs = {
  object: Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Visao_360_ParametrizacaoArgs = {
  objects: Array<Navia_Dashboards_Visao_360_Parametrizacao_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Visao_360_Parametrizacao_OneArgs = {
  object: Navia_Dashboards_Visao_360_Parametrizacao_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Visao_360_SelectoresArgs = {
  objects: Array<Navia_Dashboards_Visao_360_Selectores_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Visao_360_Selectores_OneArgs = {
  object: Navia_Dashboards_Visao_360_Selectores_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_CaudaisArgs = {
  objects: Array<Navia_Dashboards_Volumes_Diarios_Caudais_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_Caudais_OneArgs = {
  object: Navia_Dashboards_Volumes_Diarios_Caudais_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_DadosArgs = {
  objects: Array<Navia_Dashboards_Volumes_Diarios_Dados_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_Dados_OneArgs = {
  object: Navia_Dashboards_Volumes_Diarios_Dados_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_MunicipiosArgs = {
  objects: Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_OneArgs = {
  object: Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_LeiturasArgs = {
  objects: Array<Navia_Dashboards_Volumes_Diarios_Leituras_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_Leituras_OneArgs = {
  object: Navia_Dashboards_Volumes_Diarios_Leituras_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_LocaisArgs = {
  objects: Array<Navia_Dashboards_Volumes_Diarios_Locais_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_Locais_OneArgs = {
  object: Navia_Dashboards_Volumes_Diarios_Locais_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_MunicipiosArgs = {
  objects: Array<Navia_Dashboards_Volumes_Diarios_Municipios_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_Municipios_OneArgs = {
  object: Navia_Dashboards_Volumes_Diarios_Municipios_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_RegistosArgs = {
  objects: Array<Navia_Dashboards_Volumes_Diarios_Registos_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_Registos_OneArgs = {
  object: Navia_Dashboards_Volumes_Diarios_Registos_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_Totalizador_LeiturasArgs = {
  objects: Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_OneArgs = {
  object: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_TotalizadoresArgs = {
  objects: Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Dashboards_Volumes_Diarios_Totalizadores_OneArgs = {
  object: Navia_Dashboards_Volumes_Diarios_Totalizadores_Insert_Input;
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_IntegracoesArgs = {
  objects: Array<Navia_Integracoes_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Integracoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Integracoes_OneArgs = {
  object: Navia_Integracoes_Insert_Input;
  on_conflict?: InputMaybe<Navia_Integracoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_LogArgs = {
  objects: Array<Navia_Log_Insert_Input>;
  on_conflict?: InputMaybe<Navia_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Navia_Log_OneArgs = {
  object: Navia_Log_Insert_Input;
  on_conflict?: InputMaybe<Navia_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notificacoes_ItensArgs = {
  objects: Array<Notificacoes_Itens_Insert_Input>;
  on_conflict?: InputMaybe<Notificacoes_Itens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notificacoes_Itens_OneArgs = {
  object: Notificacoes_Itens_Insert_Input;
  on_conflict?: InputMaybe<Notificacoes_Itens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notificacoes_NotificacoesArgs = {
  objects: Array<Notificacoes_Notificacoes_Insert_Input>;
  on_conflict?: InputMaybe<Notificacoes_Notificacoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notificacoes_Notificacoes_OneArgs = {
  object: Notificacoes_Notificacoes_Insert_Input;
  on_conflict?: InputMaybe<Notificacoes_Notificacoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notificacoes_Notificacoes_R_UtilizadoresArgs = {
  objects: Array<Notificacoes_Notificacoes_R_Utilizadores_Insert_Input>;
  on_conflict?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notificacoes_Notificacoes_R_Utilizadores_OneArgs = {
  object: Notificacoes_Notificacoes_R_Utilizadores_Insert_Input;
  on_conflict?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notificacoes_TiposArgs = {
  objects: Array<Notificacoes_Tipos_Insert_Input>;
  on_conflict?: InputMaybe<Notificacoes_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notificacoes_Tipos_OneArgs = {
  object: Notificacoes_Tipos_Insert_Input;
  on_conflict?: InputMaybe<Notificacoes_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permissoes_TransacoesArgs = {
  objects: Array<Permissoes_Transacoes_Insert_Input>;
  on_conflict?: InputMaybe<Permissoes_Transacoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permissoes_Transacoes_OneArgs = {
  object: Permissoes_Transacoes_Insert_Input;
  on_conflict?: InputMaybe<Permissoes_Transacoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permissoes_Transacoes_R_MenusArgs = {
  objects: Array<Permissoes_Transacoes_R_Menus_Insert_Input>;
  on_conflict?: InputMaybe<Permissoes_Transacoes_R_Menus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permissoes_Transacoes_R_Menus_OneArgs = {
  object: Permissoes_Transacoes_R_Menus_Insert_Input;
  on_conflict?: InputMaybe<Permissoes_Transacoes_R_Menus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rqs_ParametrizacaoArgs = {
  objects: Array<Rqs_Parametrizacao_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Rqs_Parametrizacao_OneArgs = {
  object: Rqs_Parametrizacao_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Rqs_Requisicoes_PeriodosArgs = {
  objects: Array<Rqs_Requisicoes_Periodos_Insert_Input>;
  on_conflict?: InputMaybe<Rqs_Requisicoes_Periodos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rqs_Requisicoes_Periodos_OneArgs = {
  object: Rqs_Requisicoes_Periodos_Insert_Input;
  on_conflict?: InputMaybe<Rqs_Requisicoes_Periodos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rqs_Requisicoes_Tempos_WrapArgs = {
  objects: Array<Rqs_Requisicoes_Tempos_Wrap_Insert_Input>;
  on_conflict?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rqs_Requisicoes_Tempos_Wrap_OneArgs = {
  object: Rqs_Requisicoes_Tempos_Wrap_Insert_Input;
  on_conflict?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rqs_SintomasArgs = {
  objects: Array<Rqs_Sintomas_Insert_Input>;
  on_conflict?: InputMaybe<Rqs_Sintomas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rqs_Sintomas_OneArgs = {
  object: Rqs_Sintomas_Insert_Input;
  on_conflict?: InputMaybe<Rqs_Sintomas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rqs_Sintomas_Parametrizacao_TemposArgs = {
  objects: Array<Rqs_Sintomas_Parametrizacao_Tempos_Insert_Input>;
  on_conflict?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rqs_Sintomas_Parametrizacao_Tempos_OneArgs = {
  object: Rqs_Sintomas_Parametrizacao_Tempos_Insert_Input;
  on_conflict?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_FasesArgs = {
  objects: Array<Servicos_Fases_Insert_Input>;
  on_conflict?: InputMaybe<Servicos_Fases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Fases_OneArgs = {
  object: Servicos_Fases_Insert_Input;
  on_conflict?: InputMaybe<Servicos_Fases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_IntervencoesArgs = {
  objects: Array<Servicos_Intervencoes_Insert_Input>;
  on_conflict?: InputMaybe<Servicos_Intervencoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Intervencoes_Atribuicao_UtilizadoresArgs = {
  objects: Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Insert_Input>;
  on_conflict?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Intervencoes_Atribuicao_Utilizadores_OneArgs = {
  object: Servicos_Intervencoes_Atribuicao_Utilizadores_Insert_Input;
  on_conflict?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Intervencoes_EstadosArgs = {
  objects: Array<Servicos_Intervencoes_Estados_Insert_Input>;
  on_conflict?: InputMaybe<Servicos_Intervencoes_Estados_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Intervencoes_Estados_OneArgs = {
  object: Servicos_Intervencoes_Estados_Insert_Input;
  on_conflict?: InputMaybe<Servicos_Intervencoes_Estados_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Intervencoes_OneArgs = {
  object: Servicos_Intervencoes_Insert_Input;
  on_conflict?: InputMaybe<Servicos_Intervencoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Intervencoes_R_Causas_TrabalhosArgs = {
  objects: Array<Servicos_Intervencoes_R_Causas_Trabalhos_Insert_Input>;
  on_conflict?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Intervencoes_R_Causas_Trabalhos_OneArgs = {
  object: Servicos_Intervencoes_R_Causas_Trabalhos_Insert_Input;
  on_conflict?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_RastreabilidadeArgs = {
  objects: Array<Servicos_Rastreabilidade_Insert_Input>;
  on_conflict?: InputMaybe<Servicos_Rastreabilidade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Rastreabilidade_OneArgs = {
  object: Servicos_Rastreabilidade_Insert_Input;
  on_conflict?: InputMaybe<Servicos_Rastreabilidade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_RequisicoesArgs = {
  objects: Array<Servicos_Requisicoes_Insert_Input>;
  on_conflict?: InputMaybe<Servicos_Requisicoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Requisicoes_EstadosArgs = {
  objects: Array<Servicos_Requisicoes_Estados_Insert_Input>;
  on_conflict?: InputMaybe<Servicos_Requisicoes_Estados_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Requisicoes_Estados_OneArgs = {
  object: Servicos_Requisicoes_Estados_Insert_Input;
  on_conflict?: InputMaybe<Servicos_Requisicoes_Estados_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Requisicoes_Locais_Infra_EstruturasArgs = {
  objects: Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Insert_Input>;
  on_conflict?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Requisicoes_Locais_Infra_Estruturas_OneArgs = {
  object: Servicos_Requisicoes_Locais_Infra_Estruturas_Insert_Input;
  on_conflict?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Requisicoes_OneArgs = {
  object: Servicos_Requisicoes_Insert_Input;
  on_conflict?: InputMaybe<Servicos_Requisicoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Requisicoes_R_IntervencoesArgs = {
  objects: Array<Servicos_Requisicoes_R_Intervencoes_Insert_Input>;
  on_conflict?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Servicos_Requisicoes_R_Intervencoes_OneArgs = {
  object: Servicos_Requisicoes_R_Intervencoes_Insert_Input;
  on_conflict?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sintomas_ArvoreArgs = {
  objects: Array<Sintomas_Arvore_Insert_Input>;
  on_conflict?: InputMaybe<Sintomas_Arvore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sintomas_Arvore_OneArgs = {
  object: Sintomas_Arvore_Insert_Input;
  on_conflict?: InputMaybe<Sintomas_Arvore_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sintomas_Causas_TrabalhosArgs = {
  objects: Array<Sintomas_Causas_Trabalhos_Insert_Input>;
  on_conflict?: InputMaybe<Sintomas_Causas_Trabalhos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sintomas_Causas_Trabalhos_OneArgs = {
  object: Sintomas_Causas_Trabalhos_Insert_Input;
  on_conflict?: InputMaybe<Sintomas_Causas_Trabalhos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sintomas_Sintomas_RelacaoArgs = {
  objects: Array<Sintomas_Sintomas_Relacao_Insert_Input>;
  on_conflict?: InputMaybe<Sintomas_Sintomas_Relacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sintomas_Sintomas_Relacao_OneArgs = {
  object: Sintomas_Sintomas_Relacao_Insert_Input;
  on_conflict?: InputMaybe<Sintomas_Sintomas_Relacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sintomas_Sintomas_Relacao_OrdemArgs = {
  objects: Array<Sintomas_Sintomas_Relacao_Ordem_Insert_Input>;
  on_conflict?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sintomas_Sintomas_Relacao_Ordem_OneArgs = {
  object: Sintomas_Sintomas_Relacao_Ordem_Insert_Input;
  on_conflict?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_EstadosArgs = {
  objects: Array<Tarefas_Estados_Insert_Input>;
  on_conflict?: InputMaybe<Tarefas_Estados_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_Estados_OneArgs = {
  object: Tarefas_Estados_Insert_Input;
  on_conflict?: InputMaybe<Tarefas_Estados_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_IntervalosArgs = {
  objects: Array<Tarefas_Intervalos_Insert_Input>;
  on_conflict?: InputMaybe<Tarefas_Intervalos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_Intervalos_OneArgs = {
  object: Tarefas_Intervalos_Insert_Input;
  on_conflict?: InputMaybe<Tarefas_Intervalos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_Planos_PadraoArgs = {
  objects: Array<Tarefas_Planos_Padrao_Insert_Input>;
  on_conflict?: InputMaybe<Tarefas_Planos_Padrao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_Planos_Padrao_OneArgs = {
  object: Tarefas_Planos_Padrao_Insert_Input;
  on_conflict?: InputMaybe<Tarefas_Planos_Padrao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_TarefasArgs = {
  objects: Array<Tarefas_Tarefas_Insert_Input>;
  on_conflict?: InputMaybe<Tarefas_Tarefas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_Tarefas_OneArgs = {
  object: Tarefas_Tarefas_Insert_Input;
  on_conflict?: InputMaybe<Tarefas_Tarefas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_Tarefas_R_Equipas_VirtuaisArgs = {
  objects: Array<Tarefas_Tarefas_R_Equipas_Virtuais_Insert_Input>;
  on_conflict?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_Tarefas_R_Equipas_Virtuais_OneArgs = {
  object: Tarefas_Tarefas_R_Equipas_Virtuais_Insert_Input;
  on_conflict?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_Tarefas_R_InfraestruturasArgs = {
  objects: Array<Tarefas_Tarefas_R_Infraestruturas_Insert_Input>;
  on_conflict?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tarefas_Tarefas_R_Infraestruturas_OneArgs = {
  object: Tarefas_Tarefas_R_Infraestruturas_Insert_Input;
  on_conflict?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_CategoriasArgs = {
  objects: Array<Utilizadores_Categorias_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Categorias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Categorias_OneArgs = {
  object: Utilizadores_Categorias_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Categorias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_VirtuaisArgs = {
  objects: Array<Utilizadores_Equipas_Virtuais_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_OneArgs = {
  object: Utilizadores_Equipas_Virtuais_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_CentrosArgs = {
  objects: Array<Utilizadores_Equipas_Virtuais_R_Centros_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_Centros_OneArgs = {
  object: Utilizadores_Equipas_Virtuais_R_Centros_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_Equipas_VirtuaisArgs = {
  objects: Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_OneArgs = {
  object: Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_InfraestruturasArgs = {
  objects: Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_Infraestruturas_OneArgs = {
  object: Utilizadores_Equipas_Virtuais_R_Infraestruturas_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_SintomaArgs = {
  objects: Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_Sintoma_OneArgs = {
  object: Utilizadores_Equipas_Virtuais_R_Sintoma_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_ToponimiasArgs = {
  objects: Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_Toponimias_OneArgs = {
  object: Utilizadores_Equipas_Virtuais_R_Toponimias_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_TransacoesArgs = {
  objects: Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_Transacoes_OneArgs = {
  object: Utilizadores_Equipas_Virtuais_R_Transacoes_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_UtilizadoresArgs = {
  objects: Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Equipas_Virtuais_R_Utilizadores_OneArgs = {
  object: Utilizadores_Equipas_Virtuais_R_Utilizadores_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_ExportacoesArgs = {
  objects: Array<Utilizadores_Exportacoes_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Exportacoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Exportacoes_OneArgs = {
  object: Utilizadores_Exportacoes_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Exportacoes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Mapa_Posicao_CoresArgs = {
  objects: Array<Utilizadores_Mapa_Posicao_Cores_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Mapa_Posicao_Cores_OneArgs = {
  object: Utilizadores_Mapa_Posicao_Cores_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_MenuArgs = {
  objects: Array<Utilizadores_Menu_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Menu_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Menu_OneArgs = {
  object: Utilizadores_Menu_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Menu_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_TemasArgs = {
  objects: Array<Utilizadores_Temas_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Temas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Temas_OneArgs = {
  object: Utilizadores_Temas_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Temas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_UtilizadoresArgs = {
  objects: Array<Utilizadores_Utilizadores_Insert_Input>;
  on_conflict?: InputMaybe<Utilizadores_Utilizadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Utilizadores_Utilizadores_OneArgs = {
  object: Utilizadores_Utilizadores_Insert_Input;
  on_conflict?: InputMaybe<Utilizadores_Utilizadores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_AgregacaoArgs = {
  objects: Array<Variaveis_Agregacao_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Agregacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Agregacao_OneArgs = {
  object: Variaveis_Agregacao_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Agregacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_BaseArgs = {
  objects: Array<Variaveis_Base_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Base_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Base_Calc_VariaveisArgs = {
  objects: Array<Variaveis_Base_Calc_Variaveis_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Base_Calc_Variaveis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Base_Calc_Variaveis_OneArgs = {
  object: Variaveis_Base_Calc_Variaveis_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Base_Calc_Variaveis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Base_CategoriasArgs = {
  objects: Array<Variaveis_Base_Categorias_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Base_Categorias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Base_Categorias_OneArgs = {
  object: Variaveis_Base_Categorias_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Base_Categorias_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Base_OneArgs = {
  object: Variaveis_Base_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Base_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Base_PropriedadesArgs = {
  objects: Array<Variaveis_Base_Propriedades_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Base_Propriedades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Base_Propriedades_OneArgs = {
  object: Variaveis_Base_Propriedades_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Base_Propriedades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Calc_VariaveisArgs = {
  objects: Array<Variaveis_Calc_Variaveis_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Calc_Variaveis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Calc_Variaveis_OneArgs = {
  object: Variaveis_Calc_Variaveis_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Calc_Variaveis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_DominiosArgs = {
  objects: Array<Variaveis_Dominios_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Dominios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Dominios_OneArgs = {
  object: Variaveis_Dominios_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Dominios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Dominios_R_Dominios_ValoresArgs = {
  objects: Array<Variaveis_Dominios_R_Dominios_Valores_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Dominios_R_Dominios_Valores_OneArgs = {
  object: Variaveis_Dominios_R_Dominios_Valores_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Dominios_ValoresArgs = {
  objects: Array<Variaveis_Dominios_Valores_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Dominios_Valores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Dominios_Valores_OneArgs = {
  object: Variaveis_Dominios_Valores_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Dominios_Valores_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Escalas_PrecisaoArgs = {
  objects: Array<Variaveis_Escalas_Precisao_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Escalas_Precisao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Escalas_Precisao_OneArgs = {
  object: Variaveis_Escalas_Precisao_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Escalas_Precisao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Fontes_OrigemArgs = {
  objects: Array<Variaveis_Fontes_Origem_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Fontes_Origem_OneArgs = {
  object: Variaveis_Fontes_Origem_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Fontes_Origem_PropriedadesArgs = {
  objects: Array<Variaveis_Fontes_Origem_Propriedades_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Fontes_Origem_Propriedades_OneArgs = {
  object: Variaveis_Fontes_Origem_Propriedades_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Fontes_Origem_TiposArgs = {
  objects: Array<Variaveis_Fontes_Origem_Tipos_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Fontes_Origem_Tipos_OneArgs = {
  object: Variaveis_Fontes_Origem_Tipos_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_LeiturasArgs = {
  objects: Array<Variaveis_Leituras_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Leituras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Leituras_OneArgs = {
  object: Variaveis_Leituras_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Leituras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_ParametrosArgs = {
  objects: Array<Variaveis_Parametros_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Parametros_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Parametros_OneArgs = {
  object: Variaveis_Parametros_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Parametros_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Parametros_R_Unidades_MedidaArgs = {
  objects: Array<Variaveis_Parametros_R_Unidades_Medida_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Parametros_R_Unidades_Medida_OneArgs = {
  object: Variaveis_Parametros_R_Unidades_Medida_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_TiposArgs = {
  objects: Array<Variaveis_Tipos_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Tipos_OneArgs = {
  object: Variaveis_Tipos_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Tipos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Totalizadores_Tipos_RegistoArgs = {
  objects: Array<Variaveis_Totalizadores_Tipos_Registo_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Totalizadores_Tipos_Registo_OneArgs = {
  object: Variaveis_Totalizadores_Tipos_Registo_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Unidades_MedidaArgs = {
  objects: Array<Variaveis_Unidades_Medida_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Unidades_Medida_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Unidades_Medida_OneArgs = {
  object: Variaveis_Unidades_Medida_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Unidades_Medida_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Valores_MensaisArgs = {
  objects: Array<Variaveis_Valores_Mensais_Insert_Input>;
  on_conflict?: InputMaybe<Variaveis_Valores_Mensais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Variaveis_Valores_Mensais_OneArgs = {
  object: Variaveis_Valores_Mensais_Insert_Input;
  on_conflict?: InputMaybe<Variaveis_Valores_Mensais_On_Conflict>;
};


/** mutation root */
export type Mutation_RootSaveDailyFlowExpressionArgs = {
  expression?: InputMaybe<Scalars['String']['input']>;
  municipalityId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_Base_Bulk_TiposArgs = {
  _inc?: InputMaybe<Base_Bulk_Tipos_Inc_Input>;
  _set?: InputMaybe<Base_Bulk_Tipos_Set_Input>;
  where: Base_Bulk_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Bulk_Tipos_By_PkArgs = {
  _inc?: InputMaybe<Base_Bulk_Tipos_Inc_Input>;
  _set?: InputMaybe<Base_Bulk_Tipos_Set_Input>;
  pk_columns: Base_Bulk_Tipos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Bulk_Tipos_ManyArgs = {
  updates: Array<Base_Bulk_Tipos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_CentrosArgs = {
  _inc?: InputMaybe<Base_Centros_Inc_Input>;
  _set?: InputMaybe<Base_Centros_Set_Input>;
  where: Base_Centros_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Centros_By_PkArgs = {
  _inc?: InputMaybe<Base_Centros_Inc_Input>;
  _set?: InputMaybe<Base_Centros_Set_Input>;
  pk_columns: Base_Centros_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Centros_ManyArgs = {
  updates: Array<Base_Centros_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_InfraestruturasArgs = {
  _inc?: InputMaybe<Base_Infraestruturas_Inc_Input>;
  _set?: InputMaybe<Base_Infraestruturas_Set_Input>;
  where: Base_Infraestruturas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Infraestruturas_By_PkArgs = {
  _inc?: InputMaybe<Base_Infraestruturas_Inc_Input>;
  _set?: InputMaybe<Base_Infraestruturas_Set_Input>;
  pk_columns: Base_Infraestruturas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Infraestruturas_CoordenadasArgs = {
  _inc?: InputMaybe<Base_Infraestruturas_Coordenadas_Inc_Input>;
  _set?: InputMaybe<Base_Infraestruturas_Coordenadas_Set_Input>;
  where: Base_Infraestruturas_Coordenadas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Infraestruturas_Coordenadas_By_PkArgs = {
  _inc?: InputMaybe<Base_Infraestruturas_Coordenadas_Inc_Input>;
  _set?: InputMaybe<Base_Infraestruturas_Coordenadas_Set_Input>;
  pk_columns: Base_Infraestruturas_Coordenadas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Infraestruturas_Coordenadas_ManyArgs = {
  updates: Array<Base_Infraestruturas_Coordenadas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Infraestruturas_ManyArgs = {
  updates: Array<Base_Infraestruturas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Infraestruturas_R_ToponimiasArgs = {
  _inc?: InputMaybe<Base_Infraestruturas_R_Toponimias_Inc_Input>;
  _set?: InputMaybe<Base_Infraestruturas_R_Toponimias_Set_Input>;
  where: Base_Infraestruturas_R_Toponimias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Infraestruturas_R_Toponimias_By_PkArgs = {
  _inc?: InputMaybe<Base_Infraestruturas_R_Toponimias_Inc_Input>;
  _set?: InputMaybe<Base_Infraestruturas_R_Toponimias_Set_Input>;
  pk_columns: Base_Infraestruturas_R_Toponimias_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Infraestruturas_R_Toponimias_ManyArgs = {
  updates: Array<Base_Infraestruturas_R_Toponimias_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Infraestruturas_TiposArgs = {
  _inc?: InputMaybe<Base_Infraestruturas_Tipos_Inc_Input>;
  _set?: InputMaybe<Base_Infraestruturas_Tipos_Set_Input>;
  where: Base_Infraestruturas_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Infraestruturas_Tipos_By_PkArgs = {
  _inc?: InputMaybe<Base_Infraestruturas_Tipos_Inc_Input>;
  _set?: InputMaybe<Base_Infraestruturas_Tipos_Set_Input>;
  pk_columns: Base_Infraestruturas_Tipos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Infraestruturas_Tipos_ManyArgs = {
  updates: Array<Base_Infraestruturas_Tipos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_ParametrizacoesArgs = {
  _inc?: InputMaybe<Base_Parametrizacoes_Inc_Input>;
  _set?: InputMaybe<Base_Parametrizacoes_Set_Input>;
  where: Base_Parametrizacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Parametrizacoes_ManyArgs = {
  updates: Array<Base_Parametrizacoes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_ToponimiasArgs = {
  _inc?: InputMaybe<Base_Toponimias_Inc_Input>;
  _set?: InputMaybe<Base_Toponimias_Set_Input>;
  where: Base_Toponimias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Toponimias_By_PkArgs = {
  _inc?: InputMaybe<Base_Toponimias_Inc_Input>;
  _set?: InputMaybe<Base_Toponimias_Set_Input>;
  pk_columns: Base_Toponimias_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Toponimias_CoordenadasArgs = {
  _inc?: InputMaybe<Base_Toponimias_Coordenadas_Inc_Input>;
  _set?: InputMaybe<Base_Toponimias_Coordenadas_Set_Input>;
  where: Base_Toponimias_Coordenadas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Toponimias_Coordenadas_By_PkArgs = {
  _inc?: InputMaybe<Base_Toponimias_Coordenadas_Inc_Input>;
  _set?: InputMaybe<Base_Toponimias_Coordenadas_Set_Input>;
  pk_columns: Base_Toponimias_Coordenadas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Toponimias_Coordenadas_ManyArgs = {
  updates: Array<Base_Toponimias_Coordenadas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Toponimias_ManyArgs = {
  updates: Array<Base_Toponimias_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_ZmcArgs = {
  _inc?: InputMaybe<Base_Zmc_Inc_Input>;
  _set?: InputMaybe<Base_Zmc_Set_Input>;
  where: Base_Zmc_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Zmc_By_PkArgs = {
  _inc?: InputMaybe<Base_Zmc_Inc_Input>;
  _set?: InputMaybe<Base_Zmc_Set_Input>;
  pk_columns: Base_Zmc_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Zmc_ManyArgs = {
  updates: Array<Base_Zmc_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Zmc_Nos_TipoArgs = {
  _inc?: InputMaybe<Base_Zmc_Nos_Tipo_Inc_Input>;
  _set?: InputMaybe<Base_Zmc_Nos_Tipo_Set_Input>;
  where: Base_Zmc_Nos_Tipo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Zmc_Nos_Tipo_By_PkArgs = {
  _inc?: InputMaybe<Base_Zmc_Nos_Tipo_Inc_Input>;
  _set?: InputMaybe<Base_Zmc_Nos_Tipo_Set_Input>;
  pk_columns: Base_Zmc_Nos_Tipo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Zmc_Nos_Tipo_ManyArgs = {
  updates: Array<Base_Zmc_Nos_Tipo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Consultas_RequisicoesArgs = {
  _inc?: InputMaybe<Consultas_Requisicoes_Inc_Input>;
  _set?: InputMaybe<Consultas_Requisicoes_Set_Input>;
  where: Consultas_Requisicoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consultas_Requisicoes_By_PkArgs = {
  _inc?: InputMaybe<Consultas_Requisicoes_Inc_Input>;
  _set?: InputMaybe<Consultas_Requisicoes_Set_Input>;
  pk_columns: Consultas_Requisicoes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Consultas_Requisicoes_ManyArgs = {
  updates: Array<Consultas_Requisicoes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Ad_ParametrizacaoArgs = {
  _inc?: InputMaybe<Integracoes_Ad_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Integracoes_Ad_Parametrizacao_Set_Input>;
  where: Integracoes_Ad_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Ad_Parametrizacao_ManyArgs = {
  updates: Array<Integracoes_Ad_Parametrizacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Ad_Saml_ParametrizacaoArgs = {
  _inc?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Set_Input>;
  where: Integracoes_Ad_Saml_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Ad_Saml_Parametrizacao_By_PkArgs = {
  _inc?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Set_Input>;
  pk_columns: Integracoes_Ad_Saml_Parametrizacao_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Ad_Saml_Parametrizacao_ManyArgs = {
  updates: Array<Integracoes_Ad_Saml_Parametrizacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Maps_OrtosArgs = {
  _inc?: InputMaybe<Integracoes_Sig_Maps_Ortos_Inc_Input>;
  _set?: InputMaybe<Integracoes_Sig_Maps_Ortos_Set_Input>;
  where: Integracoes_Sig_Maps_Ortos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Maps_Ortos_By_PkArgs = {
  _inc?: InputMaybe<Integracoes_Sig_Maps_Ortos_Inc_Input>;
  _set?: InputMaybe<Integracoes_Sig_Maps_Ortos_Set_Input>;
  pk_columns: Integracoes_Sig_Maps_Ortos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Maps_Ortos_ManyArgs = {
  updates: Array<Integracoes_Sig_Maps_Ortos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_ParametrizacaoArgs = {
  _inc?: InputMaybe<Integracoes_Sig_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Integracoes_Sig_Parametrizacao_Set_Input>;
  where: Integracoes_Sig_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Parametrizacao_ManyArgs = {
  updates: Array<Integracoes_Sig_Parametrizacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_ProxyArgs = {
  _inc?: InputMaybe<Integracoes_Sig_Proxy_Inc_Input>;
  _set?: InputMaybe<Integracoes_Sig_Proxy_Set_Input>;
  where: Integracoes_Sig_Proxy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Proxy_By_PkArgs = {
  _inc?: InputMaybe<Integracoes_Sig_Proxy_Inc_Input>;
  _set?: InputMaybe<Integracoes_Sig_Proxy_Set_Input>;
  pk_columns: Integracoes_Sig_Proxy_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Proxy_ManyArgs = {
  updates: Array<Integracoes_Sig_Proxy_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Request_Get_AttributesArgs = {
  _set?: InputMaybe<Integracoes_Sig_Request_Get_Attributes_Set_Input>;
  where: Integracoes_Sig_Request_Get_Attributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Request_Get_Attributes_ManyArgs = {
  updates: Array<Integracoes_Sig_Request_Get_Attributes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Request_Get_CapabilitiesArgs = {
  _set?: InputMaybe<Integracoes_Sig_Request_Get_Capabilities_Set_Input>;
  where: Integracoes_Sig_Request_Get_Capabilities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Request_Get_Capabilities_ManyArgs = {
  updates: Array<Integracoes_Sig_Request_Get_Capabilities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Request_Get_FeaturesArgs = {
  _set?: InputMaybe<Integracoes_Sig_Request_Get_Features_Set_Input>;
  where: Integracoes_Sig_Request_Get_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Request_Get_Features_ManyArgs = {
  updates: Array<Integracoes_Sig_Request_Get_Features_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_ServicesArgs = {
  _inc?: InputMaybe<Integracoes_Sig_Services_Inc_Input>;
  _set?: InputMaybe<Integracoes_Sig_Services_Set_Input>;
  where: Integracoes_Sig_Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Services_By_PkArgs = {
  _inc?: InputMaybe<Integracoes_Sig_Services_Inc_Input>;
  _set?: InputMaybe<Integracoes_Sig_Services_Set_Input>;
  pk_columns: Integracoes_Sig_Services_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Integracoes_Sig_Services_ManyArgs = {
  updates: Array<Integracoes_Sig_Services_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mensagens_AnexosArgs = {
  _inc?: InputMaybe<Mensagens_Anexos_Inc_Input>;
  _set?: InputMaybe<Mensagens_Anexos_Set_Input>;
  where: Mensagens_Anexos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mensagens_Anexos_By_PkArgs = {
  _inc?: InputMaybe<Mensagens_Anexos_Inc_Input>;
  _set?: InputMaybe<Mensagens_Anexos_Set_Input>;
  pk_columns: Mensagens_Anexos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mensagens_Anexos_ManyArgs = {
  updates: Array<Mensagens_Anexos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mensagens_MensagensArgs = {
  _inc?: InputMaybe<Mensagens_Mensagens_Inc_Input>;
  _set?: InputMaybe<Mensagens_Mensagens_Set_Input>;
  where: Mensagens_Mensagens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mensagens_Mensagens_By_PkArgs = {
  _inc?: InputMaybe<Mensagens_Mensagens_Inc_Input>;
  _set?: InputMaybe<Mensagens_Mensagens_Set_Input>;
  pk_columns: Mensagens_Mensagens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mensagens_Mensagens_ManyArgs = {
  updates: Array<Mensagens_Mensagens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mensagens_PostArgs = {
  _inc?: InputMaybe<Mensagens_Post_Inc_Input>;
  _set?: InputMaybe<Mensagens_Post_Set_Input>;
  where: Mensagens_Post_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mensagens_Post_By_PkArgs = {
  _inc?: InputMaybe<Mensagens_Post_Inc_Input>;
  _set?: InputMaybe<Mensagens_Post_Set_Input>;
  pk_columns: Mensagens_Post_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mensagens_Post_ManyArgs = {
  updates: Array<Mensagens_Post_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_CoordenadasArgs = {
  _inc?: InputMaybe<Mobile_Coordenadas_Inc_Input>;
  _set?: InputMaybe<Mobile_Coordenadas_Set_Input>;
  where: Mobile_Coordenadas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Coordenadas_By_PkArgs = {
  _inc?: InputMaybe<Mobile_Coordenadas_Inc_Input>;
  _set?: InputMaybe<Mobile_Coordenadas_Set_Input>;
  pk_columns: Mobile_Coordenadas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Coordenadas_ManyArgs = {
  updates: Array<Mobile_Coordenadas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_CoresArgs = {
  _inc?: InputMaybe<Navia_Cores_Inc_Input>;
  _set?: InputMaybe<Navia_Cores_Set_Input>;
  where: Navia_Cores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Cores_By_PkArgs = {
  _inc?: InputMaybe<Navia_Cores_Inc_Input>;
  _set?: InputMaybe<Navia_Cores_Set_Input>;
  pk_columns: Navia_Cores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Cores_ManyArgs = {
  updates: Array<Navia_Cores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_VariaveisArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Set_Input>;
  where: Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Set_Input>;
  pk_columns: Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_ManyArgs = {
  updates: Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Mapa_NiveisArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Set_Input>;
  where: Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Set_Input>;
  pk_columns: Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_ManyArgs = {
  updates: Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_SintomasArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Set_Input>;
  where: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Sintomas_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Set_Input>;
  pk_columns: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Sintomas_ManyArgs = {
  updates: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Sintomas_TiposArgs = {
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Set_Input>;
  where: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_By_PkArgs = {
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Set_Input>;
  pk_columns: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_ManyArgs = {
  updates: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Tipos_InfraestruturaArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Set_Input>;
  where: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Set_Input>;
  pk_columns: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_ManyArgs = {
  updates: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_ZmcArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Set_Input>;
  where: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Set_Input>;
  pk_columns: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_ManyArgs = {
  updates: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_MenuArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Menu_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Menu_Set_Input>;
  where: Navia_Dashboards_Menu_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Menu_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Menu_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Menu_Set_Input>;
  pk_columns: Navia_Dashboards_Menu_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Menu_ManyArgs = {
  updates: Array<Navia_Dashboards_Menu_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Menu_R_TransacoesArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Set_Input>;
  where: Navia_Dashboards_Menu_R_Transacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Menu_R_Transacoes_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Set_Input>;
  pk_columns: Navia_Dashboards_Menu_R_Transacoes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Menu_R_Transacoes_ManyArgs = {
  updates: Array<Navia_Dashboards_Menu_R_Transacoes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Modo_Tv_TokensArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Set_Input>;
  where: Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Modo_Tv_Tokens_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Set_Input>;
  pk_columns: Navia_Dashboards_Modo_Tv_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Modo_Tv_Tokens_ManyArgs = {
  updates: Array<Navia_Dashboards_Modo_Tv_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Modo_Tv_Tokens_Revogacao_ManualArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Set_Input>;
  where: Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Set_Input>;
  pk_columns: Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_ManyArgs = {
  updates: Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Modo_Tv_Tokens_ValidadosArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Set_Input>;
  where: Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Modo_Tv_Tokens_Validados_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Set_Input>;
  pk_columns: Navia_Dashboards_Modo_Tv_Tokens_Validados_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Modo_Tv_Tokens_Validados_ManyArgs = {
  updates: Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_CausasArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Set_Input>;
  where: Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Causas_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Set_Input>;
  pk_columns: Navia_Dashboards_Monitorizacao_Roturas_Causas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Causas_ManyArgs = {
  updates: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Causas_R_CausasArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Set_Input>;
  where: Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Set_Input>;
  pk_columns: Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_ManyArgs = {
  updates: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_IndicadoresArgs = {
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Set_Input>;
  where: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Indicadores_By_PkArgs = {
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Set_Input>;
  pk_columns: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Indicadores_ManyArgs = {
  updates: Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_SintomasArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Set_Input>;
  where: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Sintomas_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Set_Input>;
  pk_columns: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Sintomas_ManyArgs = {
  updates: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_SintomasArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Set_Input>;
  where: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Set_Input>;
  pk_columns: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_ManyArgs = {
  updates: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_VariaveisArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Set_Input>;
  where: Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Variaveis_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Set_Input>;
  pk_columns: Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Monitorizacao_Roturas_Variaveis_ManyArgs = {
  updates: Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Performance_Infraestrutura_ParametrizacaoArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Set_Input>;
  where: Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Set_Input>;
  pk_columns: Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_ManyArgs = {
  updates: Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_ParametrizacaoArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Set_Input>;
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Set_Input>;
  pk_columns: Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_ManyArgs = {
  updates: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_TarefaArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Set_Input>;
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Set_Input>;
  pk_columns: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_ManyArgs = {
  updates: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_SintomasArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Set_Input>;
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Set_Input>;
  pk_columns: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_ManyArgs = {
  updates: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_ValoresArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Set_Input>;
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Set_Input>;
  pk_columns: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_ManyArgs = {
  updates: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_InfraestruturaArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Set_Input>;
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Set_Input>;
  pk_columns: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_ManyArgs = {
  updates: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Requisicoes_Indicadores_ParametrizacaoArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Set_Input>;
  where: Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Set_Input>;
  pk_columns: Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_ManyArgs = {
  updates: Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Requisicoes_Mapa_ParametrizacaoArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Set_Input>;
  where: Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Set_Input>;
  pk_columns: Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_ManyArgs = {
  updates: Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Visao_360_ParametrizacaoArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Set_Input>;
  where: Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Visao_360_Parametrizacao_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Set_Input>;
  pk_columns: Navia_Dashboards_Visao_360_Parametrizacao_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Visao_360_Parametrizacao_ManyArgs = {
  updates: Array<Navia_Dashboards_Visao_360_Parametrizacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Visao_360_SelectoresArgs = {
  _set?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Set_Input>;
  where: Navia_Dashboards_Visao_360_Selectores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Visao_360_Selectores_By_PkArgs = {
  _set?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Set_Input>;
  pk_columns: Navia_Dashboards_Visao_360_Selectores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Visao_360_Selectores_ManyArgs = {
  updates: Array<Navia_Dashboards_Visao_360_Selectores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_CaudaisArgs = {
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Set_Input>;
  where: Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Caudais_By_PkArgs = {
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Set_Input>;
  pk_columns: Navia_Dashboards_Volumes_Diarios_Caudais_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Caudais_ManyArgs = {
  updates: Array<Navia_Dashboards_Volumes_Diarios_Caudais_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_DadosArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Set_Input>;
  where: Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Dados_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Set_Input>;
  pk_columns: Navia_Dashboards_Volumes_Diarios_Dados_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Dados_ManyArgs = {
  updates: Array<Navia_Dashboards_Volumes_Diarios_Dados_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_MunicipiosArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Set_Input>;
  where: Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Set_Input>;
  pk_columns: Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_ManyArgs = {
  updates: Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_LeiturasArgs = {
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Set_Input>;
  where: Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Leituras_By_PkArgs = {
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Set_Input>;
  pk_columns: Navia_Dashboards_Volumes_Diarios_Leituras_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Leituras_ManyArgs = {
  updates: Array<Navia_Dashboards_Volumes_Diarios_Leituras_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_LocaisArgs = {
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Set_Input>;
  where: Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Locais_By_PkArgs = {
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Set_Input>;
  pk_columns: Navia_Dashboards_Volumes_Diarios_Locais_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Locais_ManyArgs = {
  updates: Array<Navia_Dashboards_Volumes_Diarios_Locais_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_MunicipiosArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Set_Input>;
  where: Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Municipios_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Set_Input>;
  pk_columns: Navia_Dashboards_Volumes_Diarios_Municipios_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Municipios_ManyArgs = {
  updates: Array<Navia_Dashboards_Volumes_Diarios_Municipios_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_RegistosArgs = {
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Set_Input>;
  where: Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Registos_By_PkArgs = {
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Set_Input>;
  pk_columns: Navia_Dashboards_Volumes_Diarios_Registos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Registos_ManyArgs = {
  updates: Array<Navia_Dashboards_Volumes_Diarios_Registos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Totalizador_LeiturasArgs = {
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Set_Input>;
  where: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_By_PkArgs = {
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Set_Input>;
  pk_columns: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_ManyArgs = {
  updates: Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_TotalizadoresArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Set_Input>;
  where: Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Totalizadores_By_PkArgs = {
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Inc_Input>;
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Set_Input>;
  pk_columns: Navia_Dashboards_Volumes_Diarios_Totalizadores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Dashboards_Volumes_Diarios_Totalizadores_ManyArgs = {
  updates: Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_IntegracoesArgs = {
  _inc?: InputMaybe<Navia_Integracoes_Inc_Input>;
  _set?: InputMaybe<Navia_Integracoes_Set_Input>;
  where: Navia_Integracoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Integracoes_By_PkArgs = {
  _inc?: InputMaybe<Navia_Integracoes_Inc_Input>;
  _set?: InputMaybe<Navia_Integracoes_Set_Input>;
  pk_columns: Navia_Integracoes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Integracoes_ManyArgs = {
  updates: Array<Navia_Integracoes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_LogArgs = {
  _inc?: InputMaybe<Navia_Log_Inc_Input>;
  _set?: InputMaybe<Navia_Log_Set_Input>;
  where: Navia_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Log_By_PkArgs = {
  _inc?: InputMaybe<Navia_Log_Inc_Input>;
  _set?: InputMaybe<Navia_Log_Set_Input>;
  pk_columns: Navia_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Navia_Log_ManyArgs = {
  updates: Array<Navia_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_ItensArgs = {
  _inc?: InputMaybe<Notificacoes_Itens_Inc_Input>;
  _set?: InputMaybe<Notificacoes_Itens_Set_Input>;
  where: Notificacoes_Itens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_Itens_By_PkArgs = {
  _inc?: InputMaybe<Notificacoes_Itens_Inc_Input>;
  _set?: InputMaybe<Notificacoes_Itens_Set_Input>;
  pk_columns: Notificacoes_Itens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_Itens_ManyArgs = {
  updates: Array<Notificacoes_Itens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_NotificacoesArgs = {
  _inc?: InputMaybe<Notificacoes_Notificacoes_Inc_Input>;
  _set?: InputMaybe<Notificacoes_Notificacoes_Set_Input>;
  where: Notificacoes_Notificacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_Notificacoes_By_PkArgs = {
  _inc?: InputMaybe<Notificacoes_Notificacoes_Inc_Input>;
  _set?: InputMaybe<Notificacoes_Notificacoes_Set_Input>;
  pk_columns: Notificacoes_Notificacoes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_Notificacoes_ManyArgs = {
  updates: Array<Notificacoes_Notificacoes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_Notificacoes_R_UtilizadoresArgs = {
  _inc?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Inc_Input>;
  _set?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Set_Input>;
  where: Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_Notificacoes_R_Utilizadores_By_PkArgs = {
  _inc?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Inc_Input>;
  _set?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Set_Input>;
  pk_columns: Notificacoes_Notificacoes_R_Utilizadores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_Notificacoes_R_Utilizadores_ManyArgs = {
  updates: Array<Notificacoes_Notificacoes_R_Utilizadores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_TiposArgs = {
  _inc?: InputMaybe<Notificacoes_Tipos_Inc_Input>;
  _set?: InputMaybe<Notificacoes_Tipos_Set_Input>;
  where: Notificacoes_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_Tipos_By_PkArgs = {
  _inc?: InputMaybe<Notificacoes_Tipos_Inc_Input>;
  _set?: InputMaybe<Notificacoes_Tipos_Set_Input>;
  pk_columns: Notificacoes_Tipos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notificacoes_Tipos_ManyArgs = {
  updates: Array<Notificacoes_Tipos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Permissoes_TransacoesArgs = {
  _inc?: InputMaybe<Permissoes_Transacoes_Inc_Input>;
  _set?: InputMaybe<Permissoes_Transacoes_Set_Input>;
  where: Permissoes_Transacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Permissoes_Transacoes_By_PkArgs = {
  _inc?: InputMaybe<Permissoes_Transacoes_Inc_Input>;
  _set?: InputMaybe<Permissoes_Transacoes_Set_Input>;
  pk_columns: Permissoes_Transacoes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Permissoes_Transacoes_ManyArgs = {
  updates: Array<Permissoes_Transacoes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Permissoes_Transacoes_R_MenusArgs = {
  _inc?: InputMaybe<Permissoes_Transacoes_R_Menus_Inc_Input>;
  _set?: InputMaybe<Permissoes_Transacoes_R_Menus_Set_Input>;
  where: Permissoes_Transacoes_R_Menus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Permissoes_Transacoes_R_Menus_By_PkArgs = {
  _inc?: InputMaybe<Permissoes_Transacoes_R_Menus_Inc_Input>;
  _set?: InputMaybe<Permissoes_Transacoes_R_Menus_Set_Input>;
  pk_columns: Permissoes_Transacoes_R_Menus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Permissoes_Transacoes_R_Menus_ManyArgs = {
  updates: Array<Permissoes_Transacoes_R_Menus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_ParametrizacaoArgs = {
  _set?: InputMaybe<Rqs_Parametrizacao_Set_Input>;
  where: Rqs_Parametrizacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Parametrizacao_ManyArgs = {
  updates: Array<Rqs_Parametrizacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Requisicoes_PeriodosArgs = {
  _inc?: InputMaybe<Rqs_Requisicoes_Periodos_Inc_Input>;
  _set?: InputMaybe<Rqs_Requisicoes_Periodos_Set_Input>;
  where: Rqs_Requisicoes_Periodos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Requisicoes_Periodos_By_PkArgs = {
  _inc?: InputMaybe<Rqs_Requisicoes_Periodos_Inc_Input>;
  _set?: InputMaybe<Rqs_Requisicoes_Periodos_Set_Input>;
  pk_columns: Rqs_Requisicoes_Periodos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Requisicoes_Periodos_ManyArgs = {
  updates: Array<Rqs_Requisicoes_Periodos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Requisicoes_Tempos_WrapArgs = {
  _inc?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Inc_Input>;
  _set?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Set_Input>;
  where: Rqs_Requisicoes_Tempos_Wrap_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Requisicoes_Tempos_Wrap_By_PkArgs = {
  _inc?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Inc_Input>;
  _set?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Set_Input>;
  pk_columns: Rqs_Requisicoes_Tempos_Wrap_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Requisicoes_Tempos_Wrap_ManyArgs = {
  updates: Array<Rqs_Requisicoes_Tempos_Wrap_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_SintomasArgs = {
  _inc?: InputMaybe<Rqs_Sintomas_Inc_Input>;
  _set?: InputMaybe<Rqs_Sintomas_Set_Input>;
  where: Rqs_Sintomas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Sintomas_By_PkArgs = {
  _inc?: InputMaybe<Rqs_Sintomas_Inc_Input>;
  _set?: InputMaybe<Rqs_Sintomas_Set_Input>;
  pk_columns: Rqs_Sintomas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Sintomas_ManyArgs = {
  updates: Array<Rqs_Sintomas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Sintomas_Parametrizacao_TemposArgs = {
  _inc?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Inc_Input>;
  _set?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Set_Input>;
  where: Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Sintomas_Parametrizacao_Tempos_By_PkArgs = {
  _inc?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Inc_Input>;
  _set?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Set_Input>;
  pk_columns: Rqs_Sintomas_Parametrizacao_Tempos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rqs_Sintomas_Parametrizacao_Tempos_ManyArgs = {
  updates: Array<Rqs_Sintomas_Parametrizacao_Tempos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_FasesArgs = {
  _inc?: InputMaybe<Servicos_Fases_Inc_Input>;
  _set?: InputMaybe<Servicos_Fases_Set_Input>;
  where: Servicos_Fases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Fases_By_PkArgs = {
  _inc?: InputMaybe<Servicos_Fases_Inc_Input>;
  _set?: InputMaybe<Servicos_Fases_Set_Input>;
  pk_columns: Servicos_Fases_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Fases_ManyArgs = {
  updates: Array<Servicos_Fases_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_IntervencoesArgs = {
  _inc?: InputMaybe<Servicos_Intervencoes_Inc_Input>;
  _set?: InputMaybe<Servicos_Intervencoes_Set_Input>;
  where: Servicos_Intervencoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Intervencoes_Atribuicao_UtilizadoresArgs = {
  _inc?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Inc_Input>;
  _set?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Set_Input>;
  where: Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Intervencoes_Atribuicao_Utilizadores_By_PkArgs = {
  _inc?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Inc_Input>;
  _set?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Set_Input>;
  pk_columns: Servicos_Intervencoes_Atribuicao_Utilizadores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Intervencoes_Atribuicao_Utilizadores_ManyArgs = {
  updates: Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Intervencoes_By_PkArgs = {
  _inc?: InputMaybe<Servicos_Intervencoes_Inc_Input>;
  _set?: InputMaybe<Servicos_Intervencoes_Set_Input>;
  pk_columns: Servicos_Intervencoes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Intervencoes_EstadosArgs = {
  _inc?: InputMaybe<Servicos_Intervencoes_Estados_Inc_Input>;
  _set?: InputMaybe<Servicos_Intervencoes_Estados_Set_Input>;
  where: Servicos_Intervencoes_Estados_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Intervencoes_Estados_By_PkArgs = {
  _inc?: InputMaybe<Servicos_Intervencoes_Estados_Inc_Input>;
  _set?: InputMaybe<Servicos_Intervencoes_Estados_Set_Input>;
  pk_columns: Servicos_Intervencoes_Estados_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Intervencoes_Estados_ManyArgs = {
  updates: Array<Servicos_Intervencoes_Estados_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Intervencoes_ManyArgs = {
  updates: Array<Servicos_Intervencoes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Intervencoes_R_Causas_TrabalhosArgs = {
  _inc?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Inc_Input>;
  _set?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Set_Input>;
  where: Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Intervencoes_R_Causas_Trabalhos_By_PkArgs = {
  _inc?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Inc_Input>;
  _set?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Set_Input>;
  pk_columns: Servicos_Intervencoes_R_Causas_Trabalhos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Intervencoes_R_Causas_Trabalhos_ManyArgs = {
  updates: Array<Servicos_Intervencoes_R_Causas_Trabalhos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_RastreabilidadeArgs = {
  _inc?: InputMaybe<Servicos_Rastreabilidade_Inc_Input>;
  _set?: InputMaybe<Servicos_Rastreabilidade_Set_Input>;
  where: Servicos_Rastreabilidade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Rastreabilidade_By_PkArgs = {
  _inc?: InputMaybe<Servicos_Rastreabilidade_Inc_Input>;
  _set?: InputMaybe<Servicos_Rastreabilidade_Set_Input>;
  pk_columns: Servicos_Rastreabilidade_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Rastreabilidade_ManyArgs = {
  updates: Array<Servicos_Rastreabilidade_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_RequisicoesArgs = {
  _inc?: InputMaybe<Servicos_Requisicoes_Inc_Input>;
  _set?: InputMaybe<Servicos_Requisicoes_Set_Input>;
  where: Servicos_Requisicoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Requisicoes_By_PkArgs = {
  _inc?: InputMaybe<Servicos_Requisicoes_Inc_Input>;
  _set?: InputMaybe<Servicos_Requisicoes_Set_Input>;
  pk_columns: Servicos_Requisicoes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Requisicoes_EstadosArgs = {
  _inc?: InputMaybe<Servicos_Requisicoes_Estados_Inc_Input>;
  _set?: InputMaybe<Servicos_Requisicoes_Estados_Set_Input>;
  where: Servicos_Requisicoes_Estados_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Requisicoes_Estados_By_PkArgs = {
  _inc?: InputMaybe<Servicos_Requisicoes_Estados_Inc_Input>;
  _set?: InputMaybe<Servicos_Requisicoes_Estados_Set_Input>;
  pk_columns: Servicos_Requisicoes_Estados_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Requisicoes_Estados_ManyArgs = {
  updates: Array<Servicos_Requisicoes_Estados_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Requisicoes_Locais_Infra_EstruturasArgs = {
  _inc?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Inc_Input>;
  _set?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Set_Input>;
  where: Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Requisicoes_Locais_Infra_Estruturas_By_PkArgs = {
  _inc?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Inc_Input>;
  _set?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Set_Input>;
  pk_columns: Servicos_Requisicoes_Locais_Infra_Estruturas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Requisicoes_Locais_Infra_Estruturas_ManyArgs = {
  updates: Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Requisicoes_ManyArgs = {
  updates: Array<Servicos_Requisicoes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Requisicoes_R_IntervencoesArgs = {
  _inc?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Inc_Input>;
  _set?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Set_Input>;
  where: Servicos_Requisicoes_R_Intervencoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Requisicoes_R_Intervencoes_By_PkArgs = {
  _inc?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Inc_Input>;
  _set?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Set_Input>;
  pk_columns: Servicos_Requisicoes_R_Intervencoes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Servicos_Requisicoes_R_Intervencoes_ManyArgs = {
  updates: Array<Servicos_Requisicoes_R_Intervencoes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_ArvoreArgs = {
  _inc?: InputMaybe<Sintomas_Arvore_Inc_Input>;
  _set?: InputMaybe<Sintomas_Arvore_Set_Input>;
  where: Sintomas_Arvore_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_Arvore_By_PkArgs = {
  _inc?: InputMaybe<Sintomas_Arvore_Inc_Input>;
  _set?: InputMaybe<Sintomas_Arvore_Set_Input>;
  pk_columns: Sintomas_Arvore_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_Arvore_ManyArgs = {
  updates: Array<Sintomas_Arvore_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_Causas_TrabalhosArgs = {
  _inc?: InputMaybe<Sintomas_Causas_Trabalhos_Inc_Input>;
  _set?: InputMaybe<Sintomas_Causas_Trabalhos_Set_Input>;
  where: Sintomas_Causas_Trabalhos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_Causas_Trabalhos_By_PkArgs = {
  _inc?: InputMaybe<Sintomas_Causas_Trabalhos_Inc_Input>;
  _set?: InputMaybe<Sintomas_Causas_Trabalhos_Set_Input>;
  pk_columns: Sintomas_Causas_Trabalhos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_Causas_Trabalhos_ManyArgs = {
  updates: Array<Sintomas_Causas_Trabalhos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_Sintomas_RelacaoArgs = {
  _inc?: InputMaybe<Sintomas_Sintomas_Relacao_Inc_Input>;
  _set?: InputMaybe<Sintomas_Sintomas_Relacao_Set_Input>;
  where: Sintomas_Sintomas_Relacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_Sintomas_Relacao_By_PkArgs = {
  _inc?: InputMaybe<Sintomas_Sintomas_Relacao_Inc_Input>;
  _set?: InputMaybe<Sintomas_Sintomas_Relacao_Set_Input>;
  pk_columns: Sintomas_Sintomas_Relacao_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_Sintomas_Relacao_ManyArgs = {
  updates: Array<Sintomas_Sintomas_Relacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_Sintomas_Relacao_OrdemArgs = {
  _inc?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Inc_Input>;
  _set?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Set_Input>;
  where: Sintomas_Sintomas_Relacao_Ordem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_Sintomas_Relacao_Ordem_By_PkArgs = {
  _inc?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Inc_Input>;
  _set?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Set_Input>;
  pk_columns: Sintomas_Sintomas_Relacao_Ordem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sintomas_Sintomas_Relacao_Ordem_ManyArgs = {
  updates: Array<Sintomas_Sintomas_Relacao_Ordem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_EstadosArgs = {
  _inc?: InputMaybe<Tarefas_Estados_Inc_Input>;
  _set?: InputMaybe<Tarefas_Estados_Set_Input>;
  where: Tarefas_Estados_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Estados_By_PkArgs = {
  _inc?: InputMaybe<Tarefas_Estados_Inc_Input>;
  _set?: InputMaybe<Tarefas_Estados_Set_Input>;
  pk_columns: Tarefas_Estados_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Estados_ManyArgs = {
  updates: Array<Tarefas_Estados_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_IntervalosArgs = {
  _inc?: InputMaybe<Tarefas_Intervalos_Inc_Input>;
  _set?: InputMaybe<Tarefas_Intervalos_Set_Input>;
  where: Tarefas_Intervalos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Intervalos_By_PkArgs = {
  _inc?: InputMaybe<Tarefas_Intervalos_Inc_Input>;
  _set?: InputMaybe<Tarefas_Intervalos_Set_Input>;
  pk_columns: Tarefas_Intervalos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Intervalos_ManyArgs = {
  updates: Array<Tarefas_Intervalos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Planos_PadraoArgs = {
  _inc?: InputMaybe<Tarefas_Planos_Padrao_Inc_Input>;
  _set?: InputMaybe<Tarefas_Planos_Padrao_Set_Input>;
  where: Tarefas_Planos_Padrao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Planos_Padrao_By_PkArgs = {
  _inc?: InputMaybe<Tarefas_Planos_Padrao_Inc_Input>;
  _set?: InputMaybe<Tarefas_Planos_Padrao_Set_Input>;
  pk_columns: Tarefas_Planos_Padrao_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Planos_Padrao_ManyArgs = {
  updates: Array<Tarefas_Planos_Padrao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_TarefasArgs = {
  _inc?: InputMaybe<Tarefas_Tarefas_Inc_Input>;
  _set?: InputMaybe<Tarefas_Tarefas_Set_Input>;
  where: Tarefas_Tarefas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Tarefas_By_PkArgs = {
  _inc?: InputMaybe<Tarefas_Tarefas_Inc_Input>;
  _set?: InputMaybe<Tarefas_Tarefas_Set_Input>;
  pk_columns: Tarefas_Tarefas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Tarefas_ManyArgs = {
  updates: Array<Tarefas_Tarefas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Tarefas_R_Equipas_VirtuaisArgs = {
  _inc?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Inc_Input>;
  _set?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Set_Input>;
  where: Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Tarefas_R_Equipas_Virtuais_By_PkArgs = {
  _inc?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Inc_Input>;
  _set?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Set_Input>;
  pk_columns: Tarefas_Tarefas_R_Equipas_Virtuais_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Tarefas_R_Equipas_Virtuais_ManyArgs = {
  updates: Array<Tarefas_Tarefas_R_Equipas_Virtuais_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Tarefas_R_InfraestruturasArgs = {
  _inc?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Inc_Input>;
  _set?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Set_Input>;
  where: Tarefas_Tarefas_R_Infraestruturas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Tarefas_R_Infraestruturas_By_PkArgs = {
  _inc?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Inc_Input>;
  _set?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Set_Input>;
  pk_columns: Tarefas_Tarefas_R_Infraestruturas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tarefas_Tarefas_R_Infraestruturas_ManyArgs = {
  updates: Array<Tarefas_Tarefas_R_Infraestruturas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_CategoriasArgs = {
  _inc?: InputMaybe<Utilizadores_Categorias_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Categorias_Set_Input>;
  where: Utilizadores_Categorias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Categorias_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Categorias_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Categorias_Set_Input>;
  pk_columns: Utilizadores_Categorias_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Categorias_ManyArgs = {
  updates: Array<Utilizadores_Categorias_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_VirtuaisArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_Set_Input>;
  where: Utilizadores_Equipas_Virtuais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_Set_Input>;
  pk_columns: Utilizadores_Equipas_Virtuais_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_ManyArgs = {
  updates: Array<Utilizadores_Equipas_Virtuais_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_CentrosArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Set_Input>;
  where: Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Centros_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Set_Input>;
  pk_columns: Utilizadores_Equipas_Virtuais_R_Centros_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Centros_ManyArgs = {
  updates: Array<Utilizadores_Equipas_Virtuais_R_Centros_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Equipas_VirtuaisArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Set_Input>;
  where: Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Set_Input>;
  pk_columns: Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_ManyArgs = {
  updates: Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_InfraestruturasArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Set_Input>;
  where: Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Infraestruturas_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Set_Input>;
  pk_columns: Utilizadores_Equipas_Virtuais_R_Infraestruturas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Infraestruturas_ManyArgs = {
  updates: Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_SintomaArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Set_Input>;
  where: Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Sintoma_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Set_Input>;
  pk_columns: Utilizadores_Equipas_Virtuais_R_Sintoma_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Sintoma_ManyArgs = {
  updates: Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_ToponimiasArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Set_Input>;
  where: Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Toponimias_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Set_Input>;
  pk_columns: Utilizadores_Equipas_Virtuais_R_Toponimias_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Toponimias_ManyArgs = {
  updates: Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_TransacoesArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Set_Input>;
  where: Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Transacoes_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Set_Input>;
  pk_columns: Utilizadores_Equipas_Virtuais_R_Transacoes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Transacoes_ManyArgs = {
  updates: Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_UtilizadoresArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Set_Input>;
  where: Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Utilizadores_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Set_Input>;
  pk_columns: Utilizadores_Equipas_Virtuais_R_Utilizadores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Equipas_Virtuais_R_Utilizadores_ManyArgs = {
  updates: Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_ExportacoesArgs = {
  _inc?: InputMaybe<Utilizadores_Exportacoes_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Exportacoes_Set_Input>;
  where: Utilizadores_Exportacoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Exportacoes_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Exportacoes_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Exportacoes_Set_Input>;
  pk_columns: Utilizadores_Exportacoes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Exportacoes_ManyArgs = {
  updates: Array<Utilizadores_Exportacoes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Mapa_Posicao_CoresArgs = {
  _inc?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Set_Input>;
  where: Utilizadores_Mapa_Posicao_Cores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Mapa_Posicao_Cores_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Set_Input>;
  pk_columns: Utilizadores_Mapa_Posicao_Cores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Mapa_Posicao_Cores_ManyArgs = {
  updates: Array<Utilizadores_Mapa_Posicao_Cores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_MenuArgs = {
  _inc?: InputMaybe<Utilizadores_Menu_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Menu_Set_Input>;
  where: Utilizadores_Menu_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Menu_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Menu_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Menu_Set_Input>;
  pk_columns: Utilizadores_Menu_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Menu_ManyArgs = {
  updates: Array<Utilizadores_Menu_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_TemasArgs = {
  _inc?: InputMaybe<Utilizadores_Temas_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Temas_Set_Input>;
  where: Utilizadores_Temas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Temas_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Temas_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Temas_Set_Input>;
  pk_columns: Utilizadores_Temas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Temas_ManyArgs = {
  updates: Array<Utilizadores_Temas_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_UtilizadoresArgs = {
  _inc?: InputMaybe<Utilizadores_Utilizadores_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Utilizadores_Set_Input>;
  where: Utilizadores_Utilizadores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Utilizadores_By_PkArgs = {
  _inc?: InputMaybe<Utilizadores_Utilizadores_Inc_Input>;
  _set?: InputMaybe<Utilizadores_Utilizadores_Set_Input>;
  pk_columns: Utilizadores_Utilizadores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Utilizadores_Utilizadores_ManyArgs = {
  updates: Array<Utilizadores_Utilizadores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_AgregacaoArgs = {
  _inc?: InputMaybe<Variaveis_Agregacao_Inc_Input>;
  _set?: InputMaybe<Variaveis_Agregacao_Set_Input>;
  where: Variaveis_Agregacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Agregacao_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Agregacao_Inc_Input>;
  _set?: InputMaybe<Variaveis_Agregacao_Set_Input>;
  pk_columns: Variaveis_Agregacao_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Agregacao_ManyArgs = {
  updates: Array<Variaveis_Agregacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_BaseArgs = {
  _inc?: InputMaybe<Variaveis_Base_Inc_Input>;
  _set?: InputMaybe<Variaveis_Base_Set_Input>;
  where: Variaveis_Base_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Base_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Base_Inc_Input>;
  _set?: InputMaybe<Variaveis_Base_Set_Input>;
  pk_columns: Variaveis_Base_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Base_Calc_VariaveisArgs = {
  _inc?: InputMaybe<Variaveis_Base_Calc_Variaveis_Inc_Input>;
  _set?: InputMaybe<Variaveis_Base_Calc_Variaveis_Set_Input>;
  where: Variaveis_Base_Calc_Variaveis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Base_Calc_Variaveis_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Base_Calc_Variaveis_Inc_Input>;
  _set?: InputMaybe<Variaveis_Base_Calc_Variaveis_Set_Input>;
  pk_columns: Variaveis_Base_Calc_Variaveis_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Base_Calc_Variaveis_ManyArgs = {
  updates: Array<Variaveis_Base_Calc_Variaveis_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Base_CategoriasArgs = {
  _inc?: InputMaybe<Variaveis_Base_Categorias_Inc_Input>;
  _set?: InputMaybe<Variaveis_Base_Categorias_Set_Input>;
  where: Variaveis_Base_Categorias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Base_Categorias_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Base_Categorias_Inc_Input>;
  _set?: InputMaybe<Variaveis_Base_Categorias_Set_Input>;
  pk_columns: Variaveis_Base_Categorias_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Base_Categorias_ManyArgs = {
  updates: Array<Variaveis_Base_Categorias_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Base_ManyArgs = {
  updates: Array<Variaveis_Base_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Base_PropriedadesArgs = {
  _inc?: InputMaybe<Variaveis_Base_Propriedades_Inc_Input>;
  _set?: InputMaybe<Variaveis_Base_Propriedades_Set_Input>;
  where: Variaveis_Base_Propriedades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Base_Propriedades_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Base_Propriedades_Inc_Input>;
  _set?: InputMaybe<Variaveis_Base_Propriedades_Set_Input>;
  pk_columns: Variaveis_Base_Propriedades_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Base_Propriedades_ManyArgs = {
  updates: Array<Variaveis_Base_Propriedades_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Calc_VariaveisArgs = {
  _inc?: InputMaybe<Variaveis_Calc_Variaveis_Inc_Input>;
  _set?: InputMaybe<Variaveis_Calc_Variaveis_Set_Input>;
  where: Variaveis_Calc_Variaveis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Calc_Variaveis_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Calc_Variaveis_Inc_Input>;
  _set?: InputMaybe<Variaveis_Calc_Variaveis_Set_Input>;
  pk_columns: Variaveis_Calc_Variaveis_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Calc_Variaveis_ManyArgs = {
  updates: Array<Variaveis_Calc_Variaveis_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_DominiosArgs = {
  _inc?: InputMaybe<Variaveis_Dominios_Inc_Input>;
  _set?: InputMaybe<Variaveis_Dominios_Set_Input>;
  where: Variaveis_Dominios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Dominios_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Dominios_Inc_Input>;
  _set?: InputMaybe<Variaveis_Dominios_Set_Input>;
  pk_columns: Variaveis_Dominios_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Dominios_ManyArgs = {
  updates: Array<Variaveis_Dominios_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Dominios_R_Dominios_ValoresArgs = {
  _inc?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Inc_Input>;
  _set?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Set_Input>;
  where: Variaveis_Dominios_R_Dominios_Valores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Dominios_R_Dominios_Valores_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Inc_Input>;
  _set?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Set_Input>;
  pk_columns: Variaveis_Dominios_R_Dominios_Valores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Dominios_R_Dominios_Valores_ManyArgs = {
  updates: Array<Variaveis_Dominios_R_Dominios_Valores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Dominios_ValoresArgs = {
  _inc?: InputMaybe<Variaveis_Dominios_Valores_Inc_Input>;
  _set?: InputMaybe<Variaveis_Dominios_Valores_Set_Input>;
  where: Variaveis_Dominios_Valores_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Dominios_Valores_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Dominios_Valores_Inc_Input>;
  _set?: InputMaybe<Variaveis_Dominios_Valores_Set_Input>;
  pk_columns: Variaveis_Dominios_Valores_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Dominios_Valores_ManyArgs = {
  updates: Array<Variaveis_Dominios_Valores_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Escalas_PrecisaoArgs = {
  _inc?: InputMaybe<Variaveis_Escalas_Precisao_Inc_Input>;
  _set?: InputMaybe<Variaveis_Escalas_Precisao_Set_Input>;
  where: Variaveis_Escalas_Precisao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Escalas_Precisao_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Escalas_Precisao_Inc_Input>;
  _set?: InputMaybe<Variaveis_Escalas_Precisao_Set_Input>;
  pk_columns: Variaveis_Escalas_Precisao_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Escalas_Precisao_ManyArgs = {
  updates: Array<Variaveis_Escalas_Precisao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Fontes_OrigemArgs = {
  _inc?: InputMaybe<Variaveis_Fontes_Origem_Inc_Input>;
  _set?: InputMaybe<Variaveis_Fontes_Origem_Set_Input>;
  where: Variaveis_Fontes_Origem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Fontes_Origem_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Fontes_Origem_Inc_Input>;
  _set?: InputMaybe<Variaveis_Fontes_Origem_Set_Input>;
  pk_columns: Variaveis_Fontes_Origem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Fontes_Origem_ManyArgs = {
  updates: Array<Variaveis_Fontes_Origem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Fontes_Origem_PropriedadesArgs = {
  _inc?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Inc_Input>;
  _set?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Set_Input>;
  where: Variaveis_Fontes_Origem_Propriedades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Fontes_Origem_Propriedades_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Inc_Input>;
  _set?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Set_Input>;
  pk_columns: Variaveis_Fontes_Origem_Propriedades_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Fontes_Origem_Propriedades_ManyArgs = {
  updates: Array<Variaveis_Fontes_Origem_Propriedades_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Fontes_Origem_TiposArgs = {
  _inc?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Inc_Input>;
  _set?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Set_Input>;
  where: Variaveis_Fontes_Origem_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Fontes_Origem_Tipos_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Inc_Input>;
  _set?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Set_Input>;
  pk_columns: Variaveis_Fontes_Origem_Tipos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Fontes_Origem_Tipos_ManyArgs = {
  updates: Array<Variaveis_Fontes_Origem_Tipos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_LeiturasArgs = {
  _inc?: InputMaybe<Variaveis_Leituras_Inc_Input>;
  _set?: InputMaybe<Variaveis_Leituras_Set_Input>;
  where: Variaveis_Leituras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Leituras_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Leituras_Inc_Input>;
  _set?: InputMaybe<Variaveis_Leituras_Set_Input>;
  pk_columns: Variaveis_Leituras_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Leituras_ManyArgs = {
  updates: Array<Variaveis_Leituras_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_ParametrosArgs = {
  _inc?: InputMaybe<Variaveis_Parametros_Inc_Input>;
  _set?: InputMaybe<Variaveis_Parametros_Set_Input>;
  where: Variaveis_Parametros_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Parametros_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Parametros_Inc_Input>;
  _set?: InputMaybe<Variaveis_Parametros_Set_Input>;
  pk_columns: Variaveis_Parametros_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Parametros_ManyArgs = {
  updates: Array<Variaveis_Parametros_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Parametros_R_Unidades_MedidaArgs = {
  _inc?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Inc_Input>;
  _set?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Set_Input>;
  where: Variaveis_Parametros_R_Unidades_Medida_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Parametros_R_Unidades_Medida_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Inc_Input>;
  _set?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Set_Input>;
  pk_columns: Variaveis_Parametros_R_Unidades_Medida_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Parametros_R_Unidades_Medida_ManyArgs = {
  updates: Array<Variaveis_Parametros_R_Unidades_Medida_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_TiposArgs = {
  _inc?: InputMaybe<Variaveis_Tipos_Inc_Input>;
  _set?: InputMaybe<Variaveis_Tipos_Set_Input>;
  where: Variaveis_Tipos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Tipos_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Tipos_Inc_Input>;
  _set?: InputMaybe<Variaveis_Tipos_Set_Input>;
  pk_columns: Variaveis_Tipos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Tipos_ManyArgs = {
  updates: Array<Variaveis_Tipos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Totalizadores_Tipos_RegistoArgs = {
  _inc?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Inc_Input>;
  _set?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Set_Input>;
  where: Variaveis_Totalizadores_Tipos_Registo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Totalizadores_Tipos_Registo_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Inc_Input>;
  _set?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Set_Input>;
  pk_columns: Variaveis_Totalizadores_Tipos_Registo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Totalizadores_Tipos_Registo_ManyArgs = {
  updates: Array<Variaveis_Totalizadores_Tipos_Registo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Unidades_MedidaArgs = {
  _inc?: InputMaybe<Variaveis_Unidades_Medida_Inc_Input>;
  _set?: InputMaybe<Variaveis_Unidades_Medida_Set_Input>;
  where: Variaveis_Unidades_Medida_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Unidades_Medida_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Unidades_Medida_Inc_Input>;
  _set?: InputMaybe<Variaveis_Unidades_Medida_Set_Input>;
  pk_columns: Variaveis_Unidades_Medida_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Unidades_Medida_ManyArgs = {
  updates: Array<Variaveis_Unidades_Medida_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Valores_MensaisArgs = {
  _inc?: InputMaybe<Variaveis_Valores_Mensais_Inc_Input>;
  _set?: InputMaybe<Variaveis_Valores_Mensais_Set_Input>;
  where: Variaveis_Valores_Mensais_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Valores_Mensais_By_PkArgs = {
  _inc?: InputMaybe<Variaveis_Valores_Mensais_Inc_Input>;
  _set?: InputMaybe<Variaveis_Valores_Mensais_Set_Input>;
  pk_columns: Variaveis_Valores_Mensais_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Variaveis_Valores_Mensais_ManyArgs = {
  updates: Array<Variaveis_Valores_Mensais_Updates>;
};

/** tabela de cores */
export type Navia_Cores = {
  __typename?: 'navia_cores';
  cor_modo_claro: Scalars['String']['output'];
  cor_modo_escuro: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "navia.cores" */
export type Navia_Cores_Aggregate = {
  __typename?: 'navia_cores_aggregate';
  aggregate?: Maybe<Navia_Cores_Aggregate_Fields>;
  nodes: Array<Navia_Cores>;
};

/** aggregate fields of "navia.cores" */
export type Navia_Cores_Aggregate_Fields = {
  __typename?: 'navia_cores_aggregate_fields';
  avg?: Maybe<Navia_Cores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Cores_Max_Fields>;
  min?: Maybe<Navia_Cores_Min_Fields>;
  stddev?: Maybe<Navia_Cores_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Cores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Cores_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Cores_Sum_Fields>;
  var_pop?: Maybe<Navia_Cores_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Cores_Var_Samp_Fields>;
  variance?: Maybe<Navia_Cores_Variance_Fields>;
};


/** aggregate fields of "navia.cores" */
export type Navia_Cores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Cores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Cores_Avg_Fields = {
  __typename?: 'navia_cores_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia.cores". All fields are combined with a logical 'AND'. */
export type Navia_Cores_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Cores_Bool_Exp>>;
  _not?: InputMaybe<Navia_Cores_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Cores_Bool_Exp>>;
  cor_modo_claro?: InputMaybe<String_Comparison_Exp>;
  cor_modo_escuro?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia.cores" */
export enum Navia_Cores_Constraint {
  /** unique or primary key constraint on columns "cor_modo_claro" */
  CoresCorModoClaroKey = 'cores_cor_modo_claro_key',
  /** unique or primary key constraint on columns "cor_modo_escuro" */
  CoresCorModoEscuroKey = 'cores_cor_modo_escuro_key',
  /** unique or primary key constraint on columns "id" */
  CoresPkey = 'cores_pkey'
}

/** input type for incrementing numeric columns in table "navia.cores" */
export type Navia_Cores_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "navia.cores" */
export type Navia_Cores_Insert_Input = {
  cor_modo_claro?: InputMaybe<Scalars['String']['input']>;
  cor_modo_escuro?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Navia_Cores_Max_Fields = {
  __typename?: 'navia_cores_max_fields';
  cor_modo_claro?: Maybe<Scalars['String']['output']>;
  cor_modo_escuro?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Navia_Cores_Min_Fields = {
  __typename?: 'navia_cores_min_fields';
  cor_modo_claro?: Maybe<Scalars['String']['output']>;
  cor_modo_escuro?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "navia.cores" */
export type Navia_Cores_Mutation_Response = {
  __typename?: 'navia_cores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Cores>;
};

/** input type for inserting object relation for remote table "navia.cores" */
export type Navia_Cores_Obj_Rel_Insert_Input = {
  data: Navia_Cores_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Cores_On_Conflict>;
};

/** on_conflict condition type for table "navia.cores" */
export type Navia_Cores_On_Conflict = {
  constraint: Navia_Cores_Constraint;
  update_columns?: Array<Navia_Cores_Update_Column>;
  where?: InputMaybe<Navia_Cores_Bool_Exp>;
};

/** Ordering options when selecting data from "navia.cores". */
export type Navia_Cores_Order_By = {
  cor_modo_claro?: InputMaybe<Order_By>;
  cor_modo_escuro?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia.cores */
export type Navia_Cores_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia.cores" */
export enum Navia_Cores_Select_Column {
  /** column name */
  CorModoClaro = 'cor_modo_claro',
  /** column name */
  CorModoEscuro = 'cor_modo_escuro',
  /** column name */
  Id = 'id',
  /** column name */
  Ordem = 'ordem'
}

/** input type for updating data in table "navia.cores" */
export type Navia_Cores_Set_Input = {
  cor_modo_claro?: InputMaybe<Scalars['String']['input']>;
  cor_modo_escuro?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Cores_Stddev_Fields = {
  __typename?: 'navia_cores_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Cores_Stddev_Pop_Fields = {
  __typename?: 'navia_cores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Cores_Stddev_Samp_Fields = {
  __typename?: 'navia_cores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_cores" */
export type Navia_Cores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Cores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Cores_Stream_Cursor_Value_Input = {
  cor_modo_claro?: InputMaybe<Scalars['String']['input']>;
  cor_modo_escuro?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Navia_Cores_Sum_Fields = {
  __typename?: 'navia_cores_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "navia.cores" */
export enum Navia_Cores_Update_Column {
  /** column name */
  CorModoClaro = 'cor_modo_claro',
  /** column name */
  CorModoEscuro = 'cor_modo_escuro',
  /** column name */
  Id = 'id',
  /** column name */
  Ordem = 'ordem'
}

export type Navia_Cores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Cores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Cores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Cores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Cores_Var_Pop_Fields = {
  __typename?: 'navia_cores_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Cores_Var_Samp_Fields = {
  __typename?: 'navia_cores_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Cores_Variance_Fields = {
  __typename?: 'navia_cores_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Tabela utilizada na parametrização da Dashboard Diagnóstico de Roturas */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis';
  data_hora_registo_db: Scalars['timestamptz']['output'];
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  unidadeMedida?: Maybe<Variaveis_Unidades_Medida>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  variavel?: Maybe<Variaveis_Base>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Aggregate = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis>;
};

/** aggregate fields of "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Aggregate_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Avg_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp>>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
  unidade_medida_id?: InputMaybe<Bigint_Comparison_Exp>;
  variavel?: InputMaybe<Variaveis_Base_Bool_Exp>;
  variavel_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
export enum Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Constraint {
  /** unique or primary key constraint on columns "descricao" */
  DiagnosticoRoturasInfraestruturasVariaveisDescricaoKey = 'diagnostico_roturas_infraestruturas_variaveis_descricao_key',
  /** unique or primary key constraint on columns "id" */
  DiagnosticoRoturasInfraestruturasVariaveisPkey = 'diagnostico_roturas_infraestruturas_variaveis_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Insert_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Obj_Rel_Insert_Input>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel?: InputMaybe<Variaveis_Base_Obj_Rel_Insert_Input>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Max_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_max_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Min_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_min_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Mutation_Response = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis>;
};

/** on_conflict condition type for table "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_On_Conflict = {
  constraint: Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Constraint;
  update_columns?: Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis". */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Order_By = {
  data_hora_registo_db?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Order_By>;
  unidade_medida_id?: InputMaybe<Order_By>;
  variavel?: InputMaybe<Variaveis_Base_Order_By>;
  variavel_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.diagnostico_roturas_infraestruturas_variaveis */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
export enum Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Select_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  UnidadeMedidaId = 'unidade_medida_id',
  /** column name */
  VariavelId = 'variavel_id'
}

/** input type for updating data in table "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Set_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Stddev_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_diagnostico_roturas_infraestruturas_variaveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Stream_Cursor_Value_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Sum_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
export enum Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Update_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  UnidadeMedidaId = 'unidade_medida_id',
  /** column name */
  VariavelId = 'variavel_id'
}

export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Variance_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Tabela utilizada na parametrização da Dashboard Diagnóstico de Roturas */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis';
  id: Scalars['bigint']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "navia_dashboards.diagnostico_roturas_mapa_niveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Aggregate = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis>;
};

/** aggregate fields of "navia_dashboards.diagnostico_roturas_mapa_niveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Aggregate_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.diagnostico_roturas_mapa_niveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Avg_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.diagnostico_roturas_mapa_niveis". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  max?: InputMaybe<Int_Comparison_Exp>;
  min?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.diagnostico_roturas_mapa_niveis" */
export enum Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Constraint {
  /** unique or primary key constraint on columns "id" */
  DiagnosticoRoturasMapaNiveisPkey = 'diagnostico_roturas_mapa_niveis_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.diagnostico_roturas_mapa_niveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "navia_dashboards.diagnostico_roturas_mapa_niveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Max_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Min_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "navia_dashboards.diagnostico_roturas_mapa_niveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Mutation_Response = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis>;
};

/** on_conflict condition type for table "navia_dashboards.diagnostico_roturas_mapa_niveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_On_Conflict = {
  constraint: Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Constraint;
  update_columns?: Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.diagnostico_roturas_mapa_niveis". */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Order_By = {
  id?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.diagnostico_roturas_mapa_niveis */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.diagnostico_roturas_mapa_niveis" */
export enum Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min'
}

/** input type for updating data in table "navia_dashboards.diagnostico_roturas_mapa_niveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Stddev_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_diagnostico_roturas_mapa_niveis" */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Sum_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "navia_dashboards.diagnostico_roturas_mapa_niveis" */
export enum Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min'
}

export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Variance_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

/** Tabela utilizada na parametrização da Dashboard Diagnóstico de Roturas */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas';
  data_hora_registo_db: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  sintoma: Sintomas_Arvore;
  sintoma_id: Scalars['bigint']['output'];
  tipo: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum;
};

/** aggregated selection of "navia_dashboards.diagnostico_roturas_sintomas" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Aggregate = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas>;
};

/** aggregate fields of "navia_dashboards.diagnostico_roturas_sintomas" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Aggregate_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.diagnostico_roturas_sintomas" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Avg_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.diagnostico_roturas_sintomas". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp>>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  sintoma?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  sintoma_id?: InputMaybe<Bigint_Comparison_Exp>;
  tipo?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.diagnostico_roturas_sintomas" */
export enum Navia_Dashboards_Diagnostico_Roturas_Sintomas_Constraint {
  /** unique or primary key constraint on columns "id" */
  DiagnosticoRoturasSintomasPkey = 'diagnostico_roturas_sintomas_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.diagnostico_roturas_sintomas" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.diagnostico_roturas_sintomas" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Insert_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sintoma?: InputMaybe<Sintomas_Arvore_Obj_Rel_Insert_Input>;
  sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
  tipo?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Max_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_max_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  sintoma_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Min_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_min_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  sintoma_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.diagnostico_roturas_sintomas" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Mutation_Response = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas>;
};

/** on_conflict condition type for table "navia_dashboards.diagnostico_roturas_sintomas" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_On_Conflict = {
  constraint: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Constraint;
  update_columns?: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.diagnostico_roturas_sintomas". */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Order_By = {
  data_hora_registo_db?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sintoma?: InputMaybe<Sintomas_Arvore_Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
  tipo?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.diagnostico_roturas_sintomas */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.diagnostico_roturas_sintomas" */
export enum Navia_Dashboards_Diagnostico_Roturas_Sintomas_Select_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Id = 'id',
  /** column name */
  SintomaId = 'sintoma_id',
  /** column name */
  Tipo = 'tipo'
}

/** input type for updating data in table "navia_dashboards.diagnostico_roturas_sintomas" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Set_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
  tipo?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Stddev_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_diagnostico_roturas_sintomas" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Stream_Cursor_Value_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
  tipo?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Sum_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  sintoma_id?: Maybe<Scalars['bigint']['output']>;
};

/** Tabela enum utilizada na parametrização da Dashboard Diagnóstico de Roturas */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_tipos';
  value: Scalars['String']['output'];
};

/** aggregated selection of "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Aggregate = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_tipos_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos>;
};

/** aggregate fields of "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Aggregate_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_tipos_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Min_Fields>;
};


/** aggregate fields of "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.diagnostico_roturas_sintomas_tipos". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
export enum Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Constraint {
  /** unique or primary key constraint on columns "value" */
  DiagnosticoRoturasSintomasTiposPkey = 'diagnostico_roturas_sintomas_tipos_pkey'
}

export enum Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum {
  Reabilitacao = 'reabilitacao',
  Roturas = 'roturas'
}

/** Boolean expression to compare columns of type "navia_dashboards_diagnostico_roturas_sintomas_tipos_enum". All fields are combined with logical 'AND'. */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum>;
  _in?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum>;
  _nin?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum>>;
};

/** input type for inserting data into table "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Max_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_tipos_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Min_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_tipos_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Mutation_Response = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_tipos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos>;
};

/** on_conflict condition type for table "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_On_Conflict = {
  constraint: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Constraint;
  update_columns?: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.diagnostico_roturas_sintomas_tipos". */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.diagnostico_roturas_sintomas_tipos */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
export enum Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "navia_dashboards_diagnostico_roturas_sintomas_tipos" */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
export enum Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Update_Column {
  /** column name */
  Value = 'value'
}

export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp;
};

/** update columns of table "navia_dashboards.diagnostico_roturas_sintomas" */
export enum Navia_Dashboards_Diagnostico_Roturas_Sintomas_Update_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Id = 'id',
  /** column name */
  SintomaId = 'sintoma_id',
  /** column name */
  Tipo = 'tipo'
}

export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Sintomas_Variance_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** Tabela utilizada na parametrização da Dashboard Diagnóstico de Roturas */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura';
  data_hora_registo_db: Scalars['timestamptz']['output'];
  /** An object relationship */
  infraestruturaTipo: Base_Infraestruturas_Tipos;
  tipo_infraestrutura_id: Scalars['bigint']['output'];
};

/** aggregated selection of "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Aggregate = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura>;
};

/** aggregate fields of "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Aggregate_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Avg_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_avg_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp>>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  infraestruturaTipo?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
  tipo_infraestrutura_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
export enum Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Constraint {
  /** unique or primary key constraint on columns "tipo_infraestrutura_id" */
  DiagnosticoRoturasTiposInfraestruturaPkey = 'diagnostico_roturas_tipos_infraestrutura_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Inc_Input = {
  tipo_infraestrutura_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Insert_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  infraestruturaTipo?: InputMaybe<Base_Infraestruturas_Tipos_Obj_Rel_Insert_Input>;
  tipo_infraestrutura_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Max_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_max_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  tipo_infraestrutura_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Min_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_min_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  tipo_infraestrutura_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Mutation_Response = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura>;
};

/** on_conflict condition type for table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_On_Conflict = {
  constraint: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Constraint;
  update_columns?: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.diagnostico_roturas_tipos_infraestrutura". */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Order_By = {
  data_hora_registo_db?: InputMaybe<Order_By>;
  infraestruturaTipo?: InputMaybe<Base_Infraestruturas_Tipos_Order_By>;
  tipo_infraestrutura_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.diagnostico_roturas_tipos_infraestrutura */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Pk_Columns_Input = {
  tipo_infraestrutura_id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
export enum Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Select_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  TipoInfraestruturaId = 'tipo_infraestrutura_id'
}

/** input type for updating data in table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Set_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  tipo_infraestrutura_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Stddev_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_stddev_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_stddev_pop_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_stddev_samp_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_diagnostico_roturas_tipos_infraestrutura" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Stream_Cursor_Value_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  tipo_infraestrutura_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Sum_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_sum_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
export enum Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Update_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  TipoInfraestruturaId = 'tipo_infraestrutura_id'
}

export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_var_pop_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_var_samp_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Variance_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_variance_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** Tabela utilizada na parametrização da Dashboard Diagnóstico de Roturas */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc';
  data_hora_registo_db: Scalars['timestamptz']['output'];
  /** An object relationship */
  infraestruturaTipo: Base_Infraestruturas_Tipos;
  tipo_infraestrutura_id: Scalars['bigint']['output'];
};

/** aggregated selection of "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Aggregate = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc>;
};

/** aggregate fields of "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Aggregate_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Avg_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_avg_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp>>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  infraestruturaTipo?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
  tipo_infraestrutura_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
export enum Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Constraint {
  /** unique or primary key constraint on columns "tipo_infraestrutura_id" */
  DiagnosticoRoturasTiposInfraestruturaZmcPkey = 'diagnostico_roturas_tipos_infraestrutura_zmc_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Inc_Input = {
  tipo_infraestrutura_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Insert_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  infraestruturaTipo?: InputMaybe<Base_Infraestruturas_Tipos_Obj_Rel_Insert_Input>;
  tipo_infraestrutura_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Max_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_max_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  tipo_infraestrutura_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Min_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_min_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  tipo_infraestrutura_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Mutation_Response = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc>;
};

/** on_conflict condition type for table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_On_Conflict = {
  constraint: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Constraint;
  update_columns?: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc". */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Order_By = {
  data_hora_registo_db?: InputMaybe<Order_By>;
  infraestruturaTipo?: InputMaybe<Base_Infraestruturas_Tipos_Order_By>;
  tipo_infraestrutura_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Pk_Columns_Input = {
  tipo_infraestrutura_id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
export enum Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Select_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  TipoInfraestruturaId = 'tipo_infraestrutura_id'
}

/** input type for updating data in table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Set_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  tipo_infraestrutura_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Stddev_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_stddev_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_stddev_pop_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_stddev_samp_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc" */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Stream_Cursor_Value_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  tipo_infraestrutura_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Sum_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_sum_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
export enum Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Update_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  TipoInfraestruturaId = 'tipo_infraestrutura_id'
}

export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_var_pop_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_var_samp_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Variance_Fields = {
  __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_variance_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "navia_dashboards.infraestruturas_totalizadores" */
export type Navia_Dashboards_Infraestruturas_Totalizadores = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores';
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  infraestrutura?: Maybe<Base_Infraestruturas>;
  level?: Maybe<Scalars['Int']['output']>;
  node?: Maybe<Scalars['jsonb']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<Scalars['bigint']['output']>>;
  search_vars?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "navia_dashboards.infraestruturas_totalizadores" */
export type Navia_Dashboards_Infraestruturas_TotalizadoresNodeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "navia_dashboards.infraestruturas_totalizadores" */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Aggregate = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Infraestruturas_Totalizadores_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Infraestruturas_Totalizadores>;
};

/** aggregate fields of "navia_dashboards.infraestruturas_totalizadores" */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Aggregate_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Infraestruturas_Totalizadores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Infraestruturas_Totalizadores_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Infraestruturas_Totalizadores_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Infraestruturas_Totalizadores_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Infraestruturas_Totalizadores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Infraestruturas_Totalizadores_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Infraestruturas_Totalizadores_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Infraestruturas_Totalizadores_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Infraestruturas_Totalizadores_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Infraestruturas_Totalizadores_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.infraestruturas_totalizadores" */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Totalizadores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Avg_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.infraestruturas_totalizadores". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Totalizadores_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Infraestruturas_Totalizadores_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Totalizadores_Bool_Exp>>;
  codigo_manutencao?: InputMaybe<String_Comparison_Exp>;
  codigo_sig?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_pai?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_bulk?: InputMaybe<Bigint_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  level?: InputMaybe<Int_Comparison_Exp>;
  node?: InputMaybe<Jsonb_Comparison_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
  path?: InputMaybe<Bigint_Array_Comparison_Exp>;
  search_vars?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Max_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_max_fields';
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<Scalars['bigint']['output']>>;
  search_vars?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Min_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_min_fields';
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<Scalars['bigint']['output']>>;
  search_vars?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "navia_dashboards.infraestruturas_totalizadores". */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Order_By = {
  codigo_manutencao?: InputMaybe<Order_By>;
  codigo_sig?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
  level?: InputMaybe<Order_By>;
  node?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  search_vars?: InputMaybe<Order_By>;
};

/** select columns of table "navia_dashboards.infraestruturas_totalizadores" */
export enum Navia_Dashboards_Infraestruturas_Totalizadores_Select_Column {
  /** column name */
  CodigoManutencao = 'codigo_manutencao',
  /** column name */
  CodigoSig = 'codigo_sig',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdTipoBulk = 'id_tipo_bulk',
  /** column name */
  Level = 'level',
  /** column name */
  Node = 'node',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  Path = 'path',
  /** column name */
  SearchVars = 'search_vars'
}

/** aggregate stddev on columns */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Stddev_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_infraestruturas_totalizadores" */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Infraestruturas_Totalizadores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Stream_Cursor_Value_Input = {
  codigo_manutencao?: InputMaybe<Scalars['String']['input']>;
  codigo_sig?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_bulk?: InputMaybe<Scalars['bigint']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Scalars['jsonb']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Array<Scalars['bigint']['input']>>;
  search_vars?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Sum_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Infraestruturas_Totalizadores_Variance_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_totalizadores_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "navia_dashboards.infraestruturas_variaveis" */
export type Navia_Dashboards_Infraestruturas_Variaveis = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis';
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  desactivado?: Maybe<Scalars['Boolean']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  node?: Maybe<Scalars['jsonb']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  nome_instalacao?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<Scalars['bigint']['output']>>;
  search_vars?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "navia_dashboards.infraestruturas_variaveis" */
export type Navia_Dashboards_Infraestruturas_VariaveisNodeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "navia_dashboards.infraestruturas_variaveis" */
export type Navia_Dashboards_Infraestruturas_Variaveis_Aggregate = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Infraestruturas_Variaveis_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Infraestruturas_Variaveis>;
};

/** aggregate fields of "navia_dashboards.infraestruturas_variaveis" */
export type Navia_Dashboards_Infraestruturas_Variaveis_Aggregate_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Infraestruturas_Variaveis_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Infraestruturas_Variaveis_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Infraestruturas_Variaveis_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Infraestruturas_Variaveis_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Infraestruturas_Variaveis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Infraestruturas_Variaveis_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Infraestruturas_Variaveis_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Infraestruturas_Variaveis_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Infraestruturas_Variaveis_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Infraestruturas_Variaveis_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.infraestruturas_variaveis" */
export type Navia_Dashboards_Infraestruturas_Variaveis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Variaveis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Infraestruturas_Variaveis_Avg_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.infraestruturas_variaveis". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Infraestruturas_Variaveis_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Variaveis_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Infraestruturas_Variaveis_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Variaveis_Bool_Exp>>;
  codigo_manutencao?: InputMaybe<String_Comparison_Exp>;
  codigo_sig?: InputMaybe<String_Comparison_Exp>;
  desactivado?: InputMaybe<Boolean_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_pai?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_bulk?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  level?: InputMaybe<Int_Comparison_Exp>;
  node?: InputMaybe<Jsonb_Comparison_Exp>;
  nome_completo?: InputMaybe<String_Comparison_Exp>;
  nome_instalacao?: InputMaybe<String_Comparison_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
  path?: InputMaybe<Bigint_Array_Comparison_Exp>;
  search_vars?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Infraestruturas_Variaveis_Max_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_max_fields';
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  nome_instalacao?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<Scalars['bigint']['output']>>;
  search_vars?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Infraestruturas_Variaveis_Min_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_min_fields';
  codigo_manutencao?: Maybe<Scalars['String']['output']>;
  codigo_sig?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  nome_instalacao?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<Scalars['bigint']['output']>>;
  search_vars?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "navia_dashboards.infraestruturas_variaveis". */
export type Navia_Dashboards_Infraestruturas_Variaveis_Order_By = {
  codigo_manutencao?: InputMaybe<Order_By>;
  codigo_sig?: InputMaybe<Order_By>;
  desactivado?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_tipo_bulk?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  node?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
  nome_instalacao?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  search_vars?: InputMaybe<Order_By>;
};

/** select columns of table "navia_dashboards.infraestruturas_variaveis" */
export enum Navia_Dashboards_Infraestruturas_Variaveis_Select_Column {
  /** column name */
  CodigoManutencao = 'codigo_manutencao',
  /** column name */
  CodigoSig = 'codigo_sig',
  /** column name */
  Desactivado = 'desactivado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdTipoBulk = 'id_tipo_bulk',
  /** column name */
  IdTipoInfraestrutura = 'id_tipo_infraestrutura',
  /** column name */
  Level = 'level',
  /** column name */
  Node = 'node',
  /** column name */
  NomeCompleto = 'nome_completo',
  /** column name */
  NomeInstalacao = 'nome_instalacao',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  Path = 'path',
  /** column name */
  SearchVars = 'search_vars'
}

/** aggregate stddev on columns */
export type Navia_Dashboards_Infraestruturas_Variaveis_Stddev_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Infraestruturas_Variaveis_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Infraestruturas_Variaveis_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_infraestruturas_variaveis" */
export type Navia_Dashboards_Infraestruturas_Variaveis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Infraestruturas_Variaveis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Infraestruturas_Variaveis_Stream_Cursor_Value_Input = {
  codigo_manutencao?: InputMaybe<Scalars['String']['input']>;
  codigo_sig?: InputMaybe<Scalars['String']['input']>;
  desactivado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_bulk?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Scalars['jsonb']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  nome_instalacao?: InputMaybe<Scalars['String']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Array<Scalars['bigint']['input']>>;
  search_vars?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Infraestruturas_Variaveis_Sum_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_tipo_bulk?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Infraestruturas_Variaveis_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Infraestruturas_Variaveis_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Infraestruturas_Variaveis_Variance_Fields = {
  __typename?: 'navia_dashboards_infraestruturas_variaveis_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_tipo_bulk?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "navia_dashboards.menu" */
export type Navia_Dashboards_Menu = {
  __typename?: 'navia_dashboards_menu';
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  image_path_dark?: Maybe<Scalars['String']['output']>;
  image_path_light?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  menuTransacoes: Array<Navia_Dashboards_Menu_R_Transacoes>;
  /** An aggregate relationship */
  menuTransacoes_aggregate: Navia_Dashboards_Menu_R_Transacoes_Aggregate;
  ordem: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};


/** columns and relationships of "navia_dashboards.menu" */
export type Navia_Dashboards_MenuMenuTransacoesArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};


/** columns and relationships of "navia_dashboards.menu" */
export type Navia_Dashboards_MenuMenuTransacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};

/** aggregated selection of "navia_dashboards.menu" */
export type Navia_Dashboards_Menu_Aggregate = {
  __typename?: 'navia_dashboards_menu_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Menu_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Menu>;
};

/** aggregate fields of "navia_dashboards.menu" */
export type Navia_Dashboards_Menu_Aggregate_Fields = {
  __typename?: 'navia_dashboards_menu_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Menu_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Menu_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Menu_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Menu_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Menu_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Menu_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Menu_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Menu_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Menu_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Menu_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.menu" */
export type Navia_Dashboards_Menu_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Menu_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Menu_Avg_Fields = {
  __typename?: 'navia_dashboards_menu_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.menu". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Menu_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Menu_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Menu_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Menu_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image_path_dark?: InputMaybe<String_Comparison_Exp>;
  image_path_light?: InputMaybe<String_Comparison_Exp>;
  menuTransacoes?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
  menuTransacoes_aggregate?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Aggregate_Bool_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.menu" */
export enum Navia_Dashboards_Menu_Constraint {
  /** unique or primary key constraint on columns "ordem" */
  MenuOrdemKey = 'menu_ordem_key',
  /** unique or primary key constraint on columns "id" */
  MenuPkey = 'menu_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.menu" */
export type Navia_Dashboards_Menu_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "navia_dashboards.menu" */
export type Navia_Dashboards_Menu_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image_path_dark?: InputMaybe<Scalars['String']['input']>;
  image_path_light?: InputMaybe<Scalars['String']['input']>;
  menuTransacoes?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Arr_Rel_Insert_Input>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Menu_Max_Fields = {
  __typename?: 'navia_dashboards_menu_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image_path_dark?: Maybe<Scalars['String']['output']>;
  image_path_light?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Menu_Min_Fields = {
  __typename?: 'navia_dashboards_menu_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image_path_dark?: Maybe<Scalars['String']['output']>;
  image_path_light?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "navia_dashboards.menu" */
export type Navia_Dashboards_Menu_Mutation_Response = {
  __typename?: 'navia_dashboards_menu_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Menu>;
};

/** input type for inserting object relation for remote table "navia_dashboards.menu" */
export type Navia_Dashboards_Menu_Obj_Rel_Insert_Input = {
  data: Navia_Dashboards_Menu_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Menu_On_Conflict>;
};

/** on_conflict condition type for table "navia_dashboards.menu" */
export type Navia_Dashboards_Menu_On_Conflict = {
  constraint: Navia_Dashboards_Menu_Constraint;
  update_columns?: Array<Navia_Dashboards_Menu_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Menu_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.menu". */
export type Navia_Dashboards_Menu_Order_By = {
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_path_dark?: InputMaybe<Order_By>;
  image_path_light?: InputMaybe<Order_By>;
  menuTransacoes_aggregate?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Aggregate_Order_By>;
  ordem?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.menu */
export type Navia_Dashboards_Menu_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes = {
  __typename?: 'navia_dashboards_menu_r_transacoes';
  id: Scalars['bigint']['output'];
  id_menu: Scalars['bigint']['output'];
  id_transacao: Scalars['bigint']['output'];
  /** An object relationship */
  menu: Navia_Dashboards_Menu;
  /** An object relationship */
  transacao: Permissoes_Transacoes;
};

/** aggregated selection of "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Aggregate = {
  __typename?: 'navia_dashboards_menu_r_transacoes_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Menu_R_Transacoes>;
};

export type Navia_Dashboards_Menu_R_Transacoes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Aggregate_Bool_Exp_Count>;
};

export type Navia_Dashboards_Menu_R_Transacoes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Aggregate_Fields = {
  __typename?: 'navia_dashboards_menu_r_transacoes_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Menu_R_Transacoes_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Aggregate_Order_By = {
  avg?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Max_Order_By>;
  min?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Min_Order_By>;
  stddev?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Sum_Order_By>;
  var_pop?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Var_Samp_Order_By>;
  variance?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Arr_Rel_Insert_Input = {
  data: Array<Navia_Dashboards_Menu_R_Transacoes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_On_Conflict>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Menu_R_Transacoes_Avg_Fields = {
  __typename?: 'navia_dashboards_menu_r_transacoes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.menu_r_transacoes". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Menu_R_Transacoes_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_menu?: InputMaybe<Bigint_Comparison_Exp>;
  id_transacao?: InputMaybe<Bigint_Comparison_Exp>;
  menu?: InputMaybe<Navia_Dashboards_Menu_Bool_Exp>;
  transacao?: InputMaybe<Permissoes_Transacoes_Bool_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.menu_r_transacoes" */
export enum Navia_Dashboards_Menu_R_Transacoes_Constraint {
  /** unique or primary key constraint on columns "id" */
  MenuRTransacoesPkey = 'menu_r_transacoes_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_menu?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_menu?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
  menu?: InputMaybe<Navia_Dashboards_Menu_Obj_Rel_Insert_Input>;
  transacao?: InputMaybe<Permissoes_Transacoes_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Menu_R_Transacoes_Max_Fields = {
  __typename?: 'navia_dashboards_menu_r_transacoes_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_menu?: Maybe<Scalars['bigint']['output']>;
  id_transacao?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Menu_R_Transacoes_Min_Fields = {
  __typename?: 'navia_dashboards_menu_r_transacoes_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_menu?: Maybe<Scalars['bigint']['output']>;
  id_transacao?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Mutation_Response = {
  __typename?: 'navia_dashboards_menu_r_transacoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Menu_R_Transacoes>;
};

/** on_conflict condition type for table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_On_Conflict = {
  constraint: Navia_Dashboards_Menu_R_Transacoes_Constraint;
  update_columns?: Array<Navia_Dashboards_Menu_R_Transacoes_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.menu_r_transacoes". */
export type Navia_Dashboards_Menu_R_Transacoes_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  menu?: InputMaybe<Navia_Dashboards_Menu_Order_By>;
  transacao?: InputMaybe<Permissoes_Transacoes_Order_By>;
};

/** primary key columns input for table: navia_dashboards.menu_r_transacoes */
export type Navia_Dashboards_Menu_R_Transacoes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.menu_r_transacoes" */
export enum Navia_Dashboards_Menu_R_Transacoes_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdMenu = 'id_menu',
  /** column name */
  IdTransacao = 'id_transacao'
}

/** input type for updating data in table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_menu?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Menu_R_Transacoes_Stddev_Fields = {
  __typename?: 'navia_dashboards_menu_r_transacoes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Menu_R_Transacoes_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_menu_r_transacoes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Menu_R_Transacoes_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_menu_r_transacoes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "navia_dashboards_menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Menu_R_Transacoes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Menu_R_Transacoes_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_menu?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Menu_R_Transacoes_Sum_Fields = {
  __typename?: 'navia_dashboards_menu_r_transacoes_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_menu?: Maybe<Scalars['bigint']['output']>;
  id_transacao?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** update columns of table "navia_dashboards.menu_r_transacoes" */
export enum Navia_Dashboards_Menu_R_Transacoes_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdMenu = 'id_menu',
  /** column name */
  IdTransacao = 'id_transacao'
}

export type Navia_Dashboards_Menu_R_Transacoes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Menu_R_Transacoes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Menu_R_Transacoes_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_menu_r_transacoes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Menu_R_Transacoes_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_menu_r_transacoes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Menu_R_Transacoes_Variance_Fields = {
  __typename?: 'navia_dashboards_menu_r_transacoes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "navia_dashboards.menu_r_transacoes" */
export type Navia_Dashboards_Menu_R_Transacoes_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** select columns of table "navia_dashboards.menu" */
export enum Navia_Dashboards_Menu_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  ImagePathDark = 'image_path_dark',
  /** column name */
  ImagePathLight = 'image_path_light',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "navia_dashboards.menu" */
export type Navia_Dashboards_Menu_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image_path_dark?: InputMaybe<Scalars['String']['input']>;
  image_path_light?: InputMaybe<Scalars['String']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Menu_Stddev_Fields = {
  __typename?: 'navia_dashboards_menu_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Menu_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_menu_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Menu_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_menu_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_menu" */
export type Navia_Dashboards_Menu_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Menu_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Menu_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image_path_dark?: InputMaybe<Scalars['String']['input']>;
  image_path_light?: InputMaybe<Scalars['String']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Menu_Sum_Fields = {
  __typename?: 'navia_dashboards_menu_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "navia_dashboards.menu" */
export enum Navia_Dashboards_Menu_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  ImagePathDark = 'image_path_dark',
  /** column name */
  ImagePathLight = 'image_path_light',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  Url = 'url'
}

export type Navia_Dashboards_Menu_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Menu_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Menu_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Menu_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Menu_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_menu_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Menu_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_menu_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Menu_Variance_Fields = {
  __typename?: 'navia_dashboards_menu_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "navia_dashboards.modo_tv_tokens" */
export type Navia_Dashboards_Modo_Tv_Tokens = {
  __typename?: 'navia_dashboards_modo_tv_tokens';
  data_expiracao: Scalars['timestamp']['output'];
  data_hora_registo_bd: Scalars['timestamp']['output'];
  descricao_equipamento?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  token_tv: Scalars['String']['output'];
};

/** aggregated selection of "navia_dashboards.modo_tv_tokens" */
export type Navia_Dashboards_Modo_Tv_Tokens_Aggregate = {
  __typename?: 'navia_dashboards_modo_tv_tokens_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Modo_Tv_Tokens>;
};

/** aggregate fields of "navia_dashboards.modo_tv_tokens" */
export type Navia_Dashboards_Modo_Tv_Tokens_Aggregate_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.modo_tv_tokens" */
export type Navia_Dashboards_Modo_Tv_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Avg_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.modo_tv_tokens". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp>>;
  data_expiracao?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_registo_bd?: InputMaybe<Timestamp_Comparison_Exp>;
  descricao_equipamento?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  token_tv?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.modo_tv_tokens" */
export enum Navia_Dashboards_Modo_Tv_Tokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  ModoTvTokensPkey = 'modo_tv_tokens_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.modo_tv_tokens" */
export type Navia_Dashboards_Modo_Tv_Tokens_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.modo_tv_tokens" */
export type Navia_Dashboards_Modo_Tv_Tokens_Insert_Input = {
  data_expiracao?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  descricao_equipamento?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  token_tv?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Max_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_max_fields';
  data_expiracao?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  descricao_equipamento?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_tv?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Min_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_min_fields';
  data_expiracao?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  descricao_equipamento?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  token_tv?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "navia_dashboards.modo_tv_tokens" */
export type Navia_Dashboards_Modo_Tv_Tokens_Mutation_Response = {
  __typename?: 'navia_dashboards_modo_tv_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Modo_Tv_Tokens>;
};

/** on_conflict condition type for table "navia_dashboards.modo_tv_tokens" */
export type Navia_Dashboards_Modo_Tv_Tokens_On_Conflict = {
  constraint: Navia_Dashboards_Modo_Tv_Tokens_Constraint;
  update_columns?: Array<Navia_Dashboards_Modo_Tv_Tokens_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.modo_tv_tokens". */
export type Navia_Dashboards_Modo_Tv_Tokens_Order_By = {
  data_expiracao?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  descricao_equipamento?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  token_tv?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.modo_tv_tokens */
export type Navia_Dashboards_Modo_Tv_Tokens_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual';
  data_hora: Scalars['timestamp']['output'];
  id_token: Scalars['bigint']['output'];
  id_utilizador: Scalars['bigint']['output'];
};

/** aggregated selection of "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Aggregate = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual>;
};

/** aggregate fields of "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Aggregate_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Avg_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_avg_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.modo_tv_tokens_revogacao_manual". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp>>;
  data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  id_token?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export enum Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Constraint {
  /** unique or primary key constraint on columns "id_token" */
  ModoTvTokensRevogacaoManualPkey = 'modo_tv_tokens_revogacao_manual_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Inc_Input = {
  id_token?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Insert_Input = {
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  id_token?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Max_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_max_fields';
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  id_token?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Min_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_min_fields';
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  id_token?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Mutation_Response = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual>;
};

/** input type for inserting object relation for remote table "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Obj_Rel_Insert_Input = {
  data: Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_On_Conflict>;
};

/** on_conflict condition type for table "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_On_Conflict = {
  constraint: Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Constraint;
  update_columns?: Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.modo_tv_tokens_revogacao_manual". */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Order_By = {
  data_hora?: InputMaybe<Order_By>;
  id_token?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.modo_tv_tokens_revogacao_manual */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Pk_Columns_Input = {
  id_token: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export enum Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Select_Column {
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  IdToken = 'id_token',
  /** column name */
  IdUtilizador = 'id_utilizador'
}

/** input type for updating data in table "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Set_Input = {
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  id_token?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Stddev_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_stddev_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_stddev_pop_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_stddev_samp_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_modo_tv_tokens_revogacao_manual" */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Stream_Cursor_Value_Input = {
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  id_token?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Sum_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_sum_fields';
  id_token?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.modo_tv_tokens_revogacao_manual" */
export enum Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Update_Column {
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  IdToken = 'id_token',
  /** column name */
  IdUtilizador = 'id_utilizador'
}

export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_var_pop_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_var_samp_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Variance_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual_variance_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "navia_dashboards.modo_tv_tokens" */
export enum Navia_Dashboards_Modo_Tv_Tokens_Select_Column {
  /** column name */
  DataExpiracao = 'data_expiracao',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DescricaoEquipamento = 'descricao_equipamento',
  /** column name */
  Id = 'id',
  /** column name */
  TokenTv = 'token_tv'
}

/** input type for updating data in table "navia_dashboards.modo_tv_tokens" */
export type Navia_Dashboards_Modo_Tv_Tokens_Set_Input = {
  data_expiracao?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  descricao_equipamento?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  token_tv?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Stddev_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_modo_tv_tokens" */
export type Navia_Dashboards_Modo_Tv_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Modo_Tv_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Modo_Tv_Tokens_Stream_Cursor_Value_Input = {
  data_expiracao?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  descricao_equipamento?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  token_tv?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Sum_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.modo_tv_tokens" */
export enum Navia_Dashboards_Modo_Tv_Tokens_Update_Column {
  /** column name */
  DataExpiracao = 'data_expiracao',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DescricaoEquipamento = 'descricao_equipamento',
  /** column name */
  Id = 'id',
  /** column name */
  TokenTv = 'token_tv'
}

export type Navia_Dashboards_Modo_Tv_Tokens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp;
};

/** columns and relationships of "navia_dashboards.modo_tv_tokens_validados" */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados';
  data_hora_expiracao: Scalars['timestamp']['output'];
  data_hora_registo_bd: Scalars['timestamp']['output'];
  id_token: Scalars['bigint']['output'];
  id_utilizador: Scalars['bigint']['output'];
  /** An object relationship */
  revogado?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual>;
  token_sistema: Scalars['String']['output'];
};

/** aggregated selection of "navia_dashboards.modo_tv_tokens_validados" */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Aggregate = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Modo_Tv_Tokens_Validados>;
};

/** aggregate fields of "navia_dashboards.modo_tv_tokens_validados" */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Aggregate_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.modo_tv_tokens_validados" */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Avg_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_avg_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.modo_tv_tokens_validados". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp>>;
  data_hora_expiracao?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_registo_bd?: InputMaybe<Timestamp_Comparison_Exp>;
  id_token?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  revogado?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp>;
  token_sistema?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.modo_tv_tokens_validados" */
export enum Navia_Dashboards_Modo_Tv_Tokens_Validados_Constraint {
  /** unique or primary key constraint on columns "id_token" */
  ModoTvTokensValidadosPkey = 'modo_tv_tokens_validados_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.modo_tv_tokens_validados" */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Inc_Input = {
  id_token?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.modo_tv_tokens_validados" */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Insert_Input = {
  data_hora_expiracao?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  id_token?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  revogado?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Obj_Rel_Insert_Input>;
  token_sistema?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Max_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_max_fields';
  data_hora_expiracao?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  id_token?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  token_sistema?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Min_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_min_fields';
  data_hora_expiracao?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  id_token?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  token_sistema?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "navia_dashboards.modo_tv_tokens_validados" */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Mutation_Response = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Modo_Tv_Tokens_Validados>;
};

/** on_conflict condition type for table "navia_dashboards.modo_tv_tokens_validados" */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_On_Conflict = {
  constraint: Navia_Dashboards_Modo_Tv_Tokens_Validados_Constraint;
  update_columns?: Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.modo_tv_tokens_validados". */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Order_By = {
  data_hora_expiracao?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  id_token?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  revogado?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Order_By>;
  token_sistema?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.modo_tv_tokens_validados */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Pk_Columns_Input = {
  id_token: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.modo_tv_tokens_validados" */
export enum Navia_Dashboards_Modo_Tv_Tokens_Validados_Select_Column {
  /** column name */
  DataHoraExpiracao = 'data_hora_expiracao',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  IdToken = 'id_token',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  TokenSistema = 'token_sistema'
}

/** input type for updating data in table "navia_dashboards.modo_tv_tokens_validados" */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Set_Input = {
  data_hora_expiracao?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  id_token?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  token_sistema?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Stddev_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_stddev_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_stddev_pop_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_stddev_samp_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_modo_tv_tokens_validados" */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Modo_Tv_Tokens_Validados_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Stream_Cursor_Value_Input = {
  data_hora_expiracao?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  id_token?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  token_sistema?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Sum_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_sum_fields';
  id_token?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.modo_tv_tokens_validados" */
export enum Navia_Dashboards_Modo_Tv_Tokens_Validados_Update_Column {
  /** column name */
  DataHoraExpiracao = 'data_hora_expiracao',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  IdToken = 'id_token',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  TokenSistema = 'token_sistema'
}

export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_var_pop_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_var_samp_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Validados_Variance_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_validados_variance_fields';
  id_token?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Modo_Tv_Tokens_Variance_Fields = {
  __typename?: 'navia_dashboards_modo_tv_tokens_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Tabela associada às causas da dashboard Monitorização de Roturas */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas';
  categoria: Scalars['String']['output'];
  /** An array relationship */
  causas: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas>;
  /** An aggregate relationship */
  causas_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate;
  /** An object relationship */
  cor: Navia_Cores;
  cor_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};


/** Tabela associada às causas da dashboard Monitorização de Roturas */
export type Navia_Dashboards_Monitorizacao_Roturas_CausasCausasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>;
};


/** Tabela associada às causas da dashboard Monitorização de Roturas */
export type Navia_Dashboards_Monitorizacao_Roturas_CausasCausas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>;
};

/** aggregated selection of "navia_dashboards.monitorizacao_roturas_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Aggregate = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas>;
};

/** aggregate fields of "navia_dashboards.monitorizacao_roturas_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Aggregate_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.monitorizacao_roturas_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Avg_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_avg_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.monitorizacao_roturas_causas". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp>>;
  categoria?: InputMaybe<String_Comparison_Exp>;
  causas?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>;
  causas_aggregate?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate_Bool_Exp>;
  cor?: InputMaybe<Navia_Cores_Bool_Exp>;
  cor_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.monitorizacao_roturas_causas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Causas_Constraint {
  /** unique or primary key constraint on columns "id" */
  MonitorizacaoRoturasCausasPkey = 'monitorizacao_roturas_causas_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.monitorizacao_roturas_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Inc_Input = {
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.monitorizacao_roturas_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Insert_Input = {
  categoria?: InputMaybe<Scalars['String']['input']>;
  causas?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Arr_Rel_Insert_Input>;
  cor?: InputMaybe<Navia_Cores_Obj_Rel_Insert_Input>;
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Max_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_max_fields';
  categoria?: Maybe<Scalars['String']['output']>;
  cor_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Min_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_min_fields';
  categoria?: Maybe<Scalars['String']['output']>;
  cor_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.monitorizacao_roturas_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Mutation_Response = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas>;
};

/** input type for inserting object relation for remote table "navia_dashboards.monitorizacao_roturas_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Obj_Rel_Insert_Input = {
  data: Navia_Dashboards_Monitorizacao_Roturas_Causas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_On_Conflict>;
};

/** on_conflict condition type for table "navia_dashboards.monitorizacao_roturas_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_On_Conflict = {
  constraint: Navia_Dashboards_Monitorizacao_Roturas_Causas_Constraint;
  update_columns?: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.monitorizacao_roturas_causas". */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Order_By = {
  categoria?: InputMaybe<Order_By>;
  causas_aggregate?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate_Order_By>;
  cor?: InputMaybe<Navia_Cores_Order_By>;
  cor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.monitorizacao_roturas_causas */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** Tabela relação associada às causas da dashboard Monitorização de Roturas */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas';
  /** An object relationship */
  causa: Sintomas_Causas_Trabalhos;
  causa_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  monitorizacaoRoturasCausa: Navia_Dashboards_Monitorizacao_Roturas_Causas;
  monitorizacao_roturas_causa_id: Scalars['bigint']['output'];
};

/** aggregated selection of "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas>;
};

export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate_Bool_Exp = {
  count?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate_Bool_Exp_Count>;
};

export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate_Order_By = {
  avg?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Max_Order_By>;
  min?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Min_Order_By>;
  stddev?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Sum_Order_By>;
  var_pop?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Var_Samp_Order_By>;
  variance?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Arr_Rel_Insert_Input = {
  data: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_On_Conflict>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Avg_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_avg_fields';
  causa_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_causa_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Avg_Order_By = {
  causa_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_causa_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.monitorizacao_roturas_causas_r_causas". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>>;
  causa?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
  causa_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  monitorizacaoRoturasCausa?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp>;
  monitorizacao_roturas_causa_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Constraint {
  /** unique or primary key constraint on columns "id" */
  MonitorizacaoRoturasCausasRCausasPkey = 'monitorizacao_roturas_causas_r_causas_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Inc_Input = {
  causa_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  monitorizacao_roturas_causa_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Insert_Input = {
  causa?: InputMaybe<Sintomas_Causas_Trabalhos_Obj_Rel_Insert_Input>;
  causa_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  monitorizacaoRoturasCausa?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Obj_Rel_Insert_Input>;
  monitorizacao_roturas_causa_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Max_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_max_fields';
  causa_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  monitorizacao_roturas_causa_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Max_Order_By = {
  causa_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_causa_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Min_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_min_fields';
  causa_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  monitorizacao_roturas_causa_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Min_Order_By = {
  causa_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_causa_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Mutation_Response = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas>;
};

/** on_conflict condition type for table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_On_Conflict = {
  constraint: Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Constraint;
  update_columns?: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.monitorizacao_roturas_causas_r_causas". */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Order_By = {
  causa?: InputMaybe<Sintomas_Causas_Trabalhos_Order_By>;
  causa_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorizacaoRoturasCausa?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Order_By>;
  monitorizacao_roturas_causa_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.monitorizacao_roturas_causas_r_causas */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Select_Column {
  /** column name */
  CausaId = 'causa_id',
  /** column name */
  Id = 'id',
  /** column name */
  MonitorizacaoRoturasCausaId = 'monitorizacao_roturas_causa_id'
}

/** input type for updating data in table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Set_Input = {
  causa_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  monitorizacao_roturas_causa_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_stddev_fields';
  causa_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_causa_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Order_By = {
  causa_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_causa_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_stddev_pop_fields';
  causa_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_causa_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Pop_Order_By = {
  causa_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_causa_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_stddev_samp_fields';
  causa_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_causa_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stddev_Samp_Order_By = {
  causa_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_causa_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "navia_dashboards_monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stream_Cursor_Value_Input = {
  causa_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  monitorizacao_roturas_causa_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Sum_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_sum_fields';
  causa_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  monitorizacao_roturas_causa_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Sum_Order_By = {
  causa_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_causa_id?: InputMaybe<Order_By>;
};

/** update columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Update_Column {
  /** column name */
  CausaId = 'causa_id',
  /** column name */
  Id = 'id',
  /** column name */
  MonitorizacaoRoturasCausaId = 'monitorizacao_roturas_causa_id'
}

export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_var_pop_fields';
  causa_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_causa_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Var_Pop_Order_By = {
  causa_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_causa_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_var_samp_fields';
  causa_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_causa_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Var_Samp_Order_By = {
  causa_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_causa_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Variance_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_variance_fields';
  causa_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_causa_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Variance_Order_By = {
  causa_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_causa_id?: InputMaybe<Order_By>;
};

/** select columns of table "navia_dashboards.monitorizacao_roturas_causas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Causas_Select_Column {
  /** column name */
  Categoria = 'categoria',
  /** column name */
  CorId = 'cor_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "navia_dashboards.monitorizacao_roturas_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Set_Input = {
  categoria?: InputMaybe<Scalars['String']['input']>;
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Stddev_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_stddev_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_stddev_pop_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_stddev_samp_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_monitorizacao_roturas_causas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Monitorizacao_Roturas_Causas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Stream_Cursor_Value_Input = {
  categoria?: InputMaybe<Scalars['String']['input']>;
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Sum_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_sum_fields';
  cor_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.monitorizacao_roturas_causas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Causas_Update_Column {
  /** column name */
  Categoria = 'categoria',
  /** column name */
  CorId = 'cor_id',
  /** column name */
  Id = 'id'
}

export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_var_pop_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_var_samp_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Causas_Variance_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_causas_variance_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Tabela enum associada aos indicadores da dashboard Monitorização de Roturas */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_indicadores';
  value: Scalars['String']['output'];
};

/** aggregated selection of "navia_dashboards.monitorizacao_roturas_indicadores" */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Aggregate = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_indicadores_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores>;
};

/** aggregate fields of "navia_dashboards.monitorizacao_roturas_indicadores" */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Aggregate_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_indicadores_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Min_Fields>;
};


/** aggregate fields of "navia_dashboards.monitorizacao_roturas_indicadores" */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.monitorizacao_roturas_indicadores". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.monitorizacao_roturas_indicadores" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Constraint {
  /** unique or primary key constraint on columns "value" */
  MonitorizacaoRoturasIndicadoresPkey = 'monitorizacao_roturas_indicadores_pkey'
}

export enum Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum {
  NumeroClientesAfetados = 'numero_clientes_afetados',
  NumeroFalhasSuperior_4h = 'numero_falhas_superior_4h',
  NumeroRamaisAfetados = 'numero_ramais_afetados',
  NumeroRoturasConduta = 'numero_roturas_conduta',
  NumeroRoturasRamal = 'numero_roturas_ramal'
}

/** Boolean expression to compare columns of type "navia_dashboards_monitorizacao_roturas_indicadores_enum". All fields are combined with logical 'AND'. */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum>;
  _in?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum>;
  _nin?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum>>;
};

/** input type for inserting data into table "navia_dashboards.monitorizacao_roturas_indicadores" */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Max_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_indicadores_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Min_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_indicadores_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "navia_dashboards.monitorizacao_roturas_indicadores" */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Mutation_Response = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_indicadores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores>;
};

/** input type for inserting object relation for remote table "navia_dashboards.monitorizacao_roturas_indicadores" */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Obj_Rel_Insert_Input = {
  data: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_On_Conflict>;
};

/** on_conflict condition type for table "navia_dashboards.monitorizacao_roturas_indicadores" */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_On_Conflict = {
  constraint: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Constraint;
  update_columns?: Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.monitorizacao_roturas_indicadores". */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.monitorizacao_roturas_indicadores */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "navia_dashboards.monitorizacao_roturas_indicadores" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "navia_dashboards.monitorizacao_roturas_indicadores" */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "navia_dashboards_monitorizacao_roturas_indicadores" */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "navia_dashboards.monitorizacao_roturas_indicadores" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Update_Column {
  /** column name */
  Value = 'value'
}

export type Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp;
};

/** Tabela associada aos sintomas da dashboard Monitorização de Roturas */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas';
  id: Scalars['bigint']['output'];
  indicador: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum;
  /** An array relationship */
  sintomas: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas>;
  /** An aggregate relationship */
  sintomas_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate;
};


/** Tabela associada aos sintomas da dashboard Monitorização de Roturas */
export type Navia_Dashboards_Monitorizacao_Roturas_SintomasSintomasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>;
};


/** Tabela associada aos sintomas da dashboard Monitorização de Roturas */
export type Navia_Dashboards_Monitorizacao_Roturas_SintomasSintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>;
};

/** aggregated selection of "navia_dashboards.monitorizacao_roturas_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Aggregate = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas>;
};

/** aggregate fields of "navia_dashboards.monitorizacao_roturas_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Aggregate_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.monitorizacao_roturas_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Avg_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.monitorizacao_roturas_sintomas". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  indicador?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum_Comparison_Exp>;
  sintomas?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>;
  sintomas_aggregate?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.monitorizacao_roturas_sintomas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Constraint {
  /** unique or primary key constraint on columns "id" */
  MonitorizacaoRoturasSintomasPkey = 'monitorizacao_roturas_sintomas_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.monitorizacao_roturas_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.monitorizacao_roturas_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  indicador?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum>;
  sintomas?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Max_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Min_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.monitorizacao_roturas_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Mutation_Response = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas>;
};

/** input type for inserting object relation for remote table "navia_dashboards.monitorizacao_roturas_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Obj_Rel_Insert_Input = {
  data: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_On_Conflict>;
};

/** on_conflict condition type for table "navia_dashboards.monitorizacao_roturas_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_On_Conflict = {
  constraint: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Constraint;
  update_columns?: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.monitorizacao_roturas_sintomas". */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Order_By = {
  id?: InputMaybe<Order_By>;
  indicador?: InputMaybe<Order_By>;
  sintomas_aggregate?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate_Order_By>;
};

/** primary key columns input for table: navia_dashboards.monitorizacao_roturas_sintomas */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** Tabela relação associada aos sintomas da dashboard Monitorização de Roturas */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas';
  id: Scalars['bigint']['output'];
  /** An object relationship */
  monitorizacaoRoturasSintoma: Navia_Dashboards_Monitorizacao_Roturas_Sintomas;
  monitorizacao_roturas_sintoma_id: Scalars['bigint']['output'];
  /** An object relationship */
  sintoma: Sintomas_Arvore;
  sintoma_id: Scalars['bigint']['output'];
};

/** aggregated selection of "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas>;
};

export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate_Bool_Exp = {
  count?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate_Bool_Exp_Count>;
};

export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate_Order_By = {
  avg?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Max_Order_By>;
  min?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Min_Order_By>;
  stddev?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Sum_Order_By>;
  var_pop?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Var_Samp_Order_By>;
  variance?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Arr_Rel_Insert_Input = {
  data: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_On_Conflict>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Avg_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_sintoma_id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  monitorizacaoRoturasSintoma?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Bigint_Comparison_Exp>;
  sintoma?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  sintoma_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Constraint {
  /** unique or primary key constraint on columns "id" */
  MonitorizacaoRoturasSintomasRSintomasPkey = 'monitorizacao_roturas_sintomas_r_sintomas_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
  sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  monitorizacaoRoturasSintoma?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Obj_Rel_Insert_Input>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
  sintoma?: InputMaybe<Sintomas_Arvore_Obj_Rel_Insert_Input>;
  sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Max_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  monitorizacao_roturas_sintoma_id?: Maybe<Scalars['bigint']['output']>;
  sintoma_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Min_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  monitorizacao_roturas_sintoma_id?: Maybe<Scalars['bigint']['output']>;
  sintoma_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Mutation_Response = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas>;
};

/** on_conflict condition type for table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_On_Conflict = {
  constraint: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Constraint;
  update_columns?: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas". */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Order_By = {
  id?: InputMaybe<Order_By>;
  monitorizacaoRoturasSintoma?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Order_By>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Order_By>;
  sintoma?: InputMaybe<Sintomas_Arvore_Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MonitorizacaoRoturasSintomaId = 'monitorizacao_roturas_sintoma_id',
  /** column name */
  SintomaId = 'sintoma_id'
}

/** input type for updating data in table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
  sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_sintoma_id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_sintoma_id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_sintoma_id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
  sintoma_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Sum_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  monitorizacao_roturas_sintoma_id?: Maybe<Scalars['bigint']['output']>;
  sintoma_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** update columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  MonitorizacaoRoturasSintomaId = 'monitorizacao_roturas_sintoma_id',
  /** column name */
  SintomaId = 'sintoma_id'
}

export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_sintoma_id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_sintoma_id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Variance_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  monitorizacao_roturas_sintoma_id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  monitorizacao_roturas_sintoma_id?: InputMaybe<Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** select columns of table "navia_dashboards.monitorizacao_roturas_sintomas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Indicador = 'indicador'
}

/** input type for updating data in table "navia_dashboards.monitorizacao_roturas_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  indicador?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Stddev_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_monitorizacao_roturas_sintomas" */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  indicador?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Sum_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.monitorizacao_roturas_sintomas" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Indicador = 'indicador'
}

export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Variance_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Tabela associada às variáveis da dashboard Monitorização de Roturas */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis';
  /** An object relationship */
  fase?: Maybe<Servicos_Fases>;
  fase_id?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  indicador: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum;
  /** An object relationship */
  monitorizacaoRoturasIndicador: Navia_Dashboards_Monitorizacao_Roturas_Indicadores;
  /** An object relationship */
  variavel?: Maybe<Variaveis_Base>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "navia_dashboards.monitorizacao_roturas_variaveis" */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Aggregate = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis>;
};

/** aggregate fields of "navia_dashboards.monitorizacao_roturas_variaveis" */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Aggregate_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.monitorizacao_roturas_variaveis" */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Avg_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_avg_fields';
  fase_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.monitorizacao_roturas_variaveis". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp>>;
  fase?: InputMaybe<Servicos_Fases_Bool_Exp>;
  fase_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  indicador?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum_Comparison_Exp>;
  monitorizacaoRoturasIndicador?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp>;
  variavel?: InputMaybe<Variaveis_Base_Bool_Exp>;
  variavel_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.monitorizacao_roturas_variaveis" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Constraint {
  /** unique or primary key constraint on columns "id" */
  MonitorizacaoRoturasVariaveisPkey = 'monitorizacao_roturas_variaveis_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.monitorizacao_roturas_variaveis" */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Inc_Input = {
  fase_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.monitorizacao_roturas_variaveis" */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Insert_Input = {
  fase?: InputMaybe<Servicos_Fases_Obj_Rel_Insert_Input>;
  fase_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  indicador?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum>;
  monitorizacaoRoturasIndicador?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Obj_Rel_Insert_Input>;
  variavel?: InputMaybe<Variaveis_Base_Obj_Rel_Insert_Input>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Max_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_max_fields';
  fase_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Min_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_min_fields';
  fase_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.monitorizacao_roturas_variaveis" */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Mutation_Response = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis>;
};

/** on_conflict condition type for table "navia_dashboards.monitorizacao_roturas_variaveis" */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_On_Conflict = {
  constraint: Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Constraint;
  update_columns?: Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.monitorizacao_roturas_variaveis". */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Order_By = {
  fase?: InputMaybe<Servicos_Fases_Order_By>;
  fase_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicador?: InputMaybe<Order_By>;
  monitorizacaoRoturasIndicador?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Order_By>;
  variavel?: InputMaybe<Variaveis_Base_Order_By>;
  variavel_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.monitorizacao_roturas_variaveis */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.monitorizacao_roturas_variaveis" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Select_Column {
  /** column name */
  FaseId = 'fase_id',
  /** column name */
  Id = 'id',
  /** column name */
  Indicador = 'indicador',
  /** column name */
  VariavelId = 'variavel_id'
}

/** input type for updating data in table "navia_dashboards.monitorizacao_roturas_variaveis" */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Set_Input = {
  fase_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  indicador?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Stddev_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_stddev_fields';
  fase_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_stddev_pop_fields';
  fase_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_stddev_samp_fields';
  fase_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_monitorizacao_roturas_variaveis" */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Stream_Cursor_Value_Input = {
  fase_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  indicador?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Sum_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_sum_fields';
  fase_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.monitorizacao_roturas_variaveis" */
export enum Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Update_Column {
  /** column name */
  FaseId = 'fase_id',
  /** column name */
  Id = 'id',
  /** column name */
  Indicador = 'indicador',
  /** column name */
  VariavelId = 'variavel_id'
}

export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_var_pop_fields';
  fase_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_var_samp_fields';
  fase_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Variance_Fields = {
  __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_variance_fields';
  fase_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Parametrização da Dashboard Performance de Infraestrutura */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao';
  data_hora_registo_db: Scalars['timestamptz']['output'];
  descricao: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  unidadeMedida?: Maybe<Variaveis_Unidades_Medida>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  variavel?: Maybe<Variaveis_Base>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "navia_dashboards.performance_infraestrutura_parametrizacao" */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Aggregate = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao>;
};

/** aggregate fields of "navia_dashboards.performance_infraestrutura_parametrizacao" */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Aggregate_Fields = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.performance_infraestrutura_parametrizacao" */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Avg_Fields = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.performance_infraestrutura_parametrizacao". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp>>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
  unidade_medida_id?: InputMaybe<Bigint_Comparison_Exp>;
  variavel?: InputMaybe<Variaveis_Base_Bool_Exp>;
  variavel_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.performance_infraestrutura_parametrizacao" */
export enum Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Constraint {
  /** unique or primary key constraint on columns "id" */
  PerformanceInfraestruturaParametrizacaoPkey = 'performance_infraestrutura_parametrizacao_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.performance_infraestrutura_parametrizacao" */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.performance_infraestrutura_parametrizacao" */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Insert_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Obj_Rel_Insert_Input>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel?: InputMaybe<Variaveis_Base_Obj_Rel_Insert_Input>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Max_Fields = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_max_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Min_Fields = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_min_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.performance_infraestrutura_parametrizacao" */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Mutation_Response = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao>;
};

/** on_conflict condition type for table "navia_dashboards.performance_infraestrutura_parametrizacao" */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_On_Conflict = {
  constraint: Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Constraint;
  update_columns?: Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.performance_infraestrutura_parametrizacao". */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Order_By = {
  data_hora_registo_db?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Order_By>;
  unidade_medida_id?: InputMaybe<Order_By>;
  variavel?: InputMaybe<Variaveis_Base_Order_By>;
  variavel_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.performance_infraestrutura_parametrizacao */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "navia_dashboards.performance_infraestrutura_parametrizacao" */
export enum Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Select_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  UnidadeMedidaId = 'unidade_medida_id',
  /** column name */
  VariavelId = 'variavel_id'
}

/** input type for updating data in table "navia_dashboards.performance_infraestrutura_parametrizacao" */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Set_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Stddev_Fields = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_performance_infraestrutura_parametrizacao" */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Stream_Cursor_Value_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Sum_Fields = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.performance_infraestrutura_parametrizacao" */
export enum Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Update_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  UnidadeMedidaId = 'unidade_medida_id',
  /** column name */
  VariavelId = 'variavel_id'
}

export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Variance_Fields = {
  __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Parametrização dos Indicadores da Dashboard Pesquisa Ativa de Fugas */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao';
  data_hora_registo_db: Scalars['timestamptz']['output'];
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  unidadeMedida?: Maybe<Variaveis_Unidades_Medida>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  variavel?: Maybe<Variaveis_Base>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Aggregate = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao>;
};

/** aggregate fields of "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Aggregate_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Avg_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp>>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
  unidade_medida_id?: InputMaybe<Bigint_Comparison_Exp>;
  variavel?: InputMaybe<Variaveis_Base_Bool_Exp>;
  variavel_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Constraint {
  /** unique or primary key constraint on columns "id" */
  PesquisaAtivaFugasIndicadoresParametrizacaoPkey = 'pesquisa_ativa_fugas_indicadores_parametrizacao_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Insert_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Obj_Rel_Insert_Input>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel?: InputMaybe<Variaveis_Base_Obj_Rel_Insert_Input>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Max_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_max_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Min_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_min_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Mutation_Response = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao>;
};

/** on_conflict condition type for table "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_On_Conflict = {
  constraint: Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Constraint;
  update_columns?: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao". */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Order_By = {
  data_hora_registo_db?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Order_By>;
  unidade_medida_id?: InputMaybe<Order_By>;
  variavel?: InputMaybe<Variaveis_Base_Order_By>;
  variavel_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Select_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  UnidadeMedidaId = 'unidade_medida_id',
  /** column name */
  VariavelId = 'variavel_id'
}

/** input type for updating data in table "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Set_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Stddev_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Stream_Cursor_Value_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Sum_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Update_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  UnidadeMedidaId = 'unidade_medida_id',
  /** column name */
  VariavelId = 'variavel_id'
}

export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Variance_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa';
  apagado: Scalars['Boolean']['output'];
  data_hora_atualizacao_db: Scalars['timestamptz']['output'];
  data_hora_registo_db: Scalars['timestamptz']['output'];
  /** An object relationship */
  modeloTarefa: Tarefas_Planos_Padrao;
  plano_padrao_id: Scalars['bigint']['output'];
};

/** aggregated selection of "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Aggregate = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa>;
};

/** aggregate fields of "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Aggregate_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Avg_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_avg_fields';
  plano_padrao_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  data_hora_atualizacao_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  modeloTarefa?: InputMaybe<Tarefas_Planos_Padrao_Bool_Exp>;
  plano_padrao_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Constraint {
  /** unique or primary key constraint on columns "plano_padrao_id" */
  PesquisaAtivaFugasMapaModelosTarefaPkey = 'pesquisa_ativa_fugas_mapa_modelos_tarefa_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Inc_Input = {
  plano_padrao_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora_atualizacao_db?: InputMaybe<Scalars['timestamptz']['input']>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  modeloTarefa?: InputMaybe<Tarefas_Planos_Padrao_Obj_Rel_Insert_Input>;
  plano_padrao_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Max_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_max_fields';
  data_hora_atualizacao_db?: Maybe<Scalars['timestamptz']['output']>;
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  plano_padrao_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Min_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_min_fields';
  data_hora_atualizacao_db?: Maybe<Scalars['timestamptz']['output']>;
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  plano_padrao_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Mutation_Response = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa>;
};

/** on_conflict condition type for table "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_On_Conflict = {
  constraint: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Constraint;
  update_columns?: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa". */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Order_By = {
  apagado?: InputMaybe<Order_By>;
  data_hora_atualizacao_db?: InputMaybe<Order_By>;
  data_hora_registo_db?: InputMaybe<Order_By>;
  modeloTarefa?: InputMaybe<Tarefas_Planos_Padrao_Order_By>;
  plano_padrao_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Pk_Columns_Input = {
  plano_padrao_id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHoraAtualizacaoDb = 'data_hora_atualizacao_db',
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  PlanoPadraoId = 'plano_padrao_id'
}

/** input type for updating data in table "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora_atualizacao_db?: InputMaybe<Scalars['timestamptz']['input']>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  plano_padrao_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Stddev_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_stddev_fields';
  plano_padrao_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_stddev_pop_fields';
  plano_padrao_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_stddev_samp_fields';
  plano_padrao_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora_atualizacao_db?: InputMaybe<Scalars['timestamptz']['input']>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  plano_padrao_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Sum_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_sum_fields';
  plano_padrao_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHoraAtualizacaoDb = 'data_hora_atualizacao_db',
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  PlanoPadraoId = 'plano_padrao_id'
}

export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_var_pop_fields';
  plano_padrao_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_var_samp_fields';
  plano_padrao_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Variance_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_variance_fields';
  plano_padrao_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas';
  /** An object relationship */
  cor: Navia_Cores;
  cor_id: Scalars['bigint']['output'];
  data_hora_registo_db: Scalars['timestamptz']['output'];
  /** An object relationship */
  fase?: Maybe<Servicos_Fases>;
  fase_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  fonteOrigem?: Maybe<Variaveis_Fontes_Origem>;
  fonte_origem_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  mapaSintomaDominiosValores: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores>;
  /** An aggregate relationship */
  mapaSintomaDominiosValores_aggregate: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate;
  /** An object relationship */
  sintoma?: Maybe<Sintomas_Arvore>;
  sintoma_id?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_SintomasMapaSintomaDominiosValoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>;
};


/** columns and relationships of "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_SintomasMapaSintomaDominiosValores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>;
};

/** aggregated selection of "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Aggregate = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas>;
};

/** aggregate fields of "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Aggregate_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Avg_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_avg_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  fase_id?: Maybe<Scalars['Float']['output']>;
  fonte_origem_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp>>;
  cor?: InputMaybe<Navia_Cores_Bool_Exp>;
  cor_id?: InputMaybe<Bigint_Comparison_Exp>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  fase?: InputMaybe<Servicos_Fases_Bool_Exp>;
  fase_id?: InputMaybe<Int_Comparison_Exp>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
  fonte_origem_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  mapaSintomaDominiosValores?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>;
  mapaSintomaDominiosValores_aggregate?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate_Bool_Exp>;
  sintoma?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  sintoma_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Constraint {
  /** unique or primary key constraint on columns "cor_id" */
  PesquisaAtivaFugasMapaSintomasCorIdKey = 'pesquisa_ativa_fugas_mapa_sintomas_cor_id_key',
  /** unique or primary key constraint on columns "id" */
  PesquisaAtivaFugasMapaSintomasPkey = 'pesquisa_ativa_fugas_mapa_sintomas_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Inc_Input = {
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  fase_id?: InputMaybe<Scalars['Int']['input']>;
  fonte_origem_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sintoma_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Insert_Input = {
  cor?: InputMaybe<Navia_Cores_Obj_Rel_Insert_Input>;
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  fase?: InputMaybe<Servicos_Fases_Obj_Rel_Insert_Input>;
  fase_id?: InputMaybe<Scalars['Int']['input']>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Obj_Rel_Insert_Input>;
  fonte_origem_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mapaSintomaDominiosValores?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Arr_Rel_Insert_Input>;
  sintoma?: InputMaybe<Sintomas_Arvore_Obj_Rel_Insert_Input>;
  sintoma_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Max_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_max_fields';
  cor_id?: Maybe<Scalars['bigint']['output']>;
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  fase_id?: Maybe<Scalars['Int']['output']>;
  fonte_origem_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  sintoma_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Min_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_min_fields';
  cor_id?: Maybe<Scalars['bigint']['output']>;
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  fase_id?: Maybe<Scalars['Int']['output']>;
  fonte_origem_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  sintoma_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Mutation_Response = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas>;
};

/** on_conflict condition type for table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_On_Conflict = {
  constraint: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Constraint;
  update_columns?: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas". */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Order_By = {
  cor?: InputMaybe<Navia_Cores_Order_By>;
  cor_id?: InputMaybe<Order_By>;
  data_hora_registo_db?: InputMaybe<Order_By>;
  fase?: InputMaybe<Servicos_Fases_Order_By>;
  fase_id?: InputMaybe<Order_By>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Order_By>;
  fonte_origem_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapaSintomaDominiosValores_aggregate?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate_Order_By>;
  sintoma?: InputMaybe<Sintomas_Arvore_Order_By>;
  sintoma_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores';
  /** An object relationship */
  dominioValor: Variaveis_Dominios_Valores;
  dominio_valor_id: Scalars['Int']['output'];
  id: Scalars['bigint']['output'];
  mapa_sintoma_id: Scalars['Int']['output'];
};

/** aggregated selection of "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores>;
};

export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate_Bool_Exp = {
  count?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate_Bool_Exp_Count>;
};

export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate_Order_By = {
  avg?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Max_Order_By>;
  min?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Min_Order_By>;
  stddev?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Sum_Order_By>;
  var_pop?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Var_Samp_Order_By>;
  variance?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Arr_Rel_Insert_Input = {
  data: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_On_Conflict>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Avg_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_avg_fields';
  dominio_valor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mapa_sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Avg_Order_By = {
  dominio_valor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapa_sintoma_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>>;
  dominioValor?: InputMaybe<Variaveis_Dominios_Valores_Bool_Exp>;
  dominio_valor_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  mapa_sintoma_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Constraint {
  /** unique or primary key constraint on columns "id" */
  PesquisaAtivaFugasMapaSintomasRDominiosValoresPkey = 'pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_pkey',
  /** unique or primary key constraint on columns "dominio_valor_id", "mapa_sintoma_id" */
  PesquisaAtivaFugasMapaSintomasSintomaValorDominio = 'pesquisa_ativa_fugas_mapa_sintomas_sintoma_valor_dominio'
}

/** input type for incrementing numeric columns in table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Inc_Input = {
  dominio_valor_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mapa_sintoma_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Insert_Input = {
  dominioValor?: InputMaybe<Variaveis_Dominios_Valores_Obj_Rel_Insert_Input>;
  dominio_valor_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mapa_sintoma_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Max_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_max_fields';
  dominio_valor_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mapa_sintoma_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Max_Order_By = {
  dominio_valor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapa_sintoma_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Min_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_min_fields';
  dominio_valor_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mapa_sintoma_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Min_Order_By = {
  dominio_valor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapa_sintoma_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Mutation_Response = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores>;
};

/** on_conflict condition type for table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_On_Conflict = {
  constraint: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Constraint;
  update_columns?: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores". */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Order_By = {
  dominioValor?: InputMaybe<Variaveis_Dominios_Valores_Order_By>;
  dominio_valor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapa_sintoma_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Select_Column {
  /** column name */
  DominioValorId = 'dominio_valor_id',
  /** column name */
  Id = 'id',
  /** column name */
  MapaSintomaId = 'mapa_sintoma_id'
}

/** input type for updating data in table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Set_Input = {
  dominio_valor_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mapa_sintoma_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_stddev_fields';
  dominio_valor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mapa_sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Order_By = {
  dominio_valor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapa_sintoma_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_stddev_pop_fields';
  dominio_valor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mapa_sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Pop_Order_By = {
  dominio_valor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapa_sintoma_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_stddev_samp_fields';
  dominio_valor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mapa_sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stddev_Samp_Order_By = {
  dominio_valor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapa_sintoma_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stream_Cursor_Value_Input = {
  dominio_valor_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mapa_sintoma_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Sum_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_sum_fields';
  dominio_valor_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mapa_sintoma_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Sum_Order_By = {
  dominio_valor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapa_sintoma_id?: InputMaybe<Order_By>;
};

/** update columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Update_Column {
  /** column name */
  DominioValorId = 'dominio_valor_id',
  /** column name */
  Id = 'id',
  /** column name */
  MapaSintomaId = 'mapa_sintoma_id'
}

export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_var_pop_fields';
  dominio_valor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mapa_sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Var_Pop_Order_By = {
  dominio_valor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapa_sintoma_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_var_samp_fields';
  dominio_valor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mapa_sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Var_Samp_Order_By = {
  dominio_valor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapa_sintoma_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Variance_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_variance_fields';
  dominio_valor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  mapa_sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Variance_Order_By = {
  dominio_valor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapa_sintoma_id?: InputMaybe<Order_By>;
};

/** select columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Select_Column {
  /** column name */
  CorId = 'cor_id',
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  FaseId = 'fase_id',
  /** column name */
  FonteOrigemId = 'fonte_origem_id',
  /** column name */
  Id = 'id',
  /** column name */
  SintomaId = 'sintoma_id'
}

/** input type for updating data in table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Set_Input = {
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  fase_id?: InputMaybe<Scalars['Int']['input']>;
  fonte_origem_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sintoma_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Stddev_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_stddev_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  fase_id?: Maybe<Scalars['Float']['output']>;
  fonte_origem_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_stddev_pop_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  fase_id?: Maybe<Scalars['Float']['output']>;
  fonte_origem_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_stddev_samp_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  fase_id?: Maybe<Scalars['Float']['output']>;
  fonte_origem_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Stream_Cursor_Value_Input = {
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  fase_id?: InputMaybe<Scalars['Int']['input']>;
  fonte_origem_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  sintoma_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Sum_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_sum_fields';
  cor_id?: Maybe<Scalars['bigint']['output']>;
  fase_id?: Maybe<Scalars['Int']['output']>;
  fonte_origem_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  sintoma_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Update_Column {
  /** column name */
  CorId = 'cor_id',
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  FaseId = 'fase_id',
  /** column name */
  FonteOrigemId = 'fonte_origem_id',
  /** column name */
  Id = 'id',
  /** column name */
  SintomaId = 'sintoma_id'
}

export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_var_pop_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  fase_id?: Maybe<Scalars['Float']['output']>;
  fonte_origem_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_var_samp_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  fase_id?: Maybe<Scalars['Float']['output']>;
  fonte_origem_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Variance_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_variance_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  fase_id?: Maybe<Scalars['Float']['output']>;
  fonte_origem_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  sintoma_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura';
  data_hora_registo_db: Scalars['timestamptz']['output'];
  /** An object relationship */
  tipoInfraestrutura: Base_Infraestruturas_Tipos;
  tipo_infraestrutura_id: Scalars['Int']['output'];
};

/** aggregated selection of "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Aggregate = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura>;
};

/** aggregate fields of "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Aggregate_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Avg_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_avg_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp>>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  tipoInfraestrutura?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
  tipo_infraestrutura_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Constraint {
  /** unique or primary key constraint on columns "tipo_infraestrutura_id" */
  PesquisaAtivaFugasMapaTipoInfraestruturaPkey = 'pesquisa_ativa_fugas_mapa_tipo_infraestrutura_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Inc_Input = {
  tipo_infraestrutura_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Insert_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  tipoInfraestrutura?: InputMaybe<Base_Infraestruturas_Tipos_Obj_Rel_Insert_Input>;
  tipo_infraestrutura_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Max_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_max_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  tipo_infraestrutura_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Min_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_min_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  tipo_infraestrutura_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Mutation_Response = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura>;
};

/** on_conflict condition type for table "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_On_Conflict = {
  constraint: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Constraint;
  update_columns?: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura". */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Order_By = {
  data_hora_registo_db?: InputMaybe<Order_By>;
  tipoInfraestrutura?: InputMaybe<Base_Infraestruturas_Tipos_Order_By>;
  tipo_infraestrutura_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Pk_Columns_Input = {
  tipo_infraestrutura_id: Scalars['Int']['input'];
};

/** select columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Select_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  TipoInfraestruturaId = 'tipo_infraestrutura_id'
}

/** input type for updating data in table "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Set_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  tipo_infraestrutura_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Stddev_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_stddev_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_stddev_pop_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_stddev_samp_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Stream_Cursor_Value_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  tipo_infraestrutura_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Sum_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_sum_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
export enum Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Update_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  TipoInfraestruturaId = 'tipo_infraestrutura_id'
}

export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_var_pop_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_var_samp_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Variance_Fields = {
  __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_variance_fields';
  tipo_infraestrutura_id?: Maybe<Scalars['Float']['output']>;
};

/** Parametrização dos Indicadores da Dashboard Requisições */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao';
  atraso_segundos: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  limite_inferior_segundos: Scalars['bigint']['output'];
  limite_superior_segundos: Scalars['bigint']['output'];
  /** An object relationship */
  variavelMarcacao?: Maybe<Variaveis_Base>;
  variavel_marcacao_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "navia_dashboards.requisicoes_indicadores_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Aggregate = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao>;
};

/** aggregate fields of "navia_dashboards.requisicoes_indicadores_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Aggregate_Fields = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.requisicoes_indicadores_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Avg_Fields = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_avg_fields';
  atraso_segundos?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  limite_inferior_segundos?: Maybe<Scalars['Float']['output']>;
  limite_superior_segundos?: Maybe<Scalars['Float']['output']>;
  variavel_marcacao_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.requisicoes_indicadores_parametrizacao". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp>>;
  atraso_segundos?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  limite_inferior_segundos?: InputMaybe<Bigint_Comparison_Exp>;
  limite_superior_segundos?: InputMaybe<Bigint_Comparison_Exp>;
  variavelMarcacao?: InputMaybe<Variaveis_Base_Bool_Exp>;
  variavel_marcacao_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.requisicoes_indicadores_parametrizacao" */
export enum Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Constraint {
  /** unique or primary key constraint on columns "id" */
  RequisicoesIndicadoresParametrizacaoPkey = 'requisicoes_indicadores_parametrizacao_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.requisicoes_indicadores_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Inc_Input = {
  atraso_segundos?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  limite_inferior_segundos?: InputMaybe<Scalars['bigint']['input']>;
  limite_superior_segundos?: InputMaybe<Scalars['bigint']['input']>;
  variavel_marcacao_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.requisicoes_indicadores_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Insert_Input = {
  atraso_segundos?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  limite_inferior_segundos?: InputMaybe<Scalars['bigint']['input']>;
  limite_superior_segundos?: InputMaybe<Scalars['bigint']['input']>;
  variavelMarcacao?: InputMaybe<Variaveis_Base_Obj_Rel_Insert_Input>;
  variavel_marcacao_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Max_Fields = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_max_fields';
  atraso_segundos?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  limite_inferior_segundos?: Maybe<Scalars['bigint']['output']>;
  limite_superior_segundos?: Maybe<Scalars['bigint']['output']>;
  variavel_marcacao_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Min_Fields = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_min_fields';
  atraso_segundos?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  limite_inferior_segundos?: Maybe<Scalars['bigint']['output']>;
  limite_superior_segundos?: Maybe<Scalars['bigint']['output']>;
  variavel_marcacao_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.requisicoes_indicadores_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Mutation_Response = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao>;
};

/** on_conflict condition type for table "navia_dashboards.requisicoes_indicadores_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_On_Conflict = {
  constraint: Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Constraint;
  update_columns?: Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.requisicoes_indicadores_parametrizacao". */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Order_By = {
  atraso_segundos?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  limite_inferior_segundos?: InputMaybe<Order_By>;
  limite_superior_segundos?: InputMaybe<Order_By>;
  variavelMarcacao?: InputMaybe<Variaveis_Base_Order_By>;
  variavel_marcacao_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.requisicoes_indicadores_parametrizacao */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.requisicoes_indicadores_parametrizacao" */
export enum Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Select_Column {
  /** column name */
  AtrasoSegundos = 'atraso_segundos',
  /** column name */
  Id = 'id',
  /** column name */
  LimiteInferiorSegundos = 'limite_inferior_segundos',
  /** column name */
  LimiteSuperiorSegundos = 'limite_superior_segundos',
  /** column name */
  VariavelMarcacaoId = 'variavel_marcacao_id'
}

/** input type for updating data in table "navia_dashboards.requisicoes_indicadores_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Set_Input = {
  atraso_segundos?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  limite_inferior_segundos?: InputMaybe<Scalars['bigint']['input']>;
  limite_superior_segundos?: InputMaybe<Scalars['bigint']['input']>;
  variavel_marcacao_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Stddev_Fields = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_stddev_fields';
  atraso_segundos?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  limite_inferior_segundos?: Maybe<Scalars['Float']['output']>;
  limite_superior_segundos?: Maybe<Scalars['Float']['output']>;
  variavel_marcacao_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_stddev_pop_fields';
  atraso_segundos?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  limite_inferior_segundos?: Maybe<Scalars['Float']['output']>;
  limite_superior_segundos?: Maybe<Scalars['Float']['output']>;
  variavel_marcacao_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_stddev_samp_fields';
  atraso_segundos?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  limite_inferior_segundos?: Maybe<Scalars['Float']['output']>;
  limite_superior_segundos?: Maybe<Scalars['Float']['output']>;
  variavel_marcacao_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_requisicoes_indicadores_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Stream_Cursor_Value_Input = {
  atraso_segundos?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  limite_inferior_segundos?: InputMaybe<Scalars['bigint']['input']>;
  limite_superior_segundos?: InputMaybe<Scalars['bigint']['input']>;
  variavel_marcacao_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Sum_Fields = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_sum_fields';
  atraso_segundos?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  limite_inferior_segundos?: Maybe<Scalars['bigint']['output']>;
  limite_superior_segundos?: Maybe<Scalars['bigint']['output']>;
  variavel_marcacao_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.requisicoes_indicadores_parametrizacao" */
export enum Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Update_Column {
  /** column name */
  AtrasoSegundos = 'atraso_segundos',
  /** column name */
  Id = 'id',
  /** column name */
  LimiteInferiorSegundos = 'limite_inferior_segundos',
  /** column name */
  LimiteSuperiorSegundos = 'limite_superior_segundos',
  /** column name */
  VariavelMarcacaoId = 'variavel_marcacao_id'
}

export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_var_pop_fields';
  atraso_segundos?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  limite_inferior_segundos?: Maybe<Scalars['Float']['output']>;
  limite_superior_segundos?: Maybe<Scalars['Float']['output']>;
  variavel_marcacao_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_var_samp_fields';
  atraso_segundos?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  limite_inferior_segundos?: Maybe<Scalars['Float']['output']>;
  limite_superior_segundos?: Maybe<Scalars['Float']['output']>;
  variavel_marcacao_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Variance_Fields = {
  __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao_variance_fields';
  atraso_segundos?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  limite_inferior_segundos?: Maybe<Scalars['Float']['output']>;
  limite_superior_segundos?: Maybe<Scalars['Float']['output']>;
  variavel_marcacao_id?: Maybe<Scalars['Float']['output']>;
};

/** Parametrização do Mapa da Dashboard Requisições */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao';
  /** An object relationship */
  cor: Navia_Cores;
  cor_id: Scalars['bigint']['output'];
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "navia_dashboards.requisicoes_mapa_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Aggregate = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao>;
};

/** aggregate fields of "navia_dashboards.requisicoes_mapa_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Aggregate_Fields = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.requisicoes_mapa_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Avg_Fields = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_avg_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.requisicoes_mapa_parametrizacao". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp>>;
  cor?: InputMaybe<Navia_Cores_Bool_Exp>;
  cor_id?: InputMaybe<Bigint_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.requisicoes_mapa_parametrizacao" */
export enum Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Constraint {
  /** unique or primary key constraint on columns "cor_id" */
  RequisicoesMapaParametrizacaoCorIdKey = 'requisicoes_mapa_parametrizacao_cor_id_key',
  /** unique or primary key constraint on columns "id" */
  RequisicoesMapaParametrizacaoPkey = 'requisicoes_mapa_parametrizacao_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.requisicoes_mapa_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Inc_Input = {
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.requisicoes_mapa_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Insert_Input = {
  cor?: InputMaybe<Navia_Cores_Obj_Rel_Insert_Input>;
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Max_Fields = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_max_fields';
  cor_id?: Maybe<Scalars['bigint']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Min_Fields = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_min_fields';
  cor_id?: Maybe<Scalars['bigint']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.requisicoes_mapa_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Mutation_Response = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao>;
};

/** on_conflict condition type for table "navia_dashboards.requisicoes_mapa_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_On_Conflict = {
  constraint: Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Constraint;
  update_columns?: Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.requisicoes_mapa_parametrizacao". */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Order_By = {
  cor?: InputMaybe<Navia_Cores_Order_By>;
  cor_id?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.requisicoes_mapa_parametrizacao */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.requisicoes_mapa_parametrizacao" */
export enum Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Select_Column {
  /** column name */
  CorId = 'cor_id',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "navia_dashboards.requisicoes_mapa_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Set_Input = {
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Stddev_Fields = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_stddev_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_stddev_pop_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_stddev_samp_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_requisicoes_mapa_parametrizacao" */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Stream_Cursor_Value_Input = {
  cor_id?: InputMaybe<Scalars['bigint']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Sum_Fields = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_sum_fields';
  cor_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.requisicoes_mapa_parametrizacao" */
export enum Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Update_Column {
  /** column name */
  CorId = 'cor_id',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_var_pop_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_var_samp_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Variance_Fields = {
  __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao_variance_fields';
  cor_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Parametrização da Dashboard Visão 360 */
export type Navia_Dashboards_Visao_360_Parametrizacao = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao';
  data_hora_registo_db: Scalars['timestamptz']['output'];
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  infraestruturaTipo?: Maybe<Base_Infraestruturas_Tipos>;
  infraestrutura_tipo_id?: Maybe<Scalars['bigint']['output']>;
  selector: Navia_Dashboards_Visao_360_Selectores_Enum;
  /** An object relationship */
  unidadeMedida?: Maybe<Variaveis_Unidades_Medida>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  variavel?: Maybe<Variaveis_Base>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "navia_dashboards.visao_360_parametrizacao" */
export type Navia_Dashboards_Visao_360_Parametrizacao_Aggregate = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Visao_360_Parametrizacao>;
};

/** aggregate fields of "navia_dashboards.visao_360_parametrizacao" */
export type Navia_Dashboards_Visao_360_Parametrizacao_Aggregate_Fields = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.visao_360_parametrizacao" */
export type Navia_Dashboards_Visao_360_Parametrizacao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Visao_360_Parametrizacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Visao_360_Parametrizacao_Avg_Fields = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  infraestrutura_tipo_id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.visao_360_parametrizacao". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp>>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  infraestruturaTipo?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
  infraestrutura_tipo_id?: InputMaybe<Bigint_Comparison_Exp>;
  selector?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Enum_Comparison_Exp>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
  unidade_medida_id?: InputMaybe<Bigint_Comparison_Exp>;
  variavel?: InputMaybe<Variaveis_Base_Bool_Exp>;
  variavel_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.visao_360_parametrizacao" */
export enum Navia_Dashboards_Visao_360_Parametrizacao_Constraint {
  /** unique or primary key constraint on columns "id" */
  Visao_360ParametrizacaoPkey = 'visao_360_parametrizacao_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.visao_360_parametrizacao" */
export type Navia_Dashboards_Visao_360_Parametrizacao_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura_tipo_id?: InputMaybe<Scalars['bigint']['input']>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.visao_360_parametrizacao" */
export type Navia_Dashboards_Visao_360_Parametrizacao_Insert_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  infraestruturaTipo?: InputMaybe<Base_Infraestruturas_Tipos_Obj_Rel_Insert_Input>;
  infraestrutura_tipo_id?: InputMaybe<Scalars['bigint']['input']>;
  selector?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Enum>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Obj_Rel_Insert_Input>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel?: InputMaybe<Variaveis_Base_Obj_Rel_Insert_Input>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Visao_360_Parametrizacao_Max_Fields = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_max_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  infraestrutura_tipo_id?: Maybe<Scalars['bigint']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Visao_360_Parametrizacao_Min_Fields = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_min_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  infraestrutura_tipo_id?: Maybe<Scalars['bigint']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.visao_360_parametrizacao" */
export type Navia_Dashboards_Visao_360_Parametrizacao_Mutation_Response = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Visao_360_Parametrizacao>;
};

/** on_conflict condition type for table "navia_dashboards.visao_360_parametrizacao" */
export type Navia_Dashboards_Visao_360_Parametrizacao_On_Conflict = {
  constraint: Navia_Dashboards_Visao_360_Parametrizacao_Constraint;
  update_columns?: Array<Navia_Dashboards_Visao_360_Parametrizacao_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.visao_360_parametrizacao". */
export type Navia_Dashboards_Visao_360_Parametrizacao_Order_By = {
  data_hora_registo_db?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  infraestruturaTipo?: InputMaybe<Base_Infraestruturas_Tipos_Order_By>;
  infraestrutura_tipo_id?: InputMaybe<Order_By>;
  selector?: InputMaybe<Order_By>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Order_By>;
  unidade_medida_id?: InputMaybe<Order_By>;
  variavel?: InputMaybe<Variaveis_Base_Order_By>;
  variavel_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.visao_360_parametrizacao */
export type Navia_Dashboards_Visao_360_Parametrizacao_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.visao_360_parametrizacao" */
export enum Navia_Dashboards_Visao_360_Parametrizacao_Select_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  InfraestruturaTipoId = 'infraestrutura_tipo_id',
  /** column name */
  Selector = 'selector',
  /** column name */
  UnidadeMedidaId = 'unidade_medida_id',
  /** column name */
  VariavelId = 'variavel_id'
}

/** input type for updating data in table "navia_dashboards.visao_360_parametrizacao" */
export type Navia_Dashboards_Visao_360_Parametrizacao_Set_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura_tipo_id?: InputMaybe<Scalars['bigint']['input']>;
  selector?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Enum>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Visao_360_Parametrizacao_Stddev_Fields = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  infraestrutura_tipo_id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Visao_360_Parametrizacao_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  infraestrutura_tipo_id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Visao_360_Parametrizacao_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  infraestrutura_tipo_id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_visao_360_parametrizacao" */
export type Navia_Dashboards_Visao_360_Parametrizacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Visao_360_Parametrizacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Visao_360_Parametrizacao_Stream_Cursor_Value_Input = {
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura_tipo_id?: InputMaybe<Scalars['bigint']['input']>;
  selector?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Enum>;
  unidade_medida_id?: InputMaybe<Scalars['bigint']['input']>;
  variavel_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Visao_360_Parametrizacao_Sum_Fields = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  infraestrutura_tipo_id?: Maybe<Scalars['bigint']['output']>;
  unidade_medida_id?: Maybe<Scalars['bigint']['output']>;
  variavel_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.visao_360_parametrizacao" */
export enum Navia_Dashboards_Visao_360_Parametrizacao_Update_Column {
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  InfraestruturaTipoId = 'infraestrutura_tipo_id',
  /** column name */
  Selector = 'selector',
  /** column name */
  UnidadeMedidaId = 'unidade_medida_id',
  /** column name */
  VariavelId = 'variavel_id'
}

export type Navia_Dashboards_Visao_360_Parametrizacao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Visao_360_Parametrizacao_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  infraestrutura_tipo_id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Visao_360_Parametrizacao_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  infraestrutura_tipo_id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Visao_360_Parametrizacao_Variance_Fields = {
  __typename?: 'navia_dashboards_visao_360_parametrizacao_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  infraestrutura_tipo_id?: Maybe<Scalars['Float']['output']>;
  unidade_medida_id?: Maybe<Scalars['Float']['output']>;
  variavel_id?: Maybe<Scalars['Float']['output']>;
};

/** Selectores da Dashboard Visao 360 */
export type Navia_Dashboards_Visao_360_Selectores = {
  __typename?: 'navia_dashboards_visao_360_selectores';
  value: Scalars['String']['output'];
};

/** aggregated selection of "navia_dashboards.visao_360_selectores" */
export type Navia_Dashboards_Visao_360_Selectores_Aggregate = {
  __typename?: 'navia_dashboards_visao_360_selectores_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Visao_360_Selectores_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Visao_360_Selectores>;
};

/** aggregate fields of "navia_dashboards.visao_360_selectores" */
export type Navia_Dashboards_Visao_360_Selectores_Aggregate_Fields = {
  __typename?: 'navia_dashboards_visao_360_selectores_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Visao_360_Selectores_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Visao_360_Selectores_Min_Fields>;
};


/** aggregate fields of "navia_dashboards.visao_360_selectores" */
export type Navia_Dashboards_Visao_360_Selectores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.visao_360_selectores". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Visao_360_Selectores_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.visao_360_selectores" */
export enum Navia_Dashboards_Visao_360_Selectores_Constraint {
  /** unique or primary key constraint on columns "value" */
  Visao_360SelectoresPkey = 'visao_360_selectores_pkey'
}

export enum Navia_Dashboards_Visao_360_Selectores_Enum {
  InfraestruturaTipo = 'infraestrutura_tipo',
  Variavel = 'variavel'
}

/** Boolean expression to compare columns of type "navia_dashboards_visao_360_selectores_enum". All fields are combined with logical 'AND'. */
export type Navia_Dashboards_Visao_360_Selectores_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Enum>;
  _in?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Enum>;
  _nin?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Enum>>;
};

/** input type for inserting data into table "navia_dashboards.visao_360_selectores" */
export type Navia_Dashboards_Visao_360_Selectores_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Visao_360_Selectores_Max_Fields = {
  __typename?: 'navia_dashboards_visao_360_selectores_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Visao_360_Selectores_Min_Fields = {
  __typename?: 'navia_dashboards_visao_360_selectores_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "navia_dashboards.visao_360_selectores" */
export type Navia_Dashboards_Visao_360_Selectores_Mutation_Response = {
  __typename?: 'navia_dashboards_visao_360_selectores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Visao_360_Selectores>;
};

/** on_conflict condition type for table "navia_dashboards.visao_360_selectores" */
export type Navia_Dashboards_Visao_360_Selectores_On_Conflict = {
  constraint: Navia_Dashboards_Visao_360_Selectores_Constraint;
  update_columns?: Array<Navia_Dashboards_Visao_360_Selectores_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.visao_360_selectores". */
export type Navia_Dashboards_Visao_360_Selectores_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.visao_360_selectores */
export type Navia_Dashboards_Visao_360_Selectores_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "navia_dashboards.visao_360_selectores" */
export enum Navia_Dashboards_Visao_360_Selectores_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "navia_dashboards.visao_360_selectores" */
export type Navia_Dashboards_Visao_360_Selectores_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "navia_dashboards_visao_360_selectores" */
export type Navia_Dashboards_Visao_360_Selectores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Visao_360_Selectores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Visao_360_Selectores_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "navia_dashboards.visao_360_selectores" */
export enum Navia_Dashboards_Visao_360_Selectores_Update_Column {
  /** column name */
  Value = 'value'
}

export type Navia_Dashboards_Visao_360_Selectores_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Visao_360_Selectores_Bool_Exp;
};

/** Tabela enum utilizada na parametrização da Dashboard Caudais Diários */
export type Navia_Dashboards_Volumes_Diarios_Caudais = {
  __typename?: 'navia_dashboards_volumes_diarios_caudais';
  value: Scalars['String']['output'];
};

/** aggregated selection of "navia_dashboards.volumes_diarios_caudais" */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Aggregate = {
  __typename?: 'navia_dashboards_volumes_diarios_caudais_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Volumes_Diarios_Caudais_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Volumes_Diarios_Caudais>;
};

/** aggregate fields of "navia_dashboards.volumes_diarios_caudais" */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Aggregate_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_caudais_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Volumes_Diarios_Caudais_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Volumes_Diarios_Caudais_Min_Fields>;
};


/** aggregate fields of "navia_dashboards.volumes_diarios_caudais" */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.volumes_diarios_caudais". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.volumes_diarios_caudais" */
export enum Navia_Dashboards_Volumes_Diarios_Caudais_Constraint {
  /** unique or primary key constraint on columns "value" */
  CaudaisDiariosCaudaisPkey = 'caudais_diarios_caudais_pkey'
}

export enum Navia_Dashboards_Volumes_Diarios_Caudais_Enum {
  ParcialDiario = 'parcial_diario',
  ParcialDireto = 'parcial_direto'
}

/** Boolean expression to compare columns of type "navia_dashboards_volumes_diarios_caudais_enum". All fields are combined with logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Enum>;
  _in?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Enum>;
  _nin?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Enum>>;
};

/** input type for inserting data into table "navia_dashboards.volumes_diarios_caudais" */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Max_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_caudais_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Min_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_caudais_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "navia_dashboards.volumes_diarios_caudais" */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Mutation_Response = {
  __typename?: 'navia_dashboards_volumes_diarios_caudais_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Volumes_Diarios_Caudais>;
};

/** on_conflict condition type for table "navia_dashboards.volumes_diarios_caudais" */
export type Navia_Dashboards_Volumes_Diarios_Caudais_On_Conflict = {
  constraint: Navia_Dashboards_Volumes_Diarios_Caudais_Constraint;
  update_columns?: Array<Navia_Dashboards_Volumes_Diarios_Caudais_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.volumes_diarios_caudais". */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.volumes_diarios_caudais */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "navia_dashboards.volumes_diarios_caudais" */
export enum Navia_Dashboards_Volumes_Diarios_Caudais_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "navia_dashboards.volumes_diarios_caudais" */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "navia_dashboards_volumes_diarios_caudais" */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Volumes_Diarios_Caudais_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Volumes_Diarios_Caudais_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "navia_dashboards.volumes_diarios_caudais" */
export enum Navia_Dashboards_Volumes_Diarios_Caudais_Update_Column {
  /** column name */
  Value = 'value'
}

export type Navia_Dashboards_Volumes_Diarios_Caudais_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp;
};

/** Tabela utilizada na parametrização da Dashboard Caudais Diários */
export type Navia_Dashboards_Volumes_Diarios_Dados = {
  __typename?: 'navia_dashboards_volumes_diarios_dados';
  caudal: Navia_Dashboards_Volumes_Diarios_Caudais_Enum;
  expressao?: Maybe<Scalars['String']['output']>;
  id_municipio: Scalars['bigint']['output'];
  leitura: Navia_Dashboards_Volumes_Diarios_Leituras_Enum;
  local: Navia_Dashboards_Volumes_Diarios_Locais_Enum;
  /** An object relationship */
  municipio: Navia_Dashboards_Volumes_Diarios_Municipios;
  registo: Navia_Dashboards_Volumes_Diarios_Registos_Enum;
};

/** aggregated selection of "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Aggregate = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Volumes_Diarios_Dados>;
};

export type Navia_Dashboards_Volumes_Diarios_Dados_Aggregate_Bool_Exp = {
  count?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Aggregate_Bool_Exp_Count>;
};

export type Navia_Dashboards_Volumes_Diarios_Dados_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Aggregate_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Aggregate_Order_By = {
  avg?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Max_Order_By>;
  min?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Min_Order_By>;
  stddev?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Sum_Order_By>;
  var_pop?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Var_Samp_Order_By>;
  variance?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Arr_Rel_Insert_Input = {
  data: Array<Navia_Dashboards_Volumes_Diarios_Dados_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_On_Conflict>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Volumes_Diarios_Dados_Avg_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_avg_fields';
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Avg_Order_By = {
  id_municipio?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.volumes_diarios_dados". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>>;
  caudal?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Enum_Comparison_Exp>;
  expressao?: InputMaybe<String_Comparison_Exp>;
  id_municipio?: InputMaybe<Bigint_Comparison_Exp>;
  leitura?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Enum_Comparison_Exp>;
  local?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Enum_Comparison_Exp>;
  municipio?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>;
  registo?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.volumes_diarios_dados" */
export enum Navia_Dashboards_Volumes_Diarios_Dados_Constraint {
  /** unique or primary key constraint on columns "id_municipio" */
  CaudaisDiariosDadosPkey = 'caudais_diarios_dados_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Inc_Input = {
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Insert_Input = {
  caudal?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Enum>;
  expressao?: InputMaybe<Scalars['String']['input']>;
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
  leitura?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Enum>;
  local?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Enum>;
  municipio?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Obj_Rel_Insert_Input>;
  registo?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Enum>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Volumes_Diarios_Dados_Max_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_max_fields';
  expressao?: Maybe<Scalars['String']['output']>;
  id_municipio?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Max_Order_By = {
  expressao?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Volumes_Diarios_Dados_Min_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_min_fields';
  expressao?: Maybe<Scalars['String']['output']>;
  id_municipio?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Min_Order_By = {
  expressao?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Mutation_Response = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Volumes_Diarios_Dados>;
};

/** on_conflict condition type for table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_On_Conflict = {
  constraint: Navia_Dashboards_Volumes_Diarios_Dados_Constraint;
  update_columns?: Array<Navia_Dashboards_Volumes_Diarios_Dados_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.volumes_diarios_dados". */
export type Navia_Dashboards_Volumes_Diarios_Dados_Order_By = {
  caudal?: InputMaybe<Order_By>;
  expressao?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
  leitura?: InputMaybe<Order_By>;
  local?: InputMaybe<Order_By>;
  municipio?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Order_By>;
  registo?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.volumes_diarios_dados */
export type Navia_Dashboards_Volumes_Diarios_Dados_Pk_Columns_Input = {
  id_municipio: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.volumes_diarios_dados" */
export enum Navia_Dashboards_Volumes_Diarios_Dados_Select_Column {
  /** column name */
  Caudal = 'caudal',
  /** column name */
  Expressao = 'expressao',
  /** column name */
  IdMunicipio = 'id_municipio',
  /** column name */
  Leitura = 'leitura',
  /** column name */
  Local = 'local',
  /** column name */
  Registo = 'registo'
}

/** input type for updating data in table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Set_Input = {
  caudal?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Enum>;
  expressao?: InputMaybe<Scalars['String']['input']>;
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
  leitura?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Enum>;
  local?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Enum>;
  registo?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Enum>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_stddev_fields';
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Order_By = {
  id_municipio?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_stddev_pop_fields';
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Pop_Order_By = {
  id_municipio?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_stddev_samp_fields';
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Stddev_Samp_Order_By = {
  id_municipio?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "navia_dashboards_volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Volumes_Diarios_Dados_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Volumes_Diarios_Dados_Stream_Cursor_Value_Input = {
  caudal?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Enum>;
  expressao?: InputMaybe<Scalars['String']['input']>;
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
  leitura?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Enum>;
  local?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Enum>;
  registo?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Enum>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Volumes_Diarios_Dados_Sum_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_sum_fields';
  id_municipio?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Sum_Order_By = {
  id_municipio?: InputMaybe<Order_By>;
};

/** update columns of table "navia_dashboards.volumes_diarios_dados" */
export enum Navia_Dashboards_Volumes_Diarios_Dados_Update_Column {
  /** column name */
  Caudal = 'caudal',
  /** column name */
  Expressao = 'expressao',
  /** column name */
  IdMunicipio = 'id_municipio',
  /** column name */
  Leitura = 'leitura',
  /** column name */
  Local = 'local',
  /** column name */
  Registo = 'registo'
}

export type Navia_Dashboards_Volumes_Diarios_Dados_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Volumes_Diarios_Dados_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_var_pop_fields';
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Var_Pop_Order_By = {
  id_municipio?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Volumes_Diarios_Dados_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_var_samp_fields';
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Var_Samp_Order_By = {
  id_municipio?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Volumes_Diarios_Dados_Variance_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_dados_variance_fields';
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "navia_dashboards.volumes_diarios_dados" */
export type Navia_Dashboards_Volumes_Diarios_Dados_Variance_Order_By = {
  id_municipio?: InputMaybe<Order_By>;
};

/** Tabela relação entre Equipas Virtuais e Municipios da Dashboard Caudais Diarios */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios';
  /** An object relationship */
  equipaVirtual: Utilizadores_Equipas_Virtuais;
  id: Scalars['bigint']['output'];
  id_equipa_virtual: Scalars['bigint']['output'];
  id_municipio: Scalars['bigint']['output'];
  /** An object relationship */
  municipio: Navia_Dashboards_Volumes_Diarios_Municipios;
};

/** aggregated selection of "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios>;
};

export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate_Bool_Exp = {
  count?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate_Bool_Exp_Count>;
};

export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate_Order_By = {
  avg?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Max_Order_By>;
  min?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Min_Order_By>;
  stddev?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Sum_Order_By>;
  var_pop?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Var_Samp_Order_By>;
  variance?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Arr_Rel_Insert_Input = {
  data: Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_On_Conflict>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Avg_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual?: InputMaybe<Bigint_Comparison_Exp>;
  id_municipio?: InputMaybe<Bigint_Comparison_Exp>;
  municipio?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export enum Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaudaisDiariosEquipasVirtuaisRMunicipiosPkey = 'caudais_diarios_equipas_virtuais_r_municipios_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Insert_Input = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
  municipio?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Max_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_municipio?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Min_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_municipio?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Mutation_Response = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios>;
};

/** on_conflict condition type for table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_On_Conflict = {
  constraint: Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Constraint;
  update_columns?: Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios". */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Order_By = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Order_By>;
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
  municipio?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Order_By>;
};

/** primary key columns input for table: navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export enum Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdMunicipio = 'id_municipio'
}

/** input type for updating data in table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Sum_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_municipio?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** update columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export enum Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdMunicipio = 'id_municipio'
}

export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Variance_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
};

/** Tabela enum utilizada na parametrização da Dashboard Caudais Diários */
export type Navia_Dashboards_Volumes_Diarios_Leituras = {
  __typename?: 'navia_dashboards_volumes_diarios_leituras';
  value: Scalars['String']['output'];
};

/** aggregated selection of "navia_dashboards.volumes_diarios_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Aggregate = {
  __typename?: 'navia_dashboards_volumes_diarios_leituras_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Volumes_Diarios_Leituras_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Volumes_Diarios_Leituras>;
};

/** aggregate fields of "navia_dashboards.volumes_diarios_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Aggregate_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_leituras_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Volumes_Diarios_Leituras_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Volumes_Diarios_Leituras_Min_Fields>;
};


/** aggregate fields of "navia_dashboards.volumes_diarios_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.volumes_diarios_leituras". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.volumes_diarios_leituras" */
export enum Navia_Dashboards_Volumes_Diarios_Leituras_Constraint {
  /** unique or primary key constraint on columns "value" */
  CaudaisDiariosLeiturasPkey = 'caudais_diarios_leituras_pkey'
}

export enum Navia_Dashboards_Volumes_Diarios_Leituras_Enum {
  Todas = 'todas',
  Validadas = 'validadas'
}

/** Boolean expression to compare columns of type "navia_dashboards_volumes_diarios_leituras_enum". All fields are combined with logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Enum>;
  _in?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Enum>;
  _nin?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Enum>>;
};

/** input type for inserting data into table "navia_dashboards.volumes_diarios_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Max_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_leituras_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Min_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_leituras_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "navia_dashboards.volumes_diarios_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Mutation_Response = {
  __typename?: 'navia_dashboards_volumes_diarios_leituras_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Volumes_Diarios_Leituras>;
};

/** on_conflict condition type for table "navia_dashboards.volumes_diarios_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Leituras_On_Conflict = {
  constraint: Navia_Dashboards_Volumes_Diarios_Leituras_Constraint;
  update_columns?: Array<Navia_Dashboards_Volumes_Diarios_Leituras_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.volumes_diarios_leituras". */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.volumes_diarios_leituras */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "navia_dashboards.volumes_diarios_leituras" */
export enum Navia_Dashboards_Volumes_Diarios_Leituras_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "navia_dashboards.volumes_diarios_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "navia_dashboards_volumes_diarios_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Volumes_Diarios_Leituras_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Volumes_Diarios_Leituras_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "navia_dashboards.volumes_diarios_leituras" */
export enum Navia_Dashboards_Volumes_Diarios_Leituras_Update_Column {
  /** column name */
  Value = 'value'
}

export type Navia_Dashboards_Volumes_Diarios_Leituras_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp;
};

/** Tabela enum utilizada na parametrização da Dashboard Caudais Diários */
export type Navia_Dashboards_Volumes_Diarios_Locais = {
  __typename?: 'navia_dashboards_volumes_diarios_locais';
  value: Scalars['String']['output'];
};

/** aggregated selection of "navia_dashboards.volumes_diarios_locais" */
export type Navia_Dashboards_Volumes_Diarios_Locais_Aggregate = {
  __typename?: 'navia_dashboards_volumes_diarios_locais_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Volumes_Diarios_Locais_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Volumes_Diarios_Locais>;
};

/** aggregate fields of "navia_dashboards.volumes_diarios_locais" */
export type Navia_Dashboards_Volumes_Diarios_Locais_Aggregate_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_locais_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Volumes_Diarios_Locais_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Volumes_Diarios_Locais_Min_Fields>;
};


/** aggregate fields of "navia_dashboards.volumes_diarios_locais" */
export type Navia_Dashboards_Volumes_Diarios_Locais_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.volumes_diarios_locais". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.volumes_diarios_locais" */
export enum Navia_Dashboards_Volumes_Diarios_Locais_Constraint {
  /** unique or primary key constraint on columns "value" */
  CaudaisDiariosLocaisPkey = 'caudais_diarios_locais_pkey'
}

export enum Navia_Dashboards_Volumes_Diarios_Locais_Enum {
  Infraestrutura = 'infraestrutura',
  Instalacao = 'instalacao'
}

/** Boolean expression to compare columns of type "navia_dashboards_volumes_diarios_locais_enum". All fields are combined with logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Locais_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Enum>;
  _in?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Enum>;
  _nin?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Enum>>;
};

/** input type for inserting data into table "navia_dashboards.volumes_diarios_locais" */
export type Navia_Dashboards_Volumes_Diarios_Locais_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Volumes_Diarios_Locais_Max_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_locais_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Volumes_Diarios_Locais_Min_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_locais_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "navia_dashboards.volumes_diarios_locais" */
export type Navia_Dashboards_Volumes_Diarios_Locais_Mutation_Response = {
  __typename?: 'navia_dashboards_volumes_diarios_locais_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Volumes_Diarios_Locais>;
};

/** on_conflict condition type for table "navia_dashboards.volumes_diarios_locais" */
export type Navia_Dashboards_Volumes_Diarios_Locais_On_Conflict = {
  constraint: Navia_Dashboards_Volumes_Diarios_Locais_Constraint;
  update_columns?: Array<Navia_Dashboards_Volumes_Diarios_Locais_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.volumes_diarios_locais". */
export type Navia_Dashboards_Volumes_Diarios_Locais_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.volumes_diarios_locais */
export type Navia_Dashboards_Volumes_Diarios_Locais_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "navia_dashboards.volumes_diarios_locais" */
export enum Navia_Dashboards_Volumes_Diarios_Locais_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "navia_dashboards.volumes_diarios_locais" */
export type Navia_Dashboards_Volumes_Diarios_Locais_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "navia_dashboards_volumes_diarios_locais" */
export type Navia_Dashboards_Volumes_Diarios_Locais_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Volumes_Diarios_Locais_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Volumes_Diarios_Locais_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "navia_dashboards.volumes_diarios_locais" */
export enum Navia_Dashboards_Volumes_Diarios_Locais_Update_Column {
  /** column name */
  Value = 'value'
}

export type Navia_Dashboards_Volumes_Diarios_Locais_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp;
};

/** Parametrização dos Municipios da Dashboard Caudais Diarios */
export type Navia_Dashboards_Volumes_Diarios_Municipios = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  configuracaoDados: Array<Navia_Dashboards_Volumes_Diarios_Dados>;
  /** An aggregate relationship */
  configuracaoDados_aggregate: Navia_Dashboards_Volumes_Diarios_Dados_Aggregate;
  data_hora_registo_db: Scalars['timestamptz']['output'];
  descricao: Scalars['String']['output'];
  /** An array relationship */
  equipasVirtuaisMunicipio: Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios>;
  /** An aggregate relationship */
  equipasVirtuaisMunicipio_aggregate: Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate;
  id: Scalars['bigint']['output'];
};


/** Parametrização dos Municipios da Dashboard Caudais Diarios */
export type Navia_Dashboards_Volumes_Diarios_MunicipiosConfiguracaoDadosArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>;
};


/** Parametrização dos Municipios da Dashboard Caudais Diarios */
export type Navia_Dashboards_Volumes_Diarios_MunicipiosConfiguracaoDados_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>;
};


/** Parametrização dos Municipios da Dashboard Caudais Diarios */
export type Navia_Dashboards_Volumes_Diarios_MunicipiosEquipasVirtuaisMunicipioArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>;
};


/** Parametrização dos Municipios da Dashboard Caudais Diarios */
export type Navia_Dashboards_Volumes_Diarios_MunicipiosEquipasVirtuaisMunicipio_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>;
};

/** aggregated selection of "navia_dashboards.volumes_diarios_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Aggregate = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Volumes_Diarios_Municipios>;
};

/** aggregate fields of "navia_dashboards.volumes_diarios_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Aggregate_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.volumes_diarios_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Avg_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.volumes_diarios_municipios". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  configuracaoDados?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>;
  configuracaoDados_aggregate?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Aggregate_Bool_Exp>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  equipasVirtuaisMunicipio?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>;
  equipasVirtuaisMunicipio_aggregate?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.volumes_diarios_municipios" */
export enum Navia_Dashboards_Volumes_Diarios_Municipios_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaudaisDiariosMunicipiosPkey = 'caudais_diarios_municipios_pkey',
  /** unique or primary key constraint on columns "descricao" */
  NaviaDashboardsCaudaisDiariosDescription = 'navia_dashboards_caudais_diarios_description'
}

/** input type for incrementing numeric columns in table "navia_dashboards.volumes_diarios_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.volumes_diarios_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  configuracaoDados?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Arr_Rel_Insert_Input>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  equipasVirtuaisMunicipio?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Max_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_max_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Min_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_min_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.volumes_diarios_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Mutation_Response = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Volumes_Diarios_Municipios>;
};

/** input type for inserting object relation for remote table "navia_dashboards.volumes_diarios_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Obj_Rel_Insert_Input = {
  data: Navia_Dashboards_Volumes_Diarios_Municipios_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_On_Conflict>;
};

/** on_conflict condition type for table "navia_dashboards.volumes_diarios_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Municipios_On_Conflict = {
  constraint: Navia_Dashboards_Volumes_Diarios_Municipios_Constraint;
  update_columns?: Array<Navia_Dashboards_Volumes_Diarios_Municipios_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.volumes_diarios_municipios". */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Order_By = {
  apagado?: InputMaybe<Order_By>;
  configuracaoDados_aggregate?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Aggregate_Order_By>;
  data_hora_registo_db?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  equipasVirtuaisMunicipio_aggregate?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.volumes_diarios_municipios */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.volumes_diarios_municipios" */
export enum Navia_Dashboards_Volumes_Diarios_Municipios_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "navia_dashboards.volumes_diarios_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Stddev_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_volumes_diarios_municipios" */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Volumes_Diarios_Municipios_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Sum_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.volumes_diarios_municipios" */
export enum Navia_Dashboards_Volumes_Diarios_Municipios_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Navia_Dashboards_Volumes_Diarios_Municipios_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Volumes_Diarios_Municipios_Variance_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_municipios_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Tabela enum utilizada na parametrização da Dashboard Caudais Diários */
export type Navia_Dashboards_Volumes_Diarios_Registos = {
  __typename?: 'navia_dashboards_volumes_diarios_registos';
  value: Scalars['String']['output'];
};

/** aggregated selection of "navia_dashboards.volumes_diarios_registos" */
export type Navia_Dashboards_Volumes_Diarios_Registos_Aggregate = {
  __typename?: 'navia_dashboards_volumes_diarios_registos_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Volumes_Diarios_Registos_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Volumes_Diarios_Registos>;
};

/** aggregate fields of "navia_dashboards.volumes_diarios_registos" */
export type Navia_Dashboards_Volumes_Diarios_Registos_Aggregate_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_registos_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Volumes_Diarios_Registos_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Volumes_Diarios_Registos_Min_Fields>;
};


/** aggregate fields of "navia_dashboards.volumes_diarios_registos" */
export type Navia_Dashboards_Volumes_Diarios_Registos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.volumes_diarios_registos". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.volumes_diarios_registos" */
export enum Navia_Dashboards_Volumes_Diarios_Registos_Constraint {
  /** unique or primary key constraint on columns "value" */
  CaudaisDiariosRegistosPkey = 'caudais_diarios_registos_pkey'
}

export enum Navia_Dashboards_Volumes_Diarios_Registos_Enum {
  DiasComLeituras = 'dias_com_leituras',
  UmaPorDia = 'uma_por_dia'
}

/** Boolean expression to compare columns of type "navia_dashboards_volumes_diarios_registos_enum". All fields are combined with logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Registos_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Enum>;
  _in?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Enum>;
  _nin?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Enum>>;
};

/** input type for inserting data into table "navia_dashboards.volumes_diarios_registos" */
export type Navia_Dashboards_Volumes_Diarios_Registos_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Volumes_Diarios_Registos_Max_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_registos_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Volumes_Diarios_Registos_Min_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_registos_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "navia_dashboards.volumes_diarios_registos" */
export type Navia_Dashboards_Volumes_Diarios_Registos_Mutation_Response = {
  __typename?: 'navia_dashboards_volumes_diarios_registos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Volumes_Diarios_Registos>;
};

/** on_conflict condition type for table "navia_dashboards.volumes_diarios_registos" */
export type Navia_Dashboards_Volumes_Diarios_Registos_On_Conflict = {
  constraint: Navia_Dashboards_Volumes_Diarios_Registos_Constraint;
  update_columns?: Array<Navia_Dashboards_Volumes_Diarios_Registos_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.volumes_diarios_registos". */
export type Navia_Dashboards_Volumes_Diarios_Registos_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.volumes_diarios_registos */
export type Navia_Dashboards_Volumes_Diarios_Registos_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "navia_dashboards.volumes_diarios_registos" */
export enum Navia_Dashboards_Volumes_Diarios_Registos_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "navia_dashboards.volumes_diarios_registos" */
export type Navia_Dashboards_Volumes_Diarios_Registos_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "navia_dashboards_volumes_diarios_registos" */
export type Navia_Dashboards_Volumes_Diarios_Registos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Volumes_Diarios_Registos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Volumes_Diarios_Registos_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "navia_dashboards.volumes_diarios_registos" */
export enum Navia_Dashboards_Volumes_Diarios_Registos_Update_Column {
  /** column name */
  Value = 'value'
}

export type Navia_Dashboards_Volumes_Diarios_Registos_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp;
};

/** Tabela enum utilizada na parametrização da Dashboard Caudais Diários */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizador_leituras';
  value: Scalars['String']['output'];
};

/** aggregated selection of "navia_dashboards.volumes_diarios_totalizador_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Aggregate = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizador_leituras_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras>;
};

/** aggregate fields of "navia_dashboards.volumes_diarios_totalizador_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Aggregate_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizador_leituras_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Min_Fields>;
};


/** aggregate fields of "navia_dashboards.volumes_diarios_totalizador_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.volumes_diarios_totalizador_leituras". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.volumes_diarios_totalizador_leituras" */
export enum Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Constraint {
  /** unique or primary key constraint on columns "value" */
  CaudaisDiariosTotalizadorLeiturasPkey = 'caudais_diarios_totalizador_leituras_pkey'
}

export enum Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum {
  Primeira = 'primeira',
  Ultima = 'ultima'
}

/** Boolean expression to compare columns of type "navia_dashboards_volumes_diarios_totalizador_leituras_enum". All fields are combined with logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum>;
  _in?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum>;
  _nin?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum>>;
};

/** input type for inserting data into table "navia_dashboards.volumes_diarios_totalizador_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Max_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizador_leituras_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Min_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizador_leituras_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "navia_dashboards.volumes_diarios_totalizador_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Mutation_Response = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizador_leituras_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras>;
};

/** on_conflict condition type for table "navia_dashboards.volumes_diarios_totalizador_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_On_Conflict = {
  constraint: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Constraint;
  update_columns?: Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.volumes_diarios_totalizador_leituras". */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia_dashboards.volumes_diarios_totalizador_leituras */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "navia_dashboards.volumes_diarios_totalizador_leituras" */
export enum Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "navia_dashboards.volumes_diarios_totalizador_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "navia_dashboards_volumes_diarios_totalizador_leituras" */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "navia_dashboards.volumes_diarios_totalizador_leituras" */
export enum Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Update_Column {
  /** column name */
  Value = 'value'
}

export type Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp;
};

/** Tabela utilizada na parametrização da Dashboard Caudais Diários */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores';
  expressao: Scalars['Boolean']['output'];
  /** An object relationship */
  fonteOrigemPropriedade?: Maybe<Variaveis_Fontes_Origem_Propriedades>;
  id: Scalars['bigint']['output'];
  id_fonte_origem_propriedade: Scalars['Int']['output'];
  id_municipio: Scalars['bigint']['output'];
  leitura: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum;
  /** An object relationship */
  municipio: Navia_Dashboards_Volumes_Diarios_Municipios;
};

/** aggregated selection of "navia_dashboards.volumes_diarios_totalizadores" */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Aggregate = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_aggregate';
  aggregate?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Aggregate_Fields>;
  nodes: Array<Navia_Dashboards_Volumes_Diarios_Totalizadores>;
};

/** aggregate fields of "navia_dashboards.volumes_diarios_totalizadores" */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Aggregate_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_aggregate_fields';
  avg?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Max_Fields>;
  min?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Min_Fields>;
  stddev?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Sum_Fields>;
  var_pop?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Var_Samp_Fields>;
  variance?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Variance_Fields>;
};


/** aggregate fields of "navia_dashboards.volumes_diarios_totalizadores" */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Avg_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem_propriedade?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia_dashboards.volumes_diarios_totalizadores". All fields are combined with a logical 'AND'. */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp>>;
  _not?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp>>;
  expressao?: InputMaybe<Boolean_Comparison_Exp>;
  fonteOrigemPropriedade?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_fonte_origem_propriedade?: InputMaybe<Int_Comparison_Exp>;
  id_municipio?: InputMaybe<Bigint_Comparison_Exp>;
  leitura?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum_Comparison_Exp>;
  municipio?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>;
};

/** unique or primary key constraints on table "navia_dashboards.volumes_diarios_totalizadores" */
export enum Navia_Dashboards_Volumes_Diarios_Totalizadores_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaudaisDiariosTotalizadoresPkey = 'caudais_diarios_totalizadores_pkey'
}

/** input type for incrementing numeric columns in table "navia_dashboards.volumes_diarios_totalizadores" */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem_propriedade?: InputMaybe<Scalars['Int']['input']>;
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia_dashboards.volumes_diarios_totalizadores" */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Insert_Input = {
  expressao?: InputMaybe<Scalars['Boolean']['input']>;
  fonteOrigemPropriedade?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem_propriedade?: InputMaybe<Scalars['Int']['input']>;
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
  leitura?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum>;
  municipio?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Max_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem_propriedade?: Maybe<Scalars['Int']['output']>;
  id_municipio?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Min_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem_propriedade?: Maybe<Scalars['Int']['output']>;
  id_municipio?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia_dashboards.volumes_diarios_totalizadores" */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Mutation_Response = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Dashboards_Volumes_Diarios_Totalizadores>;
};

/** on_conflict condition type for table "navia_dashboards.volumes_diarios_totalizadores" */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_On_Conflict = {
  constraint: Navia_Dashboards_Volumes_Diarios_Totalizadores_Constraint;
  update_columns?: Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Update_Column>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp>;
};

/** Ordering options when selecting data from "navia_dashboards.volumes_diarios_totalizadores". */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Order_By = {
  expressao?: InputMaybe<Order_By>;
  fonteOrigemPropriedade?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Order_By>;
  id?: InputMaybe<Order_By>;
  id_fonte_origem_propriedade?: InputMaybe<Order_By>;
  id_municipio?: InputMaybe<Order_By>;
  leitura?: InputMaybe<Order_By>;
  municipio?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Order_By>;
};

/** primary key columns input for table: navia_dashboards.volumes_diarios_totalizadores */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia_dashboards.volumes_diarios_totalizadores" */
export enum Navia_Dashboards_Volumes_Diarios_Totalizadores_Select_Column {
  /** column name */
  Expressao = 'expressao',
  /** column name */
  Id = 'id',
  /** column name */
  IdFonteOrigemPropriedade = 'id_fonte_origem_propriedade',
  /** column name */
  IdMunicipio = 'id_municipio',
  /** column name */
  Leitura = 'leitura'
}

/** input type for updating data in table "navia_dashboards.volumes_diarios_totalizadores" */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Set_Input = {
  expressao?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem_propriedade?: InputMaybe<Scalars['Int']['input']>;
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
  leitura?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum>;
};

/** aggregate stddev on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Stddev_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem_propriedade?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Stddev_Pop_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem_propriedade?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Stddev_Samp_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem_propriedade?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_dashboards_volumes_diarios_totalizadores" */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Dashboards_Volumes_Diarios_Totalizadores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Stream_Cursor_Value_Input = {
  expressao?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem_propriedade?: InputMaybe<Scalars['Int']['input']>;
  id_municipio?: InputMaybe<Scalars['bigint']['input']>;
  leitura?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum>;
};

/** aggregate sum on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Sum_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem_propriedade?: Maybe<Scalars['Int']['output']>;
  id_municipio?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia_dashboards.volumes_diarios_totalizadores" */
export enum Navia_Dashboards_Volumes_Diarios_Totalizadores_Update_Column {
  /** column name */
  Expressao = 'expressao',
  /** column name */
  Id = 'id',
  /** column name */
  IdFonteOrigemPropriedade = 'id_fonte_origem_propriedade',
  /** column name */
  IdMunicipio = 'id_municipio',
  /** column name */
  Leitura = 'leitura'
}

export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Var_Pop_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem_propriedade?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Var_Samp_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem_propriedade?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Dashboards_Volumes_Diarios_Totalizadores_Variance_Fields = {
  __typename?: 'navia_dashboards_volumes_diarios_totalizadores_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem_propriedade?: Maybe<Scalars['Float']['output']>;
  id_municipio?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "navia.integracoes" */
export type Navia_Integracoes = {
  __typename?: 'navia_integracoes';
  activo?: Maybe<Scalars['Boolean']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "navia.integracoes" */
export type Navia_Integracoes_Aggregate = {
  __typename?: 'navia_integracoes_aggregate';
  aggregate?: Maybe<Navia_Integracoes_Aggregate_Fields>;
  nodes: Array<Navia_Integracoes>;
};

/** aggregate fields of "navia.integracoes" */
export type Navia_Integracoes_Aggregate_Fields = {
  __typename?: 'navia_integracoes_aggregate_fields';
  avg?: Maybe<Navia_Integracoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Integracoes_Max_Fields>;
  min?: Maybe<Navia_Integracoes_Min_Fields>;
  stddev?: Maybe<Navia_Integracoes_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Integracoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Integracoes_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Integracoes_Sum_Fields>;
  var_pop?: Maybe<Navia_Integracoes_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Integracoes_Var_Samp_Fields>;
  variance?: Maybe<Navia_Integracoes_Variance_Fields>;
};


/** aggregate fields of "navia.integracoes" */
export type Navia_Integracoes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Integracoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Integracoes_Avg_Fields = {
  __typename?: 'navia_integracoes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia.integracoes". All fields are combined with a logical 'AND'. */
export type Navia_Integracoes_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Integracoes_Bool_Exp>>;
  _not?: InputMaybe<Navia_Integracoes_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Integracoes_Bool_Exp>>;
  activo?: InputMaybe<Boolean_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia.integracoes" */
export enum Navia_Integracoes_Constraint {
  /** unique or primary key constraint on columns "id" */
  IntegracoesPkey = 'integracoes_pkey'
}

/** input type for incrementing numeric columns in table "navia.integracoes" */
export type Navia_Integracoes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia.integracoes" */
export type Navia_Integracoes_Insert_Input = {
  activo?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Integracoes_Max_Fields = {
  __typename?: 'navia_integracoes_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Integracoes_Min_Fields = {
  __typename?: 'navia_integracoes_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia.integracoes" */
export type Navia_Integracoes_Mutation_Response = {
  __typename?: 'navia_integracoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Integracoes>;
};

/** on_conflict condition type for table "navia.integracoes" */
export type Navia_Integracoes_On_Conflict = {
  constraint: Navia_Integracoes_Constraint;
  update_columns?: Array<Navia_Integracoes_Update_Column>;
  where?: InputMaybe<Navia_Integracoes_Bool_Exp>;
};

/** Ordering options when selecting data from "navia.integracoes". */
export type Navia_Integracoes_Order_By = {
  activo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia.integracoes */
export type Navia_Integracoes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia.integracoes" */
export enum Navia_Integracoes_Select_Column {
  /** column name */
  Activo = 'activo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "navia.integracoes" */
export type Navia_Integracoes_Set_Input = {
  activo?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Integracoes_Stddev_Fields = {
  __typename?: 'navia_integracoes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Integracoes_Stddev_Pop_Fields = {
  __typename?: 'navia_integracoes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Integracoes_Stddev_Samp_Fields = {
  __typename?: 'navia_integracoes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_integracoes" */
export type Navia_Integracoes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Integracoes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Integracoes_Stream_Cursor_Value_Input = {
  activo?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Integracoes_Sum_Fields = {
  __typename?: 'navia_integracoes_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia.integracoes" */
export enum Navia_Integracoes_Update_Column {
  /** column name */
  Activo = 'activo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Navia_Integracoes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Integracoes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Integracoes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Integracoes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Integracoes_Var_Pop_Fields = {
  __typename?: 'navia_integracoes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Integracoes_Var_Samp_Fields = {
  __typename?: 'navia_integracoes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Integracoes_Variance_Fields = {
  __typename?: 'navia_integracoes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "navia.log" */
export type Navia_Log = {
  __typename?: 'navia_log';
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  id_modulo?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "navia.log" */
export type Navia_Log_Aggregate = {
  __typename?: 'navia_log_aggregate';
  aggregate?: Maybe<Navia_Log_Aggregate_Fields>;
  nodes: Array<Navia_Log>;
};

/** aggregate fields of "navia.log" */
export type Navia_Log_Aggregate_Fields = {
  __typename?: 'navia_log_aggregate_fields';
  avg?: Maybe<Navia_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Navia_Log_Max_Fields>;
  min?: Maybe<Navia_Log_Min_Fields>;
  stddev?: Maybe<Navia_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Navia_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Navia_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Navia_Log_Sum_Fields>;
  var_pop?: Maybe<Navia_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Navia_Log_Var_Samp_Fields>;
  variance?: Maybe<Navia_Log_Variance_Fields>;
};


/** aggregate fields of "navia.log" */
export type Navia_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Navia_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Navia_Log_Avg_Fields = {
  __typename?: 'navia_log_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "navia.log". All fields are combined with a logical 'AND'. */
export type Navia_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Navia_Log_Bool_Exp>>;
  _not?: InputMaybe<Navia_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Navia_Log_Bool_Exp>>;
  data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_modulo?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "navia.log" */
export enum Navia_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  LogPkey = 'log_pkey'
}

/** input type for incrementing numeric columns in table "navia.log" */
export type Navia_Log_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_modulo?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "navia.log" */
export type Navia_Log_Insert_Input = {
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_modulo?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Navia_Log_Max_Fields = {
  __typename?: 'navia_log_max_fields';
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_modulo?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Navia_Log_Min_Fields = {
  __typename?: 'navia_log_min_fields';
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_modulo?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "navia.log" */
export type Navia_Log_Mutation_Response = {
  __typename?: 'navia_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Navia_Log>;
};

/** on_conflict condition type for table "navia.log" */
export type Navia_Log_On_Conflict = {
  constraint: Navia_Log_Constraint;
  update_columns?: Array<Navia_Log_Update_Column>;
  where?: InputMaybe<Navia_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "navia.log". */
export type Navia_Log_Order_By = {
  data_hora?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_modulo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** primary key columns input for table: navia.log */
export type Navia_Log_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "navia.log" */
export enum Navia_Log_Select_Column {
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdModulo = 'id_modulo',
  /** column name */
  IdUtilizador = 'id_utilizador'
}

/** input type for updating data in table "navia.log" */
export type Navia_Log_Set_Input = {
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_modulo?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Navia_Log_Stddev_Fields = {
  __typename?: 'navia_log_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Navia_Log_Stddev_Pop_Fields = {
  __typename?: 'navia_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Navia_Log_Stddev_Samp_Fields = {
  __typename?: 'navia_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "navia_log" */
export type Navia_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Navia_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Navia_Log_Stream_Cursor_Value_Input = {
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_modulo?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Navia_Log_Sum_Fields = {
  __typename?: 'navia_log_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_modulo?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "navia.log" */
export enum Navia_Log_Update_Column {
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdModulo = 'id_modulo',
  /** column name */
  IdUtilizador = 'id_utilizador'
}

export type Navia_Log_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Navia_Log_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Navia_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Navia_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Navia_Log_Var_Pop_Fields = {
  __typename?: 'navia_log_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Navia_Log_Var_Samp_Fields = {
  __typename?: 'navia_log_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Navia_Log_Variance_Fields = {
  __typename?: 'navia_log_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** network_integrityNative Query Arguments */
export type Network_Integrity_Arguments = {
  endDate: Scalars['timestamptz']['input'];
  startDate: Scalars['timestamptz']['input'];
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

export type Network_Integrity_Model = {
  __typename?: 'network_integrity_model';
  interv_count: Scalars['numeric']['output'];
  network_integrity: Scalars['numeric']['output'];
  pipes_count: Scalars['bigint']['output'];
};

/** Boolean expression to filter rows from the logical model for "network_integrity_model". All fields are combined with a logical 'AND'. */
export type Network_Integrity_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Network_Integrity_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Network_Integrity_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Network_Integrity_Model_Bool_Exp_Bool_Exp>>;
  interv_count?: InputMaybe<Numeric_Comparison_Exp>;
  network_integrity?: InputMaybe<Numeric_Comparison_Exp>;
  pipes_count?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Network_Integrity_Model_Enum_Name {
  /** column name */
  IntervCount = 'interv_count',
  /** column name */
  NetworkIntegrity = 'network_integrity',
  /** column name */
  PipesCount = 'pipes_count'
}

/** Ordering options when selecting data from "network_integrity_model". */
export type Network_Integrity_Model_Order_By = {
  interv_count?: InputMaybe<Order_By>;
  network_integrity?: InputMaybe<Order_By>;
  pipes_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "notificacoes.itens" */
export type Notificacoes_Itens = {
  __typename?: 'notificacoes_itens';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  frequencia?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  id_tipo?: Maybe<Scalars['bigint']['output']>;
  parametrizavel_eq_virtuais?: Maybe<Scalars['Boolean']['output']>;
  parametrizavel_frequencia?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  tipo?: Maybe<Notificacoes_Tipos>;
};

/** aggregated selection of "notificacoes.itens" */
export type Notificacoes_Itens_Aggregate = {
  __typename?: 'notificacoes_itens_aggregate';
  aggregate?: Maybe<Notificacoes_Itens_Aggregate_Fields>;
  nodes: Array<Notificacoes_Itens>;
};

export type Notificacoes_Itens_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Notificacoes_Itens_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Notificacoes_Itens_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Notificacoes_Itens_Aggregate_Bool_Exp_Count>;
};

export type Notificacoes_Itens_Aggregate_Bool_Exp_Bool_And = {
  arguments: Notificacoes_Itens_Select_Column_Notificacoes_Itens_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Notificacoes_Itens_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Notificacoes_Itens_Select_Column_Notificacoes_Itens_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Notificacoes_Itens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notificacoes_Itens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notificacoes.itens" */
export type Notificacoes_Itens_Aggregate_Fields = {
  __typename?: 'notificacoes_itens_aggregate_fields';
  avg?: Maybe<Notificacoes_Itens_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Notificacoes_Itens_Max_Fields>;
  min?: Maybe<Notificacoes_Itens_Min_Fields>;
  stddev?: Maybe<Notificacoes_Itens_Stddev_Fields>;
  stddev_pop?: Maybe<Notificacoes_Itens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notificacoes_Itens_Stddev_Samp_Fields>;
  sum?: Maybe<Notificacoes_Itens_Sum_Fields>;
  var_pop?: Maybe<Notificacoes_Itens_Var_Pop_Fields>;
  var_samp?: Maybe<Notificacoes_Itens_Var_Samp_Fields>;
  variance?: Maybe<Notificacoes_Itens_Variance_Fields>;
};


/** aggregate fields of "notificacoes.itens" */
export type Notificacoes_Itens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notificacoes_Itens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notificacoes.itens" */
export type Notificacoes_Itens_Aggregate_Order_By = {
  avg?: InputMaybe<Notificacoes_Itens_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notificacoes_Itens_Max_Order_By>;
  min?: InputMaybe<Notificacoes_Itens_Min_Order_By>;
  stddev?: InputMaybe<Notificacoes_Itens_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Notificacoes_Itens_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Notificacoes_Itens_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Notificacoes_Itens_Sum_Order_By>;
  var_pop?: InputMaybe<Notificacoes_Itens_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Notificacoes_Itens_Var_Samp_Order_By>;
  variance?: InputMaybe<Notificacoes_Itens_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notificacoes.itens" */
export type Notificacoes_Itens_Arr_Rel_Insert_Input = {
  data: Array<Notificacoes_Itens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notificacoes_Itens_On_Conflict>;
};

/** aggregate avg on columns */
export type Notificacoes_Itens_Avg_Fields = {
  __typename?: 'notificacoes_itens_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "notificacoes.itens" */
export type Notificacoes_Itens_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notificacoes.itens". All fields are combined with a logical 'AND'. */
export type Notificacoes_Itens_Bool_Exp = {
  _and?: InputMaybe<Array<Notificacoes_Itens_Bool_Exp>>;
  _not?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
  _or?: InputMaybe<Array<Notificacoes_Itens_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  frequencia?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo?: InputMaybe<Bigint_Comparison_Exp>;
  parametrizavel_eq_virtuais?: InputMaybe<Boolean_Comparison_Exp>;
  parametrizavel_frequencia?: InputMaybe<Boolean_Comparison_Exp>;
  tipo?: InputMaybe<Notificacoes_Tipos_Bool_Exp>;
};

/** unique or primary key constraints on table "notificacoes.itens" */
export enum Notificacoes_Itens_Constraint {
  /** unique or primary key constraint on columns "id" */
  ItensPkey = 'itens_pkey'
}

/** input type for incrementing numeric columns in table "notificacoes.itens" */
export type Notificacoes_Itens_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "notificacoes.itens" */
export type Notificacoes_Itens_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  frequencia?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo?: InputMaybe<Scalars['bigint']['input']>;
  parametrizavel_eq_virtuais?: InputMaybe<Scalars['Boolean']['input']>;
  parametrizavel_frequencia?: InputMaybe<Scalars['Boolean']['input']>;
  tipo?: InputMaybe<Notificacoes_Tipos_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Notificacoes_Itens_Max_Fields = {
  __typename?: 'notificacoes_itens_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  frequencia?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_tipo?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "notificacoes.itens" */
export type Notificacoes_Itens_Max_Order_By = {
  descricao?: InputMaybe<Order_By>;
  frequencia?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notificacoes_Itens_Min_Fields = {
  __typename?: 'notificacoes_itens_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  frequencia?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_tipo?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "notificacoes.itens" */
export type Notificacoes_Itens_Min_Order_By = {
  descricao?: InputMaybe<Order_By>;
  frequencia?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notificacoes.itens" */
export type Notificacoes_Itens_Mutation_Response = {
  __typename?: 'notificacoes_itens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notificacoes_Itens>;
};

/** input type for inserting object relation for remote table "notificacoes.itens" */
export type Notificacoes_Itens_Obj_Rel_Insert_Input = {
  data: Notificacoes_Itens_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Notificacoes_Itens_On_Conflict>;
};

/** on_conflict condition type for table "notificacoes.itens" */
export type Notificacoes_Itens_On_Conflict = {
  constraint: Notificacoes_Itens_Constraint;
  update_columns?: Array<Notificacoes_Itens_Update_Column>;
  where?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
};

/** Ordering options when selecting data from "notificacoes.itens". */
export type Notificacoes_Itens_Order_By = {
  apagado?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  frequencia?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  parametrizavel_eq_virtuais?: InputMaybe<Order_By>;
  parametrizavel_frequencia?: InputMaybe<Order_By>;
  tipo?: InputMaybe<Notificacoes_Tipos_Order_By>;
};

/** primary key columns input for table: notificacoes.itens */
export type Notificacoes_Itens_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "notificacoes.itens" */
export enum Notificacoes_Itens_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Frequencia = 'frequencia',
  /** column name */
  Id = 'id',
  /** column name */
  IdTipo = 'id_tipo',
  /** column name */
  ParametrizavelEqVirtuais = 'parametrizavel_eq_virtuais',
  /** column name */
  ParametrizavelFrequencia = 'parametrizavel_frequencia'
}

/** select "notificacoes_itens_aggregate_bool_exp_bool_and_arguments_columns" columns of table "notificacoes.itens" */
export enum Notificacoes_Itens_Select_Column_Notificacoes_Itens_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  ParametrizavelEqVirtuais = 'parametrizavel_eq_virtuais',
  /** column name */
  ParametrizavelFrequencia = 'parametrizavel_frequencia'
}

/** select "notificacoes_itens_aggregate_bool_exp_bool_or_arguments_columns" columns of table "notificacoes.itens" */
export enum Notificacoes_Itens_Select_Column_Notificacoes_Itens_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  ParametrizavelEqVirtuais = 'parametrizavel_eq_virtuais',
  /** column name */
  ParametrizavelFrequencia = 'parametrizavel_frequencia'
}

/** input type for updating data in table "notificacoes.itens" */
export type Notificacoes_Itens_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  frequencia?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo?: InputMaybe<Scalars['bigint']['input']>;
  parametrizavel_eq_virtuais?: InputMaybe<Scalars['Boolean']['input']>;
  parametrizavel_frequencia?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Notificacoes_Itens_Stddev_Fields = {
  __typename?: 'notificacoes_itens_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "notificacoes.itens" */
export type Notificacoes_Itens_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Notificacoes_Itens_Stddev_Pop_Fields = {
  __typename?: 'notificacoes_itens_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "notificacoes.itens" */
export type Notificacoes_Itens_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Notificacoes_Itens_Stddev_Samp_Fields = {
  __typename?: 'notificacoes_itens_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "notificacoes.itens" */
export type Notificacoes_Itens_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notificacoes_itens" */
export type Notificacoes_Itens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notificacoes_Itens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notificacoes_Itens_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  frequencia?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo?: InputMaybe<Scalars['bigint']['input']>;
  parametrizavel_eq_virtuais?: InputMaybe<Scalars['Boolean']['input']>;
  parametrizavel_frequencia?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Notificacoes_Itens_Sum_Fields = {
  __typename?: 'notificacoes_itens_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_tipo?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "notificacoes.itens" */
export type Notificacoes_Itens_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
};

/** update columns of table "notificacoes.itens" */
export enum Notificacoes_Itens_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Frequencia = 'frequencia',
  /** column name */
  Id = 'id',
  /** column name */
  IdTipo = 'id_tipo',
  /** column name */
  ParametrizavelEqVirtuais = 'parametrizavel_eq_virtuais',
  /** column name */
  ParametrizavelFrequencia = 'parametrizavel_frequencia'
}

export type Notificacoes_Itens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notificacoes_Itens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notificacoes_Itens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notificacoes_Itens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notificacoes_Itens_Var_Pop_Fields = {
  __typename?: 'notificacoes_itens_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "notificacoes.itens" */
export type Notificacoes_Itens_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Notificacoes_Itens_Var_Samp_Fields = {
  __typename?: 'notificacoes_itens_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "notificacoes.itens" */
export type Notificacoes_Itens_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Notificacoes_Itens_Variance_Fields = {
  __typename?: 'notificacoes_itens_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "notificacoes.itens" */
export type Notificacoes_Itens_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
};

/** columns and relationships of "notificacoes.notificacoes" */
export type Notificacoes_Notificacoes = {
  __typename?: 'notificacoes_notificacoes';
  assunto?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  corpo?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd: Scalars['timestamp']['output'];
  data_silencio?: Maybe<Scalars['timestamp']['output']>;
  enviada_mail?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  id_alarme?: Maybe<Scalars['bigint']['output']>;
  id_amostra?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_item?: Maybe<Scalars['bigint']['output']>;
  id_movimento?: Maybe<Scalars['bigint']['output']>;
  id_obra_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['bigint']['output']>;
  id_ordem_compra_item?: Maybe<Scalars['bigint']['output']>;
  id_pedido?: Maybe<Scalars['bigint']['output']>;
  id_plano_controlo_versao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  item?: Maybe<Notificacoes_Itens>;
  /** An array relationship */
  notificacaoUtilizadores: Array<Notificacoes_Notificacoes_R_Utilizadores>;
  /** An aggregate relationship */
  notificacaoUtilizadores_aggregate: Notificacoes_Notificacoes_R_Utilizadores_Aggregate;
  residuos_id_guia?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_matricula?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_operador?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_transporte?: Maybe<Scalars['bigint']['output']>;
  residuos_id_pedido_transporte?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "notificacoes.notificacoes" */
export type Notificacoes_NotificacoesNotificacaoUtilizadoresArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
};


/** columns and relationships of "notificacoes.notificacoes" */
export type Notificacoes_NotificacoesNotificacaoUtilizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
};

/** aggregated selection of "notificacoes.notificacoes" */
export type Notificacoes_Notificacoes_Aggregate = {
  __typename?: 'notificacoes_notificacoes_aggregate';
  aggregate?: Maybe<Notificacoes_Notificacoes_Aggregate_Fields>;
  nodes: Array<Notificacoes_Notificacoes>;
};

/** aggregate fields of "notificacoes.notificacoes" */
export type Notificacoes_Notificacoes_Aggregate_Fields = {
  __typename?: 'notificacoes_notificacoes_aggregate_fields';
  avg?: Maybe<Notificacoes_Notificacoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Notificacoes_Notificacoes_Max_Fields>;
  min?: Maybe<Notificacoes_Notificacoes_Min_Fields>;
  stddev?: Maybe<Notificacoes_Notificacoes_Stddev_Fields>;
  stddev_pop?: Maybe<Notificacoes_Notificacoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notificacoes_Notificacoes_Stddev_Samp_Fields>;
  sum?: Maybe<Notificacoes_Notificacoes_Sum_Fields>;
  var_pop?: Maybe<Notificacoes_Notificacoes_Var_Pop_Fields>;
  var_samp?: Maybe<Notificacoes_Notificacoes_Var_Samp_Fields>;
  variance?: Maybe<Notificacoes_Notificacoes_Variance_Fields>;
};


/** aggregate fields of "notificacoes.notificacoes" */
export type Notificacoes_Notificacoes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notificacoes_Notificacoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Notificacoes_Notificacoes_Avg_Fields = {
  __typename?: 'notificacoes_notificacoes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_alarme?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_item?: Maybe<Scalars['Float']['output']>;
  id_movimento?: Maybe<Scalars['Float']['output']>;
  id_obra_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_ordem_compra_item?: Maybe<Scalars['Float']['output']>;
  id_pedido?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_versao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  residuos_id_guia?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_matricula?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_operador?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_transporte?: Maybe<Scalars['Float']['output']>;
  residuos_id_pedido_transporte?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "notificacoes.notificacoes". All fields are combined with a logical 'AND'. */
export type Notificacoes_Notificacoes_Bool_Exp = {
  _and?: InputMaybe<Array<Notificacoes_Notificacoes_Bool_Exp>>;
  _not?: InputMaybe<Notificacoes_Notificacoes_Bool_Exp>;
  _or?: InputMaybe<Array<Notificacoes_Notificacoes_Bool_Exp>>;
  assunto?: InputMaybe<String_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  corpo?: InputMaybe<String_Comparison_Exp>;
  data?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_registo_bd?: InputMaybe<Timestamp_Comparison_Exp>;
  data_silencio?: InputMaybe<Timestamp_Comparison_Exp>;
  enviada_mail?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_alarme?: InputMaybe<Bigint_Comparison_Exp>;
  id_amostra?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_intervencao?: InputMaybe<Bigint_Comparison_Exp>;
  id_item?: InputMaybe<Bigint_Comparison_Exp>;
  id_movimento?: InputMaybe<Bigint_Comparison_Exp>;
  id_obra_sinalizacao?: InputMaybe<Bigint_Comparison_Exp>;
  id_ocorrencia?: InputMaybe<Bigint_Comparison_Exp>;
  id_ocorrencia_naviacity?: InputMaybe<Bigint_Comparison_Exp>;
  id_ordem_compra_item?: InputMaybe<Bigint_Comparison_Exp>;
  id_pedido?: InputMaybe<Bigint_Comparison_Exp>;
  id_plano_controlo_versao?: InputMaybe<Bigint_Comparison_Exp>;
  id_tarefa?: InputMaybe<Bigint_Comparison_Exp>;
  id_toponimia?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  item?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
  notificacaoUtilizadores?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
  notificacaoUtilizadores_aggregate?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp>;
  residuos_id_guia?: InputMaybe<Bigint_Comparison_Exp>;
  residuos_id_licenca_matricula?: InputMaybe<Bigint_Comparison_Exp>;
  residuos_id_licenca_operador?: InputMaybe<Bigint_Comparison_Exp>;
  residuos_id_licenca_transporte?: InputMaybe<Bigint_Comparison_Exp>;
  residuos_id_pedido_transporte?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "notificacoes.notificacoes" */
export enum Notificacoes_Notificacoes_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificacoesPkey = 'notificacoes_pkey'
}

/** input type for incrementing numeric columns in table "notificacoes.notificacoes" */
export type Notificacoes_Notificacoes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_alarme?: InputMaybe<Scalars['bigint']['input']>;
  id_amostra?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_item?: InputMaybe<Scalars['bigint']['input']>;
  id_movimento?: InputMaybe<Scalars['bigint']['input']>;
  id_obra_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia_naviacity?: InputMaybe<Scalars['bigint']['input']>;
  id_ordem_compra_item?: InputMaybe<Scalars['bigint']['input']>;
  id_pedido?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_controlo_versao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_guia?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_matricula?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_operador?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_transporte?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_pedido_transporte?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "notificacoes.notificacoes" */
export type Notificacoes_Notificacoes_Insert_Input = {
  assunto?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  corpo?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_silencio?: InputMaybe<Scalars['timestamp']['input']>;
  enviada_mail?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_alarme?: InputMaybe<Scalars['bigint']['input']>;
  id_amostra?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_item?: InputMaybe<Scalars['bigint']['input']>;
  id_movimento?: InputMaybe<Scalars['bigint']['input']>;
  id_obra_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia_naviacity?: InputMaybe<Scalars['bigint']['input']>;
  id_ordem_compra_item?: InputMaybe<Scalars['bigint']['input']>;
  id_pedido?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_controlo_versao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  item?: InputMaybe<Notificacoes_Itens_Obj_Rel_Insert_Input>;
  notificacaoUtilizadores?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Arr_Rel_Insert_Input>;
  residuos_id_guia?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_matricula?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_operador?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_transporte?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_pedido_transporte?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Notificacoes_Notificacoes_Max_Fields = {
  __typename?: 'notificacoes_notificacoes_max_fields';
  assunto?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  corpo?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_silencio?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_alarme?: Maybe<Scalars['bigint']['output']>;
  id_amostra?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_item?: Maybe<Scalars['bigint']['output']>;
  id_movimento?: Maybe<Scalars['bigint']['output']>;
  id_obra_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['bigint']['output']>;
  id_ordem_compra_item?: Maybe<Scalars['bigint']['output']>;
  id_pedido?: Maybe<Scalars['bigint']['output']>;
  id_plano_controlo_versao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  residuos_id_guia?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_matricula?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_operador?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_transporte?: Maybe<Scalars['bigint']['output']>;
  residuos_id_pedido_transporte?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Notificacoes_Notificacoes_Min_Fields = {
  __typename?: 'notificacoes_notificacoes_min_fields';
  assunto?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  corpo?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_silencio?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_alarme?: Maybe<Scalars['bigint']['output']>;
  id_amostra?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_item?: Maybe<Scalars['bigint']['output']>;
  id_movimento?: Maybe<Scalars['bigint']['output']>;
  id_obra_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['bigint']['output']>;
  id_ordem_compra_item?: Maybe<Scalars['bigint']['output']>;
  id_pedido?: Maybe<Scalars['bigint']['output']>;
  id_plano_controlo_versao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  residuos_id_guia?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_matricula?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_operador?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_transporte?: Maybe<Scalars['bigint']['output']>;
  residuos_id_pedido_transporte?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "notificacoes.notificacoes" */
export type Notificacoes_Notificacoes_Mutation_Response = {
  __typename?: 'notificacoes_notificacoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notificacoes_Notificacoes>;
};

/** on_conflict condition type for table "notificacoes.notificacoes" */
export type Notificacoes_Notificacoes_On_Conflict = {
  constraint: Notificacoes_Notificacoes_Constraint;
  update_columns?: Array<Notificacoes_Notificacoes_Update_Column>;
  where?: InputMaybe<Notificacoes_Notificacoes_Bool_Exp>;
};

/** Ordering options when selecting data from "notificacoes.notificacoes". */
export type Notificacoes_Notificacoes_Order_By = {
  assunto?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  corpo?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_silencio?: InputMaybe<Order_By>;
  enviada_mail?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_alarme?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_item?: InputMaybe<Order_By>;
  id_movimento?: InputMaybe<Order_By>;
  id_obra_sinalizacao?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_ocorrencia_naviacity?: InputMaybe<Order_By>;
  id_ordem_compra_item?: InputMaybe<Order_By>;
  id_pedido?: InputMaybe<Order_By>;
  id_plano_controlo_versao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  item?: InputMaybe<Notificacoes_Itens_Order_By>;
  notificacaoUtilizadores_aggregate?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Order_By>;
  residuos_id_guia?: InputMaybe<Order_By>;
  residuos_id_licenca_matricula?: InputMaybe<Order_By>;
  residuos_id_licenca_operador?: InputMaybe<Order_By>;
  residuos_id_licenca_transporte?: InputMaybe<Order_By>;
  residuos_id_pedido_transporte?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notificacoes.notificacoes */
export type Notificacoes_Notificacoes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores';
  id: Scalars['bigint']['output'];
  id_notificacao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  lida?: Maybe<Scalars['Boolean']['output']>;
  nova?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Aggregate = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_aggregate';
  aggregate?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Fields>;
  nodes: Array<Notificacoes_Notificacoes_R_Utilizadores>;
};

export type Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp_Count>;
};

export type Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp_Bool_And = {
  arguments: Notificacoes_Notificacoes_R_Utilizadores_Select_Column_Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Notificacoes_Notificacoes_R_Utilizadores_Select_Column_Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Fields = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_aggregate_fields';
  avg?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Max_Fields>;
  min?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Min_Fields>;
  stddev?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Stddev_Fields>;
  stddev_pop?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Stddev_Samp_Fields>;
  sum?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Sum_Fields>;
  var_pop?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Var_Pop_Fields>;
  var_samp?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Var_Samp_Fields>;
  variance?: Maybe<Notificacoes_Notificacoes_R_Utilizadores_Variance_Fields>;
};


/** aggregate fields of "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Order_By = {
  avg?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Max_Order_By>;
  min?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Min_Order_By>;
  stddev?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Sum_Order_By>;
  var_pop?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Var_Samp_Order_By>;
  variance?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Arr_Rel_Insert_Input = {
  data: Array<Notificacoes_Notificacoes_R_Utilizadores_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_On_Conflict>;
};

/** aggregate avg on columns */
export type Notificacoes_Notificacoes_R_Utilizadores_Avg_Fields = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_notificacao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_notificacao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notificacoes.notificacoes_r_utilizadores". All fields are combined with a logical 'AND'. */
export type Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp = {
  _and?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>>;
  _not?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
  _or?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_notificacao?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  lida?: InputMaybe<Boolean_Comparison_Exp>;
  nova?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "notificacoes.notificacoes_r_utilizadores" */
export enum Notificacoes_Notificacoes_R_Utilizadores_Constraint {
  /** unique or primary key constraint on columns "id" */
  RNotificacoesUtilizadoresPkey = 'r_notificacoes_utilizadores_pkey'
}

/** input type for incrementing numeric columns in table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_notificacao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_notificacao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  lida?: InputMaybe<Scalars['Boolean']['input']>;
  nova?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Notificacoes_Notificacoes_R_Utilizadores_Max_Fields = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_notificacao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_notificacao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notificacoes_Notificacoes_R_Utilizadores_Min_Fields = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_notificacao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_notificacao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Mutation_Response = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notificacoes_Notificacoes_R_Utilizadores>;
};

/** on_conflict condition type for table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_On_Conflict = {
  constraint: Notificacoes_Notificacoes_R_Utilizadores_Constraint;
  update_columns?: Array<Notificacoes_Notificacoes_R_Utilizadores_Update_Column>;
  where?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
};

/** Ordering options when selecting data from "notificacoes.notificacoes_r_utilizadores". */
export type Notificacoes_Notificacoes_R_Utilizadores_Order_By = {
  id?: InputMaybe<Order_By>;
  id_notificacao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  lida?: InputMaybe<Order_By>;
  nova?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notificacoes.notificacoes_r_utilizadores */
export type Notificacoes_Notificacoes_R_Utilizadores_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "notificacoes.notificacoes_r_utilizadores" */
export enum Notificacoes_Notificacoes_R_Utilizadores_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdNotificacao = 'id_notificacao',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  Lida = 'lida',
  /** column name */
  Nova = 'nova'
}

/** select "notificacoes_notificacoes_r_utilizadores_aggregate_bool_exp_bool_and_arguments_columns" columns of table "notificacoes.notificacoes_r_utilizadores" */
export enum Notificacoes_Notificacoes_R_Utilizadores_Select_Column_Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Lida = 'lida',
  /** column name */
  Nova = 'nova'
}

/** select "notificacoes_notificacoes_r_utilizadores_aggregate_bool_exp_bool_or_arguments_columns" columns of table "notificacoes.notificacoes_r_utilizadores" */
export enum Notificacoes_Notificacoes_R_Utilizadores_Select_Column_Notificacoes_Notificacoes_R_Utilizadores_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Lida = 'lida',
  /** column name */
  Nova = 'nova'
}

/** input type for updating data in table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_notificacao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  lida?: InputMaybe<Scalars['Boolean']['input']>;
  nova?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Notificacoes_Notificacoes_R_Utilizadores_Stddev_Fields = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_notificacao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_notificacao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Notificacoes_Notificacoes_R_Utilizadores_Stddev_Pop_Fields = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_notificacao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_notificacao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Notificacoes_Notificacoes_R_Utilizadores_Stddev_Samp_Fields = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_notificacao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_notificacao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notificacoes_notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notificacoes_Notificacoes_R_Utilizadores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notificacoes_Notificacoes_R_Utilizadores_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_notificacao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  lida?: InputMaybe<Scalars['Boolean']['input']>;
  nova?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Notificacoes_Notificacoes_R_Utilizadores_Sum_Fields = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_notificacao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_notificacao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** update columns of table "notificacoes.notificacoes_r_utilizadores" */
export enum Notificacoes_Notificacoes_R_Utilizadores_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdNotificacao = 'id_notificacao',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  Lida = 'lida',
  /** column name */
  Nova = 'nova'
}

export type Notificacoes_Notificacoes_R_Utilizadores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notificacoes_Notificacoes_R_Utilizadores_Var_Pop_Fields = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_notificacao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_notificacao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Notificacoes_Notificacoes_R_Utilizadores_Var_Samp_Fields = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_notificacao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_notificacao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Notificacoes_Notificacoes_R_Utilizadores_Variance_Fields = {
  __typename?: 'notificacoes_notificacoes_r_utilizadores_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_notificacao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "notificacoes.notificacoes_r_utilizadores" */
export type Notificacoes_Notificacoes_R_Utilizadores_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_notificacao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** select columns of table "notificacoes.notificacoes" */
export enum Notificacoes_Notificacoes_Select_Column {
  /** column name */
  Assunto = 'assunto',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Corpo = 'corpo',
  /** column name */
  Data = 'data',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataSilencio = 'data_silencio',
  /** column name */
  EnviadaMail = 'enviada_mail',
  /** column name */
  Id = 'id',
  /** column name */
  IdAlarme = 'id_alarme',
  /** column name */
  IdAmostra = 'id_amostra',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdItem = 'id_item',
  /** column name */
  IdMovimento = 'id_movimento',
  /** column name */
  IdObraSinalizacao = 'id_obra_sinalizacao',
  /** column name */
  IdOcorrencia = 'id_ocorrencia',
  /** column name */
  IdOcorrenciaNaviacity = 'id_ocorrencia_naviacity',
  /** column name */
  IdOrdemCompraItem = 'id_ordem_compra_item',
  /** column name */
  IdPedido = 'id_pedido',
  /** column name */
  IdPlanoControloVersao = 'id_plano_controlo_versao',
  /** column name */
  IdTarefa = 'id_tarefa',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  ResiduosIdGuia = 'residuos_id_guia',
  /** column name */
  ResiduosIdLicencaMatricula = 'residuos_id_licenca_matricula',
  /** column name */
  ResiduosIdLicencaOperador = 'residuos_id_licenca_operador',
  /** column name */
  ResiduosIdLicencaTransporte = 'residuos_id_licenca_transporte',
  /** column name */
  ResiduosIdPedidoTransporte = 'residuos_id_pedido_transporte'
}

/** input type for updating data in table "notificacoes.notificacoes" */
export type Notificacoes_Notificacoes_Set_Input = {
  assunto?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  corpo?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_silencio?: InputMaybe<Scalars['timestamp']['input']>;
  enviada_mail?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_alarme?: InputMaybe<Scalars['bigint']['input']>;
  id_amostra?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_item?: InputMaybe<Scalars['bigint']['input']>;
  id_movimento?: InputMaybe<Scalars['bigint']['input']>;
  id_obra_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia_naviacity?: InputMaybe<Scalars['bigint']['input']>;
  id_ordem_compra_item?: InputMaybe<Scalars['bigint']['input']>;
  id_pedido?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_controlo_versao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_guia?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_matricula?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_operador?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_transporte?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_pedido_transporte?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Notificacoes_Notificacoes_Stddev_Fields = {
  __typename?: 'notificacoes_notificacoes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_alarme?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_item?: Maybe<Scalars['Float']['output']>;
  id_movimento?: Maybe<Scalars['Float']['output']>;
  id_obra_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_ordem_compra_item?: Maybe<Scalars['Float']['output']>;
  id_pedido?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_versao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  residuos_id_guia?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_matricula?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_operador?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_transporte?: Maybe<Scalars['Float']['output']>;
  residuos_id_pedido_transporte?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Notificacoes_Notificacoes_Stddev_Pop_Fields = {
  __typename?: 'notificacoes_notificacoes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_alarme?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_item?: Maybe<Scalars['Float']['output']>;
  id_movimento?: Maybe<Scalars['Float']['output']>;
  id_obra_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_ordem_compra_item?: Maybe<Scalars['Float']['output']>;
  id_pedido?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_versao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  residuos_id_guia?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_matricula?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_operador?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_transporte?: Maybe<Scalars['Float']['output']>;
  residuos_id_pedido_transporte?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Notificacoes_Notificacoes_Stddev_Samp_Fields = {
  __typename?: 'notificacoes_notificacoes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_alarme?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_item?: Maybe<Scalars['Float']['output']>;
  id_movimento?: Maybe<Scalars['Float']['output']>;
  id_obra_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_ordem_compra_item?: Maybe<Scalars['Float']['output']>;
  id_pedido?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_versao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  residuos_id_guia?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_matricula?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_operador?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_transporte?: Maybe<Scalars['Float']['output']>;
  residuos_id_pedido_transporte?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "notificacoes_notificacoes" */
export type Notificacoes_Notificacoes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notificacoes_Notificacoes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notificacoes_Notificacoes_Stream_Cursor_Value_Input = {
  assunto?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  corpo?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_silencio?: InputMaybe<Scalars['timestamp']['input']>;
  enviada_mail?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_alarme?: InputMaybe<Scalars['bigint']['input']>;
  id_amostra?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_item?: InputMaybe<Scalars['bigint']['input']>;
  id_movimento?: InputMaybe<Scalars['bigint']['input']>;
  id_obra_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia_naviacity?: InputMaybe<Scalars['bigint']['input']>;
  id_ordem_compra_item?: InputMaybe<Scalars['bigint']['input']>;
  id_pedido?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_controlo_versao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_guia?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_matricula?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_operador?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_licenca_transporte?: InputMaybe<Scalars['bigint']['input']>;
  residuos_id_pedido_transporte?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Notificacoes_Notificacoes_Sum_Fields = {
  __typename?: 'notificacoes_notificacoes_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_alarme?: Maybe<Scalars['bigint']['output']>;
  id_amostra?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_item?: Maybe<Scalars['bigint']['output']>;
  id_movimento?: Maybe<Scalars['bigint']['output']>;
  id_obra_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['bigint']['output']>;
  id_ordem_compra_item?: Maybe<Scalars['bigint']['output']>;
  id_pedido?: Maybe<Scalars['bigint']['output']>;
  id_plano_controlo_versao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  residuos_id_guia?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_matricula?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_operador?: Maybe<Scalars['bigint']['output']>;
  residuos_id_licenca_transporte?: Maybe<Scalars['bigint']['output']>;
  residuos_id_pedido_transporte?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "notificacoes.notificacoes" */
export enum Notificacoes_Notificacoes_Update_Column {
  /** column name */
  Assunto = 'assunto',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Corpo = 'corpo',
  /** column name */
  Data = 'data',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataSilencio = 'data_silencio',
  /** column name */
  EnviadaMail = 'enviada_mail',
  /** column name */
  Id = 'id',
  /** column name */
  IdAlarme = 'id_alarme',
  /** column name */
  IdAmostra = 'id_amostra',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdItem = 'id_item',
  /** column name */
  IdMovimento = 'id_movimento',
  /** column name */
  IdObraSinalizacao = 'id_obra_sinalizacao',
  /** column name */
  IdOcorrencia = 'id_ocorrencia',
  /** column name */
  IdOcorrenciaNaviacity = 'id_ocorrencia_naviacity',
  /** column name */
  IdOrdemCompraItem = 'id_ordem_compra_item',
  /** column name */
  IdPedido = 'id_pedido',
  /** column name */
  IdPlanoControloVersao = 'id_plano_controlo_versao',
  /** column name */
  IdTarefa = 'id_tarefa',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  ResiduosIdGuia = 'residuos_id_guia',
  /** column name */
  ResiduosIdLicencaMatricula = 'residuos_id_licenca_matricula',
  /** column name */
  ResiduosIdLicencaOperador = 'residuos_id_licenca_operador',
  /** column name */
  ResiduosIdLicencaTransporte = 'residuos_id_licenca_transporte',
  /** column name */
  ResiduosIdPedidoTransporte = 'residuos_id_pedido_transporte'
}

export type Notificacoes_Notificacoes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notificacoes_Notificacoes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notificacoes_Notificacoes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notificacoes_Notificacoes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notificacoes_Notificacoes_Var_Pop_Fields = {
  __typename?: 'notificacoes_notificacoes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_alarme?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_item?: Maybe<Scalars['Float']['output']>;
  id_movimento?: Maybe<Scalars['Float']['output']>;
  id_obra_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_ordem_compra_item?: Maybe<Scalars['Float']['output']>;
  id_pedido?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_versao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  residuos_id_guia?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_matricula?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_operador?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_transporte?: Maybe<Scalars['Float']['output']>;
  residuos_id_pedido_transporte?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Notificacoes_Notificacoes_Var_Samp_Fields = {
  __typename?: 'notificacoes_notificacoes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_alarme?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_item?: Maybe<Scalars['Float']['output']>;
  id_movimento?: Maybe<Scalars['Float']['output']>;
  id_obra_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_ordem_compra_item?: Maybe<Scalars['Float']['output']>;
  id_pedido?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_versao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  residuos_id_guia?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_matricula?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_operador?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_transporte?: Maybe<Scalars['Float']['output']>;
  residuos_id_pedido_transporte?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Notificacoes_Notificacoes_Variance_Fields = {
  __typename?: 'notificacoes_notificacoes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_alarme?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_item?: Maybe<Scalars['Float']['output']>;
  id_movimento?: Maybe<Scalars['Float']['output']>;
  id_obra_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia_naviacity?: Maybe<Scalars['Float']['output']>;
  id_ordem_compra_item?: Maybe<Scalars['Float']['output']>;
  id_pedido?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_versao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  residuos_id_guia?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_matricula?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_operador?: Maybe<Scalars['Float']['output']>;
  residuos_id_licenca_transporte?: Maybe<Scalars['Float']['output']>;
  residuos_id_pedido_transporte?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "notificacoes.tipos" */
export type Notificacoes_Tipos = {
  __typename?: 'notificacoes_tipos';
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  itens: Array<Notificacoes_Itens>;
  /** An aggregate relationship */
  itens_aggregate: Notificacoes_Itens_Aggregate;
  tempo_visivel?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "notificacoes.tipos" */
export type Notificacoes_TiposItensArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Itens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Itens_Order_By>>;
  where?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
};


/** columns and relationships of "notificacoes.tipos" */
export type Notificacoes_TiposItens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Itens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Itens_Order_By>>;
  where?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
};

/** aggregated selection of "notificacoes.tipos" */
export type Notificacoes_Tipos_Aggregate = {
  __typename?: 'notificacoes_tipos_aggregate';
  aggregate?: Maybe<Notificacoes_Tipos_Aggregate_Fields>;
  nodes: Array<Notificacoes_Tipos>;
};

/** aggregate fields of "notificacoes.tipos" */
export type Notificacoes_Tipos_Aggregate_Fields = {
  __typename?: 'notificacoes_tipos_aggregate_fields';
  avg?: Maybe<Notificacoes_Tipos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Notificacoes_Tipos_Max_Fields>;
  min?: Maybe<Notificacoes_Tipos_Min_Fields>;
  stddev?: Maybe<Notificacoes_Tipos_Stddev_Fields>;
  stddev_pop?: Maybe<Notificacoes_Tipos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notificacoes_Tipos_Stddev_Samp_Fields>;
  sum?: Maybe<Notificacoes_Tipos_Sum_Fields>;
  var_pop?: Maybe<Notificacoes_Tipos_Var_Pop_Fields>;
  var_samp?: Maybe<Notificacoes_Tipos_Var_Samp_Fields>;
  variance?: Maybe<Notificacoes_Tipos_Variance_Fields>;
};


/** aggregate fields of "notificacoes.tipos" */
export type Notificacoes_Tipos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notificacoes_Tipos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Notificacoes_Tipos_Avg_Fields = {
  __typename?: 'notificacoes_tipos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "notificacoes.tipos". All fields are combined with a logical 'AND'. */
export type Notificacoes_Tipos_Bool_Exp = {
  _and?: InputMaybe<Array<Notificacoes_Tipos_Bool_Exp>>;
  _not?: InputMaybe<Notificacoes_Tipos_Bool_Exp>;
  _or?: InputMaybe<Array<Notificacoes_Tipos_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  itens?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
  itens_aggregate?: InputMaybe<Notificacoes_Itens_Aggregate_Bool_Exp>;
  tempo_visivel?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notificacoes.tipos" */
export enum Notificacoes_Tipos_Constraint {
  /** unique or primary key constraint on columns "id" */
  TiposPkey = 'tipos_pkey'
}

/** input type for incrementing numeric columns in table "notificacoes.tipos" */
export type Notificacoes_Tipos_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "notificacoes.tipos" */
export type Notificacoes_Tipos_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  itens?: InputMaybe<Notificacoes_Itens_Arr_Rel_Insert_Input>;
  tempo_visivel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Notificacoes_Tipos_Max_Fields = {
  __typename?: 'notificacoes_tipos_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  tempo_visivel?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Notificacoes_Tipos_Min_Fields = {
  __typename?: 'notificacoes_tipos_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  tempo_visivel?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "notificacoes.tipos" */
export type Notificacoes_Tipos_Mutation_Response = {
  __typename?: 'notificacoes_tipos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notificacoes_Tipos>;
};

/** input type for inserting object relation for remote table "notificacoes.tipos" */
export type Notificacoes_Tipos_Obj_Rel_Insert_Input = {
  data: Notificacoes_Tipos_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Notificacoes_Tipos_On_Conflict>;
};

/** on_conflict condition type for table "notificacoes.tipos" */
export type Notificacoes_Tipos_On_Conflict = {
  constraint: Notificacoes_Tipos_Constraint;
  update_columns?: Array<Notificacoes_Tipos_Update_Column>;
  where?: InputMaybe<Notificacoes_Tipos_Bool_Exp>;
};

/** Ordering options when selecting data from "notificacoes.tipos". */
export type Notificacoes_Tipos_Order_By = {
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itens_aggregate?: InputMaybe<Notificacoes_Itens_Aggregate_Order_By>;
  tempo_visivel?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notificacoes.tipos */
export type Notificacoes_Tipos_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "notificacoes.tipos" */
export enum Notificacoes_Tipos_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  TempoVisivel = 'tempo_visivel'
}

/** input type for updating data in table "notificacoes.tipos" */
export type Notificacoes_Tipos_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  tempo_visivel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Notificacoes_Tipos_Stddev_Fields = {
  __typename?: 'notificacoes_tipos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Notificacoes_Tipos_Stddev_Pop_Fields = {
  __typename?: 'notificacoes_tipos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Notificacoes_Tipos_Stddev_Samp_Fields = {
  __typename?: 'notificacoes_tipos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "notificacoes_tipos" */
export type Notificacoes_Tipos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notificacoes_Tipos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notificacoes_Tipos_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  tempo_visivel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Notificacoes_Tipos_Sum_Fields = {
  __typename?: 'notificacoes_tipos_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "notificacoes.tipos" */
export enum Notificacoes_Tipos_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  TempoVisivel = 'tempo_visivel'
}

export type Notificacoes_Tipos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notificacoes_Tipos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notificacoes_Tipos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notificacoes_Tipos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notificacoes_Tipos_Var_Pop_Fields = {
  __typename?: 'notificacoes_tipos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Notificacoes_Tipos_Var_Samp_Fields = {
  __typename?: 'notificacoes_tipos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Notificacoes_Tipos_Variance_Fields = {
  __typename?: 'notificacoes_tipos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "permissoes.transacoes" */
export type Permissoes_Transacoes = {
  __typename?: 'permissoes_transacoes';
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  id_modulo?: Maybe<Scalars['bigint']['output']>;
  mascara?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  naviaDashboardsMenuTransacoes: Array<Navia_Dashboards_Menu_R_Transacoes>;
  /** An aggregate relationship */
  naviaDashboardsMenuTransacoes_aggregate: Navia_Dashboards_Menu_R_Transacoes_Aggregate;
  obs?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  transacoesEquipasVirtuais: Array<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** An aggregate relationship */
  transacoesEquipasVirtuais_aggregate: Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate;
};


/** columns and relationships of "permissoes.transacoes" */
export type Permissoes_TransacoesNaviaDashboardsMenuTransacoesArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};


/** columns and relationships of "permissoes.transacoes" */
export type Permissoes_TransacoesNaviaDashboardsMenuTransacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};


/** columns and relationships of "permissoes.transacoes" */
export type Permissoes_TransacoesTransacoesEquipasVirtuaisArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};


/** columns and relationships of "permissoes.transacoes" */
export type Permissoes_TransacoesTransacoesEquipasVirtuais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};

/** aggregated selection of "permissoes.transacoes" */
export type Permissoes_Transacoes_Aggregate = {
  __typename?: 'permissoes_transacoes_aggregate';
  aggregate?: Maybe<Permissoes_Transacoes_Aggregate_Fields>;
  nodes: Array<Permissoes_Transacoes>;
};

/** aggregate fields of "permissoes.transacoes" */
export type Permissoes_Transacoes_Aggregate_Fields = {
  __typename?: 'permissoes_transacoes_aggregate_fields';
  avg?: Maybe<Permissoes_Transacoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Permissoes_Transacoes_Max_Fields>;
  min?: Maybe<Permissoes_Transacoes_Min_Fields>;
  stddev?: Maybe<Permissoes_Transacoes_Stddev_Fields>;
  stddev_pop?: Maybe<Permissoes_Transacoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Permissoes_Transacoes_Stddev_Samp_Fields>;
  sum?: Maybe<Permissoes_Transacoes_Sum_Fields>;
  var_pop?: Maybe<Permissoes_Transacoes_Var_Pop_Fields>;
  var_samp?: Maybe<Permissoes_Transacoes_Var_Samp_Fields>;
  variance?: Maybe<Permissoes_Transacoes_Variance_Fields>;
};


/** aggregate fields of "permissoes.transacoes" */
export type Permissoes_Transacoes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permissoes_Transacoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Permissoes_Transacoes_Avg_Fields = {
  __typename?: 'permissoes_transacoes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  mascara?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "permissoes.transacoes". All fields are combined with a logical 'AND'. */
export type Permissoes_Transacoes_Bool_Exp = {
  _and?: InputMaybe<Array<Permissoes_Transacoes_Bool_Exp>>;
  _not?: InputMaybe<Permissoes_Transacoes_Bool_Exp>;
  _or?: InputMaybe<Array<Permissoes_Transacoes_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_modulo?: InputMaybe<Bigint_Comparison_Exp>;
  mascara?: InputMaybe<Int_Comparison_Exp>;
  naviaDashboardsMenuTransacoes?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
  naviaDashboardsMenuTransacoes_aggregate?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Aggregate_Bool_Exp>;
  obs?: InputMaybe<String_Comparison_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
  transacoesEquipasVirtuais?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
  transacoesEquipasVirtuais_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "permissoes.transacoes" */
export enum Permissoes_Transacoes_Constraint {
  /** unique or primary key constraint on columns "id" */
  TransacoesPkey = 'transacoes_pkey'
}

/** input type for incrementing numeric columns in table "permissoes.transacoes" */
export type Permissoes_Transacoes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_modulo?: InputMaybe<Scalars['bigint']['input']>;
  mascara?: InputMaybe<Scalars['Int']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "permissoes.transacoes" */
export type Permissoes_Transacoes_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_modulo?: InputMaybe<Scalars['bigint']['input']>;
  mascara?: InputMaybe<Scalars['Int']['input']>;
  naviaDashboardsMenuTransacoes?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Arr_Rel_Insert_Input>;
  obs?: InputMaybe<Scalars['String']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  transacoesEquipasVirtuais?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Permissoes_Transacoes_Max_Fields = {
  __typename?: 'permissoes_transacoes_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_modulo?: Maybe<Scalars['bigint']['output']>;
  mascara?: Maybe<Scalars['Int']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Permissoes_Transacoes_Min_Fields = {
  __typename?: 'permissoes_transacoes_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_modulo?: Maybe<Scalars['bigint']['output']>;
  mascara?: Maybe<Scalars['Int']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "permissoes.transacoes" */
export type Permissoes_Transacoes_Mutation_Response = {
  __typename?: 'permissoes_transacoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Permissoes_Transacoes>;
};

/** input type for inserting object relation for remote table "permissoes.transacoes" */
export type Permissoes_Transacoes_Obj_Rel_Insert_Input = {
  data: Permissoes_Transacoes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Permissoes_Transacoes_On_Conflict>;
};

/** on_conflict condition type for table "permissoes.transacoes" */
export type Permissoes_Transacoes_On_Conflict = {
  constraint: Permissoes_Transacoes_Constraint;
  update_columns?: Array<Permissoes_Transacoes_Update_Column>;
  where?: InputMaybe<Permissoes_Transacoes_Bool_Exp>;
};

/** Ordering options when selecting data from "permissoes.transacoes". */
export type Permissoes_Transacoes_Order_By = {
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_modulo?: InputMaybe<Order_By>;
  mascara?: InputMaybe<Order_By>;
  naviaDashboardsMenuTransacoes_aggregate?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Aggregate_Order_By>;
  obs?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  transacoesEquipasVirtuais_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Order_By>;
};

/** primary key columns input for table: permissoes.transacoes */
export type Permissoes_Transacoes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus = {
  __typename?: 'permissoes_transacoes_r_menus';
  id: Scalars['bigint']['output'];
  id_menu?: Maybe<Scalars['bigint']['output']>;
  id_transacao?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  transacoes?: Maybe<Permissoes_Transacoes>;
};

/** aggregated selection of "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Aggregate = {
  __typename?: 'permissoes_transacoes_r_menus_aggregate';
  aggregate?: Maybe<Permissoes_Transacoes_R_Menus_Aggregate_Fields>;
  nodes: Array<Permissoes_Transacoes_R_Menus>;
};

export type Permissoes_Transacoes_R_Menus_Aggregate_Bool_Exp = {
  count?: InputMaybe<Permissoes_Transacoes_R_Menus_Aggregate_Bool_Exp_Count>;
};

export type Permissoes_Transacoes_R_Menus_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Permissoes_Transacoes_R_Menus_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Aggregate_Fields = {
  __typename?: 'permissoes_transacoes_r_menus_aggregate_fields';
  avg?: Maybe<Permissoes_Transacoes_R_Menus_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Permissoes_Transacoes_R_Menus_Max_Fields>;
  min?: Maybe<Permissoes_Transacoes_R_Menus_Min_Fields>;
  stddev?: Maybe<Permissoes_Transacoes_R_Menus_Stddev_Fields>;
  stddev_pop?: Maybe<Permissoes_Transacoes_R_Menus_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Permissoes_Transacoes_R_Menus_Stddev_Samp_Fields>;
  sum?: Maybe<Permissoes_Transacoes_R_Menus_Sum_Fields>;
  var_pop?: Maybe<Permissoes_Transacoes_R_Menus_Var_Pop_Fields>;
  var_samp?: Maybe<Permissoes_Transacoes_R_Menus_Var_Samp_Fields>;
  variance?: Maybe<Permissoes_Transacoes_R_Menus_Variance_Fields>;
};


/** aggregate fields of "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Aggregate_Order_By = {
  avg?: InputMaybe<Permissoes_Transacoes_R_Menus_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Permissoes_Transacoes_R_Menus_Max_Order_By>;
  min?: InputMaybe<Permissoes_Transacoes_R_Menus_Min_Order_By>;
  stddev?: InputMaybe<Permissoes_Transacoes_R_Menus_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Permissoes_Transacoes_R_Menus_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Permissoes_Transacoes_R_Menus_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Permissoes_Transacoes_R_Menus_Sum_Order_By>;
  var_pop?: InputMaybe<Permissoes_Transacoes_R_Menus_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Permissoes_Transacoes_R_Menus_Var_Samp_Order_By>;
  variance?: InputMaybe<Permissoes_Transacoes_R_Menus_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Arr_Rel_Insert_Input = {
  data: Array<Permissoes_Transacoes_R_Menus_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Permissoes_Transacoes_R_Menus_On_Conflict>;
};

/** aggregate avg on columns */
export type Permissoes_Transacoes_R_Menus_Avg_Fields = {
  __typename?: 'permissoes_transacoes_r_menus_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "permissoes.transacoes_r_menus". All fields are combined with a logical 'AND'. */
export type Permissoes_Transacoes_R_Menus_Bool_Exp = {
  _and?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Bool_Exp>>;
  _not?: InputMaybe<Permissoes_Transacoes_R_Menus_Bool_Exp>;
  _or?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_menu?: InputMaybe<Bigint_Comparison_Exp>;
  id_transacao?: InputMaybe<Bigint_Comparison_Exp>;
  transacoes?: InputMaybe<Permissoes_Transacoes_Bool_Exp>;
};

/** unique or primary key constraints on table "permissoes.transacoes_r_menus" */
export enum Permissoes_Transacoes_R_Menus_Constraint {
  /** unique or primary key constraint on columns "id" */
  RTransacoesMenusPkey = 'r_transacoes_menus_pkey'
}

/** input type for incrementing numeric columns in table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_menu?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_menu?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
  transacoes?: InputMaybe<Permissoes_Transacoes_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Permissoes_Transacoes_R_Menus_Max_Fields = {
  __typename?: 'permissoes_transacoes_r_menus_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_menu?: Maybe<Scalars['bigint']['output']>;
  id_transacao?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Permissoes_Transacoes_R_Menus_Min_Fields = {
  __typename?: 'permissoes_transacoes_r_menus_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_menu?: Maybe<Scalars['bigint']['output']>;
  id_transacao?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Mutation_Response = {
  __typename?: 'permissoes_transacoes_r_menus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Permissoes_Transacoes_R_Menus>;
};

/** on_conflict condition type for table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_On_Conflict = {
  constraint: Permissoes_Transacoes_R_Menus_Constraint;
  update_columns?: Array<Permissoes_Transacoes_R_Menus_Update_Column>;
  where?: InputMaybe<Permissoes_Transacoes_R_Menus_Bool_Exp>;
};

/** Ordering options when selecting data from "permissoes.transacoes_r_menus". */
export type Permissoes_Transacoes_R_Menus_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  transacoes?: InputMaybe<Permissoes_Transacoes_Order_By>;
};

/** primary key columns input for table: permissoes.transacoes_r_menus */
export type Permissoes_Transacoes_R_Menus_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "permissoes.transacoes_r_menus" */
export enum Permissoes_Transacoes_R_Menus_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdMenu = 'id_menu',
  /** column name */
  IdTransacao = 'id_transacao'
}

/** input type for updating data in table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_menu?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Permissoes_Transacoes_R_Menus_Stddev_Fields = {
  __typename?: 'permissoes_transacoes_r_menus_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Permissoes_Transacoes_R_Menus_Stddev_Pop_Fields = {
  __typename?: 'permissoes_transacoes_r_menus_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Permissoes_Transacoes_R_Menus_Stddev_Samp_Fields = {
  __typename?: 'permissoes_transacoes_r_menus_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "permissoes_transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permissoes_Transacoes_R_Menus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permissoes_Transacoes_R_Menus_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_menu?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Permissoes_Transacoes_R_Menus_Sum_Fields = {
  __typename?: 'permissoes_transacoes_r_menus_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_menu?: Maybe<Scalars['bigint']['output']>;
  id_transacao?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** update columns of table "permissoes.transacoes_r_menus" */
export enum Permissoes_Transacoes_R_Menus_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdMenu = 'id_menu',
  /** column name */
  IdTransacao = 'id_transacao'
}

export type Permissoes_Transacoes_R_Menus_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Permissoes_Transacoes_R_Menus_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Permissoes_Transacoes_R_Menus_Set_Input>;
  /** filter the rows which have to be updated */
  where: Permissoes_Transacoes_R_Menus_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Permissoes_Transacoes_R_Menus_Var_Pop_Fields = {
  __typename?: 'permissoes_transacoes_r_menus_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Permissoes_Transacoes_R_Menus_Var_Samp_Fields = {
  __typename?: 'permissoes_transacoes_r_menus_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Permissoes_Transacoes_R_Menus_Variance_Fields = {
  __typename?: 'permissoes_transacoes_r_menus_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_menu?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "permissoes.transacoes_r_menus" */
export type Permissoes_Transacoes_R_Menus_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_menu?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
};

/** select columns of table "permissoes.transacoes" */
export enum Permissoes_Transacoes_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdModulo = 'id_modulo',
  /** column name */
  Mascara = 'mascara',
  /** column name */
  Obs = 'obs',
  /** column name */
  Ordem = 'ordem'
}

/** input type for updating data in table "permissoes.transacoes" */
export type Permissoes_Transacoes_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_modulo?: InputMaybe<Scalars['bigint']['input']>;
  mascara?: InputMaybe<Scalars['Int']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Permissoes_Transacoes_Stddev_Fields = {
  __typename?: 'permissoes_transacoes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  mascara?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Permissoes_Transacoes_Stddev_Pop_Fields = {
  __typename?: 'permissoes_transacoes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  mascara?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Permissoes_Transacoes_Stddev_Samp_Fields = {
  __typename?: 'permissoes_transacoes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  mascara?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "permissoes_transacoes" */
export type Permissoes_Transacoes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permissoes_Transacoes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permissoes_Transacoes_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_modulo?: InputMaybe<Scalars['bigint']['input']>;
  mascara?: InputMaybe<Scalars['Int']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Permissoes_Transacoes_Sum_Fields = {
  __typename?: 'permissoes_transacoes_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_modulo?: Maybe<Scalars['bigint']['output']>;
  mascara?: Maybe<Scalars['Int']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "permissoes.transacoes" */
export enum Permissoes_Transacoes_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdModulo = 'id_modulo',
  /** column name */
  Mascara = 'mascara',
  /** column name */
  Obs = 'obs',
  /** column name */
  Ordem = 'ordem'
}

export type Permissoes_Transacoes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Permissoes_Transacoes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Permissoes_Transacoes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Permissoes_Transacoes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Permissoes_Transacoes_Var_Pop_Fields = {
  __typename?: 'permissoes_transacoes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  mascara?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Permissoes_Transacoes_Var_Samp_Fields = {
  __typename?: 'permissoes_transacoes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  mascara?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Permissoes_Transacoes_Variance_Fields = {
  __typename?: 'permissoes_transacoes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_modulo?: Maybe<Scalars['Float']['output']>;
  mascara?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** pipe_readings_by_materialNative Query Arguments */
export type Pipe_Readings_By_Material_Arguments = {
  endDate: Scalars['timestamptz']['input'];
  startDate: Scalars['timestamptz']['input'];
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

export type Pipe_Readings_By_Material_Model = {
  __typename?: 'pipe_readings_by_material_model';
  data_hora: Scalars['timestamp']['output'];
  dominio?: Maybe<Scalars['String']['output']>;
  dominio_valor?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  id_fonte_origem: Scalars['bigint']['output'];
  valor_texto?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the logical model for "pipe_readings_by_material_model". All fields are combined with a logical 'AND'. */
export type Pipe_Readings_By_Material_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Pipe_Readings_By_Material_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Pipe_Readings_By_Material_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Pipe_Readings_By_Material_Model_Bool_Exp_Bool_Exp>>;
  data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  dominio?: InputMaybe<String_Comparison_Exp>;
  dominio_valor?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_fonte_origem?: InputMaybe<Bigint_Comparison_Exp>;
  valor_texto?: InputMaybe<String_Comparison_Exp>;
};

export enum Pipe_Readings_By_Material_Model_Enum_Name {
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  Dominio = 'dominio',
  /** column name */
  DominioValor = 'dominio_valor',
  /** column name */
  Id = 'id',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  ValorTexto = 'valor_texto'
}

/** Ordering options when selecting data from "pipe_readings_by_material_model". */
export type Pipe_Readings_By_Material_Model_Order_By = {
  data_hora?: InputMaybe<Order_By>;
  dominio?: InputMaybe<Order_By>;
  dominio_valor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  valor_texto?: InputMaybe<Order_By>;
};

/** pipe_rehabilitation_rateNative Query Arguments */
export type Pipe_Rehabilitation_Rate_Arguments = {
  endDate: Scalars['timestamptz']['input'];
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

export type Pipe_Rehabilitation_Rate_Model = {
  __typename?: 'pipe_rehabilitation_rate_model';
  avg_length_10y: Scalars['float8']['output'];
  pipe_rehabilitation_rate: Scalars['float8']['output'];
  rehab_5y_length_sum: Scalars['numeric']['output'];
};

/** Boolean expression to filter rows from the logical model for "pipe_rehabilitation_rate_model". All fields are combined with a logical 'AND'. */
export type Pipe_Rehabilitation_Rate_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Pipe_Rehabilitation_Rate_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Pipe_Rehabilitation_Rate_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Pipe_Rehabilitation_Rate_Model_Bool_Exp_Bool_Exp>>;
  avg_length_10y?: InputMaybe<Float8_Comparison_Exp>;
  pipe_rehabilitation_rate?: InputMaybe<Float8_Comparison_Exp>;
  rehab_5y_length_sum?: InputMaybe<Numeric_Comparison_Exp>;
};

export enum Pipe_Rehabilitation_Rate_Model_Enum_Name {
  /** column name */
  AvgLength_10y = 'avg_length_10y',
  /** column name */
  PipeRehabilitationRate = 'pipe_rehabilitation_rate',
  /** column name */
  Rehab_5yLengthSum = 'rehab_5y_length_sum'
}

/** Ordering options when selecting data from "pipe_rehabilitation_rate_model". */
export type Pipe_Rehabilitation_Rate_Model_Order_By = {
  avg_length_10y?: InputMaybe<Order_By>;
  pipe_rehabilitation_rate?: InputMaybe<Order_By>;
  rehab_5y_length_sum?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  age_vs_leaks_frequency: Array<Age_Vs_Leaks_Frequency_Model>;
  /** fetch data from the table: "base.bulk_tipos" */
  base_bulk_tipos: Array<Base_Bulk_Tipos>;
  /** fetch aggregated fields from the table: "base.bulk_tipos" */
  base_bulk_tipos_aggregate: Base_Bulk_Tipos_Aggregate;
  /** fetch data from the table: "base.bulk_tipos" using primary key columns */
  base_bulk_tipos_by_pk?: Maybe<Base_Bulk_Tipos>;
  /** fetch data from the table: "base.centros" */
  base_centros: Array<Base_Centros>;
  /** fetch aggregated fields from the table: "base.centros" */
  base_centros_aggregate: Base_Centros_Aggregate;
  /** fetch data from the table: "base.centros" using primary key columns */
  base_centros_by_pk?: Maybe<Base_Centros>;
  /** execute function "base.get_infraestruturas_tipos_active_childs" which returns "base.infraestruturas_tipos" */
  base_get_infraestruturas_tipos_active_childs: Array<Base_Infraestruturas_Tipos>;
  /** execute function "base.get_infraestruturas_tipos_active_childs" and query aggregates on result of table type "base.infraestruturas_tipos" */
  base_get_infraestruturas_tipos_active_childs_aggregate: Base_Infraestruturas_Tipos_Aggregate;
  /** fetch data from the table: "base.infraestruturas" */
  base_infraestruturas: Array<Base_Infraestruturas>;
  /** fetch aggregated fields from the table: "base.infraestruturas" */
  base_infraestruturas_aggregate: Base_Infraestruturas_Aggregate;
  /** fetch data from the table: "base.infraestruturas" using primary key columns */
  base_infraestruturas_by_pk?: Maybe<Base_Infraestruturas>;
  /** fetch data from the table: "base.infraestruturas_coordenadas" */
  base_infraestruturas_coordenadas: Array<Base_Infraestruturas_Coordenadas>;
  /** fetch aggregated fields from the table: "base.infraestruturas_coordenadas" */
  base_infraestruturas_coordenadas_aggregate: Base_Infraestruturas_Coordenadas_Aggregate;
  /** fetch data from the table: "base.infraestruturas_coordenadas" using primary key columns */
  base_infraestruturas_coordenadas_by_pk?: Maybe<Base_Infraestruturas_Coordenadas>;
  /** fetch data from the table: "base.infraestruturas_r_toponimias" */
  base_infraestruturas_r_toponimias: Array<Base_Infraestruturas_R_Toponimias>;
  /** fetch aggregated fields from the table: "base.infraestruturas_r_toponimias" */
  base_infraestruturas_r_toponimias_aggregate: Base_Infraestruturas_R_Toponimias_Aggregate;
  /** fetch data from the table: "base.infraestruturas_r_toponimias" using primary key columns */
  base_infraestruturas_r_toponimias_by_pk?: Maybe<Base_Infraestruturas_R_Toponimias>;
  /** fetch data from the table: "base.infraestruturas_tipos" */
  base_infraestruturas_tipos: Array<Base_Infraestruturas_Tipos>;
  /** fetch aggregated fields from the table: "base.infraestruturas_tipos" */
  base_infraestruturas_tipos_aggregate: Base_Infraestruturas_Tipos_Aggregate;
  /** fetch data from the table: "base.infraestruturas_tipos" using primary key columns */
  base_infraestruturas_tipos_by_pk?: Maybe<Base_Infraestruturas_Tipos>;
  /** fetch data from the table: "base.parametrizacoes" */
  base_parametrizacoes: Array<Base_Parametrizacoes>;
  /** fetch aggregated fields from the table: "base.parametrizacoes" */
  base_parametrizacoes_aggregate: Base_Parametrizacoes_Aggregate;
  /** fetch data from the table: "base.toponimias" */
  base_toponimias: Array<Base_Toponimias>;
  /** fetch aggregated fields from the table: "base.toponimias" */
  base_toponimias_aggregate: Base_Toponimias_Aggregate;
  /** fetch data from the table: "base.toponimias" using primary key columns */
  base_toponimias_by_pk?: Maybe<Base_Toponimias>;
  /** fetch data from the table: "base.toponimias_coordenadas" */
  base_toponimias_coordenadas: Array<Base_Toponimias_Coordenadas>;
  /** fetch aggregated fields from the table: "base.toponimias_coordenadas" */
  base_toponimias_coordenadas_aggregate: Base_Toponimias_Coordenadas_Aggregate;
  /** fetch data from the table: "base.toponimias_coordenadas" using primary key columns */
  base_toponimias_coordenadas_by_pk?: Maybe<Base_Toponimias_Coordenadas>;
  /** fetch data from the table: "base.zmc" */
  base_zmc: Array<Base_Zmc>;
  /** fetch aggregated fields from the table: "base.zmc" */
  base_zmc_aggregate: Base_Zmc_Aggregate;
  /** fetch data from the table: "base.zmc" using primary key columns */
  base_zmc_by_pk?: Maybe<Base_Zmc>;
  /** fetch data from the table: "base.zmc_nos_tipo" */
  base_zmc_nos_tipo: Array<Base_Zmc_Nos_Tipo>;
  /** fetch aggregated fields from the table: "base.zmc_nos_tipo" */
  base_zmc_nos_tipo_aggregate: Base_Zmc_Nos_Tipo_Aggregate;
  /** fetch data from the table: "base.zmc_nos_tipo" using primary key columns */
  base_zmc_nos_tipo_by_pk?: Maybe<Base_Zmc_Nos_Tipo>;
  checkMunicipalityExists?: Maybe<MunicipalityExistsResponse>;
  /** fetch data from the table: "consultas.requisicoes" */
  consultas_requisicoes: Array<Consultas_Requisicoes>;
  /** fetch aggregated fields from the table: "consultas.requisicoes" */
  consultas_requisicoes_aggregate: Consultas_Requisicoes_Aggregate;
  /** fetch data from the table: "consultas.requisicoes" using primary key columns */
  consultas_requisicoes_by_pk?: Maybe<Consultas_Requisicoes>;
  dashboardsLicenca: Array<DashboardsNaviaIds>;
  exportDailyFlowTable: Scalars['String']['output'];
  failure_recurrence_rate: Array<Failure_Recurrence_Rate_Model>;
  getAgeVsLeaksFrequency: Array<AgeVsLeaksFrequencyResponse>;
  getAllUsers: Array<Maybe<User>>;
  getCurrentUser?: Maybe<User>;
  getDailyFlowChart?: Maybe<DailyFlowChartResponse>;
  getDailyFlowIndicators?: Maybe<DailyFlowIndicators>;
  getDailyFlowReadings?: Maybe<DailyFlowReadings>;
  getDashboardQSIndicators: Array<Maybe<Indicator>>;
  getDashboardQSRequestsActList?: Maybe<Array<Maybe<RequestsActAndDangerList>>>;
  getDashboardQSRequestsDangerList?: Maybe<Array<Maybe<RequestsActAndDangerList>>>;
  getDashboardQSTopFiveAverageDurationBySymptom?: Maybe<Array<Maybe<TopFiveAverageDurationBySymptom>>>;
  getDashboardQSTopFiveNonComplianceBySymptom?: Maybe<Array<Maybe<TopFiveNonComplianceBySymptom>>>;
  getFailureRecurrenceRate: Array<FailureRecurrenceRateResponse>;
  getInfrastructureTotalizers: Array<InfrastructureTotalizerTreeResponse>;
  getInfrastructureVariablesTree: Array<InfrastructureVariableTreeResponse>;
  getLanguages: Languages;
  getLeakRecurrenceVsRehabilitation: Array<LeakRecurrenceVsRehabilitationResponse>;
  getLeaksPerDistance: Array<LeaksPerDistanceResponse>;
  getMunicipalityTotalizers?: Maybe<MunicipalityTotalizers>;
  getNetworkIntegrity: Array<NetworkIntegrityResponse>;
  getPipeReadingsByMaterial: Array<PipeReadingsByMaterialResponse>;
  getPipeRehabilitationRate: Array<PipeRehabilitationRateResponse>;
  getPipesAgeAverage: Array<PipeAgeAverageResponse>;
  getTop5PipesWithMostLeaks: Array<Top5PipesWithMostLeaksResponse>;
  getUserById?: Maybe<User>;
  getZMCLeaksCount: Array<ZmcLeaksCountResponse>;
  infrastructure_totalizers_tree: Array<Infrastructures_Totalizers_Tree_Model>;
  infrastructure_variables_tree: Array<Infrastructures_Variables_Tree_Model>;
  /** fetch data from the table: "integracoes.ad_parametrizacao" */
  integracoes_ad_parametrizacao: Array<Integracoes_Ad_Parametrizacao>;
  /** fetch aggregated fields from the table: "integracoes.ad_parametrizacao" */
  integracoes_ad_parametrizacao_aggregate: Integracoes_Ad_Parametrizacao_Aggregate;
  /** fetch data from the table: "integracoes.ad_saml_parametrizacao" */
  integracoes_ad_saml_parametrizacao: Array<Integracoes_Ad_Saml_Parametrizacao>;
  /** fetch aggregated fields from the table: "integracoes.ad_saml_parametrizacao" */
  integracoes_ad_saml_parametrizacao_aggregate: Integracoes_Ad_Saml_Parametrizacao_Aggregate;
  /** fetch data from the table: "integracoes.ad_saml_parametrizacao" using primary key columns */
  integracoes_ad_saml_parametrizacao_by_pk?: Maybe<Integracoes_Ad_Saml_Parametrizacao>;
  /** fetch data from the table: "integracoes.sig_maps_ortos" */
  integracoes_sig_maps_ortos: Array<Integracoes_Sig_Maps_Ortos>;
  /** fetch aggregated fields from the table: "integracoes.sig_maps_ortos" */
  integracoes_sig_maps_ortos_aggregate: Integracoes_Sig_Maps_Ortos_Aggregate;
  /** fetch data from the table: "integracoes.sig_maps_ortos" using primary key columns */
  integracoes_sig_maps_ortos_by_pk?: Maybe<Integracoes_Sig_Maps_Ortos>;
  /** fetch data from the table: "integracoes.sig_parametrizacao" */
  integracoes_sig_parametrizacao: Array<Integracoes_Sig_Parametrizacao>;
  /** fetch aggregated fields from the table: "integracoes.sig_parametrizacao" */
  integracoes_sig_parametrizacao_aggregate: Integracoes_Sig_Parametrizacao_Aggregate;
  /** fetch data from the table: "integracoes.sig_proxy" */
  integracoes_sig_proxy: Array<Integracoes_Sig_Proxy>;
  /** fetch aggregated fields from the table: "integracoes.sig_proxy" */
  integracoes_sig_proxy_aggregate: Integracoes_Sig_Proxy_Aggregate;
  /** fetch data from the table: "integracoes.sig_proxy" using primary key columns */
  integracoes_sig_proxy_by_pk?: Maybe<Integracoes_Sig_Proxy>;
  /** fetch data from the table: "integracoes.sig_request_get_attributes" */
  integracoes_sig_request_get_attributes: Array<Integracoes_Sig_Request_Get_Attributes>;
  /** fetch aggregated fields from the table: "integracoes.sig_request_get_attributes" */
  integracoes_sig_request_get_attributes_aggregate: Integracoes_Sig_Request_Get_Attributes_Aggregate;
  /** fetch data from the table: "integracoes.sig_request_get_capabilities" */
  integracoes_sig_request_get_capabilities: Array<Integracoes_Sig_Request_Get_Capabilities>;
  /** fetch aggregated fields from the table: "integracoes.sig_request_get_capabilities" */
  integracoes_sig_request_get_capabilities_aggregate: Integracoes_Sig_Request_Get_Capabilities_Aggregate;
  /** fetch data from the table: "integracoes.sig_request_get_features" */
  integracoes_sig_request_get_features: Array<Integracoes_Sig_Request_Get_Features>;
  /** fetch aggregated fields from the table: "integracoes.sig_request_get_features" */
  integracoes_sig_request_get_features_aggregate: Integracoes_Sig_Request_Get_Features_Aggregate;
  /** fetch data from the table: "integracoes.sig_services" */
  integracoes_sig_services: Array<Integracoes_Sig_Services>;
  /** fetch aggregated fields from the table: "integracoes.sig_services" */
  integracoes_sig_services_aggregate: Integracoes_Sig_Services_Aggregate;
  /** fetch data from the table: "integracoes.sig_services" using primary key columns */
  integracoes_sig_services_by_pk?: Maybe<Integracoes_Sig_Services>;
  leak_recurrence_vs_rehabilitation: Array<Leak_Recurrence_Vs_Rehabilitation_Model>;
  leaks_per_distance: Array<Leaks_Per_Distance_Model>;
  /** fetch data from the table: "mensagens.anexos" */
  mensagens_anexos: Array<Mensagens_Anexos>;
  /** fetch aggregated fields from the table: "mensagens.anexos" */
  mensagens_anexos_aggregate: Mensagens_Anexos_Aggregate;
  /** fetch data from the table: "mensagens.anexos" using primary key columns */
  mensagens_anexos_by_pk?: Maybe<Mensagens_Anexos>;
  /** fetch data from the table: "mensagens.mensagens" */
  mensagens_mensagens: Array<Mensagens_Mensagens>;
  /** fetch aggregated fields from the table: "mensagens.mensagens" */
  mensagens_mensagens_aggregate: Mensagens_Mensagens_Aggregate;
  /** fetch data from the table: "mensagens.mensagens" using primary key columns */
  mensagens_mensagens_by_pk?: Maybe<Mensagens_Mensagens>;
  /** fetch data from the table: "mensagens.post" */
  mensagens_post: Array<Mensagens_Post>;
  /** fetch aggregated fields from the table: "mensagens.post" */
  mensagens_post_aggregate: Mensagens_Post_Aggregate;
  /** fetch data from the table: "mensagens.post" using primary key columns */
  mensagens_post_by_pk?: Maybe<Mensagens_Post>;
  menuLicenca?: Maybe<Array<Maybe<MenuIds>>>;
  /** fetch data from the table: "mobile.coordenadas" */
  mobile_coordenadas: Array<Mobile_Coordenadas>;
  /** fetch aggregated fields from the table: "mobile.coordenadas" */
  mobile_coordenadas_aggregate: Mobile_Coordenadas_Aggregate;
  /** fetch data from the table: "mobile.coordenadas" using primary key columns */
  mobile_coordenadas_by_pk?: Maybe<Mobile_Coordenadas>;
  /** fetch data from the table: "navia.cores" */
  navia_cores: Array<Navia_Cores>;
  /** fetch aggregated fields from the table: "navia.cores" */
  navia_cores_aggregate: Navia_Cores_Aggregate;
  /** fetch data from the table: "navia.cores" using primary key columns */
  navia_cores_by_pk?: Maybe<Navia_Cores>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  navia_dashboards_diagnostico_roturas_infraestruturas_variaveis: Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_aggregate: Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" using primary key columns */
  navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  navia_dashboards_diagnostico_roturas_mapa_niveis: Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  navia_dashboards_diagnostico_roturas_mapa_niveis_aggregate: Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" using primary key columns */
  navia_dashboards_diagnostico_roturas_mapa_niveis_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_sintomas" */
  navia_dashboards_diagnostico_roturas_sintomas: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_sintomas" */
  navia_dashboards_diagnostico_roturas_sintomas_aggregate: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_sintomas" using primary key columns */
  navia_dashboards_diagnostico_roturas_sintomas_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  navia_dashboards_diagnostico_roturas_sintomas_tipos: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  navia_dashboards_diagnostico_roturas_sintomas_tipos_aggregate: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" using primary key columns */
  navia_dashboards_diagnostico_roturas_sintomas_tipos_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_aggregate: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" using primary key columns */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_aggregate: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" using primary key columns */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc>;
  /** fetch data from the table: "navia_dashboards.infraestruturas_totalizadores" */
  navia_dashboards_infraestruturas_totalizadores: Array<Navia_Dashboards_Infraestruturas_Totalizadores>;
  /** fetch aggregated fields from the table: "navia_dashboards.infraestruturas_totalizadores" */
  navia_dashboards_infraestruturas_totalizadores_aggregate: Navia_Dashboards_Infraestruturas_Totalizadores_Aggregate;
  /** fetch data from the table: "navia_dashboards.infraestruturas_variaveis" */
  navia_dashboards_infraestruturas_variaveis: Array<Navia_Dashboards_Infraestruturas_Variaveis>;
  /** fetch aggregated fields from the table: "navia_dashboards.infraestruturas_variaveis" */
  navia_dashboards_infraestruturas_variaveis_aggregate: Navia_Dashboards_Infraestruturas_Variaveis_Aggregate;
  /** fetch data from the table: "navia_dashboards.menu" */
  navia_dashboards_menu: Array<Navia_Dashboards_Menu>;
  /** fetch aggregated fields from the table: "navia_dashboards.menu" */
  navia_dashboards_menu_aggregate: Navia_Dashboards_Menu_Aggregate;
  /** fetch data from the table: "navia_dashboards.menu" using primary key columns */
  navia_dashboards_menu_by_pk?: Maybe<Navia_Dashboards_Menu>;
  /** fetch data from the table: "navia_dashboards.menu_r_transacoes" */
  navia_dashboards_menu_r_transacoes: Array<Navia_Dashboards_Menu_R_Transacoes>;
  /** fetch aggregated fields from the table: "navia_dashboards.menu_r_transacoes" */
  navia_dashboards_menu_r_transacoes_aggregate: Navia_Dashboards_Menu_R_Transacoes_Aggregate;
  /** fetch data from the table: "navia_dashboards.menu_r_transacoes" using primary key columns */
  navia_dashboards_menu_r_transacoes_by_pk?: Maybe<Navia_Dashboards_Menu_R_Transacoes>;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens" */
  navia_dashboards_modo_tv_tokens: Array<Navia_Dashboards_Modo_Tv_Tokens>;
  /** fetch aggregated fields from the table: "navia_dashboards.modo_tv_tokens" */
  navia_dashboards_modo_tv_tokens_aggregate: Navia_Dashboards_Modo_Tv_Tokens_Aggregate;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens" using primary key columns */
  navia_dashboards_modo_tv_tokens_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens>;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  navia_dashboards_modo_tv_tokens_revogacao_manual: Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual>;
  /** fetch aggregated fields from the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  navia_dashboards_modo_tv_tokens_revogacao_manual_aggregate: Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Aggregate;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" using primary key columns */
  navia_dashboards_modo_tv_tokens_revogacao_manual_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual>;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens_validados" */
  navia_dashboards_modo_tv_tokens_validados: Array<Navia_Dashboards_Modo_Tv_Tokens_Validados>;
  /** fetch aggregated fields from the table: "navia_dashboards.modo_tv_tokens_validados" */
  navia_dashboards_modo_tv_tokens_validados_aggregate: Navia_Dashboards_Modo_Tv_Tokens_Validados_Aggregate;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens_validados" using primary key columns */
  navia_dashboards_modo_tv_tokens_validados_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_causas" */
  navia_dashboards_monitorizacao_roturas_causas: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_causas" */
  navia_dashboards_monitorizacao_roturas_causas_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Causas_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_causas" using primary key columns */
  navia_dashboards_monitorizacao_roturas_causas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  navia_dashboards_monitorizacao_roturas_causas_r_causas: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  navia_dashboards_monitorizacao_roturas_causas_r_causas_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" using primary key columns */
  navia_dashboards_monitorizacao_roturas_causas_r_causas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_indicadores" */
  navia_dashboards_monitorizacao_roturas_indicadores: Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_indicadores" */
  navia_dashboards_monitorizacao_roturas_indicadores_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_indicadores" using primary key columns */
  navia_dashboards_monitorizacao_roturas_indicadores_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_sintomas" */
  navia_dashboards_monitorizacao_roturas_sintomas: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_sintomas" */
  navia_dashboards_monitorizacao_roturas_sintomas_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_sintomas" using primary key columns */
  navia_dashboards_monitorizacao_roturas_sintomas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" using primary key columns */
  navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_variaveis" */
  navia_dashboards_monitorizacao_roturas_variaveis: Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_variaveis" */
  navia_dashboards_monitorizacao_roturas_variaveis_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_variaveis" using primary key columns */
  navia_dashboards_monitorizacao_roturas_variaveis_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis>;
  /** fetch data from the table: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  navia_dashboards_performance_infraestrutura_parametrizacao: Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao>;
  /** fetch aggregated fields from the table: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  navia_dashboards_performance_infraestrutura_parametrizacao_aggregate: Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Aggregate;
  /** fetch data from the table: "navia_dashboards.performance_infraestrutura_parametrizacao" using primary key columns */
  navia_dashboards_performance_infraestrutura_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao>;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao>;
  /** fetch aggregated fields from the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_aggregate: Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Aggregate;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" using primary key columns */
  navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao>;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa>;
  /** fetch aggregated fields from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_aggregate: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Aggregate;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" using primary key columns */
  navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa>;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas>;
  /** fetch aggregated fields from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_aggregate: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Aggregate;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" using primary key columns */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas>;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores>;
  /** fetch aggregated fields from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_aggregate: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" using primary key columns */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores>;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura>;
  /** fetch aggregated fields from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_aggregate: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Aggregate;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" using primary key columns */
  navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura>;
  /** fetch data from the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  navia_dashboards_requisicoes_indicadores_parametrizacao: Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao>;
  /** fetch aggregated fields from the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  navia_dashboards_requisicoes_indicadores_parametrizacao_aggregate: Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Aggregate;
  /** fetch data from the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" using primary key columns */
  navia_dashboards_requisicoes_indicadores_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao>;
  /** fetch data from the table: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  navia_dashboards_requisicoes_mapa_parametrizacao: Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao>;
  /** fetch aggregated fields from the table: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  navia_dashboards_requisicoes_mapa_parametrizacao_aggregate: Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Aggregate;
  /** fetch data from the table: "navia_dashboards.requisicoes_mapa_parametrizacao" using primary key columns */
  navia_dashboards_requisicoes_mapa_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao>;
  /** fetch data from the table: "navia_dashboards.visao_360_parametrizacao" */
  navia_dashboards_visao_360_parametrizacao: Array<Navia_Dashboards_Visao_360_Parametrizacao>;
  /** fetch aggregated fields from the table: "navia_dashboards.visao_360_parametrizacao" */
  navia_dashboards_visao_360_parametrizacao_aggregate: Navia_Dashboards_Visao_360_Parametrizacao_Aggregate;
  /** fetch data from the table: "navia_dashboards.visao_360_parametrizacao" using primary key columns */
  navia_dashboards_visao_360_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao>;
  /** fetch data from the table: "navia_dashboards.visao_360_selectores" */
  navia_dashboards_visao_360_selectores: Array<Navia_Dashboards_Visao_360_Selectores>;
  /** fetch aggregated fields from the table: "navia_dashboards.visao_360_selectores" */
  navia_dashboards_visao_360_selectores_aggregate: Navia_Dashboards_Visao_360_Selectores_Aggregate;
  /** fetch data from the table: "navia_dashboards.visao_360_selectores" using primary key columns */
  navia_dashboards_visao_360_selectores_by_pk?: Maybe<Navia_Dashboards_Visao_360_Selectores>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_caudais" */
  navia_dashboards_volumes_diarios_caudais: Array<Navia_Dashboards_Volumes_Diarios_Caudais>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_caudais" */
  navia_dashboards_volumes_diarios_caudais_aggregate: Navia_Dashboards_Volumes_Diarios_Caudais_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_caudais" using primary key columns */
  navia_dashboards_volumes_diarios_caudais_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Caudais>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_dados" */
  navia_dashboards_volumes_diarios_dados: Array<Navia_Dashboards_Volumes_Diarios_Dados>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_dados" */
  navia_dashboards_volumes_diarios_dados_aggregate: Navia_Dashboards_Volumes_Diarios_Dados_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_dados" using primary key columns */
  navia_dashboards_volumes_diarios_dados_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios: Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_aggregate: Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" using primary key columns */
  navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_leituras" */
  navia_dashboards_volumes_diarios_leituras: Array<Navia_Dashboards_Volumes_Diarios_Leituras>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_leituras" */
  navia_dashboards_volumes_diarios_leituras_aggregate: Navia_Dashboards_Volumes_Diarios_Leituras_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_leituras" using primary key columns */
  navia_dashboards_volumes_diarios_leituras_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Leituras>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_locais" */
  navia_dashboards_volumes_diarios_locais: Array<Navia_Dashboards_Volumes_Diarios_Locais>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_locais" */
  navia_dashboards_volumes_diarios_locais_aggregate: Navia_Dashboards_Volumes_Diarios_Locais_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_locais" using primary key columns */
  navia_dashboards_volumes_diarios_locais_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Locais>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_municipios" */
  navia_dashboards_volumes_diarios_municipios: Array<Navia_Dashboards_Volumes_Diarios_Municipios>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_municipios" */
  navia_dashboards_volumes_diarios_municipios_aggregate: Navia_Dashboards_Volumes_Diarios_Municipios_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_municipios" using primary key columns */
  navia_dashboards_volumes_diarios_municipios_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_registos" */
  navia_dashboards_volumes_diarios_registos: Array<Navia_Dashboards_Volumes_Diarios_Registos>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_registos" */
  navia_dashboards_volumes_diarios_registos_aggregate: Navia_Dashboards_Volumes_Diarios_Registos_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_registos" using primary key columns */
  navia_dashboards_volumes_diarios_registos_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Registos>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  navia_dashboards_volumes_diarios_totalizador_leituras: Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  navia_dashboards_volumes_diarios_totalizador_leituras_aggregate: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_totalizador_leituras" using primary key columns */
  navia_dashboards_volumes_diarios_totalizador_leituras_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_totalizadores" */
  navia_dashboards_volumes_diarios_totalizadores: Array<Navia_Dashboards_Volumes_Diarios_Totalizadores>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_totalizadores" */
  navia_dashboards_volumes_diarios_totalizadores_aggregate: Navia_Dashboards_Volumes_Diarios_Totalizadores_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_totalizadores" using primary key columns */
  navia_dashboards_volumes_diarios_totalizadores_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores>;
  /** fetch data from the table: "navia.integracoes" */
  navia_integracoes: Array<Navia_Integracoes>;
  /** fetch aggregated fields from the table: "navia.integracoes" */
  navia_integracoes_aggregate: Navia_Integracoes_Aggregate;
  /** fetch data from the table: "navia.integracoes" using primary key columns */
  navia_integracoes_by_pk?: Maybe<Navia_Integracoes>;
  /** fetch data from the table: "navia.log" */
  navia_log: Array<Navia_Log>;
  /** fetch aggregated fields from the table: "navia.log" */
  navia_log_aggregate: Navia_Log_Aggregate;
  /** fetch data from the table: "navia.log" using primary key columns */
  navia_log_by_pk?: Maybe<Navia_Log>;
  network_integrity: Array<Network_Integrity_Model>;
  /** fetch data from the table: "notificacoes.itens" */
  notificacoes_itens: Array<Notificacoes_Itens>;
  /** fetch aggregated fields from the table: "notificacoes.itens" */
  notificacoes_itens_aggregate: Notificacoes_Itens_Aggregate;
  /** fetch data from the table: "notificacoes.itens" using primary key columns */
  notificacoes_itens_by_pk?: Maybe<Notificacoes_Itens>;
  /** fetch data from the table: "notificacoes.notificacoes" */
  notificacoes_notificacoes: Array<Notificacoes_Notificacoes>;
  /** fetch aggregated fields from the table: "notificacoes.notificacoes" */
  notificacoes_notificacoes_aggregate: Notificacoes_Notificacoes_Aggregate;
  /** fetch data from the table: "notificacoes.notificacoes" using primary key columns */
  notificacoes_notificacoes_by_pk?: Maybe<Notificacoes_Notificacoes>;
  /** fetch data from the table: "notificacoes.notificacoes_r_utilizadores" */
  notificacoes_notificacoes_r_utilizadores: Array<Notificacoes_Notificacoes_R_Utilizadores>;
  /** fetch aggregated fields from the table: "notificacoes.notificacoes_r_utilizadores" */
  notificacoes_notificacoes_r_utilizadores_aggregate: Notificacoes_Notificacoes_R_Utilizadores_Aggregate;
  /** fetch data from the table: "notificacoes.notificacoes_r_utilizadores" using primary key columns */
  notificacoes_notificacoes_r_utilizadores_by_pk?: Maybe<Notificacoes_Notificacoes_R_Utilizadores>;
  /** fetch data from the table: "notificacoes.tipos" */
  notificacoes_tipos: Array<Notificacoes_Tipos>;
  /** fetch aggregated fields from the table: "notificacoes.tipos" */
  notificacoes_tipos_aggregate: Notificacoes_Tipos_Aggregate;
  /** fetch data from the table: "notificacoes.tipos" using primary key columns */
  notificacoes_tipos_by_pk?: Maybe<Notificacoes_Tipos>;
  /** fetch data from the table: "permissoes.transacoes" */
  permissoes_transacoes: Array<Permissoes_Transacoes>;
  /** fetch aggregated fields from the table: "permissoes.transacoes" */
  permissoes_transacoes_aggregate: Permissoes_Transacoes_Aggregate;
  /** fetch data from the table: "permissoes.transacoes" using primary key columns */
  permissoes_transacoes_by_pk?: Maybe<Permissoes_Transacoes>;
  /** fetch data from the table: "permissoes.transacoes_r_menus" */
  permissoes_transacoes_r_menus: Array<Permissoes_Transacoes_R_Menus>;
  /** fetch aggregated fields from the table: "permissoes.transacoes_r_menus" */
  permissoes_transacoes_r_menus_aggregate: Permissoes_Transacoes_R_Menus_Aggregate;
  /** fetch data from the table: "permissoes.transacoes_r_menus" using primary key columns */
  permissoes_transacoes_r_menus_by_pk?: Maybe<Permissoes_Transacoes_R_Menus>;
  pipe_readings_by_material: Array<Pipe_Readings_By_Material_Model>;
  pipe_rehabilitation_rate: Array<Pipe_Rehabilitation_Rate_Model>;
  requests_act_list: Array<Requests_Act_And_Danger_List_Return>;
  requests_act_list_without_login: Array<Requests_Act_And_Danger_List_Return>;
  requests_danger_list: Array<Requests_Act_And_Danger_List_Return>;
  requests_danger_list_without_login: Array<Requests_Act_And_Danger_List_Return>;
  /** fetch data from the table: "rqs.parametrizacao" */
  rqs_parametrizacao: Array<Rqs_Parametrizacao>;
  /** fetch aggregated fields from the table: "rqs.parametrizacao" */
  rqs_parametrizacao_aggregate: Rqs_Parametrizacao_Aggregate;
  /** fetch data from the table: "rqs.requisicoes_periodos" */
  rqs_requisicoes_periodos: Array<Rqs_Requisicoes_Periodos>;
  /** fetch aggregated fields from the table: "rqs.requisicoes_periodos" */
  rqs_requisicoes_periodos_aggregate: Rqs_Requisicoes_Periodos_Aggregate;
  /** fetch data from the table: "rqs.requisicoes_periodos" using primary key columns */
  rqs_requisicoes_periodos_by_pk?: Maybe<Rqs_Requisicoes_Periodos>;
  /** fetch data from the table: "rqs.requisicoes_tempos_wrap" */
  rqs_requisicoes_tempos_wrap: Array<Rqs_Requisicoes_Tempos_Wrap>;
  /** fetch aggregated fields from the table: "rqs.requisicoes_tempos_wrap" */
  rqs_requisicoes_tempos_wrap_aggregate: Rqs_Requisicoes_Tempos_Wrap_Aggregate;
  /** fetch data from the table: "rqs.requisicoes_tempos_wrap" using primary key columns */
  rqs_requisicoes_tempos_wrap_by_pk?: Maybe<Rqs_Requisicoes_Tempos_Wrap>;
  /** fetch data from the table: "rqs.sintomas" */
  rqs_sintomas: Array<Rqs_Sintomas>;
  /** fetch aggregated fields from the table: "rqs.sintomas" */
  rqs_sintomas_aggregate: Rqs_Sintomas_Aggregate;
  /** fetch data from the table: "rqs.sintomas" using primary key columns */
  rqs_sintomas_by_pk?: Maybe<Rqs_Sintomas>;
  /** fetch data from the table: "rqs.sintomas_parametrizacao_tempos" */
  rqs_sintomas_parametrizacao_tempos: Array<Rqs_Sintomas_Parametrizacao_Tempos>;
  /** fetch aggregated fields from the table: "rqs.sintomas_parametrizacao_tempos" */
  rqs_sintomas_parametrizacao_tempos_aggregate: Rqs_Sintomas_Parametrizacao_Tempos_Aggregate;
  /** fetch data from the table: "rqs.sintomas_parametrizacao_tempos" using primary key columns */
  rqs_sintomas_parametrizacao_tempos_by_pk?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos>;
  /** fetch data from the table: "servicos.fases" */
  servicos_fases: Array<Servicos_Fases>;
  /** fetch aggregated fields from the table: "servicos.fases" */
  servicos_fases_aggregate: Servicos_Fases_Aggregate;
  /** fetch data from the table: "servicos.fases" using primary key columns */
  servicos_fases_by_pk?: Maybe<Servicos_Fases>;
  /** fetch data from the table: "servicos.intervencoes" */
  servicos_intervencoes: Array<Servicos_Intervencoes>;
  /** fetch aggregated fields from the table: "servicos.intervencoes" */
  servicos_intervencoes_aggregate: Servicos_Intervencoes_Aggregate;
  /** fetch data from the table: "servicos.intervencoes_atribuicao_utilizadores" */
  servicos_intervencoes_atribuicao_utilizadores: Array<Servicos_Intervencoes_Atribuicao_Utilizadores>;
  /** fetch aggregated fields from the table: "servicos.intervencoes_atribuicao_utilizadores" */
  servicos_intervencoes_atribuicao_utilizadores_aggregate: Servicos_Intervencoes_Atribuicao_Utilizadores_Aggregate;
  /** fetch data from the table: "servicos.intervencoes_atribuicao_utilizadores" using primary key columns */
  servicos_intervencoes_atribuicao_utilizadores_by_pk?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores>;
  /** fetch data from the table: "servicos.intervencoes" using primary key columns */
  servicos_intervencoes_by_pk?: Maybe<Servicos_Intervencoes>;
  /** fetch data from the table: "servicos.intervencoes_estados" */
  servicos_intervencoes_estados: Array<Servicos_Intervencoes_Estados>;
  /** fetch aggregated fields from the table: "servicos.intervencoes_estados" */
  servicos_intervencoes_estados_aggregate: Servicos_Intervencoes_Estados_Aggregate;
  /** fetch data from the table: "servicos.intervencoes_estados" using primary key columns */
  servicos_intervencoes_estados_by_pk?: Maybe<Servicos_Intervencoes_Estados>;
  /** fetch data from the table: "servicos.intervencoes_r_causas_trabalhos" */
  servicos_intervencoes_r_causas_trabalhos: Array<Servicos_Intervencoes_R_Causas_Trabalhos>;
  /** fetch aggregated fields from the table: "servicos.intervencoes_r_causas_trabalhos" */
  servicos_intervencoes_r_causas_trabalhos_aggregate: Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate;
  /** fetch data from the table: "servicos.intervencoes_r_causas_trabalhos" using primary key columns */
  servicos_intervencoes_r_causas_trabalhos_by_pk?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos>;
  /** fetch data from the table: "servicos.rastreabilidade" */
  servicos_rastreabilidade: Array<Servicos_Rastreabilidade>;
  /** fetch aggregated fields from the table: "servicos.rastreabilidade" */
  servicos_rastreabilidade_aggregate: Servicos_Rastreabilidade_Aggregate;
  /** fetch data from the table: "servicos.rastreabilidade" using primary key columns */
  servicos_rastreabilidade_by_pk?: Maybe<Servicos_Rastreabilidade>;
  /** fetch data from the table: "servicos.requisicoes" */
  servicos_requisicoes: Array<Servicos_Requisicoes>;
  /** fetch aggregated fields from the table: "servicos.requisicoes" */
  servicos_requisicoes_aggregate: Servicos_Requisicoes_Aggregate;
  /** fetch data from the table: "servicos.requisicoes" using primary key columns */
  servicos_requisicoes_by_pk?: Maybe<Servicos_Requisicoes>;
  /** fetch data from the table: "servicos.requisicoes_estados" */
  servicos_requisicoes_estados: Array<Servicos_Requisicoes_Estados>;
  /** fetch aggregated fields from the table: "servicos.requisicoes_estados" */
  servicos_requisicoes_estados_aggregate: Servicos_Requisicoes_Estados_Aggregate;
  /** fetch data from the table: "servicos.requisicoes_estados" using primary key columns */
  servicos_requisicoes_estados_by_pk?: Maybe<Servicos_Requisicoes_Estados>;
  /** fetch data from the table: "servicos.requisicoes_locais_infra_estruturas" */
  servicos_requisicoes_locais_infra_estruturas: Array<Servicos_Requisicoes_Locais_Infra_Estruturas>;
  /** fetch aggregated fields from the table: "servicos.requisicoes_locais_infra_estruturas" */
  servicos_requisicoes_locais_infra_estruturas_aggregate: Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate;
  /** fetch data from the table: "servicos.requisicoes_locais_infra_estruturas" using primary key columns */
  servicos_requisicoes_locais_infra_estruturas_by_pk?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas>;
  /** fetch data from the table: "servicos.requisicoes_r_intervencoes" */
  servicos_requisicoes_r_intervencoes: Array<Servicos_Requisicoes_R_Intervencoes>;
  /** fetch aggregated fields from the table: "servicos.requisicoes_r_intervencoes" */
  servicos_requisicoes_r_intervencoes_aggregate: Servicos_Requisicoes_R_Intervencoes_Aggregate;
  /** fetch data from the table: "servicos.requisicoes_r_intervencoes" using primary key columns */
  servicos_requisicoes_r_intervencoes_by_pk?: Maybe<Servicos_Requisicoes_R_Intervencoes>;
  /** fetch data from the table: "sintomas.arvore" */
  sintomas_arvore: Array<Sintomas_Arvore>;
  /** fetch aggregated fields from the table: "sintomas.arvore" */
  sintomas_arvore_aggregate: Sintomas_Arvore_Aggregate;
  /** fetch data from the table: "sintomas.arvore" using primary key columns */
  sintomas_arvore_by_pk?: Maybe<Sintomas_Arvore>;
  /** fetch data from the table: "sintomas.causas_trabalhos" */
  sintomas_causas_trabalhos: Array<Sintomas_Causas_Trabalhos>;
  /** fetch aggregated fields from the table: "sintomas.causas_trabalhos" */
  sintomas_causas_trabalhos_aggregate: Sintomas_Causas_Trabalhos_Aggregate;
  /** fetch data from the table: "sintomas.causas_trabalhos" using primary key columns */
  sintomas_causas_trabalhos_by_pk?: Maybe<Sintomas_Causas_Trabalhos>;
  /** fetch data from the table: "sintomas.sintomas_relacao" */
  sintomas_sintomas_relacao: Array<Sintomas_Sintomas_Relacao>;
  /** fetch aggregated fields from the table: "sintomas.sintomas_relacao" */
  sintomas_sintomas_relacao_aggregate: Sintomas_Sintomas_Relacao_Aggregate;
  /** fetch data from the table: "sintomas.sintomas_relacao" using primary key columns */
  sintomas_sintomas_relacao_by_pk?: Maybe<Sintomas_Sintomas_Relacao>;
  /** fetch data from the table: "sintomas.sintomas_relacao_ordem" */
  sintomas_sintomas_relacao_ordem: Array<Sintomas_Sintomas_Relacao_Ordem>;
  /** fetch aggregated fields from the table: "sintomas.sintomas_relacao_ordem" */
  sintomas_sintomas_relacao_ordem_aggregate: Sintomas_Sintomas_Relacao_Ordem_Aggregate;
  /** fetch data from the table: "sintomas.sintomas_relacao_ordem" using primary key columns */
  sintomas_sintomas_relacao_ordem_by_pk?: Maybe<Sintomas_Sintomas_Relacao_Ordem>;
  /** fetch data from the table: "tarefas.estados" */
  tarefas_estados: Array<Tarefas_Estados>;
  /** fetch aggregated fields from the table: "tarefas.estados" */
  tarefas_estados_aggregate: Tarefas_Estados_Aggregate;
  /** fetch data from the table: "tarefas.estados" using primary key columns */
  tarefas_estados_by_pk?: Maybe<Tarefas_Estados>;
  /** fetch data from the table: "tarefas.intervalos" */
  tarefas_intervalos: Array<Tarefas_Intervalos>;
  /** fetch aggregated fields from the table: "tarefas.intervalos" */
  tarefas_intervalos_aggregate: Tarefas_Intervalos_Aggregate;
  /** fetch data from the table: "tarefas.intervalos" using primary key columns */
  tarefas_intervalos_by_pk?: Maybe<Tarefas_Intervalos>;
  /** fetch data from the table: "tarefas.planos_padrao" */
  tarefas_planos_padrao: Array<Tarefas_Planos_Padrao>;
  /** fetch aggregated fields from the table: "tarefas.planos_padrao" */
  tarefas_planos_padrao_aggregate: Tarefas_Planos_Padrao_Aggregate;
  /** fetch data from the table: "tarefas.planos_padrao" using primary key columns */
  tarefas_planos_padrao_by_pk?: Maybe<Tarefas_Planos_Padrao>;
  /** fetch data from the table: "tarefas.tarefas" */
  tarefas_tarefas: Array<Tarefas_Tarefas>;
  /** fetch aggregated fields from the table: "tarefas.tarefas" */
  tarefas_tarefas_aggregate: Tarefas_Tarefas_Aggregate;
  /** fetch data from the table: "tarefas.tarefas" using primary key columns */
  tarefas_tarefas_by_pk?: Maybe<Tarefas_Tarefas>;
  /** fetch data from the table: "tarefas.tarefas_r_equipas_virtuais" */
  tarefas_tarefas_r_equipas_virtuais: Array<Tarefas_Tarefas_R_Equipas_Virtuais>;
  /** fetch aggregated fields from the table: "tarefas.tarefas_r_equipas_virtuais" */
  tarefas_tarefas_r_equipas_virtuais_aggregate: Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate;
  /** fetch data from the table: "tarefas.tarefas_r_equipas_virtuais" using primary key columns */
  tarefas_tarefas_r_equipas_virtuais_by_pk?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais>;
  /** fetch data from the table: "tarefas.tarefas_r_infraestruturas" */
  tarefas_tarefas_r_infraestruturas: Array<Tarefas_Tarefas_R_Infraestruturas>;
  /** fetch aggregated fields from the table: "tarefas.tarefas_r_infraestruturas" */
  tarefas_tarefas_r_infraestruturas_aggregate: Tarefas_Tarefas_R_Infraestruturas_Aggregate;
  /** fetch data from the table: "tarefas.tarefas_r_infraestruturas" using primary key columns */
  tarefas_tarefas_r_infraestruturas_by_pk?: Maybe<Tarefas_Tarefas_R_Infraestruturas>;
  top_5_pipes_with_most_leaks: Array<Top_5_Pipes_With_Most_Leaks_Model>;
  top_five_average_duration_by_symptom: Array<Top_Five_Average_Duration_By_Symptom_Return>;
  top_five_average_duration_by_symptom_without_login: Array<Top_Five_Average_Duration_By_Symptom_Return>;
  user_agenda: Array<User_Agenda_Model>;
  /** fetch data from the table: "utilizadores.categorias" */
  utilizadores_categorias: Array<Utilizadores_Categorias>;
  /** fetch aggregated fields from the table: "utilizadores.categorias" */
  utilizadores_categorias_aggregate: Utilizadores_Categorias_Aggregate;
  /** fetch data from the table: "utilizadores.categorias" using primary key columns */
  utilizadores_categorias_by_pk?: Maybe<Utilizadores_Categorias>;
  /** fetch data from the table: "utilizadores.equipas_virtuais" */
  utilizadores_equipas_virtuais: Array<Utilizadores_Equipas_Virtuais>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais" */
  utilizadores_equipas_virtuais_aggregate: Utilizadores_Equipas_Virtuais_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais" using primary key columns */
  utilizadores_equipas_virtuais_by_pk?: Maybe<Utilizadores_Equipas_Virtuais>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_centros" */
  utilizadores_equipas_virtuais_r_centros: Array<Utilizadores_Equipas_Virtuais_R_Centros>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_centros" */
  utilizadores_equipas_virtuais_r_centros_aggregate: Utilizadores_Equipas_Virtuais_R_Centros_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_centros" using primary key columns */
  utilizadores_equipas_virtuais_r_centros_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  utilizadores_equipas_virtuais_r_equipas_virtuais: Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  utilizadores_equipas_virtuais_r_equipas_virtuais_aggregate: Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" using primary key columns */
  utilizadores_equipas_virtuais_r_equipas_virtuais_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_infraestruturas" */
  utilizadores_equipas_virtuais_r_infraestruturas: Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_infraestruturas" */
  utilizadores_equipas_virtuais_r_infraestruturas_aggregate: Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_infraestruturas" using primary key columns */
  utilizadores_equipas_virtuais_r_infraestruturas_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_sintoma" */
  utilizadores_equipas_virtuais_r_sintoma: Array<Utilizadores_Equipas_Virtuais_R_Sintoma>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_sintoma" */
  utilizadores_equipas_virtuais_r_sintoma_aggregate: Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_sintoma" using primary key columns */
  utilizadores_equipas_virtuais_r_sintoma_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_toponimias" */
  utilizadores_equipas_virtuais_r_toponimias: Array<Utilizadores_Equipas_Virtuais_R_Toponimias>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_toponimias" */
  utilizadores_equipas_virtuais_r_toponimias_aggregate: Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_toponimias" using primary key columns */
  utilizadores_equipas_virtuais_r_toponimias_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_transacoes" */
  utilizadores_equipas_virtuais_r_transacoes: Array<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_transacoes" */
  utilizadores_equipas_virtuais_r_transacoes_aggregate: Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_transacoes" using primary key columns */
  utilizadores_equipas_virtuais_r_transacoes_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_utilizadores" */
  utilizadores_equipas_virtuais_r_utilizadores: Array<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_utilizadores" */
  utilizadores_equipas_virtuais_r_utilizadores_aggregate: Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_utilizadores" using primary key columns */
  utilizadores_equipas_virtuais_r_utilizadores_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  /** fetch data from the table: "utilizadores.exportacoes" */
  utilizadores_exportacoes: Array<Utilizadores_Exportacoes>;
  /** fetch aggregated fields from the table: "utilizadores.exportacoes" */
  utilizadores_exportacoes_aggregate: Utilizadores_Exportacoes_Aggregate;
  /** fetch data from the table: "utilizadores.exportacoes" using primary key columns */
  utilizadores_exportacoes_by_pk?: Maybe<Utilizadores_Exportacoes>;
  /** fetch data from the table: "utilizadores.mapa_posicao_cores" */
  utilizadores_mapa_posicao_cores: Array<Utilizadores_Mapa_Posicao_Cores>;
  /** fetch aggregated fields from the table: "utilizadores.mapa_posicao_cores" */
  utilizadores_mapa_posicao_cores_aggregate: Utilizadores_Mapa_Posicao_Cores_Aggregate;
  /** fetch data from the table: "utilizadores.mapa_posicao_cores" using primary key columns */
  utilizadores_mapa_posicao_cores_by_pk?: Maybe<Utilizadores_Mapa_Posicao_Cores>;
  /** fetch data from the table: "utilizadores.menu" */
  utilizadores_menu: Array<Utilizadores_Menu>;
  /** fetch aggregated fields from the table: "utilizadores.menu" */
  utilizadores_menu_aggregate: Utilizadores_Menu_Aggregate;
  /** fetch data from the table: "utilizadores.menu" using primary key columns */
  utilizadores_menu_by_pk?: Maybe<Utilizadores_Menu>;
  /** fetch data from the table: "utilizadores.temas" */
  utilizadores_temas: Array<Utilizadores_Temas>;
  /** fetch aggregated fields from the table: "utilizadores.temas" */
  utilizadores_temas_aggregate: Utilizadores_Temas_Aggregate;
  /** fetch data from the table: "utilizadores.temas" using primary key columns */
  utilizadores_temas_by_pk?: Maybe<Utilizadores_Temas>;
  /** fetch data from the table: "utilizadores.utilizadores" */
  utilizadores_utilizadores: Array<Utilizadores_Utilizadores>;
  /** fetch aggregated fields from the table: "utilizadores.utilizadores" */
  utilizadores_utilizadores_aggregate: Utilizadores_Utilizadores_Aggregate;
  /** fetch data from the table: "utilizadores.utilizadores" using primary key columns */
  utilizadores_utilizadores_by_pk?: Maybe<Utilizadores_Utilizadores>;
  /** fetch data from the table: "variaveis.agregacao" */
  variaveis_agregacao: Array<Variaveis_Agregacao>;
  /** fetch aggregated fields from the table: "variaveis.agregacao" */
  variaveis_agregacao_aggregate: Variaveis_Agregacao_Aggregate;
  /** fetch data from the table: "variaveis.agregacao" using primary key columns */
  variaveis_agregacao_by_pk?: Maybe<Variaveis_Agregacao>;
  /** fetch data from the table: "variaveis.base" */
  variaveis_base: Array<Variaveis_Base>;
  /** fetch aggregated fields from the table: "variaveis.base" */
  variaveis_base_aggregate: Variaveis_Base_Aggregate;
  /** fetch data from the table: "variaveis.base" using primary key columns */
  variaveis_base_by_pk?: Maybe<Variaveis_Base>;
  /** fetch data from the table: "variaveis.base_calc_variaveis" */
  variaveis_base_calc_variaveis: Array<Variaveis_Base_Calc_Variaveis>;
  /** fetch aggregated fields from the table: "variaveis.base_calc_variaveis" */
  variaveis_base_calc_variaveis_aggregate: Variaveis_Base_Calc_Variaveis_Aggregate;
  /** fetch data from the table: "variaveis.base_calc_variaveis" using primary key columns */
  variaveis_base_calc_variaveis_by_pk?: Maybe<Variaveis_Base_Calc_Variaveis>;
  /** fetch data from the table: "variaveis.base_categorias" */
  variaveis_base_categorias: Array<Variaveis_Base_Categorias>;
  /** fetch aggregated fields from the table: "variaveis.base_categorias" */
  variaveis_base_categorias_aggregate: Variaveis_Base_Categorias_Aggregate;
  /** fetch data from the table: "variaveis.base_categorias" using primary key columns */
  variaveis_base_categorias_by_pk?: Maybe<Variaveis_Base_Categorias>;
  /** fetch data from the table: "variaveis.base_propriedades" */
  variaveis_base_propriedades: Array<Variaveis_Base_Propriedades>;
  /** fetch aggregated fields from the table: "variaveis.base_propriedades" */
  variaveis_base_propriedades_aggregate: Variaveis_Base_Propriedades_Aggregate;
  /** fetch data from the table: "variaveis.base_propriedades" using primary key columns */
  variaveis_base_propriedades_by_pk?: Maybe<Variaveis_Base_Propriedades>;
  /** fetch data from the table: "variaveis.calc_variaveis" */
  variaveis_calc_variaveis: Array<Variaveis_Calc_Variaveis>;
  /** fetch aggregated fields from the table: "variaveis.calc_variaveis" */
  variaveis_calc_variaveis_aggregate: Variaveis_Calc_Variaveis_Aggregate;
  /** fetch data from the table: "variaveis.calc_variaveis" using primary key columns */
  variaveis_calc_variaveis_by_pk?: Maybe<Variaveis_Calc_Variaveis>;
  /** fetch data from the table: "variaveis.dominios" */
  variaveis_dominios: Array<Variaveis_Dominios>;
  /** fetch aggregated fields from the table: "variaveis.dominios" */
  variaveis_dominios_aggregate: Variaveis_Dominios_Aggregate;
  /** fetch data from the table: "variaveis.dominios" using primary key columns */
  variaveis_dominios_by_pk?: Maybe<Variaveis_Dominios>;
  /** fetch data from the table: "variaveis.dominios_r_dominios_valores" */
  variaveis_dominios_r_dominios_valores: Array<Variaveis_Dominios_R_Dominios_Valores>;
  /** fetch aggregated fields from the table: "variaveis.dominios_r_dominios_valores" */
  variaveis_dominios_r_dominios_valores_aggregate: Variaveis_Dominios_R_Dominios_Valores_Aggregate;
  /** fetch data from the table: "variaveis.dominios_r_dominios_valores" using primary key columns */
  variaveis_dominios_r_dominios_valores_by_pk?: Maybe<Variaveis_Dominios_R_Dominios_Valores>;
  /** fetch data from the table: "variaveis.dominios_valores" */
  variaveis_dominios_valores: Array<Variaveis_Dominios_Valores>;
  /** fetch aggregated fields from the table: "variaveis.dominios_valores" */
  variaveis_dominios_valores_aggregate: Variaveis_Dominios_Valores_Aggregate;
  /** fetch data from the table: "variaveis.dominios_valores" using primary key columns */
  variaveis_dominios_valores_by_pk?: Maybe<Variaveis_Dominios_Valores>;
  /** fetch data from the table: "variaveis.escalas_precisao" */
  variaveis_escalas_precisao: Array<Variaveis_Escalas_Precisao>;
  /** fetch aggregated fields from the table: "variaveis.escalas_precisao" */
  variaveis_escalas_precisao_aggregate: Variaveis_Escalas_Precisao_Aggregate;
  /** fetch data from the table: "variaveis.escalas_precisao" using primary key columns */
  variaveis_escalas_precisao_by_pk?: Maybe<Variaveis_Escalas_Precisao>;
  /** fetch data from the table: "variaveis.fontes_origem" */
  variaveis_fontes_origem: Array<Variaveis_Fontes_Origem>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem" */
  variaveis_fontes_origem_aggregate: Variaveis_Fontes_Origem_Aggregate;
  /** fetch data from the table: "variaveis.fontes_origem" using primary key columns */
  variaveis_fontes_origem_by_pk?: Maybe<Variaveis_Fontes_Origem>;
  /** fetch data from the table: "variaveis.fontes_origem_estatistica" */
  variaveis_fontes_origem_estatistica: Array<Variaveis_Fontes_Origem_Estatistica>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem_estatistica" */
  variaveis_fontes_origem_estatistica_aggregate: Variaveis_Fontes_Origem_Estatistica_Aggregate;
  /** fetch data from the table: "variaveis.fontes_origem_infraestrutura_estatistica" */
  variaveis_fontes_origem_infraestrutura_estatistica: Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem_infraestrutura_estatistica" */
  variaveis_fontes_origem_infraestrutura_estatistica_aggregate: Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate;
  /** fetch data from the table: "variaveis.fontes_origem_plano_padrao_estatistica" */
  variaveis_fontes_origem_plano_padrao_estatistica: Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem_plano_padrao_estatistica" */
  variaveis_fontes_origem_plano_padrao_estatistica_aggregate: Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Aggregate;
  /** fetch data from the table: "variaveis.fontes_origem_propriedades" */
  variaveis_fontes_origem_propriedades: Array<Variaveis_Fontes_Origem_Propriedades>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem_propriedades" */
  variaveis_fontes_origem_propriedades_aggregate: Variaveis_Fontes_Origem_Propriedades_Aggregate;
  /** fetch data from the table: "variaveis.fontes_origem_propriedades" using primary key columns */
  variaveis_fontes_origem_propriedades_by_pk?: Maybe<Variaveis_Fontes_Origem_Propriedades>;
  /** fetch data from the table: "variaveis.fontes_origem_tipos" */
  variaveis_fontes_origem_tipos: Array<Variaveis_Fontes_Origem_Tipos>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem_tipos" */
  variaveis_fontes_origem_tipos_aggregate: Variaveis_Fontes_Origem_Tipos_Aggregate;
  /** fetch data from the table: "variaveis.fontes_origem_tipos" using primary key columns */
  variaveis_fontes_origem_tipos_by_pk?: Maybe<Variaveis_Fontes_Origem_Tipos>;
  /** fetch data from the table: "variaveis.leituras" */
  variaveis_leituras: Array<Variaveis_Leituras>;
  /** fetch aggregated fields from the table: "variaveis.leituras" */
  variaveis_leituras_aggregate: Variaveis_Leituras_Aggregate;
  /** fetch data from the table: "variaveis.leituras" using primary key columns */
  variaveis_leituras_by_pk?: Maybe<Variaveis_Leituras>;
  /** fetch data from the table: "variaveis.parametros" */
  variaveis_parametros: Array<Variaveis_Parametros>;
  /** fetch aggregated fields from the table: "variaveis.parametros" */
  variaveis_parametros_aggregate: Variaveis_Parametros_Aggregate;
  /** fetch data from the table: "variaveis.parametros" using primary key columns */
  variaveis_parametros_by_pk?: Maybe<Variaveis_Parametros>;
  /** fetch data from the table: "variaveis.parametros_r_unidades_medida" */
  variaveis_parametros_r_unidades_medida: Array<Variaveis_Parametros_R_Unidades_Medida>;
  /** fetch aggregated fields from the table: "variaveis.parametros_r_unidades_medida" */
  variaveis_parametros_r_unidades_medida_aggregate: Variaveis_Parametros_R_Unidades_Medida_Aggregate;
  /** fetch data from the table: "variaveis.parametros_r_unidades_medida" using primary key columns */
  variaveis_parametros_r_unidades_medida_by_pk?: Maybe<Variaveis_Parametros_R_Unidades_Medida>;
  /** fetch data from the table: "variaveis.tipos" */
  variaveis_tipos: Array<Variaveis_Tipos>;
  /** fetch aggregated fields from the table: "variaveis.tipos" */
  variaveis_tipos_aggregate: Variaveis_Tipos_Aggregate;
  /** fetch data from the table: "variaveis.tipos" using primary key columns */
  variaveis_tipos_by_pk?: Maybe<Variaveis_Tipos>;
  /** fetch data from the table: "variaveis.totalizadores_tipos_registo" */
  variaveis_totalizadores_tipos_registo: Array<Variaveis_Totalizadores_Tipos_Registo>;
  /** fetch aggregated fields from the table: "variaveis.totalizadores_tipos_registo" */
  variaveis_totalizadores_tipos_registo_aggregate: Variaveis_Totalizadores_Tipos_Registo_Aggregate;
  /** fetch data from the table: "variaveis.totalizadores_tipos_registo" using primary key columns */
  variaveis_totalizadores_tipos_registo_by_pk?: Maybe<Variaveis_Totalizadores_Tipos_Registo>;
  /** fetch data from the table: "variaveis.unidades_medida" */
  variaveis_unidades_medida: Array<Variaveis_Unidades_Medida>;
  /** fetch aggregated fields from the table: "variaveis.unidades_medida" */
  variaveis_unidades_medida_aggregate: Variaveis_Unidades_Medida_Aggregate;
  /** fetch data from the table: "variaveis.unidades_medida" using primary key columns */
  variaveis_unidades_medida_by_pk?: Maybe<Variaveis_Unidades_Medida>;
  /** fetch data from the table: "variaveis.valores_mensais" */
  variaveis_valores_mensais: Array<Variaveis_Valores_Mensais>;
  /** fetch aggregated fields from the table: "variaveis.valores_mensais" */
  variaveis_valores_mensais_aggregate: Variaveis_Valores_Mensais_Aggregate;
  /** fetch data from the table: "variaveis.valores_mensais" using primary key columns */
  variaveis_valores_mensais_by_pk?: Maybe<Variaveis_Valores_Mensais>;
  zmc_leaks_count: Array<Zmc_Leaks_Count_Model>;
};


export type Query_RootAge_Vs_Leaks_FrequencyArgs = {
  args: Age_Vs_Leaks_Frequency_Arguments;
  distinct_on?: InputMaybe<Array<Age_Vs_Leaks_Frequency_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Age_Vs_Leaks_Frequency_Model_Order_By>>;
  where?: InputMaybe<Age_Vs_Leaks_Frequency_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootBase_Bulk_TiposArgs = {
  distinct_on?: InputMaybe<Array<Base_Bulk_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Bulk_Tipos_Order_By>>;
  where?: InputMaybe<Base_Bulk_Tipos_Bool_Exp>;
};


export type Query_RootBase_Bulk_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Bulk_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Bulk_Tipos_Order_By>>;
  where?: InputMaybe<Base_Bulk_Tipos_Bool_Exp>;
};


export type Query_RootBase_Bulk_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBase_CentrosArgs = {
  distinct_on?: InputMaybe<Array<Base_Centros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Centros_Order_By>>;
  where?: InputMaybe<Base_Centros_Bool_Exp>;
};


export type Query_RootBase_Centros_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Centros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Centros_Order_By>>;
  where?: InputMaybe<Base_Centros_Bool_Exp>;
};


export type Query_RootBase_Centros_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBase_Get_Infraestruturas_Tipos_Active_ChildsArgs = {
  args: Base_Get_Infraestruturas_Tipos_Active_Childs_Args;
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Tipos_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};


export type Query_RootBase_Get_Infraestruturas_Tipos_Active_Childs_AggregateArgs = {
  args: Base_Get_Infraestruturas_Tipos_Active_Childs_Args;
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Tipos_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};


export type Query_RootBase_InfraestruturasArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
};


export type Query_RootBase_Infraestruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
};


export type Query_RootBase_Infraestruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBase_Infraestruturas_CoordenadasArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
};


export type Query_RootBase_Infraestruturas_Coordenadas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
};


export type Query_RootBase_Infraestruturas_Coordenadas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBase_Infraestruturas_R_ToponimiasArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_R_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_R_Toponimias_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_R_Toponimias_Bool_Exp>;
};


export type Query_RootBase_Infraestruturas_R_Toponimias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_R_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_R_Toponimias_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_R_Toponimias_Bool_Exp>;
};


export type Query_RootBase_Infraestruturas_R_Toponimias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBase_Infraestruturas_TiposArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Tipos_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};


export type Query_RootBase_Infraestruturas_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Tipos_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};


export type Query_RootBase_Infraestruturas_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBase_ParametrizacoesArgs = {
  distinct_on?: InputMaybe<Array<Base_Parametrizacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Parametrizacoes_Order_By>>;
  where?: InputMaybe<Base_Parametrizacoes_Bool_Exp>;
};


export type Query_RootBase_Parametrizacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Parametrizacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Parametrizacoes_Order_By>>;
  where?: InputMaybe<Base_Parametrizacoes_Bool_Exp>;
};


export type Query_RootBase_ToponimiasArgs = {
  distinct_on?: InputMaybe<Array<Base_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Toponimias_Order_By>>;
  where?: InputMaybe<Base_Toponimias_Bool_Exp>;
};


export type Query_RootBase_Toponimias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Toponimias_Order_By>>;
  where?: InputMaybe<Base_Toponimias_Bool_Exp>;
};


export type Query_RootBase_Toponimias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBase_Toponimias_CoordenadasArgs = {
  distinct_on?: InputMaybe<Array<Base_Toponimias_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Toponimias_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
};


export type Query_RootBase_Toponimias_Coordenadas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Toponimias_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Toponimias_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
};


export type Query_RootBase_Toponimias_Coordenadas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBase_ZmcArgs = {
  distinct_on?: InputMaybe<Array<Base_Zmc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Zmc_Order_By>>;
  where?: InputMaybe<Base_Zmc_Bool_Exp>;
};


export type Query_RootBase_Zmc_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Zmc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Zmc_Order_By>>;
  where?: InputMaybe<Base_Zmc_Bool_Exp>;
};


export type Query_RootBase_Zmc_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootBase_Zmc_Nos_TipoArgs = {
  distinct_on?: InputMaybe<Array<Base_Zmc_Nos_Tipo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Zmc_Nos_Tipo_Order_By>>;
  where?: InputMaybe<Base_Zmc_Nos_Tipo_Bool_Exp>;
};


export type Query_RootBase_Zmc_Nos_Tipo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Zmc_Nos_Tipo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Zmc_Nos_Tipo_Order_By>>;
  where?: InputMaybe<Base_Zmc_Nos_Tipo_Bool_Exp>;
};


export type Query_RootBase_Zmc_Nos_Tipo_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCheckMunicipalityExistsArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootConsultas_RequisicoesArgs = {
  distinct_on?: InputMaybe<Array<Consultas_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consultas_Requisicoes_Order_By>>;
  where?: InputMaybe<Consultas_Requisicoes_Bool_Exp>;
};


export type Query_RootConsultas_Requisicoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consultas_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consultas_Requisicoes_Order_By>>;
  where?: InputMaybe<Consultas_Requisicoes_Bool_Exp>;
};


export type Query_RootConsultas_Requisicoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootDashboardsLicencaArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<DashboardsLicencaOrderByInput>;
  where?: InputMaybe<DashboardsLicencaWhereInput>;
};


export type Query_RootExportDailyFlowTableArgs = {
  endDate: Scalars['Date']['input'];
  municipalityId: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<InputMaybe<DailyFlowReadingsSortInput>>>;
  startDate: Scalars['Date']['input'];
};


export type Query_RootFailure_Recurrence_RateArgs = {
  args: Failure_Recurrence_Rate_Arguments;
  distinct_on?: InputMaybe<Array<Failure_Recurrence_Rate_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failure_Recurrence_Rate_Model_Order_By>>;
  where?: InputMaybe<Failure_Recurrence_Rate_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootGetAgeVsLeaksFrequencyArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type Query_RootGetDailyFlowChartArgs = {
  endDate: Scalars['Date']['input'];
  municipalityId: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
};


export type Query_RootGetDailyFlowIndicatorsArgs = {
  endDate: Scalars['Date']['input'];
  municipalityId: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
};


export type Query_RootGetDailyFlowReadingsArgs = {
  endDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  municipalityId: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<DailyFlowReadingsSortInput>>>;
  placeSearchValue?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
};


export type Query_RootGetDashboardQsIndicatorsArgs = {
  year: Scalars['Int']['input'];
};


export type Query_RootGetDashboardQsRequestsActListArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type Query_RootGetDashboardQsRequestsDangerListArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type Query_RootGetDashboardQsTopFiveAverageDurationBySymptomArgs = {
  year: Scalars['Int']['input'];
};


export type Query_RootGetDashboardQsTopFiveNonComplianceBySymptomArgs = {
  year: Scalars['Int']['input'];
};


export type Query_RootGetFailureRecurrenceRateArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type Query_RootGetInfrastructureTotalizersArgs = {
  description: Scalars['String']['input'];
  totalizer: Scalars['String']['input'];
  transactionId: Scalars['Int']['input'];
};


export type Query_RootGetInfrastructureVariablesTreeArgs = {
  infrastructureSearchText?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['Int']['input'];
  typeIds: Scalars['String']['input'];
  variableSearchText?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetLeakRecurrenceVsRehabilitationArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type Query_RootGetLeaksPerDistanceArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type Query_RootGetMunicipalityTotalizersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  municipalityId: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  showExpressionTotalizers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_RootGetNetworkIntegrityArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type Query_RootGetPipeReadingsByMaterialArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type Query_RootGetPipeRehabilitationRateArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
};


export type Query_RootGetPipesAgeAverageArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
};


export type Query_RootGetTop5PipesWithMostLeaksArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type Query_RootGetUserByIdArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootGetZmcLeaksCountArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type Query_RootInfrastructure_Totalizers_TreeArgs = {
  args: Infrastructure_Totalizers_Tree_Arguments;
  distinct_on?: InputMaybe<Array<Infrastructures_Totalizers_Tree_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infrastructures_Totalizers_Tree_Model_Order_By>>;
  where?: InputMaybe<Infrastructures_Totalizers_Tree_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootInfrastructure_Variables_TreeArgs = {
  args: Infrastructure_Variables_Tree_Arguments;
  distinct_on?: InputMaybe<Array<Infrastructures_Variables_Tree_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infrastructures_Variables_Tree_Model_Order_By>>;
  where?: InputMaybe<Infrastructures_Variables_Tree_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootIntegracoes_Ad_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Ad_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Ad_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Ad_Parametrizacao_Bool_Exp>;
};


export type Query_RootIntegracoes_Ad_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Ad_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Ad_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Ad_Parametrizacao_Bool_Exp>;
};


export type Query_RootIntegracoes_Ad_Saml_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Ad_Saml_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Ad_Saml_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Bool_Exp>;
};


export type Query_RootIntegracoes_Ad_Saml_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Ad_Saml_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Ad_Saml_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Bool_Exp>;
};


export type Query_RootIntegracoes_Ad_Saml_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootIntegracoes_Sig_Maps_OrtosArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Maps_Ortos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Maps_Ortos_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Maps_Ortos_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Maps_Ortos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Maps_Ortos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Maps_Ortos_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Maps_Ortos_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Maps_Ortos_By_PkArgs = {
  id: Scalars['smallint']['input'];
};


export type Query_RootIntegracoes_Sig_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Parametrizacao_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Parametrizacao_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_ProxyArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Proxy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Proxy_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Proxy_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Proxy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Proxy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Proxy_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Proxy_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Proxy_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootIntegracoes_Sig_Request_Get_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Attributes_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Attributes_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Request_Get_Attributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Attributes_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Attributes_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Request_Get_CapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Capabilities_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Capabilities_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Request_Get_Capabilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Capabilities_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Capabilities_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Request_Get_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Features_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Features_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Request_Get_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Features_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Features_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_ServicesArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Services_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Services_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Services_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Services_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Services_Bool_Exp>;
};


export type Query_RootIntegracoes_Sig_Services_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootLeak_Recurrence_Vs_RehabilitationArgs = {
  args: Leak_Recurrence_Vs_Rehabilitation_Arguments;
  distinct_on?: InputMaybe<Array<Leak_Recurrence_Vs_Rehabilitation_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leak_Recurrence_Vs_Rehabilitation_Model_Order_By>>;
  where?: InputMaybe<Leak_Recurrence_Vs_Rehabilitation_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootLeaks_Per_DistanceArgs = {
  args: Leaks_Per_Distance_Arguments;
  distinct_on?: InputMaybe<Array<Leaks_Per_Distance_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leaks_Per_Distance_Model_Order_By>>;
  where?: InputMaybe<Leaks_Per_Distance_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootMensagens_AnexosArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Anexos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Anexos_Order_By>>;
  where?: InputMaybe<Mensagens_Anexos_Bool_Exp>;
};


export type Query_RootMensagens_Anexos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Anexos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Anexos_Order_By>>;
  where?: InputMaybe<Mensagens_Anexos_Bool_Exp>;
};


export type Query_RootMensagens_Anexos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMensagens_MensagensArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Mensagens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Mensagens_Order_By>>;
  where?: InputMaybe<Mensagens_Mensagens_Bool_Exp>;
};


export type Query_RootMensagens_Mensagens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Mensagens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Mensagens_Order_By>>;
  where?: InputMaybe<Mensagens_Mensagens_Bool_Exp>;
};


export type Query_RootMensagens_Mensagens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMensagens_PostArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Post_Order_By>>;
  where?: InputMaybe<Mensagens_Post_Bool_Exp>;
};


export type Query_RootMensagens_Post_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Post_Order_By>>;
  where?: InputMaybe<Mensagens_Post_Bool_Exp>;
};


export type Query_RootMensagens_Post_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMobile_CoordenadasArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Coordenadas_Order_By>>;
  where?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
};


export type Query_RootMobile_Coordenadas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Coordenadas_Order_By>>;
  where?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
};


export type Query_RootMobile_Coordenadas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_CoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Cores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Cores_Order_By>>;
  where?: InputMaybe<Navia_Cores_Bool_Exp>;
};


export type Query_RootNavia_Cores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Cores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Cores_Order_By>>;
  where?: InputMaybe<Navia_Cores_Bool_Exp>;
};


export type Query_RootNavia_Cores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Infraestruturas_VariaveisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Mapa_NiveisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_SintomasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_TiposArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_InfraestruturaArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_By_PkArgs = {
  tipo_infraestrutura_id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_ZmcArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_By_PkArgs = {
  tipo_infraestrutura_id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Infraestruturas_TotalizadoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Totalizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Totalizadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Infraestruturas_Totalizadores_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Infraestruturas_Totalizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Totalizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Totalizadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Infraestruturas_Totalizadores_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Infraestruturas_VariaveisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Infraestruturas_Variaveis_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Infraestruturas_Variaveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Infraestruturas_Variaveis_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_MenuArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Menu_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Menu_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Menu_R_TransacoesArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Menu_R_Transacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Menu_R_Transacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Modo_Tv_TokensArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Modo_Tv_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Modo_Tv_Tokens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Modo_Tv_Tokens_Revogacao_ManualArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_By_PkArgs = {
  id_token: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Modo_Tv_Tokens_ValidadosArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Modo_Tv_Tokens_Validados_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Modo_Tv_Tokens_Validados_By_PkArgs = {
  id_token: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_CausasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_R_CausasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_IndicadoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Indicadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Indicadores_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_SintomasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_R_SintomasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_VariaveisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Variaveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Monitorizacao_Roturas_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Performance_Infraestrutura_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Performance_Infraestrutura_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Performance_Infraestrutura_Parametrizacao_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_TarefaArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_By_PkArgs = {
  plano_padrao_id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_SintomasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_ValoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_InfraestruturaArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_By_PkArgs = {
  tipo_infraestrutura_id: Scalars['Int']['input'];
};


export type Query_RootNavia_Dashboards_Requisicoes_Indicadores_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Requisicoes_Indicadores_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Requisicoes_Indicadores_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Requisicoes_Mapa_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Requisicoes_Mapa_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Requisicoes_Mapa_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Visao_360_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Visao_360_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Visao_360_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Visao_360_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Visao_360_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Visao_360_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Visao_360_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Visao_360_SelectoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Visao_360_Selectores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Visao_360_Selectores_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_CaudaisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Caudais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Caudais_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_DadosArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Dados_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Dados_By_PkArgs = {
  id_municipio: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_MunicipiosArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_LeiturasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Leituras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Leituras_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_LocaisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Locais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Locais_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_MunicipiosArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Municipios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Municipios_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_RegistosArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Registos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Registos_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Totalizador_LeiturasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Totalizador_Leituras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Totalizador_Leituras_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_TotalizadoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Totalizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp>;
};


export type Query_RootNavia_Dashboards_Volumes_Diarios_Totalizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_IntegracoesArgs = {
  distinct_on?: InputMaybe<Array<Navia_Integracoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Integracoes_Order_By>>;
  where?: InputMaybe<Navia_Integracoes_Bool_Exp>;
};


export type Query_RootNavia_Integracoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Integracoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Integracoes_Order_By>>;
  where?: InputMaybe<Navia_Integracoes_Bool_Exp>;
};


export type Query_RootNavia_Integracoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNavia_LogArgs = {
  distinct_on?: InputMaybe<Array<Navia_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Log_Order_By>>;
  where?: InputMaybe<Navia_Log_Bool_Exp>;
};


export type Query_RootNavia_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Log_Order_By>>;
  where?: InputMaybe<Navia_Log_Bool_Exp>;
};


export type Query_RootNavia_Log_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNetwork_IntegrityArgs = {
  args: Network_Integrity_Arguments;
  distinct_on?: InputMaybe<Array<Network_Integrity_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Network_Integrity_Model_Order_By>>;
  where?: InputMaybe<Network_Integrity_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootNotificacoes_ItensArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Itens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Itens_Order_By>>;
  where?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
};


export type Query_RootNotificacoes_Itens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Itens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Itens_Order_By>>;
  where?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
};


export type Query_RootNotificacoes_Itens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNotificacoes_NotificacoesArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Notificacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Notificacoes_Order_By>>;
  where?: InputMaybe<Notificacoes_Notificacoes_Bool_Exp>;
};


export type Query_RootNotificacoes_Notificacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Notificacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Notificacoes_Order_By>>;
  where?: InputMaybe<Notificacoes_Notificacoes_Bool_Exp>;
};


export type Query_RootNotificacoes_Notificacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNotificacoes_Notificacoes_R_UtilizadoresArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
};


export type Query_RootNotificacoes_Notificacoes_R_Utilizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
};


export type Query_RootNotificacoes_Notificacoes_R_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNotificacoes_TiposArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Tipos_Order_By>>;
  where?: InputMaybe<Notificacoes_Tipos_Bool_Exp>;
};


export type Query_RootNotificacoes_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Tipos_Order_By>>;
  where?: InputMaybe<Notificacoes_Tipos_Bool_Exp>;
};


export type Query_RootNotificacoes_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPermissoes_TransacoesArgs = {
  distinct_on?: InputMaybe<Array<Permissoes_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissoes_Transacoes_Order_By>>;
  where?: InputMaybe<Permissoes_Transacoes_Bool_Exp>;
};


export type Query_RootPermissoes_Transacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissoes_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissoes_Transacoes_Order_By>>;
  where?: InputMaybe<Permissoes_Transacoes_Bool_Exp>;
};


export type Query_RootPermissoes_Transacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPermissoes_Transacoes_R_MenusArgs = {
  distinct_on?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Order_By>>;
  where?: InputMaybe<Permissoes_Transacoes_R_Menus_Bool_Exp>;
};


export type Query_RootPermissoes_Transacoes_R_Menus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Order_By>>;
  where?: InputMaybe<Permissoes_Transacoes_R_Menus_Bool_Exp>;
};


export type Query_RootPermissoes_Transacoes_R_Menus_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPipe_Readings_By_MaterialArgs = {
  args: Pipe_Readings_By_Material_Arguments;
  distinct_on?: InputMaybe<Array<Pipe_Readings_By_Material_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipe_Readings_By_Material_Model_Order_By>>;
  where?: InputMaybe<Pipe_Readings_By_Material_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootPipe_Rehabilitation_RateArgs = {
  args: Pipe_Rehabilitation_Rate_Arguments;
  distinct_on?: InputMaybe<Array<Pipe_Rehabilitation_Rate_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipe_Rehabilitation_Rate_Model_Order_By>>;
  where?: InputMaybe<Pipe_Rehabilitation_Rate_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootRequests_Act_ListArgs = {
  args: Requests_Act_List_Arguments;
  distinct_on?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Order_By>>;
  where?: InputMaybe<Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp>;
};


export type Query_RootRequests_Act_List_Without_LoginArgs = {
  args: Requests_Act_List_Without_Login_Arguments;
  distinct_on?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Order_By>>;
  where?: InputMaybe<Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp>;
};


export type Query_RootRequests_Danger_ListArgs = {
  args: Requests_Danger_List_Arguments;
  distinct_on?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Order_By>>;
  where?: InputMaybe<Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp>;
};


export type Query_RootRequests_Danger_List_Without_LoginArgs = {
  args: Requests_Danger_List_Without_Login_Arguments;
  distinct_on?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Order_By>>;
  where?: InputMaybe<Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp>;
};


export type Query_RootRqs_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Parametrizacao_Order_By>>;
  where?: InputMaybe<Rqs_Parametrizacao_Bool_Exp>;
};


export type Query_RootRqs_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Parametrizacao_Order_By>>;
  where?: InputMaybe<Rqs_Parametrizacao_Bool_Exp>;
};


export type Query_RootRqs_Requisicoes_PeriodosArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Order_By>>;
  where?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
};


export type Query_RootRqs_Requisicoes_Periodos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Order_By>>;
  where?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
};


export type Query_RootRqs_Requisicoes_Periodos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRqs_Requisicoes_Tempos_WrapArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Order_By>>;
  where?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Bool_Exp>;
};


export type Query_RootRqs_Requisicoes_Tempos_Wrap_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Order_By>>;
  where?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Bool_Exp>;
};


export type Query_RootRqs_Requisicoes_Tempos_Wrap_By_PkArgs = {
  id_requisicao: Scalars['bigint']['input'];
};


export type Query_RootRqs_SintomasArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
};


export type Query_RootRqs_Sintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
};


export type Query_RootRqs_Sintomas_By_PkArgs = {
  id_sintoma: Scalars['bigint']['input'];
};


export type Query_RootRqs_Sintomas_Parametrizacao_TemposArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>;
};


export type Query_RootRqs_Sintomas_Parametrizacao_Tempos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>;
};


export type Query_RootRqs_Sintomas_Parametrizacao_Tempos_By_PkArgs = {
  id_sintoma: Scalars['bigint']['input'];
};


export type Query_RootServicos_FasesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Fases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Fases_Order_By>>;
  where?: InputMaybe<Servicos_Fases_Bool_Exp>;
};


export type Query_RootServicos_Fases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Fases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Fases_Order_By>>;
  where?: InputMaybe<Servicos_Fases_Bool_Exp>;
};


export type Query_RootServicos_Fases_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServicos_IntervencoesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
};


export type Query_RootServicos_Intervencoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
};


export type Query_RootServicos_Intervencoes_Atribuicao_UtilizadoresArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp>;
};


export type Query_RootServicos_Intervencoes_Atribuicao_Utilizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp>;
};


export type Query_RootServicos_Intervencoes_Atribuicao_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServicos_Intervencoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServicos_Intervencoes_EstadosArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Estados_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Estados_Bool_Exp>;
};


export type Query_RootServicos_Intervencoes_Estados_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Estados_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Estados_Bool_Exp>;
};


export type Query_RootServicos_Intervencoes_Estados_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServicos_Intervencoes_R_Causas_TrabalhosArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
};


export type Query_RootServicos_Intervencoes_R_Causas_Trabalhos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
};


export type Query_RootServicos_Intervencoes_R_Causas_Trabalhos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServicos_RastreabilidadeArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Rastreabilidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Rastreabilidade_Order_By>>;
  where?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
};


export type Query_RootServicos_Rastreabilidade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Rastreabilidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Rastreabilidade_Order_By>>;
  where?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
};


export type Query_RootServicos_Rastreabilidade_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServicos_RequisicoesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
};


export type Query_RootServicos_Requisicoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
};


export type Query_RootServicos_Requisicoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServicos_Requisicoes_EstadosArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Estados_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Estados_Bool_Exp>;
};


export type Query_RootServicos_Requisicoes_Estados_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Estados_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Estados_Bool_Exp>;
};


export type Query_RootServicos_Requisicoes_Estados_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServicos_Requisicoes_Locais_Infra_EstruturasArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
};


export type Query_RootServicos_Requisicoes_Locais_Infra_Estruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
};


export type Query_RootServicos_Requisicoes_Locais_Infra_Estruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServicos_Requisicoes_R_IntervencoesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
};


export type Query_RootServicos_Requisicoes_R_Intervencoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
};


export type Query_RootServicos_Requisicoes_R_Intervencoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSintomas_ArvoreArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Arvore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Arvore_Order_By>>;
  where?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
};


export type Query_RootSintomas_Arvore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Arvore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Arvore_Order_By>>;
  where?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
};


export type Query_RootSintomas_Arvore_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSintomas_Causas_TrabalhosArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Order_By>>;
  where?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
};


export type Query_RootSintomas_Causas_Trabalhos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Order_By>>;
  where?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
};


export type Query_RootSintomas_Causas_Trabalhos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSintomas_Sintomas_RelacaoArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Order_By>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
};


export type Query_RootSintomas_Sintomas_Relacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Order_By>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
};


export type Query_RootSintomas_Sintomas_Relacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSintomas_Sintomas_Relacao_OrdemArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Ordem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Ordem_Order_By>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Bool_Exp>;
};


export type Query_RootSintomas_Sintomas_Relacao_Ordem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Ordem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Ordem_Order_By>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Bool_Exp>;
};


export type Query_RootSintomas_Sintomas_Relacao_Ordem_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTarefas_EstadosArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Estados_Order_By>>;
  where?: InputMaybe<Tarefas_Estados_Bool_Exp>;
};


export type Query_RootTarefas_Estados_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Estados_Order_By>>;
  where?: InputMaybe<Tarefas_Estados_Bool_Exp>;
};


export type Query_RootTarefas_Estados_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTarefas_IntervalosArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Intervalos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Intervalos_Order_By>>;
  where?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
};


export type Query_RootTarefas_Intervalos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Intervalos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Intervalos_Order_By>>;
  where?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
};


export type Query_RootTarefas_Intervalos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTarefas_Planos_PadraoArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Planos_Padrao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Planos_Padrao_Order_By>>;
  where?: InputMaybe<Tarefas_Planos_Padrao_Bool_Exp>;
};


export type Query_RootTarefas_Planos_Padrao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Planos_Padrao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Planos_Padrao_Order_By>>;
  where?: InputMaybe<Tarefas_Planos_Padrao_Bool_Exp>;
};


export type Query_RootTarefas_Planos_Padrao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTarefas_TarefasArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
};


export type Query_RootTarefas_Tarefas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
};


export type Query_RootTarefas_Tarefas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTarefas_Tarefas_R_Equipas_VirtuaisArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
};


export type Query_RootTarefas_Tarefas_R_Equipas_Virtuais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
};


export type Query_RootTarefas_Tarefas_R_Equipas_Virtuais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTarefas_Tarefas_R_InfraestruturasArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>;
};


export type Query_RootTarefas_Tarefas_R_Infraestruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>;
};


export type Query_RootTarefas_Tarefas_R_Infraestruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTop_5_Pipes_With_Most_LeaksArgs = {
  args: Top_5_Pipes_With_Most_Leaks_Arguments;
  distinct_on?: InputMaybe<Array<Top_5_Pipes_With_Most_Leaks_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Top_5_Pipes_With_Most_Leaks_Model_Order_By>>;
  where?: InputMaybe<Top_5_Pipes_With_Most_Leaks_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootTop_Five_Average_Duration_By_SymptomArgs = {
  args: Top_Five_Average_Duration_By_Symptom_Arguments;
  distinct_on?: InputMaybe<Array<Top_Five_Average_Duration_By_Symptom_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Top_Five_Average_Duration_By_Symptom_Return_Order_By>>;
  where?: InputMaybe<Top_Five_Average_Duration_By_Symptom_Return_Bool_Exp_Bool_Exp>;
};


export type Query_RootTop_Five_Average_Duration_By_Symptom_Without_LoginArgs = {
  args: Top_Five_Average_Duration_By_Symptom_Without_Login_Arguments;
  distinct_on?: InputMaybe<Array<Top_Five_Average_Duration_By_Symptom_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Top_Five_Average_Duration_By_Symptom_Return_Order_By>>;
  where?: InputMaybe<Top_Five_Average_Duration_By_Symptom_Return_Bool_Exp_Bool_Exp>;
};


export type Query_RootUser_AgendaArgs = {
  args: User_Agenda_Arguments;
  distinct_on?: InputMaybe<Array<User_Agenda_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Agenda_Model_Order_By>>;
  where?: InputMaybe<User_Agenda_Model_Bool_Exp_Bool_Exp>;
};


export type Query_RootUtilizadores_CategoriasArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Categorias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Categorias_Order_By>>;
  where?: InputMaybe<Utilizadores_Categorias_Bool_Exp>;
};


export type Query_RootUtilizadores_Categorias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Categorias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Categorias_Order_By>>;
  where?: InputMaybe<Utilizadores_Categorias_Bool_Exp>;
};


export type Query_RootUtilizadores_Categorias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_Equipas_VirtuaisArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_CentrosArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Centros_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Centros_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Equipas_VirtuaisArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Equipas_Virtuais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Equipas_Virtuais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_InfraestruturasArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Infraestruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Infraestruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_SintomaArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Sintoma_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Sintoma_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_ToponimiasArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Toponimias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Toponimias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_TransacoesArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Transacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Transacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_UtilizadoresArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Utilizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
};


export type Query_RootUtilizadores_Equipas_Virtuais_R_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_ExportacoesArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Exportacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Exportacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Exportacoes_Bool_Exp>;
};


export type Query_RootUtilizadores_Exportacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Exportacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Exportacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Exportacoes_Bool_Exp>;
};


export type Query_RootUtilizadores_Exportacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_Mapa_Posicao_CoresArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Mapa_Posicao_Cores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Mapa_Posicao_Cores_Order_By>>;
  where?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Bool_Exp>;
};


export type Query_RootUtilizadores_Mapa_Posicao_Cores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Mapa_Posicao_Cores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Mapa_Posicao_Cores_Order_By>>;
  where?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Bool_Exp>;
};


export type Query_RootUtilizadores_Mapa_Posicao_Cores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_MenuArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Menu_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Menu_Order_By>>;
  where?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
};


export type Query_RootUtilizadores_Menu_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Menu_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Menu_Order_By>>;
  where?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
};


export type Query_RootUtilizadores_Menu_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_TemasArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Temas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Temas_Order_By>>;
  where?: InputMaybe<Utilizadores_Temas_Bool_Exp>;
};


export type Query_RootUtilizadores_Temas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Temas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Temas_Order_By>>;
  where?: InputMaybe<Utilizadores_Temas_Bool_Exp>;
};


export type Query_RootUtilizadores_Temas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUtilizadores_UtilizadoresArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
};


export type Query_RootUtilizadores_Utilizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
};


export type Query_RootUtilizadores_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_AgregacaoArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Agregacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Agregacao_Order_By>>;
  where?: InputMaybe<Variaveis_Agregacao_Bool_Exp>;
};


export type Query_RootVariaveis_Agregacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Agregacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Agregacao_Order_By>>;
  where?: InputMaybe<Variaveis_Agregacao_Bool_Exp>;
};


export type Query_RootVariaveis_Agregacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_BaseArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Bool_Exp>;
};


export type Query_RootVariaveis_Base_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Bool_Exp>;
};


export type Query_RootVariaveis_Base_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Base_Calc_VariaveisArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Calc_Variaveis_Bool_Exp>;
};


export type Query_RootVariaveis_Base_Calc_Variaveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Calc_Variaveis_Bool_Exp>;
};


export type Query_RootVariaveis_Base_Calc_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Base_CategoriasArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Categorias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Categorias_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Categorias_Bool_Exp>;
};


export type Query_RootVariaveis_Base_Categorias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Categorias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Categorias_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Categorias_Bool_Exp>;
};


export type Query_RootVariaveis_Base_Categorias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Base_PropriedadesArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
};


export type Query_RootVariaveis_Base_Propriedades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
};


export type Query_RootVariaveis_Base_Propriedades_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Calc_VariaveisArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Calc_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Calc_Variaveis_Order_By>>;
  where?: InputMaybe<Variaveis_Calc_Variaveis_Bool_Exp>;
};


export type Query_RootVariaveis_Calc_Variaveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Calc_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Calc_Variaveis_Order_By>>;
  where?: InputMaybe<Variaveis_Calc_Variaveis_Bool_Exp>;
};


export type Query_RootVariaveis_Calc_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_DominiosArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_Bool_Exp>;
};


export type Query_RootVariaveis_Dominios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_Bool_Exp>;
};


export type Query_RootVariaveis_Dominios_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Dominios_R_Dominios_ValoresArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_R_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_R_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Bool_Exp>;
};


export type Query_RootVariaveis_Dominios_R_Dominios_Valores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_R_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_R_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Bool_Exp>;
};


export type Query_RootVariaveis_Dominios_R_Dominios_Valores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Dominios_ValoresArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_Valores_Bool_Exp>;
};


export type Query_RootVariaveis_Dominios_Valores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_Valores_Bool_Exp>;
};


export type Query_RootVariaveis_Dominios_Valores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Escalas_PrecisaoArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Escalas_Precisao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Escalas_Precisao_Order_By>>;
  where?: InputMaybe<Variaveis_Escalas_Precisao_Bool_Exp>;
};


export type Query_RootVariaveis_Escalas_Precisao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Escalas_Precisao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Escalas_Precisao_Order_By>>;
  where?: InputMaybe<Variaveis_Escalas_Precisao_Bool_Exp>;
};


export type Query_RootVariaveis_Escalas_Precisao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Fontes_OrigemArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Fontes_Origem_EstatisticaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Estatistica_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_Estatistica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Estatistica_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_Infraestrutura_EstatisticaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_Infraestrutura_Estatistica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_Plano_Padrao_EstatisticaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_Plano_Padrao_Estatistica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_PropriedadesArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_Propriedades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_Propriedades_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Fontes_Origem_TiposArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Tipos_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Tipos_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Bool_Exp>;
};


export type Query_RootVariaveis_Fontes_Origem_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_LeiturasArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};


export type Query_RootVariaveis_Leituras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};


export type Query_RootVariaveis_Leituras_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_ParametrosArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_Bool_Exp>;
};


export type Query_RootVariaveis_Parametros_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_Bool_Exp>;
};


export type Query_RootVariaveis_Parametros_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Parametros_R_Unidades_MedidaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
};


export type Query_RootVariaveis_Parametros_R_Unidades_Medida_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
};


export type Query_RootVariaveis_Parametros_R_Unidades_Medida_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_TiposArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Tipos_Order_By>>;
  where?: InputMaybe<Variaveis_Tipos_Bool_Exp>;
};


export type Query_RootVariaveis_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Tipos_Order_By>>;
  where?: InputMaybe<Variaveis_Tipos_Bool_Exp>;
};


export type Query_RootVariaveis_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Totalizadores_Tipos_RegistoArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Totalizadores_Tipos_Registo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Totalizadores_Tipos_Registo_Order_By>>;
  where?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Bool_Exp>;
};


export type Query_RootVariaveis_Totalizadores_Tipos_Registo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Totalizadores_Tipos_Registo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Totalizadores_Tipos_Registo_Order_By>>;
  where?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Bool_Exp>;
};


export type Query_RootVariaveis_Totalizadores_Tipos_Registo_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Unidades_MedidaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
};


export type Query_RootVariaveis_Unidades_Medida_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
};


export type Query_RootVariaveis_Unidades_Medida_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootVariaveis_Valores_MensaisArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Valores_Mensais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Valores_Mensais_Order_By>>;
  where?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
};


export type Query_RootVariaveis_Valores_Mensais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Valores_Mensais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Valores_Mensais_Order_By>>;
  where?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
};


export type Query_RootVariaveis_Valores_Mensais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootZmc_Leaks_CountArgs = {
  args: Zmc_Leaks_Count_Arguments;
  distinct_on?: InputMaybe<Array<Zmc_Leaks_Count_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zmc_Leaks_Count_Model_Order_By>>;
  where?: InputMaybe<Zmc_Leaks_Count_Model_Bool_Exp_Bool_Exp>;
};

export type Requests_Act_And_Danger_List_Return = {
  __typename?: 'requests_act_and_danger_list_return';
  id_frequency_time_limit_response?: Maybe<Scalars['bigint']['output']>;
  id_frequency_time_notification_response?: Maybe<Scalars['bigint']['output']>;
  request_address?: Maybe<Scalars['String']['output']>;
  request_infrastructure?: Maybe<Scalars['String']['output']>;
  request_number?: Maybe<Scalars['String']['output']>;
  symptom?: Maybe<Scalars['String']['output']>;
  time_limit_response_seconds?: Maybe<Scalars['bigint']['output']>;
  time_notification_seconds?: Maybe<Scalars['bigint']['output']>;
  time_over_in_seconds?: Maybe<Scalars['Int']['output']>;
  time_passed_in_seconds?: Maybe<Scalars['Int']['output']>;
  time_remaining_in_seconds?: Maybe<Scalars['Int']['output']>;
  total_results?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the logical model for "requests_act_and_danger_list_return". All fields are combined with a logical 'AND'. */
export type Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp>>;
  id_frequency_time_limit_response?: InputMaybe<Bigint_Comparison_Exp>;
  id_frequency_time_notification_response?: InputMaybe<Bigint_Comparison_Exp>;
  request_address?: InputMaybe<String_Comparison_Exp>;
  request_infrastructure?: InputMaybe<String_Comparison_Exp>;
  request_number?: InputMaybe<String_Comparison_Exp>;
  symptom?: InputMaybe<String_Comparison_Exp>;
  time_limit_response_seconds?: InputMaybe<Bigint_Comparison_Exp>;
  time_notification_seconds?: InputMaybe<Bigint_Comparison_Exp>;
  time_over_in_seconds?: InputMaybe<Int_Comparison_Exp>;
  time_passed_in_seconds?: InputMaybe<Int_Comparison_Exp>;
  time_remaining_in_seconds?: InputMaybe<Int_Comparison_Exp>;
  total_results?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Requests_Act_And_Danger_List_Return_Enum_Name {
  /** column name */
  IdFrequencyTimeLimitResponse = 'id_frequency_time_limit_response',
  /** column name */
  IdFrequencyTimeNotificationResponse = 'id_frequency_time_notification_response',
  /** column name */
  RequestAddress = 'request_address',
  /** column name */
  RequestInfrastructure = 'request_infrastructure',
  /** column name */
  RequestNumber = 'request_number',
  /** column name */
  Symptom = 'symptom',
  /** column name */
  TimeLimitResponseSeconds = 'time_limit_response_seconds',
  /** column name */
  TimeNotificationSeconds = 'time_notification_seconds',
  /** column name */
  TimeOverInSeconds = 'time_over_in_seconds',
  /** column name */
  TimePassedInSeconds = 'time_passed_in_seconds',
  /** column name */
  TimeRemainingInSeconds = 'time_remaining_in_seconds',
  /** column name */
  TotalResults = 'total_results'
}

/** Ordering options when selecting data from "requests_act_and_danger_list_return". */
export type Requests_Act_And_Danger_List_Return_Order_By = {
  id_frequency_time_limit_response?: InputMaybe<Order_By>;
  id_frequency_time_notification_response?: InputMaybe<Order_By>;
  request_address?: InputMaybe<Order_By>;
  request_infrastructure?: InputMaybe<Order_By>;
  request_number?: InputMaybe<Order_By>;
  symptom?: InputMaybe<Order_By>;
  time_limit_response_seconds?: InputMaybe<Order_By>;
  time_notification_seconds?: InputMaybe<Order_By>;
  time_over_in_seconds?: InputMaybe<Order_By>;
  time_passed_in_seconds?: InputMaybe<Order_By>;
  time_remaining_in_seconds?: InputMaybe<Order_By>;
  total_results?: InputMaybe<Order_By>;
};

/** requests_act_listNative Query Arguments */
export type Requests_Act_List_Arguments = {
  first_day_of_year: Scalars['date']['input'];
  id_user: Scalars['Int']['input'];
  last_day_of_year: Scalars['date']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

/** requests_act_list_without_loginNative Query Arguments */
export type Requests_Act_List_Without_Login_Arguments = {
  first_day_of_year: Scalars['date']['input'];
  last_day_of_year: Scalars['date']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

/** requests_danger_listNative Query Arguments */
export type Requests_Danger_List_Arguments = {
  first_day_of_year: Scalars['date']['input'];
  id_user: Scalars['Int']['input'];
  last_day_of_year: Scalars['date']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

/** requests_danger_list_without_loginNative Query Arguments */
export type Requests_Danger_List_Without_Login_Arguments = {
  first_day_of_year: Scalars['date']['input'];
  last_day_of_year: Scalars['date']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

/** columns and relationships of "rqs.parametrizacao" */
export type Rqs_Parametrizacao = {
  __typename?: 'rqs_parametrizacao';
  data_inicio?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "rqs.parametrizacao" */
export type Rqs_Parametrizacao_Aggregate = {
  __typename?: 'rqs_parametrizacao_aggregate';
  aggregate?: Maybe<Rqs_Parametrizacao_Aggregate_Fields>;
  nodes: Array<Rqs_Parametrizacao>;
};

/** aggregate fields of "rqs.parametrizacao" */
export type Rqs_Parametrizacao_Aggregate_Fields = {
  __typename?: 'rqs_parametrizacao_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Rqs_Parametrizacao_Max_Fields>;
  min?: Maybe<Rqs_Parametrizacao_Min_Fields>;
};


/** aggregate fields of "rqs.parametrizacao" */
export type Rqs_Parametrizacao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rqs_Parametrizacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "rqs.parametrizacao". All fields are combined with a logical 'AND'. */
export type Rqs_Parametrizacao_Bool_Exp = {
  _and?: InputMaybe<Array<Rqs_Parametrizacao_Bool_Exp>>;
  _not?: InputMaybe<Rqs_Parametrizacao_Bool_Exp>;
  _or?: InputMaybe<Array<Rqs_Parametrizacao_Bool_Exp>>;
  data_inicio?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** input type for inserting data into table "rqs.parametrizacao" */
export type Rqs_Parametrizacao_Insert_Input = {
  data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Rqs_Parametrizacao_Max_Fields = {
  __typename?: 'rqs_parametrizacao_max_fields';
  data_inicio?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Rqs_Parametrizacao_Min_Fields = {
  __typename?: 'rqs_parametrizacao_min_fields';
  data_inicio?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "rqs.parametrizacao" */
export type Rqs_Parametrizacao_Mutation_Response = {
  __typename?: 'rqs_parametrizacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rqs_Parametrizacao>;
};

/** Ordering options when selecting data from "rqs.parametrizacao". */
export type Rqs_Parametrizacao_Order_By = {
  data_inicio?: InputMaybe<Order_By>;
};

/** select columns of table "rqs.parametrizacao" */
export enum Rqs_Parametrizacao_Select_Column {
  /** column name */
  DataInicio = 'data_inicio'
}

/** input type for updating data in table "rqs.parametrizacao" */
export type Rqs_Parametrizacao_Set_Input = {
  data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "rqs_parametrizacao" */
export type Rqs_Parametrizacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rqs_Parametrizacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rqs_Parametrizacao_Stream_Cursor_Value_Input = {
  data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
};

export type Rqs_Parametrizacao_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rqs_Parametrizacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rqs_Parametrizacao_Bool_Exp;
};

/** columns and relationships of "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos = {
  __typename?: 'rqs_requisicoes_periodos';
  apagado: Scalars['Boolean']['output'];
  data_hora_fim?: Maybe<Scalars['timestamp']['output']>;
  data_hora_inicio: Scalars['timestamp']['output'];
  data_hora_registo_bd: Scalars['timestamp']['output'];
  data_hora_ultima_atualizacao: Scalars['timestamp']['output'];
  id: Scalars['bigint']['output'];
  id_requisicao: Scalars['bigint']['output'];
  interrupcao_validada: Scalars['Boolean']['output'];
  motivo?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  requisicao: Servicos_Requisicoes;
};

/** aggregated selection of "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Aggregate = {
  __typename?: 'rqs_requisicoes_periodos_aggregate';
  aggregate?: Maybe<Rqs_Requisicoes_Periodos_Aggregate_Fields>;
  nodes: Array<Rqs_Requisicoes_Periodos>;
};

export type Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp_Count>;
};

export type Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp_Bool_And = {
  arguments: Rqs_Requisicoes_Periodos_Select_Column_Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Rqs_Requisicoes_Periodos_Select_Column_Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Aggregate_Fields = {
  __typename?: 'rqs_requisicoes_periodos_aggregate_fields';
  avg?: Maybe<Rqs_Requisicoes_Periodos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Rqs_Requisicoes_Periodos_Max_Fields>;
  min?: Maybe<Rqs_Requisicoes_Periodos_Min_Fields>;
  stddev?: Maybe<Rqs_Requisicoes_Periodos_Stddev_Fields>;
  stddev_pop?: Maybe<Rqs_Requisicoes_Periodos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rqs_Requisicoes_Periodos_Stddev_Samp_Fields>;
  sum?: Maybe<Rqs_Requisicoes_Periodos_Sum_Fields>;
  var_pop?: Maybe<Rqs_Requisicoes_Periodos_Var_Pop_Fields>;
  var_samp?: Maybe<Rqs_Requisicoes_Periodos_Var_Samp_Fields>;
  variance?: Maybe<Rqs_Requisicoes_Periodos_Variance_Fields>;
};


/** aggregate fields of "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Aggregate_Order_By = {
  avg?: InputMaybe<Rqs_Requisicoes_Periodos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rqs_Requisicoes_Periodos_Max_Order_By>;
  min?: InputMaybe<Rqs_Requisicoes_Periodos_Min_Order_By>;
  stddev?: InputMaybe<Rqs_Requisicoes_Periodos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rqs_Requisicoes_Periodos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rqs_Requisicoes_Periodos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rqs_Requisicoes_Periodos_Sum_Order_By>;
  var_pop?: InputMaybe<Rqs_Requisicoes_Periodos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rqs_Requisicoes_Periodos_Var_Samp_Order_By>;
  variance?: InputMaybe<Rqs_Requisicoes_Periodos_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Arr_Rel_Insert_Input = {
  data: Array<Rqs_Requisicoes_Periodos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Rqs_Requisicoes_Periodos_On_Conflict>;
};

/** aggregate avg on columns */
export type Rqs_Requisicoes_Periodos_Avg_Fields = {
  __typename?: 'rqs_requisicoes_periodos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rqs.requisicoes_periodos". All fields are combined with a logical 'AND'. */
export type Rqs_Requisicoes_Periodos_Bool_Exp = {
  _and?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Bool_Exp>>;
  _not?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
  _or?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  data_hora_fim?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_inicio?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_registo_bd?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_ultima_atualizacao?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_requisicao?: InputMaybe<Bigint_Comparison_Exp>;
  interrupcao_validada?: InputMaybe<Boolean_Comparison_Exp>;
  motivo?: InputMaybe<String_Comparison_Exp>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
};

/** unique or primary key constraints on table "rqs.requisicoes_periodos" */
export enum Rqs_Requisicoes_Periodos_Constraint {
  /** unique or primary key constraint on columns "id" */
  RequisicoesPeriodosPkey = 'requisicoes_periodos_pkey'
}

/** input type for incrementing numeric columns in table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora_fim?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  interrupcao_validada?: InputMaybe<Scalars['Boolean']['input']>;
  motivo?: InputMaybe<Scalars['String']['input']>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Rqs_Requisicoes_Periodos_Max_Fields = {
  __typename?: 'rqs_requisicoes_periodos_max_fields';
  data_hora_fim?: Maybe<Scalars['timestamp']['output']>;
  data_hora_inicio?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  motivo?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Max_Order_By = {
  data_hora_fim?: InputMaybe<Order_By>;
  data_hora_inicio?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  motivo?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Rqs_Requisicoes_Periodos_Min_Fields = {
  __typename?: 'rqs_requisicoes_periodos_min_fields';
  data_hora_fim?: Maybe<Scalars['timestamp']['output']>;
  data_hora_inicio?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  motivo?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Min_Order_By = {
  data_hora_fim?: InputMaybe<Order_By>;
  data_hora_inicio?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  motivo?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Mutation_Response = {
  __typename?: 'rqs_requisicoes_periodos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rqs_Requisicoes_Periodos>;
};

/** on_conflict condition type for table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_On_Conflict = {
  constraint: Rqs_Requisicoes_Periodos_Constraint;
  update_columns?: Array<Rqs_Requisicoes_Periodos_Update_Column>;
  where?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
};

/** Ordering options when selecting data from "rqs.requisicoes_periodos". */
export type Rqs_Requisicoes_Periodos_Order_By = {
  apagado?: InputMaybe<Order_By>;
  data_hora_fim?: InputMaybe<Order_By>;
  data_hora_inicio?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  interrupcao_validada?: InputMaybe<Order_By>;
  motivo?: InputMaybe<Order_By>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Order_By>;
};

/** primary key columns input for table: rqs.requisicoes_periodos */
export type Rqs_Requisicoes_Periodos_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "rqs.requisicoes_periodos" */
export enum Rqs_Requisicoes_Periodos_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHoraFim = 'data_hora_fim',
  /** column name */
  DataHoraInicio = 'data_hora_inicio',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaAtualizacao = 'data_hora_ultima_atualizacao',
  /** column name */
  Id = 'id',
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  InterrupcaoValidada = 'interrupcao_validada',
  /** column name */
  Motivo = 'motivo'
}

/** select "rqs_requisicoes_periodos_aggregate_bool_exp_bool_and_arguments_columns" columns of table "rqs.requisicoes_periodos" */
export enum Rqs_Requisicoes_Periodos_Select_Column_Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  InterrupcaoValidada = 'interrupcao_validada'
}

/** select "rqs_requisicoes_periodos_aggregate_bool_exp_bool_or_arguments_columns" columns of table "rqs.requisicoes_periodos" */
export enum Rqs_Requisicoes_Periodos_Select_Column_Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  InterrupcaoValidada = 'interrupcao_validada'
}

/** input type for updating data in table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora_fim?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  interrupcao_validada?: InputMaybe<Scalars['Boolean']['input']>;
  motivo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Rqs_Requisicoes_Periodos_Stddev_Fields = {
  __typename?: 'rqs_requisicoes_periodos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Rqs_Requisicoes_Periodos_Stddev_Pop_Fields = {
  __typename?: 'rqs_requisicoes_periodos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Rqs_Requisicoes_Periodos_Stddev_Samp_Fields = {
  __typename?: 'rqs_requisicoes_periodos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rqs_requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rqs_Requisicoes_Periodos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rqs_Requisicoes_Periodos_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora_fim?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  interrupcao_validada?: InputMaybe<Scalars['Boolean']['input']>;
  motivo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Rqs_Requisicoes_Periodos_Sum_Fields = {
  __typename?: 'rqs_requisicoes_periodos_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
};

/** update columns of table "rqs.requisicoes_periodos" */
export enum Rqs_Requisicoes_Periodos_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHoraFim = 'data_hora_fim',
  /** column name */
  DataHoraInicio = 'data_hora_inicio',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaAtualizacao = 'data_hora_ultima_atualizacao',
  /** column name */
  Id = 'id',
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  InterrupcaoValidada = 'interrupcao_validada',
  /** column name */
  Motivo = 'motivo'
}

export type Rqs_Requisicoes_Periodos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rqs_Requisicoes_Periodos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rqs_Requisicoes_Periodos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rqs_Requisicoes_Periodos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rqs_Requisicoes_Periodos_Var_Pop_Fields = {
  __typename?: 'rqs_requisicoes_periodos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Rqs_Requisicoes_Periodos_Var_Samp_Fields = {
  __typename?: 'rqs_requisicoes_periodos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Rqs_Requisicoes_Periodos_Variance_Fields = {
  __typename?: 'rqs_requisicoes_periodos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "rqs.requisicoes_periodos" */
export type Rqs_Requisicoes_Periodos_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
};

/** columns and relationships of "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap = {
  __typename?: 'rqs_requisicoes_tempos_wrap';
  id_requisicao: Scalars['bigint']['output'];
  /** An object relationship */
  requisicao: Servicos_Requisicoes;
  time_in_seconds?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Aggregate = {
  __typename?: 'rqs_requisicoes_tempos_wrap_aggregate';
  aggregate?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Aggregate_Fields>;
  nodes: Array<Rqs_Requisicoes_Tempos_Wrap>;
};

/** aggregate fields of "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Aggregate_Fields = {
  __typename?: 'rqs_requisicoes_tempos_wrap_aggregate_fields';
  avg?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Max_Fields>;
  min?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Min_Fields>;
  stddev?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Stddev_Fields>;
  stddev_pop?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Stddev_Samp_Fields>;
  sum?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Sum_Fields>;
  var_pop?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Var_Pop_Fields>;
  var_samp?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Var_Samp_Fields>;
  variance?: Maybe<Rqs_Requisicoes_Tempos_Wrap_Variance_Fields>;
};


/** aggregate fields of "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Aggregate_Order_By = {
  avg?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Max_Order_By>;
  min?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Min_Order_By>;
  stddev?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Sum_Order_By>;
  var_pop?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Var_Samp_Order_By>;
  variance?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Rqs_Requisicoes_Tempos_Wrap_Avg_Fields = {
  __typename?: 'rqs_requisicoes_tempos_wrap_avg_fields';
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  time_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Avg_Order_By = {
  id_requisicao?: InputMaybe<Order_By>;
  time_in_seconds?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rqs.requisicoes_tempos_wrap". All fields are combined with a logical 'AND'. */
export type Rqs_Requisicoes_Tempos_Wrap_Bool_Exp = {
  _and?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Bool_Exp>>;
  _not?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Bool_Exp>;
  _or?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Bool_Exp>>;
  id_requisicao?: InputMaybe<Bigint_Comparison_Exp>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
  time_in_seconds?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "rqs.requisicoes_tempos_wrap" */
export enum Rqs_Requisicoes_Tempos_Wrap_Constraint {
  /** unique or primary key constraint on columns "id_requisicao" */
  RequisicoesTemposWrapPkey = 'requisicoes_tempos_wrap_pkey'
}

/** input type for incrementing numeric columns in table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Inc_Input = {
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  time_in_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Insert_Input = {
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Obj_Rel_Insert_Input>;
  time_in_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Rqs_Requisicoes_Tempos_Wrap_Max_Fields = {
  __typename?: 'rqs_requisicoes_tempos_wrap_max_fields';
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  time_in_seconds?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Max_Order_By = {
  id_requisicao?: InputMaybe<Order_By>;
  time_in_seconds?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Rqs_Requisicoes_Tempos_Wrap_Min_Fields = {
  __typename?: 'rqs_requisicoes_tempos_wrap_min_fields';
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  time_in_seconds?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Min_Order_By = {
  id_requisicao?: InputMaybe<Order_By>;
  time_in_seconds?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Mutation_Response = {
  __typename?: 'rqs_requisicoes_tempos_wrap_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rqs_Requisicoes_Tempos_Wrap>;
};

/** on_conflict condition type for table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_On_Conflict = {
  constraint: Rqs_Requisicoes_Tempos_Wrap_Constraint;
  update_columns?: Array<Rqs_Requisicoes_Tempos_Wrap_Update_Column>;
  where?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Bool_Exp>;
};

/** Ordering options when selecting data from "rqs.requisicoes_tempos_wrap". */
export type Rqs_Requisicoes_Tempos_Wrap_Order_By = {
  id_requisicao?: InputMaybe<Order_By>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Order_By>;
  time_in_seconds?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rqs.requisicoes_tempos_wrap */
export type Rqs_Requisicoes_Tempos_Wrap_Pk_Columns_Input = {
  id_requisicao: Scalars['bigint']['input'];
};

/** select columns of table "rqs.requisicoes_tempos_wrap" */
export enum Rqs_Requisicoes_Tempos_Wrap_Select_Column {
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  TimeInSeconds = 'time_in_seconds'
}

/** input type for updating data in table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Set_Input = {
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  time_in_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Rqs_Requisicoes_Tempos_Wrap_Stddev_Fields = {
  __typename?: 'rqs_requisicoes_tempos_wrap_stddev_fields';
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  time_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Stddev_Order_By = {
  id_requisicao?: InputMaybe<Order_By>;
  time_in_seconds?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Rqs_Requisicoes_Tempos_Wrap_Stddev_Pop_Fields = {
  __typename?: 'rqs_requisicoes_tempos_wrap_stddev_pop_fields';
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  time_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Stddev_Pop_Order_By = {
  id_requisicao?: InputMaybe<Order_By>;
  time_in_seconds?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Rqs_Requisicoes_Tempos_Wrap_Stddev_Samp_Fields = {
  __typename?: 'rqs_requisicoes_tempos_wrap_stddev_samp_fields';
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  time_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Stddev_Samp_Order_By = {
  id_requisicao?: InputMaybe<Order_By>;
  time_in_seconds?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rqs_requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rqs_Requisicoes_Tempos_Wrap_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rqs_Requisicoes_Tempos_Wrap_Stream_Cursor_Value_Input = {
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  time_in_seconds?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Rqs_Requisicoes_Tempos_Wrap_Sum_Fields = {
  __typename?: 'rqs_requisicoes_tempos_wrap_sum_fields';
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  time_in_seconds?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Sum_Order_By = {
  id_requisicao?: InputMaybe<Order_By>;
  time_in_seconds?: InputMaybe<Order_By>;
};

/** update columns of table "rqs.requisicoes_tempos_wrap" */
export enum Rqs_Requisicoes_Tempos_Wrap_Update_Column {
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  TimeInSeconds = 'time_in_seconds'
}

export type Rqs_Requisicoes_Tempos_Wrap_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rqs_Requisicoes_Tempos_Wrap_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rqs_Requisicoes_Tempos_Wrap_Var_Pop_Fields = {
  __typename?: 'rqs_requisicoes_tempos_wrap_var_pop_fields';
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  time_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Var_Pop_Order_By = {
  id_requisicao?: InputMaybe<Order_By>;
  time_in_seconds?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Rqs_Requisicoes_Tempos_Wrap_Var_Samp_Fields = {
  __typename?: 'rqs_requisicoes_tempos_wrap_var_samp_fields';
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  time_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Var_Samp_Order_By = {
  id_requisicao?: InputMaybe<Order_By>;
  time_in_seconds?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Rqs_Requisicoes_Tempos_Wrap_Variance_Fields = {
  __typename?: 'rqs_requisicoes_tempos_wrap_variance_fields';
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  time_in_seconds?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "rqs.requisicoes_tempos_wrap" */
export type Rqs_Requisicoes_Tempos_Wrap_Variance_Order_By = {
  id_requisicao?: InputMaybe<Order_By>;
  time_in_seconds?: InputMaybe<Order_By>;
};

/** columns and relationships of "rqs.sintomas" */
export type Rqs_Sintomas = {
  __typename?: 'rqs_sintomas';
  apagado: Scalars['Boolean']['output'];
  /** An object relationship */
  arvore: Sintomas_Arvore;
  data_hora_registo_db: Scalars['timestamptz']['output'];
  data_hora_ultima_atualizacao: Scalars['timestamptz']['output'];
  id_sintoma: Scalars['bigint']['output'];
  /** An array relationship */
  requisicoes: Array<Servicos_Requisicoes>;
  /** An aggregate relationship */
  requisicoes_aggregate: Servicos_Requisicoes_Aggregate;
};


/** columns and relationships of "rqs.sintomas" */
export type Rqs_SintomasRequisicoesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
};


/** columns and relationships of "rqs.sintomas" */
export type Rqs_SintomasRequisicoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
};

/** aggregated selection of "rqs.sintomas" */
export type Rqs_Sintomas_Aggregate = {
  __typename?: 'rqs_sintomas_aggregate';
  aggregate?: Maybe<Rqs_Sintomas_Aggregate_Fields>;
  nodes: Array<Rqs_Sintomas>;
};

export type Rqs_Sintomas_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Rqs_Sintomas_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Rqs_Sintomas_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Rqs_Sintomas_Aggregate_Bool_Exp_Count>;
};

export type Rqs_Sintomas_Aggregate_Bool_Exp_Bool_And = {
  arguments: Rqs_Sintomas_Select_Column_Rqs_Sintomas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Rqs_Sintomas_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Rqs_Sintomas_Select_Column_Rqs_Sintomas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Rqs_Sintomas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Rqs_Sintomas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "rqs.sintomas" */
export type Rqs_Sintomas_Aggregate_Fields = {
  __typename?: 'rqs_sintomas_aggregate_fields';
  avg?: Maybe<Rqs_Sintomas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Rqs_Sintomas_Max_Fields>;
  min?: Maybe<Rqs_Sintomas_Min_Fields>;
  stddev?: Maybe<Rqs_Sintomas_Stddev_Fields>;
  stddev_pop?: Maybe<Rqs_Sintomas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rqs_Sintomas_Stddev_Samp_Fields>;
  sum?: Maybe<Rqs_Sintomas_Sum_Fields>;
  var_pop?: Maybe<Rqs_Sintomas_Var_Pop_Fields>;
  var_samp?: Maybe<Rqs_Sintomas_Var_Samp_Fields>;
  variance?: Maybe<Rqs_Sintomas_Variance_Fields>;
};


/** aggregate fields of "rqs.sintomas" */
export type Rqs_Sintomas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rqs_Sintomas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rqs.sintomas" */
export type Rqs_Sintomas_Aggregate_Order_By = {
  avg?: InputMaybe<Rqs_Sintomas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rqs_Sintomas_Max_Order_By>;
  min?: InputMaybe<Rqs_Sintomas_Min_Order_By>;
  stddev?: InputMaybe<Rqs_Sintomas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rqs_Sintomas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rqs_Sintomas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rqs_Sintomas_Sum_Order_By>;
  var_pop?: InputMaybe<Rqs_Sintomas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rqs_Sintomas_Var_Samp_Order_By>;
  variance?: InputMaybe<Rqs_Sintomas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "rqs.sintomas" */
export type Rqs_Sintomas_Arr_Rel_Insert_Input = {
  data: Array<Rqs_Sintomas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Rqs_Sintomas_On_Conflict>;
};

/** aggregate avg on columns */
export type Rqs_Sintomas_Avg_Fields = {
  __typename?: 'rqs_sintomas_avg_fields';
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "rqs.sintomas" */
export type Rqs_Sintomas_Avg_Order_By = {
  id_sintoma?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rqs.sintomas". All fields are combined with a logical 'AND'. */
export type Rqs_Sintomas_Bool_Exp = {
  _and?: InputMaybe<Array<Rqs_Sintomas_Bool_Exp>>;
  _not?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
  _or?: InputMaybe<Array<Rqs_Sintomas_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  arvore?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  data_hora_registo_db?: InputMaybe<Timestamptz_Comparison_Exp>;
  data_hora_ultima_atualizacao?: InputMaybe<Timestamptz_Comparison_Exp>;
  id_sintoma?: InputMaybe<Bigint_Comparison_Exp>;
  requisicoes?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
  requisicoes_aggregate?: InputMaybe<Servicos_Requisicoes_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "rqs.sintomas" */
export enum Rqs_Sintomas_Constraint {
  /** unique or primary key constraint on columns "id_sintoma" */
  SintomasPkey = 'sintomas_pkey'
}

/** input type for incrementing numeric columns in table "rqs.sintomas" */
export type Rqs_Sintomas_Inc_Input = {
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "rqs.sintomas" */
export type Rqs_Sintomas_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  arvore?: InputMaybe<Sintomas_Arvore_Obj_Rel_Insert_Input>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamptz']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  requisicoes?: InputMaybe<Servicos_Requisicoes_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Rqs_Sintomas_Max_Fields = {
  __typename?: 'rqs_sintomas_max_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  data_hora_ultima_atualizacao?: Maybe<Scalars['timestamptz']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "rqs.sintomas" */
export type Rqs_Sintomas_Max_Order_By = {
  data_hora_registo_db?: InputMaybe<Order_By>;
  data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Rqs_Sintomas_Min_Fields = {
  __typename?: 'rqs_sintomas_min_fields';
  data_hora_registo_db?: Maybe<Scalars['timestamptz']['output']>;
  data_hora_ultima_atualizacao?: Maybe<Scalars['timestamptz']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "rqs.sintomas" */
export type Rqs_Sintomas_Min_Order_By = {
  data_hora_registo_db?: InputMaybe<Order_By>;
  data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rqs.sintomas" */
export type Rqs_Sintomas_Mutation_Response = {
  __typename?: 'rqs_sintomas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rqs_Sintomas>;
};

/** on_conflict condition type for table "rqs.sintomas" */
export type Rqs_Sintomas_On_Conflict = {
  constraint: Rqs_Sintomas_Constraint;
  update_columns?: Array<Rqs_Sintomas_Update_Column>;
  where?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
};

/** Ordering options when selecting data from "rqs.sintomas". */
export type Rqs_Sintomas_Order_By = {
  apagado?: InputMaybe<Order_By>;
  arvore?: InputMaybe<Sintomas_Arvore_Order_By>;
  data_hora_registo_db?: InputMaybe<Order_By>;
  data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  requisicoes_aggregate?: InputMaybe<Servicos_Requisicoes_Aggregate_Order_By>;
};

/** columns and relationships of "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos';
  /** An object relationship */
  arvore: Sintomas_Arvore;
  data_hora_registo_bd: Scalars['timestamp']['output'];
  data_hora_ultima_atualizacao: Scalars['timestamp']['output'];
  id_frequencia_tempo_limite_resposta: Scalars['bigint']['output'];
  id_frequencia_tempo_notificacao: Scalars['bigint']['output'];
  id_sintoma: Scalars['bigint']['output'];
  tempo_limite_resposta: Scalars['bigint']['output'];
  tempo_notificacao: Scalars['bigint']['output'];
};

/** aggregated selection of "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Aggregate = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_aggregate';
  aggregate?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Aggregate_Fields>;
  nodes: Array<Rqs_Sintomas_Parametrizacao_Tempos>;
};

export type Rqs_Sintomas_Parametrizacao_Tempos_Aggregate_Bool_Exp = {
  count?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Aggregate_Bool_Exp_Count>;
};

export type Rqs_Sintomas_Parametrizacao_Tempos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Aggregate_Fields = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_aggregate_fields';
  avg?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Max_Fields>;
  min?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Min_Fields>;
  stddev?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Fields>;
  stddev_pop?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Samp_Fields>;
  sum?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Sum_Fields>;
  var_pop?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Var_Pop_Fields>;
  var_samp?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Var_Samp_Fields>;
  variance?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos_Variance_Fields>;
};


/** aggregate fields of "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Aggregate_Order_By = {
  avg?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Max_Order_By>;
  min?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Min_Order_By>;
  stddev?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Sum_Order_By>;
  var_pop?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Var_Samp_Order_By>;
  variance?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Arr_Rel_Insert_Input = {
  data: Array<Rqs_Sintomas_Parametrizacao_Tempos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_On_Conflict>;
};

/** aggregate avg on columns */
export type Rqs_Sintomas_Parametrizacao_Tempos_Avg_Fields = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_avg_fields';
  id_frequencia_tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  id_frequencia_tempo_notificacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  tempo_notificacao?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Avg_Order_By = {
  id_frequencia_tempo_limite_resposta?: InputMaybe<Order_By>;
  id_frequencia_tempo_notificacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  tempo_limite_resposta?: InputMaybe<Order_By>;
  tempo_notificacao?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rqs.sintomas_parametrizacao_tempos". All fields are combined with a logical 'AND'. */
export type Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp = {
  _and?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>>;
  _not?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>;
  _or?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>>;
  arvore?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  data_hora_registo_bd?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_ultima_atualizacao?: InputMaybe<Timestamp_Comparison_Exp>;
  id_frequencia_tempo_limite_resposta?: InputMaybe<Bigint_Comparison_Exp>;
  id_frequencia_tempo_notificacao?: InputMaybe<Bigint_Comparison_Exp>;
  id_sintoma?: InputMaybe<Bigint_Comparison_Exp>;
  tempo_limite_resposta?: InputMaybe<Bigint_Comparison_Exp>;
  tempo_notificacao?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "rqs.sintomas_parametrizacao_tempos" */
export enum Rqs_Sintomas_Parametrizacao_Tempos_Constraint {
  /** unique or primary key constraint on columns "id_sintoma" */
  SintomasParametrizacaoTemposPkey = 'sintomas_parametrizacao_tempos_pkey'
}

/** input type for incrementing numeric columns in table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Inc_Input = {
  id_frequencia_tempo_limite_resposta?: InputMaybe<Scalars['bigint']['input']>;
  id_frequencia_tempo_notificacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  tempo_limite_resposta?: InputMaybe<Scalars['bigint']['input']>;
  tempo_notificacao?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Insert_Input = {
  arvore?: InputMaybe<Sintomas_Arvore_Obj_Rel_Insert_Input>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  id_frequencia_tempo_limite_resposta?: InputMaybe<Scalars['bigint']['input']>;
  id_frequencia_tempo_notificacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  tempo_limite_resposta?: InputMaybe<Scalars['bigint']['input']>;
  tempo_notificacao?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Rqs_Sintomas_Parametrizacao_Tempos_Max_Fields = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_max_fields';
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  id_frequencia_tempo_limite_resposta?: Maybe<Scalars['bigint']['output']>;
  id_frequencia_tempo_notificacao?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  tempo_limite_resposta?: Maybe<Scalars['bigint']['output']>;
  tempo_notificacao?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Max_Order_By = {
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  id_frequencia_tempo_limite_resposta?: InputMaybe<Order_By>;
  id_frequencia_tempo_notificacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  tempo_limite_resposta?: InputMaybe<Order_By>;
  tempo_notificacao?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Rqs_Sintomas_Parametrizacao_Tempos_Min_Fields = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_min_fields';
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  id_frequencia_tempo_limite_resposta?: Maybe<Scalars['bigint']['output']>;
  id_frequencia_tempo_notificacao?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  tempo_limite_resposta?: Maybe<Scalars['bigint']['output']>;
  tempo_notificacao?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Min_Order_By = {
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  id_frequencia_tempo_limite_resposta?: InputMaybe<Order_By>;
  id_frequencia_tempo_notificacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  tempo_limite_resposta?: InputMaybe<Order_By>;
  tempo_notificacao?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Mutation_Response = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rqs_Sintomas_Parametrizacao_Tempos>;
};

/** on_conflict condition type for table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_On_Conflict = {
  constraint: Rqs_Sintomas_Parametrizacao_Tempos_Constraint;
  update_columns?: Array<Rqs_Sintomas_Parametrizacao_Tempos_Update_Column>;
  where?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>;
};

/** Ordering options when selecting data from "rqs.sintomas_parametrizacao_tempos". */
export type Rqs_Sintomas_Parametrizacao_Tempos_Order_By = {
  arvore?: InputMaybe<Sintomas_Arvore_Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  id_frequencia_tempo_limite_resposta?: InputMaybe<Order_By>;
  id_frequencia_tempo_notificacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  tempo_limite_resposta?: InputMaybe<Order_By>;
  tempo_notificacao?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rqs.sintomas_parametrizacao_tempos */
export type Rqs_Sintomas_Parametrizacao_Tempos_Pk_Columns_Input = {
  id_sintoma: Scalars['bigint']['input'];
};

/** select columns of table "rqs.sintomas_parametrizacao_tempos" */
export enum Rqs_Sintomas_Parametrizacao_Tempos_Select_Column {
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaAtualizacao = 'data_hora_ultima_atualizacao',
  /** column name */
  IdFrequenciaTempoLimiteResposta = 'id_frequencia_tempo_limite_resposta',
  /** column name */
  IdFrequenciaTempoNotificacao = 'id_frequencia_tempo_notificacao',
  /** column name */
  IdSintoma = 'id_sintoma',
  /** column name */
  TempoLimiteResposta = 'tempo_limite_resposta',
  /** column name */
  TempoNotificacao = 'tempo_notificacao'
}

/** input type for updating data in table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Set_Input = {
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  id_frequencia_tempo_limite_resposta?: InputMaybe<Scalars['bigint']['input']>;
  id_frequencia_tempo_notificacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  tempo_limite_resposta?: InputMaybe<Scalars['bigint']['input']>;
  tempo_notificacao?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Fields = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_stddev_fields';
  id_frequencia_tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  id_frequencia_tempo_notificacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  tempo_notificacao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Order_By = {
  id_frequencia_tempo_limite_resposta?: InputMaybe<Order_By>;
  id_frequencia_tempo_notificacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  tempo_limite_resposta?: InputMaybe<Order_By>;
  tempo_notificacao?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Pop_Fields = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_stddev_pop_fields';
  id_frequencia_tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  id_frequencia_tempo_notificacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  tempo_notificacao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Pop_Order_By = {
  id_frequencia_tempo_limite_resposta?: InputMaybe<Order_By>;
  id_frequencia_tempo_notificacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  tempo_limite_resposta?: InputMaybe<Order_By>;
  tempo_notificacao?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Samp_Fields = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_stddev_samp_fields';
  id_frequencia_tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  id_frequencia_tempo_notificacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  tempo_notificacao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Stddev_Samp_Order_By = {
  id_frequencia_tempo_limite_resposta?: InputMaybe<Order_By>;
  id_frequencia_tempo_notificacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  tempo_limite_resposta?: InputMaybe<Order_By>;
  tempo_notificacao?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rqs_sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rqs_Sintomas_Parametrizacao_Tempos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rqs_Sintomas_Parametrizacao_Tempos_Stream_Cursor_Value_Input = {
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  id_frequencia_tempo_limite_resposta?: InputMaybe<Scalars['bigint']['input']>;
  id_frequencia_tempo_notificacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  tempo_limite_resposta?: InputMaybe<Scalars['bigint']['input']>;
  tempo_notificacao?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Rqs_Sintomas_Parametrizacao_Tempos_Sum_Fields = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_sum_fields';
  id_frequencia_tempo_limite_resposta?: Maybe<Scalars['bigint']['output']>;
  id_frequencia_tempo_notificacao?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  tempo_limite_resposta?: Maybe<Scalars['bigint']['output']>;
  tempo_notificacao?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Sum_Order_By = {
  id_frequencia_tempo_limite_resposta?: InputMaybe<Order_By>;
  id_frequencia_tempo_notificacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  tempo_limite_resposta?: InputMaybe<Order_By>;
  tempo_notificacao?: InputMaybe<Order_By>;
};

/** update columns of table "rqs.sintomas_parametrizacao_tempos" */
export enum Rqs_Sintomas_Parametrizacao_Tempos_Update_Column {
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaAtualizacao = 'data_hora_ultima_atualizacao',
  /** column name */
  IdFrequenciaTempoLimiteResposta = 'id_frequencia_tempo_limite_resposta',
  /** column name */
  IdFrequenciaTempoNotificacao = 'id_frequencia_tempo_notificacao',
  /** column name */
  IdSintoma = 'id_sintoma',
  /** column name */
  TempoLimiteResposta = 'tempo_limite_resposta',
  /** column name */
  TempoNotificacao = 'tempo_notificacao'
}

export type Rqs_Sintomas_Parametrizacao_Tempos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rqs_Sintomas_Parametrizacao_Tempos_Var_Pop_Fields = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_var_pop_fields';
  id_frequencia_tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  id_frequencia_tempo_notificacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  tempo_notificacao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Var_Pop_Order_By = {
  id_frequencia_tempo_limite_resposta?: InputMaybe<Order_By>;
  id_frequencia_tempo_notificacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  tempo_limite_resposta?: InputMaybe<Order_By>;
  tempo_notificacao?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Rqs_Sintomas_Parametrizacao_Tempos_Var_Samp_Fields = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_var_samp_fields';
  id_frequencia_tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  id_frequencia_tempo_notificacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  tempo_notificacao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Var_Samp_Order_By = {
  id_frequencia_tempo_limite_resposta?: InputMaybe<Order_By>;
  id_frequencia_tempo_notificacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  tempo_limite_resposta?: InputMaybe<Order_By>;
  tempo_notificacao?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Rqs_Sintomas_Parametrizacao_Tempos_Variance_Fields = {
  __typename?: 'rqs_sintomas_parametrizacao_tempos_variance_fields';
  id_frequencia_tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  id_frequencia_tempo_notificacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  tempo_limite_resposta?: Maybe<Scalars['Float']['output']>;
  tempo_notificacao?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "rqs.sintomas_parametrizacao_tempos" */
export type Rqs_Sintomas_Parametrizacao_Tempos_Variance_Order_By = {
  id_frequencia_tempo_limite_resposta?: InputMaybe<Order_By>;
  id_frequencia_tempo_notificacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  tempo_limite_resposta?: InputMaybe<Order_By>;
  tempo_notificacao?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rqs.sintomas */
export type Rqs_Sintomas_Pk_Columns_Input = {
  id_sintoma: Scalars['bigint']['input'];
};

/** select columns of table "rqs.sintomas" */
export enum Rqs_Sintomas_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  DataHoraUltimaAtualizacao = 'data_hora_ultima_atualizacao',
  /** column name */
  IdSintoma = 'id_sintoma'
}

/** select "rqs_sintomas_aggregate_bool_exp_bool_and_arguments_columns" columns of table "rqs.sintomas" */
export enum Rqs_Sintomas_Select_Column_Rqs_Sintomas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado'
}

/** select "rqs_sintomas_aggregate_bool_exp_bool_or_arguments_columns" columns of table "rqs.sintomas" */
export enum Rqs_Sintomas_Select_Column_Rqs_Sintomas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado'
}

/** input type for updating data in table "rqs.sintomas" */
export type Rqs_Sintomas_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamptz']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Rqs_Sintomas_Stddev_Fields = {
  __typename?: 'rqs_sintomas_stddev_fields';
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "rqs.sintomas" */
export type Rqs_Sintomas_Stddev_Order_By = {
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Rqs_Sintomas_Stddev_Pop_Fields = {
  __typename?: 'rqs_sintomas_stddev_pop_fields';
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "rqs.sintomas" */
export type Rqs_Sintomas_Stddev_Pop_Order_By = {
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Rqs_Sintomas_Stddev_Samp_Fields = {
  __typename?: 'rqs_sintomas_stddev_samp_fields';
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "rqs.sintomas" */
export type Rqs_Sintomas_Stddev_Samp_Order_By = {
  id_sintoma?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rqs_sintomas" */
export type Rqs_Sintomas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rqs_Sintomas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rqs_Sintomas_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora_registo_db?: InputMaybe<Scalars['timestamptz']['input']>;
  data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamptz']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Rqs_Sintomas_Sum_Fields = {
  __typename?: 'rqs_sintomas_sum_fields';
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "rqs.sintomas" */
export type Rqs_Sintomas_Sum_Order_By = {
  id_sintoma?: InputMaybe<Order_By>;
};

/** update columns of table "rqs.sintomas" */
export enum Rqs_Sintomas_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHoraRegistoDb = 'data_hora_registo_db',
  /** column name */
  DataHoraUltimaAtualizacao = 'data_hora_ultima_atualizacao',
  /** column name */
  IdSintoma = 'id_sintoma'
}

export type Rqs_Sintomas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rqs_Sintomas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rqs_Sintomas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rqs_Sintomas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rqs_Sintomas_Var_Pop_Fields = {
  __typename?: 'rqs_sintomas_var_pop_fields';
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "rqs.sintomas" */
export type Rqs_Sintomas_Var_Pop_Order_By = {
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Rqs_Sintomas_Var_Samp_Fields = {
  __typename?: 'rqs_sintomas_var_samp_fields';
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "rqs.sintomas" */
export type Rqs_Sintomas_Var_Samp_Order_By = {
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Rqs_Sintomas_Variance_Fields = {
  __typename?: 'rqs_sintomas_variance_fields';
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "rqs.sintomas" */
export type Rqs_Sintomas_Variance_Order_By = {
  id_sintoma?: InputMaybe<Order_By>;
};

/** columns and relationships of "servicos.fases" */
export type Servicos_Fases = {
  __typename?: 'servicos_fases';
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_tarefa?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "servicos.fases" */
export type Servicos_Fases_Aggregate = {
  __typename?: 'servicos_fases_aggregate';
  aggregate?: Maybe<Servicos_Fases_Aggregate_Fields>;
  nodes: Array<Servicos_Fases>;
};

/** aggregate fields of "servicos.fases" */
export type Servicos_Fases_Aggregate_Fields = {
  __typename?: 'servicos_fases_aggregate_fields';
  avg?: Maybe<Servicos_Fases_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Servicos_Fases_Max_Fields>;
  min?: Maybe<Servicos_Fases_Min_Fields>;
  stddev?: Maybe<Servicos_Fases_Stddev_Fields>;
  stddev_pop?: Maybe<Servicos_Fases_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Servicos_Fases_Stddev_Samp_Fields>;
  sum?: Maybe<Servicos_Fases_Sum_Fields>;
  var_pop?: Maybe<Servicos_Fases_Var_Pop_Fields>;
  var_samp?: Maybe<Servicos_Fases_Var_Samp_Fields>;
  variance?: Maybe<Servicos_Fases_Variance_Fields>;
};


/** aggregate fields of "servicos.fases" */
export type Servicos_Fases_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Servicos_Fases_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Servicos_Fases_Avg_Fields = {
  __typename?: 'servicos_fases_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "servicos.fases". All fields are combined with a logical 'AND'. */
export type Servicos_Fases_Bool_Exp = {
  _and?: InputMaybe<Array<Servicos_Fases_Bool_Exp>>;
  _not?: InputMaybe<Servicos_Fases_Bool_Exp>;
  _or?: InputMaybe<Array<Servicos_Fases_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  descricao_tarefa?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "servicos.fases" */
export enum Servicos_Fases_Constraint {
  /** unique or primary key constraint on columns "id" */
  IntervencoesFasesPkey = 'intervencoes_fases_pkey'
}

/** input type for incrementing numeric columns in table "servicos.fases" */
export type Servicos_Fases_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "servicos.fases" */
export type Servicos_Fases_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_tarefa?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Servicos_Fases_Max_Fields = {
  __typename?: 'servicos_fases_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_tarefa?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Servicos_Fases_Min_Fields = {
  __typename?: 'servicos_fases_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_tarefa?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "servicos.fases" */
export type Servicos_Fases_Mutation_Response = {
  __typename?: 'servicos_fases_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Servicos_Fases>;
};

/** input type for inserting object relation for remote table "servicos.fases" */
export type Servicos_Fases_Obj_Rel_Insert_Input = {
  data: Servicos_Fases_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Servicos_Fases_On_Conflict>;
};

/** on_conflict condition type for table "servicos.fases" */
export type Servicos_Fases_On_Conflict = {
  constraint: Servicos_Fases_Constraint;
  update_columns?: Array<Servicos_Fases_Update_Column>;
  where?: InputMaybe<Servicos_Fases_Bool_Exp>;
};

/** Ordering options when selecting data from "servicos.fases". */
export type Servicos_Fases_Order_By = {
  descricao?: InputMaybe<Order_By>;
  descricao_tarefa?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: servicos.fases */
export type Servicos_Fases_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "servicos.fases" */
export enum Servicos_Fases_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoTarefa = 'descricao_tarefa',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "servicos.fases" */
export type Servicos_Fases_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_tarefa?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Servicos_Fases_Stddev_Fields = {
  __typename?: 'servicos_fases_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Servicos_Fases_Stddev_Pop_Fields = {
  __typename?: 'servicos_fases_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Servicos_Fases_Stddev_Samp_Fields = {
  __typename?: 'servicos_fases_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "servicos_fases" */
export type Servicos_Fases_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Servicos_Fases_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Servicos_Fases_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_tarefa?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Servicos_Fases_Sum_Fields = {
  __typename?: 'servicos_fases_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "servicos.fases" */
export enum Servicos_Fases_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoTarefa = 'descricao_tarefa',
  /** column name */
  Id = 'id'
}

export type Servicos_Fases_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Servicos_Fases_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Servicos_Fases_Set_Input>;
  /** filter the rows which have to be updated */
  where: Servicos_Fases_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Servicos_Fases_Var_Pop_Fields = {
  __typename?: 'servicos_fases_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Servicos_Fases_Var_Samp_Fields = {
  __typename?: 'servicos_fases_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Servicos_Fases_Variance_Fields = {
  __typename?: 'servicos_fases_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "servicos.intervencoes" */
export type Servicos_Intervencoes = {
  __typename?: 'servicos_intervencoes';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  bloqueado_materiais?: Maybe<Scalars['Boolean']['output']>;
  cancelada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  cancelada_motivo?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  causas: Array<Servicos_Intervencoes_R_Causas_Trabalhos>;
  /** An aggregate relationship */
  causas_aggregate: Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate;
  /** An object relationship */
  coordenadasMobile?: Maybe<Mobile_Coordenadas>;
  criacao_data_hora: Scalars['timestamp']['output'];
  criacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  data_hora_ultima_modificacao: Scalars['timestamp']['output'];
  data_planeada: Scalars['timestamp']['output'];
  desbloqueado_data_hora?: Maybe<Scalars['timestamp']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  device_key?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  estado?: Maybe<Servicos_Intervencoes_Estados>;
  executada_data_fim?: Maybe<Scalars['timestamp']['output']>;
  executada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  executada_data_inicio?: Maybe<Scalars['timestamp']['output']>;
  executada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_empreitada?: Maybe<Scalars['bigint']['output']>;
  id_entidade_externa_apagar?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_apagar?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_evento?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_local?: Maybe<Scalars['bigint']['output']>;
  id_motivo?: Maybe<Scalars['bigint']['output']>;
  id_prioridade?: Maybe<Scalars['bigint']['output']>;
  id_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  id_sub_area?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_utilizador_responsavel_apagar?: Maybe<Scalars['bigint']['output']>;
  id_veiculo_apagar?: Maybe<Scalars['bigint']['output']>;
  id_zmc?: Maybe<Scalars['bigint']['output']>;
  id_zona_abastecimento?: Maybe<Scalars['bigint']['output']>;
  ids_trabalhos_recomendados?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  infraestrutura?: Maybe<Base_Infraestruturas>;
  /** An array relationship */
  intervalos: Array<Tarefas_Intervalos>;
  /** An aggregate relationship */
  intervalos_aggregate: Tarefas_Intervalos_Aggregate;
  /** An object relationship */
  intervencaoUtilizador?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores>;
  /** An array relationship */
  leituras: Array<Variaveis_Leituras>;
  /** An aggregate relationship */
  leituras_aggregate: Variaveis_Leituras_Aggregate;
  nao_executada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  nao_executada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  nao_executada_motivo?: Maybe<Scalars['String']['output']>;
  nova_ordem_servico?: Maybe<Scalars['Boolean']['output']>;
  numero?: Maybe<Scalars['String']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  obs_local?: Maybe<Scalars['String']['output']>;
  obs_registo?: Maybe<Scalars['String']['output']>;
  outsystems_id_decisao_envio?: Maybe<Scalars['bigint']['output']>;
  periodica?: Maybe<Scalars['Boolean']['output']>;
  rav_estado_bateria?: Maybe<Scalars['numeric']['output']>;
  rav_estado_operacao?: Maybe<Scalars['String']['output']>;
  rav_estado_valvula?: Maybe<Scalars['String']['output']>;
  rav_id_valvula?: Maybe<Scalars['String']['output']>;
  rav_motivo_nao_acionamento?: Maybe<Scalars['String']['output']>;
  sap_codigo?: Maybe<Scalars['String']['output']>;
  sap_criacao_comunicada?: Maybe<Scalars['Boolean']['output']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sap_fecho_comunicado?: Maybe<Scalars['Boolean']['output']>;
  sap_horas_comunicado?: Maybe<Scalars['Boolean']['output']>;
  sap_material_comunicado?: Maybe<Scalars['Boolean']['output']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sig_atributo_atualizado?: Maybe<Scalars['Boolean']['output']>;
  sig_codigo?: Maybe<Scalars['String']['output']>;
  sig_enviado?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  sintoma?: Maybe<Sintomas_Arvore>;
  sintoma_extra?: Maybe<Scalars['String']['output']>;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
  todo_dia?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  toponimia?: Maybe<Base_Toponimias>;
  uuid?: Maybe<Scalars['String']['output']>;
  uuid_tarefa?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "servicos.intervencoes" */
export type Servicos_IntervencoesCausasArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
};


/** columns and relationships of "servicos.intervencoes" */
export type Servicos_IntervencoesCausas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
};


/** columns and relationships of "servicos.intervencoes" */
export type Servicos_IntervencoesIntervalosArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Intervalos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Intervalos_Order_By>>;
  where?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
};


/** columns and relationships of "servicos.intervencoes" */
export type Servicos_IntervencoesIntervalos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Intervalos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Intervalos_Order_By>>;
  where?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
};


/** columns and relationships of "servicos.intervencoes" */
export type Servicos_IntervencoesLeiturasArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};


/** columns and relationships of "servicos.intervencoes" */
export type Servicos_IntervencoesLeituras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};

/** aggregated selection of "servicos.intervencoes" */
export type Servicos_Intervencoes_Aggregate = {
  __typename?: 'servicos_intervencoes_aggregate';
  aggregate?: Maybe<Servicos_Intervencoes_Aggregate_Fields>;
  nodes: Array<Servicos_Intervencoes>;
};

/** aggregate fields of "servicos.intervencoes" */
export type Servicos_Intervencoes_Aggregate_Fields = {
  __typename?: 'servicos_intervencoes_aggregate_fields';
  avg?: Maybe<Servicos_Intervencoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Servicos_Intervencoes_Max_Fields>;
  min?: Maybe<Servicos_Intervencoes_Min_Fields>;
  stddev?: Maybe<Servicos_Intervencoes_Stddev_Fields>;
  stddev_pop?: Maybe<Servicos_Intervencoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Servicos_Intervencoes_Stddev_Samp_Fields>;
  sum?: Maybe<Servicos_Intervencoes_Sum_Fields>;
  var_pop?: Maybe<Servicos_Intervencoes_Var_Pop_Fields>;
  var_samp?: Maybe<Servicos_Intervencoes_Var_Samp_Fields>;
  variance?: Maybe<Servicos_Intervencoes_Variance_Fields>;
};


/** aggregate fields of "servicos.intervencoes" */
export type Servicos_Intervencoes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Servicos_Intervencoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "servicos.intervencoes_atribuicao_utilizadores" */
export type Servicos_Intervencoes_Atribuicao_Utilizadores = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores';
  id: Scalars['bigint']['output'];
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  utilizador?: Maybe<Utilizadores_Utilizadores>;
};

/** aggregated selection of "servicos.intervencoes_atribuicao_utilizadores" */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Aggregate = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_aggregate';
  aggregate?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Aggregate_Fields>;
  nodes: Array<Servicos_Intervencoes_Atribuicao_Utilizadores>;
};

/** aggregate fields of "servicos.intervencoes_atribuicao_utilizadores" */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Aggregate_Fields = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_aggregate_fields';
  avg?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Max_Fields>;
  min?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Min_Fields>;
  stddev?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Stddev_Fields>;
  stddev_pop?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Stddev_Samp_Fields>;
  sum?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Sum_Fields>;
  var_pop?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Var_Pop_Fields>;
  var_samp?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Var_Samp_Fields>;
  variance?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Variance_Fields>;
};


/** aggregate fields of "servicos.intervencoes_atribuicao_utilizadores" */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Avg_Fields = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "servicos.intervencoes_atribuicao_utilizadores". All fields are combined with a logical 'AND'. */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp = {
  _and?: InputMaybe<Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp>>;
  _not?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp>;
  _or?: InputMaybe<Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_intervencao?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  utilizador?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
};

/** unique or primary key constraints on table "servicos.intervencoes_atribuicao_utilizadores" */
export enum Servicos_Intervencoes_Atribuicao_Utilizadores_Constraint {
  /** unique or primary key constraint on columns "id" */
  IntervencoesAtribuicaoUtilizadoresPkey = 'intervencoes_atribuicao_utilizadores_pkey'
}

/** input type for incrementing numeric columns in table "servicos.intervencoes_atribuicao_utilizadores" */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "servicos.intervencoes_atribuicao_utilizadores" */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  utilizador?: InputMaybe<Utilizadores_Utilizadores_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Max_Fields = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Min_Fields = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "servicos.intervencoes_atribuicao_utilizadores" */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Mutation_Response = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Servicos_Intervencoes_Atribuicao_Utilizadores>;
};

/** input type for inserting object relation for remote table "servicos.intervencoes_atribuicao_utilizadores" */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Obj_Rel_Insert_Input = {
  data: Servicos_Intervencoes_Atribuicao_Utilizadores_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_On_Conflict>;
};

/** on_conflict condition type for table "servicos.intervencoes_atribuicao_utilizadores" */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_On_Conflict = {
  constraint: Servicos_Intervencoes_Atribuicao_Utilizadores_Constraint;
  update_columns?: Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Update_Column>;
  where?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp>;
};

/** Ordering options when selecting data from "servicos.intervencoes_atribuicao_utilizadores". */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  utilizador?: InputMaybe<Utilizadores_Utilizadores_Order_By>;
};

/** primary key columns input for table: servicos.intervencoes_atribuicao_utilizadores */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "servicos.intervencoes_atribuicao_utilizadores" */
export enum Servicos_Intervencoes_Atribuicao_Utilizadores_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdUtilizador = 'id_utilizador'
}

/** input type for updating data in table "servicos.intervencoes_atribuicao_utilizadores" */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Stddev_Fields = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Stddev_Pop_Fields = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Stddev_Samp_Fields = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "servicos_intervencoes_atribuicao_utilizadores" */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Servicos_Intervencoes_Atribuicao_Utilizadores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Sum_Fields = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "servicos.intervencoes_atribuicao_utilizadores" */
export enum Servicos_Intervencoes_Atribuicao_Utilizadores_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdUtilizador = 'id_utilizador'
}

export type Servicos_Intervencoes_Atribuicao_Utilizadores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Var_Pop_Fields = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Var_Samp_Fields = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Servicos_Intervencoes_Atribuicao_Utilizadores_Variance_Fields = {
  __typename?: 'servicos_intervencoes_atribuicao_utilizadores_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** aggregate avg on columns */
export type Servicos_Intervencoes_Avg_Fields = {
  __typename?: 'servicos_intervencoes_avg_fields';
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_empreitada?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa_apagar?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_apagar?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_evento?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_sub_area?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel_apagar?: Maybe<Scalars['Float']['output']>;
  id_veiculo_apagar?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  id_zona_abastecimento?: Maybe<Scalars['Float']['output']>;
  nao_executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  outsystems_id_decisao_envio?: Maybe<Scalars['Float']['output']>;
  rav_estado_bateria?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "servicos.intervencoes". All fields are combined with a logical 'AND'. */
export type Servicos_Intervencoes_Bool_Exp = {
  _and?: InputMaybe<Array<Servicos_Intervencoes_Bool_Exp>>;
  _not?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
  _or?: InputMaybe<Array<Servicos_Intervencoes_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  bloqueado_materiais?: InputMaybe<Boolean_Comparison_Exp>;
  cancelada_data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  cancelada_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  cancelada_motivo?: InputMaybe<String_Comparison_Exp>;
  causas?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
  causas_aggregate?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp>;
  coordenadasMobile?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
  criacao_data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  criacao_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  data_hora_ultima_modificacao?: InputMaybe<Timestamp_Comparison_Exp>;
  data_planeada?: InputMaybe<Timestamp_Comparison_Exp>;
  desbloqueado_data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  desbloqueado_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  device_key?: InputMaybe<String_Comparison_Exp>;
  estado?: InputMaybe<Servicos_Intervencoes_Estados_Bool_Exp>;
  executada_data_fim?: InputMaybe<Timestamp_Comparison_Exp>;
  executada_data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  executada_data_inicio?: InputMaybe<Timestamp_Comparison_Exp>;
  executada_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_ativo?: InputMaybe<Bigint_Comparison_Exp>;
  id_centro?: InputMaybe<Bigint_Comparison_Exp>;
  id_empreitada?: InputMaybe<Bigint_Comparison_Exp>;
  id_entidade_externa_apagar?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual_apagar?: InputMaybe<Bigint_Comparison_Exp>;
  id_estado?: InputMaybe<Bigint_Comparison_Exp>;
  id_estado_validacao?: InputMaybe<Bigint_Comparison_Exp>;
  id_evento?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_local?: InputMaybe<Bigint_Comparison_Exp>;
  id_motivo?: InputMaybe<Bigint_Comparison_Exp>;
  id_prioridade?: InputMaybe<Bigint_Comparison_Exp>;
  id_sinalizacao?: InputMaybe<Bigint_Comparison_Exp>;
  id_sintoma?: InputMaybe<Bigint_Comparison_Exp>;
  id_sub_area?: InputMaybe<Bigint_Comparison_Exp>;
  id_tarefa?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador_responsavel_apagar?: InputMaybe<Bigint_Comparison_Exp>;
  id_veiculo_apagar?: InputMaybe<Bigint_Comparison_Exp>;
  id_zmc?: InputMaybe<Bigint_Comparison_Exp>;
  id_zona_abastecimento?: InputMaybe<Bigint_Comparison_Exp>;
  ids_trabalhos_recomendados?: InputMaybe<String_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  intervalos?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
  intervalos_aggregate?: InputMaybe<Tarefas_Intervalos_Aggregate_Bool_Exp>;
  intervencaoUtilizador?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp>;
  leituras?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
  leituras_aggregate?: InputMaybe<Variaveis_Leituras_Aggregate_Bool_Exp>;
  nao_executada_data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  nao_executada_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  nao_executada_motivo?: InputMaybe<String_Comparison_Exp>;
  nova_ordem_servico?: InputMaybe<Boolean_Comparison_Exp>;
  numero?: InputMaybe<String_Comparison_Exp>;
  obs?: InputMaybe<String_Comparison_Exp>;
  obs_local?: InputMaybe<String_Comparison_Exp>;
  obs_registo?: InputMaybe<String_Comparison_Exp>;
  outsystems_id_decisao_envio?: InputMaybe<Bigint_Comparison_Exp>;
  periodica?: InputMaybe<Boolean_Comparison_Exp>;
  rav_estado_bateria?: InputMaybe<Numeric_Comparison_Exp>;
  rav_estado_operacao?: InputMaybe<String_Comparison_Exp>;
  rav_estado_valvula?: InputMaybe<String_Comparison_Exp>;
  rav_id_valvula?: InputMaybe<String_Comparison_Exp>;
  rav_motivo_nao_acionamento?: InputMaybe<String_Comparison_Exp>;
  sap_codigo?: InputMaybe<String_Comparison_Exp>;
  sap_criacao_comunicada?: InputMaybe<Boolean_Comparison_Exp>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Timestamp_Comparison_Exp>;
  sap_fecho_comunicado?: InputMaybe<Boolean_Comparison_Exp>;
  sap_horas_comunicado?: InputMaybe<Boolean_Comparison_Exp>;
  sap_material_comunicado?: InputMaybe<Boolean_Comparison_Exp>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Timestamp_Comparison_Exp>;
  sig_atributo_atualizado?: InputMaybe<Boolean_Comparison_Exp>;
  sig_codigo?: InputMaybe<String_Comparison_Exp>;
  sig_enviado?: InputMaybe<Boolean_Comparison_Exp>;
  sintoma?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  sintoma_extra?: InputMaybe<String_Comparison_Exp>;
  tempo_estimado?: InputMaybe<Int_Comparison_Exp>;
  todo_dia?: InputMaybe<Boolean_Comparison_Exp>;
  toponimia?: InputMaybe<Base_Toponimias_Bool_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
  uuid_tarefa?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "servicos.intervencoes" */
export enum Servicos_Intervencoes_Constraint {
  /** unique or primary key constraint on columns "numero" */
  IntervencoesNumeroUnico = 'intervencoes_numero_unico',
  /** unique or primary key constraint on columns "id" */
  IntervencoesPkey = 'intervencoes_pkey',
  /** unique or primary key constraint on columns "sap_codigo" */
  IntervencoesSapCodigoKey = 'intervencoes_sap_codigo_key'
}

/** columns and relationships of "servicos.intervencoes_estados" */
export type Servicos_Intervencoes_Estados = {
  __typename?: 'servicos_intervencoes_estados';
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "servicos.intervencoes_estados" */
export type Servicos_Intervencoes_Estados_Aggregate = {
  __typename?: 'servicos_intervencoes_estados_aggregate';
  aggregate?: Maybe<Servicos_Intervencoes_Estados_Aggregate_Fields>;
  nodes: Array<Servicos_Intervencoes_Estados>;
};

/** aggregate fields of "servicos.intervencoes_estados" */
export type Servicos_Intervencoes_Estados_Aggregate_Fields = {
  __typename?: 'servicos_intervencoes_estados_aggregate_fields';
  avg?: Maybe<Servicos_Intervencoes_Estados_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Servicos_Intervencoes_Estados_Max_Fields>;
  min?: Maybe<Servicos_Intervencoes_Estados_Min_Fields>;
  stddev?: Maybe<Servicos_Intervencoes_Estados_Stddev_Fields>;
  stddev_pop?: Maybe<Servicos_Intervencoes_Estados_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Servicos_Intervencoes_Estados_Stddev_Samp_Fields>;
  sum?: Maybe<Servicos_Intervencoes_Estados_Sum_Fields>;
  var_pop?: Maybe<Servicos_Intervencoes_Estados_Var_Pop_Fields>;
  var_samp?: Maybe<Servicos_Intervencoes_Estados_Var_Samp_Fields>;
  variance?: Maybe<Servicos_Intervencoes_Estados_Variance_Fields>;
};


/** aggregate fields of "servicos.intervencoes_estados" */
export type Servicos_Intervencoes_Estados_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Servicos_Intervencoes_Estados_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Servicos_Intervencoes_Estados_Avg_Fields = {
  __typename?: 'servicos_intervencoes_estados_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "servicos.intervencoes_estados". All fields are combined with a logical 'AND'. */
export type Servicos_Intervencoes_Estados_Bool_Exp = {
  _and?: InputMaybe<Array<Servicos_Intervencoes_Estados_Bool_Exp>>;
  _not?: InputMaybe<Servicos_Intervencoes_Estados_Bool_Exp>;
  _or?: InputMaybe<Array<Servicos_Intervencoes_Estados_Bool_Exp>>;
  cor?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "servicos.intervencoes_estados" */
export enum Servicos_Intervencoes_Estados_Constraint {
  /** unique or primary key constraint on columns "id" */
  IntervencoesEstadosPkey = 'intervencoes_estados_pkey'
}

/** input type for incrementing numeric columns in table "servicos.intervencoes_estados" */
export type Servicos_Intervencoes_Estados_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "servicos.intervencoes_estados" */
export type Servicos_Intervencoes_Estados_Insert_Input = {
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Servicos_Intervencoes_Estados_Max_Fields = {
  __typename?: 'servicos_intervencoes_estados_max_fields';
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Servicos_Intervencoes_Estados_Min_Fields = {
  __typename?: 'servicos_intervencoes_estados_min_fields';
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "servicos.intervencoes_estados" */
export type Servicos_Intervencoes_Estados_Mutation_Response = {
  __typename?: 'servicos_intervencoes_estados_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Servicos_Intervencoes_Estados>;
};

/** input type for inserting object relation for remote table "servicos.intervencoes_estados" */
export type Servicos_Intervencoes_Estados_Obj_Rel_Insert_Input = {
  data: Servicos_Intervencoes_Estados_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Servicos_Intervencoes_Estados_On_Conflict>;
};

/** on_conflict condition type for table "servicos.intervencoes_estados" */
export type Servicos_Intervencoes_Estados_On_Conflict = {
  constraint: Servicos_Intervencoes_Estados_Constraint;
  update_columns?: Array<Servicos_Intervencoes_Estados_Update_Column>;
  where?: InputMaybe<Servicos_Intervencoes_Estados_Bool_Exp>;
};

/** Ordering options when selecting data from "servicos.intervencoes_estados". */
export type Servicos_Intervencoes_Estados_Order_By = {
  cor?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: servicos.intervencoes_estados */
export type Servicos_Intervencoes_Estados_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "servicos.intervencoes_estados" */
export enum Servicos_Intervencoes_Estados_Select_Column {
  /** column name */
  Cor = 'cor',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "servicos.intervencoes_estados" */
export type Servicos_Intervencoes_Estados_Set_Input = {
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Servicos_Intervencoes_Estados_Stddev_Fields = {
  __typename?: 'servicos_intervencoes_estados_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Servicos_Intervencoes_Estados_Stddev_Pop_Fields = {
  __typename?: 'servicos_intervencoes_estados_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Servicos_Intervencoes_Estados_Stddev_Samp_Fields = {
  __typename?: 'servicos_intervencoes_estados_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "servicos_intervencoes_estados" */
export type Servicos_Intervencoes_Estados_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Servicos_Intervencoes_Estados_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Servicos_Intervencoes_Estados_Stream_Cursor_Value_Input = {
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Servicos_Intervencoes_Estados_Sum_Fields = {
  __typename?: 'servicos_intervencoes_estados_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "servicos.intervencoes_estados" */
export enum Servicos_Intervencoes_Estados_Update_Column {
  /** column name */
  Cor = 'cor',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Servicos_Intervencoes_Estados_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Servicos_Intervencoes_Estados_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Servicos_Intervencoes_Estados_Set_Input>;
  /** filter the rows which have to be updated */
  where: Servicos_Intervencoes_Estados_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Servicos_Intervencoes_Estados_Var_Pop_Fields = {
  __typename?: 'servicos_intervencoes_estados_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Servicos_Intervencoes_Estados_Var_Samp_Fields = {
  __typename?: 'servicos_intervencoes_estados_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Servicos_Intervencoes_Estados_Variance_Fields = {
  __typename?: 'servicos_intervencoes_estados_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "servicos.intervencoes" */
export type Servicos_Intervencoes_Inc_Input = {
  cancelada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  criacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  desbloqueado_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  executada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_empreitada?: InputMaybe<Scalars['bigint']['input']>;
  id_entidade_externa_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_evento?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_local?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  id_sub_area?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador_responsavel_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_zmc?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_abastecimento?: InputMaybe<Scalars['bigint']['input']>;
  nao_executada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  outsystems_id_decisao_envio?: InputMaybe<Scalars['bigint']['input']>;
  rav_estado_bateria?: InputMaybe<Scalars['numeric']['input']>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "servicos.intervencoes" */
export type Servicos_Intervencoes_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  bloqueado_materiais?: InputMaybe<Scalars['Boolean']['input']>;
  cancelada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  cancelada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  cancelada_motivo?: InputMaybe<Scalars['String']['input']>;
  causas?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Arr_Rel_Insert_Input>;
  coordenadasMobile?: InputMaybe<Mobile_Coordenadas_Obj_Rel_Insert_Input>;
  criacao_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  criacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  data_planeada?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  device_key?: InputMaybe<Scalars['String']['input']>;
  estado?: InputMaybe<Servicos_Intervencoes_Estados_Obj_Rel_Insert_Input>;
  executada_data_fim?: InputMaybe<Scalars['timestamp']['input']>;
  executada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  executada_data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  executada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_empreitada?: InputMaybe<Scalars['bigint']['input']>;
  id_entidade_externa_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_evento?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_local?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  id_sub_area?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador_responsavel_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_zmc?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_abastecimento?: InputMaybe<Scalars['bigint']['input']>;
  ids_trabalhos_recomendados?: InputMaybe<Scalars['String']['input']>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
  intervalos?: InputMaybe<Tarefas_Intervalos_Arr_Rel_Insert_Input>;
  intervencaoUtilizador?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Obj_Rel_Insert_Input>;
  leituras?: InputMaybe<Variaveis_Leituras_Arr_Rel_Insert_Input>;
  nao_executada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  nao_executada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  nao_executada_motivo?: InputMaybe<Scalars['String']['input']>;
  nova_ordem_servico?: InputMaybe<Scalars['Boolean']['input']>;
  numero?: InputMaybe<Scalars['String']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  obs_local?: InputMaybe<Scalars['String']['input']>;
  obs_registo?: InputMaybe<Scalars['String']['input']>;
  outsystems_id_decisao_envio?: InputMaybe<Scalars['bigint']['input']>;
  periodica?: InputMaybe<Scalars['Boolean']['input']>;
  rav_estado_bateria?: InputMaybe<Scalars['numeric']['input']>;
  rav_estado_operacao?: InputMaybe<Scalars['String']['input']>;
  rav_estado_valvula?: InputMaybe<Scalars['String']['input']>;
  rav_id_valvula?: InputMaybe<Scalars['String']['input']>;
  rav_motivo_nao_acionamento?: InputMaybe<Scalars['String']['input']>;
  sap_codigo?: InputMaybe<Scalars['String']['input']>;
  sap_criacao_comunicada?: InputMaybe<Scalars['Boolean']['input']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sap_fecho_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_horas_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sig_atributo_atualizado?: InputMaybe<Scalars['Boolean']['input']>;
  sig_codigo?: InputMaybe<Scalars['String']['input']>;
  sig_enviado?: InputMaybe<Scalars['Boolean']['input']>;
  sintoma?: InputMaybe<Sintomas_Arvore_Obj_Rel_Insert_Input>;
  sintoma_extra?: InputMaybe<Scalars['String']['input']>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
  todo_dia?: InputMaybe<Scalars['Boolean']['input']>;
  toponimia?: InputMaybe<Base_Toponimias_Obj_Rel_Insert_Input>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuid_tarefa?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Servicos_Intervencoes_Max_Fields = {
  __typename?: 'servicos_intervencoes_max_fields';
  cancelada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  cancelada_motivo?: Maybe<Scalars['String']['output']>;
  criacao_data_hora?: Maybe<Scalars['timestamp']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  data_planeada?: Maybe<Scalars['timestamp']['output']>;
  desbloqueado_data_hora?: Maybe<Scalars['timestamp']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  device_key?: Maybe<Scalars['String']['output']>;
  executada_data_fim?: Maybe<Scalars['timestamp']['output']>;
  executada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  executada_data_inicio?: Maybe<Scalars['timestamp']['output']>;
  executada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_empreitada?: Maybe<Scalars['bigint']['output']>;
  id_entidade_externa_apagar?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_apagar?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_evento?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_local?: Maybe<Scalars['bigint']['output']>;
  id_motivo?: Maybe<Scalars['bigint']['output']>;
  id_prioridade?: Maybe<Scalars['bigint']['output']>;
  id_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  id_sub_area?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_utilizador_responsavel_apagar?: Maybe<Scalars['bigint']['output']>;
  id_veiculo_apagar?: Maybe<Scalars['bigint']['output']>;
  id_zmc?: Maybe<Scalars['bigint']['output']>;
  id_zona_abastecimento?: Maybe<Scalars['bigint']['output']>;
  ids_trabalhos_recomendados?: Maybe<Scalars['String']['output']>;
  nao_executada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  nao_executada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  nao_executada_motivo?: Maybe<Scalars['String']['output']>;
  numero?: Maybe<Scalars['String']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  obs_local?: Maybe<Scalars['String']['output']>;
  obs_registo?: Maybe<Scalars['String']['output']>;
  outsystems_id_decisao_envio?: Maybe<Scalars['bigint']['output']>;
  rav_estado_bateria?: Maybe<Scalars['numeric']['output']>;
  rav_estado_operacao?: Maybe<Scalars['String']['output']>;
  rav_estado_valvula?: Maybe<Scalars['String']['output']>;
  rav_id_valvula?: Maybe<Scalars['String']['output']>;
  rav_motivo_nao_acionamento?: Maybe<Scalars['String']['output']>;
  sap_codigo?: Maybe<Scalars['String']['output']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sig_codigo?: Maybe<Scalars['String']['output']>;
  sintoma_extra?: Maybe<Scalars['String']['output']>;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  uuid_tarefa?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Servicos_Intervencoes_Min_Fields = {
  __typename?: 'servicos_intervencoes_min_fields';
  cancelada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  cancelada_motivo?: Maybe<Scalars['String']['output']>;
  criacao_data_hora?: Maybe<Scalars['timestamp']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  data_planeada?: Maybe<Scalars['timestamp']['output']>;
  desbloqueado_data_hora?: Maybe<Scalars['timestamp']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  device_key?: Maybe<Scalars['String']['output']>;
  executada_data_fim?: Maybe<Scalars['timestamp']['output']>;
  executada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  executada_data_inicio?: Maybe<Scalars['timestamp']['output']>;
  executada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_empreitada?: Maybe<Scalars['bigint']['output']>;
  id_entidade_externa_apagar?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_apagar?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_evento?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_local?: Maybe<Scalars['bigint']['output']>;
  id_motivo?: Maybe<Scalars['bigint']['output']>;
  id_prioridade?: Maybe<Scalars['bigint']['output']>;
  id_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  id_sub_area?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_utilizador_responsavel_apagar?: Maybe<Scalars['bigint']['output']>;
  id_veiculo_apagar?: Maybe<Scalars['bigint']['output']>;
  id_zmc?: Maybe<Scalars['bigint']['output']>;
  id_zona_abastecimento?: Maybe<Scalars['bigint']['output']>;
  ids_trabalhos_recomendados?: Maybe<Scalars['String']['output']>;
  nao_executada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  nao_executada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  nao_executada_motivo?: Maybe<Scalars['String']['output']>;
  numero?: Maybe<Scalars['String']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  obs_local?: Maybe<Scalars['String']['output']>;
  obs_registo?: Maybe<Scalars['String']['output']>;
  outsystems_id_decisao_envio?: Maybe<Scalars['bigint']['output']>;
  rav_estado_bateria?: Maybe<Scalars['numeric']['output']>;
  rav_estado_operacao?: Maybe<Scalars['String']['output']>;
  rav_estado_valvula?: Maybe<Scalars['String']['output']>;
  rav_id_valvula?: Maybe<Scalars['String']['output']>;
  rav_motivo_nao_acionamento?: Maybe<Scalars['String']['output']>;
  sap_codigo?: Maybe<Scalars['String']['output']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sig_codigo?: Maybe<Scalars['String']['output']>;
  sintoma_extra?: Maybe<Scalars['String']['output']>;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  uuid_tarefa?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "servicos.intervencoes" */
export type Servicos_Intervencoes_Mutation_Response = {
  __typename?: 'servicos_intervencoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Servicos_Intervencoes>;
};

/** input type for inserting object relation for remote table "servicos.intervencoes" */
export type Servicos_Intervencoes_Obj_Rel_Insert_Input = {
  data: Servicos_Intervencoes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Servicos_Intervencoes_On_Conflict>;
};

/** on_conflict condition type for table "servicos.intervencoes" */
export type Servicos_Intervencoes_On_Conflict = {
  constraint: Servicos_Intervencoes_Constraint;
  update_columns?: Array<Servicos_Intervencoes_Update_Column>;
  where?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
};

/** Ordering options when selecting data from "servicos.intervencoes". */
export type Servicos_Intervencoes_Order_By = {
  apagado?: InputMaybe<Order_By>;
  bloqueado_materiais?: InputMaybe<Order_By>;
  cancelada_data_hora?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  cancelada_motivo?: InputMaybe<Order_By>;
  causas_aggregate?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Order_By>;
  coordenadasMobile?: InputMaybe<Mobile_Coordenadas_Order_By>;
  criacao_data_hora?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  data_planeada?: InputMaybe<Order_By>;
  desbloqueado_data_hora?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  device_key?: InputMaybe<Order_By>;
  estado?: InputMaybe<Servicos_Intervencoes_Estados_Order_By>;
  executada_data_fim?: InputMaybe<Order_By>;
  executada_data_hora?: InputMaybe<Order_By>;
  executada_data_inicio?: InputMaybe<Order_By>;
  executada_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_empreitada?: InputMaybe<Order_By>;
  id_entidade_externa_apagar?: InputMaybe<Order_By>;
  id_equipa_virtual_apagar?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_evento?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_sub_area?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  id_utilizador_responsavel_apagar?: InputMaybe<Order_By>;
  id_veiculo_apagar?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  id_zona_abastecimento?: InputMaybe<Order_By>;
  ids_trabalhos_recomendados?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
  intervalos_aggregate?: InputMaybe<Tarefas_Intervalos_Aggregate_Order_By>;
  intervencaoUtilizador?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Order_By>;
  leituras_aggregate?: InputMaybe<Variaveis_Leituras_Aggregate_Order_By>;
  nao_executada_data_hora?: InputMaybe<Order_By>;
  nao_executada_id_utilizador?: InputMaybe<Order_By>;
  nao_executada_motivo?: InputMaybe<Order_By>;
  nova_ordem_servico?: InputMaybe<Order_By>;
  numero?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  obs_local?: InputMaybe<Order_By>;
  obs_registo?: InputMaybe<Order_By>;
  outsystems_id_decisao_envio?: InputMaybe<Order_By>;
  periodica?: InputMaybe<Order_By>;
  rav_estado_bateria?: InputMaybe<Order_By>;
  rav_estado_operacao?: InputMaybe<Order_By>;
  rav_estado_valvula?: InputMaybe<Order_By>;
  rav_id_valvula?: InputMaybe<Order_By>;
  rav_motivo_nao_acionamento?: InputMaybe<Order_By>;
  sap_codigo?: InputMaybe<Order_By>;
  sap_criacao_comunicada?: InputMaybe<Order_By>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  sap_fecho_comunicado?: InputMaybe<Order_By>;
  sap_horas_comunicado?: InputMaybe<Order_By>;
  sap_material_comunicado?: InputMaybe<Order_By>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  sig_atributo_atualizado?: InputMaybe<Order_By>;
  sig_codigo?: InputMaybe<Order_By>;
  sig_enviado?: InputMaybe<Order_By>;
  sintoma?: InputMaybe<Sintomas_Arvore_Order_By>;
  sintoma_extra?: InputMaybe<Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  todo_dia?: InputMaybe<Order_By>;
  toponimia?: InputMaybe<Base_Toponimias_Order_By>;
  uuid?: InputMaybe<Order_By>;
  uuid_tarefa?: InputMaybe<Order_By>;
};

/** primary key columns input for table: servicos.intervencoes */
export type Servicos_Intervencoes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos';
  /** An object relationship */
  causa?: Maybe<Sintomas_Causas_Trabalhos>;
  id: Scalars['bigint']['output'];
  id_causa_trabalho?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  intervencao?: Maybe<Servicos_Intervencoes>;
  obs?: Maybe<Scalars['String']['output']>;
  recomendado: Scalars['Boolean']['output'];
};

/** aggregated selection of "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_aggregate';
  aggregate?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Fields>;
  nodes: Array<Servicos_Intervencoes_R_Causas_Trabalhos>;
};

export type Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp_Count>;
};

export type Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp_Bool_And = {
  arguments: Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column_Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column_Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Fields = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_aggregate_fields';
  avg?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Max_Fields>;
  min?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Min_Fields>;
  stddev?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Fields>;
  stddev_pop?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Samp_Fields>;
  sum?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Sum_Fields>;
  var_pop?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Var_Pop_Fields>;
  var_samp?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Var_Samp_Fields>;
  variance?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos_Variance_Fields>;
};


/** aggregate fields of "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Order_By = {
  avg?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Max_Order_By>;
  min?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Min_Order_By>;
  stddev?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Sum_Order_By>;
  var_pop?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Var_Samp_Order_By>;
  variance?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Arr_Rel_Insert_Input = {
  data: Array<Servicos_Intervencoes_R_Causas_Trabalhos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_On_Conflict>;
};

/** aggregate avg on columns */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Avg_Fields = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "servicos.intervencoes_r_causas_trabalhos". All fields are combined with a logical 'AND'. */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp = {
  _and?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>>;
  _not?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
  _or?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>>;
  causa?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_causa_trabalho?: InputMaybe<Bigint_Comparison_Exp>;
  id_intervencao?: InputMaybe<Bigint_Comparison_Exp>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
  obs?: InputMaybe<String_Comparison_Exp>;
  recomendado?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "servicos.intervencoes_r_causas_trabalhos" */
export enum Servicos_Intervencoes_R_Causas_Trabalhos_Constraint {
  /** unique or primary key constraint on columns "id" */
  IntervencoesRCausasTrabalhosPkey = 'intervencoes_r_causas_trabalhos_pkey'
}

/** input type for incrementing numeric columns in table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_causa_trabalho?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Insert_Input = {
  causa?: InputMaybe<Sintomas_Causas_Trabalhos_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_causa_trabalho?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Obj_Rel_Insert_Input>;
  obs?: InputMaybe<Scalars['String']['input']>;
  recomendado?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Max_Fields = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_causa_trabalho?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Min_Fields = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_causa_trabalho?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Mutation_Response = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Servicos_Intervencoes_R_Causas_Trabalhos>;
};

/** on_conflict condition type for table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_On_Conflict = {
  constraint: Servicos_Intervencoes_R_Causas_Trabalhos_Constraint;
  update_columns?: Array<Servicos_Intervencoes_R_Causas_Trabalhos_Update_Column>;
  where?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
};

/** Ordering options when selecting data from "servicos.intervencoes_r_causas_trabalhos". */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Order_By = {
  causa?: InputMaybe<Sintomas_Causas_Trabalhos_Order_By>;
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Order_By>;
  obs?: InputMaybe<Order_By>;
  recomendado?: InputMaybe<Order_By>;
};

/** primary key columns input for table: servicos.intervencoes_r_causas_trabalhos */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "servicos.intervencoes_r_causas_trabalhos" */
export enum Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdCausaTrabalho = 'id_causa_trabalho',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  Obs = 'obs',
  /** column name */
  Recomendado = 'recomendado'
}

/** select "servicos_intervencoes_r_causas_trabalhos_aggregate_bool_exp_bool_and_arguments_columns" columns of table "servicos.intervencoes_r_causas_trabalhos" */
export enum Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column_Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Recomendado = 'recomendado'
}

/** select "servicos_intervencoes_r_causas_trabalhos_aggregate_bool_exp_bool_or_arguments_columns" columns of table "servicos.intervencoes_r_causas_trabalhos" */
export enum Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column_Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Recomendado = 'recomendado'
}

/** input type for updating data in table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_causa_trabalho?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  recomendado?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Fields = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Pop_Fields = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Samp_Fields = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "servicos_intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Servicos_Intervencoes_R_Causas_Trabalhos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_causa_trabalho?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  recomendado?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Sum_Fields = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_causa_trabalho?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
};

/** update columns of table "servicos.intervencoes_r_causas_trabalhos" */
export enum Servicos_Intervencoes_R_Causas_Trabalhos_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdCausaTrabalho = 'id_causa_trabalho',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  Obs = 'obs',
  /** column name */
  Recomendado = 'recomendado'
}

export type Servicos_Intervencoes_R_Causas_Trabalhos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Var_Pop_Fields = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Var_Samp_Fields = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Variance_Fields = {
  __typename?: 'servicos_intervencoes_r_causas_trabalhos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "servicos.intervencoes_r_causas_trabalhos" */
export type Servicos_Intervencoes_R_Causas_Trabalhos_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
};

/** select columns of table "servicos.intervencoes" */
export enum Servicos_Intervencoes_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  BloqueadoMateriais = 'bloqueado_materiais',
  /** column name */
  CanceladaDataHora = 'cancelada_data_hora',
  /** column name */
  CanceladaIdUtilizador = 'cancelada_id_utilizador',
  /** column name */
  CanceladaMotivo = 'cancelada_motivo',
  /** column name */
  CriacaoDataHora = 'criacao_data_hora',
  /** column name */
  CriacaoIdUtilizador = 'criacao_id_utilizador',
  /** column name */
  DataHoraUltimaModificacao = 'data_hora_ultima_modificacao',
  /** column name */
  DataPlaneada = 'data_planeada',
  /** column name */
  DesbloqueadoDataHora = 'desbloqueado_data_hora',
  /** column name */
  DesbloqueadoIdUtilizador = 'desbloqueado_id_utilizador',
  /** column name */
  DeviceKey = 'device_key',
  /** column name */
  ExecutadaDataFim = 'executada_data_fim',
  /** column name */
  ExecutadaDataHora = 'executada_data_hora',
  /** column name */
  ExecutadaDataInicio = 'executada_data_inicio',
  /** column name */
  ExecutadaIdUtilizador = 'executada_id_utilizador',
  /** column name */
  Id = 'id',
  /** column name */
  IdAtivo = 'id_ativo',
  /** column name */
  IdCentro = 'id_centro',
  /** column name */
  IdEmpreitada = 'id_empreitada',
  /** column name */
  IdEntidadeExternaApagar = 'id_entidade_externa_apagar',
  /** column name */
  IdEquipaVirtualApagar = 'id_equipa_virtual_apagar',
  /** column name */
  IdEstado = 'id_estado',
  /** column name */
  IdEstadoValidacao = 'id_estado_validacao',
  /** column name */
  IdEvento = 'id_evento',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdLocal = 'id_local',
  /** column name */
  IdMotivo = 'id_motivo',
  /** column name */
  IdPrioridade = 'id_prioridade',
  /** column name */
  IdSinalizacao = 'id_sinalizacao',
  /** column name */
  IdSintoma = 'id_sintoma',
  /** column name */
  IdSubArea = 'id_sub_area',
  /** column name */
  IdTarefa = 'id_tarefa',
  /** column name */
  IdTipoInfraestrutura = 'id_tipo_infraestrutura',
  /** column name */
  IdUtilizadorResponsavelApagar = 'id_utilizador_responsavel_apagar',
  /** column name */
  IdVeiculoApagar = 'id_veiculo_apagar',
  /** column name */
  IdZmc = 'id_zmc',
  /** column name */
  IdZonaAbastecimento = 'id_zona_abastecimento',
  /** column name */
  IdsTrabalhosRecomendados = 'ids_trabalhos_recomendados',
  /** column name */
  NaoExecutadaDataHora = 'nao_executada_data_hora',
  /** column name */
  NaoExecutadaIdUtilizador = 'nao_executada_id_utilizador',
  /** column name */
  NaoExecutadaMotivo = 'nao_executada_motivo',
  /** column name */
  NovaOrdemServico = 'nova_ordem_servico',
  /** column name */
  Numero = 'numero',
  /** column name */
  Obs = 'obs',
  /** column name */
  ObsLocal = 'obs_local',
  /** column name */
  ObsRegisto = 'obs_registo',
  /** column name */
  OutsystemsIdDecisaoEnvio = 'outsystems_id_decisao_envio',
  /** column name */
  Periodica = 'periodica',
  /** column name */
  RavEstadoBateria = 'rav_estado_bateria',
  /** column name */
  RavEstadoOperacao = 'rav_estado_operacao',
  /** column name */
  RavEstadoValvula = 'rav_estado_valvula',
  /** column name */
  RavIdValvula = 'rav_id_valvula',
  /** column name */
  RavMotivoNaoAcionamento = 'rav_motivo_nao_acionamento',
  /** column name */
  SapCodigo = 'sap_codigo',
  /** column name */
  SapCriacaoComunicada = 'sap_criacao_comunicada',
  /** column name */
  SapCriacaoComunicadaDataHoraUltimaAtualizacao = 'sap_criacao_comunicada_data_hora_ultima_atualizacao',
  /** column name */
  SapFechoComunicado = 'sap_fecho_comunicado',
  /** column name */
  SapHorasComunicado = 'sap_horas_comunicado',
  /** column name */
  SapMaterialComunicado = 'sap_material_comunicado',
  /** column name */
  SapMaterialComunicadoDataHoraUltimaAtualizacao = 'sap_material_comunicado_data_hora_ultima_atualizacao',
  /** column name */
  SigAtributoAtualizado = 'sig_atributo_atualizado',
  /** column name */
  SigCodigo = 'sig_codigo',
  /** column name */
  SigEnviado = 'sig_enviado',
  /** column name */
  SintomaExtra = 'sintoma_extra',
  /** column name */
  TempoEstimado = 'tempo_estimado',
  /** column name */
  TodoDia = 'todo_dia',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  UuidTarefa = 'uuid_tarefa'
}

/** input type for updating data in table "servicos.intervencoes" */
export type Servicos_Intervencoes_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  bloqueado_materiais?: InputMaybe<Scalars['Boolean']['input']>;
  cancelada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  cancelada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  cancelada_motivo?: InputMaybe<Scalars['String']['input']>;
  criacao_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  criacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  data_planeada?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  device_key?: InputMaybe<Scalars['String']['input']>;
  executada_data_fim?: InputMaybe<Scalars['timestamp']['input']>;
  executada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  executada_data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  executada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_empreitada?: InputMaybe<Scalars['bigint']['input']>;
  id_entidade_externa_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_evento?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_local?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  id_sub_area?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador_responsavel_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_zmc?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_abastecimento?: InputMaybe<Scalars['bigint']['input']>;
  ids_trabalhos_recomendados?: InputMaybe<Scalars['String']['input']>;
  nao_executada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  nao_executada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  nao_executada_motivo?: InputMaybe<Scalars['String']['input']>;
  nova_ordem_servico?: InputMaybe<Scalars['Boolean']['input']>;
  numero?: InputMaybe<Scalars['String']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  obs_local?: InputMaybe<Scalars['String']['input']>;
  obs_registo?: InputMaybe<Scalars['String']['input']>;
  outsystems_id_decisao_envio?: InputMaybe<Scalars['bigint']['input']>;
  periodica?: InputMaybe<Scalars['Boolean']['input']>;
  rav_estado_bateria?: InputMaybe<Scalars['numeric']['input']>;
  rav_estado_operacao?: InputMaybe<Scalars['String']['input']>;
  rav_estado_valvula?: InputMaybe<Scalars['String']['input']>;
  rav_id_valvula?: InputMaybe<Scalars['String']['input']>;
  rav_motivo_nao_acionamento?: InputMaybe<Scalars['String']['input']>;
  sap_codigo?: InputMaybe<Scalars['String']['input']>;
  sap_criacao_comunicada?: InputMaybe<Scalars['Boolean']['input']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sap_fecho_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_horas_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sig_atributo_atualizado?: InputMaybe<Scalars['Boolean']['input']>;
  sig_codigo?: InputMaybe<Scalars['String']['input']>;
  sig_enviado?: InputMaybe<Scalars['Boolean']['input']>;
  sintoma_extra?: InputMaybe<Scalars['String']['input']>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
  todo_dia?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuid_tarefa?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Servicos_Intervencoes_Stddev_Fields = {
  __typename?: 'servicos_intervencoes_stddev_fields';
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_empreitada?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa_apagar?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_apagar?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_evento?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_sub_area?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel_apagar?: Maybe<Scalars['Float']['output']>;
  id_veiculo_apagar?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  id_zona_abastecimento?: Maybe<Scalars['Float']['output']>;
  nao_executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  outsystems_id_decisao_envio?: Maybe<Scalars['Float']['output']>;
  rav_estado_bateria?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Servicos_Intervencoes_Stddev_Pop_Fields = {
  __typename?: 'servicos_intervencoes_stddev_pop_fields';
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_empreitada?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa_apagar?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_apagar?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_evento?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_sub_area?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel_apagar?: Maybe<Scalars['Float']['output']>;
  id_veiculo_apagar?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  id_zona_abastecimento?: Maybe<Scalars['Float']['output']>;
  nao_executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  outsystems_id_decisao_envio?: Maybe<Scalars['Float']['output']>;
  rav_estado_bateria?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Servicos_Intervencoes_Stddev_Samp_Fields = {
  __typename?: 'servicos_intervencoes_stddev_samp_fields';
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_empreitada?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa_apagar?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_apagar?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_evento?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_sub_area?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel_apagar?: Maybe<Scalars['Float']['output']>;
  id_veiculo_apagar?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  id_zona_abastecimento?: Maybe<Scalars['Float']['output']>;
  nao_executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  outsystems_id_decisao_envio?: Maybe<Scalars['Float']['output']>;
  rav_estado_bateria?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "servicos_intervencoes" */
export type Servicos_Intervencoes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Servicos_Intervencoes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Servicos_Intervencoes_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  bloqueado_materiais?: InputMaybe<Scalars['Boolean']['input']>;
  cancelada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  cancelada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  cancelada_motivo?: InputMaybe<Scalars['String']['input']>;
  criacao_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  criacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  data_planeada?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  device_key?: InputMaybe<Scalars['String']['input']>;
  executada_data_fim?: InputMaybe<Scalars['timestamp']['input']>;
  executada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  executada_data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  executada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_empreitada?: InputMaybe<Scalars['bigint']['input']>;
  id_entidade_externa_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_evento?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_local?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  id_sub_area?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador_responsavel_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo_apagar?: InputMaybe<Scalars['bigint']['input']>;
  id_zmc?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_abastecimento?: InputMaybe<Scalars['bigint']['input']>;
  ids_trabalhos_recomendados?: InputMaybe<Scalars['String']['input']>;
  nao_executada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  nao_executada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  nao_executada_motivo?: InputMaybe<Scalars['String']['input']>;
  nova_ordem_servico?: InputMaybe<Scalars['Boolean']['input']>;
  numero?: InputMaybe<Scalars['String']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  obs_local?: InputMaybe<Scalars['String']['input']>;
  obs_registo?: InputMaybe<Scalars['String']['input']>;
  outsystems_id_decisao_envio?: InputMaybe<Scalars['bigint']['input']>;
  periodica?: InputMaybe<Scalars['Boolean']['input']>;
  rav_estado_bateria?: InputMaybe<Scalars['numeric']['input']>;
  rav_estado_operacao?: InputMaybe<Scalars['String']['input']>;
  rav_estado_valvula?: InputMaybe<Scalars['String']['input']>;
  rav_id_valvula?: InputMaybe<Scalars['String']['input']>;
  rav_motivo_nao_acionamento?: InputMaybe<Scalars['String']['input']>;
  sap_codigo?: InputMaybe<Scalars['String']['input']>;
  sap_criacao_comunicada?: InputMaybe<Scalars['Boolean']['input']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sap_fecho_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_horas_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sig_atributo_atualizado?: InputMaybe<Scalars['Boolean']['input']>;
  sig_codigo?: InputMaybe<Scalars['String']['input']>;
  sig_enviado?: InputMaybe<Scalars['Boolean']['input']>;
  sintoma_extra?: InputMaybe<Scalars['String']['input']>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
  todo_dia?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuid_tarefa?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Servicos_Intervencoes_Sum_Fields = {
  __typename?: 'servicos_intervencoes_sum_fields';
  cancelada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  executada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_empreitada?: Maybe<Scalars['bigint']['output']>;
  id_entidade_externa_apagar?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_apagar?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_evento?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_local?: Maybe<Scalars['bigint']['output']>;
  id_motivo?: Maybe<Scalars['bigint']['output']>;
  id_prioridade?: Maybe<Scalars['bigint']['output']>;
  id_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  id_sub_area?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_utilizador_responsavel_apagar?: Maybe<Scalars['bigint']['output']>;
  id_veiculo_apagar?: Maybe<Scalars['bigint']['output']>;
  id_zmc?: Maybe<Scalars['bigint']['output']>;
  id_zona_abastecimento?: Maybe<Scalars['bigint']['output']>;
  nao_executada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  outsystems_id_decisao_envio?: Maybe<Scalars['bigint']['output']>;
  rav_estado_bateria?: Maybe<Scalars['numeric']['output']>;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "servicos.intervencoes" */
export enum Servicos_Intervencoes_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  BloqueadoMateriais = 'bloqueado_materiais',
  /** column name */
  CanceladaDataHora = 'cancelada_data_hora',
  /** column name */
  CanceladaIdUtilizador = 'cancelada_id_utilizador',
  /** column name */
  CanceladaMotivo = 'cancelada_motivo',
  /** column name */
  CriacaoDataHora = 'criacao_data_hora',
  /** column name */
  CriacaoIdUtilizador = 'criacao_id_utilizador',
  /** column name */
  DataHoraUltimaModificacao = 'data_hora_ultima_modificacao',
  /** column name */
  DataPlaneada = 'data_planeada',
  /** column name */
  DesbloqueadoDataHora = 'desbloqueado_data_hora',
  /** column name */
  DesbloqueadoIdUtilizador = 'desbloqueado_id_utilizador',
  /** column name */
  DeviceKey = 'device_key',
  /** column name */
  ExecutadaDataFim = 'executada_data_fim',
  /** column name */
  ExecutadaDataHora = 'executada_data_hora',
  /** column name */
  ExecutadaDataInicio = 'executada_data_inicio',
  /** column name */
  ExecutadaIdUtilizador = 'executada_id_utilizador',
  /** column name */
  Id = 'id',
  /** column name */
  IdAtivo = 'id_ativo',
  /** column name */
  IdCentro = 'id_centro',
  /** column name */
  IdEmpreitada = 'id_empreitada',
  /** column name */
  IdEntidadeExternaApagar = 'id_entidade_externa_apagar',
  /** column name */
  IdEquipaVirtualApagar = 'id_equipa_virtual_apagar',
  /** column name */
  IdEstado = 'id_estado',
  /** column name */
  IdEstadoValidacao = 'id_estado_validacao',
  /** column name */
  IdEvento = 'id_evento',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdLocal = 'id_local',
  /** column name */
  IdMotivo = 'id_motivo',
  /** column name */
  IdPrioridade = 'id_prioridade',
  /** column name */
  IdSinalizacao = 'id_sinalizacao',
  /** column name */
  IdSintoma = 'id_sintoma',
  /** column name */
  IdSubArea = 'id_sub_area',
  /** column name */
  IdTarefa = 'id_tarefa',
  /** column name */
  IdTipoInfraestrutura = 'id_tipo_infraestrutura',
  /** column name */
  IdUtilizadorResponsavelApagar = 'id_utilizador_responsavel_apagar',
  /** column name */
  IdVeiculoApagar = 'id_veiculo_apagar',
  /** column name */
  IdZmc = 'id_zmc',
  /** column name */
  IdZonaAbastecimento = 'id_zona_abastecimento',
  /** column name */
  IdsTrabalhosRecomendados = 'ids_trabalhos_recomendados',
  /** column name */
  NaoExecutadaDataHora = 'nao_executada_data_hora',
  /** column name */
  NaoExecutadaIdUtilizador = 'nao_executada_id_utilizador',
  /** column name */
  NaoExecutadaMotivo = 'nao_executada_motivo',
  /** column name */
  NovaOrdemServico = 'nova_ordem_servico',
  /** column name */
  Numero = 'numero',
  /** column name */
  Obs = 'obs',
  /** column name */
  ObsLocal = 'obs_local',
  /** column name */
  ObsRegisto = 'obs_registo',
  /** column name */
  OutsystemsIdDecisaoEnvio = 'outsystems_id_decisao_envio',
  /** column name */
  Periodica = 'periodica',
  /** column name */
  RavEstadoBateria = 'rav_estado_bateria',
  /** column name */
  RavEstadoOperacao = 'rav_estado_operacao',
  /** column name */
  RavEstadoValvula = 'rav_estado_valvula',
  /** column name */
  RavIdValvula = 'rav_id_valvula',
  /** column name */
  RavMotivoNaoAcionamento = 'rav_motivo_nao_acionamento',
  /** column name */
  SapCodigo = 'sap_codigo',
  /** column name */
  SapCriacaoComunicada = 'sap_criacao_comunicada',
  /** column name */
  SapCriacaoComunicadaDataHoraUltimaAtualizacao = 'sap_criacao_comunicada_data_hora_ultima_atualizacao',
  /** column name */
  SapFechoComunicado = 'sap_fecho_comunicado',
  /** column name */
  SapHorasComunicado = 'sap_horas_comunicado',
  /** column name */
  SapMaterialComunicado = 'sap_material_comunicado',
  /** column name */
  SapMaterialComunicadoDataHoraUltimaAtualizacao = 'sap_material_comunicado_data_hora_ultima_atualizacao',
  /** column name */
  SigAtributoAtualizado = 'sig_atributo_atualizado',
  /** column name */
  SigCodigo = 'sig_codigo',
  /** column name */
  SigEnviado = 'sig_enviado',
  /** column name */
  SintomaExtra = 'sintoma_extra',
  /** column name */
  TempoEstimado = 'tempo_estimado',
  /** column name */
  TodoDia = 'todo_dia',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  UuidTarefa = 'uuid_tarefa'
}

export type Servicos_Intervencoes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Servicos_Intervencoes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Servicos_Intervencoes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Servicos_Intervencoes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Servicos_Intervencoes_Var_Pop_Fields = {
  __typename?: 'servicos_intervencoes_var_pop_fields';
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_empreitada?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa_apagar?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_apagar?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_evento?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_sub_area?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel_apagar?: Maybe<Scalars['Float']['output']>;
  id_veiculo_apagar?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  id_zona_abastecimento?: Maybe<Scalars['Float']['output']>;
  nao_executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  outsystems_id_decisao_envio?: Maybe<Scalars['Float']['output']>;
  rav_estado_bateria?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Servicos_Intervencoes_Var_Samp_Fields = {
  __typename?: 'servicos_intervencoes_var_samp_fields';
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_empreitada?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa_apagar?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_apagar?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_evento?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_sub_area?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel_apagar?: Maybe<Scalars['Float']['output']>;
  id_veiculo_apagar?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  id_zona_abastecimento?: Maybe<Scalars['Float']['output']>;
  nao_executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  outsystems_id_decisao_envio?: Maybe<Scalars['Float']['output']>;
  rav_estado_bateria?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Servicos_Intervencoes_Variance_Fields = {
  __typename?: 'servicos_intervencoes_variance_fields';
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_empreitada?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa_apagar?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_apagar?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_evento?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_sub_area?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel_apagar?: Maybe<Scalars['Float']['output']>;
  id_veiculo_apagar?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  id_zona_abastecimento?: Maybe<Scalars['Float']['output']>;
  nao_executada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  outsystems_id_decisao_envio?: Maybe<Scalars['Float']['output']>;
  rav_estado_bateria?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade = {
  __typename?: 'servicos_rastreabilidade';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  id_evento_origem?: Maybe<Scalars['bigint']['output']>;
  id_intervencao_destino?: Maybe<Scalars['bigint']['output']>;
  id_intervencao_origem?: Maybe<Scalars['bigint']['output']>;
  id_requisicao_destino?: Maybe<Scalars['bigint']['output']>;
  id_requisicao_origem?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_destino?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_rastreabilidade?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  intervencaoDestino?: Maybe<Servicos_Intervencoes>;
  /** An object relationship */
  intervencaoOrigem?: Maybe<Servicos_Intervencoes>;
  /** An object relationship */
  requisicaoDestino?: Maybe<Servicos_Requisicoes>;
  /** An object relationship */
  requisicaoOrigem?: Maybe<Servicos_Requisicoes>;
  /** An object relationship */
  tarefaOrigem?: Maybe<Tarefas_Tarefas>;
};

/** aggregated selection of "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Aggregate = {
  __typename?: 'servicos_rastreabilidade_aggregate';
  aggregate?: Maybe<Servicos_Rastreabilidade_Aggregate_Fields>;
  nodes: Array<Servicos_Rastreabilidade>;
};

export type Servicos_Rastreabilidade_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Servicos_Rastreabilidade_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Servicos_Rastreabilidade_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Servicos_Rastreabilidade_Aggregate_Bool_Exp_Count>;
};

export type Servicos_Rastreabilidade_Aggregate_Bool_Exp_Bool_And = {
  arguments: Servicos_Rastreabilidade_Select_Column_Servicos_Rastreabilidade_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Servicos_Rastreabilidade_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Servicos_Rastreabilidade_Select_Column_Servicos_Rastreabilidade_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Servicos_Rastreabilidade_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Servicos_Rastreabilidade_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Aggregate_Fields = {
  __typename?: 'servicos_rastreabilidade_aggregate_fields';
  avg?: Maybe<Servicos_Rastreabilidade_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Servicos_Rastreabilidade_Max_Fields>;
  min?: Maybe<Servicos_Rastreabilidade_Min_Fields>;
  stddev?: Maybe<Servicos_Rastreabilidade_Stddev_Fields>;
  stddev_pop?: Maybe<Servicos_Rastreabilidade_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Servicos_Rastreabilidade_Stddev_Samp_Fields>;
  sum?: Maybe<Servicos_Rastreabilidade_Sum_Fields>;
  var_pop?: Maybe<Servicos_Rastreabilidade_Var_Pop_Fields>;
  var_samp?: Maybe<Servicos_Rastreabilidade_Var_Samp_Fields>;
  variance?: Maybe<Servicos_Rastreabilidade_Variance_Fields>;
};


/** aggregate fields of "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Servicos_Rastreabilidade_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Aggregate_Order_By = {
  avg?: InputMaybe<Servicos_Rastreabilidade_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Servicos_Rastreabilidade_Max_Order_By>;
  min?: InputMaybe<Servicos_Rastreabilidade_Min_Order_By>;
  stddev?: InputMaybe<Servicos_Rastreabilidade_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Servicos_Rastreabilidade_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Servicos_Rastreabilidade_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Servicos_Rastreabilidade_Sum_Order_By>;
  var_pop?: InputMaybe<Servicos_Rastreabilidade_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Servicos_Rastreabilidade_Var_Samp_Order_By>;
  variance?: InputMaybe<Servicos_Rastreabilidade_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Arr_Rel_Insert_Input = {
  data: Array<Servicos_Rastreabilidade_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Servicos_Rastreabilidade_On_Conflict>;
};

/** aggregate avg on columns */
export type Servicos_Rastreabilidade_Avg_Fields = {
  __typename?: 'servicos_rastreabilidade_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_evento_origem?: Maybe<Scalars['Float']['output']>;
  id_intervencao_destino?: Maybe<Scalars['Float']['output']>;
  id_intervencao_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao_destino?: Maybe<Scalars['Float']['output']>;
  id_requisicao_origem?: Maybe<Scalars['Float']['output']>;
  id_tarefa_destino?: Maybe<Scalars['Float']['output']>;
  id_tarefa_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_rastreabilidade?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_evento_origem?: InputMaybe<Order_By>;
  id_intervencao_destino?: InputMaybe<Order_By>;
  id_intervencao_origem?: InputMaybe<Order_By>;
  id_requisicao_destino?: InputMaybe<Order_By>;
  id_requisicao_origem?: InputMaybe<Order_By>;
  id_tarefa_destino?: InputMaybe<Order_By>;
  id_tarefa_origem?: InputMaybe<Order_By>;
  id_tipo_rastreabilidade?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "servicos.rastreabilidade". All fields are combined with a logical 'AND'. */
export type Servicos_Rastreabilidade_Bool_Exp = {
  _and?: InputMaybe<Array<Servicos_Rastreabilidade_Bool_Exp>>;
  _not?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
  _or?: InputMaybe<Array<Servicos_Rastreabilidade_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_evento_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_intervencao_destino?: InputMaybe<Bigint_Comparison_Exp>;
  id_intervencao_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_requisicao_destino?: InputMaybe<Bigint_Comparison_Exp>;
  id_requisicao_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_tarefa_destino?: InputMaybe<Bigint_Comparison_Exp>;
  id_tarefa_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_rastreabilidade?: InputMaybe<Bigint_Comparison_Exp>;
  intervencaoDestino?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
  intervencaoOrigem?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
  requisicaoDestino?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
  requisicaoOrigem?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
  tarefaOrigem?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
};

/** unique or primary key constraints on table "servicos.rastreabilidade" */
export enum Servicos_Rastreabilidade_Constraint {
  /** unique or primary key constraint on columns "id_intervencao_origem", "id_intervencao_destino" */
  IndRastreabilidadeIdIntervencaoDestinoIdIntervencaoOrige = 'ind_rastreabilidade_id_intervencao_destino_id_intervencao_orige',
  /** unique or primary key constraint on columns "id_intervencao_origem", "id_requisicao_destino" */
  IndRastreabilidadeIdRequisicaoDestinoIdIntervencaoOrigem = 'ind_rastreabilidade_id_requisicao_destino_id_intervencao_origem',
  /** unique or primary key constraint on columns "id_requisicao_origem", "id_intervencao_destino" */
  IndRastreabilidadeIdRequisicaoOrigemIdIntervencaoDestino = 'ind_rastreabilidade_id_requisicao_origem_id_intervencao_destino',
  /** unique or primary key constraint on columns "id" */
  RastreabilidadePkey = 'rastreabilidade_pkey'
}

/** input type for incrementing numeric columns in table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_evento_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_rastreabilidade?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_evento_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_rastreabilidade?: InputMaybe<Scalars['bigint']['input']>;
  intervencaoDestino?: InputMaybe<Servicos_Intervencoes_Obj_Rel_Insert_Input>;
  intervencaoOrigem?: InputMaybe<Servicos_Intervencoes_Obj_Rel_Insert_Input>;
  requisicaoDestino?: InputMaybe<Servicos_Requisicoes_Obj_Rel_Insert_Input>;
  requisicaoOrigem?: InputMaybe<Servicos_Requisicoes_Obj_Rel_Insert_Input>;
  tarefaOrigem?: InputMaybe<Tarefas_Tarefas_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Servicos_Rastreabilidade_Max_Fields = {
  __typename?: 'servicos_rastreabilidade_max_fields';
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_evento_origem?: Maybe<Scalars['bigint']['output']>;
  id_intervencao_destino?: Maybe<Scalars['bigint']['output']>;
  id_intervencao_origem?: Maybe<Scalars['bigint']['output']>;
  id_requisicao_destino?: Maybe<Scalars['bigint']['output']>;
  id_requisicao_origem?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_destino?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_rastreabilidade?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Max_Order_By = {
  data_hora?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_evento_origem?: InputMaybe<Order_By>;
  id_intervencao_destino?: InputMaybe<Order_By>;
  id_intervencao_origem?: InputMaybe<Order_By>;
  id_requisicao_destino?: InputMaybe<Order_By>;
  id_requisicao_origem?: InputMaybe<Order_By>;
  id_tarefa_destino?: InputMaybe<Order_By>;
  id_tarefa_origem?: InputMaybe<Order_By>;
  id_tipo_rastreabilidade?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Servicos_Rastreabilidade_Min_Fields = {
  __typename?: 'servicos_rastreabilidade_min_fields';
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_evento_origem?: Maybe<Scalars['bigint']['output']>;
  id_intervencao_destino?: Maybe<Scalars['bigint']['output']>;
  id_intervencao_origem?: Maybe<Scalars['bigint']['output']>;
  id_requisicao_destino?: Maybe<Scalars['bigint']['output']>;
  id_requisicao_origem?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_destino?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_rastreabilidade?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Min_Order_By = {
  data_hora?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_evento_origem?: InputMaybe<Order_By>;
  id_intervencao_destino?: InputMaybe<Order_By>;
  id_intervencao_origem?: InputMaybe<Order_By>;
  id_requisicao_destino?: InputMaybe<Order_By>;
  id_requisicao_origem?: InputMaybe<Order_By>;
  id_tarefa_destino?: InputMaybe<Order_By>;
  id_tarefa_origem?: InputMaybe<Order_By>;
  id_tipo_rastreabilidade?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Mutation_Response = {
  __typename?: 'servicos_rastreabilidade_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Servicos_Rastreabilidade>;
};

/** on_conflict condition type for table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_On_Conflict = {
  constraint: Servicos_Rastreabilidade_Constraint;
  update_columns?: Array<Servicos_Rastreabilidade_Update_Column>;
  where?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
};

/** Ordering options when selecting data from "servicos.rastreabilidade". */
export type Servicos_Rastreabilidade_Order_By = {
  apagado?: InputMaybe<Order_By>;
  data_hora?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_evento_origem?: InputMaybe<Order_By>;
  id_intervencao_destino?: InputMaybe<Order_By>;
  id_intervencao_origem?: InputMaybe<Order_By>;
  id_requisicao_destino?: InputMaybe<Order_By>;
  id_requisicao_origem?: InputMaybe<Order_By>;
  id_tarefa_destino?: InputMaybe<Order_By>;
  id_tarefa_origem?: InputMaybe<Order_By>;
  id_tipo_rastreabilidade?: InputMaybe<Order_By>;
  intervencaoDestino?: InputMaybe<Servicos_Intervencoes_Order_By>;
  intervencaoOrigem?: InputMaybe<Servicos_Intervencoes_Order_By>;
  requisicaoDestino?: InputMaybe<Servicos_Requisicoes_Order_By>;
  requisicaoOrigem?: InputMaybe<Servicos_Requisicoes_Order_By>;
  tarefaOrigem?: InputMaybe<Tarefas_Tarefas_Order_By>;
};

/** primary key columns input for table: servicos.rastreabilidade */
export type Servicos_Rastreabilidade_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "servicos.rastreabilidade" */
export enum Servicos_Rastreabilidade_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  Id = 'id',
  /** column name */
  IdEventoOrigem = 'id_evento_origem',
  /** column name */
  IdIntervencaoDestino = 'id_intervencao_destino',
  /** column name */
  IdIntervencaoOrigem = 'id_intervencao_origem',
  /** column name */
  IdRequisicaoDestino = 'id_requisicao_destino',
  /** column name */
  IdRequisicaoOrigem = 'id_requisicao_origem',
  /** column name */
  IdTarefaDestino = 'id_tarefa_destino',
  /** column name */
  IdTarefaOrigem = 'id_tarefa_origem',
  /** column name */
  IdTipoRastreabilidade = 'id_tipo_rastreabilidade'
}

/** select "servicos_rastreabilidade_aggregate_bool_exp_bool_and_arguments_columns" columns of table "servicos.rastreabilidade" */
export enum Servicos_Rastreabilidade_Select_Column_Servicos_Rastreabilidade_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado'
}

/** select "servicos_rastreabilidade_aggregate_bool_exp_bool_or_arguments_columns" columns of table "servicos.rastreabilidade" */
export enum Servicos_Rastreabilidade_Select_Column_Servicos_Rastreabilidade_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado'
}

/** input type for updating data in table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_evento_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_rastreabilidade?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Servicos_Rastreabilidade_Stddev_Fields = {
  __typename?: 'servicos_rastreabilidade_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_evento_origem?: Maybe<Scalars['Float']['output']>;
  id_intervencao_destino?: Maybe<Scalars['Float']['output']>;
  id_intervencao_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao_destino?: Maybe<Scalars['Float']['output']>;
  id_requisicao_origem?: Maybe<Scalars['Float']['output']>;
  id_tarefa_destino?: Maybe<Scalars['Float']['output']>;
  id_tarefa_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_rastreabilidade?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_evento_origem?: InputMaybe<Order_By>;
  id_intervencao_destino?: InputMaybe<Order_By>;
  id_intervencao_origem?: InputMaybe<Order_By>;
  id_requisicao_destino?: InputMaybe<Order_By>;
  id_requisicao_origem?: InputMaybe<Order_By>;
  id_tarefa_destino?: InputMaybe<Order_By>;
  id_tarefa_origem?: InputMaybe<Order_By>;
  id_tipo_rastreabilidade?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Servicos_Rastreabilidade_Stddev_Pop_Fields = {
  __typename?: 'servicos_rastreabilidade_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_evento_origem?: Maybe<Scalars['Float']['output']>;
  id_intervencao_destino?: Maybe<Scalars['Float']['output']>;
  id_intervencao_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao_destino?: Maybe<Scalars['Float']['output']>;
  id_requisicao_origem?: Maybe<Scalars['Float']['output']>;
  id_tarefa_destino?: Maybe<Scalars['Float']['output']>;
  id_tarefa_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_rastreabilidade?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_evento_origem?: InputMaybe<Order_By>;
  id_intervencao_destino?: InputMaybe<Order_By>;
  id_intervencao_origem?: InputMaybe<Order_By>;
  id_requisicao_destino?: InputMaybe<Order_By>;
  id_requisicao_origem?: InputMaybe<Order_By>;
  id_tarefa_destino?: InputMaybe<Order_By>;
  id_tarefa_origem?: InputMaybe<Order_By>;
  id_tipo_rastreabilidade?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Servicos_Rastreabilidade_Stddev_Samp_Fields = {
  __typename?: 'servicos_rastreabilidade_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_evento_origem?: Maybe<Scalars['Float']['output']>;
  id_intervencao_destino?: Maybe<Scalars['Float']['output']>;
  id_intervencao_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao_destino?: Maybe<Scalars['Float']['output']>;
  id_requisicao_origem?: Maybe<Scalars['Float']['output']>;
  id_tarefa_destino?: Maybe<Scalars['Float']['output']>;
  id_tarefa_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_rastreabilidade?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_evento_origem?: InputMaybe<Order_By>;
  id_intervencao_destino?: InputMaybe<Order_By>;
  id_intervencao_origem?: InputMaybe<Order_By>;
  id_requisicao_destino?: InputMaybe<Order_By>;
  id_requisicao_origem?: InputMaybe<Order_By>;
  id_tarefa_destino?: InputMaybe<Order_By>;
  id_tarefa_origem?: InputMaybe<Order_By>;
  id_tipo_rastreabilidade?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "servicos_rastreabilidade" */
export type Servicos_Rastreabilidade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Servicos_Rastreabilidade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Servicos_Rastreabilidade_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_evento_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_destino?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_rastreabilidade?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Servicos_Rastreabilidade_Sum_Fields = {
  __typename?: 'servicos_rastreabilidade_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_evento_origem?: Maybe<Scalars['bigint']['output']>;
  id_intervencao_destino?: Maybe<Scalars['bigint']['output']>;
  id_intervencao_origem?: Maybe<Scalars['bigint']['output']>;
  id_requisicao_destino?: Maybe<Scalars['bigint']['output']>;
  id_requisicao_origem?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_destino?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_rastreabilidade?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_evento_origem?: InputMaybe<Order_By>;
  id_intervencao_destino?: InputMaybe<Order_By>;
  id_intervencao_origem?: InputMaybe<Order_By>;
  id_requisicao_destino?: InputMaybe<Order_By>;
  id_requisicao_origem?: InputMaybe<Order_By>;
  id_tarefa_destino?: InputMaybe<Order_By>;
  id_tarefa_origem?: InputMaybe<Order_By>;
  id_tipo_rastreabilidade?: InputMaybe<Order_By>;
};

/** update columns of table "servicos.rastreabilidade" */
export enum Servicos_Rastreabilidade_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  Id = 'id',
  /** column name */
  IdEventoOrigem = 'id_evento_origem',
  /** column name */
  IdIntervencaoDestino = 'id_intervencao_destino',
  /** column name */
  IdIntervencaoOrigem = 'id_intervencao_origem',
  /** column name */
  IdRequisicaoDestino = 'id_requisicao_destino',
  /** column name */
  IdRequisicaoOrigem = 'id_requisicao_origem',
  /** column name */
  IdTarefaDestino = 'id_tarefa_destino',
  /** column name */
  IdTarefaOrigem = 'id_tarefa_origem',
  /** column name */
  IdTipoRastreabilidade = 'id_tipo_rastreabilidade'
}

export type Servicos_Rastreabilidade_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Servicos_Rastreabilidade_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Servicos_Rastreabilidade_Set_Input>;
  /** filter the rows which have to be updated */
  where: Servicos_Rastreabilidade_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Servicos_Rastreabilidade_Var_Pop_Fields = {
  __typename?: 'servicos_rastreabilidade_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_evento_origem?: Maybe<Scalars['Float']['output']>;
  id_intervencao_destino?: Maybe<Scalars['Float']['output']>;
  id_intervencao_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao_destino?: Maybe<Scalars['Float']['output']>;
  id_requisicao_origem?: Maybe<Scalars['Float']['output']>;
  id_tarefa_destino?: Maybe<Scalars['Float']['output']>;
  id_tarefa_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_rastreabilidade?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_evento_origem?: InputMaybe<Order_By>;
  id_intervencao_destino?: InputMaybe<Order_By>;
  id_intervencao_origem?: InputMaybe<Order_By>;
  id_requisicao_destino?: InputMaybe<Order_By>;
  id_requisicao_origem?: InputMaybe<Order_By>;
  id_tarefa_destino?: InputMaybe<Order_By>;
  id_tarefa_origem?: InputMaybe<Order_By>;
  id_tipo_rastreabilidade?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Servicos_Rastreabilidade_Var_Samp_Fields = {
  __typename?: 'servicos_rastreabilidade_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_evento_origem?: Maybe<Scalars['Float']['output']>;
  id_intervencao_destino?: Maybe<Scalars['Float']['output']>;
  id_intervencao_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao_destino?: Maybe<Scalars['Float']['output']>;
  id_requisicao_origem?: Maybe<Scalars['Float']['output']>;
  id_tarefa_destino?: Maybe<Scalars['Float']['output']>;
  id_tarefa_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_rastreabilidade?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_evento_origem?: InputMaybe<Order_By>;
  id_intervencao_destino?: InputMaybe<Order_By>;
  id_intervencao_origem?: InputMaybe<Order_By>;
  id_requisicao_destino?: InputMaybe<Order_By>;
  id_requisicao_origem?: InputMaybe<Order_By>;
  id_tarefa_destino?: InputMaybe<Order_By>;
  id_tarefa_origem?: InputMaybe<Order_By>;
  id_tipo_rastreabilidade?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Servicos_Rastreabilidade_Variance_Fields = {
  __typename?: 'servicos_rastreabilidade_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_evento_origem?: Maybe<Scalars['Float']['output']>;
  id_intervencao_destino?: Maybe<Scalars['Float']['output']>;
  id_intervencao_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao_destino?: Maybe<Scalars['Float']['output']>;
  id_requisicao_origem?: Maybe<Scalars['Float']['output']>;
  id_tarefa_destino?: Maybe<Scalars['Float']['output']>;
  id_tarefa_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_rastreabilidade?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "servicos.rastreabilidade" */
export type Servicos_Rastreabilidade_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_evento_origem?: InputMaybe<Order_By>;
  id_intervencao_destino?: InputMaybe<Order_By>;
  id_intervencao_origem?: InputMaybe<Order_By>;
  id_requisicao_destino?: InputMaybe<Order_By>;
  id_requisicao_origem?: InputMaybe<Order_By>;
  id_tarefa_destino?: InputMaybe<Order_By>;
  id_tarefa_origem?: InputMaybe<Order_By>;
  id_tipo_rastreabilidade?: InputMaybe<Order_By>;
};

/** columns and relationships of "servicos.requisicoes" */
export type Servicos_Requisicoes = {
  __typename?: 'servicos_requisicoes';
  analise_data_hora?: Maybe<Scalars['timestamp']['output']>;
  analise_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  anual_dia_mes?: Maybe<Scalars['String']['output']>;
  anual_mes?: Maybe<Scalars['String']['output']>;
  anual_posicao_dia_mes?: Maybe<Scalars['String']['output']>;
  anual_posicao_dia_semana?: Maybe<Scalars['String']['output']>;
  apagado?: Maybe<Scalars['Boolean']['output']>;
  cancelada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  cancelada_motivo?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  centro?: Maybe<Base_Centros>;
  contacto?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  coordenadasMobile: Array<Mobile_Coordenadas>;
  /** An aggregate relationship */
  coordenadasMobile_aggregate: Mobile_Coordenadas_Aggregate;
  criacao_data_hora: Scalars['timestamp']['output'];
  criacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  dados_externos?: Maybe<Scalars['String']['output']>;
  data_hora: Scalars['timestamp']['output'];
  data_ultima_comunicacao?: Maybe<Scalars['timestamp']['output']>;
  diaria_periodicidade?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  estado?: Maybe<Servicos_Requisicoes_Estados>;
  fechada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  fechada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  fechada_motivo?: Maybe<Scalars['String']['output']>;
  feriados?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_entidade_externa?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_comunicacao_fecho?: Maybe<Scalars['bigint']['output']>;
  id_motivo?: Maybe<Scalars['bigint']['output']>;
  id_prioridade?: Maybe<Scalars['bigint']['output']>;
  id_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_tipo_periodicidade?: Maybe<Scalars['bigint']['output']>;
  id_utilizador_responsavel?: Maybe<Scalars['bigint']['output']>;
  id_veiculo?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  leituras: Array<Variaveis_Leituras>;
  /** An aggregate relationship */
  leituras_aggregate: Variaveis_Leituras_Aggregate;
  /** An array relationship */
  locaisInfraestruturas: Array<Servicos_Requisicoes_Locais_Infra_Estruturas>;
  /** An aggregate relationship */
  locaisInfraestruturas_aggregate: Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate;
  mensal_dia_mes?: Maybe<Scalars['String']['output']>;
  mensal_periodicidade?: Maybe<Scalars['String']['output']>;
  mensal_posicao_dia_mes?: Maybe<Scalars['String']['output']>;
  mensal_posicao_dia_semana?: Maybe<Scalars['String']['output']>;
  morada_cliente?: Maybe<Scalars['String']['output']>;
  num_cliente?: Maybe<Scalars['numeric']['output']>;
  num_local_consumo?: Maybe<Scalars['numeric']['output']>;
  numero?: Maybe<Scalars['String']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  oculto_widget?: Maybe<Scalars['Boolean']['output']>;
  periodicidade_data_fim?: Maybe<Scalars['date']['output']>;
  periodicidade_data_inicio?: Maybe<Scalars['date']['output']>;
  /** An array relationship */
  qsRequisicoesPeriodos: Array<Rqs_Requisicoes_Periodos>;
  /** An aggregate relationship */
  qsRequisicoesPeriodos_aggregate: Rqs_Requisicoes_Periodos_Aggregate;
  /** A computed field, executes function "rqs.calculo_tempo_incumprimento_wrapped" */
  qsTempoIncumprimento?: Maybe<Array<Rqs_Requisicoes_Tempos_Wrap>>;
  /** An array relationship */
  rastreabilidadeOrigem: Array<Servicos_Rastreabilidade>;
  /** An aggregate relationship */
  rastreabilidadeOrigem_aggregate: Servicos_Rastreabilidade_Aggregate;
  /** An array relationship */
  requisicaoIntervencoes: Array<Servicos_Requisicoes_R_Intervencoes>;
  /** An aggregate relationship */
  requisicaoIntervencoes_aggregate: Servicos_Requisicoes_R_Intervencoes_Aggregate;
  requisitante?: Maybe<Scalars['String']['output']>;
  sap_cancelamento_comunicado?: Maybe<Scalars['Boolean']['output']>;
  sap_codigo?: Maybe<Scalars['String']['output']>;
  sap_fecho_comunicado?: Maybe<Scalars['Boolean']['output']>;
  sap_isep_id_valvula?: Maybe<Scalars['String']['output']>;
  sap_nota?: Maybe<Scalars['Boolean']['output']>;
  semanal_dias?: Maybe<Scalars['String']['output']>;
  semanal_periodicidade?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sintoma?: Maybe<Sintomas_Arvore>;
  sintoma_extra?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesCoordenadasMobileArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Coordenadas_Order_By>>;
  where?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesCoordenadasMobile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Coordenadas_Order_By>>;
  where?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesLeiturasArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesLeituras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesLocaisInfraestruturasArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesLocaisInfraestruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesQsRequisicoesPeriodosArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Order_By>>;
  where?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesQsRequisicoesPeriodos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Order_By>>;
  where?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesQsTempoIncumprimentoArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Order_By>>;
  where?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesRastreabilidadeOrigemArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Rastreabilidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Rastreabilidade_Order_By>>;
  where?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesRastreabilidadeOrigem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Rastreabilidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Rastreabilidade_Order_By>>;
  where?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesRequisicaoIntervencoesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
};


/** columns and relationships of "servicos.requisicoes" */
export type Servicos_RequisicoesRequisicaoIntervencoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
};

/** aggregated selection of "servicos.requisicoes" */
export type Servicos_Requisicoes_Aggregate = {
  __typename?: 'servicos_requisicoes_aggregate';
  aggregate?: Maybe<Servicos_Requisicoes_Aggregate_Fields>;
  nodes: Array<Servicos_Requisicoes>;
};

export type Servicos_Requisicoes_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Servicos_Requisicoes_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Servicos_Requisicoes_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Servicos_Requisicoes_Aggregate_Bool_Exp_Count>;
};

export type Servicos_Requisicoes_Aggregate_Bool_Exp_Bool_And = {
  arguments: Servicos_Requisicoes_Select_Column_Servicos_Requisicoes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Servicos_Requisicoes_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Servicos_Requisicoes_Select_Column_Servicos_Requisicoes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Servicos_Requisicoes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Servicos_Requisicoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "servicos.requisicoes" */
export type Servicos_Requisicoes_Aggregate_Fields = {
  __typename?: 'servicos_requisicoes_aggregate_fields';
  avg?: Maybe<Servicos_Requisicoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Servicos_Requisicoes_Max_Fields>;
  min?: Maybe<Servicos_Requisicoes_Min_Fields>;
  stddev?: Maybe<Servicos_Requisicoes_Stddev_Fields>;
  stddev_pop?: Maybe<Servicos_Requisicoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Servicos_Requisicoes_Stddev_Samp_Fields>;
  sum?: Maybe<Servicos_Requisicoes_Sum_Fields>;
  var_pop?: Maybe<Servicos_Requisicoes_Var_Pop_Fields>;
  var_samp?: Maybe<Servicos_Requisicoes_Var_Samp_Fields>;
  variance?: Maybe<Servicos_Requisicoes_Variance_Fields>;
};


/** aggregate fields of "servicos.requisicoes" */
export type Servicos_Requisicoes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Servicos_Requisicoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "servicos.requisicoes" */
export type Servicos_Requisicoes_Aggregate_Order_By = {
  avg?: InputMaybe<Servicos_Requisicoes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Servicos_Requisicoes_Max_Order_By>;
  min?: InputMaybe<Servicos_Requisicoes_Min_Order_By>;
  stddev?: InputMaybe<Servicos_Requisicoes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Servicos_Requisicoes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Servicos_Requisicoes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Servicos_Requisicoes_Sum_Order_By>;
  var_pop?: InputMaybe<Servicos_Requisicoes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Servicos_Requisicoes_Var_Samp_Order_By>;
  variance?: InputMaybe<Servicos_Requisicoes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "servicos.requisicoes" */
export type Servicos_Requisicoes_Arr_Rel_Insert_Input = {
  data: Array<Servicos_Requisicoes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Servicos_Requisicoes_On_Conflict>;
};

/** aggregate avg on columns */
export type Servicos_Requisicoes_Avg_Fields = {
  __typename?: 'servicos_requisicoes_avg_fields';
  analise_id_utilizador?: Maybe<Scalars['Float']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  fechada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_comunicacao_fecho?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  num_cliente?: Maybe<Scalars['Float']['output']>;
  num_local_consumo?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "servicos.requisicoes" */
export type Servicos_Requisicoes_Avg_Order_By = {
  analise_id_utilizador?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  fechada_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_entidade_externa?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_comunicacao_fecho?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_periodicidade?: InputMaybe<Order_By>;
  id_utilizador_responsavel?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  num_cliente?: InputMaybe<Order_By>;
  num_local_consumo?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "servicos.requisicoes". All fields are combined with a logical 'AND'. */
export type Servicos_Requisicoes_Bool_Exp = {
  _and?: InputMaybe<Array<Servicos_Requisicoes_Bool_Exp>>;
  _not?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
  _or?: InputMaybe<Array<Servicos_Requisicoes_Bool_Exp>>;
  analise_data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  analise_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  anual_dia_mes?: InputMaybe<String_Comparison_Exp>;
  anual_mes?: InputMaybe<String_Comparison_Exp>;
  anual_posicao_dia_mes?: InputMaybe<String_Comparison_Exp>;
  anual_posicao_dia_semana?: InputMaybe<String_Comparison_Exp>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  cancelada_data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  cancelada_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  cancelada_motivo?: InputMaybe<String_Comparison_Exp>;
  centro?: InputMaybe<Base_Centros_Bool_Exp>;
  contacto?: InputMaybe<String_Comparison_Exp>;
  coordenadasMobile?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
  coordenadasMobile_aggregate?: InputMaybe<Mobile_Coordenadas_Aggregate_Bool_Exp>;
  criacao_data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  criacao_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  dados_externos?: InputMaybe<String_Comparison_Exp>;
  data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  data_ultima_comunicacao?: InputMaybe<Timestamp_Comparison_Exp>;
  diaria_periodicidade?: InputMaybe<String_Comparison_Exp>;
  estado?: InputMaybe<Servicos_Requisicoes_Estados_Bool_Exp>;
  fechada_data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  fechada_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  fechada_motivo?: InputMaybe<String_Comparison_Exp>;
  feriados?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_centro?: InputMaybe<Bigint_Comparison_Exp>;
  id_entidade_externa?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual?: InputMaybe<Bigint_Comparison_Exp>;
  id_estado?: InputMaybe<Bigint_Comparison_Exp>;
  id_estado_comunicacao_fecho?: InputMaybe<Bigint_Comparison_Exp>;
  id_motivo?: InputMaybe<Bigint_Comparison_Exp>;
  id_prioridade?: InputMaybe<Bigint_Comparison_Exp>;
  id_sinalizacao?: InputMaybe<Bigint_Comparison_Exp>;
  id_sintoma?: InputMaybe<Bigint_Comparison_Exp>;
  id_tarefa?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_periodicidade?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador_responsavel?: InputMaybe<Bigint_Comparison_Exp>;
  id_veiculo?: InputMaybe<Bigint_Comparison_Exp>;
  leituras?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
  leituras_aggregate?: InputMaybe<Variaveis_Leituras_Aggregate_Bool_Exp>;
  locaisInfraestruturas?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
  locaisInfraestruturas_aggregate?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate_Bool_Exp>;
  mensal_dia_mes?: InputMaybe<String_Comparison_Exp>;
  mensal_periodicidade?: InputMaybe<String_Comparison_Exp>;
  mensal_posicao_dia_mes?: InputMaybe<String_Comparison_Exp>;
  mensal_posicao_dia_semana?: InputMaybe<String_Comparison_Exp>;
  morada_cliente?: InputMaybe<String_Comparison_Exp>;
  num_cliente?: InputMaybe<Numeric_Comparison_Exp>;
  num_local_consumo?: InputMaybe<Numeric_Comparison_Exp>;
  numero?: InputMaybe<String_Comparison_Exp>;
  obs?: InputMaybe<String_Comparison_Exp>;
  oculto_widget?: InputMaybe<Boolean_Comparison_Exp>;
  periodicidade_data_fim?: InputMaybe<Date_Comparison_Exp>;
  periodicidade_data_inicio?: InputMaybe<Date_Comparison_Exp>;
  qsRequisicoesPeriodos?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
  qsRequisicoesPeriodos_aggregate?: InputMaybe<Rqs_Requisicoes_Periodos_Aggregate_Bool_Exp>;
  qsTempoIncumprimento?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Bool_Exp>;
  rastreabilidadeOrigem?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
  rastreabilidadeOrigem_aggregate?: InputMaybe<Servicos_Rastreabilidade_Aggregate_Bool_Exp>;
  requisicaoIntervencoes?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
  requisicaoIntervencoes_aggregate?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp>;
  requisitante?: InputMaybe<String_Comparison_Exp>;
  sap_cancelamento_comunicado?: InputMaybe<Boolean_Comparison_Exp>;
  sap_codigo?: InputMaybe<String_Comparison_Exp>;
  sap_fecho_comunicado?: InputMaybe<Boolean_Comparison_Exp>;
  sap_isep_id_valvula?: InputMaybe<String_Comparison_Exp>;
  sap_nota?: InputMaybe<Boolean_Comparison_Exp>;
  semanal_dias?: InputMaybe<String_Comparison_Exp>;
  semanal_periodicidade?: InputMaybe<String_Comparison_Exp>;
  sintoma?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  sintoma_extra?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "servicos.requisicoes" */
export enum Servicos_Requisicoes_Constraint {
  /** unique or primary key constraint on columns "numero" */
  RequisicoesNumeroUnico = 'requisicoes_numero_unico',
  /** unique or primary key constraint on columns "id" */
  RequisicoesPkey = 'requisicoes_pkey',
  /** unique or primary key constraint on columns "sap_codigo" */
  RequisicoesSapCodigoKey = 'requisicoes_sap_codigo_key'
}

/** columns and relationships of "servicos.requisicoes_estados" */
export type Servicos_Requisicoes_Estados = {
  __typename?: 'servicos_requisicoes_estados';
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "servicos.requisicoes_estados" */
export type Servicos_Requisicoes_Estados_Aggregate = {
  __typename?: 'servicos_requisicoes_estados_aggregate';
  aggregate?: Maybe<Servicos_Requisicoes_Estados_Aggregate_Fields>;
  nodes: Array<Servicos_Requisicoes_Estados>;
};

/** aggregate fields of "servicos.requisicoes_estados" */
export type Servicos_Requisicoes_Estados_Aggregate_Fields = {
  __typename?: 'servicos_requisicoes_estados_aggregate_fields';
  avg?: Maybe<Servicos_Requisicoes_Estados_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Servicos_Requisicoes_Estados_Max_Fields>;
  min?: Maybe<Servicos_Requisicoes_Estados_Min_Fields>;
  stddev?: Maybe<Servicos_Requisicoes_Estados_Stddev_Fields>;
  stddev_pop?: Maybe<Servicos_Requisicoes_Estados_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Servicos_Requisicoes_Estados_Stddev_Samp_Fields>;
  sum?: Maybe<Servicos_Requisicoes_Estados_Sum_Fields>;
  var_pop?: Maybe<Servicos_Requisicoes_Estados_Var_Pop_Fields>;
  var_samp?: Maybe<Servicos_Requisicoes_Estados_Var_Samp_Fields>;
  variance?: Maybe<Servicos_Requisicoes_Estados_Variance_Fields>;
};


/** aggregate fields of "servicos.requisicoes_estados" */
export type Servicos_Requisicoes_Estados_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Servicos_Requisicoes_Estados_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Servicos_Requisicoes_Estados_Avg_Fields = {
  __typename?: 'servicos_requisicoes_estados_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "servicos.requisicoes_estados". All fields are combined with a logical 'AND'. */
export type Servicos_Requisicoes_Estados_Bool_Exp = {
  _and?: InputMaybe<Array<Servicos_Requisicoes_Estados_Bool_Exp>>;
  _not?: InputMaybe<Servicos_Requisicoes_Estados_Bool_Exp>;
  _or?: InputMaybe<Array<Servicos_Requisicoes_Estados_Bool_Exp>>;
  cor?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "servicos.requisicoes_estados" */
export enum Servicos_Requisicoes_Estados_Constraint {
  /** unique or primary key constraint on columns "id" */
  RequisicoesEstadosPkey = 'requisicoes_estados_pkey'
}

/** input type for incrementing numeric columns in table "servicos.requisicoes_estados" */
export type Servicos_Requisicoes_Estados_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "servicos.requisicoes_estados" */
export type Servicos_Requisicoes_Estados_Insert_Input = {
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Servicos_Requisicoes_Estados_Max_Fields = {
  __typename?: 'servicos_requisicoes_estados_max_fields';
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Servicos_Requisicoes_Estados_Min_Fields = {
  __typename?: 'servicos_requisicoes_estados_min_fields';
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "servicos.requisicoes_estados" */
export type Servicos_Requisicoes_Estados_Mutation_Response = {
  __typename?: 'servicos_requisicoes_estados_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Servicos_Requisicoes_Estados>;
};

/** input type for inserting object relation for remote table "servicos.requisicoes_estados" */
export type Servicos_Requisicoes_Estados_Obj_Rel_Insert_Input = {
  data: Servicos_Requisicoes_Estados_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Servicos_Requisicoes_Estados_On_Conflict>;
};

/** on_conflict condition type for table "servicos.requisicoes_estados" */
export type Servicos_Requisicoes_Estados_On_Conflict = {
  constraint: Servicos_Requisicoes_Estados_Constraint;
  update_columns?: Array<Servicos_Requisicoes_Estados_Update_Column>;
  where?: InputMaybe<Servicos_Requisicoes_Estados_Bool_Exp>;
};

/** Ordering options when selecting data from "servicos.requisicoes_estados". */
export type Servicos_Requisicoes_Estados_Order_By = {
  cor?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: servicos.requisicoes_estados */
export type Servicos_Requisicoes_Estados_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "servicos.requisicoes_estados" */
export enum Servicos_Requisicoes_Estados_Select_Column {
  /** column name */
  Cor = 'cor',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "servicos.requisicoes_estados" */
export type Servicos_Requisicoes_Estados_Set_Input = {
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Servicos_Requisicoes_Estados_Stddev_Fields = {
  __typename?: 'servicos_requisicoes_estados_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Servicos_Requisicoes_Estados_Stddev_Pop_Fields = {
  __typename?: 'servicos_requisicoes_estados_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Servicos_Requisicoes_Estados_Stddev_Samp_Fields = {
  __typename?: 'servicos_requisicoes_estados_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "servicos_requisicoes_estados" */
export type Servicos_Requisicoes_Estados_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Servicos_Requisicoes_Estados_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Servicos_Requisicoes_Estados_Stream_Cursor_Value_Input = {
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Servicos_Requisicoes_Estados_Sum_Fields = {
  __typename?: 'servicos_requisicoes_estados_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "servicos.requisicoes_estados" */
export enum Servicos_Requisicoes_Estados_Update_Column {
  /** column name */
  Cor = 'cor',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Servicos_Requisicoes_Estados_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Servicos_Requisicoes_Estados_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Servicos_Requisicoes_Estados_Set_Input>;
  /** filter the rows which have to be updated */
  where: Servicos_Requisicoes_Estados_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Servicos_Requisicoes_Estados_Var_Pop_Fields = {
  __typename?: 'servicos_requisicoes_estados_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Servicos_Requisicoes_Estados_Var_Samp_Fields = {
  __typename?: 'servicos_requisicoes_estados_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Servicos_Requisicoes_Estados_Variance_Fields = {
  __typename?: 'servicos_requisicoes_estados_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "servicos.requisicoes" */
export type Servicos_Requisicoes_Inc_Input = {
  analise_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  cancelada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  criacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  fechada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_entidade_externa?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_comunicacao_fecho?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_periodicidade?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador_responsavel?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo?: InputMaybe<Scalars['bigint']['input']>;
  num_cliente?: InputMaybe<Scalars['numeric']['input']>;
  num_local_consumo?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "servicos.requisicoes" */
export type Servicos_Requisicoes_Insert_Input = {
  analise_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  analise_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  anual_dia_mes?: InputMaybe<Scalars['String']['input']>;
  anual_mes?: InputMaybe<Scalars['String']['input']>;
  anual_posicao_dia_mes?: InputMaybe<Scalars['String']['input']>;
  anual_posicao_dia_semana?: InputMaybe<Scalars['String']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  cancelada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  cancelada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  cancelada_motivo?: InputMaybe<Scalars['String']['input']>;
  centro?: InputMaybe<Base_Centros_Obj_Rel_Insert_Input>;
  contacto?: InputMaybe<Scalars['String']['input']>;
  coordenadasMobile?: InputMaybe<Mobile_Coordenadas_Arr_Rel_Insert_Input>;
  criacao_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  criacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  dados_externos?: InputMaybe<Scalars['String']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  data_ultima_comunicacao?: InputMaybe<Scalars['timestamp']['input']>;
  diaria_periodicidade?: InputMaybe<Scalars['String']['input']>;
  estado?: InputMaybe<Servicos_Requisicoes_Estados_Obj_Rel_Insert_Input>;
  fechada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  fechada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  fechada_motivo?: InputMaybe<Scalars['String']['input']>;
  feriados?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_entidade_externa?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_comunicacao_fecho?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_periodicidade?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador_responsavel?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo?: InputMaybe<Scalars['bigint']['input']>;
  leituras?: InputMaybe<Variaveis_Leituras_Arr_Rel_Insert_Input>;
  locaisInfraestruturas?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Arr_Rel_Insert_Input>;
  mensal_dia_mes?: InputMaybe<Scalars['String']['input']>;
  mensal_periodicidade?: InputMaybe<Scalars['String']['input']>;
  mensal_posicao_dia_mes?: InputMaybe<Scalars['String']['input']>;
  mensal_posicao_dia_semana?: InputMaybe<Scalars['String']['input']>;
  morada_cliente?: InputMaybe<Scalars['String']['input']>;
  num_cliente?: InputMaybe<Scalars['numeric']['input']>;
  num_local_consumo?: InputMaybe<Scalars['numeric']['input']>;
  numero?: InputMaybe<Scalars['String']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  oculto_widget?: InputMaybe<Scalars['Boolean']['input']>;
  periodicidade_data_fim?: InputMaybe<Scalars['date']['input']>;
  periodicidade_data_inicio?: InputMaybe<Scalars['date']['input']>;
  qsRequisicoesPeriodos?: InputMaybe<Rqs_Requisicoes_Periodos_Arr_Rel_Insert_Input>;
  rastreabilidadeOrigem?: InputMaybe<Servicos_Rastreabilidade_Arr_Rel_Insert_Input>;
  requisicaoIntervencoes?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Arr_Rel_Insert_Input>;
  requisitante?: InputMaybe<Scalars['String']['input']>;
  sap_cancelamento_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_codigo?: InputMaybe<Scalars['String']['input']>;
  sap_fecho_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_isep_id_valvula?: InputMaybe<Scalars['String']['input']>;
  sap_nota?: InputMaybe<Scalars['Boolean']['input']>;
  semanal_dias?: InputMaybe<Scalars['String']['input']>;
  semanal_periodicidade?: InputMaybe<Scalars['String']['input']>;
  sintoma?: InputMaybe<Sintomas_Arvore_Obj_Rel_Insert_Input>;
  sintoma_extra?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas';
  id: Scalars['bigint']['output'];
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_local?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  infraestrutura?: Maybe<Base_Infraestruturas>;
  /** An object relationship */
  infraestruturas_tipo?: Maybe<Base_Infraestruturas_Tipos>;
  obs_local?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  toponimia?: Maybe<Base_Toponimias>;
};

/** aggregated selection of "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_aggregate';
  aggregate?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate_Fields>;
  nodes: Array<Servicos_Requisicoes_Locais_Infra_Estruturas>;
};

export type Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate_Bool_Exp = {
  count?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate_Bool_Exp_Count>;
};

export type Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate_Fields = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_aggregate_fields';
  avg?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Max_Fields>;
  min?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Min_Fields>;
  stddev?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Fields>;
  stddev_pop?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Samp_Fields>;
  sum?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Sum_Fields>;
  var_pop?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Var_Pop_Fields>;
  var_samp?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Var_Samp_Fields>;
  variance?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Variance_Fields>;
};


/** aggregate fields of "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate_Order_By = {
  avg?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Max_Order_By>;
  min?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Min_Order_By>;
  stddev?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Sum_Order_By>;
  var_pop?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Var_Samp_Order_By>;
  variance?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Arr_Rel_Insert_Input = {
  data: Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_On_Conflict>;
};

/** aggregate avg on columns */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Avg_Fields = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "servicos.requisicoes_locais_infra_estruturas". All fields are combined with a logical 'AND'. */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp = {
  _and?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>>;
  _not?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
  _or?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_local?: InputMaybe<Bigint_Comparison_Exp>;
  id_requisicao?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  infraestruturas_tipo?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
  obs_local?: InputMaybe<String_Comparison_Exp>;
  toponimia?: InputMaybe<Base_Toponimias_Bool_Exp>;
};

/** unique or primary key constraints on table "servicos.requisicoes_locais_infra_estruturas" */
export enum Servicos_Requisicoes_Locais_Infra_Estruturas_Constraint {
  /** unique or primary key constraint on columns "id" */
  RequisicoesLocaisInfraEstruturasPkey = 'requisicoes_locais_infra_estruturas_pkey'
}

/** input type for incrementing numeric columns in table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_local?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_local?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
  infraestruturas_tipo?: InputMaybe<Base_Infraestruturas_Tipos_Obj_Rel_Insert_Input>;
  obs_local?: InputMaybe<Scalars['String']['input']>;
  toponimia?: InputMaybe<Base_Toponimias_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Max_Fields = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_local?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  obs_local?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  obs_local?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Min_Fields = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_local?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  obs_local?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  obs_local?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Mutation_Response = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Servicos_Requisicoes_Locais_Infra_Estruturas>;
};

/** on_conflict condition type for table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_On_Conflict = {
  constraint: Servicos_Requisicoes_Locais_Infra_Estruturas_Constraint;
  update_columns?: Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Update_Column>;
  where?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
};

/** Ordering options when selecting data from "servicos.requisicoes_locais_infra_estruturas". */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
  infraestruturas_tipo?: InputMaybe<Base_Infraestruturas_Tipos_Order_By>;
  obs_local?: InputMaybe<Order_By>;
  toponimia?: InputMaybe<Base_Toponimias_Order_By>;
};

/** primary key columns input for table: servicos.requisicoes_locais_infra_estruturas */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "servicos.requisicoes_locais_infra_estruturas" */
export enum Servicos_Requisicoes_Locais_Infra_Estruturas_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdLocal = 'id_local',
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  IdTipoInfraestrutura = 'id_tipo_infraestrutura',
  /** column name */
  ObsLocal = 'obs_local'
}

/** input type for updating data in table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_local?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  obs_local?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Fields = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Pop_Fields = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Samp_Fields = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "servicos_requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Servicos_Requisicoes_Locais_Infra_Estruturas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_local?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  obs_local?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Sum_Fields = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_local?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
};

/** update columns of table "servicos.requisicoes_locais_infra_estruturas" */
export enum Servicos_Requisicoes_Locais_Infra_Estruturas_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdLocal = 'id_local',
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  IdTipoInfraestrutura = 'id_tipo_infraestrutura',
  /** column name */
  ObsLocal = 'obs_local'
}

export type Servicos_Requisicoes_Locais_Infra_Estruturas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Var_Pop_Fields = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Var_Samp_Fields = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Variance_Fields = {
  __typename?: 'servicos_requisicoes_locais_infra_estruturas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_local?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "servicos.requisicoes_locais_infra_estruturas" */
export type Servicos_Requisicoes_Locais_Infra_Estruturas_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_local?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Servicos_Requisicoes_Max_Fields = {
  __typename?: 'servicos_requisicoes_max_fields';
  analise_data_hora?: Maybe<Scalars['timestamp']['output']>;
  analise_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  anual_dia_mes?: Maybe<Scalars['String']['output']>;
  anual_mes?: Maybe<Scalars['String']['output']>;
  anual_posicao_dia_mes?: Maybe<Scalars['String']['output']>;
  anual_posicao_dia_semana?: Maybe<Scalars['String']['output']>;
  cancelada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  cancelada_motivo?: Maybe<Scalars['String']['output']>;
  contacto?: Maybe<Scalars['String']['output']>;
  criacao_data_hora?: Maybe<Scalars['timestamp']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  dados_externos?: Maybe<Scalars['String']['output']>;
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  data_ultima_comunicacao?: Maybe<Scalars['timestamp']['output']>;
  diaria_periodicidade?: Maybe<Scalars['String']['output']>;
  fechada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  fechada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  fechada_motivo?: Maybe<Scalars['String']['output']>;
  feriados?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_entidade_externa?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_comunicacao_fecho?: Maybe<Scalars['bigint']['output']>;
  id_motivo?: Maybe<Scalars['bigint']['output']>;
  id_prioridade?: Maybe<Scalars['bigint']['output']>;
  id_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_tipo_periodicidade?: Maybe<Scalars['bigint']['output']>;
  id_utilizador_responsavel?: Maybe<Scalars['bigint']['output']>;
  id_veiculo?: Maybe<Scalars['bigint']['output']>;
  mensal_dia_mes?: Maybe<Scalars['String']['output']>;
  mensal_periodicidade?: Maybe<Scalars['String']['output']>;
  mensal_posicao_dia_mes?: Maybe<Scalars['String']['output']>;
  mensal_posicao_dia_semana?: Maybe<Scalars['String']['output']>;
  morada_cliente?: Maybe<Scalars['String']['output']>;
  num_cliente?: Maybe<Scalars['numeric']['output']>;
  num_local_consumo?: Maybe<Scalars['numeric']['output']>;
  numero?: Maybe<Scalars['String']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  periodicidade_data_fim?: Maybe<Scalars['date']['output']>;
  periodicidade_data_inicio?: Maybe<Scalars['date']['output']>;
  requisitante?: Maybe<Scalars['String']['output']>;
  sap_codigo?: Maybe<Scalars['String']['output']>;
  sap_isep_id_valvula?: Maybe<Scalars['String']['output']>;
  semanal_dias?: Maybe<Scalars['String']['output']>;
  semanal_periodicidade?: Maybe<Scalars['String']['output']>;
  sintoma_extra?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "servicos.requisicoes" */
export type Servicos_Requisicoes_Max_Order_By = {
  analise_data_hora?: InputMaybe<Order_By>;
  analise_id_utilizador?: InputMaybe<Order_By>;
  anual_dia_mes?: InputMaybe<Order_By>;
  anual_mes?: InputMaybe<Order_By>;
  anual_posicao_dia_mes?: InputMaybe<Order_By>;
  anual_posicao_dia_semana?: InputMaybe<Order_By>;
  cancelada_data_hora?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  cancelada_motivo?: InputMaybe<Order_By>;
  contacto?: InputMaybe<Order_By>;
  criacao_data_hora?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  dados_externos?: InputMaybe<Order_By>;
  data_hora?: InputMaybe<Order_By>;
  data_ultima_comunicacao?: InputMaybe<Order_By>;
  diaria_periodicidade?: InputMaybe<Order_By>;
  fechada_data_hora?: InputMaybe<Order_By>;
  fechada_id_utilizador?: InputMaybe<Order_By>;
  fechada_motivo?: InputMaybe<Order_By>;
  feriados?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_entidade_externa?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_comunicacao_fecho?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_periodicidade?: InputMaybe<Order_By>;
  id_utilizador_responsavel?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  mensal_dia_mes?: InputMaybe<Order_By>;
  mensal_periodicidade?: InputMaybe<Order_By>;
  mensal_posicao_dia_mes?: InputMaybe<Order_By>;
  mensal_posicao_dia_semana?: InputMaybe<Order_By>;
  morada_cliente?: InputMaybe<Order_By>;
  num_cliente?: InputMaybe<Order_By>;
  num_local_consumo?: InputMaybe<Order_By>;
  numero?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  periodicidade_data_fim?: InputMaybe<Order_By>;
  periodicidade_data_inicio?: InputMaybe<Order_By>;
  requisitante?: InputMaybe<Order_By>;
  sap_codigo?: InputMaybe<Order_By>;
  sap_isep_id_valvula?: InputMaybe<Order_By>;
  semanal_dias?: InputMaybe<Order_By>;
  semanal_periodicidade?: InputMaybe<Order_By>;
  sintoma_extra?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Servicos_Requisicoes_Min_Fields = {
  __typename?: 'servicos_requisicoes_min_fields';
  analise_data_hora?: Maybe<Scalars['timestamp']['output']>;
  analise_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  anual_dia_mes?: Maybe<Scalars['String']['output']>;
  anual_mes?: Maybe<Scalars['String']['output']>;
  anual_posicao_dia_mes?: Maybe<Scalars['String']['output']>;
  anual_posicao_dia_semana?: Maybe<Scalars['String']['output']>;
  cancelada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  cancelada_motivo?: Maybe<Scalars['String']['output']>;
  contacto?: Maybe<Scalars['String']['output']>;
  criacao_data_hora?: Maybe<Scalars['timestamp']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  dados_externos?: Maybe<Scalars['String']['output']>;
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  data_ultima_comunicacao?: Maybe<Scalars['timestamp']['output']>;
  diaria_periodicidade?: Maybe<Scalars['String']['output']>;
  fechada_data_hora?: Maybe<Scalars['timestamp']['output']>;
  fechada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  fechada_motivo?: Maybe<Scalars['String']['output']>;
  feriados?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_entidade_externa?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_comunicacao_fecho?: Maybe<Scalars['bigint']['output']>;
  id_motivo?: Maybe<Scalars['bigint']['output']>;
  id_prioridade?: Maybe<Scalars['bigint']['output']>;
  id_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_tipo_periodicidade?: Maybe<Scalars['bigint']['output']>;
  id_utilizador_responsavel?: Maybe<Scalars['bigint']['output']>;
  id_veiculo?: Maybe<Scalars['bigint']['output']>;
  mensal_dia_mes?: Maybe<Scalars['String']['output']>;
  mensal_periodicidade?: Maybe<Scalars['String']['output']>;
  mensal_posicao_dia_mes?: Maybe<Scalars['String']['output']>;
  mensal_posicao_dia_semana?: Maybe<Scalars['String']['output']>;
  morada_cliente?: Maybe<Scalars['String']['output']>;
  num_cliente?: Maybe<Scalars['numeric']['output']>;
  num_local_consumo?: Maybe<Scalars['numeric']['output']>;
  numero?: Maybe<Scalars['String']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  periodicidade_data_fim?: Maybe<Scalars['date']['output']>;
  periodicidade_data_inicio?: Maybe<Scalars['date']['output']>;
  requisitante?: Maybe<Scalars['String']['output']>;
  sap_codigo?: Maybe<Scalars['String']['output']>;
  sap_isep_id_valvula?: Maybe<Scalars['String']['output']>;
  semanal_dias?: Maybe<Scalars['String']['output']>;
  semanal_periodicidade?: Maybe<Scalars['String']['output']>;
  sintoma_extra?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "servicos.requisicoes" */
export type Servicos_Requisicoes_Min_Order_By = {
  analise_data_hora?: InputMaybe<Order_By>;
  analise_id_utilizador?: InputMaybe<Order_By>;
  anual_dia_mes?: InputMaybe<Order_By>;
  anual_mes?: InputMaybe<Order_By>;
  anual_posicao_dia_mes?: InputMaybe<Order_By>;
  anual_posicao_dia_semana?: InputMaybe<Order_By>;
  cancelada_data_hora?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  cancelada_motivo?: InputMaybe<Order_By>;
  contacto?: InputMaybe<Order_By>;
  criacao_data_hora?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  dados_externos?: InputMaybe<Order_By>;
  data_hora?: InputMaybe<Order_By>;
  data_ultima_comunicacao?: InputMaybe<Order_By>;
  diaria_periodicidade?: InputMaybe<Order_By>;
  fechada_data_hora?: InputMaybe<Order_By>;
  fechada_id_utilizador?: InputMaybe<Order_By>;
  fechada_motivo?: InputMaybe<Order_By>;
  feriados?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_entidade_externa?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_comunicacao_fecho?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_periodicidade?: InputMaybe<Order_By>;
  id_utilizador_responsavel?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  mensal_dia_mes?: InputMaybe<Order_By>;
  mensal_periodicidade?: InputMaybe<Order_By>;
  mensal_posicao_dia_mes?: InputMaybe<Order_By>;
  mensal_posicao_dia_semana?: InputMaybe<Order_By>;
  morada_cliente?: InputMaybe<Order_By>;
  num_cliente?: InputMaybe<Order_By>;
  num_local_consumo?: InputMaybe<Order_By>;
  numero?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  periodicidade_data_fim?: InputMaybe<Order_By>;
  periodicidade_data_inicio?: InputMaybe<Order_By>;
  requisitante?: InputMaybe<Order_By>;
  sap_codigo?: InputMaybe<Order_By>;
  sap_isep_id_valvula?: InputMaybe<Order_By>;
  semanal_dias?: InputMaybe<Order_By>;
  semanal_periodicidade?: InputMaybe<Order_By>;
  sintoma_extra?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "servicos.requisicoes" */
export type Servicos_Requisicoes_Mutation_Response = {
  __typename?: 'servicos_requisicoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Servicos_Requisicoes>;
};

/** input type for inserting object relation for remote table "servicos.requisicoes" */
export type Servicos_Requisicoes_Obj_Rel_Insert_Input = {
  data: Servicos_Requisicoes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Servicos_Requisicoes_On_Conflict>;
};

/** on_conflict condition type for table "servicos.requisicoes" */
export type Servicos_Requisicoes_On_Conflict = {
  constraint: Servicos_Requisicoes_Constraint;
  update_columns?: Array<Servicos_Requisicoes_Update_Column>;
  where?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
};

/** Ordering options when selecting data from "servicos.requisicoes". */
export type Servicos_Requisicoes_Order_By = {
  analise_data_hora?: InputMaybe<Order_By>;
  analise_id_utilizador?: InputMaybe<Order_By>;
  anual_dia_mes?: InputMaybe<Order_By>;
  anual_mes?: InputMaybe<Order_By>;
  anual_posicao_dia_mes?: InputMaybe<Order_By>;
  anual_posicao_dia_semana?: InputMaybe<Order_By>;
  apagado?: InputMaybe<Order_By>;
  cancelada_data_hora?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  cancelada_motivo?: InputMaybe<Order_By>;
  centro?: InputMaybe<Base_Centros_Order_By>;
  contacto?: InputMaybe<Order_By>;
  coordenadasMobile_aggregate?: InputMaybe<Mobile_Coordenadas_Aggregate_Order_By>;
  criacao_data_hora?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  dados_externos?: InputMaybe<Order_By>;
  data_hora?: InputMaybe<Order_By>;
  data_ultima_comunicacao?: InputMaybe<Order_By>;
  diaria_periodicidade?: InputMaybe<Order_By>;
  estado?: InputMaybe<Servicos_Requisicoes_Estados_Order_By>;
  fechada_data_hora?: InputMaybe<Order_By>;
  fechada_id_utilizador?: InputMaybe<Order_By>;
  fechada_motivo?: InputMaybe<Order_By>;
  feriados?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_entidade_externa?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_comunicacao_fecho?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_periodicidade?: InputMaybe<Order_By>;
  id_utilizador_responsavel?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  leituras_aggregate?: InputMaybe<Variaveis_Leituras_Aggregate_Order_By>;
  locaisInfraestruturas_aggregate?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate_Order_By>;
  mensal_dia_mes?: InputMaybe<Order_By>;
  mensal_periodicidade?: InputMaybe<Order_By>;
  mensal_posicao_dia_mes?: InputMaybe<Order_By>;
  mensal_posicao_dia_semana?: InputMaybe<Order_By>;
  morada_cliente?: InputMaybe<Order_By>;
  num_cliente?: InputMaybe<Order_By>;
  num_local_consumo?: InputMaybe<Order_By>;
  numero?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  oculto_widget?: InputMaybe<Order_By>;
  periodicidade_data_fim?: InputMaybe<Order_By>;
  periodicidade_data_inicio?: InputMaybe<Order_By>;
  qsRequisicoesPeriodos_aggregate?: InputMaybe<Rqs_Requisicoes_Periodos_Aggregate_Order_By>;
  qsTempoIncumprimento_aggregate?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Aggregate_Order_By>;
  rastreabilidadeOrigem_aggregate?: InputMaybe<Servicos_Rastreabilidade_Aggregate_Order_By>;
  requisicaoIntervencoes_aggregate?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Aggregate_Order_By>;
  requisitante?: InputMaybe<Order_By>;
  sap_cancelamento_comunicado?: InputMaybe<Order_By>;
  sap_codigo?: InputMaybe<Order_By>;
  sap_fecho_comunicado?: InputMaybe<Order_By>;
  sap_isep_id_valvula?: InputMaybe<Order_By>;
  sap_nota?: InputMaybe<Order_By>;
  semanal_dias?: InputMaybe<Order_By>;
  semanal_periodicidade?: InputMaybe<Order_By>;
  sintoma?: InputMaybe<Sintomas_Arvore_Order_By>;
  sintoma_extra?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: servicos.requisicoes */
export type Servicos_Requisicoes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes = {
  __typename?: 'servicos_requisicoes_r_intervencoes';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  intervencao?: Maybe<Servicos_Intervencoes>;
  /** An object relationship */
  requisicao?: Maybe<Servicos_Requisicoes>;
  sap_cancelamento_comunicado?: Maybe<Scalars['Boolean']['output']>;
  sap_criacao_comunicada?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Aggregate = {
  __typename?: 'servicos_requisicoes_r_intervencoes_aggregate';
  aggregate?: Maybe<Servicos_Requisicoes_R_Intervencoes_Aggregate_Fields>;
  nodes: Array<Servicos_Requisicoes_R_Intervencoes>;
};

export type Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp_Count>;
};

export type Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp_Bool_And = {
  arguments: Servicos_Requisicoes_R_Intervencoes_Select_Column_Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Servicos_Requisicoes_R_Intervencoes_Select_Column_Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Aggregate_Fields = {
  __typename?: 'servicos_requisicoes_r_intervencoes_aggregate_fields';
  avg?: Maybe<Servicos_Requisicoes_R_Intervencoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Servicos_Requisicoes_R_Intervencoes_Max_Fields>;
  min?: Maybe<Servicos_Requisicoes_R_Intervencoes_Min_Fields>;
  stddev?: Maybe<Servicos_Requisicoes_R_Intervencoes_Stddev_Fields>;
  stddev_pop?: Maybe<Servicos_Requisicoes_R_Intervencoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Servicos_Requisicoes_R_Intervencoes_Stddev_Samp_Fields>;
  sum?: Maybe<Servicos_Requisicoes_R_Intervencoes_Sum_Fields>;
  var_pop?: Maybe<Servicos_Requisicoes_R_Intervencoes_Var_Pop_Fields>;
  var_samp?: Maybe<Servicos_Requisicoes_R_Intervencoes_Var_Samp_Fields>;
  variance?: Maybe<Servicos_Requisicoes_R_Intervencoes_Variance_Fields>;
};


/** aggregate fields of "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Aggregate_Order_By = {
  avg?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Max_Order_By>;
  min?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Min_Order_By>;
  stddev?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Sum_Order_By>;
  var_pop?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Var_Samp_Order_By>;
  variance?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Arr_Rel_Insert_Input = {
  data: Array<Servicos_Requisicoes_R_Intervencoes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_On_Conflict>;
};

/** aggregate avg on columns */
export type Servicos_Requisicoes_R_Intervencoes_Avg_Fields = {
  __typename?: 'servicos_requisicoes_r_intervencoes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "servicos.requisicoes_r_intervencoes". All fields are combined with a logical 'AND'. */
export type Servicos_Requisicoes_R_Intervencoes_Bool_Exp = {
  _and?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>>;
  _not?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
  _or?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_intervencao?: InputMaybe<Bigint_Comparison_Exp>;
  id_requisicao?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
  sap_cancelamento_comunicado?: InputMaybe<Boolean_Comparison_Exp>;
  sap_criacao_comunicada?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "servicos.requisicoes_r_intervencoes" */
export enum Servicos_Requisicoes_R_Intervencoes_Constraint {
  /** unique or primary key constraint on columns "id_requisicao", "id_intervencao" */
  IndRequisicoesRIntervencoesIdIntervencaoRequisicao = 'ind_requisicoes_r_intervencoes_id_intervencao_requisicao',
  /** unique or primary key constraint on columns "id" */
  RequisicoesRIntervencoesPkey = 'requisicoes_r_intervencoes_pkey'
}

/** input type for incrementing numeric columns in table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Obj_Rel_Insert_Input>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Obj_Rel_Insert_Input>;
  sap_cancelamento_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_criacao_comunicada?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Servicos_Requisicoes_R_Intervencoes_Max_Fields = {
  __typename?: 'servicos_requisicoes_r_intervencoes_max_fields';
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Max_Order_By = {
  data_hora?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Servicos_Requisicoes_R_Intervencoes_Min_Fields = {
  __typename?: 'servicos_requisicoes_r_intervencoes_min_fields';
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Min_Order_By = {
  data_hora?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Mutation_Response = {
  __typename?: 'servicos_requisicoes_r_intervencoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Servicos_Requisicoes_R_Intervencoes>;
};

/** on_conflict condition type for table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_On_Conflict = {
  constraint: Servicos_Requisicoes_R_Intervencoes_Constraint;
  update_columns?: Array<Servicos_Requisicoes_R_Intervencoes_Update_Column>;
  where?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
};

/** Ordering options when selecting data from "servicos.requisicoes_r_intervencoes". */
export type Servicos_Requisicoes_R_Intervencoes_Order_By = {
  apagado?: InputMaybe<Order_By>;
  data_hora?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Order_By>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Order_By>;
  sap_cancelamento_comunicado?: InputMaybe<Order_By>;
  sap_criacao_comunicada?: InputMaybe<Order_By>;
};

/** primary key columns input for table: servicos.requisicoes_r_intervencoes */
export type Servicos_Requisicoes_R_Intervencoes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "servicos.requisicoes_r_intervencoes" */
export enum Servicos_Requisicoes_R_Intervencoes_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  Id = 'id',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  SapCancelamentoComunicado = 'sap_cancelamento_comunicado',
  /** column name */
  SapCriacaoComunicada = 'sap_criacao_comunicada'
}

/** select "servicos_requisicoes_r_intervencoes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "servicos.requisicoes_r_intervencoes" */
export enum Servicos_Requisicoes_R_Intervencoes_Select_Column_Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  SapCancelamentoComunicado = 'sap_cancelamento_comunicado',
  /** column name */
  SapCriacaoComunicada = 'sap_criacao_comunicada'
}

/** select "servicos_requisicoes_r_intervencoes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "servicos.requisicoes_r_intervencoes" */
export enum Servicos_Requisicoes_R_Intervencoes_Select_Column_Servicos_Requisicoes_R_Intervencoes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  SapCancelamentoComunicado = 'sap_cancelamento_comunicado',
  /** column name */
  SapCriacaoComunicada = 'sap_criacao_comunicada'
}

/** input type for updating data in table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  sap_cancelamento_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_criacao_comunicada?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Servicos_Requisicoes_R_Intervencoes_Stddev_Fields = {
  __typename?: 'servicos_requisicoes_r_intervencoes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Servicos_Requisicoes_R_Intervencoes_Stddev_Pop_Fields = {
  __typename?: 'servicos_requisicoes_r_intervencoes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Servicos_Requisicoes_R_Intervencoes_Stddev_Samp_Fields = {
  __typename?: 'servicos_requisicoes_r_intervencoes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "servicos_requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Servicos_Requisicoes_R_Intervencoes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Servicos_Requisicoes_R_Intervencoes_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  sap_cancelamento_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_criacao_comunicada?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Servicos_Requisicoes_R_Intervencoes_Sum_Fields = {
  __typename?: 'servicos_requisicoes_r_intervencoes_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** update columns of table "servicos.requisicoes_r_intervencoes" */
export enum Servicos_Requisicoes_R_Intervencoes_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  Id = 'id',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  SapCancelamentoComunicado = 'sap_cancelamento_comunicado',
  /** column name */
  SapCriacaoComunicada = 'sap_criacao_comunicada'
}

export type Servicos_Requisicoes_R_Intervencoes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Servicos_Requisicoes_R_Intervencoes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Servicos_Requisicoes_R_Intervencoes_Var_Pop_Fields = {
  __typename?: 'servicos_requisicoes_r_intervencoes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Servicos_Requisicoes_R_Intervencoes_Var_Samp_Fields = {
  __typename?: 'servicos_requisicoes_r_intervencoes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Servicos_Requisicoes_R_Intervencoes_Variance_Fields = {
  __typename?: 'servicos_requisicoes_r_intervencoes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "servicos.requisicoes_r_intervencoes" */
export type Servicos_Requisicoes_R_Intervencoes_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** select columns of table "servicos.requisicoes" */
export enum Servicos_Requisicoes_Select_Column {
  /** column name */
  AnaliseDataHora = 'analise_data_hora',
  /** column name */
  AnaliseIdUtilizador = 'analise_id_utilizador',
  /** column name */
  AnualDiaMes = 'anual_dia_mes',
  /** column name */
  AnualMes = 'anual_mes',
  /** column name */
  AnualPosicaoDiaMes = 'anual_posicao_dia_mes',
  /** column name */
  AnualPosicaoDiaSemana = 'anual_posicao_dia_semana',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CanceladaDataHora = 'cancelada_data_hora',
  /** column name */
  CanceladaIdUtilizador = 'cancelada_id_utilizador',
  /** column name */
  CanceladaMotivo = 'cancelada_motivo',
  /** column name */
  Contacto = 'contacto',
  /** column name */
  CriacaoDataHora = 'criacao_data_hora',
  /** column name */
  CriacaoIdUtilizador = 'criacao_id_utilizador',
  /** column name */
  DadosExternos = 'dados_externos',
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  DataUltimaComunicacao = 'data_ultima_comunicacao',
  /** column name */
  DiariaPeriodicidade = 'diaria_periodicidade',
  /** column name */
  FechadaDataHora = 'fechada_data_hora',
  /** column name */
  FechadaIdUtilizador = 'fechada_id_utilizador',
  /** column name */
  FechadaMotivo = 'fechada_motivo',
  /** column name */
  Feriados = 'feriados',
  /** column name */
  Id = 'id',
  /** column name */
  IdCentro = 'id_centro',
  /** column name */
  IdEntidadeExterna = 'id_entidade_externa',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdEstado = 'id_estado',
  /** column name */
  IdEstadoComunicacaoFecho = 'id_estado_comunicacao_fecho',
  /** column name */
  IdMotivo = 'id_motivo',
  /** column name */
  IdPrioridade = 'id_prioridade',
  /** column name */
  IdSinalizacao = 'id_sinalizacao',
  /** column name */
  IdSintoma = 'id_sintoma',
  /** column name */
  IdTarefa = 'id_tarefa',
  /** column name */
  IdTipoPeriodicidade = 'id_tipo_periodicidade',
  /** column name */
  IdUtilizadorResponsavel = 'id_utilizador_responsavel',
  /** column name */
  IdVeiculo = 'id_veiculo',
  /** column name */
  MensalDiaMes = 'mensal_dia_mes',
  /** column name */
  MensalPeriodicidade = 'mensal_periodicidade',
  /** column name */
  MensalPosicaoDiaMes = 'mensal_posicao_dia_mes',
  /** column name */
  MensalPosicaoDiaSemana = 'mensal_posicao_dia_semana',
  /** column name */
  MoradaCliente = 'morada_cliente',
  /** column name */
  NumCliente = 'num_cliente',
  /** column name */
  NumLocalConsumo = 'num_local_consumo',
  /** column name */
  Numero = 'numero',
  /** column name */
  Obs = 'obs',
  /** column name */
  OcultoWidget = 'oculto_widget',
  /** column name */
  PeriodicidadeDataFim = 'periodicidade_data_fim',
  /** column name */
  PeriodicidadeDataInicio = 'periodicidade_data_inicio',
  /** column name */
  Requisitante = 'requisitante',
  /** column name */
  SapCancelamentoComunicado = 'sap_cancelamento_comunicado',
  /** column name */
  SapCodigo = 'sap_codigo',
  /** column name */
  SapFechoComunicado = 'sap_fecho_comunicado',
  /** column name */
  SapIsepIdValvula = 'sap_isep_id_valvula',
  /** column name */
  SapNota = 'sap_nota',
  /** column name */
  SemanalDias = 'semanal_dias',
  /** column name */
  SemanalPeriodicidade = 'semanal_periodicidade',
  /** column name */
  SintomaExtra = 'sintoma_extra',
  /** column name */
  Uuid = 'uuid'
}

/** select "servicos_requisicoes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "servicos.requisicoes" */
export enum Servicos_Requisicoes_Select_Column_Servicos_Requisicoes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  OcultoWidget = 'oculto_widget',
  /** column name */
  SapCancelamentoComunicado = 'sap_cancelamento_comunicado',
  /** column name */
  SapFechoComunicado = 'sap_fecho_comunicado',
  /** column name */
  SapNota = 'sap_nota'
}

/** select "servicos_requisicoes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "servicos.requisicoes" */
export enum Servicos_Requisicoes_Select_Column_Servicos_Requisicoes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  OcultoWidget = 'oculto_widget',
  /** column name */
  SapCancelamentoComunicado = 'sap_cancelamento_comunicado',
  /** column name */
  SapFechoComunicado = 'sap_fecho_comunicado',
  /** column name */
  SapNota = 'sap_nota'
}

/** input type for updating data in table "servicos.requisicoes" */
export type Servicos_Requisicoes_Set_Input = {
  analise_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  analise_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  anual_dia_mes?: InputMaybe<Scalars['String']['input']>;
  anual_mes?: InputMaybe<Scalars['String']['input']>;
  anual_posicao_dia_mes?: InputMaybe<Scalars['String']['input']>;
  anual_posicao_dia_semana?: InputMaybe<Scalars['String']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  cancelada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  cancelada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  cancelada_motivo?: InputMaybe<Scalars['String']['input']>;
  contacto?: InputMaybe<Scalars['String']['input']>;
  criacao_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  criacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  dados_externos?: InputMaybe<Scalars['String']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  data_ultima_comunicacao?: InputMaybe<Scalars['timestamp']['input']>;
  diaria_periodicidade?: InputMaybe<Scalars['String']['input']>;
  fechada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  fechada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  fechada_motivo?: InputMaybe<Scalars['String']['input']>;
  feriados?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_entidade_externa?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_comunicacao_fecho?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_periodicidade?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador_responsavel?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo?: InputMaybe<Scalars['bigint']['input']>;
  mensal_dia_mes?: InputMaybe<Scalars['String']['input']>;
  mensal_periodicidade?: InputMaybe<Scalars['String']['input']>;
  mensal_posicao_dia_mes?: InputMaybe<Scalars['String']['input']>;
  mensal_posicao_dia_semana?: InputMaybe<Scalars['String']['input']>;
  morada_cliente?: InputMaybe<Scalars['String']['input']>;
  num_cliente?: InputMaybe<Scalars['numeric']['input']>;
  num_local_consumo?: InputMaybe<Scalars['numeric']['input']>;
  numero?: InputMaybe<Scalars['String']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  oculto_widget?: InputMaybe<Scalars['Boolean']['input']>;
  periodicidade_data_fim?: InputMaybe<Scalars['date']['input']>;
  periodicidade_data_inicio?: InputMaybe<Scalars['date']['input']>;
  requisitante?: InputMaybe<Scalars['String']['input']>;
  sap_cancelamento_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_codigo?: InputMaybe<Scalars['String']['input']>;
  sap_fecho_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_isep_id_valvula?: InputMaybe<Scalars['String']['input']>;
  sap_nota?: InputMaybe<Scalars['Boolean']['input']>;
  semanal_dias?: InputMaybe<Scalars['String']['input']>;
  semanal_periodicidade?: InputMaybe<Scalars['String']['input']>;
  sintoma_extra?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Servicos_Requisicoes_Stddev_Fields = {
  __typename?: 'servicos_requisicoes_stddev_fields';
  analise_id_utilizador?: Maybe<Scalars['Float']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  fechada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_comunicacao_fecho?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  num_cliente?: Maybe<Scalars['Float']['output']>;
  num_local_consumo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "servicos.requisicoes" */
export type Servicos_Requisicoes_Stddev_Order_By = {
  analise_id_utilizador?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  fechada_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_entidade_externa?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_comunicacao_fecho?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_periodicidade?: InputMaybe<Order_By>;
  id_utilizador_responsavel?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  num_cliente?: InputMaybe<Order_By>;
  num_local_consumo?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Servicos_Requisicoes_Stddev_Pop_Fields = {
  __typename?: 'servicos_requisicoes_stddev_pop_fields';
  analise_id_utilizador?: Maybe<Scalars['Float']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  fechada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_comunicacao_fecho?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  num_cliente?: Maybe<Scalars['Float']['output']>;
  num_local_consumo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "servicos.requisicoes" */
export type Servicos_Requisicoes_Stddev_Pop_Order_By = {
  analise_id_utilizador?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  fechada_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_entidade_externa?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_comunicacao_fecho?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_periodicidade?: InputMaybe<Order_By>;
  id_utilizador_responsavel?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  num_cliente?: InputMaybe<Order_By>;
  num_local_consumo?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Servicos_Requisicoes_Stddev_Samp_Fields = {
  __typename?: 'servicos_requisicoes_stddev_samp_fields';
  analise_id_utilizador?: Maybe<Scalars['Float']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  fechada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_comunicacao_fecho?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  num_cliente?: Maybe<Scalars['Float']['output']>;
  num_local_consumo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "servicos.requisicoes" */
export type Servicos_Requisicoes_Stddev_Samp_Order_By = {
  analise_id_utilizador?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  fechada_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_entidade_externa?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_comunicacao_fecho?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_periodicidade?: InputMaybe<Order_By>;
  id_utilizador_responsavel?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  num_cliente?: InputMaybe<Order_By>;
  num_local_consumo?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "servicos_requisicoes" */
export type Servicos_Requisicoes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Servicos_Requisicoes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Servicos_Requisicoes_Stream_Cursor_Value_Input = {
  analise_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  analise_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  anual_dia_mes?: InputMaybe<Scalars['String']['input']>;
  anual_mes?: InputMaybe<Scalars['String']['input']>;
  anual_posicao_dia_mes?: InputMaybe<Scalars['String']['input']>;
  anual_posicao_dia_semana?: InputMaybe<Scalars['String']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  cancelada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  cancelada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  cancelada_motivo?: InputMaybe<Scalars['String']['input']>;
  contacto?: InputMaybe<Scalars['String']['input']>;
  criacao_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  criacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  dados_externos?: InputMaybe<Scalars['String']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  data_ultima_comunicacao?: InputMaybe<Scalars['timestamp']['input']>;
  diaria_periodicidade?: InputMaybe<Scalars['String']['input']>;
  fechada_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  fechada_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  fechada_motivo?: InputMaybe<Scalars['String']['input']>;
  feriados?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_entidade_externa?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_comunicacao_fecho?: InputMaybe<Scalars['bigint']['input']>;
  id_motivo?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_sinalizacao?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_periodicidade?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador_responsavel?: InputMaybe<Scalars['bigint']['input']>;
  id_veiculo?: InputMaybe<Scalars['bigint']['input']>;
  mensal_dia_mes?: InputMaybe<Scalars['String']['input']>;
  mensal_periodicidade?: InputMaybe<Scalars['String']['input']>;
  mensal_posicao_dia_mes?: InputMaybe<Scalars['String']['input']>;
  mensal_posicao_dia_semana?: InputMaybe<Scalars['String']['input']>;
  morada_cliente?: InputMaybe<Scalars['String']['input']>;
  num_cliente?: InputMaybe<Scalars['numeric']['input']>;
  num_local_consumo?: InputMaybe<Scalars['numeric']['input']>;
  numero?: InputMaybe<Scalars['String']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  oculto_widget?: InputMaybe<Scalars['Boolean']['input']>;
  periodicidade_data_fim?: InputMaybe<Scalars['date']['input']>;
  periodicidade_data_inicio?: InputMaybe<Scalars['date']['input']>;
  requisitante?: InputMaybe<Scalars['String']['input']>;
  sap_cancelamento_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_codigo?: InputMaybe<Scalars['String']['input']>;
  sap_fecho_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_isep_id_valvula?: InputMaybe<Scalars['String']['input']>;
  sap_nota?: InputMaybe<Scalars['Boolean']['input']>;
  semanal_dias?: InputMaybe<Scalars['String']['input']>;
  semanal_periodicidade?: InputMaybe<Scalars['String']['input']>;
  sintoma_extra?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Servicos_Requisicoes_Sum_Fields = {
  __typename?: 'servicos_requisicoes_sum_fields';
  analise_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  fechada_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_entidade_externa?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_comunicacao_fecho?: Maybe<Scalars['bigint']['output']>;
  id_motivo?: Maybe<Scalars['bigint']['output']>;
  id_prioridade?: Maybe<Scalars['bigint']['output']>;
  id_sinalizacao?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_tipo_periodicidade?: Maybe<Scalars['bigint']['output']>;
  id_utilizador_responsavel?: Maybe<Scalars['bigint']['output']>;
  id_veiculo?: Maybe<Scalars['bigint']['output']>;
  num_cliente?: Maybe<Scalars['numeric']['output']>;
  num_local_consumo?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "servicos.requisicoes" */
export type Servicos_Requisicoes_Sum_Order_By = {
  analise_id_utilizador?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  fechada_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_entidade_externa?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_comunicacao_fecho?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_periodicidade?: InputMaybe<Order_By>;
  id_utilizador_responsavel?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  num_cliente?: InputMaybe<Order_By>;
  num_local_consumo?: InputMaybe<Order_By>;
};

/** update columns of table "servicos.requisicoes" */
export enum Servicos_Requisicoes_Update_Column {
  /** column name */
  AnaliseDataHora = 'analise_data_hora',
  /** column name */
  AnaliseIdUtilizador = 'analise_id_utilizador',
  /** column name */
  AnualDiaMes = 'anual_dia_mes',
  /** column name */
  AnualMes = 'anual_mes',
  /** column name */
  AnualPosicaoDiaMes = 'anual_posicao_dia_mes',
  /** column name */
  AnualPosicaoDiaSemana = 'anual_posicao_dia_semana',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CanceladaDataHora = 'cancelada_data_hora',
  /** column name */
  CanceladaIdUtilizador = 'cancelada_id_utilizador',
  /** column name */
  CanceladaMotivo = 'cancelada_motivo',
  /** column name */
  Contacto = 'contacto',
  /** column name */
  CriacaoDataHora = 'criacao_data_hora',
  /** column name */
  CriacaoIdUtilizador = 'criacao_id_utilizador',
  /** column name */
  DadosExternos = 'dados_externos',
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  DataUltimaComunicacao = 'data_ultima_comunicacao',
  /** column name */
  DiariaPeriodicidade = 'diaria_periodicidade',
  /** column name */
  FechadaDataHora = 'fechada_data_hora',
  /** column name */
  FechadaIdUtilizador = 'fechada_id_utilizador',
  /** column name */
  FechadaMotivo = 'fechada_motivo',
  /** column name */
  Feriados = 'feriados',
  /** column name */
  Id = 'id',
  /** column name */
  IdCentro = 'id_centro',
  /** column name */
  IdEntidadeExterna = 'id_entidade_externa',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdEstado = 'id_estado',
  /** column name */
  IdEstadoComunicacaoFecho = 'id_estado_comunicacao_fecho',
  /** column name */
  IdMotivo = 'id_motivo',
  /** column name */
  IdPrioridade = 'id_prioridade',
  /** column name */
  IdSinalizacao = 'id_sinalizacao',
  /** column name */
  IdSintoma = 'id_sintoma',
  /** column name */
  IdTarefa = 'id_tarefa',
  /** column name */
  IdTipoPeriodicidade = 'id_tipo_periodicidade',
  /** column name */
  IdUtilizadorResponsavel = 'id_utilizador_responsavel',
  /** column name */
  IdVeiculo = 'id_veiculo',
  /** column name */
  MensalDiaMes = 'mensal_dia_mes',
  /** column name */
  MensalPeriodicidade = 'mensal_periodicidade',
  /** column name */
  MensalPosicaoDiaMes = 'mensal_posicao_dia_mes',
  /** column name */
  MensalPosicaoDiaSemana = 'mensal_posicao_dia_semana',
  /** column name */
  MoradaCliente = 'morada_cliente',
  /** column name */
  NumCliente = 'num_cliente',
  /** column name */
  NumLocalConsumo = 'num_local_consumo',
  /** column name */
  Numero = 'numero',
  /** column name */
  Obs = 'obs',
  /** column name */
  OcultoWidget = 'oculto_widget',
  /** column name */
  PeriodicidadeDataFim = 'periodicidade_data_fim',
  /** column name */
  PeriodicidadeDataInicio = 'periodicidade_data_inicio',
  /** column name */
  Requisitante = 'requisitante',
  /** column name */
  SapCancelamentoComunicado = 'sap_cancelamento_comunicado',
  /** column name */
  SapCodigo = 'sap_codigo',
  /** column name */
  SapFechoComunicado = 'sap_fecho_comunicado',
  /** column name */
  SapIsepIdValvula = 'sap_isep_id_valvula',
  /** column name */
  SapNota = 'sap_nota',
  /** column name */
  SemanalDias = 'semanal_dias',
  /** column name */
  SemanalPeriodicidade = 'semanal_periodicidade',
  /** column name */
  SintomaExtra = 'sintoma_extra',
  /** column name */
  Uuid = 'uuid'
}

export type Servicos_Requisicoes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Servicos_Requisicoes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Servicos_Requisicoes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Servicos_Requisicoes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Servicos_Requisicoes_Var_Pop_Fields = {
  __typename?: 'servicos_requisicoes_var_pop_fields';
  analise_id_utilizador?: Maybe<Scalars['Float']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  fechada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_comunicacao_fecho?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  num_cliente?: Maybe<Scalars['Float']['output']>;
  num_local_consumo?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "servicos.requisicoes" */
export type Servicos_Requisicoes_Var_Pop_Order_By = {
  analise_id_utilizador?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  fechada_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_entidade_externa?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_comunicacao_fecho?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_periodicidade?: InputMaybe<Order_By>;
  id_utilizador_responsavel?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  num_cliente?: InputMaybe<Order_By>;
  num_local_consumo?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Servicos_Requisicoes_Var_Samp_Fields = {
  __typename?: 'servicos_requisicoes_var_samp_fields';
  analise_id_utilizador?: Maybe<Scalars['Float']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  fechada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_comunicacao_fecho?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  num_cliente?: Maybe<Scalars['Float']['output']>;
  num_local_consumo?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "servicos.requisicoes" */
export type Servicos_Requisicoes_Var_Samp_Order_By = {
  analise_id_utilizador?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  fechada_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_entidade_externa?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_comunicacao_fecho?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_periodicidade?: InputMaybe<Order_By>;
  id_utilizador_responsavel?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  num_cliente?: InputMaybe<Order_By>;
  num_local_consumo?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Servicos_Requisicoes_Variance_Fields = {
  __typename?: 'servicos_requisicoes_variance_fields';
  analise_id_utilizador?: Maybe<Scalars['Float']['output']>;
  cancelada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  criacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  fechada_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_entidade_externa?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_comunicacao_fecho?: Maybe<Scalars['Float']['output']>;
  id_motivo?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_sinalizacao?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
  id_tipo_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_utilizador_responsavel?: Maybe<Scalars['Float']['output']>;
  id_veiculo?: Maybe<Scalars['Float']['output']>;
  num_cliente?: Maybe<Scalars['Float']['output']>;
  num_local_consumo?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "servicos.requisicoes" */
export type Servicos_Requisicoes_Variance_Order_By = {
  analise_id_utilizador?: InputMaybe<Order_By>;
  cancelada_id_utilizador?: InputMaybe<Order_By>;
  criacao_id_utilizador?: InputMaybe<Order_By>;
  fechada_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_entidade_externa?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_comunicacao_fecho?: InputMaybe<Order_By>;
  id_motivo?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_sinalizacao?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  id_tipo_periodicidade?: InputMaybe<Order_By>;
  id_utilizador_responsavel?: InputMaybe<Order_By>;
  id_veiculo?: InputMaybe<Order_By>;
  num_cliente?: InputMaybe<Order_By>;
  num_local_consumo?: InputMaybe<Order_By>;
};

/** columns and relationships of "sintomas.arvore" */
export type Sintomas_Arvore = {
  __typename?: 'sintomas_arvore';
  /** A computed field that returns sintoma active childs */
  activeChilds?: Maybe<Array<Sintomas_Arvore>>;
  apagado?: Maybe<Scalars['Boolean']['output']>;
  atualiza_nome_completo?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  causaRelacoes: Array<Sintomas_Sintomas_Relacao>;
  /** An aggregate relationship */
  causaRelacoes_aggregate: Sintomas_Sintomas_Relacao_Aggregate;
  causas_obrigatorio?: Maybe<Scalars['Boolean']['output']>;
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  coordenada_obrigatorio?: Maybe<Scalars['Boolean']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_extra?: Maybe<Scalars['Boolean']['output']>;
  editavel_registo_intervencao: Scalars['Boolean']['output'];
  encaminhamento_equipa?: Maybe<Scalars['Boolean']['output']>;
  encaminhamento_utilizador?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  equipasVirtuaisSintomas: Array<Utilizadores_Equipas_Virtuais_R_Sintoma>;
  /** An aggregate relationship */
  equipasVirtuaisSintomas_aggregate: Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate;
  foto_intervencao_obrigatorio?: Maybe<Scalars['Boolean']['output']>;
  foto_requisicao_obrigatorio?: Maybe<Scalars['Boolean']['output']>;
  has_childs?: Maybe<Scalars['Boolean']['output']>;
  has_empreitada?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  id_centro_custo?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_urgencia?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parentSymptom?: Maybe<Sintomas_Arvore>;
  /** An array relationship */
  qsSintomas: Array<Rqs_Sintomas>;
  /** An array relationship */
  qsSintomasParametrizacaoTempos: Array<Rqs_Sintomas_Parametrizacao_Tempos>;
  /** An aggregate relationship */
  qsSintomasParametrizacaoTempos_aggregate: Rqs_Sintomas_Parametrizacao_Tempos_Aggregate;
  /** An aggregate relationship */
  qsSintomas_aggregate: Rqs_Sintomas_Aggregate;
  trabalhos_obrigatorio?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "sintomas.arvore" */
export type Sintomas_ArvoreActiveChildsArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Arvore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Arvore_Order_By>>;
  where?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
};


/** columns and relationships of "sintomas.arvore" */
export type Sintomas_ArvoreCausaRelacoesArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Order_By>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
};


/** columns and relationships of "sintomas.arvore" */
export type Sintomas_ArvoreCausaRelacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Order_By>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
};


/** columns and relationships of "sintomas.arvore" */
export type Sintomas_ArvoreEquipasVirtuaisSintomasArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>;
};


/** columns and relationships of "sintomas.arvore" */
export type Sintomas_ArvoreEquipasVirtuaisSintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>;
};


/** columns and relationships of "sintomas.arvore" */
export type Sintomas_ArvoreQsSintomasArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
};


/** columns and relationships of "sintomas.arvore" */
export type Sintomas_ArvoreQsSintomasParametrizacaoTemposArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>;
};


/** columns and relationships of "sintomas.arvore" */
export type Sintomas_ArvoreQsSintomasParametrizacaoTempos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>;
};


/** columns and relationships of "sintomas.arvore" */
export type Sintomas_ArvoreQsSintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
};

/** aggregated selection of "sintomas.arvore" */
export type Sintomas_Arvore_Aggregate = {
  __typename?: 'sintomas_arvore_aggregate';
  aggregate?: Maybe<Sintomas_Arvore_Aggregate_Fields>;
  nodes: Array<Sintomas_Arvore>;
};

/** aggregate fields of "sintomas.arvore" */
export type Sintomas_Arvore_Aggregate_Fields = {
  __typename?: 'sintomas_arvore_aggregate_fields';
  avg?: Maybe<Sintomas_Arvore_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sintomas_Arvore_Max_Fields>;
  min?: Maybe<Sintomas_Arvore_Min_Fields>;
  stddev?: Maybe<Sintomas_Arvore_Stddev_Fields>;
  stddev_pop?: Maybe<Sintomas_Arvore_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sintomas_Arvore_Stddev_Samp_Fields>;
  sum?: Maybe<Sintomas_Arvore_Sum_Fields>;
  var_pop?: Maybe<Sintomas_Arvore_Var_Pop_Fields>;
  var_samp?: Maybe<Sintomas_Arvore_Var_Samp_Fields>;
  variance?: Maybe<Sintomas_Arvore_Variance_Fields>;
};


/** aggregate fields of "sintomas.arvore" */
export type Sintomas_Arvore_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sintomas_Arvore_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sintomas.arvore" */
export type Sintomas_Arvore_Aggregate_Order_By = {
  avg?: InputMaybe<Sintomas_Arvore_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sintomas_Arvore_Max_Order_By>;
  min?: InputMaybe<Sintomas_Arvore_Min_Order_By>;
  stddev?: InputMaybe<Sintomas_Arvore_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sintomas_Arvore_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sintomas_Arvore_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sintomas_Arvore_Sum_Order_By>;
  var_pop?: InputMaybe<Sintomas_Arvore_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sintomas_Arvore_Var_Samp_Order_By>;
  variance?: InputMaybe<Sintomas_Arvore_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Sintomas_Arvore_Avg_Fields = {
  __typename?: 'sintomas_arvore_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_urgencia?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sintomas.arvore" */
export type Sintomas_Arvore_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_urgencia?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sintomas.arvore". All fields are combined with a logical 'AND'. */
export type Sintomas_Arvore_Bool_Exp = {
  _and?: InputMaybe<Array<Sintomas_Arvore_Bool_Exp>>;
  _not?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  _or?: InputMaybe<Array<Sintomas_Arvore_Bool_Exp>>;
  activeChilds?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  atualiza_nome_completo?: InputMaybe<Boolean_Comparison_Exp>;
  causaRelacoes?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
  causaRelacoes_aggregate?: InputMaybe<Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp>;
  causas_obrigatorio?: InputMaybe<Boolean_Comparison_Exp>;
  codigo?: InputMaybe<String_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  coordenada_obrigatorio?: InputMaybe<Boolean_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  descricao_extra?: InputMaybe<Boolean_Comparison_Exp>;
  editavel_registo_intervencao?: InputMaybe<Boolean_Comparison_Exp>;
  encaminhamento_equipa?: InputMaybe<Boolean_Comparison_Exp>;
  encaminhamento_utilizador?: InputMaybe<Boolean_Comparison_Exp>;
  equipasVirtuaisSintomas?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>;
  equipasVirtuaisSintomas_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate_Bool_Exp>;
  foto_intervencao_obrigatorio?: InputMaybe<Boolean_Comparison_Exp>;
  foto_requisicao_obrigatorio?: InputMaybe<Boolean_Comparison_Exp>;
  has_childs?: InputMaybe<Boolean_Comparison_Exp>;
  has_empreitada?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_centro_custo?: InputMaybe<Bigint_Comparison_Exp>;
  id_no_tipo?: InputMaybe<Bigint_Comparison_Exp>;
  id_pai?: InputMaybe<Bigint_Comparison_Exp>;
  id_urgencia?: InputMaybe<Bigint_Comparison_Exp>;
  id_zona_bacia?: InputMaybe<Bigint_Comparison_Exp>;
  nome_completo?: InputMaybe<String_Comparison_Exp>;
  parentSymptom?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  qsSintomas?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
  qsSintomasParametrizacaoTempos?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>;
  qsSintomasParametrizacaoTempos_aggregate?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Aggregate_Bool_Exp>;
  qsSintomas_aggregate?: InputMaybe<Rqs_Sintomas_Aggregate_Bool_Exp>;
  trabalhos_obrigatorio?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "sintomas.arvore" */
export enum Sintomas_Arvore_Constraint {
  /** unique or primary key constraint on columns "id" */
  ArvorePkey = 'arvore_pkey'
}

/** input type for incrementing numeric columns in table "sintomas.arvore" */
export type Sintomas_Arvore_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro_custo?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_urgencia?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "sintomas.arvore" */
export type Sintomas_Arvore_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  causaRelacoes?: InputMaybe<Sintomas_Sintomas_Relacao_Arr_Rel_Insert_Input>;
  causas_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  coordenada_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_extra?: InputMaybe<Scalars['Boolean']['input']>;
  editavel_registo_intervencao?: InputMaybe<Scalars['Boolean']['input']>;
  encaminhamento_equipa?: InputMaybe<Scalars['Boolean']['input']>;
  encaminhamento_utilizador?: InputMaybe<Scalars['Boolean']['input']>;
  equipasVirtuaisSintomas?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Arr_Rel_Insert_Input>;
  foto_intervencao_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  foto_requisicao_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  has_empreitada?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro_custo?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_urgencia?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  parentSymptom?: InputMaybe<Sintomas_Arvore_Obj_Rel_Insert_Input>;
  qsSintomas?: InputMaybe<Rqs_Sintomas_Arr_Rel_Insert_Input>;
  qsSintomasParametrizacaoTempos?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Arr_Rel_Insert_Input>;
  trabalhos_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Sintomas_Arvore_Max_Fields = {
  __typename?: 'sintomas_arvore_max_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro_custo?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_urgencia?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "sintomas.arvore" */
export type Sintomas_Arvore_Max_Order_By = {
  codigo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_urgencia?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sintomas_Arvore_Min_Fields = {
  __typename?: 'sintomas_arvore_min_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro_custo?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_urgencia?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
  nome_completo?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "sintomas.arvore" */
export type Sintomas_Arvore_Min_Order_By = {
  codigo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_urgencia?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sintomas.arvore" */
export type Sintomas_Arvore_Mutation_Response = {
  __typename?: 'sintomas_arvore_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sintomas_Arvore>;
};

/** input type for inserting object relation for remote table "sintomas.arvore" */
export type Sintomas_Arvore_Obj_Rel_Insert_Input = {
  data: Sintomas_Arvore_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sintomas_Arvore_On_Conflict>;
};

/** on_conflict condition type for table "sintomas.arvore" */
export type Sintomas_Arvore_On_Conflict = {
  constraint: Sintomas_Arvore_Constraint;
  update_columns?: Array<Sintomas_Arvore_Update_Column>;
  where?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
};

/** Ordering options when selecting data from "sintomas.arvore". */
export type Sintomas_Arvore_Order_By = {
  activeChilds_aggregate?: InputMaybe<Sintomas_Arvore_Aggregate_Order_By>;
  apagado?: InputMaybe<Order_By>;
  atualiza_nome_completo?: InputMaybe<Order_By>;
  causaRelacoes_aggregate?: InputMaybe<Sintomas_Sintomas_Relacao_Aggregate_Order_By>;
  causas_obrigatorio?: InputMaybe<Order_By>;
  codigo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  coordenada_obrigatorio?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_extra?: InputMaybe<Order_By>;
  editavel_registo_intervencao?: InputMaybe<Order_By>;
  encaminhamento_equipa?: InputMaybe<Order_By>;
  encaminhamento_utilizador?: InputMaybe<Order_By>;
  equipasVirtuaisSintomas_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate_Order_By>;
  foto_intervencao_obrigatorio?: InputMaybe<Order_By>;
  foto_requisicao_obrigatorio?: InputMaybe<Order_By>;
  has_childs?: InputMaybe<Order_By>;
  has_empreitada?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_urgencia?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
  nome_completo?: InputMaybe<Order_By>;
  parentSymptom?: InputMaybe<Sintomas_Arvore_Order_By>;
  qsSintomasParametrizacaoTempos_aggregate?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Aggregate_Order_By>;
  qsSintomas_aggregate?: InputMaybe<Rqs_Sintomas_Aggregate_Order_By>;
  trabalhos_obrigatorio?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sintomas.arvore */
export type Sintomas_Arvore_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "sintomas.arvore" */
export enum Sintomas_Arvore_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  CausasObrigatorio = 'causas_obrigatorio',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  CoordenadaObrigatorio = 'coordenada_obrigatorio',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoExtra = 'descricao_extra',
  /** column name */
  EditavelRegistoIntervencao = 'editavel_registo_intervencao',
  /** column name */
  EncaminhamentoEquipa = 'encaminhamento_equipa',
  /** column name */
  EncaminhamentoUtilizador = 'encaminhamento_utilizador',
  /** column name */
  FotoIntervencaoObrigatorio = 'foto_intervencao_obrigatorio',
  /** column name */
  FotoRequisicaoObrigatorio = 'foto_requisicao_obrigatorio',
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  HasEmpreitada = 'has_empreitada',
  /** column name */
  Id = 'id',
  /** column name */
  IdCentroCusto = 'id_centro_custo',
  /** column name */
  IdNoTipo = 'id_no_tipo',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdUrgencia = 'id_urgencia',
  /** column name */
  IdZonaBacia = 'id_zona_bacia',
  /** column name */
  NomeCompleto = 'nome_completo',
  /** column name */
  TrabalhosObrigatorio = 'trabalhos_obrigatorio'
}

/** input type for updating data in table "sintomas.arvore" */
export type Sintomas_Arvore_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  causas_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  coordenada_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_extra?: InputMaybe<Scalars['Boolean']['input']>;
  editavel_registo_intervencao?: InputMaybe<Scalars['Boolean']['input']>;
  encaminhamento_equipa?: InputMaybe<Scalars['Boolean']['input']>;
  encaminhamento_utilizador?: InputMaybe<Scalars['Boolean']['input']>;
  foto_intervencao_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  foto_requisicao_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  has_empreitada?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro_custo?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_urgencia?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  trabalhos_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Sintomas_Arvore_Stddev_Fields = {
  __typename?: 'sintomas_arvore_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_urgencia?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sintomas.arvore" */
export type Sintomas_Arvore_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_urgencia?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sintomas_Arvore_Stddev_Pop_Fields = {
  __typename?: 'sintomas_arvore_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_urgencia?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sintomas.arvore" */
export type Sintomas_Arvore_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_urgencia?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sintomas_Arvore_Stddev_Samp_Fields = {
  __typename?: 'sintomas_arvore_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_urgencia?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sintomas.arvore" */
export type Sintomas_Arvore_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_urgencia?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sintomas_arvore" */
export type Sintomas_Arvore_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sintomas_Arvore_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sintomas_Arvore_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atualiza_nome_completo?: InputMaybe<Scalars['Boolean']['input']>;
  causas_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  coordenada_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_extra?: InputMaybe<Scalars['Boolean']['input']>;
  editavel_registo_intervencao?: InputMaybe<Scalars['Boolean']['input']>;
  encaminhamento_equipa?: InputMaybe<Scalars['Boolean']['input']>;
  encaminhamento_utilizador?: InputMaybe<Scalars['Boolean']['input']>;
  foto_intervencao_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  foto_requisicao_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  has_empreitada?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro_custo?: InputMaybe<Scalars['bigint']['input']>;
  id_no_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  id_urgencia?: InputMaybe<Scalars['bigint']['input']>;
  id_zona_bacia?: InputMaybe<Scalars['bigint']['input']>;
  nome_completo?: InputMaybe<Scalars['String']['input']>;
  trabalhos_obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Sintomas_Arvore_Sum_Fields = {
  __typename?: 'sintomas_arvore_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro_custo?: Maybe<Scalars['bigint']['output']>;
  id_no_tipo?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  id_urgencia?: Maybe<Scalars['bigint']['output']>;
  id_zona_bacia?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "sintomas.arvore" */
export type Sintomas_Arvore_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_urgencia?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** update columns of table "sintomas.arvore" */
export enum Sintomas_Arvore_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  AtualizaNomeCompleto = 'atualiza_nome_completo',
  /** column name */
  CausasObrigatorio = 'causas_obrigatorio',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  CoordenadaObrigatorio = 'coordenada_obrigatorio',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoExtra = 'descricao_extra',
  /** column name */
  EditavelRegistoIntervencao = 'editavel_registo_intervencao',
  /** column name */
  EncaminhamentoEquipa = 'encaminhamento_equipa',
  /** column name */
  EncaminhamentoUtilizador = 'encaminhamento_utilizador',
  /** column name */
  FotoIntervencaoObrigatorio = 'foto_intervencao_obrigatorio',
  /** column name */
  FotoRequisicaoObrigatorio = 'foto_requisicao_obrigatorio',
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  HasEmpreitada = 'has_empreitada',
  /** column name */
  Id = 'id',
  /** column name */
  IdCentroCusto = 'id_centro_custo',
  /** column name */
  IdNoTipo = 'id_no_tipo',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  IdUrgencia = 'id_urgencia',
  /** column name */
  IdZonaBacia = 'id_zona_bacia',
  /** column name */
  NomeCompleto = 'nome_completo',
  /** column name */
  TrabalhosObrigatorio = 'trabalhos_obrigatorio'
}

export type Sintomas_Arvore_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sintomas_Arvore_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sintomas_Arvore_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sintomas_Arvore_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sintomas_Arvore_Var_Pop_Fields = {
  __typename?: 'sintomas_arvore_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_urgencia?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sintomas.arvore" */
export type Sintomas_Arvore_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_urgencia?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sintomas_Arvore_Var_Samp_Fields = {
  __typename?: 'sintomas_arvore_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_urgencia?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sintomas.arvore" */
export type Sintomas_Arvore_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_urgencia?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sintomas_Arvore_Variance_Fields = {
  __typename?: 'sintomas_arvore_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro_custo?: Maybe<Scalars['Float']['output']>;
  id_no_tipo?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  id_urgencia?: Maybe<Scalars['Float']['output']>;
  id_zona_bacia?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sintomas.arvore" */
export type Sintomas_Arvore_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro_custo?: InputMaybe<Order_By>;
  id_no_tipo?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  id_urgencia?: InputMaybe<Order_By>;
  id_zona_bacia?: InputMaybe<Order_By>;
};

/** columns and relationships of "sintomas.causas_trabalhos" */
export type Sintomas_Causas_Trabalhos = {
  __typename?: 'sintomas_causas_trabalhos';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  causa?: Maybe<Scalars['Boolean']['output']>;
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  infraestrutura?: Maybe<Scalars['Boolean']['output']>;
  obs?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "sintomas.causas_trabalhos" */
export type Sintomas_Causas_Trabalhos_Aggregate = {
  __typename?: 'sintomas_causas_trabalhos_aggregate';
  aggregate?: Maybe<Sintomas_Causas_Trabalhos_Aggregate_Fields>;
  nodes: Array<Sintomas_Causas_Trabalhos>;
};

/** aggregate fields of "sintomas.causas_trabalhos" */
export type Sintomas_Causas_Trabalhos_Aggregate_Fields = {
  __typename?: 'sintomas_causas_trabalhos_aggregate_fields';
  avg?: Maybe<Sintomas_Causas_Trabalhos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sintomas_Causas_Trabalhos_Max_Fields>;
  min?: Maybe<Sintomas_Causas_Trabalhos_Min_Fields>;
  stddev?: Maybe<Sintomas_Causas_Trabalhos_Stddev_Fields>;
  stddev_pop?: Maybe<Sintomas_Causas_Trabalhos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sintomas_Causas_Trabalhos_Stddev_Samp_Fields>;
  sum?: Maybe<Sintomas_Causas_Trabalhos_Sum_Fields>;
  var_pop?: Maybe<Sintomas_Causas_Trabalhos_Var_Pop_Fields>;
  var_samp?: Maybe<Sintomas_Causas_Trabalhos_Var_Samp_Fields>;
  variance?: Maybe<Sintomas_Causas_Trabalhos_Variance_Fields>;
};


/** aggregate fields of "sintomas.causas_trabalhos" */
export type Sintomas_Causas_Trabalhos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Sintomas_Causas_Trabalhos_Avg_Fields = {
  __typename?: 'sintomas_causas_trabalhos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "sintomas.causas_trabalhos". All fields are combined with a logical 'AND'. */
export type Sintomas_Causas_Trabalhos_Bool_Exp = {
  _and?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Bool_Exp>>;
  _not?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
  _or?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  causa?: InputMaybe<Boolean_Comparison_Exp>;
  codigo?: InputMaybe<String_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  infraestrutura?: InputMaybe<Boolean_Comparison_Exp>;
  obs?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "sintomas.causas_trabalhos" */
export enum Sintomas_Causas_Trabalhos_Constraint {
  /** unique or primary key constraint on columns "id" */
  CausasPkey = 'causas_pkey',
  /** unique or primary key constraint on columns "codigo_externo" */
  UniqueCodigoExterno = 'unique_codigo_externo'
}

/** input type for incrementing numeric columns in table "sintomas.causas_trabalhos" */
export type Sintomas_Causas_Trabalhos_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "sintomas.causas_trabalhos" */
export type Sintomas_Causas_Trabalhos_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  causa?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Scalars['Boolean']['input']>;
  obs?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Sintomas_Causas_Trabalhos_Max_Fields = {
  __typename?: 'sintomas_causas_trabalhos_max_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Sintomas_Causas_Trabalhos_Min_Fields = {
  __typename?: 'sintomas_causas_trabalhos_min_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "sintomas.causas_trabalhos" */
export type Sintomas_Causas_Trabalhos_Mutation_Response = {
  __typename?: 'sintomas_causas_trabalhos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sintomas_Causas_Trabalhos>;
};

/** input type for inserting object relation for remote table "sintomas.causas_trabalhos" */
export type Sintomas_Causas_Trabalhos_Obj_Rel_Insert_Input = {
  data: Sintomas_Causas_Trabalhos_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sintomas_Causas_Trabalhos_On_Conflict>;
};

/** on_conflict condition type for table "sintomas.causas_trabalhos" */
export type Sintomas_Causas_Trabalhos_On_Conflict = {
  constraint: Sintomas_Causas_Trabalhos_Constraint;
  update_columns?: Array<Sintomas_Causas_Trabalhos_Update_Column>;
  where?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
};

/** Ordering options when selecting data from "sintomas.causas_trabalhos". */
export type Sintomas_Causas_Trabalhos_Order_By = {
  apagado?: InputMaybe<Order_By>;
  causa?: InputMaybe<Order_By>;
  codigo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sintomas.causas_trabalhos */
export type Sintomas_Causas_Trabalhos_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "sintomas.causas_trabalhos" */
export enum Sintomas_Causas_Trabalhos_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Causa = 'causa',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  Infraestrutura = 'infraestrutura',
  /** column name */
  Obs = 'obs'
}

/** input type for updating data in table "sintomas.causas_trabalhos" */
export type Sintomas_Causas_Trabalhos_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  causa?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Scalars['Boolean']['input']>;
  obs?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Sintomas_Causas_Trabalhos_Stddev_Fields = {
  __typename?: 'sintomas_causas_trabalhos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Sintomas_Causas_Trabalhos_Stddev_Pop_Fields = {
  __typename?: 'sintomas_causas_trabalhos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Sintomas_Causas_Trabalhos_Stddev_Samp_Fields = {
  __typename?: 'sintomas_causas_trabalhos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "sintomas_causas_trabalhos" */
export type Sintomas_Causas_Trabalhos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sintomas_Causas_Trabalhos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sintomas_Causas_Trabalhos_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  causa?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Scalars['Boolean']['input']>;
  obs?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Sintomas_Causas_Trabalhos_Sum_Fields = {
  __typename?: 'sintomas_causas_trabalhos_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "sintomas.causas_trabalhos" */
export enum Sintomas_Causas_Trabalhos_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Causa = 'causa',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  Infraestrutura = 'infraestrutura',
  /** column name */
  Obs = 'obs'
}

export type Sintomas_Causas_Trabalhos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sintomas_Causas_Trabalhos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sintomas_Causas_Trabalhos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sintomas_Causas_Trabalhos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sintomas_Causas_Trabalhos_Var_Pop_Fields = {
  __typename?: 'sintomas_causas_trabalhos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Sintomas_Causas_Trabalhos_Var_Samp_Fields = {
  __typename?: 'sintomas_causas_trabalhos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Sintomas_Causas_Trabalhos_Variance_Fields = {
  __typename?: 'sintomas_causas_trabalhos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao = {
  __typename?: 'sintomas_sintomas_relacao';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  causaTrabalho?: Maybe<Sintomas_Causas_Trabalhos>;
  /** An object relationship */
  fase?: Maybe<Servicos_Fases>;
  /** An object relationship */
  fonteOrigem?: Maybe<Variaveis_Fontes_Origem>;
  id: Scalars['bigint']['output'];
  id_causa_trabalho?: Maybe<Scalars['bigint']['output']>;
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  obrigatorio?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  relacaoOrdem?: Maybe<Sintomas_Sintomas_Relacao_Ordem>;
};

/** aggregated selection of "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Aggregate = {
  __typename?: 'sintomas_sintomas_relacao_aggregate';
  aggregate?: Maybe<Sintomas_Sintomas_Relacao_Aggregate_Fields>;
  nodes: Array<Sintomas_Sintomas_Relacao>;
};

export type Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp_Count>;
};

export type Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp_Bool_And = {
  arguments: Sintomas_Sintomas_Relacao_Select_Column_Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Sintomas_Sintomas_Relacao_Select_Column_Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Aggregate_Fields = {
  __typename?: 'sintomas_sintomas_relacao_aggregate_fields';
  avg?: Maybe<Sintomas_Sintomas_Relacao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sintomas_Sintomas_Relacao_Max_Fields>;
  min?: Maybe<Sintomas_Sintomas_Relacao_Min_Fields>;
  stddev?: Maybe<Sintomas_Sintomas_Relacao_Stddev_Fields>;
  stddev_pop?: Maybe<Sintomas_Sintomas_Relacao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sintomas_Sintomas_Relacao_Stddev_Samp_Fields>;
  sum?: Maybe<Sintomas_Sintomas_Relacao_Sum_Fields>;
  var_pop?: Maybe<Sintomas_Sintomas_Relacao_Var_Pop_Fields>;
  var_samp?: Maybe<Sintomas_Sintomas_Relacao_Var_Samp_Fields>;
  variance?: Maybe<Sintomas_Sintomas_Relacao_Variance_Fields>;
};


/** aggregate fields of "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Aggregate_Order_By = {
  avg?: InputMaybe<Sintomas_Sintomas_Relacao_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sintomas_Sintomas_Relacao_Max_Order_By>;
  min?: InputMaybe<Sintomas_Sintomas_Relacao_Min_Order_By>;
  stddev?: InputMaybe<Sintomas_Sintomas_Relacao_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sintomas_Sintomas_Relacao_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sintomas_Sintomas_Relacao_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sintomas_Sintomas_Relacao_Sum_Order_By>;
  var_pop?: InputMaybe<Sintomas_Sintomas_Relacao_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sintomas_Sintomas_Relacao_Var_Samp_Order_By>;
  variance?: InputMaybe<Sintomas_Sintomas_Relacao_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Arr_Rel_Insert_Input = {
  data: Array<Sintomas_Sintomas_Relacao_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sintomas_Sintomas_Relacao_On_Conflict>;
};

/** aggregate avg on columns */
export type Sintomas_Sintomas_Relacao_Avg_Fields = {
  __typename?: 'sintomas_sintomas_relacao_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sintomas.sintomas_relacao". All fields are combined with a logical 'AND'. */
export type Sintomas_Sintomas_Relacao_Bool_Exp = {
  _and?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Bool_Exp>>;
  _not?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
  _or?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  causaTrabalho?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
  fase?: InputMaybe<Servicos_Fases_Bool_Exp>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_causa_trabalho?: InputMaybe<Bigint_Comparison_Exp>;
  id_fase?: InputMaybe<Bigint_Comparison_Exp>;
  id_fonte_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_sintoma?: InputMaybe<Bigint_Comparison_Exp>;
  obrigatorio?: InputMaybe<Boolean_Comparison_Exp>;
  relacaoOrdem?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Bool_Exp>;
};

/** unique or primary key constraints on table "sintomas.sintomas_relacao" */
export enum Sintomas_Sintomas_Relacao_Constraint {
  /** unique or primary key constraint on columns "id" */
  ArvoreRVariaveisPkey = 'arvore_r_variaveis_pkey'
}

/** input type for incrementing numeric columns in table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_causa_trabalho?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  causaTrabalho?: InputMaybe<Sintomas_Causas_Trabalhos_Obj_Rel_Insert_Input>;
  fase?: InputMaybe<Servicos_Fases_Obj_Rel_Insert_Input>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_causa_trabalho?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
  relacaoOrdem?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Sintomas_Sintomas_Relacao_Max_Fields = {
  __typename?: 'sintomas_sintomas_relacao_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_causa_trabalho?: Maybe<Scalars['bigint']['output']>;
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sintomas_Sintomas_Relacao_Min_Fields = {
  __typename?: 'sintomas_sintomas_relacao_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_causa_trabalho?: Maybe<Scalars['bigint']['output']>;
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Mutation_Response = {
  __typename?: 'sintomas_sintomas_relacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sintomas_Sintomas_Relacao>;
};

/** on_conflict condition type for table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_On_Conflict = {
  constraint: Sintomas_Sintomas_Relacao_Constraint;
  update_columns?: Array<Sintomas_Sintomas_Relacao_Update_Column>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
};

/** columns and relationships of "sintomas.sintomas_relacao_ordem" */
export type Sintomas_Sintomas_Relacao_Ordem = {
  __typename?: 'sintomas_sintomas_relacao_ordem';
  id: Scalars['Int']['output'];
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "sintomas.sintomas_relacao_ordem" */
export type Sintomas_Sintomas_Relacao_Ordem_Aggregate = {
  __typename?: 'sintomas_sintomas_relacao_ordem_aggregate';
  aggregate?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Aggregate_Fields>;
  nodes: Array<Sintomas_Sintomas_Relacao_Ordem>;
};

/** aggregate fields of "sintomas.sintomas_relacao_ordem" */
export type Sintomas_Sintomas_Relacao_Ordem_Aggregate_Fields = {
  __typename?: 'sintomas_sintomas_relacao_ordem_aggregate_fields';
  avg?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Max_Fields>;
  min?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Min_Fields>;
  stddev?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Stddev_Fields>;
  stddev_pop?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Stddev_Samp_Fields>;
  sum?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Sum_Fields>;
  var_pop?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Var_Pop_Fields>;
  var_samp?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Var_Samp_Fields>;
  variance?: Maybe<Sintomas_Sintomas_Relacao_Ordem_Variance_Fields>;
};


/** aggregate fields of "sintomas.sintomas_relacao_ordem" */
export type Sintomas_Sintomas_Relacao_Ordem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Ordem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Sintomas_Sintomas_Relacao_Ordem_Avg_Fields = {
  __typename?: 'sintomas_sintomas_relacao_ordem_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "sintomas.sintomas_relacao_ordem". All fields are combined with a logical 'AND'. */
export type Sintomas_Sintomas_Relacao_Ordem_Bool_Exp = {
  _and?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Ordem_Bool_Exp>>;
  _not?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Bool_Exp>;
  _or?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Ordem_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  id_fonte_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_sintoma?: InputMaybe<Bigint_Comparison_Exp>;
  ordem?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "sintomas.sintomas_relacao_ordem" */
export enum Sintomas_Sintomas_Relacao_Ordem_Constraint {
  /** unique or primary key constraint on columns "id" */
  SintomasRelacaoOrdemPkey = 'sintomas_relacao_ordem_pkey'
}

/** input type for incrementing numeric columns in table "sintomas.sintomas_relacao_ordem" */
export type Sintomas_Sintomas_Relacao_Ordem_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "sintomas.sintomas_relacao_ordem" */
export type Sintomas_Sintomas_Relacao_Ordem_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Sintomas_Sintomas_Relacao_Ordem_Max_Fields = {
  __typename?: 'sintomas_sintomas_relacao_ordem_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Sintomas_Sintomas_Relacao_Ordem_Min_Fields = {
  __typename?: 'sintomas_sintomas_relacao_ordem_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "sintomas.sintomas_relacao_ordem" */
export type Sintomas_Sintomas_Relacao_Ordem_Mutation_Response = {
  __typename?: 'sintomas_sintomas_relacao_ordem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sintomas_Sintomas_Relacao_Ordem>;
};

/** input type for inserting object relation for remote table "sintomas.sintomas_relacao_ordem" */
export type Sintomas_Sintomas_Relacao_Ordem_Obj_Rel_Insert_Input = {
  data: Sintomas_Sintomas_Relacao_Ordem_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_On_Conflict>;
};

/** on_conflict condition type for table "sintomas.sintomas_relacao_ordem" */
export type Sintomas_Sintomas_Relacao_Ordem_On_Conflict = {
  constraint: Sintomas_Sintomas_Relacao_Ordem_Constraint;
  update_columns?: Array<Sintomas_Sintomas_Relacao_Ordem_Update_Column>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Bool_Exp>;
};

/** Ordering options when selecting data from "sintomas.sintomas_relacao_ordem". */
export type Sintomas_Sintomas_Relacao_Ordem_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sintomas.sintomas_relacao_ordem */
export type Sintomas_Sintomas_Relacao_Ordem_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "sintomas.sintomas_relacao_ordem" */
export enum Sintomas_Sintomas_Relacao_Ordem_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdSintoma = 'id_sintoma',
  /** column name */
  Ordem = 'ordem'
}

/** input type for updating data in table "sintomas.sintomas_relacao_ordem" */
export type Sintomas_Sintomas_Relacao_Ordem_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Sintomas_Sintomas_Relacao_Ordem_Stddev_Fields = {
  __typename?: 'sintomas_sintomas_relacao_ordem_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Sintomas_Sintomas_Relacao_Ordem_Stddev_Pop_Fields = {
  __typename?: 'sintomas_sintomas_relacao_ordem_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Sintomas_Sintomas_Relacao_Ordem_Stddev_Samp_Fields = {
  __typename?: 'sintomas_sintomas_relacao_ordem_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "sintomas_sintomas_relacao_ordem" */
export type Sintomas_Sintomas_Relacao_Ordem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sintomas_Sintomas_Relacao_Ordem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sintomas_Sintomas_Relacao_Ordem_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Sintomas_Sintomas_Relacao_Ordem_Sum_Fields = {
  __typename?: 'sintomas_sintomas_relacao_ordem_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "sintomas.sintomas_relacao_ordem" */
export enum Sintomas_Sintomas_Relacao_Ordem_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdSintoma = 'id_sintoma',
  /** column name */
  Ordem = 'ordem'
}

export type Sintomas_Sintomas_Relacao_Ordem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sintomas_Sintomas_Relacao_Ordem_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sintomas_Sintomas_Relacao_Ordem_Var_Pop_Fields = {
  __typename?: 'sintomas_sintomas_relacao_ordem_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Sintomas_Sintomas_Relacao_Ordem_Var_Samp_Fields = {
  __typename?: 'sintomas_sintomas_relacao_ordem_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Sintomas_Sintomas_Relacao_Ordem_Variance_Fields = {
  __typename?: 'sintomas_sintomas_relacao_ordem_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "sintomas.sintomas_relacao". */
export type Sintomas_Sintomas_Relacao_Order_By = {
  apagado?: InputMaybe<Order_By>;
  causaTrabalho?: InputMaybe<Sintomas_Causas_Trabalhos_Order_By>;
  fase?: InputMaybe<Servicos_Fases_Order_By>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Order_By>;
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
  obrigatorio?: InputMaybe<Order_By>;
  relacaoOrdem?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Order_By>;
};

/** primary key columns input for table: sintomas.sintomas_relacao */
export type Sintomas_Sintomas_Relacao_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "sintomas.sintomas_relacao" */
export enum Sintomas_Sintomas_Relacao_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Id = 'id',
  /** column name */
  IdCausaTrabalho = 'id_causa_trabalho',
  /** column name */
  IdFase = 'id_fase',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdSintoma = 'id_sintoma',
  /** column name */
  Obrigatorio = 'obrigatorio'
}

/** select "sintomas_sintomas_relacao_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sintomas.sintomas_relacao" */
export enum Sintomas_Sintomas_Relacao_Select_Column_Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Obrigatorio = 'obrigatorio'
}

/** select "sintomas_sintomas_relacao_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sintomas.sintomas_relacao" */
export enum Sintomas_Sintomas_Relacao_Select_Column_Sintomas_Sintomas_Relacao_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Obrigatorio = 'obrigatorio'
}

/** input type for updating data in table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_causa_trabalho?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Sintomas_Sintomas_Relacao_Stddev_Fields = {
  __typename?: 'sintomas_sintomas_relacao_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sintomas_Sintomas_Relacao_Stddev_Pop_Fields = {
  __typename?: 'sintomas_sintomas_relacao_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sintomas_Sintomas_Relacao_Stddev_Samp_Fields = {
  __typename?: 'sintomas_sintomas_relacao_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sintomas_sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sintomas_Sintomas_Relacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sintomas_Sintomas_Relacao_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_causa_trabalho?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
  obrigatorio?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Sintomas_Sintomas_Relacao_Sum_Fields = {
  __typename?: 'sintomas_sintomas_relacao_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_causa_trabalho?: Maybe<Scalars['bigint']['output']>;
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** update columns of table "sintomas.sintomas_relacao" */
export enum Sintomas_Sintomas_Relacao_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Id = 'id',
  /** column name */
  IdCausaTrabalho = 'id_causa_trabalho',
  /** column name */
  IdFase = 'id_fase',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdSintoma = 'id_sintoma',
  /** column name */
  Obrigatorio = 'obrigatorio'
}

export type Sintomas_Sintomas_Relacao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sintomas_Sintomas_Relacao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sintomas_Sintomas_Relacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sintomas_Sintomas_Relacao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sintomas_Sintomas_Relacao_Var_Pop_Fields = {
  __typename?: 'sintomas_sintomas_relacao_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sintomas_Sintomas_Relacao_Var_Samp_Fields = {
  __typename?: 'sintomas_sintomas_relacao_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sintomas_Sintomas_Relacao_Variance_Fields = {
  __typename?: 'sintomas_sintomas_relacao_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_causa_trabalho?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "sintomas.sintomas_relacao" */
export type Sintomas_Sintomas_Relacao_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_causa_trabalho?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  age_vs_leaks_frequency: Array<Age_Vs_Leaks_Frequency_Model>;
  /** fetch data from the table: "base.bulk_tipos" */
  base_bulk_tipos: Array<Base_Bulk_Tipos>;
  /** fetch aggregated fields from the table: "base.bulk_tipos" */
  base_bulk_tipos_aggregate: Base_Bulk_Tipos_Aggregate;
  /** fetch data from the table: "base.bulk_tipos" using primary key columns */
  base_bulk_tipos_by_pk?: Maybe<Base_Bulk_Tipos>;
  /** fetch data from the table in a streaming manner: "base.bulk_tipos" */
  base_bulk_tipos_stream: Array<Base_Bulk_Tipos>;
  /** fetch data from the table: "base.centros" */
  base_centros: Array<Base_Centros>;
  /** fetch aggregated fields from the table: "base.centros" */
  base_centros_aggregate: Base_Centros_Aggregate;
  /** fetch data from the table: "base.centros" using primary key columns */
  base_centros_by_pk?: Maybe<Base_Centros>;
  /** fetch data from the table in a streaming manner: "base.centros" */
  base_centros_stream: Array<Base_Centros>;
  /** execute function "base.get_infraestruturas_tipos_active_childs" which returns "base.infraestruturas_tipos" */
  base_get_infraestruturas_tipos_active_childs: Array<Base_Infraestruturas_Tipos>;
  /** execute function "base.get_infraestruturas_tipos_active_childs" and query aggregates on result of table type "base.infraestruturas_tipos" */
  base_get_infraestruturas_tipos_active_childs_aggregate: Base_Infraestruturas_Tipos_Aggregate;
  /** fetch data from the table: "base.infraestruturas" */
  base_infraestruturas: Array<Base_Infraestruturas>;
  /** fetch aggregated fields from the table: "base.infraestruturas" */
  base_infraestruturas_aggregate: Base_Infraestruturas_Aggregate;
  /** fetch data from the table: "base.infraestruturas" using primary key columns */
  base_infraestruturas_by_pk?: Maybe<Base_Infraestruturas>;
  /** fetch data from the table: "base.infraestruturas_coordenadas" */
  base_infraestruturas_coordenadas: Array<Base_Infraestruturas_Coordenadas>;
  /** fetch aggregated fields from the table: "base.infraestruturas_coordenadas" */
  base_infraestruturas_coordenadas_aggregate: Base_Infraestruturas_Coordenadas_Aggregate;
  /** fetch data from the table: "base.infraestruturas_coordenadas" using primary key columns */
  base_infraestruturas_coordenadas_by_pk?: Maybe<Base_Infraestruturas_Coordenadas>;
  /** fetch data from the table in a streaming manner: "base.infraestruturas_coordenadas" */
  base_infraestruturas_coordenadas_stream: Array<Base_Infraestruturas_Coordenadas>;
  /** fetch data from the table: "base.infraestruturas_r_toponimias" */
  base_infraestruturas_r_toponimias: Array<Base_Infraestruturas_R_Toponimias>;
  /** fetch aggregated fields from the table: "base.infraestruturas_r_toponimias" */
  base_infraestruturas_r_toponimias_aggregate: Base_Infraestruturas_R_Toponimias_Aggregate;
  /** fetch data from the table: "base.infraestruturas_r_toponimias" using primary key columns */
  base_infraestruturas_r_toponimias_by_pk?: Maybe<Base_Infraestruturas_R_Toponimias>;
  /** fetch data from the table in a streaming manner: "base.infraestruturas_r_toponimias" */
  base_infraestruturas_r_toponimias_stream: Array<Base_Infraestruturas_R_Toponimias>;
  /** fetch data from the table in a streaming manner: "base.infraestruturas" */
  base_infraestruturas_stream: Array<Base_Infraestruturas>;
  /** fetch data from the table: "base.infraestruturas_tipos" */
  base_infraestruturas_tipos: Array<Base_Infraestruturas_Tipos>;
  /** fetch aggregated fields from the table: "base.infraestruturas_tipos" */
  base_infraestruturas_tipos_aggregate: Base_Infraestruturas_Tipos_Aggregate;
  /** fetch data from the table: "base.infraestruturas_tipos" using primary key columns */
  base_infraestruturas_tipos_by_pk?: Maybe<Base_Infraestruturas_Tipos>;
  /** fetch data from the table in a streaming manner: "base.infraestruturas_tipos" */
  base_infraestruturas_tipos_stream: Array<Base_Infraestruturas_Tipos>;
  /** fetch data from the table: "base.parametrizacoes" */
  base_parametrizacoes: Array<Base_Parametrizacoes>;
  /** fetch aggregated fields from the table: "base.parametrizacoes" */
  base_parametrizacoes_aggregate: Base_Parametrizacoes_Aggregate;
  /** fetch data from the table in a streaming manner: "base.parametrizacoes" */
  base_parametrizacoes_stream: Array<Base_Parametrizacoes>;
  /** fetch data from the table: "base.toponimias" */
  base_toponimias: Array<Base_Toponimias>;
  /** fetch aggregated fields from the table: "base.toponimias" */
  base_toponimias_aggregate: Base_Toponimias_Aggregate;
  /** fetch data from the table: "base.toponimias" using primary key columns */
  base_toponimias_by_pk?: Maybe<Base_Toponimias>;
  /** fetch data from the table: "base.toponimias_coordenadas" */
  base_toponimias_coordenadas: Array<Base_Toponimias_Coordenadas>;
  /** fetch aggregated fields from the table: "base.toponimias_coordenadas" */
  base_toponimias_coordenadas_aggregate: Base_Toponimias_Coordenadas_Aggregate;
  /** fetch data from the table: "base.toponimias_coordenadas" using primary key columns */
  base_toponimias_coordenadas_by_pk?: Maybe<Base_Toponimias_Coordenadas>;
  /** fetch data from the table in a streaming manner: "base.toponimias_coordenadas" */
  base_toponimias_coordenadas_stream: Array<Base_Toponimias_Coordenadas>;
  /** fetch data from the table in a streaming manner: "base.toponimias" */
  base_toponimias_stream: Array<Base_Toponimias>;
  /** fetch data from the table: "base.zmc" */
  base_zmc: Array<Base_Zmc>;
  /** fetch aggregated fields from the table: "base.zmc" */
  base_zmc_aggregate: Base_Zmc_Aggregate;
  /** fetch data from the table: "base.zmc" using primary key columns */
  base_zmc_by_pk?: Maybe<Base_Zmc>;
  /** fetch data from the table: "base.zmc_nos_tipo" */
  base_zmc_nos_tipo: Array<Base_Zmc_Nos_Tipo>;
  /** fetch aggregated fields from the table: "base.zmc_nos_tipo" */
  base_zmc_nos_tipo_aggregate: Base_Zmc_Nos_Tipo_Aggregate;
  /** fetch data from the table: "base.zmc_nos_tipo" using primary key columns */
  base_zmc_nos_tipo_by_pk?: Maybe<Base_Zmc_Nos_Tipo>;
  /** fetch data from the table in a streaming manner: "base.zmc_nos_tipo" */
  base_zmc_nos_tipo_stream: Array<Base_Zmc_Nos_Tipo>;
  /** fetch data from the table in a streaming manner: "base.zmc" */
  base_zmc_stream: Array<Base_Zmc>;
  /** fetch data from the table: "consultas.requisicoes" */
  consultas_requisicoes: Array<Consultas_Requisicoes>;
  /** fetch aggregated fields from the table: "consultas.requisicoes" */
  consultas_requisicoes_aggregate: Consultas_Requisicoes_Aggregate;
  /** fetch data from the table: "consultas.requisicoes" using primary key columns */
  consultas_requisicoes_by_pk?: Maybe<Consultas_Requisicoes>;
  /** fetch data from the table in a streaming manner: "consultas.requisicoes" */
  consultas_requisicoes_stream: Array<Consultas_Requisicoes>;
  failure_recurrence_rate: Array<Failure_Recurrence_Rate_Model>;
  infrastructure_totalizers_tree: Array<Infrastructures_Totalizers_Tree_Model>;
  infrastructure_variables_tree: Array<Infrastructures_Variables_Tree_Model>;
  /** fetch data from the table: "integracoes.ad_parametrizacao" */
  integracoes_ad_parametrizacao: Array<Integracoes_Ad_Parametrizacao>;
  /** fetch aggregated fields from the table: "integracoes.ad_parametrizacao" */
  integracoes_ad_parametrizacao_aggregate: Integracoes_Ad_Parametrizacao_Aggregate;
  /** fetch data from the table in a streaming manner: "integracoes.ad_parametrizacao" */
  integracoes_ad_parametrizacao_stream: Array<Integracoes_Ad_Parametrizacao>;
  /** fetch data from the table: "integracoes.ad_saml_parametrizacao" */
  integracoes_ad_saml_parametrizacao: Array<Integracoes_Ad_Saml_Parametrizacao>;
  /** fetch aggregated fields from the table: "integracoes.ad_saml_parametrizacao" */
  integracoes_ad_saml_parametrizacao_aggregate: Integracoes_Ad_Saml_Parametrizacao_Aggregate;
  /** fetch data from the table: "integracoes.ad_saml_parametrizacao" using primary key columns */
  integracoes_ad_saml_parametrizacao_by_pk?: Maybe<Integracoes_Ad_Saml_Parametrizacao>;
  /** fetch data from the table in a streaming manner: "integracoes.ad_saml_parametrizacao" */
  integracoes_ad_saml_parametrizacao_stream: Array<Integracoes_Ad_Saml_Parametrizacao>;
  /** fetch data from the table: "integracoes.sig_maps_ortos" */
  integracoes_sig_maps_ortos: Array<Integracoes_Sig_Maps_Ortos>;
  /** fetch aggregated fields from the table: "integracoes.sig_maps_ortos" */
  integracoes_sig_maps_ortos_aggregate: Integracoes_Sig_Maps_Ortos_Aggregate;
  /** fetch data from the table: "integracoes.sig_maps_ortos" using primary key columns */
  integracoes_sig_maps_ortos_by_pk?: Maybe<Integracoes_Sig_Maps_Ortos>;
  /** fetch data from the table in a streaming manner: "integracoes.sig_maps_ortos" */
  integracoes_sig_maps_ortos_stream: Array<Integracoes_Sig_Maps_Ortos>;
  /** fetch data from the table: "integracoes.sig_parametrizacao" */
  integracoes_sig_parametrizacao: Array<Integracoes_Sig_Parametrizacao>;
  /** fetch aggregated fields from the table: "integracoes.sig_parametrizacao" */
  integracoes_sig_parametrizacao_aggregate: Integracoes_Sig_Parametrizacao_Aggregate;
  /** fetch data from the table in a streaming manner: "integracoes.sig_parametrizacao" */
  integracoes_sig_parametrizacao_stream: Array<Integracoes_Sig_Parametrizacao>;
  /** fetch data from the table: "integracoes.sig_proxy" */
  integracoes_sig_proxy: Array<Integracoes_Sig_Proxy>;
  /** fetch aggregated fields from the table: "integracoes.sig_proxy" */
  integracoes_sig_proxy_aggregate: Integracoes_Sig_Proxy_Aggregate;
  /** fetch data from the table: "integracoes.sig_proxy" using primary key columns */
  integracoes_sig_proxy_by_pk?: Maybe<Integracoes_Sig_Proxy>;
  /** fetch data from the table in a streaming manner: "integracoes.sig_proxy" */
  integracoes_sig_proxy_stream: Array<Integracoes_Sig_Proxy>;
  /** fetch data from the table: "integracoes.sig_request_get_attributes" */
  integracoes_sig_request_get_attributes: Array<Integracoes_Sig_Request_Get_Attributes>;
  /** fetch aggregated fields from the table: "integracoes.sig_request_get_attributes" */
  integracoes_sig_request_get_attributes_aggregate: Integracoes_Sig_Request_Get_Attributes_Aggregate;
  /** fetch data from the table in a streaming manner: "integracoes.sig_request_get_attributes" */
  integracoes_sig_request_get_attributes_stream: Array<Integracoes_Sig_Request_Get_Attributes>;
  /** fetch data from the table: "integracoes.sig_request_get_capabilities" */
  integracoes_sig_request_get_capabilities: Array<Integracoes_Sig_Request_Get_Capabilities>;
  /** fetch aggregated fields from the table: "integracoes.sig_request_get_capabilities" */
  integracoes_sig_request_get_capabilities_aggregate: Integracoes_Sig_Request_Get_Capabilities_Aggregate;
  /** fetch data from the table in a streaming manner: "integracoes.sig_request_get_capabilities" */
  integracoes_sig_request_get_capabilities_stream: Array<Integracoes_Sig_Request_Get_Capabilities>;
  /** fetch data from the table: "integracoes.sig_request_get_features" */
  integracoes_sig_request_get_features: Array<Integracoes_Sig_Request_Get_Features>;
  /** fetch aggregated fields from the table: "integracoes.sig_request_get_features" */
  integracoes_sig_request_get_features_aggregate: Integracoes_Sig_Request_Get_Features_Aggregate;
  /** fetch data from the table in a streaming manner: "integracoes.sig_request_get_features" */
  integracoes_sig_request_get_features_stream: Array<Integracoes_Sig_Request_Get_Features>;
  /** fetch data from the table: "integracoes.sig_services" */
  integracoes_sig_services: Array<Integracoes_Sig_Services>;
  /** fetch aggregated fields from the table: "integracoes.sig_services" */
  integracoes_sig_services_aggregate: Integracoes_Sig_Services_Aggregate;
  /** fetch data from the table: "integracoes.sig_services" using primary key columns */
  integracoes_sig_services_by_pk?: Maybe<Integracoes_Sig_Services>;
  /** fetch data from the table in a streaming manner: "integracoes.sig_services" */
  integracoes_sig_services_stream: Array<Integracoes_Sig_Services>;
  leak_recurrence_vs_rehabilitation: Array<Leak_Recurrence_Vs_Rehabilitation_Model>;
  leaks_per_distance: Array<Leaks_Per_Distance_Model>;
  /** fetch data from the table: "mensagens.anexos" */
  mensagens_anexos: Array<Mensagens_Anexos>;
  /** fetch aggregated fields from the table: "mensagens.anexos" */
  mensagens_anexos_aggregate: Mensagens_Anexos_Aggregate;
  /** fetch data from the table: "mensagens.anexos" using primary key columns */
  mensagens_anexos_by_pk?: Maybe<Mensagens_Anexos>;
  /** fetch data from the table in a streaming manner: "mensagens.anexos" */
  mensagens_anexos_stream: Array<Mensagens_Anexos>;
  /** fetch data from the table: "mensagens.mensagens" */
  mensagens_mensagens: Array<Mensagens_Mensagens>;
  /** fetch aggregated fields from the table: "mensagens.mensagens" */
  mensagens_mensagens_aggregate: Mensagens_Mensagens_Aggregate;
  /** fetch data from the table: "mensagens.mensagens" using primary key columns */
  mensagens_mensagens_by_pk?: Maybe<Mensagens_Mensagens>;
  /** fetch data from the table in a streaming manner: "mensagens.mensagens" */
  mensagens_mensagens_stream: Array<Mensagens_Mensagens>;
  /** fetch data from the table: "mensagens.post" */
  mensagens_post: Array<Mensagens_Post>;
  /** fetch aggregated fields from the table: "mensagens.post" */
  mensagens_post_aggregate: Mensagens_Post_Aggregate;
  /** fetch data from the table: "mensagens.post" using primary key columns */
  mensagens_post_by_pk?: Maybe<Mensagens_Post>;
  /** fetch data from the table in a streaming manner: "mensagens.post" */
  mensagens_post_stream: Array<Mensagens_Post>;
  /** fetch data from the table: "mobile.coordenadas" */
  mobile_coordenadas: Array<Mobile_Coordenadas>;
  /** fetch aggregated fields from the table: "mobile.coordenadas" */
  mobile_coordenadas_aggregate: Mobile_Coordenadas_Aggregate;
  /** fetch data from the table: "mobile.coordenadas" using primary key columns */
  mobile_coordenadas_by_pk?: Maybe<Mobile_Coordenadas>;
  /** fetch data from the table in a streaming manner: "mobile.coordenadas" */
  mobile_coordenadas_stream: Array<Mobile_Coordenadas>;
  /** fetch data from the table: "navia.cores" */
  navia_cores: Array<Navia_Cores>;
  /** fetch aggregated fields from the table: "navia.cores" */
  navia_cores_aggregate: Navia_Cores_Aggregate;
  /** fetch data from the table: "navia.cores" using primary key columns */
  navia_cores_by_pk?: Maybe<Navia_Cores>;
  /** fetch data from the table in a streaming manner: "navia.cores" */
  navia_cores_stream: Array<Navia_Cores>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  navia_dashboards_diagnostico_roturas_infraestruturas_variaveis: Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_aggregate: Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" using primary key columns */
  navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.diagnostico_roturas_infraestruturas_variaveis" */
  navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_stream: Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  navia_dashboards_diagnostico_roturas_mapa_niveis: Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  navia_dashboards_diagnostico_roturas_mapa_niveis_aggregate: Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_mapa_niveis" using primary key columns */
  navia_dashboards_diagnostico_roturas_mapa_niveis_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.diagnostico_roturas_mapa_niveis" */
  navia_dashboards_diagnostico_roturas_mapa_niveis_stream: Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_sintomas" */
  navia_dashboards_diagnostico_roturas_sintomas: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_sintomas" */
  navia_dashboards_diagnostico_roturas_sintomas_aggregate: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_sintomas" using primary key columns */
  navia_dashboards_diagnostico_roturas_sintomas_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.diagnostico_roturas_sintomas" */
  navia_dashboards_diagnostico_roturas_sintomas_stream: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  navia_dashboards_diagnostico_roturas_sintomas_tipos: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  navia_dashboards_diagnostico_roturas_sintomas_tipos_aggregate: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_sintomas_tipos" using primary key columns */
  navia_dashboards_diagnostico_roturas_sintomas_tipos_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.diagnostico_roturas_sintomas_tipos" */
  navia_dashboards_diagnostico_roturas_sintomas_tipos_stream: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_aggregate: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" using primary key columns */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura" */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_stream: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura>;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc>;
  /** fetch aggregated fields from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_aggregate: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Aggregate;
  /** fetch data from the table: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" using primary key columns */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_by_pk?: Maybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.diagnostico_roturas_tipos_infraestrutura_zmc" */
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_stream: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc>;
  /** fetch data from the table: "navia_dashboards.infraestruturas_totalizadores" */
  navia_dashboards_infraestruturas_totalizadores: Array<Navia_Dashboards_Infraestruturas_Totalizadores>;
  /** fetch aggregated fields from the table: "navia_dashboards.infraestruturas_totalizadores" */
  navia_dashboards_infraestruturas_totalizadores_aggregate: Navia_Dashboards_Infraestruturas_Totalizadores_Aggregate;
  /** fetch data from the table in a streaming manner: "navia_dashboards.infraestruturas_totalizadores" */
  navia_dashboards_infraestruturas_totalizadores_stream: Array<Navia_Dashboards_Infraestruturas_Totalizadores>;
  /** fetch data from the table: "navia_dashboards.infraestruturas_variaveis" */
  navia_dashboards_infraestruturas_variaveis: Array<Navia_Dashboards_Infraestruturas_Variaveis>;
  /** fetch aggregated fields from the table: "navia_dashboards.infraestruturas_variaveis" */
  navia_dashboards_infraestruturas_variaveis_aggregate: Navia_Dashboards_Infraestruturas_Variaveis_Aggregate;
  /** fetch data from the table in a streaming manner: "navia_dashboards.infraestruturas_variaveis" */
  navia_dashboards_infraestruturas_variaveis_stream: Array<Navia_Dashboards_Infraestruturas_Variaveis>;
  /** fetch data from the table: "navia_dashboards.menu" */
  navia_dashboards_menu: Array<Navia_Dashboards_Menu>;
  /** fetch aggregated fields from the table: "navia_dashboards.menu" */
  navia_dashboards_menu_aggregate: Navia_Dashboards_Menu_Aggregate;
  /** fetch data from the table: "navia_dashboards.menu" using primary key columns */
  navia_dashboards_menu_by_pk?: Maybe<Navia_Dashboards_Menu>;
  /** fetch data from the table: "navia_dashboards.menu_r_transacoes" */
  navia_dashboards_menu_r_transacoes: Array<Navia_Dashboards_Menu_R_Transacoes>;
  /** fetch aggregated fields from the table: "navia_dashboards.menu_r_transacoes" */
  navia_dashboards_menu_r_transacoes_aggregate: Navia_Dashboards_Menu_R_Transacoes_Aggregate;
  /** fetch data from the table: "navia_dashboards.menu_r_transacoes" using primary key columns */
  navia_dashboards_menu_r_transacoes_by_pk?: Maybe<Navia_Dashboards_Menu_R_Transacoes>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.menu_r_transacoes" */
  navia_dashboards_menu_r_transacoes_stream: Array<Navia_Dashboards_Menu_R_Transacoes>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.menu" */
  navia_dashboards_menu_stream: Array<Navia_Dashboards_Menu>;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens" */
  navia_dashboards_modo_tv_tokens: Array<Navia_Dashboards_Modo_Tv_Tokens>;
  /** fetch aggregated fields from the table: "navia_dashboards.modo_tv_tokens" */
  navia_dashboards_modo_tv_tokens_aggregate: Navia_Dashboards_Modo_Tv_Tokens_Aggregate;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens" using primary key columns */
  navia_dashboards_modo_tv_tokens_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens>;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  navia_dashboards_modo_tv_tokens_revogacao_manual: Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual>;
  /** fetch aggregated fields from the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  navia_dashboards_modo_tv_tokens_revogacao_manual_aggregate: Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Aggregate;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens_revogacao_manual" using primary key columns */
  navia_dashboards_modo_tv_tokens_revogacao_manual_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.modo_tv_tokens_revogacao_manual" */
  navia_dashboards_modo_tv_tokens_revogacao_manual_stream: Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.modo_tv_tokens" */
  navia_dashboards_modo_tv_tokens_stream: Array<Navia_Dashboards_Modo_Tv_Tokens>;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens_validados" */
  navia_dashboards_modo_tv_tokens_validados: Array<Navia_Dashboards_Modo_Tv_Tokens_Validados>;
  /** fetch aggregated fields from the table: "navia_dashboards.modo_tv_tokens_validados" */
  navia_dashboards_modo_tv_tokens_validados_aggregate: Navia_Dashboards_Modo_Tv_Tokens_Validados_Aggregate;
  /** fetch data from the table: "navia_dashboards.modo_tv_tokens_validados" using primary key columns */
  navia_dashboards_modo_tv_tokens_validados_by_pk?: Maybe<Navia_Dashboards_Modo_Tv_Tokens_Validados>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.modo_tv_tokens_validados" */
  navia_dashboards_modo_tv_tokens_validados_stream: Array<Navia_Dashboards_Modo_Tv_Tokens_Validados>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_causas" */
  navia_dashboards_monitorizacao_roturas_causas: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_causas" */
  navia_dashboards_monitorizacao_roturas_causas_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Causas_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_causas" using primary key columns */
  navia_dashboards_monitorizacao_roturas_causas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  navia_dashboards_monitorizacao_roturas_causas_r_causas: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  navia_dashboards_monitorizacao_roturas_causas_r_causas_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_causas_r_causas" using primary key columns */
  navia_dashboards_monitorizacao_roturas_causas_r_causas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.monitorizacao_roturas_causas_r_causas" */
  navia_dashboards_monitorizacao_roturas_causas_r_causas_stream: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.monitorizacao_roturas_causas" */
  navia_dashboards_monitorizacao_roturas_causas_stream: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_indicadores" */
  navia_dashboards_monitorizacao_roturas_indicadores: Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_indicadores" */
  navia_dashboards_monitorizacao_roturas_indicadores_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_indicadores" using primary key columns */
  navia_dashboards_monitorizacao_roturas_indicadores_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.monitorizacao_roturas_indicadores" */
  navia_dashboards_monitorizacao_roturas_indicadores_stream: Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_sintomas" */
  navia_dashboards_monitorizacao_roturas_sintomas: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_sintomas" */
  navia_dashboards_monitorizacao_roturas_sintomas_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_sintomas" using primary key columns */
  navia_dashboards_monitorizacao_roturas_sintomas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" using primary key columns */
  navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.monitorizacao_roturas_sintomas_r_sintomas" */
  navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_stream: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.monitorizacao_roturas_sintomas" */
  navia_dashboards_monitorizacao_roturas_sintomas_stream: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas>;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_variaveis" */
  navia_dashboards_monitorizacao_roturas_variaveis: Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis>;
  /** fetch aggregated fields from the table: "navia_dashboards.monitorizacao_roturas_variaveis" */
  navia_dashboards_monitorizacao_roturas_variaveis_aggregate: Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Aggregate;
  /** fetch data from the table: "navia_dashboards.monitorizacao_roturas_variaveis" using primary key columns */
  navia_dashboards_monitorizacao_roturas_variaveis_by_pk?: Maybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.monitorizacao_roturas_variaveis" */
  navia_dashboards_monitorizacao_roturas_variaveis_stream: Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis>;
  /** fetch data from the table: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  navia_dashboards_performance_infraestrutura_parametrizacao: Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao>;
  /** fetch aggregated fields from the table: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  navia_dashboards_performance_infraestrutura_parametrizacao_aggregate: Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Aggregate;
  /** fetch data from the table: "navia_dashboards.performance_infraestrutura_parametrizacao" using primary key columns */
  navia_dashboards_performance_infraestrutura_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.performance_infraestrutura_parametrizacao" */
  navia_dashboards_performance_infraestrutura_parametrizacao_stream: Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao>;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao>;
  /** fetch aggregated fields from the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_aggregate: Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Aggregate;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" using primary key columns */
  navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.pesquisa_ativa_fugas_indicadores_parametrizacao" */
  navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_stream: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao>;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa>;
  /** fetch aggregated fields from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_aggregate: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Aggregate;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" using primary key columns */
  navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.pesquisa_ativa_fugas_mapa_modelos_tarefa" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_stream: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa>;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas>;
  /** fetch aggregated fields from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_aggregate: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Aggregate;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" using primary key columns */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas>;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores>;
  /** fetch aggregated fields from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_aggregate: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Aggregate;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" using primary key columns */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_stream: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.pesquisa_ativa_fugas_mapa_sintomas" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_stream: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas>;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura>;
  /** fetch aggregated fields from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_aggregate: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Aggregate;
  /** fetch data from the table: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" using primary key columns */
  navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_by_pk?: Maybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.pesquisa_ativa_fugas_mapa_tipo_infraestrutura" */
  navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_stream: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura>;
  /** fetch data from the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  navia_dashboards_requisicoes_indicadores_parametrizacao: Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao>;
  /** fetch aggregated fields from the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  navia_dashboards_requisicoes_indicadores_parametrizacao_aggregate: Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Aggregate;
  /** fetch data from the table: "navia_dashboards.requisicoes_indicadores_parametrizacao" using primary key columns */
  navia_dashboards_requisicoes_indicadores_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.requisicoes_indicadores_parametrizacao" */
  navia_dashboards_requisicoes_indicadores_parametrizacao_stream: Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao>;
  /** fetch data from the table: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  navia_dashboards_requisicoes_mapa_parametrizacao: Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao>;
  /** fetch aggregated fields from the table: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  navia_dashboards_requisicoes_mapa_parametrizacao_aggregate: Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Aggregate;
  /** fetch data from the table: "navia_dashboards.requisicoes_mapa_parametrizacao" using primary key columns */
  navia_dashboards_requisicoes_mapa_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.requisicoes_mapa_parametrizacao" */
  navia_dashboards_requisicoes_mapa_parametrizacao_stream: Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao>;
  /** fetch data from the table: "navia_dashboards.visao_360_parametrizacao" */
  navia_dashboards_visao_360_parametrizacao: Array<Navia_Dashboards_Visao_360_Parametrizacao>;
  /** fetch aggregated fields from the table: "navia_dashboards.visao_360_parametrizacao" */
  navia_dashboards_visao_360_parametrizacao_aggregate: Navia_Dashboards_Visao_360_Parametrizacao_Aggregate;
  /** fetch data from the table: "navia_dashboards.visao_360_parametrizacao" using primary key columns */
  navia_dashboards_visao_360_parametrizacao_by_pk?: Maybe<Navia_Dashboards_Visao_360_Parametrizacao>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.visao_360_parametrizacao" */
  navia_dashboards_visao_360_parametrizacao_stream: Array<Navia_Dashboards_Visao_360_Parametrizacao>;
  /** fetch data from the table: "navia_dashboards.visao_360_selectores" */
  navia_dashboards_visao_360_selectores: Array<Navia_Dashboards_Visao_360_Selectores>;
  /** fetch aggregated fields from the table: "navia_dashboards.visao_360_selectores" */
  navia_dashboards_visao_360_selectores_aggregate: Navia_Dashboards_Visao_360_Selectores_Aggregate;
  /** fetch data from the table: "navia_dashboards.visao_360_selectores" using primary key columns */
  navia_dashboards_visao_360_selectores_by_pk?: Maybe<Navia_Dashboards_Visao_360_Selectores>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.visao_360_selectores" */
  navia_dashboards_visao_360_selectores_stream: Array<Navia_Dashboards_Visao_360_Selectores>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_caudais" */
  navia_dashboards_volumes_diarios_caudais: Array<Navia_Dashboards_Volumes_Diarios_Caudais>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_caudais" */
  navia_dashboards_volumes_diarios_caudais_aggregate: Navia_Dashboards_Volumes_Diarios_Caudais_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_caudais" using primary key columns */
  navia_dashboards_volumes_diarios_caudais_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Caudais>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.volumes_diarios_caudais" */
  navia_dashboards_volumes_diarios_caudais_stream: Array<Navia_Dashboards_Volumes_Diarios_Caudais>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_dados" */
  navia_dashboards_volumes_diarios_dados: Array<Navia_Dashboards_Volumes_Diarios_Dados>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_dados" */
  navia_dashboards_volumes_diarios_dados_aggregate: Navia_Dashboards_Volumes_Diarios_Dados_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_dados" using primary key columns */
  navia_dashboards_volumes_diarios_dados_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Dados>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.volumes_diarios_dados" */
  navia_dashboards_volumes_diarios_dados_stream: Array<Navia_Dashboards_Volumes_Diarios_Dados>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios: Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_aggregate: Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" using primary key columns */
  navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.volumes_diarios_equipas_virtuais_r_municipios" */
  navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_stream: Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_leituras" */
  navia_dashboards_volumes_diarios_leituras: Array<Navia_Dashboards_Volumes_Diarios_Leituras>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_leituras" */
  navia_dashboards_volumes_diarios_leituras_aggregate: Navia_Dashboards_Volumes_Diarios_Leituras_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_leituras" using primary key columns */
  navia_dashboards_volumes_diarios_leituras_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Leituras>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.volumes_diarios_leituras" */
  navia_dashboards_volumes_diarios_leituras_stream: Array<Navia_Dashboards_Volumes_Diarios_Leituras>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_locais" */
  navia_dashboards_volumes_diarios_locais: Array<Navia_Dashboards_Volumes_Diarios_Locais>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_locais" */
  navia_dashboards_volumes_diarios_locais_aggregate: Navia_Dashboards_Volumes_Diarios_Locais_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_locais" using primary key columns */
  navia_dashboards_volumes_diarios_locais_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Locais>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.volumes_diarios_locais" */
  navia_dashboards_volumes_diarios_locais_stream: Array<Navia_Dashboards_Volumes_Diarios_Locais>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_municipios" */
  navia_dashboards_volumes_diarios_municipios: Array<Navia_Dashboards_Volumes_Diarios_Municipios>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_municipios" */
  navia_dashboards_volumes_diarios_municipios_aggregate: Navia_Dashboards_Volumes_Diarios_Municipios_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_municipios" using primary key columns */
  navia_dashboards_volumes_diarios_municipios_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Municipios>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.volumes_diarios_municipios" */
  navia_dashboards_volumes_diarios_municipios_stream: Array<Navia_Dashboards_Volumes_Diarios_Municipios>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_registos" */
  navia_dashboards_volumes_diarios_registos: Array<Navia_Dashboards_Volumes_Diarios_Registos>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_registos" */
  navia_dashboards_volumes_diarios_registos_aggregate: Navia_Dashboards_Volumes_Diarios_Registos_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_registos" using primary key columns */
  navia_dashboards_volumes_diarios_registos_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Registos>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.volumes_diarios_registos" */
  navia_dashboards_volumes_diarios_registos_stream: Array<Navia_Dashboards_Volumes_Diarios_Registos>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  navia_dashboards_volumes_diarios_totalizador_leituras: Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  navia_dashboards_volumes_diarios_totalizador_leituras_aggregate: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_totalizador_leituras" using primary key columns */
  navia_dashboards_volumes_diarios_totalizador_leituras_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.volumes_diarios_totalizador_leituras" */
  navia_dashboards_volumes_diarios_totalizador_leituras_stream: Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras>;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_totalizadores" */
  navia_dashboards_volumes_diarios_totalizadores: Array<Navia_Dashboards_Volumes_Diarios_Totalizadores>;
  /** fetch aggregated fields from the table: "navia_dashboards.volumes_diarios_totalizadores" */
  navia_dashboards_volumes_diarios_totalizadores_aggregate: Navia_Dashboards_Volumes_Diarios_Totalizadores_Aggregate;
  /** fetch data from the table: "navia_dashboards.volumes_diarios_totalizadores" using primary key columns */
  navia_dashboards_volumes_diarios_totalizadores_by_pk?: Maybe<Navia_Dashboards_Volumes_Diarios_Totalizadores>;
  /** fetch data from the table in a streaming manner: "navia_dashboards.volumes_diarios_totalizadores" */
  navia_dashboards_volumes_diarios_totalizadores_stream: Array<Navia_Dashboards_Volumes_Diarios_Totalizadores>;
  /** fetch data from the table: "navia.integracoes" */
  navia_integracoes: Array<Navia_Integracoes>;
  /** fetch aggregated fields from the table: "navia.integracoes" */
  navia_integracoes_aggregate: Navia_Integracoes_Aggregate;
  /** fetch data from the table: "navia.integracoes" using primary key columns */
  navia_integracoes_by_pk?: Maybe<Navia_Integracoes>;
  /** fetch data from the table in a streaming manner: "navia.integracoes" */
  navia_integracoes_stream: Array<Navia_Integracoes>;
  /** fetch data from the table: "navia.log" */
  navia_log: Array<Navia_Log>;
  /** fetch aggregated fields from the table: "navia.log" */
  navia_log_aggregate: Navia_Log_Aggregate;
  /** fetch data from the table: "navia.log" using primary key columns */
  navia_log_by_pk?: Maybe<Navia_Log>;
  /** fetch data from the table in a streaming manner: "navia.log" */
  navia_log_stream: Array<Navia_Log>;
  network_integrity: Array<Network_Integrity_Model>;
  /** fetch data from the table: "notificacoes.itens" */
  notificacoes_itens: Array<Notificacoes_Itens>;
  /** fetch aggregated fields from the table: "notificacoes.itens" */
  notificacoes_itens_aggregate: Notificacoes_Itens_Aggregate;
  /** fetch data from the table: "notificacoes.itens" using primary key columns */
  notificacoes_itens_by_pk?: Maybe<Notificacoes_Itens>;
  /** fetch data from the table in a streaming manner: "notificacoes.itens" */
  notificacoes_itens_stream: Array<Notificacoes_Itens>;
  /** fetch data from the table: "notificacoes.notificacoes" */
  notificacoes_notificacoes: Array<Notificacoes_Notificacoes>;
  /** fetch aggregated fields from the table: "notificacoes.notificacoes" */
  notificacoes_notificacoes_aggregate: Notificacoes_Notificacoes_Aggregate;
  /** fetch data from the table: "notificacoes.notificacoes" using primary key columns */
  notificacoes_notificacoes_by_pk?: Maybe<Notificacoes_Notificacoes>;
  /** fetch data from the table: "notificacoes.notificacoes_r_utilizadores" */
  notificacoes_notificacoes_r_utilizadores: Array<Notificacoes_Notificacoes_R_Utilizadores>;
  /** fetch aggregated fields from the table: "notificacoes.notificacoes_r_utilizadores" */
  notificacoes_notificacoes_r_utilizadores_aggregate: Notificacoes_Notificacoes_R_Utilizadores_Aggregate;
  /** fetch data from the table: "notificacoes.notificacoes_r_utilizadores" using primary key columns */
  notificacoes_notificacoes_r_utilizadores_by_pk?: Maybe<Notificacoes_Notificacoes_R_Utilizadores>;
  /** fetch data from the table in a streaming manner: "notificacoes.notificacoes_r_utilizadores" */
  notificacoes_notificacoes_r_utilizadores_stream: Array<Notificacoes_Notificacoes_R_Utilizadores>;
  /** fetch data from the table in a streaming manner: "notificacoes.notificacoes" */
  notificacoes_notificacoes_stream: Array<Notificacoes_Notificacoes>;
  /** fetch data from the table: "notificacoes.tipos" */
  notificacoes_tipos: Array<Notificacoes_Tipos>;
  /** fetch aggregated fields from the table: "notificacoes.tipos" */
  notificacoes_tipos_aggregate: Notificacoes_Tipos_Aggregate;
  /** fetch data from the table: "notificacoes.tipos" using primary key columns */
  notificacoes_tipos_by_pk?: Maybe<Notificacoes_Tipos>;
  /** fetch data from the table in a streaming manner: "notificacoes.tipos" */
  notificacoes_tipos_stream: Array<Notificacoes_Tipos>;
  /** fetch data from the table: "permissoes.transacoes" */
  permissoes_transacoes: Array<Permissoes_Transacoes>;
  /** fetch aggregated fields from the table: "permissoes.transacoes" */
  permissoes_transacoes_aggregate: Permissoes_Transacoes_Aggregate;
  /** fetch data from the table: "permissoes.transacoes" using primary key columns */
  permissoes_transacoes_by_pk?: Maybe<Permissoes_Transacoes>;
  /** fetch data from the table: "permissoes.transacoes_r_menus" */
  permissoes_transacoes_r_menus: Array<Permissoes_Transacoes_R_Menus>;
  /** fetch aggregated fields from the table: "permissoes.transacoes_r_menus" */
  permissoes_transacoes_r_menus_aggregate: Permissoes_Transacoes_R_Menus_Aggregate;
  /** fetch data from the table: "permissoes.transacoes_r_menus" using primary key columns */
  permissoes_transacoes_r_menus_by_pk?: Maybe<Permissoes_Transacoes_R_Menus>;
  /** fetch data from the table in a streaming manner: "permissoes.transacoes_r_menus" */
  permissoes_transacoes_r_menus_stream: Array<Permissoes_Transacoes_R_Menus>;
  /** fetch data from the table in a streaming manner: "permissoes.transacoes" */
  permissoes_transacoes_stream: Array<Permissoes_Transacoes>;
  pipe_readings_by_material: Array<Pipe_Readings_By_Material_Model>;
  pipe_rehabilitation_rate: Array<Pipe_Rehabilitation_Rate_Model>;
  requests_act_list: Array<Requests_Act_And_Danger_List_Return>;
  requests_act_list_without_login: Array<Requests_Act_And_Danger_List_Return>;
  requests_danger_list: Array<Requests_Act_And_Danger_List_Return>;
  requests_danger_list_without_login: Array<Requests_Act_And_Danger_List_Return>;
  /** fetch data from the table: "rqs.parametrizacao" */
  rqs_parametrizacao: Array<Rqs_Parametrizacao>;
  /** fetch aggregated fields from the table: "rqs.parametrizacao" */
  rqs_parametrizacao_aggregate: Rqs_Parametrizacao_Aggregate;
  /** fetch data from the table in a streaming manner: "rqs.parametrizacao" */
  rqs_parametrizacao_stream: Array<Rqs_Parametrizacao>;
  /** fetch data from the table: "rqs.requisicoes_periodos" */
  rqs_requisicoes_periodos: Array<Rqs_Requisicoes_Periodos>;
  /** fetch aggregated fields from the table: "rqs.requisicoes_periodos" */
  rqs_requisicoes_periodos_aggregate: Rqs_Requisicoes_Periodos_Aggregate;
  /** fetch data from the table: "rqs.requisicoes_periodos" using primary key columns */
  rqs_requisicoes_periodos_by_pk?: Maybe<Rqs_Requisicoes_Periodos>;
  /** fetch data from the table in a streaming manner: "rqs.requisicoes_periodos" */
  rqs_requisicoes_periodos_stream: Array<Rqs_Requisicoes_Periodos>;
  /** fetch data from the table: "rqs.requisicoes_tempos_wrap" */
  rqs_requisicoes_tempos_wrap: Array<Rqs_Requisicoes_Tempos_Wrap>;
  /** fetch aggregated fields from the table: "rqs.requisicoes_tempos_wrap" */
  rqs_requisicoes_tempos_wrap_aggregate: Rqs_Requisicoes_Tempos_Wrap_Aggregate;
  /** fetch data from the table: "rqs.requisicoes_tempos_wrap" using primary key columns */
  rqs_requisicoes_tempos_wrap_by_pk?: Maybe<Rqs_Requisicoes_Tempos_Wrap>;
  /** fetch data from the table in a streaming manner: "rqs.requisicoes_tempos_wrap" */
  rqs_requisicoes_tempos_wrap_stream: Array<Rqs_Requisicoes_Tempos_Wrap>;
  /** fetch data from the table: "rqs.sintomas" */
  rqs_sintomas: Array<Rqs_Sintomas>;
  /** fetch aggregated fields from the table: "rqs.sintomas" */
  rqs_sintomas_aggregate: Rqs_Sintomas_Aggregate;
  /** fetch data from the table: "rqs.sintomas" using primary key columns */
  rqs_sintomas_by_pk?: Maybe<Rqs_Sintomas>;
  /** fetch data from the table: "rqs.sintomas_parametrizacao_tempos" */
  rqs_sintomas_parametrizacao_tempos: Array<Rqs_Sintomas_Parametrizacao_Tempos>;
  /** fetch aggregated fields from the table: "rqs.sintomas_parametrizacao_tempos" */
  rqs_sintomas_parametrizacao_tempos_aggregate: Rqs_Sintomas_Parametrizacao_Tempos_Aggregate;
  /** fetch data from the table: "rqs.sintomas_parametrizacao_tempos" using primary key columns */
  rqs_sintomas_parametrizacao_tempos_by_pk?: Maybe<Rqs_Sintomas_Parametrizacao_Tempos>;
  /** fetch data from the table in a streaming manner: "rqs.sintomas_parametrizacao_tempos" */
  rqs_sintomas_parametrizacao_tempos_stream: Array<Rqs_Sintomas_Parametrizacao_Tempos>;
  /** fetch data from the table in a streaming manner: "rqs.sintomas" */
  rqs_sintomas_stream: Array<Rqs_Sintomas>;
  /** fetch data from the table: "servicos.fases" */
  servicos_fases: Array<Servicos_Fases>;
  /** fetch aggregated fields from the table: "servicos.fases" */
  servicos_fases_aggregate: Servicos_Fases_Aggregate;
  /** fetch data from the table: "servicos.fases" using primary key columns */
  servicos_fases_by_pk?: Maybe<Servicos_Fases>;
  /** fetch data from the table in a streaming manner: "servicos.fases" */
  servicos_fases_stream: Array<Servicos_Fases>;
  /** fetch data from the table: "servicos.intervencoes" */
  servicos_intervencoes: Array<Servicos_Intervencoes>;
  /** fetch aggregated fields from the table: "servicos.intervencoes" */
  servicos_intervencoes_aggregate: Servicos_Intervencoes_Aggregate;
  /** fetch data from the table: "servicos.intervencoes_atribuicao_utilizadores" */
  servicos_intervencoes_atribuicao_utilizadores: Array<Servicos_Intervencoes_Atribuicao_Utilizadores>;
  /** fetch aggregated fields from the table: "servicos.intervencoes_atribuicao_utilizadores" */
  servicos_intervencoes_atribuicao_utilizadores_aggregate: Servicos_Intervencoes_Atribuicao_Utilizadores_Aggregate;
  /** fetch data from the table: "servicos.intervencoes_atribuicao_utilizadores" using primary key columns */
  servicos_intervencoes_atribuicao_utilizadores_by_pk?: Maybe<Servicos_Intervencoes_Atribuicao_Utilizadores>;
  /** fetch data from the table in a streaming manner: "servicos.intervencoes_atribuicao_utilizadores" */
  servicos_intervencoes_atribuicao_utilizadores_stream: Array<Servicos_Intervencoes_Atribuicao_Utilizadores>;
  /** fetch data from the table: "servicos.intervencoes" using primary key columns */
  servicos_intervencoes_by_pk?: Maybe<Servicos_Intervencoes>;
  /** fetch data from the table: "servicos.intervencoes_estados" */
  servicos_intervencoes_estados: Array<Servicos_Intervencoes_Estados>;
  /** fetch aggregated fields from the table: "servicos.intervencoes_estados" */
  servicos_intervencoes_estados_aggregate: Servicos_Intervencoes_Estados_Aggregate;
  /** fetch data from the table: "servicos.intervencoes_estados" using primary key columns */
  servicos_intervencoes_estados_by_pk?: Maybe<Servicos_Intervencoes_Estados>;
  /** fetch data from the table in a streaming manner: "servicos.intervencoes_estados" */
  servicos_intervencoes_estados_stream: Array<Servicos_Intervencoes_Estados>;
  /** fetch data from the table: "servicos.intervencoes_r_causas_trabalhos" */
  servicos_intervencoes_r_causas_trabalhos: Array<Servicos_Intervencoes_R_Causas_Trabalhos>;
  /** fetch aggregated fields from the table: "servicos.intervencoes_r_causas_trabalhos" */
  servicos_intervencoes_r_causas_trabalhos_aggregate: Servicos_Intervencoes_R_Causas_Trabalhos_Aggregate;
  /** fetch data from the table: "servicos.intervencoes_r_causas_trabalhos" using primary key columns */
  servicos_intervencoes_r_causas_trabalhos_by_pk?: Maybe<Servicos_Intervencoes_R_Causas_Trabalhos>;
  /** fetch data from the table in a streaming manner: "servicos.intervencoes_r_causas_trabalhos" */
  servicos_intervencoes_r_causas_trabalhos_stream: Array<Servicos_Intervencoes_R_Causas_Trabalhos>;
  /** fetch data from the table in a streaming manner: "servicos.intervencoes" */
  servicos_intervencoes_stream: Array<Servicos_Intervencoes>;
  /** fetch data from the table: "servicos.rastreabilidade" */
  servicos_rastreabilidade: Array<Servicos_Rastreabilidade>;
  /** fetch aggregated fields from the table: "servicos.rastreabilidade" */
  servicos_rastreabilidade_aggregate: Servicos_Rastreabilidade_Aggregate;
  /** fetch data from the table: "servicos.rastreabilidade" using primary key columns */
  servicos_rastreabilidade_by_pk?: Maybe<Servicos_Rastreabilidade>;
  /** fetch data from the table in a streaming manner: "servicos.rastreabilidade" */
  servicos_rastreabilidade_stream: Array<Servicos_Rastreabilidade>;
  /** fetch data from the table: "servicos.requisicoes" */
  servicos_requisicoes: Array<Servicos_Requisicoes>;
  /** fetch aggregated fields from the table: "servicos.requisicoes" */
  servicos_requisicoes_aggregate: Servicos_Requisicoes_Aggregate;
  /** fetch data from the table: "servicos.requisicoes" using primary key columns */
  servicos_requisicoes_by_pk?: Maybe<Servicos_Requisicoes>;
  /** fetch data from the table: "servicos.requisicoes_estados" */
  servicos_requisicoes_estados: Array<Servicos_Requisicoes_Estados>;
  /** fetch aggregated fields from the table: "servicos.requisicoes_estados" */
  servicos_requisicoes_estados_aggregate: Servicos_Requisicoes_Estados_Aggregate;
  /** fetch data from the table: "servicos.requisicoes_estados" using primary key columns */
  servicos_requisicoes_estados_by_pk?: Maybe<Servicos_Requisicoes_Estados>;
  /** fetch data from the table in a streaming manner: "servicos.requisicoes_estados" */
  servicos_requisicoes_estados_stream: Array<Servicos_Requisicoes_Estados>;
  /** fetch data from the table: "servicos.requisicoes_locais_infra_estruturas" */
  servicos_requisicoes_locais_infra_estruturas: Array<Servicos_Requisicoes_Locais_Infra_Estruturas>;
  /** fetch aggregated fields from the table: "servicos.requisicoes_locais_infra_estruturas" */
  servicos_requisicoes_locais_infra_estruturas_aggregate: Servicos_Requisicoes_Locais_Infra_Estruturas_Aggregate;
  /** fetch data from the table: "servicos.requisicoes_locais_infra_estruturas" using primary key columns */
  servicos_requisicoes_locais_infra_estruturas_by_pk?: Maybe<Servicos_Requisicoes_Locais_Infra_Estruturas>;
  /** fetch data from the table in a streaming manner: "servicos.requisicoes_locais_infra_estruturas" */
  servicos_requisicoes_locais_infra_estruturas_stream: Array<Servicos_Requisicoes_Locais_Infra_Estruturas>;
  /** fetch data from the table: "servicos.requisicoes_r_intervencoes" */
  servicos_requisicoes_r_intervencoes: Array<Servicos_Requisicoes_R_Intervencoes>;
  /** fetch aggregated fields from the table: "servicos.requisicoes_r_intervencoes" */
  servicos_requisicoes_r_intervencoes_aggregate: Servicos_Requisicoes_R_Intervencoes_Aggregate;
  /** fetch data from the table: "servicos.requisicoes_r_intervencoes" using primary key columns */
  servicos_requisicoes_r_intervencoes_by_pk?: Maybe<Servicos_Requisicoes_R_Intervencoes>;
  /** fetch data from the table in a streaming manner: "servicos.requisicoes_r_intervencoes" */
  servicos_requisicoes_r_intervencoes_stream: Array<Servicos_Requisicoes_R_Intervencoes>;
  /** fetch data from the table in a streaming manner: "servicos.requisicoes" */
  servicos_requisicoes_stream: Array<Servicos_Requisicoes>;
  /** fetch data from the table: "sintomas.arvore" */
  sintomas_arvore: Array<Sintomas_Arvore>;
  /** fetch aggregated fields from the table: "sintomas.arvore" */
  sintomas_arvore_aggregate: Sintomas_Arvore_Aggregate;
  /** fetch data from the table: "sintomas.arvore" using primary key columns */
  sintomas_arvore_by_pk?: Maybe<Sintomas_Arvore>;
  /** fetch data from the table in a streaming manner: "sintomas.arvore" */
  sintomas_arvore_stream: Array<Sintomas_Arvore>;
  /** fetch data from the table: "sintomas.causas_trabalhos" */
  sintomas_causas_trabalhos: Array<Sintomas_Causas_Trabalhos>;
  /** fetch aggregated fields from the table: "sintomas.causas_trabalhos" */
  sintomas_causas_trabalhos_aggregate: Sintomas_Causas_Trabalhos_Aggregate;
  /** fetch data from the table: "sintomas.causas_trabalhos" using primary key columns */
  sintomas_causas_trabalhos_by_pk?: Maybe<Sintomas_Causas_Trabalhos>;
  /** fetch data from the table in a streaming manner: "sintomas.causas_trabalhos" */
  sintomas_causas_trabalhos_stream: Array<Sintomas_Causas_Trabalhos>;
  /** fetch data from the table: "sintomas.sintomas_relacao" */
  sintomas_sintomas_relacao: Array<Sintomas_Sintomas_Relacao>;
  /** fetch aggregated fields from the table: "sintomas.sintomas_relacao" */
  sintomas_sintomas_relacao_aggregate: Sintomas_Sintomas_Relacao_Aggregate;
  /** fetch data from the table: "sintomas.sintomas_relacao" using primary key columns */
  sintomas_sintomas_relacao_by_pk?: Maybe<Sintomas_Sintomas_Relacao>;
  /** fetch data from the table: "sintomas.sintomas_relacao_ordem" */
  sintomas_sintomas_relacao_ordem: Array<Sintomas_Sintomas_Relacao_Ordem>;
  /** fetch aggregated fields from the table: "sintomas.sintomas_relacao_ordem" */
  sintomas_sintomas_relacao_ordem_aggregate: Sintomas_Sintomas_Relacao_Ordem_Aggregate;
  /** fetch data from the table: "sintomas.sintomas_relacao_ordem" using primary key columns */
  sintomas_sintomas_relacao_ordem_by_pk?: Maybe<Sintomas_Sintomas_Relacao_Ordem>;
  /** fetch data from the table in a streaming manner: "sintomas.sintomas_relacao_ordem" */
  sintomas_sintomas_relacao_ordem_stream: Array<Sintomas_Sintomas_Relacao_Ordem>;
  /** fetch data from the table in a streaming manner: "sintomas.sintomas_relacao" */
  sintomas_sintomas_relacao_stream: Array<Sintomas_Sintomas_Relacao>;
  /** fetch data from the table: "tarefas.estados" */
  tarefas_estados: Array<Tarefas_Estados>;
  /** fetch aggregated fields from the table: "tarefas.estados" */
  tarefas_estados_aggregate: Tarefas_Estados_Aggregate;
  /** fetch data from the table: "tarefas.estados" using primary key columns */
  tarefas_estados_by_pk?: Maybe<Tarefas_Estados>;
  /** fetch data from the table in a streaming manner: "tarefas.estados" */
  tarefas_estados_stream: Array<Tarefas_Estados>;
  /** fetch data from the table: "tarefas.intervalos" */
  tarefas_intervalos: Array<Tarefas_Intervalos>;
  /** fetch aggregated fields from the table: "tarefas.intervalos" */
  tarefas_intervalos_aggregate: Tarefas_Intervalos_Aggregate;
  /** fetch data from the table: "tarefas.intervalos" using primary key columns */
  tarefas_intervalos_by_pk?: Maybe<Tarefas_Intervalos>;
  /** fetch data from the table in a streaming manner: "tarefas.intervalos" */
  tarefas_intervalos_stream: Array<Tarefas_Intervalos>;
  /** fetch data from the table: "tarefas.planos_padrao" */
  tarefas_planos_padrao: Array<Tarefas_Planos_Padrao>;
  /** fetch aggregated fields from the table: "tarefas.planos_padrao" */
  tarefas_planos_padrao_aggregate: Tarefas_Planos_Padrao_Aggregate;
  /** fetch data from the table: "tarefas.planos_padrao" using primary key columns */
  tarefas_planos_padrao_by_pk?: Maybe<Tarefas_Planos_Padrao>;
  /** fetch data from the table in a streaming manner: "tarefas.planos_padrao" */
  tarefas_planos_padrao_stream: Array<Tarefas_Planos_Padrao>;
  /** fetch data from the table: "tarefas.tarefas" */
  tarefas_tarefas: Array<Tarefas_Tarefas>;
  /** fetch aggregated fields from the table: "tarefas.tarefas" */
  tarefas_tarefas_aggregate: Tarefas_Tarefas_Aggregate;
  /** fetch data from the table: "tarefas.tarefas" using primary key columns */
  tarefas_tarefas_by_pk?: Maybe<Tarefas_Tarefas>;
  /** fetch data from the table: "tarefas.tarefas_r_equipas_virtuais" */
  tarefas_tarefas_r_equipas_virtuais: Array<Tarefas_Tarefas_R_Equipas_Virtuais>;
  /** fetch aggregated fields from the table: "tarefas.tarefas_r_equipas_virtuais" */
  tarefas_tarefas_r_equipas_virtuais_aggregate: Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate;
  /** fetch data from the table: "tarefas.tarefas_r_equipas_virtuais" using primary key columns */
  tarefas_tarefas_r_equipas_virtuais_by_pk?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais>;
  /** fetch data from the table in a streaming manner: "tarefas.tarefas_r_equipas_virtuais" */
  tarefas_tarefas_r_equipas_virtuais_stream: Array<Tarefas_Tarefas_R_Equipas_Virtuais>;
  /** fetch data from the table: "tarefas.tarefas_r_infraestruturas" */
  tarefas_tarefas_r_infraestruturas: Array<Tarefas_Tarefas_R_Infraestruturas>;
  /** fetch aggregated fields from the table: "tarefas.tarefas_r_infraestruturas" */
  tarefas_tarefas_r_infraestruturas_aggregate: Tarefas_Tarefas_R_Infraestruturas_Aggregate;
  /** fetch data from the table: "tarefas.tarefas_r_infraestruturas" using primary key columns */
  tarefas_tarefas_r_infraestruturas_by_pk?: Maybe<Tarefas_Tarefas_R_Infraestruturas>;
  /** fetch data from the table in a streaming manner: "tarefas.tarefas_r_infraestruturas" */
  tarefas_tarefas_r_infraestruturas_stream: Array<Tarefas_Tarefas_R_Infraestruturas>;
  /** fetch data from the table in a streaming manner: "tarefas.tarefas" */
  tarefas_tarefas_stream: Array<Tarefas_Tarefas>;
  top_5_pipes_with_most_leaks: Array<Top_5_Pipes_With_Most_Leaks_Model>;
  top_five_average_duration_by_symptom: Array<Top_Five_Average_Duration_By_Symptom_Return>;
  top_five_average_duration_by_symptom_without_login: Array<Top_Five_Average_Duration_By_Symptom_Return>;
  user_agenda: Array<User_Agenda_Model>;
  /** fetch data from the table: "utilizadores.categorias" */
  utilizadores_categorias: Array<Utilizadores_Categorias>;
  /** fetch aggregated fields from the table: "utilizadores.categorias" */
  utilizadores_categorias_aggregate: Utilizadores_Categorias_Aggregate;
  /** fetch data from the table: "utilizadores.categorias" using primary key columns */
  utilizadores_categorias_by_pk?: Maybe<Utilizadores_Categorias>;
  /** fetch data from the table in a streaming manner: "utilizadores.categorias" */
  utilizadores_categorias_stream: Array<Utilizadores_Categorias>;
  /** fetch data from the table: "utilizadores.equipas_virtuais" */
  utilizadores_equipas_virtuais: Array<Utilizadores_Equipas_Virtuais>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais" */
  utilizadores_equipas_virtuais_aggregate: Utilizadores_Equipas_Virtuais_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais" using primary key columns */
  utilizadores_equipas_virtuais_by_pk?: Maybe<Utilizadores_Equipas_Virtuais>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_centros" */
  utilizadores_equipas_virtuais_r_centros: Array<Utilizadores_Equipas_Virtuais_R_Centros>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_centros" */
  utilizadores_equipas_virtuais_r_centros_aggregate: Utilizadores_Equipas_Virtuais_R_Centros_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_centros" using primary key columns */
  utilizadores_equipas_virtuais_r_centros_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros>;
  /** fetch data from the table in a streaming manner: "utilizadores.equipas_virtuais_r_centros" */
  utilizadores_equipas_virtuais_r_centros_stream: Array<Utilizadores_Equipas_Virtuais_R_Centros>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  utilizadores_equipas_virtuais_r_equipas_virtuais: Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  utilizadores_equipas_virtuais_r_equipas_virtuais_aggregate: Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_equipas_virtuais" using primary key columns */
  utilizadores_equipas_virtuais_r_equipas_virtuais_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais>;
  /** fetch data from the table in a streaming manner: "utilizadores.equipas_virtuais_r_equipas_virtuais" */
  utilizadores_equipas_virtuais_r_equipas_virtuais_stream: Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_infraestruturas" */
  utilizadores_equipas_virtuais_r_infraestruturas: Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_infraestruturas" */
  utilizadores_equipas_virtuais_r_infraestruturas_aggregate: Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_infraestruturas" using primary key columns */
  utilizadores_equipas_virtuais_r_infraestruturas_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas>;
  /** fetch data from the table in a streaming manner: "utilizadores.equipas_virtuais_r_infraestruturas" */
  utilizadores_equipas_virtuais_r_infraestruturas_stream: Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_sintoma" */
  utilizadores_equipas_virtuais_r_sintoma: Array<Utilizadores_Equipas_Virtuais_R_Sintoma>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_sintoma" */
  utilizadores_equipas_virtuais_r_sintoma_aggregate: Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_sintoma" using primary key columns */
  utilizadores_equipas_virtuais_r_sintoma_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma>;
  /** fetch data from the table in a streaming manner: "utilizadores.equipas_virtuais_r_sintoma" */
  utilizadores_equipas_virtuais_r_sintoma_stream: Array<Utilizadores_Equipas_Virtuais_R_Sintoma>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_toponimias" */
  utilizadores_equipas_virtuais_r_toponimias: Array<Utilizadores_Equipas_Virtuais_R_Toponimias>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_toponimias" */
  utilizadores_equipas_virtuais_r_toponimias_aggregate: Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_toponimias" using primary key columns */
  utilizadores_equipas_virtuais_r_toponimias_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias>;
  /** fetch data from the table in a streaming manner: "utilizadores.equipas_virtuais_r_toponimias" */
  utilizadores_equipas_virtuais_r_toponimias_stream: Array<Utilizadores_Equipas_Virtuais_R_Toponimias>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_transacoes" */
  utilizadores_equipas_virtuais_r_transacoes: Array<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_transacoes" */
  utilizadores_equipas_virtuais_r_transacoes_aggregate: Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_transacoes" using primary key columns */
  utilizadores_equipas_virtuais_r_transacoes_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** fetch data from the table in a streaming manner: "utilizadores.equipas_virtuais_r_transacoes" */
  utilizadores_equipas_virtuais_r_transacoes_stream: Array<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_utilizadores" */
  utilizadores_equipas_virtuais_r_utilizadores: Array<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  /** fetch aggregated fields from the table: "utilizadores.equipas_virtuais_r_utilizadores" */
  utilizadores_equipas_virtuais_r_utilizadores_aggregate: Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate;
  /** fetch data from the table: "utilizadores.equipas_virtuais_r_utilizadores" using primary key columns */
  utilizadores_equipas_virtuais_r_utilizadores_by_pk?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  /** fetch data from the table in a streaming manner: "utilizadores.equipas_virtuais_r_utilizadores" */
  utilizadores_equipas_virtuais_r_utilizadores_stream: Array<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  /** fetch data from the table in a streaming manner: "utilizadores.equipas_virtuais" */
  utilizadores_equipas_virtuais_stream: Array<Utilizadores_Equipas_Virtuais>;
  /** fetch data from the table: "utilizadores.exportacoes" */
  utilizadores_exportacoes: Array<Utilizadores_Exportacoes>;
  /** fetch aggregated fields from the table: "utilizadores.exportacoes" */
  utilizadores_exportacoes_aggregate: Utilizadores_Exportacoes_Aggregate;
  /** fetch data from the table: "utilizadores.exportacoes" using primary key columns */
  utilizadores_exportacoes_by_pk?: Maybe<Utilizadores_Exportacoes>;
  /** fetch data from the table in a streaming manner: "utilizadores.exportacoes" */
  utilizadores_exportacoes_stream: Array<Utilizadores_Exportacoes>;
  /** fetch data from the table: "utilizadores.mapa_posicao_cores" */
  utilizadores_mapa_posicao_cores: Array<Utilizadores_Mapa_Posicao_Cores>;
  /** fetch aggregated fields from the table: "utilizadores.mapa_posicao_cores" */
  utilizadores_mapa_posicao_cores_aggregate: Utilizadores_Mapa_Posicao_Cores_Aggregate;
  /** fetch data from the table: "utilizadores.mapa_posicao_cores" using primary key columns */
  utilizadores_mapa_posicao_cores_by_pk?: Maybe<Utilizadores_Mapa_Posicao_Cores>;
  /** fetch data from the table in a streaming manner: "utilizadores.mapa_posicao_cores" */
  utilizadores_mapa_posicao_cores_stream: Array<Utilizadores_Mapa_Posicao_Cores>;
  /** fetch data from the table: "utilizadores.menu" */
  utilizadores_menu: Array<Utilizadores_Menu>;
  /** fetch aggregated fields from the table: "utilizadores.menu" */
  utilizadores_menu_aggregate: Utilizadores_Menu_Aggregate;
  /** fetch data from the table: "utilizadores.menu" using primary key columns */
  utilizadores_menu_by_pk?: Maybe<Utilizadores_Menu>;
  /** fetch data from the table in a streaming manner: "utilizadores.menu" */
  utilizadores_menu_stream: Array<Utilizadores_Menu>;
  /** fetch data from the table: "utilizadores.temas" */
  utilizadores_temas: Array<Utilizadores_Temas>;
  /** fetch aggregated fields from the table: "utilizadores.temas" */
  utilizadores_temas_aggregate: Utilizadores_Temas_Aggregate;
  /** fetch data from the table: "utilizadores.temas" using primary key columns */
  utilizadores_temas_by_pk?: Maybe<Utilizadores_Temas>;
  /** fetch data from the table in a streaming manner: "utilizadores.temas" */
  utilizadores_temas_stream: Array<Utilizadores_Temas>;
  /** fetch data from the table: "utilizadores.utilizadores" */
  utilizadores_utilizadores: Array<Utilizadores_Utilizadores>;
  /** fetch aggregated fields from the table: "utilizadores.utilizadores" */
  utilizadores_utilizadores_aggregate: Utilizadores_Utilizadores_Aggregate;
  /** fetch data from the table: "utilizadores.utilizadores" using primary key columns */
  utilizadores_utilizadores_by_pk?: Maybe<Utilizadores_Utilizadores>;
  /** fetch data from the table in a streaming manner: "utilizadores.utilizadores" */
  utilizadores_utilizadores_stream: Array<Utilizadores_Utilizadores>;
  /** fetch data from the table: "variaveis.agregacao" */
  variaveis_agregacao: Array<Variaveis_Agregacao>;
  /** fetch aggregated fields from the table: "variaveis.agregacao" */
  variaveis_agregacao_aggregate: Variaveis_Agregacao_Aggregate;
  /** fetch data from the table: "variaveis.agregacao" using primary key columns */
  variaveis_agregacao_by_pk?: Maybe<Variaveis_Agregacao>;
  /** fetch data from the table in a streaming manner: "variaveis.agregacao" */
  variaveis_agregacao_stream: Array<Variaveis_Agregacao>;
  /** fetch data from the table: "variaveis.base" */
  variaveis_base: Array<Variaveis_Base>;
  /** fetch aggregated fields from the table: "variaveis.base" */
  variaveis_base_aggregate: Variaveis_Base_Aggregate;
  /** fetch data from the table: "variaveis.base" using primary key columns */
  variaveis_base_by_pk?: Maybe<Variaveis_Base>;
  /** fetch data from the table: "variaveis.base_calc_variaveis" */
  variaveis_base_calc_variaveis: Array<Variaveis_Base_Calc_Variaveis>;
  /** fetch aggregated fields from the table: "variaveis.base_calc_variaveis" */
  variaveis_base_calc_variaveis_aggregate: Variaveis_Base_Calc_Variaveis_Aggregate;
  /** fetch data from the table: "variaveis.base_calc_variaveis" using primary key columns */
  variaveis_base_calc_variaveis_by_pk?: Maybe<Variaveis_Base_Calc_Variaveis>;
  /** fetch data from the table in a streaming manner: "variaveis.base_calc_variaveis" */
  variaveis_base_calc_variaveis_stream: Array<Variaveis_Base_Calc_Variaveis>;
  /** fetch data from the table: "variaveis.base_categorias" */
  variaveis_base_categorias: Array<Variaveis_Base_Categorias>;
  /** fetch aggregated fields from the table: "variaveis.base_categorias" */
  variaveis_base_categorias_aggregate: Variaveis_Base_Categorias_Aggregate;
  /** fetch data from the table: "variaveis.base_categorias" using primary key columns */
  variaveis_base_categorias_by_pk?: Maybe<Variaveis_Base_Categorias>;
  /** fetch data from the table in a streaming manner: "variaveis.base_categorias" */
  variaveis_base_categorias_stream: Array<Variaveis_Base_Categorias>;
  /** fetch data from the table: "variaveis.base_propriedades" */
  variaveis_base_propriedades: Array<Variaveis_Base_Propriedades>;
  /** fetch aggregated fields from the table: "variaveis.base_propriedades" */
  variaveis_base_propriedades_aggregate: Variaveis_Base_Propriedades_Aggregate;
  /** fetch data from the table: "variaveis.base_propriedades" using primary key columns */
  variaveis_base_propriedades_by_pk?: Maybe<Variaveis_Base_Propriedades>;
  /** fetch data from the table in a streaming manner: "variaveis.base_propriedades" */
  variaveis_base_propriedades_stream: Array<Variaveis_Base_Propriedades>;
  /** fetch data from the table in a streaming manner: "variaveis.base" */
  variaveis_base_stream: Array<Variaveis_Base>;
  /** fetch data from the table: "variaveis.calc_variaveis" */
  variaveis_calc_variaveis: Array<Variaveis_Calc_Variaveis>;
  /** fetch aggregated fields from the table: "variaveis.calc_variaveis" */
  variaveis_calc_variaveis_aggregate: Variaveis_Calc_Variaveis_Aggregate;
  /** fetch data from the table: "variaveis.calc_variaveis" using primary key columns */
  variaveis_calc_variaveis_by_pk?: Maybe<Variaveis_Calc_Variaveis>;
  /** fetch data from the table in a streaming manner: "variaveis.calc_variaveis" */
  variaveis_calc_variaveis_stream: Array<Variaveis_Calc_Variaveis>;
  /** fetch data from the table: "variaveis.dominios" */
  variaveis_dominios: Array<Variaveis_Dominios>;
  /** fetch aggregated fields from the table: "variaveis.dominios" */
  variaveis_dominios_aggregate: Variaveis_Dominios_Aggregate;
  /** fetch data from the table: "variaveis.dominios" using primary key columns */
  variaveis_dominios_by_pk?: Maybe<Variaveis_Dominios>;
  /** fetch data from the table: "variaveis.dominios_r_dominios_valores" */
  variaveis_dominios_r_dominios_valores: Array<Variaveis_Dominios_R_Dominios_Valores>;
  /** fetch aggregated fields from the table: "variaveis.dominios_r_dominios_valores" */
  variaveis_dominios_r_dominios_valores_aggregate: Variaveis_Dominios_R_Dominios_Valores_Aggregate;
  /** fetch data from the table: "variaveis.dominios_r_dominios_valores" using primary key columns */
  variaveis_dominios_r_dominios_valores_by_pk?: Maybe<Variaveis_Dominios_R_Dominios_Valores>;
  /** fetch data from the table in a streaming manner: "variaveis.dominios_r_dominios_valores" */
  variaveis_dominios_r_dominios_valores_stream: Array<Variaveis_Dominios_R_Dominios_Valores>;
  /** fetch data from the table in a streaming manner: "variaveis.dominios" */
  variaveis_dominios_stream: Array<Variaveis_Dominios>;
  /** fetch data from the table: "variaveis.dominios_valores" */
  variaveis_dominios_valores: Array<Variaveis_Dominios_Valores>;
  /** fetch aggregated fields from the table: "variaveis.dominios_valores" */
  variaveis_dominios_valores_aggregate: Variaveis_Dominios_Valores_Aggregate;
  /** fetch data from the table: "variaveis.dominios_valores" using primary key columns */
  variaveis_dominios_valores_by_pk?: Maybe<Variaveis_Dominios_Valores>;
  /** fetch data from the table in a streaming manner: "variaveis.dominios_valores" */
  variaveis_dominios_valores_stream: Array<Variaveis_Dominios_Valores>;
  /** fetch data from the table: "variaveis.escalas_precisao" */
  variaveis_escalas_precisao: Array<Variaveis_Escalas_Precisao>;
  /** fetch aggregated fields from the table: "variaveis.escalas_precisao" */
  variaveis_escalas_precisao_aggregate: Variaveis_Escalas_Precisao_Aggregate;
  /** fetch data from the table: "variaveis.escalas_precisao" using primary key columns */
  variaveis_escalas_precisao_by_pk?: Maybe<Variaveis_Escalas_Precisao>;
  /** fetch data from the table in a streaming manner: "variaveis.escalas_precisao" */
  variaveis_escalas_precisao_stream: Array<Variaveis_Escalas_Precisao>;
  /** fetch data from the table: "variaveis.fontes_origem" */
  variaveis_fontes_origem: Array<Variaveis_Fontes_Origem>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem" */
  variaveis_fontes_origem_aggregate: Variaveis_Fontes_Origem_Aggregate;
  /** fetch data from the table: "variaveis.fontes_origem" using primary key columns */
  variaveis_fontes_origem_by_pk?: Maybe<Variaveis_Fontes_Origem>;
  /** fetch data from the table: "variaveis.fontes_origem_estatistica" */
  variaveis_fontes_origem_estatistica: Array<Variaveis_Fontes_Origem_Estatistica>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem_estatistica" */
  variaveis_fontes_origem_estatistica_aggregate: Variaveis_Fontes_Origem_Estatistica_Aggregate;
  /** fetch data from the table in a streaming manner: "variaveis.fontes_origem_estatistica" */
  variaveis_fontes_origem_estatistica_stream: Array<Variaveis_Fontes_Origem_Estatistica>;
  /** fetch data from the table: "variaveis.fontes_origem_infraestrutura_estatistica" */
  variaveis_fontes_origem_infraestrutura_estatistica: Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem_infraestrutura_estatistica" */
  variaveis_fontes_origem_infraestrutura_estatistica_aggregate: Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate;
  /** fetch data from the table in a streaming manner: "variaveis.fontes_origem_infraestrutura_estatistica" */
  variaveis_fontes_origem_infraestrutura_estatistica_stream: Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica>;
  /** fetch data from the table: "variaveis.fontes_origem_plano_padrao_estatistica" */
  variaveis_fontes_origem_plano_padrao_estatistica: Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem_plano_padrao_estatistica" */
  variaveis_fontes_origem_plano_padrao_estatistica_aggregate: Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Aggregate;
  /** fetch data from the table in a streaming manner: "variaveis.fontes_origem_plano_padrao_estatistica" */
  variaveis_fontes_origem_plano_padrao_estatistica_stream: Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica>;
  /** fetch data from the table: "variaveis.fontes_origem_propriedades" */
  variaveis_fontes_origem_propriedades: Array<Variaveis_Fontes_Origem_Propriedades>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem_propriedades" */
  variaveis_fontes_origem_propriedades_aggregate: Variaveis_Fontes_Origem_Propriedades_Aggregate;
  /** fetch data from the table: "variaveis.fontes_origem_propriedades" using primary key columns */
  variaveis_fontes_origem_propriedades_by_pk?: Maybe<Variaveis_Fontes_Origem_Propriedades>;
  /** fetch data from the table in a streaming manner: "variaveis.fontes_origem_propriedades" */
  variaveis_fontes_origem_propriedades_stream: Array<Variaveis_Fontes_Origem_Propriedades>;
  /** fetch data from the table in a streaming manner: "variaveis.fontes_origem" */
  variaveis_fontes_origem_stream: Array<Variaveis_Fontes_Origem>;
  /** fetch data from the table: "variaveis.fontes_origem_tipos" */
  variaveis_fontes_origem_tipos: Array<Variaveis_Fontes_Origem_Tipos>;
  /** fetch aggregated fields from the table: "variaveis.fontes_origem_tipos" */
  variaveis_fontes_origem_tipos_aggregate: Variaveis_Fontes_Origem_Tipos_Aggregate;
  /** fetch data from the table: "variaveis.fontes_origem_tipos" using primary key columns */
  variaveis_fontes_origem_tipos_by_pk?: Maybe<Variaveis_Fontes_Origem_Tipos>;
  /** fetch data from the table in a streaming manner: "variaveis.fontes_origem_tipos" */
  variaveis_fontes_origem_tipos_stream: Array<Variaveis_Fontes_Origem_Tipos>;
  /** fetch data from the table: "variaveis.leituras" */
  variaveis_leituras: Array<Variaveis_Leituras>;
  /** fetch aggregated fields from the table: "variaveis.leituras" */
  variaveis_leituras_aggregate: Variaveis_Leituras_Aggregate;
  /** fetch data from the table: "variaveis.leituras" using primary key columns */
  variaveis_leituras_by_pk?: Maybe<Variaveis_Leituras>;
  /** fetch data from the table in a streaming manner: "variaveis.leituras" */
  variaveis_leituras_stream: Array<Variaveis_Leituras>;
  /** fetch data from the table: "variaveis.parametros" */
  variaveis_parametros: Array<Variaveis_Parametros>;
  /** fetch aggregated fields from the table: "variaveis.parametros" */
  variaveis_parametros_aggregate: Variaveis_Parametros_Aggregate;
  /** fetch data from the table: "variaveis.parametros" using primary key columns */
  variaveis_parametros_by_pk?: Maybe<Variaveis_Parametros>;
  /** fetch data from the table: "variaveis.parametros_r_unidades_medida" */
  variaveis_parametros_r_unidades_medida: Array<Variaveis_Parametros_R_Unidades_Medida>;
  /** fetch aggregated fields from the table: "variaveis.parametros_r_unidades_medida" */
  variaveis_parametros_r_unidades_medida_aggregate: Variaveis_Parametros_R_Unidades_Medida_Aggregate;
  /** fetch data from the table: "variaveis.parametros_r_unidades_medida" using primary key columns */
  variaveis_parametros_r_unidades_medida_by_pk?: Maybe<Variaveis_Parametros_R_Unidades_Medida>;
  /** fetch data from the table in a streaming manner: "variaveis.parametros_r_unidades_medida" */
  variaveis_parametros_r_unidades_medida_stream: Array<Variaveis_Parametros_R_Unidades_Medida>;
  /** fetch data from the table in a streaming manner: "variaveis.parametros" */
  variaveis_parametros_stream: Array<Variaveis_Parametros>;
  /** fetch data from the table: "variaveis.tipos" */
  variaveis_tipos: Array<Variaveis_Tipos>;
  /** fetch aggregated fields from the table: "variaveis.tipos" */
  variaveis_tipos_aggregate: Variaveis_Tipos_Aggregate;
  /** fetch data from the table: "variaveis.tipos" using primary key columns */
  variaveis_tipos_by_pk?: Maybe<Variaveis_Tipos>;
  /** fetch data from the table in a streaming manner: "variaveis.tipos" */
  variaveis_tipos_stream: Array<Variaveis_Tipos>;
  /** fetch data from the table: "variaveis.totalizadores_tipos_registo" */
  variaveis_totalizadores_tipos_registo: Array<Variaveis_Totalizadores_Tipos_Registo>;
  /** fetch aggregated fields from the table: "variaveis.totalizadores_tipos_registo" */
  variaveis_totalizadores_tipos_registo_aggregate: Variaveis_Totalizadores_Tipos_Registo_Aggregate;
  /** fetch data from the table: "variaveis.totalizadores_tipos_registo" using primary key columns */
  variaveis_totalizadores_tipos_registo_by_pk?: Maybe<Variaveis_Totalizadores_Tipos_Registo>;
  /** fetch data from the table in a streaming manner: "variaveis.totalizadores_tipos_registo" */
  variaveis_totalizadores_tipos_registo_stream: Array<Variaveis_Totalizadores_Tipos_Registo>;
  /** fetch data from the table: "variaveis.unidades_medida" */
  variaveis_unidades_medida: Array<Variaveis_Unidades_Medida>;
  /** fetch aggregated fields from the table: "variaveis.unidades_medida" */
  variaveis_unidades_medida_aggregate: Variaveis_Unidades_Medida_Aggregate;
  /** fetch data from the table: "variaveis.unidades_medida" using primary key columns */
  variaveis_unidades_medida_by_pk?: Maybe<Variaveis_Unidades_Medida>;
  /** fetch data from the table in a streaming manner: "variaveis.unidades_medida" */
  variaveis_unidades_medida_stream: Array<Variaveis_Unidades_Medida>;
  /** fetch data from the table: "variaveis.valores_mensais" */
  variaveis_valores_mensais: Array<Variaveis_Valores_Mensais>;
  /** fetch aggregated fields from the table: "variaveis.valores_mensais" */
  variaveis_valores_mensais_aggregate: Variaveis_Valores_Mensais_Aggregate;
  /** fetch data from the table: "variaveis.valores_mensais" using primary key columns */
  variaveis_valores_mensais_by_pk?: Maybe<Variaveis_Valores_Mensais>;
  /** fetch data from the table in a streaming manner: "variaveis.valores_mensais" */
  variaveis_valores_mensais_stream: Array<Variaveis_Valores_Mensais>;
  zmc_leaks_count: Array<Zmc_Leaks_Count_Model>;
};


export type Subscription_RootAge_Vs_Leaks_FrequencyArgs = {
  args: Age_Vs_Leaks_Frequency_Arguments;
  distinct_on?: InputMaybe<Array<Age_Vs_Leaks_Frequency_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Age_Vs_Leaks_Frequency_Model_Order_By>>;
  where?: InputMaybe<Age_Vs_Leaks_Frequency_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootBase_Bulk_TiposArgs = {
  distinct_on?: InputMaybe<Array<Base_Bulk_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Bulk_Tipos_Order_By>>;
  where?: InputMaybe<Base_Bulk_Tipos_Bool_Exp>;
};


export type Subscription_RootBase_Bulk_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Bulk_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Bulk_Tipos_Order_By>>;
  where?: InputMaybe<Base_Bulk_Tipos_Bool_Exp>;
};


export type Subscription_RootBase_Bulk_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBase_Bulk_Tipos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Base_Bulk_Tipos_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Bulk_Tipos_Bool_Exp>;
};


export type Subscription_RootBase_CentrosArgs = {
  distinct_on?: InputMaybe<Array<Base_Centros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Centros_Order_By>>;
  where?: InputMaybe<Base_Centros_Bool_Exp>;
};


export type Subscription_RootBase_Centros_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Centros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Centros_Order_By>>;
  where?: InputMaybe<Base_Centros_Bool_Exp>;
};


export type Subscription_RootBase_Centros_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBase_Centros_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Base_Centros_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Centros_Bool_Exp>;
};


export type Subscription_RootBase_Get_Infraestruturas_Tipos_Active_ChildsArgs = {
  args: Base_Get_Infraestruturas_Tipos_Active_Childs_Args;
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Tipos_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};


export type Subscription_RootBase_Get_Infraestruturas_Tipos_Active_Childs_AggregateArgs = {
  args: Base_Get_Infraestruturas_Tipos_Active_Childs_Args;
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Tipos_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};


export type Subscription_RootBase_InfraestruturasArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
};


export type Subscription_RootBase_Infraestruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
};


export type Subscription_RootBase_Infraestruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBase_Infraestruturas_CoordenadasArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
};


export type Subscription_RootBase_Infraestruturas_Coordenadas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
};


export type Subscription_RootBase_Infraestruturas_Coordenadas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBase_Infraestruturas_Coordenadas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Base_Infraestruturas_Coordenadas_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Infraestruturas_Coordenadas_Bool_Exp>;
};


export type Subscription_RootBase_Infraestruturas_R_ToponimiasArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_R_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_R_Toponimias_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_R_Toponimias_Bool_Exp>;
};


export type Subscription_RootBase_Infraestruturas_R_Toponimias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_R_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_R_Toponimias_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_R_Toponimias_Bool_Exp>;
};


export type Subscription_RootBase_Infraestruturas_R_Toponimias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBase_Infraestruturas_R_Toponimias_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Base_Infraestruturas_R_Toponimias_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Infraestruturas_R_Toponimias_Bool_Exp>;
};


export type Subscription_RootBase_Infraestruturas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Base_Infraestruturas_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
};


export type Subscription_RootBase_Infraestruturas_TiposArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Tipos_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};


export type Subscription_RootBase_Infraestruturas_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Infraestruturas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Infraestruturas_Tipos_Order_By>>;
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};


export type Subscription_RootBase_Infraestruturas_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBase_Infraestruturas_Tipos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Base_Infraestruturas_Tipos_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
};


export type Subscription_RootBase_ParametrizacoesArgs = {
  distinct_on?: InputMaybe<Array<Base_Parametrizacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Parametrizacoes_Order_By>>;
  where?: InputMaybe<Base_Parametrizacoes_Bool_Exp>;
};


export type Subscription_RootBase_Parametrizacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Parametrizacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Parametrizacoes_Order_By>>;
  where?: InputMaybe<Base_Parametrizacoes_Bool_Exp>;
};


export type Subscription_RootBase_Parametrizacoes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Base_Parametrizacoes_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Parametrizacoes_Bool_Exp>;
};


export type Subscription_RootBase_ToponimiasArgs = {
  distinct_on?: InputMaybe<Array<Base_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Toponimias_Order_By>>;
  where?: InputMaybe<Base_Toponimias_Bool_Exp>;
};


export type Subscription_RootBase_Toponimias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Toponimias_Order_By>>;
  where?: InputMaybe<Base_Toponimias_Bool_Exp>;
};


export type Subscription_RootBase_Toponimias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBase_Toponimias_CoordenadasArgs = {
  distinct_on?: InputMaybe<Array<Base_Toponimias_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Toponimias_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
};


export type Subscription_RootBase_Toponimias_Coordenadas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Toponimias_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Toponimias_Coordenadas_Order_By>>;
  where?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
};


export type Subscription_RootBase_Toponimias_Coordenadas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBase_Toponimias_Coordenadas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Base_Toponimias_Coordenadas_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Toponimias_Coordenadas_Bool_Exp>;
};


export type Subscription_RootBase_Toponimias_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Base_Toponimias_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Toponimias_Bool_Exp>;
};


export type Subscription_RootBase_ZmcArgs = {
  distinct_on?: InputMaybe<Array<Base_Zmc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Zmc_Order_By>>;
  where?: InputMaybe<Base_Zmc_Bool_Exp>;
};


export type Subscription_RootBase_Zmc_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Zmc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Zmc_Order_By>>;
  where?: InputMaybe<Base_Zmc_Bool_Exp>;
};


export type Subscription_RootBase_Zmc_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBase_Zmc_Nos_TipoArgs = {
  distinct_on?: InputMaybe<Array<Base_Zmc_Nos_Tipo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Zmc_Nos_Tipo_Order_By>>;
  where?: InputMaybe<Base_Zmc_Nos_Tipo_Bool_Exp>;
};


export type Subscription_RootBase_Zmc_Nos_Tipo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Zmc_Nos_Tipo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Base_Zmc_Nos_Tipo_Order_By>>;
  where?: InputMaybe<Base_Zmc_Nos_Tipo_Bool_Exp>;
};


export type Subscription_RootBase_Zmc_Nos_Tipo_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootBase_Zmc_Nos_Tipo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Base_Zmc_Nos_Tipo_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Zmc_Nos_Tipo_Bool_Exp>;
};


export type Subscription_RootBase_Zmc_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Base_Zmc_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Zmc_Bool_Exp>;
};


export type Subscription_RootConsultas_RequisicoesArgs = {
  distinct_on?: InputMaybe<Array<Consultas_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consultas_Requisicoes_Order_By>>;
  where?: InputMaybe<Consultas_Requisicoes_Bool_Exp>;
};


export type Subscription_RootConsultas_Requisicoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consultas_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consultas_Requisicoes_Order_By>>;
  where?: InputMaybe<Consultas_Requisicoes_Bool_Exp>;
};


export type Subscription_RootConsultas_Requisicoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootConsultas_Requisicoes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Consultas_Requisicoes_Stream_Cursor_Input>>;
  where?: InputMaybe<Consultas_Requisicoes_Bool_Exp>;
};


export type Subscription_RootFailure_Recurrence_RateArgs = {
  args: Failure_Recurrence_Rate_Arguments;
  distinct_on?: InputMaybe<Array<Failure_Recurrence_Rate_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Failure_Recurrence_Rate_Model_Order_By>>;
  where?: InputMaybe<Failure_Recurrence_Rate_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootInfrastructure_Totalizers_TreeArgs = {
  args: Infrastructure_Totalizers_Tree_Arguments;
  distinct_on?: InputMaybe<Array<Infrastructures_Totalizers_Tree_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infrastructures_Totalizers_Tree_Model_Order_By>>;
  where?: InputMaybe<Infrastructures_Totalizers_Tree_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootInfrastructure_Variables_TreeArgs = {
  args: Infrastructure_Variables_Tree_Arguments;
  distinct_on?: InputMaybe<Array<Infrastructures_Variables_Tree_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Infrastructures_Variables_Tree_Model_Order_By>>;
  where?: InputMaybe<Infrastructures_Variables_Tree_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Ad_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Ad_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Ad_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Ad_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Ad_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Ad_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Ad_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Ad_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Ad_Parametrizacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Integracoes_Ad_Parametrizacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Integracoes_Ad_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Ad_Saml_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Ad_Saml_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Ad_Saml_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Ad_Saml_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Ad_Saml_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Ad_Saml_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Ad_Saml_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootIntegracoes_Ad_Saml_Parametrizacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Integracoes_Ad_Saml_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Maps_OrtosArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Maps_Ortos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Maps_Ortos_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Maps_Ortos_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Maps_Ortos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Maps_Ortos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Maps_Ortos_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Maps_Ortos_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Maps_Ortos_By_PkArgs = {
  id: Scalars['smallint']['input'];
};


export type Subscription_RootIntegracoes_Sig_Maps_Ortos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Integracoes_Sig_Maps_Ortos_Stream_Cursor_Input>>;
  where?: InputMaybe<Integracoes_Sig_Maps_Ortos_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Parametrizacao_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Parametrizacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Integracoes_Sig_Parametrizacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Integracoes_Sig_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_ProxyArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Proxy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Proxy_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Proxy_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Proxy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Proxy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Proxy_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Proxy_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Proxy_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootIntegracoes_Sig_Proxy_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Integracoes_Sig_Proxy_Stream_Cursor_Input>>;
  where?: InputMaybe<Integracoes_Sig_Proxy_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Request_Get_AttributesArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Attributes_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Attributes_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Request_Get_Attributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Attributes_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Attributes_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Request_Get_Attributes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Integracoes_Sig_Request_Get_Attributes_Stream_Cursor_Input>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Attributes_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Request_Get_CapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Capabilities_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Capabilities_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Request_Get_Capabilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Capabilities_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Capabilities_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Request_Get_Capabilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Integracoes_Sig_Request_Get_Capabilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Capabilities_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Request_Get_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Features_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Features_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Request_Get_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Request_Get_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Request_Get_Features_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Features_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Request_Get_Features_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Integracoes_Sig_Request_Get_Features_Stream_Cursor_Input>>;
  where?: InputMaybe<Integracoes_Sig_Request_Get_Features_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_ServicesArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Services_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Services_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Services_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Integracoes_Sig_Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Integracoes_Sig_Services_Order_By>>;
  where?: InputMaybe<Integracoes_Sig_Services_Bool_Exp>;
};


export type Subscription_RootIntegracoes_Sig_Services_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootIntegracoes_Sig_Services_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Integracoes_Sig_Services_Stream_Cursor_Input>>;
  where?: InputMaybe<Integracoes_Sig_Services_Bool_Exp>;
};


export type Subscription_RootLeak_Recurrence_Vs_RehabilitationArgs = {
  args: Leak_Recurrence_Vs_Rehabilitation_Arguments;
  distinct_on?: InputMaybe<Array<Leak_Recurrence_Vs_Rehabilitation_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leak_Recurrence_Vs_Rehabilitation_Model_Order_By>>;
  where?: InputMaybe<Leak_Recurrence_Vs_Rehabilitation_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootLeaks_Per_DistanceArgs = {
  args: Leaks_Per_Distance_Arguments;
  distinct_on?: InputMaybe<Array<Leaks_Per_Distance_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leaks_Per_Distance_Model_Order_By>>;
  where?: InputMaybe<Leaks_Per_Distance_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootMensagens_AnexosArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Anexos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Anexos_Order_By>>;
  where?: InputMaybe<Mensagens_Anexos_Bool_Exp>;
};


export type Subscription_RootMensagens_Anexos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Anexos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Anexos_Order_By>>;
  where?: InputMaybe<Mensagens_Anexos_Bool_Exp>;
};


export type Subscription_RootMensagens_Anexos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMensagens_Anexos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mensagens_Anexos_Stream_Cursor_Input>>;
  where?: InputMaybe<Mensagens_Anexos_Bool_Exp>;
};


export type Subscription_RootMensagens_MensagensArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Mensagens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Mensagens_Order_By>>;
  where?: InputMaybe<Mensagens_Mensagens_Bool_Exp>;
};


export type Subscription_RootMensagens_Mensagens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Mensagens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Mensagens_Order_By>>;
  where?: InputMaybe<Mensagens_Mensagens_Bool_Exp>;
};


export type Subscription_RootMensagens_Mensagens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMensagens_Mensagens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mensagens_Mensagens_Stream_Cursor_Input>>;
  where?: InputMaybe<Mensagens_Mensagens_Bool_Exp>;
};


export type Subscription_RootMensagens_PostArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Post_Order_By>>;
  where?: InputMaybe<Mensagens_Post_Bool_Exp>;
};


export type Subscription_RootMensagens_Post_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mensagens_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mensagens_Post_Order_By>>;
  where?: InputMaybe<Mensagens_Post_Bool_Exp>;
};


export type Subscription_RootMensagens_Post_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMensagens_Post_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mensagens_Post_Stream_Cursor_Input>>;
  where?: InputMaybe<Mensagens_Post_Bool_Exp>;
};


export type Subscription_RootMobile_CoordenadasArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Coordenadas_Order_By>>;
  where?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
};


export type Subscription_RootMobile_Coordenadas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Coordenadas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Coordenadas_Order_By>>;
  where?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
};


export type Subscription_RootMobile_Coordenadas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMobile_Coordenadas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mobile_Coordenadas_Stream_Cursor_Input>>;
  where?: InputMaybe<Mobile_Coordenadas_Bool_Exp>;
};


export type Subscription_RootNavia_CoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Cores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Cores_Order_By>>;
  where?: InputMaybe<Navia_Cores_Bool_Exp>;
};


export type Subscription_RootNavia_Cores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Cores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Cores_Order_By>>;
  where?: InputMaybe<Navia_Cores_Bool_Exp>;
};


export type Subscription_RootNavia_Cores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Cores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Cores_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Cores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Infraestruturas_VariaveisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Mapa_NiveisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_SintomasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_TiposArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_InfraestruturaArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_By_PkArgs = {
  tipo_infraestrutura_id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_ZmcArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_By_PkArgs = {
  tipo_infraestrutura_id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Infraestruturas_TotalizadoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Totalizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Totalizadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Infraestruturas_Totalizadores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Infraestruturas_Totalizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Totalizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Totalizadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Infraestruturas_Totalizadores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Infraestruturas_Totalizadores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Infraestruturas_Totalizadores_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Infraestruturas_Totalizadores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Infraestruturas_VariaveisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Infraestruturas_Variaveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Infraestruturas_Variaveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Infraestruturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Infraestruturas_Variaveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Infraestruturas_Variaveis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Infraestruturas_Variaveis_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Infraestruturas_Variaveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_MenuArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Menu_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Menu_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Menu_R_TransacoesArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Menu_R_Transacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Menu_R_Transacoes_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Menu_R_Transacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Menu_R_Transacoes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Menu_R_Transacoes_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Menu_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Menu_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Menu_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_TokensArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_Tokens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_Tokens_Revogacao_ManualArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_By_PkArgs = {
  id_token: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Revogacao_Manual_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_Tokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_Tokens_ValidadosArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_Tokens_Validados_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Modo_Tv_Tokens_Validados_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_Tokens_Validados_By_PkArgs = {
  id_token: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Modo_Tv_Tokens_Validados_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Modo_Tv_Tokens_Validados_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_CausasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_R_CausasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Causas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_IndicadoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Indicadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Indicadores_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Indicadores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_SintomasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_R_SintomasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Sintomas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_VariaveisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Variaveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Monitorizacao_Roturas_Variaveis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Performance_Infraestrutura_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Performance_Infraestrutura_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Performance_Infraestrutura_Parametrizacao_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootNavia_Dashboards_Performance_Infraestrutura_Parametrizacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_TarefaArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_By_PkArgs = {
  plano_padrao_id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_SintomasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_ValoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_R_Dominios_Valores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_InfraestruturaArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_By_PkArgs = {
  tipo_infraestrutura_id: Scalars['Int']['input'];
};


export type Subscription_RootNavia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Requisicoes_Indicadores_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Requisicoes_Indicadores_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Requisicoes_Indicadores_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Requisicoes_Indicadores_Parametrizacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Requisicoes_Mapa_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Requisicoes_Mapa_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Requisicoes_Mapa_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Requisicoes_Mapa_Parametrizacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Visao_360_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Visao_360_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Visao_360_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Visao_360_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Visao_360_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Visao_360_Parametrizacao_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Visao_360_Parametrizacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Visao_360_Parametrizacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Visao_360_SelectoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Visao_360_Selectores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Visao_360_Selectores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Visao_360_Selectores_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootNavia_Dashboards_Visao_360_Selectores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Visao_360_Selectores_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Visao_360_Selectores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_CaudaisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Caudais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Caudais_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Caudais_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Caudais_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Caudais_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_DadosArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Dados_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Dados_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Dados_By_PkArgs = {
  id_municipio: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Dados_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_MunicipiosArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_LeiturasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Leituras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Leituras_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Leituras_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Leituras_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Leituras_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_LocaisArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Locais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Locais_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Locais_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Locais_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Locais_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_MunicipiosArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Municipios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Municipios_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Municipios_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_RegistosArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Registos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Registos_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Registos_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Registos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Registos_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Totalizador_LeiturasArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Totalizador_Leituras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Totalizador_Leituras_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Totalizador_Leituras_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_TotalizadoresArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Totalizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Order_By>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp>;
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Totalizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Dashboards_Volumes_Diarios_Totalizadores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp>;
};


export type Subscription_RootNavia_IntegracoesArgs = {
  distinct_on?: InputMaybe<Array<Navia_Integracoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Integracoes_Order_By>>;
  where?: InputMaybe<Navia_Integracoes_Bool_Exp>;
};


export type Subscription_RootNavia_Integracoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Integracoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Integracoes_Order_By>>;
  where?: InputMaybe<Navia_Integracoes_Bool_Exp>;
};


export type Subscription_RootNavia_Integracoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Integracoes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Integracoes_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Integracoes_Bool_Exp>;
};


export type Subscription_RootNavia_LogArgs = {
  distinct_on?: InputMaybe<Array<Navia_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Log_Order_By>>;
  where?: InputMaybe<Navia_Log_Bool_Exp>;
};


export type Subscription_RootNavia_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Navia_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Navia_Log_Order_By>>;
  where?: InputMaybe<Navia_Log_Bool_Exp>;
};


export type Subscription_RootNavia_Log_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNavia_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Navia_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Navia_Log_Bool_Exp>;
};


export type Subscription_RootNetwork_IntegrityArgs = {
  args: Network_Integrity_Arguments;
  distinct_on?: InputMaybe<Array<Network_Integrity_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Network_Integrity_Model_Order_By>>;
  where?: InputMaybe<Network_Integrity_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootNotificacoes_ItensArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Itens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Itens_Order_By>>;
  where?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
};


export type Subscription_RootNotificacoes_Itens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Itens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Itens_Order_By>>;
  where?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
};


export type Subscription_RootNotificacoes_Itens_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNotificacoes_Itens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notificacoes_Itens_Stream_Cursor_Input>>;
  where?: InputMaybe<Notificacoes_Itens_Bool_Exp>;
};


export type Subscription_RootNotificacoes_NotificacoesArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Notificacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Notificacoes_Order_By>>;
  where?: InputMaybe<Notificacoes_Notificacoes_Bool_Exp>;
};


export type Subscription_RootNotificacoes_Notificacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Notificacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Notificacoes_Order_By>>;
  where?: InputMaybe<Notificacoes_Notificacoes_Bool_Exp>;
};


export type Subscription_RootNotificacoes_Notificacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNotificacoes_Notificacoes_R_UtilizadoresArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
};


export type Subscription_RootNotificacoes_Notificacoes_R_Utilizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Notificacoes_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
};


export type Subscription_RootNotificacoes_Notificacoes_R_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNotificacoes_Notificacoes_R_Utilizadores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Stream_Cursor_Input>>;
  where?: InputMaybe<Notificacoes_Notificacoes_R_Utilizadores_Bool_Exp>;
};


export type Subscription_RootNotificacoes_Notificacoes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notificacoes_Notificacoes_Stream_Cursor_Input>>;
  where?: InputMaybe<Notificacoes_Notificacoes_Bool_Exp>;
};


export type Subscription_RootNotificacoes_TiposArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Tipos_Order_By>>;
  where?: InputMaybe<Notificacoes_Tipos_Bool_Exp>;
};


export type Subscription_RootNotificacoes_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notificacoes_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notificacoes_Tipos_Order_By>>;
  where?: InputMaybe<Notificacoes_Tipos_Bool_Exp>;
};


export type Subscription_RootNotificacoes_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNotificacoes_Tipos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notificacoes_Tipos_Stream_Cursor_Input>>;
  where?: InputMaybe<Notificacoes_Tipos_Bool_Exp>;
};


export type Subscription_RootPermissoes_TransacoesArgs = {
  distinct_on?: InputMaybe<Array<Permissoes_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissoes_Transacoes_Order_By>>;
  where?: InputMaybe<Permissoes_Transacoes_Bool_Exp>;
};


export type Subscription_RootPermissoes_Transacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissoes_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissoes_Transacoes_Order_By>>;
  where?: InputMaybe<Permissoes_Transacoes_Bool_Exp>;
};


export type Subscription_RootPermissoes_Transacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPermissoes_Transacoes_R_MenusArgs = {
  distinct_on?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Order_By>>;
  where?: InputMaybe<Permissoes_Transacoes_R_Menus_Bool_Exp>;
};


export type Subscription_RootPermissoes_Transacoes_R_Menus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Order_By>>;
  where?: InputMaybe<Permissoes_Transacoes_R_Menus_Bool_Exp>;
};


export type Subscription_RootPermissoes_Transacoes_R_Menus_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootPermissoes_Transacoes_R_Menus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Permissoes_Transacoes_R_Menus_Stream_Cursor_Input>>;
  where?: InputMaybe<Permissoes_Transacoes_R_Menus_Bool_Exp>;
};


export type Subscription_RootPermissoes_Transacoes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Permissoes_Transacoes_Stream_Cursor_Input>>;
  where?: InputMaybe<Permissoes_Transacoes_Bool_Exp>;
};


export type Subscription_RootPipe_Readings_By_MaterialArgs = {
  args: Pipe_Readings_By_Material_Arguments;
  distinct_on?: InputMaybe<Array<Pipe_Readings_By_Material_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipe_Readings_By_Material_Model_Order_By>>;
  where?: InputMaybe<Pipe_Readings_By_Material_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootPipe_Rehabilitation_RateArgs = {
  args: Pipe_Rehabilitation_Rate_Arguments;
  distinct_on?: InputMaybe<Array<Pipe_Rehabilitation_Rate_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipe_Rehabilitation_Rate_Model_Order_By>>;
  where?: InputMaybe<Pipe_Rehabilitation_Rate_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootRequests_Act_ListArgs = {
  args: Requests_Act_List_Arguments;
  distinct_on?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Order_By>>;
  where?: InputMaybe<Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootRequests_Act_List_Without_LoginArgs = {
  args: Requests_Act_List_Without_Login_Arguments;
  distinct_on?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Order_By>>;
  where?: InputMaybe<Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootRequests_Danger_ListArgs = {
  args: Requests_Danger_List_Arguments;
  distinct_on?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Order_By>>;
  where?: InputMaybe<Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootRequests_Danger_List_Without_LoginArgs = {
  args: Requests_Danger_List_Without_Login_Arguments;
  distinct_on?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Requests_Act_And_Danger_List_Return_Order_By>>;
  where?: InputMaybe<Requests_Act_And_Danger_List_Return_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootRqs_ParametrizacaoArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Parametrizacao_Order_By>>;
  where?: InputMaybe<Rqs_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootRqs_Parametrizacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Parametrizacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Parametrizacao_Order_By>>;
  where?: InputMaybe<Rqs_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootRqs_Parametrizacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rqs_Parametrizacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Rqs_Parametrizacao_Bool_Exp>;
};


export type Subscription_RootRqs_Requisicoes_PeriodosArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Order_By>>;
  where?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
};


export type Subscription_RootRqs_Requisicoes_Periodos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Requisicoes_Periodos_Order_By>>;
  where?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
};


export type Subscription_RootRqs_Requisicoes_Periodos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRqs_Requisicoes_Periodos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rqs_Requisicoes_Periodos_Stream_Cursor_Input>>;
  where?: InputMaybe<Rqs_Requisicoes_Periodos_Bool_Exp>;
};


export type Subscription_RootRqs_Requisicoes_Tempos_WrapArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Order_By>>;
  where?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Bool_Exp>;
};


export type Subscription_RootRqs_Requisicoes_Tempos_Wrap_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Requisicoes_Tempos_Wrap_Order_By>>;
  where?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Bool_Exp>;
};


export type Subscription_RootRqs_Requisicoes_Tempos_Wrap_By_PkArgs = {
  id_requisicao: Scalars['bigint']['input'];
};


export type Subscription_RootRqs_Requisicoes_Tempos_Wrap_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Stream_Cursor_Input>>;
  where?: InputMaybe<Rqs_Requisicoes_Tempos_Wrap_Bool_Exp>;
};


export type Subscription_RootRqs_SintomasArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
};


export type Subscription_RootRqs_Sintomas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
};


export type Subscription_RootRqs_Sintomas_By_PkArgs = {
  id_sintoma: Scalars['bigint']['input'];
};


export type Subscription_RootRqs_Sintomas_Parametrizacao_TemposArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>;
};


export type Subscription_RootRqs_Sintomas_Parametrizacao_Tempos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rqs_Sintomas_Parametrizacao_Tempos_Order_By>>;
  where?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>;
};


export type Subscription_RootRqs_Sintomas_Parametrizacao_Tempos_By_PkArgs = {
  id_sintoma: Scalars['bigint']['input'];
};


export type Subscription_RootRqs_Sintomas_Parametrizacao_Tempos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Stream_Cursor_Input>>;
  where?: InputMaybe<Rqs_Sintomas_Parametrizacao_Tempos_Bool_Exp>;
};


export type Subscription_RootRqs_Sintomas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rqs_Sintomas_Stream_Cursor_Input>>;
  where?: InputMaybe<Rqs_Sintomas_Bool_Exp>;
};


export type Subscription_RootServicos_FasesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Fases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Fases_Order_By>>;
  where?: InputMaybe<Servicos_Fases_Bool_Exp>;
};


export type Subscription_RootServicos_Fases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Fases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Fases_Order_By>>;
  where?: InputMaybe<Servicos_Fases_Bool_Exp>;
};


export type Subscription_RootServicos_Fases_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServicos_Fases_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Servicos_Fases_Stream_Cursor_Input>>;
  where?: InputMaybe<Servicos_Fases_Bool_Exp>;
};


export type Subscription_RootServicos_IntervencoesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
};


export type Subscription_RootServicos_Intervencoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
};


export type Subscription_RootServicos_Intervencoes_Atribuicao_UtilizadoresArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp>;
};


export type Subscription_RootServicos_Intervencoes_Atribuicao_Utilizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Atribuicao_Utilizadores_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp>;
};


export type Subscription_RootServicos_Intervencoes_Atribuicao_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServicos_Intervencoes_Atribuicao_Utilizadores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Stream_Cursor_Input>>;
  where?: InputMaybe<Servicos_Intervencoes_Atribuicao_Utilizadores_Bool_Exp>;
};


export type Subscription_RootServicos_Intervencoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServicos_Intervencoes_EstadosArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Estados_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Estados_Bool_Exp>;
};


export type Subscription_RootServicos_Intervencoes_Estados_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_Estados_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_Estados_Bool_Exp>;
};


export type Subscription_RootServicos_Intervencoes_Estados_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServicos_Intervencoes_Estados_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Servicos_Intervencoes_Estados_Stream_Cursor_Input>>;
  where?: InputMaybe<Servicos_Intervencoes_Estados_Bool_Exp>;
};


export type Subscription_RootServicos_Intervencoes_R_Causas_TrabalhosArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
};


export type Subscription_RootServicos_Intervencoes_R_Causas_Trabalhos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Intervencoes_R_Causas_Trabalhos_Order_By>>;
  where?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
};


export type Subscription_RootServicos_Intervencoes_R_Causas_Trabalhos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServicos_Intervencoes_R_Causas_Trabalhos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Stream_Cursor_Input>>;
  where?: InputMaybe<Servicos_Intervencoes_R_Causas_Trabalhos_Bool_Exp>;
};


export type Subscription_RootServicos_Intervencoes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Servicos_Intervencoes_Stream_Cursor_Input>>;
  where?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
};


export type Subscription_RootServicos_RastreabilidadeArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Rastreabilidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Rastreabilidade_Order_By>>;
  where?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
};


export type Subscription_RootServicos_Rastreabilidade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Rastreabilidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Rastreabilidade_Order_By>>;
  where?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
};


export type Subscription_RootServicos_Rastreabilidade_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServicos_Rastreabilidade_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Servicos_Rastreabilidade_Stream_Cursor_Input>>;
  where?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
};


export type Subscription_RootServicos_RequisicoesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
};


export type Subscription_RootServicos_Requisicoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
};


export type Subscription_RootServicos_Requisicoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServicos_Requisicoes_EstadosArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Estados_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Estados_Bool_Exp>;
};


export type Subscription_RootServicos_Requisicoes_Estados_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Estados_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Estados_Bool_Exp>;
};


export type Subscription_RootServicos_Requisicoes_Estados_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServicos_Requisicoes_Estados_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Servicos_Requisicoes_Estados_Stream_Cursor_Input>>;
  where?: InputMaybe<Servicos_Requisicoes_Estados_Bool_Exp>;
};


export type Subscription_RootServicos_Requisicoes_Locais_Infra_EstruturasArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
};


export type Subscription_RootServicos_Requisicoes_Locais_Infra_Estruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_Locais_Infra_Estruturas_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
};


export type Subscription_RootServicos_Requisicoes_Locais_Infra_Estruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServicos_Requisicoes_Locais_Infra_Estruturas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Stream_Cursor_Input>>;
  where?: InputMaybe<Servicos_Requisicoes_Locais_Infra_Estruturas_Bool_Exp>;
};


export type Subscription_RootServicos_Requisicoes_R_IntervencoesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
};


export type Subscription_RootServicos_Requisicoes_R_Intervencoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Requisicoes_R_Intervencoes_Order_By>>;
  where?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
};


export type Subscription_RootServicos_Requisicoes_R_Intervencoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServicos_Requisicoes_R_Intervencoes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Servicos_Requisicoes_R_Intervencoes_Stream_Cursor_Input>>;
  where?: InputMaybe<Servicos_Requisicoes_R_Intervencoes_Bool_Exp>;
};


export type Subscription_RootServicos_Requisicoes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Servicos_Requisicoes_Stream_Cursor_Input>>;
  where?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
};


export type Subscription_RootSintomas_ArvoreArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Arvore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Arvore_Order_By>>;
  where?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
};


export type Subscription_RootSintomas_Arvore_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Arvore_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Arvore_Order_By>>;
  where?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
};


export type Subscription_RootSintomas_Arvore_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSintomas_Arvore_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sintomas_Arvore_Stream_Cursor_Input>>;
  where?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
};


export type Subscription_RootSintomas_Causas_TrabalhosArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Order_By>>;
  where?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
};


export type Subscription_RootSintomas_Causas_Trabalhos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Order_By>>;
  where?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
};


export type Subscription_RootSintomas_Causas_Trabalhos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSintomas_Causas_Trabalhos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sintomas_Causas_Trabalhos_Stream_Cursor_Input>>;
  where?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
};


export type Subscription_RootSintomas_Sintomas_RelacaoArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Order_By>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
};


export type Subscription_RootSintomas_Sintomas_Relacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Order_By>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
};


export type Subscription_RootSintomas_Sintomas_Relacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSintomas_Sintomas_Relacao_OrdemArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Ordem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Ordem_Order_By>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Bool_Exp>;
};


export type Subscription_RootSintomas_Sintomas_Relacao_Ordem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Ordem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Ordem_Order_By>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Bool_Exp>;
};


export type Subscription_RootSintomas_Sintomas_Relacao_Ordem_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSintomas_Sintomas_Relacao_Ordem_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Stream_Cursor_Input>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Ordem_Bool_Exp>;
};


export type Subscription_RootSintomas_Sintomas_Relacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sintomas_Sintomas_Relacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
};


export type Subscription_RootTarefas_EstadosArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Estados_Order_By>>;
  where?: InputMaybe<Tarefas_Estados_Bool_Exp>;
};


export type Subscription_RootTarefas_Estados_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Estados_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Estados_Order_By>>;
  where?: InputMaybe<Tarefas_Estados_Bool_Exp>;
};


export type Subscription_RootTarefas_Estados_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTarefas_Estados_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tarefas_Estados_Stream_Cursor_Input>>;
  where?: InputMaybe<Tarefas_Estados_Bool_Exp>;
};


export type Subscription_RootTarefas_IntervalosArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Intervalos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Intervalos_Order_By>>;
  where?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
};


export type Subscription_RootTarefas_Intervalos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Intervalos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Intervalos_Order_By>>;
  where?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
};


export type Subscription_RootTarefas_Intervalos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTarefas_Intervalos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tarefas_Intervalos_Stream_Cursor_Input>>;
  where?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
};


export type Subscription_RootTarefas_Planos_PadraoArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Planos_Padrao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Planos_Padrao_Order_By>>;
  where?: InputMaybe<Tarefas_Planos_Padrao_Bool_Exp>;
};


export type Subscription_RootTarefas_Planos_Padrao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Planos_Padrao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Planos_Padrao_Order_By>>;
  where?: InputMaybe<Tarefas_Planos_Padrao_Bool_Exp>;
};


export type Subscription_RootTarefas_Planos_Padrao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTarefas_Planos_Padrao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tarefas_Planos_Padrao_Stream_Cursor_Input>>;
  where?: InputMaybe<Tarefas_Planos_Padrao_Bool_Exp>;
};


export type Subscription_RootTarefas_TarefasArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
};


export type Subscription_RootTarefas_Tarefas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
};


export type Subscription_RootTarefas_Tarefas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTarefas_Tarefas_R_Equipas_VirtuaisArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
};


export type Subscription_RootTarefas_Tarefas_R_Equipas_Virtuais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
};


export type Subscription_RootTarefas_Tarefas_R_Equipas_Virtuais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTarefas_Tarefas_R_Equipas_Virtuais_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Stream_Cursor_Input>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
};


export type Subscription_RootTarefas_Tarefas_R_InfraestruturasArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>;
};


export type Subscription_RootTarefas_Tarefas_R_Infraestruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>;
};


export type Subscription_RootTarefas_Tarefas_R_Infraestruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTarefas_Tarefas_R_Infraestruturas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Stream_Cursor_Input>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>;
};


export type Subscription_RootTarefas_Tarefas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tarefas_Tarefas_Stream_Cursor_Input>>;
  where?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
};


export type Subscription_RootTop_5_Pipes_With_Most_LeaksArgs = {
  args: Top_5_Pipes_With_Most_Leaks_Arguments;
  distinct_on?: InputMaybe<Array<Top_5_Pipes_With_Most_Leaks_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Top_5_Pipes_With_Most_Leaks_Model_Order_By>>;
  where?: InputMaybe<Top_5_Pipes_With_Most_Leaks_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootTop_Five_Average_Duration_By_SymptomArgs = {
  args: Top_Five_Average_Duration_By_Symptom_Arguments;
  distinct_on?: InputMaybe<Array<Top_Five_Average_Duration_By_Symptom_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Top_Five_Average_Duration_By_Symptom_Return_Order_By>>;
  where?: InputMaybe<Top_Five_Average_Duration_By_Symptom_Return_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootTop_Five_Average_Duration_By_Symptom_Without_LoginArgs = {
  args: Top_Five_Average_Duration_By_Symptom_Without_Login_Arguments;
  distinct_on?: InputMaybe<Array<Top_Five_Average_Duration_By_Symptom_Return_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Top_Five_Average_Duration_By_Symptom_Return_Order_By>>;
  where?: InputMaybe<Top_Five_Average_Duration_By_Symptom_Return_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootUser_AgendaArgs = {
  args: User_Agenda_Arguments;
  distinct_on?: InputMaybe<Array<User_Agenda_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Agenda_Model_Order_By>>;
  where?: InputMaybe<User_Agenda_Model_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootUtilizadores_CategoriasArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Categorias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Categorias_Order_By>>;
  where?: InputMaybe<Utilizadores_Categorias_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Categorias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Categorias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Categorias_Order_By>>;
  where?: InputMaybe<Utilizadores_Categorias_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Categorias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Categorias_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Categorias_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Categorias_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_VirtuaisArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_CentrosArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Centros_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Centros_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Centros_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Equipas_VirtuaisArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Equipas_Virtuais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Equipas_Virtuais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Equipas_Virtuais_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_InfraestruturasArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Infraestruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Infraestruturas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Infraestruturas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_SintomaArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Sintoma_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Sintoma_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Sintoma_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_ToponimiasArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Toponimias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Toponimias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Toponimias_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_TransacoesArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Transacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Transacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Transacoes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_UtilizadoresArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Utilizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_R_Utilizadores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Equipas_Virtuais_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Equipas_Virtuais_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
};


export type Subscription_RootUtilizadores_ExportacoesArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Exportacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Exportacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Exportacoes_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Exportacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Exportacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Exportacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Exportacoes_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Exportacoes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Exportacoes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Exportacoes_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Exportacoes_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Mapa_Posicao_CoresArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Mapa_Posicao_Cores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Mapa_Posicao_Cores_Order_By>>;
  where?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Mapa_Posicao_Cores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Mapa_Posicao_Cores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Mapa_Posicao_Cores_Order_By>>;
  where?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Mapa_Posicao_Cores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Mapa_Posicao_Cores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Mapa_Posicao_Cores_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Bool_Exp>;
};


export type Subscription_RootUtilizadores_MenuArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Menu_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Menu_Order_By>>;
  where?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Menu_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Menu_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Menu_Order_By>>;
  where?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Menu_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Menu_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Menu_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
};


export type Subscription_RootUtilizadores_TemasArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Temas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Temas_Order_By>>;
  where?: InputMaybe<Utilizadores_Temas_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Temas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Temas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Temas_Order_By>>;
  where?: InputMaybe<Utilizadores_Temas_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Temas_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Temas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Temas_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Temas_Bool_Exp>;
};


export type Subscription_RootUtilizadores_UtilizadoresArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Utilizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
};


export type Subscription_RootUtilizadores_Utilizadores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUtilizadores_Utilizadores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Utilizadores_Utilizadores_Stream_Cursor_Input>>;
  where?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
};


export type Subscription_RootVariaveis_AgregacaoArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Agregacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Agregacao_Order_By>>;
  where?: InputMaybe<Variaveis_Agregacao_Bool_Exp>;
};


export type Subscription_RootVariaveis_Agregacao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Agregacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Agregacao_Order_By>>;
  where?: InputMaybe<Variaveis_Agregacao_Bool_Exp>;
};


export type Subscription_RootVariaveis_Agregacao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Agregacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Agregacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Agregacao_Bool_Exp>;
};


export type Subscription_RootVariaveis_BaseArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Bool_Exp>;
};


export type Subscription_RootVariaveis_Base_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Bool_Exp>;
};


export type Subscription_RootVariaveis_Base_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Base_Calc_VariaveisArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Calc_Variaveis_Bool_Exp>;
};


export type Subscription_RootVariaveis_Base_Calc_Variaveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Calc_Variaveis_Bool_Exp>;
};


export type Subscription_RootVariaveis_Base_Calc_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Base_Calc_Variaveis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Base_Calc_Variaveis_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Base_Calc_Variaveis_Bool_Exp>;
};


export type Subscription_RootVariaveis_Base_CategoriasArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Categorias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Categorias_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Categorias_Bool_Exp>;
};


export type Subscription_RootVariaveis_Base_Categorias_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Categorias_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Categorias_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Categorias_Bool_Exp>;
};


export type Subscription_RootVariaveis_Base_Categorias_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Base_Categorias_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Base_Categorias_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Base_Categorias_Bool_Exp>;
};


export type Subscription_RootVariaveis_Base_PropriedadesArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
};


export type Subscription_RootVariaveis_Base_Propriedades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
};


export type Subscription_RootVariaveis_Base_Propriedades_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Base_Propriedades_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Base_Propriedades_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
};


export type Subscription_RootVariaveis_Base_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Base_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Base_Bool_Exp>;
};


export type Subscription_RootVariaveis_Calc_VariaveisArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Calc_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Calc_Variaveis_Order_By>>;
  where?: InputMaybe<Variaveis_Calc_Variaveis_Bool_Exp>;
};


export type Subscription_RootVariaveis_Calc_Variaveis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Calc_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Calc_Variaveis_Order_By>>;
  where?: InputMaybe<Variaveis_Calc_Variaveis_Bool_Exp>;
};


export type Subscription_RootVariaveis_Calc_Variaveis_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Calc_Variaveis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Calc_Variaveis_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Calc_Variaveis_Bool_Exp>;
};


export type Subscription_RootVariaveis_DominiosArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_Bool_Exp>;
};


export type Subscription_RootVariaveis_Dominios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_Bool_Exp>;
};


export type Subscription_RootVariaveis_Dominios_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Dominios_R_Dominios_ValoresArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_R_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_R_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Bool_Exp>;
};


export type Subscription_RootVariaveis_Dominios_R_Dominios_Valores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_R_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_R_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Bool_Exp>;
};


export type Subscription_RootVariaveis_Dominios_R_Dominios_Valores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Dominios_R_Dominios_Valores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Bool_Exp>;
};


export type Subscription_RootVariaveis_Dominios_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Dominios_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Dominios_Bool_Exp>;
};


export type Subscription_RootVariaveis_Dominios_ValoresArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_Valores_Bool_Exp>;
};


export type Subscription_RootVariaveis_Dominios_Valores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Dominios_Valores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Dominios_Valores_Order_By>>;
  where?: InputMaybe<Variaveis_Dominios_Valores_Bool_Exp>;
};


export type Subscription_RootVariaveis_Dominios_Valores_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Dominios_Valores_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Dominios_Valores_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Dominios_Valores_Bool_Exp>;
};


export type Subscription_RootVariaveis_Escalas_PrecisaoArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Escalas_Precisao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Escalas_Precisao_Order_By>>;
  where?: InputMaybe<Variaveis_Escalas_Precisao_Bool_Exp>;
};


export type Subscription_RootVariaveis_Escalas_Precisao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Escalas_Precisao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Escalas_Precisao_Order_By>>;
  where?: InputMaybe<Variaveis_Escalas_Precisao_Bool_Exp>;
};


export type Subscription_RootVariaveis_Escalas_Precisao_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Escalas_Precisao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Escalas_Precisao_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Escalas_Precisao_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_OrigemArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Fontes_Origem_EstatisticaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Estatistica_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Estatistica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Estatistica_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Estatistica_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Fontes_Origem_Estatistica_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Estatistica_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Infraestrutura_EstatisticaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Infraestrutura_Estatistica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Infraestrutura_Estatistica_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Plano_Padrao_EstatisticaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Plano_Padrao_Estatistica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Plano_Padrao_Estatistica_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_PropriedadesArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Propriedades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Propriedades_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Fontes_Origem_Propriedades_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Fontes_Origem_Propriedades_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Fontes_Origem_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_TiposArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Tipos_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Tipos_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Bool_Exp>;
};


export type Subscription_RootVariaveis_Fontes_Origem_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Fontes_Origem_Tipos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Fontes_Origem_Tipos_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Bool_Exp>;
};


export type Subscription_RootVariaveis_LeiturasArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};


export type Subscription_RootVariaveis_Leituras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};


export type Subscription_RootVariaveis_Leituras_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Leituras_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Leituras_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};


export type Subscription_RootVariaveis_ParametrosArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_Bool_Exp>;
};


export type Subscription_RootVariaveis_Parametros_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_Bool_Exp>;
};


export type Subscription_RootVariaveis_Parametros_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Parametros_R_Unidades_MedidaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
};


export type Subscription_RootVariaveis_Parametros_R_Unidades_Medida_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
};


export type Subscription_RootVariaveis_Parametros_R_Unidades_Medida_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Parametros_R_Unidades_Medida_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
};


export type Subscription_RootVariaveis_Parametros_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Parametros_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Parametros_Bool_Exp>;
};


export type Subscription_RootVariaveis_TiposArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Tipos_Order_By>>;
  where?: InputMaybe<Variaveis_Tipos_Bool_Exp>;
};


export type Subscription_RootVariaveis_Tipos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Tipos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Tipos_Order_By>>;
  where?: InputMaybe<Variaveis_Tipos_Bool_Exp>;
};


export type Subscription_RootVariaveis_Tipos_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Tipos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Tipos_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Tipos_Bool_Exp>;
};


export type Subscription_RootVariaveis_Totalizadores_Tipos_RegistoArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Totalizadores_Tipos_Registo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Totalizadores_Tipos_Registo_Order_By>>;
  where?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Bool_Exp>;
};


export type Subscription_RootVariaveis_Totalizadores_Tipos_Registo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Totalizadores_Tipos_Registo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Totalizadores_Tipos_Registo_Order_By>>;
  where?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Bool_Exp>;
};


export type Subscription_RootVariaveis_Totalizadores_Tipos_Registo_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Totalizadores_Tipos_Registo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Bool_Exp>;
};


export type Subscription_RootVariaveis_Unidades_MedidaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
};


export type Subscription_RootVariaveis_Unidades_Medida_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
};


export type Subscription_RootVariaveis_Unidades_Medida_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Unidades_Medida_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Unidades_Medida_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
};


export type Subscription_RootVariaveis_Valores_MensaisArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Valores_Mensais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Valores_Mensais_Order_By>>;
  where?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
};


export type Subscription_RootVariaveis_Valores_Mensais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Valores_Mensais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Valores_Mensais_Order_By>>;
  where?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
};


export type Subscription_RootVariaveis_Valores_Mensais_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootVariaveis_Valores_Mensais_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Variaveis_Valores_Mensais_Stream_Cursor_Input>>;
  where?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
};


export type Subscription_RootZmc_Leaks_CountArgs = {
  args: Zmc_Leaks_Count_Arguments;
  distinct_on?: InputMaybe<Array<Zmc_Leaks_Count_Model_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Zmc_Leaks_Count_Model_Order_By>>;
  where?: InputMaybe<Zmc_Leaks_Count_Model_Bool_Exp_Bool_Exp>;
};

/** columns and relationships of "tarefas.estados" */
export type Tarefas_Estados = {
  __typename?: 'tarefas_estados';
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "tarefas.estados" */
export type Tarefas_Estados_Aggregate = {
  __typename?: 'tarefas_estados_aggregate';
  aggregate?: Maybe<Tarefas_Estados_Aggregate_Fields>;
  nodes: Array<Tarefas_Estados>;
};

/** aggregate fields of "tarefas.estados" */
export type Tarefas_Estados_Aggregate_Fields = {
  __typename?: 'tarefas_estados_aggregate_fields';
  avg?: Maybe<Tarefas_Estados_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tarefas_Estados_Max_Fields>;
  min?: Maybe<Tarefas_Estados_Min_Fields>;
  stddev?: Maybe<Tarefas_Estados_Stddev_Fields>;
  stddev_pop?: Maybe<Tarefas_Estados_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tarefas_Estados_Stddev_Samp_Fields>;
  sum?: Maybe<Tarefas_Estados_Sum_Fields>;
  var_pop?: Maybe<Tarefas_Estados_Var_Pop_Fields>;
  var_samp?: Maybe<Tarefas_Estados_Var_Samp_Fields>;
  variance?: Maybe<Tarefas_Estados_Variance_Fields>;
};


/** aggregate fields of "tarefas.estados" */
export type Tarefas_Estados_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tarefas_Estados_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Tarefas_Estados_Avg_Fields = {
  __typename?: 'tarefas_estados_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tarefas.estados". All fields are combined with a logical 'AND'. */
export type Tarefas_Estados_Bool_Exp = {
  _and?: InputMaybe<Array<Tarefas_Estados_Bool_Exp>>;
  _not?: InputMaybe<Tarefas_Estados_Bool_Exp>;
  _or?: InputMaybe<Array<Tarefas_Estados_Bool_Exp>>;
  cor?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "tarefas.estados" */
export enum Tarefas_Estados_Constraint {
  /** unique or primary key constraint on columns "id" */
  EstadosPkey = 'estados_pkey'
}

/** input type for incrementing numeric columns in table "tarefas.estados" */
export type Tarefas_Estados_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "tarefas.estados" */
export type Tarefas_Estados_Insert_Input = {
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Tarefas_Estados_Max_Fields = {
  __typename?: 'tarefas_estados_max_fields';
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Tarefas_Estados_Min_Fields = {
  __typename?: 'tarefas_estados_min_fields';
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "tarefas.estados" */
export type Tarefas_Estados_Mutation_Response = {
  __typename?: 'tarefas_estados_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tarefas_Estados>;
};

/** on_conflict condition type for table "tarefas.estados" */
export type Tarefas_Estados_On_Conflict = {
  constraint: Tarefas_Estados_Constraint;
  update_columns?: Array<Tarefas_Estados_Update_Column>;
  where?: InputMaybe<Tarefas_Estados_Bool_Exp>;
};

/** Ordering options when selecting data from "tarefas.estados". */
export type Tarefas_Estados_Order_By = {
  cor?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tarefas.estados */
export type Tarefas_Estados_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "tarefas.estados" */
export enum Tarefas_Estados_Select_Column {
  /** column name */
  Cor = 'cor',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "tarefas.estados" */
export type Tarefas_Estados_Set_Input = {
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Tarefas_Estados_Stddev_Fields = {
  __typename?: 'tarefas_estados_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Tarefas_Estados_Stddev_Pop_Fields = {
  __typename?: 'tarefas_estados_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Tarefas_Estados_Stddev_Samp_Fields = {
  __typename?: 'tarefas_estados_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tarefas_estados" */
export type Tarefas_Estados_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tarefas_Estados_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tarefas_Estados_Stream_Cursor_Value_Input = {
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Tarefas_Estados_Sum_Fields = {
  __typename?: 'tarefas_estados_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "tarefas.estados" */
export enum Tarefas_Estados_Update_Column {
  /** column name */
  Cor = 'cor',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Tarefas_Estados_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tarefas_Estados_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tarefas_Estados_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tarefas_Estados_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tarefas_Estados_Var_Pop_Fields = {
  __typename?: 'tarefas_estados_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Tarefas_Estados_Var_Samp_Fields = {
  __typename?: 'tarefas_estados_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Tarefas_Estados_Variance_Fields = {
  __typename?: 'tarefas_estados_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tarefas.intervalos" */
export type Tarefas_Intervalos = {
  __typename?: 'tarefas_intervalos';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  data_fim?: Maybe<Scalars['timestamp']['output']>;
  data_inicio?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['bigint']['output'];
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  intervencao?: Maybe<Servicos_Intervencoes>;
};

/** aggregated selection of "tarefas.intervalos" */
export type Tarefas_Intervalos_Aggregate = {
  __typename?: 'tarefas_intervalos_aggregate';
  aggregate?: Maybe<Tarefas_Intervalos_Aggregate_Fields>;
  nodes: Array<Tarefas_Intervalos>;
};

export type Tarefas_Intervalos_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tarefas_Intervalos_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tarefas_Intervalos_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tarefas_Intervalos_Aggregate_Bool_Exp_Count>;
};

export type Tarefas_Intervalos_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tarefas_Intervalos_Select_Column_Tarefas_Intervalos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tarefas_Intervalos_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tarefas_Intervalos_Select_Column_Tarefas_Intervalos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tarefas_Intervalos_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tarefas_Intervalos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tarefas.intervalos" */
export type Tarefas_Intervalos_Aggregate_Fields = {
  __typename?: 'tarefas_intervalos_aggregate_fields';
  avg?: Maybe<Tarefas_Intervalos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tarefas_Intervalos_Max_Fields>;
  min?: Maybe<Tarefas_Intervalos_Min_Fields>;
  stddev?: Maybe<Tarefas_Intervalos_Stddev_Fields>;
  stddev_pop?: Maybe<Tarefas_Intervalos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tarefas_Intervalos_Stddev_Samp_Fields>;
  sum?: Maybe<Tarefas_Intervalos_Sum_Fields>;
  var_pop?: Maybe<Tarefas_Intervalos_Var_Pop_Fields>;
  var_samp?: Maybe<Tarefas_Intervalos_Var_Samp_Fields>;
  variance?: Maybe<Tarefas_Intervalos_Variance_Fields>;
};


/** aggregate fields of "tarefas.intervalos" */
export type Tarefas_Intervalos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tarefas_Intervalos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tarefas.intervalos" */
export type Tarefas_Intervalos_Aggregate_Order_By = {
  avg?: InputMaybe<Tarefas_Intervalos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tarefas_Intervalos_Max_Order_By>;
  min?: InputMaybe<Tarefas_Intervalos_Min_Order_By>;
  stddev?: InputMaybe<Tarefas_Intervalos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tarefas_Intervalos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tarefas_Intervalos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tarefas_Intervalos_Sum_Order_By>;
  var_pop?: InputMaybe<Tarefas_Intervalos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tarefas_Intervalos_Var_Samp_Order_By>;
  variance?: InputMaybe<Tarefas_Intervalos_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tarefas.intervalos" */
export type Tarefas_Intervalos_Arr_Rel_Insert_Input = {
  data: Array<Tarefas_Intervalos_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tarefas_Intervalos_On_Conflict>;
};

/** aggregate avg on columns */
export type Tarefas_Intervalos_Avg_Fields = {
  __typename?: 'tarefas_intervalos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tarefas.intervalos" */
export type Tarefas_Intervalos_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tarefas.intervalos". All fields are combined with a logical 'AND'. */
export type Tarefas_Intervalos_Bool_Exp = {
  _and?: InputMaybe<Array<Tarefas_Intervalos_Bool_Exp>>;
  _not?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
  _or?: InputMaybe<Array<Tarefas_Intervalos_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  data_fim?: InputMaybe<Timestamp_Comparison_Exp>;
  data_inicio?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_intervencao?: InputMaybe<Bigint_Comparison_Exp>;
  id_tarefa?: InputMaybe<Bigint_Comparison_Exp>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
};

/** unique or primary key constraints on table "tarefas.intervalos" */
export enum Tarefas_Intervalos_Constraint {
  /** unique or primary key constraint on columns "id" */
  IntervalosPkey = 'intervalos_pkey',
  /** unique or primary key constraint on columns "data_inicio", "id_intervencao" */
  UniqueIntervencao = 'unique_intervencao',
  /** unique or primary key constraint on columns "data_inicio", "id_tarefa" */
  UniqueTarefa = 'unique_tarefa'
}

/** input type for incrementing numeric columns in table "tarefas.intervalos" */
export type Tarefas_Intervalos_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "tarefas.intervalos" */
export type Tarefas_Intervalos_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_fim?: InputMaybe<Scalars['timestamp']['input']>;
  data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tarefas_Intervalos_Max_Fields = {
  __typename?: 'tarefas_intervalos_max_fields';
  data_fim?: Maybe<Scalars['timestamp']['output']>;
  data_inicio?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "tarefas.intervalos" */
export type Tarefas_Intervalos_Max_Order_By = {
  data_fim?: InputMaybe<Order_By>;
  data_inicio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tarefas_Intervalos_Min_Fields = {
  __typename?: 'tarefas_intervalos_min_fields';
  data_fim?: Maybe<Scalars['timestamp']['output']>;
  data_inicio?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "tarefas.intervalos" */
export type Tarefas_Intervalos_Min_Order_By = {
  data_fim?: InputMaybe<Order_By>;
  data_inicio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tarefas.intervalos" */
export type Tarefas_Intervalos_Mutation_Response = {
  __typename?: 'tarefas_intervalos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tarefas_Intervalos>;
};

/** on_conflict condition type for table "tarefas.intervalos" */
export type Tarefas_Intervalos_On_Conflict = {
  constraint: Tarefas_Intervalos_Constraint;
  update_columns?: Array<Tarefas_Intervalos_Update_Column>;
  where?: InputMaybe<Tarefas_Intervalos_Bool_Exp>;
};

/** Ordering options when selecting data from "tarefas.intervalos". */
export type Tarefas_Intervalos_Order_By = {
  apagado?: InputMaybe<Order_By>;
  data_fim?: InputMaybe<Order_By>;
  data_inicio?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Order_By>;
};

/** primary key columns input for table: tarefas.intervalos */
export type Tarefas_Intervalos_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "tarefas.intervalos" */
export enum Tarefas_Intervalos_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataFim = 'data_fim',
  /** column name */
  DataInicio = 'data_inicio',
  /** column name */
  Id = 'id',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdTarefa = 'id_tarefa'
}

/** select "tarefas_intervalos_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tarefas.intervalos" */
export enum Tarefas_Intervalos_Select_Column_Tarefas_Intervalos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado'
}

/** select "tarefas_intervalos_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tarefas.intervalos" */
export enum Tarefas_Intervalos_Select_Column_Tarefas_Intervalos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado'
}

/** input type for updating data in table "tarefas.intervalos" */
export type Tarefas_Intervalos_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_fim?: InputMaybe<Scalars['timestamp']['input']>;
  data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Tarefas_Intervalos_Stddev_Fields = {
  __typename?: 'tarefas_intervalos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tarefas.intervalos" */
export type Tarefas_Intervalos_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tarefas_Intervalos_Stddev_Pop_Fields = {
  __typename?: 'tarefas_intervalos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tarefas.intervalos" */
export type Tarefas_Intervalos_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tarefas_Intervalos_Stddev_Samp_Fields = {
  __typename?: 'tarefas_intervalos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tarefas.intervalos" */
export type Tarefas_Intervalos_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tarefas_intervalos" */
export type Tarefas_Intervalos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tarefas_Intervalos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tarefas_Intervalos_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  data_fim?: InputMaybe<Scalars['timestamp']['input']>;
  data_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Tarefas_Intervalos_Sum_Fields = {
  __typename?: 'tarefas_intervalos_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "tarefas.intervalos" */
export type Tarefas_Intervalos_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** update columns of table "tarefas.intervalos" */
export enum Tarefas_Intervalos_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  DataFim = 'data_fim',
  /** column name */
  DataInicio = 'data_inicio',
  /** column name */
  Id = 'id',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdTarefa = 'id_tarefa'
}

export type Tarefas_Intervalos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tarefas_Intervalos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tarefas_Intervalos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tarefas_Intervalos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tarefas_Intervalos_Var_Pop_Fields = {
  __typename?: 'tarefas_intervalos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tarefas.intervalos" */
export type Tarefas_Intervalos_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tarefas_Intervalos_Var_Samp_Fields = {
  __typename?: 'tarefas_intervalos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tarefas.intervalos" */
export type Tarefas_Intervalos_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tarefas_Intervalos_Variance_Fields = {
  __typename?: 'tarefas_intervalos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tarefas.intervalos" */
export type Tarefas_Intervalos_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** columns and relationships of "tarefas.planos_padrao" */
export type Tarefas_Planos_Padrao = {
  __typename?: 'tarefas_planos_padrao';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  apenas_variavel_local?: Maybe<Scalars['Boolean']['output']>;
  campos_preenchidos?: Maybe<Scalars['Boolean']['output']>;
  data_criacao?: Maybe<Scalars['date']['output']>;
  descricao: Scalars['String']['output'];
  descricao_curta?: Maybe<Scalars['String']['output']>;
  frequencia?: Maybe<Scalars['Int']['output']>;
  frequencia_controlo?: Maybe<Scalars['Int']['output']>;
  id: Scalars['bigint']['output'];
  id_autor: Scalars['bigint']['output'];
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_legenda?: Maybe<Scalars['bigint']['output']>;
  id_tipo_foto: Scalars['bigint']['output'];
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_tipo_registo: Scalars['bigint']['output'];
  id_tipo_tarefa: Scalars['bigint']['output'];
  id_variavel_base_controlo?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  infraestrutura?: Maybe<Base_Infraestruturas>;
  limite?: Maybe<Scalars['String']['output']>;
  modo_seguranca?: Maybe<Scalars['Boolean']['output']>;
  mostrar_ultimo_valor?: Maybe<Scalars['Boolean']['output']>;
  registo_nos_desativados?: Maybe<Scalars['Boolean']['output']>;
  registo_nos_separados?: Maybe<Scalars['Boolean']['output']>;
  tarefa_mensal?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  tarefas: Array<Tarefas_Tarefas>;
  /** An aggregate relationship */
  tarefas_aggregate: Tarefas_Tarefas_Aggregate;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
  tolerancia?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "tarefas.planos_padrao" */
export type Tarefas_Planos_PadraoTarefasArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
};


/** columns and relationships of "tarefas.planos_padrao" */
export type Tarefas_Planos_PadraoTarefas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
};

/** aggregated selection of "tarefas.planos_padrao" */
export type Tarefas_Planos_Padrao_Aggregate = {
  __typename?: 'tarefas_planos_padrao_aggregate';
  aggregate?: Maybe<Tarefas_Planos_Padrao_Aggregate_Fields>;
  nodes: Array<Tarefas_Planos_Padrao>;
};

/** aggregate fields of "tarefas.planos_padrao" */
export type Tarefas_Planos_Padrao_Aggregate_Fields = {
  __typename?: 'tarefas_planos_padrao_aggregate_fields';
  avg?: Maybe<Tarefas_Planos_Padrao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tarefas_Planos_Padrao_Max_Fields>;
  min?: Maybe<Tarefas_Planos_Padrao_Min_Fields>;
  stddev?: Maybe<Tarefas_Planos_Padrao_Stddev_Fields>;
  stddev_pop?: Maybe<Tarefas_Planos_Padrao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tarefas_Planos_Padrao_Stddev_Samp_Fields>;
  sum?: Maybe<Tarefas_Planos_Padrao_Sum_Fields>;
  var_pop?: Maybe<Tarefas_Planos_Padrao_Var_Pop_Fields>;
  var_samp?: Maybe<Tarefas_Planos_Padrao_Var_Samp_Fields>;
  variance?: Maybe<Tarefas_Planos_Padrao_Variance_Fields>;
};


/** aggregate fields of "tarefas.planos_padrao" */
export type Tarefas_Planos_Padrao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tarefas_Planos_Padrao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Tarefas_Planos_Padrao_Avg_Fields = {
  __typename?: 'tarefas_planos_padrao_avg_fields';
  frequencia?: Maybe<Scalars['Float']['output']>;
  frequencia_controlo?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_autor?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_legenda?: Maybe<Scalars['Float']['output']>;
  id_tipo_foto?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_tipo_tarefa?: Maybe<Scalars['Float']['output']>;
  id_variavel_base_controlo?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tarefas.planos_padrao". All fields are combined with a logical 'AND'. */
export type Tarefas_Planos_Padrao_Bool_Exp = {
  _and?: InputMaybe<Array<Tarefas_Planos_Padrao_Bool_Exp>>;
  _not?: InputMaybe<Tarefas_Planos_Padrao_Bool_Exp>;
  _or?: InputMaybe<Array<Tarefas_Planos_Padrao_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  apenas_variavel_local?: InputMaybe<Boolean_Comparison_Exp>;
  campos_preenchidos?: InputMaybe<Boolean_Comparison_Exp>;
  data_criacao?: InputMaybe<Date_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  descricao_curta?: InputMaybe<String_Comparison_Exp>;
  frequencia?: InputMaybe<Int_Comparison_Exp>;
  frequencia_controlo?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_autor?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_legenda?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_foto?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_registo?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_tarefa?: InputMaybe<Bigint_Comparison_Exp>;
  id_variavel_base_controlo?: InputMaybe<Bigint_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  limite?: InputMaybe<String_Comparison_Exp>;
  modo_seguranca?: InputMaybe<Boolean_Comparison_Exp>;
  mostrar_ultimo_valor?: InputMaybe<Boolean_Comparison_Exp>;
  registo_nos_desativados?: InputMaybe<Boolean_Comparison_Exp>;
  registo_nos_separados?: InputMaybe<Boolean_Comparison_Exp>;
  tarefa_mensal?: InputMaybe<Boolean_Comparison_Exp>;
  tarefas?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
  tarefas_aggregate?: InputMaybe<Tarefas_Tarefas_Aggregate_Bool_Exp>;
  tempo_estimado?: InputMaybe<Int_Comparison_Exp>;
  tolerancia?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tarefas.planos_padrao" */
export enum Tarefas_Planos_Padrao_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlanosPadraoPkey = 'planos_padrao_pkey'
}

/** input type for incrementing numeric columns in table "tarefas.planos_padrao" */
export type Tarefas_Planos_Padrao_Inc_Input = {
  frequencia?: InputMaybe<Scalars['Int']['input']>;
  frequencia_controlo?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_autor?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_legenda?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_foto?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_registo?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base_controlo?: InputMaybe<Scalars['bigint']['input']>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tarefas.planos_padrao" */
export type Tarefas_Planos_Padrao_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  apenas_variavel_local?: InputMaybe<Scalars['Boolean']['input']>;
  campos_preenchidos?: InputMaybe<Scalars['Boolean']['input']>;
  data_criacao?: InputMaybe<Scalars['date']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  frequencia?: InputMaybe<Scalars['Int']['input']>;
  frequencia_controlo?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_autor?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_legenda?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_foto?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_registo?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base_controlo?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
  limite?: InputMaybe<Scalars['String']['input']>;
  modo_seguranca?: InputMaybe<Scalars['Boolean']['input']>;
  mostrar_ultimo_valor?: InputMaybe<Scalars['Boolean']['input']>;
  registo_nos_desativados?: InputMaybe<Scalars['Boolean']['input']>;
  registo_nos_separados?: InputMaybe<Scalars['Boolean']['input']>;
  tarefa_mensal?: InputMaybe<Scalars['Boolean']['input']>;
  tarefas?: InputMaybe<Tarefas_Tarefas_Arr_Rel_Insert_Input>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
  tolerancia?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tarefas_Planos_Padrao_Max_Fields = {
  __typename?: 'tarefas_planos_padrao_max_fields';
  data_criacao?: Maybe<Scalars['date']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  frequencia?: Maybe<Scalars['Int']['output']>;
  frequencia_controlo?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_autor?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_legenda?: Maybe<Scalars['bigint']['output']>;
  id_tipo_foto?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_tipo_registo?: Maybe<Scalars['bigint']['output']>;
  id_tipo_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base_controlo?: Maybe<Scalars['bigint']['output']>;
  limite?: Maybe<Scalars['String']['output']>;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
  tolerancia?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Tarefas_Planos_Padrao_Min_Fields = {
  __typename?: 'tarefas_planos_padrao_min_fields';
  data_criacao?: Maybe<Scalars['date']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  frequencia?: Maybe<Scalars['Int']['output']>;
  frequencia_controlo?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_autor?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_legenda?: Maybe<Scalars['bigint']['output']>;
  id_tipo_foto?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_tipo_registo?: Maybe<Scalars['bigint']['output']>;
  id_tipo_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base_controlo?: Maybe<Scalars['bigint']['output']>;
  limite?: Maybe<Scalars['String']['output']>;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
  tolerancia?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "tarefas.planos_padrao" */
export type Tarefas_Planos_Padrao_Mutation_Response = {
  __typename?: 'tarefas_planos_padrao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tarefas_Planos_Padrao>;
};

/** input type for inserting object relation for remote table "tarefas.planos_padrao" */
export type Tarefas_Planos_Padrao_Obj_Rel_Insert_Input = {
  data: Tarefas_Planos_Padrao_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tarefas_Planos_Padrao_On_Conflict>;
};

/** on_conflict condition type for table "tarefas.planos_padrao" */
export type Tarefas_Planos_Padrao_On_Conflict = {
  constraint: Tarefas_Planos_Padrao_Constraint;
  update_columns?: Array<Tarefas_Planos_Padrao_Update_Column>;
  where?: InputMaybe<Tarefas_Planos_Padrao_Bool_Exp>;
};

/** Ordering options when selecting data from "tarefas.planos_padrao". */
export type Tarefas_Planos_Padrao_Order_By = {
  apagado?: InputMaybe<Order_By>;
  apenas_variavel_local?: InputMaybe<Order_By>;
  campos_preenchidos?: InputMaybe<Order_By>;
  data_criacao?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  frequencia?: InputMaybe<Order_By>;
  frequencia_controlo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_autor?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_legenda?: InputMaybe<Order_By>;
  id_tipo_foto?: InputMaybe<Order_By>;
  id_tipo_infraestrutura?: InputMaybe<Order_By>;
  id_tipo_registo?: InputMaybe<Order_By>;
  id_tipo_tarefa?: InputMaybe<Order_By>;
  id_variavel_base_controlo?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
  limite?: InputMaybe<Order_By>;
  modo_seguranca?: InputMaybe<Order_By>;
  mostrar_ultimo_valor?: InputMaybe<Order_By>;
  registo_nos_desativados?: InputMaybe<Order_By>;
  registo_nos_separados?: InputMaybe<Order_By>;
  tarefa_mensal?: InputMaybe<Order_By>;
  tarefas_aggregate?: InputMaybe<Tarefas_Tarefas_Aggregate_Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  tolerancia?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tarefas.planos_padrao */
export type Tarefas_Planos_Padrao_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "tarefas.planos_padrao" */
export enum Tarefas_Planos_Padrao_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  ApenasVariavelLocal = 'apenas_variavel_local',
  /** column name */
  CamposPreenchidos = 'campos_preenchidos',
  /** column name */
  DataCriacao = 'data_criacao',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  Frequencia = 'frequencia',
  /** column name */
  FrequenciaControlo = 'frequencia_controlo',
  /** column name */
  Id = 'id',
  /** column name */
  IdAutor = 'id_autor',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdLegenda = 'id_legenda',
  /** column name */
  IdTipoFoto = 'id_tipo_foto',
  /** column name */
  IdTipoInfraestrutura = 'id_tipo_infraestrutura',
  /** column name */
  IdTipoRegisto = 'id_tipo_registo',
  /** column name */
  IdTipoTarefa = 'id_tipo_tarefa',
  /** column name */
  IdVariavelBaseControlo = 'id_variavel_base_controlo',
  /** column name */
  Limite = 'limite',
  /** column name */
  ModoSeguranca = 'modo_seguranca',
  /** column name */
  MostrarUltimoValor = 'mostrar_ultimo_valor',
  /** column name */
  RegistoNosDesativados = 'registo_nos_desativados',
  /** column name */
  RegistoNosSeparados = 'registo_nos_separados',
  /** column name */
  TarefaMensal = 'tarefa_mensal',
  /** column name */
  TempoEstimado = 'tempo_estimado',
  /** column name */
  Tolerancia = 'tolerancia'
}

/** input type for updating data in table "tarefas.planos_padrao" */
export type Tarefas_Planos_Padrao_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  apenas_variavel_local?: InputMaybe<Scalars['Boolean']['input']>;
  campos_preenchidos?: InputMaybe<Scalars['Boolean']['input']>;
  data_criacao?: InputMaybe<Scalars['date']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  frequencia?: InputMaybe<Scalars['Int']['input']>;
  frequencia_controlo?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_autor?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_legenda?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_foto?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_registo?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base_controlo?: InputMaybe<Scalars['bigint']['input']>;
  limite?: InputMaybe<Scalars['String']['input']>;
  modo_seguranca?: InputMaybe<Scalars['Boolean']['input']>;
  mostrar_ultimo_valor?: InputMaybe<Scalars['Boolean']['input']>;
  registo_nos_desativados?: InputMaybe<Scalars['Boolean']['input']>;
  registo_nos_separados?: InputMaybe<Scalars['Boolean']['input']>;
  tarefa_mensal?: InputMaybe<Scalars['Boolean']['input']>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
  tolerancia?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Tarefas_Planos_Padrao_Stddev_Fields = {
  __typename?: 'tarefas_planos_padrao_stddev_fields';
  frequencia?: Maybe<Scalars['Float']['output']>;
  frequencia_controlo?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_autor?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_legenda?: Maybe<Scalars['Float']['output']>;
  id_tipo_foto?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_tipo_tarefa?: Maybe<Scalars['Float']['output']>;
  id_variavel_base_controlo?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Tarefas_Planos_Padrao_Stddev_Pop_Fields = {
  __typename?: 'tarefas_planos_padrao_stddev_pop_fields';
  frequencia?: Maybe<Scalars['Float']['output']>;
  frequencia_controlo?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_autor?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_legenda?: Maybe<Scalars['Float']['output']>;
  id_tipo_foto?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_tipo_tarefa?: Maybe<Scalars['Float']['output']>;
  id_variavel_base_controlo?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Tarefas_Planos_Padrao_Stddev_Samp_Fields = {
  __typename?: 'tarefas_planos_padrao_stddev_samp_fields';
  frequencia?: Maybe<Scalars['Float']['output']>;
  frequencia_controlo?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_autor?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_legenda?: Maybe<Scalars['Float']['output']>;
  id_tipo_foto?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_tipo_tarefa?: Maybe<Scalars['Float']['output']>;
  id_variavel_base_controlo?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tarefas_planos_padrao" */
export type Tarefas_Planos_Padrao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tarefas_Planos_Padrao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tarefas_Planos_Padrao_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  apenas_variavel_local?: InputMaybe<Scalars['Boolean']['input']>;
  campos_preenchidos?: InputMaybe<Scalars['Boolean']['input']>;
  data_criacao?: InputMaybe<Scalars['date']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  frequencia?: InputMaybe<Scalars['Int']['input']>;
  frequencia_controlo?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_autor?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_legenda?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_foto?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_registo?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base_controlo?: InputMaybe<Scalars['bigint']['input']>;
  limite?: InputMaybe<Scalars['String']['input']>;
  modo_seguranca?: InputMaybe<Scalars['Boolean']['input']>;
  mostrar_ultimo_valor?: InputMaybe<Scalars['Boolean']['input']>;
  registo_nos_desativados?: InputMaybe<Scalars['Boolean']['input']>;
  registo_nos_separados?: InputMaybe<Scalars['Boolean']['input']>;
  tarefa_mensal?: InputMaybe<Scalars['Boolean']['input']>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
  tolerancia?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Tarefas_Planos_Padrao_Sum_Fields = {
  __typename?: 'tarefas_planos_padrao_sum_fields';
  frequencia?: Maybe<Scalars['Int']['output']>;
  frequencia_controlo?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_autor?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_legenda?: Maybe<Scalars['bigint']['output']>;
  id_tipo_foto?: Maybe<Scalars['bigint']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_tipo_registo?: Maybe<Scalars['bigint']['output']>;
  id_tipo_tarefa?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base_controlo?: Maybe<Scalars['bigint']['output']>;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "tarefas.planos_padrao" */
export enum Tarefas_Planos_Padrao_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  ApenasVariavelLocal = 'apenas_variavel_local',
  /** column name */
  CamposPreenchidos = 'campos_preenchidos',
  /** column name */
  DataCriacao = 'data_criacao',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  Frequencia = 'frequencia',
  /** column name */
  FrequenciaControlo = 'frequencia_controlo',
  /** column name */
  Id = 'id',
  /** column name */
  IdAutor = 'id_autor',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdLegenda = 'id_legenda',
  /** column name */
  IdTipoFoto = 'id_tipo_foto',
  /** column name */
  IdTipoInfraestrutura = 'id_tipo_infraestrutura',
  /** column name */
  IdTipoRegisto = 'id_tipo_registo',
  /** column name */
  IdTipoTarefa = 'id_tipo_tarefa',
  /** column name */
  IdVariavelBaseControlo = 'id_variavel_base_controlo',
  /** column name */
  Limite = 'limite',
  /** column name */
  ModoSeguranca = 'modo_seguranca',
  /** column name */
  MostrarUltimoValor = 'mostrar_ultimo_valor',
  /** column name */
  RegistoNosDesativados = 'registo_nos_desativados',
  /** column name */
  RegistoNosSeparados = 'registo_nos_separados',
  /** column name */
  TarefaMensal = 'tarefa_mensal',
  /** column name */
  TempoEstimado = 'tempo_estimado',
  /** column name */
  Tolerancia = 'tolerancia'
}

export type Tarefas_Planos_Padrao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tarefas_Planos_Padrao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tarefas_Planos_Padrao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tarefas_Planos_Padrao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tarefas_Planos_Padrao_Var_Pop_Fields = {
  __typename?: 'tarefas_planos_padrao_var_pop_fields';
  frequencia?: Maybe<Scalars['Float']['output']>;
  frequencia_controlo?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_autor?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_legenda?: Maybe<Scalars['Float']['output']>;
  id_tipo_foto?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_tipo_tarefa?: Maybe<Scalars['Float']['output']>;
  id_variavel_base_controlo?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Tarefas_Planos_Padrao_Var_Samp_Fields = {
  __typename?: 'tarefas_planos_padrao_var_samp_fields';
  frequencia?: Maybe<Scalars['Float']['output']>;
  frequencia_controlo?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_autor?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_legenda?: Maybe<Scalars['Float']['output']>;
  id_tipo_foto?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_tipo_tarefa?: Maybe<Scalars['Float']['output']>;
  id_variavel_base_controlo?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Tarefas_Planos_Padrao_Variance_Fields = {
  __typename?: 'tarefas_planos_padrao_variance_fields';
  frequencia?: Maybe<Scalars['Float']['output']>;
  frequencia_controlo?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_autor?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_legenda?: Maybe<Scalars['Float']['output']>;
  id_tipo_foto?: Maybe<Scalars['Float']['output']>;
  id_tipo_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_tipo_tarefa?: Maybe<Scalars['Float']['output']>;
  id_variavel_base_controlo?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tarefas.tarefas" */
export type Tarefas_Tarefas = {
  __typename?: 'tarefas_tarefas';
  adiada?: Maybe<Scalars['Boolean']['output']>;
  apagado?: Maybe<Scalars['Boolean']['output']>;
  bloqueado_materiais?: Maybe<Scalars['Boolean']['output']>;
  ca_fase_programacao?: Maybe<Scalars['Boolean']['output']>;
  ca_quantidade_prevista?: Maybe<Scalars['numeric']['output']>;
  ca_recolha_automatica?: Maybe<Scalars['Boolean']['output']>;
  codigo_unico?: Maybe<Scalars['String']['output']>;
  data_executada?: Maybe<Scalars['timestamp']['output']>;
  data_executada_anterior?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  data_limite?: Maybe<Scalars['timestamp']['output']>;
  data_planeada?: Maybe<Scalars['timestamp']['output']>;
  data_registo?: Maybe<Scalars['timestamp']['output']>;
  data_registo_anterior?: Maybe<Scalars['timestamp']['output']>;
  data_tolerancia?: Maybe<Scalars['timestamp']['output']>;
  desbloqueado_data_hora?: Maybe<Scalars['timestamp']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_anterior?: Maybe<Scalars['bigint']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_operador?: Maybe<Scalars['bigint']['output']>;
  id_operador_anterior?: Maybe<Scalars['bigint']['output']>;
  id_pda?: Maybe<Scalars['bigint']['output']>;
  id_periodicidade: Scalars['bigint']['output'];
  id_plano_execucao?: Maybe<Scalars['bigint']['output']>;
  id_plano_padrao: Scalars['bigint']['output'];
  id_prioridade: Scalars['bigint']['output'];
  id_rota?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  incompleta?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  infraestrutura?: Maybe<Base_Infraestruturas>;
  key_device?: Maybe<Scalars['String']['output']>;
  mobile_id_motivo?: Maybe<Scalars['Int']['output']>;
  mobile_obs?: Maybe<Scalars['String']['output']>;
  nao_planeada?: Maybe<Scalars['Boolean']['output']>;
  notificacoes_enviadas?: Maybe<Scalars['Boolean']['output']>;
  nr_variaveis_registadas?: Maybe<Scalars['Int']['output']>;
  nr_variaveis_total?: Maybe<Scalars['Int']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  obs_planeamento?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  operador?: Maybe<Utilizadores_Utilizadores>;
  ordem?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  planoPadrao: Tarefas_Planos_Padrao;
  /** An array relationship */
  rastreabilidades: Array<Servicos_Rastreabilidade>;
  /** An aggregate relationship */
  rastreabilidades_aggregate: Servicos_Rastreabilidade_Aggregate;
  sap_codigo?: Maybe<Scalars['String']['output']>;
  sap_criacao_comunicada?: Maybe<Scalars['Boolean']['output']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sap_fecho_comunicado?: Maybe<Scalars['Boolean']['output']>;
  sap_horas_comunicado?: Maybe<Scalars['Boolean']['output']>;
  sap_material_comunicado?: Maybe<Scalars['Boolean']['output']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sig_atributo_atualizado?: Maybe<Scalars['Boolean']['output']>;
  sig_codigo?: Maybe<Scalars['String']['output']>;
  sig_enviado?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  tarefaEquipasVirtuais: Array<Tarefas_Tarefas_R_Equipas_Virtuais>;
  /** An aggregate relationship */
  tarefaEquipasVirtuais_aggregate: Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate;
  /** An array relationship */
  tarefaInfraestruturas: Array<Tarefas_Tarefas_R_Infraestruturas>;
  /** An aggregate relationship */
  tarefaInfraestruturas_aggregate: Tarefas_Tarefas_R_Infraestruturas_Aggregate;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
  timestamp_inicio?: Maybe<Scalars['numeric']['output']>;
  todo_dia?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  toponimia?: Maybe<Base_Toponimias>;
  uuid?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "tarefas.tarefas" */
export type Tarefas_TarefasRastreabilidadesArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Rastreabilidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Rastreabilidade_Order_By>>;
  where?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
};


/** columns and relationships of "tarefas.tarefas" */
export type Tarefas_TarefasRastreabilidades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Servicos_Rastreabilidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Servicos_Rastreabilidade_Order_By>>;
  where?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
};


/** columns and relationships of "tarefas.tarefas" */
export type Tarefas_TarefasTarefaEquipasVirtuaisArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
};


/** columns and relationships of "tarefas.tarefas" */
export type Tarefas_TarefasTarefaEquipasVirtuais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
};


/** columns and relationships of "tarefas.tarefas" */
export type Tarefas_TarefasTarefaInfraestruturasArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>;
};


/** columns and relationships of "tarefas.tarefas" */
export type Tarefas_TarefasTarefaInfraestruturas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>;
};

/** aggregated selection of "tarefas.tarefas" */
export type Tarefas_Tarefas_Aggregate = {
  __typename?: 'tarefas_tarefas_aggregate';
  aggregate?: Maybe<Tarefas_Tarefas_Aggregate_Fields>;
  nodes: Array<Tarefas_Tarefas>;
};

export type Tarefas_Tarefas_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tarefas_Tarefas_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tarefas_Tarefas_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tarefas_Tarefas_Aggregate_Bool_Exp_Count>;
};

export type Tarefas_Tarefas_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tarefas_Tarefas_Select_Column_Tarefas_Tarefas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tarefas_Tarefas_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tarefas_Tarefas_Select_Column_Tarefas_Tarefas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tarefas_Tarefas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tarefas_Tarefas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tarefas.tarefas" */
export type Tarefas_Tarefas_Aggregate_Fields = {
  __typename?: 'tarefas_tarefas_aggregate_fields';
  avg?: Maybe<Tarefas_Tarefas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tarefas_Tarefas_Max_Fields>;
  min?: Maybe<Tarefas_Tarefas_Min_Fields>;
  stddev?: Maybe<Tarefas_Tarefas_Stddev_Fields>;
  stddev_pop?: Maybe<Tarefas_Tarefas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tarefas_Tarefas_Stddev_Samp_Fields>;
  sum?: Maybe<Tarefas_Tarefas_Sum_Fields>;
  var_pop?: Maybe<Tarefas_Tarefas_Var_Pop_Fields>;
  var_samp?: Maybe<Tarefas_Tarefas_Var_Samp_Fields>;
  variance?: Maybe<Tarefas_Tarefas_Variance_Fields>;
};


/** aggregate fields of "tarefas.tarefas" */
export type Tarefas_Tarefas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tarefas_Tarefas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tarefas.tarefas" */
export type Tarefas_Tarefas_Aggregate_Order_By = {
  avg?: InputMaybe<Tarefas_Tarefas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tarefas_Tarefas_Max_Order_By>;
  min?: InputMaybe<Tarefas_Tarefas_Min_Order_By>;
  stddev?: InputMaybe<Tarefas_Tarefas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tarefas_Tarefas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tarefas_Tarefas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tarefas_Tarefas_Sum_Order_By>;
  var_pop?: InputMaybe<Tarefas_Tarefas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tarefas_Tarefas_Var_Samp_Order_By>;
  variance?: InputMaybe<Tarefas_Tarefas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tarefas.tarefas" */
export type Tarefas_Tarefas_Arr_Rel_Insert_Input = {
  data: Array<Tarefas_Tarefas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tarefas_Tarefas_On_Conflict>;
};

/** aggregate avg on columns */
export type Tarefas_Tarefas_Avg_Fields = {
  __typename?: 'tarefas_tarefas_avg_fields';
  ca_quantidade_prevista?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_anterior?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_operador?: Maybe<Scalars['Float']['output']>;
  id_operador_anterior?: Maybe<Scalars['Float']['output']>;
  id_pda?: Maybe<Scalars['Float']['output']>;
  id_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_plano_execucao?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_rota?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  mobile_id_motivo?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_registadas?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_total?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
  timestamp_inicio?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tarefas.tarefas" */
export type Tarefas_Tarefas_Avg_Order_By = {
  ca_quantidade_prevista?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_anterior?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_operador?: InputMaybe<Order_By>;
  id_operador_anterior?: InputMaybe<Order_By>;
  id_pda?: InputMaybe<Order_By>;
  id_periodicidade?: InputMaybe<Order_By>;
  id_plano_execucao?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_rota?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  mobile_id_motivo?: InputMaybe<Order_By>;
  nr_variaveis_registadas?: InputMaybe<Order_By>;
  nr_variaveis_total?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  timestamp_inicio?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tarefas.tarefas". All fields are combined with a logical 'AND'. */
export type Tarefas_Tarefas_Bool_Exp = {
  _and?: InputMaybe<Array<Tarefas_Tarefas_Bool_Exp>>;
  _not?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
  _or?: InputMaybe<Array<Tarefas_Tarefas_Bool_Exp>>;
  adiada?: InputMaybe<Boolean_Comparison_Exp>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  bloqueado_materiais?: InputMaybe<Boolean_Comparison_Exp>;
  ca_fase_programacao?: InputMaybe<Boolean_Comparison_Exp>;
  ca_quantidade_prevista?: InputMaybe<Numeric_Comparison_Exp>;
  ca_recolha_automatica?: InputMaybe<Boolean_Comparison_Exp>;
  codigo_unico?: InputMaybe<String_Comparison_Exp>;
  data_executada?: InputMaybe<Timestamp_Comparison_Exp>;
  data_executada_anterior?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_registo_bd?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_ultima_modificacao?: InputMaybe<Timestamp_Comparison_Exp>;
  data_limite?: InputMaybe<Timestamp_Comparison_Exp>;
  data_planeada?: InputMaybe<Timestamp_Comparison_Exp>;
  data_registo?: InputMaybe<Timestamp_Comparison_Exp>;
  data_registo_anterior?: InputMaybe<Timestamp_Comparison_Exp>;
  data_tolerancia?: InputMaybe<Timestamp_Comparison_Exp>;
  desbloqueado_data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  desbloqueado_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_ativo?: InputMaybe<Bigint_Comparison_Exp>;
  id_estado?: InputMaybe<Bigint_Comparison_Exp>;
  id_estado_anterior?: InputMaybe<Bigint_Comparison_Exp>;
  id_estado_validacao?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_operador?: InputMaybe<Bigint_Comparison_Exp>;
  id_operador_anterior?: InputMaybe<Bigint_Comparison_Exp>;
  id_pda?: InputMaybe<Bigint_Comparison_Exp>;
  id_periodicidade?: InputMaybe<Bigint_Comparison_Exp>;
  id_plano_execucao?: InputMaybe<Bigint_Comparison_Exp>;
  id_plano_padrao?: InputMaybe<Bigint_Comparison_Exp>;
  id_prioridade?: InputMaybe<Bigint_Comparison_Exp>;
  id_rota?: InputMaybe<Bigint_Comparison_Exp>;
  id_toponimia?: InputMaybe<Bigint_Comparison_Exp>;
  incompleta?: InputMaybe<Boolean_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  key_device?: InputMaybe<String_Comparison_Exp>;
  mobile_id_motivo?: InputMaybe<Int_Comparison_Exp>;
  mobile_obs?: InputMaybe<String_Comparison_Exp>;
  nao_planeada?: InputMaybe<Boolean_Comparison_Exp>;
  notificacoes_enviadas?: InputMaybe<Boolean_Comparison_Exp>;
  nr_variaveis_registadas?: InputMaybe<Int_Comparison_Exp>;
  nr_variaveis_total?: InputMaybe<Int_Comparison_Exp>;
  obs?: InputMaybe<String_Comparison_Exp>;
  obs_planeamento?: InputMaybe<String_Comparison_Exp>;
  operador?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
  planoPadrao?: InputMaybe<Tarefas_Planos_Padrao_Bool_Exp>;
  rastreabilidades?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
  rastreabilidades_aggregate?: InputMaybe<Servicos_Rastreabilidade_Aggregate_Bool_Exp>;
  sap_codigo?: InputMaybe<String_Comparison_Exp>;
  sap_criacao_comunicada?: InputMaybe<Boolean_Comparison_Exp>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Timestamp_Comparison_Exp>;
  sap_fecho_comunicado?: InputMaybe<Boolean_Comparison_Exp>;
  sap_horas_comunicado?: InputMaybe<Boolean_Comparison_Exp>;
  sap_material_comunicado?: InputMaybe<Boolean_Comparison_Exp>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Timestamp_Comparison_Exp>;
  sig_atributo_atualizado?: InputMaybe<Boolean_Comparison_Exp>;
  sig_codigo?: InputMaybe<String_Comparison_Exp>;
  sig_enviado?: InputMaybe<Boolean_Comparison_Exp>;
  tarefaEquipasVirtuais?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
  tarefaEquipasVirtuais_aggregate?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate_Bool_Exp>;
  tarefaInfraestruturas?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>;
  tarefaInfraestruturas_aggregate?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Aggregate_Bool_Exp>;
  tempo_estimado?: InputMaybe<Int_Comparison_Exp>;
  timestamp_inicio?: InputMaybe<Numeric_Comparison_Exp>;
  todo_dia?: InputMaybe<Boolean_Comparison_Exp>;
  toponimia?: InputMaybe<Base_Toponimias_Bool_Exp>;
  uuid?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tarefas.tarefas" */
export enum Tarefas_Tarefas_Constraint {
  /** unique or primary key constraint on columns "codigo_unico" */
  CtTarefasTarefasCodigoUnicoUnique = 'ct_tarefas_tarefas_codigo_unico_unique',
  /** unique or primary key constraint on columns "id" */
  TarefasPkey = 'tarefas_pkey',
  /** unique or primary key constraint on columns "sap_codigo" */
  TarefasSapCodigoKey = 'tarefas_sap_codigo_key'
}

/** input type for incrementing numeric columns in table "tarefas.tarefas" */
export type Tarefas_Tarefas_Inc_Input = {
  ca_quantidade_prevista?: InputMaybe<Scalars['numeric']['input']>;
  desbloqueado_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_anterior?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_operador?: InputMaybe<Scalars['bigint']['input']>;
  id_operador_anterior?: InputMaybe<Scalars['bigint']['input']>;
  id_pda?: InputMaybe<Scalars['bigint']['input']>;
  id_periodicidade?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_execucao?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_padrao?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_rota?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  mobile_id_motivo?: InputMaybe<Scalars['Int']['input']>;
  nr_variaveis_registadas?: InputMaybe<Scalars['Int']['input']>;
  nr_variaveis_total?: InputMaybe<Scalars['Int']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
  timestamp_inicio?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "tarefas.tarefas" */
export type Tarefas_Tarefas_Insert_Input = {
  adiada?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  bloqueado_materiais?: InputMaybe<Scalars['Boolean']['input']>;
  ca_fase_programacao?: InputMaybe<Scalars['Boolean']['input']>;
  ca_quantidade_prevista?: InputMaybe<Scalars['numeric']['input']>;
  ca_recolha_automatica?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_unico?: InputMaybe<Scalars['String']['input']>;
  data_executada?: InputMaybe<Scalars['timestamp']['input']>;
  data_executada_anterior?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  data_limite?: InputMaybe<Scalars['timestamp']['input']>;
  data_planeada?: InputMaybe<Scalars['timestamp']['input']>;
  data_registo?: InputMaybe<Scalars['timestamp']['input']>;
  data_registo_anterior?: InputMaybe<Scalars['timestamp']['input']>;
  data_tolerancia?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_anterior?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_operador?: InputMaybe<Scalars['bigint']['input']>;
  id_operador_anterior?: InputMaybe<Scalars['bigint']['input']>;
  id_pda?: InputMaybe<Scalars['bigint']['input']>;
  id_periodicidade?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_execucao?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_padrao?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_rota?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  incompleta?: InputMaybe<Scalars['Boolean']['input']>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
  key_device?: InputMaybe<Scalars['String']['input']>;
  mobile_id_motivo?: InputMaybe<Scalars['Int']['input']>;
  mobile_obs?: InputMaybe<Scalars['String']['input']>;
  nao_planeada?: InputMaybe<Scalars['Boolean']['input']>;
  notificacoes_enviadas?: InputMaybe<Scalars['Boolean']['input']>;
  nr_variaveis_registadas?: InputMaybe<Scalars['Int']['input']>;
  nr_variaveis_total?: InputMaybe<Scalars['Int']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  obs_planeamento?: InputMaybe<Scalars['String']['input']>;
  operador?: InputMaybe<Utilizadores_Utilizadores_Obj_Rel_Insert_Input>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  planoPadrao?: InputMaybe<Tarefas_Planos_Padrao_Obj_Rel_Insert_Input>;
  rastreabilidades?: InputMaybe<Servicos_Rastreabilidade_Arr_Rel_Insert_Input>;
  sap_codigo?: InputMaybe<Scalars['String']['input']>;
  sap_criacao_comunicada?: InputMaybe<Scalars['Boolean']['input']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sap_fecho_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_horas_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sig_atributo_atualizado?: InputMaybe<Scalars['Boolean']['input']>;
  sig_codigo?: InputMaybe<Scalars['String']['input']>;
  sig_enviado?: InputMaybe<Scalars['Boolean']['input']>;
  tarefaEquipasVirtuais?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Arr_Rel_Insert_Input>;
  tarefaInfraestruturas?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Arr_Rel_Insert_Input>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
  timestamp_inicio?: InputMaybe<Scalars['numeric']['input']>;
  todo_dia?: InputMaybe<Scalars['Boolean']['input']>;
  toponimia?: InputMaybe<Base_Toponimias_Obj_Rel_Insert_Input>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Tarefas_Tarefas_Max_Fields = {
  __typename?: 'tarefas_tarefas_max_fields';
  ca_quantidade_prevista?: Maybe<Scalars['numeric']['output']>;
  codigo_unico?: Maybe<Scalars['String']['output']>;
  data_executada?: Maybe<Scalars['timestamp']['output']>;
  data_executada_anterior?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  data_limite?: Maybe<Scalars['timestamp']['output']>;
  data_planeada?: Maybe<Scalars['timestamp']['output']>;
  data_registo?: Maybe<Scalars['timestamp']['output']>;
  data_registo_anterior?: Maybe<Scalars['timestamp']['output']>;
  data_tolerancia?: Maybe<Scalars['timestamp']['output']>;
  desbloqueado_data_hora?: Maybe<Scalars['timestamp']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_anterior?: Maybe<Scalars['bigint']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_operador?: Maybe<Scalars['bigint']['output']>;
  id_operador_anterior?: Maybe<Scalars['bigint']['output']>;
  id_pda?: Maybe<Scalars['bigint']['output']>;
  id_periodicidade?: Maybe<Scalars['bigint']['output']>;
  id_plano_execucao?: Maybe<Scalars['bigint']['output']>;
  id_plano_padrao?: Maybe<Scalars['bigint']['output']>;
  id_prioridade?: Maybe<Scalars['bigint']['output']>;
  id_rota?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  key_device?: Maybe<Scalars['String']['output']>;
  mobile_id_motivo?: Maybe<Scalars['Int']['output']>;
  mobile_obs?: Maybe<Scalars['String']['output']>;
  nr_variaveis_registadas?: Maybe<Scalars['Int']['output']>;
  nr_variaveis_total?: Maybe<Scalars['Int']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  obs_planeamento?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  sap_codigo?: Maybe<Scalars['String']['output']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sig_codigo?: Maybe<Scalars['String']['output']>;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
  timestamp_inicio?: Maybe<Scalars['numeric']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tarefas.tarefas" */
export type Tarefas_Tarefas_Max_Order_By = {
  ca_quantidade_prevista?: InputMaybe<Order_By>;
  codigo_unico?: InputMaybe<Order_By>;
  data_executada?: InputMaybe<Order_By>;
  data_executada_anterior?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  data_limite?: InputMaybe<Order_By>;
  data_planeada?: InputMaybe<Order_By>;
  data_registo?: InputMaybe<Order_By>;
  data_registo_anterior?: InputMaybe<Order_By>;
  data_tolerancia?: InputMaybe<Order_By>;
  desbloqueado_data_hora?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_anterior?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_operador?: InputMaybe<Order_By>;
  id_operador_anterior?: InputMaybe<Order_By>;
  id_pda?: InputMaybe<Order_By>;
  id_periodicidade?: InputMaybe<Order_By>;
  id_plano_execucao?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_rota?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  key_device?: InputMaybe<Order_By>;
  mobile_id_motivo?: InputMaybe<Order_By>;
  mobile_obs?: InputMaybe<Order_By>;
  nr_variaveis_registadas?: InputMaybe<Order_By>;
  nr_variaveis_total?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  obs_planeamento?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  sap_codigo?: InputMaybe<Order_By>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  sig_codigo?: InputMaybe<Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  timestamp_inicio?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tarefas_Tarefas_Min_Fields = {
  __typename?: 'tarefas_tarefas_min_fields';
  ca_quantidade_prevista?: Maybe<Scalars['numeric']['output']>;
  codigo_unico?: Maybe<Scalars['String']['output']>;
  data_executada?: Maybe<Scalars['timestamp']['output']>;
  data_executada_anterior?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  data_limite?: Maybe<Scalars['timestamp']['output']>;
  data_planeada?: Maybe<Scalars['timestamp']['output']>;
  data_registo?: Maybe<Scalars['timestamp']['output']>;
  data_registo_anterior?: Maybe<Scalars['timestamp']['output']>;
  data_tolerancia?: Maybe<Scalars['timestamp']['output']>;
  desbloqueado_data_hora?: Maybe<Scalars['timestamp']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_anterior?: Maybe<Scalars['bigint']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_operador?: Maybe<Scalars['bigint']['output']>;
  id_operador_anterior?: Maybe<Scalars['bigint']['output']>;
  id_pda?: Maybe<Scalars['bigint']['output']>;
  id_periodicidade?: Maybe<Scalars['bigint']['output']>;
  id_plano_execucao?: Maybe<Scalars['bigint']['output']>;
  id_plano_padrao?: Maybe<Scalars['bigint']['output']>;
  id_prioridade?: Maybe<Scalars['bigint']['output']>;
  id_rota?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  key_device?: Maybe<Scalars['String']['output']>;
  mobile_id_motivo?: Maybe<Scalars['Int']['output']>;
  mobile_obs?: Maybe<Scalars['String']['output']>;
  nr_variaveis_registadas?: Maybe<Scalars['Int']['output']>;
  nr_variaveis_total?: Maybe<Scalars['Int']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  obs_planeamento?: Maybe<Scalars['String']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  sap_codigo?: Maybe<Scalars['String']['output']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  sig_codigo?: Maybe<Scalars['String']['output']>;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
  timestamp_inicio?: Maybe<Scalars['numeric']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tarefas.tarefas" */
export type Tarefas_Tarefas_Min_Order_By = {
  ca_quantidade_prevista?: InputMaybe<Order_By>;
  codigo_unico?: InputMaybe<Order_By>;
  data_executada?: InputMaybe<Order_By>;
  data_executada_anterior?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  data_limite?: InputMaybe<Order_By>;
  data_planeada?: InputMaybe<Order_By>;
  data_registo?: InputMaybe<Order_By>;
  data_registo_anterior?: InputMaybe<Order_By>;
  data_tolerancia?: InputMaybe<Order_By>;
  desbloqueado_data_hora?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_anterior?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_operador?: InputMaybe<Order_By>;
  id_operador_anterior?: InputMaybe<Order_By>;
  id_pda?: InputMaybe<Order_By>;
  id_periodicidade?: InputMaybe<Order_By>;
  id_plano_execucao?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_rota?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  key_device?: InputMaybe<Order_By>;
  mobile_id_motivo?: InputMaybe<Order_By>;
  mobile_obs?: InputMaybe<Order_By>;
  nr_variaveis_registadas?: InputMaybe<Order_By>;
  nr_variaveis_total?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  obs_planeamento?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  sap_codigo?: InputMaybe<Order_By>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  sig_codigo?: InputMaybe<Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  timestamp_inicio?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tarefas.tarefas" */
export type Tarefas_Tarefas_Mutation_Response = {
  __typename?: 'tarefas_tarefas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tarefas_Tarefas>;
};

/** input type for inserting object relation for remote table "tarefas.tarefas" */
export type Tarefas_Tarefas_Obj_Rel_Insert_Input = {
  data: Tarefas_Tarefas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tarefas_Tarefas_On_Conflict>;
};

/** on_conflict condition type for table "tarefas.tarefas" */
export type Tarefas_Tarefas_On_Conflict = {
  constraint: Tarefas_Tarefas_Constraint;
  update_columns?: Array<Tarefas_Tarefas_Update_Column>;
  where?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
};

/** Ordering options when selecting data from "tarefas.tarefas". */
export type Tarefas_Tarefas_Order_By = {
  adiada?: InputMaybe<Order_By>;
  apagado?: InputMaybe<Order_By>;
  bloqueado_materiais?: InputMaybe<Order_By>;
  ca_fase_programacao?: InputMaybe<Order_By>;
  ca_quantidade_prevista?: InputMaybe<Order_By>;
  ca_recolha_automatica?: InputMaybe<Order_By>;
  codigo_unico?: InputMaybe<Order_By>;
  data_executada?: InputMaybe<Order_By>;
  data_executada_anterior?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  data_limite?: InputMaybe<Order_By>;
  data_planeada?: InputMaybe<Order_By>;
  data_registo?: InputMaybe<Order_By>;
  data_registo_anterior?: InputMaybe<Order_By>;
  data_tolerancia?: InputMaybe<Order_By>;
  desbloqueado_data_hora?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_anterior?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_operador?: InputMaybe<Order_By>;
  id_operador_anterior?: InputMaybe<Order_By>;
  id_pda?: InputMaybe<Order_By>;
  id_periodicidade?: InputMaybe<Order_By>;
  id_plano_execucao?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_rota?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  incompleta?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
  key_device?: InputMaybe<Order_By>;
  mobile_id_motivo?: InputMaybe<Order_By>;
  mobile_obs?: InputMaybe<Order_By>;
  nao_planeada?: InputMaybe<Order_By>;
  notificacoes_enviadas?: InputMaybe<Order_By>;
  nr_variaveis_registadas?: InputMaybe<Order_By>;
  nr_variaveis_total?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  obs_planeamento?: InputMaybe<Order_By>;
  operador?: InputMaybe<Utilizadores_Utilizadores_Order_By>;
  ordem?: InputMaybe<Order_By>;
  planoPadrao?: InputMaybe<Tarefas_Planos_Padrao_Order_By>;
  rastreabilidades_aggregate?: InputMaybe<Servicos_Rastreabilidade_Aggregate_Order_By>;
  sap_codigo?: InputMaybe<Order_By>;
  sap_criacao_comunicada?: InputMaybe<Order_By>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  sap_fecho_comunicado?: InputMaybe<Order_By>;
  sap_horas_comunicado?: InputMaybe<Order_By>;
  sap_material_comunicado?: InputMaybe<Order_By>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Order_By>;
  sig_atributo_atualizado?: InputMaybe<Order_By>;
  sig_codigo?: InputMaybe<Order_By>;
  sig_enviado?: InputMaybe<Order_By>;
  tarefaEquipasVirtuais_aggregate?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate_Order_By>;
  tarefaInfraestruturas_aggregate?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Aggregate_Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  timestamp_inicio?: InputMaybe<Order_By>;
  todo_dia?: InputMaybe<Order_By>;
  toponimia?: InputMaybe<Base_Toponimias_Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tarefas.tarefas */
export type Tarefas_Tarefas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais';
  /** An object relationship */
  equipaVirtual?: Maybe<Utilizadores_Equipas_Virtuais>;
  id: Scalars['bigint']['output'];
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  tarefa?: Maybe<Tarefas_Tarefas>;
};

/** aggregated selection of "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_aggregate';
  aggregate?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate_Fields>;
  nodes: Array<Tarefas_Tarefas_R_Equipas_Virtuais>;
};

export type Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate_Bool_Exp_Count>;
};

export type Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate_Fields = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_aggregate_fields';
  avg?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Max_Fields>;
  min?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Min_Fields>;
  stddev?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Fields>;
  stddev_pop?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Samp_Fields>;
  sum?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Sum_Fields>;
  var_pop?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Var_Pop_Fields>;
  var_samp?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Var_Samp_Fields>;
  variance?: Maybe<Tarefas_Tarefas_R_Equipas_Virtuais_Variance_Fields>;
};


/** aggregate fields of "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate_Order_By = {
  avg?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Max_Order_By>;
  min?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Min_Order_By>;
  stddev?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Sum_Order_By>;
  var_pop?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Var_Samp_Order_By>;
  variance?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Arr_Rel_Insert_Input = {
  data: Array<Tarefas_Tarefas_R_Equipas_Virtuais_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_On_Conflict>;
};

/** aggregate avg on columns */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Avg_Fields = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tarefas.tarefas_r_equipas_virtuais". All fields are combined with a logical 'AND'. */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp = {
  _and?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>>;
  _not?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
  _or?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual?: InputMaybe<Bigint_Comparison_Exp>;
  id_tarefa?: InputMaybe<Bigint_Comparison_Exp>;
  tarefa?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
};

/** unique or primary key constraints on table "tarefas.tarefas_r_equipas_virtuais" */
export enum Tarefas_Tarefas_R_Equipas_Virtuais_Constraint {
  /** unique or primary key constraint on columns "id" */
  TarefasREquipasVirtuaisPkey = 'tarefas_r_equipas_virtuais_pkey'
}

/** input type for incrementing numeric columns in table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Insert_Input = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  tarefa?: InputMaybe<Tarefas_Tarefas_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Max_Fields = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Min_Fields = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Mutation_Response = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tarefas_Tarefas_R_Equipas_Virtuais>;
};

/** on_conflict condition type for table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_On_Conflict = {
  constraint: Tarefas_Tarefas_R_Equipas_Virtuais_Constraint;
  update_columns?: Array<Tarefas_Tarefas_R_Equipas_Virtuais_Update_Column>;
  where?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
};

/** Ordering options when selecting data from "tarefas.tarefas_r_equipas_virtuais". */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Order_By = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Order_By>;
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  tarefa?: InputMaybe<Tarefas_Tarefas_Order_By>;
};

/** primary key columns input for table: tarefas.tarefas_r_equipas_virtuais */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "tarefas.tarefas_r_equipas_virtuais" */
export enum Tarefas_Tarefas_R_Equipas_Virtuais_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdTarefa = 'id_tarefa'
}

/** input type for updating data in table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Fields = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Pop_Fields = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Samp_Fields = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tarefas_tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tarefas_Tarefas_R_Equipas_Virtuais_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Sum_Fields = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** update columns of table "tarefas.tarefas_r_equipas_virtuais" */
export enum Tarefas_Tarefas_R_Equipas_Virtuais_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdTarefa = 'id_tarefa'
}

export type Tarefas_Tarefas_R_Equipas_Virtuais_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Var_Pop_Fields = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Var_Samp_Fields = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Variance_Fields = {
  __typename?: 'tarefas_tarefas_r_equipas_virtuais_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tarefas.tarefas_r_equipas_virtuais" */
export type Tarefas_Tarefas_R_Equipas_Virtuais_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** columns and relationships of "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas = {
  __typename?: 'tarefas_tarefas_r_infraestruturas';
  id: Scalars['bigint']['output'];
  id_infraestrutura: Scalars['bigint']['output'];
  id_tarefa: Scalars['bigint']['output'];
  /** An object relationship */
  infraestrutura: Base_Infraestruturas;
};

/** aggregated selection of "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Aggregate = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_aggregate';
  aggregate?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Aggregate_Fields>;
  nodes: Array<Tarefas_Tarefas_R_Infraestruturas>;
};

export type Tarefas_Tarefas_R_Infraestruturas_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Aggregate_Bool_Exp_Count>;
};

export type Tarefas_Tarefas_R_Infraestruturas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Aggregate_Fields = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_aggregate_fields';
  avg?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Max_Fields>;
  min?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Min_Fields>;
  stddev?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Stddev_Fields>;
  stddev_pop?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Stddev_Samp_Fields>;
  sum?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Sum_Fields>;
  var_pop?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Var_Pop_Fields>;
  var_samp?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Var_Samp_Fields>;
  variance?: Maybe<Tarefas_Tarefas_R_Infraestruturas_Variance_Fields>;
};


/** aggregate fields of "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Aggregate_Order_By = {
  avg?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Max_Order_By>;
  min?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Min_Order_By>;
  stddev?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Sum_Order_By>;
  var_pop?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Var_Samp_Order_By>;
  variance?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Arr_Rel_Insert_Input = {
  data: Array<Tarefas_Tarefas_R_Infraestruturas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_On_Conflict>;
};

/** aggregate avg on columns */
export type Tarefas_Tarefas_R_Infraestruturas_Avg_Fields = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tarefas.tarefas_r_infraestruturas". All fields are combined with a logical 'AND'. */
export type Tarefas_Tarefas_R_Infraestruturas_Bool_Exp = {
  _and?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>>;
  _not?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>;
  _or?: InputMaybe<Array<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_tarefa?: InputMaybe<Bigint_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
};

/** unique or primary key constraints on table "tarefas.tarefas_r_infraestruturas" */
export enum Tarefas_Tarefas_R_Infraestruturas_Constraint {
  /** unique or primary key constraint on columns "id" */
  TarefasRInfraestruturasPkey = 'tarefas_r_infraestruturas_pkey'
}

/** input type for incrementing numeric columns in table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tarefas_Tarefas_R_Infraestruturas_Max_Fields = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tarefas_Tarefas_R_Infraestruturas_Min_Fields = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Mutation_Response = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tarefas_Tarefas_R_Infraestruturas>;
};

/** on_conflict condition type for table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_On_Conflict = {
  constraint: Tarefas_Tarefas_R_Infraestruturas_Constraint;
  update_columns?: Array<Tarefas_Tarefas_R_Infraestruturas_Update_Column>;
  where?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Bool_Exp>;
};

/** Ordering options when selecting data from "tarefas.tarefas_r_infraestruturas". */
export type Tarefas_Tarefas_R_Infraestruturas_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
};

/** primary key columns input for table: tarefas.tarefas_r_infraestruturas */
export type Tarefas_Tarefas_R_Infraestruturas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "tarefas.tarefas_r_infraestruturas" */
export enum Tarefas_Tarefas_R_Infraestruturas_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdTarefa = 'id_tarefa'
}

/** input type for updating data in table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Tarefas_Tarefas_R_Infraestruturas_Stddev_Fields = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tarefas_Tarefas_R_Infraestruturas_Stddev_Pop_Fields = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tarefas_Tarefas_R_Infraestruturas_Stddev_Samp_Fields = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tarefas_tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tarefas_Tarefas_R_Infraestruturas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tarefas_Tarefas_R_Infraestruturas_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Tarefas_Tarefas_R_Infraestruturas_Sum_Fields = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_tarefa?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** update columns of table "tarefas.tarefas_r_infraestruturas" */
export enum Tarefas_Tarefas_R_Infraestruturas_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdTarefa = 'id_tarefa'
}

export type Tarefas_Tarefas_R_Infraestruturas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tarefas_Tarefas_R_Infraestruturas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tarefas_Tarefas_R_Infraestruturas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tarefas_Tarefas_R_Infraestruturas_Var_Pop_Fields = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tarefas_Tarefas_R_Infraestruturas_Var_Samp_Fields = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tarefas_Tarefas_R_Infraestruturas_Variance_Fields = {
  __typename?: 'tarefas_tarefas_r_infraestruturas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_tarefa?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tarefas.tarefas_r_infraestruturas" */
export type Tarefas_Tarefas_R_Infraestruturas_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_tarefa?: InputMaybe<Order_By>;
};

/** select columns of table "tarefas.tarefas" */
export enum Tarefas_Tarefas_Select_Column {
  /** column name */
  Adiada = 'adiada',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  BloqueadoMateriais = 'bloqueado_materiais',
  /** column name */
  CaFaseProgramacao = 'ca_fase_programacao',
  /** column name */
  CaQuantidadePrevista = 'ca_quantidade_prevista',
  /** column name */
  CaRecolhaAutomatica = 'ca_recolha_automatica',
  /** column name */
  CodigoUnico = 'codigo_unico',
  /** column name */
  DataExecutada = 'data_executada',
  /** column name */
  DataExecutadaAnterior = 'data_executada_anterior',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaModificacao = 'data_hora_ultima_modificacao',
  /** column name */
  DataLimite = 'data_limite',
  /** column name */
  DataPlaneada = 'data_planeada',
  /** column name */
  DataRegisto = 'data_registo',
  /** column name */
  DataRegistoAnterior = 'data_registo_anterior',
  /** column name */
  DataTolerancia = 'data_tolerancia',
  /** column name */
  DesbloqueadoDataHora = 'desbloqueado_data_hora',
  /** column name */
  DesbloqueadoIdUtilizador = 'desbloqueado_id_utilizador',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdAtivo = 'id_ativo',
  /** column name */
  IdEstado = 'id_estado',
  /** column name */
  IdEstadoAnterior = 'id_estado_anterior',
  /** column name */
  IdEstadoValidacao = 'id_estado_validacao',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdOperador = 'id_operador',
  /** column name */
  IdOperadorAnterior = 'id_operador_anterior',
  /** column name */
  IdPda = 'id_pda',
  /** column name */
  IdPeriodicidade = 'id_periodicidade',
  /** column name */
  IdPlanoExecucao = 'id_plano_execucao',
  /** column name */
  IdPlanoPadrao = 'id_plano_padrao',
  /** column name */
  IdPrioridade = 'id_prioridade',
  /** column name */
  IdRota = 'id_rota',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  Incompleta = 'incompleta',
  /** column name */
  KeyDevice = 'key_device',
  /** column name */
  MobileIdMotivo = 'mobile_id_motivo',
  /** column name */
  MobileObs = 'mobile_obs',
  /** column name */
  NaoPlaneada = 'nao_planeada',
  /** column name */
  NotificacoesEnviadas = 'notificacoes_enviadas',
  /** column name */
  NrVariaveisRegistadas = 'nr_variaveis_registadas',
  /** column name */
  NrVariaveisTotal = 'nr_variaveis_total',
  /** column name */
  Obs = 'obs',
  /** column name */
  ObsPlaneamento = 'obs_planeamento',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  SapCodigo = 'sap_codigo',
  /** column name */
  SapCriacaoComunicada = 'sap_criacao_comunicada',
  /** column name */
  SapCriacaoComunicadaDataHoraUltimaAtualizacao = 'sap_criacao_comunicada_data_hora_ultima_atualizacao',
  /** column name */
  SapFechoComunicado = 'sap_fecho_comunicado',
  /** column name */
  SapHorasComunicado = 'sap_horas_comunicado',
  /** column name */
  SapMaterialComunicado = 'sap_material_comunicado',
  /** column name */
  SapMaterialComunicadoDataHoraUltimaAtualizacao = 'sap_material_comunicado_data_hora_ultima_atualizacao',
  /** column name */
  SigAtributoAtualizado = 'sig_atributo_atualizado',
  /** column name */
  SigCodigo = 'sig_codigo',
  /** column name */
  SigEnviado = 'sig_enviado',
  /** column name */
  TempoEstimado = 'tempo_estimado',
  /** column name */
  TimestampInicio = 'timestamp_inicio',
  /** column name */
  TodoDia = 'todo_dia',
  /** column name */
  Uuid = 'uuid'
}

/** select "tarefas_tarefas_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tarefas.tarefas" */
export enum Tarefas_Tarefas_Select_Column_Tarefas_Tarefas_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Adiada = 'adiada',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  BloqueadoMateriais = 'bloqueado_materiais',
  /** column name */
  CaFaseProgramacao = 'ca_fase_programacao',
  /** column name */
  CaRecolhaAutomatica = 'ca_recolha_automatica',
  /** column name */
  Incompleta = 'incompleta',
  /** column name */
  NaoPlaneada = 'nao_planeada',
  /** column name */
  NotificacoesEnviadas = 'notificacoes_enviadas',
  /** column name */
  SapCriacaoComunicada = 'sap_criacao_comunicada',
  /** column name */
  SapFechoComunicado = 'sap_fecho_comunicado',
  /** column name */
  SapHorasComunicado = 'sap_horas_comunicado',
  /** column name */
  SapMaterialComunicado = 'sap_material_comunicado',
  /** column name */
  SigAtributoAtualizado = 'sig_atributo_atualizado',
  /** column name */
  SigEnviado = 'sig_enviado',
  /** column name */
  TodoDia = 'todo_dia'
}

/** select "tarefas_tarefas_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tarefas.tarefas" */
export enum Tarefas_Tarefas_Select_Column_Tarefas_Tarefas_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Adiada = 'adiada',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  BloqueadoMateriais = 'bloqueado_materiais',
  /** column name */
  CaFaseProgramacao = 'ca_fase_programacao',
  /** column name */
  CaRecolhaAutomatica = 'ca_recolha_automatica',
  /** column name */
  Incompleta = 'incompleta',
  /** column name */
  NaoPlaneada = 'nao_planeada',
  /** column name */
  NotificacoesEnviadas = 'notificacoes_enviadas',
  /** column name */
  SapCriacaoComunicada = 'sap_criacao_comunicada',
  /** column name */
  SapFechoComunicado = 'sap_fecho_comunicado',
  /** column name */
  SapHorasComunicado = 'sap_horas_comunicado',
  /** column name */
  SapMaterialComunicado = 'sap_material_comunicado',
  /** column name */
  SigAtributoAtualizado = 'sig_atributo_atualizado',
  /** column name */
  SigEnviado = 'sig_enviado',
  /** column name */
  TodoDia = 'todo_dia'
}

/** input type for updating data in table "tarefas.tarefas" */
export type Tarefas_Tarefas_Set_Input = {
  adiada?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  bloqueado_materiais?: InputMaybe<Scalars['Boolean']['input']>;
  ca_fase_programacao?: InputMaybe<Scalars['Boolean']['input']>;
  ca_quantidade_prevista?: InputMaybe<Scalars['numeric']['input']>;
  ca_recolha_automatica?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_unico?: InputMaybe<Scalars['String']['input']>;
  data_executada?: InputMaybe<Scalars['timestamp']['input']>;
  data_executada_anterior?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  data_limite?: InputMaybe<Scalars['timestamp']['input']>;
  data_planeada?: InputMaybe<Scalars['timestamp']['input']>;
  data_registo?: InputMaybe<Scalars['timestamp']['input']>;
  data_registo_anterior?: InputMaybe<Scalars['timestamp']['input']>;
  data_tolerancia?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_anterior?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_operador?: InputMaybe<Scalars['bigint']['input']>;
  id_operador_anterior?: InputMaybe<Scalars['bigint']['input']>;
  id_pda?: InputMaybe<Scalars['bigint']['input']>;
  id_periodicidade?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_execucao?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_padrao?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_rota?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  incompleta?: InputMaybe<Scalars['Boolean']['input']>;
  key_device?: InputMaybe<Scalars['String']['input']>;
  mobile_id_motivo?: InputMaybe<Scalars['Int']['input']>;
  mobile_obs?: InputMaybe<Scalars['String']['input']>;
  nao_planeada?: InputMaybe<Scalars['Boolean']['input']>;
  notificacoes_enviadas?: InputMaybe<Scalars['Boolean']['input']>;
  nr_variaveis_registadas?: InputMaybe<Scalars['Int']['input']>;
  nr_variaveis_total?: InputMaybe<Scalars['Int']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  obs_planeamento?: InputMaybe<Scalars['String']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  sap_codigo?: InputMaybe<Scalars['String']['input']>;
  sap_criacao_comunicada?: InputMaybe<Scalars['Boolean']['input']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sap_fecho_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_horas_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sig_atributo_atualizado?: InputMaybe<Scalars['Boolean']['input']>;
  sig_codigo?: InputMaybe<Scalars['String']['input']>;
  sig_enviado?: InputMaybe<Scalars['Boolean']['input']>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
  timestamp_inicio?: InputMaybe<Scalars['numeric']['input']>;
  todo_dia?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Tarefas_Tarefas_Stddev_Fields = {
  __typename?: 'tarefas_tarefas_stddev_fields';
  ca_quantidade_prevista?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_anterior?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_operador?: Maybe<Scalars['Float']['output']>;
  id_operador_anterior?: Maybe<Scalars['Float']['output']>;
  id_pda?: Maybe<Scalars['Float']['output']>;
  id_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_plano_execucao?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_rota?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  mobile_id_motivo?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_registadas?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_total?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
  timestamp_inicio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tarefas.tarefas" */
export type Tarefas_Tarefas_Stddev_Order_By = {
  ca_quantidade_prevista?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_anterior?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_operador?: InputMaybe<Order_By>;
  id_operador_anterior?: InputMaybe<Order_By>;
  id_pda?: InputMaybe<Order_By>;
  id_periodicidade?: InputMaybe<Order_By>;
  id_plano_execucao?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_rota?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  mobile_id_motivo?: InputMaybe<Order_By>;
  nr_variaveis_registadas?: InputMaybe<Order_By>;
  nr_variaveis_total?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  timestamp_inicio?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tarefas_Tarefas_Stddev_Pop_Fields = {
  __typename?: 'tarefas_tarefas_stddev_pop_fields';
  ca_quantidade_prevista?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_anterior?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_operador?: Maybe<Scalars['Float']['output']>;
  id_operador_anterior?: Maybe<Scalars['Float']['output']>;
  id_pda?: Maybe<Scalars['Float']['output']>;
  id_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_plano_execucao?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_rota?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  mobile_id_motivo?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_registadas?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_total?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
  timestamp_inicio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tarefas.tarefas" */
export type Tarefas_Tarefas_Stddev_Pop_Order_By = {
  ca_quantidade_prevista?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_anterior?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_operador?: InputMaybe<Order_By>;
  id_operador_anterior?: InputMaybe<Order_By>;
  id_pda?: InputMaybe<Order_By>;
  id_periodicidade?: InputMaybe<Order_By>;
  id_plano_execucao?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_rota?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  mobile_id_motivo?: InputMaybe<Order_By>;
  nr_variaveis_registadas?: InputMaybe<Order_By>;
  nr_variaveis_total?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  timestamp_inicio?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tarefas_Tarefas_Stddev_Samp_Fields = {
  __typename?: 'tarefas_tarefas_stddev_samp_fields';
  ca_quantidade_prevista?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_anterior?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_operador?: Maybe<Scalars['Float']['output']>;
  id_operador_anterior?: Maybe<Scalars['Float']['output']>;
  id_pda?: Maybe<Scalars['Float']['output']>;
  id_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_plano_execucao?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_rota?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  mobile_id_motivo?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_registadas?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_total?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
  timestamp_inicio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tarefas.tarefas" */
export type Tarefas_Tarefas_Stddev_Samp_Order_By = {
  ca_quantidade_prevista?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_anterior?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_operador?: InputMaybe<Order_By>;
  id_operador_anterior?: InputMaybe<Order_By>;
  id_pda?: InputMaybe<Order_By>;
  id_periodicidade?: InputMaybe<Order_By>;
  id_plano_execucao?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_rota?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  mobile_id_motivo?: InputMaybe<Order_By>;
  nr_variaveis_registadas?: InputMaybe<Order_By>;
  nr_variaveis_total?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  timestamp_inicio?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tarefas_tarefas" */
export type Tarefas_Tarefas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tarefas_Tarefas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tarefas_Tarefas_Stream_Cursor_Value_Input = {
  adiada?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  bloqueado_materiais?: InputMaybe<Scalars['Boolean']['input']>;
  ca_fase_programacao?: InputMaybe<Scalars['Boolean']['input']>;
  ca_quantidade_prevista?: InputMaybe<Scalars['numeric']['input']>;
  ca_recolha_automatica?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_unico?: InputMaybe<Scalars['String']['input']>;
  data_executada?: InputMaybe<Scalars['timestamp']['input']>;
  data_executada_anterior?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  data_limite?: InputMaybe<Scalars['timestamp']['input']>;
  data_planeada?: InputMaybe<Scalars['timestamp']['input']>;
  data_registo?: InputMaybe<Scalars['timestamp']['input']>;
  data_registo_anterior?: InputMaybe<Scalars['timestamp']['input']>;
  data_tolerancia?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  desbloqueado_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_estado?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_anterior?: InputMaybe<Scalars['bigint']['input']>;
  id_estado_validacao?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_operador?: InputMaybe<Scalars['bigint']['input']>;
  id_operador_anterior?: InputMaybe<Scalars['bigint']['input']>;
  id_pda?: InputMaybe<Scalars['bigint']['input']>;
  id_periodicidade?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_execucao?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_padrao?: InputMaybe<Scalars['bigint']['input']>;
  id_prioridade?: InputMaybe<Scalars['bigint']['input']>;
  id_rota?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  incompleta?: InputMaybe<Scalars['Boolean']['input']>;
  key_device?: InputMaybe<Scalars['String']['input']>;
  mobile_id_motivo?: InputMaybe<Scalars['Int']['input']>;
  mobile_obs?: InputMaybe<Scalars['String']['input']>;
  nao_planeada?: InputMaybe<Scalars['Boolean']['input']>;
  notificacoes_enviadas?: InputMaybe<Scalars['Boolean']['input']>;
  nr_variaveis_registadas?: InputMaybe<Scalars['Int']['input']>;
  nr_variaveis_total?: InputMaybe<Scalars['Int']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  obs_planeamento?: InputMaybe<Scalars['String']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  sap_codigo?: InputMaybe<Scalars['String']['input']>;
  sap_criacao_comunicada?: InputMaybe<Scalars['Boolean']['input']>;
  sap_criacao_comunicada_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sap_fecho_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_horas_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado?: InputMaybe<Scalars['Boolean']['input']>;
  sap_material_comunicado_data_hora_ultima_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  sig_atributo_atualizado?: InputMaybe<Scalars['Boolean']['input']>;
  sig_codigo?: InputMaybe<Scalars['String']['input']>;
  sig_enviado?: InputMaybe<Scalars['Boolean']['input']>;
  tempo_estimado?: InputMaybe<Scalars['Int']['input']>;
  timestamp_inicio?: InputMaybe<Scalars['numeric']['input']>;
  todo_dia?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Tarefas_Tarefas_Sum_Fields = {
  __typename?: 'tarefas_tarefas_sum_fields';
  ca_quantidade_prevista?: Maybe<Scalars['numeric']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_estado?: Maybe<Scalars['bigint']['output']>;
  id_estado_anterior?: Maybe<Scalars['bigint']['output']>;
  id_estado_validacao?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_operador?: Maybe<Scalars['bigint']['output']>;
  id_operador_anterior?: Maybe<Scalars['bigint']['output']>;
  id_pda?: Maybe<Scalars['bigint']['output']>;
  id_periodicidade?: Maybe<Scalars['bigint']['output']>;
  id_plano_execucao?: Maybe<Scalars['bigint']['output']>;
  id_plano_padrao?: Maybe<Scalars['bigint']['output']>;
  id_prioridade?: Maybe<Scalars['bigint']['output']>;
  id_rota?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  mobile_id_motivo?: Maybe<Scalars['Int']['output']>;
  nr_variaveis_registadas?: Maybe<Scalars['Int']['output']>;
  nr_variaveis_total?: Maybe<Scalars['Int']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  tempo_estimado?: Maybe<Scalars['Int']['output']>;
  timestamp_inicio?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "tarefas.tarefas" */
export type Tarefas_Tarefas_Sum_Order_By = {
  ca_quantidade_prevista?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_anterior?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_operador?: InputMaybe<Order_By>;
  id_operador_anterior?: InputMaybe<Order_By>;
  id_pda?: InputMaybe<Order_By>;
  id_periodicidade?: InputMaybe<Order_By>;
  id_plano_execucao?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_rota?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  mobile_id_motivo?: InputMaybe<Order_By>;
  nr_variaveis_registadas?: InputMaybe<Order_By>;
  nr_variaveis_total?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  timestamp_inicio?: InputMaybe<Order_By>;
};

/** update columns of table "tarefas.tarefas" */
export enum Tarefas_Tarefas_Update_Column {
  /** column name */
  Adiada = 'adiada',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  BloqueadoMateriais = 'bloqueado_materiais',
  /** column name */
  CaFaseProgramacao = 'ca_fase_programacao',
  /** column name */
  CaQuantidadePrevista = 'ca_quantidade_prevista',
  /** column name */
  CaRecolhaAutomatica = 'ca_recolha_automatica',
  /** column name */
  CodigoUnico = 'codigo_unico',
  /** column name */
  DataExecutada = 'data_executada',
  /** column name */
  DataExecutadaAnterior = 'data_executada_anterior',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaModificacao = 'data_hora_ultima_modificacao',
  /** column name */
  DataLimite = 'data_limite',
  /** column name */
  DataPlaneada = 'data_planeada',
  /** column name */
  DataRegisto = 'data_registo',
  /** column name */
  DataRegistoAnterior = 'data_registo_anterior',
  /** column name */
  DataTolerancia = 'data_tolerancia',
  /** column name */
  DesbloqueadoDataHora = 'desbloqueado_data_hora',
  /** column name */
  DesbloqueadoIdUtilizador = 'desbloqueado_id_utilizador',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdAtivo = 'id_ativo',
  /** column name */
  IdEstado = 'id_estado',
  /** column name */
  IdEstadoAnterior = 'id_estado_anterior',
  /** column name */
  IdEstadoValidacao = 'id_estado_validacao',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdOperador = 'id_operador',
  /** column name */
  IdOperadorAnterior = 'id_operador_anterior',
  /** column name */
  IdPda = 'id_pda',
  /** column name */
  IdPeriodicidade = 'id_periodicidade',
  /** column name */
  IdPlanoExecucao = 'id_plano_execucao',
  /** column name */
  IdPlanoPadrao = 'id_plano_padrao',
  /** column name */
  IdPrioridade = 'id_prioridade',
  /** column name */
  IdRota = 'id_rota',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  Incompleta = 'incompleta',
  /** column name */
  KeyDevice = 'key_device',
  /** column name */
  MobileIdMotivo = 'mobile_id_motivo',
  /** column name */
  MobileObs = 'mobile_obs',
  /** column name */
  NaoPlaneada = 'nao_planeada',
  /** column name */
  NotificacoesEnviadas = 'notificacoes_enviadas',
  /** column name */
  NrVariaveisRegistadas = 'nr_variaveis_registadas',
  /** column name */
  NrVariaveisTotal = 'nr_variaveis_total',
  /** column name */
  Obs = 'obs',
  /** column name */
  ObsPlaneamento = 'obs_planeamento',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  SapCodigo = 'sap_codigo',
  /** column name */
  SapCriacaoComunicada = 'sap_criacao_comunicada',
  /** column name */
  SapCriacaoComunicadaDataHoraUltimaAtualizacao = 'sap_criacao_comunicada_data_hora_ultima_atualizacao',
  /** column name */
  SapFechoComunicado = 'sap_fecho_comunicado',
  /** column name */
  SapHorasComunicado = 'sap_horas_comunicado',
  /** column name */
  SapMaterialComunicado = 'sap_material_comunicado',
  /** column name */
  SapMaterialComunicadoDataHoraUltimaAtualizacao = 'sap_material_comunicado_data_hora_ultima_atualizacao',
  /** column name */
  SigAtributoAtualizado = 'sig_atributo_atualizado',
  /** column name */
  SigCodigo = 'sig_codigo',
  /** column name */
  SigEnviado = 'sig_enviado',
  /** column name */
  TempoEstimado = 'tempo_estimado',
  /** column name */
  TimestampInicio = 'timestamp_inicio',
  /** column name */
  TodoDia = 'todo_dia',
  /** column name */
  Uuid = 'uuid'
}

export type Tarefas_Tarefas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tarefas_Tarefas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tarefas_Tarefas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tarefas_Tarefas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tarefas_Tarefas_Var_Pop_Fields = {
  __typename?: 'tarefas_tarefas_var_pop_fields';
  ca_quantidade_prevista?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_anterior?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_operador?: Maybe<Scalars['Float']['output']>;
  id_operador_anterior?: Maybe<Scalars['Float']['output']>;
  id_pda?: Maybe<Scalars['Float']['output']>;
  id_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_plano_execucao?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_rota?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  mobile_id_motivo?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_registadas?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_total?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
  timestamp_inicio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tarefas.tarefas" */
export type Tarefas_Tarefas_Var_Pop_Order_By = {
  ca_quantidade_prevista?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_anterior?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_operador?: InputMaybe<Order_By>;
  id_operador_anterior?: InputMaybe<Order_By>;
  id_pda?: InputMaybe<Order_By>;
  id_periodicidade?: InputMaybe<Order_By>;
  id_plano_execucao?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_rota?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  mobile_id_motivo?: InputMaybe<Order_By>;
  nr_variaveis_registadas?: InputMaybe<Order_By>;
  nr_variaveis_total?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  timestamp_inicio?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tarefas_Tarefas_Var_Samp_Fields = {
  __typename?: 'tarefas_tarefas_var_samp_fields';
  ca_quantidade_prevista?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_anterior?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_operador?: Maybe<Scalars['Float']['output']>;
  id_operador_anterior?: Maybe<Scalars['Float']['output']>;
  id_pda?: Maybe<Scalars['Float']['output']>;
  id_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_plano_execucao?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_rota?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  mobile_id_motivo?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_registadas?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_total?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
  timestamp_inicio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tarefas.tarefas" */
export type Tarefas_Tarefas_Var_Samp_Order_By = {
  ca_quantidade_prevista?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_anterior?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_operador?: InputMaybe<Order_By>;
  id_operador_anterior?: InputMaybe<Order_By>;
  id_pda?: InputMaybe<Order_By>;
  id_periodicidade?: InputMaybe<Order_By>;
  id_plano_execucao?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_rota?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  mobile_id_motivo?: InputMaybe<Order_By>;
  nr_variaveis_registadas?: InputMaybe<Order_By>;
  nr_variaveis_total?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  timestamp_inicio?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tarefas_Tarefas_Variance_Fields = {
  __typename?: 'tarefas_tarefas_variance_fields';
  ca_quantidade_prevista?: Maybe<Scalars['Float']['output']>;
  desbloqueado_id_utilizador?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_estado?: Maybe<Scalars['Float']['output']>;
  id_estado_anterior?: Maybe<Scalars['Float']['output']>;
  id_estado_validacao?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_operador?: Maybe<Scalars['Float']['output']>;
  id_operador_anterior?: Maybe<Scalars['Float']['output']>;
  id_pda?: Maybe<Scalars['Float']['output']>;
  id_periodicidade?: Maybe<Scalars['Float']['output']>;
  id_plano_execucao?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
  id_prioridade?: Maybe<Scalars['Float']['output']>;
  id_rota?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  mobile_id_motivo?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_registadas?: Maybe<Scalars['Float']['output']>;
  nr_variaveis_total?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
  tempo_estimado?: Maybe<Scalars['Float']['output']>;
  timestamp_inicio?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tarefas.tarefas" */
export type Tarefas_Tarefas_Variance_Order_By = {
  ca_quantidade_prevista?: InputMaybe<Order_By>;
  desbloqueado_id_utilizador?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_estado?: InputMaybe<Order_By>;
  id_estado_anterior?: InputMaybe<Order_By>;
  id_estado_validacao?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_operador?: InputMaybe<Order_By>;
  id_operador_anterior?: InputMaybe<Order_By>;
  id_pda?: InputMaybe<Order_By>;
  id_periodicidade?: InputMaybe<Order_By>;
  id_plano_execucao?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
  id_prioridade?: InputMaybe<Order_By>;
  id_rota?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  mobile_id_motivo?: InputMaybe<Order_By>;
  nr_variaveis_registadas?: InputMaybe<Order_By>;
  nr_variaveis_total?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  tempo_estimado?: InputMaybe<Order_By>;
  timestamp_inicio?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** top_5_pipes_with_most_leaksNative Query Arguments */
export type Top_5_Pipes_With_Most_Leaks_Arguments = {
  endDate: Scalars['timestamptz']['input'];
  startDate: Scalars['timestamptz']['input'];
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

export type Top_5_Pipes_With_Most_Leaks_Model = {
  __typename?: 'top_5_pipes_with_most_leaks_model';
  descricao?: Maybe<Scalars['String']['output']>;
  i_codigo_externo?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  interv_count: Scalars['bigint']['output'];
  sig_atributo_id?: Maybe<Scalars['String']['output']>;
  t_codigo_externo?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the logical model for "top_5_pipes_with_most_leaks_model". All fields are combined with a logical 'AND'. */
export type Top_5_Pipes_With_Most_Leaks_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Top_5_Pipes_With_Most_Leaks_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Top_5_Pipes_With_Most_Leaks_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Top_5_Pipes_With_Most_Leaks_Model_Bool_Exp_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  i_codigo_externo?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  interv_count?: InputMaybe<Bigint_Comparison_Exp>;
  sig_atributo_id?: InputMaybe<String_Comparison_Exp>;
  t_codigo_externo?: InputMaybe<String_Comparison_Exp>;
};

export enum Top_5_Pipes_With_Most_Leaks_Model_Enum_Name {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  ICodigoExterno = 'i_codigo_externo',
  /** column name */
  Id = 'id',
  /** column name */
  IntervCount = 'interv_count',
  /** column name */
  SigAtributoId = 'sig_atributo_id',
  /** column name */
  TCodigoExterno = 't_codigo_externo'
}

/** Ordering options when selecting data from "top_5_pipes_with_most_leaks_model". */
export type Top_5_Pipes_With_Most_Leaks_Model_Order_By = {
  descricao?: InputMaybe<Order_By>;
  i_codigo_externo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interv_count?: InputMaybe<Order_By>;
  sig_atributo_id?: InputMaybe<Order_By>;
  t_codigo_externo?: InputMaybe<Order_By>;
};

/** top_five_average_duration_by_symptomNative Query Arguments */
export type Top_Five_Average_Duration_By_Symptom_Arguments = {
  first_day_of_year: Scalars['date']['input'];
  id_user: Scalars['Int']['input'];
  last_day_of_year: Scalars['date']['input'];
};

export type Top_Five_Average_Duration_By_Symptom_Return = {
  __typename?: 'top_five_average_duration_by_symptom_return';
  average_time_in_seconds?: Maybe<Scalars['numeric']['output']>;
  id_frequency_time_limit_response?: Maybe<Scalars['bigint']['output']>;
  id_symptom?: Maybe<Scalars['bigint']['output']>;
  symptom?: Maybe<Scalars['String']['output']>;
  time_limit_response?: Maybe<Scalars['bigint']['output']>;
  time_limit_seconds?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the logical model for "top_five_average_duration_by_symptom_return". All fields are combined with a logical 'AND'. */
export type Top_Five_Average_Duration_By_Symptom_Return_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Top_Five_Average_Duration_By_Symptom_Return_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Top_Five_Average_Duration_By_Symptom_Return_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Top_Five_Average_Duration_By_Symptom_Return_Bool_Exp_Bool_Exp>>;
  average_time_in_seconds?: InputMaybe<Numeric_Comparison_Exp>;
  id_frequency_time_limit_response?: InputMaybe<Bigint_Comparison_Exp>;
  id_symptom?: InputMaybe<Bigint_Comparison_Exp>;
  symptom?: InputMaybe<String_Comparison_Exp>;
  time_limit_response?: InputMaybe<Bigint_Comparison_Exp>;
  time_limit_seconds?: InputMaybe<Bigint_Comparison_Exp>;
};

export enum Top_Five_Average_Duration_By_Symptom_Return_Enum_Name {
  /** column name */
  AverageTimeInSeconds = 'average_time_in_seconds',
  /** column name */
  IdFrequencyTimeLimitResponse = 'id_frequency_time_limit_response',
  /** column name */
  IdSymptom = 'id_symptom',
  /** column name */
  Symptom = 'symptom',
  /** column name */
  TimeLimitResponse = 'time_limit_response',
  /** column name */
  TimeLimitSeconds = 'time_limit_seconds'
}

/** Ordering options when selecting data from "top_five_average_duration_by_symptom_return". */
export type Top_Five_Average_Duration_By_Symptom_Return_Order_By = {
  average_time_in_seconds?: InputMaybe<Order_By>;
  id_frequency_time_limit_response?: InputMaybe<Order_By>;
  id_symptom?: InputMaybe<Order_By>;
  symptom?: InputMaybe<Order_By>;
  time_limit_response?: InputMaybe<Order_By>;
  time_limit_seconds?: InputMaybe<Order_By>;
};

/** top_five_average_duration_by_symptom_without_loginNative Query Arguments */
export type Top_Five_Average_Duration_By_Symptom_Without_Login_Arguments = {
  first_day_of_year: Scalars['date']['input'];
  last_day_of_year: Scalars['date']['input'];
};

/** user_agendaNative Query Arguments */
export type User_Agenda_Arguments = {
  endDate: Scalars['timestamp']['input'];
  userId: Scalars['bigint']['input'];
};

export type User_Agenda_Model = {
  __typename?: 'user_agenda_model';
  data_planeada?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  local?: Maybe<Scalars['String']['output']>;
  numero?: Maybe<Scalars['String']['output']>;
  sintoma?: Maybe<Scalars['String']['output']>;
  tipo?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the logical model for "user_agenda_model". All fields are combined with a logical 'AND'. */
export type User_Agenda_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<User_Agenda_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<User_Agenda_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<User_Agenda_Model_Bool_Exp_Bool_Exp>>;
  data_planeada?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  local?: InputMaybe<String_Comparison_Exp>;
  numero?: InputMaybe<String_Comparison_Exp>;
  sintoma?: InputMaybe<String_Comparison_Exp>;
  tipo?: InputMaybe<String_Comparison_Exp>;
};

export enum User_Agenda_Model_Enum_Name {
  /** column name */
  DataPlaneada = 'data_planeada',
  /** column name */
  Id = 'id',
  /** column name */
  Local = 'local',
  /** column name */
  Numero = 'numero',
  /** column name */
  Sintoma = 'sintoma',
  /** column name */
  Tipo = 'tipo'
}

/** Ordering options when selecting data from "user_agenda_model". */
export type User_Agenda_Model_Order_By = {
  data_planeada?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  local?: InputMaybe<Order_By>;
  numero?: InputMaybe<Order_By>;
  sintoma?: InputMaybe<Order_By>;
  tipo?: InputMaybe<Order_By>;
};

/** columns and relationships of "utilizadores.categorias" */
export type Utilizadores_Categorias = {
  __typename?: 'utilizadores_categorias';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "utilizadores.categorias" */
export type Utilizadores_Categorias_Aggregate = {
  __typename?: 'utilizadores_categorias_aggregate';
  aggregate?: Maybe<Utilizadores_Categorias_Aggregate_Fields>;
  nodes: Array<Utilizadores_Categorias>;
};

/** aggregate fields of "utilizadores.categorias" */
export type Utilizadores_Categorias_Aggregate_Fields = {
  __typename?: 'utilizadores_categorias_aggregate_fields';
  avg?: Maybe<Utilizadores_Categorias_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Categorias_Max_Fields>;
  min?: Maybe<Utilizadores_Categorias_Min_Fields>;
  stddev?: Maybe<Utilizadores_Categorias_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Categorias_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Categorias_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Categorias_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Categorias_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Categorias_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Categorias_Variance_Fields>;
};


/** aggregate fields of "utilizadores.categorias" */
export type Utilizadores_Categorias_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Categorias_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Utilizadores_Categorias_Avg_Fields = {
  __typename?: 'utilizadores_categorias_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "utilizadores.categorias". All fields are combined with a logical 'AND'. */
export type Utilizadores_Categorias_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Categorias_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Categorias_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Categorias_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "utilizadores.categorias" */
export enum Utilizadores_Categorias_Constraint {
  /** unique or primary key constraint on columns "id" */
  CategoriasPkey = 'categorias_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.categorias" */
export type Utilizadores_Categorias_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "utilizadores.categorias" */
export type Utilizadores_Categorias_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Utilizadores_Categorias_Max_Fields = {
  __typename?: 'utilizadores_categorias_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Utilizadores_Categorias_Min_Fields = {
  __typename?: 'utilizadores_categorias_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "utilizadores.categorias" */
export type Utilizadores_Categorias_Mutation_Response = {
  __typename?: 'utilizadores_categorias_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Categorias>;
};

/** on_conflict condition type for table "utilizadores.categorias" */
export type Utilizadores_Categorias_On_Conflict = {
  constraint: Utilizadores_Categorias_Constraint;
  update_columns?: Array<Utilizadores_Categorias_Update_Column>;
  where?: InputMaybe<Utilizadores_Categorias_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.categorias". */
export type Utilizadores_Categorias_Order_By = {
  apagado?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utilizadores.categorias */
export type Utilizadores_Categorias_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.categorias" */
export enum Utilizadores_Categorias_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "utilizadores.categorias" */
export type Utilizadores_Categorias_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Categorias_Stddev_Fields = {
  __typename?: 'utilizadores_categorias_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Categorias_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_categorias_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Categorias_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_categorias_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "utilizadores_categorias" */
export type Utilizadores_Categorias_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Categorias_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Categorias_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Categorias_Sum_Fields = {
  __typename?: 'utilizadores_categorias_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "utilizadores.categorias" */
export enum Utilizadores_Categorias_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Utilizadores_Categorias_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Categorias_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Categorias_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Categorias_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Categorias_Var_Pop_Fields = {
  __typename?: 'utilizadores_categorias_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Categorias_Var_Samp_Fields = {
  __typename?: 'utilizadores_categorias_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Utilizadores_Categorias_Variance_Fields = {
  __typename?: 'utilizadores_categorias_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais = {
  __typename?: 'utilizadores_equipas_virtuais';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  equipa_sos?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  equipasVirtuaisEquipasVirtuais: Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais>;
  /** An aggregate relationship */
  equipasVirtuaisEquipasVirtuais_aggregate: Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate;
  /** An array relationship */
  equipasVirtuaisTarefas: Array<Tarefas_Tarefas_R_Equipas_Virtuais>;
  /** An aggregate relationship */
  equipasVirtuaisTarefas_aggregate: Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate;
  /** An array relationship */
  equipasVirtuaisTransacoes: Array<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** An aggregate relationship */
  equipasVirtuaisTransacoes_aggregate: Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate;
  /** An array relationship */
  equipasVirtuaisUtilizadores: Array<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  /** An aggregate relationship */
  equipasVirtuaisUtilizadores_aggregate: Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate;
  id: Scalars['bigint']['output'];
  id_perfil?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_VirtuaisEquipasVirtuaisEquipasVirtuaisArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>;
};


/** columns and relationships of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_VirtuaisEquipasVirtuaisEquipasVirtuais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>;
};


/** columns and relationships of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_VirtuaisEquipasVirtuaisTarefasArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
};


/** columns and relationships of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_VirtuaisEquipasVirtuaisTarefas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tarefas_Tarefas_R_Equipas_Virtuais_Order_By>>;
  where?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
};


/** columns and relationships of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_VirtuaisEquipasVirtuaisTransacoesArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};


/** columns and relationships of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_VirtuaisEquipasVirtuaisTransacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};


/** columns and relationships of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_VirtuaisEquipasVirtuaisUtilizadoresArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
};


/** columns and relationships of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_VirtuaisEquipasVirtuaisUtilizadores_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
};

/** aggregated selection of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_Aggregate = {
  __typename?: 'utilizadores_equipas_virtuais_aggregate';
  aggregate?: Maybe<Utilizadores_Equipas_Virtuais_Aggregate_Fields>;
  nodes: Array<Utilizadores_Equipas_Virtuais>;
};

/** aggregate fields of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_Aggregate_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_aggregate_fields';
  avg?: Maybe<Utilizadores_Equipas_Virtuais_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Equipas_Virtuais_Max_Fields>;
  min?: Maybe<Utilizadores_Equipas_Virtuais_Min_Fields>;
  stddev?: Maybe<Utilizadores_Equipas_Virtuais_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Equipas_Virtuais_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Equipas_Virtuais_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Equipas_Virtuais_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Equipas_Virtuais_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Equipas_Virtuais_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Equipas_Virtuais_Variance_Fields>;
};


/** aggregate fields of "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Utilizadores_Equipas_Virtuais_Avg_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_perfil?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "utilizadores.equipas_virtuais". All fields are combined with a logical 'AND'. */
export type Utilizadores_Equipas_Virtuais_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  cor?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  descricao_curta?: InputMaybe<String_Comparison_Exp>;
  equipa_sos?: InputMaybe<Boolean_Comparison_Exp>;
  equipasVirtuaisEquipasVirtuais?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>;
  equipasVirtuaisEquipasVirtuais_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate_Bool_Exp>;
  equipasVirtuaisTarefas?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Bool_Exp>;
  equipasVirtuaisTarefas_aggregate?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate_Bool_Exp>;
  equipasVirtuaisTransacoes?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
  equipasVirtuaisTransacoes_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Bool_Exp>;
  equipasVirtuaisUtilizadores?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
  equipasVirtuaisUtilizadores_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_perfil?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "utilizadores.equipas_virtuais" */
export enum Utilizadores_Equipas_Virtuais_Constraint {
  /** unique or primary key constraint on columns "id" */
  EquipasVirtuaisPkey = 'equipas_virtuais_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_perfil?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  equipa_sos?: InputMaybe<Scalars['Boolean']['input']>;
  equipasVirtuaisEquipasVirtuais?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Arr_Rel_Insert_Input>;
  equipasVirtuaisTarefas?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Arr_Rel_Insert_Input>;
  equipasVirtuaisTransacoes?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Arr_Rel_Insert_Input>;
  equipasVirtuaisUtilizadores?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_perfil?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Utilizadores_Equipas_Virtuais_Max_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_max_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_perfil?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Utilizadores_Equipas_Virtuais_Min_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_min_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  cor?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_perfil?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_Mutation_Response = {
  __typename?: 'utilizadores_equipas_virtuais_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Equipas_Virtuais>;
};

/** input type for inserting object relation for remote table "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_Obj_Rel_Insert_Input = {
  data: Utilizadores_Equipas_Virtuais_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_On_Conflict>;
};

/** on_conflict condition type for table "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_On_Conflict = {
  constraint: Utilizadores_Equipas_Virtuais_Constraint;
  update_columns?: Array<Utilizadores_Equipas_Virtuais_Update_Column>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.equipas_virtuais". */
export type Utilizadores_Equipas_Virtuais_Order_By = {
  apagado?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  cor?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  equipa_sos?: InputMaybe<Order_By>;
  equipasVirtuaisEquipasVirtuais_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate_Order_By>;
  equipasVirtuaisTarefas_aggregate?: InputMaybe<Tarefas_Tarefas_R_Equipas_Virtuais_Aggregate_Order_By>;
  equipasVirtuaisTransacoes_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Order_By>;
  equipasVirtuaisUtilizadores_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  id_perfil?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utilizadores.equipas_virtuais */
export type Utilizadores_Equipas_Virtuais_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros';
  /** An object relationship */
  centro: Base_Centros;
  /** An object relationship */
  equipaVirtual: Utilizadores_Equipas_Virtuais;
  id: Scalars['bigint']['output'];
  id_centro: Scalars['bigint']['output'];
  id_equipa_virtual: Scalars['bigint']['output'];
};

/** aggregated selection of "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Aggregate = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_aggregate';
  aggregate?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Aggregate_Fields>;
  nodes: Array<Utilizadores_Equipas_Virtuais_R_Centros>;
};

export type Utilizadores_Equipas_Virtuais_R_Centros_Aggregate_Bool_Exp = {
  count?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Aggregate_Bool_Exp_Count>;
};

export type Utilizadores_Equipas_Virtuais_R_Centros_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Aggregate_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_aggregate_fields';
  avg?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Max_Fields>;
  min?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Min_Fields>;
  stddev?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Equipas_Virtuais_R_Centros_Variance_Fields>;
};


/** aggregate fields of "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Aggregate_Order_By = {
  avg?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Max_Order_By>;
  min?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Min_Order_By>;
  stddev?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Sum_Order_By>;
  var_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Var_Samp_Order_By>;
  variance?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Arr_Rel_Insert_Input = {
  data: Array<Utilizadores_Equipas_Virtuais_R_Centros_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_On_Conflict>;
};

/** aggregate avg on columns */
export type Utilizadores_Equipas_Virtuais_R_Centros_Avg_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "utilizadores.equipas_virtuais_r_centros". All fields are combined with a logical 'AND'. */
export type Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>>;
  centro?: InputMaybe<Base_Centros_Bool_Exp>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_centro?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "utilizadores.equipas_virtuais_r_centros" */
export enum Utilizadores_Equipas_Virtuais_R_Centros_Constraint {
  /** unique or primary key constraint on columns "id" */
  EquipasVirtuaisRCentrosPkey = 'equipas_virtuais_r_centros_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Insert_Input = {
  centro?: InputMaybe<Base_Centros_Obj_Rel_Insert_Input>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Utilizadores_Equipas_Virtuais_R_Centros_Max_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Utilizadores_Equipas_Virtuais_R_Centros_Min_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Mutation_Response = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Equipas_Virtuais_R_Centros>;
};

/** on_conflict condition type for table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_On_Conflict = {
  constraint: Utilizadores_Equipas_Virtuais_R_Centros_Constraint;
  update_columns?: Array<Utilizadores_Equipas_Virtuais_R_Centros_Update_Column>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.equipas_virtuais_r_centros". */
export type Utilizadores_Equipas_Virtuais_R_Centros_Order_By = {
  centro?: InputMaybe<Base_Centros_Order_By>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Order_By>;
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utilizadores.equipas_virtuais_r_centros */
export type Utilizadores_Equipas_Virtuais_R_Centros_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.equipas_virtuais_r_centros" */
export enum Utilizadores_Equipas_Virtuais_R_Centros_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdCentro = 'id_centro',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual'
}

/** input type for updating data in table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "utilizadores_equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Equipas_Virtuais_R_Centros_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Equipas_Virtuais_R_Centros_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_centro?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Equipas_Virtuais_R_Centros_Sum_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_centro?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
};

/** update columns of table "utilizadores.equipas_virtuais_r_centros" */
export enum Utilizadores_Equipas_Virtuais_R_Centros_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdCentro = 'id_centro',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual'
}

export type Utilizadores_Equipas_Virtuais_R_Centros_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Centros_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Equipas_Virtuais_R_Centros_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Centros_Var_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Centros_Var_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Utilizadores_Equipas_Virtuais_R_Centros_Variance_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_centros_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_centro?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "utilizadores.equipas_virtuais_r_centros" */
export type Utilizadores_Equipas_Virtuais_R_Centros_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_centro?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
};

/** columns and relationships of "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais';
  /** An object relationship */
  equipaVirtualGerida?: Maybe<Utilizadores_Equipas_Virtuais>;
  /** An object relationship */
  equipaVirtualGestora?: Maybe<Utilizadores_Equipas_Virtuais>;
  id: Scalars['bigint']['output'];
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_gerir?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_aggregate';
  aggregate?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate_Fields>;
  nodes: Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais>;
};

export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate_Bool_Exp = {
  count?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate_Bool_Exp_Count>;
};

export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_aggregate_fields';
  avg?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Max_Fields>;
  min?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Min_Fields>;
  stddev?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Variance_Fields>;
};


/** aggregate fields of "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Aggregate_Order_By = {
  avg?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Max_Order_By>;
  min?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Min_Order_By>;
  stddev?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Sum_Order_By>;
  var_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Var_Samp_Order_By>;
  variance?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Arr_Rel_Insert_Input = {
  data: Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_On_Conflict>;
};

/** aggregate avg on columns */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Avg_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_gerir?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_equipa_virtual_gerir?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "utilizadores.equipas_virtuais_r_equipas_virtuais". All fields are combined with a logical 'AND'. */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>>;
  equipaVirtualGerida?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  equipaVirtualGestora?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual_gerir?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export enum Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Constraint {
  /** unique or primary key constraint on columns "id" */
  EquipasVirtuaisREquipasVirtuaisPkey = 'equipas_virtuais_r_equipas_virtuais_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_gerir?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Insert_Input = {
  equipaVirtualGerida?: InputMaybe<Utilizadores_Equipas_Virtuais_Obj_Rel_Insert_Input>;
  equipaVirtualGestora?: InputMaybe<Utilizadores_Equipas_Virtuais_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_gerir?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Max_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_gerir?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_equipa_virtual_gerir?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Min_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_gerir?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_equipa_virtual_gerir?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Mutation_Response = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais>;
};

/** on_conflict condition type for table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_On_Conflict = {
  constraint: Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Constraint;
  update_columns?: Array<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Update_Column>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.equipas_virtuais_r_equipas_virtuais". */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Order_By = {
  equipaVirtualGerida?: InputMaybe<Utilizadores_Equipas_Virtuais_Order_By>;
  equipaVirtualGestora?: InputMaybe<Utilizadores_Equipas_Virtuais_Order_By>;
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_equipa_virtual_gerir?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utilizadores.equipas_virtuais_r_equipas_virtuais */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export enum Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdEquipaVirtualGerir = 'id_equipa_virtual_gerir'
}

/** input type for updating data in table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_gerir?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_gerir?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_equipa_virtual_gerir?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_gerir?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_equipa_virtual_gerir?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_gerir?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_equipa_virtual_gerir?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "utilizadores_equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual_gerir?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Sum_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual_gerir?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_equipa_virtual_gerir?: InputMaybe<Order_By>;
};

/** update columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export enum Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdEquipaVirtualGerir = 'id_equipa_virtual_gerir'
}

export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Var_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_gerir?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_equipa_virtual_gerir?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Var_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_gerir?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_equipa_virtual_gerir?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Variance_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_equipas_virtuais_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual_gerir?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "utilizadores.equipas_virtuais_r_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_R_Equipas_Virtuais_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_equipa_virtual_gerir?: InputMaybe<Order_By>;
};

/** columns and relationships of "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas';
  /** An object relationship */
  equipaVirtual?: Maybe<Utilizadores_Equipas_Virtuais>;
  /** An array relationship */
  equipaVirtualTransacoes: Array<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** An aggregate relationship */
  equipaVirtualTransacoes_aggregate: Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate;
  /** An object relationship */
  equipaVirtualUtilizadores?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  id: Scalars['bigint']['output'];
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  infraestrutura?: Maybe<Base_Infraestruturas>;
};


/** columns and relationships of "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_InfraestruturasEquipaVirtualTransacoesArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};


/** columns and relationships of "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_InfraestruturasEquipaVirtualTransacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};

/** aggregated selection of "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_aggregate';
  aggregate?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate_Fields>;
  nodes: Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas>;
};

export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate_Bool_Exp = {
  count?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate_Bool_Exp_Count>;
};

export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_aggregate_fields';
  avg?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Max_Fields>;
  min?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Min_Fields>;
  stddev?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Variance_Fields>;
};


/** aggregate fields of "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Aggregate_Order_By = {
  avg?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Max_Order_By>;
  min?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Min_Order_By>;
  stddev?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Sum_Order_By>;
  var_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Var_Samp_Order_By>;
  variance?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Arr_Rel_Insert_Input = {
  data: Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_On_Conflict>;
};

/** aggregate avg on columns */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Avg_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "utilizadores.equipas_virtuais_r_infraestruturas". All fields are combined with a logical 'AND'. */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  equipaVirtualTransacoes?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
  equipaVirtualTransacoes_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Bool_Exp>;
  equipaVirtualUtilizadores?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
};

/** unique or primary key constraints on table "utilizadores.equipas_virtuais_r_infraestruturas" */
export enum Utilizadores_Equipas_Virtuais_R_Infraestruturas_Constraint {
  /** unique or primary key constraint on columns "id_infraestrutura", "id_equipa_virtual" */
  IndUniqueEquipasVirtuaisRInfraestruturas = 'ind_unique_equipas_virtuais_r_infraestruturas',
  /** unique or primary key constraint on columns "id" */
  REquipasVirtuaisArvorePkey = 'r_equipas_virtuais_arvore_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Insert_Input = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Obj_Rel_Insert_Input>;
  equipaVirtualTransacoes?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Arr_Rel_Insert_Input>;
  equipaVirtualUtilizadores?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Max_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Min_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Mutation_Response = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas>;
};

/** on_conflict condition type for table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_On_Conflict = {
  constraint: Utilizadores_Equipas_Virtuais_R_Infraestruturas_Constraint;
  update_columns?: Array<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Update_Column>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.equipas_virtuais_r_infraestruturas". */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Order_By = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Order_By>;
  equipaVirtualTransacoes_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Order_By>;
  equipaVirtualUtilizadores?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By>;
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
};

/** primary key columns input for table: utilizadores.equipas_virtuais_r_infraestruturas */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export enum Utilizadores_Equipas_Virtuais_R_Infraestruturas_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura'
}

/** input type for updating data in table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "utilizadores_equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Sum_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** update columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export enum Utilizadores_Equipas_Virtuais_R_Infraestruturas_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura'
}

export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Infraestruturas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Equipas_Virtuais_R_Infraestruturas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Var_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Var_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Variance_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_infraestruturas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "utilizadores.equipas_virtuais_r_infraestruturas" */
export type Utilizadores_Equipas_Virtuais_R_Infraestruturas_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** columns and relationships of "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma';
  /** An object relationship */
  arvore?: Maybe<Sintomas_Arvore>;
  /** An object relationship */
  equipaVirtual?: Maybe<Utilizadores_Equipas_Virtuais>;
  /** An array relationship */
  equipaVirtualTransacoes: Array<Utilizadores_Equipas_Virtuais_R_Transacoes>;
  /** An aggregate relationship */
  equipaVirtualTransacoes_aggregate: Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate;
  id: Scalars['bigint']['output'];
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_SintomaEquipaVirtualTransacoesArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};


/** columns and relationships of "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_SintomaEquipaVirtualTransacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};

/** aggregated selection of "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_aggregate';
  aggregate?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate_Fields>;
  nodes: Array<Utilizadores_Equipas_Virtuais_R_Sintoma>;
};

export type Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate_Bool_Exp = {
  count?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate_Bool_Exp_Count>;
};

export type Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_aggregate_fields';
  avg?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Max_Fields>;
  min?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Min_Fields>;
  stddev?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Variance_Fields>;
};


/** aggregate fields of "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Aggregate_Order_By = {
  avg?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Max_Order_By>;
  min?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Min_Order_By>;
  stddev?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Sum_Order_By>;
  var_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Var_Samp_Order_By>;
  variance?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Arr_Rel_Insert_Input = {
  data: Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_On_Conflict>;
};

/** aggregate avg on columns */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Avg_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "utilizadores.equipas_virtuais_r_sintoma". All fields are combined with a logical 'AND'. */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>>;
  arvore?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  equipaVirtualTransacoes?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
  equipaVirtualTransacoes_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual?: InputMaybe<Bigint_Comparison_Exp>;
  id_sintoma?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "utilizadores.equipas_virtuais_r_sintoma" */
export enum Utilizadores_Equipas_Virtuais_R_Sintoma_Constraint {
  /** unique or primary key constraint on columns "id" */
  REquipasVirtuaisSintomaPkey = 'r_equipas_virtuais_sintoma_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Insert_Input = {
  arvore?: InputMaybe<Sintomas_Arvore_Obj_Rel_Insert_Input>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Obj_Rel_Insert_Input>;
  equipaVirtualTransacoes?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Max_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Min_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Mutation_Response = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Equipas_Virtuais_R_Sintoma>;
};

/** on_conflict condition type for table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_On_Conflict = {
  constraint: Utilizadores_Equipas_Virtuais_R_Sintoma_Constraint;
  update_columns?: Array<Utilizadores_Equipas_Virtuais_R_Sintoma_Update_Column>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.equipas_virtuais_r_sintoma". */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Order_By = {
  arvore?: InputMaybe<Sintomas_Arvore_Order_By>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Order_By>;
  equipaVirtualTransacoes_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utilizadores.equipas_virtuais_r_sintoma */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export enum Utilizadores_Equipas_Virtuais_R_Sintoma_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdSintoma = 'id_sintoma'
}

/** input type for updating data in table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "utilizadores_equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Equipas_Virtuais_R_Sintoma_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_sintoma?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Sum_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_sintoma?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** update columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export enum Utilizadores_Equipas_Virtuais_R_Sintoma_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdSintoma = 'id_sintoma'
}

export type Utilizadores_Equipas_Virtuais_R_Sintoma_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Sintoma_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Equipas_Virtuais_R_Sintoma_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Var_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Var_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Variance_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_sintoma_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_sintoma?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "utilizadores.equipas_virtuais_r_sintoma" */
export type Utilizadores_Equipas_Virtuais_R_Sintoma_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_sintoma?: InputMaybe<Order_By>;
};

/** columns and relationships of "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias';
  /** An object relationship */
  equipaVirtual?: Maybe<Utilizadores_Equipas_Virtuais>;
  /** An object relationship */
  equipaVirtualUtilizadores?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  id: Scalars['bigint']['output'];
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_aggregate';
  aggregate?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate_Fields>;
  nodes: Array<Utilizadores_Equipas_Virtuais_R_Toponimias>;
};

export type Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate_Bool_Exp = {
  count?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate_Bool_Exp_Count>;
};

export type Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_aggregate_fields';
  avg?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Max_Fields>;
  min?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Min_Fields>;
  stddev?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Variance_Fields>;
};


/** aggregate fields of "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Aggregate_Order_By = {
  avg?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Max_Order_By>;
  min?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Min_Order_By>;
  stddev?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Sum_Order_By>;
  var_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Var_Samp_Order_By>;
  variance?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Arr_Rel_Insert_Input = {
  data: Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_On_Conflict>;
};

/** aggregate avg on columns */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Avg_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "utilizadores.equipas_virtuais_r_toponimias". All fields are combined with a logical 'AND'. */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  equipaVirtualUtilizadores?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual?: InputMaybe<Bigint_Comparison_Exp>;
  id_toponimia?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "utilizadores.equipas_virtuais_r_toponimias" */
export enum Utilizadores_Equipas_Virtuais_R_Toponimias_Constraint {
  /** unique or primary key constraint on columns "id_equipa_virtual", "id_toponimia" */
  EquipasVirtuaisRToponimiasUniqueKey = 'equipas_virtuais_r_toponimias_unique_key',
  /** unique or primary key constraint on columns "id" */
  REquipasVirtuaisSupArvorePkey = 'r_equipas_virtuais_sup_arvore_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Insert_Input = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Obj_Rel_Insert_Input>;
  equipaVirtualUtilizadores?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Max_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Min_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Mutation_Response = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Equipas_Virtuais_R_Toponimias>;
};

/** on_conflict condition type for table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_On_Conflict = {
  constraint: Utilizadores_Equipas_Virtuais_R_Toponimias_Constraint;
  update_columns?: Array<Utilizadores_Equipas_Virtuais_R_Toponimias_Update_Column>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.equipas_virtuais_r_toponimias". */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Order_By = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Order_By>;
  equipaVirtualUtilizadores?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By>;
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utilizadores.equipas_virtuais_r_toponimias */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export enum Utilizadores_Equipas_Virtuais_R_Toponimias_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdToponimia = 'id_toponimia'
}

/** input type for updating data in table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "utilizadores_equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Equipas_Virtuais_R_Toponimias_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Sum_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
};

/** update columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export enum Utilizadores_Equipas_Virtuais_R_Toponimias_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdToponimia = 'id_toponimia'
}

export type Utilizadores_Equipas_Virtuais_R_Toponimias_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Toponimias_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Equipas_Virtuais_R_Toponimias_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Var_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Var_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Variance_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_toponimias_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "utilizadores.equipas_virtuais_r_toponimias" */
export type Utilizadores_Equipas_Virtuais_R_Toponimias_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
};

/** columns and relationships of "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes';
  /** An object relationship */
  equipaVirtual?: Maybe<Utilizadores_Equipas_Virtuais>;
  /** An object relationship */
  equipaVirtualUtilizadores?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  id: Scalars['bigint']['output'];
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_transacao?: Maybe<Scalars['bigint']['output']>;
  permissoes?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  transacoes?: Maybe<Permissoes_Transacoes>;
};

/** aggregated selection of "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_aggregate';
  aggregate?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Fields>;
  nodes: Array<Utilizadores_Equipas_Virtuais_R_Transacoes>;
};

export type Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Bool_Exp_Count>;
};

export type Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_aggregate_fields';
  avg?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Max_Fields>;
  min?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Min_Fields>;
  stddev?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Variance_Fields>;
};


/** aggregate fields of "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Aggregate_Order_By = {
  avg?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Max_Order_By>;
  min?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Min_Order_By>;
  stddev?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Sum_Order_By>;
  var_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Var_Samp_Order_By>;
  variance?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Arr_Rel_Insert_Input = {
  data: Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_On_Conflict>;
};

/** aggregate avg on columns */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Avg_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
  permissoes?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  permissoes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "utilizadores.equipas_virtuais_r_transacoes". All fields are combined with a logical 'AND'. */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  equipaVirtualUtilizadores?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual?: InputMaybe<Bigint_Comparison_Exp>;
  id_transacao?: InputMaybe<Bigint_Comparison_Exp>;
  permissoes?: InputMaybe<Int_Comparison_Exp>;
  transacoes?: InputMaybe<Permissoes_Transacoes_Bool_Exp>;
};

/** unique or primary key constraints on table "utilizadores.equipas_virtuais_r_transacoes" */
export enum Utilizadores_Equipas_Virtuais_R_Transacoes_Constraint {
  /** unique or primary key constraint on columns "id_transacao", "id_equipa_virtual" */
  EquipasVirtuaisRTransacoesUniqueKey = 'equipas_virtuais_r_transacoes_unique_key',
  /** unique or primary key constraint on columns "id" */
  REquipasVirtuaisTransacoesPkey = 'r_equipas_virtuais_transacoes_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
  permissoes?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Insert_Input = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Obj_Rel_Insert_Input>;
  equipaVirtualUtilizadores?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
  permissoes?: InputMaybe<Scalars['Int']['input']>;
  transacoes?: InputMaybe<Permissoes_Transacoes_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Max_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_transacao?: Maybe<Scalars['bigint']['output']>;
  permissoes?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  permissoes?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Min_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_transacao?: Maybe<Scalars['bigint']['output']>;
  permissoes?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  permissoes?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Mutation_Response = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Equipas_Virtuais_R_Transacoes>;
};

/** on_conflict condition type for table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_On_Conflict = {
  constraint: Utilizadores_Equipas_Virtuais_R_Transacoes_Constraint;
  update_columns?: Array<Utilizadores_Equipas_Virtuais_R_Transacoes_Update_Column>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.equipas_virtuais_r_transacoes". */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Order_By = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Order_By>;
  equipaVirtualUtilizadores?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By>;
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  permissoes?: InputMaybe<Order_By>;
  transacoes?: InputMaybe<Permissoes_Transacoes_Order_By>;
};

/** primary key columns input for table: utilizadores.equipas_virtuais_r_transacoes */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export enum Utilizadores_Equipas_Virtuais_R_Transacoes_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdTransacao = 'id_transacao',
  /** column name */
  Permissoes = 'permissoes'
}

/** input type for updating data in table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
  permissoes?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
  permissoes?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  permissoes?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
  permissoes?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  permissoes?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
  permissoes?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  permissoes?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "utilizadores_equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Equipas_Virtuais_R_Transacoes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_transacao?: InputMaybe<Scalars['bigint']['input']>;
  permissoes?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Sum_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_transacao?: Maybe<Scalars['bigint']['output']>;
  permissoes?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  permissoes?: InputMaybe<Order_By>;
};

/** update columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export enum Utilizadores_Equipas_Virtuais_R_Transacoes_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdTransacao = 'id_transacao',
  /** column name */
  Permissoes = 'permissoes'
}

export type Utilizadores_Equipas_Virtuais_R_Transacoes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Transacoes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Equipas_Virtuais_R_Transacoes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Var_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
  permissoes?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  permissoes?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Var_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
  permissoes?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  permissoes?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Variance_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_transacoes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_transacao?: Maybe<Scalars['Float']['output']>;
  permissoes?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "utilizadores.equipas_virtuais_r_transacoes" */
export type Utilizadores_Equipas_Virtuais_R_Transacoes_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_transacao?: InputMaybe<Order_By>;
  permissoes?: InputMaybe<Order_By>;
};

/** columns and relationships of "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores';
  /** An object relationship */
  equipaVirtual?: Maybe<Utilizadores_Equipas_Virtuais>;
  id: Scalars['bigint']['output'];
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  utilizadores?: Maybe<Utilizadores_Utilizadores>;
};

/** aggregated selection of "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_aggregate';
  aggregate?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate_Fields>;
  nodes: Array<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
};

export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate_Bool_Exp = {
  count?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate_Bool_Exp_Count>;
};

export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_aggregate_fields';
  avg?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Max_Fields>;
  min?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Min_Fields>;
  stddev?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Variance_Fields>;
};


/** aggregate fields of "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate_Order_By = {
  avg?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Max_Order_By>;
  min?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Min_Order_By>;
  stddev?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Sum_Order_By>;
  var_pop?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Var_Samp_Order_By>;
  variance?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Arr_Rel_Insert_Input = {
  data: Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_On_Conflict>;
};

/** aggregate avg on columns */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Avg_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "utilizadores.equipas_virtuais_r_utilizadores". All fields are combined with a logical 'AND'. */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>>;
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_equipa_virtual?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  utilizadores?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
};

/** unique or primary key constraints on table "utilizadores.equipas_virtuais_r_utilizadores" */
export enum Utilizadores_Equipas_Virtuais_R_Utilizadores_Constraint {
  /** unique or primary key constraint on columns "id_equipa_virtual", "id_utilizador" */
  EquipasVirtuaisRUtilizadoresUniqueKey = 'equipas_virtuais_r_utilizadores_unique_key',
  /** unique or primary key constraint on columns "id" */
  REquipasVirtuaisUtilizadoresPkey = 'r_equipas_virtuais_utilizadores_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Insert_Input = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  utilizadores?: InputMaybe<Utilizadores_Utilizadores_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Max_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Min_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Mutation_Response = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
};

/** input type for inserting object relation for remote table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Obj_Rel_Insert_Input = {
  data: Utilizadores_Equipas_Virtuais_R_Utilizadores_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_On_Conflict>;
};

/** on_conflict condition type for table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_On_Conflict = {
  constraint: Utilizadores_Equipas_Virtuais_R_Utilizadores_Constraint;
  update_columns?: Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Update_Column>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.equipas_virtuais_r_utilizadores". */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By = {
  equipaVirtual?: InputMaybe<Utilizadores_Equipas_Virtuais_Order_By>;
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  utilizadores?: InputMaybe<Utilizadores_Utilizadores_Order_By>;
};

/** primary key columns input for table: utilizadores.equipas_virtuais_r_utilizadores */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export enum Utilizadores_Equipas_Virtuais_R_Utilizadores_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdUtilizador = 'id_utilizador'
}

/** input type for updating data in table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "utilizadores_equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Equipas_Virtuais_R_Utilizadores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_equipa_virtual?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Sum_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_equipa_virtual?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** update columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export enum Utilizadores_Equipas_Virtuais_R_Utilizadores_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdEquipaVirtual = 'id_equipa_virtual',
  /** column name */
  IdUtilizador = 'id_utilizador'
}

export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Var_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Var_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Variance_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_r_utilizadores_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_equipa_virtual?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "utilizadores.equipas_virtuais_r_utilizadores" */
export type Utilizadores_Equipas_Virtuais_R_Utilizadores_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_equipa_virtual?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
};

/** select columns of table "utilizadores.equipas_virtuais" */
export enum Utilizadores_Equipas_Virtuais_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Cor = 'cor',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  EquipaSos = 'equipa_sos',
  /** column name */
  Id = 'id',
  /** column name */
  IdPerfil = 'id_perfil'
}

/** input type for updating data in table "utilizadores.equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  equipa_sos?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_perfil?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Equipas_Virtuais_Stddev_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_perfil?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Equipas_Virtuais_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_perfil?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Equipas_Virtuais_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_perfil?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "utilizadores_equipas_virtuais" */
export type Utilizadores_Equipas_Virtuais_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Equipas_Virtuais_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Equipas_Virtuais_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  cor?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  equipa_sos?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_perfil?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Equipas_Virtuais_Sum_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_perfil?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "utilizadores.equipas_virtuais" */
export enum Utilizadores_Equipas_Virtuais_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Cor = 'cor',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  EquipaSos = 'equipa_sos',
  /** column name */
  Id = 'id',
  /** column name */
  IdPerfil = 'id_perfil'
}

export type Utilizadores_Equipas_Virtuais_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Equipas_Virtuais_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Equipas_Virtuais_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Equipas_Virtuais_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Equipas_Virtuais_Var_Pop_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_perfil?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Equipas_Virtuais_Var_Samp_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_perfil?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Utilizadores_Equipas_Virtuais_Variance_Fields = {
  __typename?: 'utilizadores_equipas_virtuais_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_perfil?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "utilizadores.exportacoes" */
export type Utilizadores_Exportacoes = {
  __typename?: 'utilizadores_exportacoes';
  data_hora_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  data_hora_inicio?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  duracao?: Maybe<Scalars['time']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  id_utilizador: Scalars['bigint']['output'];
  oculto: Scalars['Boolean']['output'];
  pid?: Maybe<Scalars['bigint']['output']>;
  pid_killed: Scalars['Boolean']['output'];
  pid_killed_data_hora?: Maybe<Scalars['timestamp']['output']>;
  status_id: Scalars['bigint']['output'];
  status_percent?: Maybe<Scalars['numeric']['output']>;
  status_text?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "utilizadores.exportacoes" */
export type Utilizadores_Exportacoes_Aggregate = {
  __typename?: 'utilizadores_exportacoes_aggregate';
  aggregate?: Maybe<Utilizadores_Exportacoes_Aggregate_Fields>;
  nodes: Array<Utilizadores_Exportacoes>;
};

/** aggregate fields of "utilizadores.exportacoes" */
export type Utilizadores_Exportacoes_Aggregate_Fields = {
  __typename?: 'utilizadores_exportacoes_aggregate_fields';
  avg?: Maybe<Utilizadores_Exportacoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Exportacoes_Max_Fields>;
  min?: Maybe<Utilizadores_Exportacoes_Min_Fields>;
  stddev?: Maybe<Utilizadores_Exportacoes_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Exportacoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Exportacoes_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Exportacoes_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Exportacoes_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Exportacoes_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Exportacoes_Variance_Fields>;
};


/** aggregate fields of "utilizadores.exportacoes" */
export type Utilizadores_Exportacoes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Exportacoes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Utilizadores_Exportacoes_Avg_Fields = {
  __typename?: 'utilizadores_exportacoes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  pid?: Maybe<Scalars['Float']['output']>;
  status_id?: Maybe<Scalars['Float']['output']>;
  status_percent?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "utilizadores.exportacoes". All fields are combined with a logical 'AND'. */
export type Utilizadores_Exportacoes_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Exportacoes_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Exportacoes_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Exportacoes_Bool_Exp>>;
  data_hora_atualizacao?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_inicio?: InputMaybe<Timestamp_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  duracao?: InputMaybe<Time_Comparison_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  oculto?: InputMaybe<Boolean_Comparison_Exp>;
  pid?: InputMaybe<Bigint_Comparison_Exp>;
  pid_killed?: InputMaybe<Boolean_Comparison_Exp>;
  pid_killed_data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  status_id?: InputMaybe<Bigint_Comparison_Exp>;
  status_percent?: InputMaybe<Numeric_Comparison_Exp>;
  status_text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "utilizadores.exportacoes" */
export enum Utilizadores_Exportacoes_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExcelPkey = 'excel_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.exportacoes" */
export type Utilizadores_Exportacoes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  pid?: InputMaybe<Scalars['bigint']['input']>;
  status_id?: InputMaybe<Scalars['bigint']['input']>;
  status_percent?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "utilizadores.exportacoes" */
export type Utilizadores_Exportacoes_Insert_Input = {
  data_hora_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  duracao?: InputMaybe<Scalars['time']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  oculto?: InputMaybe<Scalars['Boolean']['input']>;
  pid?: InputMaybe<Scalars['bigint']['input']>;
  pid_killed?: InputMaybe<Scalars['Boolean']['input']>;
  pid_killed_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  status_id?: InputMaybe<Scalars['bigint']['input']>;
  status_percent?: InputMaybe<Scalars['numeric']['input']>;
  status_text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Utilizadores_Exportacoes_Max_Fields = {
  __typename?: 'utilizadores_exportacoes_max_fields';
  data_hora_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  data_hora_inicio?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  pid?: Maybe<Scalars['bigint']['output']>;
  pid_killed_data_hora?: Maybe<Scalars['timestamp']['output']>;
  status_id?: Maybe<Scalars['bigint']['output']>;
  status_percent?: Maybe<Scalars['numeric']['output']>;
  status_text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Utilizadores_Exportacoes_Min_Fields = {
  __typename?: 'utilizadores_exportacoes_min_fields';
  data_hora_atualizacao?: Maybe<Scalars['timestamp']['output']>;
  data_hora_inicio?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  pid?: Maybe<Scalars['bigint']['output']>;
  pid_killed_data_hora?: Maybe<Scalars['timestamp']['output']>;
  status_id?: Maybe<Scalars['bigint']['output']>;
  status_percent?: Maybe<Scalars['numeric']['output']>;
  status_text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "utilizadores.exportacoes" */
export type Utilizadores_Exportacoes_Mutation_Response = {
  __typename?: 'utilizadores_exportacoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Exportacoes>;
};

/** on_conflict condition type for table "utilizadores.exportacoes" */
export type Utilizadores_Exportacoes_On_Conflict = {
  constraint: Utilizadores_Exportacoes_Constraint;
  update_columns?: Array<Utilizadores_Exportacoes_Update_Column>;
  where?: InputMaybe<Utilizadores_Exportacoes_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.exportacoes". */
export type Utilizadores_Exportacoes_Order_By = {
  data_hora_atualizacao?: InputMaybe<Order_By>;
  data_hora_inicio?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  duracao?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  file?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  oculto?: InputMaybe<Order_By>;
  pid?: InputMaybe<Order_By>;
  pid_killed?: InputMaybe<Order_By>;
  pid_killed_data_hora?: InputMaybe<Order_By>;
  status_id?: InputMaybe<Order_By>;
  status_percent?: InputMaybe<Order_By>;
  status_text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utilizadores.exportacoes */
export type Utilizadores_Exportacoes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.exportacoes" */
export enum Utilizadores_Exportacoes_Select_Column {
  /** column name */
  DataHoraAtualizacao = 'data_hora_atualizacao',
  /** column name */
  DataHoraInicio = 'data_hora_inicio',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Duracao = 'duracao',
  /** column name */
  Extension = 'extension',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  Oculto = 'oculto',
  /** column name */
  Pid = 'pid',
  /** column name */
  PidKilled = 'pid_killed',
  /** column name */
  PidKilledDataHora = 'pid_killed_data_hora',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  StatusPercent = 'status_percent',
  /** column name */
  StatusText = 'status_text'
}

/** input type for updating data in table "utilizadores.exportacoes" */
export type Utilizadores_Exportacoes_Set_Input = {
  data_hora_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  duracao?: InputMaybe<Scalars['time']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  oculto?: InputMaybe<Scalars['Boolean']['input']>;
  pid?: InputMaybe<Scalars['bigint']['input']>;
  pid_killed?: InputMaybe<Scalars['Boolean']['input']>;
  pid_killed_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  status_id?: InputMaybe<Scalars['bigint']['input']>;
  status_percent?: InputMaybe<Scalars['numeric']['input']>;
  status_text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Exportacoes_Stddev_Fields = {
  __typename?: 'utilizadores_exportacoes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  pid?: Maybe<Scalars['Float']['output']>;
  status_id?: Maybe<Scalars['Float']['output']>;
  status_percent?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Exportacoes_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_exportacoes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  pid?: Maybe<Scalars['Float']['output']>;
  status_id?: Maybe<Scalars['Float']['output']>;
  status_percent?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Exportacoes_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_exportacoes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  pid?: Maybe<Scalars['Float']['output']>;
  status_id?: Maybe<Scalars['Float']['output']>;
  status_percent?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "utilizadores_exportacoes" */
export type Utilizadores_Exportacoes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Exportacoes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Exportacoes_Stream_Cursor_Value_Input = {
  data_hora_atualizacao?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_inicio?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  duracao?: InputMaybe<Scalars['time']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  oculto?: InputMaybe<Scalars['Boolean']['input']>;
  pid?: InputMaybe<Scalars['bigint']['input']>;
  pid_killed?: InputMaybe<Scalars['Boolean']['input']>;
  pid_killed_data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  status_id?: InputMaybe<Scalars['bigint']['input']>;
  status_percent?: InputMaybe<Scalars['numeric']['input']>;
  status_text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Exportacoes_Sum_Fields = {
  __typename?: 'utilizadores_exportacoes_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  pid?: Maybe<Scalars['bigint']['output']>;
  status_id?: Maybe<Scalars['bigint']['output']>;
  status_percent?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "utilizadores.exportacoes" */
export enum Utilizadores_Exportacoes_Update_Column {
  /** column name */
  DataHoraAtualizacao = 'data_hora_atualizacao',
  /** column name */
  DataHoraInicio = 'data_hora_inicio',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Duracao = 'duracao',
  /** column name */
  Extension = 'extension',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  Oculto = 'oculto',
  /** column name */
  Pid = 'pid',
  /** column name */
  PidKilled = 'pid_killed',
  /** column name */
  PidKilledDataHora = 'pid_killed_data_hora',
  /** column name */
  StatusId = 'status_id',
  /** column name */
  StatusPercent = 'status_percent',
  /** column name */
  StatusText = 'status_text'
}

export type Utilizadores_Exportacoes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Exportacoes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Exportacoes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Exportacoes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Exportacoes_Var_Pop_Fields = {
  __typename?: 'utilizadores_exportacoes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  pid?: Maybe<Scalars['Float']['output']>;
  status_id?: Maybe<Scalars['Float']['output']>;
  status_percent?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Exportacoes_Var_Samp_Fields = {
  __typename?: 'utilizadores_exportacoes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  pid?: Maybe<Scalars['Float']['output']>;
  status_id?: Maybe<Scalars['Float']['output']>;
  status_percent?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Utilizadores_Exportacoes_Variance_Fields = {
  __typename?: 'utilizadores_exportacoes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  pid?: Maybe<Scalars['Float']['output']>;
  status_id?: Maybe<Scalars['Float']['output']>;
  status_percent?: Maybe<Scalars['Float']['output']>;
};

/** Tabela com a cor dos marcadores que mostram a posição do utilizador no mapa */
export type Utilizadores_Mapa_Posicao_Cores = {
  __typename?: 'utilizadores_mapa_posicao_cores';
  cor_modo_claro: Scalars['String']['output'];
  cor_modo_escuro: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  limite_superior?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "utilizadores.mapa_posicao_cores" */
export type Utilizadores_Mapa_Posicao_Cores_Aggregate = {
  __typename?: 'utilizadores_mapa_posicao_cores_aggregate';
  aggregate?: Maybe<Utilizadores_Mapa_Posicao_Cores_Aggregate_Fields>;
  nodes: Array<Utilizadores_Mapa_Posicao_Cores>;
};

/** aggregate fields of "utilizadores.mapa_posicao_cores" */
export type Utilizadores_Mapa_Posicao_Cores_Aggregate_Fields = {
  __typename?: 'utilizadores_mapa_posicao_cores_aggregate_fields';
  avg?: Maybe<Utilizadores_Mapa_Posicao_Cores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Mapa_Posicao_Cores_Max_Fields>;
  min?: Maybe<Utilizadores_Mapa_Posicao_Cores_Min_Fields>;
  stddev?: Maybe<Utilizadores_Mapa_Posicao_Cores_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Mapa_Posicao_Cores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Mapa_Posicao_Cores_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Mapa_Posicao_Cores_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Mapa_Posicao_Cores_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Mapa_Posicao_Cores_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Mapa_Posicao_Cores_Variance_Fields>;
};


/** aggregate fields of "utilizadores.mapa_posicao_cores" */
export type Utilizadores_Mapa_Posicao_Cores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Mapa_Posicao_Cores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Utilizadores_Mapa_Posicao_Cores_Avg_Fields = {
  __typename?: 'utilizadores_mapa_posicao_cores_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  limite_superior?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "utilizadores.mapa_posicao_cores". All fields are combined with a logical 'AND'. */
export type Utilizadores_Mapa_Posicao_Cores_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Mapa_Posicao_Cores_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Mapa_Posicao_Cores_Bool_Exp>>;
  cor_modo_claro?: InputMaybe<String_Comparison_Exp>;
  cor_modo_escuro?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  limite_superior?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "utilizadores.mapa_posicao_cores" */
export enum Utilizadores_Mapa_Posicao_Cores_Constraint {
  /** unique or primary key constraint on columns "cor_modo_claro" */
  MapaPosicaoCoresCorKey = 'mapa_posicao_cores_cor_key',
  /** unique or primary key constraint on columns "cor_modo_escuro" */
  MapaPosicaoCoresCorModoEscuroKey = 'mapa_posicao_cores_cor_modo_escuro_key',
  /** unique or primary key constraint on columns "id" */
  MapaPosicaoCoresPkey = 'mapa_posicao_cores_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.mapa_posicao_cores" */
export type Utilizadores_Mapa_Posicao_Cores_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  limite_superior?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "utilizadores.mapa_posicao_cores" */
export type Utilizadores_Mapa_Posicao_Cores_Insert_Input = {
  cor_modo_claro?: InputMaybe<Scalars['String']['input']>;
  cor_modo_escuro?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  limite_superior?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Utilizadores_Mapa_Posicao_Cores_Max_Fields = {
  __typename?: 'utilizadores_mapa_posicao_cores_max_fields';
  cor_modo_claro?: Maybe<Scalars['String']['output']>;
  cor_modo_escuro?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  limite_superior?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Utilizadores_Mapa_Posicao_Cores_Min_Fields = {
  __typename?: 'utilizadores_mapa_posicao_cores_min_fields';
  cor_modo_claro?: Maybe<Scalars['String']['output']>;
  cor_modo_escuro?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  limite_superior?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "utilizadores.mapa_posicao_cores" */
export type Utilizadores_Mapa_Posicao_Cores_Mutation_Response = {
  __typename?: 'utilizadores_mapa_posicao_cores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Mapa_Posicao_Cores>;
};

/** on_conflict condition type for table "utilizadores.mapa_posicao_cores" */
export type Utilizadores_Mapa_Posicao_Cores_On_Conflict = {
  constraint: Utilizadores_Mapa_Posicao_Cores_Constraint;
  update_columns?: Array<Utilizadores_Mapa_Posicao_Cores_Update_Column>;
  where?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.mapa_posicao_cores". */
export type Utilizadores_Mapa_Posicao_Cores_Order_By = {
  cor_modo_claro?: InputMaybe<Order_By>;
  cor_modo_escuro?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  limite_superior?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utilizadores.mapa_posicao_cores */
export type Utilizadores_Mapa_Posicao_Cores_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.mapa_posicao_cores" */
export enum Utilizadores_Mapa_Posicao_Cores_Select_Column {
  /** column name */
  CorModoClaro = 'cor_modo_claro',
  /** column name */
  CorModoEscuro = 'cor_modo_escuro',
  /** column name */
  Id = 'id',
  /** column name */
  LimiteSuperior = 'limite_superior'
}

/** input type for updating data in table "utilizadores.mapa_posicao_cores" */
export type Utilizadores_Mapa_Posicao_Cores_Set_Input = {
  cor_modo_claro?: InputMaybe<Scalars['String']['input']>;
  cor_modo_escuro?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  limite_superior?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Mapa_Posicao_Cores_Stddev_Fields = {
  __typename?: 'utilizadores_mapa_posicao_cores_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  limite_superior?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Mapa_Posicao_Cores_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_mapa_posicao_cores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  limite_superior?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Mapa_Posicao_Cores_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_mapa_posicao_cores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  limite_superior?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "utilizadores_mapa_posicao_cores" */
export type Utilizadores_Mapa_Posicao_Cores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Mapa_Posicao_Cores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Mapa_Posicao_Cores_Stream_Cursor_Value_Input = {
  cor_modo_claro?: InputMaybe<Scalars['String']['input']>;
  cor_modo_escuro?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  limite_superior?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Mapa_Posicao_Cores_Sum_Fields = {
  __typename?: 'utilizadores_mapa_posicao_cores_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  limite_superior?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "utilizadores.mapa_posicao_cores" */
export enum Utilizadores_Mapa_Posicao_Cores_Update_Column {
  /** column name */
  CorModoClaro = 'cor_modo_claro',
  /** column name */
  CorModoEscuro = 'cor_modo_escuro',
  /** column name */
  Id = 'id',
  /** column name */
  LimiteSuperior = 'limite_superior'
}

export type Utilizadores_Mapa_Posicao_Cores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Mapa_Posicao_Cores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Mapa_Posicao_Cores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Mapa_Posicao_Cores_Var_Pop_Fields = {
  __typename?: 'utilizadores_mapa_posicao_cores_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  limite_superior?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Mapa_Posicao_Cores_Var_Samp_Fields = {
  __typename?: 'utilizadores_mapa_posicao_cores_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  limite_superior?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Utilizadores_Mapa_Posicao_Cores_Variance_Fields = {
  __typename?: 'utilizadores_mapa_posicao_cores_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  limite_superior?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "utilizadores.menu" */
export type Utilizadores_Menu = {
  __typename?: 'utilizadores_menu';
  has_childs?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  id_pai?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  menuPai?: Maybe<Utilizadores_Menu>;
  /** An array relationship */
  menuTransacoes: Array<Permissoes_Transacoes_R_Menus>;
  /** An aggregate relationship */
  menuTransacoes_aggregate: Permissoes_Transacoes_R_Menus_Aggregate;
  /** An array relationship */
  menusFilhos: Array<Utilizadores_Menu>;
  /** An aggregate relationship */
  menusFilhos_aggregate: Utilizadores_Menu_Aggregate;
  new_ui: Scalars['Boolean']['output'];
  ordem?: Maybe<Scalars['Int']['output']>;
  texto?: Maybe<Scalars['String']['output']>;
  translation_key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "utilizadores.menu" */
export type Utilizadores_MenuMenuTransacoesArgs = {
  distinct_on?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Order_By>>;
  where?: InputMaybe<Permissoes_Transacoes_R_Menus_Bool_Exp>;
};


/** columns and relationships of "utilizadores.menu" */
export type Utilizadores_MenuMenuTransacoes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Permissoes_Transacoes_R_Menus_Order_By>>;
  where?: InputMaybe<Permissoes_Transacoes_R_Menus_Bool_Exp>;
};


/** columns and relationships of "utilizadores.menu" */
export type Utilizadores_MenuMenusFilhosArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Menu_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Menu_Order_By>>;
  where?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
};


/** columns and relationships of "utilizadores.menu" */
export type Utilizadores_MenuMenusFilhos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Menu_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Menu_Order_By>>;
  where?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
};

/** aggregated selection of "utilizadores.menu" */
export type Utilizadores_Menu_Aggregate = {
  __typename?: 'utilizadores_menu_aggregate';
  aggregate?: Maybe<Utilizadores_Menu_Aggregate_Fields>;
  nodes: Array<Utilizadores_Menu>;
};

export type Utilizadores_Menu_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Utilizadores_Menu_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Utilizadores_Menu_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Utilizadores_Menu_Aggregate_Bool_Exp_Count>;
};

export type Utilizadores_Menu_Aggregate_Bool_Exp_Bool_And = {
  arguments: Utilizadores_Menu_Select_Column_Utilizadores_Menu_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Utilizadores_Menu_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Utilizadores_Menu_Select_Column_Utilizadores_Menu_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Utilizadores_Menu_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Utilizadores_Menu_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "utilizadores.menu" */
export type Utilizadores_Menu_Aggregate_Fields = {
  __typename?: 'utilizadores_menu_aggregate_fields';
  avg?: Maybe<Utilizadores_Menu_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Menu_Max_Fields>;
  min?: Maybe<Utilizadores_Menu_Min_Fields>;
  stddev?: Maybe<Utilizadores_Menu_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Menu_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Menu_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Menu_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Menu_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Menu_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Menu_Variance_Fields>;
};


/** aggregate fields of "utilizadores.menu" */
export type Utilizadores_Menu_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Menu_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "utilizadores.menu" */
export type Utilizadores_Menu_Aggregate_Order_By = {
  avg?: InputMaybe<Utilizadores_Menu_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Utilizadores_Menu_Max_Order_By>;
  min?: InputMaybe<Utilizadores_Menu_Min_Order_By>;
  stddev?: InputMaybe<Utilizadores_Menu_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Utilizadores_Menu_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Utilizadores_Menu_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Utilizadores_Menu_Sum_Order_By>;
  var_pop?: InputMaybe<Utilizadores_Menu_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Utilizadores_Menu_Var_Samp_Order_By>;
  variance?: InputMaybe<Utilizadores_Menu_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "utilizadores.menu" */
export type Utilizadores_Menu_Arr_Rel_Insert_Input = {
  data: Array<Utilizadores_Menu_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Menu_On_Conflict>;
};

/** aggregate avg on columns */
export type Utilizadores_Menu_Avg_Fields = {
  __typename?: 'utilizadores_menu_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "utilizadores.menu" */
export type Utilizadores_Menu_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "utilizadores.menu". All fields are combined with a logical 'AND'. */
export type Utilizadores_Menu_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Menu_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Menu_Bool_Exp>>;
  has_childs?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_pai?: InputMaybe<Bigint_Comparison_Exp>;
  menuPai?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
  menuTransacoes?: InputMaybe<Permissoes_Transacoes_R_Menus_Bool_Exp>;
  menuTransacoes_aggregate?: InputMaybe<Permissoes_Transacoes_R_Menus_Aggregate_Bool_Exp>;
  menusFilhos?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
  menusFilhos_aggregate?: InputMaybe<Utilizadores_Menu_Aggregate_Bool_Exp>;
  new_ui?: InputMaybe<Boolean_Comparison_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
  texto?: InputMaybe<String_Comparison_Exp>;
  translation_key?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "utilizadores.menu" */
export enum Utilizadores_Menu_Constraint {
  /** unique or primary key constraint on columns "id" */
  MenuPkey = 'menu_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.menu" */
export type Utilizadores_Menu_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "utilizadores.menu" */
export type Utilizadores_Menu_Insert_Input = {
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  menuPai?: InputMaybe<Utilizadores_Menu_Obj_Rel_Insert_Input>;
  menuTransacoes?: InputMaybe<Permissoes_Transacoes_R_Menus_Arr_Rel_Insert_Input>;
  menusFilhos?: InputMaybe<Utilizadores_Menu_Arr_Rel_Insert_Input>;
  new_ui?: InputMaybe<Scalars['Boolean']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  texto?: InputMaybe<Scalars['String']['input']>;
  translation_key?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Utilizadores_Menu_Max_Fields = {
  __typename?: 'utilizadores_menu_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  texto?: Maybe<Scalars['String']['output']>;
  translation_key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "utilizadores.menu" */
export type Utilizadores_Menu_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  texto?: InputMaybe<Order_By>;
  translation_key?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Utilizadores_Menu_Min_Fields = {
  __typename?: 'utilizadores_menu_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  texto?: Maybe<Scalars['String']['output']>;
  translation_key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "utilizadores.menu" */
export type Utilizadores_Menu_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  texto?: InputMaybe<Order_By>;
  translation_key?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "utilizadores.menu" */
export type Utilizadores_Menu_Mutation_Response = {
  __typename?: 'utilizadores_menu_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Menu>;
};

/** input type for inserting object relation for remote table "utilizadores.menu" */
export type Utilizadores_Menu_Obj_Rel_Insert_Input = {
  data: Utilizadores_Menu_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Menu_On_Conflict>;
};

/** on_conflict condition type for table "utilizadores.menu" */
export type Utilizadores_Menu_On_Conflict = {
  constraint: Utilizadores_Menu_Constraint;
  update_columns?: Array<Utilizadores_Menu_Update_Column>;
  where?: InputMaybe<Utilizadores_Menu_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.menu". */
export type Utilizadores_Menu_Order_By = {
  has_childs?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  menuPai?: InputMaybe<Utilizadores_Menu_Order_By>;
  menuTransacoes_aggregate?: InputMaybe<Permissoes_Transacoes_R_Menus_Aggregate_Order_By>;
  menusFilhos_aggregate?: InputMaybe<Utilizadores_Menu_Aggregate_Order_By>;
  new_ui?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  texto?: InputMaybe<Order_By>;
  translation_key?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utilizadores.menu */
export type Utilizadores_Menu_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.menu" */
export enum Utilizadores_Menu_Select_Column {
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  Id = 'id',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  NewUi = 'new_ui',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  Texto = 'texto',
  /** column name */
  TranslationKey = 'translation_key',
  /** column name */
  Url = 'url'
}

/** select "utilizadores_menu_aggregate_bool_exp_bool_and_arguments_columns" columns of table "utilizadores.menu" */
export enum Utilizadores_Menu_Select_Column_Utilizadores_Menu_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  NewUi = 'new_ui'
}

/** select "utilizadores_menu_aggregate_bool_exp_bool_or_arguments_columns" columns of table "utilizadores.menu" */
export enum Utilizadores_Menu_Select_Column_Utilizadores_Menu_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  NewUi = 'new_ui'
}

/** input type for updating data in table "utilizadores.menu" */
export type Utilizadores_Menu_Set_Input = {
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  new_ui?: InputMaybe<Scalars['Boolean']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  texto?: InputMaybe<Scalars['String']['input']>;
  translation_key?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Menu_Stddev_Fields = {
  __typename?: 'utilizadores_menu_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "utilizadores.menu" */
export type Utilizadores_Menu_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Menu_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_menu_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "utilizadores.menu" */
export type Utilizadores_Menu_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Menu_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_menu_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "utilizadores.menu" */
export type Utilizadores_Menu_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "utilizadores_menu" */
export type Utilizadores_Menu_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Menu_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Menu_Stream_Cursor_Value_Input = {
  has_childs?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_pai?: InputMaybe<Scalars['bigint']['input']>;
  new_ui?: InputMaybe<Scalars['Boolean']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  texto?: InputMaybe<Scalars['String']['input']>;
  translation_key?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Menu_Sum_Fields = {
  __typename?: 'utilizadores_menu_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_pai?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "utilizadores.menu" */
export type Utilizadores_Menu_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** update columns of table "utilizadores.menu" */
export enum Utilizadores_Menu_Update_Column {
  /** column name */
  HasChilds = 'has_childs',
  /** column name */
  Id = 'id',
  /** column name */
  IdPai = 'id_pai',
  /** column name */
  NewUi = 'new_ui',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  Texto = 'texto',
  /** column name */
  TranslationKey = 'translation_key',
  /** column name */
  Url = 'url'
}

export type Utilizadores_Menu_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Menu_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Menu_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Menu_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Menu_Var_Pop_Fields = {
  __typename?: 'utilizadores_menu_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "utilizadores.menu" */
export type Utilizadores_Menu_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Menu_Var_Samp_Fields = {
  __typename?: 'utilizadores_menu_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "utilizadores.menu" */
export type Utilizadores_Menu_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Utilizadores_Menu_Variance_Fields = {
  __typename?: 'utilizadores_menu_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_pai?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "utilizadores.menu" */
export type Utilizadores_Menu_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_pai?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** columns and relationships of "utilizadores.temas" */
export type Utilizadores_Temas = {
  __typename?: 'utilizadores_temas';
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "utilizadores.temas" */
export type Utilizadores_Temas_Aggregate = {
  __typename?: 'utilizadores_temas_aggregate';
  aggregate?: Maybe<Utilizadores_Temas_Aggregate_Fields>;
  nodes: Array<Utilizadores_Temas>;
};

/** aggregate fields of "utilizadores.temas" */
export type Utilizadores_Temas_Aggregate_Fields = {
  __typename?: 'utilizadores_temas_aggregate_fields';
  avg?: Maybe<Utilizadores_Temas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Temas_Max_Fields>;
  min?: Maybe<Utilizadores_Temas_Min_Fields>;
  stddev?: Maybe<Utilizadores_Temas_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Temas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Temas_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Temas_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Temas_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Temas_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Temas_Variance_Fields>;
};


/** aggregate fields of "utilizadores.temas" */
export type Utilizadores_Temas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Temas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Utilizadores_Temas_Avg_Fields = {
  __typename?: 'utilizadores_temas_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "utilizadores.temas". All fields are combined with a logical 'AND'. */
export type Utilizadores_Temas_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Temas_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Temas_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Temas_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "utilizadores.temas" */
export enum Utilizadores_Temas_Constraint {
  /** unique or primary key constraint on columns "id" */
  TemasPkey = 'temas_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.temas" */
export type Utilizadores_Temas_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "utilizadores.temas" */
export type Utilizadores_Temas_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Utilizadores_Temas_Max_Fields = {
  __typename?: 'utilizadores_temas_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Utilizadores_Temas_Min_Fields = {
  __typename?: 'utilizadores_temas_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "utilizadores.temas" */
export type Utilizadores_Temas_Mutation_Response = {
  __typename?: 'utilizadores_temas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Temas>;
};

/** input type for inserting object relation for remote table "utilizadores.temas" */
export type Utilizadores_Temas_Obj_Rel_Insert_Input = {
  data: Utilizadores_Temas_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Temas_On_Conflict>;
};

/** on_conflict condition type for table "utilizadores.temas" */
export type Utilizadores_Temas_On_Conflict = {
  constraint: Utilizadores_Temas_Constraint;
  update_columns?: Array<Utilizadores_Temas_Update_Column>;
  where?: InputMaybe<Utilizadores_Temas_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.temas". */
export type Utilizadores_Temas_Order_By = {
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utilizadores.temas */
export type Utilizadores_Temas_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.temas" */
export enum Utilizadores_Temas_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "utilizadores.temas" */
export type Utilizadores_Temas_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Temas_Stddev_Fields = {
  __typename?: 'utilizadores_temas_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Temas_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_temas_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Temas_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_temas_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "utilizadores_temas" */
export type Utilizadores_Temas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Temas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Temas_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Temas_Sum_Fields = {
  __typename?: 'utilizadores_temas_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "utilizadores.temas" */
export enum Utilizadores_Temas_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Utilizadores_Temas_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Temas_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Temas_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Temas_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Temas_Var_Pop_Fields = {
  __typename?: 'utilizadores_temas_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Temas_Var_Samp_Fields = {
  __typename?: 'utilizadores_temas_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Utilizadores_Temas_Variance_Fields = {
  __typename?: 'utilizadores_temas_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "utilizadores.utilizadores" */
export type Utilizadores_Utilizadores = {
  __typename?: 'utilizadores_utilizadores';
  activo?: Maybe<Scalars['Boolean']['output']>;
  apagado?: Maybe<Scalars['Boolean']['output']>;
  auth_2p_codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  data_alter_pw?: Maybe<Scalars['timestamp']['output']>;
  data_bloq_temp?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  equipasVirtuais: Array<Utilizadores_Equipas_Virtuais_R_Utilizadores>;
  /** An aggregate relationship */
  equipasVirtuais_aggregate: Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate;
  id: Scalars['bigint']['output'];
  id_categoria?: Maybe<Scalars['bigint']['output']>;
  id_tema?: Maybe<Scalars['smallint']['output']>;
  login_tentativa_erro?: Maybe<Scalars['smallint']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  receber_alarmes?: Maybe<Scalars['Boolean']['output']>;
  receber_mensagens?: Maybe<Scalars['Boolean']['output']>;
  receber_notas_agenda?: Maybe<Scalars['Boolean']['output']>;
  receber_notificacoes?: Maybe<Scalars['Boolean']['output']>;
  receber_ocorrencias?: Maybe<Scalars['Boolean']['output']>;
  telefone?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tema?: Maybe<Utilizadores_Temas>;
  username: Scalars['String']['output'];
};


/** columns and relationships of "utilizadores.utilizadores" */
export type Utilizadores_UtilizadoresEquipasVirtuaisArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
};


/** columns and relationships of "utilizadores.utilizadores" */
export type Utilizadores_UtilizadoresEquipasVirtuais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_R_Utilizadores_Order_By>>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
};

/** aggregated selection of "utilizadores.utilizadores" */
export type Utilizadores_Utilizadores_Aggregate = {
  __typename?: 'utilizadores_utilizadores_aggregate';
  aggregate?: Maybe<Utilizadores_Utilizadores_Aggregate_Fields>;
  nodes: Array<Utilizadores_Utilizadores>;
};

/** aggregate fields of "utilizadores.utilizadores" */
export type Utilizadores_Utilizadores_Aggregate_Fields = {
  __typename?: 'utilizadores_utilizadores_aggregate_fields';
  avg?: Maybe<Utilizadores_Utilizadores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Utilizadores_Utilizadores_Max_Fields>;
  min?: Maybe<Utilizadores_Utilizadores_Min_Fields>;
  stddev?: Maybe<Utilizadores_Utilizadores_Stddev_Fields>;
  stddev_pop?: Maybe<Utilizadores_Utilizadores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Utilizadores_Utilizadores_Stddev_Samp_Fields>;
  sum?: Maybe<Utilizadores_Utilizadores_Sum_Fields>;
  var_pop?: Maybe<Utilizadores_Utilizadores_Var_Pop_Fields>;
  var_samp?: Maybe<Utilizadores_Utilizadores_Var_Samp_Fields>;
  variance?: Maybe<Utilizadores_Utilizadores_Variance_Fields>;
};


/** aggregate fields of "utilizadores.utilizadores" */
export type Utilizadores_Utilizadores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Utilizadores_Utilizadores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Utilizadores_Utilizadores_Avg_Fields = {
  __typename?: 'utilizadores_utilizadores_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_tema?: Maybe<Scalars['Float']['output']>;
  login_tentativa_erro?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "utilizadores.utilizadores". All fields are combined with a logical 'AND'. */
export type Utilizadores_Utilizadores_Bool_Exp = {
  _and?: InputMaybe<Array<Utilizadores_Utilizadores_Bool_Exp>>;
  _not?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
  _or?: InputMaybe<Array<Utilizadores_Utilizadores_Bool_Exp>>;
  activo?: InputMaybe<Boolean_Comparison_Exp>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  auth_2p_codigo?: InputMaybe<String_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  data_alter_pw?: InputMaybe<Timestamp_Comparison_Exp>;
  data_bloq_temp?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_registo_bd?: InputMaybe<Timestamp_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  equipasVirtuais?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Bool_Exp>;
  equipasVirtuais_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_categoria?: InputMaybe<Bigint_Comparison_Exp>;
  id_tema?: InputMaybe<Smallint_Comparison_Exp>;
  login_tentativa_erro?: InputMaybe<Smallint_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  receber_alarmes?: InputMaybe<Boolean_Comparison_Exp>;
  receber_mensagens?: InputMaybe<Boolean_Comparison_Exp>;
  receber_notas_agenda?: InputMaybe<Boolean_Comparison_Exp>;
  receber_notificacoes?: InputMaybe<Boolean_Comparison_Exp>;
  receber_ocorrencias?: InputMaybe<Boolean_Comparison_Exp>;
  telefone?: InputMaybe<String_Comparison_Exp>;
  tema?: InputMaybe<Utilizadores_Temas_Bool_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "utilizadores.utilizadores" */
export enum Utilizadores_Utilizadores_Constraint {
  /** unique or primary key constraint on columns "username" */
  IndUniqueUtilizadoresUsername = 'ind_unique_utilizadores_username',
  /** unique or primary key constraint on columns "id" */
  UtilizadoresPkey = 'utilizadores_pkey'
}

/** input type for incrementing numeric columns in table "utilizadores.utilizadores" */
export type Utilizadores_Utilizadores_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_categoria?: InputMaybe<Scalars['bigint']['input']>;
  id_tema?: InputMaybe<Scalars['smallint']['input']>;
  login_tentativa_erro?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "utilizadores.utilizadores" */
export type Utilizadores_Utilizadores_Insert_Input = {
  activo?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  auth_2p_codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  data_alter_pw?: InputMaybe<Scalars['timestamp']['input']>;
  data_bloq_temp?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  equipasVirtuais?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_categoria?: InputMaybe<Scalars['bigint']['input']>;
  id_tema?: InputMaybe<Scalars['smallint']['input']>;
  login_tentativa_erro?: InputMaybe<Scalars['smallint']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  receber_alarmes?: InputMaybe<Scalars['Boolean']['input']>;
  receber_mensagens?: InputMaybe<Scalars['Boolean']['input']>;
  receber_notas_agenda?: InputMaybe<Scalars['Boolean']['input']>;
  receber_notificacoes?: InputMaybe<Scalars['Boolean']['input']>;
  receber_ocorrencias?: InputMaybe<Scalars['Boolean']['input']>;
  telefone?: InputMaybe<Scalars['String']['input']>;
  tema?: InputMaybe<Utilizadores_Temas_Obj_Rel_Insert_Input>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Utilizadores_Utilizadores_Max_Fields = {
  __typename?: 'utilizadores_utilizadores_max_fields';
  auth_2p_codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  data_alter_pw?: Maybe<Scalars['timestamp']['output']>;
  data_bloq_temp?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_categoria?: Maybe<Scalars['bigint']['output']>;
  id_tema?: Maybe<Scalars['smallint']['output']>;
  login_tentativa_erro?: Maybe<Scalars['smallint']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  telefone?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Utilizadores_Utilizadores_Min_Fields = {
  __typename?: 'utilizadores_utilizadores_min_fields';
  auth_2p_codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  data_alter_pw?: Maybe<Scalars['timestamp']['output']>;
  data_bloq_temp?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_categoria?: Maybe<Scalars['bigint']['output']>;
  id_tema?: Maybe<Scalars['smallint']['output']>;
  login_tentativa_erro?: Maybe<Scalars['smallint']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  telefone?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "utilizadores.utilizadores" */
export type Utilizadores_Utilizadores_Mutation_Response = {
  __typename?: 'utilizadores_utilizadores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Utilizadores_Utilizadores>;
};

/** input type for inserting object relation for remote table "utilizadores.utilizadores" */
export type Utilizadores_Utilizadores_Obj_Rel_Insert_Input = {
  data: Utilizadores_Utilizadores_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Utilizadores_Utilizadores_On_Conflict>;
};

/** on_conflict condition type for table "utilizadores.utilizadores" */
export type Utilizadores_Utilizadores_On_Conflict = {
  constraint: Utilizadores_Utilizadores_Constraint;
  update_columns?: Array<Utilizadores_Utilizadores_Update_Column>;
  where?: InputMaybe<Utilizadores_Utilizadores_Bool_Exp>;
};

/** Ordering options when selecting data from "utilizadores.utilizadores". */
export type Utilizadores_Utilizadores_Order_By = {
  activo?: InputMaybe<Order_By>;
  apagado?: InputMaybe<Order_By>;
  auth_2p_codigo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  data_alter_pw?: InputMaybe<Order_By>;
  data_bloq_temp?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  equipasVirtuais_aggregate?: InputMaybe<Utilizadores_Equipas_Virtuais_R_Utilizadores_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_tema?: InputMaybe<Order_By>;
  login_tentativa_erro?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  receber_alarmes?: InputMaybe<Order_By>;
  receber_mensagens?: InputMaybe<Order_By>;
  receber_notas_agenda?: InputMaybe<Order_By>;
  receber_notificacoes?: InputMaybe<Order_By>;
  receber_ocorrencias?: InputMaybe<Order_By>;
  telefone?: InputMaybe<Order_By>;
  tema?: InputMaybe<Utilizadores_Temas_Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: utilizadores.utilizadores */
export type Utilizadores_Utilizadores_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "utilizadores.utilizadores" */
export enum Utilizadores_Utilizadores_Select_Column {
  /** column name */
  Activo = 'activo',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Auth_2pCodigo = 'auth_2p_codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  DataAlterPw = 'data_alter_pw',
  /** column name */
  DataBloqTemp = 'data_bloq_temp',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IdCategoria = 'id_categoria',
  /** column name */
  IdTema = 'id_tema',
  /** column name */
  LoginTentativaErro = 'login_tentativa_erro',
  /** column name */
  Password = 'password',
  /** column name */
  ReceberAlarmes = 'receber_alarmes',
  /** column name */
  ReceberMensagens = 'receber_mensagens',
  /** column name */
  ReceberNotasAgenda = 'receber_notas_agenda',
  /** column name */
  ReceberNotificacoes = 'receber_notificacoes',
  /** column name */
  ReceberOcorrencias = 'receber_ocorrencias',
  /** column name */
  Telefone = 'telefone',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "utilizadores.utilizadores" */
export type Utilizadores_Utilizadores_Set_Input = {
  activo?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  auth_2p_codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  data_alter_pw?: InputMaybe<Scalars['timestamp']['input']>;
  data_bloq_temp?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_categoria?: InputMaybe<Scalars['bigint']['input']>;
  id_tema?: InputMaybe<Scalars['smallint']['input']>;
  login_tentativa_erro?: InputMaybe<Scalars['smallint']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  receber_alarmes?: InputMaybe<Scalars['Boolean']['input']>;
  receber_mensagens?: InputMaybe<Scalars['Boolean']['input']>;
  receber_notas_agenda?: InputMaybe<Scalars['Boolean']['input']>;
  receber_notificacoes?: InputMaybe<Scalars['Boolean']['input']>;
  receber_ocorrencias?: InputMaybe<Scalars['Boolean']['input']>;
  telefone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Utilizadores_Utilizadores_Stddev_Fields = {
  __typename?: 'utilizadores_utilizadores_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_tema?: Maybe<Scalars['Float']['output']>;
  login_tentativa_erro?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Utilizadores_Utilizadores_Stddev_Pop_Fields = {
  __typename?: 'utilizadores_utilizadores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_tema?: Maybe<Scalars['Float']['output']>;
  login_tentativa_erro?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Utilizadores_Utilizadores_Stddev_Samp_Fields = {
  __typename?: 'utilizadores_utilizadores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_tema?: Maybe<Scalars['Float']['output']>;
  login_tentativa_erro?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "utilizadores_utilizadores" */
export type Utilizadores_Utilizadores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Utilizadores_Utilizadores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Utilizadores_Utilizadores_Stream_Cursor_Value_Input = {
  activo?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  auth_2p_codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  data_alter_pw?: InputMaybe<Scalars['timestamp']['input']>;
  data_bloq_temp?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_categoria?: InputMaybe<Scalars['bigint']['input']>;
  id_tema?: InputMaybe<Scalars['smallint']['input']>;
  login_tentativa_erro?: InputMaybe<Scalars['smallint']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  receber_alarmes?: InputMaybe<Scalars['Boolean']['input']>;
  receber_mensagens?: InputMaybe<Scalars['Boolean']['input']>;
  receber_notas_agenda?: InputMaybe<Scalars['Boolean']['input']>;
  receber_notificacoes?: InputMaybe<Scalars['Boolean']['input']>;
  receber_ocorrencias?: InputMaybe<Scalars['Boolean']['input']>;
  telefone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Utilizadores_Utilizadores_Sum_Fields = {
  __typename?: 'utilizadores_utilizadores_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_categoria?: Maybe<Scalars['bigint']['output']>;
  id_tema?: Maybe<Scalars['smallint']['output']>;
  login_tentativa_erro?: Maybe<Scalars['smallint']['output']>;
};

/** update columns of table "utilizadores.utilizadores" */
export enum Utilizadores_Utilizadores_Update_Column {
  /** column name */
  Activo = 'activo',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Auth_2pCodigo = 'auth_2p_codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  DataAlterPw = 'data_alter_pw',
  /** column name */
  DataBloqTemp = 'data_bloq_temp',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IdCategoria = 'id_categoria',
  /** column name */
  IdTema = 'id_tema',
  /** column name */
  LoginTentativaErro = 'login_tentativa_erro',
  /** column name */
  Password = 'password',
  /** column name */
  ReceberAlarmes = 'receber_alarmes',
  /** column name */
  ReceberMensagens = 'receber_mensagens',
  /** column name */
  ReceberNotasAgenda = 'receber_notas_agenda',
  /** column name */
  ReceberNotificacoes = 'receber_notificacoes',
  /** column name */
  ReceberOcorrencias = 'receber_ocorrencias',
  /** column name */
  Telefone = 'telefone',
  /** column name */
  Username = 'username'
}

export type Utilizadores_Utilizadores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Utilizadores_Utilizadores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Utilizadores_Utilizadores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Utilizadores_Utilizadores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Utilizadores_Utilizadores_Var_Pop_Fields = {
  __typename?: 'utilizadores_utilizadores_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_tema?: Maybe<Scalars['Float']['output']>;
  login_tentativa_erro?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Utilizadores_Utilizadores_Var_Samp_Fields = {
  __typename?: 'utilizadores_utilizadores_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_tema?: Maybe<Scalars['Float']['output']>;
  login_tentativa_erro?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Utilizadores_Utilizadores_Variance_Fields = {
  __typename?: 'utilizadores_utilizadores_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_tema?: Maybe<Scalars['Float']['output']>;
  login_tentativa_erro?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "variaveis.agregacao" */
export type Variaveis_Agregacao = {
  __typename?: 'variaveis_agregacao';
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "variaveis.agregacao" */
export type Variaveis_Agregacao_Aggregate = {
  __typename?: 'variaveis_agregacao_aggregate';
  aggregate?: Maybe<Variaveis_Agregacao_Aggregate_Fields>;
  nodes: Array<Variaveis_Agregacao>;
};

/** aggregate fields of "variaveis.agregacao" */
export type Variaveis_Agregacao_Aggregate_Fields = {
  __typename?: 'variaveis_agregacao_aggregate_fields';
  avg?: Maybe<Variaveis_Agregacao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Agregacao_Max_Fields>;
  min?: Maybe<Variaveis_Agregacao_Min_Fields>;
  stddev?: Maybe<Variaveis_Agregacao_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Agregacao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Agregacao_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Agregacao_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Agregacao_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Agregacao_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Agregacao_Variance_Fields>;
};


/** aggregate fields of "variaveis.agregacao" */
export type Variaveis_Agregacao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Agregacao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Agregacao_Avg_Fields = {
  __typename?: 'variaveis_agregacao_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.agregacao". All fields are combined with a logical 'AND'. */
export type Variaveis_Agregacao_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Agregacao_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Agregacao_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Agregacao_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.agregacao" */
export enum Variaveis_Agregacao_Constraint {
  /** unique or primary key constraint on columns "id" */
  AgregacaoPkey = 'agregacao_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.agregacao" */
export type Variaveis_Agregacao_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.agregacao" */
export type Variaveis_Agregacao_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Agregacao_Max_Fields = {
  __typename?: 'variaveis_agregacao_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Agregacao_Min_Fields = {
  __typename?: 'variaveis_agregacao_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "variaveis.agregacao" */
export type Variaveis_Agregacao_Mutation_Response = {
  __typename?: 'variaveis_agregacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Agregacao>;
};

/** input type for inserting object relation for remote table "variaveis.agregacao" */
export type Variaveis_Agregacao_Obj_Rel_Insert_Input = {
  data: Variaveis_Agregacao_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Agregacao_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.agregacao" */
export type Variaveis_Agregacao_On_Conflict = {
  constraint: Variaveis_Agregacao_Constraint;
  update_columns?: Array<Variaveis_Agregacao_Update_Column>;
  where?: InputMaybe<Variaveis_Agregacao_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.agregacao". */
export type Variaveis_Agregacao_Order_By = {
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.agregacao */
export type Variaveis_Agregacao_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.agregacao" */
export enum Variaveis_Agregacao_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "variaveis.agregacao" */
export type Variaveis_Agregacao_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Agregacao_Stddev_Fields = {
  __typename?: 'variaveis_agregacao_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Agregacao_Stddev_Pop_Fields = {
  __typename?: 'variaveis_agregacao_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Agregacao_Stddev_Samp_Fields = {
  __typename?: 'variaveis_agregacao_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_agregacao" */
export type Variaveis_Agregacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Agregacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Agregacao_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Agregacao_Sum_Fields = {
  __typename?: 'variaveis_agregacao_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "variaveis.agregacao" */
export enum Variaveis_Agregacao_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Variaveis_Agregacao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Agregacao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Agregacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Agregacao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Agregacao_Var_Pop_Fields = {
  __typename?: 'variaveis_agregacao_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Agregacao_Var_Samp_Fields = {
  __typename?: 'variaveis_agregacao_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Agregacao_Variance_Fields = {
  __typename?: 'variaveis_agregacao_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "variaveis.base" */
export type Variaveis_Base = {
  __typename?: 'variaveis_base';
  apagado: Scalars['Boolean']['output'];
  atributo: Scalars['Boolean']['output'];
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  com_valores_parametricos?: Maybe<Scalars['Boolean']['output']>;
  cumpre_valores_parametricos?: Maybe<Scalars['Boolean']['output']>;
  desativado: Scalars['Boolean']['output'];
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  dominio?: Maybe<Variaveis_Dominios>;
  filtro_and_variaveis?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  fonteOrigem: Array<Variaveis_Fontes_Origem>;
  /** An aggregate relationship */
  fonteOrigem_aggregate: Variaveis_Fontes_Origem_Aggregate;
  id: Scalars['bigint']['output'];
  id_categoria?: Maybe<Scalars['bigint']['output']>;
  id_dominio: Scalars['bigint']['output'];
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_filtro_data?: Maybe<Scalars['smallint']['output']>;
  id_origem_dados?: Maybe<Scalars['bigint']['output']>;
  id_parametro?: Maybe<Scalars['bigint']['output']>;
  id_plano_controlo_tipo?: Maybe<Scalars['bigint']['output']>;
  id_sub_dominio?: Maybe<Scalars['bigint']['output']>;
  id_tipo: Scalars['bigint']['output'];
  id_totalizador?: Maybe<Scalars['bigint']['output']>;
  ids_clientes?: Maybe<Scalars['String']['output']>;
  ids_contratos?: Maybe<Scalars['String']['output']>;
  ids_estado_validacao_tarefas?: Maybe<Scalars['String']['output']>;
  ids_estado_validacao_tipo_regiao?: Maybe<Scalars['String']['output']>;
  ids_estados_amostra?: Maybe<Scalars['String']['output']>;
  ids_estados_tarefas?: Maybe<Scalars['String']['output']>;
  ids_medidores?: Maybe<Scalars['String']['output']>;
  ids_modelos_tarefas?: Maybe<Scalars['String']['output']>;
  ids_tipos_tarefas?: Maybe<Scalars['String']['output']>;
  ind_id_reagente?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  parametro?: Maybe<Variaveis_Parametros>;
  /** An array relationship */
  parciais: Array<Variaveis_Base>;
  /** An aggregate relationship */
  parciais_aggregate: Variaveis_Base_Aggregate;
  /** An array relationship */
  propriedades: Array<Variaveis_Base_Propriedades>;
  /** An aggregate relationship */
  propriedades_aggregate: Variaveis_Base_Propriedades_Aggregate;
  str_incompletas?: Maybe<Scalars['String']['output']>;
  str_planeadas?: Maybe<Scalars['String']['output']>;
  tarefa_descricao?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tipo: Variaveis_Tipos;
  /** An object relationship */
  totalizador?: Maybe<Variaveis_Base>;
  /** An array relationship */
  valoresMensais: Array<Variaveis_Valores_Mensais>;
  /** An aggregate relationship */
  valoresMensais_aggregate: Variaveis_Valores_Mensais_Aggregate;
  /** An array relationship */
  variaveisCalculo: Array<Variaveis_Base_Calc_Variaveis>;
  /** An aggregate relationship */
  variaveisCalculo_aggregate: Variaveis_Base_Calc_Variaveis_Aggregate;
};


/** columns and relationships of "variaveis.base" */
export type Variaveis_BaseFonteOrigemArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
};


/** columns and relationships of "variaveis.base" */
export type Variaveis_BaseFonteOrigem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
};


/** columns and relationships of "variaveis.base" */
export type Variaveis_BaseParciaisArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Bool_Exp>;
};


/** columns and relationships of "variaveis.base" */
export type Variaveis_BaseParciais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Bool_Exp>;
};


/** columns and relationships of "variaveis.base" */
export type Variaveis_BasePropriedadesArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
};


/** columns and relationships of "variaveis.base" */
export type Variaveis_BasePropriedades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Propriedades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Propriedades_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
};


/** columns and relationships of "variaveis.base" */
export type Variaveis_BaseValoresMensaisArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Valores_Mensais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Valores_Mensais_Order_By>>;
  where?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
};


/** columns and relationships of "variaveis.base" */
export type Variaveis_BaseValoresMensais_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Valores_Mensais_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Valores_Mensais_Order_By>>;
  where?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
};


/** columns and relationships of "variaveis.base" */
export type Variaveis_BaseVariaveisCalculoArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Calc_Variaveis_Bool_Exp>;
};


/** columns and relationships of "variaveis.base" */
export type Variaveis_BaseVariaveisCalculo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Calc_Variaveis_Bool_Exp>;
};

/** aggregated selection of "variaveis.base" */
export type Variaveis_Base_Aggregate = {
  __typename?: 'variaveis_base_aggregate';
  aggregate?: Maybe<Variaveis_Base_Aggregate_Fields>;
  nodes: Array<Variaveis_Base>;
};

export type Variaveis_Base_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Variaveis_Base_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Variaveis_Base_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Variaveis_Base_Aggregate_Bool_Exp_Count>;
};

export type Variaveis_Base_Aggregate_Bool_Exp_Bool_And = {
  arguments: Variaveis_Base_Select_Column_Variaveis_Base_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Base_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Base_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Variaveis_Base_Select_Column_Variaveis_Base_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Base_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Base_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variaveis_Base_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Base_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variaveis.base" */
export type Variaveis_Base_Aggregate_Fields = {
  __typename?: 'variaveis_base_aggregate_fields';
  avg?: Maybe<Variaveis_Base_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Base_Max_Fields>;
  min?: Maybe<Variaveis_Base_Min_Fields>;
  stddev?: Maybe<Variaveis_Base_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Base_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Base_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Base_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Base_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Base_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Base_Variance_Fields>;
};


/** aggregate fields of "variaveis.base" */
export type Variaveis_Base_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Base_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variaveis.base" */
export type Variaveis_Base_Aggregate_Order_By = {
  avg?: InputMaybe<Variaveis_Base_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variaveis_Base_Max_Order_By>;
  min?: InputMaybe<Variaveis_Base_Min_Order_By>;
  stddev?: InputMaybe<Variaveis_Base_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variaveis_Base_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variaveis_Base_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variaveis_Base_Sum_Order_By>;
  var_pop?: InputMaybe<Variaveis_Base_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variaveis_Base_Var_Samp_Order_By>;
  variance?: InputMaybe<Variaveis_Base_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variaveis.base" */
export type Variaveis_Base_Arr_Rel_Insert_Input = {
  data: Array<Variaveis_Base_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Base_On_Conflict>;
};

/** aggregate avg on columns */
export type Variaveis_Base_Avg_Fields = {
  __typename?: 'variaveis_base_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_filtro_data?: Maybe<Scalars['Float']['output']>;
  id_origem_dados?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_tipo?: Maybe<Scalars['Float']['output']>;
  id_sub_dominio?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
  id_totalizador?: Maybe<Scalars['Float']['output']>;
  ind_id_reagente?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variaveis.base" */
export type Variaveis_Base_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_filtro_data?: InputMaybe<Order_By>;
  id_origem_dados?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_plano_controlo_tipo?: InputMaybe<Order_By>;
  id_sub_dominio?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  id_totalizador?: InputMaybe<Order_By>;
  ind_id_reagente?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variaveis.base". All fields are combined with a logical 'AND'. */
export type Variaveis_Base_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Base_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Base_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Base_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  atributo?: InputMaybe<Boolean_Comparison_Exp>;
  codigo?: InputMaybe<String_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  com_valores_parametricos?: InputMaybe<Boolean_Comparison_Exp>;
  cumpre_valores_parametricos?: InputMaybe<Boolean_Comparison_Exp>;
  desativado?: InputMaybe<Boolean_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  descricao_curta?: InputMaybe<String_Comparison_Exp>;
  dominio?: InputMaybe<Variaveis_Dominios_Bool_Exp>;
  filtro_and_variaveis?: InputMaybe<Boolean_Comparison_Exp>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
  fonteOrigem_aggregate?: InputMaybe<Variaveis_Fontes_Origem_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_categoria?: InputMaybe<Bigint_Comparison_Exp>;
  id_dominio?: InputMaybe<Bigint_Comparison_Exp>;
  id_fase?: InputMaybe<Bigint_Comparison_Exp>;
  id_filtro_data?: InputMaybe<Smallint_Comparison_Exp>;
  id_origem_dados?: InputMaybe<Bigint_Comparison_Exp>;
  id_parametro?: InputMaybe<Bigint_Comparison_Exp>;
  id_plano_controlo_tipo?: InputMaybe<Bigint_Comparison_Exp>;
  id_sub_dominio?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo?: InputMaybe<Bigint_Comparison_Exp>;
  id_totalizador?: InputMaybe<Bigint_Comparison_Exp>;
  ids_clientes?: InputMaybe<String_Comparison_Exp>;
  ids_contratos?: InputMaybe<String_Comparison_Exp>;
  ids_estado_validacao_tarefas?: InputMaybe<String_Comparison_Exp>;
  ids_estado_validacao_tipo_regiao?: InputMaybe<String_Comparison_Exp>;
  ids_estados_amostra?: InputMaybe<String_Comparison_Exp>;
  ids_estados_tarefas?: InputMaybe<String_Comparison_Exp>;
  ids_medidores?: InputMaybe<String_Comparison_Exp>;
  ids_modelos_tarefas?: InputMaybe<String_Comparison_Exp>;
  ids_tipos_tarefas?: InputMaybe<String_Comparison_Exp>;
  ind_id_reagente?: InputMaybe<Bigint_Comparison_Exp>;
  parametro?: InputMaybe<Variaveis_Parametros_Bool_Exp>;
  parciais?: InputMaybe<Variaveis_Base_Bool_Exp>;
  parciais_aggregate?: InputMaybe<Variaveis_Base_Aggregate_Bool_Exp>;
  propriedades?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
  propriedades_aggregate?: InputMaybe<Variaveis_Base_Propriedades_Aggregate_Bool_Exp>;
  str_incompletas?: InputMaybe<String_Comparison_Exp>;
  str_planeadas?: InputMaybe<String_Comparison_Exp>;
  tarefa_descricao?: InputMaybe<String_Comparison_Exp>;
  tipo?: InputMaybe<Variaveis_Tipos_Bool_Exp>;
  totalizador?: InputMaybe<Variaveis_Base_Bool_Exp>;
  valoresMensais?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
  valoresMensais_aggregate?: InputMaybe<Variaveis_Valores_Mensais_Aggregate_Bool_Exp>;
  variaveisCalculo?: InputMaybe<Variaveis_Base_Calc_Variaveis_Bool_Exp>;
  variaveisCalculo_aggregate?: InputMaybe<Variaveis_Base_Calc_Variaveis_Aggregate_Bool_Exp>;
};

/** columns and relationships of "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis = {
  __typename?: 'variaveis_base_calc_variaveis';
  /** An object relationship */
  fonteOrigem?: Maybe<Variaveis_Fontes_Origem>;
  id: Scalars['bigint']['output'];
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_dados?: Maybe<Scalars['bigint']['output']>;
  id_var_calculada?: Maybe<Scalars['bigint']['output']>;
  str_variavel?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  variavelCalculada?: Maybe<Variaveis_Base>;
};

/** aggregated selection of "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Aggregate = {
  __typename?: 'variaveis_base_calc_variaveis_aggregate';
  aggregate?: Maybe<Variaveis_Base_Calc_Variaveis_Aggregate_Fields>;
  nodes: Array<Variaveis_Base_Calc_Variaveis>;
};

export type Variaveis_Base_Calc_Variaveis_Aggregate_Bool_Exp = {
  count?: InputMaybe<Variaveis_Base_Calc_Variaveis_Aggregate_Bool_Exp_Count>;
};

export type Variaveis_Base_Calc_Variaveis_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Base_Calc_Variaveis_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Aggregate_Fields = {
  __typename?: 'variaveis_base_calc_variaveis_aggregate_fields';
  avg?: Maybe<Variaveis_Base_Calc_Variaveis_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Base_Calc_Variaveis_Max_Fields>;
  min?: Maybe<Variaveis_Base_Calc_Variaveis_Min_Fields>;
  stddev?: Maybe<Variaveis_Base_Calc_Variaveis_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Base_Calc_Variaveis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Base_Calc_Variaveis_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Base_Calc_Variaveis_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Base_Calc_Variaveis_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Base_Calc_Variaveis_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Base_Calc_Variaveis_Variance_Fields>;
};


/** aggregate fields of "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Aggregate_Order_By = {
  avg?: InputMaybe<Variaveis_Base_Calc_Variaveis_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variaveis_Base_Calc_Variaveis_Max_Order_By>;
  min?: InputMaybe<Variaveis_Base_Calc_Variaveis_Min_Order_By>;
  stddev?: InputMaybe<Variaveis_Base_Calc_Variaveis_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variaveis_Base_Calc_Variaveis_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variaveis_Base_Calc_Variaveis_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variaveis_Base_Calc_Variaveis_Sum_Order_By>;
  var_pop?: InputMaybe<Variaveis_Base_Calc_Variaveis_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variaveis_Base_Calc_Variaveis_Var_Samp_Order_By>;
  variance?: InputMaybe<Variaveis_Base_Calc_Variaveis_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Arr_Rel_Insert_Input = {
  data: Array<Variaveis_Base_Calc_Variaveis_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Base_Calc_Variaveis_On_Conflict>;
};

/** aggregate avg on columns */
export type Variaveis_Base_Calc_Variaveis_Avg_Fields = {
  __typename?: 'variaveis_base_calc_variaveis_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_dados?: Maybe<Scalars['Float']['output']>;
  id_var_calculada?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_dados?: InputMaybe<Order_By>;
  id_var_calculada?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variaveis.base_calc_variaveis". All fields are combined with a logical 'AND'. */
export type Variaveis_Base_Calc_Variaveis_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Base_Calc_Variaveis_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Base_Calc_Variaveis_Bool_Exp>>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_fonte_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_dados?: InputMaybe<Bigint_Comparison_Exp>;
  id_var_calculada?: InputMaybe<Bigint_Comparison_Exp>;
  str_variavel?: InputMaybe<String_Comparison_Exp>;
  variavelCalculada?: InputMaybe<Variaveis_Base_Bool_Exp>;
};

/** unique or primary key constraints on table "variaveis.base_calc_variaveis" */
export enum Variaveis_Base_Calc_Variaveis_Constraint {
  /** unique or primary key constraint on columns "id" */
  BaseCalcVariaveisPkey = 'base_calc_variaveis_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_dados?: InputMaybe<Scalars['bigint']['input']>;
  id_var_calculada?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Insert_Input = {
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_dados?: InputMaybe<Scalars['bigint']['input']>;
  id_var_calculada?: InputMaybe<Scalars['bigint']['input']>;
  str_variavel?: InputMaybe<Scalars['String']['input']>;
  variavelCalculada?: InputMaybe<Variaveis_Base_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Variaveis_Base_Calc_Variaveis_Max_Fields = {
  __typename?: 'variaveis_base_calc_variaveis_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_dados?: Maybe<Scalars['bigint']['output']>;
  id_var_calculada?: Maybe<Scalars['bigint']['output']>;
  str_variavel?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_dados?: InputMaybe<Order_By>;
  id_var_calculada?: InputMaybe<Order_By>;
  str_variavel?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variaveis_Base_Calc_Variaveis_Min_Fields = {
  __typename?: 'variaveis_base_calc_variaveis_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_dados?: Maybe<Scalars['bigint']['output']>;
  id_var_calculada?: Maybe<Scalars['bigint']['output']>;
  str_variavel?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_dados?: InputMaybe<Order_By>;
  id_var_calculada?: InputMaybe<Order_By>;
  str_variavel?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Mutation_Response = {
  __typename?: 'variaveis_base_calc_variaveis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Base_Calc_Variaveis>;
};

/** on_conflict condition type for table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_On_Conflict = {
  constraint: Variaveis_Base_Calc_Variaveis_Constraint;
  update_columns?: Array<Variaveis_Base_Calc_Variaveis_Update_Column>;
  where?: InputMaybe<Variaveis_Base_Calc_Variaveis_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.base_calc_variaveis". */
export type Variaveis_Base_Calc_Variaveis_Order_By = {
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Order_By>;
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_dados?: InputMaybe<Order_By>;
  id_var_calculada?: InputMaybe<Order_By>;
  str_variavel?: InputMaybe<Order_By>;
  variavelCalculada?: InputMaybe<Variaveis_Base_Order_By>;
};

/** primary key columns input for table: variaveis.base_calc_variaveis */
export type Variaveis_Base_Calc_Variaveis_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.base_calc_variaveis" */
export enum Variaveis_Base_Calc_Variaveis_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdTipoDados = 'id_tipo_dados',
  /** column name */
  IdVarCalculada = 'id_var_calculada',
  /** column name */
  StrVariavel = 'str_variavel'
}

/** input type for updating data in table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_dados?: InputMaybe<Scalars['bigint']['input']>;
  id_var_calculada?: InputMaybe<Scalars['bigint']['input']>;
  str_variavel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Base_Calc_Variaveis_Stddev_Fields = {
  __typename?: 'variaveis_base_calc_variaveis_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_dados?: Maybe<Scalars['Float']['output']>;
  id_var_calculada?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_dados?: InputMaybe<Order_By>;
  id_var_calculada?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Base_Calc_Variaveis_Stddev_Pop_Fields = {
  __typename?: 'variaveis_base_calc_variaveis_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_dados?: Maybe<Scalars['Float']['output']>;
  id_var_calculada?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_dados?: InputMaybe<Order_By>;
  id_var_calculada?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Base_Calc_Variaveis_Stddev_Samp_Fields = {
  __typename?: 'variaveis_base_calc_variaveis_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_dados?: Maybe<Scalars['Float']['output']>;
  id_var_calculada?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_dados?: InputMaybe<Order_By>;
  id_var_calculada?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variaveis_base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Base_Calc_Variaveis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Base_Calc_Variaveis_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_dados?: InputMaybe<Scalars['bigint']['input']>;
  id_var_calculada?: InputMaybe<Scalars['bigint']['input']>;
  str_variavel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Base_Calc_Variaveis_Sum_Fields = {
  __typename?: 'variaveis_base_calc_variaveis_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_dados?: Maybe<Scalars['bigint']['output']>;
  id_var_calculada?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_dados?: InputMaybe<Order_By>;
  id_var_calculada?: InputMaybe<Order_By>;
};

/** update columns of table "variaveis.base_calc_variaveis" */
export enum Variaveis_Base_Calc_Variaveis_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdTipoDados = 'id_tipo_dados',
  /** column name */
  IdVarCalculada = 'id_var_calculada',
  /** column name */
  StrVariavel = 'str_variavel'
}

export type Variaveis_Base_Calc_Variaveis_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Base_Calc_Variaveis_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Base_Calc_Variaveis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Base_Calc_Variaveis_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Base_Calc_Variaveis_Var_Pop_Fields = {
  __typename?: 'variaveis_base_calc_variaveis_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_dados?: Maybe<Scalars['Float']['output']>;
  id_var_calculada?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_dados?: InputMaybe<Order_By>;
  id_var_calculada?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variaveis_Base_Calc_Variaveis_Var_Samp_Fields = {
  __typename?: 'variaveis_base_calc_variaveis_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_dados?: Maybe<Scalars['Float']['output']>;
  id_var_calculada?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_dados?: InputMaybe<Order_By>;
  id_var_calculada?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variaveis_Base_Calc_Variaveis_Variance_Fields = {
  __typename?: 'variaveis_base_calc_variaveis_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_dados?: Maybe<Scalars['Float']['output']>;
  id_var_calculada?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variaveis.base_calc_variaveis" */
export type Variaveis_Base_Calc_Variaveis_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_dados?: InputMaybe<Order_By>;
  id_var_calculada?: InputMaybe<Order_By>;
};

/** columns and relationships of "variaveis.base_categorias" */
export type Variaveis_Base_Categorias = {
  __typename?: 'variaveis_base_categorias';
  apagado: Scalars['Boolean']['output'];
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "variaveis.base_categorias" */
export type Variaveis_Base_Categorias_Aggregate = {
  __typename?: 'variaveis_base_categorias_aggregate';
  aggregate?: Maybe<Variaveis_Base_Categorias_Aggregate_Fields>;
  nodes: Array<Variaveis_Base_Categorias>;
};

/** aggregate fields of "variaveis.base_categorias" */
export type Variaveis_Base_Categorias_Aggregate_Fields = {
  __typename?: 'variaveis_base_categorias_aggregate_fields';
  avg?: Maybe<Variaveis_Base_Categorias_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Base_Categorias_Max_Fields>;
  min?: Maybe<Variaveis_Base_Categorias_Min_Fields>;
  stddev?: Maybe<Variaveis_Base_Categorias_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Base_Categorias_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Base_Categorias_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Base_Categorias_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Base_Categorias_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Base_Categorias_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Base_Categorias_Variance_Fields>;
};


/** aggregate fields of "variaveis.base_categorias" */
export type Variaveis_Base_Categorias_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Base_Categorias_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Base_Categorias_Avg_Fields = {
  __typename?: 'variaveis_base_categorias_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.base_categorias". All fields are combined with a logical 'AND'. */
export type Variaveis_Base_Categorias_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Base_Categorias_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Base_Categorias_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Base_Categorias_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.base_categorias" */
export enum Variaveis_Base_Categorias_Constraint {
  /** unique or primary key constraint on columns "id" */
  BaseCategoriasPkey = 'base_categorias_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.base_categorias" */
export type Variaveis_Base_Categorias_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.base_categorias" */
export type Variaveis_Base_Categorias_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Base_Categorias_Max_Fields = {
  __typename?: 'variaveis_base_categorias_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Base_Categorias_Min_Fields = {
  __typename?: 'variaveis_base_categorias_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "variaveis.base_categorias" */
export type Variaveis_Base_Categorias_Mutation_Response = {
  __typename?: 'variaveis_base_categorias_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Base_Categorias>;
};

/** on_conflict condition type for table "variaveis.base_categorias" */
export type Variaveis_Base_Categorias_On_Conflict = {
  constraint: Variaveis_Base_Categorias_Constraint;
  update_columns?: Array<Variaveis_Base_Categorias_Update_Column>;
  where?: InputMaybe<Variaveis_Base_Categorias_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.base_categorias". */
export type Variaveis_Base_Categorias_Order_By = {
  apagado?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.base_categorias */
export type Variaveis_Base_Categorias_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.base_categorias" */
export enum Variaveis_Base_Categorias_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "variaveis.base_categorias" */
export type Variaveis_Base_Categorias_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Base_Categorias_Stddev_Fields = {
  __typename?: 'variaveis_base_categorias_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Base_Categorias_Stddev_Pop_Fields = {
  __typename?: 'variaveis_base_categorias_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Base_Categorias_Stddev_Samp_Fields = {
  __typename?: 'variaveis_base_categorias_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_base_categorias" */
export type Variaveis_Base_Categorias_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Base_Categorias_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Base_Categorias_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Base_Categorias_Sum_Fields = {
  __typename?: 'variaveis_base_categorias_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "variaveis.base_categorias" */
export enum Variaveis_Base_Categorias_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Variaveis_Base_Categorias_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Base_Categorias_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Base_Categorias_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Base_Categorias_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Base_Categorias_Var_Pop_Fields = {
  __typename?: 'variaveis_base_categorias_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Base_Categorias_Var_Samp_Fields = {
  __typename?: 'variaveis_base_categorias_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Base_Categorias_Variance_Fields = {
  __typename?: 'variaveis_base_categorias_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** unique or primary key constraints on table "variaveis.base" */
export enum Variaveis_Base_Constraint {
  /** unique or primary key constraint on columns "id" */
  GlobaisPkey = 'globais_pkey',
  /** unique or primary key constraint on columns "codigo_externo" */
  UniqueCodigoExterno = 'unique_codigo_externo',
  /** unique or primary key constraint on columns "id_dominio", "id_tipo", "id_parametro", "atributo", "descricao" */
  UniqueVariavelDescricaoParametroTipoDominoAtributo = 'unique_variavel_descricao_parametro_tipo_domino_atributo'
}

/** input type for incrementing numeric columns in table "variaveis.base" */
export type Variaveis_Base_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_categoria?: InputMaybe<Scalars['bigint']['input']>;
  id_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_filtro_data?: InputMaybe<Scalars['smallint']['input']>;
  id_origem_dados?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_controlo_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_sub_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_totalizador?: InputMaybe<Scalars['bigint']['input']>;
  ind_id_reagente?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.base" */
export type Variaveis_Base_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atributo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  com_valores_parametricos?: InputMaybe<Scalars['Boolean']['input']>;
  cumpre_valores_parametricos?: InputMaybe<Scalars['Boolean']['input']>;
  desativado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  dominio?: InputMaybe<Variaveis_Dominios_Obj_Rel_Insert_Input>;
  filtro_and_variaveis?: InputMaybe<Scalars['Boolean']['input']>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_categoria?: InputMaybe<Scalars['bigint']['input']>;
  id_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_filtro_data?: InputMaybe<Scalars['smallint']['input']>;
  id_origem_dados?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_controlo_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_sub_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_totalizador?: InputMaybe<Scalars['bigint']['input']>;
  ids_clientes?: InputMaybe<Scalars['String']['input']>;
  ids_contratos?: InputMaybe<Scalars['String']['input']>;
  ids_estado_validacao_tarefas?: InputMaybe<Scalars['String']['input']>;
  ids_estado_validacao_tipo_regiao?: InputMaybe<Scalars['String']['input']>;
  ids_estados_amostra?: InputMaybe<Scalars['String']['input']>;
  ids_estados_tarefas?: InputMaybe<Scalars['String']['input']>;
  ids_medidores?: InputMaybe<Scalars['String']['input']>;
  ids_modelos_tarefas?: InputMaybe<Scalars['String']['input']>;
  ids_tipos_tarefas?: InputMaybe<Scalars['String']['input']>;
  ind_id_reagente?: InputMaybe<Scalars['bigint']['input']>;
  parametro?: InputMaybe<Variaveis_Parametros_Obj_Rel_Insert_Input>;
  parciais?: InputMaybe<Variaveis_Base_Arr_Rel_Insert_Input>;
  propriedades?: InputMaybe<Variaveis_Base_Propriedades_Arr_Rel_Insert_Input>;
  str_incompletas?: InputMaybe<Scalars['String']['input']>;
  str_planeadas?: InputMaybe<Scalars['String']['input']>;
  tarefa_descricao?: InputMaybe<Scalars['String']['input']>;
  tipo?: InputMaybe<Variaveis_Tipos_Obj_Rel_Insert_Input>;
  totalizador?: InputMaybe<Variaveis_Base_Obj_Rel_Insert_Input>;
  valoresMensais?: InputMaybe<Variaveis_Valores_Mensais_Arr_Rel_Insert_Input>;
  variaveisCalculo?: InputMaybe<Variaveis_Base_Calc_Variaveis_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Variaveis_Base_Max_Fields = {
  __typename?: 'variaveis_base_max_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_categoria?: Maybe<Scalars['bigint']['output']>;
  id_dominio?: Maybe<Scalars['bigint']['output']>;
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_filtro_data?: Maybe<Scalars['smallint']['output']>;
  id_origem_dados?: Maybe<Scalars['bigint']['output']>;
  id_parametro?: Maybe<Scalars['bigint']['output']>;
  id_plano_controlo_tipo?: Maybe<Scalars['bigint']['output']>;
  id_sub_dominio?: Maybe<Scalars['bigint']['output']>;
  id_tipo?: Maybe<Scalars['bigint']['output']>;
  id_totalizador?: Maybe<Scalars['bigint']['output']>;
  ids_clientes?: Maybe<Scalars['String']['output']>;
  ids_contratos?: Maybe<Scalars['String']['output']>;
  ids_estado_validacao_tarefas?: Maybe<Scalars['String']['output']>;
  ids_estado_validacao_tipo_regiao?: Maybe<Scalars['String']['output']>;
  ids_estados_amostra?: Maybe<Scalars['String']['output']>;
  ids_estados_tarefas?: Maybe<Scalars['String']['output']>;
  ids_medidores?: Maybe<Scalars['String']['output']>;
  ids_modelos_tarefas?: Maybe<Scalars['String']['output']>;
  ids_tipos_tarefas?: Maybe<Scalars['String']['output']>;
  ind_id_reagente?: Maybe<Scalars['bigint']['output']>;
  str_incompletas?: Maybe<Scalars['String']['output']>;
  str_planeadas?: Maybe<Scalars['String']['output']>;
  tarefa_descricao?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "variaveis.base" */
export type Variaveis_Base_Max_Order_By = {
  codigo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_filtro_data?: InputMaybe<Order_By>;
  id_origem_dados?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_plano_controlo_tipo?: InputMaybe<Order_By>;
  id_sub_dominio?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  id_totalizador?: InputMaybe<Order_By>;
  ids_clientes?: InputMaybe<Order_By>;
  ids_contratos?: InputMaybe<Order_By>;
  ids_estado_validacao_tarefas?: InputMaybe<Order_By>;
  ids_estado_validacao_tipo_regiao?: InputMaybe<Order_By>;
  ids_estados_amostra?: InputMaybe<Order_By>;
  ids_estados_tarefas?: InputMaybe<Order_By>;
  ids_medidores?: InputMaybe<Order_By>;
  ids_modelos_tarefas?: InputMaybe<Order_By>;
  ids_tipos_tarefas?: InputMaybe<Order_By>;
  ind_id_reagente?: InputMaybe<Order_By>;
  str_incompletas?: InputMaybe<Order_By>;
  str_planeadas?: InputMaybe<Order_By>;
  tarefa_descricao?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variaveis_Base_Min_Fields = {
  __typename?: 'variaveis_base_min_fields';
  codigo?: Maybe<Scalars['String']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_categoria?: Maybe<Scalars['bigint']['output']>;
  id_dominio?: Maybe<Scalars['bigint']['output']>;
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_filtro_data?: Maybe<Scalars['smallint']['output']>;
  id_origem_dados?: Maybe<Scalars['bigint']['output']>;
  id_parametro?: Maybe<Scalars['bigint']['output']>;
  id_plano_controlo_tipo?: Maybe<Scalars['bigint']['output']>;
  id_sub_dominio?: Maybe<Scalars['bigint']['output']>;
  id_tipo?: Maybe<Scalars['bigint']['output']>;
  id_totalizador?: Maybe<Scalars['bigint']['output']>;
  ids_clientes?: Maybe<Scalars['String']['output']>;
  ids_contratos?: Maybe<Scalars['String']['output']>;
  ids_estado_validacao_tarefas?: Maybe<Scalars['String']['output']>;
  ids_estado_validacao_tipo_regiao?: Maybe<Scalars['String']['output']>;
  ids_estados_amostra?: Maybe<Scalars['String']['output']>;
  ids_estados_tarefas?: Maybe<Scalars['String']['output']>;
  ids_medidores?: Maybe<Scalars['String']['output']>;
  ids_modelos_tarefas?: Maybe<Scalars['String']['output']>;
  ids_tipos_tarefas?: Maybe<Scalars['String']['output']>;
  ind_id_reagente?: Maybe<Scalars['bigint']['output']>;
  str_incompletas?: Maybe<Scalars['String']['output']>;
  str_planeadas?: Maybe<Scalars['String']['output']>;
  tarefa_descricao?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "variaveis.base" */
export type Variaveis_Base_Min_Order_By = {
  codigo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_filtro_data?: InputMaybe<Order_By>;
  id_origem_dados?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_plano_controlo_tipo?: InputMaybe<Order_By>;
  id_sub_dominio?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  id_totalizador?: InputMaybe<Order_By>;
  ids_clientes?: InputMaybe<Order_By>;
  ids_contratos?: InputMaybe<Order_By>;
  ids_estado_validacao_tarefas?: InputMaybe<Order_By>;
  ids_estado_validacao_tipo_regiao?: InputMaybe<Order_By>;
  ids_estados_amostra?: InputMaybe<Order_By>;
  ids_estados_tarefas?: InputMaybe<Order_By>;
  ids_medidores?: InputMaybe<Order_By>;
  ids_modelos_tarefas?: InputMaybe<Order_By>;
  ids_tipos_tarefas?: InputMaybe<Order_By>;
  ind_id_reagente?: InputMaybe<Order_By>;
  str_incompletas?: InputMaybe<Order_By>;
  str_planeadas?: InputMaybe<Order_By>;
  tarefa_descricao?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variaveis.base" */
export type Variaveis_Base_Mutation_Response = {
  __typename?: 'variaveis_base_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Base>;
};

/** input type for inserting object relation for remote table "variaveis.base" */
export type Variaveis_Base_Obj_Rel_Insert_Input = {
  data: Variaveis_Base_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Base_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.base" */
export type Variaveis_Base_On_Conflict = {
  constraint: Variaveis_Base_Constraint;
  update_columns?: Array<Variaveis_Base_Update_Column>;
  where?: InputMaybe<Variaveis_Base_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.base". */
export type Variaveis_Base_Order_By = {
  apagado?: InputMaybe<Order_By>;
  atributo?: InputMaybe<Order_By>;
  codigo?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  com_valores_parametricos?: InputMaybe<Order_By>;
  cumpre_valores_parametricos?: InputMaybe<Order_By>;
  desativado?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  dominio?: InputMaybe<Variaveis_Dominios_Order_By>;
  filtro_and_variaveis?: InputMaybe<Order_By>;
  fonteOrigem_aggregate?: InputMaybe<Variaveis_Fontes_Origem_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_filtro_data?: InputMaybe<Order_By>;
  id_origem_dados?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_plano_controlo_tipo?: InputMaybe<Order_By>;
  id_sub_dominio?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  id_totalizador?: InputMaybe<Order_By>;
  ids_clientes?: InputMaybe<Order_By>;
  ids_contratos?: InputMaybe<Order_By>;
  ids_estado_validacao_tarefas?: InputMaybe<Order_By>;
  ids_estado_validacao_tipo_regiao?: InputMaybe<Order_By>;
  ids_estados_amostra?: InputMaybe<Order_By>;
  ids_estados_tarefas?: InputMaybe<Order_By>;
  ids_medidores?: InputMaybe<Order_By>;
  ids_modelos_tarefas?: InputMaybe<Order_By>;
  ids_tipos_tarefas?: InputMaybe<Order_By>;
  ind_id_reagente?: InputMaybe<Order_By>;
  parametro?: InputMaybe<Variaveis_Parametros_Order_By>;
  parciais_aggregate?: InputMaybe<Variaveis_Base_Aggregate_Order_By>;
  propriedades_aggregate?: InputMaybe<Variaveis_Base_Propriedades_Aggregate_Order_By>;
  str_incompletas?: InputMaybe<Order_By>;
  str_planeadas?: InputMaybe<Order_By>;
  tarefa_descricao?: InputMaybe<Order_By>;
  tipo?: InputMaybe<Variaveis_Tipos_Order_By>;
  totalizador?: InputMaybe<Variaveis_Base_Order_By>;
  valoresMensais_aggregate?: InputMaybe<Variaveis_Valores_Mensais_Aggregate_Order_By>;
  variaveisCalculo_aggregate?: InputMaybe<Variaveis_Base_Calc_Variaveis_Aggregate_Order_By>;
};

/** primary key columns input for table: variaveis.base */
export type Variaveis_Base_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades = {
  __typename?: 'variaveis_base_propriedades';
  /** An object relationship */
  agregacaoTempo?: Maybe<Variaveis_Agregacao>;
  apagado: Scalars['Boolean']['output'];
  calc_anual_dia_mes?: Maybe<Scalars['String']['output']>;
  calc_anual_mes_ano?: Maybe<Scalars['String']['output']>;
  calc_ativa?: Maybe<Scalars['Boolean']['output']>;
  calc_expressao?: Maybe<Scalars['String']['output']>;
  calc_hora?: Maybe<Scalars['String']['output']>;
  calc_id_tipo?: Maybe<Scalars['bigint']['output']>;
  calc_mensal_dia_mes?: Maybe<Scalars['String']['output']>;
  calc_mensal_posicao_dia_semana?: Maybe<Scalars['String']['output']>;
  calc_nr_casas_decimais?: Maybe<Scalars['bigint']['output']>;
  calc_periodo?: Maybe<Scalars['String']['output']>;
  calc_semanal_dia?: Maybe<Scalars['String']['output']>;
  calc_tolerancia?: Maybe<Scalars['String']['output']>;
  codigo?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  id_agregacao_no?: Maybe<Scalars['bigint']['output']>;
  id_agregacao_tempo?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base: Scalars['bigint']['output'];
  max?: Maybe<Scalars['numeric']['output']>;
  min?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  per_estabilizacao?: Maybe<Scalars['String']['output']>;
  registo_standard_dinamico: Scalars['Boolean']['output'];
  sufixo?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Aggregate = {
  __typename?: 'variaveis_base_propriedades_aggregate';
  aggregate?: Maybe<Variaveis_Base_Propriedades_Aggregate_Fields>;
  nodes: Array<Variaveis_Base_Propriedades>;
};

export type Variaveis_Base_Propriedades_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Variaveis_Base_Propriedades_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Variaveis_Base_Propriedades_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Variaveis_Base_Propriedades_Aggregate_Bool_Exp_Count>;
};

export type Variaveis_Base_Propriedades_Aggregate_Bool_Exp_Bool_And = {
  arguments: Variaveis_Base_Propriedades_Select_Column_Variaveis_Base_Propriedades_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Base_Propriedades_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Variaveis_Base_Propriedades_Select_Column_Variaveis_Base_Propriedades_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Base_Propriedades_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variaveis_Base_Propriedades_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Aggregate_Fields = {
  __typename?: 'variaveis_base_propriedades_aggregate_fields';
  avg?: Maybe<Variaveis_Base_Propriedades_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Base_Propriedades_Max_Fields>;
  min?: Maybe<Variaveis_Base_Propriedades_Min_Fields>;
  stddev?: Maybe<Variaveis_Base_Propriedades_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Base_Propriedades_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Base_Propriedades_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Base_Propriedades_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Base_Propriedades_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Base_Propriedades_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Base_Propriedades_Variance_Fields>;
};


/** aggregate fields of "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Base_Propriedades_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Aggregate_Order_By = {
  avg?: InputMaybe<Variaveis_Base_Propriedades_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variaveis_Base_Propriedades_Max_Order_By>;
  min?: InputMaybe<Variaveis_Base_Propriedades_Min_Order_By>;
  stddev?: InputMaybe<Variaveis_Base_Propriedades_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variaveis_Base_Propriedades_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variaveis_Base_Propriedades_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variaveis_Base_Propriedades_Sum_Order_By>;
  var_pop?: InputMaybe<Variaveis_Base_Propriedades_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variaveis_Base_Propriedades_Var_Samp_Order_By>;
  variance?: InputMaybe<Variaveis_Base_Propriedades_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Arr_Rel_Insert_Input = {
  data: Array<Variaveis_Base_Propriedades_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Base_Propriedades_On_Conflict>;
};

/** aggregate avg on columns */
export type Variaveis_Base_Propriedades_Avg_Fields = {
  __typename?: 'variaveis_base_propriedades_avg_fields';
  calc_id_tipo?: Maybe<Scalars['Float']['output']>;
  calc_nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_agregacao_no?: Maybe<Scalars['Float']['output']>;
  id_agregacao_tempo?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Avg_Order_By = {
  calc_id_tipo?: InputMaybe<Order_By>;
  calc_nr_casas_decimais?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_agregacao_no?: InputMaybe<Order_By>;
  id_agregacao_tempo?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variaveis.base_propriedades". All fields are combined with a logical 'AND'. */
export type Variaveis_Base_Propriedades_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Base_Propriedades_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Base_Propriedades_Bool_Exp>>;
  agregacaoTempo?: InputMaybe<Variaveis_Agregacao_Bool_Exp>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  calc_anual_dia_mes?: InputMaybe<String_Comparison_Exp>;
  calc_anual_mes_ano?: InputMaybe<String_Comparison_Exp>;
  calc_ativa?: InputMaybe<Boolean_Comparison_Exp>;
  calc_expressao?: InputMaybe<String_Comparison_Exp>;
  calc_hora?: InputMaybe<String_Comparison_Exp>;
  calc_id_tipo?: InputMaybe<Bigint_Comparison_Exp>;
  calc_mensal_dia_mes?: InputMaybe<String_Comparison_Exp>;
  calc_mensal_posicao_dia_semana?: InputMaybe<String_Comparison_Exp>;
  calc_nr_casas_decimais?: InputMaybe<Bigint_Comparison_Exp>;
  calc_periodo?: InputMaybe<String_Comparison_Exp>;
  calc_semanal_dia?: InputMaybe<String_Comparison_Exp>;
  calc_tolerancia?: InputMaybe<String_Comparison_Exp>;
  codigo?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_agregacao_no?: InputMaybe<Bigint_Comparison_Exp>;
  id_agregacao_tempo?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_variavel_base?: InputMaybe<Bigint_Comparison_Exp>;
  max?: InputMaybe<Numeric_Comparison_Exp>;
  min?: InputMaybe<Numeric_Comparison_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
  per_estabilizacao?: InputMaybe<String_Comparison_Exp>;
  registo_standard_dinamico?: InputMaybe<Boolean_Comparison_Exp>;
  sufixo?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.base_propriedades" */
export enum Variaveis_Base_Propriedades_Constraint {
  /** unique or primary key constraint on columns "id" */
  BasePropriedadesPkey = 'base_propriedades_pkey',
  /** unique or primary key constraint on columns "id_infraestrutura", "id_variavel_base" */
  UniqueBasePropriedadesIdVariavelBaseIdInfraestrutura = 'unique_base_propriedades_id_variavel_base_id_infraestrutura'
}

/** input type for incrementing numeric columns in table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Inc_Input = {
  calc_id_tipo?: InputMaybe<Scalars['bigint']['input']>;
  calc_nr_casas_decimais?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_agregacao_no?: InputMaybe<Scalars['bigint']['input']>;
  id_agregacao_tempo?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  max?: InputMaybe<Scalars['numeric']['input']>;
  min?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Insert_Input = {
  agregacaoTempo?: InputMaybe<Variaveis_Agregacao_Obj_Rel_Insert_Input>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  calc_anual_dia_mes?: InputMaybe<Scalars['String']['input']>;
  calc_anual_mes_ano?: InputMaybe<Scalars['String']['input']>;
  calc_ativa?: InputMaybe<Scalars['Boolean']['input']>;
  calc_expressao?: InputMaybe<Scalars['String']['input']>;
  calc_hora?: InputMaybe<Scalars['String']['input']>;
  calc_id_tipo?: InputMaybe<Scalars['bigint']['input']>;
  calc_mensal_dia_mes?: InputMaybe<Scalars['String']['input']>;
  calc_mensal_posicao_dia_semana?: InputMaybe<Scalars['String']['input']>;
  calc_nr_casas_decimais?: InputMaybe<Scalars['bigint']['input']>;
  calc_periodo?: InputMaybe<Scalars['String']['input']>;
  calc_semanal_dia?: InputMaybe<Scalars['String']['input']>;
  calc_tolerancia?: InputMaybe<Scalars['String']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_agregacao_no?: InputMaybe<Scalars['bigint']['input']>;
  id_agregacao_tempo?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  max?: InputMaybe<Scalars['numeric']['input']>;
  min?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  per_estabilizacao?: InputMaybe<Scalars['String']['input']>;
  registo_standard_dinamico?: InputMaybe<Scalars['Boolean']['input']>;
  sufixo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Base_Propriedades_Max_Fields = {
  __typename?: 'variaveis_base_propriedades_max_fields';
  calc_anual_dia_mes?: Maybe<Scalars['String']['output']>;
  calc_anual_mes_ano?: Maybe<Scalars['String']['output']>;
  calc_expressao?: Maybe<Scalars['String']['output']>;
  calc_hora?: Maybe<Scalars['String']['output']>;
  calc_id_tipo?: Maybe<Scalars['bigint']['output']>;
  calc_mensal_dia_mes?: Maybe<Scalars['String']['output']>;
  calc_mensal_posicao_dia_semana?: Maybe<Scalars['String']['output']>;
  calc_nr_casas_decimais?: Maybe<Scalars['bigint']['output']>;
  calc_periodo?: Maybe<Scalars['String']['output']>;
  calc_semanal_dia?: Maybe<Scalars['String']['output']>;
  calc_tolerancia?: Maybe<Scalars['String']['output']>;
  codigo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_agregacao_no?: Maybe<Scalars['bigint']['output']>;
  id_agregacao_tempo?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  max?: Maybe<Scalars['numeric']['output']>;
  min?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  per_estabilizacao?: Maybe<Scalars['String']['output']>;
  sufixo?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Max_Order_By = {
  calc_anual_dia_mes?: InputMaybe<Order_By>;
  calc_anual_mes_ano?: InputMaybe<Order_By>;
  calc_expressao?: InputMaybe<Order_By>;
  calc_hora?: InputMaybe<Order_By>;
  calc_id_tipo?: InputMaybe<Order_By>;
  calc_mensal_dia_mes?: InputMaybe<Order_By>;
  calc_mensal_posicao_dia_semana?: InputMaybe<Order_By>;
  calc_nr_casas_decimais?: InputMaybe<Order_By>;
  calc_periodo?: InputMaybe<Order_By>;
  calc_semanal_dia?: InputMaybe<Order_By>;
  calc_tolerancia?: InputMaybe<Order_By>;
  codigo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_agregacao_no?: InputMaybe<Order_By>;
  id_agregacao_tempo?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  per_estabilizacao?: InputMaybe<Order_By>;
  sufixo?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variaveis_Base_Propriedades_Min_Fields = {
  __typename?: 'variaveis_base_propriedades_min_fields';
  calc_anual_dia_mes?: Maybe<Scalars['String']['output']>;
  calc_anual_mes_ano?: Maybe<Scalars['String']['output']>;
  calc_expressao?: Maybe<Scalars['String']['output']>;
  calc_hora?: Maybe<Scalars['String']['output']>;
  calc_id_tipo?: Maybe<Scalars['bigint']['output']>;
  calc_mensal_dia_mes?: Maybe<Scalars['String']['output']>;
  calc_mensal_posicao_dia_semana?: Maybe<Scalars['String']['output']>;
  calc_nr_casas_decimais?: Maybe<Scalars['bigint']['output']>;
  calc_periodo?: Maybe<Scalars['String']['output']>;
  calc_semanal_dia?: Maybe<Scalars['String']['output']>;
  calc_tolerancia?: Maybe<Scalars['String']['output']>;
  codigo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_agregacao_no?: Maybe<Scalars['bigint']['output']>;
  id_agregacao_tempo?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  max?: Maybe<Scalars['numeric']['output']>;
  min?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
  per_estabilizacao?: Maybe<Scalars['String']['output']>;
  sufixo?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Min_Order_By = {
  calc_anual_dia_mes?: InputMaybe<Order_By>;
  calc_anual_mes_ano?: InputMaybe<Order_By>;
  calc_expressao?: InputMaybe<Order_By>;
  calc_hora?: InputMaybe<Order_By>;
  calc_id_tipo?: InputMaybe<Order_By>;
  calc_mensal_dia_mes?: InputMaybe<Order_By>;
  calc_mensal_posicao_dia_semana?: InputMaybe<Order_By>;
  calc_nr_casas_decimais?: InputMaybe<Order_By>;
  calc_periodo?: InputMaybe<Order_By>;
  calc_semanal_dia?: InputMaybe<Order_By>;
  calc_tolerancia?: InputMaybe<Order_By>;
  codigo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_agregacao_no?: InputMaybe<Order_By>;
  id_agregacao_tempo?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  per_estabilizacao?: InputMaybe<Order_By>;
  sufixo?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Mutation_Response = {
  __typename?: 'variaveis_base_propriedades_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Base_Propriedades>;
};

/** on_conflict condition type for table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_On_Conflict = {
  constraint: Variaveis_Base_Propriedades_Constraint;
  update_columns?: Array<Variaveis_Base_Propriedades_Update_Column>;
  where?: InputMaybe<Variaveis_Base_Propriedades_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.base_propriedades". */
export type Variaveis_Base_Propriedades_Order_By = {
  agregacaoTempo?: InputMaybe<Variaveis_Agregacao_Order_By>;
  apagado?: InputMaybe<Order_By>;
  calc_anual_dia_mes?: InputMaybe<Order_By>;
  calc_anual_mes_ano?: InputMaybe<Order_By>;
  calc_ativa?: InputMaybe<Order_By>;
  calc_expressao?: InputMaybe<Order_By>;
  calc_hora?: InputMaybe<Order_By>;
  calc_id_tipo?: InputMaybe<Order_By>;
  calc_mensal_dia_mes?: InputMaybe<Order_By>;
  calc_mensal_posicao_dia_semana?: InputMaybe<Order_By>;
  calc_nr_casas_decimais?: InputMaybe<Order_By>;
  calc_periodo?: InputMaybe<Order_By>;
  calc_semanal_dia?: InputMaybe<Order_By>;
  calc_tolerancia?: InputMaybe<Order_By>;
  codigo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_agregacao_no?: InputMaybe<Order_By>;
  id_agregacao_tempo?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
  per_estabilizacao?: InputMaybe<Order_By>;
  registo_standard_dinamico?: InputMaybe<Order_By>;
  sufixo?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.base_propriedades */
export type Variaveis_Base_Propriedades_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.base_propriedades" */
export enum Variaveis_Base_Propriedades_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CalcAnualDiaMes = 'calc_anual_dia_mes',
  /** column name */
  CalcAnualMesAno = 'calc_anual_mes_ano',
  /** column name */
  CalcAtiva = 'calc_ativa',
  /** column name */
  CalcExpressao = 'calc_expressao',
  /** column name */
  CalcHora = 'calc_hora',
  /** column name */
  CalcIdTipo = 'calc_id_tipo',
  /** column name */
  CalcMensalDiaMes = 'calc_mensal_dia_mes',
  /** column name */
  CalcMensalPosicaoDiaSemana = 'calc_mensal_posicao_dia_semana',
  /** column name */
  CalcNrCasasDecimais = 'calc_nr_casas_decimais',
  /** column name */
  CalcPeriodo = 'calc_periodo',
  /** column name */
  CalcSemanalDia = 'calc_semanal_dia',
  /** column name */
  CalcTolerancia = 'calc_tolerancia',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  Id = 'id',
  /** column name */
  IdAgregacaoNo = 'id_agregacao_no',
  /** column name */
  IdAgregacaoTempo = 'id_agregacao_tempo',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdVariavelBase = 'id_variavel_base',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  PerEstabilizacao = 'per_estabilizacao',
  /** column name */
  RegistoStandardDinamico = 'registo_standard_dinamico',
  /** column name */
  Sufixo = 'sufixo'
}

/** select "variaveis_base_propriedades_aggregate_bool_exp_bool_and_arguments_columns" columns of table "variaveis.base_propriedades" */
export enum Variaveis_Base_Propriedades_Select_Column_Variaveis_Base_Propriedades_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CalcAtiva = 'calc_ativa',
  /** column name */
  RegistoStandardDinamico = 'registo_standard_dinamico'
}

/** select "variaveis_base_propriedades_aggregate_bool_exp_bool_or_arguments_columns" columns of table "variaveis.base_propriedades" */
export enum Variaveis_Base_Propriedades_Select_Column_Variaveis_Base_Propriedades_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CalcAtiva = 'calc_ativa',
  /** column name */
  RegistoStandardDinamico = 'registo_standard_dinamico'
}

/** input type for updating data in table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  calc_anual_dia_mes?: InputMaybe<Scalars['String']['input']>;
  calc_anual_mes_ano?: InputMaybe<Scalars['String']['input']>;
  calc_ativa?: InputMaybe<Scalars['Boolean']['input']>;
  calc_expressao?: InputMaybe<Scalars['String']['input']>;
  calc_hora?: InputMaybe<Scalars['String']['input']>;
  calc_id_tipo?: InputMaybe<Scalars['bigint']['input']>;
  calc_mensal_dia_mes?: InputMaybe<Scalars['String']['input']>;
  calc_mensal_posicao_dia_semana?: InputMaybe<Scalars['String']['input']>;
  calc_nr_casas_decimais?: InputMaybe<Scalars['bigint']['input']>;
  calc_periodo?: InputMaybe<Scalars['String']['input']>;
  calc_semanal_dia?: InputMaybe<Scalars['String']['input']>;
  calc_tolerancia?: InputMaybe<Scalars['String']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_agregacao_no?: InputMaybe<Scalars['bigint']['input']>;
  id_agregacao_tempo?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  max?: InputMaybe<Scalars['numeric']['input']>;
  min?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  per_estabilizacao?: InputMaybe<Scalars['String']['input']>;
  registo_standard_dinamico?: InputMaybe<Scalars['Boolean']['input']>;
  sufixo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Base_Propriedades_Stddev_Fields = {
  __typename?: 'variaveis_base_propriedades_stddev_fields';
  calc_id_tipo?: Maybe<Scalars['Float']['output']>;
  calc_nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_agregacao_no?: Maybe<Scalars['Float']['output']>;
  id_agregacao_tempo?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Stddev_Order_By = {
  calc_id_tipo?: InputMaybe<Order_By>;
  calc_nr_casas_decimais?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_agregacao_no?: InputMaybe<Order_By>;
  id_agregacao_tempo?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Base_Propriedades_Stddev_Pop_Fields = {
  __typename?: 'variaveis_base_propriedades_stddev_pop_fields';
  calc_id_tipo?: Maybe<Scalars['Float']['output']>;
  calc_nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_agregacao_no?: Maybe<Scalars['Float']['output']>;
  id_agregacao_tempo?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Stddev_Pop_Order_By = {
  calc_id_tipo?: InputMaybe<Order_By>;
  calc_nr_casas_decimais?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_agregacao_no?: InputMaybe<Order_By>;
  id_agregacao_tempo?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Base_Propriedades_Stddev_Samp_Fields = {
  __typename?: 'variaveis_base_propriedades_stddev_samp_fields';
  calc_id_tipo?: Maybe<Scalars['Float']['output']>;
  calc_nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_agregacao_no?: Maybe<Scalars['Float']['output']>;
  id_agregacao_tempo?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Stddev_Samp_Order_By = {
  calc_id_tipo?: InputMaybe<Order_By>;
  calc_nr_casas_decimais?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_agregacao_no?: InputMaybe<Order_By>;
  id_agregacao_tempo?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variaveis_base_propriedades" */
export type Variaveis_Base_Propriedades_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Base_Propriedades_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Base_Propriedades_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  calc_anual_dia_mes?: InputMaybe<Scalars['String']['input']>;
  calc_anual_mes_ano?: InputMaybe<Scalars['String']['input']>;
  calc_ativa?: InputMaybe<Scalars['Boolean']['input']>;
  calc_expressao?: InputMaybe<Scalars['String']['input']>;
  calc_hora?: InputMaybe<Scalars['String']['input']>;
  calc_id_tipo?: InputMaybe<Scalars['bigint']['input']>;
  calc_mensal_dia_mes?: InputMaybe<Scalars['String']['input']>;
  calc_mensal_posicao_dia_semana?: InputMaybe<Scalars['String']['input']>;
  calc_nr_casas_decimais?: InputMaybe<Scalars['bigint']['input']>;
  calc_periodo?: InputMaybe<Scalars['String']['input']>;
  calc_semanal_dia?: InputMaybe<Scalars['String']['input']>;
  calc_tolerancia?: InputMaybe<Scalars['String']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_agregacao_no?: InputMaybe<Scalars['bigint']['input']>;
  id_agregacao_tempo?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  max?: InputMaybe<Scalars['numeric']['input']>;
  min?: InputMaybe<Scalars['numeric']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
  per_estabilizacao?: InputMaybe<Scalars['String']['input']>;
  registo_standard_dinamico?: InputMaybe<Scalars['Boolean']['input']>;
  sufixo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Base_Propriedades_Sum_Fields = {
  __typename?: 'variaveis_base_propriedades_sum_fields';
  calc_id_tipo?: Maybe<Scalars['bigint']['output']>;
  calc_nr_casas_decimais?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_agregacao_no?: Maybe<Scalars['bigint']['output']>;
  id_agregacao_tempo?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  max?: Maybe<Scalars['numeric']['output']>;
  min?: Maybe<Scalars['numeric']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Sum_Order_By = {
  calc_id_tipo?: InputMaybe<Order_By>;
  calc_nr_casas_decimais?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_agregacao_no?: InputMaybe<Order_By>;
  id_agregacao_tempo?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** update columns of table "variaveis.base_propriedades" */
export enum Variaveis_Base_Propriedades_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CalcAnualDiaMes = 'calc_anual_dia_mes',
  /** column name */
  CalcAnualMesAno = 'calc_anual_mes_ano',
  /** column name */
  CalcAtiva = 'calc_ativa',
  /** column name */
  CalcExpressao = 'calc_expressao',
  /** column name */
  CalcHora = 'calc_hora',
  /** column name */
  CalcIdTipo = 'calc_id_tipo',
  /** column name */
  CalcMensalDiaMes = 'calc_mensal_dia_mes',
  /** column name */
  CalcMensalPosicaoDiaSemana = 'calc_mensal_posicao_dia_semana',
  /** column name */
  CalcNrCasasDecimais = 'calc_nr_casas_decimais',
  /** column name */
  CalcPeriodo = 'calc_periodo',
  /** column name */
  CalcSemanalDia = 'calc_semanal_dia',
  /** column name */
  CalcTolerancia = 'calc_tolerancia',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  Id = 'id',
  /** column name */
  IdAgregacaoNo = 'id_agregacao_no',
  /** column name */
  IdAgregacaoTempo = 'id_agregacao_tempo',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdVariavelBase = 'id_variavel_base',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  Ordem = 'ordem',
  /** column name */
  PerEstabilizacao = 'per_estabilizacao',
  /** column name */
  RegistoStandardDinamico = 'registo_standard_dinamico',
  /** column name */
  Sufixo = 'sufixo'
}

export type Variaveis_Base_Propriedades_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Base_Propriedades_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Base_Propriedades_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Base_Propriedades_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Base_Propriedades_Var_Pop_Fields = {
  __typename?: 'variaveis_base_propriedades_var_pop_fields';
  calc_id_tipo?: Maybe<Scalars['Float']['output']>;
  calc_nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_agregacao_no?: Maybe<Scalars['Float']['output']>;
  id_agregacao_tempo?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Var_Pop_Order_By = {
  calc_id_tipo?: InputMaybe<Order_By>;
  calc_nr_casas_decimais?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_agregacao_no?: InputMaybe<Order_By>;
  id_agregacao_tempo?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variaveis_Base_Propriedades_Var_Samp_Fields = {
  __typename?: 'variaveis_base_propriedades_var_samp_fields';
  calc_id_tipo?: Maybe<Scalars['Float']['output']>;
  calc_nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_agregacao_no?: Maybe<Scalars['Float']['output']>;
  id_agregacao_tempo?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Var_Samp_Order_By = {
  calc_id_tipo?: InputMaybe<Order_By>;
  calc_nr_casas_decimais?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_agregacao_no?: InputMaybe<Order_By>;
  id_agregacao_tempo?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variaveis_Base_Propriedades_Variance_Fields = {
  __typename?: 'variaveis_base_propriedades_variance_fields';
  calc_id_tipo?: Maybe<Scalars['Float']['output']>;
  calc_nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_agregacao_no?: Maybe<Scalars['Float']['output']>;
  id_agregacao_tempo?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variaveis.base_propriedades" */
export type Variaveis_Base_Propriedades_Variance_Order_By = {
  calc_id_tipo?: InputMaybe<Order_By>;
  calc_nr_casas_decimais?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_agregacao_no?: InputMaybe<Order_By>;
  id_agregacao_tempo?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** select columns of table "variaveis.base" */
export enum Variaveis_Base_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Atributo = 'atributo',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  ComValoresParametricos = 'com_valores_parametricos',
  /** column name */
  CumpreValoresParametricos = 'cumpre_valores_parametricos',
  /** column name */
  Desativado = 'desativado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  FiltroAndVariaveis = 'filtro_and_variaveis',
  /** column name */
  Id = 'id',
  /** column name */
  IdCategoria = 'id_categoria',
  /** column name */
  IdDominio = 'id_dominio',
  /** column name */
  IdFase = 'id_fase',
  /** column name */
  IdFiltroData = 'id_filtro_data',
  /** column name */
  IdOrigemDados = 'id_origem_dados',
  /** column name */
  IdParametro = 'id_parametro',
  /** column name */
  IdPlanoControloTipo = 'id_plano_controlo_tipo',
  /** column name */
  IdSubDominio = 'id_sub_dominio',
  /** column name */
  IdTipo = 'id_tipo',
  /** column name */
  IdTotalizador = 'id_totalizador',
  /** column name */
  IdsClientes = 'ids_clientes',
  /** column name */
  IdsContratos = 'ids_contratos',
  /** column name */
  IdsEstadoValidacaoTarefas = 'ids_estado_validacao_tarefas',
  /** column name */
  IdsEstadoValidacaoTipoRegiao = 'ids_estado_validacao_tipo_regiao',
  /** column name */
  IdsEstadosAmostra = 'ids_estados_amostra',
  /** column name */
  IdsEstadosTarefas = 'ids_estados_tarefas',
  /** column name */
  IdsMedidores = 'ids_medidores',
  /** column name */
  IdsModelosTarefas = 'ids_modelos_tarefas',
  /** column name */
  IdsTiposTarefas = 'ids_tipos_tarefas',
  /** column name */
  IndIdReagente = 'ind_id_reagente',
  /** column name */
  StrIncompletas = 'str_incompletas',
  /** column name */
  StrPlaneadas = 'str_planeadas',
  /** column name */
  TarefaDescricao = 'tarefa_descricao'
}

/** select "variaveis_base_aggregate_bool_exp_bool_and_arguments_columns" columns of table "variaveis.base" */
export enum Variaveis_Base_Select_Column_Variaveis_Base_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Atributo = 'atributo',
  /** column name */
  ComValoresParametricos = 'com_valores_parametricos',
  /** column name */
  CumpreValoresParametricos = 'cumpre_valores_parametricos',
  /** column name */
  Desativado = 'desativado',
  /** column name */
  FiltroAndVariaveis = 'filtro_and_variaveis'
}

/** select "variaveis_base_aggregate_bool_exp_bool_or_arguments_columns" columns of table "variaveis.base" */
export enum Variaveis_Base_Select_Column_Variaveis_Base_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Atributo = 'atributo',
  /** column name */
  ComValoresParametricos = 'com_valores_parametricos',
  /** column name */
  CumpreValoresParametricos = 'cumpre_valores_parametricos',
  /** column name */
  Desativado = 'desativado',
  /** column name */
  FiltroAndVariaveis = 'filtro_and_variaveis'
}

/** input type for updating data in table "variaveis.base" */
export type Variaveis_Base_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atributo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  com_valores_parametricos?: InputMaybe<Scalars['Boolean']['input']>;
  cumpre_valores_parametricos?: InputMaybe<Scalars['Boolean']['input']>;
  desativado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  filtro_and_variaveis?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_categoria?: InputMaybe<Scalars['bigint']['input']>;
  id_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_filtro_data?: InputMaybe<Scalars['smallint']['input']>;
  id_origem_dados?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_controlo_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_sub_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_totalizador?: InputMaybe<Scalars['bigint']['input']>;
  ids_clientes?: InputMaybe<Scalars['String']['input']>;
  ids_contratos?: InputMaybe<Scalars['String']['input']>;
  ids_estado_validacao_tarefas?: InputMaybe<Scalars['String']['input']>;
  ids_estado_validacao_tipo_regiao?: InputMaybe<Scalars['String']['input']>;
  ids_estados_amostra?: InputMaybe<Scalars['String']['input']>;
  ids_estados_tarefas?: InputMaybe<Scalars['String']['input']>;
  ids_medidores?: InputMaybe<Scalars['String']['input']>;
  ids_modelos_tarefas?: InputMaybe<Scalars['String']['input']>;
  ids_tipos_tarefas?: InputMaybe<Scalars['String']['input']>;
  ind_id_reagente?: InputMaybe<Scalars['bigint']['input']>;
  str_incompletas?: InputMaybe<Scalars['String']['input']>;
  str_planeadas?: InputMaybe<Scalars['String']['input']>;
  tarefa_descricao?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Base_Stddev_Fields = {
  __typename?: 'variaveis_base_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_filtro_data?: Maybe<Scalars['Float']['output']>;
  id_origem_dados?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_tipo?: Maybe<Scalars['Float']['output']>;
  id_sub_dominio?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
  id_totalizador?: Maybe<Scalars['Float']['output']>;
  ind_id_reagente?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variaveis.base" */
export type Variaveis_Base_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_filtro_data?: InputMaybe<Order_By>;
  id_origem_dados?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_plano_controlo_tipo?: InputMaybe<Order_By>;
  id_sub_dominio?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  id_totalizador?: InputMaybe<Order_By>;
  ind_id_reagente?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Base_Stddev_Pop_Fields = {
  __typename?: 'variaveis_base_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_filtro_data?: Maybe<Scalars['Float']['output']>;
  id_origem_dados?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_tipo?: Maybe<Scalars['Float']['output']>;
  id_sub_dominio?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
  id_totalizador?: Maybe<Scalars['Float']['output']>;
  ind_id_reagente?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variaveis.base" */
export type Variaveis_Base_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_filtro_data?: InputMaybe<Order_By>;
  id_origem_dados?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_plano_controlo_tipo?: InputMaybe<Order_By>;
  id_sub_dominio?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  id_totalizador?: InputMaybe<Order_By>;
  ind_id_reagente?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Base_Stddev_Samp_Fields = {
  __typename?: 'variaveis_base_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_filtro_data?: Maybe<Scalars['Float']['output']>;
  id_origem_dados?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_tipo?: Maybe<Scalars['Float']['output']>;
  id_sub_dominio?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
  id_totalizador?: Maybe<Scalars['Float']['output']>;
  ind_id_reagente?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variaveis.base" */
export type Variaveis_Base_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_filtro_data?: InputMaybe<Order_By>;
  id_origem_dados?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_plano_controlo_tipo?: InputMaybe<Order_By>;
  id_sub_dominio?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  id_totalizador?: InputMaybe<Order_By>;
  ind_id_reagente?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variaveis_base" */
export type Variaveis_Base_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Base_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Base_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  atributo?: InputMaybe<Scalars['Boolean']['input']>;
  codigo?: InputMaybe<Scalars['String']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  com_valores_parametricos?: InputMaybe<Scalars['Boolean']['input']>;
  cumpre_valores_parametricos?: InputMaybe<Scalars['Boolean']['input']>;
  desativado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  filtro_and_variaveis?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_categoria?: InputMaybe<Scalars['bigint']['input']>;
  id_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_filtro_data?: InputMaybe<Scalars['smallint']['input']>;
  id_origem_dados?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_controlo_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_sub_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo?: InputMaybe<Scalars['bigint']['input']>;
  id_totalizador?: InputMaybe<Scalars['bigint']['input']>;
  ids_clientes?: InputMaybe<Scalars['String']['input']>;
  ids_contratos?: InputMaybe<Scalars['String']['input']>;
  ids_estado_validacao_tarefas?: InputMaybe<Scalars['String']['input']>;
  ids_estado_validacao_tipo_regiao?: InputMaybe<Scalars['String']['input']>;
  ids_estados_amostra?: InputMaybe<Scalars['String']['input']>;
  ids_estados_tarefas?: InputMaybe<Scalars['String']['input']>;
  ids_medidores?: InputMaybe<Scalars['String']['input']>;
  ids_modelos_tarefas?: InputMaybe<Scalars['String']['input']>;
  ids_tipos_tarefas?: InputMaybe<Scalars['String']['input']>;
  ind_id_reagente?: InputMaybe<Scalars['bigint']['input']>;
  str_incompletas?: InputMaybe<Scalars['String']['input']>;
  str_planeadas?: InputMaybe<Scalars['String']['input']>;
  tarefa_descricao?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Base_Sum_Fields = {
  __typename?: 'variaveis_base_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_categoria?: Maybe<Scalars['bigint']['output']>;
  id_dominio?: Maybe<Scalars['bigint']['output']>;
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_filtro_data?: Maybe<Scalars['smallint']['output']>;
  id_origem_dados?: Maybe<Scalars['bigint']['output']>;
  id_parametro?: Maybe<Scalars['bigint']['output']>;
  id_plano_controlo_tipo?: Maybe<Scalars['bigint']['output']>;
  id_sub_dominio?: Maybe<Scalars['bigint']['output']>;
  id_tipo?: Maybe<Scalars['bigint']['output']>;
  id_totalizador?: Maybe<Scalars['bigint']['output']>;
  ind_id_reagente?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "variaveis.base" */
export type Variaveis_Base_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_filtro_data?: InputMaybe<Order_By>;
  id_origem_dados?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_plano_controlo_tipo?: InputMaybe<Order_By>;
  id_sub_dominio?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  id_totalizador?: InputMaybe<Order_By>;
  ind_id_reagente?: InputMaybe<Order_By>;
};

/** update columns of table "variaveis.base" */
export enum Variaveis_Base_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Atributo = 'atributo',
  /** column name */
  Codigo = 'codigo',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  ComValoresParametricos = 'com_valores_parametricos',
  /** column name */
  CumpreValoresParametricos = 'cumpre_valores_parametricos',
  /** column name */
  Desativado = 'desativado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  FiltroAndVariaveis = 'filtro_and_variaveis',
  /** column name */
  Id = 'id',
  /** column name */
  IdCategoria = 'id_categoria',
  /** column name */
  IdDominio = 'id_dominio',
  /** column name */
  IdFase = 'id_fase',
  /** column name */
  IdFiltroData = 'id_filtro_data',
  /** column name */
  IdOrigemDados = 'id_origem_dados',
  /** column name */
  IdParametro = 'id_parametro',
  /** column name */
  IdPlanoControloTipo = 'id_plano_controlo_tipo',
  /** column name */
  IdSubDominio = 'id_sub_dominio',
  /** column name */
  IdTipo = 'id_tipo',
  /** column name */
  IdTotalizador = 'id_totalizador',
  /** column name */
  IdsClientes = 'ids_clientes',
  /** column name */
  IdsContratos = 'ids_contratos',
  /** column name */
  IdsEstadoValidacaoTarefas = 'ids_estado_validacao_tarefas',
  /** column name */
  IdsEstadoValidacaoTipoRegiao = 'ids_estado_validacao_tipo_regiao',
  /** column name */
  IdsEstadosAmostra = 'ids_estados_amostra',
  /** column name */
  IdsEstadosTarefas = 'ids_estados_tarefas',
  /** column name */
  IdsMedidores = 'ids_medidores',
  /** column name */
  IdsModelosTarefas = 'ids_modelos_tarefas',
  /** column name */
  IdsTiposTarefas = 'ids_tipos_tarefas',
  /** column name */
  IndIdReagente = 'ind_id_reagente',
  /** column name */
  StrIncompletas = 'str_incompletas',
  /** column name */
  StrPlaneadas = 'str_planeadas',
  /** column name */
  TarefaDescricao = 'tarefa_descricao'
}

export type Variaveis_Base_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Base_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Base_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Base_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Base_Var_Pop_Fields = {
  __typename?: 'variaveis_base_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_filtro_data?: Maybe<Scalars['Float']['output']>;
  id_origem_dados?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_tipo?: Maybe<Scalars['Float']['output']>;
  id_sub_dominio?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
  id_totalizador?: Maybe<Scalars['Float']['output']>;
  ind_id_reagente?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variaveis.base" */
export type Variaveis_Base_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_filtro_data?: InputMaybe<Order_By>;
  id_origem_dados?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_plano_controlo_tipo?: InputMaybe<Order_By>;
  id_sub_dominio?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  id_totalizador?: InputMaybe<Order_By>;
  ind_id_reagente?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variaveis_Base_Var_Samp_Fields = {
  __typename?: 'variaveis_base_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_filtro_data?: Maybe<Scalars['Float']['output']>;
  id_origem_dados?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_tipo?: Maybe<Scalars['Float']['output']>;
  id_sub_dominio?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
  id_totalizador?: Maybe<Scalars['Float']['output']>;
  ind_id_reagente?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variaveis.base" */
export type Variaveis_Base_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_filtro_data?: InputMaybe<Order_By>;
  id_origem_dados?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_plano_controlo_tipo?: InputMaybe<Order_By>;
  id_sub_dominio?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  id_totalizador?: InputMaybe<Order_By>;
  ind_id_reagente?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variaveis_Base_Variance_Fields = {
  __typename?: 'variaveis_base_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_categoria?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_filtro_data?: Maybe<Scalars['Float']['output']>;
  id_origem_dados?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_plano_controlo_tipo?: Maybe<Scalars['Float']['output']>;
  id_sub_dominio?: Maybe<Scalars['Float']['output']>;
  id_tipo?: Maybe<Scalars['Float']['output']>;
  id_totalizador?: Maybe<Scalars['Float']['output']>;
  ind_id_reagente?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variaveis.base" */
export type Variaveis_Base_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_categoria?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_filtro_data?: InputMaybe<Order_By>;
  id_origem_dados?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_plano_controlo_tipo?: InputMaybe<Order_By>;
  id_sub_dominio?: InputMaybe<Order_By>;
  id_tipo?: InputMaybe<Order_By>;
  id_totalizador?: InputMaybe<Order_By>;
  ind_id_reagente?: InputMaybe<Order_By>;
};

/** columns and relationships of "variaveis.calc_variaveis" */
export type Variaveis_Calc_Variaveis = {
  __typename?: 'variaveis_calc_variaveis';
  id: Scalars['bigint']['output'];
  id_base_propriedades_calc?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_instante_leitura?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  str_variavel?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "variaveis.calc_variaveis" */
export type Variaveis_Calc_Variaveis_Aggregate = {
  __typename?: 'variaveis_calc_variaveis_aggregate';
  aggregate?: Maybe<Variaveis_Calc_Variaveis_Aggregate_Fields>;
  nodes: Array<Variaveis_Calc_Variaveis>;
};

/** aggregate fields of "variaveis.calc_variaveis" */
export type Variaveis_Calc_Variaveis_Aggregate_Fields = {
  __typename?: 'variaveis_calc_variaveis_aggregate_fields';
  avg?: Maybe<Variaveis_Calc_Variaveis_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Calc_Variaveis_Max_Fields>;
  min?: Maybe<Variaveis_Calc_Variaveis_Min_Fields>;
  stddev?: Maybe<Variaveis_Calc_Variaveis_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Calc_Variaveis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Calc_Variaveis_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Calc_Variaveis_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Calc_Variaveis_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Calc_Variaveis_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Calc_Variaveis_Variance_Fields>;
};


/** aggregate fields of "variaveis.calc_variaveis" */
export type Variaveis_Calc_Variaveis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Calc_Variaveis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Calc_Variaveis_Avg_Fields = {
  __typename?: 'variaveis_calc_variaveis_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_base_propriedades_calc?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_instante_leitura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.calc_variaveis". All fields are combined with a logical 'AND'. */
export type Variaveis_Calc_Variaveis_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Calc_Variaveis_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Calc_Variaveis_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Calc_Variaveis_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_base_propriedades_calc?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_instante_leitura?: InputMaybe<Bigint_Comparison_Exp>;
  id_variavel_base?: InputMaybe<Bigint_Comparison_Exp>;
  str_variavel?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.calc_variaveis" */
export enum Variaveis_Calc_Variaveis_Constraint {
  /** unique or primary key constraint on columns "id" */
  CalcVariaveisPkey = 'calc_variaveis_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.calc_variaveis" */
export type Variaveis_Calc_Variaveis_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_base_propriedades_calc?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_instante_leitura?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.calc_variaveis" */
export type Variaveis_Calc_Variaveis_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_base_propriedades_calc?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_instante_leitura?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  str_variavel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Calc_Variaveis_Max_Fields = {
  __typename?: 'variaveis_calc_variaveis_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_base_propriedades_calc?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_instante_leitura?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  str_variavel?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Calc_Variaveis_Min_Fields = {
  __typename?: 'variaveis_calc_variaveis_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_base_propriedades_calc?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_instante_leitura?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  str_variavel?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "variaveis.calc_variaveis" */
export type Variaveis_Calc_Variaveis_Mutation_Response = {
  __typename?: 'variaveis_calc_variaveis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Calc_Variaveis>;
};

/** on_conflict condition type for table "variaveis.calc_variaveis" */
export type Variaveis_Calc_Variaveis_On_Conflict = {
  constraint: Variaveis_Calc_Variaveis_Constraint;
  update_columns?: Array<Variaveis_Calc_Variaveis_Update_Column>;
  where?: InputMaybe<Variaveis_Calc_Variaveis_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.calc_variaveis". */
export type Variaveis_Calc_Variaveis_Order_By = {
  id?: InputMaybe<Order_By>;
  id_base_propriedades_calc?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_instante_leitura?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  str_variavel?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.calc_variaveis */
export type Variaveis_Calc_Variaveis_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.calc_variaveis" */
export enum Variaveis_Calc_Variaveis_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdBasePropriedadesCalc = 'id_base_propriedades_calc',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdInstanteLeitura = 'id_instante_leitura',
  /** column name */
  IdVariavelBase = 'id_variavel_base',
  /** column name */
  StrVariavel = 'str_variavel'
}

/** input type for updating data in table "variaveis.calc_variaveis" */
export type Variaveis_Calc_Variaveis_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_base_propriedades_calc?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_instante_leitura?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  str_variavel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Calc_Variaveis_Stddev_Fields = {
  __typename?: 'variaveis_calc_variaveis_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_base_propriedades_calc?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_instante_leitura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Calc_Variaveis_Stddev_Pop_Fields = {
  __typename?: 'variaveis_calc_variaveis_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_base_propriedades_calc?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_instante_leitura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Calc_Variaveis_Stddev_Samp_Fields = {
  __typename?: 'variaveis_calc_variaveis_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_base_propriedades_calc?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_instante_leitura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_calc_variaveis" */
export type Variaveis_Calc_Variaveis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Calc_Variaveis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Calc_Variaveis_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_base_propriedades_calc?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_instante_leitura?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  str_variavel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Calc_Variaveis_Sum_Fields = {
  __typename?: 'variaveis_calc_variaveis_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_base_propriedades_calc?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_instante_leitura?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "variaveis.calc_variaveis" */
export enum Variaveis_Calc_Variaveis_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdBasePropriedadesCalc = 'id_base_propriedades_calc',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdInstanteLeitura = 'id_instante_leitura',
  /** column name */
  IdVariavelBase = 'id_variavel_base',
  /** column name */
  StrVariavel = 'str_variavel'
}

export type Variaveis_Calc_Variaveis_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Calc_Variaveis_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Calc_Variaveis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Calc_Variaveis_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Calc_Variaveis_Var_Pop_Fields = {
  __typename?: 'variaveis_calc_variaveis_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_base_propriedades_calc?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_instante_leitura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Calc_Variaveis_Var_Samp_Fields = {
  __typename?: 'variaveis_calc_variaveis_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_base_propriedades_calc?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_instante_leitura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Calc_Variaveis_Variance_Fields = {
  __typename?: 'variaveis_calc_variaveis_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_base_propriedades_calc?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_instante_leitura?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "variaveis.dominios" */
export type Variaveis_Dominios = {
  __typename?: 'variaveis_dominios';
  apagado: Scalars['Boolean']['output'];
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  id_integracao?: Maybe<Scalars['bigint']['output']>;
  numerico?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  variaveisBase: Array<Variaveis_Base>;
  /** An aggregate relationship */
  variaveisBase_aggregate: Variaveis_Base_Aggregate;
};


/** columns and relationships of "variaveis.dominios" */
export type Variaveis_DominiosVariaveisBaseArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Bool_Exp>;
};


/** columns and relationships of "variaveis.dominios" */
export type Variaveis_DominiosVariaveisBase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Base_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Base_Order_By>>;
  where?: InputMaybe<Variaveis_Base_Bool_Exp>;
};

/** aggregated selection of "variaveis.dominios" */
export type Variaveis_Dominios_Aggregate = {
  __typename?: 'variaveis_dominios_aggregate';
  aggregate?: Maybe<Variaveis_Dominios_Aggregate_Fields>;
  nodes: Array<Variaveis_Dominios>;
};

/** aggregate fields of "variaveis.dominios" */
export type Variaveis_Dominios_Aggregate_Fields = {
  __typename?: 'variaveis_dominios_aggregate_fields';
  avg?: Maybe<Variaveis_Dominios_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Dominios_Max_Fields>;
  min?: Maybe<Variaveis_Dominios_Min_Fields>;
  stddev?: Maybe<Variaveis_Dominios_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Dominios_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Dominios_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Dominios_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Dominios_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Dominios_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Dominios_Variance_Fields>;
};


/** aggregate fields of "variaveis.dominios" */
export type Variaveis_Dominios_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Dominios_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Dominios_Avg_Fields = {
  __typename?: 'variaveis_dominios_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_integracao?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.dominios". All fields are combined with a logical 'AND'. */
export type Variaveis_Dominios_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Dominios_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Dominios_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Dominios_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_integracao?: InputMaybe<Bigint_Comparison_Exp>;
  numerico?: InputMaybe<Boolean_Comparison_Exp>;
  variaveisBase?: InputMaybe<Variaveis_Base_Bool_Exp>;
  variaveisBase_aggregate?: InputMaybe<Variaveis_Base_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "variaveis.dominios" */
export enum Variaveis_Dominios_Constraint {
  /** unique or primary key constraint on columns "id" */
  DominiosPkey = 'dominios_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.dominios" */
export type Variaveis_Dominios_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_integracao?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.dominios" */
export type Variaveis_Dominios_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_integracao?: InputMaybe<Scalars['bigint']['input']>;
  numerico?: InputMaybe<Scalars['Boolean']['input']>;
  variaveisBase?: InputMaybe<Variaveis_Base_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Variaveis_Dominios_Max_Fields = {
  __typename?: 'variaveis_dominios_max_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_integracao?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Dominios_Min_Fields = {
  __typename?: 'variaveis_dominios_min_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_integracao?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "variaveis.dominios" */
export type Variaveis_Dominios_Mutation_Response = {
  __typename?: 'variaveis_dominios_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Dominios>;
};

/** input type for inserting object relation for remote table "variaveis.dominios" */
export type Variaveis_Dominios_Obj_Rel_Insert_Input = {
  data: Variaveis_Dominios_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Dominios_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.dominios" */
export type Variaveis_Dominios_On_Conflict = {
  constraint: Variaveis_Dominios_Constraint;
  update_columns?: Array<Variaveis_Dominios_Update_Column>;
  where?: InputMaybe<Variaveis_Dominios_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.dominios". */
export type Variaveis_Dominios_Order_By = {
  apagado?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_integracao?: InputMaybe<Order_By>;
  numerico?: InputMaybe<Order_By>;
  variaveisBase_aggregate?: InputMaybe<Variaveis_Base_Aggregate_Order_By>;
};

/** primary key columns input for table: variaveis.dominios */
export type Variaveis_Dominios_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "variaveis.dominios_r_dominios_valores" */
export type Variaveis_Dominios_R_Dominios_Valores = {
  __typename?: 'variaveis_dominios_r_dominios_valores';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  dominio: Variaveis_Dominios;
  /** An object relationship */
  dominioValor: Variaveis_Dominios_Valores;
  id: Scalars['bigint']['output'];
  id_dominio: Scalars['bigint']['output'];
  id_valor_dominio: Scalars['bigint']['output'];
  ordem: Scalars['Int']['output'];
};

/** aggregated selection of "variaveis.dominios_r_dominios_valores" */
export type Variaveis_Dominios_R_Dominios_Valores_Aggregate = {
  __typename?: 'variaveis_dominios_r_dominios_valores_aggregate';
  aggregate?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Aggregate_Fields>;
  nodes: Array<Variaveis_Dominios_R_Dominios_Valores>;
};

/** aggregate fields of "variaveis.dominios_r_dominios_valores" */
export type Variaveis_Dominios_R_Dominios_Valores_Aggregate_Fields = {
  __typename?: 'variaveis_dominios_r_dominios_valores_aggregate_fields';
  avg?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Max_Fields>;
  min?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Min_Fields>;
  stddev?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Dominios_R_Dominios_Valores_Variance_Fields>;
};


/** aggregate fields of "variaveis.dominios_r_dominios_valores" */
export type Variaveis_Dominios_R_Dominios_Valores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Dominios_R_Dominios_Valores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Dominios_R_Dominios_Valores_Avg_Fields = {
  __typename?: 'variaveis_dominios_r_dominios_valores_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.dominios_r_dominios_valores". All fields are combined with a logical 'AND'. */
export type Variaveis_Dominios_R_Dominios_Valores_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Dominios_R_Dominios_Valores_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Dominios_R_Dominios_Valores_Bool_Exp>>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  dominio?: InputMaybe<Variaveis_Dominios_Bool_Exp>;
  dominioValor?: InputMaybe<Variaveis_Dominios_Valores_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_dominio?: InputMaybe<Bigint_Comparison_Exp>;
  id_valor_dominio?: InputMaybe<Bigint_Comparison_Exp>;
  ordem?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.dominios_r_dominios_valores" */
export enum Variaveis_Dominios_R_Dominios_Valores_Constraint {
  /** unique or primary key constraint on columns "id" */
  ValoresdominioPkey = 'valoresdominio_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.dominios_r_dominios_valores" */
export type Variaveis_Dominios_R_Dominios_Valores_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_valor_dominio?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "variaveis.dominios_r_dominios_valores" */
export type Variaveis_Dominios_R_Dominios_Valores_Insert_Input = {
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  dominio?: InputMaybe<Variaveis_Dominios_Obj_Rel_Insert_Input>;
  dominioValor?: InputMaybe<Variaveis_Dominios_Valores_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_valor_dominio?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Dominios_R_Dominios_Valores_Max_Fields = {
  __typename?: 'variaveis_dominios_r_dominios_valores_max_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_dominio?: Maybe<Scalars['bigint']['output']>;
  id_valor_dominio?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Dominios_R_Dominios_Valores_Min_Fields = {
  __typename?: 'variaveis_dominios_r_dominios_valores_min_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_dominio?: Maybe<Scalars['bigint']['output']>;
  id_valor_dominio?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "variaveis.dominios_r_dominios_valores" */
export type Variaveis_Dominios_R_Dominios_Valores_Mutation_Response = {
  __typename?: 'variaveis_dominios_r_dominios_valores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Dominios_R_Dominios_Valores>;
};

/** on_conflict condition type for table "variaveis.dominios_r_dominios_valores" */
export type Variaveis_Dominios_R_Dominios_Valores_On_Conflict = {
  constraint: Variaveis_Dominios_R_Dominios_Valores_Constraint;
  update_columns?: Array<Variaveis_Dominios_R_Dominios_Valores_Update_Column>;
  where?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.dominios_r_dominios_valores". */
export type Variaveis_Dominios_R_Dominios_Valores_Order_By = {
  codigo_externo?: InputMaybe<Order_By>;
  dominio?: InputMaybe<Variaveis_Dominios_Order_By>;
  dominioValor?: InputMaybe<Variaveis_Dominios_Valores_Order_By>;
  id?: InputMaybe<Order_By>;
  id_dominio?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.dominios_r_dominios_valores */
export type Variaveis_Dominios_R_Dominios_Valores_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.dominios_r_dominios_valores" */
export enum Variaveis_Dominios_R_Dominios_Valores_Select_Column {
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Id = 'id',
  /** column name */
  IdDominio = 'id_dominio',
  /** column name */
  IdValorDominio = 'id_valor_dominio',
  /** column name */
  Ordem = 'ordem'
}

/** input type for updating data in table "variaveis.dominios_r_dominios_valores" */
export type Variaveis_Dominios_R_Dominios_Valores_Set_Input = {
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_valor_dominio?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Dominios_R_Dominios_Valores_Stddev_Fields = {
  __typename?: 'variaveis_dominios_r_dominios_valores_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Dominios_R_Dominios_Valores_Stddev_Pop_Fields = {
  __typename?: 'variaveis_dominios_r_dominios_valores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Dominios_R_Dominios_Valores_Stddev_Samp_Fields = {
  __typename?: 'variaveis_dominios_r_dominios_valores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_dominios_r_dominios_valores" */
export type Variaveis_Dominios_R_Dominios_Valores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Dominios_R_Dominios_Valores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Dominios_R_Dominios_Valores_Stream_Cursor_Value_Input = {
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_dominio?: InputMaybe<Scalars['bigint']['input']>;
  id_valor_dominio?: InputMaybe<Scalars['bigint']['input']>;
  ordem?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Dominios_R_Dominios_Valores_Sum_Fields = {
  __typename?: 'variaveis_dominios_r_dominios_valores_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_dominio?: Maybe<Scalars['bigint']['output']>;
  id_valor_dominio?: Maybe<Scalars['bigint']['output']>;
  ordem?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "variaveis.dominios_r_dominios_valores" */
export enum Variaveis_Dominios_R_Dominios_Valores_Update_Column {
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Id = 'id',
  /** column name */
  IdDominio = 'id_dominio',
  /** column name */
  IdValorDominio = 'id_valor_dominio',
  /** column name */
  Ordem = 'ordem'
}

export type Variaveis_Dominios_R_Dominios_Valores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Dominios_R_Dominios_Valores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Dominios_R_Dominios_Valores_Var_Pop_Fields = {
  __typename?: 'variaveis_dominios_r_dominios_valores_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Dominios_R_Dominios_Valores_Var_Samp_Fields = {
  __typename?: 'variaveis_dominios_r_dominios_valores_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Dominios_R_Dominios_Valores_Variance_Fields = {
  __typename?: 'variaveis_dominios_r_dominios_valores_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_dominio?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ordem?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "variaveis.dominios" */
export enum Variaveis_Dominios_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdIntegracao = 'id_integracao',
  /** column name */
  Numerico = 'numerico'
}

/** input type for updating data in table "variaveis.dominios" */
export type Variaveis_Dominios_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_integracao?: InputMaybe<Scalars['bigint']['input']>;
  numerico?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Dominios_Stddev_Fields = {
  __typename?: 'variaveis_dominios_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_integracao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Dominios_Stddev_Pop_Fields = {
  __typename?: 'variaveis_dominios_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_integracao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Dominios_Stddev_Samp_Fields = {
  __typename?: 'variaveis_dominios_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_integracao?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_dominios" */
export type Variaveis_Dominios_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Dominios_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Dominios_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_integracao?: InputMaybe<Scalars['bigint']['input']>;
  numerico?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Dominios_Sum_Fields = {
  __typename?: 'variaveis_dominios_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_integracao?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "variaveis.dominios" */
export enum Variaveis_Dominios_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdIntegracao = 'id_integracao',
  /** column name */
  Numerico = 'numerico'
}

export type Variaveis_Dominios_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Dominios_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Dominios_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Dominios_Bool_Exp;
};

/** columns and relationships of "variaveis.dominios_valores" */
export type Variaveis_Dominios_Valores = {
  __typename?: 'variaveis_dominios_valores';
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  valor?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "variaveis.dominios_valores" */
export type Variaveis_Dominios_Valores_Aggregate = {
  __typename?: 'variaveis_dominios_valores_aggregate';
  aggregate?: Maybe<Variaveis_Dominios_Valores_Aggregate_Fields>;
  nodes: Array<Variaveis_Dominios_Valores>;
};

/** aggregate fields of "variaveis.dominios_valores" */
export type Variaveis_Dominios_Valores_Aggregate_Fields = {
  __typename?: 'variaveis_dominios_valores_aggregate_fields';
  avg?: Maybe<Variaveis_Dominios_Valores_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Dominios_Valores_Max_Fields>;
  min?: Maybe<Variaveis_Dominios_Valores_Min_Fields>;
  stddev?: Maybe<Variaveis_Dominios_Valores_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Dominios_Valores_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Dominios_Valores_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Dominios_Valores_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Dominios_Valores_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Dominios_Valores_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Dominios_Valores_Variance_Fields>;
};


/** aggregate fields of "variaveis.dominios_valores" */
export type Variaveis_Dominios_Valores_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Dominios_Valores_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Dominios_Valores_Avg_Fields = {
  __typename?: 'variaveis_dominios_valores_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.dominios_valores". All fields are combined with a logical 'AND'. */
export type Variaveis_Dominios_Valores_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Dominios_Valores_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Dominios_Valores_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Dominios_Valores_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  valor?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.dominios_valores" */
export enum Variaveis_Dominios_Valores_Constraint {
  /** unique or primary key constraint on columns "descricao" */
  DominiosValoresDescricaoKey = 'dominios_valores_descricao_key',
  /** unique or primary key constraint on columns "id" */
  DominiosValoresPkey = 'dominios_valores_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.dominios_valores" */
export type Variaveis_Dominios_Valores_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  valor?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "variaveis.dominios_valores" */
export type Variaveis_Dominios_Valores_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  valor?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Dominios_Valores_Max_Fields = {
  __typename?: 'variaveis_dominios_valores_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  valor?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Dominios_Valores_Min_Fields = {
  __typename?: 'variaveis_dominios_valores_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  valor?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "variaveis.dominios_valores" */
export type Variaveis_Dominios_Valores_Mutation_Response = {
  __typename?: 'variaveis_dominios_valores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Dominios_Valores>;
};

/** input type for inserting object relation for remote table "variaveis.dominios_valores" */
export type Variaveis_Dominios_Valores_Obj_Rel_Insert_Input = {
  data: Variaveis_Dominios_Valores_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Dominios_Valores_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.dominios_valores" */
export type Variaveis_Dominios_Valores_On_Conflict = {
  constraint: Variaveis_Dominios_Valores_Constraint;
  update_columns?: Array<Variaveis_Dominios_Valores_Update_Column>;
  where?: InputMaybe<Variaveis_Dominios_Valores_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.dominios_valores". */
export type Variaveis_Dominios_Valores_Order_By = {
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.dominios_valores */
export type Variaveis_Dominios_Valores_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.dominios_valores" */
export enum Variaveis_Dominios_Valores_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  Valor = 'valor'
}

/** input type for updating data in table "variaveis.dominios_valores" */
export type Variaveis_Dominios_Valores_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  valor?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Dominios_Valores_Stddev_Fields = {
  __typename?: 'variaveis_dominios_valores_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Dominios_Valores_Stddev_Pop_Fields = {
  __typename?: 'variaveis_dominios_valores_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Dominios_Valores_Stddev_Samp_Fields = {
  __typename?: 'variaveis_dominios_valores_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_dominios_valores" */
export type Variaveis_Dominios_Valores_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Dominios_Valores_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Dominios_Valores_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  valor?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Dominios_Valores_Sum_Fields = {
  __typename?: 'variaveis_dominios_valores_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  valor?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "variaveis.dominios_valores" */
export enum Variaveis_Dominios_Valores_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  Valor = 'valor'
}

export type Variaveis_Dominios_Valores_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Dominios_Valores_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Dominios_Valores_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Dominios_Valores_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Dominios_Valores_Var_Pop_Fields = {
  __typename?: 'variaveis_dominios_valores_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Dominios_Valores_Var_Samp_Fields = {
  __typename?: 'variaveis_dominios_valores_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Dominios_Valores_Variance_Fields = {
  __typename?: 'variaveis_dominios_valores_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Variaveis_Dominios_Var_Pop_Fields = {
  __typename?: 'variaveis_dominios_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_integracao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Dominios_Var_Samp_Fields = {
  __typename?: 'variaveis_dominios_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_integracao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Dominios_Variance_Fields = {
  __typename?: 'variaveis_dominios_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_integracao?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao = {
  __typename?: 'variaveis_escalas_precisao';
  id: Scalars['bigint']['output'];
  id_parametro_r_unidade_medida: Scalars['bigint']['output'];
  limite_max: Scalars['numeric']['output'];
  limite_min: Scalars['numeric']['output'];
  nr_casas_decimais: Scalars['Int']['output'];
};

/** aggregated selection of "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Aggregate = {
  __typename?: 'variaveis_escalas_precisao_aggregate';
  aggregate?: Maybe<Variaveis_Escalas_Precisao_Aggregate_Fields>;
  nodes: Array<Variaveis_Escalas_Precisao>;
};

export type Variaveis_Escalas_Precisao_Aggregate_Bool_Exp = {
  count?: InputMaybe<Variaveis_Escalas_Precisao_Aggregate_Bool_Exp_Count>;
};

export type Variaveis_Escalas_Precisao_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variaveis_Escalas_Precisao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Escalas_Precisao_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Aggregate_Fields = {
  __typename?: 'variaveis_escalas_precisao_aggregate_fields';
  avg?: Maybe<Variaveis_Escalas_Precisao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Escalas_Precisao_Max_Fields>;
  min?: Maybe<Variaveis_Escalas_Precisao_Min_Fields>;
  stddev?: Maybe<Variaveis_Escalas_Precisao_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Escalas_Precisao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Escalas_Precisao_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Escalas_Precisao_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Escalas_Precisao_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Escalas_Precisao_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Escalas_Precisao_Variance_Fields>;
};


/** aggregate fields of "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Escalas_Precisao_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Aggregate_Order_By = {
  avg?: InputMaybe<Variaveis_Escalas_Precisao_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variaveis_Escalas_Precisao_Max_Order_By>;
  min?: InputMaybe<Variaveis_Escalas_Precisao_Min_Order_By>;
  stddev?: InputMaybe<Variaveis_Escalas_Precisao_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variaveis_Escalas_Precisao_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variaveis_Escalas_Precisao_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variaveis_Escalas_Precisao_Sum_Order_By>;
  var_pop?: InputMaybe<Variaveis_Escalas_Precisao_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variaveis_Escalas_Precisao_Var_Samp_Order_By>;
  variance?: InputMaybe<Variaveis_Escalas_Precisao_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Arr_Rel_Insert_Input = {
  data: Array<Variaveis_Escalas_Precisao_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Escalas_Precisao_On_Conflict>;
};

/** aggregate avg on columns */
export type Variaveis_Escalas_Precisao_Avg_Fields = {
  __typename?: 'variaveis_escalas_precisao_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  limite_max?: Maybe<Scalars['Float']['output']>;
  limite_min?: Maybe<Scalars['Float']['output']>;
  nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  limite_max?: InputMaybe<Order_By>;
  limite_min?: InputMaybe<Order_By>;
  nr_casas_decimais?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variaveis.escalas_precisao". All fields are combined with a logical 'AND'. */
export type Variaveis_Escalas_Precisao_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Escalas_Precisao_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Escalas_Precisao_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Escalas_Precisao_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_parametro_r_unidade_medida?: InputMaybe<Bigint_Comparison_Exp>;
  limite_max?: InputMaybe<Numeric_Comparison_Exp>;
  limite_min?: InputMaybe<Numeric_Comparison_Exp>;
  nr_casas_decimais?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.escalas_precisao" */
export enum Variaveis_Escalas_Precisao_Constraint {
  /** unique or primary key constraint on columns "id" */
  EscalasPrecisaoPkey = 'escalas_precisao_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro_r_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
  limite_max?: InputMaybe<Scalars['numeric']['input']>;
  limite_min?: InputMaybe<Scalars['numeric']['input']>;
  nr_casas_decimais?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro_r_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
  limite_max?: InputMaybe<Scalars['numeric']['input']>;
  limite_min?: InputMaybe<Scalars['numeric']['input']>;
  nr_casas_decimais?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Escalas_Precisao_Max_Fields = {
  __typename?: 'variaveis_escalas_precisao_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['bigint']['output']>;
  limite_max?: Maybe<Scalars['numeric']['output']>;
  limite_min?: Maybe<Scalars['numeric']['output']>;
  nr_casas_decimais?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  limite_max?: InputMaybe<Order_By>;
  limite_min?: InputMaybe<Order_By>;
  nr_casas_decimais?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variaveis_Escalas_Precisao_Min_Fields = {
  __typename?: 'variaveis_escalas_precisao_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['bigint']['output']>;
  limite_max?: Maybe<Scalars['numeric']['output']>;
  limite_min?: Maybe<Scalars['numeric']['output']>;
  nr_casas_decimais?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  limite_max?: InputMaybe<Order_By>;
  limite_min?: InputMaybe<Order_By>;
  nr_casas_decimais?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Mutation_Response = {
  __typename?: 'variaveis_escalas_precisao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Escalas_Precisao>;
};

/** on_conflict condition type for table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_On_Conflict = {
  constraint: Variaveis_Escalas_Precisao_Constraint;
  update_columns?: Array<Variaveis_Escalas_Precisao_Update_Column>;
  where?: InputMaybe<Variaveis_Escalas_Precisao_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.escalas_precisao". */
export type Variaveis_Escalas_Precisao_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  limite_max?: InputMaybe<Order_By>;
  limite_min?: InputMaybe<Order_By>;
  nr_casas_decimais?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.escalas_precisao */
export type Variaveis_Escalas_Precisao_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.escalas_precisao" */
export enum Variaveis_Escalas_Precisao_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdParametroRUnidadeMedida = 'id_parametro_r_unidade_medida',
  /** column name */
  LimiteMax = 'limite_max',
  /** column name */
  LimiteMin = 'limite_min',
  /** column name */
  NrCasasDecimais = 'nr_casas_decimais'
}

/** input type for updating data in table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro_r_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
  limite_max?: InputMaybe<Scalars['numeric']['input']>;
  limite_min?: InputMaybe<Scalars['numeric']['input']>;
  nr_casas_decimais?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Escalas_Precisao_Stddev_Fields = {
  __typename?: 'variaveis_escalas_precisao_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  limite_max?: Maybe<Scalars['Float']['output']>;
  limite_min?: Maybe<Scalars['Float']['output']>;
  nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  limite_max?: InputMaybe<Order_By>;
  limite_min?: InputMaybe<Order_By>;
  nr_casas_decimais?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Escalas_Precisao_Stddev_Pop_Fields = {
  __typename?: 'variaveis_escalas_precisao_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  limite_max?: Maybe<Scalars['Float']['output']>;
  limite_min?: Maybe<Scalars['Float']['output']>;
  nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  limite_max?: InputMaybe<Order_By>;
  limite_min?: InputMaybe<Order_By>;
  nr_casas_decimais?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Escalas_Precisao_Stddev_Samp_Fields = {
  __typename?: 'variaveis_escalas_precisao_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  limite_max?: Maybe<Scalars['Float']['output']>;
  limite_min?: Maybe<Scalars['Float']['output']>;
  nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  limite_max?: InputMaybe<Order_By>;
  limite_min?: InputMaybe<Order_By>;
  nr_casas_decimais?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variaveis_escalas_precisao" */
export type Variaveis_Escalas_Precisao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Escalas_Precisao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Escalas_Precisao_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro_r_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
  limite_max?: InputMaybe<Scalars['numeric']['input']>;
  limite_min?: InputMaybe<Scalars['numeric']['input']>;
  nr_casas_decimais?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Escalas_Precisao_Sum_Fields = {
  __typename?: 'variaveis_escalas_precisao_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['bigint']['output']>;
  limite_max?: Maybe<Scalars['numeric']['output']>;
  limite_min?: Maybe<Scalars['numeric']['output']>;
  nr_casas_decimais?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  limite_max?: InputMaybe<Order_By>;
  limite_min?: InputMaybe<Order_By>;
  nr_casas_decimais?: InputMaybe<Order_By>;
};

/** update columns of table "variaveis.escalas_precisao" */
export enum Variaveis_Escalas_Precisao_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IdParametroRUnidadeMedida = 'id_parametro_r_unidade_medida',
  /** column name */
  LimiteMax = 'limite_max',
  /** column name */
  LimiteMin = 'limite_min',
  /** column name */
  NrCasasDecimais = 'nr_casas_decimais'
}

export type Variaveis_Escalas_Precisao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Escalas_Precisao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Escalas_Precisao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Escalas_Precisao_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Escalas_Precisao_Var_Pop_Fields = {
  __typename?: 'variaveis_escalas_precisao_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  limite_max?: Maybe<Scalars['Float']['output']>;
  limite_min?: Maybe<Scalars['Float']['output']>;
  nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  limite_max?: InputMaybe<Order_By>;
  limite_min?: InputMaybe<Order_By>;
  nr_casas_decimais?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variaveis_Escalas_Precisao_Var_Samp_Fields = {
  __typename?: 'variaveis_escalas_precisao_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  limite_max?: Maybe<Scalars['Float']['output']>;
  limite_min?: Maybe<Scalars['Float']['output']>;
  nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  limite_max?: InputMaybe<Order_By>;
  limite_min?: InputMaybe<Order_By>;
  nr_casas_decimais?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variaveis_Escalas_Precisao_Variance_Fields = {
  __typename?: 'variaveis_escalas_precisao_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  limite_max?: Maybe<Scalars['Float']['output']>;
  limite_min?: Maybe<Scalars['Float']['output']>;
  nr_casas_decimais?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variaveis.escalas_precisao" */
export type Variaveis_Escalas_Precisao_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  limite_max?: InputMaybe<Order_By>;
  limite_min?: InputMaybe<Order_By>;
  nr_casas_decimais?: InputMaybe<Order_By>;
};

/** columns and relationships of "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem = {
  __typename?: 'variaveis_fontes_origem';
  apagado?: Maybe<Scalars['Boolean']['output']>;
  codigo_externo?: Maybe<Scalars['String']['output']>;
  desativado?: Maybe<Scalars['Boolean']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  estatistica?: Maybe<Variaveis_Fontes_Origem_Estatistica>;
  id: Scalars['bigint']['output'];
  id_parametro_r_unidade_medida: Scalars['bigint']['output'];
  id_tipo_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_totalizador?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  infraestruturaEstatistica: Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica>;
  /** An aggregate relationship */
  infraestruturaEstatistica_aggregate: Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate;
  /** An array relationship */
  leituras: Array<Variaveis_Leituras>;
  /** An aggregate relationship */
  leituras_aggregate: Variaveis_Leituras_Aggregate;
  /** An object relationship */
  parametroUnidadeMedida: Variaveis_Parametros_R_Unidades_Medida;
  principal?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  tipo?: Maybe<Variaveis_Fontes_Origem_Tipos>;
  /** An object relationship */
  variavel?: Maybe<Variaveis_Base>;
  widget_icone?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "variaveis.fontes_origem" */
export type Variaveis_Fontes_OrigemInfraestruturaEstatisticaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
};


/** columns and relationships of "variaveis.fontes_origem" */
export type Variaveis_Fontes_OrigemInfraestruturaEstatistica_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Order_By>>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
};


/** columns and relationships of "variaveis.fontes_origem" */
export type Variaveis_Fontes_OrigemLeiturasArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};


/** columns and relationships of "variaveis.fontes_origem" */
export type Variaveis_Fontes_OrigemLeituras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Leituras_Order_By>>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};

/** aggregated selection of "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Aggregate = {
  __typename?: 'variaveis_fontes_origem_aggregate';
  aggregate?: Maybe<Variaveis_Fontes_Origem_Aggregate_Fields>;
  nodes: Array<Variaveis_Fontes_Origem>;
};

export type Variaveis_Fontes_Origem_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Variaveis_Fontes_Origem_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Variaveis_Fontes_Origem_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Variaveis_Fontes_Origem_Aggregate_Bool_Exp_Count>;
};

export type Variaveis_Fontes_Origem_Aggregate_Bool_Exp_Bool_And = {
  arguments: Variaveis_Fontes_Origem_Select_Column_Variaveis_Fontes_Origem_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Fontes_Origem_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Variaveis_Fontes_Origem_Select_Column_Variaveis_Fontes_Origem_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Fontes_Origem_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variaveis_Fontes_Origem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Aggregate_Fields = {
  __typename?: 'variaveis_fontes_origem_aggregate_fields';
  avg?: Maybe<Variaveis_Fontes_Origem_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Fontes_Origem_Max_Fields>;
  min?: Maybe<Variaveis_Fontes_Origem_Min_Fields>;
  stddev?: Maybe<Variaveis_Fontes_Origem_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Fontes_Origem_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Fontes_Origem_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Fontes_Origem_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Fontes_Origem_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Fontes_Origem_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Fontes_Origem_Variance_Fields>;
};


/** aggregate fields of "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Fontes_Origem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Aggregate_Order_By = {
  avg?: InputMaybe<Variaveis_Fontes_Origem_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variaveis_Fontes_Origem_Max_Order_By>;
  min?: InputMaybe<Variaveis_Fontes_Origem_Min_Order_By>;
  stddev?: InputMaybe<Variaveis_Fontes_Origem_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variaveis_Fontes_Origem_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variaveis_Fontes_Origem_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variaveis_Fontes_Origem_Sum_Order_By>;
  var_pop?: InputMaybe<Variaveis_Fontes_Origem_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variaveis_Fontes_Origem_Var_Samp_Order_By>;
  variance?: InputMaybe<Variaveis_Fontes_Origem_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Arr_Rel_Insert_Input = {
  data: Array<Variaveis_Fontes_Origem_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_On_Conflict>;
};

/** aggregate avg on columns */
export type Variaveis_Fontes_Origem_Avg_Fields = {
  __typename?: 'variaveis_fontes_origem_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  id_tipo_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_totalizador?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  id_tipo_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_totalizador?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variaveis.fontes_origem". All fields are combined with a logical 'AND'. */
export type Variaveis_Fontes_Origem_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Fontes_Origem_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Fontes_Origem_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  desativado?: InputMaybe<Boolean_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  estatistica?: InputMaybe<Variaveis_Fontes_Origem_Estatistica_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_parametro_r_unidade_medida?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_fonte_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_tipo_totalizador?: InputMaybe<Bigint_Comparison_Exp>;
  id_variavel_base?: InputMaybe<Bigint_Comparison_Exp>;
  infraestruturaEstatistica?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
  infraestruturaEstatistica_aggregate?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate_Bool_Exp>;
  leituras?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
  leituras_aggregate?: InputMaybe<Variaveis_Leituras_Aggregate_Bool_Exp>;
  parametroUnidadeMedida?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
  principal?: InputMaybe<Boolean_Comparison_Exp>;
  tipo?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Bool_Exp>;
  variavel?: InputMaybe<Variaveis_Base_Bool_Exp>;
  widget_icone?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.fontes_origem" */
export enum Variaveis_Fontes_Origem_Constraint {
  /** unique or primary key constraint on columns "id" */
  FontesOrigemPkey = 'fontes_origem_pkey'
}

/** columns and relationships of "variaveis.fontes_origem_estatistica" */
export type Variaveis_Fontes_Origem_Estatistica = {
  __typename?: 'variaveis_fontes_origem_estatistica';
  count?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  infraestrutura?: Maybe<Scalars['Boolean']['output']>;
  toponimia?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "variaveis.fontes_origem_estatistica" */
export type Variaveis_Fontes_Origem_Estatistica_Aggregate = {
  __typename?: 'variaveis_fontes_origem_estatistica_aggregate';
  aggregate?: Maybe<Variaveis_Fontes_Origem_Estatistica_Aggregate_Fields>;
  nodes: Array<Variaveis_Fontes_Origem_Estatistica>;
};

/** aggregate fields of "variaveis.fontes_origem_estatistica" */
export type Variaveis_Fontes_Origem_Estatistica_Aggregate_Fields = {
  __typename?: 'variaveis_fontes_origem_estatistica_aggregate_fields';
  avg?: Maybe<Variaveis_Fontes_Origem_Estatistica_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Fontes_Origem_Estatistica_Max_Fields>;
  min?: Maybe<Variaveis_Fontes_Origem_Estatistica_Min_Fields>;
  stddev?: Maybe<Variaveis_Fontes_Origem_Estatistica_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Fontes_Origem_Estatistica_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Fontes_Origem_Estatistica_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Fontes_Origem_Estatistica_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Fontes_Origem_Estatistica_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Fontes_Origem_Estatistica_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Fontes_Origem_Estatistica_Variance_Fields>;
};


/** aggregate fields of "variaveis.fontes_origem_estatistica" */
export type Variaveis_Fontes_Origem_Estatistica_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Fontes_Origem_Estatistica_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Fontes_Origem_Estatistica_Avg_Fields = {
  __typename?: 'variaveis_fontes_origem_estatistica_avg_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.fontes_origem_estatistica". All fields are combined with a logical 'AND'. */
export type Variaveis_Fontes_Origem_Estatistica_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Fontes_Origem_Estatistica_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Fontes_Origem_Estatistica_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Fontes_Origem_Estatistica_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  id_fonte_origem?: InputMaybe<Bigint_Comparison_Exp>;
  infraestrutura?: InputMaybe<Boolean_Comparison_Exp>;
  toponimia?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.fontes_origem_estatistica" */
export enum Variaveis_Fontes_Origem_Estatistica_Constraint {
  /** unique or primary key constraint on columns "id_fonte_origem" */
  FontesOrigemEstatisticaIdFonteOrigemIdx = 'fontes_origem_estatistica_id_fonte_origem_idx'
}

/** input type for inserting data into table "variaveis.fontes_origem_estatistica" */
export type Variaveis_Fontes_Origem_Estatistica_Insert_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Scalars['Boolean']['input']>;
  toponimia?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Fontes_Origem_Estatistica_Max_Fields = {
  __typename?: 'variaveis_fontes_origem_estatistica_max_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Fontes_Origem_Estatistica_Min_Fields = {
  __typename?: 'variaveis_fontes_origem_estatistica_min_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
};

/** input type for inserting object relation for remote table "variaveis.fontes_origem_estatistica" */
export type Variaveis_Fontes_Origem_Estatistica_Obj_Rel_Insert_Input = {
  data: Variaveis_Fontes_Origem_Estatistica_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_Estatistica_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.fontes_origem_estatistica" */
export type Variaveis_Fontes_Origem_Estatistica_On_Conflict = {
  constraint: Variaveis_Fontes_Origem_Estatistica_Constraint;
  update_columns?: Array<Variaveis_Fontes_Origem_Estatistica_Update_Column>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Estatistica_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.fontes_origem_estatistica". */
export type Variaveis_Fontes_Origem_Estatistica_Order_By = {
  count?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Order_By>;
  toponimia?: InputMaybe<Order_By>;
};

/** select columns of table "variaveis.fontes_origem_estatistica" */
export enum Variaveis_Fontes_Origem_Estatistica_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  Infraestrutura = 'infraestrutura',
  /** column name */
  Toponimia = 'toponimia'
}

/** aggregate stddev on columns */
export type Variaveis_Fontes_Origem_Estatistica_Stddev_Fields = {
  __typename?: 'variaveis_fontes_origem_estatistica_stddev_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Fontes_Origem_Estatistica_Stddev_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_estatistica_stddev_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Fontes_Origem_Estatistica_Stddev_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_estatistica_stddev_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_fontes_origem_estatistica" */
export type Variaveis_Fontes_Origem_Estatistica_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Fontes_Origem_Estatistica_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Fontes_Origem_Estatistica_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Scalars['Boolean']['input']>;
  toponimia?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Fontes_Origem_Estatistica_Sum_Fields = {
  __typename?: 'variaveis_fontes_origem_estatistica_sum_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "variaveis.fontes_origem_estatistica" */
export enum Variaveis_Fontes_Origem_Estatistica_Update_Column {
  /** column name */
  Count = 'count',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  Infraestrutura = 'infraestrutura',
  /** column name */
  Toponimia = 'toponimia'
}

/** aggregate var_pop on columns */
export type Variaveis_Fontes_Origem_Estatistica_Var_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_estatistica_var_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Fontes_Origem_Estatistica_Var_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_estatistica_var_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Fontes_Origem_Estatistica_Variance_Fields = {
  __typename?: 'variaveis_fontes_origem_estatistica_variance_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro_r_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_totalizador?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
};

/** columns and relationships of "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica';
  count?: Maybe<Scalars['bigint']['output']>;
  data_hora_atualizacao?: Maybe<Scalars['timestamptz']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_aggregate';
  aggregate?: Maybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate_Fields>;
  nodes: Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica>;
};

export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate_Bool_Exp = {
  count?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate_Bool_Exp_Count>;
};

export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate_Fields = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_aggregate_fields';
  avg?: Maybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Max_Fields>;
  min?: Maybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Min_Fields>;
  stddev?: Maybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Variance_Fields>;
};


/** aggregate fields of "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate_Order_By = {
  avg?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Max_Order_By>;
  min?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Min_Order_By>;
  stddev?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Sum_Order_By>;
  var_pop?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Var_Samp_Order_By>;
  variance?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Arr_Rel_Insert_Input = {
  data: Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_On_Conflict>;
};

/** aggregate avg on columns */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Avg_Fields = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_avg_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variaveis.fontes_origem_infraestrutura_estatistica". All fields are combined with a logical 'AND'. */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  data_hora_atualizacao?: InputMaybe<Timestamptz_Comparison_Exp>;
  id_fonte_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.fontes_origem_infraestrutura_estatistica" */
export enum Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Constraint {
  /** unique or primary key constraint on columns "id_infraestrutura", "id_fonte_origem" */
  FontesOrigemInfraestruturaIdFonteOrigemIdInfraestruIdx = 'fontes_origem_infraestrutura__id_fonte_origem_id_infraestru_idx'
}

/** input type for inserting data into table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Insert_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  data_hora_atualizacao?: InputMaybe<Scalars['timestamptz']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Max_Fields = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_max_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  data_hora_atualizacao?: Maybe<Scalars['timestamptz']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  data_hora_atualizacao?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Min_Fields = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_min_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  data_hora_atualizacao?: Maybe<Scalars['timestamptz']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  data_hora_atualizacao?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_On_Conflict = {
  constraint: Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Constraint;
  update_columns?: Array<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Update_Column>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.fontes_origem_infraestrutura_estatistica". */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Order_By = {
  count?: InputMaybe<Order_By>;
  data_hora_atualizacao?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** select columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export enum Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  DataHoraAtualizacao = 'data_hora_atualizacao',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura'
}

/** aggregate stddev on columns */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Fields = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_stddev_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_stddev_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_stddev_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variaveis_fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  data_hora_atualizacao?: InputMaybe<Scalars['timestamptz']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Sum_Fields = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_sum_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** update columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export enum Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Update_Column {
  /** column name */
  Count = 'count',
  /** column name */
  DataHoraAtualizacao = 'data_hora_atualizacao',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura'
}

/** aggregate var_pop on columns */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Var_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_var_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Var_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_var_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Variance_Fields = {
  __typename?: 'variaveis_fontes_origem_infraestrutura_estatistica_variance_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variaveis.fontes_origem_infraestrutura_estatistica" */
export type Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  desativado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  estatistica?: InputMaybe<Variaveis_Fontes_Origem_Estatistica_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro_r_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_totalizador?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  infraestruturaEstatistica?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Arr_Rel_Insert_Input>;
  leituras?: InputMaybe<Variaveis_Leituras_Arr_Rel_Insert_Input>;
  parametroUnidadeMedida?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Obj_Rel_Insert_Input>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
  tipo?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Obj_Rel_Insert_Input>;
  variavel?: InputMaybe<Variaveis_Base_Obj_Rel_Insert_Input>;
  widget_icone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Fontes_Origem_Max_Fields = {
  __typename?: 'variaveis_fontes_origem_max_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['bigint']['output']>;
  id_tipo_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_totalizador?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  widget_icone?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Max_Order_By = {
  codigo_externo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  id_tipo_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_totalizador?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  widget_icone?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variaveis_Fontes_Origem_Min_Fields = {
  __typename?: 'variaveis_fontes_origem_min_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['bigint']['output']>;
  id_tipo_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_totalizador?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  widget_icone?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Min_Order_By = {
  codigo_externo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  id_tipo_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_totalizador?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  widget_icone?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Mutation_Response = {
  __typename?: 'variaveis_fontes_origem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Fontes_Origem>;
};

/** input type for inserting object relation for remote table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Obj_Rel_Insert_Input = {
  data: Variaveis_Fontes_Origem_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_On_Conflict = {
  constraint: Variaveis_Fontes_Origem_Constraint;
  update_columns?: Array<Variaveis_Fontes_Origem_Update_Column>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.fontes_origem". */
export type Variaveis_Fontes_Origem_Order_By = {
  apagado?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  desativado?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  estatistica?: InputMaybe<Variaveis_Fontes_Origem_Estatistica_Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  id_tipo_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_totalizador?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  infraestruturaEstatistica_aggregate?: InputMaybe<Variaveis_Fontes_Origem_Infraestrutura_Estatistica_Aggregate_Order_By>;
  leituras_aggregate?: InputMaybe<Variaveis_Leituras_Aggregate_Order_By>;
  parametroUnidadeMedida?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Order_By>;
  principal?: InputMaybe<Order_By>;
  tipo?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Order_By>;
  variavel?: InputMaybe<Variaveis_Base_Order_By>;
  widget_icone?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.fontes_origem */
export type Variaveis_Fontes_Origem_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "variaveis.fontes_origem_plano_padrao_estatistica" */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica';
  count?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_plano_padrao?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "variaveis.fontes_origem_plano_padrao_estatistica" */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Aggregate = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_aggregate';
  aggregate?: Maybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Aggregate_Fields>;
  nodes: Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica>;
};

/** aggregate fields of "variaveis.fontes_origem_plano_padrao_estatistica" */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Aggregate_Fields = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_aggregate_fields';
  avg?: Maybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Max_Fields>;
  min?: Maybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Min_Fields>;
  stddev?: Maybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Variance_Fields>;
};


/** aggregate fields of "variaveis.fontes_origem_plano_padrao_estatistica" */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Avg_Fields = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_avg_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.fontes_origem_plano_padrao_estatistica". All fields are combined with a logical 'AND'. */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  id_fonte_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_plano_padrao?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Max_Fields = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_max_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_plano_padrao?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Min_Fields = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_min_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_plano_padrao?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "variaveis.fontes_origem_plano_padrao_estatistica". */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Order_By = {
  count?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_plano_padrao?: InputMaybe<Order_By>;
};

/** select columns of table "variaveis.fontes_origem_plano_padrao_estatistica" */
export enum Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdPlanoPadrao = 'id_plano_padrao'
}

/** aggregate stddev on columns */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Stddev_Fields = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_stddev_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Stddev_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_stddev_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Stddev_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_stddev_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_fontes_origem_plano_padrao_estatistica" */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_plano_padrao?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Sum_Fields = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_sum_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_plano_padrao?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Var_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_var_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Var_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_var_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Fontes_Origem_Plano_Padrao_Estatistica_Variance_Fields = {
  __typename?: 'variaveis_fontes_origem_plano_padrao_estatistica_variance_fields';
  count?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_plano_padrao?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades = {
  __typename?: 'variaveis_fontes_origem_propriedades';
  agregacao_horaria_enabled?: Maybe<Scalars['Boolean']['output']>;
  apagado: Scalars['Boolean']['output'];
  /** An object relationship */
  fonteOrigem: Variaveis_Fontes_Origem;
  id: Scalars['bigint']['output'];
  id_fonte_origem: Scalars['bigint']['output'];
  id_infraestrutura: Scalars['bigint']['output'];
  /** An object relationship */
  infraestrutura: Base_Infraestruturas;
  register_enabled?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Aggregate = {
  __typename?: 'variaveis_fontes_origem_propriedades_aggregate';
  aggregate?: Maybe<Variaveis_Fontes_Origem_Propriedades_Aggregate_Fields>;
  nodes: Array<Variaveis_Fontes_Origem_Propriedades>;
};

export type Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp_Count>;
};

export type Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp_Bool_And = {
  arguments: Variaveis_Fontes_Origem_Propriedades_Select_Column_Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Variaveis_Fontes_Origem_Propriedades_Select_Column_Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Aggregate_Fields = {
  __typename?: 'variaveis_fontes_origem_propriedades_aggregate_fields';
  avg?: Maybe<Variaveis_Fontes_Origem_Propriedades_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Fontes_Origem_Propriedades_Max_Fields>;
  min?: Maybe<Variaveis_Fontes_Origem_Propriedades_Min_Fields>;
  stddev?: Maybe<Variaveis_Fontes_Origem_Propriedades_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Fontes_Origem_Propriedades_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Fontes_Origem_Propriedades_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Fontes_Origem_Propriedades_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Fontes_Origem_Propriedades_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Fontes_Origem_Propriedades_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Fontes_Origem_Propriedades_Variance_Fields>;
};


/** aggregate fields of "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Aggregate_Order_By = {
  avg?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Max_Order_By>;
  min?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Min_Order_By>;
  stddev?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Sum_Order_By>;
  var_pop?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Var_Samp_Order_By>;
  variance?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Arr_Rel_Insert_Input = {
  data: Array<Variaveis_Fontes_Origem_Propriedades_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_On_Conflict>;
};

/** aggregate avg on columns */
export type Variaveis_Fontes_Origem_Propriedades_Avg_Fields = {
  __typename?: 'variaveis_fontes_origem_propriedades_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variaveis.fontes_origem_propriedades". All fields are combined with a logical 'AND'. */
export type Variaveis_Fontes_Origem_Propriedades_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>>;
  agregacao_horaria_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_fonte_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  register_enabled?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.fontes_origem_propriedades" */
export enum Variaveis_Fontes_Origem_Propriedades_Constraint {
  /** unique or primary key constraint on columns "id" */
  FontesOrigemPropriedadesPkey = 'fontes_origem_propriedades_pkey',
  /** unique or primary key constraint on columns "id_infraestrutura", "id_fonte_origem" */
  UniqueFontesOrigemPropriedadesIdFonteOrigemIdInfraestru = 'unique_fontes_origem_propriedades_id_fonte_origem_id_infraestru'
}

/** input type for incrementing numeric columns in table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Insert_Input = {
  agregacao_horaria_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
  register_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Fontes_Origem_Propriedades_Max_Fields = {
  __typename?: 'variaveis_fontes_origem_propriedades_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variaveis_Fontes_Origem_Propriedades_Min_Fields = {
  __typename?: 'variaveis_fontes_origem_propriedades_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Mutation_Response = {
  __typename?: 'variaveis_fontes_origem_propriedades_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Fontes_Origem_Propriedades>;
};

/** input type for inserting object relation for remote table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Obj_Rel_Insert_Input = {
  data: Variaveis_Fontes_Origem_Propriedades_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_On_Conflict = {
  constraint: Variaveis_Fontes_Origem_Propriedades_Constraint;
  update_columns?: Array<Variaveis_Fontes_Origem_Propriedades_Update_Column>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.fontes_origem_propriedades". */
export type Variaveis_Fontes_Origem_Propriedades_Order_By = {
  agregacao_horaria_enabled?: InputMaybe<Order_By>;
  apagado?: InputMaybe<Order_By>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Order_By>;
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
  register_enabled?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.fontes_origem_propriedades */
export type Variaveis_Fontes_Origem_Propriedades_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.fontes_origem_propriedades" */
export enum Variaveis_Fontes_Origem_Propriedades_Select_Column {
  /** column name */
  AgregacaoHorariaEnabled = 'agregacao_horaria_enabled',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Id = 'id',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  RegisterEnabled = 'register_enabled'
}

/** select "variaveis_fontes_origem_propriedades_aggregate_bool_exp_bool_and_arguments_columns" columns of table "variaveis.fontes_origem_propriedades" */
export enum Variaveis_Fontes_Origem_Propriedades_Select_Column_Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AgregacaoHorariaEnabled = 'agregacao_horaria_enabled',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  RegisterEnabled = 'register_enabled'
}

/** select "variaveis_fontes_origem_propriedades_aggregate_bool_exp_bool_or_arguments_columns" columns of table "variaveis.fontes_origem_propriedades" */
export enum Variaveis_Fontes_Origem_Propriedades_Select_Column_Variaveis_Fontes_Origem_Propriedades_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AgregacaoHorariaEnabled = 'agregacao_horaria_enabled',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  RegisterEnabled = 'register_enabled'
}

/** input type for updating data in table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Set_Input = {
  agregacao_horaria_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  register_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Fontes_Origem_Propriedades_Stddev_Fields = {
  __typename?: 'variaveis_fontes_origem_propriedades_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Fontes_Origem_Propriedades_Stddev_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_propriedades_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Fontes_Origem_Propriedades_Stddev_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_propriedades_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variaveis_fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Fontes_Origem_Propriedades_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Fontes_Origem_Propriedades_Stream_Cursor_Value_Input = {
  agregacao_horaria_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  register_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Fontes_Origem_Propriedades_Sum_Fields = {
  __typename?: 'variaveis_fontes_origem_propriedades_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** update columns of table "variaveis.fontes_origem_propriedades" */
export enum Variaveis_Fontes_Origem_Propriedades_Update_Column {
  /** column name */
  AgregacaoHorariaEnabled = 'agregacao_horaria_enabled',
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Id = 'id',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  RegisterEnabled = 'register_enabled'
}

export type Variaveis_Fontes_Origem_Propriedades_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Fontes_Origem_Propriedades_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Fontes_Origem_Propriedades_Var_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_propriedades_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variaveis_Fontes_Origem_Propriedades_Var_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_propriedades_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variaveis_Fontes_Origem_Propriedades_Variance_Fields = {
  __typename?: 'variaveis_fontes_origem_propriedades_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variaveis.fontes_origem_propriedades" */
export type Variaveis_Fontes_Origem_Propriedades_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
};

/** select columns of table "variaveis.fontes_origem" */
export enum Variaveis_Fontes_Origem_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Desativado = 'desativado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdParametroRUnidadeMedida = 'id_parametro_r_unidade_medida',
  /** column name */
  IdTipoFonteOrigem = 'id_tipo_fonte_origem',
  /** column name */
  IdTipoTotalizador = 'id_tipo_totalizador',
  /** column name */
  IdVariavelBase = 'id_variavel_base',
  /** column name */
  Principal = 'principal',
  /** column name */
  WidgetIcone = 'widget_icone'
}

/** select "variaveis_fontes_origem_aggregate_bool_exp_bool_and_arguments_columns" columns of table "variaveis.fontes_origem" */
export enum Variaveis_Fontes_Origem_Select_Column_Variaveis_Fontes_Origem_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Desativado = 'desativado',
  /** column name */
  Principal = 'principal'
}

/** select "variaveis_fontes_origem_aggregate_bool_exp_bool_or_arguments_columns" columns of table "variaveis.fontes_origem" */
export enum Variaveis_Fontes_Origem_Select_Column_Variaveis_Fontes_Origem_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Desativado = 'desativado',
  /** column name */
  Principal = 'principal'
}

/** input type for updating data in table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  desativado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro_r_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_totalizador?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
  widget_icone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Fontes_Origem_Stddev_Fields = {
  __typename?: 'variaveis_fontes_origem_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  id_tipo_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_totalizador?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  id_tipo_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_totalizador?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Fontes_Origem_Stddev_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  id_tipo_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_totalizador?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  id_tipo_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_totalizador?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Fontes_Origem_Stddev_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  id_tipo_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_totalizador?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  id_tipo_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_totalizador?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variaveis_fontes_origem" */
export type Variaveis_Fontes_Origem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Fontes_Origem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Fontes_Origem_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  desativado?: InputMaybe<Scalars['Boolean']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro_r_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_tipo_totalizador?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
  widget_icone?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Fontes_Origem_Sum_Fields = {
  __typename?: 'variaveis_fontes_origem_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['bigint']['output']>;
  id_tipo_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_tipo_totalizador?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  id_tipo_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_totalizador?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
};

/** columns and relationships of "variaveis.fontes_origem_tipos" */
export type Variaveis_Fontes_Origem_Tipos = {
  __typename?: 'variaveis_fontes_origem_tipos';
  descricao: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "variaveis.fontes_origem_tipos" */
export type Variaveis_Fontes_Origem_Tipos_Aggregate = {
  __typename?: 'variaveis_fontes_origem_tipos_aggregate';
  aggregate?: Maybe<Variaveis_Fontes_Origem_Tipos_Aggregate_Fields>;
  nodes: Array<Variaveis_Fontes_Origem_Tipos>;
};

/** aggregate fields of "variaveis.fontes_origem_tipos" */
export type Variaveis_Fontes_Origem_Tipos_Aggregate_Fields = {
  __typename?: 'variaveis_fontes_origem_tipos_aggregate_fields';
  avg?: Maybe<Variaveis_Fontes_Origem_Tipos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Fontes_Origem_Tipos_Max_Fields>;
  min?: Maybe<Variaveis_Fontes_Origem_Tipos_Min_Fields>;
  stddev?: Maybe<Variaveis_Fontes_Origem_Tipos_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Fontes_Origem_Tipos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Fontes_Origem_Tipos_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Fontes_Origem_Tipos_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Fontes_Origem_Tipos_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Fontes_Origem_Tipos_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Fontes_Origem_Tipos_Variance_Fields>;
};


/** aggregate fields of "variaveis.fontes_origem_tipos" */
export type Variaveis_Fontes_Origem_Tipos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Fontes_Origem_Tipos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Fontes_Origem_Tipos_Avg_Fields = {
  __typename?: 'variaveis_fontes_origem_tipos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.fontes_origem_tipos". All fields are combined with a logical 'AND'. */
export type Variaveis_Fontes_Origem_Tipos_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Fontes_Origem_Tipos_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Fontes_Origem_Tipos_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.fontes_origem_tipos" */
export enum Variaveis_Fontes_Origem_Tipos_Constraint {
  /** unique or primary key constraint on columns "descricao" */
  FontesOrigemTiposDescricaoKey = 'fontes_origem_tipos_descricao_key',
  /** unique or primary key constraint on columns "id" */
  FontesOrigemTiposPkey = 'fontes_origem_tipos_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.fontes_origem_tipos" */
export type Variaveis_Fontes_Origem_Tipos_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.fontes_origem_tipos" */
export type Variaveis_Fontes_Origem_Tipos_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Fontes_Origem_Tipos_Max_Fields = {
  __typename?: 'variaveis_fontes_origem_tipos_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Fontes_Origem_Tipos_Min_Fields = {
  __typename?: 'variaveis_fontes_origem_tipos_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "variaveis.fontes_origem_tipos" */
export type Variaveis_Fontes_Origem_Tipos_Mutation_Response = {
  __typename?: 'variaveis_fontes_origem_tipos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Fontes_Origem_Tipos>;
};

/** input type for inserting object relation for remote table "variaveis.fontes_origem_tipos" */
export type Variaveis_Fontes_Origem_Tipos_Obj_Rel_Insert_Input = {
  data: Variaveis_Fontes_Origem_Tipos_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Fontes_Origem_Tipos_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.fontes_origem_tipos" */
export type Variaveis_Fontes_Origem_Tipos_On_Conflict = {
  constraint: Variaveis_Fontes_Origem_Tipos_Constraint;
  update_columns?: Array<Variaveis_Fontes_Origem_Tipos_Update_Column>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.fontes_origem_tipos". */
export type Variaveis_Fontes_Origem_Tipos_Order_By = {
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.fontes_origem_tipos */
export type Variaveis_Fontes_Origem_Tipos_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.fontes_origem_tipos" */
export enum Variaveis_Fontes_Origem_Tipos_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "variaveis.fontes_origem_tipos" */
export type Variaveis_Fontes_Origem_Tipos_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Fontes_Origem_Tipos_Stddev_Fields = {
  __typename?: 'variaveis_fontes_origem_tipos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Fontes_Origem_Tipos_Stddev_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_tipos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Fontes_Origem_Tipos_Stddev_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_tipos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_fontes_origem_tipos" */
export type Variaveis_Fontes_Origem_Tipos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Fontes_Origem_Tipos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Fontes_Origem_Tipos_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Fontes_Origem_Tipos_Sum_Fields = {
  __typename?: 'variaveis_fontes_origem_tipos_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "variaveis.fontes_origem_tipos" */
export enum Variaveis_Fontes_Origem_Tipos_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Variaveis_Fontes_Origem_Tipos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Fontes_Origem_Tipos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Fontes_Origem_Tipos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Fontes_Origem_Tipos_Var_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_tipos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Fontes_Origem_Tipos_Var_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_tipos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Fontes_Origem_Tipos_Variance_Fields = {
  __typename?: 'variaveis_fontes_origem_tipos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** update columns of table "variaveis.fontes_origem" */
export enum Variaveis_Fontes_Origem_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Desativado = 'desativado',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  IdParametroRUnidadeMedida = 'id_parametro_r_unidade_medida',
  /** column name */
  IdTipoFonteOrigem = 'id_tipo_fonte_origem',
  /** column name */
  IdTipoTotalizador = 'id_tipo_totalizador',
  /** column name */
  IdVariavelBase = 'id_variavel_base',
  /** column name */
  Principal = 'principal',
  /** column name */
  WidgetIcone = 'widget_icone'
}

export type Variaveis_Fontes_Origem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Fontes_Origem_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Fontes_Origem_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Fontes_Origem_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Fontes_Origem_Var_Pop_Fields = {
  __typename?: 'variaveis_fontes_origem_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  id_tipo_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_totalizador?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  id_tipo_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_totalizador?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variaveis_Fontes_Origem_Var_Samp_Fields = {
  __typename?: 'variaveis_fontes_origem_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  id_tipo_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_totalizador?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  id_tipo_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_totalizador?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variaveis_Fontes_Origem_Variance_Fields = {
  __typename?: 'variaveis_fontes_origem_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro_r_unidade_medida?: Maybe<Scalars['Float']['output']>;
  id_tipo_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_tipo_totalizador?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variaveis.fontes_origem" */
export type Variaveis_Fontes_Origem_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_parametro_r_unidade_medida?: InputMaybe<Order_By>;
  id_tipo_fonte_origem?: InputMaybe<Order_By>;
  id_tipo_totalizador?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
};

/** columns and relationships of "variaveis.leituras" */
export type Variaveis_Leituras = {
  __typename?: 'variaveis_leituras';
  data_analise?: Maybe<Scalars['timestamp']['output']>;
  data_hora: Scalars['timestamp']['output'];
  data_hora_registo_bd: Scalars['timestamp']['output'];
  data_hora_ultima_modificacao: Scalars['timestamp']['output'];
  /** An object relationship */
  fonteOrigem: Variaveis_Fontes_Origem;
  id: Scalars['bigint']['output'];
  id_amostra?: Maybe<Scalars['bigint']['output']>;
  id_area_afetada?: Maybe<Scalars['bigint']['output']>;
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem: Scalars['bigint']['output'];
  id_hardware: Scalars['bigint']['output'];
  id_importacao_ficheiro_dado?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_laboratorio?: Maybe<Scalars['bigint']['output']>;
  id_metodo_analise?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia?: Maybe<Scalars['bigint']['output']>;
  id_origem: Scalars['bigint']['output'];
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_bulk?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_totalizador_tipo_registo?: Maybe<Scalars['bigint']['output']>;
  id_utilizador: Scalars['bigint']['output'];
  id_valor_dominio?: Maybe<Scalars['bigint']['output']>;
  ids_erros?: Maybe<Scalars['String']['output']>;
  ids_valores_dominio?: Maybe<Scalars['String']['output']>;
  ignorar_aviso?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  infraestrutura?: Maybe<Base_Infraestruturas>;
  /** An object relationship */
  intervencao?: Maybe<Servicos_Intervencoes>;
  ixis_cod_resultado?: Maybe<Scalars['bigint']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  ocorrencia_variavel_local?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  requisicao?: Maybe<Servicos_Requisicoes>;
  reset_valor_totalizador_anterior?: Maybe<Scalars['numeric']['output']>;
  rgpd_ofuscado: Scalars['Boolean']['output'];
  sinal?: Maybe<Scalars['bpchar']['output']>;
  /** An object relationship */
  toponimia?: Maybe<Base_Toponimias>;
  validacao_data?: Maybe<Scalars['timestamp']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  valor_data?: Maybe<Scalars['timestamp']['output']>;
  valor_incompleto?: Maybe<Scalars['Boolean']['output']>;
  valor_numerico?: Maybe<Scalars['numeric']['output']>;
  valor_raw?: Maybe<Scalars['String']['output']>;
  valor_tempo?: Maybe<Scalars['bigint']['output']>;
  valor_texto?: Maybe<Scalars['String']['output']>;
  volta_contador?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "variaveis.leituras" */
export type Variaveis_Leituras_Aggregate = {
  __typename?: 'variaveis_leituras_aggregate';
  aggregate?: Maybe<Variaveis_Leituras_Aggregate_Fields>;
  nodes: Array<Variaveis_Leituras>;
};

export type Variaveis_Leituras_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Variaveis_Leituras_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Variaveis_Leituras_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Variaveis_Leituras_Aggregate_Bool_Exp_Count>;
};

export type Variaveis_Leituras_Aggregate_Bool_Exp_Bool_And = {
  arguments: Variaveis_Leituras_Select_Column_Variaveis_Leituras_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Leituras_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Variaveis_Leituras_Select_Column_Variaveis_Leituras_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Leituras_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variaveis.leituras" */
export type Variaveis_Leituras_Aggregate_Fields = {
  __typename?: 'variaveis_leituras_aggregate_fields';
  avg?: Maybe<Variaveis_Leituras_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Leituras_Max_Fields>;
  min?: Maybe<Variaveis_Leituras_Min_Fields>;
  stddev?: Maybe<Variaveis_Leituras_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Leituras_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Leituras_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Leituras_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Leituras_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Leituras_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Leituras_Variance_Fields>;
};


/** aggregate fields of "variaveis.leituras" */
export type Variaveis_Leituras_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Leituras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variaveis.leituras" */
export type Variaveis_Leituras_Aggregate_Order_By = {
  avg?: InputMaybe<Variaveis_Leituras_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variaveis_Leituras_Max_Order_By>;
  min?: InputMaybe<Variaveis_Leituras_Min_Order_By>;
  stddev?: InputMaybe<Variaveis_Leituras_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variaveis_Leituras_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variaveis_Leituras_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variaveis_Leituras_Sum_Order_By>;
  var_pop?: InputMaybe<Variaveis_Leituras_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variaveis_Leituras_Var_Samp_Order_By>;
  variance?: InputMaybe<Variaveis_Leituras_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variaveis.leituras" */
export type Variaveis_Leituras_Arr_Rel_Insert_Input = {
  data: Array<Variaveis_Leituras_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Leituras_On_Conflict>;
};

/** aggregate avg on columns */
export type Variaveis_Leituras_Avg_Fields = {
  __typename?: 'variaveis_leituras_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_area_afetada?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_hardware?: Maybe<Scalars['Float']['output']>;
  id_importacao_ficheiro_dado?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_laboratorio?: Maybe<Scalars['Float']['output']>;
  id_metodo_analise?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa_bulk?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_totalizador_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ixis_cod_resultado?: Maybe<Scalars['Float']['output']>;
  reset_valor_totalizador_anterior?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_numerico?: Maybe<Scalars['Float']['output']>;
  valor_tempo?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variaveis.leituras" */
export type Variaveis_Leituras_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_area_afetada?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_hardware?: InputMaybe<Order_By>;
  id_importacao_ficheiro_dado?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_laboratorio?: InputMaybe<Order_By>;
  id_metodo_analise?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa_bulk?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_totalizador_tipo_registo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ixis_cod_resultado?: InputMaybe<Order_By>;
  reset_valor_totalizador_anterior?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_numerico?: InputMaybe<Order_By>;
  valor_tempo?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variaveis.leituras". All fields are combined with a logical 'AND'. */
export type Variaveis_Leituras_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Leituras_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Leituras_Bool_Exp>>;
  data_analise?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_registo_bd?: InputMaybe<Timestamp_Comparison_Exp>;
  data_hora_ultima_modificacao?: InputMaybe<Timestamp_Comparison_Exp>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_amostra?: InputMaybe<Bigint_Comparison_Exp>;
  id_area_afetada?: InputMaybe<Bigint_Comparison_Exp>;
  id_ativo?: InputMaybe<Bigint_Comparison_Exp>;
  id_fase?: InputMaybe<Bigint_Comparison_Exp>;
  id_fonte_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_hardware?: InputMaybe<Bigint_Comparison_Exp>;
  id_importacao_ficheiro_dado?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_intervencao?: InputMaybe<Bigint_Comparison_Exp>;
  id_laboratorio?: InputMaybe<Bigint_Comparison_Exp>;
  id_metodo_analise?: InputMaybe<Bigint_Comparison_Exp>;
  id_ocorrencia?: InputMaybe<Bigint_Comparison_Exp>;
  id_origem?: InputMaybe<Bigint_Comparison_Exp>;
  id_requisicao?: InputMaybe<Bigint_Comparison_Exp>;
  id_tarefa_bulk?: InputMaybe<Bigint_Comparison_Exp>;
  id_toponimia?: InputMaybe<Bigint_Comparison_Exp>;
  id_totalizador_tipo_registo?: InputMaybe<Bigint_Comparison_Exp>;
  id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  id_valor_dominio?: InputMaybe<Bigint_Comparison_Exp>;
  ids_erros?: InputMaybe<String_Comparison_Exp>;
  ids_valores_dominio?: InputMaybe<String_Comparison_Exp>;
  ignorar_aviso?: InputMaybe<Boolean_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
  ixis_cod_resultado?: InputMaybe<Bigint_Comparison_Exp>;
  obs?: InputMaybe<String_Comparison_Exp>;
  ocorrencia_variavel_local?: InputMaybe<Boolean_Comparison_Exp>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Bool_Exp>;
  reset_valor_totalizador_anterior?: InputMaybe<Numeric_Comparison_Exp>;
  rgpd_ofuscado?: InputMaybe<Boolean_Comparison_Exp>;
  sinal?: InputMaybe<Bpchar_Comparison_Exp>;
  toponimia?: InputMaybe<Base_Toponimias_Bool_Exp>;
  validacao_data?: InputMaybe<Timestamp_Comparison_Exp>;
  validacao_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  valor_data?: InputMaybe<Timestamp_Comparison_Exp>;
  valor_incompleto?: InputMaybe<Boolean_Comparison_Exp>;
  valor_numerico?: InputMaybe<Numeric_Comparison_Exp>;
  valor_raw?: InputMaybe<String_Comparison_Exp>;
  valor_tempo?: InputMaybe<Bigint_Comparison_Exp>;
  valor_texto?: InputMaybe<String_Comparison_Exp>;
  volta_contador?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.leituras" */
export enum Variaveis_Leituras_Constraint {
  /** unique or primary key constraint on columns "id_amostra", "id_fonte_origem" */
  IndUniqueLeiturasIdAmostraFo = 'ind_unique_leituras_id_amostra_fo',
  /** unique or primary key constraint on columns "id_infraestrutura", "id_fonte_origem", "data_hora" */
  IndUniqueLeiturasIdFoDatahoraInfraestrutura = 'ind_unique_leituras_id_fo_datahora_infraestrutura',
  /** unique or primary key constraint on columns "id_infraestrutura", "id_fase", "id_fonte_origem", "id_tarefa_bulk" */
  IndUniqueLeiturasIdFoInfraestruturaTarefaFase = 'ind_unique_leituras_id_fo_infraestrutura_tarefa_fase',
  /** unique or primary key constraint on columns "id_amostra", "id_fonte_origem", "id_laboratorio" */
  IndUniqueLeiturasIdFoLabAmostra = 'ind_unique_leituras_id_fo_lab_amostra',
  /** unique or primary key constraint on columns "id" */
  LeiturasGlobaisPkey = 'leituras_globais_pkey',
  /** unique or primary key constraint on columns "id_fase", "id_fonte_origem", "id_intervencao" */
  UniqueLeiturasIdFonteOrigemIntervencaoFase = 'unique_leituras_id_fonte_origem_intervencao_fase',
  /** unique or primary key constraint on columns "id_requisicao", "id_fase", "id_fonte_origem" */
  UniqueLeiturasIdFonteOrigemRequisicaoFase = 'unique_leituras_id_fonte_origem_requisicao_fase'
}

/** input type for incrementing numeric columns in table "variaveis.leituras" */
export type Variaveis_Leituras_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_amostra?: InputMaybe<Scalars['bigint']['input']>;
  id_area_afetada?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_hardware?: InputMaybe<Scalars['bigint']['input']>;
  id_importacao_ficheiro_dado?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_laboratorio?: InputMaybe<Scalars['bigint']['input']>;
  id_metodo_analise?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia?: InputMaybe<Scalars['bigint']['input']>;
  id_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_bulk?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_totalizador_tipo_registo?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id_valor_dominio?: InputMaybe<Scalars['bigint']['input']>;
  ixis_cod_resultado?: InputMaybe<Scalars['bigint']['input']>;
  reset_valor_totalizador_anterior?: InputMaybe<Scalars['numeric']['input']>;
  validacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  valor_numerico?: InputMaybe<Scalars['numeric']['input']>;
  valor_tempo?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.leituras" */
export type Variaveis_Leituras_Insert_Input = {
  data_analise?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_amostra?: InputMaybe<Scalars['bigint']['input']>;
  id_area_afetada?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_hardware?: InputMaybe<Scalars['bigint']['input']>;
  id_importacao_ficheiro_dado?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_laboratorio?: InputMaybe<Scalars['bigint']['input']>;
  id_metodo_analise?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia?: InputMaybe<Scalars['bigint']['input']>;
  id_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_bulk?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_totalizador_tipo_registo?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id_valor_dominio?: InputMaybe<Scalars['bigint']['input']>;
  ids_erros?: InputMaybe<Scalars['String']['input']>;
  ids_valores_dominio?: InputMaybe<Scalars['String']['input']>;
  ignorar_aviso?: InputMaybe<Scalars['Boolean']['input']>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Obj_Rel_Insert_Input>;
  ixis_cod_resultado?: InputMaybe<Scalars['bigint']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  ocorrencia_variavel_local?: InputMaybe<Scalars['Boolean']['input']>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Obj_Rel_Insert_Input>;
  reset_valor_totalizador_anterior?: InputMaybe<Scalars['numeric']['input']>;
  rgpd_ofuscado?: InputMaybe<Scalars['Boolean']['input']>;
  sinal?: InputMaybe<Scalars['bpchar']['input']>;
  toponimia?: InputMaybe<Base_Toponimias_Obj_Rel_Insert_Input>;
  validacao_data?: InputMaybe<Scalars['timestamp']['input']>;
  validacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  valor_data?: InputMaybe<Scalars['timestamp']['input']>;
  valor_incompleto?: InputMaybe<Scalars['Boolean']['input']>;
  valor_numerico?: InputMaybe<Scalars['numeric']['input']>;
  valor_raw?: InputMaybe<Scalars['String']['input']>;
  valor_tempo?: InputMaybe<Scalars['bigint']['input']>;
  valor_texto?: InputMaybe<Scalars['String']['input']>;
  volta_contador?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Leituras_Max_Fields = {
  __typename?: 'variaveis_leituras_max_fields';
  data_analise?: Maybe<Scalars['timestamp']['output']>;
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_amostra?: Maybe<Scalars['bigint']['output']>;
  id_area_afetada?: Maybe<Scalars['bigint']['output']>;
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_hardware?: Maybe<Scalars['bigint']['output']>;
  id_importacao_ficheiro_dado?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_laboratorio?: Maybe<Scalars['bigint']['output']>;
  id_metodo_analise?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia?: Maybe<Scalars['bigint']['output']>;
  id_origem?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_bulk?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_totalizador_tipo_registo?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id_valor_dominio?: Maybe<Scalars['bigint']['output']>;
  ids_erros?: Maybe<Scalars['String']['output']>;
  ids_valores_dominio?: Maybe<Scalars['String']['output']>;
  ixis_cod_resultado?: Maybe<Scalars['bigint']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  reset_valor_totalizador_anterior?: Maybe<Scalars['numeric']['output']>;
  sinal?: Maybe<Scalars['bpchar']['output']>;
  validacao_data?: Maybe<Scalars['timestamp']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  valor_data?: Maybe<Scalars['timestamp']['output']>;
  valor_numerico?: Maybe<Scalars['numeric']['output']>;
  valor_raw?: Maybe<Scalars['String']['output']>;
  valor_tempo?: Maybe<Scalars['bigint']['output']>;
  valor_texto?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "variaveis.leituras" */
export type Variaveis_Leituras_Max_Order_By = {
  data_analise?: InputMaybe<Order_By>;
  data_hora?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_area_afetada?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_hardware?: InputMaybe<Order_By>;
  id_importacao_ficheiro_dado?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_laboratorio?: InputMaybe<Order_By>;
  id_metodo_analise?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa_bulk?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_totalizador_tipo_registo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ids_erros?: InputMaybe<Order_By>;
  ids_valores_dominio?: InputMaybe<Order_By>;
  ixis_cod_resultado?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  reset_valor_totalizador_anterior?: InputMaybe<Order_By>;
  sinal?: InputMaybe<Order_By>;
  validacao_data?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_data?: InputMaybe<Order_By>;
  valor_numerico?: InputMaybe<Order_By>;
  valor_raw?: InputMaybe<Order_By>;
  valor_tempo?: InputMaybe<Order_By>;
  valor_texto?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variaveis_Leituras_Min_Fields = {
  __typename?: 'variaveis_leituras_min_fields';
  data_analise?: Maybe<Scalars['timestamp']['output']>;
  data_hora?: Maybe<Scalars['timestamp']['output']>;
  data_hora_registo_bd?: Maybe<Scalars['timestamp']['output']>;
  data_hora_ultima_modificacao?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_amostra?: Maybe<Scalars['bigint']['output']>;
  id_area_afetada?: Maybe<Scalars['bigint']['output']>;
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_hardware?: Maybe<Scalars['bigint']['output']>;
  id_importacao_ficheiro_dado?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_laboratorio?: Maybe<Scalars['bigint']['output']>;
  id_metodo_analise?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia?: Maybe<Scalars['bigint']['output']>;
  id_origem?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_bulk?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_totalizador_tipo_registo?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id_valor_dominio?: Maybe<Scalars['bigint']['output']>;
  ids_erros?: Maybe<Scalars['String']['output']>;
  ids_valores_dominio?: Maybe<Scalars['String']['output']>;
  ixis_cod_resultado?: Maybe<Scalars['bigint']['output']>;
  obs?: Maybe<Scalars['String']['output']>;
  reset_valor_totalizador_anterior?: Maybe<Scalars['numeric']['output']>;
  sinal?: Maybe<Scalars['bpchar']['output']>;
  validacao_data?: Maybe<Scalars['timestamp']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  valor_data?: Maybe<Scalars['timestamp']['output']>;
  valor_numerico?: Maybe<Scalars['numeric']['output']>;
  valor_raw?: Maybe<Scalars['String']['output']>;
  valor_tempo?: Maybe<Scalars['bigint']['output']>;
  valor_texto?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "variaveis.leituras" */
export type Variaveis_Leituras_Min_Order_By = {
  data_analise?: InputMaybe<Order_By>;
  data_hora?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_area_afetada?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_hardware?: InputMaybe<Order_By>;
  id_importacao_ficheiro_dado?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_laboratorio?: InputMaybe<Order_By>;
  id_metodo_analise?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa_bulk?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_totalizador_tipo_registo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ids_erros?: InputMaybe<Order_By>;
  ids_valores_dominio?: InputMaybe<Order_By>;
  ixis_cod_resultado?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  reset_valor_totalizador_anterior?: InputMaybe<Order_By>;
  sinal?: InputMaybe<Order_By>;
  validacao_data?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_data?: InputMaybe<Order_By>;
  valor_numerico?: InputMaybe<Order_By>;
  valor_raw?: InputMaybe<Order_By>;
  valor_tempo?: InputMaybe<Order_By>;
  valor_texto?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variaveis.leituras" */
export type Variaveis_Leituras_Mutation_Response = {
  __typename?: 'variaveis_leituras_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Leituras>;
};

/** on_conflict condition type for table "variaveis.leituras" */
export type Variaveis_Leituras_On_Conflict = {
  constraint: Variaveis_Leituras_Constraint;
  update_columns?: Array<Variaveis_Leituras_Update_Column>;
  where?: InputMaybe<Variaveis_Leituras_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.leituras". */
export type Variaveis_Leituras_Order_By = {
  data_analise?: InputMaybe<Order_By>;
  data_hora?: InputMaybe<Order_By>;
  data_hora_registo_bd?: InputMaybe<Order_By>;
  data_hora_ultima_modificacao?: InputMaybe<Order_By>;
  fonteOrigem?: InputMaybe<Variaveis_Fontes_Origem_Order_By>;
  id?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_area_afetada?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_hardware?: InputMaybe<Order_By>;
  id_importacao_ficheiro_dado?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_laboratorio?: InputMaybe<Order_By>;
  id_metodo_analise?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa_bulk?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_totalizador_tipo_registo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ids_erros?: InputMaybe<Order_By>;
  ids_valores_dominio?: InputMaybe<Order_By>;
  ignorar_aviso?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
  intervencao?: InputMaybe<Servicos_Intervencoes_Order_By>;
  ixis_cod_resultado?: InputMaybe<Order_By>;
  obs?: InputMaybe<Order_By>;
  ocorrencia_variavel_local?: InputMaybe<Order_By>;
  requisicao?: InputMaybe<Servicos_Requisicoes_Order_By>;
  reset_valor_totalizador_anterior?: InputMaybe<Order_By>;
  rgpd_ofuscado?: InputMaybe<Order_By>;
  sinal?: InputMaybe<Order_By>;
  toponimia?: InputMaybe<Base_Toponimias_Order_By>;
  validacao_data?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_data?: InputMaybe<Order_By>;
  valor_incompleto?: InputMaybe<Order_By>;
  valor_numerico?: InputMaybe<Order_By>;
  valor_raw?: InputMaybe<Order_By>;
  valor_tempo?: InputMaybe<Order_By>;
  valor_texto?: InputMaybe<Order_By>;
  volta_contador?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.leituras */
export type Variaveis_Leituras_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.leituras" */
export enum Variaveis_Leituras_Select_Column {
  /** column name */
  DataAnalise = 'data_analise',
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaModificacao = 'data_hora_ultima_modificacao',
  /** column name */
  Id = 'id',
  /** column name */
  IdAmostra = 'id_amostra',
  /** column name */
  IdAreaAfetada = 'id_area_afetada',
  /** column name */
  IdAtivo = 'id_ativo',
  /** column name */
  IdFase = 'id_fase',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdHardware = 'id_hardware',
  /** column name */
  IdImportacaoFicheiroDado = 'id_importacao_ficheiro_dado',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdLaboratorio = 'id_laboratorio',
  /** column name */
  IdMetodoAnalise = 'id_metodo_analise',
  /** column name */
  IdOcorrencia = 'id_ocorrencia',
  /** column name */
  IdOrigem = 'id_origem',
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  IdTarefaBulk = 'id_tarefa_bulk',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  IdTotalizadorTipoRegisto = 'id_totalizador_tipo_registo',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  IdValorDominio = 'id_valor_dominio',
  /** column name */
  IdsErros = 'ids_erros',
  /** column name */
  IdsValoresDominio = 'ids_valores_dominio',
  /** column name */
  IgnorarAviso = 'ignorar_aviso',
  /** column name */
  IxisCodResultado = 'ixis_cod_resultado',
  /** column name */
  Obs = 'obs',
  /** column name */
  OcorrenciaVariavelLocal = 'ocorrencia_variavel_local',
  /** column name */
  ResetValorTotalizadorAnterior = 'reset_valor_totalizador_anterior',
  /** column name */
  RgpdOfuscado = 'rgpd_ofuscado',
  /** column name */
  Sinal = 'sinal',
  /** column name */
  ValidacaoData = 'validacao_data',
  /** column name */
  ValidacaoIdUtilizador = 'validacao_id_utilizador',
  /** column name */
  ValorData = 'valor_data',
  /** column name */
  ValorIncompleto = 'valor_incompleto',
  /** column name */
  ValorNumerico = 'valor_numerico',
  /** column name */
  ValorRaw = 'valor_raw',
  /** column name */
  ValorTempo = 'valor_tempo',
  /** column name */
  ValorTexto = 'valor_texto',
  /** column name */
  VoltaContador = 'volta_contador'
}

/** select "variaveis_leituras_aggregate_bool_exp_bool_and_arguments_columns" columns of table "variaveis.leituras" */
export enum Variaveis_Leituras_Select_Column_Variaveis_Leituras_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IgnorarAviso = 'ignorar_aviso',
  /** column name */
  OcorrenciaVariavelLocal = 'ocorrencia_variavel_local',
  /** column name */
  RgpdOfuscado = 'rgpd_ofuscado',
  /** column name */
  ValorIncompleto = 'valor_incompleto',
  /** column name */
  VoltaContador = 'volta_contador'
}

/** select "variaveis_leituras_aggregate_bool_exp_bool_or_arguments_columns" columns of table "variaveis.leituras" */
export enum Variaveis_Leituras_Select_Column_Variaveis_Leituras_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IgnorarAviso = 'ignorar_aviso',
  /** column name */
  OcorrenciaVariavelLocal = 'ocorrencia_variavel_local',
  /** column name */
  RgpdOfuscado = 'rgpd_ofuscado',
  /** column name */
  ValorIncompleto = 'valor_incompleto',
  /** column name */
  VoltaContador = 'volta_contador'
}

/** input type for updating data in table "variaveis.leituras" */
export type Variaveis_Leituras_Set_Input = {
  data_analise?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_amostra?: InputMaybe<Scalars['bigint']['input']>;
  id_area_afetada?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_hardware?: InputMaybe<Scalars['bigint']['input']>;
  id_importacao_ficheiro_dado?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_laboratorio?: InputMaybe<Scalars['bigint']['input']>;
  id_metodo_analise?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia?: InputMaybe<Scalars['bigint']['input']>;
  id_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_bulk?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_totalizador_tipo_registo?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id_valor_dominio?: InputMaybe<Scalars['bigint']['input']>;
  ids_erros?: InputMaybe<Scalars['String']['input']>;
  ids_valores_dominio?: InputMaybe<Scalars['String']['input']>;
  ignorar_aviso?: InputMaybe<Scalars['Boolean']['input']>;
  ixis_cod_resultado?: InputMaybe<Scalars['bigint']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  ocorrencia_variavel_local?: InputMaybe<Scalars['Boolean']['input']>;
  reset_valor_totalizador_anterior?: InputMaybe<Scalars['numeric']['input']>;
  rgpd_ofuscado?: InputMaybe<Scalars['Boolean']['input']>;
  sinal?: InputMaybe<Scalars['bpchar']['input']>;
  validacao_data?: InputMaybe<Scalars['timestamp']['input']>;
  validacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  valor_data?: InputMaybe<Scalars['timestamp']['input']>;
  valor_incompleto?: InputMaybe<Scalars['Boolean']['input']>;
  valor_numerico?: InputMaybe<Scalars['numeric']['input']>;
  valor_raw?: InputMaybe<Scalars['String']['input']>;
  valor_tempo?: InputMaybe<Scalars['bigint']['input']>;
  valor_texto?: InputMaybe<Scalars['String']['input']>;
  volta_contador?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Leituras_Stddev_Fields = {
  __typename?: 'variaveis_leituras_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_area_afetada?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_hardware?: Maybe<Scalars['Float']['output']>;
  id_importacao_ficheiro_dado?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_laboratorio?: Maybe<Scalars['Float']['output']>;
  id_metodo_analise?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa_bulk?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_totalizador_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ixis_cod_resultado?: Maybe<Scalars['Float']['output']>;
  reset_valor_totalizador_anterior?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_numerico?: Maybe<Scalars['Float']['output']>;
  valor_tempo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variaveis.leituras" */
export type Variaveis_Leituras_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_area_afetada?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_hardware?: InputMaybe<Order_By>;
  id_importacao_ficheiro_dado?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_laboratorio?: InputMaybe<Order_By>;
  id_metodo_analise?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa_bulk?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_totalizador_tipo_registo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ixis_cod_resultado?: InputMaybe<Order_By>;
  reset_valor_totalizador_anterior?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_numerico?: InputMaybe<Order_By>;
  valor_tempo?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Leituras_Stddev_Pop_Fields = {
  __typename?: 'variaveis_leituras_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_area_afetada?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_hardware?: Maybe<Scalars['Float']['output']>;
  id_importacao_ficheiro_dado?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_laboratorio?: Maybe<Scalars['Float']['output']>;
  id_metodo_analise?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa_bulk?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_totalizador_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ixis_cod_resultado?: Maybe<Scalars['Float']['output']>;
  reset_valor_totalizador_anterior?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_numerico?: Maybe<Scalars['Float']['output']>;
  valor_tempo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variaveis.leituras" */
export type Variaveis_Leituras_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_area_afetada?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_hardware?: InputMaybe<Order_By>;
  id_importacao_ficheiro_dado?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_laboratorio?: InputMaybe<Order_By>;
  id_metodo_analise?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa_bulk?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_totalizador_tipo_registo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ixis_cod_resultado?: InputMaybe<Order_By>;
  reset_valor_totalizador_anterior?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_numerico?: InputMaybe<Order_By>;
  valor_tempo?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Leituras_Stddev_Samp_Fields = {
  __typename?: 'variaveis_leituras_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_area_afetada?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_hardware?: Maybe<Scalars['Float']['output']>;
  id_importacao_ficheiro_dado?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_laboratorio?: Maybe<Scalars['Float']['output']>;
  id_metodo_analise?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa_bulk?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_totalizador_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ixis_cod_resultado?: Maybe<Scalars['Float']['output']>;
  reset_valor_totalizador_anterior?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_numerico?: Maybe<Scalars['Float']['output']>;
  valor_tempo?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variaveis.leituras" */
export type Variaveis_Leituras_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_area_afetada?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_hardware?: InputMaybe<Order_By>;
  id_importacao_ficheiro_dado?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_laboratorio?: InputMaybe<Order_By>;
  id_metodo_analise?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa_bulk?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_totalizador_tipo_registo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ixis_cod_resultado?: InputMaybe<Order_By>;
  reset_valor_totalizador_anterior?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_numerico?: InputMaybe<Order_By>;
  valor_tempo?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variaveis_leituras" */
export type Variaveis_Leituras_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Leituras_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Leituras_Stream_Cursor_Value_Input = {
  data_analise?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_registo_bd?: InputMaybe<Scalars['timestamp']['input']>;
  data_hora_ultima_modificacao?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_amostra?: InputMaybe<Scalars['bigint']['input']>;
  id_area_afetada?: InputMaybe<Scalars['bigint']['input']>;
  id_ativo?: InputMaybe<Scalars['bigint']['input']>;
  id_fase?: InputMaybe<Scalars['bigint']['input']>;
  id_fonte_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_hardware?: InputMaybe<Scalars['bigint']['input']>;
  id_importacao_ficheiro_dado?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_intervencao?: InputMaybe<Scalars['bigint']['input']>;
  id_laboratorio?: InputMaybe<Scalars['bigint']['input']>;
  id_metodo_analise?: InputMaybe<Scalars['bigint']['input']>;
  id_ocorrencia?: InputMaybe<Scalars['bigint']['input']>;
  id_origem?: InputMaybe<Scalars['bigint']['input']>;
  id_requisicao?: InputMaybe<Scalars['bigint']['input']>;
  id_tarefa_bulk?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_totalizador_tipo_registo?: InputMaybe<Scalars['bigint']['input']>;
  id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  id_valor_dominio?: InputMaybe<Scalars['bigint']['input']>;
  ids_erros?: InputMaybe<Scalars['String']['input']>;
  ids_valores_dominio?: InputMaybe<Scalars['String']['input']>;
  ignorar_aviso?: InputMaybe<Scalars['Boolean']['input']>;
  ixis_cod_resultado?: InputMaybe<Scalars['bigint']['input']>;
  obs?: InputMaybe<Scalars['String']['input']>;
  ocorrencia_variavel_local?: InputMaybe<Scalars['Boolean']['input']>;
  reset_valor_totalizador_anterior?: InputMaybe<Scalars['numeric']['input']>;
  rgpd_ofuscado?: InputMaybe<Scalars['Boolean']['input']>;
  sinal?: InputMaybe<Scalars['bpchar']['input']>;
  validacao_data?: InputMaybe<Scalars['timestamp']['input']>;
  validacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  valor_data?: InputMaybe<Scalars['timestamp']['input']>;
  valor_incompleto?: InputMaybe<Scalars['Boolean']['input']>;
  valor_numerico?: InputMaybe<Scalars['numeric']['input']>;
  valor_raw?: InputMaybe<Scalars['String']['input']>;
  valor_tempo?: InputMaybe<Scalars['bigint']['input']>;
  valor_texto?: InputMaybe<Scalars['String']['input']>;
  volta_contador?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Leituras_Sum_Fields = {
  __typename?: 'variaveis_leituras_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  id_amostra?: Maybe<Scalars['bigint']['output']>;
  id_area_afetada?: Maybe<Scalars['bigint']['output']>;
  id_ativo?: Maybe<Scalars['bigint']['output']>;
  id_fase?: Maybe<Scalars['bigint']['output']>;
  id_fonte_origem?: Maybe<Scalars['bigint']['output']>;
  id_hardware?: Maybe<Scalars['bigint']['output']>;
  id_importacao_ficheiro_dado?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_intervencao?: Maybe<Scalars['bigint']['output']>;
  id_laboratorio?: Maybe<Scalars['bigint']['output']>;
  id_metodo_analise?: Maybe<Scalars['bigint']['output']>;
  id_ocorrencia?: Maybe<Scalars['bigint']['output']>;
  id_origem?: Maybe<Scalars['bigint']['output']>;
  id_requisicao?: Maybe<Scalars['bigint']['output']>;
  id_tarefa_bulk?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_totalizador_tipo_registo?: Maybe<Scalars['bigint']['output']>;
  id_utilizador?: Maybe<Scalars['bigint']['output']>;
  id_valor_dominio?: Maybe<Scalars['bigint']['output']>;
  ixis_cod_resultado?: Maybe<Scalars['bigint']['output']>;
  reset_valor_totalizador_anterior?: Maybe<Scalars['numeric']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  valor_numerico?: Maybe<Scalars['numeric']['output']>;
  valor_tempo?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "variaveis.leituras" */
export type Variaveis_Leituras_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_area_afetada?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_hardware?: InputMaybe<Order_By>;
  id_importacao_ficheiro_dado?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_laboratorio?: InputMaybe<Order_By>;
  id_metodo_analise?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa_bulk?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_totalizador_tipo_registo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ixis_cod_resultado?: InputMaybe<Order_By>;
  reset_valor_totalizador_anterior?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_numerico?: InputMaybe<Order_By>;
  valor_tempo?: InputMaybe<Order_By>;
};

/** update columns of table "variaveis.leituras" */
export enum Variaveis_Leituras_Update_Column {
  /** column name */
  DataAnalise = 'data_analise',
  /** column name */
  DataHora = 'data_hora',
  /** column name */
  DataHoraRegistoBd = 'data_hora_registo_bd',
  /** column name */
  DataHoraUltimaModificacao = 'data_hora_ultima_modificacao',
  /** column name */
  Id = 'id',
  /** column name */
  IdAmostra = 'id_amostra',
  /** column name */
  IdAreaAfetada = 'id_area_afetada',
  /** column name */
  IdAtivo = 'id_ativo',
  /** column name */
  IdFase = 'id_fase',
  /** column name */
  IdFonteOrigem = 'id_fonte_origem',
  /** column name */
  IdHardware = 'id_hardware',
  /** column name */
  IdImportacaoFicheiroDado = 'id_importacao_ficheiro_dado',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdIntervencao = 'id_intervencao',
  /** column name */
  IdLaboratorio = 'id_laboratorio',
  /** column name */
  IdMetodoAnalise = 'id_metodo_analise',
  /** column name */
  IdOcorrencia = 'id_ocorrencia',
  /** column name */
  IdOrigem = 'id_origem',
  /** column name */
  IdRequisicao = 'id_requisicao',
  /** column name */
  IdTarefaBulk = 'id_tarefa_bulk',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  IdTotalizadorTipoRegisto = 'id_totalizador_tipo_registo',
  /** column name */
  IdUtilizador = 'id_utilizador',
  /** column name */
  IdValorDominio = 'id_valor_dominio',
  /** column name */
  IdsErros = 'ids_erros',
  /** column name */
  IdsValoresDominio = 'ids_valores_dominio',
  /** column name */
  IgnorarAviso = 'ignorar_aviso',
  /** column name */
  IxisCodResultado = 'ixis_cod_resultado',
  /** column name */
  Obs = 'obs',
  /** column name */
  OcorrenciaVariavelLocal = 'ocorrencia_variavel_local',
  /** column name */
  ResetValorTotalizadorAnterior = 'reset_valor_totalizador_anterior',
  /** column name */
  RgpdOfuscado = 'rgpd_ofuscado',
  /** column name */
  Sinal = 'sinal',
  /** column name */
  ValidacaoData = 'validacao_data',
  /** column name */
  ValidacaoIdUtilizador = 'validacao_id_utilizador',
  /** column name */
  ValorData = 'valor_data',
  /** column name */
  ValorIncompleto = 'valor_incompleto',
  /** column name */
  ValorNumerico = 'valor_numerico',
  /** column name */
  ValorRaw = 'valor_raw',
  /** column name */
  ValorTempo = 'valor_tempo',
  /** column name */
  ValorTexto = 'valor_texto',
  /** column name */
  VoltaContador = 'volta_contador'
}

export type Variaveis_Leituras_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Leituras_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Leituras_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Leituras_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Leituras_Var_Pop_Fields = {
  __typename?: 'variaveis_leituras_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_area_afetada?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_hardware?: Maybe<Scalars['Float']['output']>;
  id_importacao_ficheiro_dado?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_laboratorio?: Maybe<Scalars['Float']['output']>;
  id_metodo_analise?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa_bulk?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_totalizador_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ixis_cod_resultado?: Maybe<Scalars['Float']['output']>;
  reset_valor_totalizador_anterior?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_numerico?: Maybe<Scalars['Float']['output']>;
  valor_tempo?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variaveis.leituras" */
export type Variaveis_Leituras_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_area_afetada?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_hardware?: InputMaybe<Order_By>;
  id_importacao_ficheiro_dado?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_laboratorio?: InputMaybe<Order_By>;
  id_metodo_analise?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa_bulk?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_totalizador_tipo_registo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ixis_cod_resultado?: InputMaybe<Order_By>;
  reset_valor_totalizador_anterior?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_numerico?: InputMaybe<Order_By>;
  valor_tempo?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variaveis_Leituras_Var_Samp_Fields = {
  __typename?: 'variaveis_leituras_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_area_afetada?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_hardware?: Maybe<Scalars['Float']['output']>;
  id_importacao_ficheiro_dado?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_laboratorio?: Maybe<Scalars['Float']['output']>;
  id_metodo_analise?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa_bulk?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_totalizador_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ixis_cod_resultado?: Maybe<Scalars['Float']['output']>;
  reset_valor_totalizador_anterior?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_numerico?: Maybe<Scalars['Float']['output']>;
  valor_tempo?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variaveis.leituras" */
export type Variaveis_Leituras_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_area_afetada?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_hardware?: InputMaybe<Order_By>;
  id_importacao_ficheiro_dado?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_laboratorio?: InputMaybe<Order_By>;
  id_metodo_analise?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa_bulk?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_totalizador_tipo_registo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ixis_cod_resultado?: InputMaybe<Order_By>;
  reset_valor_totalizador_anterior?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_numerico?: InputMaybe<Order_By>;
  valor_tempo?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variaveis_Leituras_Variance_Fields = {
  __typename?: 'variaveis_leituras_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  id_amostra?: Maybe<Scalars['Float']['output']>;
  id_area_afetada?: Maybe<Scalars['Float']['output']>;
  id_ativo?: Maybe<Scalars['Float']['output']>;
  id_fase?: Maybe<Scalars['Float']['output']>;
  id_fonte_origem?: Maybe<Scalars['Float']['output']>;
  id_hardware?: Maybe<Scalars['Float']['output']>;
  id_importacao_ficheiro_dado?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_intervencao?: Maybe<Scalars['Float']['output']>;
  id_laboratorio?: Maybe<Scalars['Float']['output']>;
  id_metodo_analise?: Maybe<Scalars['Float']['output']>;
  id_ocorrencia?: Maybe<Scalars['Float']['output']>;
  id_origem?: Maybe<Scalars['Float']['output']>;
  id_requisicao?: Maybe<Scalars['Float']['output']>;
  id_tarefa_bulk?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_totalizador_tipo_registo?: Maybe<Scalars['Float']['output']>;
  id_utilizador?: Maybe<Scalars['Float']['output']>;
  id_valor_dominio?: Maybe<Scalars['Float']['output']>;
  ixis_cod_resultado?: Maybe<Scalars['Float']['output']>;
  reset_valor_totalizador_anterior?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_numerico?: Maybe<Scalars['Float']['output']>;
  valor_tempo?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variaveis.leituras" */
export type Variaveis_Leituras_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  id_amostra?: InputMaybe<Order_By>;
  id_area_afetada?: InputMaybe<Order_By>;
  id_ativo?: InputMaybe<Order_By>;
  id_fase?: InputMaybe<Order_By>;
  id_fonte_origem?: InputMaybe<Order_By>;
  id_hardware?: InputMaybe<Order_By>;
  id_importacao_ficheiro_dado?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_intervencao?: InputMaybe<Order_By>;
  id_laboratorio?: InputMaybe<Order_By>;
  id_metodo_analise?: InputMaybe<Order_By>;
  id_ocorrencia?: InputMaybe<Order_By>;
  id_origem?: InputMaybe<Order_By>;
  id_requisicao?: InputMaybe<Order_By>;
  id_tarefa_bulk?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_totalizador_tipo_registo?: InputMaybe<Order_By>;
  id_utilizador?: InputMaybe<Order_By>;
  id_valor_dominio?: InputMaybe<Order_By>;
  ixis_cod_resultado?: InputMaybe<Order_By>;
  reset_valor_totalizador_anterior?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_numerico?: InputMaybe<Order_By>;
  valor_tempo?: InputMaybe<Order_By>;
};

/** columns and relationships of "variaveis.parametros" */
export type Variaveis_Parametros = {
  __typename?: 'variaveis_parametros';
  apagado: Scalars['Boolean']['output'];
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  parametroUnidadesMedida: Array<Variaveis_Parametros_R_Unidades_Medida>;
  /** An aggregate relationship */
  parametroUnidadesMedida_aggregate: Variaveis_Parametros_R_Unidades_Medida_Aggregate;
  tempo_analise?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "variaveis.parametros" */
export type Variaveis_ParametrosParametroUnidadesMedidaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
};


/** columns and relationships of "variaveis.parametros" */
export type Variaveis_ParametrosParametroUnidadesMedida_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
};

/** aggregated selection of "variaveis.parametros" */
export type Variaveis_Parametros_Aggregate = {
  __typename?: 'variaveis_parametros_aggregate';
  aggregate?: Maybe<Variaveis_Parametros_Aggregate_Fields>;
  nodes: Array<Variaveis_Parametros>;
};

/** aggregate fields of "variaveis.parametros" */
export type Variaveis_Parametros_Aggregate_Fields = {
  __typename?: 'variaveis_parametros_aggregate_fields';
  avg?: Maybe<Variaveis_Parametros_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Parametros_Max_Fields>;
  min?: Maybe<Variaveis_Parametros_Min_Fields>;
  stddev?: Maybe<Variaveis_Parametros_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Parametros_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Parametros_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Parametros_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Parametros_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Parametros_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Parametros_Variance_Fields>;
};


/** aggregate fields of "variaveis.parametros" */
export type Variaveis_Parametros_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Parametros_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Parametros_Avg_Fields = {
  __typename?: 'variaveis_parametros_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.parametros". All fields are combined with a logical 'AND'. */
export type Variaveis_Parametros_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Parametros_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Parametros_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Parametros_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  descricao_curta?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  parametroUnidadesMedida?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
  parametroUnidadesMedida_aggregate?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp>;
  tempo_analise?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.parametros" */
export enum Variaveis_Parametros_Constraint {
  /** unique or primary key constraint on columns "id" */
  ParametrosPkey = 'parametros_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.parametros" */
export type Variaveis_Parametros_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.parametros" */
export type Variaveis_Parametros_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parametroUnidadesMedida?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Arr_Rel_Insert_Input>;
  tempo_analise?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Parametros_Max_Fields = {
  __typename?: 'variaveis_parametros_max_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  tempo_analise?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Parametros_Min_Fields = {
  __typename?: 'variaveis_parametros_min_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  tempo_analise?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "variaveis.parametros" */
export type Variaveis_Parametros_Mutation_Response = {
  __typename?: 'variaveis_parametros_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Parametros>;
};

/** input type for inserting object relation for remote table "variaveis.parametros" */
export type Variaveis_Parametros_Obj_Rel_Insert_Input = {
  data: Variaveis_Parametros_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Parametros_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.parametros" */
export type Variaveis_Parametros_On_Conflict = {
  constraint: Variaveis_Parametros_Constraint;
  update_columns?: Array<Variaveis_Parametros_Update_Column>;
  where?: InputMaybe<Variaveis_Parametros_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.parametros". */
export type Variaveis_Parametros_Order_By = {
  apagado?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parametroUnidadesMedida_aggregate?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Aggregate_Order_By>;
  tempo_analise?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.parametros */
export type Variaveis_Parametros_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida = {
  __typename?: 'variaveis_parametros_r_unidades_medida';
  apagado: Scalars['Boolean']['output'];
  /** An array relationship */
  escalasPrecisao: Array<Variaveis_Escalas_Precisao>;
  /** An aggregate relationship */
  escalasPrecisao_aggregate: Variaveis_Escalas_Precisao_Aggregate;
  factor_multiplicativo: Scalars['String']['output'];
  fator_multiplicativo_numerico: Scalars['numeric']['output'];
  id: Scalars['bigint']['output'];
  id_parametro: Scalars['bigint']['output'];
  id_unidade_medida: Scalars['bigint']['output'];
  /** An object relationship */
  parametro: Variaveis_Parametros;
  principal: Scalars['Boolean']['output'];
  /** An object relationship */
  unidadeMedida: Variaveis_Unidades_Medida;
};


/** columns and relationships of "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_MedidaEscalasPrecisaoArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Escalas_Precisao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Escalas_Precisao_Order_By>>;
  where?: InputMaybe<Variaveis_Escalas_Precisao_Bool_Exp>;
};


/** columns and relationships of "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_MedidaEscalasPrecisao_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Escalas_Precisao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Escalas_Precisao_Order_By>>;
  where?: InputMaybe<Variaveis_Escalas_Precisao_Bool_Exp>;
};

/** aggregated selection of "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Aggregate = {
  __typename?: 'variaveis_parametros_r_unidades_medida_aggregate';
  aggregate?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Aggregate_Fields>;
  nodes: Array<Variaveis_Parametros_R_Unidades_Medida>;
};

export type Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp_Count>;
};

export type Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp_Bool_And = {
  arguments: Variaveis_Parametros_R_Unidades_Medida_Select_Column_Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Variaveis_Parametros_R_Unidades_Medida_Select_Column_Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Aggregate_Fields = {
  __typename?: 'variaveis_parametros_r_unidades_medida_aggregate_fields';
  avg?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Max_Fields>;
  min?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Min_Fields>;
  stddev?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Parametros_R_Unidades_Medida_Variance_Fields>;
};


/** aggregate fields of "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Aggregate_Order_By = {
  avg?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Max_Order_By>;
  min?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Min_Order_By>;
  stddev?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Sum_Order_By>;
  var_pop?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Var_Samp_Order_By>;
  variance?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Arr_Rel_Insert_Input = {
  data: Array<Variaveis_Parametros_R_Unidades_Medida_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_On_Conflict>;
};

/** aggregate avg on columns */
export type Variaveis_Parametros_R_Unidades_Medida_Avg_Fields = {
  __typename?: 'variaveis_parametros_r_unidades_medida_avg_fields';
  fator_multiplicativo_numerico?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_unidade_medida?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Avg_Order_By = {
  fator_multiplicativo_numerico?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_unidade_medida?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variaveis.parametros_r_unidades_medida". All fields are combined with a logical 'AND'. */
export type Variaveis_Parametros_R_Unidades_Medida_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  escalasPrecisao?: InputMaybe<Variaveis_Escalas_Precisao_Bool_Exp>;
  escalasPrecisao_aggregate?: InputMaybe<Variaveis_Escalas_Precisao_Aggregate_Bool_Exp>;
  factor_multiplicativo?: InputMaybe<String_Comparison_Exp>;
  fator_multiplicativo_numerico?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_parametro?: InputMaybe<Bigint_Comparison_Exp>;
  id_unidade_medida?: InputMaybe<Bigint_Comparison_Exp>;
  parametro?: InputMaybe<Variaveis_Parametros_Bool_Exp>;
  principal?: InputMaybe<Boolean_Comparison_Exp>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
};

/** unique or primary key constraints on table "variaveis.parametros_r_unidades_medida" */
export enum Variaveis_Parametros_R_Unidades_Medida_Constraint {
  /** unique or primary key constraint on columns "id" */
  UnidadesMedidaPkey = 'unidades_medida_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Inc_Input = {
  fator_multiplicativo_numerico?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro?: InputMaybe<Scalars['bigint']['input']>;
  id_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  escalasPrecisao?: InputMaybe<Variaveis_Escalas_Precisao_Arr_Rel_Insert_Input>;
  factor_multiplicativo?: InputMaybe<Scalars['String']['input']>;
  fator_multiplicativo_numerico?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro?: InputMaybe<Scalars['bigint']['input']>;
  id_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
  parametro?: InputMaybe<Variaveis_Parametros_Obj_Rel_Insert_Input>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Variaveis_Parametros_R_Unidades_Medida_Max_Fields = {
  __typename?: 'variaveis_parametros_r_unidades_medida_max_fields';
  factor_multiplicativo?: Maybe<Scalars['String']['output']>;
  fator_multiplicativo_numerico?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_parametro?: Maybe<Scalars['bigint']['output']>;
  id_unidade_medida?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Max_Order_By = {
  factor_multiplicativo?: InputMaybe<Order_By>;
  fator_multiplicativo_numerico?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_unidade_medida?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variaveis_Parametros_R_Unidades_Medida_Min_Fields = {
  __typename?: 'variaveis_parametros_r_unidades_medida_min_fields';
  factor_multiplicativo?: Maybe<Scalars['String']['output']>;
  fator_multiplicativo_numerico?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_parametro?: Maybe<Scalars['bigint']['output']>;
  id_unidade_medida?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Min_Order_By = {
  factor_multiplicativo?: InputMaybe<Order_By>;
  fator_multiplicativo_numerico?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_unidade_medida?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Mutation_Response = {
  __typename?: 'variaveis_parametros_r_unidades_medida_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Parametros_R_Unidades_Medida>;
};

/** input type for inserting object relation for remote table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Obj_Rel_Insert_Input = {
  data: Variaveis_Parametros_R_Unidades_Medida_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_On_Conflict = {
  constraint: Variaveis_Parametros_R_Unidades_Medida_Constraint;
  update_columns?: Array<Variaveis_Parametros_R_Unidades_Medida_Update_Column>;
  where?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.parametros_r_unidades_medida". */
export type Variaveis_Parametros_R_Unidades_Medida_Order_By = {
  apagado?: InputMaybe<Order_By>;
  escalasPrecisao_aggregate?: InputMaybe<Variaveis_Escalas_Precisao_Aggregate_Order_By>;
  factor_multiplicativo?: InputMaybe<Order_By>;
  fator_multiplicativo_numerico?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_unidade_medida?: InputMaybe<Order_By>;
  parametro?: InputMaybe<Variaveis_Parametros_Order_By>;
  principal?: InputMaybe<Order_By>;
  unidadeMedida?: InputMaybe<Variaveis_Unidades_Medida_Order_By>;
};

/** primary key columns input for table: variaveis.parametros_r_unidades_medida */
export type Variaveis_Parametros_R_Unidades_Medida_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.parametros_r_unidades_medida" */
export enum Variaveis_Parametros_R_Unidades_Medida_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  FactorMultiplicativo = 'factor_multiplicativo',
  /** column name */
  FatorMultiplicativoNumerico = 'fator_multiplicativo_numerico',
  /** column name */
  Id = 'id',
  /** column name */
  IdParametro = 'id_parametro',
  /** column name */
  IdUnidadeMedida = 'id_unidade_medida',
  /** column name */
  Principal = 'principal'
}

/** select "variaveis_parametros_r_unidades_medida_aggregate_bool_exp_bool_and_arguments_columns" columns of table "variaveis.parametros_r_unidades_medida" */
export enum Variaveis_Parametros_R_Unidades_Medida_Select_Column_Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Principal = 'principal'
}

/** select "variaveis_parametros_r_unidades_medida_aggregate_bool_exp_bool_or_arguments_columns" columns of table "variaveis.parametros_r_unidades_medida" */
export enum Variaveis_Parametros_R_Unidades_Medida_Select_Column_Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  Principal = 'principal'
}

/** input type for updating data in table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  factor_multiplicativo?: InputMaybe<Scalars['String']['input']>;
  fator_multiplicativo_numerico?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro?: InputMaybe<Scalars['bigint']['input']>;
  id_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Parametros_R_Unidades_Medida_Stddev_Fields = {
  __typename?: 'variaveis_parametros_r_unidades_medida_stddev_fields';
  fator_multiplicativo_numerico?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_unidade_medida?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Stddev_Order_By = {
  fator_multiplicativo_numerico?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_unidade_medida?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Parametros_R_Unidades_Medida_Stddev_Pop_Fields = {
  __typename?: 'variaveis_parametros_r_unidades_medida_stddev_pop_fields';
  fator_multiplicativo_numerico?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_unidade_medida?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Stddev_Pop_Order_By = {
  fator_multiplicativo_numerico?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_unidade_medida?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Parametros_R_Unidades_Medida_Stddev_Samp_Fields = {
  __typename?: 'variaveis_parametros_r_unidades_medida_stddev_samp_fields';
  fator_multiplicativo_numerico?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_unidade_medida?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Stddev_Samp_Order_By = {
  fator_multiplicativo_numerico?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_unidade_medida?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variaveis_parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Parametros_R_Unidades_Medida_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Parametros_R_Unidades_Medida_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  factor_multiplicativo?: InputMaybe<Scalars['String']['input']>;
  fator_multiplicativo_numerico?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_parametro?: InputMaybe<Scalars['bigint']['input']>;
  id_unidade_medida?: InputMaybe<Scalars['bigint']['input']>;
  principal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Parametros_R_Unidades_Medida_Sum_Fields = {
  __typename?: 'variaveis_parametros_r_unidades_medida_sum_fields';
  fator_multiplicativo_numerico?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_parametro?: Maybe<Scalars['bigint']['output']>;
  id_unidade_medida?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Sum_Order_By = {
  fator_multiplicativo_numerico?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_unidade_medida?: InputMaybe<Order_By>;
};

/** update columns of table "variaveis.parametros_r_unidades_medida" */
export enum Variaveis_Parametros_R_Unidades_Medida_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  FactorMultiplicativo = 'factor_multiplicativo',
  /** column name */
  FatorMultiplicativoNumerico = 'fator_multiplicativo_numerico',
  /** column name */
  Id = 'id',
  /** column name */
  IdParametro = 'id_parametro',
  /** column name */
  IdUnidadeMedida = 'id_unidade_medida',
  /** column name */
  Principal = 'principal'
}

export type Variaveis_Parametros_R_Unidades_Medida_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Parametros_R_Unidades_Medida_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Parametros_R_Unidades_Medida_Var_Pop_Fields = {
  __typename?: 'variaveis_parametros_r_unidades_medida_var_pop_fields';
  fator_multiplicativo_numerico?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_unidade_medida?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Var_Pop_Order_By = {
  fator_multiplicativo_numerico?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_unidade_medida?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variaveis_Parametros_R_Unidades_Medida_Var_Samp_Fields = {
  __typename?: 'variaveis_parametros_r_unidades_medida_var_samp_fields';
  fator_multiplicativo_numerico?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_unidade_medida?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Var_Samp_Order_By = {
  fator_multiplicativo_numerico?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_unidade_medida?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variaveis_Parametros_R_Unidades_Medida_Variance_Fields = {
  __typename?: 'variaveis_parametros_r_unidades_medida_variance_fields';
  fator_multiplicativo_numerico?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_parametro?: Maybe<Scalars['Float']['output']>;
  id_unidade_medida?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variaveis.parametros_r_unidades_medida" */
export type Variaveis_Parametros_R_Unidades_Medida_Variance_Order_By = {
  fator_multiplicativo_numerico?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_parametro?: InputMaybe<Order_By>;
  id_unidade_medida?: InputMaybe<Order_By>;
};

/** select columns of table "variaveis.parametros" */
export enum Variaveis_Parametros_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  Id = 'id',
  /** column name */
  TempoAnalise = 'tempo_analise'
}

/** input type for updating data in table "variaveis.parametros" */
export type Variaveis_Parametros_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  tempo_analise?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Parametros_Stddev_Fields = {
  __typename?: 'variaveis_parametros_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Parametros_Stddev_Pop_Fields = {
  __typename?: 'variaveis_parametros_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Parametros_Stddev_Samp_Fields = {
  __typename?: 'variaveis_parametros_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_parametros" */
export type Variaveis_Parametros_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Parametros_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Parametros_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  tempo_analise?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Parametros_Sum_Fields = {
  __typename?: 'variaveis_parametros_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "variaveis.parametros" */
export enum Variaveis_Parametros_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  Id = 'id',
  /** column name */
  TempoAnalise = 'tempo_analise'
}

export type Variaveis_Parametros_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Parametros_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Parametros_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Parametros_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Parametros_Var_Pop_Fields = {
  __typename?: 'variaveis_parametros_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Parametros_Var_Samp_Fields = {
  __typename?: 'variaveis_parametros_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Parametros_Variance_Fields = {
  __typename?: 'variaveis_parametros_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "variaveis.tipos" */
export type Variaveis_Tipos = {
  __typename?: 'variaveis_tipos';
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  tipo?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "variaveis.tipos" */
export type Variaveis_Tipos_Aggregate = {
  __typename?: 'variaveis_tipos_aggregate';
  aggregate?: Maybe<Variaveis_Tipos_Aggregate_Fields>;
  nodes: Array<Variaveis_Tipos>;
};

/** aggregate fields of "variaveis.tipos" */
export type Variaveis_Tipos_Aggregate_Fields = {
  __typename?: 'variaveis_tipos_aggregate_fields';
  avg?: Maybe<Variaveis_Tipos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Tipos_Max_Fields>;
  min?: Maybe<Variaveis_Tipos_Min_Fields>;
  stddev?: Maybe<Variaveis_Tipos_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Tipos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Tipos_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Tipos_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Tipos_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Tipos_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Tipos_Variance_Fields>;
};


/** aggregate fields of "variaveis.tipos" */
export type Variaveis_Tipos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Tipos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Tipos_Avg_Fields = {
  __typename?: 'variaveis_tipos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.tipos". All fields are combined with a logical 'AND'. */
export type Variaveis_Tipos_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Tipos_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Tipos_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Tipos_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  tipo?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.tipos" */
export enum Variaveis_Tipos_Constraint {
  /** unique or primary key constraint on columns "id" */
  GlobaisTiposPkey = 'globais_tipos_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.tipos" */
export type Variaveis_Tipos_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.tipos" */
export type Variaveis_Tipos_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  tipo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Tipos_Max_Fields = {
  __typename?: 'variaveis_tipos_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  tipo?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Tipos_Min_Fields = {
  __typename?: 'variaveis_tipos_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  tipo?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "variaveis.tipos" */
export type Variaveis_Tipos_Mutation_Response = {
  __typename?: 'variaveis_tipos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Tipos>;
};

/** input type for inserting object relation for remote table "variaveis.tipos" */
export type Variaveis_Tipos_Obj_Rel_Insert_Input = {
  data: Variaveis_Tipos_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Tipos_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.tipos" */
export type Variaveis_Tipos_On_Conflict = {
  constraint: Variaveis_Tipos_Constraint;
  update_columns?: Array<Variaveis_Tipos_Update_Column>;
  where?: InputMaybe<Variaveis_Tipos_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.tipos". */
export type Variaveis_Tipos_Order_By = {
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tipo?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.tipos */
export type Variaveis_Tipos_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.tipos" */
export enum Variaveis_Tipos_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  Tipo = 'tipo'
}

/** input type for updating data in table "variaveis.tipos" */
export type Variaveis_Tipos_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  tipo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Tipos_Stddev_Fields = {
  __typename?: 'variaveis_tipos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Tipos_Stddev_Pop_Fields = {
  __typename?: 'variaveis_tipos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Tipos_Stddev_Samp_Fields = {
  __typename?: 'variaveis_tipos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_tipos" */
export type Variaveis_Tipos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Tipos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Tipos_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  tipo?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Tipos_Sum_Fields = {
  __typename?: 'variaveis_tipos_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "variaveis.tipos" */
export enum Variaveis_Tipos_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id',
  /** column name */
  Tipo = 'tipo'
}

export type Variaveis_Tipos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Tipos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Tipos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Tipos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Tipos_Var_Pop_Fields = {
  __typename?: 'variaveis_tipos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Tipos_Var_Samp_Fields = {
  __typename?: 'variaveis_tipos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Tipos_Variance_Fields = {
  __typename?: 'variaveis_tipos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "variaveis.totalizadores_tipos_registo" */
export type Variaveis_Totalizadores_Tipos_Registo = {
  __typename?: 'variaveis_totalizadores_tipos_registo';
  descricao?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "variaveis.totalizadores_tipos_registo" */
export type Variaveis_Totalizadores_Tipos_Registo_Aggregate = {
  __typename?: 'variaveis_totalizadores_tipos_registo_aggregate';
  aggregate?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Aggregate_Fields>;
  nodes: Array<Variaveis_Totalizadores_Tipos_Registo>;
};

/** aggregate fields of "variaveis.totalizadores_tipos_registo" */
export type Variaveis_Totalizadores_Tipos_Registo_Aggregate_Fields = {
  __typename?: 'variaveis_totalizadores_tipos_registo_aggregate_fields';
  avg?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Max_Fields>;
  min?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Min_Fields>;
  stddev?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Totalizadores_Tipos_Registo_Variance_Fields>;
};


/** aggregate fields of "variaveis.totalizadores_tipos_registo" */
export type Variaveis_Totalizadores_Tipos_Registo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Totalizadores_Tipos_Registo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Totalizadores_Tipos_Registo_Avg_Fields = {
  __typename?: 'variaveis_totalizadores_tipos_registo_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.totalizadores_tipos_registo". All fields are combined with a logical 'AND'. */
export type Variaveis_Totalizadores_Tipos_Registo_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Totalizadores_Tipos_Registo_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Totalizadores_Tipos_Registo_Bool_Exp>>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "variaveis.totalizadores_tipos_registo" */
export enum Variaveis_Totalizadores_Tipos_Registo_Constraint {
  /** unique or primary key constraint on columns "id" */
  TotalizadoresTiposRegistoPkey = 'totalizadores_tipos_registo_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.totalizadores_tipos_registo" */
export type Variaveis_Totalizadores_Tipos_Registo_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.totalizadores_tipos_registo" */
export type Variaveis_Totalizadores_Tipos_Registo_Insert_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Variaveis_Totalizadores_Tipos_Registo_Max_Fields = {
  __typename?: 'variaveis_totalizadores_tipos_registo_max_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Totalizadores_Tipos_Registo_Min_Fields = {
  __typename?: 'variaveis_totalizadores_tipos_registo_min_fields';
  descricao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "variaveis.totalizadores_tipos_registo" */
export type Variaveis_Totalizadores_Tipos_Registo_Mutation_Response = {
  __typename?: 'variaveis_totalizadores_tipos_registo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Totalizadores_Tipos_Registo>;
};

/** on_conflict condition type for table "variaveis.totalizadores_tipos_registo" */
export type Variaveis_Totalizadores_Tipos_Registo_On_Conflict = {
  constraint: Variaveis_Totalizadores_Tipos_Registo_Constraint;
  update_columns?: Array<Variaveis_Totalizadores_Tipos_Registo_Update_Column>;
  where?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.totalizadores_tipos_registo". */
export type Variaveis_Totalizadores_Tipos_Registo_Order_By = {
  descricao?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: variaveis.totalizadores_tipos_registo */
export type Variaveis_Totalizadores_Tipos_Registo_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.totalizadores_tipos_registo" */
export enum Variaveis_Totalizadores_Tipos_Registo_Select_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "variaveis.totalizadores_tipos_registo" */
export type Variaveis_Totalizadores_Tipos_Registo_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Totalizadores_Tipos_Registo_Stddev_Fields = {
  __typename?: 'variaveis_totalizadores_tipos_registo_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Totalizadores_Tipos_Registo_Stddev_Pop_Fields = {
  __typename?: 'variaveis_totalizadores_tipos_registo_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Totalizadores_Tipos_Registo_Stddev_Samp_Fields = {
  __typename?: 'variaveis_totalizadores_tipos_registo_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_totalizadores_tipos_registo" */
export type Variaveis_Totalizadores_Tipos_Registo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Totalizadores_Tipos_Registo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Totalizadores_Tipos_Registo_Stream_Cursor_Value_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Totalizadores_Tipos_Registo_Sum_Fields = {
  __typename?: 'variaveis_totalizadores_tipos_registo_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "variaveis.totalizadores_tipos_registo" */
export enum Variaveis_Totalizadores_Tipos_Registo_Update_Column {
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Id = 'id'
}

export type Variaveis_Totalizadores_Tipos_Registo_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Totalizadores_Tipos_Registo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Totalizadores_Tipos_Registo_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Totalizadores_Tipos_Registo_Var_Pop_Fields = {
  __typename?: 'variaveis_totalizadores_tipos_registo_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Totalizadores_Tipos_Registo_Var_Samp_Fields = {
  __typename?: 'variaveis_totalizadores_tipos_registo_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Totalizadores_Tipos_Registo_Variance_Fields = {
  __typename?: 'variaveis_totalizadores_tipos_registo_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "variaveis.unidades_medida" */
export type Variaveis_Unidades_Medida = {
  __typename?: 'variaveis_unidades_medida';
  apagado: Scalars['Boolean']['output'];
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  parametroUnidadeMedida: Array<Variaveis_Parametros_R_Unidades_Medida>;
  /** An aggregate relationship */
  parametroUnidadeMedida_aggregate: Variaveis_Parametros_R_Unidades_Medida_Aggregate;
};


/** columns and relationships of "variaveis.unidades_medida" */
export type Variaveis_Unidades_MedidaParametroUnidadeMedidaArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
};


/** columns and relationships of "variaveis.unidades_medida" */
export type Variaveis_Unidades_MedidaParametroUnidadeMedida_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Variaveis_Parametros_R_Unidades_Medida_Order_By>>;
  where?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
};

/** aggregated selection of "variaveis.unidades_medida" */
export type Variaveis_Unidades_Medida_Aggregate = {
  __typename?: 'variaveis_unidades_medida_aggregate';
  aggregate?: Maybe<Variaveis_Unidades_Medida_Aggregate_Fields>;
  nodes: Array<Variaveis_Unidades_Medida>;
};

/** aggregate fields of "variaveis.unidades_medida" */
export type Variaveis_Unidades_Medida_Aggregate_Fields = {
  __typename?: 'variaveis_unidades_medida_aggregate_fields';
  avg?: Maybe<Variaveis_Unidades_Medida_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Unidades_Medida_Max_Fields>;
  min?: Maybe<Variaveis_Unidades_Medida_Min_Fields>;
  stddev?: Maybe<Variaveis_Unidades_Medida_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Unidades_Medida_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Unidades_Medida_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Unidades_Medida_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Unidades_Medida_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Unidades_Medida_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Unidades_Medida_Variance_Fields>;
};


/** aggregate fields of "variaveis.unidades_medida" */
export type Variaveis_Unidades_Medida_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Unidades_Medida_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Variaveis_Unidades_Medida_Avg_Fields = {
  __typename?: 'variaveis_unidades_medida_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "variaveis.unidades_medida". All fields are combined with a logical 'AND'. */
export type Variaveis_Unidades_Medida_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Unidades_Medida_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Unidades_Medida_Bool_Exp>>;
  apagado?: InputMaybe<Boolean_Comparison_Exp>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  descricao?: InputMaybe<String_Comparison_Exp>;
  descricao_curta?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  parametroUnidadeMedida?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Bool_Exp>;
  parametroUnidadeMedida_aggregate?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "variaveis.unidades_medida" */
export enum Variaveis_Unidades_Medida_Constraint {
  /** unique or primary key constraint on columns "id" */
  UnidadesMedidaPkey1 = 'unidades_medida_pkey1'
}

/** input type for incrementing numeric columns in table "variaveis.unidades_medida" */
export type Variaveis_Unidades_Medida_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "variaveis.unidades_medida" */
export type Variaveis_Unidades_Medida_Insert_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parametroUnidadeMedida?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Variaveis_Unidades_Medida_Max_Fields = {
  __typename?: 'variaveis_unidades_medida_max_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Variaveis_Unidades_Medida_Min_Fields = {
  __typename?: 'variaveis_unidades_medida_min_fields';
  codigo_externo?: Maybe<Scalars['String']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  descricao_curta?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "variaveis.unidades_medida" */
export type Variaveis_Unidades_Medida_Mutation_Response = {
  __typename?: 'variaveis_unidades_medida_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Unidades_Medida>;
};

/** input type for inserting object relation for remote table "variaveis.unidades_medida" */
export type Variaveis_Unidades_Medida_Obj_Rel_Insert_Input = {
  data: Variaveis_Unidades_Medida_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Unidades_Medida_On_Conflict>;
};

/** on_conflict condition type for table "variaveis.unidades_medida" */
export type Variaveis_Unidades_Medida_On_Conflict = {
  constraint: Variaveis_Unidades_Medida_Constraint;
  update_columns?: Array<Variaveis_Unidades_Medida_Update_Column>;
  where?: InputMaybe<Variaveis_Unidades_Medida_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.unidades_medida". */
export type Variaveis_Unidades_Medida_Order_By = {
  apagado?: InputMaybe<Order_By>;
  codigo_externo?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  descricao_curta?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parametroUnidadeMedida_aggregate?: InputMaybe<Variaveis_Parametros_R_Unidades_Medida_Aggregate_Order_By>;
};

/** primary key columns input for table: variaveis.unidades_medida */
export type Variaveis_Unidades_Medida_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.unidades_medida" */
export enum Variaveis_Unidades_Medida_Select_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "variaveis.unidades_medida" */
export type Variaveis_Unidades_Medida_Set_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Unidades_Medida_Stddev_Fields = {
  __typename?: 'variaveis_unidades_medida_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Unidades_Medida_Stddev_Pop_Fields = {
  __typename?: 'variaveis_unidades_medida_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Unidades_Medida_Stddev_Samp_Fields = {
  __typename?: 'variaveis_unidades_medida_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "variaveis_unidades_medida" */
export type Variaveis_Unidades_Medida_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Unidades_Medida_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Unidades_Medida_Stream_Cursor_Value_Input = {
  apagado?: InputMaybe<Scalars['Boolean']['input']>;
  codigo_externo?: InputMaybe<Scalars['String']['input']>;
  descricao?: InputMaybe<Scalars['String']['input']>;
  descricao_curta?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Unidades_Medida_Sum_Fields = {
  __typename?: 'variaveis_unidades_medida_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "variaveis.unidades_medida" */
export enum Variaveis_Unidades_Medida_Update_Column {
  /** column name */
  Apagado = 'apagado',
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DescricaoCurta = 'descricao_curta',
  /** column name */
  Id = 'id'
}

export type Variaveis_Unidades_Medida_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Unidades_Medida_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Unidades_Medida_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Unidades_Medida_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Unidades_Medida_Var_Pop_Fields = {
  __typename?: 'variaveis_unidades_medida_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Variaveis_Unidades_Medida_Var_Samp_Fields = {
  __typename?: 'variaveis_unidades_medida_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Variaveis_Unidades_Medida_Variance_Fields = {
  __typename?: 'variaveis_unidades_medida_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais = {
  __typename?: 'variaveis_valores_mensais';
  ano?: Maybe<Scalars['Int']['output']>;
  id: Scalars['bigint']['output'];
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  id_zmc?: Maybe<Scalars['bigint']['output']>;
  ids_erros?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  infraestrutura?: Maybe<Base_Infraestruturas>;
  mes?: Maybe<Scalars['Int']['output']>;
  validacao_data?: Maybe<Scalars['timestamp']['output']>;
  validacao_estado?: Maybe<Scalars['Boolean']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  valor_calculado?: Maybe<Scalars['numeric']['output']>;
  valor_proprio?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  variavel?: Maybe<Variaveis_Base>;
};

/** aggregated selection of "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Aggregate = {
  __typename?: 'variaveis_valores_mensais_aggregate';
  aggregate?: Maybe<Variaveis_Valores_Mensais_Aggregate_Fields>;
  nodes: Array<Variaveis_Valores_Mensais>;
};

export type Variaveis_Valores_Mensais_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Variaveis_Valores_Mensais_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Variaveis_Valores_Mensais_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Variaveis_Valores_Mensais_Aggregate_Bool_Exp_Count>;
};

export type Variaveis_Valores_Mensais_Aggregate_Bool_Exp_Bool_And = {
  arguments: Variaveis_Valores_Mensais_Select_Column_Variaveis_Valores_Mensais_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Valores_Mensais_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Variaveis_Valores_Mensais_Select_Column_Variaveis_Valores_Mensais_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Variaveis_Valores_Mensais_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Variaveis_Valores_Mensais_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Aggregate_Fields = {
  __typename?: 'variaveis_valores_mensais_aggregate_fields';
  avg?: Maybe<Variaveis_Valores_Mensais_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Variaveis_Valores_Mensais_Max_Fields>;
  min?: Maybe<Variaveis_Valores_Mensais_Min_Fields>;
  stddev?: Maybe<Variaveis_Valores_Mensais_Stddev_Fields>;
  stddev_pop?: Maybe<Variaveis_Valores_Mensais_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Variaveis_Valores_Mensais_Stddev_Samp_Fields>;
  sum?: Maybe<Variaveis_Valores_Mensais_Sum_Fields>;
  var_pop?: Maybe<Variaveis_Valores_Mensais_Var_Pop_Fields>;
  var_samp?: Maybe<Variaveis_Valores_Mensais_Var_Samp_Fields>;
  variance?: Maybe<Variaveis_Valores_Mensais_Variance_Fields>;
};


/** aggregate fields of "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Variaveis_Valores_Mensais_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Aggregate_Order_By = {
  avg?: InputMaybe<Variaveis_Valores_Mensais_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Variaveis_Valores_Mensais_Max_Order_By>;
  min?: InputMaybe<Variaveis_Valores_Mensais_Min_Order_By>;
  stddev?: InputMaybe<Variaveis_Valores_Mensais_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Variaveis_Valores_Mensais_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Variaveis_Valores_Mensais_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Variaveis_Valores_Mensais_Sum_Order_By>;
  var_pop?: InputMaybe<Variaveis_Valores_Mensais_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Variaveis_Valores_Mensais_Var_Samp_Order_By>;
  variance?: InputMaybe<Variaveis_Valores_Mensais_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Arr_Rel_Insert_Input = {
  data: Array<Variaveis_Valores_Mensais_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Variaveis_Valores_Mensais_On_Conflict>;
};

/** aggregate avg on columns */
export type Variaveis_Valores_Mensais_Avg_Fields = {
  __typename?: 'variaveis_valores_mensais_avg_fields';
  ano?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  mes?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_calculado?: Maybe<Scalars['Float']['output']>;
  valor_proprio?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Avg_Order_By = {
  ano?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  mes?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_calculado?: InputMaybe<Order_By>;
  valor_proprio?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "variaveis.valores_mensais". All fields are combined with a logical 'AND'. */
export type Variaveis_Valores_Mensais_Bool_Exp = {
  _and?: InputMaybe<Array<Variaveis_Valores_Mensais_Bool_Exp>>;
  _not?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
  _or?: InputMaybe<Array<Variaveis_Valores_Mensais_Bool_Exp>>;
  ano?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  id_infraestrutura?: InputMaybe<Bigint_Comparison_Exp>;
  id_toponimia?: InputMaybe<Bigint_Comparison_Exp>;
  id_variavel_base?: InputMaybe<Bigint_Comparison_Exp>;
  id_zmc?: InputMaybe<Bigint_Comparison_Exp>;
  ids_erros?: InputMaybe<String_Comparison_Exp>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  mes?: InputMaybe<Int_Comparison_Exp>;
  validacao_data?: InputMaybe<Timestamp_Comparison_Exp>;
  validacao_estado?: InputMaybe<Boolean_Comparison_Exp>;
  validacao_id_utilizador?: InputMaybe<Bigint_Comparison_Exp>;
  valor_calculado?: InputMaybe<Numeric_Comparison_Exp>;
  valor_proprio?: InputMaybe<Numeric_Comparison_Exp>;
  variavel?: InputMaybe<Variaveis_Base_Bool_Exp>;
};

/** unique or primary key constraints on table "variaveis.valores_mensais" */
export enum Variaveis_Valores_Mensais_Constraint {
  /** unique or primary key constraint on columns "id_infraestrutura", "mes", "ano", "id_variavel_base" */
  UniqueValoresMensaisIdInfraestrutura = 'unique_valores_mensais_id_infraestrutura',
  /** unique or primary key constraint on columns "mes", "id_toponimia", "ano", "id_variavel_base" */
  UniqueValoresMensaisIdToponimia = 'unique_valores_mensais_id_toponimia',
  /** unique or primary key constraint on columns "id" */
  ValoresMensaisPkey = 'valores_mensais_pkey'
}

/** input type for incrementing numeric columns in table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Inc_Input = {
  ano?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  id_zmc?: InputMaybe<Scalars['bigint']['input']>;
  mes?: InputMaybe<Scalars['Int']['input']>;
  validacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  valor_calculado?: InputMaybe<Scalars['numeric']['input']>;
  valor_proprio?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Insert_Input = {
  ano?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  id_zmc?: InputMaybe<Scalars['bigint']['input']>;
  ids_erros?: InputMaybe<Scalars['String']['input']>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Obj_Rel_Insert_Input>;
  mes?: InputMaybe<Scalars['Int']['input']>;
  validacao_data?: InputMaybe<Scalars['timestamp']['input']>;
  validacao_estado?: InputMaybe<Scalars['Boolean']['input']>;
  validacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  valor_calculado?: InputMaybe<Scalars['numeric']['input']>;
  valor_proprio?: InputMaybe<Scalars['numeric']['input']>;
  variavel?: InputMaybe<Variaveis_Base_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Variaveis_Valores_Mensais_Max_Fields = {
  __typename?: 'variaveis_valores_mensais_max_fields';
  ano?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  id_zmc?: Maybe<Scalars['bigint']['output']>;
  ids_erros?: Maybe<Scalars['String']['output']>;
  mes?: Maybe<Scalars['Int']['output']>;
  validacao_data?: Maybe<Scalars['timestamp']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  valor_calculado?: Maybe<Scalars['numeric']['output']>;
  valor_proprio?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Max_Order_By = {
  ano?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  ids_erros?: InputMaybe<Order_By>;
  mes?: InputMaybe<Order_By>;
  validacao_data?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_calculado?: InputMaybe<Order_By>;
  valor_proprio?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Variaveis_Valores_Mensais_Min_Fields = {
  __typename?: 'variaveis_valores_mensais_min_fields';
  ano?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  id_zmc?: Maybe<Scalars['bigint']['output']>;
  ids_erros?: Maybe<Scalars['String']['output']>;
  mes?: Maybe<Scalars['Int']['output']>;
  validacao_data?: Maybe<Scalars['timestamp']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  valor_calculado?: Maybe<Scalars['numeric']['output']>;
  valor_proprio?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Min_Order_By = {
  ano?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  ids_erros?: InputMaybe<Order_By>;
  mes?: InputMaybe<Order_By>;
  validacao_data?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_calculado?: InputMaybe<Order_By>;
  valor_proprio?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Mutation_Response = {
  __typename?: 'variaveis_valores_mensais_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Variaveis_Valores_Mensais>;
};

/** on_conflict condition type for table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_On_Conflict = {
  constraint: Variaveis_Valores_Mensais_Constraint;
  update_columns?: Array<Variaveis_Valores_Mensais_Update_Column>;
  where?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
};

/** Ordering options when selecting data from "variaveis.valores_mensais". */
export type Variaveis_Valores_Mensais_Order_By = {
  ano?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  ids_erros?: InputMaybe<Order_By>;
  infraestrutura?: InputMaybe<Base_Infraestruturas_Order_By>;
  mes?: InputMaybe<Order_By>;
  validacao_data?: InputMaybe<Order_By>;
  validacao_estado?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_calculado?: InputMaybe<Order_By>;
  valor_proprio?: InputMaybe<Order_By>;
  variavel?: InputMaybe<Variaveis_Base_Order_By>;
};

/** primary key columns input for table: variaveis.valores_mensais */
export type Variaveis_Valores_Mensais_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "variaveis.valores_mensais" */
export enum Variaveis_Valores_Mensais_Select_Column {
  /** column name */
  Ano = 'ano',
  /** column name */
  Id = 'id',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  IdVariavelBase = 'id_variavel_base',
  /** column name */
  IdZmc = 'id_zmc',
  /** column name */
  IdsErros = 'ids_erros',
  /** column name */
  Mes = 'mes',
  /** column name */
  ValidacaoData = 'validacao_data',
  /** column name */
  ValidacaoEstado = 'validacao_estado',
  /** column name */
  ValidacaoIdUtilizador = 'validacao_id_utilizador',
  /** column name */
  ValorCalculado = 'valor_calculado',
  /** column name */
  ValorProprio = 'valor_proprio'
}

/** select "variaveis_valores_mensais_aggregate_bool_exp_bool_and_arguments_columns" columns of table "variaveis.valores_mensais" */
export enum Variaveis_Valores_Mensais_Select_Column_Variaveis_Valores_Mensais_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ValidacaoEstado = 'validacao_estado'
}

/** select "variaveis_valores_mensais_aggregate_bool_exp_bool_or_arguments_columns" columns of table "variaveis.valores_mensais" */
export enum Variaveis_Valores_Mensais_Select_Column_Variaveis_Valores_Mensais_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ValidacaoEstado = 'validacao_estado'
}

/** input type for updating data in table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Set_Input = {
  ano?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  id_zmc?: InputMaybe<Scalars['bigint']['input']>;
  ids_erros?: InputMaybe<Scalars['String']['input']>;
  mes?: InputMaybe<Scalars['Int']['input']>;
  validacao_data?: InputMaybe<Scalars['timestamp']['input']>;
  validacao_estado?: InputMaybe<Scalars['Boolean']['input']>;
  validacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  valor_calculado?: InputMaybe<Scalars['numeric']['input']>;
  valor_proprio?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Variaveis_Valores_Mensais_Stddev_Fields = {
  __typename?: 'variaveis_valores_mensais_stddev_fields';
  ano?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  mes?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_calculado?: Maybe<Scalars['Float']['output']>;
  valor_proprio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Stddev_Order_By = {
  ano?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  mes?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_calculado?: InputMaybe<Order_By>;
  valor_proprio?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Variaveis_Valores_Mensais_Stddev_Pop_Fields = {
  __typename?: 'variaveis_valores_mensais_stddev_pop_fields';
  ano?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  mes?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_calculado?: Maybe<Scalars['Float']['output']>;
  valor_proprio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Stddev_Pop_Order_By = {
  ano?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  mes?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_calculado?: InputMaybe<Order_By>;
  valor_proprio?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Variaveis_Valores_Mensais_Stddev_Samp_Fields = {
  __typename?: 'variaveis_valores_mensais_stddev_samp_fields';
  ano?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  mes?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_calculado?: Maybe<Scalars['Float']['output']>;
  valor_proprio?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Stddev_Samp_Order_By = {
  ano?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  mes?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_calculado?: InputMaybe<Order_By>;
  valor_proprio?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "variaveis_valores_mensais" */
export type Variaveis_Valores_Mensais_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Variaveis_Valores_Mensais_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Variaveis_Valores_Mensais_Stream_Cursor_Value_Input = {
  ano?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  id_infraestrutura?: InputMaybe<Scalars['bigint']['input']>;
  id_toponimia?: InputMaybe<Scalars['bigint']['input']>;
  id_variavel_base?: InputMaybe<Scalars['bigint']['input']>;
  id_zmc?: InputMaybe<Scalars['bigint']['input']>;
  ids_erros?: InputMaybe<Scalars['String']['input']>;
  mes?: InputMaybe<Scalars['Int']['input']>;
  validacao_data?: InputMaybe<Scalars['timestamp']['input']>;
  validacao_estado?: InputMaybe<Scalars['Boolean']['input']>;
  validacao_id_utilizador?: InputMaybe<Scalars['bigint']['input']>;
  valor_calculado?: InputMaybe<Scalars['numeric']['input']>;
  valor_proprio?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Variaveis_Valores_Mensais_Sum_Fields = {
  __typename?: 'variaveis_valores_mensais_sum_fields';
  ano?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  id_infraestrutura?: Maybe<Scalars['bigint']['output']>;
  id_toponimia?: Maybe<Scalars['bigint']['output']>;
  id_variavel_base?: Maybe<Scalars['bigint']['output']>;
  id_zmc?: Maybe<Scalars['bigint']['output']>;
  mes?: Maybe<Scalars['Int']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['bigint']['output']>;
  valor_calculado?: Maybe<Scalars['numeric']['output']>;
  valor_proprio?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Sum_Order_By = {
  ano?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  mes?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_calculado?: InputMaybe<Order_By>;
  valor_proprio?: InputMaybe<Order_By>;
};

/** update columns of table "variaveis.valores_mensais" */
export enum Variaveis_Valores_Mensais_Update_Column {
  /** column name */
  Ano = 'ano',
  /** column name */
  Id = 'id',
  /** column name */
  IdInfraestrutura = 'id_infraestrutura',
  /** column name */
  IdToponimia = 'id_toponimia',
  /** column name */
  IdVariavelBase = 'id_variavel_base',
  /** column name */
  IdZmc = 'id_zmc',
  /** column name */
  IdsErros = 'ids_erros',
  /** column name */
  Mes = 'mes',
  /** column name */
  ValidacaoData = 'validacao_data',
  /** column name */
  ValidacaoEstado = 'validacao_estado',
  /** column name */
  ValidacaoIdUtilizador = 'validacao_id_utilizador',
  /** column name */
  ValorCalculado = 'valor_calculado',
  /** column name */
  ValorProprio = 'valor_proprio'
}

export type Variaveis_Valores_Mensais_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Variaveis_Valores_Mensais_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Variaveis_Valores_Mensais_Set_Input>;
  /** filter the rows which have to be updated */
  where: Variaveis_Valores_Mensais_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Variaveis_Valores_Mensais_Var_Pop_Fields = {
  __typename?: 'variaveis_valores_mensais_var_pop_fields';
  ano?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  mes?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_calculado?: Maybe<Scalars['Float']['output']>;
  valor_proprio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Var_Pop_Order_By = {
  ano?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  mes?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_calculado?: InputMaybe<Order_By>;
  valor_proprio?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Variaveis_Valores_Mensais_Var_Samp_Fields = {
  __typename?: 'variaveis_valores_mensais_var_samp_fields';
  ano?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  mes?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_calculado?: Maybe<Scalars['Float']['output']>;
  valor_proprio?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Var_Samp_Order_By = {
  ano?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  mes?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_calculado?: InputMaybe<Order_By>;
  valor_proprio?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Variaveis_Valores_Mensais_Variance_Fields = {
  __typename?: 'variaveis_valores_mensais_variance_fields';
  ano?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_infraestrutura?: Maybe<Scalars['Float']['output']>;
  id_toponimia?: Maybe<Scalars['Float']['output']>;
  id_variavel_base?: Maybe<Scalars['Float']['output']>;
  id_zmc?: Maybe<Scalars['Float']['output']>;
  mes?: Maybe<Scalars['Float']['output']>;
  validacao_id_utilizador?: Maybe<Scalars['Float']['output']>;
  valor_calculado?: Maybe<Scalars['Float']['output']>;
  valor_proprio?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "variaveis.valores_mensais" */
export type Variaveis_Valores_Mensais_Variance_Order_By = {
  ano?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_infraestrutura?: InputMaybe<Order_By>;
  id_toponimia?: InputMaybe<Order_By>;
  id_variavel_base?: InputMaybe<Order_By>;
  id_zmc?: InputMaybe<Order_By>;
  mes?: InputMaybe<Order_By>;
  validacao_id_utilizador?: InputMaybe<Order_By>;
  valor_calculado?: InputMaybe<Order_By>;
  valor_proprio?: InputMaybe<Order_By>;
};

/** zmc_leaks_countNative Query Arguments */
export type Zmc_Leaks_Count_Arguments = {
  endDate: Scalars['timestamptz']['input'];
  startDate: Scalars['timestamptz']['input'];
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

export type Zmc_Leaks_Count_Model = {
  __typename?: 'zmc_leaks_count_model';
  codigo_externo: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  interv_count: Scalars['bigint']['output'];
  sig_atributo_id: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the logical model for "zmc_leaks_count_model". All fields are combined with a logical 'AND'. */
export type Zmc_Leaks_Count_Model_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Zmc_Leaks_Count_Model_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Zmc_Leaks_Count_Model_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Zmc_Leaks_Count_Model_Bool_Exp_Bool_Exp>>;
  codigo_externo?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  interv_count?: InputMaybe<Bigint_Comparison_Exp>;
  sig_atributo_id?: InputMaybe<String_Comparison_Exp>;
};

export enum Zmc_Leaks_Count_Model_Enum_Name {
  /** column name */
  CodigoExterno = 'codigo_externo',
  /** column name */
  Id = 'id',
  /** column name */
  IntervCount = 'interv_count',
  /** column name */
  SigAtributoId = 'sig_atributo_id'
}

/** Ordering options when selecting data from "zmc_leaks_count_model". */
export type Zmc_Leaks_Count_Model_Order_By = {
  codigo_externo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interv_count?: InputMaybe<Order_By>;
  sig_atributo_id?: InputMaybe<Order_By>;
};

export type InsertCausaMutationVariables = Exact<{
  object: Sintomas_Causas_Trabalhos_Insert_Input;
}>;


export type InsertCausaMutation = { __typename?: 'mutation_root', insert_sintomas_causas_trabalhos_one?: { __typename?: 'sintomas_causas_trabalhos', id: any, codigo?: string | null, descricao?: string | null, obs?: boolean | null, infraestrutura?: boolean | null } | null };

export type UpdateCausasMutationVariables = Exact<{
  where?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
  _set?: InputMaybe<Sintomas_Causas_Trabalhos_Set_Input>;
}>;


export type UpdateCausasMutation = { __typename?: 'mutation_root', update_sintomas_causas_trabalhos?: { __typename?: 'sintomas_causas_trabalhos_mutation_response', returning: Array<{ __typename?: 'sintomas_causas_trabalhos', id: any, codigo?: string | null, descricao?: string | null, infraestrutura?: boolean | null, obs?: boolean | null }> } | null };

export type UpsertSintomaRelationsMutationVariables = Exact<{
  values: Array<Sintomas_Sintomas_Relacao_Insert_Input> | Sintomas_Sintomas_Relacao_Insert_Input;
}>;


export type UpsertSintomaRelationsMutation = { __typename?: 'mutation_root', insert_sintomas_sintomas_relacao?: { __typename?: 'sintomas_sintomas_relacao_mutation_response', returning: Array<{ __typename?: 'sintomas_sintomas_relacao', id: any, id_sintoma?: any | null, id_fase?: any | null, obrigatorio?: boolean | null, id_causa_trabalho?: any | null, apagado?: boolean | null }> } | null };

export type DeleteSintomaRelationMutationVariables = Exact<{
  relationshipId: Scalars['bigint']['input'];
}>;


export type DeleteSintomaRelationMutation = { __typename?: 'mutation_root', update_sintomas_sintomas_relacao_by_pk?: { __typename?: 'sintomas_sintomas_relacao', id: any, apagado?: boolean | null } | null };

export type InsertSintomaCausaVariavelRelationshipMutationVariables = Exact<{
  objects: Array<Sintomas_Sintomas_Relacao_Insert_Input> | Sintomas_Sintomas_Relacao_Insert_Input;
}>;


export type InsertSintomaCausaVariavelRelationshipMutation = { __typename?: 'mutation_root', insert_sintomas_sintomas_relacao?: { __typename?: 'sintomas_sintomas_relacao_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'sintomas_sintomas_relacao', id: any, id_sintoma?: any | null, id_causa_trabalho?: any | null, id_fase?: any | null, id_fonte_origem?: any | null, obrigatorio?: boolean | null, relacaoOrdem?: { __typename?: 'sintomas_sintomas_relacao_ordem', id: number, ordem?: any | null } | null, fase?: { __typename?: 'servicos_fases', id: any, descricao?: string | null } | null, fonteOrigem?: { __typename?: 'variaveis_fontes_origem', id: any, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, dominio?: { __typename?: 'variaveis_dominios', id: any, descricao: string } | null } | null } | null }> } | null };

export type UpdateSintomaCausaVariavelRelationshipMutationVariables = Exact<{
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
  _set?: InputMaybe<Sintomas_Sintomas_Relacao_Set_Input>;
}>;


export type UpdateSintomaCausaVariavelRelationshipMutation = { __typename?: 'mutation_root', update_sintomas_sintomas_relacao?: { __typename?: 'sintomas_sintomas_relacao_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'sintomas_sintomas_relacao', id: any, id_sintoma?: any | null, id_causa_trabalho?: any | null, id_fase?: any | null, id_fonte_origem?: any | null, obrigatorio?: boolean | null, relacaoOrdem?: { __typename?: 'sintomas_sintomas_relacao_ordem', id: number, ordem?: any | null } | null, fase?: { __typename?: 'servicos_fases', id: any, descricao?: string | null } | null, fonteOrigem?: { __typename?: 'variaveis_fontes_origem', id: any, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, dominio?: { __typename?: 'variaveis_dominios', id: any, descricao: string } | null } | null } | null }> } | null };

export type CreateUserMutationVariables = Exact<{
  input: Utilizadores_Utilizadores_Insert_Input;
}>;


export type CreateUserMutation = { __typename?: 'mutation_root', insert_utilizadores_utilizadores_one?: { __typename?: 'utilizadores_utilizadores', id: any } | null };

export type UpdatePerformanceInfraestruturaParameterMutationVariables = Exact<{
  parameterId: Scalars['Int']['input'];
  _set: Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Set_Input;
}>;


export type UpdatePerformanceInfraestruturaParameterMutation = { __typename?: 'mutation_root', update_navia_dashboards_performance_infraestrutura_parametrizacao_by_pk?: { __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao', id: number, descricao: string, unidadeMedida?: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null, parametroUnidadeMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, fator_multiplicativo_numerico: any, escalasPrecisao: Array<{ __typename?: 'variaveis_escalas_precisao', id: any, nr_casas_decimais: number }> }> } | null, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, id_tipo: any, fonteOrigem: Array<{ __typename?: 'variaveis_fontes_origem', id: any }>, propriedades: Array<{ __typename?: 'variaveis_base_propriedades', id: any, calc_expressao?: string | null, calc_nr_casas_decimais?: any | null, agregacaoTempo?: { __typename?: 'variaveis_agregacao', id: any, descricao?: string | null } | null }>, parametro?: { __typename?: 'variaveis_parametros', id: any, parametroUnidadesMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, fator_multiplicativo_numerico: any, unidadeMedida: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null }, escalasPrecisao: Array<{ __typename?: 'variaveis_escalas_precisao', id: any, nr_casas_decimais: number }> }> } | null } | null } | null };

export type UpdatePerformanceInfraestruturaParametersMutationVariables = Exact<{
  updates: Array<Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Updates> | Navia_Dashboards_Performance_Infraestrutura_Parametrizacao_Updates;
}>;


export type UpdatePerformanceInfraestruturaParametersMutation = { __typename?: 'mutation_root', update_navia_dashboards_performance_infraestrutura_parametrizacao_many?: Array<{ __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao', id: number, descricao: string, unidadeMedida?: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null, parametroUnidadeMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, fator_multiplicativo_numerico: any, escalasPrecisao: Array<{ __typename?: 'variaveis_escalas_precisao', id: any, nr_casas_decimais: number }> }> } | null, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, fonteOrigem: Array<{ __typename?: 'variaveis_fontes_origem', id: any }>, parametro?: { __typename?: 'variaveis_parametros', id: any, parametroUnidadesMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, fator_multiplicativo_numerico: any, unidadeMedida: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null }, escalasPrecisao: Array<{ __typename?: 'variaveis_escalas_precisao', id: any, nr_casas_decimais: number }> }> } | null } | null }> } | null> | null };

export type CreateLogMutationVariables = Exact<{
  logs: Array<Navia_Log_Insert_Input> | Navia_Log_Insert_Input;
}>;


export type CreateLogMutation = { __typename?: 'mutation_root', insert_navia_log?: { __typename?: 'navia_log_mutation_response', affected_rows: number } | null };

export type UpdatePesquisaAtivaFugasIndicatorsMutationVariables = Exact<{
  updates: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Updates> | Navia_Dashboards_Pesquisa_Ativa_Fugas_Indicadores_Parametrizacao_Updates;
}>;


export type UpdatePesquisaAtivaFugasIndicatorsMutation = { __typename?: 'mutation_root', update_navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_many?: Array<{ __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao', id: any, descricao: string, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, parametro?: { __typename?: 'variaveis_parametros', id: any, parametroUnidadesMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, principal: boolean, unidadeMedida: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null }, escalasPrecisao: Array<{ __typename?: 'variaveis_escalas_precisao', id: any, nr_casas_decimais: number }> }> } | null, fonteOrigem: Array<{ __typename?: 'variaveis_fontes_origem', id: any }> } | null, unidadeMedida?: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null } | null }> } | null> | null };

export type UpsertPesquisaAtivaFugasModelosTarefaMutationVariables = Exact<{
  objects: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Insert_Input> | Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Modelos_Tarefa_Insert_Input;
}>;


export type UpsertPesquisaAtivaFugasModelosTarefaMutation = { __typename?: 'mutation_root', insert_navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa?: { __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa', plano_padrao_id: any, apagado: boolean, modeloTarefa: { __typename?: 'tarefas_planos_padrao', id: any, descricao: string } }> } | null };

export type UpsertPesquisaAtivaFugasMapaSintomasMutationVariables = Exact<{
  object: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Sintomas_Insert_Input;
}>;


export type UpsertPesquisaAtivaFugasMapaSintomasMutation = { __typename?: 'mutation_root', insert_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_one?: { __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas', id: any, fase?: { __typename?: 'servicos_fases', id: any, descricao?: string | null } | null, sintoma?: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null } | null, fonteOrigem?: { __typename?: 'variaveis_fontes_origem', id: any, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null } | null } | null, mapaSintomaDominiosValores: Array<{ __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores', id: any, dominioValor: { __typename?: 'variaveis_dominios_valores', id: any, descricao: string } }> } | null };

export type DeletePesquisaAtivaFugasMapaSintomaMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeletePesquisaAtivaFugasMapaSintomaMutation = { __typename?: 'mutation_root', delete_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_by_pk?: { __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas', id: any } | null };

export type DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutationVariables = Exact<{
  mapaSintomaId: Scalars['Int']['input'];
}>;


export type DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation = { __typename?: 'mutation_root', delete_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores?: { __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores_mutation_response', affected_rows: number } | null };

export type DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutationVariables = Exact<{
  where: Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Bool_Exp;
}>;


export type DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation = { __typename?: 'mutation_root', delete_navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura?: { __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_mutation_response', affected_rows: number } | null };

export type InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutationVariables = Exact<{
  objects: Array<Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Insert_Input> | Navia_Dashboards_Pesquisa_Ativa_Fugas_Mapa_Tipo_Infraestrutura_Insert_Input;
}>;


export type InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation = { __typename?: 'mutation_root', insert_navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura?: { __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_mutation_response', affected_rows: number } | null };

export type UpdateVisao360IndicatorsMutationVariables = Exact<{
  updates: Array<Navia_Dashboards_Visao_360_Parametrizacao_Updates> | Navia_Dashboards_Visao_360_Parametrizacao_Updates;
}>;


export type UpdateVisao360IndicatorsMutation = { __typename?: 'mutation_root', update_navia_dashboards_visao_360_parametrizacao_many?: Array<{ __typename?: 'navia_dashboards_visao_360_parametrizacao_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_visao_360_parametrizacao', id: any, descricao: string, selector: Navia_Dashboards_Visao_360_Selectores_Enum, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, parametro?: { __typename?: 'variaveis_parametros', id: any, parametroUnidadesMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, principal: boolean, unidadeMedida: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null }, escalasPrecisao: Array<{ __typename?: 'variaveis_escalas_precisao', id: any, nr_casas_decimais: number }> }> } | null, fonteOrigem: Array<{ __typename?: 'variaveis_fontes_origem', id: any }> } | null, unidadeMedida?: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null } | null, infraestruturaTipo?: { __typename?: 'base_infraestruturas_tipos', id: any, descricao: string } | null }> } | null> | null };

export type InsertCaudaisDiariosMunicipalityMutationVariables = Exact<{
  objects: Array<Navia_Dashboards_Volumes_Diarios_Municipios_Insert_Input> | Navia_Dashboards_Volumes_Diarios_Municipios_Insert_Input;
}>;


export type InsertCaudaisDiariosMunicipalityMutation = { __typename?: 'mutation_root', insert_navia_dashboards_volumes_diarios_municipios?: { __typename?: 'navia_dashboards_volumes_diarios_municipios_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'navia_dashboards_volumes_diarios_municipios', id: any, descricao: string, apagado?: boolean | null, equipasVirtuaisMunicipio: Array<{ __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios', id: any, equipaVirtual: { __typename?: 'utilizadores_equipas_virtuais', id: any, descricao?: string | null } }> }> } | null };

export type UpdateCaudaisDiariosMunicipalityMutationVariables = Exact<{
  where: Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp;
  _set: Navia_Dashboards_Volumes_Diarios_Municipios_Set_Input;
}>;


export type UpdateCaudaisDiariosMunicipalityMutation = { __typename?: 'mutation_root', update_navia_dashboards_volumes_diarios_municipios?: { __typename?: 'navia_dashboards_volumes_diarios_municipios_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'navia_dashboards_volumes_diarios_municipios', id: any, descricao: string, apagado?: boolean | null, equipasVirtuaisMunicipio: Array<{ __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios', id: any, equipaVirtual: { __typename?: 'utilizadores_equipas_virtuais', id: any, descricao?: string | null } }> }> } | null };

export type InsertVirtualTeamsToCaudaisDiariosMunicipalityMutationVariables = Exact<{
  objects: Array<Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Insert_Input> | Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Insert_Input;
}>;


export type InsertVirtualTeamsToCaudaisDiariosMunicipalityMutation = { __typename?: 'mutation_root', insert_navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios?: { __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_mutation_response', affected_rows: number } | null };

export type DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutationVariables = Exact<{
  where: Navia_Dashboards_Volumes_Diarios_Equipas_Virtuais_R_Municipios_Bool_Exp;
}>;


export type DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation = { __typename?: 'mutation_root', delete_navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios?: { __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_mutation_response', affected_rows: number } | null };

export type InsertCaudaisDiariosTotalizersMutationVariables = Exact<{
  objects: Array<Navia_Dashboards_Volumes_Diarios_Totalizadores_Insert_Input> | Navia_Dashboards_Volumes_Diarios_Totalizadores_Insert_Input;
}>;


export type InsertCaudaisDiariosTotalizersMutation = { __typename?: 'mutation_root', insert_navia_dashboards_volumes_diarios_totalizadores?: { __typename?: 'navia_dashboards_volumes_diarios_totalizadores_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_volumes_diarios_totalizadores', id: any, leitura: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum, expressao: boolean, fonteOrigemPropriedade?: { __typename?: 'variaveis_fontes_origem_propriedades', id: any, fonteOrigem: { __typename?: 'variaveis_fontes_origem', id: any, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null } | null }, infraestrutura: { __typename?: 'base_infraestruturas', id: any, descricao: string } } | null }> } | null };

export type UpdateCaudaisDiariosTotalizerByPkMutationVariables = Exact<{
  pk_columns: Navia_Dashboards_Volumes_Diarios_Totalizadores_Pk_Columns_Input;
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Totalizadores_Set_Input>;
}>;


export type UpdateCaudaisDiariosTotalizerByPkMutation = { __typename?: 'mutation_root', update_navia_dashboards_volumes_diarios_totalizadores_by_pk?: { __typename?: 'navia_dashboards_volumes_diarios_totalizadores', id: any, leitura: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum, expressao: boolean, fonteOrigemPropriedade?: { __typename?: 'variaveis_fontes_origem_propriedades', id: any, fonteOrigem: { __typename?: 'variaveis_fontes_origem', id: any, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null } | null }, infraestrutura: { __typename?: 'base_infraestruturas', id: any, descricao: string } } | null } | null };

export type DeleteTotalizerByPkMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteTotalizerByPkMutation = { __typename?: 'mutation_root', delete_navia_dashboards_volumes_diarios_totalizadores_by_pk?: { __typename?: 'navia_dashboards_volumes_diarios_totalizadores', id: any } | null };

export type DeleteTotalizersMutationVariables = Exact<{
  where: Navia_Dashboards_Volumes_Diarios_Totalizadores_Bool_Exp;
}>;


export type DeleteTotalizersMutation = { __typename?: 'mutation_root', delete_navia_dashboards_volumes_diarios_totalizadores?: { __typename?: 'navia_dashboards_volumes_diarios_totalizadores_mutation_response', affected_rows: number } | null };

export type InsertCaudaisDiariosDataConfigMutationVariables = Exact<{
  objects: Array<Navia_Dashboards_Volumes_Diarios_Dados_Insert_Input> | Navia_Dashboards_Volumes_Diarios_Dados_Insert_Input;
}>;


export type InsertCaudaisDiariosDataConfigMutation = { __typename?: 'mutation_root', insert_navia_dashboards_volumes_diarios_dados?: { __typename?: 'navia_dashboards_volumes_diarios_dados_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_volumes_diarios_dados', id_municipio: any, caudal: Navia_Dashboards_Volumes_Diarios_Caudais_Enum, expressao?: string | null, leitura: Navia_Dashboards_Volumes_Diarios_Leituras_Enum, local: Navia_Dashboards_Volumes_Diarios_Locais_Enum, registo: Navia_Dashboards_Volumes_Diarios_Registos_Enum }> } | null };

export type UpdateCaudaisDiariosDataConfigMutationVariables = Exact<{
  where: Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp;
  _set?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Dados_Set_Input>;
}>;


export type UpdateCaudaisDiariosDataConfigMutation = { __typename?: 'mutation_root', update_navia_dashboards_volumes_diarios_dados?: { __typename?: 'navia_dashboards_volumes_diarios_dados_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_volumes_diarios_dados', id_municipio: any, caudal: Navia_Dashboards_Volumes_Diarios_Caudais_Enum, expressao?: string | null, leitura: Navia_Dashboards_Volumes_Diarios_Leituras_Enum, local: Navia_Dashboards_Volumes_Diarios_Locais_Enum, registo: Navia_Dashboards_Volumes_Diarios_Registos_Enum }> } | null };

export type DeleteCaudaisDiariosDataConfigMutationVariables = Exact<{
  where: Navia_Dashboards_Volumes_Diarios_Dados_Bool_Exp;
}>;


export type DeleteCaudaisDiariosDataConfigMutation = { __typename?: 'mutation_root', delete_navia_dashboards_volumes_diarios_dados?: { __typename?: 'navia_dashboards_volumes_diarios_dados_mutation_response', affected_rows: number } | null };

export type UpdateDailyFlowExpressionMutationVariables = Exact<{
  municipalityId: Scalars['Int']['input'];
  expression: Scalars['String']['input'];
}>;


export type UpdateDailyFlowExpressionMutation = { __typename?: 'mutation_root', saveDailyFlowExpression?: { __typename?: 'SaveDailyFlowExpressionResponse', id: number, savedExpression?: string | null, valid: boolean } | null };

export type UpdateRequestsMapParamaterizationByPkMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  _set?: InputMaybe<Navia_Dashboards_Requisicoes_Mapa_Parametrizacao_Set_Input>;
}>;


export type UpdateRequestsMapParamaterizationByPkMutation = { __typename?: 'mutation_root', update_navia_dashboards_requisicoes_mapa_parametrizacao_by_pk?: { __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao', id: any, descricao: string, cor: { __typename?: 'navia_cores', id: any, cor_modo_claro: string, cor_modo_escuro: string } } | null };

export type UpdateRequestIndicatorsParameterizationByPkMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  _set?: InputMaybe<Navia_Dashboards_Requisicoes_Indicadores_Parametrizacao_Set_Input>;
}>;


export type UpdateRequestIndicatorsParameterizationByPkMutation = { __typename?: 'mutation_root', update_navia_dashboards_requisicoes_indicadores_parametrizacao_by_pk?: { __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao', id: any, atraso_segundos: any, limite_inferior_segundos: any, limite_superior_segundos: any, variavelMarcacao?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, fonteOrigem: Array<{ __typename?: 'variaveis_fontes_origem', id: any }> } | null } | null };

export type DeleteLeakMonitoringSymptomsMutationVariables = Exact<{
  where: Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Bool_Exp;
}>;


export type DeleteLeakMonitoringSymptomsMutation = { __typename?: 'mutation_root', delete_navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas?: { __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas', id: any, sintoma_id: any, monitorizacao_roturas_sintoma_id: any, sintoma: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null } }> } | null };

export type InsertLeakMonitoringSymptomsMutationVariables = Exact<{
  objects: Array<Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Insert_Input> | Navia_Dashboards_Monitorizacao_Roturas_Sintomas_R_Sintomas_Insert_Input;
}>;


export type InsertLeakMonitoringSymptomsMutation = { __typename?: 'mutation_root', insert_navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas?: { __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas', id: any, sintoma_id: any, monitorizacao_roturas_sintoma_id: any, sintoma: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null } }> } | null };

export type UpdateLeakMonitoringCauseMutationVariables = Exact<{
  where: Navia_Dashboards_Monitorizacao_Roturas_Causas_Bool_Exp;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Causas_Set_Input>;
}>;


export type UpdateLeakMonitoringCauseMutation = { __typename?: 'mutation_root', update_navia_dashboards_monitorizacao_roturas_causas?: { __typename?: 'navia_dashboards_monitorizacao_roturas_causas_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_monitorizacao_roturas_causas', id: any, categoria: string, cor_id: any }> } | null };

export type DeleteLeakMonitoringCausesMutationVariables = Exact<{
  where: Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Bool_Exp;
}>;


export type DeleteLeakMonitoringCausesMutation = { __typename?: 'mutation_root', delete_navia_dashboards_monitorizacao_roturas_causas_r_causas?: { __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas', id: any, monitorizacao_roturas_causa_id: any, causa: { __typename?: 'sintomas_causas_trabalhos', id: any, descricao?: string | null } }> } | null };

export type InsertLeakMonitoringCausesMutationVariables = Exact<{
  objects: Array<Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Insert_Input> | Navia_Dashboards_Monitorizacao_Roturas_Causas_R_Causas_Insert_Input;
}>;


export type InsertLeakMonitoringCausesMutation = { __typename?: 'mutation_root', insert_navia_dashboards_monitorizacao_roturas_causas_r_causas?: { __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas', id: any, monitorizacao_roturas_causa_id: any, causa: { __typename?: 'sintomas_causas_trabalhos', id: any, descricao?: string | null } }> } | null };

export type UpdateLeakMonitoringVariablesMutationVariables = Exact<{
  where: Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Bool_Exp;
  _set?: InputMaybe<Navia_Dashboards_Monitorizacao_Roturas_Variaveis_Set_Input>;
}>;


export type UpdateLeakMonitoringVariablesMutation = { __typename?: 'mutation_root', update_navia_dashboards_monitorizacao_roturas_variaveis?: { __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis', id: any, indicador: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null } | null, fase?: { __typename?: 'servicos_fases', id: any, descricao?: string | null } | null }> } | null };

export type DeleteLeakDiagnosisSymptomsMutationVariables = Exact<{
  where: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Bool_Exp;
}>;


export type DeleteLeakDiagnosisSymptomsMutation = { __typename?: 'mutation_root', delete_navia_dashboards_diagnostico_roturas_sintomas?: { __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_sintomas', id: any, sintoma: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null } }> } | null };

export type InsertLeakDiagnosisSymptomsMutationVariables = Exact<{
  objects: Array<Navia_Dashboards_Diagnostico_Roturas_Sintomas_Insert_Input> | Navia_Dashboards_Diagnostico_Roturas_Sintomas_Insert_Input;
}>;


export type InsertLeakDiagnosisSymptomsMutation = { __typename?: 'mutation_root', insert_navia_dashboards_diagnostico_roturas_sintomas?: { __typename?: 'navia_dashboards_diagnostico_roturas_sintomas_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_sintomas', id: any, sintoma: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null } }> } | null };

export type DeleteLeakDiagnosisInfrastructureTypesMutationVariables = Exact<{
  where: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Bool_Exp;
}>;


export type DeleteLeakDiagnosisInfrastructureTypesMutation = { __typename?: 'mutation_root', delete_navia_dashboards_diagnostico_roturas_tipos_infraestrutura?: { __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura', tipo_infraestrutura_id: any }> } | null };

export type InsertLeakDiagnosisInfrastructureTypesMutationVariables = Exact<{
  objects: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Insert_Input> | Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Insert_Input;
}>;


export type InsertLeakDiagnosisInfrastructureTypesMutation = { __typename?: 'mutation_root', insert_navia_dashboards_diagnostico_roturas_tipos_infraestrutura?: { __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura', tipo_infraestrutura_id: any }> } | null };

export type UpdateLeakDiagnosisInfrastructureVariablesMutationVariables = Exact<{
  where: Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Bool_Exp;
  _set?: InputMaybe<Navia_Dashboards_Diagnostico_Roturas_Infraestruturas_Variaveis_Set_Input>;
}>;


export type UpdateLeakDiagnosisInfrastructureVariablesMutation = { __typename?: 'mutation_root', update_navia_dashboards_diagnostico_roturas_infraestruturas_variaveis?: { __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis', id: any, unidadeMedida?: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null } | null }> } | null };

export type DeleteLeakDiagnosisMapZmcMutationVariables = Exact<{
  where: Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Bool_Exp;
}>;


export type DeleteLeakDiagnosisMapZmcMutation = { __typename?: 'mutation_root', delete_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc?: { __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc', tipo_infraestrutura_id: any }> } | null };

export type InsertLeakDiagnosisMapZmcMutationVariables = Exact<{
  objects: Array<Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Insert_Input> | Navia_Dashboards_Diagnostico_Roturas_Tipos_Infraestrutura_Zmc_Insert_Input;
}>;


export type InsertLeakDiagnosisMapZmcMutation = { __typename?: 'mutation_root', insert_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc?: { __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc', tipo_infraestrutura_id: any }> } | null };

export type UpdateLeakDiagnosisMapLevelsMutationVariables = Exact<{
  updates: Array<Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Updates> | Navia_Dashboards_Diagnostico_Roturas_Mapa_Niveis_Updates;
}>;


export type UpdateLeakDiagnosisMapLevelsMutation = { __typename?: 'mutation_root', update_navia_dashboards_diagnostico_roturas_mapa_niveis_many?: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis_mutation_response', returning: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis', id: any, min?: number | null, max?: number | null }> } | null> | null };

export type UsersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type UsersQuery = { __typename?: 'query_root', utilizadores_utilizadores: Array<{ __typename?: 'utilizadores_utilizadores', id: any, username: string, tema?: { __typename?: 'utilizadores_temas', id: any } | null }> };

export type GetUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'query_root', utilizadores_utilizadores: Array<{ __typename?: 'utilizadores_utilizadores', activo?: boolean | null, email?: string | null, id: any, username: string, descricao?: string | null, codigo_externo?: string | null }>, utilizadores_utilizadores_aggregate: { __typename?: 'utilizadores_utilizadores_aggregate', aggregate?: { __typename?: 'utilizadores_utilizadores_aggregate_fields', count: number } | null } };

export type TransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TransactionsQuery = { __typename?: 'query_root', permissoes_transacoes: Array<{ __typename?: 'permissoes_transacoes', id: any, id_modulo?: any | null, mascara?: number | null, descricao?: string | null }> };

export type TransactionsByIdQueryVariables = Exact<{
  transactionId: Scalars['bigint']['input'];
}>;


export type TransactionsByIdQuery = { __typename?: 'query_root', permissoes_transacoes_by_pk?: { __typename?: 'permissoes_transacoes', id: any, id_modulo?: any | null, descricao?: string | null, mascara?: number | null } | null };

export type MenuQueryVariables = Exact<{ [key: string]: never; }>;


export type MenuQuery = { __typename?: 'query_root', menuLicenca?: Array<{ __typename?: 'MenuIds', id?: number | null, UtilizadoresMenu?: { __typename?: 'utilizadores_menu', id: any, id_pai?: any | null, has_childs?: boolean | null, url?: string | null, ordem?: number | null, texto?: string | null, new_ui: boolean, translation_key?: string | null } | null } | null> | null };

export type LanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguagesQuery = { __typename?: 'query_root', getLanguages: { __typename?: 'Languages', available_languages: Array<string>, default_language: string } };

export type CausasQueryVariables = Exact<{
  where?: InputMaybe<Sintomas_Causas_Trabalhos_Bool_Exp>;
  orderBy?: InputMaybe<Array<Sintomas_Causas_Trabalhos_Order_By> | Sintomas_Causas_Trabalhos_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CausasQuery = { __typename?: 'query_root', sintomas_causas_trabalhos: Array<{ __typename?: 'sintomas_causas_trabalhos', id: any, codigo?: string | null, descricao?: string | null, obs?: boolean | null, causa?: boolean | null, infraestrutura?: boolean | null, codigo_externo?: string | null }>, sintomas_causas_trabalhos_aggregate: { __typename?: 'sintomas_causas_trabalhos_aggregate', aggregate?: { __typename?: 'sintomas_causas_trabalhos_aggregate_fields', count: number } | null } };

export type InfraestruturasQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  orderBy?: InputMaybe<Array<Base_Infraestruturas_Order_By> | Base_Infraestruturas_Order_By>;
  whereActiveChilds?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
}>;


export type InfraestruturasQuery = { __typename?: 'query_root', base_infraestruturas: Array<{ __typename?: 'base_infraestruturas', id: any, descricao: string, id_tipo_bulk?: any | null, id_tipo_infraestrutura: any, codigo_manutencao?: string | null, codigo_sig?: string | null, nome_instalacao?: string | null, nome_completo?: string | null, tipo: { __typename?: 'base_infraestruturas_tipos', id: any, descricao_curta?: string | null }, infraestruturaToponimia?: { __typename?: 'base_infraestruturas_r_toponimias', id: any, toponimia?: { __typename?: 'base_toponimias', id: any, nome_medio?: string | null } | null } | null, activeChilds?: Array<{ __typename?: 'base_infraestruturas', id: any, descricao: string, apagado: boolean, id_tipo_bulk?: any | null, id_tipo_infraestrutura: any, codigo_manutencao?: string | null, codigo_sig?: string | null, nome_instalacao?: string | null, tipo: { __typename?: 'base_infraestruturas_tipos', id: any, descricao_curta?: string | null } }> | null }>, base_infraestruturas_aggregate: { __typename?: 'base_infraestruturas_aggregate', aggregate?: { __typename?: 'base_infraestruturas_aggregate_fields', count: number } | null } };

export type BulkTiposQueryVariables = Exact<{
  where?: InputMaybe<Base_Bulk_Tipos_Bool_Exp>;
  order_by?: InputMaybe<Array<Base_Bulk_Tipos_Order_By> | Base_Bulk_Tipos_Order_By>;
}>;


export type BulkTiposQuery = { __typename?: 'query_root', base_bulk_tipos: Array<{ __typename?: 'base_bulk_tipos', id: any, descricao?: string | null }> };

export type InfraestruturasTiposQueryVariables = Exact<{
  where?: InputMaybe<Base_Infraestruturas_Tipos_Bool_Exp>;
  orderBy?: InputMaybe<Array<Base_Infraestruturas_Tipos_Order_By> | Base_Infraestruturas_Tipos_Order_By>;
}>;


export type InfraestruturasTiposQuery = { __typename?: 'query_root', base_infraestruturas_tipos: Array<{ __typename?: 'base_infraestruturas_tipos', id: any, descricao: string, nome_completo?: string | null, id_pai?: any | null, id_no_tipo?: any | null, apagado: boolean, activeChilds?: Array<{ __typename?: 'base_infraestruturas_tipos', id: any, descricao: string, nome_completo?: string | null, id_pai?: any | null, id_no_tipo?: any | null, apagado: boolean }> | null, infraestruturas_aggregate: { __typename?: 'base_infraestruturas_aggregate', aggregate?: { __typename?: 'base_infraestruturas_aggregate_fields', count: number } | null } }> };

export type InterventionsQueryVariables = Exact<{
  where?: InputMaybe<Servicos_Intervencoes_Bool_Exp>;
  orderBy?: InputMaybe<Array<Servicos_Intervencoes_Order_By> | Servicos_Intervencoes_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InterventionsQuery = { __typename?: 'query_root', servicos_intervencoes: Array<{ __typename?: 'servicos_intervencoes', id: any, data_planeada: any, executada_data_hora?: any | null, numero?: string | null, estado?: { __typename?: 'servicos_intervencoes_estados', id: any, descricao?: string | null, cor?: string | null } | null, sintoma?: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null } | null, coordenadasMobile?: { __typename?: 'mobile_coordenadas', id: any, latitude: any, longitude: any } | null, toponimia?: { __typename?: 'base_toponimias', id: any, descricao_curta?: string | null, nome_medio?: string | null, toponimiaCoordenadas: Array<{ __typename?: 'base_toponimias_coordenadas', id: any, latitude?: any | null, longitude?: any | null }> } | null, infraestrutura?: { __typename?: 'base_infraestruturas', id: any, descricao: string, tipo: { __typename?: 'base_infraestruturas_tipos', id: any, descricao: string }, infraestruturaCoordenadas: Array<{ __typename?: 'base_infraestruturas_coordenadas', id: any, latitude?: any | null, longitude?: any | null }> } | null, intervencaoUtilizador?: { __typename?: 'servicos_intervencoes_atribuicao_utilizadores', id: any, utilizador?: { __typename?: 'utilizadores_utilizadores', id: any, descricao?: string | null } | null } | null, leituras: Array<{ __typename?: 'variaveis_leituras', id: any, id_fonte_origem: any, id_fase?: any | null, valor_numerico?: any | null }>, causas: Array<{ __typename?: 'servicos_intervencoes_r_causas_trabalhos', id: any, causa?: { __typename?: 'sintomas_causas_trabalhos', id: any, descricao?: string | null } | null }>, intervalos: Array<{ __typename?: 'tarefas_intervalos', id: any, data_inicio?: any | null, data_fim?: any | null }> }>, servicos_intervencoes_aggregate: { __typename?: 'servicos_intervencoes_aggregate', aggregate?: { __typename?: 'servicos_intervencoes_aggregate_fields', count: number } | null } };

export type SintomasQueryVariables = Exact<{
  where?: InputMaybe<Sintomas_Arvore_Bool_Exp>;
  orderBy?: InputMaybe<Array<Sintomas_Arvore_Order_By> | Sintomas_Arvore_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SintomasQuery = { __typename?: 'query_root', sintomas_arvore: Array<{ __typename?: 'sintomas_arvore', id: any, id_no_tipo?: any | null, descricao?: string | null, id_pai?: any | null, activeChilds?: Array<{ __typename?: 'sintomas_arvore', id: any }> | null }> };

export type SintomaByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type SintomaByIdQuery = { __typename?: 'query_root', sintomas_arvore_by_pk?: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null, nome_completo?: string | null, causaRelacoes: Array<{ __typename?: 'sintomas_sintomas_relacao', id: any, id_sintoma?: any | null, id_fase?: any | null, obrigatorio?: boolean | null, apagado?: boolean | null, id_fonte_origem?: any | null, id_causa_trabalho?: any | null, causaTrabalho?: { __typename?: 'sintomas_causas_trabalhos', id: any, obs?: boolean | null, descricao?: string | null, causa?: boolean | null } | null }> } | null };

export type SintomaCausaRelationQueryVariables = Exact<{
  where?: InputMaybe<Sintomas_Sintomas_Relacao_Bool_Exp>;
  orderBy?: InputMaybe<Array<Sintomas_Sintomas_Relacao_Order_By> | Sintomas_Sintomas_Relacao_Order_By>;
}>;


export type SintomaCausaRelationQuery = { __typename?: 'query_root', sintomas_sintomas_relacao: Array<{ __typename?: 'sintomas_sintomas_relacao', id: any, id_sintoma?: any | null, id_causa_trabalho?: any | null, id_fase?: any | null, id_fonte_origem?: any | null, obrigatorio?: boolean | null, relacaoOrdem?: { __typename?: 'sintomas_sintomas_relacao_ordem', id: number, ordem?: any | null } | null, fase?: { __typename?: 'servicos_fases', id: any, descricao?: string | null } | null, fonteOrigem?: { __typename?: 'variaveis_fontes_origem', id: any, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, dominio?: { __typename?: 'variaveis_dominios', id: any, descricao: string } | null } | null } | null }> };

export type ParametrizacoesQueryVariables = Exact<{ [key: string]: never; }>;


export type ParametrizacoesQuery = { __typename?: 'query_root', base_parametrizacoes: Array<{ __typename?: 'base_parametrizacoes', id: any, descricao?: string | null, valor?: string | null }> };

export type FontesOrigemVariablesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Variaveis_Fontes_Origem_Bool_Exp>;
  orderBy?: InputMaybe<Array<Variaveis_Fontes_Origem_Order_By> | Variaveis_Fontes_Origem_Order_By>;
}>;


export type FontesOrigemVariablesQuery = { __typename?: 'query_root', variaveis_fontes_origem: Array<{ __typename?: 'variaveis_fontes_origem', id: any, descricao?: string | null, variavel?: { __typename?: 'variaveis_base', id: any, codigo?: string | null, descricao?: string | null, tipo: { __typename?: 'variaveis_tipos', id: any, tipo?: string | null, descricao?: string | null }, dominio?: { __typename?: 'variaveis_dominios', id: any, descricao: string } | null, parametro?: { __typename?: 'variaveis_parametros', id: any, parametroUnidadesMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, principal: boolean, fator_multiplicativo_numerico: any, unidadeMedida: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null } }> } | null } | null, parametroUnidadeMedida: { __typename?: 'variaveis_parametros_r_unidades_medida', id: any, unidadeMedida: { __typename?: 'variaveis_unidades_medida', id: any, descricao?: string | null } } }>, variaveis_fontes_origem_aggregate: { __typename?: 'variaveis_fontes_origem_aggregate', aggregate?: { __typename?: 'variaveis_fontes_origem_aggregate_fields', count: number } | null } };

export type VariableCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type VariableCategoriesQuery = { __typename?: 'query_root', variaveis_base_categorias: Array<{ __typename?: 'variaveis_base_categorias', id: any, descricao?: string | null }> };

export type GetUtilizadorCategoriasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUtilizadorCategoriasQuery = { __typename?: 'query_root', utilizadores_categorias: Array<{ __typename?: 'utilizadores_categorias', id: any, descricao?: string | null }> };

export type PerformanceInfraestruturaParametersQueryVariables = Exact<{ [key: string]: never; }>;


export type PerformanceInfraestruturaParametersQuery = { __typename?: 'query_root', navia_dashboards_performance_infraestrutura_parametrizacao: Array<{ __typename?: 'navia_dashboards_performance_infraestrutura_parametrizacao', id: number, descricao: string, unidadeMedida?: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null, parametroUnidadeMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, fator_multiplicativo_numerico: any, escalasPrecisao: Array<{ __typename?: 'variaveis_escalas_precisao', id: any, nr_casas_decimais: number }> }> } | null, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, fonteOrigem: Array<{ __typename?: 'variaveis_fontes_origem', id: any }>, parametro?: { __typename?: 'variaveis_parametros', id: any, parametroUnidadesMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, fator_multiplicativo_numerico: any, unidadeMedida: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null }, escalasPrecisao: Array<{ __typename?: 'variaveis_escalas_precisao', id: any, nr_casas_decimais: number }> }> } | null, propriedades: Array<{ __typename?: 'variaveis_base_propriedades', id: any, calc_expressao?: string | null, calc_nr_casas_decimais?: any | null, agregacaoTempo?: { __typename?: 'variaveis_agregacao', id: any, descricao?: string | null } | null }> } | null }> };

export type PerformanceInfraestruturaDashboardQueryVariables = Exact<{
  variablesWhereClause?: InputMaybe<Variaveis_Base_Bool_Exp>;
  homologousWhereClause?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
  pastMonthWhereClause?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
  evolutionWhereClause?: InputMaybe<Variaveis_Valores_Mensais_Bool_Exp>;
}>;


export type PerformanceInfraestruturaDashboardQuery = { __typename?: 'query_root', variaveis_base: Array<{ __typename?: 'variaveis_base', id: any, descricao?: string | null, id_tipo: any, propriedades: Array<{ __typename?: 'variaveis_base_propriedades', id: any, calc_expressao?: string | null, calc_nr_casas_decimais?: any | null, agregacaoTempo?: { __typename?: 'variaveis_agregacao', id: any, descricao?: string | null } | null }>, variaveisCalculo: Array<{ __typename?: 'variaveis_base_calc_variaveis', id: any, str_variavel?: string | null, id_fonte_origem?: any | null, fonteOrigem?: { __typename?: 'variaveis_fontes_origem', id: any, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, evolution: Array<{ __typename?: 'variaveis_valores_mensais', id: any, mes?: number | null, ano?: number | null, valor_calculado?: any | null, id_variavel_base?: any | null }> } | null } | null }>, homologous: Array<{ __typename?: 'variaveis_valores_mensais', id: any, valor_calculado?: any | null, mes?: number | null, ano?: number | null, id_variavel_base?: any | null }>, pastMonth: Array<{ __typename?: 'variaveis_valores_mensais', id: any, valor_calculado?: any | null, mes?: number | null, ano?: number | null, id_variavel_base?: any | null }>, evolution: Array<{ __typename?: 'variaveis_valores_mensais', id: any, mes?: number | null, ano?: number | null, valor_calculado?: any | null, id_variavel_base?: any | null }> }> };

export type PesquisaAtivaFugasParametrizacaoQueryVariables = Exact<{ [key: string]: never; }>;


export type PesquisaAtivaFugasParametrizacaoQuery = { __typename?: 'query_root', navia_integracoes_by_pk?: { __typename?: 'navia_integracoes', id: any, descricao?: string | null, activo?: boolean | null } | null, integracoes_sig_maps_ortos: Array<{ __typename?: 'integracoes_sig_maps_ortos', id: any, name?: string | null, json?: string | null, url?: string | null }>, navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao: Array<{ __typename?: 'navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao', id: any, descricao: string, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, parametro?: { __typename?: 'variaveis_parametros', id: any, parametroUnidadesMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, principal: boolean, fator_multiplicativo_numerico: any, unidadeMedida: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null }, escalasPrecisao: Array<{ __typename?: 'variaveis_escalas_precisao', id: any, nr_casas_decimais: number }> }> } | null, fonteOrigem: Array<{ __typename?: 'variaveis_fontes_origem', id: any }>, propriedades: Array<{ __typename?: 'variaveis_base_propriedades', id: any, calc_expressao?: string | null, calc_nr_casas_decimais?: any | null, agregacaoTempo?: { __typename?: 'variaveis_agregacao', id: any, descricao?: string | null } | null }> } | null, unidadeMedida?: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null } | null }>, integracoes_sig_proxy: Array<{ __typename?: 'integracoes_sig_proxy', id: any, url: string }>, integracoes_sig_services: Array<{ __typename?: 'integracoes_sig_services', id: any, url?: string | null, title?: string | null, visibility_default: boolean, opacity?: any | null }>, integracoes_sig_parametrizacao: Array<{ __typename?: 'integracoes_sig_parametrizacao', latitude?: string | null, longitude?: string | null, zoom_default?: number | null, url_services?: string | null, map_server?: string | null, type?: string | null }>, navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa: Array<{ __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa', plano_padrao_id: any, modeloTarefa: { __typename?: 'tarefas_planos_padrao', id: any, descricao: string } }>, navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas: Array<{ __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas', id: any, cor_id: any, cor: { __typename?: 'navia_cores', id: any, cor_modo_claro: string, cor_modo_escuro: string }, sintoma?: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null } | null, fonteOrigem?: { __typename?: 'variaveis_fontes_origem', id: any, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, id_dominio: any } | null } | null, fase?: { __typename?: 'servicos_fases', id: any, descricao?: string | null } | null, mapaSintomaDominiosValores: Array<{ __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores', id: any, dominioValor: { __typename?: 'variaveis_dominios_valores', id: any, descricao: string } }> }>, navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura: Array<{ __typename?: 'navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura', tipoInfraestrutura: { __typename?: 'base_infraestruturas_tipos', id: any, descricao: string, id_sig_service?: any | null, codigo_externo?: string | null, sig_atributo_id?: string | null } }> };

export type MonthlyVariableValuesQueryVariables = Exact<{
  variableIds?: InputMaybe<Array<Scalars['bigint']['input']> | Scalars['bigint']['input']>;
  startMonth: Scalars['Int']['input'];
  endMonth: Scalars['Int']['input'];
  startYear: Scalars['Int']['input'];
  endYear: Scalars['Int']['input'];
}>;


export type MonthlyVariableValuesQuery = { __typename?: 'query_root', variaveis_base: Array<{ __typename?: 'variaveis_base', id: any, descricao?: string | null, id_tipo: any, propriedades: Array<{ __typename?: 'variaveis_base_propriedades', id: any, calc_expressao?: string | null, calc_nr_casas_decimais?: any | null, agregacaoTempo?: { __typename?: 'variaveis_agregacao', id: any, descricao?: string | null } | null }>, variaveisCalculo: Array<{ __typename?: 'variaveis_base_calc_variaveis', id: any, str_variavel?: string | null, id_fonte_origem?: any | null, fonteOrigem?: { __typename?: 'variaveis_fontes_origem', id: any, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, evolution: Array<{ __typename?: 'variaveis_valores_mensais', id: any, mes?: number | null, ano?: number | null, valor_calculado?: any | null, id_variavel_base?: any | null }> } | null } | null }>, evolution: Array<{ __typename?: 'variaveis_valores_mensais', id: any, mes?: number | null, ano?: number | null, valor_calculado?: any | null, id_variavel_base?: any | null }> }> };

export type NaviaDashboardsMenuQueryVariables = Exact<{
  orderBy?: InputMaybe<DashboardsLicencaOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DashboardsLicencaWhereInput>;
}>;


export type NaviaDashboardsMenuQuery = { __typename?: 'query_root', dashboardsLicenca: Array<{ __typename?: 'DashboardsNaviaIds', id: number, url: string, ordem: number, descricao: string, image_path_light?: string | null, image_path_dark?: string | null, menuTransacoes: Array<{ __typename?: 'navia_dashboards_menu_r_transacoes', id: any, id_transacao: any }> }> };

export type ModelosTarefaQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Tarefas_Planos_Padrao_Bool_Exp>;
  orderBy?: InputMaybe<Array<Tarefas_Planos_Padrao_Order_By> | Tarefas_Planos_Padrao_Order_By>;
}>;


export type ModelosTarefaQuery = { __typename?: 'query_root', tarefas_planos_padrao: Array<{ __typename?: 'tarefas_planos_padrao', id: any, descricao: string }>, tarefas_planos_padrao_aggregate: { __typename?: 'tarefas_planos_padrao_aggregate', aggregate?: { __typename?: 'tarefas_planos_padrao_aggregate_fields', count: number } | null } };

export type RegistrationPhasesQueryVariables = Exact<{
  where?: InputMaybe<Servicos_Fases_Bool_Exp>;
}>;


export type RegistrationPhasesQuery = { __typename?: 'query_root', servicos_fases: Array<{ __typename?: 'servicos_fases', id: any, descricao?: string | null }> };

export type DominioDominioValoresQueryVariables = Exact<{
  where?: InputMaybe<Variaveis_Dominios_R_Dominios_Valores_Bool_Exp>;
}>;


export type DominioDominioValoresQuery = { __typename?: 'query_root', variaveis_dominios_r_dominios_valores: Array<{ __typename?: 'variaveis_dominios_r_dominios_valores', id: any, dominio: { __typename?: 'variaveis_dominios', id: any, descricao: string }, dominioValor: { __typename?: 'variaveis_dominios_valores', id: any, descricao: string } }> };

export type PesquisaAtivaFugasTarefasQueryVariables = Exact<{
  planosPadraoWhereClause?: InputMaybe<Tarefas_Planos_Padrao_Bool_Exp>;
  tarefasWhereClause?: InputMaybe<Tarefas_Tarefas_Bool_Exp>;
  rastreabilidadesWhereClause?: InputMaybe<Servicos_Rastreabilidade_Bool_Exp>;
}>;


export type PesquisaAtivaFugasTarefasQuery = { __typename?: 'query_root', tarefas_planos_padrao: Array<{ __typename?: 'tarefas_planos_padrao', id: any, descricao: string, tarefas: Array<{ __typename?: 'tarefas_tarefas', id: any, tarefaInfraestruturas: Array<{ __typename?: 'tarefas_tarefas_r_infraestruturas', id: any, infraestrutura: { __typename?: 'base_infraestruturas', id: any, codigo_externo?: string | null } }>, rastreabilidades: Array<{ __typename?: 'servicos_rastreabilidade', id: any, intervencaoDestino?: { __typename?: 'servicos_intervencoes', id: any, id_sintoma?: any | null, numero?: string | null, data_planeada: any, sintoma?: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null } | null, estado?: { __typename?: 'servicos_intervencoes_estados', id: any, descricao?: string | null } | null, leituras: Array<{ __typename?: 'variaveis_leituras', id: any, id_fonte_origem: any, id_fase?: any | null, id_valor_dominio?: any | null }>, infraestrutura?: { __typename?: 'base_infraestruturas', id: any, descricao: string, codigo_externo?: string | null, infraestruturaCoordenadas: Array<{ __typename?: 'base_infraestruturas_coordenadas', id: any, latitude?: any | null, longitude?: any | null }> } | null } | null, requisicaoDestino?: { __typename?: 'servicos_requisicoes', id: any, id_sintoma?: any | null, numero?: string | null, data_hora: any, sintoma?: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null } | null, estado?: { __typename?: 'servicos_requisicoes_estados', id: any, descricao?: string | null } | null, leituras: Array<{ __typename?: 'variaveis_leituras', id: any, id_fonte_origem: any, id_fase?: any | null, id_valor_dominio?: any | null }>, locaisInfraestruturas: Array<{ __typename?: 'servicos_requisicoes_locais_infra_estruturas', id: any, infraestrutura?: { __typename?: 'base_infraestruturas', id: any, descricao: string, codigo_externo?: string | null, infraestruturaCoordenadas: Array<{ __typename?: 'base_infraestruturas_coordenadas', id: any, latitude?: any | null, longitude?: any | null }> } | null }> } | null }> }> }> };

export type GetIntegrationStatusByIdQueryVariables = Exact<{
  id: Bigint_Comparison_Exp;
}>;


export type GetIntegrationStatusByIdQuery = { __typename?: 'query_root', navia_integracoes: Array<{ __typename?: 'navia_integracoes', id: any, activo?: boolean | null, descricao?: string | null }> };

export type GetAdProtocolIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdProtocolIdQuery = { __typename?: 'query_root', integracoes_ad_parametrizacao: Array<{ __typename?: 'integracoes_ad_parametrizacao', id_protocolo?: number | null }> };

export type GetAdsamlConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdsamlConfigQuery = { __typename?: 'query_root', integracoes_ad_saml_parametrizacao: Array<{ __typename?: 'integracoes_ad_saml_parametrizacao', url_encaminhamento?: string | null }> };

export type Visao360ParametrizacaoQueryVariables = Exact<{ [key: string]: never; }>;


export type Visao360ParametrizacaoQuery = { __typename?: 'query_root', navia_dashboards_visao_360_parametrizacao: Array<{ __typename?: 'navia_dashboards_visao_360_parametrizacao', id: any, descricao: string, selector: Navia_Dashboards_Visao_360_Selectores_Enum, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, propriedades: Array<{ __typename?: 'variaveis_base_propriedades', id: any, calc_expressao?: string | null, calc_nr_casas_decimais?: any | null, agregacaoTempo?: { __typename?: 'variaveis_agregacao', id: any, descricao?: string | null } | null }>, parametro?: { __typename?: 'variaveis_parametros', id: any, parametroUnidadesMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, principal: boolean, fator_multiplicativo_numerico: any, unidadeMedida: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null }, escalasPrecisao: Array<{ __typename?: 'variaveis_escalas_precisao', id: any, nr_casas_decimais: number }> }> } | null, fonteOrigem: Array<{ __typename?: 'variaveis_fontes_origem', id: any }> } | null, unidadeMedida?: { __typename?: 'variaveis_unidades_medida', id: any, descricao_curta?: string | null } | null, infraestruturaTipo?: { __typename?: 'base_infraestruturas_tipos', id: any, descricao: string } | null }> };

export type QsParametrizacaoQueryVariables = Exact<{ [key: string]: never; }>;


export type QsParametrizacaoQuery = { __typename?: 'query_root', rqs_parametrizacao: Array<{ __typename?: 'rqs_parametrizacao', data_inicio?: any | null }> };

export type CaudaisDiariosMunicipalitiesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Navia_Dashboards_Volumes_Diarios_Municipios_Bool_Exp>;
  orderBy?: InputMaybe<Array<Navia_Dashboards_Volumes_Diarios_Municipios_Order_By> | Navia_Dashboards_Volumes_Diarios_Municipios_Order_By>;
}>;


export type CaudaisDiariosMunicipalitiesQuery = { __typename?: 'query_root', navia_dashboards_volumes_diarios_municipios: Array<{ __typename?: 'navia_dashboards_volumes_diarios_municipios', id: any, descricao: string, apagado?: boolean | null, equipasVirtuaisMunicipio: Array<{ __typename?: 'navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios', id: any, equipaVirtual: { __typename?: 'utilizadores_equipas_virtuais', id: any, descricao?: string | null } }> }>, navia_dashboards_volumes_diarios_municipios_aggregate: { __typename?: 'navia_dashboards_volumes_diarios_municipios_aggregate', aggregate?: { __typename?: 'navia_dashboards_volumes_diarios_municipios_aggregate_fields', count: number } | null } };

export type VirtualTeamsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Utilizadores_Equipas_Virtuais_Bool_Exp>;
  orderBy?: InputMaybe<Array<Utilizadores_Equipas_Virtuais_Order_By> | Utilizadores_Equipas_Virtuais_Order_By>;
}>;


export type VirtualTeamsQuery = { __typename?: 'query_root', utilizadores_equipas_virtuais: Array<{ __typename?: 'utilizadores_equipas_virtuais', id: any, descricao?: string | null }>, utilizadores_equipas_virtuais_aggregate: { __typename?: 'utilizadores_equipas_virtuais_aggregate', aggregate?: { __typename?: 'utilizadores_equipas_virtuais_aggregate_fields', count: number } | null } };

export type GetDashboardQsIndicatorsQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type GetDashboardQsIndicatorsQuery = { __typename?: 'query_root', getDashboardQSIndicators: Array<{ __typename?: 'Indicator', value?: number | null, id: string } | null> };

export type GetDashboardQsTopFiveNonComplianceBySymptomQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type GetDashboardQsTopFiveNonComplianceBySymptomQuery = { __typename?: 'query_root', getDashboardQSTopFiveNonComplianceBySymptom?: Array<{ __typename?: 'TopFiveNonComplianceBySymptom', id_symptom: string, symptom: string, total_requests?: number | null } | null> | null };

export type GetDashboardQsTopFiveAverageDurationBySymptomQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type GetDashboardQsTopFiveAverageDurationBySymptomQuery = { __typename?: 'query_root', getDashboardQSTopFiveAverageDurationBySymptom?: Array<{ __typename?: 'TopFiveAverageDurationBySymptom', id_symptom: string, average_time_in_seconds: number, id_frequency_time_limit_response: string, time_limit_response: number, symptom: string, time_limit_seconds: number } | null> | null };

export type CheckMunicipalityExistsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CheckMunicipalityExistsQuery = { __typename?: 'query_root', checkMunicipalityExists?: { __typename?: 'MunicipalityExistsResponse', exists: boolean, id?: number | null } | null };

export type DailyFlowReadingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  municipalityId: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  placeSearchValue?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<DailyFlowReadingsSortInput>> | InputMaybe<DailyFlowReadingsSortInput>>;
}>;


export type DailyFlowReadingsQuery = { __typename?: 'query_root', getDailyFlowReadings?: { __typename?: 'DailyFlowReadings', id: string, totalCount: number, readings: Array<{ __typename?: 'DailyFlowReading', id: number, readingId?: number | null, id_fonte_origem: number, place: string, totalizer?: number | null, parcial_totalizer?: number | null, date: any, unit?: string | null } | null> } | null };

export type InfrastructureTotalizersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Base_Infraestruturas_Bool_Exp>;
  sourceOriginPropertiesWhere?: InputMaybe<Variaveis_Fontes_Origem_Propriedades_Bool_Exp>;
  orderBy?: InputMaybe<Array<Base_Infraestruturas_Order_By> | Base_Infraestruturas_Order_By>;
}>;


export type InfrastructureTotalizersQuery = { __typename?: 'query_root', base_infraestruturas: Array<{ __typename?: 'base_infraestruturas', id: any, descricao: string, id_tipo_bulk?: any | null, id_tipo_infraestrutura: any, codigo_manutencao?: string | null, codigo_sig?: string | null, nome_instalacao?: string | null, has_childs?: boolean | null, parentInfra?: { __typename?: 'base_infraestruturas', id: any, descricao: string, id_tipo_bulk?: any | null, parentInfra?: { __typename?: 'base_infraestruturas', id: any, descricao: string, id_tipo_bulk?: any | null, parentInfra?: { __typename?: 'base_infraestruturas', id: any, descricao: string, id_tipo_bulk?: any | null, parentInfra?: { __typename?: 'base_infraestruturas', id: any, descricao: string, id_tipo_bulk?: any | null, parentInfra?: { __typename?: 'base_infraestruturas', id: any, descricao: string, id_tipo_bulk?: any | null, parentInfra?: { __typename?: 'base_infraestruturas', id: any, descricao: string, id_tipo_bulk?: any | null, parentInfra?: { __typename?: 'base_infraestruturas', id: any, descricao: string, id_tipo_bulk?: any | null, parentInfra?: { __typename?: 'base_infraestruturas', id: any, descricao: string, id_tipo_bulk?: any | null } | null } | null } | null } | null } | null } | null } | null } | null, fontesOrigemPropriedades: Array<{ __typename?: 'variaveis_fontes_origem_propriedades', id: any, fonteOrigem: { __typename?: 'variaveis_fontes_origem', id: any, descricao?: string | null, parametroUnidadeMedida: { __typename?: 'variaveis_parametros_r_unidades_medida', id: any, id_parametro: any, unidadeMedida: { __typename?: 'variaveis_unidades_medida', id: any, descricao?: string | null } }, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, id_tipo: any, dominio?: { __typename?: 'variaveis_dominios', id: any, descricao: string } | null } | null } }> }>, base_infraestruturas_aggregate: { __typename?: 'base_infraestruturas_aggregate', aggregate?: { __typename?: 'base_infraestruturas_aggregate_fields', count: number } | null } };

export type InfrastructureTotalizersTreeQueryVariables = Exact<{
  description: Scalars['String']['input'];
  totalizer: Scalars['String']['input'];
  transactionId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
}>;


export type InfrastructureTotalizersTreeQuery = { __typename?: 'query_root', infrastructure_totalizers_tree: Array<{ __typename?: 'infrastructures_totalizers_tree_model', id: any, id_pai?: any | null, descricao: string, node: any, id_tipo_bulk?: any | null, codigo_manutencao?: string | null, codigo_sig?: string | null }> };

export type TotalizersQueryVariables = Exact<{
  municipalityId: Scalars['bigint']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type TotalizersQuery = { __typename?: 'query_root', navia_dashboards_volumes_diarios_totalizadores: Array<{ __typename?: 'navia_dashboards_volumes_diarios_totalizadores', id: any, id_fonte_origem_propriedade: number, leitura: Navia_Dashboards_Volumes_Diarios_Totalizador_Leituras_Enum, expressao: boolean, fonteOrigemPropriedade?: { __typename?: 'variaveis_fontes_origem_propriedades', id: any, fonteOrigem: { __typename?: 'variaveis_fontes_origem', id: any, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null } | null }, infraestrutura: { __typename?: 'base_infraestruturas', id: any, descricao: string } } | null }> };

export type CaudaisDiariosDataConfigQueryVariables = Exact<{
  municipalityId: Scalars['bigint']['input'];
}>;


export type CaudaisDiariosDataConfigQuery = { __typename?: 'query_root', navia_dashboards_volumes_diarios_dados: Array<{ __typename?: 'navia_dashboards_volumes_diarios_dados', id_municipio: any, local: Navia_Dashboards_Volumes_Diarios_Locais_Enum, caudal: Navia_Dashboards_Volumes_Diarios_Caudais_Enum, registo: Navia_Dashboards_Volumes_Diarios_Registos_Enum, leitura: Navia_Dashboards_Volumes_Diarios_Leituras_Enum, expressao?: string | null }> };

export type DailyFlowIndicatorsQueryVariables = Exact<{
  municipalityId: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type DailyFlowIndicatorsQuery = { __typename?: 'query_root', getDailyFlowIndicators?: { __typename?: 'DailyFlowIndicators', id: string, min: { __typename?: 'DailyFlowIndicator', id: string, value: string, date?: any | null }, max: { __typename?: 'DailyFlowIndicator', id: string, value: string, date?: any | null }, avg: { __typename?: 'DailyFlowIndicator', id: string, value: string }, total: { __typename?: 'DailyFlowIndicator', id: string, value: string } } | null };

export type DailyFlowChartQueryVariables = Exact<{
  municipalityId: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type DailyFlowChartQuery = { __typename?: 'query_root', getDailyFlowChart?: { __typename?: 'DailyFlowChartResponse', id: string, items: Array<{ __typename?: 'DailyFlowChartItem', id: string, place: string, value: number }> } | null };

export type ExportDailyFlowTableQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  municipalityId: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<InputMaybe<DailyFlowReadingsSortInput>> | InputMaybe<DailyFlowReadingsSortInput>>;
}>;


export type ExportDailyFlowTableQuery = { __typename?: 'query_root', exportDailyFlowTable: string };

export type GetDashboardQsRequestsActListQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetDashboardQsRequestsActListQuery = { __typename?: 'query_root', getDashboardQSRequestsActList?: Array<{ __typename?: 'RequestsActAndDangerList', id_frequency_time_notification_response: string, request_address?: string | null, request_infrastructure?: string | null, request_number: string, time_passed_in_seconds: number, symptom: string, time_remaining_in_seconds: number, time_over_in_seconds: number, total_results: number, time_notification_seconds: number, time_limit_response_seconds: number, id_frequency_time_limit_response: number } | null> | null };

export type GetDashboardQsRequestsDangerListQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetDashboardQsRequestsDangerListQuery = { __typename?: 'query_root', getDashboardQSRequestsDangerList?: Array<{ __typename?: 'RequestsActAndDangerList', id_frequency_time_notification_response: string, request_address?: string | null, request_infrastructure?: string | null, request_number: string, time_passed_in_seconds: number, symptom: string, time_remaining_in_seconds: number, time_over_in_seconds: number, total_results: number, time_notification_seconds: number, time_limit_response_seconds: number, id_frequency_time_limit_response: number } | null> | null };

export type GetIntegrationByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetIntegrationByIdQuery = { __typename?: 'query_root', navia_integracoes: Array<{ __typename?: 'navia_integracoes', id: any, activo?: boolean | null, descricao?: string | null }> };

export type RequestsQueryVariables = Exact<{
  startDate: Scalars['timestamp']['input'];
  endDate: Scalars['timestamp']['input'];
}>;


export type RequestsQuery = { __typename?: 'query_root', servicos_requisicoes: Array<{ __typename?: 'servicos_requisicoes', id: any, data_hora: any, numero?: string | null, sintoma?: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null, id_no_tipo?: any | null, parentSymptom?: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null, id_no_tipo?: any | null, parentSymptom?: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null, id_no_tipo?: any | null, parentSymptom?: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null, id_no_tipo?: any | null, parentSymptom?: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null, id_no_tipo?: any | null } | null } | null } | null } | null } | null, estado?: { __typename?: 'servicos_requisicoes_estados', id: any, descricao?: string | null } | null, rastreabilidadeOrigem: Array<{ __typename?: 'servicos_rastreabilidade', id: any, apagado?: boolean | null, id_requisicao_destino?: any | null, id_requisicao_origem?: any | null, id_intervencao_destino?: any | null, id_intervencao_origem?: any | null, intervencaoDestino?: { __typename?: 'servicos_intervencoes', id: any, estado?: { __typename?: 'servicos_intervencoes_estados', id: any, descricao?: string | null } | null } | null }>, locaisInfraestruturas: Array<{ __typename?: 'servicos_requisicoes_locais_infra_estruturas', id: any, infraestrutura?: { __typename?: 'base_infraestruturas', id: any, infraestruturaCoordenadas: Array<{ __typename?: 'base_infraestruturas_coordenadas', id: any, latitude?: any | null, longitude?: any | null }> } | null, toponimia?: { __typename?: 'base_toponimias', id: any, toponimiaCoordenadas: Array<{ __typename?: 'base_toponimias_coordenadas', id: any, latitude?: any | null, longitude?: any | null }> } | null }>, coordenadasMobile: Array<{ __typename?: 'mobile_coordenadas', id: any, latitude: any, longitude: any }> }> };

export type RequestsParameterizationQueryVariables = Exact<{ [key: string]: never; }>;


export type RequestsParameterizationQuery = { __typename?: 'query_root', navia_dashboards_requisicoes_indicadores_parametrizacao: Array<{ __typename?: 'navia_dashboards_requisicoes_indicadores_parametrizacao', id: any, atraso_segundos: any, limite_inferior_segundos: any, limite_superior_segundos: any, variavelMarcacao?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, fonteOrigem: Array<{ __typename?: 'variaveis_fontes_origem', id: any }> } | null }>, navia_dashboards_requisicoes_mapa_parametrizacao: Array<{ __typename?: 'navia_dashboards_requisicoes_mapa_parametrizacao', id: any, descricao: string, cor: { __typename?: 'navia_cores', id: any, cor_modo_claro: string, cor_modo_escuro: string } }>, utilizadores_mapa_posicao_cores: Array<{ __typename?: 'utilizadores_mapa_posicao_cores', id: any, limite_superior?: number | null, cor_modo_claro: string, cor_modo_escuro: string }> };

export type RequestsWithMarkingVariableQueryVariables = Exact<{
  markingVariableId: Scalars['bigint']['input'];
  startDate: Scalars['timestamp']['input'];
  endDate: Scalars['timestamp']['input'];
}>;


export type RequestsWithMarkingVariableQuery = { __typename?: 'query_root', servicos_requisicoes: Array<{ __typename?: 'servicos_requisicoes', id: any, data_hora: any, leituras: Array<{ __typename?: 'variaveis_leituras', id: any, valor_data?: any | null }> }> };

export type MapParameterizationQueryVariables = Exact<{ [key: string]: never; }>;


export type MapParameterizationQuery = { __typename?: 'query_root', integracoes_sig_parametrizacao: Array<{ __typename?: 'integracoes_sig_parametrizacao', latitude?: string | null, longitude?: string | null, zoom_default?: number | null, url_services?: string | null, map_server?: string | null, type?: string | null }>, navia_integracoes_by_pk?: { __typename?: 'navia_integracoes', id: any, descricao?: string | null, activo?: boolean | null } | null, integracoes_sig_proxy: Array<{ __typename?: 'integracoes_sig_proxy', id: any, url: string }>, integracoes_sig_services: Array<{ __typename?: 'integracoes_sig_services', id: any, url?: string | null, title?: string | null, id_type_service?: any | null, visibility_default: boolean, opacity?: any | null }> };

export type MobileCoordinatesQueryVariables = Exact<{
  startDate: Scalars['timestamp']['input'];
  endDate: Scalars['timestamp']['input'];
}>;


export type MobileCoordinatesQuery = { __typename?: 'query_root', mobile_coordenadas: Array<{ __typename?: 'mobile_coordenadas', id: any, key?: string | null, data_hora: any, latitude: any, longitude: any, utilizador?: { __typename?: 'utilizadores_utilizadores', id: any, descricao?: string | null } | null }> };

export type UserAgendaQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['bigint']['input'];
  endDate: Scalars['timestamp']['input'];
  orderBy?: InputMaybe<Array<User_Agenda_Model_Order_By> | User_Agenda_Model_Order_By>;
}>;


export type UserAgendaQuery = { __typename?: 'query_root', user_agenda: Array<{ __typename?: 'user_agenda_model', id?: any | null, numero?: string | null, sintoma?: string | null, data_planeada?: any | null, local?: string | null, tipo?: string | null }> };

export type ColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ColorsQuery = { __typename?: 'query_root', navia_cores: Array<{ __typename?: 'navia_cores', id: any, cor_modo_claro: string, cor_modo_escuro: string }> };

export type LeakMonitoringSymptomsQueryVariables = Exact<{ [key: string]: never; }>;


export type LeakMonitoringSymptomsQuery = { __typename?: 'query_root', navia_dashboards_monitorizacao_roturas_sintomas: Array<{ __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas', id: any, indicador: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum, sintomas: Array<{ __typename?: 'navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas', id: any, sintoma_id: any, sintoma: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null } }> }> };

export type LeakMonitoringCausesQueryVariables = Exact<{ [key: string]: never; }>;


export type LeakMonitoringCausesQuery = { __typename?: 'query_root', navia_dashboards_monitorizacao_roturas_causas: Array<{ __typename?: 'navia_dashboards_monitorizacao_roturas_causas', id: any, categoria: string, cor_id: any, cor: { __typename?: 'navia_cores', id: any, cor_modo_claro: string, cor_modo_escuro: string }, causas: Array<{ __typename?: 'navia_dashboards_monitorizacao_roturas_causas_r_causas', id: any, monitorizacao_roturas_causa_id: any, causa: { __typename?: 'sintomas_causas_trabalhos', id: any, descricao?: string | null } }> }> };

export type LeakMonitoringVariablesQueryVariables = Exact<{ [key: string]: never; }>;


export type LeakMonitoringVariablesQuery = { __typename?: 'query_root', navia_dashboards_monitorizacao_roturas_variaveis: Array<{ __typename?: 'navia_dashboards_monitorizacao_roturas_variaveis', id: any, indicador: Navia_Dashboards_Monitorizacao_Roturas_Indicadores_Enum, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, fonteOrigem: Array<{ __typename?: 'variaveis_fontes_origem', id: any }> } | null, fase?: { __typename?: 'servicos_fases', id: any, descricao?: string | null } | null }> };

export type LeakDiagnosisSymptomsQueryVariables = Exact<{ [key: string]: never; }>;


export type LeakDiagnosisSymptomsQuery = { __typename?: 'query_root', navia_dashboards_diagnostico_roturas_sintomas: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_sintomas', id: any, tipo: Navia_Dashboards_Diagnostico_Roturas_Sintomas_Tipos_Enum, sintoma: { __typename?: 'sintomas_arvore', id: any, descricao?: string | null } }> };

export type LeakDiagnosisInfrastructuresQueryVariables = Exact<{ [key: string]: never; }>;


export type LeakDiagnosisInfrastructuresQuery = { __typename?: 'query_root', navia_dashboards_diagnostico_roturas_tipos_infraestrutura: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura', tipo_infraestrutura_id: any, infraestruturaTipo: { __typename?: 'base_infraestruturas_tipos', id: any, descricao: string, codigo_externo?: string | null, id_sig_service?: any | null } }>, navia_dashboards_diagnostico_roturas_infraestruturas_variaveis: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_infraestruturas_variaveis', id: any, unidade_medida_id?: any | null, variavel?: { __typename?: 'variaveis_base', id: any, descricao?: string | null, parametro?: { __typename?: 'variaveis_parametros', id: any, descricao?: string | null, parametroUnidadesMedida: Array<{ __typename?: 'variaveis_parametros_r_unidades_medida', id: any, fator_multiplicativo_numerico: any, unidadeMedida: { __typename?: 'variaveis_unidades_medida', id: any, descricao?: string | null } }> } | null, fonteOrigem: Array<{ __typename?: 'variaveis_fontes_origem', id: any, descricao?: string | null, apagado?: boolean | null }> } | null }> };

export type LeakDiagnosisMapQueryVariables = Exact<{ [key: string]: never; }>;


export type LeakDiagnosisMapQuery = { __typename?: 'query_root', navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc', tipo_infraestrutura_id: any, infraestruturaTipo: { __typename?: 'base_infraestruturas_tipos', id: any, descricao: string, codigo_externo?: string | null } }>, navia_dashboards_diagnostico_roturas_mapa_niveis: Array<{ __typename?: 'navia_dashboards_diagnostico_roturas_mapa_niveis', id: any, min?: number | null, max?: number | null }> };

export type PipesRehabilitationRateQueryVariables = Exact<{
  endDate: Scalars['Date']['input'];
}>;


export type PipesRehabilitationRateQuery = { __typename?: 'query_root', getPipeRehabilitationRate: Array<{ __typename?: 'PipeRehabilitationRateResponse', avg_length_10y?: number | null, rehab_5y_length_sum?: number | null, pipe_rehabilitation_rate?: number | null }> };

export type AvgPipesAgeQueryVariables = Exact<{
  endDate: Scalars['Date']['input'];
}>;


export type AvgPipesAgeQuery = { __typename?: 'query_root', getPipesAgeAverage: Array<{ __typename?: 'PipeAgeAverageResponse', avg: number }> };

export type PipesNetworkIntegrityQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type PipesNetworkIntegrityQuery = { __typename?: 'query_root', getNetworkIntegrity: Array<{ __typename?: 'NetworkIntegrityResponse', pipes_count: number, interv_count: number, network_integrity: number }> };

export type LeaksPerDistanceQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type LeaksPerDistanceQuery = { __typename?: 'query_root', getLeaksPerDistance: Array<{ __typename?: 'LeaksPerDistanceResponse', interv_count: number, leaks_per_distance?: number | null, length_sum?: number | null, unit?: string | null, multiplier?: number | null }> };

export type PipesFailureRecurrenceRateQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type PipesFailureRecurrenceRateQuery = { __typename?: 'query_root', getFailureRecurrenceRate: Array<{ __typename?: 'FailureRecurrenceRateResponse', pipes_count: number, pipes_with_more_than_1: number, failure_recurrence_rate: number }> };

export type Top5PipesWithMostLeaksQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type Top5PipesWithMostLeaksQuery = { __typename?: 'query_root', getTop5PipesWithMostLeaks: Array<{ __typename?: 'Top5PipesWithMostLeaksResponse', id: string, descricao?: string | null, i_codigo_externo?: string | null, t_codigo_externo?: string | null, sig_atributo_id?: string | null, interv_count: number }> };

export type PipeReadingsByMaterialQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type PipeReadingsByMaterialQuery = { __typename?: 'query_root', getPipeReadingsByMaterial: Array<{ __typename?: 'PipeReadingsByMaterialResponse', id: string, id_fonte_origem: number, valor_texto?: string | null, dominio?: string | null, dominio_valor?: string | null, data_hora: any }> };

export type AgeVsLeakFrequencyQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type AgeVsLeakFrequencyQuery = { __typename?: 'query_root', getAgeVsLeaksFrequency: Array<{ __typename?: 'AgeVsLeaksFrequencyResponse', id: string, interv_count: number, age: number }> };

export type LeakRecurrenceVsRehabilitationQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type LeakRecurrenceVsRehabilitationQuery = { __typename?: 'query_root', getLeakRecurrenceVsRehabilitation: Array<{ __typename?: 'LeakRecurrenceVsRehabilitationResponse', year: number, rehabilitation_interv_count: number, leak_interv_count: number, pipes_with_more_than_1: number, pipes_count: number, failure_recurrence_rate: number }> };

export type ZmcLeaksCountQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
}>;


export type ZmcLeaksCountQuery = { __typename?: 'query_root', getZMCLeaksCount: Array<{ __typename?: 'ZMCLeaksCountResponse', id: string, interv_count: number, codigo_externo?: string | null, sig_atributo_id?: string | null }> };

export type InfrastructureVariablesTreeQueryVariables = Exact<{
  infrastructureSearchText?: InputMaybe<Scalars['String']['input']>;
  variableSearchText?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['Int']['input'];
  typeIds: Scalars['String']['input'];
}>;


export type InfrastructureVariablesTreeQuery = { __typename?: 'query_root', getInfrastructureVariablesTree: Array<{ __typename?: 'InfrastructureVariableTreeResponse', id: number, id_pai?: number | null, descricao: string, node: any, id_tipo_bulk?: number | null, id_tipo_infraestrutura?: number | null, codigo_manutencao?: string | null, codigo_sig?: string | null, nome_completo?: string | null, nome_instalacao?: string | null, ordem?: number | null }> };

export type VariablesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Variaveis_Base_Bool_Exp>;
  orderBy?: InputMaybe<Array<Variaveis_Base_Order_By> | Variaveis_Base_Order_By>;
}>;


export type VariablesQuery = { __typename?: 'query_root', variaveis_base: Array<{ __typename?: 'variaveis_base', id: any, descricao?: string | null, codigo?: string | null, tipo: { __typename?: 'variaveis_tipos', id: any, descricao?: string | null, tipo?: string | null }, dominio?: { __typename?: 'variaveis_dominios', id: any, descricao: string } | null }>, variaveis_base_aggregate: { __typename?: 'variaveis_base_aggregate', aggregate?: { __typename?: 'variaveis_base_aggregate_fields', count: number } | null } };

export type UserThemeSubscriptionVariables = Exact<{
  id?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type UserThemeSubscription = { __typename?: 'subscription_root', utilizadores_utilizadores: Array<{ __typename?: 'utilizadores_utilizadores', id: any, username: string, tema?: { __typename?: 'utilizadores_temas', id: any } | null }> };

export type UserPermissionsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserPermissionsSubscription = { __typename?: 'subscription_root', utilizadores_equipas_virtuais_r_transacoes: Array<{ __typename?: 'utilizadores_equipas_virtuais_r_transacoes', id: any, id_transacao?: any | null, permissoes?: number | null, equipaVirtualUtilizadores?: { __typename?: 'utilizadores_equipas_virtuais_r_utilizadores', id: any, id_utilizador?: any | null } | null }> };

export type UserMessagesSubscriptionVariables = Exact<{
  userId: Scalars['bigint']['input'];
}>;


export type UserMessagesSubscription = { __typename?: 'subscription_root', mensagens_mensagens: Array<{ __typename?: 'mensagens_mensagens', id: any, assunto?: string | null, data?: any | null, id_remetente?: any | null, posts: Array<{ __typename?: 'mensagens_post', id: any, lida?: boolean | null, nova?: boolean | null }>, remetente?: { __typename?: 'utilizadores_utilizadores', id: any, descricao?: string | null } | null }> };

export type GetUserTotalAvailableMessagesSubscriptionVariables = Exact<{
  userId: Scalars['bigint']['input'];
}>;


export type GetUserTotalAvailableMessagesSubscription = { __typename?: 'subscription_root', mensagens_post_aggregate: { __typename?: 'mensagens_post_aggregate', aggregate?: { __typename?: 'mensagens_post_aggregate_fields', count: number } | null } };

export type UserNotificationsSubscriptionVariables = Exact<{
  userId: Scalars['bigint']['input'];
}>;


export type UserNotificationsSubscription = { __typename?: 'subscription_root', notificacoes_notificacoes: Array<{ __typename?: 'notificacoes_notificacoes', id: any, data?: any | null, assunto?: string | null, notificacaoUtilizadores: Array<{ __typename?: 'notificacoes_notificacoes_r_utilizadores', lida?: boolean | null }>, item?: { __typename?: 'notificacoes_itens', descricao?: string | null, tipo?: { __typename?: 'notificacoes_tipos', descricao?: string | null } | null } | null }> };

export type GetUserTotalAvailableNotificationsSubscriptionVariables = Exact<{
  userId: Scalars['bigint']['input'];
}>;


export type GetUserTotalAvailableNotificationsSubscription = { __typename?: 'subscription_root', notificacoes_notificacoes_r_utilizadores_aggregate: { __typename?: 'notificacoes_notificacoes_r_utilizadores_aggregate', aggregate?: { __typename?: 'notificacoes_notificacoes_r_utilizadores_aggregate_fields', count: number } | null } };

export type GetValidatedTvTokenByIdSubscriptionVariables = Exact<{
  id_token?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type GetValidatedTvTokenByIdSubscription = { __typename?: 'subscription_root', navia_dashboards_modo_tv_tokens_validados_by_pk?: { __typename?: 'navia_dashboards_modo_tv_tokens_validados', id_token: any, token_sistema: string, data_hora_expiracao: any } | null };

export type GetRevogatedTvTokenByIdSubscriptionVariables = Exact<{
  id_token?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type GetRevogatedTvTokenByIdSubscription = { __typename?: 'subscription_root', navia_dashboards_modo_tv_tokens_revogacao_manual_by_pk?: { __typename?: 'navia_dashboards_modo_tv_tokens_revogacao_manual', id_token: any } | null };


export const InsertCausaDocument = gql`
    mutation InsertCausa($object: sintomas_causas_trabalhos_insert_input!) {
  insert_sintomas_causas_trabalhos_one(object: $object) {
    id
    codigo
    descricao
    obs
    infraestrutura
  }
}
    `;
export type InsertCausaMutationFn = Apollo.MutationFunction<InsertCausaMutation, InsertCausaMutationVariables>;

/**
 * __useInsertCausaMutation__
 *
 * To run a mutation, you first call `useInsertCausaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCausaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCausaMutation, { data, loading, error }] = useInsertCausaMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertCausaMutation(baseOptions?: Apollo.MutationHookOptions<InsertCausaMutation, InsertCausaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCausaMutation, InsertCausaMutationVariables>(InsertCausaDocument, options);
      }
export type InsertCausaMutationHookResult = ReturnType<typeof useInsertCausaMutation>;
export type InsertCausaMutationResult = Apollo.MutationResult<InsertCausaMutation>;
export type InsertCausaMutationOptions = Apollo.BaseMutationOptions<InsertCausaMutation, InsertCausaMutationVariables>;
export const UpdateCausasDocument = gql`
    mutation UpdateCausas($where: sintomas_causas_trabalhos_bool_exp = {}, $_set: sintomas_causas_trabalhos_set_input = {}) {
  update_sintomas_causas_trabalhos(where: $where, _set: $_set) {
    returning {
      id
      codigo
      descricao
      infraestrutura
      obs
    }
  }
}
    `;
export type UpdateCausasMutationFn = Apollo.MutationFunction<UpdateCausasMutation, UpdateCausasMutationVariables>;

/**
 * __useUpdateCausasMutation__
 *
 * To run a mutation, you first call `useUpdateCausasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCausasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCausasMutation, { data, loading, error }] = useUpdateCausasMutation({
 *   variables: {
 *      where: // value for 'where'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateCausasMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCausasMutation, UpdateCausasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCausasMutation, UpdateCausasMutationVariables>(UpdateCausasDocument, options);
      }
export type UpdateCausasMutationHookResult = ReturnType<typeof useUpdateCausasMutation>;
export type UpdateCausasMutationResult = Apollo.MutationResult<UpdateCausasMutation>;
export type UpdateCausasMutationOptions = Apollo.BaseMutationOptions<UpdateCausasMutation, UpdateCausasMutationVariables>;
export const UpsertSintomaRelationsDocument = gql`
    mutation UpsertSintomaRelations($values: [sintomas_sintomas_relacao_insert_input!]!) {
  insert_sintomas_sintomas_relacao(
    objects: $values
    on_conflict: {constraint: arvore_r_variaveis_pkey, update_columns: [id_sintoma, id_causa_trabalho, apagado]}
  ) {
    returning {
      id
      id_sintoma
      id_fase
      obrigatorio
      id_causa_trabalho
      apagado
    }
  }
}
    `;
export type UpsertSintomaRelationsMutationFn = Apollo.MutationFunction<UpsertSintomaRelationsMutation, UpsertSintomaRelationsMutationVariables>;

/**
 * __useUpsertSintomaRelationsMutation__
 *
 * To run a mutation, you first call `useUpsertSintomaRelationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSintomaRelationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSintomaRelationsMutation, { data, loading, error }] = useUpsertSintomaRelationsMutation({
 *   variables: {
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpsertSintomaRelationsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSintomaRelationsMutation, UpsertSintomaRelationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSintomaRelationsMutation, UpsertSintomaRelationsMutationVariables>(UpsertSintomaRelationsDocument, options);
      }
export type UpsertSintomaRelationsMutationHookResult = ReturnType<typeof useUpsertSintomaRelationsMutation>;
export type UpsertSintomaRelationsMutationResult = Apollo.MutationResult<UpsertSintomaRelationsMutation>;
export type UpsertSintomaRelationsMutationOptions = Apollo.BaseMutationOptions<UpsertSintomaRelationsMutation, UpsertSintomaRelationsMutationVariables>;
export const DeleteSintomaRelationDocument = gql`
    mutation DeleteSintomaRelation($relationshipId: bigint!) {
  update_sintomas_sintomas_relacao_by_pk(
    pk_columns: {id: $relationshipId}
    _set: {apagado: true}
  ) {
    id
    apagado
  }
}
    `;
export type DeleteSintomaRelationMutationFn = Apollo.MutationFunction<DeleteSintomaRelationMutation, DeleteSintomaRelationMutationVariables>;

/**
 * __useDeleteSintomaRelationMutation__
 *
 * To run a mutation, you first call `useDeleteSintomaRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSintomaRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSintomaRelationMutation, { data, loading, error }] = useDeleteSintomaRelationMutation({
 *   variables: {
 *      relationshipId: // value for 'relationshipId'
 *   },
 * });
 */
export function useDeleteSintomaRelationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSintomaRelationMutation, DeleteSintomaRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSintomaRelationMutation, DeleteSintomaRelationMutationVariables>(DeleteSintomaRelationDocument, options);
      }
export type DeleteSintomaRelationMutationHookResult = ReturnType<typeof useDeleteSintomaRelationMutation>;
export type DeleteSintomaRelationMutationResult = Apollo.MutationResult<DeleteSintomaRelationMutation>;
export type DeleteSintomaRelationMutationOptions = Apollo.BaseMutationOptions<DeleteSintomaRelationMutation, DeleteSintomaRelationMutationVariables>;
export const InsertSintomaCausaVariavelRelationshipDocument = gql`
    mutation InsertSintomaCausaVariavelRelationship($objects: [sintomas_sintomas_relacao_insert_input!]!) {
  insert_sintomas_sintomas_relacao(objects: $objects) {
    returning {
      id
      id_sintoma
      id_causa_trabalho
      id_fase
      relacaoOrdem {
        id
        ordem
      }
      id_fonte_origem
      obrigatorio
      fase {
        id
        descricao
      }
      fonteOrigem {
        id
        variavel {
          id
          descricao
          dominio {
            id
            descricao
          }
        }
      }
    }
    affected_rows
  }
}
    `;
export type InsertSintomaCausaVariavelRelationshipMutationFn = Apollo.MutationFunction<InsertSintomaCausaVariavelRelationshipMutation, InsertSintomaCausaVariavelRelationshipMutationVariables>;

/**
 * __useInsertSintomaCausaVariavelRelationshipMutation__
 *
 * To run a mutation, you first call `useInsertSintomaCausaVariavelRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSintomaCausaVariavelRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSintomaCausaVariavelRelationshipMutation, { data, loading, error }] = useInsertSintomaCausaVariavelRelationshipMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertSintomaCausaVariavelRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<InsertSintomaCausaVariavelRelationshipMutation, InsertSintomaCausaVariavelRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSintomaCausaVariavelRelationshipMutation, InsertSintomaCausaVariavelRelationshipMutationVariables>(InsertSintomaCausaVariavelRelationshipDocument, options);
      }
export type InsertSintomaCausaVariavelRelationshipMutationHookResult = ReturnType<typeof useInsertSintomaCausaVariavelRelationshipMutation>;
export type InsertSintomaCausaVariavelRelationshipMutationResult = Apollo.MutationResult<InsertSintomaCausaVariavelRelationshipMutation>;
export type InsertSintomaCausaVariavelRelationshipMutationOptions = Apollo.BaseMutationOptions<InsertSintomaCausaVariavelRelationshipMutation, InsertSintomaCausaVariavelRelationshipMutationVariables>;
export const UpdateSintomaCausaVariavelRelationshipDocument = gql`
    mutation UpdateSintomaCausaVariavelRelationship($where: sintomas_sintomas_relacao_bool_exp = {}, $_set: sintomas_sintomas_relacao_set_input = {}) {
  update_sintomas_sintomas_relacao(where: $where, _set: $_set) {
    returning {
      id
      id_sintoma
      id_causa_trabalho
      id_fase
      relacaoOrdem {
        id
        ordem
      }
      id_fonte_origem
      obrigatorio
      fase {
        id
        descricao
      }
      fonteOrigem {
        id
        variavel {
          id
          descricao
          dominio {
            id
            descricao
          }
        }
      }
    }
    affected_rows
  }
}
    `;
export type UpdateSintomaCausaVariavelRelationshipMutationFn = Apollo.MutationFunction<UpdateSintomaCausaVariavelRelationshipMutation, UpdateSintomaCausaVariavelRelationshipMutationVariables>;

/**
 * __useUpdateSintomaCausaVariavelRelationshipMutation__
 *
 * To run a mutation, you first call `useUpdateSintomaCausaVariavelRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSintomaCausaVariavelRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSintomaCausaVariavelRelationshipMutation, { data, loading, error }] = useUpdateSintomaCausaVariavelRelationshipMutation({
 *   variables: {
 *      where: // value for 'where'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateSintomaCausaVariavelRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSintomaCausaVariavelRelationshipMutation, UpdateSintomaCausaVariavelRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSintomaCausaVariavelRelationshipMutation, UpdateSintomaCausaVariavelRelationshipMutationVariables>(UpdateSintomaCausaVariavelRelationshipDocument, options);
      }
export type UpdateSintomaCausaVariavelRelationshipMutationHookResult = ReturnType<typeof useUpdateSintomaCausaVariavelRelationshipMutation>;
export type UpdateSintomaCausaVariavelRelationshipMutationResult = Apollo.MutationResult<UpdateSintomaCausaVariavelRelationshipMutation>;
export type UpdateSintomaCausaVariavelRelationshipMutationOptions = Apollo.BaseMutationOptions<UpdateSintomaCausaVariavelRelationshipMutation, UpdateSintomaCausaVariavelRelationshipMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: utilizadores_utilizadores_insert_input!) {
  insert_utilizadores_utilizadores_one(object: $input) {
    id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdatePerformanceInfraestruturaParameterDocument = gql`
    mutation UpdatePerformanceInfraestruturaParameter($parameterId: Int!, $_set: navia_dashboards_performance_infraestrutura_parametrizacao_set_input!) {
  update_navia_dashboards_performance_infraestrutura_parametrizacao_by_pk(
    pk_columns: {id: $parameterId}
    _set: $_set
  ) {
    id
    descricao
    unidadeMedida {
      id
      descricao_curta
      parametroUnidadeMedida {
        id
        fator_multiplicativo_numerico
        escalasPrecisao {
          id
          nr_casas_decimais
        }
      }
    }
    variavel {
      id
      descricao
      id_tipo
      fonteOrigem {
        id
      }
      propriedades(where: {id_infraestrutura: {_is_null: true}}) {
        id
        calc_expressao
        calc_nr_casas_decimais
        agregacaoTempo {
          id
          descricao
        }
      }
      parametro {
        id
        parametroUnidadesMedida {
          id
          fator_multiplicativo_numerico
          unidadeMedida {
            id
            descricao_curta
          }
          escalasPrecisao {
            id
            nr_casas_decimais
          }
        }
      }
    }
  }
}
    `;
export type UpdatePerformanceInfraestruturaParameterMutationFn = Apollo.MutationFunction<UpdatePerformanceInfraestruturaParameterMutation, UpdatePerformanceInfraestruturaParameterMutationVariables>;

/**
 * __useUpdatePerformanceInfraestruturaParameterMutation__
 *
 * To run a mutation, you first call `useUpdatePerformanceInfraestruturaParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerformanceInfraestruturaParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerformanceInfraestruturaParameterMutation, { data, loading, error }] = useUpdatePerformanceInfraestruturaParameterMutation({
 *   variables: {
 *      parameterId: // value for 'parameterId'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdatePerformanceInfraestruturaParameterMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePerformanceInfraestruturaParameterMutation, UpdatePerformanceInfraestruturaParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePerformanceInfraestruturaParameterMutation, UpdatePerformanceInfraestruturaParameterMutationVariables>(UpdatePerformanceInfraestruturaParameterDocument, options);
      }
export type UpdatePerformanceInfraestruturaParameterMutationHookResult = ReturnType<typeof useUpdatePerformanceInfraestruturaParameterMutation>;
export type UpdatePerformanceInfraestruturaParameterMutationResult = Apollo.MutationResult<UpdatePerformanceInfraestruturaParameterMutation>;
export type UpdatePerformanceInfraestruturaParameterMutationOptions = Apollo.BaseMutationOptions<UpdatePerformanceInfraestruturaParameterMutation, UpdatePerformanceInfraestruturaParameterMutationVariables>;
export const UpdatePerformanceInfraestruturaParametersDocument = gql`
    mutation UpdatePerformanceInfraestruturaParameters($updates: [navia_dashboards_performance_infraestrutura_parametrizacao_updates!]!) {
  update_navia_dashboards_performance_infraestrutura_parametrizacao_many(
    updates: $updates
  ) {
    returning {
      id
      descricao
      unidadeMedida {
        id
        descricao_curta
        parametroUnidadeMedida {
          id
          fator_multiplicativo_numerico
          escalasPrecisao {
            id
            nr_casas_decimais
          }
        }
      }
      variavel {
        id
        descricao
        fonteOrigem {
          id
        }
        parametro {
          id
          parametroUnidadesMedida {
            id
            fator_multiplicativo_numerico
            unidadeMedida {
              id
              descricao_curta
            }
            escalasPrecisao {
              id
              nr_casas_decimais
            }
          }
        }
      }
    }
  }
}
    `;
export type UpdatePerformanceInfraestruturaParametersMutationFn = Apollo.MutationFunction<UpdatePerformanceInfraestruturaParametersMutation, UpdatePerformanceInfraestruturaParametersMutationVariables>;

/**
 * __useUpdatePerformanceInfraestruturaParametersMutation__
 *
 * To run a mutation, you first call `useUpdatePerformanceInfraestruturaParametersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerformanceInfraestruturaParametersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerformanceInfraestruturaParametersMutation, { data, loading, error }] = useUpdatePerformanceInfraestruturaParametersMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdatePerformanceInfraestruturaParametersMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePerformanceInfraestruturaParametersMutation, UpdatePerformanceInfraestruturaParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePerformanceInfraestruturaParametersMutation, UpdatePerformanceInfraestruturaParametersMutationVariables>(UpdatePerformanceInfraestruturaParametersDocument, options);
      }
export type UpdatePerformanceInfraestruturaParametersMutationHookResult = ReturnType<typeof useUpdatePerformanceInfraestruturaParametersMutation>;
export type UpdatePerformanceInfraestruturaParametersMutationResult = Apollo.MutationResult<UpdatePerformanceInfraestruturaParametersMutation>;
export type UpdatePerformanceInfraestruturaParametersMutationOptions = Apollo.BaseMutationOptions<UpdatePerformanceInfraestruturaParametersMutation, UpdatePerformanceInfraestruturaParametersMutationVariables>;
export const CreateLogDocument = gql`
    mutation CreateLog($logs: [navia_log_insert_input!]!) {
  insert_navia_log(objects: $logs) {
    affected_rows
  }
}
    `;
export type CreateLogMutationFn = Apollo.MutationFunction<CreateLogMutation, CreateLogMutationVariables>;

/**
 * __useCreateLogMutation__
 *
 * To run a mutation, you first call `useCreateLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLogMutation, { data, loading, error }] = useCreateLogMutation({
 *   variables: {
 *      logs: // value for 'logs'
 *   },
 * });
 */
export function useCreateLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateLogMutation, CreateLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLogMutation, CreateLogMutationVariables>(CreateLogDocument, options);
      }
export type CreateLogMutationHookResult = ReturnType<typeof useCreateLogMutation>;
export type CreateLogMutationResult = Apollo.MutationResult<CreateLogMutation>;
export type CreateLogMutationOptions = Apollo.BaseMutationOptions<CreateLogMutation, CreateLogMutationVariables>;
export const UpdatePesquisaAtivaFugasIndicatorsDocument = gql`
    mutation UpdatePesquisaAtivaFugasIndicators($updates: [navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_updates!]!) {
  update_navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao_many(
    updates: $updates
  ) {
    returning {
      id
      descricao
      variavel {
        id
        descricao
        parametro {
          id
          parametroUnidadesMedida {
            id
            principal
            unidadeMedida {
              id
              descricao_curta
            }
            escalasPrecisao {
              id
              nr_casas_decimais
            }
          }
        }
        fonteOrigem {
          id
        }
      }
      unidadeMedida {
        id
        descricao_curta
      }
    }
  }
}
    `;
export type UpdatePesquisaAtivaFugasIndicatorsMutationFn = Apollo.MutationFunction<UpdatePesquisaAtivaFugasIndicatorsMutation, UpdatePesquisaAtivaFugasIndicatorsMutationVariables>;

/**
 * __useUpdatePesquisaAtivaFugasIndicatorsMutation__
 *
 * To run a mutation, you first call `useUpdatePesquisaAtivaFugasIndicatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePesquisaAtivaFugasIndicatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePesquisaAtivaFugasIndicatorsMutation, { data, loading, error }] = useUpdatePesquisaAtivaFugasIndicatorsMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdatePesquisaAtivaFugasIndicatorsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePesquisaAtivaFugasIndicatorsMutation, UpdatePesquisaAtivaFugasIndicatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePesquisaAtivaFugasIndicatorsMutation, UpdatePesquisaAtivaFugasIndicatorsMutationVariables>(UpdatePesquisaAtivaFugasIndicatorsDocument, options);
      }
export type UpdatePesquisaAtivaFugasIndicatorsMutationHookResult = ReturnType<typeof useUpdatePesquisaAtivaFugasIndicatorsMutation>;
export type UpdatePesquisaAtivaFugasIndicatorsMutationResult = Apollo.MutationResult<UpdatePesquisaAtivaFugasIndicatorsMutation>;
export type UpdatePesquisaAtivaFugasIndicatorsMutationOptions = Apollo.BaseMutationOptions<UpdatePesquisaAtivaFugasIndicatorsMutation, UpdatePesquisaAtivaFugasIndicatorsMutationVariables>;
export const UpsertPesquisaAtivaFugasModelosTarefaDocument = gql`
    mutation UpsertPesquisaAtivaFugasModelosTarefa($objects: [navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa_insert_input!]!) {
  insert_navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa(
    objects: $objects
    on_conflict: {constraint: pesquisa_ativa_fugas_mapa_modelos_tarefa_pkey, update_columns: [apagado]}
  ) {
    returning {
      plano_padrao_id
      modeloTarefa {
        id
        descricao
      }
      apagado
    }
    affected_rows
  }
}
    `;
export type UpsertPesquisaAtivaFugasModelosTarefaMutationFn = Apollo.MutationFunction<UpsertPesquisaAtivaFugasModelosTarefaMutation, UpsertPesquisaAtivaFugasModelosTarefaMutationVariables>;

/**
 * __useUpsertPesquisaAtivaFugasModelosTarefaMutation__
 *
 * To run a mutation, you first call `useUpsertPesquisaAtivaFugasModelosTarefaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPesquisaAtivaFugasModelosTarefaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPesquisaAtivaFugasModelosTarefaMutation, { data, loading, error }] = useUpsertPesquisaAtivaFugasModelosTarefaMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertPesquisaAtivaFugasModelosTarefaMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPesquisaAtivaFugasModelosTarefaMutation, UpsertPesquisaAtivaFugasModelosTarefaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPesquisaAtivaFugasModelosTarefaMutation, UpsertPesquisaAtivaFugasModelosTarefaMutationVariables>(UpsertPesquisaAtivaFugasModelosTarefaDocument, options);
      }
export type UpsertPesquisaAtivaFugasModelosTarefaMutationHookResult = ReturnType<typeof useUpsertPesquisaAtivaFugasModelosTarefaMutation>;
export type UpsertPesquisaAtivaFugasModelosTarefaMutationResult = Apollo.MutationResult<UpsertPesquisaAtivaFugasModelosTarefaMutation>;
export type UpsertPesquisaAtivaFugasModelosTarefaMutationOptions = Apollo.BaseMutationOptions<UpsertPesquisaAtivaFugasModelosTarefaMutation, UpsertPesquisaAtivaFugasModelosTarefaMutationVariables>;
export const UpsertPesquisaAtivaFugasMapaSintomasDocument = gql`
    mutation UpsertPesquisaAtivaFugasMapaSintomas($object: navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_insert_input!) {
  insert_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_one(
    object: $object
    on_conflict: {constraint: pesquisa_ativa_fugas_mapa_sintomas_pkey, update_columns: [sintoma_id, fase_id, cor_id, fonte_origem_id]}
  ) {
    id
    fase {
      id
      descricao
    }
    sintoma {
      id
      descricao
    }
    fonteOrigem {
      id
      variavel {
        id
        descricao
      }
    }
    mapaSintomaDominiosValores {
      id
      dominioValor {
        id
        descricao
      }
    }
  }
}
    `;
export type UpsertPesquisaAtivaFugasMapaSintomasMutationFn = Apollo.MutationFunction<UpsertPesquisaAtivaFugasMapaSintomasMutation, UpsertPesquisaAtivaFugasMapaSintomasMutationVariables>;

/**
 * __useUpsertPesquisaAtivaFugasMapaSintomasMutation__
 *
 * To run a mutation, you first call `useUpsertPesquisaAtivaFugasMapaSintomasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPesquisaAtivaFugasMapaSintomasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPesquisaAtivaFugasMapaSintomasMutation, { data, loading, error }] = useUpsertPesquisaAtivaFugasMapaSintomasMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertPesquisaAtivaFugasMapaSintomasMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPesquisaAtivaFugasMapaSintomasMutation, UpsertPesquisaAtivaFugasMapaSintomasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPesquisaAtivaFugasMapaSintomasMutation, UpsertPesquisaAtivaFugasMapaSintomasMutationVariables>(UpsertPesquisaAtivaFugasMapaSintomasDocument, options);
      }
export type UpsertPesquisaAtivaFugasMapaSintomasMutationHookResult = ReturnType<typeof useUpsertPesquisaAtivaFugasMapaSintomasMutation>;
export type UpsertPesquisaAtivaFugasMapaSintomasMutationResult = Apollo.MutationResult<UpsertPesquisaAtivaFugasMapaSintomasMutation>;
export type UpsertPesquisaAtivaFugasMapaSintomasMutationOptions = Apollo.BaseMutationOptions<UpsertPesquisaAtivaFugasMapaSintomasMutation, UpsertPesquisaAtivaFugasMapaSintomasMutationVariables>;
export const DeletePesquisaAtivaFugasMapaSintomaDocument = gql`
    mutation DeletePesquisaAtivaFugasMapaSintoma($id: bigint!) {
  delete_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_by_pk(id: $id) {
    id
  }
}
    `;
export type DeletePesquisaAtivaFugasMapaSintomaMutationFn = Apollo.MutationFunction<DeletePesquisaAtivaFugasMapaSintomaMutation, DeletePesquisaAtivaFugasMapaSintomaMutationVariables>;

/**
 * __useDeletePesquisaAtivaFugasMapaSintomaMutation__
 *
 * To run a mutation, you first call `useDeletePesquisaAtivaFugasMapaSintomaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePesquisaAtivaFugasMapaSintomaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePesquisaAtivaFugasMapaSintomaMutation, { data, loading, error }] = useDeletePesquisaAtivaFugasMapaSintomaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePesquisaAtivaFugasMapaSintomaMutation(baseOptions?: Apollo.MutationHookOptions<DeletePesquisaAtivaFugasMapaSintomaMutation, DeletePesquisaAtivaFugasMapaSintomaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePesquisaAtivaFugasMapaSintomaMutation, DeletePesquisaAtivaFugasMapaSintomaMutationVariables>(DeletePesquisaAtivaFugasMapaSintomaDocument, options);
      }
export type DeletePesquisaAtivaFugasMapaSintomaMutationHookResult = ReturnType<typeof useDeletePesquisaAtivaFugasMapaSintomaMutation>;
export type DeletePesquisaAtivaFugasMapaSintomaMutationResult = Apollo.MutationResult<DeletePesquisaAtivaFugasMapaSintomaMutation>;
export type DeletePesquisaAtivaFugasMapaSintomaMutationOptions = Apollo.BaseMutationOptions<DeletePesquisaAtivaFugasMapaSintomaMutation, DeletePesquisaAtivaFugasMapaSintomaMutationVariables>;
export const DeletePesquisaAtivaFugasMapaSintomaDominioValoresDocument = gql`
    mutation DeletePesquisaAtivaFugasMapaSintomaDominioValores($mapaSintomaId: Int!) {
  delete_navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas_r_dominios_valores(
    where: {mapa_sintoma_id: {_eq: $mapaSintomaId}}
  ) {
    affected_rows
  }
}
    `;
export type DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutationFn = Apollo.MutationFunction<DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation, DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutationVariables>;

/**
 * __useDeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation__
 *
 * To run a mutation, you first call `useDeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePesquisaAtivaFugasMapaSintomaDominioValoresMutation, { data, loading, error }] = useDeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation({
 *   variables: {
 *      mapaSintomaId: // value for 'mapaSintomaId'
 *   },
 * });
 */
export function useDeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation(baseOptions?: Apollo.MutationHookOptions<DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation, DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation, DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutationVariables>(DeletePesquisaAtivaFugasMapaSintomaDominioValoresDocument, options);
      }
export type DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutationHookResult = ReturnType<typeof useDeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation>;
export type DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutationResult = Apollo.MutationResult<DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation>;
export type DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutationOptions = Apollo.BaseMutationOptions<DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutation, DeletePesquisaAtivaFugasMapaSintomaDominioValoresMutationVariables>;
export const DeletePesquisaAtivaFugasMapaTipoInfraestruturaDocument = gql`
    mutation DeletePesquisaAtivaFugasMapaTipoInfraestrutura($where: navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_bool_exp!) {
  delete_navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura(
    where: $where
  ) {
    affected_rows
  }
}
    `;
export type DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutationFn = Apollo.MutationFunction<DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation, DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutationVariables>;

/**
 * __useDeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation__
 *
 * To run a mutation, you first call `useDeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePesquisaAtivaFugasMapaTipoInfraestruturaMutation, { data, loading, error }] = useDeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation(baseOptions?: Apollo.MutationHookOptions<DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation, DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation, DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutationVariables>(DeletePesquisaAtivaFugasMapaTipoInfraestruturaDocument, options);
      }
export type DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutationHookResult = ReturnType<typeof useDeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation>;
export type DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutationResult = Apollo.MutationResult<DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation>;
export type DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutationOptions = Apollo.BaseMutationOptions<DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutation, DeletePesquisaAtivaFugasMapaTipoInfraestruturaMutationVariables>;
export const InsertPesquisaAtivaFugasMapaTipoInfraestruturaDocument = gql`
    mutation InsertPesquisaAtivaFugasMapaTipoInfraestrutura($objects: [navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura_insert_input!]!) {
  insert_navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura(
    objects: $objects
  ) {
    affected_rows
  }
}
    `;
export type InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutationFn = Apollo.MutationFunction<InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation, InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutationVariables>;

/**
 * __useInsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation__
 *
 * To run a mutation, you first call `useInsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPesquisaAtivaFugasMapaTipoInfraestruturaMutation, { data, loading, error }] = useInsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation(baseOptions?: Apollo.MutationHookOptions<InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation, InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation, InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutationVariables>(InsertPesquisaAtivaFugasMapaTipoInfraestruturaDocument, options);
      }
export type InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutationHookResult = ReturnType<typeof useInsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation>;
export type InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutationResult = Apollo.MutationResult<InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation>;
export type InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutationOptions = Apollo.BaseMutationOptions<InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutation, InsertPesquisaAtivaFugasMapaTipoInfraestruturaMutationVariables>;
export const UpdateVisao360IndicatorsDocument = gql`
    mutation UpdateVisao360Indicators($updates: [navia_dashboards_visao_360_parametrizacao_updates!]!) {
  update_navia_dashboards_visao_360_parametrizacao_many(updates: $updates) {
    returning {
      id
      descricao
      selector
      variavel {
        id
        descricao
        parametro {
          id
          parametroUnidadesMedida {
            id
            principal
            unidadeMedida {
              id
              descricao_curta
            }
            escalasPrecisao {
              id
              nr_casas_decimais
            }
          }
        }
        fonteOrigem {
          id
        }
      }
      unidadeMedida {
        id
        descricao_curta
      }
      infraestruturaTipo {
        id
        descricao
      }
    }
  }
}
    `;
export type UpdateVisao360IndicatorsMutationFn = Apollo.MutationFunction<UpdateVisao360IndicatorsMutation, UpdateVisao360IndicatorsMutationVariables>;

/**
 * __useUpdateVisao360IndicatorsMutation__
 *
 * To run a mutation, you first call `useUpdateVisao360IndicatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisao360IndicatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisao360IndicatorsMutation, { data, loading, error }] = useUpdateVisao360IndicatorsMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateVisao360IndicatorsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisao360IndicatorsMutation, UpdateVisao360IndicatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisao360IndicatorsMutation, UpdateVisao360IndicatorsMutationVariables>(UpdateVisao360IndicatorsDocument, options);
      }
export type UpdateVisao360IndicatorsMutationHookResult = ReturnType<typeof useUpdateVisao360IndicatorsMutation>;
export type UpdateVisao360IndicatorsMutationResult = Apollo.MutationResult<UpdateVisao360IndicatorsMutation>;
export type UpdateVisao360IndicatorsMutationOptions = Apollo.BaseMutationOptions<UpdateVisao360IndicatorsMutation, UpdateVisao360IndicatorsMutationVariables>;
export const InsertCaudaisDiariosMunicipalityDocument = gql`
    mutation InsertCaudaisDiariosMunicipality($objects: [navia_dashboards_volumes_diarios_municipios_insert_input!]!) {
  insert_navia_dashboards_volumes_diarios_municipios(objects: $objects) {
    returning {
      id
      descricao
      equipasVirtuaisMunicipio {
        id
        equipaVirtual {
          id
          descricao
        }
      }
      apagado
    }
    affected_rows
  }
}
    `;
export type InsertCaudaisDiariosMunicipalityMutationFn = Apollo.MutationFunction<InsertCaudaisDiariosMunicipalityMutation, InsertCaudaisDiariosMunicipalityMutationVariables>;

/**
 * __useInsertCaudaisDiariosMunicipalityMutation__
 *
 * To run a mutation, you first call `useInsertCaudaisDiariosMunicipalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCaudaisDiariosMunicipalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCaudaisDiariosMunicipalityMutation, { data, loading, error }] = useInsertCaudaisDiariosMunicipalityMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertCaudaisDiariosMunicipalityMutation(baseOptions?: Apollo.MutationHookOptions<InsertCaudaisDiariosMunicipalityMutation, InsertCaudaisDiariosMunicipalityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCaudaisDiariosMunicipalityMutation, InsertCaudaisDiariosMunicipalityMutationVariables>(InsertCaudaisDiariosMunicipalityDocument, options);
      }
export type InsertCaudaisDiariosMunicipalityMutationHookResult = ReturnType<typeof useInsertCaudaisDiariosMunicipalityMutation>;
export type InsertCaudaisDiariosMunicipalityMutationResult = Apollo.MutationResult<InsertCaudaisDiariosMunicipalityMutation>;
export type InsertCaudaisDiariosMunicipalityMutationOptions = Apollo.BaseMutationOptions<InsertCaudaisDiariosMunicipalityMutation, InsertCaudaisDiariosMunicipalityMutationVariables>;
export const UpdateCaudaisDiariosMunicipalityDocument = gql`
    mutation UpdateCaudaisDiariosMunicipality($where: navia_dashboards_volumes_diarios_municipios_bool_exp!, $_set: navia_dashboards_volumes_diarios_municipios_set_input!) {
  update_navia_dashboards_volumes_diarios_municipios(where: $where, _set: $_set) {
    returning {
      id
      descricao
      equipasVirtuaisMunicipio {
        id
        equipaVirtual {
          id
          descricao
        }
      }
      apagado
    }
    affected_rows
  }
}
    `;
export type UpdateCaudaisDiariosMunicipalityMutationFn = Apollo.MutationFunction<UpdateCaudaisDiariosMunicipalityMutation, UpdateCaudaisDiariosMunicipalityMutationVariables>;

/**
 * __useUpdateCaudaisDiariosMunicipalityMutation__
 *
 * To run a mutation, you first call `useUpdateCaudaisDiariosMunicipalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaudaisDiariosMunicipalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaudaisDiariosMunicipalityMutation, { data, loading, error }] = useUpdateCaudaisDiariosMunicipalityMutation({
 *   variables: {
 *      where: // value for 'where'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateCaudaisDiariosMunicipalityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaudaisDiariosMunicipalityMutation, UpdateCaudaisDiariosMunicipalityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaudaisDiariosMunicipalityMutation, UpdateCaudaisDiariosMunicipalityMutationVariables>(UpdateCaudaisDiariosMunicipalityDocument, options);
      }
export type UpdateCaudaisDiariosMunicipalityMutationHookResult = ReturnType<typeof useUpdateCaudaisDiariosMunicipalityMutation>;
export type UpdateCaudaisDiariosMunicipalityMutationResult = Apollo.MutationResult<UpdateCaudaisDiariosMunicipalityMutation>;
export type UpdateCaudaisDiariosMunicipalityMutationOptions = Apollo.BaseMutationOptions<UpdateCaudaisDiariosMunicipalityMutation, UpdateCaudaisDiariosMunicipalityMutationVariables>;
export const InsertVirtualTeamsToCaudaisDiariosMunicipalityDocument = gql`
    mutation InsertVirtualTeamsToCaudaisDiariosMunicipality($objects: [navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_insert_input!]!) {
  insert_navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios(
    objects: $objects
  ) {
    affected_rows
  }
}
    `;
export type InsertVirtualTeamsToCaudaisDiariosMunicipalityMutationFn = Apollo.MutationFunction<InsertVirtualTeamsToCaudaisDiariosMunicipalityMutation, InsertVirtualTeamsToCaudaisDiariosMunicipalityMutationVariables>;

/**
 * __useInsertVirtualTeamsToCaudaisDiariosMunicipalityMutation__
 *
 * To run a mutation, you first call `useInsertVirtualTeamsToCaudaisDiariosMunicipalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertVirtualTeamsToCaudaisDiariosMunicipalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertVirtualTeamsToCaudaisDiariosMunicipalityMutation, { data, loading, error }] = useInsertVirtualTeamsToCaudaisDiariosMunicipalityMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertVirtualTeamsToCaudaisDiariosMunicipalityMutation(baseOptions?: Apollo.MutationHookOptions<InsertVirtualTeamsToCaudaisDiariosMunicipalityMutation, InsertVirtualTeamsToCaudaisDiariosMunicipalityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertVirtualTeamsToCaudaisDiariosMunicipalityMutation, InsertVirtualTeamsToCaudaisDiariosMunicipalityMutationVariables>(InsertVirtualTeamsToCaudaisDiariosMunicipalityDocument, options);
      }
export type InsertVirtualTeamsToCaudaisDiariosMunicipalityMutationHookResult = ReturnType<typeof useInsertVirtualTeamsToCaudaisDiariosMunicipalityMutation>;
export type InsertVirtualTeamsToCaudaisDiariosMunicipalityMutationResult = Apollo.MutationResult<InsertVirtualTeamsToCaudaisDiariosMunicipalityMutation>;
export type InsertVirtualTeamsToCaudaisDiariosMunicipalityMutationOptions = Apollo.BaseMutationOptions<InsertVirtualTeamsToCaudaisDiariosMunicipalityMutation, InsertVirtualTeamsToCaudaisDiariosMunicipalityMutationVariables>;
export const DeleteVirtualTeamsToCaudaisDiariosMunicipalityDocument = gql`
    mutation DeleteVirtualTeamsToCaudaisDiariosMunicipality($where: navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios_bool_exp!) {
  delete_navia_dashboards_volumes_diarios_equipas_virtuais_r_municipios(
    where: $where
  ) {
    affected_rows
  }
}
    `;
export type DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutationFn = Apollo.MutationFunction<DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation, DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutationVariables>;

/**
 * __useDeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation__
 *
 * To run a mutation, you first call `useDeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVirtualTeamsToCaudaisDiariosMunicipalityMutation, { data, loading, error }] = useDeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation, DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation, DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutationVariables>(DeleteVirtualTeamsToCaudaisDiariosMunicipalityDocument, options);
      }
export type DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutationHookResult = ReturnType<typeof useDeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation>;
export type DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutationResult = Apollo.MutationResult<DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation>;
export type DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutationOptions = Apollo.BaseMutationOptions<DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutation, DeleteVirtualTeamsToCaudaisDiariosMunicipalityMutationVariables>;
export const InsertCaudaisDiariosTotalizersDocument = gql`
    mutation InsertCaudaisDiariosTotalizers($objects: [navia_dashboards_volumes_diarios_totalizadores_insert_input!]!) {
  insert_navia_dashboards_volumes_diarios_totalizadores(objects: $objects) {
    returning {
      id
      fonteOrigemPropriedade {
        id
        fonteOrigem {
          id
          variavel {
            id
            descricao
          }
        }
        infraestrutura {
          id
          descricao
        }
      }
      leitura
      expressao
    }
  }
}
    `;
export type InsertCaudaisDiariosTotalizersMutationFn = Apollo.MutationFunction<InsertCaudaisDiariosTotalizersMutation, InsertCaudaisDiariosTotalizersMutationVariables>;

/**
 * __useInsertCaudaisDiariosTotalizersMutation__
 *
 * To run a mutation, you first call `useInsertCaudaisDiariosTotalizersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCaudaisDiariosTotalizersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCaudaisDiariosTotalizersMutation, { data, loading, error }] = useInsertCaudaisDiariosTotalizersMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertCaudaisDiariosTotalizersMutation(baseOptions?: Apollo.MutationHookOptions<InsertCaudaisDiariosTotalizersMutation, InsertCaudaisDiariosTotalizersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCaudaisDiariosTotalizersMutation, InsertCaudaisDiariosTotalizersMutationVariables>(InsertCaudaisDiariosTotalizersDocument, options);
      }
export type InsertCaudaisDiariosTotalizersMutationHookResult = ReturnType<typeof useInsertCaudaisDiariosTotalizersMutation>;
export type InsertCaudaisDiariosTotalizersMutationResult = Apollo.MutationResult<InsertCaudaisDiariosTotalizersMutation>;
export type InsertCaudaisDiariosTotalizersMutationOptions = Apollo.BaseMutationOptions<InsertCaudaisDiariosTotalizersMutation, InsertCaudaisDiariosTotalizersMutationVariables>;
export const UpdateCaudaisDiariosTotalizerByPkDocument = gql`
    mutation UpdateCaudaisDiariosTotalizerByPk($pk_columns: navia_dashboards_volumes_diarios_totalizadores_pk_columns_input!, $_set: navia_dashboards_volumes_diarios_totalizadores_set_input) {
  update_navia_dashboards_volumes_diarios_totalizadores_by_pk(
    pk_columns: $pk_columns
    _set: $_set
  ) {
    id
    fonteOrigemPropriedade {
      id
      fonteOrigem {
        id
        variavel {
          id
          descricao
        }
      }
      infraestrutura {
        id
        descricao
      }
    }
    leitura
    expressao
  }
}
    `;
export type UpdateCaudaisDiariosTotalizerByPkMutationFn = Apollo.MutationFunction<UpdateCaudaisDiariosTotalizerByPkMutation, UpdateCaudaisDiariosTotalizerByPkMutationVariables>;

/**
 * __useUpdateCaudaisDiariosTotalizerByPkMutation__
 *
 * To run a mutation, you first call `useUpdateCaudaisDiariosTotalizerByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaudaisDiariosTotalizerByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaudaisDiariosTotalizerByPkMutation, { data, loading, error }] = useUpdateCaudaisDiariosTotalizerByPkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateCaudaisDiariosTotalizerByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaudaisDiariosTotalizerByPkMutation, UpdateCaudaisDiariosTotalizerByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaudaisDiariosTotalizerByPkMutation, UpdateCaudaisDiariosTotalizerByPkMutationVariables>(UpdateCaudaisDiariosTotalizerByPkDocument, options);
      }
export type UpdateCaudaisDiariosTotalizerByPkMutationHookResult = ReturnType<typeof useUpdateCaudaisDiariosTotalizerByPkMutation>;
export type UpdateCaudaisDiariosTotalizerByPkMutationResult = Apollo.MutationResult<UpdateCaudaisDiariosTotalizerByPkMutation>;
export type UpdateCaudaisDiariosTotalizerByPkMutationOptions = Apollo.BaseMutationOptions<UpdateCaudaisDiariosTotalizerByPkMutation, UpdateCaudaisDiariosTotalizerByPkMutationVariables>;
export const DeleteTotalizerByPkDocument = gql`
    mutation DeleteTotalizerByPk($id: bigint!) {
  delete_navia_dashboards_volumes_diarios_totalizadores_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteTotalizerByPkMutationFn = Apollo.MutationFunction<DeleteTotalizerByPkMutation, DeleteTotalizerByPkMutationVariables>;

/**
 * __useDeleteTotalizerByPkMutation__
 *
 * To run a mutation, you first call `useDeleteTotalizerByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTotalizerByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTotalizerByPkMutation, { data, loading, error }] = useDeleteTotalizerByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTotalizerByPkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTotalizerByPkMutation, DeleteTotalizerByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTotalizerByPkMutation, DeleteTotalizerByPkMutationVariables>(DeleteTotalizerByPkDocument, options);
      }
export type DeleteTotalizerByPkMutationHookResult = ReturnType<typeof useDeleteTotalizerByPkMutation>;
export type DeleteTotalizerByPkMutationResult = Apollo.MutationResult<DeleteTotalizerByPkMutation>;
export type DeleteTotalizerByPkMutationOptions = Apollo.BaseMutationOptions<DeleteTotalizerByPkMutation, DeleteTotalizerByPkMutationVariables>;
export const DeleteTotalizersDocument = gql`
    mutation DeleteTotalizers($where: navia_dashboards_volumes_diarios_totalizadores_bool_exp!) {
  delete_navia_dashboards_volumes_diarios_totalizadores(where: $where) {
    affected_rows
  }
}
    `;
export type DeleteTotalizersMutationFn = Apollo.MutationFunction<DeleteTotalizersMutation, DeleteTotalizersMutationVariables>;

/**
 * __useDeleteTotalizersMutation__
 *
 * To run a mutation, you first call `useDeleteTotalizersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTotalizersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTotalizersMutation, { data, loading, error }] = useDeleteTotalizersMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteTotalizersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTotalizersMutation, DeleteTotalizersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTotalizersMutation, DeleteTotalizersMutationVariables>(DeleteTotalizersDocument, options);
      }
export type DeleteTotalizersMutationHookResult = ReturnType<typeof useDeleteTotalizersMutation>;
export type DeleteTotalizersMutationResult = Apollo.MutationResult<DeleteTotalizersMutation>;
export type DeleteTotalizersMutationOptions = Apollo.BaseMutationOptions<DeleteTotalizersMutation, DeleteTotalizersMutationVariables>;
export const InsertCaudaisDiariosDataConfigDocument = gql`
    mutation InsertCaudaisDiariosDataConfig($objects: [navia_dashboards_volumes_diarios_dados_insert_input!]!) {
  insert_navia_dashboards_volumes_diarios_dados(objects: $objects) {
    returning {
      id_municipio
      caudal
      expressao
      leitura
      local
      registo
    }
  }
}
    `;
export type InsertCaudaisDiariosDataConfigMutationFn = Apollo.MutationFunction<InsertCaudaisDiariosDataConfigMutation, InsertCaudaisDiariosDataConfigMutationVariables>;

/**
 * __useInsertCaudaisDiariosDataConfigMutation__
 *
 * To run a mutation, you first call `useInsertCaudaisDiariosDataConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCaudaisDiariosDataConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCaudaisDiariosDataConfigMutation, { data, loading, error }] = useInsertCaudaisDiariosDataConfigMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertCaudaisDiariosDataConfigMutation(baseOptions?: Apollo.MutationHookOptions<InsertCaudaisDiariosDataConfigMutation, InsertCaudaisDiariosDataConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCaudaisDiariosDataConfigMutation, InsertCaudaisDiariosDataConfigMutationVariables>(InsertCaudaisDiariosDataConfigDocument, options);
      }
export type InsertCaudaisDiariosDataConfigMutationHookResult = ReturnType<typeof useInsertCaudaisDiariosDataConfigMutation>;
export type InsertCaudaisDiariosDataConfigMutationResult = Apollo.MutationResult<InsertCaudaisDiariosDataConfigMutation>;
export type InsertCaudaisDiariosDataConfigMutationOptions = Apollo.BaseMutationOptions<InsertCaudaisDiariosDataConfigMutation, InsertCaudaisDiariosDataConfigMutationVariables>;
export const UpdateCaudaisDiariosDataConfigDocument = gql`
    mutation UpdateCaudaisDiariosDataConfig($where: navia_dashboards_volumes_diarios_dados_bool_exp!, $_set: navia_dashboards_volumes_diarios_dados_set_input) {
  update_navia_dashboards_volumes_diarios_dados(where: $where, _set: $_set) {
    returning {
      id_municipio
      caudal
      expressao
      leitura
      local
      registo
    }
  }
}
    `;
export type UpdateCaudaisDiariosDataConfigMutationFn = Apollo.MutationFunction<UpdateCaudaisDiariosDataConfigMutation, UpdateCaudaisDiariosDataConfigMutationVariables>;

/**
 * __useUpdateCaudaisDiariosDataConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCaudaisDiariosDataConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaudaisDiariosDataConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaudaisDiariosDataConfigMutation, { data, loading, error }] = useUpdateCaudaisDiariosDataConfigMutation({
 *   variables: {
 *      where: // value for 'where'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateCaudaisDiariosDataConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaudaisDiariosDataConfigMutation, UpdateCaudaisDiariosDataConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaudaisDiariosDataConfigMutation, UpdateCaudaisDiariosDataConfigMutationVariables>(UpdateCaudaisDiariosDataConfigDocument, options);
      }
export type UpdateCaudaisDiariosDataConfigMutationHookResult = ReturnType<typeof useUpdateCaudaisDiariosDataConfigMutation>;
export type UpdateCaudaisDiariosDataConfigMutationResult = Apollo.MutationResult<UpdateCaudaisDiariosDataConfigMutation>;
export type UpdateCaudaisDiariosDataConfigMutationOptions = Apollo.BaseMutationOptions<UpdateCaudaisDiariosDataConfigMutation, UpdateCaudaisDiariosDataConfigMutationVariables>;
export const DeleteCaudaisDiariosDataConfigDocument = gql`
    mutation DeleteCaudaisDiariosDataConfig($where: navia_dashboards_volumes_diarios_dados_bool_exp!) {
  delete_navia_dashboards_volumes_diarios_dados(where: $where) {
    affected_rows
  }
}
    `;
export type DeleteCaudaisDiariosDataConfigMutationFn = Apollo.MutationFunction<DeleteCaudaisDiariosDataConfigMutation, DeleteCaudaisDiariosDataConfigMutationVariables>;

/**
 * __useDeleteCaudaisDiariosDataConfigMutation__
 *
 * To run a mutation, you first call `useDeleteCaudaisDiariosDataConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaudaisDiariosDataConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaudaisDiariosDataConfigMutation, { data, loading, error }] = useDeleteCaudaisDiariosDataConfigMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteCaudaisDiariosDataConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaudaisDiariosDataConfigMutation, DeleteCaudaisDiariosDataConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaudaisDiariosDataConfigMutation, DeleteCaudaisDiariosDataConfigMutationVariables>(DeleteCaudaisDiariosDataConfigDocument, options);
      }
export type DeleteCaudaisDiariosDataConfigMutationHookResult = ReturnType<typeof useDeleteCaudaisDiariosDataConfigMutation>;
export type DeleteCaudaisDiariosDataConfigMutationResult = Apollo.MutationResult<DeleteCaudaisDiariosDataConfigMutation>;
export type DeleteCaudaisDiariosDataConfigMutationOptions = Apollo.BaseMutationOptions<DeleteCaudaisDiariosDataConfigMutation, DeleteCaudaisDiariosDataConfigMutationVariables>;
export const UpdateDailyFlowExpressionDocument = gql`
    mutation UpdateDailyFlowExpression($municipalityId: Int!, $expression: String!) {
  saveDailyFlowExpression(
    municipalityId: $municipalityId
    expression: $expression
  ) {
    id
    savedExpression
    valid
  }
}
    `;
export type UpdateDailyFlowExpressionMutationFn = Apollo.MutationFunction<UpdateDailyFlowExpressionMutation, UpdateDailyFlowExpressionMutationVariables>;

/**
 * __useUpdateDailyFlowExpressionMutation__
 *
 * To run a mutation, you first call `useUpdateDailyFlowExpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyFlowExpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyFlowExpressionMutation, { data, loading, error }] = useUpdateDailyFlowExpressionMutation({
 *   variables: {
 *      municipalityId: // value for 'municipalityId'
 *      expression: // value for 'expression'
 *   },
 * });
 */
export function useUpdateDailyFlowExpressionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyFlowExpressionMutation, UpdateDailyFlowExpressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyFlowExpressionMutation, UpdateDailyFlowExpressionMutationVariables>(UpdateDailyFlowExpressionDocument, options);
      }
export type UpdateDailyFlowExpressionMutationHookResult = ReturnType<typeof useUpdateDailyFlowExpressionMutation>;
export type UpdateDailyFlowExpressionMutationResult = Apollo.MutationResult<UpdateDailyFlowExpressionMutation>;
export type UpdateDailyFlowExpressionMutationOptions = Apollo.BaseMutationOptions<UpdateDailyFlowExpressionMutation, UpdateDailyFlowExpressionMutationVariables>;
export const UpdateRequestsMapParamaterizationByPkDocument = gql`
    mutation UpdateRequestsMapParamaterizationByPk($id: bigint!, $_set: navia_dashboards_requisicoes_mapa_parametrizacao_set_input = {}) {
  update_navia_dashboards_requisicoes_mapa_parametrizacao_by_pk(
    pk_columns: {id: $id}
    _set: $_set
  ) {
    id
    descricao
    cor {
      id
      cor_modo_claro
      cor_modo_escuro
    }
  }
}
    `;
export type UpdateRequestsMapParamaterizationByPkMutationFn = Apollo.MutationFunction<UpdateRequestsMapParamaterizationByPkMutation, UpdateRequestsMapParamaterizationByPkMutationVariables>;

/**
 * __useUpdateRequestsMapParamaterizationByPkMutation__
 *
 * To run a mutation, you first call `useUpdateRequestsMapParamaterizationByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequestsMapParamaterizationByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequestsMapParamaterizationByPkMutation, { data, loading, error }] = useUpdateRequestsMapParamaterizationByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateRequestsMapParamaterizationByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRequestsMapParamaterizationByPkMutation, UpdateRequestsMapParamaterizationByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRequestsMapParamaterizationByPkMutation, UpdateRequestsMapParamaterizationByPkMutationVariables>(UpdateRequestsMapParamaterizationByPkDocument, options);
      }
export type UpdateRequestsMapParamaterizationByPkMutationHookResult = ReturnType<typeof useUpdateRequestsMapParamaterizationByPkMutation>;
export type UpdateRequestsMapParamaterizationByPkMutationResult = Apollo.MutationResult<UpdateRequestsMapParamaterizationByPkMutation>;
export type UpdateRequestsMapParamaterizationByPkMutationOptions = Apollo.BaseMutationOptions<UpdateRequestsMapParamaterizationByPkMutation, UpdateRequestsMapParamaterizationByPkMutationVariables>;
export const UpdateRequestIndicatorsParameterizationByPkDocument = gql`
    mutation UpdateRequestIndicatorsParameterizationByPk($id: bigint!, $_set: navia_dashboards_requisicoes_indicadores_parametrizacao_set_input = {}) {
  update_navia_dashboards_requisicoes_indicadores_parametrizacao_by_pk(
    pk_columns: {id: $id}
    _set: $_set
  ) {
    id
    atraso_segundos
    limite_inferior_segundos
    limite_superior_segundos
    variavelMarcacao {
      id
      descricao
      fonteOrigem {
        id
      }
    }
  }
}
    `;
export type UpdateRequestIndicatorsParameterizationByPkMutationFn = Apollo.MutationFunction<UpdateRequestIndicatorsParameterizationByPkMutation, UpdateRequestIndicatorsParameterizationByPkMutationVariables>;

/**
 * __useUpdateRequestIndicatorsParameterizationByPkMutation__
 *
 * To run a mutation, you first call `useUpdateRequestIndicatorsParameterizationByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequestIndicatorsParameterizationByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequestIndicatorsParameterizationByPkMutation, { data, loading, error }] = useUpdateRequestIndicatorsParameterizationByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateRequestIndicatorsParameterizationByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRequestIndicatorsParameterizationByPkMutation, UpdateRequestIndicatorsParameterizationByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRequestIndicatorsParameterizationByPkMutation, UpdateRequestIndicatorsParameterizationByPkMutationVariables>(UpdateRequestIndicatorsParameterizationByPkDocument, options);
      }
export type UpdateRequestIndicatorsParameterizationByPkMutationHookResult = ReturnType<typeof useUpdateRequestIndicatorsParameterizationByPkMutation>;
export type UpdateRequestIndicatorsParameterizationByPkMutationResult = Apollo.MutationResult<UpdateRequestIndicatorsParameterizationByPkMutation>;
export type UpdateRequestIndicatorsParameterizationByPkMutationOptions = Apollo.BaseMutationOptions<UpdateRequestIndicatorsParameterizationByPkMutation, UpdateRequestIndicatorsParameterizationByPkMutationVariables>;
export const DeleteLeakMonitoringSymptomsDocument = gql`
    mutation DeleteLeakMonitoringSymptoms($where: navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_bool_exp!) {
  delete_navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas(where: $where) {
    returning {
      id
      sintoma_id
      monitorizacao_roturas_sintoma_id
      sintoma {
        id
        descricao
      }
    }
  }
}
    `;
export type DeleteLeakMonitoringSymptomsMutationFn = Apollo.MutationFunction<DeleteLeakMonitoringSymptomsMutation, DeleteLeakMonitoringSymptomsMutationVariables>;

/**
 * __useDeleteLeakMonitoringSymptomsMutation__
 *
 * To run a mutation, you first call `useDeleteLeakMonitoringSymptomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeakMonitoringSymptomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeakMonitoringSymptomsMutation, { data, loading, error }] = useDeleteLeakMonitoringSymptomsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteLeakMonitoringSymptomsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeakMonitoringSymptomsMutation, DeleteLeakMonitoringSymptomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeakMonitoringSymptomsMutation, DeleteLeakMonitoringSymptomsMutationVariables>(DeleteLeakMonitoringSymptomsDocument, options);
      }
export type DeleteLeakMonitoringSymptomsMutationHookResult = ReturnType<typeof useDeleteLeakMonitoringSymptomsMutation>;
export type DeleteLeakMonitoringSymptomsMutationResult = Apollo.MutationResult<DeleteLeakMonitoringSymptomsMutation>;
export type DeleteLeakMonitoringSymptomsMutationOptions = Apollo.BaseMutationOptions<DeleteLeakMonitoringSymptomsMutation, DeleteLeakMonitoringSymptomsMutationVariables>;
export const InsertLeakMonitoringSymptomsDocument = gql`
    mutation InsertLeakMonitoringSymptoms($objects: [navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas_insert_input!]!) {
  insert_navia_dashboards_monitorizacao_roturas_sintomas_r_sintomas(
    objects: $objects
  ) {
    returning {
      id
      sintoma_id
      monitorizacao_roturas_sintoma_id
      sintoma {
        id
        descricao
      }
    }
  }
}
    `;
export type InsertLeakMonitoringSymptomsMutationFn = Apollo.MutationFunction<InsertLeakMonitoringSymptomsMutation, InsertLeakMonitoringSymptomsMutationVariables>;

/**
 * __useInsertLeakMonitoringSymptomsMutation__
 *
 * To run a mutation, you first call `useInsertLeakMonitoringSymptomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLeakMonitoringSymptomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLeakMonitoringSymptomsMutation, { data, loading, error }] = useInsertLeakMonitoringSymptomsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertLeakMonitoringSymptomsMutation(baseOptions?: Apollo.MutationHookOptions<InsertLeakMonitoringSymptomsMutation, InsertLeakMonitoringSymptomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertLeakMonitoringSymptomsMutation, InsertLeakMonitoringSymptomsMutationVariables>(InsertLeakMonitoringSymptomsDocument, options);
      }
export type InsertLeakMonitoringSymptomsMutationHookResult = ReturnType<typeof useInsertLeakMonitoringSymptomsMutation>;
export type InsertLeakMonitoringSymptomsMutationResult = Apollo.MutationResult<InsertLeakMonitoringSymptomsMutation>;
export type InsertLeakMonitoringSymptomsMutationOptions = Apollo.BaseMutationOptions<InsertLeakMonitoringSymptomsMutation, InsertLeakMonitoringSymptomsMutationVariables>;
export const UpdateLeakMonitoringCauseDocument = gql`
    mutation UpdateLeakMonitoringCause($where: navia_dashboards_monitorizacao_roturas_causas_bool_exp!, $_set: navia_dashboards_monitorizacao_roturas_causas_set_input) {
  update_navia_dashboards_monitorizacao_roturas_causas(where: $where, _set: $_set) {
    returning {
      id
      categoria
      cor_id
    }
  }
}
    `;
export type UpdateLeakMonitoringCauseMutationFn = Apollo.MutationFunction<UpdateLeakMonitoringCauseMutation, UpdateLeakMonitoringCauseMutationVariables>;

/**
 * __useUpdateLeakMonitoringCauseMutation__
 *
 * To run a mutation, you first call `useUpdateLeakMonitoringCauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeakMonitoringCauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeakMonitoringCauseMutation, { data, loading, error }] = useUpdateLeakMonitoringCauseMutation({
 *   variables: {
 *      where: // value for 'where'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateLeakMonitoringCauseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeakMonitoringCauseMutation, UpdateLeakMonitoringCauseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeakMonitoringCauseMutation, UpdateLeakMonitoringCauseMutationVariables>(UpdateLeakMonitoringCauseDocument, options);
      }
export type UpdateLeakMonitoringCauseMutationHookResult = ReturnType<typeof useUpdateLeakMonitoringCauseMutation>;
export type UpdateLeakMonitoringCauseMutationResult = Apollo.MutationResult<UpdateLeakMonitoringCauseMutation>;
export type UpdateLeakMonitoringCauseMutationOptions = Apollo.BaseMutationOptions<UpdateLeakMonitoringCauseMutation, UpdateLeakMonitoringCauseMutationVariables>;
export const DeleteLeakMonitoringCausesDocument = gql`
    mutation DeleteLeakMonitoringCauses($where: navia_dashboards_monitorizacao_roturas_causas_r_causas_bool_exp!) {
  delete_navia_dashboards_monitorizacao_roturas_causas_r_causas(where: $where) {
    returning {
      id
      monitorizacao_roturas_causa_id
      causa {
        id
        descricao
      }
    }
  }
}
    `;
export type DeleteLeakMonitoringCausesMutationFn = Apollo.MutationFunction<DeleteLeakMonitoringCausesMutation, DeleteLeakMonitoringCausesMutationVariables>;

/**
 * __useDeleteLeakMonitoringCausesMutation__
 *
 * To run a mutation, you first call `useDeleteLeakMonitoringCausesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeakMonitoringCausesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeakMonitoringCausesMutation, { data, loading, error }] = useDeleteLeakMonitoringCausesMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteLeakMonitoringCausesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeakMonitoringCausesMutation, DeleteLeakMonitoringCausesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeakMonitoringCausesMutation, DeleteLeakMonitoringCausesMutationVariables>(DeleteLeakMonitoringCausesDocument, options);
      }
export type DeleteLeakMonitoringCausesMutationHookResult = ReturnType<typeof useDeleteLeakMonitoringCausesMutation>;
export type DeleteLeakMonitoringCausesMutationResult = Apollo.MutationResult<DeleteLeakMonitoringCausesMutation>;
export type DeleteLeakMonitoringCausesMutationOptions = Apollo.BaseMutationOptions<DeleteLeakMonitoringCausesMutation, DeleteLeakMonitoringCausesMutationVariables>;
export const InsertLeakMonitoringCausesDocument = gql`
    mutation InsertLeakMonitoringCauses($objects: [navia_dashboards_monitorizacao_roturas_causas_r_causas_insert_input!]!) {
  insert_navia_dashboards_monitorizacao_roturas_causas_r_causas(objects: $objects) {
    returning {
      id
      monitorizacao_roturas_causa_id
      causa {
        id
        descricao
      }
    }
  }
}
    `;
export type InsertLeakMonitoringCausesMutationFn = Apollo.MutationFunction<InsertLeakMonitoringCausesMutation, InsertLeakMonitoringCausesMutationVariables>;

/**
 * __useInsertLeakMonitoringCausesMutation__
 *
 * To run a mutation, you first call `useInsertLeakMonitoringCausesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLeakMonitoringCausesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLeakMonitoringCausesMutation, { data, loading, error }] = useInsertLeakMonitoringCausesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertLeakMonitoringCausesMutation(baseOptions?: Apollo.MutationHookOptions<InsertLeakMonitoringCausesMutation, InsertLeakMonitoringCausesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertLeakMonitoringCausesMutation, InsertLeakMonitoringCausesMutationVariables>(InsertLeakMonitoringCausesDocument, options);
      }
export type InsertLeakMonitoringCausesMutationHookResult = ReturnType<typeof useInsertLeakMonitoringCausesMutation>;
export type InsertLeakMonitoringCausesMutationResult = Apollo.MutationResult<InsertLeakMonitoringCausesMutation>;
export type InsertLeakMonitoringCausesMutationOptions = Apollo.BaseMutationOptions<InsertLeakMonitoringCausesMutation, InsertLeakMonitoringCausesMutationVariables>;
export const UpdateLeakMonitoringVariablesDocument = gql`
    mutation UpdateLeakMonitoringVariables($where: navia_dashboards_monitorizacao_roturas_variaveis_bool_exp!, $_set: navia_dashboards_monitorizacao_roturas_variaveis_set_input) {
  update_navia_dashboards_monitorizacao_roturas_variaveis(
    where: $where
    _set: $_set
  ) {
    returning {
      id
      indicador
      variavel {
        id
        descricao
      }
      fase {
        id
        descricao
      }
    }
  }
}
    `;
export type UpdateLeakMonitoringVariablesMutationFn = Apollo.MutationFunction<UpdateLeakMonitoringVariablesMutation, UpdateLeakMonitoringVariablesMutationVariables>;

/**
 * __useUpdateLeakMonitoringVariablesMutation__
 *
 * To run a mutation, you first call `useUpdateLeakMonitoringVariablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeakMonitoringVariablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeakMonitoringVariablesMutation, { data, loading, error }] = useUpdateLeakMonitoringVariablesMutation({
 *   variables: {
 *      where: // value for 'where'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateLeakMonitoringVariablesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeakMonitoringVariablesMutation, UpdateLeakMonitoringVariablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeakMonitoringVariablesMutation, UpdateLeakMonitoringVariablesMutationVariables>(UpdateLeakMonitoringVariablesDocument, options);
      }
export type UpdateLeakMonitoringVariablesMutationHookResult = ReturnType<typeof useUpdateLeakMonitoringVariablesMutation>;
export type UpdateLeakMonitoringVariablesMutationResult = Apollo.MutationResult<UpdateLeakMonitoringVariablesMutation>;
export type UpdateLeakMonitoringVariablesMutationOptions = Apollo.BaseMutationOptions<UpdateLeakMonitoringVariablesMutation, UpdateLeakMonitoringVariablesMutationVariables>;
export const DeleteLeakDiagnosisSymptomsDocument = gql`
    mutation DeleteLeakDiagnosisSymptoms($where: navia_dashboards_diagnostico_roturas_sintomas_bool_exp!) {
  delete_navia_dashboards_diagnostico_roturas_sintomas(where: $where) {
    returning {
      id
      sintoma {
        id
        descricao
      }
    }
  }
}
    `;
export type DeleteLeakDiagnosisSymptomsMutationFn = Apollo.MutationFunction<DeleteLeakDiagnosisSymptomsMutation, DeleteLeakDiagnosisSymptomsMutationVariables>;

/**
 * __useDeleteLeakDiagnosisSymptomsMutation__
 *
 * To run a mutation, you first call `useDeleteLeakDiagnosisSymptomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeakDiagnosisSymptomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeakDiagnosisSymptomsMutation, { data, loading, error }] = useDeleteLeakDiagnosisSymptomsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteLeakDiagnosisSymptomsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeakDiagnosisSymptomsMutation, DeleteLeakDiagnosisSymptomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeakDiagnosisSymptomsMutation, DeleteLeakDiagnosisSymptomsMutationVariables>(DeleteLeakDiagnosisSymptomsDocument, options);
      }
export type DeleteLeakDiagnosisSymptomsMutationHookResult = ReturnType<typeof useDeleteLeakDiagnosisSymptomsMutation>;
export type DeleteLeakDiagnosisSymptomsMutationResult = Apollo.MutationResult<DeleteLeakDiagnosisSymptomsMutation>;
export type DeleteLeakDiagnosisSymptomsMutationOptions = Apollo.BaseMutationOptions<DeleteLeakDiagnosisSymptomsMutation, DeleteLeakDiagnosisSymptomsMutationVariables>;
export const InsertLeakDiagnosisSymptomsDocument = gql`
    mutation InsertLeakDiagnosisSymptoms($objects: [navia_dashboards_diagnostico_roturas_sintomas_insert_input!]!) {
  insert_navia_dashboards_diagnostico_roturas_sintomas(objects: $objects) {
    returning {
      id
      sintoma {
        id
        descricao
      }
    }
  }
}
    `;
export type InsertLeakDiagnosisSymptomsMutationFn = Apollo.MutationFunction<InsertLeakDiagnosisSymptomsMutation, InsertLeakDiagnosisSymptomsMutationVariables>;

/**
 * __useInsertLeakDiagnosisSymptomsMutation__
 *
 * To run a mutation, you first call `useInsertLeakDiagnosisSymptomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLeakDiagnosisSymptomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLeakDiagnosisSymptomsMutation, { data, loading, error }] = useInsertLeakDiagnosisSymptomsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertLeakDiagnosisSymptomsMutation(baseOptions?: Apollo.MutationHookOptions<InsertLeakDiagnosisSymptomsMutation, InsertLeakDiagnosisSymptomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertLeakDiagnosisSymptomsMutation, InsertLeakDiagnosisSymptomsMutationVariables>(InsertLeakDiagnosisSymptomsDocument, options);
      }
export type InsertLeakDiagnosisSymptomsMutationHookResult = ReturnType<typeof useInsertLeakDiagnosisSymptomsMutation>;
export type InsertLeakDiagnosisSymptomsMutationResult = Apollo.MutationResult<InsertLeakDiagnosisSymptomsMutation>;
export type InsertLeakDiagnosisSymptomsMutationOptions = Apollo.BaseMutationOptions<InsertLeakDiagnosisSymptomsMutation, InsertLeakDiagnosisSymptomsMutationVariables>;
export const DeleteLeakDiagnosisInfrastructureTypesDocument = gql`
    mutation DeleteLeakDiagnosisInfrastructureTypes($where: navia_dashboards_diagnostico_roturas_tipos_infraestrutura_bool_exp!) {
  delete_navia_dashboards_diagnostico_roturas_tipos_infraestrutura(where: $where) {
    returning {
      tipo_infraestrutura_id
    }
  }
}
    `;
export type DeleteLeakDiagnosisInfrastructureTypesMutationFn = Apollo.MutationFunction<DeleteLeakDiagnosisInfrastructureTypesMutation, DeleteLeakDiagnosisInfrastructureTypesMutationVariables>;

/**
 * __useDeleteLeakDiagnosisInfrastructureTypesMutation__
 *
 * To run a mutation, you first call `useDeleteLeakDiagnosisInfrastructureTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeakDiagnosisInfrastructureTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeakDiagnosisInfrastructureTypesMutation, { data, loading, error }] = useDeleteLeakDiagnosisInfrastructureTypesMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteLeakDiagnosisInfrastructureTypesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeakDiagnosisInfrastructureTypesMutation, DeleteLeakDiagnosisInfrastructureTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeakDiagnosisInfrastructureTypesMutation, DeleteLeakDiagnosisInfrastructureTypesMutationVariables>(DeleteLeakDiagnosisInfrastructureTypesDocument, options);
      }
export type DeleteLeakDiagnosisInfrastructureTypesMutationHookResult = ReturnType<typeof useDeleteLeakDiagnosisInfrastructureTypesMutation>;
export type DeleteLeakDiagnosisInfrastructureTypesMutationResult = Apollo.MutationResult<DeleteLeakDiagnosisInfrastructureTypesMutation>;
export type DeleteLeakDiagnosisInfrastructureTypesMutationOptions = Apollo.BaseMutationOptions<DeleteLeakDiagnosisInfrastructureTypesMutation, DeleteLeakDiagnosisInfrastructureTypesMutationVariables>;
export const InsertLeakDiagnosisInfrastructureTypesDocument = gql`
    mutation InsertLeakDiagnosisInfrastructureTypes($objects: [navia_dashboards_diagnostico_roturas_tipos_infraestrutura_insert_input!]!) {
  insert_navia_dashboards_diagnostico_roturas_tipos_infraestrutura(
    objects: $objects
  ) {
    returning {
      tipo_infraestrutura_id
    }
  }
}
    `;
export type InsertLeakDiagnosisInfrastructureTypesMutationFn = Apollo.MutationFunction<InsertLeakDiagnosisInfrastructureTypesMutation, InsertLeakDiagnosisInfrastructureTypesMutationVariables>;

/**
 * __useInsertLeakDiagnosisInfrastructureTypesMutation__
 *
 * To run a mutation, you first call `useInsertLeakDiagnosisInfrastructureTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLeakDiagnosisInfrastructureTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLeakDiagnosisInfrastructureTypesMutation, { data, loading, error }] = useInsertLeakDiagnosisInfrastructureTypesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertLeakDiagnosisInfrastructureTypesMutation(baseOptions?: Apollo.MutationHookOptions<InsertLeakDiagnosisInfrastructureTypesMutation, InsertLeakDiagnosisInfrastructureTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertLeakDiagnosisInfrastructureTypesMutation, InsertLeakDiagnosisInfrastructureTypesMutationVariables>(InsertLeakDiagnosisInfrastructureTypesDocument, options);
      }
export type InsertLeakDiagnosisInfrastructureTypesMutationHookResult = ReturnType<typeof useInsertLeakDiagnosisInfrastructureTypesMutation>;
export type InsertLeakDiagnosisInfrastructureTypesMutationResult = Apollo.MutationResult<InsertLeakDiagnosisInfrastructureTypesMutation>;
export type InsertLeakDiagnosisInfrastructureTypesMutationOptions = Apollo.BaseMutationOptions<InsertLeakDiagnosisInfrastructureTypesMutation, InsertLeakDiagnosisInfrastructureTypesMutationVariables>;
export const UpdateLeakDiagnosisInfrastructureVariablesDocument = gql`
    mutation UpdateLeakDiagnosisInfrastructureVariables($where: navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_bool_exp!, $_set: navia_dashboards_diagnostico_roturas_infraestruturas_variaveis_set_input) {
  update_navia_dashboards_diagnostico_roturas_infraestruturas_variaveis(
    where: $where
    _set: $_set
  ) {
    returning {
      id
      unidadeMedida {
        id
        descricao_curta
      }
    }
  }
}
    `;
export type UpdateLeakDiagnosisInfrastructureVariablesMutationFn = Apollo.MutationFunction<UpdateLeakDiagnosisInfrastructureVariablesMutation, UpdateLeakDiagnosisInfrastructureVariablesMutationVariables>;

/**
 * __useUpdateLeakDiagnosisInfrastructureVariablesMutation__
 *
 * To run a mutation, you first call `useUpdateLeakDiagnosisInfrastructureVariablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeakDiagnosisInfrastructureVariablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeakDiagnosisInfrastructureVariablesMutation, { data, loading, error }] = useUpdateLeakDiagnosisInfrastructureVariablesMutation({
 *   variables: {
 *      where: // value for 'where'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateLeakDiagnosisInfrastructureVariablesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeakDiagnosisInfrastructureVariablesMutation, UpdateLeakDiagnosisInfrastructureVariablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeakDiagnosisInfrastructureVariablesMutation, UpdateLeakDiagnosisInfrastructureVariablesMutationVariables>(UpdateLeakDiagnosisInfrastructureVariablesDocument, options);
      }
export type UpdateLeakDiagnosisInfrastructureVariablesMutationHookResult = ReturnType<typeof useUpdateLeakDiagnosisInfrastructureVariablesMutation>;
export type UpdateLeakDiagnosisInfrastructureVariablesMutationResult = Apollo.MutationResult<UpdateLeakDiagnosisInfrastructureVariablesMutation>;
export type UpdateLeakDiagnosisInfrastructureVariablesMutationOptions = Apollo.BaseMutationOptions<UpdateLeakDiagnosisInfrastructureVariablesMutation, UpdateLeakDiagnosisInfrastructureVariablesMutationVariables>;
export const DeleteLeakDiagnosisMapZmcDocument = gql`
    mutation DeleteLeakDiagnosisMapZMC($where: navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_bool_exp!) {
  delete_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc(
    where: $where
  ) {
    returning {
      tipo_infraestrutura_id
    }
  }
}
    `;
export type DeleteLeakDiagnosisMapZmcMutationFn = Apollo.MutationFunction<DeleteLeakDiagnosisMapZmcMutation, DeleteLeakDiagnosisMapZmcMutationVariables>;

/**
 * __useDeleteLeakDiagnosisMapZmcMutation__
 *
 * To run a mutation, you first call `useDeleteLeakDiagnosisMapZmcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLeakDiagnosisMapZmcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLeakDiagnosisMapZmcMutation, { data, loading, error }] = useDeleteLeakDiagnosisMapZmcMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteLeakDiagnosisMapZmcMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLeakDiagnosisMapZmcMutation, DeleteLeakDiagnosisMapZmcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLeakDiagnosisMapZmcMutation, DeleteLeakDiagnosisMapZmcMutationVariables>(DeleteLeakDiagnosisMapZmcDocument, options);
      }
export type DeleteLeakDiagnosisMapZmcMutationHookResult = ReturnType<typeof useDeleteLeakDiagnosisMapZmcMutation>;
export type DeleteLeakDiagnosisMapZmcMutationResult = Apollo.MutationResult<DeleteLeakDiagnosisMapZmcMutation>;
export type DeleteLeakDiagnosisMapZmcMutationOptions = Apollo.BaseMutationOptions<DeleteLeakDiagnosisMapZmcMutation, DeleteLeakDiagnosisMapZmcMutationVariables>;
export const InsertLeakDiagnosisMapZmcDocument = gql`
    mutation InsertLeakDiagnosisMapZMC($objects: [navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc_insert_input!]!) {
  insert_navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc(
    objects: $objects
  ) {
    returning {
      tipo_infraestrutura_id
    }
  }
}
    `;
export type InsertLeakDiagnosisMapZmcMutationFn = Apollo.MutationFunction<InsertLeakDiagnosisMapZmcMutation, InsertLeakDiagnosisMapZmcMutationVariables>;

/**
 * __useInsertLeakDiagnosisMapZmcMutation__
 *
 * To run a mutation, you first call `useInsertLeakDiagnosisMapZmcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLeakDiagnosisMapZmcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLeakDiagnosisMapZmcMutation, { data, loading, error }] = useInsertLeakDiagnosisMapZmcMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertLeakDiagnosisMapZmcMutation(baseOptions?: Apollo.MutationHookOptions<InsertLeakDiagnosisMapZmcMutation, InsertLeakDiagnosisMapZmcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertLeakDiagnosisMapZmcMutation, InsertLeakDiagnosisMapZmcMutationVariables>(InsertLeakDiagnosisMapZmcDocument, options);
      }
export type InsertLeakDiagnosisMapZmcMutationHookResult = ReturnType<typeof useInsertLeakDiagnosisMapZmcMutation>;
export type InsertLeakDiagnosisMapZmcMutationResult = Apollo.MutationResult<InsertLeakDiagnosisMapZmcMutation>;
export type InsertLeakDiagnosisMapZmcMutationOptions = Apollo.BaseMutationOptions<InsertLeakDiagnosisMapZmcMutation, InsertLeakDiagnosisMapZmcMutationVariables>;
export const UpdateLeakDiagnosisMapLevelsDocument = gql`
    mutation UpdateLeakDiagnosisMapLevels($updates: [navia_dashboards_diagnostico_roturas_mapa_niveis_updates!]!) {
  update_navia_dashboards_diagnostico_roturas_mapa_niveis_many(updates: $updates) {
    returning {
      id
      min
      max
    }
  }
}
    `;
export type UpdateLeakDiagnosisMapLevelsMutationFn = Apollo.MutationFunction<UpdateLeakDiagnosisMapLevelsMutation, UpdateLeakDiagnosisMapLevelsMutationVariables>;

/**
 * __useUpdateLeakDiagnosisMapLevelsMutation__
 *
 * To run a mutation, you first call `useUpdateLeakDiagnosisMapLevelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeakDiagnosisMapLevelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeakDiagnosisMapLevelsMutation, { data, loading, error }] = useUpdateLeakDiagnosisMapLevelsMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateLeakDiagnosisMapLevelsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeakDiagnosisMapLevelsMutation, UpdateLeakDiagnosisMapLevelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeakDiagnosisMapLevelsMutation, UpdateLeakDiagnosisMapLevelsMutationVariables>(UpdateLeakDiagnosisMapLevelsDocument, options);
      }
export type UpdateLeakDiagnosisMapLevelsMutationHookResult = ReturnType<typeof useUpdateLeakDiagnosisMapLevelsMutation>;
export type UpdateLeakDiagnosisMapLevelsMutationResult = Apollo.MutationResult<UpdateLeakDiagnosisMapLevelsMutation>;
export type UpdateLeakDiagnosisMapLevelsMutationOptions = Apollo.BaseMutationOptions<UpdateLeakDiagnosisMapLevelsMutation, UpdateLeakDiagnosisMapLevelsMutationVariables>;
export const UsersDocument = gql`
    query Users($id: bigint) {
  utilizadores_utilizadores(where: {id: {_eq: $id}}) {
    id
    username
    tema {
      id
    }
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($search: String, $limit: Int, $offset: Int) {
  utilizadores_utilizadores(
    where: {_and: {apagado: {_eq: false}}, _or: {descricao: {_ilike: $search}, username: {_ilike: $search}}}
    offset: $offset
    limit: $limit
    order_by: {descricao: asc}
  ) {
    activo
    email
    id
    username
    descricao
    codigo_externo
  }
  utilizadores_utilizadores_aggregate(
    where: {_and: {apagado: {_eq: false}}, _or: {descricao: {_ilike: $search}, username: {_ilike: $search}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const TransactionsDocument = gql`
    query Transactions {
  permissoes_transacoes {
    id
    id_modulo
    mascara
    descricao
  }
}
    `;

/**
 * __useTransactionsQuery__
 *
 * To run a query within a React component, call `useTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
      }
export function useTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export function useTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export type TransactionsQueryHookResult = ReturnType<typeof useTransactionsQuery>;
export type TransactionsLazyQueryHookResult = ReturnType<typeof useTransactionsLazyQuery>;
export type TransactionsSuspenseQueryHookResult = ReturnType<typeof useTransactionsSuspenseQuery>;
export type TransactionsQueryResult = Apollo.QueryResult<TransactionsQuery, TransactionsQueryVariables>;
export const TransactionsByIdDocument = gql`
    query TransactionsById($transactionId: bigint!) {
  permissoes_transacoes_by_pk(id: $transactionId) {
    id
    id_modulo
    descricao
    mascara
  }
}
    `;

/**
 * __useTransactionsByIdQuery__
 *
 * To run a query within a React component, call `useTransactionsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsByIdQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useTransactionsByIdQuery(baseOptions: Apollo.QueryHookOptions<TransactionsByIdQuery, TransactionsByIdQueryVariables> & ({ variables: TransactionsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsByIdQuery, TransactionsByIdQueryVariables>(TransactionsByIdDocument, options);
      }
export function useTransactionsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsByIdQuery, TransactionsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsByIdQuery, TransactionsByIdQueryVariables>(TransactionsByIdDocument, options);
        }
export function useTransactionsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsByIdQuery, TransactionsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionsByIdQuery, TransactionsByIdQueryVariables>(TransactionsByIdDocument, options);
        }
export type TransactionsByIdQueryHookResult = ReturnType<typeof useTransactionsByIdQuery>;
export type TransactionsByIdLazyQueryHookResult = ReturnType<typeof useTransactionsByIdLazyQuery>;
export type TransactionsByIdSuspenseQueryHookResult = ReturnType<typeof useTransactionsByIdSuspenseQuery>;
export type TransactionsByIdQueryResult = Apollo.QueryResult<TransactionsByIdQuery, TransactionsByIdQueryVariables>;
export const MenuDocument = gql`
    query Menu {
  menuLicenca {
    id
    UtilizadoresMenu {
      id
      id_pai
      has_childs
      url
      ordem
      texto
      new_ui
      translation_key
    }
  }
}
    `;

/**
 * __useMenuQuery__
 *
 * To run a query within a React component, call `useMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useMenuQuery(baseOptions?: Apollo.QueryHookOptions<MenuQuery, MenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuQuery, MenuQueryVariables>(MenuDocument, options);
      }
export function useMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuQuery, MenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuQuery, MenuQueryVariables>(MenuDocument, options);
        }
export function useMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuQuery, MenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MenuQuery, MenuQueryVariables>(MenuDocument, options);
        }
export type MenuQueryHookResult = ReturnType<typeof useMenuQuery>;
export type MenuLazyQueryHookResult = ReturnType<typeof useMenuLazyQuery>;
export type MenuSuspenseQueryHookResult = ReturnType<typeof useMenuSuspenseQuery>;
export type MenuQueryResult = Apollo.QueryResult<MenuQuery, MenuQueryVariables>;
export const LanguagesDocument = gql`
    query languages {
  getLanguages {
    available_languages
    default_language
  }
}
    `;

/**
 * __useLanguagesQuery__
 *
 * To run a query within a React component, call `useLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
      }
export function useLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
        }
export function useLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
        }
export type LanguagesQueryHookResult = ReturnType<typeof useLanguagesQuery>;
export type LanguagesLazyQueryHookResult = ReturnType<typeof useLanguagesLazyQuery>;
export type LanguagesSuspenseQueryHookResult = ReturnType<typeof useLanguagesSuspenseQuery>;
export type LanguagesQueryResult = Apollo.QueryResult<LanguagesQuery, LanguagesQueryVariables>;
export const CausasDocument = gql`
    query Causas($where: sintomas_causas_trabalhos_bool_exp, $orderBy: [sintomas_causas_trabalhos_order_by!], $limit: Int, $offset: Int) {
  sintomas_causas_trabalhos(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $orderBy
  ) {
    id
    codigo
    descricao
    obs
    causa
    infraestrutura
    causa
    codigo_externo
  }
  sintomas_causas_trabalhos_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useCausasQuery__
 *
 * To run a query within a React component, call `useCausasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCausasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCausasQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useCausasQuery(baseOptions?: Apollo.QueryHookOptions<CausasQuery, CausasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CausasQuery, CausasQueryVariables>(CausasDocument, options);
      }
export function useCausasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CausasQuery, CausasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CausasQuery, CausasQueryVariables>(CausasDocument, options);
        }
export function useCausasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CausasQuery, CausasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CausasQuery, CausasQueryVariables>(CausasDocument, options);
        }
export type CausasQueryHookResult = ReturnType<typeof useCausasQuery>;
export type CausasLazyQueryHookResult = ReturnType<typeof useCausasLazyQuery>;
export type CausasSuspenseQueryHookResult = ReturnType<typeof useCausasSuspenseQuery>;
export type CausasQueryResult = Apollo.QueryResult<CausasQuery, CausasQueryVariables>;
export const InfraestruturasDocument = gql`
    query Infraestruturas($limit: Int, $offset: Int, $where: base_infraestruturas_bool_exp, $orderBy: [base_infraestruturas_order_by!], $whereActiveChilds: base_infraestruturas_bool_exp) {
  base_infraestruturas(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $orderBy
  ) {
    id
    descricao
    id_tipo_bulk
    id_tipo_infraestrutura
    codigo_manutencao
    codigo_sig
    nome_instalacao
    nome_completo
    tipo {
      id
      descricao_curta
    }
    infraestruturaToponimia {
      id
      toponimia {
        id
        nome_medio
      }
    }
    activeChilds(where: $whereActiveChilds) {
      id
      descricao
      apagado
      id_tipo_bulk
      id_tipo_infraestrutura
      codigo_manutencao
      codigo_sig
      nome_instalacao
      tipo {
        id
        descricao_curta
      }
    }
    infraestruturaToponimia {
      id
      toponimia {
        id
        nome_medio
      }
    }
  }
  base_infraestruturas_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useInfraestruturasQuery__
 *
 * To run a query within a React component, call `useInfraestruturasQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfraestruturasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfraestruturasQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      whereActiveChilds: // value for 'whereActiveChilds'
 *   },
 * });
 */
export function useInfraestruturasQuery(baseOptions?: Apollo.QueryHookOptions<InfraestruturasQuery, InfraestruturasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfraestruturasQuery, InfraestruturasQueryVariables>(InfraestruturasDocument, options);
      }
export function useInfraestruturasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfraestruturasQuery, InfraestruturasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfraestruturasQuery, InfraestruturasQueryVariables>(InfraestruturasDocument, options);
        }
export function useInfraestruturasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfraestruturasQuery, InfraestruturasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfraestruturasQuery, InfraestruturasQueryVariables>(InfraestruturasDocument, options);
        }
export type InfraestruturasQueryHookResult = ReturnType<typeof useInfraestruturasQuery>;
export type InfraestruturasLazyQueryHookResult = ReturnType<typeof useInfraestruturasLazyQuery>;
export type InfraestruturasSuspenseQueryHookResult = ReturnType<typeof useInfraestruturasSuspenseQuery>;
export type InfraestruturasQueryResult = Apollo.QueryResult<InfraestruturasQuery, InfraestruturasQueryVariables>;
export const BulkTiposDocument = gql`
    query BulkTipos($where: base_bulk_tipos_bool_exp, $order_by: [base_bulk_tipos_order_by!]) {
  base_bulk_tipos(where: $where, order_by: $order_by) {
    id
    descricao
  }
}
    `;

/**
 * __useBulkTiposQuery__
 *
 * To run a query within a React component, call `useBulkTiposQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkTiposQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkTiposQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useBulkTiposQuery(baseOptions?: Apollo.QueryHookOptions<BulkTiposQuery, BulkTiposQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkTiposQuery, BulkTiposQueryVariables>(BulkTiposDocument, options);
      }
export function useBulkTiposLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkTiposQuery, BulkTiposQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkTiposQuery, BulkTiposQueryVariables>(BulkTiposDocument, options);
        }
export function useBulkTiposSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkTiposQuery, BulkTiposQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkTiposQuery, BulkTiposQueryVariables>(BulkTiposDocument, options);
        }
export type BulkTiposQueryHookResult = ReturnType<typeof useBulkTiposQuery>;
export type BulkTiposLazyQueryHookResult = ReturnType<typeof useBulkTiposLazyQuery>;
export type BulkTiposSuspenseQueryHookResult = ReturnType<typeof useBulkTiposSuspenseQuery>;
export type BulkTiposQueryResult = Apollo.QueryResult<BulkTiposQuery, BulkTiposQueryVariables>;
export const InfraestruturasTiposDocument = gql`
    query InfraestruturasTipos($where: base_infraestruturas_tipos_bool_exp, $orderBy: [base_infraestruturas_tipos_order_by!]) {
  base_infraestruturas_tipos(where: $where, order_by: $orderBy) {
    id
    descricao
    nome_completo
    id_pai
    id_no_tipo
    apagado
    activeChilds {
      id
      descricao
      nome_completo
      id_pai
      id_no_tipo
      apagado
    }
    infraestruturas_aggregate(where: {apagado: {_eq: false}}) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useInfraestruturasTiposQuery__
 *
 * To run a query within a React component, call `useInfraestruturasTiposQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfraestruturasTiposQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfraestruturasTiposQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useInfraestruturasTiposQuery(baseOptions?: Apollo.QueryHookOptions<InfraestruturasTiposQuery, InfraestruturasTiposQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfraestruturasTiposQuery, InfraestruturasTiposQueryVariables>(InfraestruturasTiposDocument, options);
      }
export function useInfraestruturasTiposLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfraestruturasTiposQuery, InfraestruturasTiposQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfraestruturasTiposQuery, InfraestruturasTiposQueryVariables>(InfraestruturasTiposDocument, options);
        }
export function useInfraestruturasTiposSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfraestruturasTiposQuery, InfraestruturasTiposQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfraestruturasTiposQuery, InfraestruturasTiposQueryVariables>(InfraestruturasTiposDocument, options);
        }
export type InfraestruturasTiposQueryHookResult = ReturnType<typeof useInfraestruturasTiposQuery>;
export type InfraestruturasTiposLazyQueryHookResult = ReturnType<typeof useInfraestruturasTiposLazyQuery>;
export type InfraestruturasTiposSuspenseQueryHookResult = ReturnType<typeof useInfraestruturasTiposSuspenseQuery>;
export type InfraestruturasTiposQueryResult = Apollo.QueryResult<InfraestruturasTiposQuery, InfraestruturasTiposQueryVariables>;
export const InterventionsDocument = gql`
    query Interventions($where: servicos_intervencoes_bool_exp, $orderBy: [servicos_intervencoes_order_by!], $limit: Int, $offset: Int) {
  servicos_intervencoes(
    where: $where
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    id
    data_planeada
    executada_data_hora
    numero
    estado {
      id
      descricao
      cor
    }
    sintoma {
      id
      descricao
    }
    coordenadasMobile {
      id
      latitude
      longitude
    }
    toponimia {
      id
      descricao_curta
      nome_medio
      toponimiaCoordenadas(where: {principal: {_eq: true}}) {
        id
        latitude
        longitude
      }
    }
    infraestrutura {
      id
      descricao
      tipo {
        id
        descricao
      }
      infraestruturaCoordenadas(where: {principal: {_eq: true}}) {
        id
        latitude
        longitude
      }
    }
    intervencaoUtilizador {
      id
      utilizador {
        id
        descricao
      }
    }
    leituras {
      id
      id_fonte_origem
      id_fase
      valor_numerico
    }
    causas {
      id
      causa {
        id
        descricao
      }
    }
    intervalos(where: {apagado: {_eq: false}}) {
      id
      data_inicio
      data_fim
    }
  }
  servicos_intervencoes_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useInterventionsQuery__
 *
 * To run a query within a React component, call `useInterventionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterventionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterventionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useInterventionsQuery(baseOptions?: Apollo.QueryHookOptions<InterventionsQuery, InterventionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterventionsQuery, InterventionsQueryVariables>(InterventionsDocument, options);
      }
export function useInterventionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterventionsQuery, InterventionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterventionsQuery, InterventionsQueryVariables>(InterventionsDocument, options);
        }
export function useInterventionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterventionsQuery, InterventionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterventionsQuery, InterventionsQueryVariables>(InterventionsDocument, options);
        }
export type InterventionsQueryHookResult = ReturnType<typeof useInterventionsQuery>;
export type InterventionsLazyQueryHookResult = ReturnType<typeof useInterventionsLazyQuery>;
export type InterventionsSuspenseQueryHookResult = ReturnType<typeof useInterventionsSuspenseQuery>;
export type InterventionsQueryResult = Apollo.QueryResult<InterventionsQuery, InterventionsQueryVariables>;
export const SintomasDocument = gql`
    query Sintomas($where: sintomas_arvore_bool_exp, $orderBy: [sintomas_arvore_order_by!], $limit: Int, $offset: Int) {
  sintomas_arvore(
    where: $where
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    id
    id_no_tipo
    descricao
    id_pai
    activeChilds {
      id
    }
  }
}
    `;

/**
 * __useSintomasQuery__
 *
 * To run a query within a React component, call `useSintomasQuery` and pass it any options that fit your needs.
 * When your component renders, `useSintomasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSintomasQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSintomasQuery(baseOptions?: Apollo.QueryHookOptions<SintomasQuery, SintomasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SintomasQuery, SintomasQueryVariables>(SintomasDocument, options);
      }
export function useSintomasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SintomasQuery, SintomasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SintomasQuery, SintomasQueryVariables>(SintomasDocument, options);
        }
export function useSintomasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SintomasQuery, SintomasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SintomasQuery, SintomasQueryVariables>(SintomasDocument, options);
        }
export type SintomasQueryHookResult = ReturnType<typeof useSintomasQuery>;
export type SintomasLazyQueryHookResult = ReturnType<typeof useSintomasLazyQuery>;
export type SintomasSuspenseQueryHookResult = ReturnType<typeof useSintomasSuspenseQuery>;
export type SintomasQueryResult = Apollo.QueryResult<SintomasQuery, SintomasQueryVariables>;
export const SintomaByIdDocument = gql`
    query SintomaById($id: bigint!) {
  sintomas_arvore_by_pk(id: $id) {
    id
    descricao
    nome_completo
    causaRelacoes(
      where: {causaTrabalho: {causa: {_eq: true}}, apagado: {_eq: false}, id_fonte_origem: {_is_null: true}}
      order_by: {causaTrabalho: {descricao: asc}}
    ) {
      id
      id_sintoma
      id_fase
      obrigatorio
      apagado
      id_fonte_origem
      id_causa_trabalho
      causaTrabalho {
        id
        obs
        descricao
        causa
      }
    }
  }
}
    `;

/**
 * __useSintomaByIdQuery__
 *
 * To run a query within a React component, call `useSintomaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSintomaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSintomaByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSintomaByIdQuery(baseOptions: Apollo.QueryHookOptions<SintomaByIdQuery, SintomaByIdQueryVariables> & ({ variables: SintomaByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SintomaByIdQuery, SintomaByIdQueryVariables>(SintomaByIdDocument, options);
      }
export function useSintomaByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SintomaByIdQuery, SintomaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SintomaByIdQuery, SintomaByIdQueryVariables>(SintomaByIdDocument, options);
        }
export function useSintomaByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SintomaByIdQuery, SintomaByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SintomaByIdQuery, SintomaByIdQueryVariables>(SintomaByIdDocument, options);
        }
export type SintomaByIdQueryHookResult = ReturnType<typeof useSintomaByIdQuery>;
export type SintomaByIdLazyQueryHookResult = ReturnType<typeof useSintomaByIdLazyQuery>;
export type SintomaByIdSuspenseQueryHookResult = ReturnType<typeof useSintomaByIdSuspenseQuery>;
export type SintomaByIdQueryResult = Apollo.QueryResult<SintomaByIdQuery, SintomaByIdQueryVariables>;
export const SintomaCausaRelationDocument = gql`
    query SintomaCausaRelation($where: sintomas_sintomas_relacao_bool_exp = {}, $orderBy: [sintomas_sintomas_relacao_order_by!]) {
  sintomas_sintomas_relacao(where: $where, order_by: $orderBy) {
    id
    id_sintoma
    id_causa_trabalho
    id_fase
    relacaoOrdem {
      id
      ordem
    }
    id_fonte_origem
    obrigatorio
    fase {
      id
      descricao
    }
    fonteOrigem {
      id
      variavel {
        id
        descricao
        dominio {
          id
          descricao
        }
      }
    }
  }
}
    `;

/**
 * __useSintomaCausaRelationQuery__
 *
 * To run a query within a React component, call `useSintomaCausaRelationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSintomaCausaRelationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSintomaCausaRelationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSintomaCausaRelationQuery(baseOptions?: Apollo.QueryHookOptions<SintomaCausaRelationQuery, SintomaCausaRelationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SintomaCausaRelationQuery, SintomaCausaRelationQueryVariables>(SintomaCausaRelationDocument, options);
      }
export function useSintomaCausaRelationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SintomaCausaRelationQuery, SintomaCausaRelationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SintomaCausaRelationQuery, SintomaCausaRelationQueryVariables>(SintomaCausaRelationDocument, options);
        }
export function useSintomaCausaRelationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SintomaCausaRelationQuery, SintomaCausaRelationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SintomaCausaRelationQuery, SintomaCausaRelationQueryVariables>(SintomaCausaRelationDocument, options);
        }
export type SintomaCausaRelationQueryHookResult = ReturnType<typeof useSintomaCausaRelationQuery>;
export type SintomaCausaRelationLazyQueryHookResult = ReturnType<typeof useSintomaCausaRelationLazyQuery>;
export type SintomaCausaRelationSuspenseQueryHookResult = ReturnType<typeof useSintomaCausaRelationSuspenseQuery>;
export type SintomaCausaRelationQueryResult = Apollo.QueryResult<SintomaCausaRelationQuery, SintomaCausaRelationQueryVariables>;
export const ParametrizacoesDocument = gql`
    query Parametrizacoes {
  base_parametrizacoes {
    id
    descricao
    valor
  }
}
    `;

/**
 * __useParametrizacoesQuery__
 *
 * To run a query within a React component, call `useParametrizacoesQuery` and pass it any options that fit your needs.
 * When your component renders, `useParametrizacoesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParametrizacoesQuery({
 *   variables: {
 *   },
 * });
 */
export function useParametrizacoesQuery(baseOptions?: Apollo.QueryHookOptions<ParametrizacoesQuery, ParametrizacoesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParametrizacoesQuery, ParametrizacoesQueryVariables>(ParametrizacoesDocument, options);
      }
export function useParametrizacoesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParametrizacoesQuery, ParametrizacoesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParametrizacoesQuery, ParametrizacoesQueryVariables>(ParametrizacoesDocument, options);
        }
export function useParametrizacoesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ParametrizacoesQuery, ParametrizacoesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParametrizacoesQuery, ParametrizacoesQueryVariables>(ParametrizacoesDocument, options);
        }
export type ParametrizacoesQueryHookResult = ReturnType<typeof useParametrizacoesQuery>;
export type ParametrizacoesLazyQueryHookResult = ReturnType<typeof useParametrizacoesLazyQuery>;
export type ParametrizacoesSuspenseQueryHookResult = ReturnType<typeof useParametrizacoesSuspenseQuery>;
export type ParametrizacoesQueryResult = Apollo.QueryResult<ParametrizacoesQuery, ParametrizacoesQueryVariables>;
export const FontesOrigemVariablesDocument = gql`
    query FontesOrigemVariables($limit: Int, $offset: Int, $where: variaveis_fontes_origem_bool_exp, $orderBy: [variaveis_fontes_origem_order_by!]) {
  variaveis_fontes_origem(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $orderBy
  ) {
    id
    descricao
    variavel {
      id
      codigo
      descricao
      tipo {
        id
        tipo
        descricao
      }
      dominio {
        id
        descricao
      }
      parametro {
        id
        parametroUnidadesMedida(where: {apagado: {_eq: false}}) {
          id
          principal
          fator_multiplicativo_numerico
          unidadeMedida {
            id
            descricao_curta
          }
        }
      }
    }
    parametroUnidadeMedida {
      id
      unidadeMedida {
        id
        descricao
      }
    }
  }
  variaveis_fontes_origem_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useFontesOrigemVariablesQuery__
 *
 * To run a query within a React component, call `useFontesOrigemVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFontesOrigemVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFontesOrigemVariablesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFontesOrigemVariablesQuery(baseOptions?: Apollo.QueryHookOptions<FontesOrigemVariablesQuery, FontesOrigemVariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FontesOrigemVariablesQuery, FontesOrigemVariablesQueryVariables>(FontesOrigemVariablesDocument, options);
      }
export function useFontesOrigemVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FontesOrigemVariablesQuery, FontesOrigemVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FontesOrigemVariablesQuery, FontesOrigemVariablesQueryVariables>(FontesOrigemVariablesDocument, options);
        }
export function useFontesOrigemVariablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FontesOrigemVariablesQuery, FontesOrigemVariablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FontesOrigemVariablesQuery, FontesOrigemVariablesQueryVariables>(FontesOrigemVariablesDocument, options);
        }
export type FontesOrigemVariablesQueryHookResult = ReturnType<typeof useFontesOrigemVariablesQuery>;
export type FontesOrigemVariablesLazyQueryHookResult = ReturnType<typeof useFontesOrigemVariablesLazyQuery>;
export type FontesOrigemVariablesSuspenseQueryHookResult = ReturnType<typeof useFontesOrigemVariablesSuspenseQuery>;
export type FontesOrigemVariablesQueryResult = Apollo.QueryResult<FontesOrigemVariablesQuery, FontesOrigemVariablesQueryVariables>;
export const VariableCategoriesDocument = gql`
    query VariableCategories {
  variaveis_base_categorias(where: {apagado: {_eq: false}}, order_by: {id: asc}) {
    id
    descricao
  }
}
    `;

/**
 * __useVariableCategoriesQuery__
 *
 * To run a query within a React component, call `useVariableCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVariableCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVariableCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVariableCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<VariableCategoriesQuery, VariableCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VariableCategoriesQuery, VariableCategoriesQueryVariables>(VariableCategoriesDocument, options);
      }
export function useVariableCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VariableCategoriesQuery, VariableCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VariableCategoriesQuery, VariableCategoriesQueryVariables>(VariableCategoriesDocument, options);
        }
export function useVariableCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VariableCategoriesQuery, VariableCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VariableCategoriesQuery, VariableCategoriesQueryVariables>(VariableCategoriesDocument, options);
        }
export type VariableCategoriesQueryHookResult = ReturnType<typeof useVariableCategoriesQuery>;
export type VariableCategoriesLazyQueryHookResult = ReturnType<typeof useVariableCategoriesLazyQuery>;
export type VariableCategoriesSuspenseQueryHookResult = ReturnType<typeof useVariableCategoriesSuspenseQuery>;
export type VariableCategoriesQueryResult = Apollo.QueryResult<VariableCategoriesQuery, VariableCategoriesQueryVariables>;
export const GetUtilizadorCategoriasDocument = gql`
    query GetUtilizadorCategorias {
  utilizadores_categorias(where: {apagado: {_eq: false}}) {
    id
    descricao
  }
}
    `;

/**
 * __useGetUtilizadorCategoriasQuery__
 *
 * To run a query within a React component, call `useGetUtilizadorCategoriasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUtilizadorCategoriasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUtilizadorCategoriasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUtilizadorCategoriasQuery(baseOptions?: Apollo.QueryHookOptions<GetUtilizadorCategoriasQuery, GetUtilizadorCategoriasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUtilizadorCategoriasQuery, GetUtilizadorCategoriasQueryVariables>(GetUtilizadorCategoriasDocument, options);
      }
export function useGetUtilizadorCategoriasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUtilizadorCategoriasQuery, GetUtilizadorCategoriasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUtilizadorCategoriasQuery, GetUtilizadorCategoriasQueryVariables>(GetUtilizadorCategoriasDocument, options);
        }
export function useGetUtilizadorCategoriasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUtilizadorCategoriasQuery, GetUtilizadorCategoriasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUtilizadorCategoriasQuery, GetUtilizadorCategoriasQueryVariables>(GetUtilizadorCategoriasDocument, options);
        }
export type GetUtilizadorCategoriasQueryHookResult = ReturnType<typeof useGetUtilizadorCategoriasQuery>;
export type GetUtilizadorCategoriasLazyQueryHookResult = ReturnType<typeof useGetUtilizadorCategoriasLazyQuery>;
export type GetUtilizadorCategoriasSuspenseQueryHookResult = ReturnType<typeof useGetUtilizadorCategoriasSuspenseQuery>;
export type GetUtilizadorCategoriasQueryResult = Apollo.QueryResult<GetUtilizadorCategoriasQuery, GetUtilizadorCategoriasQueryVariables>;
export const PerformanceInfraestruturaParametersDocument = gql`
    query PerformanceInfraestruturaParameters {
  navia_dashboards_performance_infraestrutura_parametrizacao(order_by: {id: asc}) {
    id
    descricao
    unidadeMedida {
      id
      descricao_curta
      parametroUnidadeMedida {
        id
        fator_multiplicativo_numerico
        escalasPrecisao {
          id
          nr_casas_decimais
        }
      }
    }
    variavel {
      id
      descricao
      fonteOrigem {
        id
      }
      parametro {
        id
        parametroUnidadesMedida {
          id
          fator_multiplicativo_numerico
          unidadeMedida {
            id
            descricao_curta
          }
          escalasPrecisao {
            id
            nr_casas_decimais
          }
        }
      }
      propriedades(where: {id_infraestrutura: {_is_null: true}}) {
        id
        calc_expressao
        calc_nr_casas_decimais
        agregacaoTempo {
          id
          descricao
        }
      }
    }
  }
}
    `;

/**
 * __usePerformanceInfraestruturaParametersQuery__
 *
 * To run a query within a React component, call `usePerformanceInfraestruturaParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceInfraestruturaParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceInfraestruturaParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePerformanceInfraestruturaParametersQuery(baseOptions?: Apollo.QueryHookOptions<PerformanceInfraestruturaParametersQuery, PerformanceInfraestruturaParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceInfraestruturaParametersQuery, PerformanceInfraestruturaParametersQueryVariables>(PerformanceInfraestruturaParametersDocument, options);
      }
export function usePerformanceInfraestruturaParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceInfraestruturaParametersQuery, PerformanceInfraestruturaParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceInfraestruturaParametersQuery, PerformanceInfraestruturaParametersQueryVariables>(PerformanceInfraestruturaParametersDocument, options);
        }
export function usePerformanceInfraestruturaParametersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceInfraestruturaParametersQuery, PerformanceInfraestruturaParametersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceInfraestruturaParametersQuery, PerformanceInfraestruturaParametersQueryVariables>(PerformanceInfraestruturaParametersDocument, options);
        }
export type PerformanceInfraestruturaParametersQueryHookResult = ReturnType<typeof usePerformanceInfraestruturaParametersQuery>;
export type PerformanceInfraestruturaParametersLazyQueryHookResult = ReturnType<typeof usePerformanceInfraestruturaParametersLazyQuery>;
export type PerformanceInfraestruturaParametersSuspenseQueryHookResult = ReturnType<typeof usePerformanceInfraestruturaParametersSuspenseQuery>;
export type PerformanceInfraestruturaParametersQueryResult = Apollo.QueryResult<PerformanceInfraestruturaParametersQuery, PerformanceInfraestruturaParametersQueryVariables>;
export const PerformanceInfraestruturaDashboardDocument = gql`
    query PerformanceInfraestruturaDashboard($variablesWhereClause: variaveis_base_bool_exp = {}, $homologousWhereClause: variaveis_valores_mensais_bool_exp = {}, $pastMonthWhereClause: variaveis_valores_mensais_bool_exp = {}, $evolutionWhereClause: variaveis_valores_mensais_bool_exp = {}) {
  variaveis_base(where: $variablesWhereClause) {
    id
    descricao
    id_tipo
    propriedades(where: {id_infraestrutura: {_is_null: true}}) {
      id
      calc_expressao
      calc_nr_casas_decimais
      agregacaoTempo {
        id
        descricao
      }
    }
    variaveisCalculo {
      id
      str_variavel
      id_fonte_origem
      fonteOrigem {
        id
        variavel {
          id
          descricao
          evolution: valoresMensais(
            order_by: {id: desc, mes: asc}
            where: $evolutionWhereClause
          ) {
            id
            mes
            ano
            valor_calculado
            id_variavel_base
          }
        }
      }
    }
    homologous: valoresMensais(where: $homologousWhereClause, order_by: {id: desc}) {
      id
      valor_calculado
      mes
      ano
      id_variavel_base
    }
    pastMonth: valoresMensais(where: $pastMonthWhereClause, order_by: {id: desc}) {
      id
      valor_calculado
      mes
      ano
      id_variavel_base
    }
    evolution: valoresMensais(
      order_by: {id: desc, mes: asc}
      where: $evolutionWhereClause
    ) {
      id
      mes
      ano
      valor_calculado
      id_variavel_base
    }
  }
}
    `;

/**
 * __usePerformanceInfraestruturaDashboardQuery__
 *
 * To run a query within a React component, call `usePerformanceInfraestruturaDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceInfraestruturaDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceInfraestruturaDashboardQuery({
 *   variables: {
 *      variablesWhereClause: // value for 'variablesWhereClause'
 *      homologousWhereClause: // value for 'homologousWhereClause'
 *      pastMonthWhereClause: // value for 'pastMonthWhereClause'
 *      evolutionWhereClause: // value for 'evolutionWhereClause'
 *   },
 * });
 */
export function usePerformanceInfraestruturaDashboardQuery(baseOptions?: Apollo.QueryHookOptions<PerformanceInfraestruturaDashboardQuery, PerformanceInfraestruturaDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceInfraestruturaDashboardQuery, PerformanceInfraestruturaDashboardQueryVariables>(PerformanceInfraestruturaDashboardDocument, options);
      }
export function usePerformanceInfraestruturaDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceInfraestruturaDashboardQuery, PerformanceInfraestruturaDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceInfraestruturaDashboardQuery, PerformanceInfraestruturaDashboardQueryVariables>(PerformanceInfraestruturaDashboardDocument, options);
        }
export function usePerformanceInfraestruturaDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceInfraestruturaDashboardQuery, PerformanceInfraestruturaDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceInfraestruturaDashboardQuery, PerformanceInfraestruturaDashboardQueryVariables>(PerformanceInfraestruturaDashboardDocument, options);
        }
export type PerformanceInfraestruturaDashboardQueryHookResult = ReturnType<typeof usePerformanceInfraestruturaDashboardQuery>;
export type PerformanceInfraestruturaDashboardLazyQueryHookResult = ReturnType<typeof usePerformanceInfraestruturaDashboardLazyQuery>;
export type PerformanceInfraestruturaDashboardSuspenseQueryHookResult = ReturnType<typeof usePerformanceInfraestruturaDashboardSuspenseQuery>;
export type PerformanceInfraestruturaDashboardQueryResult = Apollo.QueryResult<PerformanceInfraestruturaDashboardQuery, PerformanceInfraestruturaDashboardQueryVariables>;
export const PesquisaAtivaFugasParametrizacaoDocument = gql`
    query PesquisaAtivaFugasParametrizacao {
  navia_integracoes_by_pk(id: 7) {
    id
    descricao
    activo
  }
  integracoes_sig_maps_ortos {
    id
    name
    json
    url
  }
  navia_dashboards_pesquisa_ativa_fugas_indicadores_parametrizacao(
    order_by: {id: asc}
  ) {
    id
    descricao
    variavel {
      id
      descricao
      parametro {
        id
        parametroUnidadesMedida {
          id
          principal
          fator_multiplicativo_numerico
          unidadeMedida {
            id
            descricao_curta
          }
          escalasPrecisao {
            id
            nr_casas_decimais
          }
        }
      }
      fonteOrigem {
        id
      }
      propriedades(where: {id_infraestrutura: {_is_null: true}}) {
        id
        calc_expressao
        calc_nr_casas_decimais
        agregacaoTempo {
          id
          descricao
        }
      }
    }
    unidadeMedida {
      id
      descricao_curta
    }
  }
  integracoes_sig_proxy(where: {apagado: {_eq: false}, ativo: {_eq: true}}) {
    id
    url
  }
  integracoes_sig_services(distinct_on: title, where: {apagado: {_eq: false}}) {
    id
    url
    title
    visibility_default
    opacity
  }
  integracoes_sig_parametrizacao {
    latitude
    longitude
    zoom_default
    url_services
    map_server
    type
  }
  navia_dashboards_pesquisa_ativa_fugas_mapa_modelos_tarefa(
    where: {apagado: {_eq: false}}
  ) {
    plano_padrao_id
    modeloTarefa {
      id
      descricao
    }
  }
  navia_dashboards_pesquisa_ativa_fugas_mapa_sintomas(order_by: {id: desc}) {
    id
    cor_id
    cor {
      id
      cor_modo_claro
      cor_modo_escuro
    }
    sintoma {
      id
      descricao
    }
    fonteOrigem {
      id
      variavel {
        id
        descricao
        id_dominio
      }
    }
    fase {
      id
      descricao
    }
    mapaSintomaDominiosValores {
      id
      dominioValor {
        id
        descricao
      }
    }
  }
  navia_dashboards_pesquisa_ativa_fugas_mapa_tipo_infraestrutura {
    tipoInfraestrutura {
      id
      descricao
      id_sig_service
      codigo_externo
      sig_atributo_id
    }
  }
}
    `;

/**
 * __usePesquisaAtivaFugasParametrizacaoQuery__
 *
 * To run a query within a React component, call `usePesquisaAtivaFugasParametrizacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePesquisaAtivaFugasParametrizacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePesquisaAtivaFugasParametrizacaoQuery({
 *   variables: {
 *   },
 * });
 */
export function usePesquisaAtivaFugasParametrizacaoQuery(baseOptions?: Apollo.QueryHookOptions<PesquisaAtivaFugasParametrizacaoQuery, PesquisaAtivaFugasParametrizacaoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PesquisaAtivaFugasParametrizacaoQuery, PesquisaAtivaFugasParametrizacaoQueryVariables>(PesquisaAtivaFugasParametrizacaoDocument, options);
      }
export function usePesquisaAtivaFugasParametrizacaoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PesquisaAtivaFugasParametrizacaoQuery, PesquisaAtivaFugasParametrizacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PesquisaAtivaFugasParametrizacaoQuery, PesquisaAtivaFugasParametrizacaoQueryVariables>(PesquisaAtivaFugasParametrizacaoDocument, options);
        }
export function usePesquisaAtivaFugasParametrizacaoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PesquisaAtivaFugasParametrizacaoQuery, PesquisaAtivaFugasParametrizacaoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PesquisaAtivaFugasParametrizacaoQuery, PesquisaAtivaFugasParametrizacaoQueryVariables>(PesquisaAtivaFugasParametrizacaoDocument, options);
        }
export type PesquisaAtivaFugasParametrizacaoQueryHookResult = ReturnType<typeof usePesquisaAtivaFugasParametrizacaoQuery>;
export type PesquisaAtivaFugasParametrizacaoLazyQueryHookResult = ReturnType<typeof usePesquisaAtivaFugasParametrizacaoLazyQuery>;
export type PesquisaAtivaFugasParametrizacaoSuspenseQueryHookResult = ReturnType<typeof usePesquisaAtivaFugasParametrizacaoSuspenseQuery>;
export type PesquisaAtivaFugasParametrizacaoQueryResult = Apollo.QueryResult<PesquisaAtivaFugasParametrizacaoQuery, PesquisaAtivaFugasParametrizacaoQueryVariables>;
export const MonthlyVariableValuesDocument = gql`
    query MonthlyVariableValues($variableIds: [bigint!], $startMonth: Int!, $endMonth: Int!, $startYear: Int!, $endYear: Int!) {
  variaveis_base(where: {id: {_in: $variableIds}}) {
    id
    descricao
    id_tipo
    propriedades(where: {id_infraestrutura: {_is_null: true}}) {
      id
      calc_expressao
      calc_nr_casas_decimais
      agregacaoTempo {
        id
        descricao
      }
    }
    variaveisCalculo {
      id
      str_variavel
      id_fonte_origem
      fonteOrigem {
        id
        variavel {
          id
          descricao
          evolution: valoresMensais(
            order_by: {id: desc, mes: asc}
            where: {id_infraestrutura: {_is_null: true}, id_toponimia: {_is_null: true}, id_zmc: {_is_null: true}, _and: [{ano: {_gte: $startYear}, mes: {_gte: $startMonth}}, {ano: {_lte: $endYear}, mes: {_lte: $endMonth}}]}
          ) {
            id
            mes
            ano
            valor_calculado
            id_variavel_base
          }
        }
      }
    }
    evolution: valoresMensais(
      where: {id_infraestrutura: {_is_null: true}, id_toponimia: {_is_null: true}, id_zmc: {_is_null: true}, _and: [{ano: {_gte: $startYear}, mes: {_gte: $startMonth}}, {ano: {_lte: $endYear}, mes: {_lte: $endMonth}}]}
    ) {
      id
      mes
      ano
      valor_calculado
      id_variavel_base
    }
  }
}
    `;

/**
 * __useMonthlyVariableValuesQuery__
 *
 * To run a query within a React component, call `useMonthlyVariableValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyVariableValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyVariableValuesQuery({
 *   variables: {
 *      variableIds: // value for 'variableIds'
 *      startMonth: // value for 'startMonth'
 *      endMonth: // value for 'endMonth'
 *      startYear: // value for 'startYear'
 *      endYear: // value for 'endYear'
 *   },
 * });
 */
export function useMonthlyVariableValuesQuery(baseOptions: Apollo.QueryHookOptions<MonthlyVariableValuesQuery, MonthlyVariableValuesQueryVariables> & ({ variables: MonthlyVariableValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonthlyVariableValuesQuery, MonthlyVariableValuesQueryVariables>(MonthlyVariableValuesDocument, options);
      }
export function useMonthlyVariableValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonthlyVariableValuesQuery, MonthlyVariableValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonthlyVariableValuesQuery, MonthlyVariableValuesQueryVariables>(MonthlyVariableValuesDocument, options);
        }
export function useMonthlyVariableValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MonthlyVariableValuesQuery, MonthlyVariableValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MonthlyVariableValuesQuery, MonthlyVariableValuesQueryVariables>(MonthlyVariableValuesDocument, options);
        }
export type MonthlyVariableValuesQueryHookResult = ReturnType<typeof useMonthlyVariableValuesQuery>;
export type MonthlyVariableValuesLazyQueryHookResult = ReturnType<typeof useMonthlyVariableValuesLazyQuery>;
export type MonthlyVariableValuesSuspenseQueryHookResult = ReturnType<typeof useMonthlyVariableValuesSuspenseQuery>;
export type MonthlyVariableValuesQueryResult = Apollo.QueryResult<MonthlyVariableValuesQuery, MonthlyVariableValuesQueryVariables>;
export const NaviaDashboardsMenuDocument = gql`
    query NaviaDashboardsMenu($orderBy: DashboardsLicencaOrderByInput, $limit: Int, $offset: Int, $where: DashboardsLicencaWhereInput = {}) {
  dashboardsLicenca(
    where: $where
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    id
    url
    ordem
    descricao
    image_path_light
    image_path_dark
    menuTransacoes {
      id
      id_transacao
    }
  }
}
    `;

/**
 * __useNaviaDashboardsMenuQuery__
 *
 * To run a query within a React component, call `useNaviaDashboardsMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useNaviaDashboardsMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNaviaDashboardsMenuQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNaviaDashboardsMenuQuery(baseOptions?: Apollo.QueryHookOptions<NaviaDashboardsMenuQuery, NaviaDashboardsMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NaviaDashboardsMenuQuery, NaviaDashboardsMenuQueryVariables>(NaviaDashboardsMenuDocument, options);
      }
export function useNaviaDashboardsMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NaviaDashboardsMenuQuery, NaviaDashboardsMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NaviaDashboardsMenuQuery, NaviaDashboardsMenuQueryVariables>(NaviaDashboardsMenuDocument, options);
        }
export function useNaviaDashboardsMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NaviaDashboardsMenuQuery, NaviaDashboardsMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NaviaDashboardsMenuQuery, NaviaDashboardsMenuQueryVariables>(NaviaDashboardsMenuDocument, options);
        }
export type NaviaDashboardsMenuQueryHookResult = ReturnType<typeof useNaviaDashboardsMenuQuery>;
export type NaviaDashboardsMenuLazyQueryHookResult = ReturnType<typeof useNaviaDashboardsMenuLazyQuery>;
export type NaviaDashboardsMenuSuspenseQueryHookResult = ReturnType<typeof useNaviaDashboardsMenuSuspenseQuery>;
export type NaviaDashboardsMenuQueryResult = Apollo.QueryResult<NaviaDashboardsMenuQuery, NaviaDashboardsMenuQueryVariables>;
export const ModelosTarefaDocument = gql`
    query ModelosTarefa($limit: Int, $offset: Int, $where: tarefas_planos_padrao_bool_exp, $orderBy: [tarefas_planos_padrao_order_by!]) {
  tarefas_planos_padrao(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $orderBy
  ) {
    id
    descricao
  }
  tarefas_planos_padrao_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useModelosTarefaQuery__
 *
 * To run a query within a React component, call `useModelosTarefaQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelosTarefaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelosTarefaQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useModelosTarefaQuery(baseOptions?: Apollo.QueryHookOptions<ModelosTarefaQuery, ModelosTarefaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelosTarefaQuery, ModelosTarefaQueryVariables>(ModelosTarefaDocument, options);
      }
export function useModelosTarefaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelosTarefaQuery, ModelosTarefaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelosTarefaQuery, ModelosTarefaQueryVariables>(ModelosTarefaDocument, options);
        }
export function useModelosTarefaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModelosTarefaQuery, ModelosTarefaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModelosTarefaQuery, ModelosTarefaQueryVariables>(ModelosTarefaDocument, options);
        }
export type ModelosTarefaQueryHookResult = ReturnType<typeof useModelosTarefaQuery>;
export type ModelosTarefaLazyQueryHookResult = ReturnType<typeof useModelosTarefaLazyQuery>;
export type ModelosTarefaSuspenseQueryHookResult = ReturnType<typeof useModelosTarefaSuspenseQuery>;
export type ModelosTarefaQueryResult = Apollo.QueryResult<ModelosTarefaQuery, ModelosTarefaQueryVariables>;
export const RegistrationPhasesDocument = gql`
    query RegistrationPhases($where: servicos_fases_bool_exp) {
  servicos_fases(where: $where, order_by: {id: asc}) {
    id
    descricao
  }
}
    `;

/**
 * __useRegistrationPhasesQuery__
 *
 * To run a query within a React component, call `useRegistrationPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationPhasesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRegistrationPhasesQuery(baseOptions?: Apollo.QueryHookOptions<RegistrationPhasesQuery, RegistrationPhasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegistrationPhasesQuery, RegistrationPhasesQueryVariables>(RegistrationPhasesDocument, options);
      }
export function useRegistrationPhasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegistrationPhasesQuery, RegistrationPhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegistrationPhasesQuery, RegistrationPhasesQueryVariables>(RegistrationPhasesDocument, options);
        }
export function useRegistrationPhasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegistrationPhasesQuery, RegistrationPhasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegistrationPhasesQuery, RegistrationPhasesQueryVariables>(RegistrationPhasesDocument, options);
        }
export type RegistrationPhasesQueryHookResult = ReturnType<typeof useRegistrationPhasesQuery>;
export type RegistrationPhasesLazyQueryHookResult = ReturnType<typeof useRegistrationPhasesLazyQuery>;
export type RegistrationPhasesSuspenseQueryHookResult = ReturnType<typeof useRegistrationPhasesSuspenseQuery>;
export type RegistrationPhasesQueryResult = Apollo.QueryResult<RegistrationPhasesQuery, RegistrationPhasesQueryVariables>;
export const DominioDominioValoresDocument = gql`
    query DominioDominioValores($where: variaveis_dominios_r_dominios_valores_bool_exp) {
  variaveis_dominios_r_dominios_valores(where: $where, order_by: {ordem: asc}) {
    id
    dominio {
      id
      descricao
    }
    dominioValor {
      id
      descricao
    }
  }
}
    `;

/**
 * __useDominioDominioValoresQuery__
 *
 * To run a query within a React component, call `useDominioDominioValoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useDominioDominioValoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDominioDominioValoresQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDominioDominioValoresQuery(baseOptions?: Apollo.QueryHookOptions<DominioDominioValoresQuery, DominioDominioValoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DominioDominioValoresQuery, DominioDominioValoresQueryVariables>(DominioDominioValoresDocument, options);
      }
export function useDominioDominioValoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DominioDominioValoresQuery, DominioDominioValoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DominioDominioValoresQuery, DominioDominioValoresQueryVariables>(DominioDominioValoresDocument, options);
        }
export function useDominioDominioValoresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DominioDominioValoresQuery, DominioDominioValoresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DominioDominioValoresQuery, DominioDominioValoresQueryVariables>(DominioDominioValoresDocument, options);
        }
export type DominioDominioValoresQueryHookResult = ReturnType<typeof useDominioDominioValoresQuery>;
export type DominioDominioValoresLazyQueryHookResult = ReturnType<typeof useDominioDominioValoresLazyQuery>;
export type DominioDominioValoresSuspenseQueryHookResult = ReturnType<typeof useDominioDominioValoresSuspenseQuery>;
export type DominioDominioValoresQueryResult = Apollo.QueryResult<DominioDominioValoresQuery, DominioDominioValoresQueryVariables>;
export const PesquisaAtivaFugasTarefasDocument = gql`
    query PesquisaAtivaFugasTarefas($planosPadraoWhereClause: tarefas_planos_padrao_bool_exp = {}, $tarefasWhereClause: tarefas_tarefas_bool_exp = {}, $rastreabilidadesWhereClause: servicos_rastreabilidade_bool_exp = {}) {
  tarefas_planos_padrao(where: $planosPadraoWhereClause) {
    id
    descricao
    tarefas(where: $tarefasWhereClause) {
      id
      tarefaInfraestruturas {
        id
        infraestrutura {
          id
          codigo_externo
        }
      }
      rastreabilidades(where: $rastreabilidadesWhereClause) {
        id
        intervencaoDestino {
          id
          id_sintoma
          numero
          data_planeada
          sintoma {
            id
            descricao
          }
          estado {
            id
            descricao
          }
          leituras {
            id
            id_fonte_origem
            id_fase
            id_valor_dominio
          }
          infraestrutura {
            id
            descricao
            codigo_externo
            infraestruturaCoordenadas(where: {principal: {_eq: true}}) {
              id
              latitude
              longitude
            }
          }
        }
        requisicaoDestino {
          id
          id_sintoma
          numero
          data_hora
          sintoma {
            id
            descricao
          }
          estado {
            id
            descricao
          }
          leituras {
            id
            id_fonte_origem
            id_fase
            id_valor_dominio
          }
          locaisInfraestruturas {
            id
            infraestrutura {
              id
              descricao
              codigo_externo
              infraestruturaCoordenadas(where: {principal: {_eq: true}}) {
                id
                latitude
                longitude
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePesquisaAtivaFugasTarefasQuery__
 *
 * To run a query within a React component, call `usePesquisaAtivaFugasTarefasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePesquisaAtivaFugasTarefasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePesquisaAtivaFugasTarefasQuery({
 *   variables: {
 *      planosPadraoWhereClause: // value for 'planosPadraoWhereClause'
 *      tarefasWhereClause: // value for 'tarefasWhereClause'
 *      rastreabilidadesWhereClause: // value for 'rastreabilidadesWhereClause'
 *   },
 * });
 */
export function usePesquisaAtivaFugasTarefasQuery(baseOptions?: Apollo.QueryHookOptions<PesquisaAtivaFugasTarefasQuery, PesquisaAtivaFugasTarefasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PesquisaAtivaFugasTarefasQuery, PesquisaAtivaFugasTarefasQueryVariables>(PesquisaAtivaFugasTarefasDocument, options);
      }
export function usePesquisaAtivaFugasTarefasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PesquisaAtivaFugasTarefasQuery, PesquisaAtivaFugasTarefasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PesquisaAtivaFugasTarefasQuery, PesquisaAtivaFugasTarefasQueryVariables>(PesquisaAtivaFugasTarefasDocument, options);
        }
export function usePesquisaAtivaFugasTarefasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PesquisaAtivaFugasTarefasQuery, PesquisaAtivaFugasTarefasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PesquisaAtivaFugasTarefasQuery, PesquisaAtivaFugasTarefasQueryVariables>(PesquisaAtivaFugasTarefasDocument, options);
        }
export type PesquisaAtivaFugasTarefasQueryHookResult = ReturnType<typeof usePesquisaAtivaFugasTarefasQuery>;
export type PesquisaAtivaFugasTarefasLazyQueryHookResult = ReturnType<typeof usePesquisaAtivaFugasTarefasLazyQuery>;
export type PesquisaAtivaFugasTarefasSuspenseQueryHookResult = ReturnType<typeof usePesquisaAtivaFugasTarefasSuspenseQuery>;
export type PesquisaAtivaFugasTarefasQueryResult = Apollo.QueryResult<PesquisaAtivaFugasTarefasQuery, PesquisaAtivaFugasTarefasQueryVariables>;
export const GetIntegrationStatusByIdDocument = gql`
    query GetIntegrationStatusById($id: bigint_comparison_exp!) {
  navia_integracoes(where: {id: $id}) {
    id
    activo
    descricao
  }
}
    `;

/**
 * __useGetIntegrationStatusByIdQuery__
 *
 * To run a query within a React component, call `useGetIntegrationStatusByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationStatusByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationStatusByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationStatusByIdQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationStatusByIdQuery, GetIntegrationStatusByIdQueryVariables> & ({ variables: GetIntegrationStatusByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationStatusByIdQuery, GetIntegrationStatusByIdQueryVariables>(GetIntegrationStatusByIdDocument, options);
      }
export function useGetIntegrationStatusByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationStatusByIdQuery, GetIntegrationStatusByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationStatusByIdQuery, GetIntegrationStatusByIdQueryVariables>(GetIntegrationStatusByIdDocument, options);
        }
export function useGetIntegrationStatusByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationStatusByIdQuery, GetIntegrationStatusByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationStatusByIdQuery, GetIntegrationStatusByIdQueryVariables>(GetIntegrationStatusByIdDocument, options);
        }
export type GetIntegrationStatusByIdQueryHookResult = ReturnType<typeof useGetIntegrationStatusByIdQuery>;
export type GetIntegrationStatusByIdLazyQueryHookResult = ReturnType<typeof useGetIntegrationStatusByIdLazyQuery>;
export type GetIntegrationStatusByIdSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationStatusByIdSuspenseQuery>;
export type GetIntegrationStatusByIdQueryResult = Apollo.QueryResult<GetIntegrationStatusByIdQuery, GetIntegrationStatusByIdQueryVariables>;
export const GetAdProtocolIdDocument = gql`
    query GetADProtocolId {
  integracoes_ad_parametrizacao {
    id_protocolo
  }
}
    `;

/**
 * __useGetAdProtocolIdQuery__
 *
 * To run a query within a React component, call `useGetAdProtocolIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdProtocolIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdProtocolIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdProtocolIdQuery(baseOptions?: Apollo.QueryHookOptions<GetAdProtocolIdQuery, GetAdProtocolIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdProtocolIdQuery, GetAdProtocolIdQueryVariables>(GetAdProtocolIdDocument, options);
      }
export function useGetAdProtocolIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdProtocolIdQuery, GetAdProtocolIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdProtocolIdQuery, GetAdProtocolIdQueryVariables>(GetAdProtocolIdDocument, options);
        }
export function useGetAdProtocolIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdProtocolIdQuery, GetAdProtocolIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdProtocolIdQuery, GetAdProtocolIdQueryVariables>(GetAdProtocolIdDocument, options);
        }
export type GetAdProtocolIdQueryHookResult = ReturnType<typeof useGetAdProtocolIdQuery>;
export type GetAdProtocolIdLazyQueryHookResult = ReturnType<typeof useGetAdProtocolIdLazyQuery>;
export type GetAdProtocolIdSuspenseQueryHookResult = ReturnType<typeof useGetAdProtocolIdSuspenseQuery>;
export type GetAdProtocolIdQueryResult = Apollo.QueryResult<GetAdProtocolIdQuery, GetAdProtocolIdQueryVariables>;
export const GetAdsamlConfigDocument = gql`
    query GetADSAMLConfig {
  integracoes_ad_saml_parametrizacao {
    url_encaminhamento
  }
}
    `;

/**
 * __useGetAdsamlConfigQuery__
 *
 * To run a query within a React component, call `useGetAdsamlConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdsamlConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdsamlConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdsamlConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetAdsamlConfigQuery, GetAdsamlConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdsamlConfigQuery, GetAdsamlConfigQueryVariables>(GetAdsamlConfigDocument, options);
      }
export function useGetAdsamlConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdsamlConfigQuery, GetAdsamlConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdsamlConfigQuery, GetAdsamlConfigQueryVariables>(GetAdsamlConfigDocument, options);
        }
export function useGetAdsamlConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdsamlConfigQuery, GetAdsamlConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdsamlConfigQuery, GetAdsamlConfigQueryVariables>(GetAdsamlConfigDocument, options);
        }
export type GetAdsamlConfigQueryHookResult = ReturnType<typeof useGetAdsamlConfigQuery>;
export type GetAdsamlConfigLazyQueryHookResult = ReturnType<typeof useGetAdsamlConfigLazyQuery>;
export type GetAdsamlConfigSuspenseQueryHookResult = ReturnType<typeof useGetAdsamlConfigSuspenseQuery>;
export type GetAdsamlConfigQueryResult = Apollo.QueryResult<GetAdsamlConfigQuery, GetAdsamlConfigQueryVariables>;
export const Visao360ParametrizacaoDocument = gql`
    query Visao360Parametrizacao {
  navia_dashboards_visao_360_parametrizacao(order_by: {id: asc}) {
    id
    descricao
    selector
    variavel {
      id
      descricao
      propriedades(where: {id_infraestrutura: {_is_null: true}}) {
        id
        calc_expressao
        calc_nr_casas_decimais
        agregacaoTempo {
          id
          descricao
        }
      }
      parametro {
        id
        parametroUnidadesMedida {
          id
          principal
          fator_multiplicativo_numerico
          unidadeMedida {
            id
            descricao_curta
          }
          escalasPrecisao {
            id
            nr_casas_decimais
          }
        }
      }
      fonteOrigem {
        id
      }
    }
    unidadeMedida {
      id
      descricao_curta
    }
    infraestruturaTipo {
      id
      descricao
    }
  }
}
    `;

/**
 * __useVisao360ParametrizacaoQuery__
 *
 * To run a query within a React component, call `useVisao360ParametrizacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisao360ParametrizacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisao360ParametrizacaoQuery({
 *   variables: {
 *   },
 * });
 */
export function useVisao360ParametrizacaoQuery(baseOptions?: Apollo.QueryHookOptions<Visao360ParametrizacaoQuery, Visao360ParametrizacaoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Visao360ParametrizacaoQuery, Visao360ParametrizacaoQueryVariables>(Visao360ParametrizacaoDocument, options);
      }
export function useVisao360ParametrizacaoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Visao360ParametrizacaoQuery, Visao360ParametrizacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Visao360ParametrizacaoQuery, Visao360ParametrizacaoQueryVariables>(Visao360ParametrizacaoDocument, options);
        }
export function useVisao360ParametrizacaoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Visao360ParametrizacaoQuery, Visao360ParametrizacaoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Visao360ParametrizacaoQuery, Visao360ParametrizacaoQueryVariables>(Visao360ParametrizacaoDocument, options);
        }
export type Visao360ParametrizacaoQueryHookResult = ReturnType<typeof useVisao360ParametrizacaoQuery>;
export type Visao360ParametrizacaoLazyQueryHookResult = ReturnType<typeof useVisao360ParametrizacaoLazyQuery>;
export type Visao360ParametrizacaoSuspenseQueryHookResult = ReturnType<typeof useVisao360ParametrizacaoSuspenseQuery>;
export type Visao360ParametrizacaoQueryResult = Apollo.QueryResult<Visao360ParametrizacaoQuery, Visao360ParametrizacaoQueryVariables>;
export const QsParametrizacaoDocument = gql`
    query QSParametrizacao {
  rqs_parametrizacao {
    data_inicio
  }
}
    `;

/**
 * __useQsParametrizacaoQuery__
 *
 * To run a query within a React component, call `useQsParametrizacaoQuery` and pass it any options that fit your needs.
 * When your component renders, `useQsParametrizacaoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQsParametrizacaoQuery({
 *   variables: {
 *   },
 * });
 */
export function useQsParametrizacaoQuery(baseOptions?: Apollo.QueryHookOptions<QsParametrizacaoQuery, QsParametrizacaoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QsParametrizacaoQuery, QsParametrizacaoQueryVariables>(QsParametrizacaoDocument, options);
      }
export function useQsParametrizacaoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QsParametrizacaoQuery, QsParametrizacaoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QsParametrizacaoQuery, QsParametrizacaoQueryVariables>(QsParametrizacaoDocument, options);
        }
export function useQsParametrizacaoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QsParametrizacaoQuery, QsParametrizacaoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QsParametrizacaoQuery, QsParametrizacaoQueryVariables>(QsParametrizacaoDocument, options);
        }
export type QsParametrizacaoQueryHookResult = ReturnType<typeof useQsParametrizacaoQuery>;
export type QsParametrizacaoLazyQueryHookResult = ReturnType<typeof useQsParametrizacaoLazyQuery>;
export type QsParametrizacaoSuspenseQueryHookResult = ReturnType<typeof useQsParametrizacaoSuspenseQuery>;
export type QsParametrizacaoQueryResult = Apollo.QueryResult<QsParametrizacaoQuery, QsParametrizacaoQueryVariables>;
export const CaudaisDiariosMunicipalitiesDocument = gql`
    query CaudaisDiariosMunicipalities($limit: Int, $offset: Int, $where: navia_dashboards_volumes_diarios_municipios_bool_exp, $orderBy: [navia_dashboards_volumes_diarios_municipios_order_by!]) {
  navia_dashboards_volumes_diarios_municipios(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $orderBy
  ) {
    id
    descricao
    equipasVirtuaisMunicipio {
      id
      equipaVirtual {
        id
        descricao
      }
    }
    apagado
  }
  navia_dashboards_volumes_diarios_municipios_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useCaudaisDiariosMunicipalitiesQuery__
 *
 * To run a query within a React component, call `useCaudaisDiariosMunicipalitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaudaisDiariosMunicipalitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaudaisDiariosMunicipalitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCaudaisDiariosMunicipalitiesQuery(baseOptions?: Apollo.QueryHookOptions<CaudaisDiariosMunicipalitiesQuery, CaudaisDiariosMunicipalitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaudaisDiariosMunicipalitiesQuery, CaudaisDiariosMunicipalitiesQueryVariables>(CaudaisDiariosMunicipalitiesDocument, options);
      }
export function useCaudaisDiariosMunicipalitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaudaisDiariosMunicipalitiesQuery, CaudaisDiariosMunicipalitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaudaisDiariosMunicipalitiesQuery, CaudaisDiariosMunicipalitiesQueryVariables>(CaudaisDiariosMunicipalitiesDocument, options);
        }
export function useCaudaisDiariosMunicipalitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaudaisDiariosMunicipalitiesQuery, CaudaisDiariosMunicipalitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaudaisDiariosMunicipalitiesQuery, CaudaisDiariosMunicipalitiesQueryVariables>(CaudaisDiariosMunicipalitiesDocument, options);
        }
export type CaudaisDiariosMunicipalitiesQueryHookResult = ReturnType<typeof useCaudaisDiariosMunicipalitiesQuery>;
export type CaudaisDiariosMunicipalitiesLazyQueryHookResult = ReturnType<typeof useCaudaisDiariosMunicipalitiesLazyQuery>;
export type CaudaisDiariosMunicipalitiesSuspenseQueryHookResult = ReturnType<typeof useCaudaisDiariosMunicipalitiesSuspenseQuery>;
export type CaudaisDiariosMunicipalitiesQueryResult = Apollo.QueryResult<CaudaisDiariosMunicipalitiesQuery, CaudaisDiariosMunicipalitiesQueryVariables>;
export const VirtualTeamsDocument = gql`
    query VirtualTeams($limit: Int, $offset: Int, $where: utilizadores_equipas_virtuais_bool_exp, $orderBy: [utilizadores_equipas_virtuais_order_by!]) {
  utilizadores_equipas_virtuais(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $orderBy
  ) {
    id
    descricao
  }
  utilizadores_equipas_virtuais_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useVirtualTeamsQuery__
 *
 * To run a query within a React component, call `useVirtualTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualTeamsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useVirtualTeamsQuery(baseOptions?: Apollo.QueryHookOptions<VirtualTeamsQuery, VirtualTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VirtualTeamsQuery, VirtualTeamsQueryVariables>(VirtualTeamsDocument, options);
      }
export function useVirtualTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VirtualTeamsQuery, VirtualTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VirtualTeamsQuery, VirtualTeamsQueryVariables>(VirtualTeamsDocument, options);
        }
export function useVirtualTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VirtualTeamsQuery, VirtualTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VirtualTeamsQuery, VirtualTeamsQueryVariables>(VirtualTeamsDocument, options);
        }
export type VirtualTeamsQueryHookResult = ReturnType<typeof useVirtualTeamsQuery>;
export type VirtualTeamsLazyQueryHookResult = ReturnType<typeof useVirtualTeamsLazyQuery>;
export type VirtualTeamsSuspenseQueryHookResult = ReturnType<typeof useVirtualTeamsSuspenseQuery>;
export type VirtualTeamsQueryResult = Apollo.QueryResult<VirtualTeamsQuery, VirtualTeamsQueryVariables>;
export const GetDashboardQsIndicatorsDocument = gql`
    query getDashboardQSIndicators($year: Int!) {
  getDashboardQSIndicators(year: $year) {
    value
    id
  }
}
    `;

/**
 * __useGetDashboardQsIndicatorsQuery__
 *
 * To run a query within a React component, call `useGetDashboardQsIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQsIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQsIndicatorsQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetDashboardQsIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardQsIndicatorsQuery, GetDashboardQsIndicatorsQueryVariables> & ({ variables: GetDashboardQsIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardQsIndicatorsQuery, GetDashboardQsIndicatorsQueryVariables>(GetDashboardQsIndicatorsDocument, options);
      }
export function useGetDashboardQsIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardQsIndicatorsQuery, GetDashboardQsIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardQsIndicatorsQuery, GetDashboardQsIndicatorsQueryVariables>(GetDashboardQsIndicatorsDocument, options);
        }
export function useGetDashboardQsIndicatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardQsIndicatorsQuery, GetDashboardQsIndicatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardQsIndicatorsQuery, GetDashboardQsIndicatorsQueryVariables>(GetDashboardQsIndicatorsDocument, options);
        }
export type GetDashboardQsIndicatorsQueryHookResult = ReturnType<typeof useGetDashboardQsIndicatorsQuery>;
export type GetDashboardQsIndicatorsLazyQueryHookResult = ReturnType<typeof useGetDashboardQsIndicatorsLazyQuery>;
export type GetDashboardQsIndicatorsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardQsIndicatorsSuspenseQuery>;
export type GetDashboardQsIndicatorsQueryResult = Apollo.QueryResult<GetDashboardQsIndicatorsQuery, GetDashboardQsIndicatorsQueryVariables>;
export const GetDashboardQsTopFiveNonComplianceBySymptomDocument = gql`
    query getDashboardQSTopFiveNonComplianceBySymptom($year: Int!) {
  getDashboardQSTopFiveNonComplianceBySymptom(year: $year) {
    id_symptom
    symptom
    total_requests
  }
}
    `;

/**
 * __useGetDashboardQsTopFiveNonComplianceBySymptomQuery__
 *
 * To run a query within a React component, call `useGetDashboardQsTopFiveNonComplianceBySymptomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQsTopFiveNonComplianceBySymptomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQsTopFiveNonComplianceBySymptomQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetDashboardQsTopFiveNonComplianceBySymptomQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardQsTopFiveNonComplianceBySymptomQuery, GetDashboardQsTopFiveNonComplianceBySymptomQueryVariables> & ({ variables: GetDashboardQsTopFiveNonComplianceBySymptomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardQsTopFiveNonComplianceBySymptomQuery, GetDashboardQsTopFiveNonComplianceBySymptomQueryVariables>(GetDashboardQsTopFiveNonComplianceBySymptomDocument, options);
      }
export function useGetDashboardQsTopFiveNonComplianceBySymptomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardQsTopFiveNonComplianceBySymptomQuery, GetDashboardQsTopFiveNonComplianceBySymptomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardQsTopFiveNonComplianceBySymptomQuery, GetDashboardQsTopFiveNonComplianceBySymptomQueryVariables>(GetDashboardQsTopFiveNonComplianceBySymptomDocument, options);
        }
export function useGetDashboardQsTopFiveNonComplianceBySymptomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardQsTopFiveNonComplianceBySymptomQuery, GetDashboardQsTopFiveNonComplianceBySymptomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardQsTopFiveNonComplianceBySymptomQuery, GetDashboardQsTopFiveNonComplianceBySymptomQueryVariables>(GetDashboardQsTopFiveNonComplianceBySymptomDocument, options);
        }
export type GetDashboardQsTopFiveNonComplianceBySymptomQueryHookResult = ReturnType<typeof useGetDashboardQsTopFiveNonComplianceBySymptomQuery>;
export type GetDashboardQsTopFiveNonComplianceBySymptomLazyQueryHookResult = ReturnType<typeof useGetDashboardQsTopFiveNonComplianceBySymptomLazyQuery>;
export type GetDashboardQsTopFiveNonComplianceBySymptomSuspenseQueryHookResult = ReturnType<typeof useGetDashboardQsTopFiveNonComplianceBySymptomSuspenseQuery>;
export type GetDashboardQsTopFiveNonComplianceBySymptomQueryResult = Apollo.QueryResult<GetDashboardQsTopFiveNonComplianceBySymptomQuery, GetDashboardQsTopFiveNonComplianceBySymptomQueryVariables>;
export const GetDashboardQsTopFiveAverageDurationBySymptomDocument = gql`
    query getDashboardQSTopFiveAverageDurationBySymptom($year: Int!) {
  getDashboardQSTopFiveAverageDurationBySymptom(year: $year) {
    id_symptom
    average_time_in_seconds
    id_frequency_time_limit_response
    time_limit_response
    symptom
    time_limit_seconds
  }
}
    `;

/**
 * __useGetDashboardQsTopFiveAverageDurationBySymptomQuery__
 *
 * To run a query within a React component, call `useGetDashboardQsTopFiveAverageDurationBySymptomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQsTopFiveAverageDurationBySymptomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQsTopFiveAverageDurationBySymptomQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetDashboardQsTopFiveAverageDurationBySymptomQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardQsTopFiveAverageDurationBySymptomQuery, GetDashboardQsTopFiveAverageDurationBySymptomQueryVariables> & ({ variables: GetDashboardQsTopFiveAverageDurationBySymptomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardQsTopFiveAverageDurationBySymptomQuery, GetDashboardQsTopFiveAverageDurationBySymptomQueryVariables>(GetDashboardQsTopFiveAverageDurationBySymptomDocument, options);
      }
export function useGetDashboardQsTopFiveAverageDurationBySymptomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardQsTopFiveAverageDurationBySymptomQuery, GetDashboardQsTopFiveAverageDurationBySymptomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardQsTopFiveAverageDurationBySymptomQuery, GetDashboardQsTopFiveAverageDurationBySymptomQueryVariables>(GetDashboardQsTopFiveAverageDurationBySymptomDocument, options);
        }
export function useGetDashboardQsTopFiveAverageDurationBySymptomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardQsTopFiveAverageDurationBySymptomQuery, GetDashboardQsTopFiveAverageDurationBySymptomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardQsTopFiveAverageDurationBySymptomQuery, GetDashboardQsTopFiveAverageDurationBySymptomQueryVariables>(GetDashboardQsTopFiveAverageDurationBySymptomDocument, options);
        }
export type GetDashboardQsTopFiveAverageDurationBySymptomQueryHookResult = ReturnType<typeof useGetDashboardQsTopFiveAverageDurationBySymptomQuery>;
export type GetDashboardQsTopFiveAverageDurationBySymptomLazyQueryHookResult = ReturnType<typeof useGetDashboardQsTopFiveAverageDurationBySymptomLazyQuery>;
export type GetDashboardQsTopFiveAverageDurationBySymptomSuspenseQueryHookResult = ReturnType<typeof useGetDashboardQsTopFiveAverageDurationBySymptomSuspenseQuery>;
export type GetDashboardQsTopFiveAverageDurationBySymptomQueryResult = Apollo.QueryResult<GetDashboardQsTopFiveAverageDurationBySymptomQuery, GetDashboardQsTopFiveAverageDurationBySymptomQueryVariables>;
export const CheckMunicipalityExistsDocument = gql`
    query CheckMunicipalityExists($name: String!) {
  checkMunicipalityExists(name: $name) {
    exists
    id
  }
}
    `;

/**
 * __useCheckMunicipalityExistsQuery__
 *
 * To run a query within a React component, call `useCheckMunicipalityExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckMunicipalityExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMunicipalityExistsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCheckMunicipalityExistsQuery(baseOptions: Apollo.QueryHookOptions<CheckMunicipalityExistsQuery, CheckMunicipalityExistsQueryVariables> & ({ variables: CheckMunicipalityExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckMunicipalityExistsQuery, CheckMunicipalityExistsQueryVariables>(CheckMunicipalityExistsDocument, options);
      }
export function useCheckMunicipalityExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckMunicipalityExistsQuery, CheckMunicipalityExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckMunicipalityExistsQuery, CheckMunicipalityExistsQueryVariables>(CheckMunicipalityExistsDocument, options);
        }
export function useCheckMunicipalityExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckMunicipalityExistsQuery, CheckMunicipalityExistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckMunicipalityExistsQuery, CheckMunicipalityExistsQueryVariables>(CheckMunicipalityExistsDocument, options);
        }
export type CheckMunicipalityExistsQueryHookResult = ReturnType<typeof useCheckMunicipalityExistsQuery>;
export type CheckMunicipalityExistsLazyQueryHookResult = ReturnType<typeof useCheckMunicipalityExistsLazyQuery>;
export type CheckMunicipalityExistsSuspenseQueryHookResult = ReturnType<typeof useCheckMunicipalityExistsSuspenseQuery>;
export type CheckMunicipalityExistsQueryResult = Apollo.QueryResult<CheckMunicipalityExistsQuery, CheckMunicipalityExistsQueryVariables>;
export const DailyFlowReadingsDocument = gql`
    query DailyFlowReadings($limit: Int, $offset: Int, $municipalityId: Int!, $startDate: Date!, $endDate: Date!, $placeSearchValue: String, $orderBy: [DailyFlowReadingsSortInput]) {
  getDailyFlowReadings(
    limit: $limit
    offset: $offset
    municipalityId: $municipalityId
    startDate: $startDate
    endDate: $endDate
    placeSearchValue: $placeSearchValue
    orderBy: $orderBy
  ) {
    id
    readings {
      id
      readingId
      id_fonte_origem
      place
      totalizer
      parcial_totalizer
      date
      unit
    }
    totalCount
  }
}
    `;

/**
 * __useDailyFlowReadingsQuery__
 *
 * To run a query within a React component, call `useDailyFlowReadingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyFlowReadingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyFlowReadingsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      municipalityId: // value for 'municipalityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      placeSearchValue: // value for 'placeSearchValue'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDailyFlowReadingsQuery(baseOptions: Apollo.QueryHookOptions<DailyFlowReadingsQuery, DailyFlowReadingsQueryVariables> & ({ variables: DailyFlowReadingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyFlowReadingsQuery, DailyFlowReadingsQueryVariables>(DailyFlowReadingsDocument, options);
      }
export function useDailyFlowReadingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyFlowReadingsQuery, DailyFlowReadingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyFlowReadingsQuery, DailyFlowReadingsQueryVariables>(DailyFlowReadingsDocument, options);
        }
export function useDailyFlowReadingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyFlowReadingsQuery, DailyFlowReadingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyFlowReadingsQuery, DailyFlowReadingsQueryVariables>(DailyFlowReadingsDocument, options);
        }
export type DailyFlowReadingsQueryHookResult = ReturnType<typeof useDailyFlowReadingsQuery>;
export type DailyFlowReadingsLazyQueryHookResult = ReturnType<typeof useDailyFlowReadingsLazyQuery>;
export type DailyFlowReadingsSuspenseQueryHookResult = ReturnType<typeof useDailyFlowReadingsSuspenseQuery>;
export type DailyFlowReadingsQueryResult = Apollo.QueryResult<DailyFlowReadingsQuery, DailyFlowReadingsQueryVariables>;
export const InfrastructureTotalizersDocument = gql`
    query InfrastructureTotalizers($limit: Int, $offset: Int, $where: base_infraestruturas_bool_exp, $sourceOriginPropertiesWhere: variaveis_fontes_origem_propriedades_bool_exp, $orderBy: [base_infraestruturas_order_by!]) {
  base_infraestruturas(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $orderBy
  ) {
    id
    descricao
    id_tipo_bulk
    id_tipo_infraestrutura
    codigo_manutencao
    codigo_sig
    nome_instalacao
    has_childs
    parentInfra {
      id
      descricao
      id_tipo_bulk
      parentInfra {
        id
        descricao
        id_tipo_bulk
        parentInfra {
          id
          descricao
          id_tipo_bulk
          parentInfra {
            id
            descricao
            id_tipo_bulk
            parentInfra {
              id
              descricao
              id_tipo_bulk
              parentInfra {
                id
                descricao
                id_tipo_bulk
                parentInfra {
                  id
                  descricao
                  id_tipo_bulk
                  parentInfra {
                    id
                    descricao
                    id_tipo_bulk
                  }
                }
              }
            }
          }
        }
      }
    }
    fontesOrigemPropriedades(where: $sourceOriginPropertiesWhere) {
      id
      fonteOrigem {
        id
        descricao
        parametroUnidadeMedida {
          id
          id_parametro
          unidadeMedida {
            id
            descricao
          }
        }
        variavel {
          id
          descricao
          dominio {
            id
            descricao
          }
          id_tipo
        }
      }
    }
  }
  base_infraestruturas_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useInfrastructureTotalizersQuery__
 *
 * To run a query within a React component, call `useInfrastructureTotalizersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureTotalizersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureTotalizersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      sourceOriginPropertiesWhere: // value for 'sourceOriginPropertiesWhere'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useInfrastructureTotalizersQuery(baseOptions?: Apollo.QueryHookOptions<InfrastructureTotalizersQuery, InfrastructureTotalizersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureTotalizersQuery, InfrastructureTotalizersQueryVariables>(InfrastructureTotalizersDocument, options);
      }
export function useInfrastructureTotalizersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureTotalizersQuery, InfrastructureTotalizersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureTotalizersQuery, InfrastructureTotalizersQueryVariables>(InfrastructureTotalizersDocument, options);
        }
export function useInfrastructureTotalizersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfrastructureTotalizersQuery, InfrastructureTotalizersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureTotalizersQuery, InfrastructureTotalizersQueryVariables>(InfrastructureTotalizersDocument, options);
        }
export type InfrastructureTotalizersQueryHookResult = ReturnType<typeof useInfrastructureTotalizersQuery>;
export type InfrastructureTotalizersLazyQueryHookResult = ReturnType<typeof useInfrastructureTotalizersLazyQuery>;
export type InfrastructureTotalizersSuspenseQueryHookResult = ReturnType<typeof useInfrastructureTotalizersSuspenseQuery>;
export type InfrastructureTotalizersQueryResult = Apollo.QueryResult<InfrastructureTotalizersQuery, InfrastructureTotalizersQueryVariables>;
export const InfrastructureTotalizersTreeDocument = gql`
    query InfrastructureTotalizersTree($description: String!, $totalizer: String!, $transactionId: bigint!, $userId: bigint!) {
  infrastructure_totalizers_tree(
    args: {description: $description, totalizer: $totalizer, transactionId: $transactionId, userId: $userId}
  ) {
    id
    id_pai
    descricao
    node
    id_tipo_bulk
    codigo_manutencao
    codigo_sig
  }
}
    `;

/**
 * __useInfrastructureTotalizersTreeQuery__
 *
 * To run a query within a React component, call `useInfrastructureTotalizersTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureTotalizersTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureTotalizersTreeQuery({
 *   variables: {
 *      description: // value for 'description'
 *      totalizer: // value for 'totalizer'
 *      transactionId: // value for 'transactionId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInfrastructureTotalizersTreeQuery(baseOptions: Apollo.QueryHookOptions<InfrastructureTotalizersTreeQuery, InfrastructureTotalizersTreeQueryVariables> & ({ variables: InfrastructureTotalizersTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureTotalizersTreeQuery, InfrastructureTotalizersTreeQueryVariables>(InfrastructureTotalizersTreeDocument, options);
      }
export function useInfrastructureTotalizersTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureTotalizersTreeQuery, InfrastructureTotalizersTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureTotalizersTreeQuery, InfrastructureTotalizersTreeQueryVariables>(InfrastructureTotalizersTreeDocument, options);
        }
export function useInfrastructureTotalizersTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfrastructureTotalizersTreeQuery, InfrastructureTotalizersTreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureTotalizersTreeQuery, InfrastructureTotalizersTreeQueryVariables>(InfrastructureTotalizersTreeDocument, options);
        }
export type InfrastructureTotalizersTreeQueryHookResult = ReturnType<typeof useInfrastructureTotalizersTreeQuery>;
export type InfrastructureTotalizersTreeLazyQueryHookResult = ReturnType<typeof useInfrastructureTotalizersTreeLazyQuery>;
export type InfrastructureTotalizersTreeSuspenseQueryHookResult = ReturnType<typeof useInfrastructureTotalizersTreeSuspenseQuery>;
export type InfrastructureTotalizersTreeQueryResult = Apollo.QueryResult<InfrastructureTotalizersTreeQuery, InfrastructureTotalizersTreeQueryVariables>;
export const TotalizersDocument = gql`
    query Totalizers($municipalityId: bigint!, $searchText: String = "%%") {
  navia_dashboards_volumes_diarios_totalizadores(
    where: {id_municipio: {_eq: $municipalityId}, _or: [{fonteOrigemPropriedade: {infraestrutura: {descricao: {_ilike: $searchText}}}}, {fonteOrigemPropriedade: {fonteOrigem: {variavel: {descricao: {_ilike: $searchText}}}}}]}
    order_by: {id: asc}
  ) {
    id
    id_fonte_origem_propriedade
    leitura
    expressao
    fonteOrigemPropriedade {
      id
      fonteOrigem {
        id
        variavel {
          id
          descricao
        }
      }
      infraestrutura {
        id
        descricao
      }
    }
  }
}
    `;

/**
 * __useTotalizersQuery__
 *
 * To run a query within a React component, call `useTotalizersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalizersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalizersQuery({
 *   variables: {
 *      municipalityId: // value for 'municipalityId'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useTotalizersQuery(baseOptions: Apollo.QueryHookOptions<TotalizersQuery, TotalizersQueryVariables> & ({ variables: TotalizersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalizersQuery, TotalizersQueryVariables>(TotalizersDocument, options);
      }
export function useTotalizersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalizersQuery, TotalizersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalizersQuery, TotalizersQueryVariables>(TotalizersDocument, options);
        }
export function useTotalizersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TotalizersQuery, TotalizersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TotalizersQuery, TotalizersQueryVariables>(TotalizersDocument, options);
        }
export type TotalizersQueryHookResult = ReturnType<typeof useTotalizersQuery>;
export type TotalizersLazyQueryHookResult = ReturnType<typeof useTotalizersLazyQuery>;
export type TotalizersSuspenseQueryHookResult = ReturnType<typeof useTotalizersSuspenseQuery>;
export type TotalizersQueryResult = Apollo.QueryResult<TotalizersQuery, TotalizersQueryVariables>;
export const CaudaisDiariosDataConfigDocument = gql`
    query CaudaisDiariosDataConfig($municipalityId: bigint!) {
  navia_dashboards_volumes_diarios_dados(
    where: {id_municipio: {_eq: $municipalityId}}
  ) {
    id_municipio
    local
    caudal
    registo
    leitura
    expressao
  }
}
    `;

/**
 * __useCaudaisDiariosDataConfigQuery__
 *
 * To run a query within a React component, call `useCaudaisDiariosDataConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaudaisDiariosDataConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaudaisDiariosDataConfigQuery({
 *   variables: {
 *      municipalityId: // value for 'municipalityId'
 *   },
 * });
 */
export function useCaudaisDiariosDataConfigQuery(baseOptions: Apollo.QueryHookOptions<CaudaisDiariosDataConfigQuery, CaudaisDiariosDataConfigQueryVariables> & ({ variables: CaudaisDiariosDataConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaudaisDiariosDataConfigQuery, CaudaisDiariosDataConfigQueryVariables>(CaudaisDiariosDataConfigDocument, options);
      }
export function useCaudaisDiariosDataConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaudaisDiariosDataConfigQuery, CaudaisDiariosDataConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaudaisDiariosDataConfigQuery, CaudaisDiariosDataConfigQueryVariables>(CaudaisDiariosDataConfigDocument, options);
        }
export function useCaudaisDiariosDataConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaudaisDiariosDataConfigQuery, CaudaisDiariosDataConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaudaisDiariosDataConfigQuery, CaudaisDiariosDataConfigQueryVariables>(CaudaisDiariosDataConfigDocument, options);
        }
export type CaudaisDiariosDataConfigQueryHookResult = ReturnType<typeof useCaudaisDiariosDataConfigQuery>;
export type CaudaisDiariosDataConfigLazyQueryHookResult = ReturnType<typeof useCaudaisDiariosDataConfigLazyQuery>;
export type CaudaisDiariosDataConfigSuspenseQueryHookResult = ReturnType<typeof useCaudaisDiariosDataConfigSuspenseQuery>;
export type CaudaisDiariosDataConfigQueryResult = Apollo.QueryResult<CaudaisDiariosDataConfigQuery, CaudaisDiariosDataConfigQueryVariables>;
export const DailyFlowIndicatorsDocument = gql`
    query DailyFlowIndicators($municipalityId: Int!, $startDate: Date!, $endDate: Date!) {
  getDailyFlowIndicators(
    municipalityId: $municipalityId
    startDate: $startDate
    endDate: $endDate
  ) {
    id
    min {
      id
      value
      date
    }
    max {
      id
      value
      date
    }
    avg {
      id
      value
    }
    total {
      id
      value
    }
  }
}
    `;

/**
 * __useDailyFlowIndicatorsQuery__
 *
 * To run a query within a React component, call `useDailyFlowIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyFlowIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyFlowIndicatorsQuery({
 *   variables: {
 *      municipalityId: // value for 'municipalityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useDailyFlowIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<DailyFlowIndicatorsQuery, DailyFlowIndicatorsQueryVariables> & ({ variables: DailyFlowIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyFlowIndicatorsQuery, DailyFlowIndicatorsQueryVariables>(DailyFlowIndicatorsDocument, options);
      }
export function useDailyFlowIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyFlowIndicatorsQuery, DailyFlowIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyFlowIndicatorsQuery, DailyFlowIndicatorsQueryVariables>(DailyFlowIndicatorsDocument, options);
        }
export function useDailyFlowIndicatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyFlowIndicatorsQuery, DailyFlowIndicatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyFlowIndicatorsQuery, DailyFlowIndicatorsQueryVariables>(DailyFlowIndicatorsDocument, options);
        }
export type DailyFlowIndicatorsQueryHookResult = ReturnType<typeof useDailyFlowIndicatorsQuery>;
export type DailyFlowIndicatorsLazyQueryHookResult = ReturnType<typeof useDailyFlowIndicatorsLazyQuery>;
export type DailyFlowIndicatorsSuspenseQueryHookResult = ReturnType<typeof useDailyFlowIndicatorsSuspenseQuery>;
export type DailyFlowIndicatorsQueryResult = Apollo.QueryResult<DailyFlowIndicatorsQuery, DailyFlowIndicatorsQueryVariables>;
export const DailyFlowChartDocument = gql`
    query DailyFlowChart($municipalityId: Int!, $startDate: Date!, $endDate: Date!) {
  getDailyFlowChart(
    municipalityId: $municipalityId
    startDate: $startDate
    endDate: $endDate
  ) {
    id
    items {
      id
      place
      value
    }
  }
}
    `;

/**
 * __useDailyFlowChartQuery__
 *
 * To run a query within a React component, call `useDailyFlowChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyFlowChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyFlowChartQuery({
 *   variables: {
 *      municipalityId: // value for 'municipalityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useDailyFlowChartQuery(baseOptions: Apollo.QueryHookOptions<DailyFlowChartQuery, DailyFlowChartQueryVariables> & ({ variables: DailyFlowChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyFlowChartQuery, DailyFlowChartQueryVariables>(DailyFlowChartDocument, options);
      }
export function useDailyFlowChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyFlowChartQuery, DailyFlowChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyFlowChartQuery, DailyFlowChartQueryVariables>(DailyFlowChartDocument, options);
        }
export function useDailyFlowChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyFlowChartQuery, DailyFlowChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyFlowChartQuery, DailyFlowChartQueryVariables>(DailyFlowChartDocument, options);
        }
export type DailyFlowChartQueryHookResult = ReturnType<typeof useDailyFlowChartQuery>;
export type DailyFlowChartLazyQueryHookResult = ReturnType<typeof useDailyFlowChartLazyQuery>;
export type DailyFlowChartSuspenseQueryHookResult = ReturnType<typeof useDailyFlowChartSuspenseQuery>;
export type DailyFlowChartQueryResult = Apollo.QueryResult<DailyFlowChartQuery, DailyFlowChartQueryVariables>;
export const ExportDailyFlowTableDocument = gql`
    query ExportDailyFlowTable($startDate: Date!, $endDate: Date!, $municipalityId: Int!, $orderBy: [DailyFlowReadingsSortInput]) {
  exportDailyFlowTable(
    startDate: $startDate
    endDate: $endDate
    municipalityId: $municipalityId
    orderBy: $orderBy
  )
}
    `;

/**
 * __useExportDailyFlowTableQuery__
 *
 * To run a query within a React component, call `useExportDailyFlowTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDailyFlowTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDailyFlowTableQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      municipalityId: // value for 'municipalityId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useExportDailyFlowTableQuery(baseOptions: Apollo.QueryHookOptions<ExportDailyFlowTableQuery, ExportDailyFlowTableQueryVariables> & ({ variables: ExportDailyFlowTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportDailyFlowTableQuery, ExportDailyFlowTableQueryVariables>(ExportDailyFlowTableDocument, options);
      }
export function useExportDailyFlowTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportDailyFlowTableQuery, ExportDailyFlowTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportDailyFlowTableQuery, ExportDailyFlowTableQueryVariables>(ExportDailyFlowTableDocument, options);
        }
export function useExportDailyFlowTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportDailyFlowTableQuery, ExportDailyFlowTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportDailyFlowTableQuery, ExportDailyFlowTableQueryVariables>(ExportDailyFlowTableDocument, options);
        }
export type ExportDailyFlowTableQueryHookResult = ReturnType<typeof useExportDailyFlowTableQuery>;
export type ExportDailyFlowTableLazyQueryHookResult = ReturnType<typeof useExportDailyFlowTableLazyQuery>;
export type ExportDailyFlowTableSuspenseQueryHookResult = ReturnType<typeof useExportDailyFlowTableSuspenseQuery>;
export type ExportDailyFlowTableQueryResult = Apollo.QueryResult<ExportDailyFlowTableQuery, ExportDailyFlowTableQueryVariables>;
export const GetDashboardQsRequestsActListDocument = gql`
    query getDashboardQSRequestsActList($year: Int!, $limit: Int!, $offset: Int!) {
  getDashboardQSRequestsActList(year: $year, limit: $limit, offset: $offset) {
    id_frequency_time_notification_response
    request_address
    request_infrastructure
    request_number
    time_passed_in_seconds
    symptom
    time_remaining_in_seconds
    time_over_in_seconds
    total_results
    time_notification_seconds
    time_limit_response_seconds
    id_frequency_time_limit_response
  }
}
    `;

/**
 * __useGetDashboardQsRequestsActListQuery__
 *
 * To run a query within a React component, call `useGetDashboardQsRequestsActListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQsRequestsActListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQsRequestsActListQuery({
 *   variables: {
 *      year: // value for 'year'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDashboardQsRequestsActListQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardQsRequestsActListQuery, GetDashboardQsRequestsActListQueryVariables> & ({ variables: GetDashboardQsRequestsActListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardQsRequestsActListQuery, GetDashboardQsRequestsActListQueryVariables>(GetDashboardQsRequestsActListDocument, options);
      }
export function useGetDashboardQsRequestsActListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardQsRequestsActListQuery, GetDashboardQsRequestsActListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardQsRequestsActListQuery, GetDashboardQsRequestsActListQueryVariables>(GetDashboardQsRequestsActListDocument, options);
        }
export function useGetDashboardQsRequestsActListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardQsRequestsActListQuery, GetDashboardQsRequestsActListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardQsRequestsActListQuery, GetDashboardQsRequestsActListQueryVariables>(GetDashboardQsRequestsActListDocument, options);
        }
export type GetDashboardQsRequestsActListQueryHookResult = ReturnType<typeof useGetDashboardQsRequestsActListQuery>;
export type GetDashboardQsRequestsActListLazyQueryHookResult = ReturnType<typeof useGetDashboardQsRequestsActListLazyQuery>;
export type GetDashboardQsRequestsActListSuspenseQueryHookResult = ReturnType<typeof useGetDashboardQsRequestsActListSuspenseQuery>;
export type GetDashboardQsRequestsActListQueryResult = Apollo.QueryResult<GetDashboardQsRequestsActListQuery, GetDashboardQsRequestsActListQueryVariables>;
export const GetDashboardQsRequestsDangerListDocument = gql`
    query getDashboardQSRequestsDangerList($year: Int!, $limit: Int!, $offset: Int!) {
  getDashboardQSRequestsDangerList(year: $year, limit: $limit, offset: $offset) {
    id_frequency_time_notification_response
    request_address
    request_infrastructure
    request_number
    time_passed_in_seconds
    symptom
    time_remaining_in_seconds
    time_over_in_seconds
    total_results
    time_notification_seconds
    time_limit_response_seconds
    id_frequency_time_limit_response
  }
}
    `;

/**
 * __useGetDashboardQsRequestsDangerListQuery__
 *
 * To run a query within a React component, call `useGetDashboardQsRequestsDangerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQsRequestsDangerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQsRequestsDangerListQuery({
 *   variables: {
 *      year: // value for 'year'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDashboardQsRequestsDangerListQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardQsRequestsDangerListQuery, GetDashboardQsRequestsDangerListQueryVariables> & ({ variables: GetDashboardQsRequestsDangerListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardQsRequestsDangerListQuery, GetDashboardQsRequestsDangerListQueryVariables>(GetDashboardQsRequestsDangerListDocument, options);
      }
export function useGetDashboardQsRequestsDangerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardQsRequestsDangerListQuery, GetDashboardQsRequestsDangerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardQsRequestsDangerListQuery, GetDashboardQsRequestsDangerListQueryVariables>(GetDashboardQsRequestsDangerListDocument, options);
        }
export function useGetDashboardQsRequestsDangerListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardQsRequestsDangerListQuery, GetDashboardQsRequestsDangerListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardQsRequestsDangerListQuery, GetDashboardQsRequestsDangerListQueryVariables>(GetDashboardQsRequestsDangerListDocument, options);
        }
export type GetDashboardQsRequestsDangerListQueryHookResult = ReturnType<typeof useGetDashboardQsRequestsDangerListQuery>;
export type GetDashboardQsRequestsDangerListLazyQueryHookResult = ReturnType<typeof useGetDashboardQsRequestsDangerListLazyQuery>;
export type GetDashboardQsRequestsDangerListSuspenseQueryHookResult = ReturnType<typeof useGetDashboardQsRequestsDangerListSuspenseQuery>;
export type GetDashboardQsRequestsDangerListQueryResult = Apollo.QueryResult<GetDashboardQsRequestsDangerListQuery, GetDashboardQsRequestsDangerListQueryVariables>;
export const GetIntegrationByIdDocument = gql`
    query GetIntegrationById($id: bigint!) {
  navia_integracoes(where: {id: {_eq: $id}}) {
    id
    activo
    descricao
  }
}
    `;

/**
 * __useGetIntegrationByIdQuery__
 *
 * To run a query within a React component, call `useGetIntegrationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationByIdQuery, GetIntegrationByIdQueryVariables> & ({ variables: GetIntegrationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationByIdQuery, GetIntegrationByIdQueryVariables>(GetIntegrationByIdDocument, options);
      }
export function useGetIntegrationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationByIdQuery, GetIntegrationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationByIdQuery, GetIntegrationByIdQueryVariables>(GetIntegrationByIdDocument, options);
        }
export function useGetIntegrationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationByIdQuery, GetIntegrationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationByIdQuery, GetIntegrationByIdQueryVariables>(GetIntegrationByIdDocument, options);
        }
export type GetIntegrationByIdQueryHookResult = ReturnType<typeof useGetIntegrationByIdQuery>;
export type GetIntegrationByIdLazyQueryHookResult = ReturnType<typeof useGetIntegrationByIdLazyQuery>;
export type GetIntegrationByIdSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationByIdSuspenseQuery>;
export type GetIntegrationByIdQueryResult = Apollo.QueryResult<GetIntegrationByIdQuery, GetIntegrationByIdQueryVariables>;
export const RequestsDocument = gql`
    query Requests($startDate: timestamp!, $endDate: timestamp!) {
  servicos_requisicoes(
    where: {apagado: {_eq: false}, data_hora: {_gte: $startDate, _lte: $endDate}}
  ) {
    id
    data_hora
    numero
    sintoma {
      id
      descricao
      id_no_tipo
      parentSymptom {
        id
        descricao
        id_no_tipo
        parentSymptom {
          id
          descricao
          id_no_tipo
          parentSymptom {
            id
            descricao
            id_no_tipo
            parentSymptom {
              id
              descricao
              id_no_tipo
            }
          }
        }
      }
    }
    estado {
      id
      descricao
    }
    rastreabilidadeOrigem(
      where: {apagado: {_eq: false}, id_requisicao_origem: {_is_null: false}, id_intervencao_destino: {_is_null: false}}
    ) {
      id
      apagado
      id_requisicao_destino
      id_requisicao_origem
      id_intervencao_destino
      id_intervencao_origem
      intervencaoDestino {
        id
        estado {
          id
          descricao
        }
      }
    }
    locaisInfraestruturas {
      id
      infraestrutura {
        id
        infraestruturaCoordenadas(where: {principal: {_eq: true}}) {
          id
          latitude
          longitude
        }
      }
      toponimia {
        id
        toponimiaCoordenadas(where: {principal: {_eq: true}}) {
          id
          latitude
          longitude
        }
      }
    }
    coordenadasMobile(where: {id_origem: {_eq: 5}}) {
      id
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useRequestsQuery__
 *
 * To run a query within a React component, call `useRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useRequestsQuery(baseOptions: Apollo.QueryHookOptions<RequestsQuery, RequestsQueryVariables> & ({ variables: RequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestsQuery, RequestsQueryVariables>(RequestsDocument, options);
      }
export function useRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestsQuery, RequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestsQuery, RequestsQueryVariables>(RequestsDocument, options);
        }
export function useRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestsQuery, RequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestsQuery, RequestsQueryVariables>(RequestsDocument, options);
        }
export type RequestsQueryHookResult = ReturnType<typeof useRequestsQuery>;
export type RequestsLazyQueryHookResult = ReturnType<typeof useRequestsLazyQuery>;
export type RequestsSuspenseQueryHookResult = ReturnType<typeof useRequestsSuspenseQuery>;
export type RequestsQueryResult = Apollo.QueryResult<RequestsQuery, RequestsQueryVariables>;
export const RequestsParameterizationDocument = gql`
    query RequestsParameterization {
  navia_dashboards_requisicoes_indicadores_parametrizacao {
    id
    variavelMarcacao {
      id
      descricao
      fonteOrigem {
        id
      }
    }
    atraso_segundos
    limite_inferior_segundos
    limite_superior_segundos
  }
  navia_dashboards_requisicoes_mapa_parametrizacao(order_by: {id: asc}) {
    id
    descricao
    cor {
      id
      cor_modo_claro
      cor_modo_escuro
    }
  }
  utilizadores_mapa_posicao_cores {
    id
    limite_superior
    cor_modo_claro
    cor_modo_escuro
  }
}
    `;

/**
 * __useRequestsParameterizationQuery__
 *
 * To run a query within a React component, call `useRequestsParameterizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestsParameterizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestsParameterizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useRequestsParameterizationQuery(baseOptions?: Apollo.QueryHookOptions<RequestsParameterizationQuery, RequestsParameterizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestsParameterizationQuery, RequestsParameterizationQueryVariables>(RequestsParameterizationDocument, options);
      }
export function useRequestsParameterizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestsParameterizationQuery, RequestsParameterizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestsParameterizationQuery, RequestsParameterizationQueryVariables>(RequestsParameterizationDocument, options);
        }
export function useRequestsParameterizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestsParameterizationQuery, RequestsParameterizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestsParameterizationQuery, RequestsParameterizationQueryVariables>(RequestsParameterizationDocument, options);
        }
export type RequestsParameterizationQueryHookResult = ReturnType<typeof useRequestsParameterizationQuery>;
export type RequestsParameterizationLazyQueryHookResult = ReturnType<typeof useRequestsParameterizationLazyQuery>;
export type RequestsParameterizationSuspenseQueryHookResult = ReturnType<typeof useRequestsParameterizationSuspenseQuery>;
export type RequestsParameterizationQueryResult = Apollo.QueryResult<RequestsParameterizationQuery, RequestsParameterizationQueryVariables>;
export const RequestsWithMarkingVariableDocument = gql`
    query RequestsWithMarkingVariable($markingVariableId: bigint!, $startDate: timestamp!, $endDate: timestamp!) {
  servicos_requisicoes(
    where: {apagado: {_eq: false}, id_estado: {_in: [1, 2]}, data_hora: {_gte: $startDate, _lte: $endDate}, _or: [{_not: {rastreabilidadeOrigem: {}}}, {rastreabilidadeOrigem: {apagado: {_eq: false}, intervencaoDestino: {id_estado: {_neq: 3}}}}], leituras: {fonteOrigem: {id_variavel_base: {_eq: $markingVariableId}}}}
  ) {
    id
    data_hora
    leituras(where: {fonteOrigem: {id_variavel_base: {_eq: $markingVariableId}}}) {
      id
      valor_data
    }
  }
}
    `;

/**
 * __useRequestsWithMarkingVariableQuery__
 *
 * To run a query within a React component, call `useRequestsWithMarkingVariableQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestsWithMarkingVariableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestsWithMarkingVariableQuery({
 *   variables: {
 *      markingVariableId: // value for 'markingVariableId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useRequestsWithMarkingVariableQuery(baseOptions: Apollo.QueryHookOptions<RequestsWithMarkingVariableQuery, RequestsWithMarkingVariableQueryVariables> & ({ variables: RequestsWithMarkingVariableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestsWithMarkingVariableQuery, RequestsWithMarkingVariableQueryVariables>(RequestsWithMarkingVariableDocument, options);
      }
export function useRequestsWithMarkingVariableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestsWithMarkingVariableQuery, RequestsWithMarkingVariableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestsWithMarkingVariableQuery, RequestsWithMarkingVariableQueryVariables>(RequestsWithMarkingVariableDocument, options);
        }
export function useRequestsWithMarkingVariableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestsWithMarkingVariableQuery, RequestsWithMarkingVariableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestsWithMarkingVariableQuery, RequestsWithMarkingVariableQueryVariables>(RequestsWithMarkingVariableDocument, options);
        }
export type RequestsWithMarkingVariableQueryHookResult = ReturnType<typeof useRequestsWithMarkingVariableQuery>;
export type RequestsWithMarkingVariableLazyQueryHookResult = ReturnType<typeof useRequestsWithMarkingVariableLazyQuery>;
export type RequestsWithMarkingVariableSuspenseQueryHookResult = ReturnType<typeof useRequestsWithMarkingVariableSuspenseQuery>;
export type RequestsWithMarkingVariableQueryResult = Apollo.QueryResult<RequestsWithMarkingVariableQuery, RequestsWithMarkingVariableQueryVariables>;
export const MapParameterizationDocument = gql`
    query MapParameterization {
  integracoes_sig_parametrizacao {
    latitude
    longitude
    zoom_default
    url_services
    map_server
    type
  }
  navia_integracoes_by_pk(id: 7) {
    id
    descricao
    activo
  }
  integracoes_sig_proxy(where: {apagado: {_eq: false}, ativo: {_eq: true}}) {
    id
    url
  }
  integracoes_sig_services(distinct_on: title, where: {apagado: {_eq: false}}) {
    id
    url
    title
    id_type_service
    visibility_default
    opacity
  }
}
    `;

/**
 * __useMapParameterizationQuery__
 *
 * To run a query within a React component, call `useMapParameterizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapParameterizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapParameterizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useMapParameterizationQuery(baseOptions?: Apollo.QueryHookOptions<MapParameterizationQuery, MapParameterizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MapParameterizationQuery, MapParameterizationQueryVariables>(MapParameterizationDocument, options);
      }
export function useMapParameterizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MapParameterizationQuery, MapParameterizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MapParameterizationQuery, MapParameterizationQueryVariables>(MapParameterizationDocument, options);
        }
export function useMapParameterizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MapParameterizationQuery, MapParameterizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MapParameterizationQuery, MapParameterizationQueryVariables>(MapParameterizationDocument, options);
        }
export type MapParameterizationQueryHookResult = ReturnType<typeof useMapParameterizationQuery>;
export type MapParameterizationLazyQueryHookResult = ReturnType<typeof useMapParameterizationLazyQuery>;
export type MapParameterizationSuspenseQueryHookResult = ReturnType<typeof useMapParameterizationSuspenseQuery>;
export type MapParameterizationQueryResult = Apollo.QueryResult<MapParameterizationQuery, MapParameterizationQueryVariables>;
export const MobileCoordinatesDocument = gql`
    query MobileCoordinates($startDate: timestamp!, $endDate: timestamp!) {
  mobile_coordenadas(
    where: {data_hora: {_gte: $startDate, _lte: $endDate}, id_utilizador: {_is_null: false}}
    distinct_on: key
    order_by: [{key: asc}, {data_hora: desc}]
  ) {
    id
    key
    data_hora
    latitude
    longitude
    utilizador {
      id
      descricao
    }
  }
}
    `;

/**
 * __useMobileCoordinatesQuery__
 *
 * To run a query within a React component, call `useMobileCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMobileCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMobileCoordinatesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useMobileCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<MobileCoordinatesQuery, MobileCoordinatesQueryVariables> & ({ variables: MobileCoordinatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MobileCoordinatesQuery, MobileCoordinatesQueryVariables>(MobileCoordinatesDocument, options);
      }
export function useMobileCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MobileCoordinatesQuery, MobileCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MobileCoordinatesQuery, MobileCoordinatesQueryVariables>(MobileCoordinatesDocument, options);
        }
export function useMobileCoordinatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MobileCoordinatesQuery, MobileCoordinatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MobileCoordinatesQuery, MobileCoordinatesQueryVariables>(MobileCoordinatesDocument, options);
        }
export type MobileCoordinatesQueryHookResult = ReturnType<typeof useMobileCoordinatesQuery>;
export type MobileCoordinatesLazyQueryHookResult = ReturnType<typeof useMobileCoordinatesLazyQuery>;
export type MobileCoordinatesSuspenseQueryHookResult = ReturnType<typeof useMobileCoordinatesSuspenseQuery>;
export type MobileCoordinatesQueryResult = Apollo.QueryResult<MobileCoordinatesQuery, MobileCoordinatesQueryVariables>;
export const UserAgendaDocument = gql`
    query UserAgenda($limit: Int, $offset: Int, $userId: bigint!, $endDate: timestamp!, $orderBy: [user_agenda_model_order_by!]) {
  user_agenda(
    args: {userId: $userId, endDate: $endDate}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    id
    numero
    sintoma
    data_planeada
    local
    tipo
  }
}
    `;

/**
 * __useUserAgendaQuery__
 *
 * To run a query within a React component, call `useUserAgendaQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAgendaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAgendaQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      userId: // value for 'userId'
 *      endDate: // value for 'endDate'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUserAgendaQuery(baseOptions: Apollo.QueryHookOptions<UserAgendaQuery, UserAgendaQueryVariables> & ({ variables: UserAgendaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAgendaQuery, UserAgendaQueryVariables>(UserAgendaDocument, options);
      }
export function useUserAgendaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAgendaQuery, UserAgendaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAgendaQuery, UserAgendaQueryVariables>(UserAgendaDocument, options);
        }
export function useUserAgendaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserAgendaQuery, UserAgendaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserAgendaQuery, UserAgendaQueryVariables>(UserAgendaDocument, options);
        }
export type UserAgendaQueryHookResult = ReturnType<typeof useUserAgendaQuery>;
export type UserAgendaLazyQueryHookResult = ReturnType<typeof useUserAgendaLazyQuery>;
export type UserAgendaSuspenseQueryHookResult = ReturnType<typeof useUserAgendaSuspenseQuery>;
export type UserAgendaQueryResult = Apollo.QueryResult<UserAgendaQuery, UserAgendaQueryVariables>;
export const ColorsDocument = gql`
    query Colors {
  navia_cores(order_by: {ordem: asc}) {
    id
    cor_modo_claro
    cor_modo_escuro
  }
}
    `;

/**
 * __useColorsQuery__
 *
 * To run a query within a React component, call `useColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useColorsQuery(baseOptions?: Apollo.QueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
      }
export function useColorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
        }
export function useColorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
        }
export type ColorsQueryHookResult = ReturnType<typeof useColorsQuery>;
export type ColorsLazyQueryHookResult = ReturnType<typeof useColorsLazyQuery>;
export type ColorsSuspenseQueryHookResult = ReturnType<typeof useColorsSuspenseQuery>;
export type ColorsQueryResult = Apollo.QueryResult<ColorsQuery, ColorsQueryVariables>;
export const LeakMonitoringSymptomsDocument = gql`
    query LeakMonitoringSymptoms {
  navia_dashboards_monitorizacao_roturas_sintomas(order_by: {id: asc}) {
    id
    indicador
    sintomas {
      id
      sintoma_id
      sintoma {
        id
        descricao
      }
    }
  }
}
    `;

/**
 * __useLeakMonitoringSymptomsQuery__
 *
 * To run a query within a React component, call `useLeakMonitoringSymptomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeakMonitoringSymptomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeakMonitoringSymptomsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeakMonitoringSymptomsQuery(baseOptions?: Apollo.QueryHookOptions<LeakMonitoringSymptomsQuery, LeakMonitoringSymptomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeakMonitoringSymptomsQuery, LeakMonitoringSymptomsQueryVariables>(LeakMonitoringSymptomsDocument, options);
      }
export function useLeakMonitoringSymptomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeakMonitoringSymptomsQuery, LeakMonitoringSymptomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeakMonitoringSymptomsQuery, LeakMonitoringSymptomsQueryVariables>(LeakMonitoringSymptomsDocument, options);
        }
export function useLeakMonitoringSymptomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeakMonitoringSymptomsQuery, LeakMonitoringSymptomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeakMonitoringSymptomsQuery, LeakMonitoringSymptomsQueryVariables>(LeakMonitoringSymptomsDocument, options);
        }
export type LeakMonitoringSymptomsQueryHookResult = ReturnType<typeof useLeakMonitoringSymptomsQuery>;
export type LeakMonitoringSymptomsLazyQueryHookResult = ReturnType<typeof useLeakMonitoringSymptomsLazyQuery>;
export type LeakMonitoringSymptomsSuspenseQueryHookResult = ReturnType<typeof useLeakMonitoringSymptomsSuspenseQuery>;
export type LeakMonitoringSymptomsQueryResult = Apollo.QueryResult<LeakMonitoringSymptomsQuery, LeakMonitoringSymptomsQueryVariables>;
export const LeakMonitoringCausesDocument = gql`
    query LeakMonitoringCauses {
  navia_dashboards_monitorizacao_roturas_causas(order_by: {id: asc}) {
    id
    categoria
    cor_id
    cor {
      id
      cor_modo_claro
      cor_modo_escuro
    }
    causas {
      id
      monitorizacao_roturas_causa_id
      causa {
        id
        descricao
      }
    }
  }
}
    `;

/**
 * __useLeakMonitoringCausesQuery__
 *
 * To run a query within a React component, call `useLeakMonitoringCausesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeakMonitoringCausesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeakMonitoringCausesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeakMonitoringCausesQuery(baseOptions?: Apollo.QueryHookOptions<LeakMonitoringCausesQuery, LeakMonitoringCausesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeakMonitoringCausesQuery, LeakMonitoringCausesQueryVariables>(LeakMonitoringCausesDocument, options);
      }
export function useLeakMonitoringCausesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeakMonitoringCausesQuery, LeakMonitoringCausesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeakMonitoringCausesQuery, LeakMonitoringCausesQueryVariables>(LeakMonitoringCausesDocument, options);
        }
export function useLeakMonitoringCausesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeakMonitoringCausesQuery, LeakMonitoringCausesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeakMonitoringCausesQuery, LeakMonitoringCausesQueryVariables>(LeakMonitoringCausesDocument, options);
        }
export type LeakMonitoringCausesQueryHookResult = ReturnType<typeof useLeakMonitoringCausesQuery>;
export type LeakMonitoringCausesLazyQueryHookResult = ReturnType<typeof useLeakMonitoringCausesLazyQuery>;
export type LeakMonitoringCausesSuspenseQueryHookResult = ReturnType<typeof useLeakMonitoringCausesSuspenseQuery>;
export type LeakMonitoringCausesQueryResult = Apollo.QueryResult<LeakMonitoringCausesQuery, LeakMonitoringCausesQueryVariables>;
export const LeakMonitoringVariablesDocument = gql`
    query LeakMonitoringVariables {
  navia_dashboards_monitorizacao_roturas_variaveis(order_by: {id: asc}) {
    id
    indicador
    variavel {
      id
      descricao
      fonteOrigem(where: {apagado: {_eq: false}}) {
        id
      }
    }
    fase {
      id
      descricao
    }
  }
}
    `;

/**
 * __useLeakMonitoringVariablesQuery__
 *
 * To run a query within a React component, call `useLeakMonitoringVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeakMonitoringVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeakMonitoringVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeakMonitoringVariablesQuery(baseOptions?: Apollo.QueryHookOptions<LeakMonitoringVariablesQuery, LeakMonitoringVariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeakMonitoringVariablesQuery, LeakMonitoringVariablesQueryVariables>(LeakMonitoringVariablesDocument, options);
      }
export function useLeakMonitoringVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeakMonitoringVariablesQuery, LeakMonitoringVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeakMonitoringVariablesQuery, LeakMonitoringVariablesQueryVariables>(LeakMonitoringVariablesDocument, options);
        }
export function useLeakMonitoringVariablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeakMonitoringVariablesQuery, LeakMonitoringVariablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeakMonitoringVariablesQuery, LeakMonitoringVariablesQueryVariables>(LeakMonitoringVariablesDocument, options);
        }
export type LeakMonitoringVariablesQueryHookResult = ReturnType<typeof useLeakMonitoringVariablesQuery>;
export type LeakMonitoringVariablesLazyQueryHookResult = ReturnType<typeof useLeakMonitoringVariablesLazyQuery>;
export type LeakMonitoringVariablesSuspenseQueryHookResult = ReturnType<typeof useLeakMonitoringVariablesSuspenseQuery>;
export type LeakMonitoringVariablesQueryResult = Apollo.QueryResult<LeakMonitoringVariablesQuery, LeakMonitoringVariablesQueryVariables>;
export const LeakDiagnosisSymptomsDocument = gql`
    query LeakDiagnosisSymptoms {
  navia_dashboards_diagnostico_roturas_sintomas(order_by: {id: asc}) {
    id
    tipo
    sintoma {
      id
      descricao
    }
  }
}
    `;

/**
 * __useLeakDiagnosisSymptomsQuery__
 *
 * To run a query within a React component, call `useLeakDiagnosisSymptomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeakDiagnosisSymptomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeakDiagnosisSymptomsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeakDiagnosisSymptomsQuery(baseOptions?: Apollo.QueryHookOptions<LeakDiagnosisSymptomsQuery, LeakDiagnosisSymptomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeakDiagnosisSymptomsQuery, LeakDiagnosisSymptomsQueryVariables>(LeakDiagnosisSymptomsDocument, options);
      }
export function useLeakDiagnosisSymptomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeakDiagnosisSymptomsQuery, LeakDiagnosisSymptomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeakDiagnosisSymptomsQuery, LeakDiagnosisSymptomsQueryVariables>(LeakDiagnosisSymptomsDocument, options);
        }
export function useLeakDiagnosisSymptomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeakDiagnosisSymptomsQuery, LeakDiagnosisSymptomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeakDiagnosisSymptomsQuery, LeakDiagnosisSymptomsQueryVariables>(LeakDiagnosisSymptomsDocument, options);
        }
export type LeakDiagnosisSymptomsQueryHookResult = ReturnType<typeof useLeakDiagnosisSymptomsQuery>;
export type LeakDiagnosisSymptomsLazyQueryHookResult = ReturnType<typeof useLeakDiagnosisSymptomsLazyQuery>;
export type LeakDiagnosisSymptomsSuspenseQueryHookResult = ReturnType<typeof useLeakDiagnosisSymptomsSuspenseQuery>;
export type LeakDiagnosisSymptomsQueryResult = Apollo.QueryResult<LeakDiagnosisSymptomsQuery, LeakDiagnosisSymptomsQueryVariables>;
export const LeakDiagnosisInfrastructuresDocument = gql`
    query LeakDiagnosisInfrastructures {
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura(
    order_by: {tipo_infraestrutura_id: asc}
  ) {
    tipo_infraestrutura_id
    infraestruturaTipo {
      id
      descricao
      codigo_externo
      id_sig_service
    }
  }
  navia_dashboards_diagnostico_roturas_infraestruturas_variaveis(
    order_by: {id: asc}
  ) {
    id
    variavel {
      id
      descricao
      parametro {
        id
        descricao
        parametroUnidadesMedida {
          id
          fator_multiplicativo_numerico
          unidadeMedida {
            id
            descricao
          }
        }
      }
      fonteOrigem(where: {apagado: {_eq: false}}) {
        id
        descricao
        apagado
      }
    }
    unidade_medida_id
  }
}
    `;

/**
 * __useLeakDiagnosisInfrastructuresQuery__
 *
 * To run a query within a React component, call `useLeakDiagnosisInfrastructuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeakDiagnosisInfrastructuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeakDiagnosisInfrastructuresQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeakDiagnosisInfrastructuresQuery(baseOptions?: Apollo.QueryHookOptions<LeakDiagnosisInfrastructuresQuery, LeakDiagnosisInfrastructuresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeakDiagnosisInfrastructuresQuery, LeakDiagnosisInfrastructuresQueryVariables>(LeakDiagnosisInfrastructuresDocument, options);
      }
export function useLeakDiagnosisInfrastructuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeakDiagnosisInfrastructuresQuery, LeakDiagnosisInfrastructuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeakDiagnosisInfrastructuresQuery, LeakDiagnosisInfrastructuresQueryVariables>(LeakDiagnosisInfrastructuresDocument, options);
        }
export function useLeakDiagnosisInfrastructuresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeakDiagnosisInfrastructuresQuery, LeakDiagnosisInfrastructuresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeakDiagnosisInfrastructuresQuery, LeakDiagnosisInfrastructuresQueryVariables>(LeakDiagnosisInfrastructuresDocument, options);
        }
export type LeakDiagnosisInfrastructuresQueryHookResult = ReturnType<typeof useLeakDiagnosisInfrastructuresQuery>;
export type LeakDiagnosisInfrastructuresLazyQueryHookResult = ReturnType<typeof useLeakDiagnosisInfrastructuresLazyQuery>;
export type LeakDiagnosisInfrastructuresSuspenseQueryHookResult = ReturnType<typeof useLeakDiagnosisInfrastructuresSuspenseQuery>;
export type LeakDiagnosisInfrastructuresQueryResult = Apollo.QueryResult<LeakDiagnosisInfrastructuresQuery, LeakDiagnosisInfrastructuresQueryVariables>;
export const LeakDiagnosisMapDocument = gql`
    query LeakDiagnosisMap {
  navia_dashboards_diagnostico_roturas_tipos_infraestrutura_zmc {
    tipo_infraestrutura_id
    infraestruturaTipo {
      id
      descricao
      codigo_externo
    }
  }
  navia_dashboards_diagnostico_roturas_mapa_niveis {
    id
    min
    max
  }
}
    `;

/**
 * __useLeakDiagnosisMapQuery__
 *
 * To run a query within a React component, call `useLeakDiagnosisMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeakDiagnosisMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeakDiagnosisMapQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeakDiagnosisMapQuery(baseOptions?: Apollo.QueryHookOptions<LeakDiagnosisMapQuery, LeakDiagnosisMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeakDiagnosisMapQuery, LeakDiagnosisMapQueryVariables>(LeakDiagnosisMapDocument, options);
      }
export function useLeakDiagnosisMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeakDiagnosisMapQuery, LeakDiagnosisMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeakDiagnosisMapQuery, LeakDiagnosisMapQueryVariables>(LeakDiagnosisMapDocument, options);
        }
export function useLeakDiagnosisMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeakDiagnosisMapQuery, LeakDiagnosisMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeakDiagnosisMapQuery, LeakDiagnosisMapQueryVariables>(LeakDiagnosisMapDocument, options);
        }
export type LeakDiagnosisMapQueryHookResult = ReturnType<typeof useLeakDiagnosisMapQuery>;
export type LeakDiagnosisMapLazyQueryHookResult = ReturnType<typeof useLeakDiagnosisMapLazyQuery>;
export type LeakDiagnosisMapSuspenseQueryHookResult = ReturnType<typeof useLeakDiagnosisMapSuspenseQuery>;
export type LeakDiagnosisMapQueryResult = Apollo.QueryResult<LeakDiagnosisMapQuery, LeakDiagnosisMapQueryVariables>;
export const PipesRehabilitationRateDocument = gql`
    query PipesRehabilitationRate($endDate: Date!) {
  getPipeRehabilitationRate(endDate: $endDate) {
    avg_length_10y
    rehab_5y_length_sum
    pipe_rehabilitation_rate
  }
}
    `;

/**
 * __usePipesRehabilitationRateQuery__
 *
 * To run a query within a React component, call `usePipesRehabilitationRateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipesRehabilitationRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipesRehabilitationRateQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function usePipesRehabilitationRateQuery(baseOptions: Apollo.QueryHookOptions<PipesRehabilitationRateQuery, PipesRehabilitationRateQueryVariables> & ({ variables: PipesRehabilitationRateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipesRehabilitationRateQuery, PipesRehabilitationRateQueryVariables>(PipesRehabilitationRateDocument, options);
      }
export function usePipesRehabilitationRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipesRehabilitationRateQuery, PipesRehabilitationRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipesRehabilitationRateQuery, PipesRehabilitationRateQueryVariables>(PipesRehabilitationRateDocument, options);
        }
export function usePipesRehabilitationRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipesRehabilitationRateQuery, PipesRehabilitationRateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipesRehabilitationRateQuery, PipesRehabilitationRateQueryVariables>(PipesRehabilitationRateDocument, options);
        }
export type PipesRehabilitationRateQueryHookResult = ReturnType<typeof usePipesRehabilitationRateQuery>;
export type PipesRehabilitationRateLazyQueryHookResult = ReturnType<typeof usePipesRehabilitationRateLazyQuery>;
export type PipesRehabilitationRateSuspenseQueryHookResult = ReturnType<typeof usePipesRehabilitationRateSuspenseQuery>;
export type PipesRehabilitationRateQueryResult = Apollo.QueryResult<PipesRehabilitationRateQuery, PipesRehabilitationRateQueryVariables>;
export const AvgPipesAgeDocument = gql`
    query AvgPipesAge($endDate: Date!) {
  getPipesAgeAverage(endDate: $endDate) {
    avg
  }
}
    `;

/**
 * __useAvgPipesAgeQuery__
 *
 * To run a query within a React component, call `useAvgPipesAgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvgPipesAgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvgPipesAgeQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAvgPipesAgeQuery(baseOptions: Apollo.QueryHookOptions<AvgPipesAgeQuery, AvgPipesAgeQueryVariables> & ({ variables: AvgPipesAgeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvgPipesAgeQuery, AvgPipesAgeQueryVariables>(AvgPipesAgeDocument, options);
      }
export function useAvgPipesAgeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvgPipesAgeQuery, AvgPipesAgeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvgPipesAgeQuery, AvgPipesAgeQueryVariables>(AvgPipesAgeDocument, options);
        }
export function useAvgPipesAgeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvgPipesAgeQuery, AvgPipesAgeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvgPipesAgeQuery, AvgPipesAgeQueryVariables>(AvgPipesAgeDocument, options);
        }
export type AvgPipesAgeQueryHookResult = ReturnType<typeof useAvgPipesAgeQuery>;
export type AvgPipesAgeLazyQueryHookResult = ReturnType<typeof useAvgPipesAgeLazyQuery>;
export type AvgPipesAgeSuspenseQueryHookResult = ReturnType<typeof useAvgPipesAgeSuspenseQuery>;
export type AvgPipesAgeQueryResult = Apollo.QueryResult<AvgPipesAgeQuery, AvgPipesAgeQueryVariables>;
export const PipesNetworkIntegrityDocument = gql`
    query PipesNetworkIntegrity($startDate: Date!, $endDate: Date!) {
  getNetworkIntegrity(startDate: $startDate, endDate: $endDate) {
    pipes_count
    interv_count
    network_integrity
  }
}
    `;

/**
 * __usePipesNetworkIntegrityQuery__
 *
 * To run a query within a React component, call `usePipesNetworkIntegrityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipesNetworkIntegrityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipesNetworkIntegrityQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function usePipesNetworkIntegrityQuery(baseOptions: Apollo.QueryHookOptions<PipesNetworkIntegrityQuery, PipesNetworkIntegrityQueryVariables> & ({ variables: PipesNetworkIntegrityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipesNetworkIntegrityQuery, PipesNetworkIntegrityQueryVariables>(PipesNetworkIntegrityDocument, options);
      }
export function usePipesNetworkIntegrityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipesNetworkIntegrityQuery, PipesNetworkIntegrityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipesNetworkIntegrityQuery, PipesNetworkIntegrityQueryVariables>(PipesNetworkIntegrityDocument, options);
        }
export function usePipesNetworkIntegritySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipesNetworkIntegrityQuery, PipesNetworkIntegrityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipesNetworkIntegrityQuery, PipesNetworkIntegrityQueryVariables>(PipesNetworkIntegrityDocument, options);
        }
export type PipesNetworkIntegrityQueryHookResult = ReturnType<typeof usePipesNetworkIntegrityQuery>;
export type PipesNetworkIntegrityLazyQueryHookResult = ReturnType<typeof usePipesNetworkIntegrityLazyQuery>;
export type PipesNetworkIntegritySuspenseQueryHookResult = ReturnType<typeof usePipesNetworkIntegritySuspenseQuery>;
export type PipesNetworkIntegrityQueryResult = Apollo.QueryResult<PipesNetworkIntegrityQuery, PipesNetworkIntegrityQueryVariables>;
export const LeaksPerDistanceDocument = gql`
    query LeaksPerDistance($startDate: Date!, $endDate: Date!) {
  getLeaksPerDistance(startDate: $startDate, endDate: $endDate) {
    interv_count
    leaks_per_distance
    length_sum
    unit
    multiplier
  }
}
    `;

/**
 * __useLeaksPerDistanceQuery__
 *
 * To run a query within a React component, call `useLeaksPerDistanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaksPerDistanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaksPerDistanceQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useLeaksPerDistanceQuery(baseOptions: Apollo.QueryHookOptions<LeaksPerDistanceQuery, LeaksPerDistanceQueryVariables> & ({ variables: LeaksPerDistanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaksPerDistanceQuery, LeaksPerDistanceQueryVariables>(LeaksPerDistanceDocument, options);
      }
export function useLeaksPerDistanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaksPerDistanceQuery, LeaksPerDistanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaksPerDistanceQuery, LeaksPerDistanceQueryVariables>(LeaksPerDistanceDocument, options);
        }
export function useLeaksPerDistanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeaksPerDistanceQuery, LeaksPerDistanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeaksPerDistanceQuery, LeaksPerDistanceQueryVariables>(LeaksPerDistanceDocument, options);
        }
export type LeaksPerDistanceQueryHookResult = ReturnType<typeof useLeaksPerDistanceQuery>;
export type LeaksPerDistanceLazyQueryHookResult = ReturnType<typeof useLeaksPerDistanceLazyQuery>;
export type LeaksPerDistanceSuspenseQueryHookResult = ReturnType<typeof useLeaksPerDistanceSuspenseQuery>;
export type LeaksPerDistanceQueryResult = Apollo.QueryResult<LeaksPerDistanceQuery, LeaksPerDistanceQueryVariables>;
export const PipesFailureRecurrenceRateDocument = gql`
    query PipesFailureRecurrenceRate($startDate: Date!, $endDate: Date!) {
  getFailureRecurrenceRate(startDate: $startDate, endDate: $endDate) {
    pipes_count
    pipes_with_more_than_1
    failure_recurrence_rate
  }
}
    `;

/**
 * __usePipesFailureRecurrenceRateQuery__
 *
 * To run a query within a React component, call `usePipesFailureRecurrenceRateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipesFailureRecurrenceRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipesFailureRecurrenceRateQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function usePipesFailureRecurrenceRateQuery(baseOptions: Apollo.QueryHookOptions<PipesFailureRecurrenceRateQuery, PipesFailureRecurrenceRateQueryVariables> & ({ variables: PipesFailureRecurrenceRateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipesFailureRecurrenceRateQuery, PipesFailureRecurrenceRateQueryVariables>(PipesFailureRecurrenceRateDocument, options);
      }
export function usePipesFailureRecurrenceRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipesFailureRecurrenceRateQuery, PipesFailureRecurrenceRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipesFailureRecurrenceRateQuery, PipesFailureRecurrenceRateQueryVariables>(PipesFailureRecurrenceRateDocument, options);
        }
export function usePipesFailureRecurrenceRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipesFailureRecurrenceRateQuery, PipesFailureRecurrenceRateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipesFailureRecurrenceRateQuery, PipesFailureRecurrenceRateQueryVariables>(PipesFailureRecurrenceRateDocument, options);
        }
export type PipesFailureRecurrenceRateQueryHookResult = ReturnType<typeof usePipesFailureRecurrenceRateQuery>;
export type PipesFailureRecurrenceRateLazyQueryHookResult = ReturnType<typeof usePipesFailureRecurrenceRateLazyQuery>;
export type PipesFailureRecurrenceRateSuspenseQueryHookResult = ReturnType<typeof usePipesFailureRecurrenceRateSuspenseQuery>;
export type PipesFailureRecurrenceRateQueryResult = Apollo.QueryResult<PipesFailureRecurrenceRateQuery, PipesFailureRecurrenceRateQueryVariables>;
export const Top5PipesWithMostLeaksDocument = gql`
    query Top5PipesWithMostLeaks($startDate: Date!, $endDate: Date!) {
  getTop5PipesWithMostLeaks(startDate: $startDate, endDate: $endDate) {
    id
    descricao
    i_codigo_externo
    t_codigo_externo
    sig_atributo_id
    interv_count
  }
}
    `;

/**
 * __useTop5PipesWithMostLeaksQuery__
 *
 * To run a query within a React component, call `useTop5PipesWithMostLeaksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTop5PipesWithMostLeaksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTop5PipesWithMostLeaksQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useTop5PipesWithMostLeaksQuery(baseOptions: Apollo.QueryHookOptions<Top5PipesWithMostLeaksQuery, Top5PipesWithMostLeaksQueryVariables> & ({ variables: Top5PipesWithMostLeaksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Top5PipesWithMostLeaksQuery, Top5PipesWithMostLeaksQueryVariables>(Top5PipesWithMostLeaksDocument, options);
      }
export function useTop5PipesWithMostLeaksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Top5PipesWithMostLeaksQuery, Top5PipesWithMostLeaksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Top5PipesWithMostLeaksQuery, Top5PipesWithMostLeaksQueryVariables>(Top5PipesWithMostLeaksDocument, options);
        }
export function useTop5PipesWithMostLeaksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Top5PipesWithMostLeaksQuery, Top5PipesWithMostLeaksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Top5PipesWithMostLeaksQuery, Top5PipesWithMostLeaksQueryVariables>(Top5PipesWithMostLeaksDocument, options);
        }
export type Top5PipesWithMostLeaksQueryHookResult = ReturnType<typeof useTop5PipesWithMostLeaksQuery>;
export type Top5PipesWithMostLeaksLazyQueryHookResult = ReturnType<typeof useTop5PipesWithMostLeaksLazyQuery>;
export type Top5PipesWithMostLeaksSuspenseQueryHookResult = ReturnType<typeof useTop5PipesWithMostLeaksSuspenseQuery>;
export type Top5PipesWithMostLeaksQueryResult = Apollo.QueryResult<Top5PipesWithMostLeaksQuery, Top5PipesWithMostLeaksQueryVariables>;
export const PipeReadingsByMaterialDocument = gql`
    query PipeReadingsByMaterial($startDate: Date!, $endDate: Date!) {
  getPipeReadingsByMaterial(startDate: $startDate, endDate: $endDate) {
    id
    id_fonte_origem
    valor_texto
    dominio
    dominio_valor
    data_hora
  }
}
    `;

/**
 * __usePipeReadingsByMaterialQuery__
 *
 * To run a query within a React component, call `usePipeReadingsByMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipeReadingsByMaterialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipeReadingsByMaterialQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function usePipeReadingsByMaterialQuery(baseOptions: Apollo.QueryHookOptions<PipeReadingsByMaterialQuery, PipeReadingsByMaterialQueryVariables> & ({ variables: PipeReadingsByMaterialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipeReadingsByMaterialQuery, PipeReadingsByMaterialQueryVariables>(PipeReadingsByMaterialDocument, options);
      }
export function usePipeReadingsByMaterialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipeReadingsByMaterialQuery, PipeReadingsByMaterialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipeReadingsByMaterialQuery, PipeReadingsByMaterialQueryVariables>(PipeReadingsByMaterialDocument, options);
        }
export function usePipeReadingsByMaterialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipeReadingsByMaterialQuery, PipeReadingsByMaterialQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipeReadingsByMaterialQuery, PipeReadingsByMaterialQueryVariables>(PipeReadingsByMaterialDocument, options);
        }
export type PipeReadingsByMaterialQueryHookResult = ReturnType<typeof usePipeReadingsByMaterialQuery>;
export type PipeReadingsByMaterialLazyQueryHookResult = ReturnType<typeof usePipeReadingsByMaterialLazyQuery>;
export type PipeReadingsByMaterialSuspenseQueryHookResult = ReturnType<typeof usePipeReadingsByMaterialSuspenseQuery>;
export type PipeReadingsByMaterialQueryResult = Apollo.QueryResult<PipeReadingsByMaterialQuery, PipeReadingsByMaterialQueryVariables>;
export const AgeVsLeakFrequencyDocument = gql`
    query AgeVsLeakFrequency($startDate: Date!, $endDate: Date!) {
  getAgeVsLeaksFrequency(startDate: $startDate, endDate: $endDate) {
    id
    interv_count
    age
  }
}
    `;

/**
 * __useAgeVsLeakFrequencyQuery__
 *
 * To run a query within a React component, call `useAgeVsLeakFrequencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgeVsLeakFrequencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgeVsLeakFrequencyQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAgeVsLeakFrequencyQuery(baseOptions: Apollo.QueryHookOptions<AgeVsLeakFrequencyQuery, AgeVsLeakFrequencyQueryVariables> & ({ variables: AgeVsLeakFrequencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgeVsLeakFrequencyQuery, AgeVsLeakFrequencyQueryVariables>(AgeVsLeakFrequencyDocument, options);
      }
export function useAgeVsLeakFrequencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgeVsLeakFrequencyQuery, AgeVsLeakFrequencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgeVsLeakFrequencyQuery, AgeVsLeakFrequencyQueryVariables>(AgeVsLeakFrequencyDocument, options);
        }
export function useAgeVsLeakFrequencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgeVsLeakFrequencyQuery, AgeVsLeakFrequencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgeVsLeakFrequencyQuery, AgeVsLeakFrequencyQueryVariables>(AgeVsLeakFrequencyDocument, options);
        }
export type AgeVsLeakFrequencyQueryHookResult = ReturnType<typeof useAgeVsLeakFrequencyQuery>;
export type AgeVsLeakFrequencyLazyQueryHookResult = ReturnType<typeof useAgeVsLeakFrequencyLazyQuery>;
export type AgeVsLeakFrequencySuspenseQueryHookResult = ReturnType<typeof useAgeVsLeakFrequencySuspenseQuery>;
export type AgeVsLeakFrequencyQueryResult = Apollo.QueryResult<AgeVsLeakFrequencyQuery, AgeVsLeakFrequencyQueryVariables>;
export const LeakRecurrenceVsRehabilitationDocument = gql`
    query LeakRecurrenceVsRehabilitation($startDate: Date!, $endDate: Date!) {
  getLeakRecurrenceVsRehabilitation(startDate: $startDate, endDate: $endDate) {
    year
    rehabilitation_interv_count
    leak_interv_count
    pipes_with_more_than_1
    pipes_count
    failure_recurrence_rate
  }
}
    `;

/**
 * __useLeakRecurrenceVsRehabilitationQuery__
 *
 * To run a query within a React component, call `useLeakRecurrenceVsRehabilitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeakRecurrenceVsRehabilitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeakRecurrenceVsRehabilitationQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useLeakRecurrenceVsRehabilitationQuery(baseOptions: Apollo.QueryHookOptions<LeakRecurrenceVsRehabilitationQuery, LeakRecurrenceVsRehabilitationQueryVariables> & ({ variables: LeakRecurrenceVsRehabilitationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeakRecurrenceVsRehabilitationQuery, LeakRecurrenceVsRehabilitationQueryVariables>(LeakRecurrenceVsRehabilitationDocument, options);
      }
export function useLeakRecurrenceVsRehabilitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeakRecurrenceVsRehabilitationQuery, LeakRecurrenceVsRehabilitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeakRecurrenceVsRehabilitationQuery, LeakRecurrenceVsRehabilitationQueryVariables>(LeakRecurrenceVsRehabilitationDocument, options);
        }
export function useLeakRecurrenceVsRehabilitationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeakRecurrenceVsRehabilitationQuery, LeakRecurrenceVsRehabilitationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeakRecurrenceVsRehabilitationQuery, LeakRecurrenceVsRehabilitationQueryVariables>(LeakRecurrenceVsRehabilitationDocument, options);
        }
export type LeakRecurrenceVsRehabilitationQueryHookResult = ReturnType<typeof useLeakRecurrenceVsRehabilitationQuery>;
export type LeakRecurrenceVsRehabilitationLazyQueryHookResult = ReturnType<typeof useLeakRecurrenceVsRehabilitationLazyQuery>;
export type LeakRecurrenceVsRehabilitationSuspenseQueryHookResult = ReturnType<typeof useLeakRecurrenceVsRehabilitationSuspenseQuery>;
export type LeakRecurrenceVsRehabilitationQueryResult = Apollo.QueryResult<LeakRecurrenceVsRehabilitationQuery, LeakRecurrenceVsRehabilitationQueryVariables>;
export const ZmcLeaksCountDocument = gql`
    query ZMCLeaksCount($startDate: Date!, $endDate: Date!) {
  getZMCLeaksCount(startDate: $startDate, endDate: $endDate) {
    id
    interv_count
    codigo_externo
    sig_atributo_id
  }
}
    `;

/**
 * __useZmcLeaksCountQuery__
 *
 * To run a query within a React component, call `useZmcLeaksCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useZmcLeaksCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZmcLeaksCountQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useZmcLeaksCountQuery(baseOptions: Apollo.QueryHookOptions<ZmcLeaksCountQuery, ZmcLeaksCountQueryVariables> & ({ variables: ZmcLeaksCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZmcLeaksCountQuery, ZmcLeaksCountQueryVariables>(ZmcLeaksCountDocument, options);
      }
export function useZmcLeaksCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZmcLeaksCountQuery, ZmcLeaksCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZmcLeaksCountQuery, ZmcLeaksCountQueryVariables>(ZmcLeaksCountDocument, options);
        }
export function useZmcLeaksCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZmcLeaksCountQuery, ZmcLeaksCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZmcLeaksCountQuery, ZmcLeaksCountQueryVariables>(ZmcLeaksCountDocument, options);
        }
export type ZmcLeaksCountQueryHookResult = ReturnType<typeof useZmcLeaksCountQuery>;
export type ZmcLeaksCountLazyQueryHookResult = ReturnType<typeof useZmcLeaksCountLazyQuery>;
export type ZmcLeaksCountSuspenseQueryHookResult = ReturnType<typeof useZmcLeaksCountSuspenseQuery>;
export type ZmcLeaksCountQueryResult = Apollo.QueryResult<ZmcLeaksCountQuery, ZmcLeaksCountQueryVariables>;
export const InfrastructureVariablesTreeDocument = gql`
    query InfrastructureVariablesTree($infrastructureSearchText: String, $variableSearchText: String, $transactionId: Int!, $typeIds: String!) {
  getInfrastructureVariablesTree(
    infrastructureSearchText: $infrastructureSearchText
    variableSearchText: $variableSearchText
    transactionId: $transactionId
    typeIds: $typeIds
  ) {
    id
    id_pai
    descricao
    node
    id_tipo_bulk
    id_tipo_infraestrutura
    codigo_manutencao
    codigo_sig
    nome_completo
    nome_instalacao
    ordem
  }
}
    `;

/**
 * __useInfrastructureVariablesTreeQuery__
 *
 * To run a query within a React component, call `useInfrastructureVariablesTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfrastructureVariablesTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfrastructureVariablesTreeQuery({
 *   variables: {
 *      infrastructureSearchText: // value for 'infrastructureSearchText'
 *      variableSearchText: // value for 'variableSearchText'
 *      transactionId: // value for 'transactionId'
 *      typeIds: // value for 'typeIds'
 *   },
 * });
 */
export function useInfrastructureVariablesTreeQuery(baseOptions: Apollo.QueryHookOptions<InfrastructureVariablesTreeQuery, InfrastructureVariablesTreeQueryVariables> & ({ variables: InfrastructureVariablesTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfrastructureVariablesTreeQuery, InfrastructureVariablesTreeQueryVariables>(InfrastructureVariablesTreeDocument, options);
      }
export function useInfrastructureVariablesTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfrastructureVariablesTreeQuery, InfrastructureVariablesTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfrastructureVariablesTreeQuery, InfrastructureVariablesTreeQueryVariables>(InfrastructureVariablesTreeDocument, options);
        }
export function useInfrastructureVariablesTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfrastructureVariablesTreeQuery, InfrastructureVariablesTreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfrastructureVariablesTreeQuery, InfrastructureVariablesTreeQueryVariables>(InfrastructureVariablesTreeDocument, options);
        }
export type InfrastructureVariablesTreeQueryHookResult = ReturnType<typeof useInfrastructureVariablesTreeQuery>;
export type InfrastructureVariablesTreeLazyQueryHookResult = ReturnType<typeof useInfrastructureVariablesTreeLazyQuery>;
export type InfrastructureVariablesTreeSuspenseQueryHookResult = ReturnType<typeof useInfrastructureVariablesTreeSuspenseQuery>;
export type InfrastructureVariablesTreeQueryResult = Apollo.QueryResult<InfrastructureVariablesTreeQuery, InfrastructureVariablesTreeQueryVariables>;
export const VariablesDocument = gql`
    query Variables($limit: Int, $offset: Int, $where: variaveis_base_bool_exp, $orderBy: [variaveis_base_order_by!]) {
  variaveis_base(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $orderBy
  ) {
    id
    descricao
    tipo {
      id
      descricao
      tipo
    }
    dominio {
      id
      descricao
    }
    codigo
  }
  variaveis_base_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useVariablesQuery__
 *
 * To run a query within a React component, call `useVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVariablesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useVariablesQuery(baseOptions?: Apollo.QueryHookOptions<VariablesQuery, VariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VariablesQuery, VariablesQueryVariables>(VariablesDocument, options);
      }
export function useVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VariablesQuery, VariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VariablesQuery, VariablesQueryVariables>(VariablesDocument, options);
        }
export function useVariablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VariablesQuery, VariablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VariablesQuery, VariablesQueryVariables>(VariablesDocument, options);
        }
export type VariablesQueryHookResult = ReturnType<typeof useVariablesQuery>;
export type VariablesLazyQueryHookResult = ReturnType<typeof useVariablesLazyQuery>;
export type VariablesSuspenseQueryHookResult = ReturnType<typeof useVariablesSuspenseQuery>;
export type VariablesQueryResult = Apollo.QueryResult<VariablesQuery, VariablesQueryVariables>;
export const UserThemeDocument = gql`
    subscription UserTheme($id: bigint) {
  utilizadores_utilizadores(where: {id: {_eq: $id}}) {
    id
    username
    tema {
      id
    }
  }
}
    `;

/**
 * __useUserThemeSubscription__
 *
 * To run a query within a React component, call `useUserThemeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserThemeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserThemeSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserThemeSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserThemeSubscription, UserThemeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserThemeSubscription, UserThemeSubscriptionVariables>(UserThemeDocument, options);
      }
export type UserThemeSubscriptionHookResult = ReturnType<typeof useUserThemeSubscription>;
export type UserThemeSubscriptionResult = Apollo.SubscriptionResult<UserThemeSubscription>;
export const UserPermissionsDocument = gql`
    subscription UserPermissions {
  utilizadores_equipas_virtuais_r_transacoes {
    id
    id_transacao
    permissoes
    equipaVirtualUtilizadores {
      id
      id_utilizador
    }
  }
}
    `;

/**
 * __useUserPermissionsSubscription__
 *
 * To run a query within a React component, call `useUserPermissionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserPermissionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPermissionsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserPermissionsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserPermissionsSubscription, UserPermissionsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserPermissionsSubscription, UserPermissionsSubscriptionVariables>(UserPermissionsDocument, options);
      }
export type UserPermissionsSubscriptionHookResult = ReturnType<typeof useUserPermissionsSubscription>;
export type UserPermissionsSubscriptionResult = Apollo.SubscriptionResult<UserPermissionsSubscription>;
export const UserMessagesDocument = gql`
    subscription UserMessages($userId: bigint!) {
  mensagens_mensagens(
    where: {posts: {apagada: {_eq: false}, id_destinatario: {_eq: $userId}}}
    order_by: {data: desc}
    limit: 10
  ) {
    id
    assunto
    data
    id_remetente
    posts {
      id
      lida
      nova
    }
    remetente {
      id
      descricao
    }
  }
}
    `;

/**
 * __useUserMessagesSubscription__
 *
 * To run a query within a React component, call `useUserMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMessagesSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<UserMessagesSubscription, UserMessagesSubscriptionVariables> & ({ variables: UserMessagesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserMessagesSubscription, UserMessagesSubscriptionVariables>(UserMessagesDocument, options);
      }
export type UserMessagesSubscriptionHookResult = ReturnType<typeof useUserMessagesSubscription>;
export type UserMessagesSubscriptionResult = Apollo.SubscriptionResult<UserMessagesSubscription>;
export const GetUserTotalAvailableMessagesDocument = gql`
    subscription getUserTotalAvailableMessages($userId: bigint!) {
  mensagens_post_aggregate(
    where: {nova: {_eq: true}, apagada: {_eq: false}, id_destinatario: {_eq: $userId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUserTotalAvailableMessagesSubscription__
 *
 * To run a query within a React component, call `useGetUserTotalAvailableMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTotalAvailableMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTotalAvailableMessagesSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserTotalAvailableMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetUserTotalAvailableMessagesSubscription, GetUserTotalAvailableMessagesSubscriptionVariables> & ({ variables: GetUserTotalAvailableMessagesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetUserTotalAvailableMessagesSubscription, GetUserTotalAvailableMessagesSubscriptionVariables>(GetUserTotalAvailableMessagesDocument, options);
      }
export type GetUserTotalAvailableMessagesSubscriptionHookResult = ReturnType<typeof useGetUserTotalAvailableMessagesSubscription>;
export type GetUserTotalAvailableMessagesSubscriptionResult = Apollo.SubscriptionResult<GetUserTotalAvailableMessagesSubscription>;
export const UserNotificationsDocument = gql`
    subscription UserNotifications($userId: bigint!) {
  notificacoes_notificacoes(
    limit: 10
    order_by: {data: desc}
    where: {notificacaoUtilizadores: {id_utilizador: {_eq: $userId}}}
  ) {
    id
    data
    assunto
    notificacaoUtilizadores(limit: 1) {
      lida
    }
    item {
      descricao
      tipo {
        descricao
      }
    }
  }
}
    `;

/**
 * __useUserNotificationsSubscription__
 *
 * To run a query within a React component, call `useUserNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationsSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserNotificationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<UserNotificationsSubscription, UserNotificationsSubscriptionVariables> & ({ variables: UserNotificationsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserNotificationsSubscription, UserNotificationsSubscriptionVariables>(UserNotificationsDocument, options);
      }
export type UserNotificationsSubscriptionHookResult = ReturnType<typeof useUserNotificationsSubscription>;
export type UserNotificationsSubscriptionResult = Apollo.SubscriptionResult<UserNotificationsSubscription>;
export const GetUserTotalAvailableNotificationsDocument = gql`
    subscription getUserTotalAvailableNotifications($userId: bigint!) {
  notificacoes_notificacoes_r_utilizadores_aggregate(
    where: {nova: {_eq: true}, id_utilizador: {_eq: $userId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUserTotalAvailableNotificationsSubscription__
 *
 * To run a query within a React component, call `useGetUserTotalAvailableNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTotalAvailableNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTotalAvailableNotificationsSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserTotalAvailableNotificationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetUserTotalAvailableNotificationsSubscription, GetUserTotalAvailableNotificationsSubscriptionVariables> & ({ variables: GetUserTotalAvailableNotificationsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetUserTotalAvailableNotificationsSubscription, GetUserTotalAvailableNotificationsSubscriptionVariables>(GetUserTotalAvailableNotificationsDocument, options);
      }
export type GetUserTotalAvailableNotificationsSubscriptionHookResult = ReturnType<typeof useGetUserTotalAvailableNotificationsSubscription>;
export type GetUserTotalAvailableNotificationsSubscriptionResult = Apollo.SubscriptionResult<GetUserTotalAvailableNotificationsSubscription>;
export const GetValidatedTvTokenByIdDocument = gql`
    subscription getValidatedTvTokenById($id_token: bigint = "") {
  navia_dashboards_modo_tv_tokens_validados_by_pk(id_token: $id_token) {
    id_token
    token_sistema
    data_hora_expiracao
  }
}
    `;

/**
 * __useGetValidatedTvTokenByIdSubscription__
 *
 * To run a query within a React component, call `useGetValidatedTvTokenByIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetValidatedTvTokenByIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidatedTvTokenByIdSubscription({
 *   variables: {
 *      id_token: // value for 'id_token'
 *   },
 * });
 */
export function useGetValidatedTvTokenByIdSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetValidatedTvTokenByIdSubscription, GetValidatedTvTokenByIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetValidatedTvTokenByIdSubscription, GetValidatedTvTokenByIdSubscriptionVariables>(GetValidatedTvTokenByIdDocument, options);
      }
export type GetValidatedTvTokenByIdSubscriptionHookResult = ReturnType<typeof useGetValidatedTvTokenByIdSubscription>;
export type GetValidatedTvTokenByIdSubscriptionResult = Apollo.SubscriptionResult<GetValidatedTvTokenByIdSubscription>;
export const GetRevogatedTvTokenByIdDocument = gql`
    subscription getRevogatedTvTokenById($id_token: bigint = "") {
  navia_dashboards_modo_tv_tokens_revogacao_manual_by_pk(id_token: $id_token) {
    id_token
  }
}
    `;

/**
 * __useGetRevogatedTvTokenByIdSubscription__
 *
 * To run a query within a React component, call `useGetRevogatedTvTokenByIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetRevogatedTvTokenByIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevogatedTvTokenByIdSubscription({
 *   variables: {
 *      id_token: // value for 'id_token'
 *   },
 * });
 */
export function useGetRevogatedTvTokenByIdSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetRevogatedTvTokenByIdSubscription, GetRevogatedTvTokenByIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetRevogatedTvTokenByIdSubscription, GetRevogatedTvTokenByIdSubscriptionVariables>(GetRevogatedTvTokenByIdDocument, options);
      }
export type GetRevogatedTvTokenByIdSubscriptionHookResult = ReturnType<typeof useGetRevogatedTvTokenByIdSubscription>;
export type GetRevogatedTvTokenByIdSubscriptionResult = Apollo.SubscriptionResult<GetRevogatedTvTokenByIdSubscription>;